function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}
parcelRequire.register("bbzbN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2nzLi"));

});
parcelRequire.register("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRequire.register("7fPBF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fSPLm"));

});
parcelRequire.register("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
"use strict";
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.2.0";

});




parcelRequire.register("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $4d82739dd229d539$var$Mg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Ng = null, $4d82739dd229d539$var$Og = null, $4d82739dd229d539$var$Pg = null;
function $4d82739dd229d539$var$Qg() {
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Ng = null;
}
function $4d82739dd229d539$var$Rg(a) {
    var b = $4d82739dd229d539$var$Mg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Mg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$Tg(a, b) {
    $4d82739dd229d539$var$Ng = a;
    $4d82739dd229d539$var$Pg = $4d82739dd229d539$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$Ug = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$Vg(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Og) {
            if (null === $4d82739dd229d539$var$Ng) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Og = a;
            $4d82739dd229d539$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Og = $4d82739dd229d539$var$Og.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$Wg = null;
function $4d82739dd229d539$var$Xg(a) {
    null === $4d82739dd229d539$var$Wg ? $4d82739dd229d539$var$Wg = [
        a
    ] : $4d82739dd229d539$var$Wg.push(a);
}
function $4d82739dd229d539$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$Zg(a, d);
}
function $4d82739dd229d539$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$$g = !1;
function $4d82739dd229d539$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$Zg(a, c);
}
function $4d82739dd229d539$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$jh = (new $7fPBF.Component).refs;
function $4d82739dd229d539$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$L(), e = $4d82739dd229d539$var$lh(a), f = $4d82739dd229d539$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$dh(a, f, e);
        null !== b && ($4d82739dd229d539$var$mh(b, a, e, d), $4d82739dd229d539$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$L(), d = $4d82739dd229d539$var$lh(a), e = $4d82739dd229d539$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$dh(a, e, d);
        null !== b && ($4d82739dd229d539$var$mh(b, a, d, c), $4d82739dd229d539$var$eh(b, a, d));
    }
};
function $4d82739dd229d539$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$ph(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$Vg(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$nh.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $4d82739dd229d539$var$jh;
    $4d82739dd229d539$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$Vg(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$nh.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $4d82739dd229d539$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$sh(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$sh(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$zh(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Ah(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Bh = $4d82739dd229d539$var$vh(!0), $4d82739dd229d539$var$Ch = $4d82739dd229d539$var$vh(!1), $4d82739dd229d539$var$Dh = {}, $4d82739dd229d539$var$Eh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh), $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Dh);
function $4d82739dd229d539$var$Hh(a) {
    if (a === $4d82739dd229d539$var$Dh) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$Ih(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Gh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, $4d82739dd229d539$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, b);
}
function $4d82739dd229d539$var$Jh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Eh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Gh);
}
function $4d82739dd229d539$var$Kh(a) {
    $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
    var b = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$Fh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$Eh, c));
}
function $4d82739dd229d539$var$Lh(a) {
    $4d82739dd229d539$var$Fh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$Eh), $4d82739dd229d539$var$E($4d82739dd229d539$var$Fh));
}
var $4d82739dd229d539$var$M = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nh = [];
function $4d82739dd229d539$var$Oh() {
    for(var a = 0; a < $4d82739dd229d539$var$Nh.length; a++)$4d82739dd229d539$var$Nh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Nh.length = 0;
}
var $4d82739dd229d539$var$Ph = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Qh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Rh = 0, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$P = null, $4d82739dd229d539$var$Sh = !1, $4d82739dd229d539$var$Th = !1, $4d82739dd229d539$var$Uh = 0, $4d82739dd229d539$var$Vh = 0;
function $4d82739dd229d539$var$Q() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Xh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Rh = f;
    $4d82739dd229d539$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Ph.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Yh : $4d82739dd229d539$var$Zh;
    a = c(d, e);
    if ($4d82739dd229d539$var$Th) {
        f = 0;
        do {
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$$h;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Th);
    }
    $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
    b = null !== $4d82739dd229d539$var$O && null !== $4d82739dd229d539$var$O.next;
    $4d82739dd229d539$var$Rh = 0;
    $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
    $4d82739dd229d539$var$Sh = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$bi() {
    var a = 0 !== $4d82739dd229d539$var$Uh;
    $4d82739dd229d539$var$Uh = 0;
    return a;
}
function $4d82739dd229d539$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$di() {
    if (null === $4d82739dd229d539$var$O) {
        var a = $4d82739dd229d539$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$O.next;
    var b = null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState : $4d82739dd229d539$var$P.next;
    if (null !== b) $4d82739dd229d539$var$P = b, $4d82739dd229d539$var$O = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$O = a;
        a = {
            memoizedState: $4d82739dd229d539$var$O.memoizedState,
            baseState: $4d82739dd229d539$var$O.baseState,
            baseQueue: $4d82739dd229d539$var$O.baseQueue,
            queue: $4d82739dd229d539$var$O.queue,
            next: null
        };
        null === $4d82739dd229d539$var$P ? $4d82739dd229d539$var$N.memoizedState = $4d82739dd229d539$var$P = a : $4d82739dd229d539$var$P = $4d82739dd229d539$var$P.next = a;
    }
    return $4d82739dd229d539$var$P;
}
function $4d82739dd229d539$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$N.lanes |= m;
                $4d82739dd229d539$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$N.lanes |= f, $4d82739dd229d539$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$gi(a) {
    var b = $4d82739dd229d539$var$di(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$hi() {}
function $4d82739dd229d539$var$ii(a, b) {
    var c = $4d82739dd229d539$var$N, d = $4d82739dd229d539$var$di(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$Ug = !0);
    d = d.queue;
    $4d82739dd229d539$var$ji($4d82739dd229d539$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$P && $4d82739dd229d539$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
}
function $4d82739dd229d539$var$ki(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$oi(b) && $4d82739dd229d539$var$pi(a);
    });
}
function $4d82739dd229d539$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$pi(a) {
    var b = $4d82739dd229d539$var$Zg(a, 1);
    null !== b && $4d82739dd229d539$var$mh(b, a, 1, -1);
}
function $4d82739dd229d539$var$qi(a) {
    var b = $4d82739dd229d539$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ri.bind(null, $4d82739dd229d539$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$si() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$ti(a, b, c, d) {
    var e = $4d82739dd229d539$var$ci();
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$ui(a, b, c, d) {
    var e = $4d82739dd229d539$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$O) {
        var g = $4d82739dd229d539$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Wh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$li(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$N.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$li(1 | b, c, f, d);
}
function $4d82739dd229d539$var$vi(a, b) {
    return $4d82739dd229d539$var$ti(8390656, 8, a, b);
}
function $4d82739dd229d539$var$ji(a, b) {
    return $4d82739dd229d539$var$ui(2048, 8, a, b);
}
function $4d82739dd229d539$var$wi(a, b) {
    return $4d82739dd229d539$var$ui(4, 2, a, b);
}
function $4d82739dd229d539$var$xi(a, b) {
    return $4d82739dd229d539$var$ui(4, 4, a, b);
}
function $4d82739dd229d539$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$ui(4, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$Ai() {}
function $4d82739dd229d539$var$Bi(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Ci(a, b) {
    var c = $4d82739dd229d539$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$Di(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Rh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$Ug = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$N.lanes |= c, $4d82739dd229d539$var$hh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$Ei(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Qh.transition;
    $4d82739dd229d539$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Qh.transition = d;
    }
}
function $4d82739dd229d539$var$Fi() {
    return $4d82739dd229d539$var$di().memoizedState;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, c);
    else if (c = $4d82739dd229d539$var$Yg(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$L();
        $4d82739dd229d539$var$mh(c, a, d, e);
        $4d82739dd229d539$var$Ji(c, b, d);
    }
}
function $4d82739dd229d539$var$ri(a, b, c) {
    var d = $4d82739dd229d539$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$Hi(a)) $4d82739dd229d539$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$Yg(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$L(), $4d82739dd229d539$var$mh(c, a, d, e), $4d82739dd229d539$var$Ji(c, b, d));
    }
}
function $4d82739dd229d539$var$Hi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$N || null !== b && b === $4d82739dd229d539$var$N;
}
function $4d82739dd229d539$var$Ii(a, b) {
    $4d82739dd229d539$var$Th = $4d82739dd229d539$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$ai = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Q,
    useContext: $4d82739dd229d539$var$Q,
    useEffect: $4d82739dd229d539$var$Q,
    useImperativeHandle: $4d82739dd229d539$var$Q,
    useInsertionEffect: $4d82739dd229d539$var$Q,
    useLayoutEffect: $4d82739dd229d539$var$Q,
    useMemo: $4d82739dd229d539$var$Q,
    useReducer: $4d82739dd229d539$var$Q,
    useRef: $4d82739dd229d539$var$Q,
    useState: $4d82739dd229d539$var$Q,
    useDebugValue: $4d82739dd229d539$var$Q,
    useDeferredValue: $4d82739dd229d539$var$Q,
    useTransition: $4d82739dd229d539$var$Q,
    useMutableSource: $4d82739dd229d539$var$Q,
    useSyncExternalStore: $4d82739dd229d539$var$Q,
    useId: $4d82739dd229d539$var$Q,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Yh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ti(4194308, 4, $4d82739dd229d539$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$Gi.bind(null, $4d82739dd229d539$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$qi,
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$qi(!1), b = a[0];
        a = $4d82739dd229d539$var$Ei.bind(null, a[1]);
        $4d82739dd229d539$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$N, e = $4d82739dd229d539$var$ci();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$R) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Rh & 30) || $4d82739dd229d539$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$vi($4d82739dd229d539$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$li(9, $4d82739dd229d539$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$ci(), b = $4d82739dd229d539$var$R.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Zh = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$fi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$fi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$$h = {
    readContext: $4d82739dd229d539$var$Vg,
    useCallback: $4d82739dd229d539$var$Bi,
    useContext: $4d82739dd229d539$var$Vg,
    useEffect: $4d82739dd229d539$var$ji,
    useImperativeHandle: $4d82739dd229d539$var$zi,
    useInsertionEffect: $4d82739dd229d539$var$wi,
    useLayoutEffect: $4d82739dd229d539$var$xi,
    useMemo: $4d82739dd229d539$var$Ci,
    useReducer: $4d82739dd229d539$var$gi,
    useRef: $4d82739dd229d539$var$si,
    useState: function() {
        return $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei);
    },
    useDebugValue: $4d82739dd229d539$var$Ai,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$di();
        return null === $4d82739dd229d539$var$O ? b.memoizedState = a : $4d82739dd229d539$var$Di(b, $4d82739dd229d539$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$gi($4d82739dd229d539$var$ei)[0], b = $4d82739dd229d539$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$hi,
    useSyncExternalStore: $4d82739dd229d539$var$ii,
    useId: $4d82739dd229d539$var$Fi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Oi(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Pi || ($4d82739dd229d539$var$Pi = !0, $4d82739dd229d539$var$Qi = d);
        $4d82739dd229d539$var$Mi(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Ri(a, b, c) {
    c = $4d82739dd229d539$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Mi(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Si ? $4d82739dd229d539$var$Si = new Set([
            this
        ]) : $4d82739dd229d539$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$ch(-1, 1), b.tag = 2, $4d82739dd229d539$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Xi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$Ug = !1;
function $4d82739dd229d539$var$Yi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Ch(b, null, c, d) : $4d82739dd229d539$var$Bh(b, a.child, c, d);
}
function $4d82739dd229d539$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$Tg(b, e);
    d = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$cj(a, b, f, d, e);
        a = $4d82739dd229d539$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$Ug = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$$i(a, b, e);
        }
    }
    return $4d82739dd229d539$var$dj(a, b, c, d, e);
}
function $4d82739dd229d539$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj);
            $4d82739dd229d539$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$fj, $4d82739dd229d539$var$gj), $4d82739dd229d539$var$gj |= d;
    $4d82739dd229d539$var$Yi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$dj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$Tg(b, e);
    c = $4d82739dd229d539$var$Xh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$bi();
    if (null !== a && !$4d82739dd229d539$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$$i(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Yi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$Tg(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$jj(a, b), $4d82739dd229d539$var$ph(b, c, d), $4d82739dd229d539$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$Vg(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$qh(b, g, d, l);
        $4d82739dd229d539$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof m && ($4d82739dd229d539$var$kh(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$Vg(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$qh(b, g, d, k);
        $4d82739dd229d539$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$$g ? ("function" === typeof y && ($4d82739dd229d539$var$kh(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$$g || $4d82739dd229d539$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$kj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$kj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$$i(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Bh(b, a.child, null, f), b.child = $4d82739dd229d539$var$Bh(b, null, h, f)) : $4d82739dd229d539$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$Ih(a, b.containerInfo);
}
function $4d82739dd229d539$var$mj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Yi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$pj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$qj(g, d, 0, null), a = $4d82739dd229d539$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$oj(c), b.memoizedState = $4d82739dd229d539$var$nj, a) : $4d82739dd229d539$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$wh(h, f) : (f = $4d82739dd229d539$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$rj(a, b) {
    b = $4d82739dd229d539$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$tj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Bh(b, a.child, null, c);
    a = $4d82739dd229d539$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$oj(g);
        b.memoizedState = $4d82739dd229d539$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Li(f, d, void 0);
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$Ug || h) {
        d = $4d82739dd229d539$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$Zg(a, e), $4d82739dd229d539$var$mh(d, a, e, -1));
        }
        $4d82739dd229d539$var$uj();
        d = $4d82739dd229d539$var$Li(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$Sg(a.return, b, c);
}
function $4d82739dd229d539$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Yi(a, b, d.children, c);
    d = $4d82739dd229d539$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$wj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$lj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Kh(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$pj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
                a = $4d82739dd229d539$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$ej(a, b, c);
    }
    return $4d82739dd229d539$var$$i(a, b, c);
}
var $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj, $4d82739dd229d539$var$Dj;
$4d82739dd229d539$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Bj = function() {};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Ej(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$Jh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Bj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Lh(b);
            var e = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Gh.current);
                $4d82739dd229d539$var$Hh($4d82739dd229d539$var$Eh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Gj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$M.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$Bj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Ej(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$M, $4d82739dd229d539$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Hj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$M.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$M, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$gj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Jj(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$Jh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Lh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$M), null;
        case 4:
            return $4d82739dd229d539$var$Jh(), null;
        case 10:
            return $4d82739dd229d539$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Kj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Oj = !1;
function $4d82739dd229d539$var$Pj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Oj;
    $4d82739dd229d539$var$Oj = !1;
    return n;
}
function $4d82739dd229d539$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Xj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Xj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Yj = !1;
function $4d82739dd229d539$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$ak(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$ak(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Mj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Yj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Yj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Yj = !0;
            $4d82739dd229d539$var$Zj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Nj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Zj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Zj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Zj(a, b, c);
    }
}
function $4d82739dd229d539$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Lj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Yj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$ak(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$ek(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Qj(3, a, a.return), $4d82739dd229d539$var$Rj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Qj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            break;
        case 13:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$gk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$dk(b, a);
            $4d82739dd229d539$var$fk(a);
            d & 4 && $4d82739dd229d539$var$bk(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$dk(b, a), $4d82739dd229d539$var$fk(a);
    }
}
function $4d82739dd229d539$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Vj(a);
                    $4d82739dd229d539$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$jk(a, b, c);
}
function $4d82739dd229d539$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Kj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Kj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$kk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$kk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$jk(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Kj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$lk(a, b, c);
    }
}
function $4d82739dd229d539$var$lk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Sj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$hk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Sj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$mk = Math.ceil, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$pk = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$gj = 0, $4d82739dd229d539$var$fj = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$qk = null, $4d82739dd229d539$var$hh = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = 0, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$gk = 0, $4d82739dd229d539$var$Hj = Infinity, $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Pi = !1, $4d82739dd229d539$var$Qi = null, $4d82739dd229d539$var$Si = null, $4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = null, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, $4d82739dd229d539$var$Bk = -1, $4d82739dd229d539$var$Ck = 0;
function $4d82739dd229d539$var$L() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Bk ? $4d82739dd229d539$var$Bk : $4d82739dd229d539$var$Bk = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Ck && ($4d82739dd229d539$var$Ck = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Ck;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$mh(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$zk) throw $4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$R) a === $4d82739dd229d539$var$R && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$rk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Ek(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Ek(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Fk.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Fk.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Gk(c, $4d82739dd229d539$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Hk(a, b) {
    $4d82739dd229d539$var$Bk = -1;
    $4d82739dd229d539$var$Ck = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Ik() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$R ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Jk(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Kk();
        if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Lk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Mk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Nk(a, h);
        }
        $4d82739dd229d539$var$Qg();
        $4d82739dd229d539$var$nk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Ok(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Pk(e) && (b = $4d82739dd229d539$var$Jk(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Ok(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, d), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$gk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Qk.bind(null, a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Hk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Ok(a, b) {
    var c = $4d82739dd229d539$var$tk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Lk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Jk(a, b);
    2 !== a && (b = $4d82739dd229d539$var$uk, $4d82739dd229d539$var$uk = c, null !== b && $4d82739dd229d539$var$Gj(b));
    return a;
}
function $4d82739dd229d539$var$Gj(a) {
    null === $4d82739dd229d539$var$uk ? $4d82739dd229d539$var$uk = a : $4d82739dd229d539$var$uk.push.apply($4d82739dd229d539$var$uk, a);
}
function $4d82739dd229d539$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Dk(a, b) {
    b &= ~$4d82739dd229d539$var$sk;
    b &= ~$4d82739dd229d539$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Fk(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Ok(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$qk, $4d82739dd229d539$var$Lk(a, 0), $4d82739dd229d539$var$Dk(a, b), $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Qk(a, $4d82739dd229d539$var$uk, $4d82739dd229d539$var$vk);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Rk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Sk(a) {
    null !== $4d82739dd229d539$var$xk && 0 === $4d82739dd229d539$var$xk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Ik();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$pk.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$pk.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Ij() {
    $4d82739dd229d539$var$gj = $4d82739dd229d539$var$fj.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$fj);
}
function $4d82739dd229d539$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$Jh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Oh();
                break;
            case 5:
                $4d82739dd229d539$var$Lh(d);
                break;
            case 4:
                $4d82739dd229d539$var$Jh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$M);
                break;
            case 10:
                $4d82739dd229d539$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Ij();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$R = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$wh(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$gj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$qk = null;
    $4d82739dd229d539$var$sk = $4d82739dd229d539$var$rk = $4d82739dd229d539$var$hh = 0;
    $4d82739dd229d539$var$uk = $4d82739dd229d539$var$tk = null;
    if (null !== $4d82739dd229d539$var$Wg) {
        for(b = 0; b < $4d82739dd229d539$var$Wg.length; b++)if (c = $4d82739dd229d539$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$Wg = null;
    }
    return a;
}
function $4d82739dd229d539$var$Nk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$Qg();
            $4d82739dd229d539$var$Ph.current = $4d82739dd229d539$var$ai;
            if ($4d82739dd229d539$var$Sh) {
                for(var d = $4d82739dd229d539$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Sh = !1;
            }
            $4d82739dd229d539$var$Rh = 0;
            $4d82739dd229d539$var$P = $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            $4d82739dd229d539$var$Th = !1;
            $4d82739dd229d539$var$Uh = 0;
            $4d82739dd229d539$var$ok.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$qk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Ti(f, l, b);
                            $4d82739dd229d539$var$uj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Wi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ki(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = [
                    f
                ] : $4d82739dd229d539$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Oi(f, k, b);
                            $4d82739dd229d539$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Ri(f, h, b);
                                $4d82739dd229d539$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Tk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Kk() {
    var a = $4d82739dd229d539$var$nk.current;
    $4d82739dd229d539$var$nk.current = $4d82739dd229d539$var$ai;
    return null === a ? $4d82739dd229d539$var$ai : a;
}
function $4d82739dd229d539$var$uj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$R || 0 === ($4d82739dd229d539$var$hh & 268435455) && 0 === ($4d82739dd229d539$var$rk & 268435455) || $4d82739dd229d539$var$Dk($4d82739dd229d539$var$R, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Jk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Kk();
    if ($4d82739dd229d539$var$R !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$vk = null, $4d82739dd229d539$var$Lk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Uk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Nk(a, e);
    }
    $4d82739dd229d539$var$Qg();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$nk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$R = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Uk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Mk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Vk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Vk(a) {
    var b = $4d82739dd229d539$var$Wk(a.alternate, a, $4d82739dd229d539$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Tk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$ok.current = null;
}
function $4d82739dd229d539$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Fj(c, b, $4d82739dd229d539$var$gj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Qk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$pk.transition;
    try {
        $4d82739dd229d539$var$pk.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Xk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$pk.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Xk(a, b, c, d) {
    do $4d82739dd229d539$var$Ik();
    while (null !== $4d82739dd229d539$var$xk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$R && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$R = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$wk || ($4d82739dd229d539$var$wk = !0, $4d82739dd229d539$var$Gk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$pk.transition;
        $4d82739dd229d539$var$pk.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$ok.current = null;
        $4d82739dd229d539$var$Pj(a, c);
        $4d82739dd229d539$var$ek(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$ik(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$pk.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$wk && ($4d82739dd229d539$var$wk = !1, $4d82739dd229d539$var$xk = a, $4d82739dd229d539$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Si = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Ek(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Pi) throw $4d82739dd229d539$var$Pi = !1, a = $4d82739dd229d539$var$Qi, $4d82739dd229d539$var$Qi = null, a;
    0 !== ($4d82739dd229d539$var$yk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$zk++ : ($4d82739dd229d539$var$zk = 0, $4d82739dd229d539$var$Ak = a) : $4d82739dd229d539$var$zk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Ik() {
    if (null !== $4d82739dd229d539$var$xk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$yk), b = $4d82739dd229d539$var$pk.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$pk.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$xk) var d = !1;
            else {
                a = $4d82739dd229d539$var$xk;
                $4d82739dd229d539$var$xk = null;
                $4d82739dd229d539$var$yk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Tj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Rj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$pk.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Yk(a, b, c) {
    b = $4d82739dd229d539$var$Ki(c, b);
    b = $4d82739dd229d539$var$Oi(a, b, 1);
    a = $4d82739dd229d539$var$dh(a, b, 1);
    b = $4d82739dd229d539$var$L();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Ek(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Si || !$4d82739dd229d539$var$Si.has(d))) {
                a = $4d82739dd229d539$var$Ki(c, a);
                a = $4d82739dd229d539$var$Ri(b, a, 1);
                b = $4d82739dd229d539$var$dh(b, a, 1);
                a = $4d82739dd229d539$var$L();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$R === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$gk ? $4d82739dd229d539$var$Lk(a, 0) : $4d82739dd229d539$var$sk |= c);
    $4d82739dd229d539$var$Ek(a, b);
}
function $4d82739dd229d539$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$L();
    a = $4d82739dd229d539$var$Zg(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Ek(a, c));
}
function $4d82739dd229d539$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Zk(a, c);
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Zk(a, c);
}
var $4d82739dd229d539$var$Wk;
$4d82739dd229d539$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$zj(a, b, c);
            $4d82739dd229d539$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$Ug = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$jj(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$Tg(b, c);
            e = $4d82739dd229d539$var$Xh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$ah(b), e.updater = $4d82739dd229d539$var$nh, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$rh(b, d, a, c), b = $4d82739dd229d539$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$$k(d);
                a = $4d82739dd229d539$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$aj(null, b, d, $4d82739dd229d539$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$lj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$bh(a, b);
                $4d82739dd229d539$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$mj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$$i(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Kh(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$hj(a, b), $4d82739dd229d539$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$pj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Bh(b, null, d, c) : $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$Zi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$Tg(b, c), e = $4d82739dd229d539$var$Vg(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Lg(d, b.pendingProps), e = $4d82739dd229d539$var$Lg(d.type, e), $4d82739dd229d539$var$aj(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Lg(d, e), $4d82739dd229d539$var$jj(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$Tg(b, c), $4d82739dd229d539$var$ph(b, d, e), $4d82739dd229d539$var$rh(b, d, e, c), $4d82739dd229d539$var$kj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$yj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$ej(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Gk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$al(a, b, c, d);
}
function $4d82739dd229d539$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$$k(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Ah(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Ah(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$qj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$xh(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$zh(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$ah(f);
    return a;
}
function $4d82739dd229d539$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$el(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$el(null);
    c = a.current;
    d = $4d82739dd229d539$var$L();
    e = $4d82739dd229d539$var$lh(c);
    f = $4d82739dd229d539$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$dh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Ek(a, d);
    return a;
}
function $4d82739dd229d539$var$gl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$L(), g = $4d82739dd229d539$var$lh(e);
    c = $4d82739dd229d539$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$dh(e, b, g);
    null !== a && ($4d82739dd229d539$var$mh(a, e, g, f), $4d82739dd229d539$var$eh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$jl(a, b) {
    $4d82739dd229d539$var$il(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$il(a, b);
}
function $4d82739dd229d539$var$kl() {
    return null;
}
var $4d82739dd229d539$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.render = $4d82739dd229d539$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$gl(a, b, null, null);
};
$4d82739dd229d539$var$nl.prototype.unmount = $4d82739dd229d539$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Sk(function() {
            $4d82739dd229d539$var$gl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$nl(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$ql() {}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$hl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$fl(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$ql);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$hl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$cl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$ql);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$gl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$hl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$gl(b, g, a, e);
    } else g = $4d82739dd229d539$var$rl(c, b, a, e, d);
    return $4d82739dd229d539$var$hl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Ek(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Hj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Sk(function() {
                var b = $4d82739dd229d539$var$Zg(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$L();
                    $4d82739dd229d539$var$mh(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$jl(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$jl(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$lh(a), c = $4d82739dd229d539$var$Zg(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$L();
            $4d82739dd229d539$var$mh(c, a, b, d);
        }
        $4d82739dd229d539$var$jl(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Sk;
var $4d82739dd229d539$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Rk
    ]
}, $4d82739dd229d539$var$ul = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$vl = {
    bundleType: $4d82739dd229d539$var$ul.bundleType,
    version: $4d82739dd229d539$var$ul.version,
    rendererPackageName: $4d82739dd229d539$var$ul.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$ul.findFiberByHostInstance || $4d82739dd229d539$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$wl.isDisabled && $4d82739dd229d539$var$wl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$wl.inject($4d82739dd229d539$var$vl), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$wl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$tl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$dl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Sk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$nl(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$pl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$sl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$pl(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Sk(function() {
        $4d82739dd229d539$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Rk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$pl(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$sl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("33s19", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a0C75"));

});
parcelRequire.register("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
"use strict";
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRequire.register("fVMg8", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRequire.register("3GBGj", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("doyfp")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("NDJJg")).initReactI18next; });

var $91Jfg = parcelRequire("91Jfg");

var $2ocZR = parcelRequire("2ocZR");

var $doyfp = parcelRequire("doyfp");

var $2mZbw = parcelRequire("2mZbw");

var $1teFb = parcelRequire("1teFb");

var $kX5ZB = parcelRequire("kX5ZB");

var $3fGol = parcelRequire("3fGol");

var $9ql4S = parcelRequire("9ql4S");

var $NDJJg = parcelRequire("NDJJg");

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");

var $beOCj = parcelRequire("beOCj");
const $2af286126fb112dc$export$324d90190a8b822a = ()=>"";
const $2af286126fb112dc$export$2da9be4cfdb689b1 = ()=>"";
const $2af286126fb112dc$export$98e628dec113755e = ()=>"";
const $2af286126fb112dc$export$2e6c959c16ff56b8 = ()=>"";
const $2af286126fb112dc$export$4e35d5c922a95490 = ()=>"";
const $2af286126fb112dc$export$720a3b9db04b7a0f = ()=>"";

});
parcelRequire.register("91Jfg", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $2ocZR = parcelRequire("2ocZR");

var $beOCj = parcelRequire("beOCj");
var $cvg5R = parcelRequire("cvg5R");
function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $2ocZR.Trans)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}

});
parcelRequire.register("2ocZR", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce; });

var $cvBp9 = parcelRequire("cvBp9");

var $7fPBF = parcelRequire("7fPBF");

var $58Q0I = parcelRequire("58Q0I");

var $5RTF6 = parcelRequire("5RTF6");

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");
function $1bd7e790a57f14c4$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $1bd7e790a57f14c4$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $1bd7e790a57f14c4$var$getAsArray(children) : children;
}
function $1bd7e790a57f14c4$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $7fPBF.isValidElement)(child));
}
function $1bd7e790a57f14c4$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $1bd7e790a57f14c4$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $1bd7e790a57f14c4$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $7fPBF.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $1bd7e790a57f14c4$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $5RTF6.warn)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $5RTF6.warn)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $5RTF6.warn)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $1bd7e790a57f14c4$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if (typeof child === "object" && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $58Q0I.default).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $1bd7e790a57f14c4$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1bd7e790a57f14c4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $7fPBF.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $7fPBF.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($cvBp9)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $1bd7e790a57f14c4$var$getAsArray(reactNode);
        const astNodes = $1bd7e790a57f14c4$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $1bd7e790a57f14c4$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $7fPBF.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $1bd7e790a57f14c4$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1bd7e790a57f14c4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1bd7e790a57f14c4$var$getAsArray(children || []));
    return $1bd7e790a57f14c4$var$getChildren(result[0]);
}
function $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $cvg5R.getI18n)();
    if (!i18n) {
        (0, $5RTF6.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $fYpGK.getDefaults)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const defaultValue = defaults || $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $1bd7e790a57f14c4$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRequire.register("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $91b5651481cc9d5c$var$_extends.apply(this, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("58Q0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be60b4f29d3a6e3$export$2e2bcd8739ae039; });

var $kLNeb = parcelRequire("kLNeb");
var $3be60b4f29d3a6e3$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($kLNeb)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3be60b4f29d3a6e3$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3be60b4f29d3a6e3$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3be60b4f29d3a6e3$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3be60b4f29d3a6e3$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3be60b4f29d3a6e3$var$a("", t);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;

});
parcelRequire.register("kLNeb", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRequire.register("5RTF6", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $445d14444882807b$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $445d14444882807b$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $445d14444882807b$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $445d14444882807b$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $445d14444882807b$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $445d14444882807b$export$be63e0664592e141; });
function $445d14444882807b$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $445d14444882807b$var$alreadyWarned = {};
function $445d14444882807b$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $445d14444882807b$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $445d14444882807b$var$alreadyWarned[args[0]] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d(...args);
}
const $445d14444882807b$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $445d14444882807b$var$loadedClb(i18n, cb));
}
function $445d14444882807b$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $445d14444882807b$var$loadedClb(i18n, cb));
}
function $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $445d14444882807b$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $445d14444882807b$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRequire.register("fYpGK", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $ba1062cc0d1f4b93$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $ba1062cc0d1f4b93$export$212bb2fc580a90a8; });

var $iRLKp = parcelRequire("iRLKp");
let $ba1062cc0d1f4b93$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $iRLKp.unescape
};
function $ba1062cc0d1f4b93$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $ba1062cc0d1f4b93$var$defaultOptions = {
        ...$ba1062cc0d1f4b93$var$defaultOptions,
        ...options
    };
}
function $ba1062cc0d1f4b93$export$212bb2fc580a90a8() {
    return $ba1062cc0d1f4b93$var$defaultOptions;
}

});
parcelRequire.register("iRLKp", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $dbc236e0ae4b1bc0$export$e8bacd2802a88316; });
const $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $dbc236e0ae4b1bc0$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = (m)=>$dbc236e0ae4b1bc0$var$htmlEntities[m];
const $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = (text)=>text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);

});


parcelRequire.register("cvg5R", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $91a4dd25d142fe34$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $91a4dd25d142fe34$export$64af334f494c2f47; });
let $91a4dd25d142fe34$var$i18nInstance;
function $91a4dd25d142fe34$export$a039134f2fc7e0(instance) {
    $91a4dd25d142fe34$var$i18nInstance = instance;
}
function $91a4dd25d142fe34$export$64af334f494c2f47() {
    return $91a4dd25d142fe34$var$i18nInstance;
}

});


parcelRequire.register("beOCj", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $021c8539c0651064$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $021c8539c0651064$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $021c8539c0651064$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("fYpGK")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("cvg5R")).getI18n; });

var $7fPBF = parcelRequire("7fPBF");

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");

var $NDJJg = parcelRequire("NDJJg");
const $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
class $021c8539c0651064$export$ea171b67e3820290 {
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
    constructor(){
        this.usedNamespaces = {};
    }
}
function $021c8539c0651064$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $021c8539c0651064$export$704200e5d0b9e8f() {
    const i18n = (0, $cvg5R.getI18n)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRequire.register("NDJJg", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $09536692873e4879$export$ae7e14d40d89f296; });

var $fYpGK = parcelRequire("fYpGK");

var $cvg5R = parcelRequire("cvg5R");
const $09536692873e4879$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $fYpGK.setDefaults)(instance.options.react);
        (0, $cvg5R.setI18n)(instance);
    }
};

});



parcelRequire.register("doyfp", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $9c081519ec78392c$export$9fc83ad70ead8663; });

var $7fPBF = parcelRequire("7fPBF");

var $beOCj = parcelRequire("beOCj");
var $cvg5R = parcelRequire("cvg5R");
var $fYpGK = parcelRequire("fYpGK");

var $5RTF6 = parcelRequire("5RTF6");
const $9c081519ec78392c$var$usePrevious = (value, ignore)=>{
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $9c081519ec78392c$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $beOCj.ReportNamespaces)();
    if (!i18n) {
        (0, $5RTF6.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $5RTF6.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $fYpGK.getDefaults)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $5RTF6.hasLoadedNamespace)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $7fPBF.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $9c081519ec78392c$var$usePrevious(joinedNS);
    const isMounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $5RTF6.loadLanguages)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $5RTF6.loadNamespaces)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $5RTF6.loadLanguages)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $5RTF6.loadNamespaces)(i18n, namespaces, ()=>resolve());
    });
}

});

parcelRequire.register("2mZbw", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $doyfp = parcelRequire("doyfp");

var $5RTF6 = parcelRequire("5RTF6");
function $1b9d18dce12af9e0$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $doyfp.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7fPBF.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $5RTF6.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $7fPBF.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $7fPBF.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRequire.register("1teFb", function(module, exports) {

var $doyfp = parcelRequire("doyfp");
function $1123dfab2acde046$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $doyfp.useTranslation)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRequire.register("kX5ZB", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $beOCj = parcelRequire("beOCj");
function $f40df753886fac13$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $7fPBF.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $7fPBF.createElement)((0, $beOCj.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRequire.register("3fGol", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $9ql4S = parcelRequire("9ql4S");

var $beOCj = parcelRequire("beOCj");

var $5RTF6 = parcelRequire("5RTF6");
function $25e3a7ece768866e$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $9ql4S.useSSR)(initialI18nStore, initialLanguage);
            return (0, $7fPBF.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $beOCj.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $5RTF6.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRequire.register("9ql4S", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $6dc6e4594d06aae3$export$3526fb65ade8d8b7; });

var $7fPBF = parcelRequire("7fPBF");

var $beOCj = parcelRequire("beOCj");
var $cvg5R = parcelRequire("cvg5R");
function $6dc6e4594d06aae3$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $7fPBF.useContext)((0, $beOCj.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $cvg5R.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRequire.register("dNYY5", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $a0cf24fd73ae067c$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $a0cf24fd73ae067c$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("iIluI")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("iIluI")).useNavigate; });
/**
 * React Router DOM v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7iMIy = parcelRequire("7iMIy");
var $iIluI = parcelRequire("iIluI");

var $7iMIy = parcelRequire("7iMIy");
function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $7iMIy.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $7iMIy.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $7iMIy.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7iMIy.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $iIluI.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $7iMIy.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7iMIy.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $iIluI.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $7iMIy.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7iMIy.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $iIluI.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7iMIy.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $iIluI.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $iIluI.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref4, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $iIluI.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $7iMIy.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $iIluI.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref5, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $iIluI.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $iIluI.useLocation)();
    let routerState = $7fPBF.useContext((0, $iIluI.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $7fPBF.useContext((0, $iIluI.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$FormImpl, $a0cf24fd73ae067c$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $a0cf24fd73ae067c$var$FormImpl = /*#__PURE__*/ $7fPBF.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref6, $a0cf24fd73ae067c$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $iIluI.UNSAFE_DataRouterContext));
    !ctx && (0, $7iMIy.UNSAFE_invariant)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $iIluI.UNSAFE_DataRouterStateContext));
    !state && (0, $7iMIy.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $iIluI.useNavigate)();
    let location = (0, $iIluI.useLocation)();
    let path = (0, $iIluI.useResolvedPath)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $7iMIy.createPath)(location) === (0, $7iMIy.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $iIluI.useLocation)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $iIluI.useNavigate)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $iIluI.UNSAFE_NavigationContext));
    let currentRouteId = (0, $iIluI.UNSAFE_useRouteId)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $a0cf24fd73ae067c$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $7fPBF.useContext((0, $iIluI.UNSAFE_NavigationContext));
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $7iMIy.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $iIluI.UNSAFE_NavigationContext));
    let routeContext = $7fPBF.useContext((0, $iIluI.UNSAFE_RouteContext));
    !routeContext && (0, $7iMIy.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $iIluI.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $iIluI.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7iMIy.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $7iMIy.createPath)(path);
}
function $a0cf24fd73ae067c$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
        let submit = $a0cf24fd73ae067c$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$FormImpl, $a0cf24fd73ae067c$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let route = $7fPBF.useContext((0, $iIluI.UNSAFE_RouteContext));
    !route && (0, $7iMIy.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $7iMIy.UNSAFE_invariant)(false);
    let [fetcherKey] = $7fPBF.useState(()=>String(++$a0cf24fd73ae067c$var$fetcherId));
    let [Form] = $7fPBF.useState(()=>{
        !routeId && (0, $7iMIy.UNSAFE_invariant)(false);
        return $a0cf24fd73ae067c$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $7fPBF.useState(()=>(href)=>{
            !router && (0, $7iMIy.UNSAFE_invariant)(false);
            !routeId && (0, $7iMIy.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $a0cf24fd73ae067c$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $7fPBF.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $iIluI.UNSAFE_NavigationContext));
    let location = (0, $iIluI.useLocation)();
    let matches = (0, $iIluI.useMatches)();
    let navigation = (0, $iIluI.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $7iMIy.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $iIluI.unstable_useBlocker)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});
parcelRequire.register("7iMIy", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $55100129ab36ed65$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $55100129ab36ed65$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $55100129ab36ed65$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $55100129ab36ed65$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $55100129ab36ed65$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $55100129ab36ed65$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $55100129ab36ed65$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $55100129ab36ed65$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $55100129ab36ed65$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "joinPaths", function () { return $55100129ab36ed65$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $55100129ab36ed65$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $55100129ab36ed65$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $55100129ab36ed65$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $55100129ab36ed65$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "ErrorResponse", function () { return $55100129ab36ed65$export$acf1a680051f5031; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $55100129ab36ed65$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $55100129ab36ed65$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $55100129ab36ed65$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $55100129ab36ed65$var$safelyDecodeURI(pathname));
    return matches;
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:\w+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $55100129ab36ed65$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $55100129ab36ed65$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $55100129ab36ed65$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $55100129ab36ed65$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$55100129ab36ed65$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $55100129ab36ed65$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($55100129ab36ed65$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $55100129ab36ed65$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission);
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($55100129ab36ed65$var$_extends({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $55100129ab36ed65$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, redirect.location, $55100129ab36ed65$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $55100129ab36ed65$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $55100129ab36ed65$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$55100129ab36ed65$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $55100129ab36ed65$var$callLoaderOrAction("loader", $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $55100129ab36ed65$var$ResultType.error,
                        error: $55100129ab36ed65$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $55100129ab36ed65$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($55100129ab36ed65$var$isQueryRouteResponse(e)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error && !$55100129ab36ed65$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            result = await $55100129ab36ed65$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $55100129ab36ed65$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$55100129ab36ed65$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$55100129ab36ed65$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They only set `defaultShouldRevalidate` on
        // explicit revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        //
        // They automatically revalidate without even calling shouldRevalidate if:
        // - They were cancelled
        // - They're in the middle of their first load and therefore this is still
        //   an initial load and not a revalidation
        //
        // If neither of those is true, then they _always_ check shouldRevalidate
        let fetcher = state.fetchers.get(key);
        let isPerformingInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === undefined && // If a fetcher.load redirected then it'll be "loading" without any data
        // so ensure we're not processing the redirect from this fetcher
        !fetchRedirectIds.has(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = cancelledFetcherLoads.includes(key) || isPerformingInitialLoad || $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $55100129ab36ed65$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $55100129ab36ed65$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $55100129ab36ed65$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($55100129ab36ed65$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($55100129ab36ed65$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $55100129ab36ed65$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $55100129ab36ed65$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $55100129ab36ed65$var$ResultType.error) return {
            type: resultType,
            error: new $55100129ab36ed65$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $55100129ab36ed65$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($55100129ab36ed65$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $55100129ab36ed65$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $55100129ab36ed65$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return result;
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isQueryRouteResponse(obj) {
    return obj && $55100129ab36ed65$var$isResponse(obj.response) && (obj.type === $55100129ab36ed65$var$ResultType.data || $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $55100129ab36ed65$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $55100129ab36ed65$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

});

parcelRequire.register("iIluI", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $d9fd026bfea79ab9$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $d9fd026bfea79ab9$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $d9fd026bfea79ab9$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $d9fd026bfea79ab9$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $d9fd026bfea79ab9$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $d9fd026bfea79ab9$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $d9fd026bfea79ab9$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $d9fd026bfea79ab9$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $d9fd026bfea79ab9$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $d9fd026bfea79ab9$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $d9fd026bfea79ab9$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $d9fd026bfea79ab9$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $d9fd026bfea79ab9$export$2af03a1de5c0910; });
$parcel$export(module.exports, "Router", function () { return $d9fd026bfea79ab9$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $d9fd026bfea79ab9$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $d9fd026bfea79ab9$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $d9fd026bfea79ab9$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $d9fd026bfea79ab9$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $d9fd026bfea79ab9$export$52b333d321859367; });
/**
 * React Router v6.14.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $7iMIy = parcelRequire("7iMIy");
function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7iMIy.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $7iMIy.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7iMIy.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $7iMIy.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7iMIy.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7iMIy.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $7fPBF.useMemo(()=>(0, $7iMIy.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $7iMIy.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7iMIy.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $7iMIy.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7iMIy.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7iMIy.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7iMIy.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $7iMIy.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $7iMIy.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($d9fd026bfea79ab9$var$DataRouterHook || ($d9fd026bfea79ab9$var$DataRouterHook = {}));
var $d9fd026bfea79ab9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($d9fd026bfea79ab9$var$DataRouterStateHook || ($d9fd026bfea79ab9$var$DataRouterStateHook = {}));
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $7iMIy.UNSAFE_invariant)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $7iMIy.UNSAFE_invariant)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $7iMIy.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7iMIy.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $7iMIy.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $7iMIy.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $7iMIy.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7iMIy.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned[key]) $d9fd026bfea79ab9$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7iMIy.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $7iMIy.resolveTo)(to, (0, $7iMIy.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $7iMIy.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $7iMIy.Action).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $7iMIy.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7iMIy.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $7iMIy.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($d9fd026bfea79ab9$var$AwaitRenderStatus || ($d9fd026bfea79ab9$var$AwaitRenderStatus = {}));
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : promise._data !== undefined ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $7iMIy.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $7iMIy.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $7iMIy.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $7iMIy.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7iMIy.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367
    }).initialize();
}

});


parcelRequire.register("fI21S", function(module, exports) {
$parcel$export(module.exports, "QueryClient", function () { return (parcelRequire("3lDoJ")).QueryClient; });
$parcel$export(module.exports, "QueryClientProvider", function () { return (parcelRequire("6V5bv")).QueryClientProvider; });
$parcel$export(module.exports, "useMutation", function () { return (parcelRequire("3irMb")).useMutation; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("1HW2x")).useQuery; });
$parcel$export(module.exports, "useQueryClient", function () { return (parcelRequire("6V5bv")).useQueryClient; });
parcelRequire("3lDoJ");
parcelRequire("cXpUO");

});
parcelRequire.register("3lDoJ", function(module, exports) {

$parcel$export(module.exports, "QueryClient", function () { return $2701e4e367fb45bc$export$405d0624ed55a03f; });

var $kY3Ke = parcelRequire("kY3Ke");

var $fduVO = parcelRequire("fduVO");

var $gSisT = parcelRequire("gSisT");

var $dlRI6 = parcelRequire("dlRI6");

var $9sKWJ = parcelRequire("9sKWJ");

var $9KNwT = parcelRequire("9KNwT");

var $it2r3 = parcelRequire("it2r3");

var $lmNwJ = parcelRequire("lmNwJ");
var $2701e4e367fb45bc$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $gSisT.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $dlRI6.MutationCache)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $9sKWJ.focusManager).subscribe(function() {
            if ((0, $9sKWJ.focusManager).isFocused() && (0, $9KNwT.onlineManager).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $9KNwT.onlineManager).subscribe(function() {
            if ((0, $9sKWJ.focusManager).isFocused() && (0, $9KNwT.onlineManager).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $fduVO.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $kY3Ke.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $fduVO.parseQueryArgs)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $it2r3.notifyManager).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $fduVO.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $it2r3.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $fduVO.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $kY3Ke.default)({}, filters, {
            active: true
        });
        return (0, $it2r3.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $fduVO.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        var promises = (0, $it2r3.notifyManager).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $fduVO.noop)).catch((0, $fduVO.noop));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $fduVO.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $kY3Ke.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $it2r3.notifyManager).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $fduVO.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $it2r3.notifyManager).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $kY3Ke.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $fduVO.noop));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $fduVO.noop));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $fduVO.parseQueryArgs)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $fduVO.noop)).catch((0, $fduVO.noop));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $fduVO.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $lmNwJ.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $fduVO.noop)).catch((0, $fduVO.noop));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $it2r3.notifyManager).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $fduVO.noop)).catch((0, $fduVO.noop));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $fduVO.hashQueryKey)(queryKey) === (0, $fduVO.hashQueryKey)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $fduVO.partialMatchKey)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $fduVO.hashQueryKey)(mutationKey) === (0, $fduVO.hashQueryKey)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $fduVO.partialMatchKey)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $kY3Ke.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $fduVO.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $kY3Ke.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();

});
parcelRequire.register("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f43c50d92a19d876$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("fduVO", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $b14010445a49f98f$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $b14010445a49f98f$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $b14010445a49f98f$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $b14010445a49f98f$export$e539f754e934e270; });
$parcel$export(module.exports, "ensureQueryKeyArray", function () { return $b14010445a49f98f$export$4d32d63f64b825b9; });
$parcel$export(module.exports, "timeUntilStale", function () { return $b14010445a49f98f$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $b14010445a49f98f$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $b14010445a49f98f$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $b14010445a49f98f$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $b14010445a49f98f$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $b14010445a49f98f$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $b14010445a49f98f$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $b14010445a49f98f$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $b14010445a49f98f$export$5fcb678681417b54; });
$parcel$export(module.exports, "replaceEqualDeep", function () { return $b14010445a49f98f$export$77a71fc411098696; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $b14010445a49f98f$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $b14010445a49f98f$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $b14010445a49f98f$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $b14010445a49f98f$export$382ca5d13a8f252c; });

var $kY3Ke = parcelRequire("kY3Ke");
var $b14010445a49f98f$export$6acf61af03e62db = typeof window === "undefined";
function $b14010445a49f98f$export$8793edee2d425525() {
    return undefined;
}
function $b14010445a49f98f$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $b14010445a49f98f$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $b14010445a49f98f$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $b14010445a49f98f$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $b14010445a49f98f$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $b14010445a49f98f$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $b14010445a49f98f$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$b14010445a49f98f$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return (0, $kY3Ke.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $kY3Ke.default)({}, arg2, {
        queryKey: arg1
    });
}
function $b14010445a49f98f$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($b14010445a49f98f$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return (0, $kY3Ke.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $kY3Ke.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === "function") return (0, $kY3Ke.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $kY3Ke.default)({}, arg1);
}
function $b14010445a49f98f$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $b14010445a49f98f$export$aaae5295ec3351c9(arg1) ? [
        (0, $kY3Ke.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $b14010445a49f98f$export$42387eeaac09cf54(arg1, arg2) {
    return $b14010445a49f98f$export$aaae5295ec3351c9(arg1) ? (0, $kY3Ke.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $b14010445a49f98f$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return "all";
    else if (active === false && inactive === false) return "none";
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? "active" : "inactive";
    }
}
function $b14010445a49f98f$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($b14010445a49f98f$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $b14010445a49f98f$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$b14010445a49f98f$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $b14010445a49f98f$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === "none") return false;
    else if (queryStatusFilter !== "all") {
        var isActive = query.isActive();
        if (queryStatusFilter === "active" && !isActive) return false;
        if (queryStatusFilter === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetching === "boolean" && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $b14010445a49f98f$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($b14010445a49f98f$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($b14010445a49f98f$export$5fcb678681417b54(mutation.options.mutationKey) !== $b14010445a49f98f$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$b14010445a49f98f$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $b14010445a49f98f$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $b14010445a49f98f$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $b14010445a49f98f$export$5fcb678681417b54(queryKey) {
    var asArray = $b14010445a49f98f$export$4d32d63f64b825b9(queryKey);
    return $b14010445a49f98f$export$e7f2f041280beb00(asArray);
}
function $b14010445a49f98f$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $b14010445a49f98f$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $b14010445a49f98f$export$2f07189bb9fa26a7(a, b) {
    return $b14010445a49f98f$export$3bc9138b70293839($b14010445a49f98f$export$4d32d63f64b825b9(a), $b14010445a49f98f$export$4d32d63f64b825b9(b));
}
function $b14010445a49f98f$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some(function(key) {
        return !$b14010445a49f98f$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $b14010445a49f98f$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $b14010445a49f98f$export$53b83ca8eaab0383(a) && $b14010445a49f98f$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $b14010445a49f98f$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $b14010445a49f98f$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $b14010445a49f98f$export$53b83ca8eaab0383(o) {
    if (!$b14010445a49f98f$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$b14010445a49f98f$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $b14010445a49f98f$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $b14010445a49f98f$export$aaae5295ec3351c9(value) {
    return typeof value === "string" || Array.isArray(value);
}
function $b14010445a49f98f$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $b14010445a49f98f$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $b14010445a49f98f$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $b14010445a49f98f$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
}

});

parcelRequire.register("gSisT", function(module, exports) {

$parcel$export(module.exports, "QueryCache", function () { return $c49003431597a9f1$export$5dde0cd941da8468; });

var $1KLsX = parcelRequire("1KLsX");

var $fduVO = parcelRequire("fduVO");

var $f75J7 = parcelRequire("f75J7");

var $it2r3 = parcelRequire("it2r3");

var $7VskH = parcelRequire("7VskH");
var $c49003431597a9f1$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $fduVO.hashQueryKeyByOptions)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $f75J7.Query)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "queryAdded",
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "queryRemoved",
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $it2r3.notifyManager).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $fduVO.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $fduVO.matchQuery)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $fduVO.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $fduVO.matchQuery)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $it2r3.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $it2r3.notifyManager).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $it2r3.notifyManager).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $7VskH.Subscribable));

});
parcelRequire.register("1KLsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146ee816144a450d$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $146ee816144a450d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $iJeDO.default)(subClass, superClass);
}

});
parcelRequire.register("iJeDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da27c96857818bcc$export$2e2bcd8739ae039; });
function $da27c96857818bcc$export$2e2bcd8739ae039(o, p) {
    $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $da27c96857818bcc$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("f75J7", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $b00bf3a597a425de$export$62297b13309008b2; });

var $kY3Ke = parcelRequire("kY3Ke");

var $fduVO = parcelRequire("fduVO");

var $it2r3 = parcelRequire("it2r3");

var $jgQjg = parcelRequire("jgQjg");

var $l2CiO = parcelRequire("l2CiO");
var $b00bf3a597a425de$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $kY3Ke.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $fduVO.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $fduVO.functionalUpdate)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $fduVO.replaceEqualDeep)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $fduVO.noop)).catch((0, $fduVO.noop)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $fduVO.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $fduVO.ensureQueryKeyArray)(this.queryKey);
        var abortController = (0, $fduVO.getAbortController)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, "signal", {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject("Missing queryFn");
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $l2CiO.Retryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $l2CiO.isCancelledError)(error) && error.silent)) _this2.dispatch({
                    type: "error",
                    error: error
                });
                if (!(0, $l2CiO.isCancelledError)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $jgQjg.getLogger)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $it2r3.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: "queryUpdated",
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== "undefined";
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== "undefined";
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? "success" : "idle"
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case "failed":
                return (0, $kY3Ke.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case "pause":
                return (0, $kY3Ke.default)({}, state, {
                    isPaused: true
                });
            case "continue":
                return (0, $kY3Ke.default)({}, state, {
                    isPaused: false
                });
            case "fetch":
                return (0, $kY3Ke.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: "loading"
                });
            case "success":
                return (0, $kY3Ke.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: "success"
                });
            case "error":
                var error = action.error;
                if ((0, $l2CiO.isCancelledError)(error) && error.revert && this.revertState) return (0, $kY3Ke.default)({}, this.revertState);
                return (0, $kY3Ke.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: "error"
                });
            case "invalidate":
                return (0, $kY3Ke.default)({}, state, {
                    isInvalidated: true
                });
            case "setState":
                return (0, $kY3Ke.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();

});
parcelRequire.register("it2r3", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $d71cd30eeffaca8c$export$520687f44db6e1ab; });

var $fduVO = parcelRequire("fduVO");
var $d71cd30eeffaca8c$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $fduVO.scheduleMicrotask)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $fduVO.scheduleMicrotask)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $d71cd30eeffaca8c$export$520687f44db6e1ab = new $d71cd30eeffaca8c$export$c3ab47f7c70c8aa4();

});

parcelRequire.register("jgQjg", function(module, exports) {

$parcel$export(module.exports, "getLogger", function () { return $e078169100228fdf$export$2b1d391cd05230fd; });
$parcel$export(module.exports, "setLogger", function () { return $e078169100228fdf$export$3abbd92f765bee58; });
// TYPES
// FUNCTIONS
var $e078169100228fdf$var$logger = console;
function $e078169100228fdf$export$2b1d391cd05230fd() {
    return $e078169100228fdf$var$logger;
}
function $e078169100228fdf$export$3abbd92f765bee58(newLogger) {
    $e078169100228fdf$var$logger = newLogger;
}

});

parcelRequire.register("l2CiO", function(module, exports) {

$parcel$export(module.exports, "isCancelable", function () { return $f5177ef2c89b9562$export$22e08d49843051be; });
$parcel$export(module.exports, "isCancelledError", function () { return $f5177ef2c89b9562$export$986cc6445c1d323; });
$parcel$export(module.exports, "Retryer", function () { return $f5177ef2c89b9562$export$586a619a4618a582; });

var $9sKWJ = parcelRequire("9sKWJ");

var $9KNwT = parcelRequire("9KNwT");

var $fduVO = parcelRequire("fduVO");
function $f5177ef2c89b9562$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $f5177ef2c89b9562$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === "function";
}
var $f5177ef2c89b9562$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $f5177ef2c89b9562$export$986cc6445c1d323(value) {
    return value instanceof $f5177ef2c89b9562$export$a8430ed4188f35a9;
} // CLASS
var $f5177ef2c89b9562$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $f5177ef2c89b9562$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($f5177ef2c89b9562$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $f5177ef2c89b9562$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $f5177ef2c89b9562$var$defaultRetryDelay;
            var delay = typeof retryDelay === "function" ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === "number" && _this.failureCount < retry || typeof retry === "function" && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $fduVO.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $9sKWJ.focusManager).isFocused() || !(0, $9KNwT.onlineManager).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};

});
parcelRequire.register("9sKWJ", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $6e3b25249016e5ef$export$6bf54661be5b02cf; });

var $1KLsX = parcelRequire("1KLsX");

var $7VskH = parcelRequire("7VskH");

var $fduVO = parcelRequire("fduVO");
var $6e3b25249016e5ef$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $fduVO.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === "boolean") _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $7VskH.Subscribable));
var $6e3b25249016e5ef$export$6bf54661be5b02cf = new $6e3b25249016e5ef$export$86f1af424b2ca4de();

});
parcelRequire.register("7VskH", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $5c53d597f9d08bb7$export$d26086b469ecdbcc; });
var $5c53d597f9d08bb7$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();

});


parcelRequire.register("9KNwT", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $719ed4727143bd8c$export$b113e788b2dd3fdc; });

var $1KLsX = parcelRequire("1KLsX");

var $7VskH = parcelRequire("7VskH");

var $fduVO = parcelRequire("fduVO");
var $719ed4727143bd8c$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $fduVO.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener("online", listener, false);
                window.addEventListener("offline", listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("online", listener);
                    window.removeEventListener("offline", listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === "boolean") _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $7VskH.Subscribable));
var $719ed4727143bd8c$export$b113e788b2dd3fdc = new $719ed4727143bd8c$export$58774fb55d5ff7fc();

});




parcelRequire.register("dlRI6", function(module, exports) {

$parcel$export(module.exports, "MutationCache", function () { return $9b86e646be22e839$export$1fcfd9a244434844; });

var $1KLsX = parcelRequire("1KLsX");

var $it2r3 = parcelRequire("it2r3");

var $arv2Z = parcelRequire("arv2Z");

var $fduVO = parcelRequire("fduVO");

var $7VskH = parcelRequire("7VskH");
var $9b86e646be22e839$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $arv2Z.Mutation)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $it2r3.notifyManager).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $fduVO.matchMutation)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $fduVO.matchMutation)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $it2r3.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $it2r3.notifyManager).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $fduVO.noop));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $7VskH.Subscribable));

});
parcelRequire.register("arv2Z", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $79a4825474d5b187$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $79a4825474d5b187$export$a1659b54bac3252a; });

var $kY3Ke = parcelRequire("kY3Ke");

var $jgQjg = parcelRequire("jgQjg");

var $it2r3 = parcelRequire("it2r3");

var $l2CiO = parcelRequire("l2CiO");

var $fduVO = parcelRequire("fduVO");
var $79a4825474d5b187$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $kY3Ke.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $79a4825474d5b187$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $fduVO.noop)).catch((0, $fduVO.noop));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === "loading";
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: "loading",
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: "loading",
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: "success",
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $jgQjg.getLogger)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: "error",
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $l2CiO.Retryer)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject("No mutationFn found");
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: "failed"
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: "pause"
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: "continue"
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $79a4825474d5b187$var$reducer(this.state, action);
        (0, $it2r3.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $79a4825474d5b187$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}
function $79a4825474d5b187$var$reducer(state, action) {
    switch(action.type){
        case "failed":
            return (0, $kY3Ke.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case "pause":
            return (0, $kY3Ke.default)({}, state, {
                isPaused: true
            });
        case "continue":
            return (0, $kY3Ke.default)({}, state, {
                isPaused: false
            });
        case "loading":
            return (0, $kY3Ke.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: "loading",
                variables: action.variables
            });
        case "success":
            return (0, $kY3Ke.default)({}, state, {
                data: action.data,
                error: null,
                status: "success",
                isPaused: false
            });
        case "error":
            return (0, $kY3Ke.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: "error"
            });
        case "setState":
            return (0, $kY3Ke.default)({}, state, action.state);
        default:
            return state;
    }
}

});


parcelRequire.register("lmNwJ", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $f8e21210973082fe$export$84470d1367601e8d; });

var $l2CiO = parcelRequire("l2CiO");

var $fduVO = parcelRequire("fduVO");
function $f8e21210973082fe$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $fduVO.getAbortController)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject("Missing queryFn");
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $l2CiO.isCancelable)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== "undefined";
                    var param = manual ? pageParam : $f8e21210973082fe$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== "undefined";
                    var _param = _manual ? pageParam : $f8e21210973082fe$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === "undefined";
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $f8e21210973082fe$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $l2CiO.isCancelable)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $f8e21210973082fe$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $f8e21210973082fe$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $f8e21210973082fe$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $f8e21210973082fe$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
}
function $f8e21210973082fe$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $f8e21210973082fe$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
}

});


parcelRequire.register("cXpUO", function(module, exports) {

$parcel$export(module.exports, "QueryClientProvider", function () { return (parcelRequire("6V5bv")).QueryClientProvider; });
$parcel$export(module.exports, "useQueryClient", function () { return (parcelRequire("6V5bv")).useQueryClient; });
$parcel$export(module.exports, "useMutation", function () { return (parcelRequire("3irMb")).useMutation; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("1HW2x")).useQuery; });
// Side effects
parcelRequire("a47v0");
parcelRequire("9uPSG");

var $6V5bv = parcelRequire("6V5bv");




var $3irMb = parcelRequire("3irMb");

var $1HW2x = parcelRequire("1HW2x");





});
parcelRequire.register("a47v0", function(module, exports) {

var $it2r3 = parcelRequire("it2r3");

var $9oipK = parcelRequire("9oipK");
(0, $it2r3.notifyManager).setBatchNotifyFunction((0, $9oipK.unstable_batchedUpdates));

});
parcelRequire.register("9oipK", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $6d64a3a9e9739f85$export$c78a37762a8d58e1; });

var $fw0lo = parcelRequire("fw0lo");
var $6d64a3a9e9739f85$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).unstable_batchedUpdates;

});
parcelRequire.register("fw0lo", function(module, exports) {
"use strict";
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});



parcelRequire.register("9uPSG", function(module, exports) {

var $jgQjg = parcelRequire("jgQjg");

var $iwdDK = parcelRequire("iwdDK");
(0, $jgQjg.setLogger)((0, $iwdDK.logger));

});
parcelRequire.register("iwdDK", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $d7b5cbcb312f2761$export$af88d00dbe7f521; });
var $d7b5cbcb312f2761$export$af88d00dbe7f521 = console;

});


parcelRequire.register("6V5bv", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $509c1684c3be0a4f$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $509c1684c3be0a4f$export$45604f0cc8ae667b; });

var $7fPBF = parcelRequire("7fPBF");
var $509c1684c3be0a4f$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(undefined);
var $509c1684c3be0a4f$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $509c1684c3be0a4f$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $509c1684c3be0a4f$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $509c1684c3be0a4f$var$defaultContext;
}
var $509c1684c3be0a4f$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($509c1684c3be0a4f$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($509c1684c3be0a4f$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
var $509c1684c3be0a4f$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $509c1684c3be0a4f$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($509c1684c3be0a4f$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRequire.register("3irMb", function(module, exports) {

$parcel$export(module.exports, "useMutation", function () { return $2668994c46bd3e68$export$609860bf8b0084c; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $it2r3 = parcelRequire("it2r3");

var $fduVO = parcelRequire("fduVO");

var $9FSXg = parcelRequire("9FSXg");

var $6V5bv = parcelRequire("6V5bv");

var $5Vg32 = parcelRequire("5Vg32");
function $2668994c46bd3e68$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $fduVO.parseMutationArgs)(arg1, arg2, arg3);
    var queryClient = (0, $6V5bv.useQueryClient)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $9FSXg.MutationObserver)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $it2r3.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $fduVO.noop));
    }, []);
    if (currentResult.error && (0, $5Vg32.shouldThrowError)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $kY3Ke.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}

});
parcelRequire.register("9FSXg", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", function () { return $70b2924f2be16d1a$export$d3c1860ee66f291a; });

var $kY3Ke = parcelRequire("kY3Ke");

var $1KLsX = parcelRequire("1KLsX");

var $arv2Z = parcelRequire("arv2Z");

var $it2r3 = parcelRequire("it2r3");

var $7VskH = parcelRequire("7VskH");
var $70b2924f2be16d1a$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $kY3Ke.default)({}, this.options, {
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $arv2Z.getDefaultState)();
        var result = (0, $kY3Ke.default)({}, state, {
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $it2r3.notifyManager).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $7VskH.Subscribable));

});

parcelRequire.register("5Vg32", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $44feb96f67e82ed0$export$2072f68e6c3507cf; });
function $44feb96f67e82ed0$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === "boolean") return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}

});


parcelRequire.register("1HW2x", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $13e6d41be5252f10$export$dd0a697e1782aedd; });

var $7B3sW = parcelRequire("7B3sW");

var $fduVO = parcelRequire("fduVO");

var $4AGni = parcelRequire("4AGni");
function $13e6d41be5252f10$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $fduVO.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $4AGni.useBaseQuery)(parsedOptions, (0, $7B3sW.QueryObserver));
}

});
parcelRequire.register("7B3sW", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $587ead52f8096f7a$export$a06cf8c0066f0d4c; });

var $kY3Ke = parcelRequire("kY3Ke");

var $1KLsX = parcelRequire("1KLsX");

var $fduVO = parcelRequire("fduVO");

var $it2r3 = parcelRequire("it2r3");

var $9sKWJ = parcelRequire("9sKWJ");

var $7VskH = parcelRequire("7VskH");

var $jgQjg = parcelRequire("jgQjg");

var $l2CiO = parcelRequire("l2CiO");
var $587ead52f8096f7a$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $1KLsX.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($587ead52f8096f7a$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $587ead52f8096f7a$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $587ead52f8096f7a$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $587ead52f8096f7a$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp("error");
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $kY3Ke.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $fduVO.noop));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $fduVO.isServer) || this.currentResult.isStale || !(0, $fduVO.isValidTimeout)(this.options.staleTime)) return;
        var time = (0, $fduVO.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $fduVO.isServer) || this.options.enabled === false || !(0, $fduVO.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $9sKWJ.focusManager).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $587ead52f8096f7a$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $587ead52f8096f7a$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = "loading";
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $fduVO.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $jgQjg.getLogger)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && (status === "loading" || status === "idle")) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $fduVO.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $jgQjg.getLogger)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        var result = {
            status: status,
            isLoading: status === "loading",
            isSuccess: status === "success",
            isError: status === "error",
            isIdle: status === "idle",
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== "loading",
            isLoadingError: status === "error" && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === "error" && state.dataUpdatedAt !== 0,
            isStale: $587ead52f8096f7a$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === "tracked" && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === "tracked" ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $fduVO.shallowEqualObjects)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $kY3Ke.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error" && !(0, $l2CiO.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $it2r3.notifyManager).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    };
    return QueryObserver;
}((0, $7VskH.Subscribable));
function $587ead52f8096f7a$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $587ead52f8096f7a$var$shouldFetchOnMount(query, options) {
    return $587ead52f8096f7a$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $587ead52f8096f7a$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $587ead52f8096f7a$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $587ead52f8096f7a$var$isStale(query, options);
    }
    return false;
}
function $587ead52f8096f7a$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $587ead52f8096f7a$var$isStale(query, options);
}
function $587ead52f8096f7a$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}

});

parcelRequire.register("4AGni", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $357b64f35604fd55$export$fff0865807e996c5; });

var $7fPBF = parcelRequire("7fPBF");

var $it2r3 = parcelRequire("it2r3");

var $2uNbH = parcelRequire("2uNbH");

var $6V5bv = parcelRequire("6V5bv");

var $5Vg32 = parcelRequire("5Vg32");
function $357b64f35604fd55$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $6V5bv.useQueryClient)();
    var errorResetBoundary = (0, $2uNbH.useQueryErrorResetBoundary)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $it2r3.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $it2r3.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $it2r3.notifyManager).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $it2r3.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $5Vg32.shouldThrowError)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === "tracked") result = observer.trackResult(result, defaultedOptions);
    return result;
}

});
parcelRequire.register("2uNbH", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $1d1489ca3b909b0e$export$50dfac555130cafd; });

var $7fPBF = parcelRequire("7fPBF");
function $1d1489ca3b909b0e$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $1d1489ca3b909b0e$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($1d1489ca3b909b0e$var$createValue()); // HOOK
var $1d1489ca3b909b0e$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($1d1489ca3b909b0e$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $1d1489ca3b909b0e$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(function() {
        return $1d1489ca3b909b0e$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1d1489ca3b909b0e$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});





parcelRequire.register("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});
parcelRequire.register("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});



parcelRequire.register("hngXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a883fe7c352c85$export$2e2bcd8739ae039; });
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;

});

parcelRequire.register("cFCqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93971f0806345477$export$2e2bcd8739ae039; });
function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("kDBhE", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $f0645ef192f222f7$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $f0645ef192f222f7$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $f0645ef192f222f7$export$2e2bcd8739ae039; });

var $UAzpO = parcelRequire("UAzpO");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
const $f0645ef192f222f7$export$effb20ecdbf4d6aa = (prop)=>(0, $UAzpO.shouldForwardProp)(prop) && prop !== "classes";
const $f0645ef192f222f7$export$f10c5a10d27438e5 = (0, $UAzpO.shouldForwardProp);
const $f0645ef192f222f7$var$styled = (0, $UAzpO.default)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $9P91Y.default,
    rootShouldForwardProp: $f0645ef192f222f7$export$effb20ecdbf4d6aa
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;

});
parcelRequire.register("UAzpO", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $0aa19929000e58fe$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $0aa19929000e58fe$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $5VCcJ = parcelRequire("5VCcJ");


var $2G6xE = parcelRequire("2G6xE");

var $kQ3gK = parcelRequire("kQ3gK");

var $8M6a3 = parcelRequire("8M6a3");
const $0aa19929000e58fe$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0aa19929000e58fe$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0aa19929000e58fe$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $0aa19929000e58fe$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $0aa19929000e58fe$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $kQ3gK.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $0aa19929000e58fe$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $kQ3gK.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $0aa19929000e58fe$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $0aa19929000e58fe$export$35e57303dbd8a66 = (0, $2G6xE.default)();
const $0aa19929000e58fe$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0aa19929000e58fe$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0aa19929000e58fe$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0aa19929000e58fe$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $0aa19929000e58fe$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0aa19929000e58fe$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $8M6a3.default)((0, $kY3Ke.default)({}, props, {
            theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5VCcJ.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0aa19929000e58fe$var$defaultOverridesResolver($0aa19929000e58fe$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $cFLic.default)(inputOptions, $0aa19929000e58fe$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0aa19929000e58fe$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0aa19929000e58fe$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5VCcJ.default)(tag, (0, $kY3Ke.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $kY3Ke.default)({}, props, {
                        theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $0aa19929000e58fe$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $kY3Ke.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $0aa19929000e58fe$var$variantsResolver(props, $0aa19929000e58fe$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $kY3Ke.default)({}, props, {
                    theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("5VCcJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $450fe936b88a7a32$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $cbgs6 = parcelRequire("cbgs6");
parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");
var $bpHMA = parcelRequire("bpHMA");


var $5tMhb = parcelRequire("5tMhb");
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $cbgs6.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("cbgs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de346382d86c747$export$2e2bcd8739ae039; });

var $2MQws = parcelRequire("2MQws");
parcelRequire("cvBp9");
parcelRequire("7fPBF");
parcelRequire("9YmaI");

parcelRequire("6g0AG");
parcelRequire("3kqr7");
parcelRequire("fjS7T");
var $8de346382d86c747$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $8de346382d86c747$export$2e2bcd8739ae039 = (0, $2MQws.default).bind();
$8de346382d86c747$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $8de346382d86c747$export$2e2bcd8739ae039[tagName] = $8de346382d86c747$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("2MQws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2078ce513e00dfd7$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");

var $6g0AG = parcelRequire("6g0AG");

var $3kqr7 = parcelRequire("3kqr7");

var $fjS7T = parcelRequire("fjS7T");
var $2078ce513e00dfd7$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $2078ce513e00dfd7$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $2078ce513e00dfd7$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2078ce513e00dfd7$var$testOmitPropsOnStringTag : $2078ce513e00dfd7$var$testOmitPropsOnComponent;
};
var $2078ce513e00dfd7$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $2078ce513e00dfd7$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2078ce513e00dfd7$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $6g0AG.registerStyles)(cache, serialized, isStringTag);
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $6g0AG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $2078ce513e00dfd7$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $2078ce513e00dfd7$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $2078ce513e00dfd7$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $6H441.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $6H441.T));
            }
            if (typeof props.className === "string") className = (0, $6g0AG.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $3kqr7.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2078ce513e00dfd7$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($2078ce513e00dfd7$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $2078ce513e00dfd7$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRequire.register("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("bpHMA", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $84f3fdd51733d70b$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $84f3fdd51733d70b$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $84f3fdd51733d70b$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6H441")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("6H441")).w; });

var $6H441 = parcelRequire("6H441");

var $7fPBF = parcelRequire("7fPBF");

var $6g0AG = parcelRequire("6g0AG");

var $fjS7T = parcelRequire("fjS7T");

var $3kqr7 = parcelRequire("3kqr7");
parcelRequire("10euI");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $84f3fdd51733d70b$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $84f3fdd51733d70b$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $6H441.h).call(props, "css")) // $FlowFixMe
    return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6H441.E);
    createElementArgArray[1] = (0, $6H441.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
var $84f3fdd51733d70b$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $84f3fdd51733d70b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6H441.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $3kqr7.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $6H441.T)));
    if (!(0, $6H441.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $fjS7T.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fjS7T.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $6g0AG.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $84f3fdd51733d70b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $3kqr7.serializeStyles)(args);
}
var $84f3fdd51733d70b$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $84f3fdd51733d70b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $84f3fdd51733d70b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $84f3fdd51733d70b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $6g0AG.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $84f3fdd51733d70b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $6g0AG.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $84f3fdd51733d70b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6H441.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $3kqr7.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $6g0AG.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $84f3fdd51733d70b$var$merge(cache.registered, css, $84f3fdd51733d70b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $6H441.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($84f3fdd51733d70b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $84f3fdd51733d70b$var$isBrowser, $84f3fdd51733d70b$var$isTestEnv, $84f3fdd51733d70b$var$globalContext, $84f3fdd51733d70b$var$globalKey;

});
parcelRequire.register("6H441", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $4df9e939738a7402$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $4df9e939738a7402$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $4df9e939738a7402$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4df9e939738a7402$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $4df9e939738a7402$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4df9e939738a7402$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $10euI = parcelRequire("10euI");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $haRds = parcelRequire("haRds");

var $6g0AG = parcelRequire("6g0AG");

var $3kqr7 = parcelRequire("3kqr7");

var $fjS7T = parcelRequire("fjS7T");
var $4df9e939738a7402$export$23f2a1d2818174ef = true;
var $4df9e939738a7402$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4df9e939738a7402$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $10euI.default)({
    key: "css"
}) : null);
var $4df9e939738a7402$export$e7094788287c5e9b = $4df9e939738a7402$var$EmotionCacheContext.Provider;
var $4df9e939738a7402$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
};
var $4df9e939738a7402$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4df9e939738a7402$export$23f2a1d2818174ef) $4df9e939738a7402$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4df9e939738a7402$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $10euI.default)({
                key: "css"
            });
            return /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4df9e939738a7402$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4df9e939738a7402$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
};
var $4df9e939738a7402$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $4df9e939738a7402$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $4df9e939738a7402$var$getTheme(outerTheme, theme);
    });
});
var $4df9e939738a7402$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4df9e939738a7402$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4df9e939738a7402$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $haRds.default)(WithTheme, Component);
}
var $4df9e939738a7402$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $4df9e939738a7402$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $4df9e939738a7402$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $4df9e939738a7402$var$getLastPart(match[1]);
    return undefined;
};
var $4df9e939738a7402$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $4df9e939738a7402$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $4df9e939738a7402$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $4df9e939738a7402$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($4df9e939738a7402$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $4df9e939738a7402$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $4df9e939738a7402$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $4df9e939738a7402$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $4df9e939738a7402$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4df9e939738a7402$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4df9e939738a7402$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $4df9e939738a7402$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $6g0AG.registerStyles)(cache, serialized, isStringTag);
    (0, $fjS7T.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $6g0AG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $4df9e939738a7402$var$Emotion = /* #__PURE__ */ $4df9e939738a7402$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4df9e939738a7402$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $6g0AG.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $3kqr7.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($4df9e939738a7402$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4df9e939738a7402$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $4df9e939738a7402$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4df9e939738a7402$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4df9e939738a7402$export$a9c23c6ac3fc3eca = $4df9e939738a7402$var$Emotion;

});
parcelRequire.register("10euI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb108cf9f15301b$export$2e2bcd8739ae039; });

var $67tST = parcelRequire("67tST");

var $cByrN = parcelRequire("cByrN");
parcelRequire("lT6zG");
parcelRequire("4AWAi");
var $0bb108cf9f15301b$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $0bb108cf9f15301b$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $0bb108cf9f15301b$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $0bb108cf9f15301b$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($0bb108cf9f15301b$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $0bb108cf9f15301b$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $0bb108cf9f15301b$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$0bb108cf9f15301b$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $0bb108cf9f15301b$var$fixedElements.set(element, true);
    var points = [];
    var rules = $0bb108cf9f15301b$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $0bb108cf9f15301b$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $0bb108cf9f15301b$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $0bb108cf9f15301b$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($0bb108cf9f15301b$var$ignoreFlag) > -1;
};
var $0bb108cf9f15301b$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($0bb108cf9f15301b$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $0bb108cf9f15301b$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $0bb108cf9f15301b$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$0bb108cf9f15301b$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $0bb108cf9f15301b$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $0bb108cf9f15301b$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$0bb108cf9f15301b$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    } else if ($0bb108cf9f15301b$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $0bb108cf9f15301b$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $0bb108cf9f15301b$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + "box-$1$2" + (0, $cByrN.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-item-" + (0, $cByrN.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + "flex-line-pack" + (0, $cByrN.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + "box-" + (0, $cByrN.replace)(value, "-grow", "") + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, "$1" + (0, $cByrN.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + "$1"), /(image-set)/, (0, $cByrN.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + "box-pack:$3" + (0, $cByrN.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $cByrN.WEBKIT) + "$2-$3" + "$1" + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, "stretch") ? $0bb108cf9f15301b$var$prefix((0, $cByrN.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ":", ":" + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $cByrN.WEBKIT) + "$2$3" + "$1" + (0, $cByrN.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $0bb108cf9f15301b$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $0bb108cf9f15301b$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, "@", "@" + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ":" + (0, $cByrN.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ":" + (0, $cByrN.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ":" + (0, $cByrN.MOZ) + "$1")
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $0bb108cf9f15301b$var$defaultStylisPlugins = [
    $0bb108cf9f15301b$var$prefixer
];
var $0bb108cf9f15301b$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $0bb108cf9f15301b$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $0bb108cf9f15301b$var$compat,
        $0bb108cf9f15301b$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $cByrN.stringify),
        (0, $cByrN.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $67tST.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("67tST", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $474a93eda108ec7a$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $474a93eda108ec7a$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $474a93eda108ec7a$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $474a93eda108ec7a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($474a93eda108ec7a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $474a93eda108ec7a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRequire.register("haRds", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c80ca66c64e3fad5$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $c80ca66c64e3fad5$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("8Ae2G", function(module, exports) {
"use strict";

var $dOv1V = parcelRequire("dOv1V");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dOv1V.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component["$$typeof"]] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRequire.register("dOv1V", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3oWWu"));

});
parcelRequire.register("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
"use strict";
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});




parcelRequire.register("6g0AG", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $48e4b1fcfcd646c1$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $48e4b1fcfcd646c1$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $48e4b1fcfcd646c1$export$6f077d94b33a01aa; });
var $48e4b1fcfcd646c1$var$isBrowser = true;
function $48e4b1fcfcd646c1$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $48e4b1fcfcd646c1$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $48e4b1fcfcd646c1$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $48e4b1fcfcd646c1$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $48e4b1fcfcd646c1$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("3kqr7", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $26c7bf120a29b208$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $26c7bf120a29b208$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $26c7bf120a29b208$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $26c7bf120a29b208$var$hyphenateRegex = /[A-Z]|^ms/g;
var $26c7bf120a29b208$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $26c7bf120a29b208$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $26c7bf120a29b208$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $26c7bf120a29b208$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $26c7bf120a29b208$var$isCustomProperty(styleName) ? styleName : styleName.replace($26c7bf120a29b208$var$hyphenateRegex, "-$&").toLowerCase();
});
var $26c7bf120a29b208$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($26c7bf120a29b208$var$animationRegex, function(match, p1, p2) {
                $26c7bf120a29b208$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $26c7bf120a29b208$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$26c7bf120a29b208$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $26c7bf120a29b208$var$contentValuePattern, $26c7bf120a29b208$var$contentValues, $26c7bf120a29b208$var$oldProcessStyleValue, $26c7bf120a29b208$var$msPattern, $26c7bf120a29b208$var$hyphenPattern, $26c7bf120a29b208$var$hyphenatedCache;
var $26c7bf120a29b208$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $26c7bf120a29b208$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $26c7bf120a29b208$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $26c7bf120a29b208$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $26c7bf120a29b208$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $26c7bf120a29b208$var$cursor;
                var result = interpolation(mergedProps);
                $26c7bf120a29b208$var$cursor = previousCursor;
                return $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $26c7bf120a29b208$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($26c7bf120a29b208$var$isProcessableValue(value)) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($26c7bf120a29b208$var$isProcessableValue(value[_i])) string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + $26c7bf120a29b208$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $26c7bf120a29b208$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $26c7bf120a29b208$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $26c7bf120a29b208$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $26c7bf120a29b208$var$cursor;
var $26c7bf120a29b208$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $26c7bf120a29b208$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $26c7bf120a29b208$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $26c7bf120a29b208$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $26c7bf120a29b208$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $26c7bf120a29b208$var$cursor
    };
};

});
parcelRequire.register("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("fjS7T", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b2729db54ba7ee9b$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b2729db54ba7ee9b$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $b2729db54ba7ee9b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b2729db54ba7ee9b$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $b2729db54ba7ee9b$export$db21c7ffa21794e7 = $b2729db54ba7ee9b$var$useInsertionEffect || $b2729db54ba7ee9b$var$syncFallback;
var $b2729db54ba7ee9b$export$811a713a7276cb9d = $b2729db54ba7ee9b$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});





parcelRequire.register("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $bpHMA = parcelRequire("bpHMA");

var $bbzbN = parcelRequire("bbzbN");
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bpHMA.Global), {
        styles: globalStyles
    });
}

});


parcelRequire.register("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");

var $iZrRs = parcelRequire("iZrRs");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");
const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cFLic.default)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $iZrRs.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $dYkRa.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $kY3Ke.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kY3Ke.default)({}, (0, $l8Cag.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dYkRa.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRequire.register("dYkRa", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $a2c10ea133da1790$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $a2c10ea133da1790$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $a2c10ea133da1790$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $a2c10ea133da1790$var$deepClone(source) {
    if (!$a2c10ea133da1790$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $a2c10ea133da1790$var$deepClone(source[key]);
    });
    return output;
}
function $a2c10ea133da1790$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($a2c10ea133da1790$export$53b83ca8eaab0383(target) && $a2c10ea133da1790$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($a2c10ea133da1790$export$53b83ca8eaab0383(source[key]) && key in target && $a2c10ea133da1790$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $a2c10ea133da1790$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $a2c10ea133da1790$export$53b83ca8eaab0383(source[key]) ? $a2c10ea133da1790$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("iZrRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd33892704fa9f8b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kY3Ke.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $cFLic.default)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $kY3Ke.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRequire.register("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5z69T.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("5z69T", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $40d4ff9e66a5531b$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $40d4ff9e66a5531b$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $40d4ff9e66a5531b$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $40d4ff9e66a5531b$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $40d4ff9e66a5531b$export$6f98e8eaf0be1996; });


var $cvrkU = parcelRequire("cvrkU");

var $190Wm = parcelRequire("190Wm");

var $4So0q = parcelRequire("4So0q");

var $dMDTp = parcelRequire("dMDTp");
const $40d4ff9e66a5531b$var$properties = {
    m: "margin",
    p: "padding"
};
const $40d4ff9e66a5531b$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $dMDTp.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $190Wm.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4So0q.default), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;

});
parcelRequire.register("cvrkU", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $91ad95ac62846a03$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $91ad95ac62846a03$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $91ad95ac62846a03$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $91ad95ac62846a03$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $91ad95ac62846a03$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $91ad95ac62846a03$export$980e6a259d807490; });

var $kY3Ke = parcelRequire("kY3Ke");


var $dYkRa = parcelRequire("dYkRa");

var $4So0q = parcelRequire("4So0q");
const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $4So0q.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $dYkRa.default)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;

});
parcelRequire.register("4So0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ced3a04f47cab4$export$2e2bcd8739ae039; });

var $dYkRa = parcelRequire("dYkRa");
function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $dYkRa.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;

});


parcelRequire.register("190Wm", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0d575c74131361b5$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0d575c74131361b5$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0d575c74131361b5$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");


var $cvrkU = parcelRequire("cvrkU");
function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;

});
parcelRequire.register("iCiVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da749d88f71122$export$2e2bcd8739ae039; });

var $e5zLi = parcelRequire("e5zLi");
function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $e5zLi.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("e5zLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a41d45db477219b9$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $a41d45db477219b9$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("dMDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08eb3ea758ca121$export$2e2bcd8739ae039; });
function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("8M6a3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");

var $4So0q = parcelRequire("4So0q");

var $190Wm = parcelRequire("190Wm");

var $cvrkU = parcelRequire("cvrkU");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $190Wm.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $190Wm.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $190Wm.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cvrkU.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cvrkU.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $4So0q.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    "sx"
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRequire.register("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");

var $brmMH = parcelRequire("brmMH");

var $aoYMG = parcelRequire("aoYMG");

var $lzsJx = parcelRequire("lzsJx");

var $8LvXe = parcelRequire("8LvXe");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $brmMH.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $brmMH.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $lzsJx.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $lzsJx.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $lzsJx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5z69T.padding)
    },
    pt: {
        style: (0, $5z69T.padding)
    },
    pr: {
        style: (0, $5z69T.padding)
    },
    pb: {
        style: (0, $5z69T.padding)
    },
    pl: {
        style: (0, $5z69T.padding)
    },
    px: {
        style: (0, $5z69T.padding)
    },
    py: {
        style: (0, $5z69T.padding)
    },
    padding: {
        style: (0, $5z69T.padding)
    },
    paddingTop: {
        style: (0, $5z69T.padding)
    },
    paddingRight: {
        style: (0, $5z69T.padding)
    },
    paddingBottom: {
        style: (0, $5z69T.padding)
    },
    paddingLeft: {
        style: (0, $5z69T.padding)
    },
    paddingX: {
        style: (0, $5z69T.padding)
    },
    paddingY: {
        style: (0, $5z69T.padding)
    },
    paddingInline: {
        style: (0, $5z69T.padding)
    },
    paddingInlineStart: {
        style: (0, $5z69T.padding)
    },
    paddingInlineEnd: {
        style: (0, $5z69T.padding)
    },
    paddingBlock: {
        style: (0, $5z69T.padding)
    },
    paddingBlockStart: {
        style: (0, $5z69T.padding)
    },
    paddingBlockEnd: {
        style: (0, $5z69T.padding)
    },
    m: {
        style: (0, $5z69T.margin)
    },
    mt: {
        style: (0, $5z69T.margin)
    },
    mr: {
        style: (0, $5z69T.margin)
    },
    mb: {
        style: (0, $5z69T.margin)
    },
    ml: {
        style: (0, $5z69T.margin)
    },
    mx: {
        style: (0, $5z69T.margin)
    },
    my: {
        style: (0, $5z69T.margin)
    },
    margin: {
        style: (0, $5z69T.margin)
    },
    marginTop: {
        style: (0, $5z69T.margin)
    },
    marginRight: {
        style: (0, $5z69T.margin)
    },
    marginBottom: {
        style: (0, $5z69T.margin)
    },
    marginLeft: {
        style: (0, $5z69T.margin)
    },
    marginX: {
        style: (0, $5z69T.margin)
    },
    marginY: {
        style: (0, $5z69T.margin)
    },
    marginInline: {
        style: (0, $5z69T.margin)
    },
    marginInlineStart: {
        style: (0, $5z69T.margin)
    },
    marginInlineEnd: {
        style: (0, $5z69T.margin)
    },
    marginBlock: {
        style: (0, $5z69T.margin)
    },
    marginBlockStart: {
        style: (0, $5z69T.margin)
    },
    marginBlockEnd: {
        style: (0, $5z69T.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $aoYMG.gap)
    },
    rowGap: {
        style: (0, $aoYMG.rowGap)
    },
    columnGap: {
        style: (0, $aoYMG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxWidth: {
        style: (0, $8LvXe.maxWidth)
    },
    minWidth: {
        transform: (0, $8LvXe.sizingTransform)
    },
    height: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    minHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRequire.register("brmMH", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $8543e3d4e0a2f626$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $8543e3d4e0a2f626$export$7a57f79000377ca2; });


var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");
function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = (0, $190Wm.default)({
    prop: "border",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = (0, $190Wm.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = (0, $190Wm.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = (0, $190Wm.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$47658cca1a909427 = (0, $190Wm.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $8543e3d4e0a2f626$export$34e2febe53ae29cc
});
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = (0, $190Wm.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$126a92c968acdb85 = (0, $190Wm.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = (0, $190Wm.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$340b0327727f6d1a = (0, $190Wm.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$60beef91a985b4bf = (0, $190Wm.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $8543e3d4e0a2f626$var$borders = (0, $eB9d8.default)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;

});
parcelRequire.register("eB9d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0baa79cee865b3$export$2e2bcd8739ae039; });

var $4So0q = parcelRequire("4So0q");
function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4So0q.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;

});


parcelRequire.register("aoYMG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $792b4bc41110be3c$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $792b4bc41110be3c$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $792b4bc41110be3c$export$8a833ffa5f5dbeda; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");

const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $190Wm.default)({
    prop: "gridColumn"
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $190Wm.default)({
    prop: "gridRow"
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $190Wm.default)({
    prop: "gridAutoFlow"
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $190Wm.default)({
    prop: "gridAutoColumns"
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $190Wm.default)({
    prop: "gridAutoRows"
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $190Wm.default)({
    prop: "gridTemplateColumns"
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $190Wm.default)({
    prop: "gridTemplateRows"
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $190Wm.default)({
    prop: "gridTemplateAreas"
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $190Wm.default)({
    prop: "gridArea"
});
const $792b4bc41110be3c$var$grid = (0, $eB9d8.default)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;

});

parcelRequire.register("lzsJx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $fb4327c08e40e84e$export$dbaffd4420ea0ac6; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");
function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $190Wm.default)({
    prop: "color",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $190Wm.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $190Wm.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $eB9d8.default)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;

});

parcelRequire.register("8LvXe", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $661b7ffebb8ef134$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $661b7ffebb8ef134$export$488fda99655ff65a; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $cvrkU = parcelRequire("cvrkU");
function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $190Wm.default)({
    prop: "width",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cvrkU.values)[propValue];
            return {
                maxWidth: breakpoint || $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $190Wm.default)({
    prop: "minWidth",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $190Wm.default)({
    prop: "height",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $190Wm.default)({
    prop: "maxHeight",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $190Wm.default)({
    prop: "minHeight",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $190Wm.default)({
    prop: "size",
    cssProperty: "width",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $190Wm.default)({
    prop: "size",
    cssProperty: "height",
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $190Wm.default)({
    prop: "boxSizing"
});
const $661b7ffebb8ef134$var$sizing = (0, $eB9d8.default)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;

});




parcelRequire.register("kQ3gK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2bb3328370663ea$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $iCiVn = parcelRequire("iCiVn");
const $f2bb3328370663ea$var$_excluded = [
    "variant"
];
function $f2bb3328370663ea$var$isEmpty(string) {
    return string.length === 0;
}
function $f2bb3328370663ea$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $cFLic.default)(props, $f2bb3328370663ea$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $f2bb3328370663ea$var$isEmpty(classKey) ? props[key] : (0, $iCiVn.default)(props[key]);
        else classKey += `${$f2bb3328370663ea$var$isEmpty(classKey) ? key : (0, $iCiVn.default)(key)}${(0, $iCiVn.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRequire.register("9P91Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe1d2377a5002$export$2e2bcd8739ae039; });

var $hmhHQ = parcelRequire("hmhHQ");
"use client";
const $726fe1d2377a5002$var$defaultTheme = (0, $hmhHQ.default)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;

});
parcelRequire.register("hmhHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3239ce6bf6e490$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");
var $e5zLi = parcelRequire("e5zLi");

var $2G6xE = parcelRequire("2G6xE");
var $hXGiu = parcelRequire("hXGiu");
var $8M6a3 = parcelRequire("8M6a3");


var $oPCQw = parcelRequire("oPCQw");

var $G7KID = parcelRequire("G7KID");

var $5vuSA = parcelRequire("5vuSA");

var $3jGgo = parcelRequire("3jGgo");

var $kjiCM = parcelRequire("kjiCM");

var $eGmqa = parcelRequire("eGmqa");
const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cFLic.default)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars) throw new Error((0, $e5zLi.default)(18));
    const palette = (0, $G7KID.default)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $dYkRa.default)(systemTheme, {
        mixins: (0, $oPCQw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3jGgo.default).slice(),
        typography: (0, $5vuSA.default)(palette, typographyInput),
        transitions: (0, $kjiCM.default)(transitionsInput),
        zIndex: (0, $kY3Ke.default)({}, (0, $eGmqa.default))
    });
    muiTheme = (0, $dYkRa.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dYkRa.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;

});
parcelRequire.register("oPCQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04aa49c3b5b31b02$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kY3Ke.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("G7KID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e9efd96a5c6f8a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");
var $e5zLi = parcelRequire("e5zLi");

var $cxeT8 = parcelRequire("cxeT8");

var $6akYf = parcelRequire("6akYf");

var $2nhXL = parcelRequire("2nhXL");

var $3Ctzq = parcelRequire("3Ctzq");

var $9PTBs = parcelRequire("9PTBs");

var $5WQac = parcelRequire("5WQac");

var $gal31 = parcelRequire("gal31");

var $1Btry = parcelRequire("1Btry");

var $hnm6Q = parcelRequire("hnm6Q");
const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $6akYf.default).white,
        default: (0, $6akYf.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $6akYf.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $6akYf.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $cxeT8.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $cxeT8.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $gal31.default)[200],
        light: (0, $gal31.default)[50],
        dark: (0, $gal31.default)[400]
    };
    return {
        main: (0, $gal31.default)[700],
        light: (0, $gal31.default)[400],
        dark: (0, $gal31.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3Ctzq.default)[200],
        light: (0, $3Ctzq.default)[50],
        dark: (0, $3Ctzq.default)[400]
    };
    return {
        main: (0, $3Ctzq.default)[500],
        light: (0, $3Ctzq.default)[300],
        dark: (0, $3Ctzq.default)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9PTBs.default)[500],
        light: (0, $9PTBs.default)[300],
        dark: (0, $9PTBs.default)[700]
    };
    return {
        main: (0, $9PTBs.default)[700],
        light: (0, $9PTBs.default)[400],
        dark: (0, $9PTBs.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1Btry.default)[400],
        light: (0, $1Btry.default)[300],
        dark: (0, $1Btry.default)[700]
    };
    return {
        main: (0, $1Btry.default)[700],
        light: (0, $1Btry.default)[500],
        dark: (0, $1Btry.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $hnm6Q.default)[400],
        light: (0, $hnm6Q.default)[300],
        dark: (0, $hnm6Q.default)[700]
    };
    return {
        main: (0, $hnm6Q.default)[800],
        light: (0, $hnm6Q.default)[500],
        dark: (0, $hnm6Q.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5WQac.default)[400],
        light: (0, $5WQac.default)[300],
        dark: (0, $5WQac.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $5WQac.default)[500],
        dark: (0, $5WQac.default)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cFLic.default)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $cxeT8.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $e5zLi.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $e5zLi.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $dYkRa.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $kY3Ke.default)({}, (0, $6akYf.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2nhXL.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("cxeT8", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $92041da11764723e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $92041da11764723e$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $92041da11764723e$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $92041da11764723e$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $92041da11764723e$export$e665714f76e581fd; });

var $e5zLi = parcelRequire("e5zLi");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $92041da11764723e$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $92041da11764723e$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $92041da11764723e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $92041da11764723e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $92041da11764723e$export$677b39864803984e($92041da11764723e$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $e5zLi.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $e5zLi.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $92041da11764723e$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $92041da11764723e$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $92041da11764723e$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $92041da11764723e$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $92041da11764723e$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $92041da11764723e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $92041da11764723e$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$92041da11764723e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $92041da11764723e$export$29fb7152bd3f781a(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $92041da11764723e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $92041da11764723e$export$c852d90bf7403b62(color) {
    color = $92041da11764723e$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $92041da11764723e$export$677b39864803984e($92041da11764723e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $92041da11764723e$export$d061e26956a60b0a(foreground, background) {
    const lumA = $92041da11764723e$export$c852d90bf7403b62(foreground);
    const lumB = $92041da11764723e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $92041da11764723e$export$58f0f39f63f3cf42(color, value) {
    color = $92041da11764723e$export$677b39864803984e(color);
    value = $92041da11764723e$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $92041da11764723e$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$4b073707ff63303(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$c0816ed86df316af(color, coefficient) {
    color = $92041da11764723e$export$677b39864803984e(color);
    coefficient = $92041da11764723e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $92041da11764723e$export$211a73f2b8c10ce4(color);
}
function $92041da11764723e$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $92041da11764723e$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $92041da11764723e$export$c852d90bf7403b62(color) > 0.5 ? $92041da11764723e$export$4b073707ff63303(color, coefficient) : $92041da11764723e$export$c0816ed86df316af(color, coefficient);
}
function $92041da11764723e$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $92041da11764723e$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("6akYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d3f19e39b3b144$export$2e2bcd8739ae039; });
const $47d3f19e39b3b144$var$common = {
    black: "#000",
    white: "#fff"
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;

});

parcelRequire.register("2nhXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baba9d0f229a247$export$2e2bcd8739ae039; });
const $1baba9d0f229a247$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;

});

parcelRequire.register("3Ctzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bdbc6cce4aa96$export$2e2bcd8739ae039; });
const $2a2bdbc6cce4aa96$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;

});

parcelRequire.register("9PTBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72940215fdf862f4$export$2e2bcd8739ae039; });
const $72940215fdf862f4$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;

});

parcelRequire.register("5WQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $454ad523c90fa85d$export$2e2bcd8739ae039; });
const $454ad523c90fa85d$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;

});

parcelRequire.register("gal31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4de82bafd68977$export$2e2bcd8739ae039; });
const $bc4de82bafd68977$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;

});

parcelRequire.register("1Btry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b015f9ee6c8f9f$export$2e2bcd8739ae039; });
const $12b015f9ee6c8f9f$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;

});

parcelRequire.register("hnm6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca65bc19996a7eac$export$2e2bcd8739ae039; });
const $ca65bc19996a7eac$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;

});


parcelRequire.register("5vuSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4027cd084802bc60$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");
const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cFLic.default)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $dYkRa.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("3jGgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a3ee12a0d43232$export$2e2bcd8739ae039; });
const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    "none",
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;

});

parcelRequire.register("kjiCM", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $ec94076b9ecccee1$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $ec94076b9ecccee1$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cFLic.default)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(",");
    };
    return (0, $kY3Ke.default)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("eGmqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06614e124e32b2$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;

});



parcelRequire.register("jwhZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e35ef6915a224202$export$2e2bcd8739ae039; });
var $e35ef6915a224202$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("5j2OD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dd0e9417d40119e$export$2e2bcd8739ae039; });

var $9HPC7 = parcelRequire("9HPC7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
function $3dd0e9417d40119e$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9HPC7.default)({
        props: props,
        name: name,
        defaultTheme: $9P91Y.default,
        themeId: (0, $jwhZE.default)
    });
}

});
parcelRequire.register("9HPC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71102aa90e2b2620$export$2e2bcd8739ae039; });

var $38WAi = parcelRequire("38WAi");

var $4kWyf = parcelRequire("4kWyf");
"use client";
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $4kWyf.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $38WAi.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("38WAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $249f9015c4a2303b$export$2e2bcd8739ae039; });

var $aNaIu = parcelRequire("aNaIu");
function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $aNaIu.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("aNaIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db6cb11f5bc6e76$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $7db6cb11f5bc6e76$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kY3Ke.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kY3Ke.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kY3Ke.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $7db6cb11f5bc6e76$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("4kWyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328672c8d07e1c59$export$2e2bcd8739ae039; });

var $2G6xE = parcelRequire("2G6xE");

var $84PRT = parcelRequire("84PRT");
"use client";
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $84PRT.default)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;

});
parcelRequire.register("84PRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e16ee62ac64bb0b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");
"use client";
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $6H441.T));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;

});




parcelRequire.register("4jzsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32447174989d1976$export$2e2bcd8739ae039; });

var $k6RDS = parcelRequire("k6RDS");
function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $k6RDS.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRequire.register("k6RDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3dfa6b173640a4$export$2e2bcd8739ae039; });

var $kU6nt = parcelRequire("kU6nt");
const $ea3dfa6b173640a4$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $ea3dfa6b173640a4$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $kU6nt.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("kU6nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37dfc12e5d89c96$export$2e2bcd8739ae039; });
const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;

});



parcelRequire.register("hG0Cb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cde6d60726777b50$export$2e2bcd8739ae039; });


var $iRkEk = parcelRequire("iRkEk");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
"use client";
const $cde6d60726777b50$var$Stack = (0, $iRkEk.default)({
    createStyledComponent: (0, $kDBhE.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $5j2OD.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $cde6d60726777b50$export$2e2bcd8739ae039 = $cde6d60726777b50$var$Stack;

});
parcelRequire.register("iRkEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbad31c7655ddfe7$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $dYkRa = parcelRequire("dYkRa");
var $cFCqu = parcelRequire("cFCqu");
var $k6RDS = parcelRequire("k6RDS");

var $b9j48 = parcelRequire("b9j48");

var $9HPC7 = parcelRequire("9HPC7");

var $mqrnX = parcelRequire("mqrnX");

var $2G6xE = parcelRequire("2G6xE");

var $cvrkU = parcelRequire("cvrkU");

var $5z69T = parcelRequire("5z69T");

var $bbzbN = parcelRequire("bbzbN");
const $dbad31c7655ddfe7$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $dbad31c7655ddfe7$var$defaultTheme = (0, $2G6xE.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $dbad31c7655ddfe7$var$defaultCreateStyledComponent = (0, $b9j48.default)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $dbad31c7655ddfe7$var$useThemePropsDefault(props) {
    return (0, $9HPC7.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $dbad31c7655ddfe7$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $dbad31c7655ddfe7$var$joinChildren(children, separator) {
    const childrenArray = $7fPBF.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $7fPBF.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $dbad31c7655ddfe7$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $dbad31c7655ddfe7$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $cvrkU.handleBreakpoints)({
        theme: theme
    }, (0, $cvrkU.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $5z69T.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $cvrkU.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $5z69T.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$dbad31c7655ddfe7$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $5z69T.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $dYkRa.default)(styles, (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $cvrkU.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $dbad31c7655ddfe7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $dbad31c7655ddfe7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $dbad31c7655ddfe7$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $cFCqu.default)(slots, (slot)=>(0, $k6RDS.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($dbad31c7655ddfe7$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $mqrnX.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $cFLic.default)(props, $dbad31c7655ddfe7$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $bbzbN.jsx)(StackRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            children: divider ? $dbad31c7655ddfe7$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}

});
parcelRequire.register("b9j48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81df530a7daa801f$export$2e2bcd8739ae039; });

var $UAzpO = parcelRequire("UAzpO");
const $81df530a7daa801f$var$styled = (0, $UAzpO.default)();
var $81df530a7daa801f$export$2e2bcd8739ae039 = $81df530a7daa801f$var$styled;

});

parcelRequire.register("mqrnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043690c2de8ba6fa$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $dYkRa = parcelRequire("dYkRa");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cFLic.default)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $dYkRa.isPlainObject)(result)) return systemProps;
        return (0, $kY3Ke.default)({}, systemProps, result);
    };
    else finalSx = (0, $kY3Ke.default)({}, systemProps, inSx);
    return (0, $kY3Ke.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRequire.register("3loMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f68e516ee75fc4$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $mqrnX = parcelRequire("mqrnX");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $iG6DO = parcelRequire("iG6DO");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $b6UUh.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $iG6DO.getTypographyUtilityClass), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $kDBhE.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $b6UUh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $mqrnX.default)((0, $kY3Ke.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $cFLic.default)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || "span";
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $kY3Ke.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;

});
parcelRequire.register("b6UUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816c65c0e1f7082c$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $iCiVn.default);

});

parcelRequire.register("iG6DO", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $d9914d0380157c73$export$24c1f8f60cbac79e; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $k6RDS.default)("MuiTypography", slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $4jzsB.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;

});


parcelRequire.register("dNDci", function(module, exports) {

$parcel$export(module.exports, "AppService", function () { return $84b4898d1fec7fab$export$ab0fd2f388007ee1; });

var $xggF4 = parcelRequire("xggF4");
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");
class $84b4898d1fec7fab$export$ab0fd2f388007ee1 {
    async api_getAllOrganizations(domain) {
        return (0, $xggF4.default)({
            url: `/private/organizations${!!domain ? `/?domain=${domain}` : ""}`,
            method: "GET"
        });
    }
    async api_getClubFeatureToggles(role, clubId) {
        return (0, $xggF4.default)({
            url: `/${role}/club/${clubId}/feature-toggles`,
            method: "GET"
        });
    }
    async api_getDomainFeatureToggles() {
        return (0, $xggF4.default)({
            url: "/feature-toggles",
            method: "GET"
        });
    }
    async api_getReservationTypes(role) {
        return (0, $xggF4.default)({
            url: `/${role}/reservation/reservation-categories`,
            method: "GET"
        });
    }
    async api_getClubsByOrganizationId(role, organizationId) {
        return (0, $xggF4.default)({
            //depending on the user role we must pass public, private or admin
            url: `/${role}/organizations/${organizationId}/clubs`,
            method: "GET"
        });
    }
    async api_getAvailableSlots(clubId, startDate, endDate) {
        return (0, $xggF4.default)({
            url: `/public/club/${clubId}/available-slots?startDate=${startDate}&endDate=${endDate}`,
            method: "GET"
        });
    }
    async api_createClubOrganizations(clubId, organizationsData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/organizations`,
                method: "POST",
                data: {
                    organizationIds: organizationsData
                }
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_getCategories() {
        return (0, $xggF4.default)({
            url: `/categories`,
            method: "GET"
        });
    }
    async api_getClubNames() {
        return (0, $xggF4.default)({
            url: `/club/clubNames`,
            method: "GET"
        });
    }
    async api_getClubs(role) {
        return (0, $xggF4.default)({
            //depending on the user role we must pass public, private or admin
            url: `/${role}/club`,
            method: "GET"
        });
    }
    async api_getUser() {
        return (0, $xggF4.default)({
            url: `/public/user`,
            method: "GET"
        });
    }
    async api_getAreaById(id) {
        return (0, $xggF4.default)({
            url: `/area/${id}`,
            method: "GET"
        });
    }
    async api_areaPhotos(role, areaId, areaPhotos) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/area/${areaId}/photo`,
                method: "POST",
                data: {
                    photos: areaPhotos
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_deleteAreaPhotos(areaId, photosUrl) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/area/${areaId}/photo`,
                method: "DELETE",
                data: {
                    photosUrl: photosUrl
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_deleteArea(areaId) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/area/${areaId}`,
                method: "DELETE"
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_getClubById(role, clubId) {
        return (0, $xggF4.default)({
            //depending on the user role we must pass public, private or admin
            url: `/${role}/club/${clubId}`,
            method: "GET"
        });
    }
    async api_deleteAccount(role, password) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/user/${role === "private" ? "" : "player"}`,
                method: "DELETE",
                data: {
                    password: password
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_createClub(role, clubData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club`,
                method: "POST",
                data: clubData
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_createClubAddress(clubId, clubAddress) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/address`,
                method: "POST",
                data: clubAddress
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_createClubContact(clubId, contactData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/contact`,
                method: "POST",
                data: {
                    contacts: [
                        contactData
                    ]
                }
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_updateClubContact(contactId, contactData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/contact/${contactId}`,
                method: "PUT",
                data: contactData
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_deleteClubContact(contactId) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/contact/${contactId}`,
                method: "DELETE"
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_getClub(role, data) {
        return (0, $xggF4.default)({
            url: `${role !== "open" ? `/${role}` : ""}/club/${data.clubId}`,
            method: "GET"
        });
    }
    async api_getHighlightedClubs() {
        try {
            const response = await (0, $xggF4.default)({
                url: `/club/highlighted`,
                method: "GET"
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_getClubAreas(role, data, params) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${data.clubId}/area`,
                method: "GET",
                params: params
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_getAreaSchedules(areaId) {
        return (0, $xggF4.default)({
            url: `/private/area/${areaId}/schedule`,
            method: "GET"
        });
    }
    async api_getClosedSchedules(areaId) {
        return (0, $xggF4.default)({
            url: `/private/area/${areaId}/closed-schedule`,
            method: "GET"
        });
    }
    async api_createAreaSchedules(areaId, schedules) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/area/${areaId}/schedule`,
                method: "POST",
                data: {
                    schedules: schedules
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_createClosedSchedules(areaId, closedSchedules) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/area/${areaId}/closed-schedule`,
                method: "POST",
                data: {
                    schedules: closedSchedules
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_createArea(areaData) {
        try {
            const response = await (0, $xggF4.default)({
                url: "/private/area",
                method: "POST",
                data: areaData
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_updateArea(areaId, areaData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/area/${areaId}`,
                method: "PUT",
                data: areaData
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_createAreaCategories(areaId, categoryData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/area/${areaId}/category`,
                method: "POST",
                data: categoryData
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_searchAreas(role, searchObj = {}) {
        return (0, $xggF4.default)({
            url: `/${role}/area/search`,
            method: "GET",
            params: {
                ...searchObj
            }
        });
    }
    async api_searchClubs(searchObj = {}, role) {
        return (0, $xggF4.default)({
            url: `${!!role ? `/${role}` : ""}/club/search`,
            method: "GET",
            params: searchObj
        });
    }
    async api_getClubSchedules(clubId) {
        return (0, $xggF4.default)({
            url: `/private/club/${clubId}/schedule`,
            method: "GET"
        });
    }
    async api_createClubSchedules(clubId, schedules) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/schedule`,
                method: "POST",
                data: {
                    schedules: schedules
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_getBookingById(bookingId) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/public/reservation/${bookingId}`,
                method: "GET"
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_getClubBookings(role, clubId, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${clubId}/reservation`,
                method: "GET",
                params: data
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_getReservationHistory(role, clubId, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${clubId}/reservation/history`,
                method: "GET",
                params: data
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_deleteBooking(role, bookingId) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/reservation/${bookingId}`,
                method: "DELETE"
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_changePassword(role, oldPassword, newPassword) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/public/user/${role}/password`,
                method: "PATCH",
                data: {
                    oldPassword: oldPassword,
                    newPassword: newPassword
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.message;
        }
    }
    async api_updateUser(user) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/public/user`,
                method: "PUT",
                data: user
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_updateClub(role, clubId, clubData) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${clubId}`,
                method: "PUT",
                data: clubData
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_clubAddress(role, clubId, address) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${clubId}/address`,
                method: "POST",
                data: address
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_clubPhotos(role, clubId, clubPhotos) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${clubId}/photo`,
                method: "POST",
                data: {
                    photos: clubPhotos
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_updateClubPhotoDefault(clubId, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/photo`,
                method: "PUT",
                data: data
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_deleteClubPhotos(clubId, photosUrl) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/photo`,
                method: "DELETE",
                data: {
                    photosUrl: photosUrl
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_clubPayments(role, clubId, payments) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/club/${clubId}/payment-method`,
                method: "POST",
                data: {
                    clubId: clubId,
                    payments: payments
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_requestClubAdminAccount(data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/user/club-admin`,
                method: "POST",
                data: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_changeTemporaryPassword(role, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/auth/${role}/temporary-password`,
                method: "PATCH",
                data: data
            });
            return response;
        } catch (e) {
            return (0, $a04va.default).isAxiosError(e) ? e.response : e;
        }
    }
    async api_resetPassword(role, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/user/${role}/reset-password`,
                method: "POST",
                data: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_createBooking(role, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/public/reservation`,
                method: "POST",
                data: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_registerPaymentProof(reservationId, paymentProof) {
        return (0, $xggF4.default)({
            url: `/public/reservation/${reservationId}/payment-proof`,
            method: "POST",
            data: {
                photo: paymentProof,
                reservationId: reservationId
            }
        });
    }
    async api_requestCodeForResetPassword(role, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/user/${role}/code-for-password`,
                method: "GET",
                params: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_registerUser(role, data) {
        return (0, $xggF4.default)({
            url: `/auth/${role}/register`,
            method: "POST",
            data: data
        });
    }
    async api_getBookingsByUser(data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/public/reservation/user`,
                method: "GET",
                params: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_loginWithGoogle(data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/auth/player/external-provider`,
                method: "GET",
                params: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_getBookingByShareId(data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/reservation/detail/${data.shareId}`,
                method: "GET"
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_setInterestInBooking(data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `public/reservation/${data.id}/interest`,
                method: data.isInterested ? "POST" : "DELETE"
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_login(role, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `auth/${role}/login`,
                method: "POST",
                data: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_deleteClub(clubId) {
        return (0, $xggF4.default)({
            url: `/private/club/${clubId}`,
            method: "DELETE"
        });
    }
    async api_getPaymentMethods() {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/payment-methods`,
                method: "GET"
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_updateBooking(role, data) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/${role}/reservation/${data.id}`,
                method: "PUT",
                data: data
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_updateClubCategory(categories, clubId) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/category`,
                method: "PUT",
                data: {
                    categories: categories
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
    async api_updateClubSchedule(schedules, clubId) {
        try {
            const response = await (0, $xggF4.default)({
                url: `/private/club/${clubId}/schedule`,
                method: "PUT",
                data: {
                    schedules: schedules
                }
            });
            return response;
        } catch (e) {
            if ((0, $a04va.default).isAxiosError(e)) return e.response;
        }
    }
}

});
parcelRequire.register("xggF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063fb39d8037333e$export$2e2bcd8739ae039; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");
const $063fb39d8037333e$var$instance = (0, $a04va.default).create({
    baseURL: `${window.location.host === "localhost:3000" ? "http://localhost:3001/api" : window.location.origin + "/api"}`,
    headers: {
        "Content-Type": "application/json"
    }
});
$063fb39d8037333e$var$instance.interceptors.request.use((config)=>{
    const token = localStorage.getItem("token");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
}, (error)=>{
    return Promise.reject(error);
});
$063fb39d8037333e$var$instance.interceptors.response.use((response)=>{
    const token = response.headers["x-access-token"];
    if (token) localStorage.setItem("token", token);
    return response;
}, (error)=>{
    const token = localStorage.getItem("token");
    if (error.response.status === 401 && !error.response.request.responseURL.includes("auth") && token) window.location.href = `${window.location.origin}/logout`;
    throw error;
});
var $063fb39d8037333e$export$2e2bcd8739ae039 = $063fb39d8037333e$var$instance;

});
parcelRequire.register("h3OEn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("a04va")).default; });

var $a04va = parcelRequire("a04va");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a } = (0, $a04va.default);

});
parcelRequire.register("a04va", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $747d656b899e6115$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $ef5jC = parcelRequire("ef5jC");

var $3aVh3 = parcelRequire("3aVh3");

var $lb2qV = parcelRequire("lb2qV");

var $kZZD0 = parcelRequire("kZZD0");

var $4IsRW = parcelRequire("4IsRW");

var $cR4ZD = parcelRequire("cR4ZD");

var $29a93 = parcelRequire("29a93");

var $fX03H = parcelRequire("fX03H");

var $b676K = parcelRequire("b676K");

var $kgiwQ = parcelRequire("kgiwQ");

var $ha7aM = parcelRequire("ha7aM");

var $ewGK1 = parcelRequire("ewGK1");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $8PZpp.default)(defaultConfig);
    const instance = (0, $6zjya.default)((0, $8PZpp.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $adReO.default).extend(instance, (0, $8PZpp.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $adReO.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $5f6d7.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $ef5jC.default));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $8PZpp.default);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $lb2qV.default);
$747d656b899e6115$var$axios.CancelToken = (0, $kZZD0.default);
$747d656b899e6115$var$axios.isCancel = (0, $4IsRW.default);
$747d656b899e6115$var$axios.VERSION = (0, $cR4ZD.VERSION);
$747d656b899e6115$var$axios.toFormData = (0, $29a93.default);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $fX03H.default);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $b676K.default);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $kgiwQ.default);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $5f6d7.default);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $ha7aM.default);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $3aVh3.default)((0, $adReO.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.HttpStatusCode = (0, $ewGK1.default);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;

});
parcelRequire.register("adReO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77146a31cb578292$export$2e2bcd8739ae039; });

var $6zjya = parcelRequire("6zjya");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if ($77146a31cb578292$var$kindOf(val) !== "object") return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $77146a31cb578292$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $77146a31cb578292$var$isFunction(thing.append) && ((kind = $77146a31cb578292$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $77146a31cb578292$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    const { caseless: caseless } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $77146a31cb578292$var$findKey(result, key) || key;
        if ($77146a31cb578292$var$isPlainObject(result[targetKey]) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(result[targetKey], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) a[key] = (0, $6zjya.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest("HTMLFormElement");
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest("RegExp");
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $77146a31cb578292$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $77146a31cb578292$var$DIGIT = "0123456789";
const $77146a31cb578292$var$ALPHABET = {
    DIGIT: $77146a31cb578292$var$DIGIT,
    ALPHA: $77146a31cb578292$var$ALPHA,
    ALPHA_DIGIT: $77146a31cb578292$var$ALPHA + $77146a31cb578292$var$ALPHA.toUpperCase() + $77146a31cb578292$var$DIGIT
};
const $77146a31cb578292$var$generateString = (size = 16, alphabet = $77146a31cb578292$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $77146a31cb578292$var$isArray(source) ? [] : {};
                $77146a31cb578292$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest("AsyncFunction");
const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    ALPHABET: $77146a31cb578292$var$ALPHABET,
    generateString: $77146a31cb578292$var$generateString,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable
};

});
parcelRequire.register("6zjya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c852d2f6a5a0387$export$2e2bcd8739ae039; });
"use strict";
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRequire.register("8PZpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f2b8a41463d1e8$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $40T1q = parcelRequire("40T1q");

var $2iR5D = parcelRequire("2iR5D");

var $ha7aM = parcelRequire("ha7aM");
"use strict";
const $66f2b8a41463d1e8$var$validators = (0, $2iR5D.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $5f6d7.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $2iR5D.default).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $adReO.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $2iR5D.default).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $adReO.default).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $adReO.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $ha7aM.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $eystn.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $eystn.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $5f6d7.default)(this.defaults, config);
        const fullPath = (0, $40T1q.default)(config.baseURL, config.url);
        return (0, $6nvAH.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $khPLX.default)(),
            response: new (0, $khPLX.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $adReO.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $5f6d7.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $adReO.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $5f6d7.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    $66f2b8a41463d1e8$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;

});
parcelRequire.register("6nvAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a4d655613ae826e$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $dWNM1 = parcelRequire("dWNM1");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4a4d655613ae826e$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $adReO.default).isURLSearchParams(params) ? params.toString() : new (0, $dWNM1.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRequire.register("dWNM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2774d1dd3bec636$export$2e2bcd8739ae039; });

var $29a93 = parcelRequire("29a93");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $29a93.default)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $a2774d1dd3bec636$var$encode);
    } : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;

});
parcelRequire.register("29a93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19044a9fa7281693$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $4htkn = parcelRequire("4htkn");

var $bdjQ6 = parcelRequire("bdjQ6");
var $19044a9fa7281693$require$Buffer = $bdjQ6.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $adReO.default).isPlainObject(thing) || (0, $adReO.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $adReO.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $adReO.default).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $adReO.default).toFlatObject((0, $adReO.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $adReO.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4htkn.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $adReO.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $adReO.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $adReO.default).isSpecCompliantForm(formData);
    if (!(0, $adReO.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $adReO.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $adReO.default).isBlob(value)) throw new (0, $fX03H.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $adReO.default).isArrayBuffer(value) || (0, $adReO.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $19044a9fa7281693$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $adReO.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $adReO.default).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $adReO.default).isFileList(value) || (0, $adReO.default).endsWith(key, "[]")) && (arr = (0, $adReO.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $adReO.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path) {
        if ((0, $adReO.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $adReO.default).forEach(value, function each(el, key) {
            const result = !((0, $adReO.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $adReO.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $adReO.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;

});
parcelRequire.register("fX03H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9cc6960093b095e$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $b9cc6960093b095e$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $adReO.default).inherits($b9cc6960093b095e$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $adReO.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $b9cc6960093b095e$var$prototype = $b9cc6960093b095e$var$AxiosError.prototype;
const $b9cc6960093b095e$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $b9cc6960093b095e$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($b9cc6960093b095e$var$AxiosError, $b9cc6960093b095e$var$descriptors);
Object.defineProperty($b9cc6960093b095e$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$b9cc6960093b095e$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($b9cc6960093b095e$var$prototype);
    (0, $adReO.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $b9cc6960093b095e$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;

});

parcelRequire.register("4htkn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31df7fcb8acaa73a$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;

});

parcelRequire.register("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
"use strict";

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case "ascii":
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case "base64":
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$82a04c4ec6982288$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
"use strict";
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup["-".charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup["_".charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRequire.register("khPLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec4d8e24b0699790$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
"use strict";
class $ec4d8e24b0699790$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $adReO.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRequire.register("eystn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a98a53c8a75f9db0$export$2e2bcd8739ae039; });

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $ef5jC = parcelRequire("ef5jC");

var $lb2qV = parcelRequire("lb2qV");

var $ha7aM = parcelRequire("ha7aM");

var $gv9ju = parcelRequire("gv9ju");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $lb2qV.default)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $ha7aM.default).from(config.headers);
    // Transform request data
    config.data = (0, $15ANS.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $gv9ju.default).getAdapter(config.adapter || (0, $ef5jC.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $15ANS.default).call(config, config.transformResponse, response);
        response.headers = (0, $ha7aM.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $4IsRW.default)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $15ANS.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $ha7aM.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRequire.register("15ANS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb2ce7608ace114$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ef5jC = parcelRequire("ef5jC");

var $ha7aM = parcelRequire("ha7aM");
"use strict";
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ef5jC.default);
    const context = response || config;
    const headers = (0, $ha7aM.default).from(context.headers);
    let data = context.data;
    (0, $adReO.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRequire.register("ef5jC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5e696f232d0dc12$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $aP7qx = parcelRequire("aP7qx");

var $29a93 = parcelRequire("29a93");

var $kKiHJ = parcelRequire("kKiHJ");

var $jB9at = parcelRequire("jB9at");

var $3aVh3 = parcelRequire("3aVh3");
"use strict";
const $a5e696f232d0dc12$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $adReO.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $adReO.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $aP7qx.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $adReO.default).isObject(data);
            if (isObjectPayload && (0, $adReO.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $adReO.default).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $3aVh3.default)(data)) : data;
            }
            if ((0, $adReO.default).isArrayBuffer(data) || (0, $adReO.default).isBuffer(data) || (0, $adReO.default).isStream(data) || (0, $adReO.default).isFile(data) || (0, $adReO.default).isBlob(data)) return data;
            if ((0, $adReO.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $adReO.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $kKiHJ.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $adReO.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $29a93.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $adReO.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $fX03H.default).from(e, (0, $fX03H.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $jB9at.default).classes.FormData,
        Blob: (0, $jB9at.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $adReO.default).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
(0, $adReO.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $a5e696f232d0dc12$var$defaults.headers[method] = (0, $adReO.default).merge($a5e696f232d0dc12$var$DEFAULT_CONTENT_TYPE);
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;

});
parcelRequire.register("aP7qx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e146da7bba06216$export$2e2bcd8739ae039; });
"use strict";
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRequire.register("kKiHJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1a69cd24a140b61$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $29a93 = parcelRequire("29a93");

var $jB9at = parcelRequire("jB9at");
"use strict";
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $29a93.default)(data, new (0, $jB9at.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $jB9at.default).isNode && (0, $adReO.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRequire.register("jB9at", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4489594588108ef$export$2e2bcd8739ae039; });

var $de9wd = parcelRequire("de9wd");

var $1U9sr = parcelRequire("1U9sr");

var $8FSfW = parcelRequire("8FSfW");
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e4489594588108ef$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e4489594588108ef$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $de9wd.default,
        FormData: $1U9sr.default,
        Blob: $8FSfW.default
    },
    isStandardBrowserEnv: $e4489594588108ef$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $e4489594588108ef$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRequire.register("de9wd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a13f762833a66d0$export$2e2bcd8739ae039; });

var $dWNM1 = parcelRequire("dWNM1");
"use strict";
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $dWNM1.default);

});

parcelRequire.register("1U9sr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16325b87e107b4bc$export$2e2bcd8739ae039; });
"use strict";
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRequire.register("8FSfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $650c3d387ae3fbd4$export$2e2bcd8739ae039; });
"use strict";
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});



parcelRequire.register("3aVh3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24febbb5d340c733$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $adReO.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $adReO.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $adReO.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $adReO.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $adReO.default).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $adReO.default).isFormData(formData) && (0, $adReO.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $adReO.default).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;

});


parcelRequire.register("ha7aM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7e8ef3e2bb241a6$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $hMzvi = parcelRequire("hMzvi");
"use strict";
const $c7e8ef3e2bb241a6$var$$internals = Symbol("internals");
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $adReO.default).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : String(value);
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $adReO.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $adReO.default).isString(value)) return;
    if ((0, $adReO.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $adReO.default).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $adReO.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $adReO.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $adReO.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $adReO.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $adReO.default).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $hMzvi.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $adReO.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $adReO.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $adReO.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $adReO.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $adReO.default).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $adReO.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $adReO.default).forEach(this, (value, header)=>{
            const key = (0, $adReO.default).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $adReO.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $adReO.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $adReO.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
(0, $adReO.default).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype);
(0, $adReO.default).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;

});
parcelRequire.register("hMzvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf2275aca40d6d88$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $adReO.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRequire.register("4IsRW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36f1aa490c1da053$export$2e2bcd8739ae039; });
"use strict";
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRequire.register("lb2qV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6ac833a4b31e3dc$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");

var $adReO = parcelRequire("adReO");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $f6ac833a4b31e3dc$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $fX03H.default).call(this, message == null ? "canceled" : message, (0, $fX03H.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $adReO.default).inherits($f6ac833a4b31e3dc$var$CanceledError, (0, $fX03H.default), {
    __CANCEL__: true
});
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;

});

parcelRequire.register("gv9ju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c036c406f3928265$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $4htkn = parcelRequire("4htkn");

var $3PMHb = parcelRequire("3PMHb");

var $fX03H = parcelRequire("fX03H");
const $c036c406f3928265$var$knownAdapters = {
    http: (0, $4htkn.default),
    xhr: (0, $3PMHb.default)
};
(0, $adReO.default).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $adReO.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $adReO.default).isString(nameOrAdapter) ? $c036c406f3928265$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $fX03H.default)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $adReO.default).hasOwnProp($c036c406f3928265$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $adReO.default).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $c036c406f3928265$var$knownAdapters
};

});
parcelRequire.register("3PMHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cabe869ce51dbf6$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $79n0f = parcelRequire("79n0f");

var $6nvAH = parcelRequire("6nvAH");

var $40T1q = parcelRequire("40T1q");

var $besJL = parcelRequire("besJL");

var $aP7qx = parcelRequire("aP7qx");

var $fX03H = parcelRequire("fX03H");

var $lb2qV = parcelRequire("lb2qV");

var $41as5 = parcelRequire("41as5");

var $jB9at = parcelRequire("jB9at");

var $ha7aM = parcelRequire("ha7aM");

var $ikQjh = parcelRequire("ikQjh");
"use strict";
function $2cabe869ce51dbf6$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $ikQjh.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $ha7aM.default).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $adReO.default).isFormData(requestData)) {
            if ((0, $jB9at.default).isStandardBrowserEnv || (0, $jB9at.default).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $40T1q.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $6nvAH.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $ha7aM.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $3PfpF.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $fX03H.default)("Request aborted", (0, $fX03H.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $fX03H.default)("Network Error", (0, $fX03H.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $aP7qx.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $fX03H.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $fX03H.default).ETIMEDOUT : (0, $fX03H.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $jB9at.default).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $besJL.default)(fullPath)) && config.xsrfCookieName && (0, $79n0f.default).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $adReO.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $adReO.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $2cabe869ce51dbf6$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $2cabe869ce51dbf6$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $lb2qV.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $41as5.default)(fullPath);
        if (protocol && (0, $jB9at.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $fX03H.default)("Unsupported protocol " + protocol + ":", (0, $fX03H.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRequire.register("3PfpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c92173995cdc070$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");
"use strict";
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $fX03H.default)("Request failed with status code " + response.status, [
        (0, $fX03H.default).ERR_BAD_REQUEST,
        (0, $fX03H.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRequire.register("79n0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534b3794da5c002d$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $jB9at = parcelRequire("jB9at");
"use strict";
var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $jB9at.default).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $adReO.default).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $adReO.default).isString(path)) cookie.push("path=" + path);
            if ((0, $adReO.default).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("40T1q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ec1d7b86495f966$export$2e2bcd8739ae039; });

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
"use strict";
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $1yk63.default)(requestedURL)) return (0, $l45Ly.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRequire.register("1yk63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12188e34b7070552$export$2e2bcd8739ae039; });
"use strict";
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRequire.register("l45Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55e71b6c54c4376$export$2e2bcd8739ae039; });
"use strict";
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRequire.register("besJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82d74b1a5a0a01da$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $jB9at = parcelRequire("jB9at");
"use strict";
var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $jB9at.default).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $adReO.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("41as5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecf5cf4c0202afd$export$2e2bcd8739ae039; });
"use strict";
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRequire.register("ikQjh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d592abf0a04957f1$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;

});




parcelRequire.register("5f6d7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d132bbf7812485b$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ha7aM = parcelRequire("ha7aM");
"use strict";
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $ha7aM.default) ? thing.toJSON() : thing;
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $adReO.default).isPlainObject(target) && (0, $adReO.default).isPlainObject(source)) return (0, $adReO.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $adReO.default).isPlainObject(source)) return (0, $adReO.default).merge({}, source);
        else if ((0, $adReO.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $adReO.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $adReO.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), true)
    };
    (0, $adReO.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $adReO.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRequire.register("2iR5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad671c27810423e$export$2e2bcd8739ae039; });

var $cR4ZD = parcelRequire("cR4ZD");

var $fX03H = parcelRequire("fX03H");
"use strict";
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $cR4ZD.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $fX03H.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $fX03H.default).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $fX03H.default)("options must be an object", (0, $fX03H.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $fX03H.default)("option " + opt + " must be " + result, (0, $fX03H.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $fX03H.default)("Unknown option " + opt, (0, $fX03H.default).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});
parcelRequire.register("cR4ZD", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $95be4ecd446de127$export$a4ad2735b021c132; });
const $95be4ecd446de127$export$a4ad2735b021c132 = "1.4.0";

});



parcelRequire.register("kZZD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4994f37c883aea2$export$2e2bcd8739ae039; });

var $lb2qV = parcelRequire("lb2qV");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $lb2qV.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;

});

parcelRequire.register("b676K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8145c4b68bfee186$export$2e2bcd8739ae039; });
"use strict";
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRequire.register("kgiwQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec03acb464b74212$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
"use strict";
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $adReO.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRequire.register("ewGK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9353565c2e0947e$export$2e2bcd8739ae039; });
const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;

});





parcelRequire.register("7uzyD", function(module, exports) {
"use strict";
var $5746eabcc63d419b$var$__assign = module.exports && module.exports.__assign || function() {
    $5746eabcc63d419b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5746eabcc63d419b$var$__assign.apply(this, arguments);
};
var $5746eabcc63d419b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5746eabcc63d419b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5746eabcc63d419b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5746eabcc63d419b$var$__createBinding(result, mod, k);
    }
    $5746eabcc63d419b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Carousel = void 0;

var $1dnTW = parcelRequire("1dnTW");

var $gJFtO = parcelRequire("gJFtO");

var $3mJq6 = parcelRequire("3mJq6");

var $fSoNm = parcelRequire("fSoNm");

var $5746eabcc63d419b$var$react_1 = $5746eabcc63d419b$var$__importStar((parcelRequire("7fPBF")));
var $5746eabcc63d419b$var$Carousel = function(props) {
    var _a = (0, $5746eabcc63d419b$var$react_1.useState)({
        active: 0,
        prevActive: 0,
        next: true
    }), state = _a[0], setState = _a[1];
    /** Used to set carousel's height. It is being set by the CarouselItems */ var _b = (0, $5746eabcc63d419b$var$react_1.useState)(), childrenHeight = _b[0], setChildrenHeight = _b[1];
    var _c = (0, $5746eabcc63d419b$var$react_1.useState)(false), paused = _c[0], setPaused = _c[1];
    var sanitizedProps = (0, $3mJq6.sanitizeProps)(props);
    // componentDidMount & onIndexChange
    (0, $5746eabcc63d419b$var$react_1.useEffect)(function() {
        var index = sanitizedProps.index, changeOnFirstRender = sanitizedProps.changeOnFirstRender;
        setNext(index, true, changeOnFirstRender);
    }, [
        sanitizedProps.index
    ]);
    (0, $3mJq6.useInterval)(function() {
        var autoPlay = sanitizedProps.autoPlay;
        if (autoPlay && !paused) next(undefined);
    }, sanitizedProps.interval);
    var next = function(event) {
        var children = sanitizedProps.children, cycleNavigation = sanitizedProps.cycleNavigation;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        var nextActive = state.active + 1 > last ? cycleNavigation ? 0 : state.active : state.active + 1;
        setNext(nextActive, true);
        if (event) event.stopPropagation();
    };
    var prev = function(event) {
        var children = sanitizedProps.children, cycleNavigation = sanitizedProps.cycleNavigation;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        var nextActive = state.active - 1 < 0 ? cycleNavigation ? last : state.active : state.active - 1;
        setNext(nextActive, false);
        if (event) event.stopPropagation();
    };
    var setNext = function(index, isNext, runCallbacks) {
        if (runCallbacks === void 0) runCallbacks = true;
        var onChange = sanitizedProps.onChange, children = sanitizedProps.children, strictIndexing = sanitizedProps.strictIndexing;
        if (Array.isArray(children)) {
            if (strictIndexing && index > children.length - 1) index = children.length - 1;
            if (strictIndexing && index < 0) index = 0;
        } else index = 0;
        if (runCallbacks) {
            if (isNext !== undefined) isNext ? sanitizedProps.next(index, state.active) : sanitizedProps.prev(index, state.active);
            onChange(index, state.active);
        }
        if (isNext === undefined) isNext = index > state.active;
        setState({
            active: index,
            prevActive: state.active,
            next: isNext
        });
    };
    var children = sanitizedProps.children, sx = sanitizedProps.sx, className = sanitizedProps.className, height = sanitizedProps.height, stopAutoPlayOnHover = sanitizedProps.stopAutoPlayOnHover, animation = sanitizedProps.animation, duration = sanitizedProps.duration, swipe = sanitizedProps.swipe, navButtonsAlwaysInvisible = sanitizedProps.navButtonsAlwaysInvisible, navButtonsAlwaysVisible = sanitizedProps.navButtonsAlwaysVisible, cycleNavigation = sanitizedProps.cycleNavigation, fullHeightHover = sanitizedProps.fullHeightHover, navButtonsProps = sanitizedProps.navButtonsProps, navButtonsWrapperProps = sanitizedProps.navButtonsWrapperProps, NavButton = sanitizedProps.NavButton, NextIcon = sanitizedProps.NextIcon, PrevIcon = sanitizedProps.PrevIcon, indicators = sanitizedProps.indicators, indicatorContainerProps = sanitizedProps.indicatorContainerProps, indicatorIconButtonProps = sanitizedProps.indicatorIconButtonProps, activeIndicatorIconButtonProps = sanitizedProps.activeIndicatorIconButtonProps, IndicatorIcon = sanitizedProps.IndicatorIcon;
    var showButton = function(next) {
        if (next === void 0) next = true;
        if (cycleNavigation) return true;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        if (next && state.active === last) return false;
        if (!next && state.active === 0) return false;
        return true;
    };
    return $5746eabcc63d419b$var$react_1.default.createElement($fSoNm.StyledRoot, {
        sx: sx,
        className: className,
        onMouseOver: function() {
            stopAutoPlayOnHover && setPaused(true);
        },
        onMouseOut: function() {
            stopAutoPlayOnHover && setPaused(false);
        },
        onFocus: function() {
            stopAutoPlayOnHover && setPaused(true);
        },
        onBlur: function() {
            stopAutoPlayOnHover && setPaused(false);
        }
    }, $5746eabcc63d419b$var$react_1.default.createElement($fSoNm.StyledItemWrapper, {
        style: {
            height: height ? height : childrenHeight
        }
    }, Array.isArray(children) ? children.map(function(child, index) {
        return $5746eabcc63d419b$var$react_1.default.createElement($1dnTW.CarouselItem, {
            key: "carousel-item" + index,
            state: state,
            index: index,
            maxIndex: children.length - 1,
            child: child,
            animation: animation,
            duration: duration,
            swipe: swipe,
            next: next,
            prev: prev,
            height: height,
            setHeight: setChildrenHeight
        });
    }) : $5746eabcc63d419b$var$react_1.default.createElement($1dnTW.CarouselItem, {
        key: "carousel-item0",
        state: state,
        index: 0,
        maxIndex: 0,
        child: children,
        animation: animation,
        duration: duration,
        height: height,
        setHeight: setChildrenHeight
    })), !navButtonsAlwaysInvisible && showButton(true) && $5746eabcc63d419b$var$react_1.default.createElement($fSoNm.StyledButtonWrapper, $5746eabcc63d419b$var$__assign({
        "$next": true,
        "$prev": false,
        "$fullHeightHover": fullHeightHover
    }, navButtonsWrapperProps), NavButton !== undefined ? NavButton($5746eabcc63d419b$var$__assign({
        onClick: next,
        next: true,
        prev: false
    }, navButtonsProps)) : $5746eabcc63d419b$var$react_1.default.createElement($fSoNm.StyledIconButton, $5746eabcc63d419b$var$__assign({
        "$alwaysVisible": navButtonsAlwaysVisible,
        "$fullHeightHover": fullHeightHover,
        onClick: next,
        "aria-label": "Next"
    }, navButtonsProps), NextIcon)), !navButtonsAlwaysInvisible && showButton(false) && $5746eabcc63d419b$var$react_1.default.createElement($fSoNm.StyledButtonWrapper, $5746eabcc63d419b$var$__assign({
        "$next": false,
        "$prev": true,
        "$fullHeightHover": fullHeightHover
    }, navButtonsWrapperProps), NavButton !== undefined ? NavButton($5746eabcc63d419b$var$__assign({
        onClick: prev,
        next: false,
        prev: true
    }, navButtonsProps)) : $5746eabcc63d419b$var$react_1.default.createElement($fSoNm.StyledIconButton, $5746eabcc63d419b$var$__assign({
        "$alwaysVisible": navButtonsAlwaysVisible,
        "$fullHeightHover": fullHeightHover,
        onClick: prev,
        "aria-label": "Previous"
    }, navButtonsProps), PrevIcon)), indicators ? $5746eabcc63d419b$var$react_1.default.createElement($gJFtO.Indicators, {
        length: Array.isArray(children) ? children.length : 0,
        active: state.active,
        press: setNext,
        indicatorContainerProps: indicatorContainerProps,
        indicatorIconButtonProps: indicatorIconButtonProps,
        activeIndicatorIconButtonProps: activeIndicatorIconButtonProps,
        IndicatorIcon: IndicatorIcon
    }) : null);
};
module.exports.Carousel = $5746eabcc63d419b$var$Carousel;
module.exports.default = module.exports.Carousel;

});
parcelRequire.register("1dnTW", function(module, exports) {
"use strict";
var $0e298b9fc49113a8$var$__assign = module.exports && module.exports.__assign || function() {
    $0e298b9fc49113a8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e298b9fc49113a8$var$__assign.apply(this, arguments);
};
var $0e298b9fc49113a8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0e298b9fc49113a8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0e298b9fc49113a8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0e298b9fc49113a8$var$__createBinding(result, mod, k);
    }
    $0e298b9fc49113a8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselItem = void 0;

var $4vDJM = parcelRequire("4vDJM");
var $2oFHj = parcelRequire("2oFHj");

var $0e298b9fc49113a8$var$react_1 = $0e298b9fc49113a8$var$__importStar((parcelRequire("7fPBF")));

var $fSoNm = parcelRequire("fSoNm");
var $0e298b9fc49113a8$var$CarouselItem = function(_a) {
    var animation = _a.animation, next = _a.next, prev = _a.prev, swipe = _a.swipe, state = _a.state, index = _a.index, maxIndex = _a.maxIndex, duration = _a.duration, child = _a.child, height = _a.height, setHeight = _a.setHeight;
    var slide = animation === "slide";
    var fade = animation === "fade";
    var dragProps = {
        drag: "x",
        layout: true,
        onDragEnd: function(event, info) {
            if (!swipe) return;
            if (info.offset.x > 0) prev && prev();
            else if (info.offset.x < 0) next && next();
            event.stopPropagation();
        },
        dragElastic: 0,
        dragConstraints: {
            left: 0,
            right: 0
        }
    };
    var divRef = (0, $0e298b9fc49113a8$var$react_1.useRef)(null);
    var checkAndSetHeight = (0, $0e298b9fc49113a8$var$react_1.useCallback)(function() {
        if (index !== state.active) return;
        if (!divRef.current) return;
        if (divRef.current.offsetHeight === 0) setTimeout(function() {
            return checkAndSetHeight();
        }, 100);
        else setHeight(divRef.current.offsetHeight);
    }, [
        setHeight,
        state.active,
        index,
        divRef
    ]);
    // Set height on every child change
    (0, $0e298b9fc49113a8$var$react_1.useEffect)(function() {
        checkAndSetHeight();
    }, [
        checkAndSetHeight
    ]);
    var variants = {
        leftwardExit: {
            x: slide ? "-100%" : undefined,
            opacity: fade ? 0 : undefined,
            zIndex: 0
        },
        leftOut: {
            x: slide ? "-100%" : undefined,
            opacity: fade ? 0 : undefined,
            display: "none",
            zIndex: 0
        },
        rightwardExit: {
            x: slide ? "100%" : undefined,
            opacity: fade ? 0 : undefined,
            zIndex: 0
        },
        rightOut: {
            x: slide ? "100%" : undefined,
            opacity: fade ? 0 : undefined,
            display: "none",
            zIndex: 0
        },
        center: {
            x: 0,
            opacity: 1,
            zIndex: 1
        }
    };
    // Handle animation directions and opacity given based on active, prevActive and this item's index
    var active = state.active, isNext = state.next, prevActive = state.prevActive;
    var animate = "center";
    if (index === active) animate = "center";
    else if (index === prevActive) {
        animate = isNext ? "leftwardExit" : "rightwardExit";
        if (active === maxIndex && index === 0) animate = "rightwardExit";
        if (active === 0 && index === maxIndex) animate = "leftwardExit";
    } else {
        animate = index < active ? "leftOut" : "rightOut";
        if (active === maxIndex && index === 0) animate = "rightOut";
        if (active === 0 && index === maxIndex) animate = "leftOut";
    }
    duration = duration / 1000;
    return $0e298b9fc49113a8$var$react_1.default.createElement($fSoNm.StyledItem, null, $0e298b9fc49113a8$var$react_1.default.createElement($4vDJM.AnimatePresence, {
        custom: isNext
    }, $0e298b9fc49113a8$var$react_1.default.createElement($2oFHj.motion.div, $0e298b9fc49113a8$var$__assign({}, swipe && dragProps, {
        style: {
            height: "100%"
        }
    }), $0e298b9fc49113a8$var$react_1.default.createElement($2oFHj.motion.div, {
        custom: isNext,
        variants: variants,
        animate: animate,
        transition: {
            x: {
                type: "tween",
                duration: duration,
                delay: 0
            },
            opacity: {
                duration: duration
            }
        },
        style: {
            position: "relative",
            height: "100%"
        }
    }, $0e298b9fc49113a8$var$react_1.default.createElement("div", {
        ref: divRef,
        style: {
            height: height
        }
    }, child)))));
};
module.exports.CarouselItem = $0e298b9fc49113a8$var$CarouselItem;

});
parcelRequire.register("4vDJM", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $3488e1aca3a24bc9$export$3ae376d12526dd6f; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $8SsRE = parcelRequire("8SsRE");

var $ctcID = parcelRequire("ctcID");

var $dGWvt = parcelRequire("dGWvt");
function $3488e1aca3a24bc9$var$getChildKey(child) {
    return child.key || "";
}
function $3488e1aca3a24bc9$var$updateChildLookup(children, allChildren) {
    var seenChildren = null;
    children.forEach(function(child) {
        var key = $3488e1aca3a24bc9$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $3488e1aca3a24bc9$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $7fPBF.Children).forEach(children, function(child) {
        if ((0, $7fPBF.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $3488e1aca3a24bc9$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = (0, $8SsRE.useForceUpdate)();
    var layoutContext = (0, $7fPBF.useContext)((0, $dGWvt.SharedLayoutContext));
    if ((0, $dGWvt.isSharedLayout)(layoutContext)) forceRender = layoutContext.forceUpdate;
    var isInitialRender = (0, $7fPBF.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $3488e1aca3a24bc9$var$onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $7fPBF.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $7fPBF.useRef)(new Map()).current;
    // A living record of all currently exiting components.
    var exiting = (0, $7fPBF.useRef)(new Set()).current;
    $3488e1aca3a24bc9$var$updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return $7fPBF.createElement($7fPBF.Fragment, null, filteredChildren.map(function(child) {
            return $7fPBF.createElement((0, $ctcID.PresenceChild), {
                key: $3488e1aca3a24bc9$var$getChildKey(child),
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout
            }, child);
        }));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($3488e1aca3a24bc9$var$getChildKey);
    var targetKeys = filteredChildren.map($3488e1aca3a24bc9$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
        else // In case this key has re-entered, remove from the exiting list
        exiting.delete(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $7fPBF.createElement((0, $ctcID.PresenceChild), {
            key: $3488e1aca3a24bc9$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $7fPBF.createElement((0, $ctcID.PresenceChild), {
            key: $3488e1aca3a24bc9$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    presentChildren.current = childrenToRender;
    return $7fPBF.createElement($7fPBF.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $7fPBF.cloneElement)(child);
    }));
};

});
parcelRequire.register("cA1Ck", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $928a19f4ffb37b4a$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $928a19f4ffb37b4a$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $928a19f4ffb37b4a$export$3c9a16f847548506; });
$parcel$export(module.exports, "__read", function () { return $928a19f4ffb37b4a$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $928a19f4ffb37b4a$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $928a19f4ffb37b4a$var$extendStatics = function(d, b) {
    $928a19f4ffb37b4a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $928a19f4ffb37b4a$var$extendStatics(d, b);
};
function $928a19f4ffb37b4a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $928a19f4ffb37b4a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $928a19f4ffb37b4a$export$18ce0697a983be9b = function() {
    $928a19f4ffb37b4a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $928a19f4ffb37b4a$export$18ce0697a983be9b.apply(this, arguments);
};
function $928a19f4ffb37b4a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $928a19f4ffb37b4a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $928a19f4ffb37b4a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $928a19f4ffb37b4a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $928a19f4ffb37b4a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $928a19f4ffb37b4a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $928a19f4ffb37b4a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $928a19f4ffb37b4a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $928a19f4ffb37b4a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $928a19f4ffb37b4a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $928a19f4ffb37b4a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $928a19f4ffb37b4a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $928a19f4ffb37b4a$export$45d3717a4c69092e(o, m, p);
}
function $928a19f4ffb37b4a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $928a19f4ffb37b4a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $928a19f4ffb37b4a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($928a19f4ffb37b4a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $928a19f4ffb37b4a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $928a19f4ffb37b4a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $928a19f4ffb37b4a$export$10c90e4f7922046c(v) {
    return this instanceof $928a19f4ffb37b4a$export$10c90e4f7922046c ? (this.v = v, this) : new $928a19f4ffb37b4a$export$10c90e4f7922046c(v);
}
function $928a19f4ffb37b4a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $928a19f4ffb37b4a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $928a19f4ffb37b4a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $928a19f4ffb37b4a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $928a19f4ffb37b4a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $928a19f4ffb37b4a$export$19a8beecd37a4c45 === "function" ? $928a19f4ffb37b4a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $928a19f4ffb37b4a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $928a19f4ffb37b4a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $928a19f4ffb37b4a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $928a19f4ffb37b4a$export$45d3717a4c69092e(result, mod, k);
    }
    $928a19f4ffb37b4a$var$__setModuleDefault(result, mod);
    return result;
}
function $928a19f4ffb37b4a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $928a19f4ffb37b4a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $928a19f4ffb37b4a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $928a19f4ffb37b4a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $928a19f4ffb37b4a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $928a19f4ffb37b4a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $928a19f4ffb37b4a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $928a19f4ffb37b4a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $928a19f4ffb37b4a$export$2e2bcd8739ae039 = {
    __extends: $928a19f4ffb37b4a$export$a8ba968b8961cb8a,
    __assign: $928a19f4ffb37b4a$export$18ce0697a983be9b,
    __rest: $928a19f4ffb37b4a$export$3c9a16f847548506,
    __decorate: $928a19f4ffb37b4a$export$29e00dfd3077644b,
    __param: $928a19f4ffb37b4a$export$d5ad3fd78186038f,
    __metadata: $928a19f4ffb37b4a$export$f1db080c865becb9,
    __awaiter: $928a19f4ffb37b4a$export$1050f835b63b671e,
    __generator: $928a19f4ffb37b4a$export$67ebef60e6f28a6,
    __createBinding: $928a19f4ffb37b4a$export$45d3717a4c69092e,
    __exportStar: $928a19f4ffb37b4a$export$f33643c0debef087,
    __values: $928a19f4ffb37b4a$export$19a8beecd37a4c45,
    __read: $928a19f4ffb37b4a$export$8d051b38c9118094,
    __spread: $928a19f4ffb37b4a$export$afc72e2116322959,
    __spreadArrays: $928a19f4ffb37b4a$export$6388937ca91ccae8,
    __spreadArray: $928a19f4ffb37b4a$export$1216008129fb82ed,
    __await: $928a19f4ffb37b4a$export$10c90e4f7922046c,
    __asyncGenerator: $928a19f4ffb37b4a$export$e427f37a30a4de9b,
    __asyncDelegator: $928a19f4ffb37b4a$export$bbd80228419bb833,
    __asyncValues: $928a19f4ffb37b4a$export$e3b29a3d6162315f,
    __makeTemplateObject: $928a19f4ffb37b4a$export$4fb47efe1390b86f,
    __importStar: $928a19f4ffb37b4a$export$c21735bcef00d192,
    __importDefault: $928a19f4ffb37b4a$export$da59b14a69baef04,
    __classPrivateFieldGet: $928a19f4ffb37b4a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $928a19f4ffb37b4a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $928a19f4ffb37b4a$export$81fdc39f203e4e04,
    __addDisposableResource: $928a19f4ffb37b4a$export$88ac25d8e944e405,
    __disposeResources: $928a19f4ffb37b4a$export$8f076105dc360e92
};

});

parcelRequire.register("8SsRE", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $6769c1b5ab6a6d18$export$91db9bc4f8ac944a; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $8ANN9 = parcelRequire("8ANN9");
function $6769c1b5ab6a6d18$export$91db9bc4f8ac944a() {
    var unloadingRef = (0, $7fPBF.useRef)(false);
    var _a = (0, $cA1Ck.__read)((0, $7fPBF.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0, $8ANN9.useUnmountEffect)(function() {
        return unloadingRef.current = true;
    });
    return (0, $7fPBF.useCallback)(function() {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
}

});
parcelRequire.register("8ANN9", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $64184f1cae19af8f$export$f3a192d0cbd30b96; });

var $7fPBF = parcelRequire("7fPBF");
function $64184f1cae19af8f$export$f3a192d0cbd30b96(callback) {
    return (0, $7fPBF.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}

});


parcelRequire.register("ctcID", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $91420f337c8c6cc7$export$979daf65881a382a; });

var $7fPBF = parcelRequire("7fPBF");

var $6iH3e = parcelRequire("6iH3e");

var $5URq7 = parcelRequire("5URq7");
var $91420f337c8c6cc7$var$presenceId = 0;
function $91420f337c8c6cc7$var$getPresenceId() {
    var id = $91420f337c8c6cc7$var$presenceId;
    $91420f337c8c6cc7$var$presenceId++;
    return id;
}
var $91420f337c8c6cc7$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $5URq7.useConstant)($91420f337c8c6cc7$var$newChildrenMap);
    var id = (0, $5URq7.useConstant)($91420f337c8c6cc7$var$getPresenceId);
    var context = (0, $7fPBF.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var allComplete = true;
                presenceChildren.forEach(function(isComplete) {
                    if (!isComplete) allComplete = false;
                });
                allComplete && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $7fPBF.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $7fPBF.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $7fPBF.createElement((0, $6iH3e.PresenceContext).Provider, {
        value: context
    }, children);
};
function $91420f337c8c6cc7$var$newChildrenMap() {
    return new Map();
}

});
parcelRequire.register("6iH3e", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $4965d1984215d74f$export$f224e4635b6f8ce2; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @public
 */ var $4965d1984215d74f$export$f224e4635b6f8ce2 = (0, $7fPBF.createContext)(null);

});

parcelRequire.register("5URq7", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $44eb9ee06004aac3$export$fe4300aa8eebea86; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $44eb9ee06004aac3$export$fe4300aa8eebea86(init) {
    var ref = (0, $7fPBF.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});


parcelRequire.register("dGWvt", function(module, exports) {

$parcel$export(module.exports, "SharedLayoutContext", function () { return $9f7c94ca9ec4dfe0$export$a3d1a816cb91a642; });
$parcel$export(module.exports, "FramerTreeLayoutContext", function () { return $9f7c94ca9ec4dfe0$export$88d0442641a5238c; });
$parcel$export(module.exports, "isSharedLayout", function () { return $9f7c94ca9ec4dfe0$export$8475119b63356082; });

var $7fPBF = parcelRequire("7fPBF");

var $dlOCv = parcelRequire("dlOCv");
var $9f7c94ca9ec4dfe0$export$a3d1a816cb91a642 = (0, $7fPBF.createContext)((0, $dlOCv.createBatcher)());
/**
 * @internal
 */ var $9f7c94ca9ec4dfe0$export$88d0442641a5238c = (0, $7fPBF.createContext)((0, $dlOCv.createBatcher)());
function $9f7c94ca9ec4dfe0$export$8475119b63356082(context) {
    return !!context.forceUpdate;
}

});
parcelRequire.register("dlOCv", function(module, exports) {

$parcel$export(module.exports, "createBatcher", function () { return $9b84809f4245c297$export$29e5fe0a0fc8f32f; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7n4cL = parcelRequire("7n4cL");

var $2twVH = parcelRequire("2twVH");

var $1Uuis = parcelRequire("1Uuis");

var $7k3Fq = parcelRequire("7k3Fq");

var $4ZkPk = parcelRequire("4ZkPk");
/**
 * Default handlers for batching VisualElements
 */ var $9b84809f4245c297$var$defaultHandler = {
    layoutReady: function(child) {
        return child.notifyLayoutReady();
    }
};
/**
 * Create a batcher to process VisualElements
 */ function $9b84809f4245c297$export$29e5fe0a0fc8f32f() {
    var queue = new Set();
    return {
        add: function(child) {
            return queue.add(child);
        },
        flush: function(_a) {
            var _b = _a === void 0 ? $9b84809f4245c297$var$defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
            (0, $1Uuis.batchLayout)(function(read, write) {
                var order = Array.from(queue).sort((0, $7k3Fq.compareByDepth));
                var ancestors = parent ? (0, $2twVH.collectProjectingAncestors)(parent) : [];
                write(function() {
                    var allElements = (0, $cA1Ck.__spreadArray)((0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(ancestors)), (0, $cA1Ck.__read)(order));
                    allElements.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    order.forEach((0, $2twVH.updateLayoutMeasurement));
                });
                write(function() {
                    ancestors.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    order.forEach(layoutReady);
                });
                read(function() {
                    /**
                     * After all children have started animating, ensure any Entering components are set to Present.
                     * If we add deferred animations (set up all animations and then start them in two loops) this
                     * could be moved to the start loop. But it needs to happen after all the animations configs
                     * are generated in AnimateSharedLayout as this relies on presence data
                     */ order.forEach(function(child) {
                        if (child.isPresent) child.presence = (0, $4ZkPk.Presence).Present;
                    });
                });
                write(function() {
                    /**
                     * Starting these animations will have queued jobs on the frame loop. In some situations,
                     * like when removing an element, these will be processed too late after the DOM is manipulated,
                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                     * we ensure there's no flash.
                     */ (0, $7n4cL.flushSync).preRender();
                    (0, $7n4cL.flushSync).render();
                });
                read(function() {
                    /**
                     * Schedule a callback at the end of the following frame to assign the latest projection
                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                     * child attempts to calculate its previous relative position against a prevViewportBox
                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
                     * render.
                     */ (0, $7n4cL.default).postRender(function() {
                        return order.forEach($9b84809f4245c297$var$assignProjectionToSnapshot);
                    });
                    queue.clear();
                });
            });
            // TODO: Need to find a layout-synchronous way of flushing this
            (0, $1Uuis.flushLayout)();
        }
    };
}
function $9b84809f4245c297$var$assignProjectionToSnapshot(child) {
    child.prevViewportBox = child.projection.target;
}

});
parcelRequire.register("7n4cL", function(module, exports) {

$parcel$export(module.exports, "cancelSync", function () { return $55ddf168544371bc$export$d93e9c1fe0553512; });
$parcel$export(module.exports, "flushSync", function () { return $55ddf168544371bc$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "getFrameData", function () { return $55ddf168544371bc$export$7244445918e670ed; });
$parcel$export(module.exports, "default", function () { return $55ddf168544371bc$export$2e2bcd8739ae039; });

var $29NAb = parcelRequire("29NAb");

var $b7yce = parcelRequire("b7yce");
var $55ddf168544371bc$var$maxElapsed = 40;
var $55ddf168544371bc$var$useDefaultElapsed = true;
var $55ddf168544371bc$var$runNextFrame = false;
var $55ddf168544371bc$var$isProcessing = false;
var $55ddf168544371bc$var$frame = {
    delta: 0,
    timestamp: 0
};
var $55ddf168544371bc$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
var $55ddf168544371bc$var$steps = /*#__PURE__*/ $55ddf168544371bc$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = (0, $b7yce.createRenderStep)(function() {
        return $55ddf168544371bc$var$runNextFrame = true;
    });
    return acc;
}, {});
var $55ddf168544371bc$var$sync = /*#__PURE__*/ $55ddf168544371bc$var$stepsOrder.reduce(function(acc, key) {
    var step = $55ddf168544371bc$var$steps[key];
    acc[key] = function(process, keepAlive, immediate) {
        if (keepAlive === void 0) keepAlive = false;
        if (immediate === void 0) immediate = false;
        if (!$55ddf168544371bc$var$runNextFrame) $55ddf168544371bc$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var $55ddf168544371bc$export$d93e9c1fe0553512 = /*#__PURE__*/ $55ddf168544371bc$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = $55ddf168544371bc$var$steps[key].cancel;
    return acc;
}, {});
var $55ddf168544371bc$export$cd75ccfd720a3cd4 = /*#__PURE__*/ $55ddf168544371bc$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = function() {
        return $55ddf168544371bc$var$steps[key].process($55ddf168544371bc$var$frame);
    };
    return acc;
}, {});
var $55ddf168544371bc$var$processStep = function(stepId) {
    return $55ddf168544371bc$var$steps[stepId].process($55ddf168544371bc$var$frame);
};
var $55ddf168544371bc$var$processFrame = function(timestamp) {
    $55ddf168544371bc$var$runNextFrame = false;
    $55ddf168544371bc$var$frame.delta = $55ddf168544371bc$var$useDefaultElapsed ? (0, $29NAb.defaultTimestep) : Math.max(Math.min(timestamp - $55ddf168544371bc$var$frame.timestamp, $55ddf168544371bc$var$maxElapsed), 1);
    $55ddf168544371bc$var$frame.timestamp = timestamp;
    $55ddf168544371bc$var$isProcessing = true;
    $55ddf168544371bc$var$stepsOrder.forEach($55ddf168544371bc$var$processStep);
    $55ddf168544371bc$var$isProcessing = false;
    if ($55ddf168544371bc$var$runNextFrame) {
        $55ddf168544371bc$var$useDefaultElapsed = false;
        (0, $29NAb.onNextFrame)($55ddf168544371bc$var$processFrame);
    }
};
var $55ddf168544371bc$var$startLoop = function() {
    $55ddf168544371bc$var$runNextFrame = true;
    $55ddf168544371bc$var$useDefaultElapsed = true;
    if (!$55ddf168544371bc$var$isProcessing) (0, $29NAb.onNextFrame)($55ddf168544371bc$var$processFrame);
};
var $55ddf168544371bc$export$7244445918e670ed = function() {
    return $55ddf168544371bc$var$frame;
};
var $55ddf168544371bc$export$2e2bcd8739ae039 = $55ddf168544371bc$var$sync;

});
parcelRequire.register("29NAb", function(module, exports) {

$parcel$export(module.exports, "defaultTimestep", function () { return $1922e2201fe1c461$export$f8caf8121275292d; });
$parcel$export(module.exports, "onNextFrame", function () { return $1922e2201fe1c461$export$4fdea63ab5513fd5; });
var $1922e2201fe1c461$export$f8caf8121275292d = 1 / 60 * 1000;
var $1922e2201fe1c461$var$getCurrentTime = typeof performance !== "undefined" ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
var $1922e2201fe1c461$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? function(callback) {
    return window.requestAnimationFrame(callback);
} : function(callback) {
    return setTimeout(function() {
        return callback($1922e2201fe1c461$var$getCurrentTime());
    }, $1922e2201fe1c461$export$f8caf8121275292d);
};

});

parcelRequire.register("b7yce", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $818adfd2ce944dbb$export$b995e5e85f5c8289; });
function $818adfd2ce944dbb$export$b995e5e85f5c8289(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function(callback, keepAlive, immediate) {
            if (keepAlive === void 0) keepAlive = false;
            if (immediate === void 0) immediate = false;
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function(callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function(frameData) {
            var _a;
            isProcessing = true;
            _a = [
                toRunNextFrame,
                toRun
            ], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(var i = 0; i < numToRun; i++){
                var callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
        }
    };
    return step;
}

});


parcelRequire.register("2twVH", function(module, exports) {

$parcel$export(module.exports, "collectProjectingAncestors", function () { return $1cd7d556139c10aa$export$e900175ee6159829; });
$parcel$export(module.exports, "collectProjectingChildren", function () { return $1cd7d556139c10aa$export$99d2ce63b1d58b9f; });
$parcel$export(module.exports, "updateLayoutMeasurement", function () { return $1cd7d556139c10aa$export$ec1805441219fc83; });
$parcel$export(module.exports, "snapshotViewportBox", function () { return $1cd7d556139c10aa$export$4f13d577f7028d57; });

var $7n4cL = parcelRequire("7n4cL");

var $lfoD4 = parcelRequire("lfoD4");

var $7k3Fq = parcelRequire("7k3Fq");
function $1cd7d556139c10aa$var$isProjecting(visualElement) {
    var isEnabled = visualElement.projection.isEnabled;
    return isEnabled || visualElement.shouldResetTransform();
}
function $1cd7d556139c10aa$export$e900175ee6159829(visualElement, ancestors) {
    if (ancestors === void 0) ancestors = [];
    var parent = visualElement.parent;
    if (parent) $1cd7d556139c10aa$export$e900175ee6159829(parent, ancestors);
    if ($1cd7d556139c10aa$var$isProjecting(visualElement)) ancestors.push(visualElement);
    return ancestors;
}
function $1cd7d556139c10aa$export$99d2ce63b1d58b9f(visualElement) {
    var children = [];
    var addChild = function(child) {
        if ($1cd7d556139c10aa$var$isProjecting(child)) children.push(child);
        child.children.forEach(addChild);
    };
    visualElement.children.forEach(addChild);
    return children.sort((0, $7k3Fq.compareByDepth));
}
/**
 * Update the layoutState by measuring the DOM layout. This
 * should be called after resetting any layout-affecting transforms.
 */ function $1cd7d556139c10aa$export$ec1805441219fc83(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    var layoutState = visualElement.getLayoutState();
    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
    layoutState.isHydrated = true;
    layoutState.layout = visualElement.measureViewportBox();
    layoutState.layoutCorrected = (0, $lfoD4.copyAxisBox)(layoutState.layout);
    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
    (0, $7n4cL.default).update(function() {
        return visualElement.rebaseProjectionTarget();
    });
}
/**
 * Record the viewport box as it was before an expected mutation/re-render
 */ function $1cd7d556139c10aa$export$4f13d577f7028d57(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
    /**
     * Update targetBox to match the prevViewportBox. This is just to ensure
     * that targetBox is affected by scroll in the same way as the measured box
     */ visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
}

});
parcelRequire.register("lfoD4", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToAxisBox", function () { return $f77e1a85671e9a3e$export$a6a6a93acd99480a; });
$parcel$export(module.exports, "convertAxisBoxToBoundingBox", function () { return $f77e1a85671e9a3e$export$7dccf987ed3cfb10; });
$parcel$export(module.exports, "transformBoundingBox", function () { return $f77e1a85671e9a3e$export$e79a6921359ce186; });
$parcel$export(module.exports, "axisBox", function () { return $f77e1a85671e9a3e$export$392205f483678b20; });
$parcel$export(module.exports, "copyAxisBox", function () { return $f77e1a85671e9a3e$export$cad7f7b798bfcc39; });
$parcel$export(module.exports, "delta", function () { return $f77e1a85671e9a3e$export$eabbe41f409ce55b; });

var $cA1Ck = parcelRequire("cA1Ck");

var $1m9Jt = parcelRequire("1m9Jt");
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $f77e1a85671e9a3e$export$a6a6a93acd99480a(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $f77e1a85671e9a3e$export$7dccf987ed3cfb10(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $f77e1a85671e9a3e$export$e79a6921359ce186(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) transformPoint = (0, $1m9Jt.noop);
    var topLeft = transformPoint({
        x: left,
        y: top
    });
    var bottomRight = transformPoint({
        x: right,
        y: bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}
/**
 * Create an empty axis box of zero size
 */ function $f77e1a85671e9a3e$export$392205f483678b20() {
    return {
        x: {
            min: 0,
            max: 1
        },
        y: {
            min: 0,
            max: 1
        }
    };
}
function $f77e1a85671e9a3e$export$cad7f7b798bfcc39(box) {
    return {
        x: (0, $cA1Ck.__assign)({}, box.x),
        y: (0, $cA1Ck.__assign)({}, box.y)
    };
}
/**
 * Create an empty box delta
 */ var $f77e1a85671e9a3e$var$zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
};
function $f77e1a85671e9a3e$export$eabbe41f409ce55b() {
    return {
        x: (0, $cA1Ck.__assign)({}, $f77e1a85671e9a3e$var$zeroDelta),
        y: (0, $cA1Ck.__assign)({}, $f77e1a85671e9a3e$var$zeroDelta)
    };
}

});
parcelRequire.register("1m9Jt", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $0fcf6528541b8f64$export$8793edee2d425525; });
function $0fcf6528541b8f64$export$8793edee2d425525(any) {
    return any;
}

});


parcelRequire.register("7k3Fq", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $554d3ee529c07acb$export$d689d9dec5ad338; });
var $554d3ee529c07acb$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});


parcelRequire.register("1Uuis", function(module, exports) {

$parcel$export(module.exports, "batchLayout", function () { return $164285b1de7c2478$export$7e76af4b25f08a69; });
$parcel$export(module.exports, "flushLayout", function () { return $164285b1de7c2478$export$6445c3d91f1ae606; });
var $164285b1de7c2478$var$unresolvedJobs = new Set();
function $164285b1de7c2478$var$pushJob(stack, job, pointer) {
    if (!stack[pointer]) stack[pointer] = [];
    stack[pointer].push(job);
}
function $164285b1de7c2478$export$7e76af4b25f08a69(callback) {
    $164285b1de7c2478$var$unresolvedJobs.add(callback);
    return function() {
        return $164285b1de7c2478$var$unresolvedJobs.delete(callback);
    };
}
function $164285b1de7c2478$export$6445c3d91f1ae606() {
    if (!$164285b1de7c2478$var$unresolvedJobs.size) return;
    var pointer = 0;
    var reads = [
        []
    ];
    var writes = [];
    var setRead = function(job) {
        return $164285b1de7c2478$var$pushJob(reads, job, pointer);
    };
    var setWrite = function(job) {
        $164285b1de7c2478$var$pushJob(writes, job, pointer);
        pointer++;
    };
    /**
     * Resolve jobs into their array stacks
     */ $164285b1de7c2478$var$unresolvedJobs.forEach(function(callback) {
        callback(setRead, setWrite);
        pointer = 0;
    });
    $164285b1de7c2478$var$unresolvedJobs.clear();
    /**
     * Execute jobs
     */ var numStacks = writes.length;
    for(var i = 0; i <= numStacks; i++){
        reads[i] && reads[i].forEach($164285b1de7c2478$var$executeJob);
        writes[i] && writes[i].forEach($164285b1de7c2478$var$executeJob);
    }
}
var $164285b1de7c2478$var$executeJob = function(job) {
    return job();
};

});

parcelRequire.register("4ZkPk", function(module, exports) {

$parcel$export(module.exports, "Presence", function () { return $3a1d03ba1e88c856$export$99c2b779aa4e8b8b; });
$parcel$export(module.exports, "VisibilityAction", function () { return $3a1d03ba1e88c856$export$560b21f26820dbed; });
/**
 * @public
 */ var $3a1d03ba1e88c856$export$99c2b779aa4e8b8b;
(function(Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})($3a1d03ba1e88c856$export$99c2b779aa4e8b8b || ($3a1d03ba1e88c856$export$99c2b779aa4e8b8b = {}));
/**
 * @public
 */ var $3a1d03ba1e88c856$export$560b21f26820dbed;
(function(VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})($3a1d03ba1e88c856$export$560b21f26820dbed || ($3a1d03ba1e88c856$export$560b21f26820dbed = {}));

});




parcelRequire.register("2oFHj", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $1bee2aed7588e189$export$e25e478948902b8b; });

var $cA1Ck = parcelRequire("cA1Ck");

var $kvFqP = parcelRequire("kvFqP");

var $7p6TO = parcelRequire("7p6TO");

var $52tdF = parcelRequire("52tdF");

var $39RYB = parcelRequire("39RYB");

var $3YY9Z = parcelRequire("3YY9Z");

var $2Txhq = parcelRequire("2Txhq");

var $gdtmI = parcelRequire("gdtmI");

var $fKGIV = parcelRequire("fKGIV");
var $1bee2aed7588e189$var$featureBundle = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, (0, $3YY9Z.animations)), (0, $39RYB.gestureAnimations)), (0, $2Txhq.drag)), (0, $gdtmI.layoutAnimations));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $1bee2aed7588e189$export$e25e478948902b8b = /*@__PURE__*/ (0, $7p6TO.createMotionProxy)(function(Component, config) {
    return (0, $52tdF.createDomMotionConfig)(Component, config, $1bee2aed7588e189$var$featureBundle, (0, $fKGIV.createDomVisualElement));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $1bee2aed7588e189$export$546614c4a05701f9(key) {
    return (0, $kvFqP.createMotionComponent)((0, $52tdF.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $1bee2aed7588e189$var$featureBundle, (0, $fKGIV.createDomVisualElement)));
}

});
parcelRequire.register("kvFqP", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $eee6d75ee2925d98$export$46b7e4b9dc6110c3; });

var $7fPBF = parcelRequire("7fPBF");

var $cFH5Z = parcelRequire("cFH5Z");

var $kfwla = parcelRequire("kfwla");

var $9kV0b = parcelRequire("9kV0b");

var $9NtK2 = parcelRequire("9NtK2");

var $hF6ox = parcelRequire("hF6ox");

var $jXZZQ = parcelRequire("jXZZQ");

var $gwSqD = parcelRequire("gwSqD");

var $ko9lZ = parcelRequire("ko9lZ");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */ function $eee6d75ee2925d98$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $gwSqD.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var isStatic = (0, $7fPBF.useContext)((0, $kfwla.MotionConfigContext)).isStatic;
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */ var context = (0, $jXZZQ.useCreateMotionContext)(props, isStatic);
        /**
         *
         */ var visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $ko9lZ.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $9NtK2.useVisualElement)(Component, visualState, props, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */ features = (0, $cFH5Z.useFeatures)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement((0, $9kV0b.MotionContext).Provider, {
            value: context
        }, useRender(Component, props, (0, $hF6ox.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic)), features);
    }
    return (0, $7fPBF.forwardRef)(MotionComponent);
}

});
parcelRequire.register("cFH5Z", function(module, exports) {

$parcel$export(module.exports, "useFeatures", function () { return $939abe402de70fe4$export$4a39035bacc4ed76; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $gwSqD = parcelRequire("gwSqD");
parcelRequire("hrQbS");

var $abxu1 = parcelRequire("abxu1");
var $939abe402de70fe4$var$featureNames = Object.keys((0, $gwSqD.featureDefinitions));
var $939abe402de70fe4$var$numFeatures = $939abe402de70fe4$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $939abe402de70fe4$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $7fPBF.useContext)((0, $abxu1.LazyContext));
    if (!visualElement) return null;
    for(var i = 0; i < $939abe402de70fe4$var$numFeatures; i++){
        var name_1 = $939abe402de70fe4$var$featureNames[i];
        var _a = (0, $gwSqD.featureDefinitions)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($7fPBF.createElement(Component, (0, $cA1Ck.__assign)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}

});
parcelRequire.register("gwSqD", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $c089dae6be282b3c$export$65570e08d843624d; });
$parcel$export(module.exports, "loadFeatures", function () { return $c089dae6be282b3c$export$449561ec5703cdc8; });
var $c089dae6be282b3c$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $c089dae6be282b3c$export$65570e08d843624d = {
    measureLayout: $c089dae6be282b3c$var$createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform"
    ]),
    animation: $c089dae6be282b3c$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag"
    ]),
    exit: $c089dae6be282b3c$var$createDefinition([
        "exit"
    ]),
    drag: $c089dae6be282b3c$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $c089dae6be282b3c$var$createDefinition([
        "whileFocus"
    ]),
    hover: $c089dae6be282b3c$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $c089dae6be282b3c$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $c089dae6be282b3c$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    layoutAnimation: $c089dae6be282b3c$var$createDefinition([
        "layout",
        "layoutId"
    ])
};
function $c089dae6be282b3c$export$449561ec5703cdc8(features) {
    for(var key in features){
        var Component = features[key];
        if (Component !== null) $c089dae6be282b3c$export$65570e08d843624d[key].Component = Component;
    }
}

});

parcelRequire.register("hrQbS", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $cb3d713e4bfb4957$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $cb3d713e4bfb4957$export$f5708dca728d7177; });
var $cb3d713e4bfb4957$export$491112666e282270 = function() {};
var $cb3d713e4bfb4957$export$f5708dca728d7177 = function() {};

});

parcelRequire.register("abxu1", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $76a4e78367f28a1a$export$40f10139ecf1f171; });

var $7fPBF = parcelRequire("7fPBF");
var $76a4e78367f28a1a$export$40f10139ecf1f171 = (0, $7fPBF.createContext)({
    strict: false
});

});


parcelRequire.register("kfwla", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $ebde4b82a963a1d8$export$22a697fb29aac98d; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @public
 */ var $ebde4b82a963a1d8$export$22a697fb29aac98d = (0, $7fPBF.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false
});

});

parcelRequire.register("9kV0b", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $6cc232bcef6ada8e$export$2285bbca2c666415; });
$parcel$export(module.exports, "useVisualElementContext", function () { return $6cc232bcef6ada8e$export$cd995842eb2ab956; });

var $7fPBF = parcelRequire("7fPBF");
var $6cc232bcef6ada8e$export$2285bbca2c666415 = (0, $7fPBF.createContext)({});
function $6cc232bcef6ada8e$export$cd995842eb2ab956() {
    return (0, $7fPBF.useContext)($6cc232bcef6ada8e$export$2285bbca2c666415).visualElement;
}

});

parcelRequire.register("9NtK2", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $721fc2b7b59a7699$export$dc0335d73ab0b115; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $6iH3e = parcelRequire("6iH3e");

var $iesfz = parcelRequire("iesfz");

var $cbFU5 = parcelRequire("cbFU5");

var $9kV0b = parcelRequire("9kV0b");

var $9M3iX = parcelRequire("9M3iX");

var $kfwla = parcelRequire("kfwla");

var $abxu1 = parcelRequire("abxu1");
function $721fc2b7b59a7699$var$useLayoutId(_a) {
    var layoutId = _a.layoutId;
    var layoutGroupId = (0, $7fPBF.useContext)((0, $cbFU5.LayoutGroupContext));
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $721fc2b7b59a7699$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var config = (0, $7fPBF.useContext)((0, $kfwla.MotionConfigContext));
    var lazyContext = (0, $7fPBF.useContext)((0, $abxu1.LazyContext));
    var parent = (0, $9kV0b.useVisualElementContext)();
    var presenceContext = (0, $7fPBF.useContext)((0, $6iH3e.PresenceContext));
    var layoutId = $721fc2b7b59a7699$var$useLayoutId(props);
    var visualElementRef = (0, $7fPBF.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, props), {
            layoutId: layoutId
        }),
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
    var visualElement = visualElementRef.current;
    (0, $9M3iX.useIsomorphicLayoutEffect)(function() {
        if (!visualElement) return;
        visualElement.setProps((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, config), props), {
            layoutId: layoutId
        }));
        visualElement.isPresent = (0, $iesfz.isPresent)(presenceContext);
        visualElement.isPresenceRoot = !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
        /**
         * Fire a render to ensure the latest state is reflected on-screen.
         */ visualElement.syncRender();
    });
    (0, $7fPBF.useEffect)(function() {
        var _a;
        if (!visualElement) return;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $9M3iX.useIsomorphicLayoutEffect)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}

});
parcelRequire.register("iesfz", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $d45f72acc0891bf6$export$2a8c16d82a0a0e26; });
$parcel$export(module.exports, "isPresent", function () { return $d45f72acc0891bf6$export$ee27c052bca048fb; });

var $7fPBF = parcelRequire("7fPBF");

var $6iH3e = parcelRequire("6iH3e");

var $5URq7 = parcelRequire("5URq7");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $d45f72acc0891bf6$export$2a8c16d82a0a0e26() {
    var context = (0, $7fPBF.useContext)((0, $6iH3e.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = $d45f72acc0891bf6$var$useUniqueId();
    (0, $7fPBF.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $d45f72acc0891bf6$export$8249053f690ea39a() {
    return $d45f72acc0891bf6$export$ee27c052bca048fb((0, $7fPBF.useContext)((0, $6iH3e.PresenceContext)));
}
function $d45f72acc0891bf6$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}
var $d45f72acc0891bf6$var$counter = 0;
var $d45f72acc0891bf6$var$incrementId = function() {
    return $d45f72acc0891bf6$var$counter++;
};
var $d45f72acc0891bf6$var$useUniqueId = function() {
    return (0, $5URq7.useConstant)($d45f72acc0891bf6$var$incrementId);
};

});

parcelRequire.register("cbFU5", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $8df70446ee9ca217$export$a3579ca508007a95; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @internal
 */ var $8df70446ee9ca217$export$a3579ca508007a95 = (0, $7fPBF.createContext)(null);

});

parcelRequire.register("9M3iX", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $71db2907a52d119e$export$700979bc83e7db82; });

var $7fPBF = parcelRequire("7fPBF");

var $ko9lZ = parcelRequire("ko9lZ");
var $71db2907a52d119e$export$700979bc83e7db82 = (0, $ko9lZ.isBrowser) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);

});
parcelRequire.register("ko9lZ", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $ed7d4dfe1d2767a8$export$4e09c449d6c407f7; });
var $ed7d4dfe1d2767a8$export$4e09c449d6c407f7 = typeof window !== "undefined";

});



parcelRequire.register("hF6ox", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $cdbb39e2e87d7394$export$c684914703d321fd; });

var $7fPBF = parcelRequire("7fPBF");

var $fPMQj = parcelRequire("fPMQj");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $cdbb39e2e87d7394$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $7fPBF.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $fPMQj.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRequire.register("fPMQj", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $b8718199adf569fa$export$dedd81df7bc1307; });
function $b8718199adf569fa$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRequire.register("jXZZQ", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $e8939e3baa04cae7$export$c5638d843b37a176; });

var $7fPBF = parcelRequire("7fPBF");

var $9kV0b = parcelRequire("9kV0b");

var $5hdpY = parcelRequire("5hdpY");
function $e8939e3baa04cae7$export$c5638d843b37a176(props, isStatic) {
    var _a = (0, $5hdpY.getCurrentTreeVariants)(props, (0, $7fPBF.useContext)((0, $9kV0b.MotionContext))), initial = _a.initial, animate = _a.animate;
    return (0, $7fPBF.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, /**
     * Only break memoisation in static mode
     */ isStatic ? [
        $e8939e3baa04cae7$var$variantLabelsAsDependency(initial),
        $e8939e3baa04cae7$var$variantLabelsAsDependency(animate)
    ] : []);
}
function $e8939e3baa04cae7$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRequire.register("5hdpY", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $3d78f2cb774eec3e$export$12fc32fc096a04a3; });

var $5KrvS = parcelRequire("5KrvS");
function $3d78f2cb774eec3e$export$12fc32fc096a04a3(props, context) {
    if ((0, $5KrvS.checkIfControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $5KrvS.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $5KrvS.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRequire.register("5KrvS", function(module, exports) {

$parcel$export(module.exports, "isVariantLabels", function () { return $42f69724c9b68ce3$export$562271cd22f751d; });
$parcel$export(module.exports, "isVariantLabel", function () { return $42f69724c9b68ce3$export$720b90e312cea233; });
$parcel$export(module.exports, "resolveVariantFromProps", function () { return $42f69724c9b68ce3$export$d68f140c4d9b48bc; });
$parcel$export(module.exports, "resolveVariant", function () { return $42f69724c9b68ce3$export$7b1b1c981f4f0558; });
$parcel$export(module.exports, "checkIfControllingVariants", function () { return $42f69724c9b68ce3$export$cf3a7bd331c35bf0; });
$parcel$export(module.exports, "checkIfVariantNode", function () { return $42f69724c9b68ce3$export$c0eba02279c18fea; });
/**
 * Decides if the supplied variable is an array of variant labels
 */ function $42f69724c9b68ce3$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $42f69724c9b68ce3$export$720b90e312cea233(v) {
    return typeof v === "string" || $42f69724c9b68ce3$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $42f69724c9b68ce3$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $42f69724c9b68ce3$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $42f69724c9b68ce3$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    return typeof definition === "function" ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity) : definition;
}
function $42f69724c9b68ce3$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $42f69724c9b68ce3$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $42f69724c9b68ce3$var$getCurrent(visualElement), $42f69724c9b68ce3$var$getVelocity(visualElement));
}
function $42f69724c9b68ce3$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $42f69724c9b68ce3$export$720b90e312cea233(props.initial) || $42f69724c9b68ce3$export$720b90e312cea233(props.animate) || $42f69724c9b68ce3$export$720b90e312cea233(props.whileHover) || $42f69724c9b68ce3$export$720b90e312cea233(props.whileDrag) || $42f69724c9b68ce3$export$720b90e312cea233(props.whileTap) || $42f69724c9b68ce3$export$720b90e312cea233(props.whileFocus) || $42f69724c9b68ce3$export$720b90e312cea233(props.exit);
}
function $42f69724c9b68ce3$export$c0eba02279c18fea(props) {
    return Boolean($42f69724c9b68ce3$export$cf3a7bd331c35bf0(props) || props.variants);
}

});




parcelRequire.register("7p6TO", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $5640383eaea687d4$export$a28d6df673050e18; });

var $kvFqP = parcelRequire("kvFqP");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $5640383eaea687d4$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $kvFqP.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRequire.register("52tdF", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $3ab3ce0b388c82ba$export$732916c0e88175fb; });

var $cA1Ck = parcelRequire("cA1Ck");

var $lebiC = parcelRequire("lebiC");

var $k30S4 = parcelRequire("k30S4");

var $8k5ba = parcelRequire("8k5ba");

var $cMStC = parcelRequire("cMStC");
function $3ab3ce0b388c82ba$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $lebiC.isSVGComponent)(Component) ? (0, $8k5ba.svgMotionConfig) : (0, $cMStC.htmlMotionConfig);
    return (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $k30S4.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}

});
parcelRequire.register("lebiC", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $f743ab972dca93a2$export$88f3fc2fd3766989; });

var $8Fmvc = parcelRequire("8Fmvc");
function $f743ab972dca93a2$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $8Fmvc.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRequire.register("8Fmvc", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $64f39b8b4b43c90f$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $64f39b8b4b43c90f$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRequire.register("k30S4", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $e984c374359760d1$export$5d29104eefd89cc8; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $bBAH9 = parcelRequire("bBAH9");

var $9Lv8O = parcelRequire("9Lv8O");

var $lebiC = parcelRequire("lebiC");

var $43t3W = parcelRequire("43t3W");
function $e984c374359760d1$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $lebiC.isSVGComponent)(Component) ? (0, $43t3W.useSVGProps) : (0, $bBAH9.useHTMLProps);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $9Lv8O.filterProps)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, filteredProps), visualProps), {
            ref: ref
        });
        return (0, $7fPBF.createElement)(Component, elementProps);
    };
    return useRender;
}

});
parcelRequire.register("bBAH9", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $872f9d420a123490$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $872f9d420a123490$export$57be0a314572d87d; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $3cCsT = parcelRequire("3cCsT");

var $8olpw = parcelRequire("8olpw");

var $hcgl4 = parcelRequire("hcgl4");

var $hGNon = parcelRequire("hGNon");
function $872f9d420a123490$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $8olpw.isMotionValue)(source[key]) && !(0, $3cCsT.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $872f9d420a123490$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $7fPBF.useMemo)(function() {
        var state = (0, $hGNon.createHtmlRenderState)();
        (0, $hcgl4.buildHTMLStyles)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, vars), style);
    }, [
        visualState
    ]);
}
function $872f9d420a123490$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $872f9d420a123490$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $872f9d420a123490$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $872f9d420a123490$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $872f9d420a123490$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRequire.register("3cCsT", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $25505475d877f9ec$export$6d27ce8e3de1c3cf; });

var $jVB6R = parcelRequire("jVB6R");

var $3r0Rf = parcelRequire("3r0Rf");
function $25505475d877f9ec$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $3r0Rf.isTransformProp)(key) || (0, $3r0Rf.isTransformOriginProp)(key) || (layout || layoutId !== undefined) && (!!(0, $jVB6R.valueScaleCorrection)[key] || key === "opacity");
}

});
parcelRequire.register("jVB6R", function(module, exports) {

$parcel$export(module.exports, "valueScaleCorrection", function () { return $e820206c2cdbfb61$export$d57fad728466ad75; });
$parcel$export(module.exports, "addScaleCorrection", function () { return $e820206c2cdbfb61$export$2cba7fcde4b7b2d5; });
var $e820206c2cdbfb61$export$d57fad728466ad75 = {};
/**
 * @internal
 */ function $e820206c2cdbfb61$export$2cba7fcde4b7b2d5(correctors) {
    for(var key in correctors)$e820206c2cdbfb61$export$d57fad728466ad75[key] = correctors[key];
}

});

parcelRequire.register("3r0Rf", function(module, exports) {

$parcel$export(module.exports, "transformProps", function () { return $28048f0bc4b7616b$export$7b42a0094fb00b6e; });
$parcel$export(module.exports, "sortTransformProps", function () { return $28048f0bc4b7616b$export$61f68472e7973485; });
$parcel$export(module.exports, "isTransformProp", function () { return $28048f0bc4b7616b$export$15240a8a4379d8de; });
$parcel$export(module.exports, "isTransformOriginProp", function () { return $28048f0bc4b7616b$export$91fe49ee9d172523; });
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $28048f0bc4b7616b$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $28048f0bc4b7616b$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $28048f0bc4b7616b$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$28048f0bc4b7616b$var$order.forEach(function(operationKey) {
    return $28048f0bc4b7616b$export$67cd428da31419e1.forEach(function(axesKey) {
        return $28048f0bc4b7616b$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $28048f0bc4b7616b$export$61f68472e7973485(a, b) {
    return $28048f0bc4b7616b$export$7b42a0094fb00b6e.indexOf(a) - $28048f0bc4b7616b$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $28048f0bc4b7616b$var$transformPropSet = new Set($28048f0bc4b7616b$export$7b42a0094fb00b6e);
function $28048f0bc4b7616b$export$15240a8a4379d8de(key) {
    return $28048f0bc4b7616b$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $28048f0bc4b7616b$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $28048f0bc4b7616b$export$91fe49ee9d172523(key) {
    return $28048f0bc4b7616b$var$transformOriginProps.has(key);
}

});


parcelRequire.register("8olpw", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $61c12c5aad365d08$export$605d60a2578142d3; });
var $61c12c5aad365d08$export$605d60a2578142d3 = function(value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};

});

parcelRequire.register("hcgl4", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $c8503b35c1018e99$export$bb517f8b40f8e99d; });

var $jVB6R = parcelRequire("jVB6R");

var $faP52 = parcelRequire("faP52");

var $7yQ2l = parcelRequire("7yQ2l");

var $3r0Rf = parcelRequire("3r0Rf");

var $7EKKk = parcelRequire("7EKKk");

var $ddwKx = parcelRequire("ddwKx");
function $c8503b35c1018e99$export$bb517f8b40f8e99d(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $7yQ2l.isCSSVariable)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $ddwKx.numberValueTypes)[key];
        var valueAsType = (0, $7EKKk.getValueAsType)(value, valueType);
        if ((0, $3r0Rf.isTransformProp)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $3r0Rf.isTransformOriginProp)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else /**
             * If layout projection is on, and we need to perform scale correction for this
             * value type, perform it.
             */ if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) && (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) && (0, $jVB6R.valueScaleCorrection)[key]) {
            var correctedValue = (0, $jVB6R.valueScaleCorrection)[key].process(value, layoutState, projection);
            /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */ var applyTo = (0, $jVB6R.valueScaleCorrection)[key].applyTo;
            if (applyTo) {
                var num = applyTo.length;
                for(var i = 0; i < num; i++)style[applyTo[i]] = correctedValue;
            } else style[key] = correctedValue;
        } else style[key] = valueAsType;
    }
    if (layoutState && projection && buildProjectionTransform && buildProjectionTransformOrigin) {
        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
        if (transformTemplate) style.transform = transformTemplate(transform, style.transform);
        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
    } else {
        if (hasTransform) style.transform = (0, $faP52.buildTransform)(state, options, transformIsNone, transformTemplate);
        if (hasTransformOrigin) style.transformOrigin = (0, $faP52.buildTransformOrigin)(transformOrigin);
    }
}

});
parcelRequire.register("faP52", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $b0bf69aa03a78187$export$bdc96e0d5c8f914; });
$parcel$export(module.exports, "buildTransformOrigin", function () { return $b0bf69aa03a78187$export$22d2fbf39767d07a; });

var $3r0Rf = parcelRequire("3r0Rf");
var $b0bf69aa03a78187$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $b0bf69aa03a78187$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $3r0Rf.sortTransformProps));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += ($b0bf69aa03a78187$var$translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $b0bf69aa03a78187$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}

});

parcelRequire.register("7yQ2l", function(module, exports) {

$parcel$export(module.exports, "isCSSVariable", function () { return $581412d005c27fc0$export$451bc42768436155; });
/**
 * Returns true if the provided key is a CSS variable
 */ function $581412d005c27fc0$export$451bc42768436155(key) {
    return key.startsWith("--");
}

});

parcelRequire.register("7EKKk", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $593087a7f7fa4da8$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $593087a7f7fa4da8$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRequire.register("ddwKx", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $99f5e4a46787d273$export$eec14432cd1cb67b; });

var $avOce = parcelRequire("avOce");
var $c1DuU = parcelRequire("c1DuU");

var $eV6Vz = parcelRequire("eV6Vz");
var $99f5e4a46787d273$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $c1DuU.px),
    borderTopWidth: (0, $c1DuU.px),
    borderRightWidth: (0, $c1DuU.px),
    borderBottomWidth: (0, $c1DuU.px),
    borderLeftWidth: (0, $c1DuU.px),
    borderRadius: (0, $c1DuU.px),
    radius: (0, $c1DuU.px),
    borderTopLeftRadius: (0, $c1DuU.px),
    borderTopRightRadius: (0, $c1DuU.px),
    borderBottomRightRadius: (0, $c1DuU.px),
    borderBottomLeftRadius: (0, $c1DuU.px),
    // Positioning props
    width: (0, $c1DuU.px),
    maxWidth: (0, $c1DuU.px),
    height: (0, $c1DuU.px),
    maxHeight: (0, $c1DuU.px),
    size: (0, $c1DuU.px),
    top: (0, $c1DuU.px),
    right: (0, $c1DuU.px),
    bottom: (0, $c1DuU.px),
    left: (0, $c1DuU.px),
    // Spacing props
    padding: (0, $c1DuU.px),
    paddingTop: (0, $c1DuU.px),
    paddingRight: (0, $c1DuU.px),
    paddingBottom: (0, $c1DuU.px),
    paddingLeft: (0, $c1DuU.px),
    margin: (0, $c1DuU.px),
    marginTop: (0, $c1DuU.px),
    marginRight: (0, $c1DuU.px),
    marginBottom: (0, $c1DuU.px),
    marginLeft: (0, $c1DuU.px),
    // Transform props
    rotate: (0, $c1DuU.degrees),
    rotateX: (0, $c1DuU.degrees),
    rotateY: (0, $c1DuU.degrees),
    rotateZ: (0, $c1DuU.degrees),
    scale: (0, $avOce.scale),
    scaleX: (0, $avOce.scale),
    scaleY: (0, $avOce.scale),
    scaleZ: (0, $avOce.scale),
    skew: (0, $c1DuU.degrees),
    skewX: (0, $c1DuU.degrees),
    skewY: (0, $c1DuU.degrees),
    distance: (0, $c1DuU.px),
    translateX: (0, $c1DuU.px),
    translateY: (0, $c1DuU.px),
    translateZ: (0, $c1DuU.px),
    x: (0, $c1DuU.px),
    y: (0, $c1DuU.px),
    z: (0, $c1DuU.px),
    perspective: (0, $c1DuU.px),
    transformPerspective: (0, $c1DuU.px),
    opacity: (0, $avOce.alpha),
    originX: (0, $c1DuU.progressPercentage),
    originY: (0, $c1DuU.progressPercentage),
    originZ: (0, $c1DuU.px),
    // Misc
    zIndex: (0, $eV6Vz.int),
    // SVG
    fillOpacity: (0, $avOce.alpha),
    strokeOpacity: (0, $avOce.alpha),
    numOctaves: (0, $eV6Vz.int)
};

});
parcelRequire.register("avOce", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $7a73bc9356bfc91b$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $7a73bc9356bfc91b$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $7a73bc9356bfc91b$export$dcdf75081b88279d; });

var $fmyED = parcelRequire("fmyED");

var $H3Eg8 = parcelRequire("H3Eg8");
var $7a73bc9356bfc91b$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $7a73bc9356bfc91b$export$58f0f39f63f3cf42 = (0, $fmyED.__assign)((0, $fmyED.__assign)({}, $7a73bc9356bfc91b$export$98e628dec113755e), {
    transform: (0, $H3Eg8.clamp)(0, 1)
});
var $7a73bc9356bfc91b$export$dcdf75081b88279d = (0, $fmyED.__assign)((0, $fmyED.__assign)({}, $7a73bc9356bfc91b$export$98e628dec113755e), {
    default: 1
});

});
parcelRequire.register("fmyED", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $b2f3cabc70d72049$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $b2f3cabc70d72049$var$extendStatics = function(d, b) {
    $b2f3cabc70d72049$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $b2f3cabc70d72049$var$extendStatics(d, b);
};
function $b2f3cabc70d72049$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $b2f3cabc70d72049$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b2f3cabc70d72049$export$18ce0697a983be9b = function() {
    $b2f3cabc70d72049$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b2f3cabc70d72049$export$18ce0697a983be9b.apply(this, arguments);
};
function $b2f3cabc70d72049$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b2f3cabc70d72049$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b2f3cabc70d72049$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b2f3cabc70d72049$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $b2f3cabc70d72049$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $b2f3cabc70d72049$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $b2f3cabc70d72049$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $b2f3cabc70d72049$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b2f3cabc70d72049$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b2f3cabc70d72049$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $b2f3cabc70d72049$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $b2f3cabc70d72049$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $b2f3cabc70d72049$export$45d3717a4c69092e(o, m, p);
}
function $b2f3cabc70d72049$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b2f3cabc70d72049$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b2f3cabc70d72049$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b2f3cabc70d72049$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b2f3cabc70d72049$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b2f3cabc70d72049$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $b2f3cabc70d72049$export$10c90e4f7922046c(v) {
    return this instanceof $b2f3cabc70d72049$export$10c90e4f7922046c ? (this.v = v, this) : new $b2f3cabc70d72049$export$10c90e4f7922046c(v);
}
function $b2f3cabc70d72049$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b2f3cabc70d72049$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b2f3cabc70d72049$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b2f3cabc70d72049$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $b2f3cabc70d72049$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b2f3cabc70d72049$export$19a8beecd37a4c45 === "function" ? $b2f3cabc70d72049$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b2f3cabc70d72049$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $b2f3cabc70d72049$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $b2f3cabc70d72049$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b2f3cabc70d72049$export$45d3717a4c69092e(result, mod, k);
    }
    $b2f3cabc70d72049$var$__setModuleDefault(result, mod);
    return result;
}
function $b2f3cabc70d72049$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b2f3cabc70d72049$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $b2f3cabc70d72049$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $b2f3cabc70d72049$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $b2f3cabc70d72049$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $b2f3cabc70d72049$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $b2f3cabc70d72049$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $b2f3cabc70d72049$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $b2f3cabc70d72049$export$2e2bcd8739ae039 = {
    __extends: $b2f3cabc70d72049$export$a8ba968b8961cb8a,
    __assign: $b2f3cabc70d72049$export$18ce0697a983be9b,
    __rest: $b2f3cabc70d72049$export$3c9a16f847548506,
    __decorate: $b2f3cabc70d72049$export$29e00dfd3077644b,
    __param: $b2f3cabc70d72049$export$d5ad3fd78186038f,
    __metadata: $b2f3cabc70d72049$export$f1db080c865becb9,
    __awaiter: $b2f3cabc70d72049$export$1050f835b63b671e,
    __generator: $b2f3cabc70d72049$export$67ebef60e6f28a6,
    __createBinding: $b2f3cabc70d72049$export$45d3717a4c69092e,
    __exportStar: $b2f3cabc70d72049$export$f33643c0debef087,
    __values: $b2f3cabc70d72049$export$19a8beecd37a4c45,
    __read: $b2f3cabc70d72049$export$8d051b38c9118094,
    __spread: $b2f3cabc70d72049$export$afc72e2116322959,
    __spreadArrays: $b2f3cabc70d72049$export$6388937ca91ccae8,
    __spreadArray: $b2f3cabc70d72049$export$1216008129fb82ed,
    __await: $b2f3cabc70d72049$export$10c90e4f7922046c,
    __asyncGenerator: $b2f3cabc70d72049$export$e427f37a30a4de9b,
    __asyncDelegator: $b2f3cabc70d72049$export$bbd80228419bb833,
    __asyncValues: $b2f3cabc70d72049$export$e3b29a3d6162315f,
    __makeTemplateObject: $b2f3cabc70d72049$export$4fb47efe1390b86f,
    __importStar: $b2f3cabc70d72049$export$c21735bcef00d192,
    __importDefault: $b2f3cabc70d72049$export$da59b14a69baef04,
    __classPrivateFieldGet: $b2f3cabc70d72049$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $b2f3cabc70d72049$export$d40a35129aaff81f,
    __classPrivateFieldIn: $b2f3cabc70d72049$export$81fdc39f203e4e04,
    __addDisposableResource: $b2f3cabc70d72049$export$88ac25d8e944e405,
    __disposeResources: $b2f3cabc70d72049$export$8f076105dc360e92
};

});

parcelRequire.register("H3Eg8", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $0816d8c06f642bad$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "sanitize", function () { return $0816d8c06f642bad$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $0816d8c06f642bad$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $0816d8c06f642bad$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $0816d8c06f642bad$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $0816d8c06f642bad$export$844ec244b1367d54; });
var $0816d8c06f642bad$export$7d15b64cf5a3a4c4 = function(min, max) {
    return function(v) {
        return Math.max(Math.min(v, max), min);
    };
};
var $0816d8c06f642bad$export$83d2e9e3e4ee39ed = function(v) {
    return v % 1 ? Number(v.toFixed(5)) : v;
};
var $0816d8c06f642bad$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
var $0816d8c06f642bad$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var $0816d8c06f642bad$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $0816d8c06f642bad$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});


parcelRequire.register("c1DuU", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $8c14376b2b00a646$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $8c14376b2b00a646$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $8c14376b2b00a646$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $8c14376b2b00a646$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $8c14376b2b00a646$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $8c14376b2b00a646$export$44e2e1705876d7ed; });

var $fmyED = parcelRequire("fmyED");

var $H3Eg8 = parcelRequire("H3Eg8");
var $8c14376b2b00a646$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return (0, $H3Eg8.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "" + v + unit;
        }
    };
};
var $8c14376b2b00a646$export$41fc368e1a942b97 = $8c14376b2b00a646$var$createUnitType("deg");
var $8c14376b2b00a646$export$626336c2cd4b14de = $8c14376b2b00a646$var$createUnitType("%");
var $8c14376b2b00a646$export$91c0eda1d06bf008 = $8c14376b2b00a646$var$createUnitType("px");
var $8c14376b2b00a646$export$f91e8c45a95a32f2 = $8c14376b2b00a646$var$createUnitType("vh");
var $8c14376b2b00a646$export$aed3d7b7d206c196 = $8c14376b2b00a646$var$createUnitType("vw");
var $8c14376b2b00a646$export$44e2e1705876d7ed = (0, $fmyED.__assign)((0, $fmyED.__assign)({}, $8c14376b2b00a646$export$626336c2cd4b14de), {
    parse: function(v) {
        return $8c14376b2b00a646$export$626336c2cd4b14de.parse(v) / 100;
    },
    transform: function(v) {
        return $8c14376b2b00a646$export$626336c2cd4b14de.transform(v * 100);
    }
});

});

parcelRequire.register("eV6Vz", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $adcbc337a5a1f43f$export$7d260a2a5f8bc19e; });

var $cA1Ck = parcelRequire("cA1Ck");

var $avOce = parcelRequire("avOce");
var $adcbc337a5a1f43f$export$7d260a2a5f8bc19e = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, (0, $avOce.number)), {
    transform: Math.round
});

});



parcelRequire.register("hGNon", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $ce0cac25586ce3ea$export$8940b483cf52eeda; });
var $ce0cac25586ce3ea$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRequire.register("9Lv8O", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $71c0a8ce43c8face$export$d697c39a2985a4c; });

var $4qPJH = parcelRequire("4qPJH");
var $71c0a8ce43c8face$var$shouldForward = function(key) {
    return !(0, $4qPJH.isValidMotionProp)(key);
};

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    var $71c0a8ce43c8face$var$emotionIsPropValid_1 = (parcelRequire("e1N9g")).default;
    $71c0a8ce43c8face$var$shouldForward = function(key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) return !(0, $4qPJH.isValidMotionProp)(key);
        else return $71c0a8ce43c8face$var$emotionIsPropValid_1(key);
    };
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $71c0a8ce43c8face$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($71c0a8ce43c8face$var$shouldForward(key) || forwardMotionProps === true && (0, $4qPJH.isValidMotionProp)(key) || !isDom && !(0, $4qPJH.isValidMotionProp)(key)) filteredProps[key] = props[key];
    return filteredProps;
}

});
parcelRequire.register("4qPJH", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $33a1b8d62719be54$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $33a1b8d62719be54$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "_layoutResetTransform",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $33a1b8d62719be54$export$2f9c46555243bf04(key) {
    return $33a1b8d62719be54$var$validMotionProps.has(key);
}

});

parcelRequire.register("e1N9g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3674889b12d03a5$export$2e2bcd8739ae039; });

var $1D61w = parcelRequire("1D61w");
var $a3674889b12d03a5$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a3674889b12d03a5$var$index = (0, $1D61w.default)(function(prop) {
    return $a3674889b12d03a5$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $a3674889b12d03a5$export$2e2bcd8739ae039 = $a3674889b12d03a5$var$index;

});
parcelRequire.register("1D61w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12fe1b18334f0447$export$2e2bcd8739ae039; });
function $12fe1b18334f0447$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $12fe1b18334f0447$export$2e2bcd8739ae039 = $12fe1b18334f0447$var$memoize;

});



parcelRequire.register("43t3W", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $2f3dfc795295dd78$export$84309c4f53cb1bd5; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $bBAH9 = parcelRequire("bBAH9");

var $hrXjD = parcelRequire("hrXjD");

var $hVAHJ = parcelRequire("hVAHJ");
function $2f3dfc795295dd78$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $7fPBF.useMemo)(function() {
        var state = (0, $hVAHJ.createSvgRenderState)();
        (0, $hrXjD.buildSVGAttrs)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, state.attrs), {
            style: (0, $cA1Ck.__assign)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $bBAH9.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

});
parcelRequire.register("hrXjD", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $cb42f82aeec4c3d0$export$5475d24f125d7053; });

var $cA1Ck = parcelRequire("cA1Ck");

var $hcgl4 = parcelRequire("hcgl4");

var $amjzM = parcelRequire("amjzM");

var $ffCNQ = parcelRequire("ffCNQ");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $cb42f82aeec4c3d0$export$5475d24f125d7053(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $cA1Ck.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $hcgl4.buildHTMLStyles)(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $amjzM.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) (0, $ffCNQ.buildSVGPath)(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRequire.register("amjzM", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $78ab24d6db231a56$export$d4fbcfc8e5472155; });

var $c1DuU = parcelRequire("c1DuU");
function $78ab24d6db231a56$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $c1DuU.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $78ab24d6db231a56$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $78ab24d6db231a56$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $78ab24d6db231a56$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}

});

parcelRequire.register("ffCNQ", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $b1a65b2fb453634c$export$311b43f666da1d82; });

var $c1DuU = parcelRequire("c1DuU");
// Convert a progress 0-1 to a pixels value based on the provided length
var $b1a65b2fb453634c$var$progressToPixels = function(progress, length) {
    return (0, $c1DuU.px).transform(progress * length);
};
var $b1a65b2fb453634c$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $b1a65b2fb453634c$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $b1a65b2fb453634c$export$311b43f666da1d82(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $b1a65b2fb453634c$var$dashKeys : $b1a65b2fb453634c$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = $b1a65b2fb453634c$var$progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = $b1a65b2fb453634c$var$progressToPixels(length, totalLength);
    var pathSpacing = $b1a65b2fb453634c$var$progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}

});


parcelRequire.register("hVAHJ", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $d0d43b42f5690311$export$41be8b43e1c4d4f9; });

var $cA1Ck = parcelRequire("cA1Ck");

var $hGNon = parcelRequire("hGNon");
var $d0d43b42f5690311$export$41be8b43e1c4d4f9 = function() {
    return (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, (0, $hGNon.createHtmlRenderState)()), {
        attrs: {}
    });
};

});



parcelRequire.register("8k5ba", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $60f4357a19675f32$export$44dabd3fae512e85; });

var $ayzhm = parcelRequire("ayzhm");

var $keTze = parcelRequire("keTze");

var $gGMUD = parcelRequire("gGMUD");

var $hVAHJ = parcelRequire("hVAHJ");

var $hrXjD = parcelRequire("hrXjD");
var $60f4357a19675f32$export$44dabd3fae512e85 = {
    useVisualState: (0, $gGMUD.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $keTze.scrapeMotionValuesFromProps),
        createRenderState: (0, $hVAHJ.createSvgRenderState),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            if ($60f4357a19675f32$var$isPath(instance)) renderState.totalPathLength = instance.getTotalLength();
            (0, $hrXjD.buildSVGAttrs)(renderState, latestValues, undefined, undefined, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            // TODO: Replace with direct assignment
            (0, $ayzhm.renderSVG)(instance, renderState);
        }
    })
};
function $60f4357a19675f32$var$isPath(element) {
    return element.tagName === "path";
}

});
parcelRequire.register("ayzhm", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $7af872044bdad6d6$export$c5f8399d19a7394b; });

var $jp6qR = parcelRequire("jp6qR");

var $7hl4L = parcelRequire("7hl4L");

var $7q4PB = parcelRequire("7q4PB");
function $7af872044bdad6d6$export$c5f8399d19a7394b(element, renderState) {
    (0, $7hl4L.renderHTML)(element, renderState);
    for(var key in renderState.attrs)element.setAttribute(!(0, $7q4PB.camelCaseAttributes).has(key) ? (0, $jp6qR.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRequire.register("jp6qR", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $e20557675330dd48$export$9fd24a634729c672; });
var $e20557675330dd48$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $e20557675330dd48$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $e20557675330dd48$export$9fd24a634729c672 = function(str) {
    return str.replace($e20557675330dd48$var$CAMEL_CASE_PATTERN, $e20557675330dd48$var$REPLACE_TEMPLATE).toLowerCase();
};

});

parcelRequire.register("7hl4L", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $54ca7822019d6836$export$1a32bf6229c258c0; });
function $54ca7822019d6836$export$1a32bf6229c258c0(element, _a) {
    var style = _a.style, vars = _a.vars;
    // Directly assign style into the Element's style prop. In tests Object.assign is the
    // fastest way to assign styles.
    Object.assign(element.style, style);
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRequire.register("7q4PB", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $566eb585f722e4c0$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $566eb585f722e4c0$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform"
]);

});


parcelRequire.register("keTze", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $ebc037f38ef32c13$export$16da615486abaa45; });

var $8olpw = parcelRequire("8olpw");

var $2Lf9c = parcelRequire("2Lf9c");
function $ebc037f38ef32c13$export$16da615486abaa45(props) {
    var newValues = (0, $2Lf9c.scrapeMotionValuesFromProps)(props);
    for(var key in props)if ((0, $8olpw.isMotionValue)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRequire.register("2Lf9c", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $202bb87d1f8c8319$export$16da615486abaa45; });

var $3cCsT = parcelRequire("3cCsT");

var $8olpw = parcelRequire("8olpw");
function $202bb87d1f8c8319$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $8olpw.isMotionValue)(style[key]) || (0, $3cCsT.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRequire.register("gGMUD", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $c2668290ded2d65d$export$e91e107bc6d03a8e; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $7uAIt = parcelRequire("7uAIt");

var $6iH3e = parcelRequire("6iH3e");

var $5KrvS = parcelRequire("5KrvS");

var $5URq7 = parcelRequire("5URq7");

var $hiyDv = parcelRequire("hiyDv");

var $9kV0b = parcelRequire("9kV0b");
function $c2668290ded2d65d$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $c2668290ded2d65d$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $c2668290ded2d65d$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $7fPBF.useContext)((0, $9kV0b.MotionContext));
        var presenceContext = (0, $7fPBF.useContext)((0, $6iH3e.PresenceContext));
        return isStatic ? $c2668290ded2d65d$var$makeState(config, props, context, presenceContext) : (0, $5URq7.useConstant)(function() {
            return $c2668290ded2d65d$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $c2668290ded2d65d$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $hiyDv.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $5KrvS.checkIfControllingVariants)(props);
    var isVariantNode = (0, $5KrvS.checkIfVariantNode)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $7uAIt.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $5KrvS.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $cA1Ck.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target)values[key] = target[key];
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRequire.register("7uAIt", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $5747d0d77edc82d7$export$aa71198ceeaf53ce; });
function $5747d0d77edc82d7$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}

});

parcelRequire.register("hiyDv", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $c97efc1d11fa52e3$export$fcc2206ecb6d74b; });

var $17KpK = parcelRequire("17KpK");

var $8olpw = parcelRequire("8olpw");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */ function $c97efc1d11fa52e3$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $8olpw.isMotionValue)(value) ? value.get() : value;
    return (0, $17KpK.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRequire.register("17KpK", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $0d1a72cf6ee852eb$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $0d1a72cf6ee852eb$export$5485128c47bd48bb; });

var $7L1pF = parcelRequire("7L1pF");
var $0d1a72cf6ee852eb$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $0d1a72cf6ee852eb$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $7L1pF.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRequire.register("7L1pF", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $5a5e04c12e31fd51$export$9153ad4c4999f4a0; });
var $5a5e04c12e31fd51$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});





parcelRequire.register("cMStC", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $94f439af87e01939$export$e13ea21d87ea57c8; });

var $gGMUD = parcelRequire("gGMUD");

var $2Lf9c = parcelRequire("2Lf9c");

var $hGNon = parcelRequire("hGNon");
var $94f439af87e01939$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $gGMUD.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $2Lf9c.scrapeMotionValuesFromProps),
        createRenderState: (0, $hGNon.createHtmlRenderState)
    })
};

});


parcelRequire.register("39RYB", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $24cc14f74a5d2e18$export$e5b72898e5a201f1; });

var $kVdMm = parcelRequire("kVdMm");

var $lUV4u = parcelRequire("lUV4u");

var $YkhDZ = parcelRequire("YkhDZ");

var $lOUEd = parcelRequire("lOUEd");
var $24cc14f74a5d2e18$export$e5b72898e5a201f1 = {
    tap: (0, $lOUEd.makeRenderlessComponent)((0, $YkhDZ.useTapGesture)),
    focus: (0, $lOUEd.makeRenderlessComponent)((0, $kVdMm.useFocusGesture)),
    hover: (0, $lOUEd.makeRenderlessComponent)((0, $lUV4u.useHoverGesture))
};

});
parcelRequire.register("kVdMm", function(module, exports) {

$parcel$export(module.exports, "useFocusGesture", function () { return $f3b3d1bc49fa4a34$export$cac52d7cca250a66; });

var $k2WUd = parcelRequire("k2WUd");

var $3FqxT = parcelRequire("3FqxT");
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $f3b3d1bc49fa4a34$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $k2WUd.AnimationType).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $k2WUd.AnimationType).Focus, false);
    };
    (0, $3FqxT.useDomEvent)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $3FqxT.useDomEvent)(visualElement, "blur", whileFocus ? onBlur : undefined);
}

});
parcelRequire.register("k2WUd", function(module, exports) {

$parcel$export(module.exports, "AnimationType", function () { return $e981affb9dfec2e3$export$2deb71ebd3734d23; });
var $e981affb9dfec2e3$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})($e981affb9dfec2e3$export$2deb71ebd3734d23 || ($e981affb9dfec2e3$export$2deb71ebd3734d23 = {}));

});

parcelRequire.register("3FqxT", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $2ab9cad49f0d8293$export$b1d829ddf82884aa; });
$parcel$export(module.exports, "useDomEvent", function () { return $2ab9cad49f0d8293$export$c1052189363cb2e0; });

var $7fPBF = parcelRequire("7fPBF");
function $2ab9cad49f0d8293$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $2ab9cad49f0d8293$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $7fPBF.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $2ab9cad49f0d8293$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}

});


parcelRequire.register("lUV4u", function(module, exports) {

$parcel$export(module.exports, "useHoverGesture", function () { return $ff4b191afdac86b4$export$dea06860711b7ebc; });

var $c23GA = parcelRequire("c23GA");

var $k2WUd = parcelRequire("k2WUd");

var $cxW7Z = parcelRequire("cxW7Z");

var $aRnpR = parcelRequire("aRnpR");
function $ff4b191afdac86b4$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $c23GA.isMouseEvent)(event) || (0, $aRnpR.isDragActive)()) return;
        callback === null || callback === void 0 || callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $k2WUd.AnimationType).Hover, isActive);
    };
}
function $ff4b191afdac86b4$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $cxW7Z.usePointerEvent)(visualElement, "pointerenter", onHoverStart || whileHover ? $ff4b191afdac86b4$var$createHoverEvent(visualElement, true, onHoverStart) : undefined);
    (0, $cxW7Z.usePointerEvent)(visualElement, "pointerleave", onHoverEnd || whileHover ? $ff4b191afdac86b4$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined);
}

});
parcelRequire.register("c23GA", function(module, exports) {

$parcel$export(module.exports, "isMouseEvent", function () { return $8c2887e7677afe9b$export$764db16956f554f8; });
$parcel$export(module.exports, "isTouchEvent", function () { return $8c2887e7677afe9b$export$c4dfce035d43d1e0; });
function $8c2887e7677afe9b$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $8c2887e7677afe9b$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

});

parcelRequire.register("cxW7Z", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $9225a81b5821d6ae$export$fcff2e64e6676b81; });
$parcel$export(module.exports, "usePointerEvent", function () { return $9225a81b5821d6ae$export$734d04395f5243cd; });

var $3FqxT = parcelRequire("3FqxT");

var $czpCm = parcelRequire("czpCm");

var $hWD80 = parcelRequire("hWD80");
var $9225a81b5821d6ae$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $9225a81b5821d6ae$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $9225a81b5821d6ae$var$getPointerEventName(name) {
    if ((0, $hWD80.supportsPointerEvents)()) return name;
    else if ((0, $hWD80.supportsTouchEvents)()) return $9225a81b5821d6ae$var$touchEventNames[name];
    else if ((0, $hWD80.supportsMouseEvents)()) return $9225a81b5821d6ae$var$mouseEventNames[name];
    return name;
}
function $9225a81b5821d6ae$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $3FqxT.addDomEvent)(target, $9225a81b5821d6ae$var$getPointerEventName(eventName), (0, $czpCm.wrapHandler)(handler, eventName === "pointerdown"), options);
}
function $9225a81b5821d6ae$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $3FqxT.useDomEvent)(ref, $9225a81b5821d6ae$var$getPointerEventName(eventName), handler && (0, $czpCm.wrapHandler)(handler, eventName === "pointerdown"), options);
}

});
parcelRequire.register("czpCm", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $926ca016b8e76ee3$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "getViewportPointFromEvent", function () { return $926ca016b8e76ee3$export$750e59ed656e0503; });
$parcel$export(module.exports, "wrapHandler", function () { return $926ca016b8e76ee3$export$f4437ba81469b709; });

var $c23GA = parcelRequire("c23GA");
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $926ca016b8e76ee3$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $926ca016b8e76ee3$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $926ca016b8e76ee3$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $926ca016b8e76ee3$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $926ca016b8e76ee3$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $926ca016b8e76ee3$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $c23GA.isTouchEvent)(event) ? $926ca016b8e76ee3$var$pointFromTouch(event, pointType) : $926ca016b8e76ee3$var$pointFromMouse(event, pointType)
    };
}
function $926ca016b8e76ee3$export$750e59ed656e0503(event) {
    return $926ca016b8e76ee3$export$12f84bb882d06e1a(event, "client");
}
var $926ca016b8e76ee3$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $926ca016b8e76ee3$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $926ca016b8e76ee3$var$filterPrimaryPointer(listener) : listener;
};

});

parcelRequire.register("hWD80", function(module, exports) {

$parcel$export(module.exports, "supportsPointerEvents", function () { return $d10634783e819d67$export$ed662207763ba653; });
$parcel$export(module.exports, "supportsTouchEvents", function () { return $d10634783e819d67$export$58e9cbc5718eb8c2; });
$parcel$export(module.exports, "supportsMouseEvents", function () { return $d10634783e819d67$export$1a3879af679d3ede; });

var $ko9lZ = parcelRequire("ko9lZ");
// We check for event support via functions in case they've been mocked by a testing suite.
var $d10634783e819d67$export$ed662207763ba653 = function() {
    return (0, $ko9lZ.isBrowser) && window.onpointerdown === null;
};
var $d10634783e819d67$export$58e9cbc5718eb8c2 = function() {
    return (0, $ko9lZ.isBrowser) && window.ontouchstart === null;
};
var $d10634783e819d67$export$1a3879af679d3ede = function() {
    return (0, $ko9lZ.isBrowser) && window.onmousedown === null;
};

});


parcelRequire.register("aRnpR", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", function () { return $7e81048c6ecbedf1$export$2b7959ed03c1a3fe; });
$parcel$export(module.exports, "isDragActive", function () { return $7e81048c6ecbedf1$export$1b3dd616664938e4; });
function $7e81048c6ecbedf1$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $7e81048c6ecbedf1$var$globalHorizontalLock = $7e81048c6ecbedf1$export$518c5fc2dcb7974b("dragHorizontal");
var $7e81048c6ecbedf1$var$globalVerticalLock = $7e81048c6ecbedf1$export$518c5fc2dcb7974b("dragVertical");
function $7e81048c6ecbedf1$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $7e81048c6ecbedf1$var$globalVerticalLock();
    else if (drag === "x") lock = $7e81048c6ecbedf1$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $7e81048c6ecbedf1$var$globalHorizontalLock();
        var openVertical_1 = $7e81048c6ecbedf1$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $7e81048c6ecbedf1$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $7e81048c6ecbedf1$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRequire.register("YkhDZ", function(module, exports) {

$parcel$export(module.exports, "useTapGesture", function () { return $0b55569bb8c7cc18$export$16dee6ef8c34532; });

var $7fPBF = parcelRequire("7fPBF");

var $6Rkje = parcelRequire("6Rkje");

var $cxW7Z = parcelRequire("cxW7Z");

var $8ANN9 = parcelRequire("8ANN9");

var $kdCPt = parcelRequire("kdCPt");

var $k2WUd = parcelRequire("k2WUd");

var $aRnpR = parcelRequire("aRnpR");
/**
 * @param handlers -
 * @internal
 */ function $0b55569bb8c7cc18$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $7fPBF.useRef)(false);
    var cancelPointerEndListeners = (0, $7fPBF.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $k2WUd.AnimationType).Tap, false);
        return !(0, $aRnpR.isDragActive)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $6Rkje.isNodeOrChild)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $kdCPt.pipe)((0, $cxW7Z.addPointerEvent)(window, "pointerup", onPointerUp), (0, $cxW7Z.addPointerEvent)(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $k2WUd.AnimationType).Tap, true);
    }
    (0, $cxW7Z.usePointerEvent)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0, $8ANN9.useUnmountEffect)(removePointerEndListener);
}

});
parcelRequire.register("6Rkje", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $4fe77247f551be80$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $4fe77247f551be80$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $4fe77247f551be80$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRequire.register("kdCPt", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $eb83243d1da90886$export$a4627e546088548d; });
var $eb83243d1da90886$var$combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var $eb83243d1da90886$export$a4627e546088548d = function() {
    var transformers = [];
    for(var _i = 0; _i < arguments.length; _i++)transformers[_i] = arguments[_i];
    return transformers.reduce($eb83243d1da90886$var$combineFunctions);
};

});


parcelRequire.register("lOUEd", function(module, exports) {

$parcel$export(module.exports, "makeRenderlessComponent", function () { return $fe2a3586a83b5944$export$46d1d6d046f826e4; });
var $fe2a3586a83b5944$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};

});


parcelRequire.register("3YY9Z", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $2e65a43d204b10a6$export$7f9953c70dacfd7f; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $7uAIt = parcelRequire("7uAIt");

var $iesfz = parcelRequire("iesfz");

var $6iH3e = parcelRequire("6iH3e");

var $3cBt8 = parcelRequire("3cBt8");

var $k2WUd = parcelRequire("k2WUd");

var $lOUEd = parcelRequire("lOUEd");
var $2e65a43d204b10a6$export$7f9953c70dacfd7f = {
    animation: (0, $lOUEd.makeRenderlessComponent)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $3cBt8.createAnimationState)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $7uAIt.isAnimationControls)(animate)) (0, $7fPBF.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $lOUEd.makeRenderlessComponent)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $cA1Ck.__read)((0, $iesfz.usePresence)(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0, $7fPBF.useContext)((0, $6iH3e.PresenceContext));
        (0, $7fPBF.useEffect)(function() {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $k2WUd.AnimationType).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(onExitComplete));
        }, [
            isPresent
        ]);
    })
};

});
parcelRequire.register("3cBt8", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $254f8ea27a4e8544$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "createAnimationState", function () { return $254f8ea27a4e8544$export$bb53502b7a672aa8; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7uAIt = parcelRequire("7uAIt");

var $7L1pF = parcelRequire("7L1pF");

var $eKnqX = parcelRequire("eKnqX");

var $48z9i = parcelRequire("48z9i");

var $k2WUd = parcelRequire("k2WUd");

var $5KrvS = parcelRequire("5KrvS");
var $254f8ea27a4e8544$export$16e45afcc206d3a8 = [
    (0, $k2WUd.AnimationType).Animate,
    (0, $k2WUd.AnimationType).Hover,
    (0, $k2WUd.AnimationType).Tap,
    (0, $k2WUd.AnimationType).Drag,
    (0, $k2WUd.AnimationType).Focus,
    (0, $k2WUd.AnimationType).Exit
];
var $254f8ea27a4e8544$var$reversePriorityOrder = (0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)($254f8ea27a4e8544$export$16e45afcc206d3a8)).reverse();
var $254f8ea27a4e8544$var$numAnimationTypes = $254f8ea27a4e8544$export$16e45afcc206d3a8.length;
function $254f8ea27a4e8544$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $48z9i.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $254f8ea27a4e8544$export$bb53502b7a672aa8(visualElement) {
    var animate = $254f8ea27a4e8544$var$animateList(visualElement);
    var state = $254f8ea27a4e8544$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $5KrvS.resolveVariant)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $cA1Ck.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $254f8ea27a4e8544$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $5KrvS.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $cA1Ck.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $7uAIt.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var shouldAnimateType = $254f8ea27a4e8544$export$b9d9a225005a5327(typeState.prevProp, prop) || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $7L1pF.isKeyframesTarget)(next) && (0, $7L1pF.isKeyframesTarget)(prev)) {
                        if (!(0, $eKnqX.shallowCompare)(next, prev)) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $cA1Ck.__assign)({
                        type: type
                    }, options)
                };
            }))));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $254f8ea27a4e8544$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $cA1Ck.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $254f8ea27a4e8544$export$b9d9a225005a5327(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $5KrvS.isVariantLabels)(next)) return !(0, $eKnqX.shallowCompare)(next, prev);
    return false;
}
function $254f8ea27a4e8544$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $254f8ea27a4e8544$var$createState() {
    var _a;
    return _a = {}, _a[(0, $k2WUd.AnimationType).Animate] = $254f8ea27a4e8544$var$createTypeState(true), _a[(0, $k2WUd.AnimationType).Hover] = $254f8ea27a4e8544$var$createTypeState(), _a[(0, $k2WUd.AnimationType).Tap] = $254f8ea27a4e8544$var$createTypeState(), _a[(0, $k2WUd.AnimationType).Drag] = $254f8ea27a4e8544$var$createTypeState(), _a[(0, $k2WUd.AnimationType).Focus] = $254f8ea27a4e8544$var$createTypeState(), _a[(0, $k2WUd.AnimationType).Exit] = $254f8ea27a4e8544$var$createTypeState(), _a;
}

});
parcelRequire.register("eKnqX", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $abc78a0cf18267ab$export$90e866afbd6b9f1a; });
function $abc78a0cf18267ab$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRequire.register("48z9i", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $30332ca1b9e688ea$export$ff62cf473653f109; });

var $cA1Ck = parcelRequire("cA1Ck");

var $bRoOe = parcelRequire("bRoOe");

var $hktAr = parcelRequire("hktAr");

var $5KrvS = parcelRequire("5KrvS");
/**
 * @internal
 */ function $30332ca1b9e688ea$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $30332ca1b9e688ea$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $30332ca1b9e688ea$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $5KrvS.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = $30332ca1b9e688ea$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $30332ca1b9e688ea$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $5KrvS.resolveVariant)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $30332ca1b9e688ea$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $30332ca1b9e688ea$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $cA1Ck.__read)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $30332ca1b9e688ea$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $cA1Ck.__rest)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $30332ca1b9e688ea$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var animation = (0, $bRoOe.startAnimation)(key, value, valueTarget, (0, $cA1Ck.__assign)({
            delay: delay
        }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $hktAr.setTarget)(visualElement, transitionEnd);
    });
}
function $30332ca1b9e688ea$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($30332ca1b9e688ea$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($30332ca1b9e688ea$var$animateVariant(child, variant, (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $30332ca1b9e688ea$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $30332ca1b9e688ea$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $30332ca1b9e688ea$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

});
parcelRequire.register("bRoOe", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $8a27e38b4fa314e2$export$7c1391340308742e; });
$parcel$export(module.exports, "startAnimation", function () { return $8a27e38b4fa314e2$export$592dbd515a49cf1b; });

var $cA1Ck = parcelRequire("cA1Ck");

var $5yzf6 = parcelRequire("5yzf6");
var $9TvJJ = parcelRequire("9TvJJ");

var $3Ns70 = parcelRequire("3Ns70");

var $hTNOY = parcelRequire("hTNOY");

var $kg0xf = parcelRequire("kg0xf");

var $jd5TW = parcelRequire("jd5TW");

var $hrQbS = parcelRequire("hrQbS");

var $lE419 = parcelRequire("lE419");
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $8a27e38b4fa314e2$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $cA1Ck.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $8a27e38b4fa314e2$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $8a27e38b4fa314e2$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $cA1Ck.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $cA1Ck.__assign)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $3Ns70.secondsToMilliseconds)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $3Ns70.secondsToMilliseconds)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $hTNOY.isEasingArray)(ease) ? ease.map((0, $hTNOY.easingDefinitionToFunction)) : (0, $hTNOY.easingDefinitionToFunction)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $hrQbS.warning)(!$8a27e38b4fa314e2$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $8a27e38b4fa314e2$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $8a27e38b4fa314e2$export$b55a0e77aebddb70(transition, key) {
    var _a;
    var valueTransition = $8a27e38b4fa314e2$export$7c1391340308742e(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function $8a27e38b4fa314e2$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(options.to));
        options.to[0] = options.from;
    }
    return options;
}
function $8a27e38b4fa314e2$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $8a27e38b4fa314e2$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$8a27e38b4fa314e2$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, transition), (0, $jd5TW.getDefaultTransition)(key, options.to));
    return (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, options), $8a27e38b4fa314e2$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $8a27e38b4fa314e2$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $8a27e38b4fa314e2$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $kg0xf.isAnimatable)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $lE419.getAnimatableNone)(key, target);
    else if ($8a27e38b4fa314e2$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $8a27e38b4fa314e2$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $8a27e38b4fa314e2$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $8a27e38b4fa314e2$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $kg0xf.isAnimatable)(key, origin);
    (0, $hrQbS.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + ' from "' + origin + '" to "' + target + '". ' + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $9TvJJ.inertia)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, options), valueTransition)) : (0, $5yzf6.animate)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, $8a27e38b4fa314e2$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $8a27e38b4fa314e2$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $8a27e38b4fa314e2$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $lE419.getAnimatableNone)("", potentialUnitType);
}
function $8a27e38b4fa314e2$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */ function $8a27e38b4fa314e2$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $8a27e38b4fa314e2$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $8a27e38b4fa314e2$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = setTimeout(start, (0, $3Ns70.secondsToMilliseconds)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}

});
parcelRequire.register("5yzf6", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $40bb77289cadcc6f$export$e3607ec2d7a891c4; });

var $kGaDj = parcelRequire("kGaDj");

var $kxHuf = parcelRequire("kxHuf");

var $7n4cL = parcelRequire("7n4cL");

var $9WSyX = parcelRequire("9WSyX");

var $lc1JK = parcelRequire("lc1JK");
var $40bb77289cadcc6f$var$framesync = function(update) {
    var passTimestamp = function(_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function() {
            return (0, $7n4cL.default).update(passTimestamp, true);
        },
        stop: function() {
            return (0, $7n4cL.cancelSync).update(passTimestamp);
        }
    };
};
function $40bb77289cadcc6f$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? $40bb77289cadcc6f$var$framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = (0, $kGaDj.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = (0, $kxHuf.detectAnimationFromOptions)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $9WSyX.interpolate)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    var animation = animator((0, $kGaDj.__assign)((0, $kGaDj.__assign)({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $lc1JK.reverseElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $lc1JK.loopElapsed)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $lc1JK.hasRepeatDelayElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function() {
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}

});
parcelRequire.register("kGaDj", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $f0dffa61f0179e37$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $f0dffa61f0179e37$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $f0dffa61f0179e37$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f0dffa61f0179e37$var$extendStatics = function(d, b) {
    $f0dffa61f0179e37$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f0dffa61f0179e37$var$extendStatics(d, b);
};
function $f0dffa61f0179e37$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f0dffa61f0179e37$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f0dffa61f0179e37$export$18ce0697a983be9b = function() {
    $f0dffa61f0179e37$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f0dffa61f0179e37$export$18ce0697a983be9b.apply(this, arguments);
};
function $f0dffa61f0179e37$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f0dffa61f0179e37$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f0dffa61f0179e37$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f0dffa61f0179e37$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f0dffa61f0179e37$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f0dffa61f0179e37$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f0dffa61f0179e37$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f0dffa61f0179e37$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f0dffa61f0179e37$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f0dffa61f0179e37$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f0dffa61f0179e37$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f0dffa61f0179e37$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f0dffa61f0179e37$export$45d3717a4c69092e(o, m, p);
}
function $f0dffa61f0179e37$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f0dffa61f0179e37$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f0dffa61f0179e37$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f0dffa61f0179e37$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f0dffa61f0179e37$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f0dffa61f0179e37$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f0dffa61f0179e37$export$10c90e4f7922046c(v) {
    return this instanceof $f0dffa61f0179e37$export$10c90e4f7922046c ? (this.v = v, this) : new $f0dffa61f0179e37$export$10c90e4f7922046c(v);
}
function $f0dffa61f0179e37$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f0dffa61f0179e37$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f0dffa61f0179e37$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f0dffa61f0179e37$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f0dffa61f0179e37$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f0dffa61f0179e37$export$19a8beecd37a4c45 === "function" ? $f0dffa61f0179e37$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f0dffa61f0179e37$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f0dffa61f0179e37$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f0dffa61f0179e37$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f0dffa61f0179e37$export$45d3717a4c69092e(result, mod, k);
    }
    $f0dffa61f0179e37$var$__setModuleDefault(result, mod);
    return result;
}
function $f0dffa61f0179e37$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f0dffa61f0179e37$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f0dffa61f0179e37$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f0dffa61f0179e37$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f0dffa61f0179e37$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f0dffa61f0179e37$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f0dffa61f0179e37$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f0dffa61f0179e37$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f0dffa61f0179e37$export$2e2bcd8739ae039 = {
    __extends: $f0dffa61f0179e37$export$a8ba968b8961cb8a,
    __assign: $f0dffa61f0179e37$export$18ce0697a983be9b,
    __rest: $f0dffa61f0179e37$export$3c9a16f847548506,
    __decorate: $f0dffa61f0179e37$export$29e00dfd3077644b,
    __param: $f0dffa61f0179e37$export$d5ad3fd78186038f,
    __metadata: $f0dffa61f0179e37$export$f1db080c865becb9,
    __awaiter: $f0dffa61f0179e37$export$1050f835b63b671e,
    __generator: $f0dffa61f0179e37$export$67ebef60e6f28a6,
    __createBinding: $f0dffa61f0179e37$export$45d3717a4c69092e,
    __exportStar: $f0dffa61f0179e37$export$f33643c0debef087,
    __values: $f0dffa61f0179e37$export$19a8beecd37a4c45,
    __read: $f0dffa61f0179e37$export$8d051b38c9118094,
    __spread: $f0dffa61f0179e37$export$afc72e2116322959,
    __spreadArrays: $f0dffa61f0179e37$export$6388937ca91ccae8,
    __spreadArray: $f0dffa61f0179e37$export$1216008129fb82ed,
    __await: $f0dffa61f0179e37$export$10c90e4f7922046c,
    __asyncGenerator: $f0dffa61f0179e37$export$e427f37a30a4de9b,
    __asyncDelegator: $f0dffa61f0179e37$export$bbd80228419bb833,
    __asyncValues: $f0dffa61f0179e37$export$e3b29a3d6162315f,
    __makeTemplateObject: $f0dffa61f0179e37$export$4fb47efe1390b86f,
    __importStar: $f0dffa61f0179e37$export$c21735bcef00d192,
    __importDefault: $f0dffa61f0179e37$export$da59b14a69baef04,
    __classPrivateFieldGet: $f0dffa61f0179e37$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f0dffa61f0179e37$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f0dffa61f0179e37$export$81fdc39f203e4e04,
    __addDisposableResource: $f0dffa61f0179e37$export$88ac25d8e944e405,
    __disposeResources: $f0dffa61f0179e37$export$8f076105dc360e92
};

});

parcelRequire.register("kxHuf", function(module, exports) {

$parcel$export(module.exports, "detectAnimationFromOptions", function () { return $ef489f509130348e$export$74df49bbebf8cb2c; });

var $l3tV7 = parcelRequire("l3tV7");

var $4TQdI = parcelRequire("4TQdI");

var $hYg6j = parcelRequire("hYg6j");
var $ef489f509130348e$var$types = {
    keyframes: (0, $4TQdI.keyframes),
    spring: (0, $l3tV7.spring),
    decay: (0, $hYg6j.decay)
};
function $ef489f509130348e$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $4TQdI.keyframes;
    else if ($ef489f509130348e$var$types[config.type]) return $ef489f509130348e$var$types[config.type];
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $4TQdI.keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $l3tV7.spring;
    return 0, $4TQdI.keyframes;
}

});
parcelRequire.register("l3tV7", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $f541164e0a4b6fe4$export$b36281d89752ae66; });

var $kGaDj = parcelRequire("kGaDj");

var $MNMKX = parcelRequire("MNMKX");
var $f541164e0a4b6fe4$var$durationKeys = [
    "duration",
    "bounce"
];
var $f541164e0a4b6fe4$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $f541164e0a4b6fe4$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $f541164e0a4b6fe4$var$getSpringOptions(options) {
    var springOptions = (0, $kGaDj.__assign)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$f541164e0a4b6fe4$var$isSpringType(options, $f541164e0a4b6fe4$var$physicsKeys) && $f541164e0a4b6fe4$var$isSpringType(options, $f541164e0a4b6fe4$var$durationKeys)) {
        var derived = (0, $MNMKX.findSpring)(options);
        springOptions = (0, $kGaDj.__assign)((0, $kGaDj.__assign)((0, $kGaDj.__assign)({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $f541164e0a4b6fe4$export$b36281d89752ae66(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = (0, $kGaDj.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    var state = {
        done: false,
        value: from
    };
    var _e = $f541164e0a4b6fe4$var$getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = $f541164e0a4b6fe4$var$zero;
    var resolveVelocity = $f541164e0a4b6fe4$var$zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
        if (dampingRatio < 1) {
            var angularFreq_1 = (0, $MNMKX.calcAngularFreq)(undampedAngularFreq, dampingRatio);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 * Math.sin(angularFreq_1 * t) + initialDelta * Math.cos(angularFreq_1 * t));
            };
            resolveVelocity = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 + initialDelta * Math.cos(angularFreq_1 * t)) - envelope * (Math.cos(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq_1 * initialDelta * Math.sin(angularFreq_1 * t));
            };
        } else if (dampingRatio === 1) resolveSpring = function(t) {
            return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq_1 * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq_1;
            };
        }
    }
    createSpring();
    return {
        next: function(t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function() {
            var _a;
            velocity = -velocity;
            _a = [
                to,
                from
            ], from = _a[0], to = _a[1];
            createSpring();
        }
    };
}
$f541164e0a4b6fe4$export$b36281d89752ae66.needsInterpolation = function(a, b) {
    return typeof a === "string" || typeof b === "string";
};
var $f541164e0a4b6fe4$var$zero = function(_t) {
    return 0;
};

});
parcelRequire.register("MNMKX", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $092b1a26c9da4ed7$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $092b1a26c9da4ed7$export$5f679887c3a78b15; });

var $hrQbS = parcelRequire("hrQbS");

var $giw6G = parcelRequire("giw6G");
var $092b1a26c9da4ed7$var$safeMin = 0.001;
var $092b1a26c9da4ed7$export$a3cdb76e84ee608e = 0.01;
var $092b1a26c9da4ed7$export$1824b851fad8862b = 10.0;
var $092b1a26c9da4ed7$export$ff08f2d53484465 = 0.05;
var $092b1a26c9da4ed7$export$201ca48e54038115 = 1;
function $092b1a26c9da4ed7$export$b15f158dc6d6f458(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    (0, $hrQbS.warning)(duration <= $092b1a26c9da4ed7$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = (0, $giw6G.clamp)($092b1a26c9da4ed7$export$ff08f2d53484465, $092b1a26c9da4ed7$export$201ca48e54038115, dampingRatio);
    duration = (0, $giw6G.clamp)($092b1a26c9da4ed7$export$a3cdb76e84ee608e, $092b1a26c9da4ed7$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $092b1a26c9da4ed7$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $092b1a26c9da4ed7$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $092b1a26c9da4ed7$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $092b1a26c9da4ed7$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$092b1a26c9da4ed7$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $092b1a26c9da4ed7$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $092b1a26c9da4ed7$var$rootIterations = 12;
function $092b1a26c9da4ed7$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $092b1a26c9da4ed7$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $092b1a26c9da4ed7$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});
parcelRequire.register("giw6G", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $bdd73b88d9e68e49$export$7d15b64cf5a3a4c4; });
var $bdd73b88d9e68e49$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    return Math.min(Math.max(v, min), max);
};

});



parcelRequire.register("4TQdI", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $3914ce4fe593eeaf$export$d25ddfdf17c3ad3e; });

var $9WSyX = parcelRequire("9WSyX");

var $7dfX1 = parcelRequire("7dfX1");
function $3914ce4fe593eeaf$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $7dfX1.easeInOut);
    }).splice(0, values.length - 1);
}
function $3914ce4fe593eeaf$export$24dbcec0b26e6d9d(values) {
    var numValues = values.length;
    return values.map(function(_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function $3914ce4fe593eeaf$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}
function $3914ce4fe593eeaf$export$d25ddfdf17c3ad3e(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
    var state = {
        done: false,
        value: from
    };
    var values = Array.isArray(to) ? to : [
        from,
        to
    ];
    var times = $3914ce4fe593eeaf$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $3914ce4fe593eeaf$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $9WSyX.interpolate)(times, values, {
            ease: Array.isArray(ease) ? ease : $3914ce4fe593eeaf$export$6b60b58e4ea7d715(values, ease)
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function(t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function() {
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

});
parcelRequire.register("9WSyX", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $73e3dadb6b966a20$export$89e29e4ab65e70a9; });

var $bJjZI = parcelRequire("bJjZI");

var $7CXds = parcelRequire("7CXds");

var $dlROr = parcelRequire("dlROr");

var $6LVYo = parcelRequire("6LVYo");

var $cSeSi = parcelRequire("cSeSi");

var $giw6G = parcelRequire("giw6G");

var $kdCPt = parcelRequire("kdCPt");

var $hrQbS = parcelRequire("hrQbS");
var $73e3dadb6b966a20$var$mixNumber = function(from, to) {
    return function(p) {
        return (0, $7CXds.mix)(from, to, p);
    };
};
function $73e3dadb6b966a20$var$detectMixerFactory(v) {
    if (typeof v === "number") return $73e3dadb6b966a20$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $cSeSi.color).test(v)) return 0, $dlROr.mixColor;
        else return 0, $6LVYo.mixComplex;
    } else if (Array.isArray(v)) return 0, $6LVYo.mixArray;
    else if (typeof v === "object") return 0, $6LVYo.mixObject;
}
function $73e3dadb6b966a20$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || $73e3dadb6b966a20$var$detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $kdCPt.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $73e3dadb6b966a20$var$fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function(v) {
        return mixer((0, $bJjZI.progress)(from, to, v));
    };
}
function $73e3dadb6b966a20$var$slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function(v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        var progressInRange = (0, $bJjZI.progress)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $73e3dadb6b966a20$export$89e29e4ab65e70a9(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    (0, $hrQbS.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $hrQbS.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = $73e3dadb6b966a20$var$createMixers(output, ease, mixer);
    var interpolator = inputLength === 2 ? $73e3dadb6b966a20$var$fastInterpolate(input, mixers) : $73e3dadb6b966a20$var$slowInterpolate(input, mixers);
    return isClamp ? function(v) {
        return interpolator((0, $giw6G.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

});
parcelRequire.register("bJjZI", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $88a36829e35f7638$export$504d7abb21fa8c9; });
var $88a36829e35f7638$export$504d7abb21fa8c9 = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRequire.register("7CXds", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $58da0419ce3ef2b4$export$2c9e8a9632a706b2; });
var $58da0419ce3ef2b4$export$2c9e8a9632a706b2 = function(from, to, progress) {
    return -progress * from + progress * to + from;
};

});

parcelRequire.register("dlROr", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $9b86fa9289211422$export$51e568cf5c039bac; });

var $kGaDj = parcelRequire("kGaDj");

var $7CXds = parcelRequire("7CXds");

var $8VIas = parcelRequire("8VIas");
var $8W1qk = parcelRequire("8W1qk");
var $56pMW = parcelRequire("56pMW");

var $hrQbS = parcelRequire("hrQbS");
var $9b86fa9289211422$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var $9b86fa9289211422$var$colorTypes = [
    (0, $8VIas.hex),
    (0, $56pMW.rgba),
    (0, $8W1qk.hsla)
];
var $9b86fa9289211422$var$getColorType = function(v) {
    return $9b86fa9289211422$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
var $9b86fa9289211422$var$notAnimatable = function(color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var $9b86fa9289211422$export$51e568cf5c039bac = function(from, to) {
    var fromColorType = $9b86fa9289211422$var$getColorType(from);
    var toColorType = $9b86fa9289211422$var$getColorType(to);
    (0, $hrQbS.invariant)(!!fromColorType, $9b86fa9289211422$var$notAnimatable(from));
    (0, $hrQbS.invariant)(!!toColorType, $9b86fa9289211422$var$notAnimatable(to));
    (0, $hrQbS.invariant)(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = (0, $kGaDj.__assign)({}, fromColor);
    var mixFunc = fromColorType === (0, $8W1qk.hsla) ? (0, $7CXds.mix) : $9b86fa9289211422$export$d4ecea248cce73c;
    return function(v) {
        for(var key in blended)if (key !== "alpha") blended[key] = mixFunc(fromColor[key], toColor[key], v);
        blended.alpha = (0, $7CXds.mix)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

});
parcelRequire.register("8VIas", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $6805e861bf35a19d$export$834dfc94dde4b3d8; });

var $56pMW = parcelRequire("56pMW");

var $7nJXk = parcelRequire("7nJXk");
function $6805e861bf35a19d$var$parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $6805e861bf35a19d$export$834dfc94dde4b3d8 = {
    test: (0, $7nJXk.isColorString)("#"),
    parse: $6805e861bf35a19d$var$parseHex,
    transform: (0, $56pMW.rgba).transform
};

});
parcelRequire.register("56pMW", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $3b718454491987ca$export$4e46ac54fc82cf3b; });

var $fmyED = parcelRequire("fmyED");

var $avOce = parcelRequire("avOce");

var $H3Eg8 = parcelRequire("H3Eg8");

var $7nJXk = parcelRequire("7nJXk");
var $3b718454491987ca$var$clampRgbUnit = (0, $H3Eg8.clamp)(0, 255);
var $3b718454491987ca$export$7a99c86b5b1f4c9e = (0, $fmyED.__assign)((0, $fmyED.__assign)({}, (0, $avOce.number)), {
    transform: function(v) {
        return Math.round($3b718454491987ca$var$clampRgbUnit(v));
    }
});
var $3b718454491987ca$export$4e46ac54fc82cf3b = {
    test: (0, $7nJXk.isColorString)("rgb", "red"),
    parse: (0, $7nJXk.splitColor)("red", "green", "blue"),
    transform: function(_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return "rgba(" + $3b718454491987ca$export$7a99c86b5b1f4c9e.transform(red) + ", " + $3b718454491987ca$export$7a99c86b5b1f4c9e.transform(green) + ", " + $3b718454491987ca$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $H3Eg8.sanitize)((0, $avOce.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRequire.register("7nJXk", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $55fe544238e0b0a0$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $55fe544238e0b0a0$export$73d6f35be992df24; });

var $H3Eg8 = parcelRequire("H3Eg8");
var $55fe544238e0b0a0$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean((0, $H3Eg8.isString)(v) && (0, $H3Eg8.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $55fe544238e0b0a0$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        var _a;
        if (!(0, $H3Eg8.isString)(v)) return v;
        var _b = v.match((0, $H3Eg8.floatRegex)), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
        return _a = {}, _a[aName] = parseFloat(a), _a[bName] = parseFloat(b), _a[cName] = parseFloat(c), _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1, _a;
    };
};

});



parcelRequire.register("8W1qk", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $6814d831eb6e998b$export$810b04175080204c; });

var $avOce = parcelRequire("avOce");

var $c1DuU = parcelRequire("c1DuU");

var $H3Eg8 = parcelRequire("H3Eg8");

var $7nJXk = parcelRequire("7nJXk");
var $6814d831eb6e998b$export$810b04175080204c = {
    test: (0, $7nJXk.isColorString)("hsl", "hue"),
    parse: (0, $7nJXk.splitColor)("hue", "saturation", "lightness"),
    transform: function(_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return "hsla(" + Math.round(hue) + ", " + (0, $c1DuU.percent).transform((0, $H3Eg8.sanitize)(saturation)) + ", " + (0, $c1DuU.percent).transform((0, $H3Eg8.sanitize)(lightness)) + ", " + (0, $H3Eg8.sanitize)((0, $avOce.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRequire.register("6LVYo", function(module, exports) {

$parcel$export(module.exports, "mixComplex", function () { return $4ee41a182ad1ca87$export$65516310a87d8205; });
$parcel$export(module.exports, "mixArray", function () { return $4ee41a182ad1ca87$export$3bbefa2f402845c4; });
$parcel$export(module.exports, "mixObject", function () { return $4ee41a182ad1ca87$export$ebc23b6840c51ba1; });

var $kGaDj = parcelRequire("kGaDj");

var $cSeSi = parcelRequire("cSeSi");
var $1tBsz = parcelRequire("1tBsz");

var $7CXds = parcelRequire("7CXds");

var $dlROr = parcelRequire("dlROr");

var $lpJWO = parcelRequire("lpJWO");

var $kdCPt = parcelRequire("kdCPt");

var $hrQbS = parcelRequire("hrQbS");
function $4ee41a182ad1ca87$var$getMixer(origin, target) {
    if ((0, $lpJWO.isNum)(origin)) return function(v) {
        return (0, $7CXds.mix)(origin, target, v);
    };
    else if ((0, $cSeSi.color).test(origin)) return (0, $dlROr.mixColor)(origin, target);
    else return $4ee41a182ad1ca87$export$65516310a87d8205(origin, target);
}
var $4ee41a182ad1ca87$export$3bbefa2f402845c4 = function(from, to) {
    var output = (0, $kGaDj.__spreadArray)([], from);
    var numValues = output.length;
    var blendValue = from.map(function(fromThis, i) {
        return $4ee41a182ad1ca87$var$getMixer(fromThis, to[i]);
    });
    return function(v) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
var $4ee41a182ad1ca87$export$ebc23b6840c51ba1 = function(origin, target) {
    var output = (0, $kGaDj.__assign)((0, $kGaDj.__assign)({}, origin), target);
    var blendValue = {};
    for(var key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $4ee41a182ad1ca87$var$getMixer(origin[key], target[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $4ee41a182ad1ca87$var$analyse(value) {
    var parsed = (0, $1tBsz.complex).parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for(var i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
var $4ee41a182ad1ca87$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $1tBsz.complex).createTransformer(target);
    var originStats = $4ee41a182ad1ca87$var$analyse(origin);
    var targetStats = $4ee41a182ad1ca87$var$analyse(target);
    (0, $hrQbS.invariant)(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return (0, $kdCPt.pipe)($4ee41a182ad1ca87$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
};

});
parcelRequire.register("cSeSi", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $95f61102339ba931$export$35e9368ef982300f; });

var $H3Eg8 = parcelRequire("H3Eg8");

var $8VIas = parcelRequire("8VIas");

var $8W1qk = parcelRequire("8W1qk");

var $56pMW = parcelRequire("56pMW");
var $95f61102339ba931$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $56pMW.rgba).test(v) || (0, $8VIas.hex).test(v) || (0, $8W1qk.hsla).test(v);
    },
    parse: function(v) {
        if ((0, $56pMW.rgba).test(v)) return (0, $56pMW.rgba).parse(v);
        else if ((0, $8W1qk.hsla).test(v)) return (0, $8W1qk.hsla).parse(v);
        else return (0, $8VIas.hex).parse(v);
    },
    transform: function(v) {
        return (0, $H3Eg8.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $56pMW.rgba).transform(v) : (0, $8W1qk.hsla).transform(v);
    }
};

});

parcelRequire.register("1tBsz", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $11358ea39c12a510$export$83a0e34f1302825b; });

var $cSeSi = parcelRequire("cSeSi");

var $avOce = parcelRequire("avOce");

var $H3Eg8 = parcelRequire("H3Eg8");
var $11358ea39c12a510$var$colorToken = "${c}";
var $11358ea39c12a510$var$numberToken = "${n}";
function $11358ea39c12a510$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $H3Eg8.isString)(v) && ((_b = (_a = v.match((0, $H3Eg8.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $H3Eg8.colorRegex))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $11358ea39c12a510$var$analyse(v) {
    var values = [];
    var numColors = 0;
    var colors = v.match((0, $H3Eg8.colorRegex));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $H3Eg8.colorRegex), $11358ea39c12a510$var$colorToken);
        values.push.apply(values, colors.map((0, $cSeSi.color).parse));
    }
    var numbers = v.match((0, $H3Eg8.floatRegex));
    if (numbers) {
        v = v.replace((0, $H3Eg8.floatRegex), $11358ea39c12a510$var$numberToken);
        values.push.apply(values, numbers.map((0, $avOce.number).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $11358ea39c12a510$var$parse(v) {
    return $11358ea39c12a510$var$analyse(v).values;
}
function $11358ea39c12a510$var$createTransformer(v) {
    var _a = $11358ea39c12a510$var$analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
    var numValues = values.length;
    return function(v) {
        var output = tokenised;
        for(var i = 0; i < numValues; i++)output = output.replace(i < numColors ? $11358ea39c12a510$var$colorToken : $11358ea39c12a510$var$numberToken, i < numColors ? (0, $cSeSi.color).transform(v[i]) : (0, $H3Eg8.sanitize)(v[i]));
        return output;
    };
}
var $11358ea39c12a510$var$convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : v;
};
function $11358ea39c12a510$var$getAnimatableNone(v) {
    var parsed = $11358ea39c12a510$var$parse(v);
    var transformer = $11358ea39c12a510$var$createTransformer(v);
    return transformer(parsed.map($11358ea39c12a510$var$convertNumbersToZero));
}
var $11358ea39c12a510$export$83a0e34f1302825b = {
    test: $11358ea39c12a510$var$test,
    parse: $11358ea39c12a510$var$parse,
    createTransformer: $11358ea39c12a510$var$createTransformer,
    getAnimatableNone: $11358ea39c12a510$var$getAnimatableNone
};

});

parcelRequire.register("lpJWO", function(module, exports) {

$parcel$export(module.exports, "isNum", function () { return $f96f92fb7ae42379$export$4e960b977ccfec97; });
var $f96f92fb7ae42379$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
var $f96f92fb7ae42379$export$4e960b977ccfec97 = function(v) {
    return typeof v === "number";
};

});



parcelRequire.register("7dfX1", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $54061eceb4c034f8$export$45db2fc2f15997e7; });
$parcel$export(module.exports, "easeIn", function () { return $54061eceb4c034f8$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $54061eceb4c034f8$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $54061eceb4c034f8$export$c07234257a03d5e9; });
$parcel$export(module.exports, "circIn", function () { return $54061eceb4c034f8$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $54061eceb4c034f8$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $54061eceb4c034f8$export$30d3455eee55bed5; });
$parcel$export(module.exports, "backIn", function () { return $54061eceb4c034f8$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $54061eceb4c034f8$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $54061eceb4c034f8$export$ddc5fd596f6c71b2; });
$parcel$export(module.exports, "anticipate", function () { return $54061eceb4c034f8$export$6b0af63b873d419e; });
$parcel$export(module.exports, "bounceOut", function () { return $54061eceb4c034f8$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceIn", function () { return $54061eceb4c034f8$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceInOut", function () { return $54061eceb4c034f8$export$41ad9e9849a703ce; });

var $2oBmN = parcelRequire("2oBmN");
var $54061eceb4c034f8$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var $54061eceb4c034f8$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var $54061eceb4c034f8$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var $54061eceb4c034f8$var$BOUNCE_THIRD_THRESHOLD = 0.9;
var $54061eceb4c034f8$export$45db2fc2f15997e7 = function(p) {
    return p;
};
var $54061eceb4c034f8$export$929e5a82286172a6 = (0, $2oBmN.createExpoIn)(2);
var $54061eceb4c034f8$export$57636bb43b1ccbb0 = (0, $2oBmN.reverseEasing)($54061eceb4c034f8$export$929e5a82286172a6);
var $54061eceb4c034f8$export$c07234257a03d5e9 = (0, $2oBmN.mirrorEasing)($54061eceb4c034f8$export$929e5a82286172a6);
var $54061eceb4c034f8$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $54061eceb4c034f8$export$c8d67a19199d1a50 = (0, $2oBmN.reverseEasing)($54061eceb4c034f8$export$e444123e42d03385);
var $54061eceb4c034f8$export$30d3455eee55bed5 = (0, $2oBmN.mirrorEasing)($54061eceb4c034f8$export$c8d67a19199d1a50);
var $54061eceb4c034f8$export$b01116c84cdfe1a2 = (0, $2oBmN.createBackIn)($54061eceb4c034f8$var$DEFAULT_OVERSHOOT_STRENGTH);
var $54061eceb4c034f8$export$77edfce482316a60 = (0, $2oBmN.reverseEasing)($54061eceb4c034f8$export$b01116c84cdfe1a2);
var $54061eceb4c034f8$export$ddc5fd596f6c71b2 = (0, $2oBmN.mirrorEasing)($54061eceb4c034f8$export$b01116c84cdfe1a2);
var $54061eceb4c034f8$export$6b0af63b873d419e = (0, $2oBmN.createAnticipate)($54061eceb4c034f8$var$DEFAULT_OVERSHOOT_STRENGTH);
var $54061eceb4c034f8$var$ca = 4356.0 / 361.0;
var $54061eceb4c034f8$var$cb = 35442.0 / 1805.0;
var $54061eceb4c034f8$var$cc = 16061.0 / 1805.0;
var $54061eceb4c034f8$export$cccc9e04465dce11 = function(p) {
    if (p === 1 || p === 0) return p;
    var p2 = p * p;
    return p < $54061eceb4c034f8$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $54061eceb4c034f8$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $54061eceb4c034f8$var$BOUNCE_THIRD_THRESHOLD ? $54061eceb4c034f8$var$ca * p2 - $54061eceb4c034f8$var$cb * p + $54061eceb4c034f8$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var $54061eceb4c034f8$export$fccebd7948554554 = (0, $2oBmN.reverseEasing)($54061eceb4c034f8$export$cccc9e04465dce11);
var $54061eceb4c034f8$export$41ad9e9849a703ce = function(p) {
    return p < 0.5 ? 0.5 * (1.0 - $54061eceb4c034f8$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $54061eceb4c034f8$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;
};

});
parcelRequire.register("2oBmN", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $1beacee9e5671609$export$2c07eeff45156d4d; });
$parcel$export(module.exports, "mirrorEasing", function () { return $1beacee9e5671609$export$f946554fb8aeaf0d; });
$parcel$export(module.exports, "createExpoIn", function () { return $1beacee9e5671609$export$c90c8c5a3c7a5e80; });
$parcel$export(module.exports, "createBackIn", function () { return $1beacee9e5671609$export$2a739ba6da1d1495; });
$parcel$export(module.exports, "createAnticipate", function () { return $1beacee9e5671609$export$222fa0be41d8b537; });
var $1beacee9e5671609$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};
var $1beacee9e5671609$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var $1beacee9e5671609$export$c90c8c5a3c7a5e80 = function(power) {
    return function(p) {
        return Math.pow(p, power);
    };
};
var $1beacee9e5671609$export$2a739ba6da1d1495 = function(power) {
    return function(p) {
        return p * p * ((power + 1) * p - power);
    };
};
var $1beacee9e5671609$export$222fa0be41d8b537 = function(power) {
    var backEasing = $1beacee9e5671609$export$2a739ba6da1d1495(power);
    return function(p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};

});



parcelRequire.register("hYg6j", function(module, exports) {

$parcel$export(module.exports, "decay", function () { return $d1548792cbf1eb87$export$e9341ba102272ab9; });
function $d1548792cbf1eb87$export$e9341ba102272ab9(_a) {
    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
    var state = {
        done: false,
        value: from
    };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: function(t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function() {}
    };
}

});


parcelRequire.register("lc1JK", function(module, exports) {

$parcel$export(module.exports, "loopElapsed", function () { return $f6dc10db521eb0c4$export$7d0784e050d8e25f; });
$parcel$export(module.exports, "reverseElapsed", function () { return $f6dc10db521eb0c4$export$ab9042754680126b; });
$parcel$export(module.exports, "hasRepeatDelayElapsed", function () { return $f6dc10db521eb0c4$export$c9c9437f9b8733b5; });
function $f6dc10db521eb0c4$export$7d0784e050d8e25f(elapsed, duration, delay) {
    if (delay === void 0) delay = 0;
    return elapsed - duration - delay;
}
function $f6dc10db521eb0c4$export$ab9042754680126b(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) delay = 0;
    if (isForwardPlayback === void 0) isForwardPlayback = true;
    return isForwardPlayback ? $f6dc10db521eb0c4$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $f6dc10db521eb0c4$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

});


parcelRequire.register("9TvJJ", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $7341de52bfbe4af6$export$ee3ff3a17106998; });

var $kGaDj = parcelRequire("kGaDj");

var $5yzf6 = parcelRequire("5yzf6");

var $9DinE = parcelRequire("9DinE");

var $7n4cL = parcelRequire("7n4cL");
function $7341de52bfbe4af6$export$ee3ff3a17106998(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $5yzf6.animate)((0, $kGaDj.__assign)((0, $kGaDj.__assign)({}, options), {
            driver: driver,
            onUpdate: function(v) {
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete
        }));
    }
    function startSpring(options) {
        startAnimation((0, $kGaDj.__assign)({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function(v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = (0, $9DinE.velocityPerSecond)(v - prev_1, (0, $7n4cL.getFrameData)().delta);
            if (heading_1 === 1 && v > boundary_1 || heading_1 === -1 && v < boundary_1) startSpring({
                from: v,
                to: boundary_1,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: function() {
            return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        }
    };
}

});
parcelRequire.register("9DinE", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $7036038836c8aad2$export$eab0632f7ad4f9d7; });
function $7036038836c8aad2$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRequire.register("3Ns70", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $2c3bc123ecf5d531$export$fc3e7e8557f8c8c7; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $2c3bc123ecf5d531$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};

});

parcelRequire.register("hTNOY", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $d07e3827c182cc65$export$ef97fe084f156ca4; });
$parcel$export(module.exports, "isEasingArray", function () { return $d07e3827c182cc65$export$216948827bbdc797; });

var $cA1Ck = parcelRequire("cA1Ck");

var $hrQbS = parcelRequire("hrQbS");

var $7dfX1 = parcelRequire("7dfX1");
var $wedLi = parcelRequire("wedLi");
var $d07e3827c182cc65$var$easingLookup = {
    linear: (0, $7dfX1.linear),
    easeIn: (0, $7dfX1.easeIn),
    easeInOut: (0, $7dfX1.easeInOut),
    easeOut: (0, $7dfX1.easeOut),
    circIn: (0, $7dfX1.circIn),
    circInOut: (0, $7dfX1.circInOut),
    circOut: (0, $7dfX1.circOut),
    backIn: (0, $7dfX1.backIn),
    backInOut: (0, $7dfX1.backInOut),
    backOut: (0, $7dfX1.backOut),
    anticipate: (0, $7dfX1.anticipate),
    bounceIn: (0, $7dfX1.bounceIn),
    bounceInOut: (0, $7dfX1.bounceInOut),
    bounceOut: (0, $7dfX1.bounceOut)
};
var $d07e3827c182cc65$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $hrQbS.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $cA1Ck.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $wedLi.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $hrQbS.invariant)($d07e3827c182cc65$var$easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return $d07e3827c182cc65$var$easingLookup[definition];
    }
    return definition;
};
var $d07e3827c182cc65$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});
parcelRequire.register("wedLi", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $060e0542de8f3d2c$export$2c575fa1d20488bd; });

var $7dfX1 = parcelRequire("7dfX1");
var $060e0542de8f3d2c$var$a = function(a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var $060e0542de8f3d2c$var$b = function(a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var $060e0542de8f3d2c$var$c = function(a1) {
    return 3.0 * a1;
};
var $060e0542de8f3d2c$var$calcBezier = function(t, a1, a2) {
    return (($060e0542de8f3d2c$var$a(a1, a2) * t + $060e0542de8f3d2c$var$b(a1, a2)) * t + $060e0542de8f3d2c$var$c(a1)) * t;
};
var $060e0542de8f3d2c$var$getSlope = function(t, a1, a2) {
    return 3.0 * $060e0542de8f3d2c$var$a(a1, a2) * t * t + 2.0 * $060e0542de8f3d2c$var$b(a1, a2) * t + $060e0542de8f3d2c$var$c(a1);
};
var $060e0542de8f3d2c$var$subdivisionPrecision = 0.0000001;
var $060e0542de8f3d2c$var$subdivisionMaxIterations = 10;
function $060e0542de8f3d2c$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $060e0542de8f3d2c$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $060e0542de8f3d2c$var$subdivisionPrecision && ++i < $060e0542de8f3d2c$var$subdivisionMaxIterations);
    return currentT;
}
var $060e0542de8f3d2c$var$newtonIterations = 8;
var $060e0542de8f3d2c$var$newtonMinSlope = 0.001;
function $060e0542de8f3d2c$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $060e0542de8f3d2c$var$newtonIterations; ++i){
        var currentSlope = $060e0542de8f3d2c$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $060e0542de8f3d2c$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var $060e0542de8f3d2c$var$kSplineTableSize = 11;
var $060e0542de8f3d2c$var$kSampleStepSize = 1.0 / ($060e0542de8f3d2c$var$kSplineTableSize - 1.0);
function $060e0542de8f3d2c$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $7dfX1.linear;
    var sampleValues = new Float32Array($060e0542de8f3d2c$var$kSplineTableSize);
    for(var i = 0; i < $060e0542de8f3d2c$var$kSplineTableSize; ++i)sampleValues[i] = $060e0542de8f3d2c$var$calcBezier(i * $060e0542de8f3d2c$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $060e0542de8f3d2c$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $060e0542de8f3d2c$var$kSampleStepSize;
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $060e0542de8f3d2c$var$kSampleStepSize;
        var initialSlope = $060e0542de8f3d2c$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $060e0542de8f3d2c$var$newtonMinSlope) return $060e0542de8f3d2c$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $060e0542de8f3d2c$var$binarySubdivide(aX, intervalStart, intervalStart + $060e0542de8f3d2c$var$kSampleStepSize, mX1, mX2);
    }
    return function(t) {
        return t === 0 || t === 1 ? t : $060e0542de8f3d2c$var$calcBezier(getTForX(t), mY1, mY2);
    };
}

});


parcelRequire.register("kg0xf", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $ebf5b78b13bea3f9$export$65676b58b122bc38; });

var $1tBsz = parcelRequire("1tBsz");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $ebf5b78b13bea3f9$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $1tBsz.complex).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRequire.register("jd5TW", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $dfc3cf19c3991db2$export$262124b154b9f1c0; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7L1pF = parcelRequire("7L1pF");
var $dfc3cf19c3991db2$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    };
};
var $dfc3cf19c3991db2$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restDelta: 0.01,
        restSpeed: 10
    };
};
var $dfc3cf19c3991db2$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $dfc3cf19c3991db2$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $dfc3cf19c3991db2$var$defaultTransitions = {
    x: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    y: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    z: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    rotate: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    rotateX: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    rotateY: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    rotateZ: $dfc3cf19c3991db2$export$2577c2184b2254d3,
    scaleX: $dfc3cf19c3991db2$export$a743142a31c132c,
    scaleY: $dfc3cf19c3991db2$export$a743142a31c132c,
    scale: $dfc3cf19c3991db2$export$a743142a31c132c,
    opacity: $dfc3cf19c3991db2$export$c2d663fbb86d66d6,
    backgroundColor: $dfc3cf19c3991db2$export$c2d663fbb86d66d6,
    color: $dfc3cf19c3991db2$export$c2d663fbb86d66d6,
    default: $dfc3cf19c3991db2$export$a743142a31c132c
};
var $dfc3cf19c3991db2$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $7L1pF.isKeyframesTarget)(to)) transitionFactory = $dfc3cf19c3991db2$var$keyframes;
    else transitionFactory = $dfc3cf19c3991db2$var$defaultTransitions[valueKey] || $dfc3cf19c3991db2$var$defaultTransitions.default;
    return (0, $cA1Ck.__assign)({
        to: to
    }, transitionFactory(to));
};

});

parcelRequire.register("lE419", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $fc20732e27e1068d$export$cea0cedcb94873b5; });

var $1tBsz = parcelRequire("1tBsz");
var $jwc9B = parcelRequire("jwc9B");

var $7qIRb = parcelRequire("7qIRb");
function $fc20732e27e1068d$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $7qIRb.getDefaultValueType)(key);
    if (defaultValueType !== (0, $jwc9B.filter)) defaultValueType = (0, $1tBsz.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

});
parcelRequire.register("jwc9B", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $e35a6ef858b80f36$export$3dea766d36a8935f; });

var $fmyED = parcelRequire("fmyED");

var $1tBsz = parcelRequire("1tBsz");

var $H3Eg8 = parcelRequire("H3Eg8");
var $e35a6ef858b80f36$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $e35a6ef858b80f36$var$applyDefaultFilter(v) {
    var _a = v.slice(0, -1).split("("), name = _a[0], value = _a[1];
    if (name === "drop-shadow") return v;
    var number = (value.match((0, $H3Eg8.floatRegex)) || [])[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = $e35a6ef858b80f36$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var $e35a6ef858b80f36$var$functionRegex = /([a-z-]*)\(.*?\)/g;
var $e35a6ef858b80f36$export$3dea766d36a8935f = (0, $fmyED.__assign)((0, $fmyED.__assign)({}, (0, $1tBsz.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match($e35a6ef858b80f36$var$functionRegex);
        return functions ? functions.map($e35a6ef858b80f36$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRequire.register("7qIRb", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $568dc1b72f16079e$export$67d1babe0338d23b; });

var $cA1Ck = parcelRequire("cA1Ck");

var $cSeSi = parcelRequire("cSeSi");
var $jwc9B = parcelRequire("jwc9B");

var $ddwKx = parcelRequire("ddwKx");
/**
 * A map of default value types for common values
 */ var $568dc1b72f16079e$export$98cd7c72c5a731fb = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, (0, $ddwKx.numberValueTypes)), {
    // Color props
    color: (0, $cSeSi.color),
    backgroundColor: (0, $cSeSi.color),
    outlineColor: (0, $cSeSi.color),
    fill: (0, $cSeSi.color),
    stroke: (0, $cSeSi.color),
    // Border props
    borderColor: (0, $cSeSi.color),
    borderTopColor: (0, $cSeSi.color),
    borderRightColor: (0, $cSeSi.color),
    borderBottomColor: (0, $cSeSi.color),
    borderLeftColor: (0, $cSeSi.color),
    filter: (0, $jwc9B.filter),
    WebkitFilter: (0, $jwc9B.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $568dc1b72f16079e$export$67d1babe0338d23b = function(key) {
    return $568dc1b72f16079e$export$98cd7c72c5a731fb[key];
};

});



parcelRequire.register("hktAr", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $c9db413a0aeb5e7c$export$1f61c53461aff4a5; });
$parcel$export(module.exports, "checkTargetForNewValues", function () { return $c9db413a0aeb5e7c$export$6afbed164019a54c; });
$parcel$export(module.exports, "getOrigin", function () { return $c9db413a0aeb5e7c$export$5a759dc7a1cfb72a; });

var $cA1Ck = parcelRequire("cA1Ck");

var $1tBsz = parcelRequire("1tBsz");

var $bpdHU = parcelRequire("bpdHU");

var $17KpK = parcelRequire("17KpK");

var $7cogK = parcelRequire("7cogK");

var $lE419 = parcelRequire("lE419");

var $jJ3ym = parcelRequire("jJ3ym");

var $5KrvS = parcelRequire("5KrvS");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $c9db413a0aeb5e7c$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $7cogK.motionValue)(value));
}
function $c9db413a0aeb5e7c$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $5KrvS.resolveVariant)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $cA1Ck.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $17KpK.resolveFinalValueInKeyframes)(target[key]);
        $c9db413a0aeb5e7c$var$setMotionValue(visualElement, key, value);
    }
}
function $c9db413a0aeb5e7c$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(variantLabels)).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $c9db413a0aeb5e7c$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $c9db413a0aeb5e7c$var$setVariants(child, variantLabels);
        });
    });
}
function $c9db413a0aeb5e7c$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $c9db413a0aeb5e7c$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $c9db413a0aeb5e7c$var$setVariants(visualElement, [
        definition
    ]);
    else $c9db413a0aeb5e7c$export$1f61c53461aff4a5(visualElement, definition);
}
function $c9db413a0aeb5e7c$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && (0, $bpdHU.isNumericalString)(value)) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $jJ3ym.findValueType)(value) && (0, $1tBsz.complex).test(targetValue)) value = (0, $lE419.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $7cogK.motionValue)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $c9db413a0aeb5e7c$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $c9db413a0aeb5e7c$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $c9db413a0aeb5e7c$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}

});
parcelRequire.register("bpdHU", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $84dca97545b81872$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $84dca97545b81872$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};

});

parcelRequire.register("7cogK", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $53dc7ac083387906$export$ce8bdc721e76545f; });

var $7n4cL = parcelRequire("7n4cL");

var $9DinE = parcelRequire("9DinE");

var $hvyCr = parcelRequire("hvyCr");
var $53dc7ac083387906$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $53dc7ac083387906$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $hvyCr.SubscriptionManager)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $hvyCr.SubscriptionManager)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $hvyCr.SubscriptionManager)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $7n4cL.getFrameData)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $7n4cL.default).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $7n4cL.default).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $53dc7ac083387906$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $9DinE.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
/**
 * @internal
 */ function $53dc7ac083387906$export$ce8bdc721e76545f(init) {
    return new $53dc7ac083387906$export$8cea36d14ee64562(init);
}

});
parcelRequire.register("hvyCr", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $cbf02f8a40bebac9$export$e7dff9482a5fd23c; });

var $8tZP2 = parcelRequire("8tZP2");
var $cbf02f8a40bebac9$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $8tZP2.addUniqueItem)(this.subscriptions, handler);
        return function() {
            return (0, $8tZP2.removeItem)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();

});
parcelRequire.register("8tZP2", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $62d0fcc4e25e83ca$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $62d0fcc4e25e83ca$export$fe2d9b4e03920b4c; });
function $62d0fcc4e25e83ca$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $62d0fcc4e25e83ca$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

});



parcelRequire.register("jJ3ym", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $e5c4f9df3d3cf73f$export$950e7e59ea1ffed7; });

var $cA1Ck = parcelRequire("cA1Ck");

var $cSeSi = parcelRequire("cSeSi");
var $1tBsz = parcelRequire("1tBsz");

var $gU1yc = parcelRequire("gU1yc");

var $jAnZ0 = parcelRequire("jAnZ0");
/**
 * A list of all ValueTypes
 */ var $e5c4f9df3d3cf73f$var$valueTypes = (0, $cA1Ck.__spreadArray)((0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)((0, $gU1yc.dimensionValueTypes))), [
    (0, $cSeSi.color),
    (0, $1tBsz.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $e5c4f9df3d3cf73f$export$950e7e59ea1ffed7 = function(v) {
    return $e5c4f9df3d3cf73f$var$valueTypes.find((0, $jAnZ0.testValueType)(v));
};

});
parcelRequire.register("gU1yc", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $c4e3143b6db1cd4d$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $c4e3143b6db1cd4d$export$eefdd52e3ccae428; });

var $c1DuU = parcelRequire("c1DuU");
var $avOce = parcelRequire("avOce");

var $jAnZ0 = parcelRequire("jAnZ0");

var $lVwkY = parcelRequire("lVwkY");
/**
 * A list of value types commonly used for dimensions
 */ var $c4e3143b6db1cd4d$export$d176691c1998a1f5 = [
    (0, $avOce.number),
    (0, $c1DuU.px),
    (0, $c1DuU.percent),
    (0, $c1DuU.degrees),
    (0, $c1DuU.vw),
    (0, $c1DuU.vh),
    (0, $lVwkY.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $c4e3143b6db1cd4d$export$eefdd52e3ccae428 = function(v) {
    return $c4e3143b6db1cd4d$export$d176691c1998a1f5.find((0, $jAnZ0.testValueType)(v));
};

});
parcelRequire.register("jAnZ0", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $e423fba7b163be33$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $e423fba7b163be33$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});

parcelRequire.register("lVwkY", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $ff6801593220a34f$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $ff6801593220a34f$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});







parcelRequire.register("2Txhq", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $21ba8890f9685f77$export$d7d5d435647ed5a0; });

var $japQ0 = parcelRequire("japQ0");

var $aN6tz = parcelRequire("aN6tz");

var $lOUEd = parcelRequire("lOUEd");
var $21ba8890f9685f77$export$d7d5d435647ed5a0 = {
    pan: (0, $lOUEd.makeRenderlessComponent)((0, $aN6tz.usePanGesture)),
    drag: (0, $lOUEd.makeRenderlessComponent)((0, $japQ0.useDrag))
};

});
parcelRequire.register("japQ0", function(module, exports) {

$parcel$export(module.exports, "useDrag", function () { return $df42fe5c28853def$export$7941f8aafa4b6021; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $kfwla = parcelRequire("kfwla");

var $5piJh = parcelRequire("5piJh");

var $5URq7 = parcelRequire("5URq7");
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $df42fe5c28853def$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var transformPagePoint = (0, $7fPBF.useContext)((0, $kfwla.MotionConfigContext)).transformPagePoint;
    var dragControls = (0, $5URq7.useConstant)(function() {
        return new (0, $5piJh.VisualElementDragControls)({
            visualElement: visualElement
        });
    });
    dragControls.setProps((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, props), {
        transformPagePoint: transformPagePoint
    }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $7fPBF.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls
    ]);
    // Mount the drag controls with the visualElement
    (0, $7fPBF.useEffect)(function() {
        return dragControls.mount(visualElement);
    }, []);
}

});
parcelRequire.register("5piJh", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $3efdd0d11da300b3$export$86bff71f18910307; });

var $cA1Ck = parcelRequire("cA1Ck");

var $hrQbS = parcelRequire("hrQbS");

var $7jkc2 = parcelRequire("7jkc2");

var $aRnpR = parcelRequire("aRnpR");

var $fPMQj = parcelRequire("fPMQj");

var $cxW7Z = parcelRequire("cxW7Z");

var $3FqxT = parcelRequire("3FqxT");

var $czpCm = parcelRequire("czpCm");

var $lfoD4 = parcelRequire("lfoD4");

var $fuMt1 = parcelRequire("fuMt1");

var $9zbbt = parcelRequire("9zbbt");

var $4Gk2R = parcelRequire("4Gk2R");

var $hDhYG = parcelRequire("hDhYG");

var $bRoOe = parcelRequire("bRoOe");

var $k2WUd = parcelRequire("k2WUd");

var $2twVH = parcelRequire("2twVH");

var $bJjZI = parcelRequire("bJjZI");

var $galdX = parcelRequire("galdX");

var $f8vBp = parcelRequire("f8vBp");

var $1Uuis = parcelRequire("1Uuis");

var $7n4cL = parcelRequire("7n4cL");
var $3efdd0d11da300b3$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ var $3efdd0d11da300b3$var$lastPointerEvent;
var $3efdd0d11da300b3$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */ this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */ this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */ this.constraints = false;
        /**
         * The per-axis resolved elastic values.
         *
         * @internal
         */ this.elastic = (0, $lfoD4.axisBox)();
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */ this.props = {};
        /**
         * @internal
         */ this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */ this.cursorProgress = {
            x: 0.5,
            y: 0.5
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */ this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        $3efdd0d11da300b3$export$f0a15892c27dc07c.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */ VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        var onSessionStart = function(event) {
            var _a;
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */ var initialPoint = (0, $czpCm.getViewportPointFromEvent)(event).point;
            (_a = _this.cancelLayout) === null || _a === void 0 || _a.call(_this);
            _this.cancelLayout = (0, $1Uuis.batchLayout)(function(read, write) {
                var ancestors = (0, $2twVH.collectProjectingAncestors)(_this.visualElement);
                var children = (0, $2twVH.collectProjectingChildren)(_this.visualElement);
                var tree = (0, $cA1Ck.__spreadArray)((0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(ancestors)), (0, $cA1Ck.__read)(children));
                var hasManuallySetCursorOrigin = false;
                /**
                 * Apply a simple lock to the projection target. This ensures no animations
                 * can run on the projection box while this lock is active.
                 */ _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                write(function() {
                    tree.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    (0, $2twVH.updateLayoutMeasurement)(_this.visualElement);
                    children.forEach((0, $2twVH.updateLayoutMeasurement));
                });
                write(function() {
                    tree.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    if (snapToCursor) hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                });
                read(function() {
                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                    if (!isRelativeDrag) _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                    _this.visualElement.scheduleUpdateLayoutProjection();
                    /**
                     * When dragging starts, we want to find where the cursor is relative to the bounding box
                     * of the element. Every frame, we calculate a new bounding box using this relative position
                     * and let the visualElement renderer figure out how to reproject the element into this bounding
                     * box.
                     *
                     * By doing it this way, rather than applying an x/y transform directly to the element,
                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
                     * if the DOM element itself changes layout as a result of React updates the user might
                     * make based on the drag position.
                     */ var projection = _this.visualElement.projection;
                    (0, $fuMt1.eachAxis)(function(axis) {
                        if (!hasManuallySetCursorOrigin) {
                            var _a = projection.target[axis], min = _a.min, max = _a.max;
                            _this.cursorProgress[axis] = cursorProgress ? cursorProgress[axis] : (0, $bJjZI.progress)(min, max, initialPoint[axis]);
                        }
                        /**
                         * If we have external drag MotionValues, record their origin point. On pointermove
                         * we'll apply the pan gesture offset directly to this value.
                         */ var axisValue = _this.getAxisMotionValue(axis);
                        if (axisValue) _this.originPoint[axis] = axisValue.get();
                    });
                });
                write(function() {
                    (0, $7n4cL.flushSync).update();
                    (0, $7n4cL.flushSync).preRender();
                    (0, $7n4cL.flushSync).render();
                    (0, $7n4cL.flushSync).postRender();
                });
                read(function() {
                    return _this.resolveDragConstraints();
                });
            });
        };
        var onStart = function(event, info) {
            var _a, _b, _c;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $aRnpR.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            (0, $1Uuis.flushLayout)();
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 || _b.call(_a, event, info);
            (_c = _this.visualElement.animationState) === null || _c === void 0 || _c.setActive((0, $k2WUd.AnimationType).Drag, true);
        };
        var onMove = function(event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $3efdd0d11da300b3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 || _b.call(_a, _this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 || _d.call(_c, event, info);
            // Update the last pointer event
            $3efdd0d11da300b3$var$lastPointerEvent = event;
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new (0, $7jkc2.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: transformPagePoint
        });
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function() {
        var _this = this;
        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = this.visualElement.getLayoutState().layoutCorrected;
        if (dragConstraints) this.constraints = (0, $fPMQj.isRefObject)(dragConstraints) ? this.resolveRefConstraints(layout, dragConstraints) : (0, $9zbbt.calcRelativeConstraints)(layout, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $9zbbt.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (this.constraints && !this.hasMutatedConstraints) (0, $fuMt1.eachAxis)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $9zbbt.rebaseAxisConstraints)(layout[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function(layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        (0, $hrQbS.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = (0, $4Gk2R.getBoundingBox)(constraintsElement, transformPagePoint);
        var measuredConstraints = (0, $9zbbt.calcViewportConstraints)(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $lfoD4.convertAxisBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $lfoD4.convertBoundingBoxToAxisBox)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function() {
        var _a, _b;
        this.visualElement.unlockProjectionTarget();
        (_a = this.cancelLayout) === null || _a === void 0 || _a.call(this);
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $k2WUd.AnimationType).Drag, false);
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var _a, _b, _c;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 || _c.call(_b, event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        return (0, $fuMt1.eachAxis)(function(axis) {
            var drag = _this.props.drag;
            // If we're not dragging this axis, do an early return.
            if (!$3efdd0d11da300b3$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var box = _this.visualElement.getLayoutState().layout;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            } else {
                _this.cursorProgress[axis] = 0.5;
                return true;
            }
        }).includes(true);
    };
    /**
     * Update the specified axis with the latest pointer information.
     */ VisualElementDragControls.prototype.updateAxis = function(axis, point, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!$3efdd0d11da300b3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        return this.getAxisMotionValue(axis) ? this.updateAxisMotionValue(axis, offset) : this.updateVisualElementAxis(axis, point);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function(axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue) return;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints ? (0, $9zbbt.applyConstraints)(nextValue, this.constraints[axis], this.elastic[axis]) : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function(axis, point) {
        var _a;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.getLayoutState().layout[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = (0, $9zbbt.calcConstrainedMinPoint)(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.setProps = function(_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? (0, $9zbbt.defaultElastic) : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = (0, $cA1Ck.__rest)(_a, [
            "drag",
            "dragDirectionLock",
            "dragPropagation",
            "dragConstraints",
            "dragElastic",
            "dragMomentum"
        ]);
        this.props = (0, $cA1Ck.__assign)({
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) return this.props[dragKey];
        else if (!layout && layoutId === undefined) return this.visualElement.getValue(axis, 0);
    };
    VisualElementDragControls.prototype.isLayoutDrag = function() {
        return !this.getAxisMotionValue("x");
    };
    VisualElementDragControls.prototype.isExternalDrag = function() {
        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
        return _dragX || _dragY;
    };
    VisualElementDragControls.prototype.animateDragEnd = function(velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        /**
         * Everything beyond the drag gesture should be performed with
         * relative projection so children stay in sync with their parent element.
         */ var isRelative = (0, $galdX.convertToRelativeProjection)(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
        /**
         * If we had previously resolved constraints relative to the viewport,
         * we need to also convert those to a relative coordinate space for the animation
         */ var constraints = this.constraints || {};
        if (isRelative && Object.keys(constraints).length && this.isLayoutDrag()) {
            var projectionParent = this.visualElement.getProjectionParent();
            if (projectionParent) {
                var relativeConstraints_1 = (0, $f8vBp.calcRelativeOffset)(projectionParent.projection.targetFinal, constraints);
                (0, $fuMt1.eachAxis)(function(axis) {
                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                    constraints[axis] = {
                        min: isNaN(min) ? undefined : min,
                        max: isNaN(max) ? undefined : max
                    };
                });
            }
        }
        var momentumAnimations = (0, $fuMt1.eachAxis)(function(axis) {
            var _a;
            if (!$3efdd0d11da300b3$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis) ? _this.startAxisValueAnimation(axis, inertia) : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function() {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 || _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function() {
        var _this = this;
        (0, $fuMt1.eachAxis)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue ? axisValue.stop() : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue) return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return (0, $bRoOe.startAnimation)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function() {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!(0, $fPMQj.isRefObject)(dragConstraints) || !this.constraintsBox) return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $fuMt1.eachAxis)(function(axis) {
            boxProgress[axis] = (0, $hDhYG.calcOrigin)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */ this.updateConstraints(function() {
            (0, $fuMt1.eachAxis)(function(axis) {
                if (!$3efdd0d11da300b3$var$shouldDrag(axis, drag, null)) return;
                // Calculate the position of the targetBox relative to the constraintsBox using the
                // previously calculated progress
                var _a = (0, $9zbbt.calcPositionFromProgress)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                _this.visualElement.setProjectionTargetAxis(axis, min, max);
            });
        });
        /**
         * If any other draggable components are queuing the same tasks synchronously
         * this will wait until they've all been scheduled before flushing.
         */ setTimeout((0, $1Uuis.flushLayout), 1);
    };
    VisualElementDragControls.prototype.updateConstraints = function(onReady) {
        var _this = this;
        this.cancelLayout = (0, $1Uuis.batchLayout)(function(read, write) {
            var ancestors = (0, $2twVH.collectProjectingAncestors)(_this.visualElement);
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.resetTransform();
                });
            });
            read(function() {
                return (0, $2twVH.updateLayoutMeasurement)(_this.visualElement);
            });
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.restoreTransform();
                });
            });
            read(function() {
                _this.resolveDragConstraints();
            });
            if (onReady) write(onReady);
        });
    };
    VisualElementDragControls.prototype.mount = function(visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $cxW7Z.addPointerEvent)(element, "pointerdown", function(event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $3FqxT.addDomEvent)(window, "resize", function() {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */ var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function() {
            if (_this.isDragging) _this.resolveDragConstraints();
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */ var prevDragCursor = visualElement.prevDragCursor;
        if (prevDragCursor) this.start($3efdd0d11da300b3$var$lastPointerEvent, {
            cursorProgress: prevDragCursor
        });
        /**
         * Return a function that will teardown the drag gesture
         */ return function() {
            stopPointerListener === null || stopPointerListener === void 0 || stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 || stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}();
function $3efdd0d11da300b3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $3efdd0d11da300b3$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRequire.register("7jkc2", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $5529f8ae9fc48be3$export$d9c66232c9c4689c; });

var $cA1Ck = parcelRequire("cA1Ck");

var $c23GA = parcelRequire("c23GA");

var $czpCm = parcelRequire("czpCm");

var $7n4cL = parcelRequire("7n4cL");

var $3Ns70 = parcelRequire("3Ns70");

var $cxW7Z = parcelRequire("cxW7Z");

var $gPf6m = parcelRequire("gPf6m");
var $kdCPt = parcelRequire("kdCPt");
/**
 * @internal
 */ var $5529f8ae9fc48be3$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $5529f8ae9fc48be3$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $gPf6m.distance)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $7n4cL.getFrameData)().timestamp;
            _this.history.push((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $5529f8ae9fc48be3$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $c23GA.isMouseEvent)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $7n4cL.default).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $5529f8ae9fc48be3$var$getPanInfo($5529f8ae9fc48be3$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $c23GA.isTouchEvent)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $czpCm.extractEventInfo)(event);
        var initialInfo = $5529f8ae9fc48be3$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $7n4cL.getFrameData)().timestamp;
        this.history = [
            (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $5529f8ae9fc48be3$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $kdCPt.pipe)((0, $cxW7Z.addPointerEvent)(window, "pointermove", this.handlePointerMove), (0, $cxW7Z.addPointerEvent)(window, "pointerup", this.handlePointerUp), (0, $cxW7Z.addPointerEvent)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $7n4cL.cancelSync).update(this.updatePoint);
    };
    return PanSession;
}();
function $5529f8ae9fc48be3$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $5529f8ae9fc48be3$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $5529f8ae9fc48be3$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $5529f8ae9fc48be3$var$subtractPoint(point, $5529f8ae9fc48be3$var$lastDevicePoint(history)),
        offset: $5529f8ae9fc48be3$var$subtractPoint(point, $5529f8ae9fc48be3$var$startDevicePoint(history)),
        velocity: $5529f8ae9fc48be3$var$getVelocity(history, 0.1)
    };
}
function $5529f8ae9fc48be3$var$startDevicePoint(history) {
    return history[0];
}
function $5529f8ae9fc48be3$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $5529f8ae9fc48be3$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $5529f8ae9fc48be3$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $3Ns70.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRequire.register("gPf6m", function(module, exports) {

$parcel$export(module.exports, "distance", function () { return $c3fd1f99c90d61fb$export$9f17032d917177de; });

var $NSJ7f = parcelRequire("NSJ7f");

var $1Qftx = parcelRequire("1Qftx");

var $lpJWO = parcelRequire("lpJWO");
var $c3fd1f99c90d61fb$var$distance1D = function(a, b) {
    return Math.abs(a - b);
};
function $c3fd1f99c90d61fb$export$9f17032d917177de(a, b) {
    if ((0, $lpJWO.isNum)(a) && (0, $lpJWO.isNum)(b)) return $c3fd1f99c90d61fb$var$distance1D(a, b);
    else if ((0, $NSJ7f.isPoint)(a) && (0, $NSJ7f.isPoint)(b)) {
        var xDelta = $c3fd1f99c90d61fb$var$distance1D(a.x, b.x);
        var yDelta = $c3fd1f99c90d61fb$var$distance1D(a.y, b.y);
        var zDelta = (0, $1Qftx.isPoint3D)(a) && (0, $1Qftx.isPoint3D)(b) ? $c3fd1f99c90d61fb$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

});
parcelRequire.register("NSJ7f", function(module, exports) {

$parcel$export(module.exports, "isPoint", function () { return $095f074bd34f53a6$export$aff838a5553f2a92; });
var $095f074bd34f53a6$export$aff838a5553f2a92 = function(point) {
    return point.hasOwnProperty("x") && point.hasOwnProperty("y");
};

});

parcelRequire.register("1Qftx", function(module, exports) {

$parcel$export(module.exports, "isPoint3D", function () { return $1576a6dd05206e5e$export$319d74662aaa2966; });

var $NSJ7f = parcelRequire("NSJ7f");
var $1576a6dd05206e5e$export$319d74662aaa2966 = function(point) {
    return (0, $NSJ7f.isPoint)(point) && point.hasOwnProperty("z");
};

});



parcelRequire.register("fuMt1", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $b47f40ea2ed27f3c$export$b789de563eb43b1; });
// Call a handler once for each axis
function $b47f40ea2ed27f3c$export$b789de563eb43b1(handler) {
    return [
        handler("x"),
        handler("y")
    ];
}

});

parcelRequire.register("9zbbt", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $6f700eddbe978da9$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcConstrainedMinPoint", function () { return $6f700eddbe978da9$export$365d4f5bee5334d2; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $6f700eddbe978da9$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $6f700eddbe978da9$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcPositionFromProgress", function () { return $6f700eddbe978da9$export$c24202d5faacd1d9; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $6f700eddbe978da9$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $6f700eddbe978da9$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $6f700eddbe978da9$export$7c5eaef8f4723d22; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7CXds = parcelRequire("7CXds");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $6f700eddbe978da9$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $7CXds.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $7CXds.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */ function $6f700eddbe978da9$export$365d4f5bee5334d2(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? $6f700eddbe978da9$export$b3c764d3fca3ffe3(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $6f700eddbe978da9$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $6f700eddbe978da9$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $6f700eddbe978da9$export$690c180aa5775042(layoutBox.x, left, right),
        y: $6f700eddbe978da9$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $6f700eddbe978da9$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $cA1Ck.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $6f700eddbe978da9$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $6f700eddbe978da9$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $6f700eddbe978da9$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */ function $6f700eddbe978da9$export$c24202d5faacd1d9(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = (0, $7CXds.mix)(constraints.min, constraints.max - axisLength, progress);
    return {
        min: min,
        max: min + axisLength
    };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $6f700eddbe978da9$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $6f700eddbe978da9$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $6f700eddbe978da9$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $6f700eddbe978da9$export$a3366d3bac43a742;
    return {
        x: $6f700eddbe978da9$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $6f700eddbe978da9$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $6f700eddbe978da9$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $6f700eddbe978da9$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $6f700eddbe978da9$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $6f700eddbe978da9$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

});

parcelRequire.register("4Gk2R", function(module, exports) {

$parcel$export(module.exports, "getBoundingBox", function () { return $368aa23a42f1166d$export$895c5e634403eaa7; });

var $lfoD4 = parcelRequire("lfoD4");
/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */ function $368aa23a42f1166d$export$895c5e634403eaa7(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return (0, $lfoD4.convertBoundingBoxToAxisBox)((0, $lfoD4.transformBoundingBox)(box, transformPagePoint));
}

});

parcelRequire.register("hDhYG", function(module, exports) {

$parcel$export(module.exports, "calcOrigin", function () { return $cd6406311af01cb5$export$13abbfca044ca46d; });
$parcel$export(module.exports, "updateBoxDelta", function () { return $cd6406311af01cb5$export$1435a2beec546d2e; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $cd6406311af01cb5$export$426154f9d100f99; });

var $giw6G = parcelRequire("giw6G");
var $gPf6m = parcelRequire("gPf6m");
var $7CXds = parcelRequire("7CXds");
var $bJjZI = parcelRequire("bJjZI");
var $cd6406311af01cb5$var$clampProgress = function(v) {
    return (0, $giw6G.clamp)(0, 1, v);
};
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */ function $cd6406311af01cb5$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $gPf6m.distance)(value, target) < maxDistance;
}
function $cd6406311af01cb5$var$calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $cd6406311af01cb5$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = $cd6406311af01cb5$var$calcLength(source);
    var targetLength = $cd6406311af01cb5$var$calcLength(target);
    if (targetLength > sourceLength) origin = (0, $bJjZI.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $bJjZI.progress)(source.min, source.max - targetLength, target.min);
    return $cd6406311af01cb5$var$clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $cd6406311af01cb5$export$acf2fd1e22884f56(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $7CXds.mix)(source.min, source.max, delta.origin);
    delta.scale = $cd6406311af01cb5$var$calcLength(target) / $cd6406311af01cb5$var$calcLength(source);
    if ($cd6406311af01cb5$export$28d0384c4b79bde2(delta.scale, 1, 0.0001)) delta.scale = 1;
    delta.translate = (0, $7CXds.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($cd6406311af01cb5$export$28d0384c4b79bde2(delta.translate)) delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $cd6406311af01cb5$export$1435a2beec546d2e(delta, source, target, origin) {
    $cd6406311af01cb5$export$acf2fd1e22884f56(delta.x, source.x, target.x, $cd6406311af01cb5$var$defaultOrigin(origin.originX));
    $cd6406311af01cb5$export$acf2fd1e22884f56(delta.y, source.y, target.y, $cd6406311af01cb5$var$defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */ function $cd6406311af01cb5$var$defaultOrigin(origin) {
    return typeof origin === "number" ? origin : 0.5;
}
function $cd6406311af01cb5$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $cd6406311af01cb5$var$calcLength(relative);
}
function $cd6406311af01cb5$export$426154f9d100f99(projection, parentProjection) {
    $cd6406311af01cb5$export$cabef5b392704b41(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
    $cd6406311af01cb5$export$cabef5b392704b41(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}

});

parcelRequire.register("galdX", function(module, exports) {

$parcel$export(module.exports, "convertToRelativeProjection", function () { return $bc4e0b2b59f68b75$export$69bccedc5101c4d1; });

var $f8vBp = parcelRequire("f8vBp");

var $fuMt1 = parcelRequire("fuMt1");

var $hoJOf = parcelRequire("hoJOf");
/**
 * Returns a boolean stating whether or not we converted the projection
 * to relative projection.
 */ function $bc4e0b2b59f68b75$export$69bccedc5101c4d1(visualElement, isLayoutDrag) {
    if (isLayoutDrag === void 0) isLayoutDrag = true;
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) return false;
    var offset;
    if (isLayoutDrag) {
        offset = (0, $f8vBp.calcRelativeOffset)(projectionParent.projection.target, visualElement.projection.target);
        (0, $hoJOf.removeBoxTransforms)(offset, projectionParent.getLatestValues());
    } else offset = (0, $f8vBp.calcRelativeOffset)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $fuMt1.eachAxis)(function(axis) {
        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
    });
    return true;
}

});
parcelRequire.register("f8vBp", function(module, exports) {

$parcel$export(module.exports, "tweenAxis", function () { return $02d8007b9ea684e4$export$21d180ad0c0013cb; });
$parcel$export(module.exports, "calcRelativeOffset", function () { return $02d8007b9ea684e4$export$5d8b2d12fde0857a; });
$parcel$export(module.exports, "checkIfParentHasChanged", function () { return $02d8007b9ea684e4$export$d1cc994fa3b9d457; });

var $7CXds = parcelRequire("7CXds");
function $02d8007b9ea684e4$export$21d180ad0c0013cb(target, prev, next, p) {
    target.min = (0, $7CXds.mix)(prev.min, next.min, p);
    target.max = (0, $7CXds.mix)(prev.max, next.max, p);
}
function $02d8007b9ea684e4$export$58fa21d412109d6b(parent, child) {
    return {
        min: child.min - parent.min,
        max: child.max - parent.min
    };
}
function $02d8007b9ea684e4$export$5d8b2d12fde0857a(parent, child) {
    return {
        x: $02d8007b9ea684e4$export$58fa21d412109d6b(parent.x, child.x),
        y: $02d8007b9ea684e4$export$58fa21d412109d6b(parent.y, child.y)
    };
}
function $02d8007b9ea684e4$export$d1cc994fa3b9d457(prev, next) {
    var prevId = prev.getLayoutId();
    var nextId = next.getLayoutId();
    return prevId !== nextId || nextId === undefined && prev !== next;
}

});

parcelRequire.register("hoJOf", function(module, exports) {

$parcel$export(module.exports, "resetBox", function () { return $caa83659a980641d$export$d7ad1d43f7ab13a6; });
$parcel$export(module.exports, "applyBoxTransforms", function () { return $caa83659a980641d$export$c8fdd2c80d7384dd; });
$parcel$export(module.exports, "removeBoxTransforms", function () { return $caa83659a980641d$export$73e1ad0a9694e25c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $caa83659a980641d$export$e2a980535c55eabb; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7CXds = parcelRequire("7CXds");

var $azcC7 = parcelRequire("azcC7");
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $caa83659a980641d$export$ab0da4c5058aa6e9(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $caa83659a980641d$export$d7ad1d43f7ab13a6(box, originBox) {
    $caa83659a980641d$export$ab0da4c5058aa6e9(box.x, originBox.x);
    $caa83659a980641d$export$ab0da4c5058aa6e9(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */ function $caa83659a980641d$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $caa83659a980641d$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $caa83659a980641d$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $caa83659a980641d$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $caa83659a980641d$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $caa83659a980641d$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $caa83659a980641d$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $caa83659a980641d$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $caa83659a980641d$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $caa83659a980641d$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $caa83659a980641d$export$fe9134d4e4502d7e(final, axis, transforms, _a) {
    var _b = (0, $cA1Ck.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $7CXds.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $caa83659a980641d$export$e8e3a712e9ebf422(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $caa83659a980641d$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $caa83659a980641d$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $caa83659a980641d$export$c8fdd2c80d7384dd(finalBox, box, transforms) {
    $caa83659a980641d$export$fe9134d4e4502d7e(finalBox.x, box.x, transforms, $caa83659a980641d$var$xKeys);
    $caa83659a980641d$export$fe9134d4e4502d7e(finalBox.y, box.y, transforms, $caa83659a980641d$var$yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $caa83659a980641d$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = $caa83659a980641d$export$2290ec7febe36dd6(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = $caa83659a980641d$export$2290ec7febe36dd6(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $caa83659a980641d$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    var originPoint = (0, $7CXds.mix)(axis.min, axis.max, origin) - translate;
    axis.min = $caa83659a980641d$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $caa83659a980641d$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $caa83659a980641d$export$42b76f1d0d16d5b(axis, transforms, _a) {
    var _b = (0, $cA1Ck.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $caa83659a980641d$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $caa83659a980641d$export$73e1ad0a9694e25c(box, transforms) {
    $caa83659a980641d$export$42b76f1d0d16d5b(box.x, transforms, $caa83659a980641d$var$xKeys);
    $caa83659a980641d$export$42b76f1d0d16d5b(box.y, transforms, $caa83659a980641d$var$yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $caa83659a980641d$export$e2a980535c55eabb(box, treeScale, treePath) {
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.getLayoutState().delta;
        // Incoporate each ancestor's scale into a culmulative treeScale for this component
        treeScale.x *= delta.x.scale;
        treeScale.y *= delta.y.scale;
        // Apply each ancestor's calculated delta into this component's recorded layout box
        $caa83659a980641d$export$d80074982803af5c(box, delta);
        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
        if ((0, $azcC7.isDraggable)(node)) $caa83659a980641d$export$c8fdd2c80d7384dd(box, box, node.getLatestValues());
    }
}

});
parcelRequire.register("azcC7", function(module, exports) {

$parcel$export(module.exports, "isDraggable", function () { return $7b16f51785a420c3$export$fe8f97248bbe2d04; });
function $7b16f51785a420c3$export$fe8f97248bbe2d04(visualElement) {
    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
    return drag && !_dragX;
}

});





parcelRequire.register("aN6tz", function(module, exports) {

$parcel$export(module.exports, "usePanGesture", function () { return $7db380f613e22a0a$export$eb0f62174cac1aec; });

var $7fPBF = parcelRequire("7fPBF");

var $kfwla = parcelRequire("kfwla");

var $8ANN9 = parcelRequire("8ANN9");

var $cxW7Z = parcelRequire("cxW7Z");

var $7jkc2 = parcelRequire("7jkc2");
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $7db380f613e22a0a$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $7fPBF.useRef)(null);
    var transformPagePoint = (0, $7fPBF.useContext)((0, $kfwla.MotionConfigContext)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $7fPBF.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $7jkc2.PanSession)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $cxW7Z.usePointerEvent)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $8ANN9.useUnmountEffect)(function() {
        return panSession.current && panSession.current.end();
    });
}

});


parcelRequire.register("gdtmI", function(module, exports) {

$parcel$export(module.exports, "layoutAnimations", function () { return $bce4a391927d666b$export$eb704cf7366aa18a; });

var $gjRAB = parcelRequire("gjRAB");

var $bFIkO = parcelRequire("bFIkO");
var $bce4a391927d666b$export$eb704cf7366aa18a = {
    measureLayout: (0, $bFIkO.MeasureContextProvider),
    layoutAnimation: (0, $gjRAB.AnimateLayoutContextProvider)
};

});
parcelRequire.register("gjRAB", function(module, exports) {

$parcel$export(module.exports, "AnimateLayoutContextProvider", function () { return $be17fd6ad2f3a114$export$bd44d4206e0b4eca; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $fuMt1 = parcelRequire("fuMt1");

var $bRoOe = parcelRequire("bRoOe");

var $f8vBp = parcelRequire("f8vBp");

var $4ZkPk = parcelRequire("4ZkPk");

var $iesfz = parcelRequire("iesfz");

var $lfoD4 = parcelRequire("lfoD4");

var $jVB6R = parcelRequire("jVB6R");

var $cQ083 = parcelRequire("cQ083");
var $be17fd6ad2f3a114$var$progressTarget = 1000;
var $be17fd6ad2f3a114$var$Animate = /** @class */ function(_super) {
    (0, $cA1Ck.__extends)(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable object that tracks the target viewport box
         * for the current animation frame.
         */ _this.frameTarget = (0, $lfoD4.axisBox)();
        /**
         * The current animation target, we use this to check whether to start
         * a new animation or continue the existing one.
         */ _this.currentAnimationTarget = (0, $lfoD4.axisBox)();
        /**
         * Track whether we're animating this axis.
         */ _this.isAnimating = {
            x: false,
            y: false
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined
        };
        _this.isAnimatingTree = false;
        _this.animate = function(target, origin, _a) {
            if (_a === void 0) _a = {};
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = (0, $cA1Ck.__rest)(_a, [
                "originBox",
                "targetBox",
                "visibilityAction",
                "shouldStackAnimate",
                "onComplete",
                "prevParent"
            ]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */ if (shouldStackAnimate === false) {
                _this.isAnimatingTree = false;
                return _this.safeToRemove();
            }
            /**
             * Prioritise tree animations
             */ if (_this.isAnimatingTree && shouldStackAnimate !== true) return;
            else if (shouldStackAnimate) _this.isAnimatingTree = true;
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */ origin = originBox || origin;
            target = targetBox || target;
            /**
             * If this element has a projecting parent, there's an opportunity to animate
             * it relatively to that parent rather than relatively to the viewport. This
             * allows us to add orchestrated animations.
             */ var isRelative = false;
            var projectionParent = visualElement.getProjectionParent();
            if (projectionParent) {
                var prevParentViewportBox = projectionParent.prevViewportBox;
                var parentLayout = projectionParent.getLayoutState().layout;
                /**
                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                 */ if (prevParent) {
                    /**
                     * If we've been provided an explicit target box it means we're animating back
                     * to this previous parent. So we can make a relative box by comparing to the previous
                     * parent's layout
                     */ if (targetBox) parentLayout = prevParent.getLayoutState().layout;
                    /**
                     * Likewise if we've been provided an explicit origin box it means we're
                     * animating out from a different element. So we should figure out where that was
                     * on screen relative to the new parent element.
                     */ if (originBox && !(0, $f8vBp.checkIfParentHasChanged)(prevParent, projectionParent) && prevParent.prevViewportBox) prevParentViewportBox = prevParent.prevViewportBox;
                }
                if (prevParentViewportBox && $be17fd6ad2f3a114$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                    isRelative = true;
                    origin = (0, $f8vBp.calcRelativeOffset)(prevParentViewportBox, origin);
                    target = (0, $f8vBp.calcRelativeOffset)(parentLayout, target);
                }
            }
            var boxHasMoved = $be17fd6ad2f3a114$var$hasMoved(origin, target);
            var animations = (0, $fuMt1.eachAxis)(function(axis) {
                var _a, _b;
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */ if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.projection.isTargetLocked) return;
                else if (visibilityAction !== undefined) visualElement.setVisibility(visibilityAction === (0, $4ZkPk.VisibilityAction).Show);
                else if (boxHasMoved) // If the box has moved, animate between it's current visual state and its
                // final state
                return _this.animateAxis(axis, target[axis], origin[axis], (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, config), {
                    isRelative: isRelative
                }));
                else {
                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 || _b.call(_a);
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.syncRender();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */ return Promise.all(animations).then(function() {
                _this.isAnimatingTree = false;
                onComplete && onComplete();
                visualElement.notifyLayoutAnimationComplete();
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function() {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = (0, $bRoOe.startAnimation);
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.layoutSafeToRemove = function() {
            return _this.safeToRemove();
        };
        (0, $jVB6R.addScaleCorrection)((0, $cQ083.defaultScaleCorrectors));
    };
    Animate.prototype.componentWillUnmount = function() {
        var _this = this;
        this.unsubLayoutReady();
        (0, $fuMt1.eachAxis)(function(axis) {
            var _a, _b;
            return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */ Animate.prototype.animateAxis = function(axis, target, origin, _a) {
        var _this = this;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
        /**
         * If we're not animating to a new target, don't run this animation
         */ if (this.isAnimating[axis] && $be17fd6ad2f3a114$var$axisIsEqual(target, this.currentAnimationTarget[axis])) return;
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 || _c.call(_b);
        this.isAnimating[axis] = true;
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */ layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */ var frame = function() {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / $be17fd6ad2f3a114$var$progressTarget;
            // Tween the axis and update the visualElement with the latest values
            (0, $f8vBp.tweenAxis)(frameTarget, origin, target, p);
            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        this.stopAxisAnimation[axis] = function() {
            _this.isAnimating[axis] = false;
            layoutProgress.stop();
            unsubscribeProgress();
        };
        this.currentAnimationTarget[axis] = target;
        var layoutTransition = transition || visualElement.getDefaultTransition() || $be17fd6ad2f3a114$var$defaultLayoutTransition;
        // Start the animation on this axis
        var animation = (0, $bRoOe.startAnimation)(axis === "x" ? "layoutX" : "layoutY", layoutProgress, $be17fd6ad2f3a114$var$progressTarget, layoutTransition && (0, $bRoOe.getValueTransition)(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
        return animation;
    };
    Animate.prototype.safeToRemove = function() {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 || _b.call(_a);
    };
    Animate.prototype.render = function() {
        return null;
    };
    return Animate;
}($7fPBF.Component);
function $be17fd6ad2f3a114$export$bd44d4206e0b4eca(props) {
    var _a = (0, $cA1Ck.__read)((0, $iesfz.usePresence)(), 2), safeToRemove = _a[1];
    return $7fPBF.createElement($be17fd6ad2f3a114$var$Animate, (0, $cA1Ck.__assign)({}, props, {
        safeToRemove: safeToRemove
    }));
}
function $be17fd6ad2f3a114$var$hasMoved(a, b) {
    return !$be17fd6ad2f3a114$var$isZeroBox(a) && !$be17fd6ad2f3a114$var$isZeroBox(b) && (!$be17fd6ad2f3a114$var$axisIsEqual(a.x, b.x) || !$be17fd6ad2f3a114$var$axisIsEqual(a.y, b.y));
}
var $be17fd6ad2f3a114$var$zeroAxis = {
    min: 0,
    max: 0
};
function $be17fd6ad2f3a114$var$isZeroBox(a) {
    return $be17fd6ad2f3a114$var$axisIsEqual(a.x, $be17fd6ad2f3a114$var$zeroAxis) && $be17fd6ad2f3a114$var$axisIsEqual(a.y, $be17fd6ad2f3a114$var$zeroAxis);
}
function $be17fd6ad2f3a114$var$axisIsEqual(a, b) {
    return a.min === b.min && a.max === b.max;
}
var $be17fd6ad2f3a114$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $be17fd6ad2f3a114$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
    return prevParent || !prevParent && !(originBox || targetBox);
}

});
parcelRequire.register("cQ083", function(module, exports) {

$parcel$export(module.exports, "defaultScaleCorrectors", function () { return $958a70f301ae987f$export$f5121daded6e3d5d; });

var $cA1Ck = parcelRequire("cA1Ck");

var $1tBsz = parcelRequire("1tBsz");
var $c1DuU = parcelRequire("c1DuU");

var $7CXds = parcelRequire("7CXds");

var $dKRnh = parcelRequire("dKRnh");
function $958a70f301ae987f$export$fafff692be55225d(pixels, axis) {
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ function $958a70f301ae987f$export$5eafb6257a5844c(latest, _layoutState, _a) {
    var target = _a.target;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */ if (typeof latest === "string") {
        if ((0, $c1DuU.px).test(latest)) latest = parseFloat(latest);
        else return latest;
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */ var x = $958a70f301ae987f$export$fafff692be55225d(latest, target.x);
    var y = $958a70f301ae987f$export$fafff692be55225d(latest, target.y);
    return x + "% " + y + "%";
}
var $958a70f301ae987f$var$varToken = "_$css";
function $958a70f301ae987f$export$eb0bc629e74dcf8(latest, _a) {
    var delta = _a.delta, treeScale = _a.treeScale;
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */ var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) latest = latest.replace((0, $dKRnh.cssVariableRegex), function(match) {
        cssVariables.push(match);
        return $958a70f301ae987f$var$varToken;
    });
    var shadow = (0, $1tBsz.complex).parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5) return original;
    var template = (0, $1tBsz.complex).createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */ var averageScale = (0, $7CXds.mix)(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace($958a70f301ae987f$var$varToken, function() {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var $958a70f301ae987f$var$borderCorrectionDefinition = {
    process: $958a70f301ae987f$export$5eafb6257a5844c
};
var $958a70f301ae987f$export$f5121daded6e3d5d = {
    borderRadius: (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, $958a70f301ae987f$var$borderCorrectionDefinition), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: $958a70f301ae987f$var$borderCorrectionDefinition,
    borderTopRightRadius: $958a70f301ae987f$var$borderCorrectionDefinition,
    borderBottomLeftRadius: $958a70f301ae987f$var$borderCorrectionDefinition,
    borderBottomRightRadius: $958a70f301ae987f$var$borderCorrectionDefinition,
    boxShadow: {
        process: $958a70f301ae987f$export$eb0bc629e74dcf8
    }
};

});
parcelRequire.register("dKRnh", function(module, exports) {

$parcel$export(module.exports, "cssVariableRegex", function () { return $a038f949d9276c51$export$f7c0a352d8ef6313; });
$parcel$export(module.exports, "resolveCSSVariables", function () { return $a038f949d9276c51$export$669319b042b57350; });

var $cA1Ck = parcelRequire("cA1Ck");

var $hrQbS = parcelRequire("hrQbS");
function $a038f949d9276c51$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $a038f949d9276c51$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $a038f949d9276c51$export$b9f0c1f373aee2b0(current) {
    var match = $a038f949d9276c51$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $cA1Ck.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $a038f949d9276c51$var$maxDepth = 4;
function $a038f949d9276c51$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $hrQbS.invariant)(depth <= $a038f949d9276c51$var$maxDepth, 'Max CSS variable fallback depth detected in property "' + current + '". This may indicate a circular fallback dependency.');
    var _a = (0, $cA1Ck.__read)($a038f949d9276c51$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($a038f949d9276c51$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $a038f949d9276c51$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $a038f949d9276c51$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $cA1Ck.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $cA1Ck.__assign)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$a038f949d9276c51$var$isCSSVariable(current)) return;
        var resolved = $a038f949d9276c51$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$a038f949d9276c51$var$isCSSVariable(current)) continue;
        var resolved = $a038f949d9276c51$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRequire.register("bFIkO", function(module, exports) {

$parcel$export(module.exports, "MeasureContextProvider", function () { return $87f5e9f9cac1855d$export$47ef792ac0e676f6; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7fPBF = parcelRequire("7fPBF");

var $dGWvt = parcelRequire("dGWvt");

var $2twVH = parcelRequire("2twVH");
/**
 * This component is responsible for scheduling the measuring of the motion component
 */ var $87f5e9f9cac1855d$var$Measure = /** @class */ function(_super) {
    (0, $cA1Ck.__extends)(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */ Measure.prototype.componentDidMount = function() {
        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
        (0, $dGWvt.isSharedLayout)(syncLayout) && syncLayout.register(visualElement);
        (0, $dGWvt.isSharedLayout)(framerSyncLayout) && framerSyncLayout.register(visualElement);
        visualElement.onUnmount(function() {
            if ((0, $dGWvt.isSharedLayout)(syncLayout)) syncLayout.remove(visualElement);
            if ((0, $dGWvt.isSharedLayout)(framerSyncLayout)) framerSyncLayout.remove(visualElement);
        });
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */ Measure.prototype.getSnapshotBeforeUpdate = function() {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if ((0, $dGWvt.isSharedLayout)(syncLayout)) syncLayout.syncUpdate();
        else {
            (0, $2twVH.snapshotViewportBox)(visualElement);
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function() {
        var syncLayout = this.props.syncLayout;
        if (!(0, $dGWvt.isSharedLayout)(syncLayout)) syncLayout.flush();
    };
    Measure.prototype.render = function() {
        return null;
    };
    return Measure;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
function $87f5e9f9cac1855d$export$47ef792ac0e676f6(props) {
    var syncLayout = (0, $7fPBF.useContext)((0, $dGWvt.SharedLayoutContext));
    var framerSyncLayout = (0, $7fPBF.useContext)((0, $dGWvt.FramerTreeLayoutContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($87f5e9f9cac1855d$var$Measure, (0, $cA1Ck.__assign)({}, props, {
        syncLayout: syncLayout,
        framerSyncLayout: framerSyncLayout
    }));
}

});


parcelRequire.register("fKGIV", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $b77c4ae632fa79bc$export$56ba0183203348f5; });

var $gOuvl = parcelRequire("gOuvl");

var $bC21j = parcelRequire("bC21j");

var $lebiC = parcelRequire("lebiC");
var $b77c4ae632fa79bc$export$56ba0183203348f5 = function(Component, options) {
    return (0, $lebiC.isSVGComponent)(Component) ? (0, $bC21j.svgVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : (0, $gOuvl.htmlVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRequire.register("gOuvl", function(module, exports) {

$parcel$export(module.exports, "htmlConfig", function () { return $c3d8fa6db022cf25$export$985b1494d4aeee90; });
$parcel$export(module.exports, "htmlVisualElement", function () { return $c3d8fa6db022cf25$export$9509f7c142585e92; });

var $cA1Ck = parcelRequire("cA1Ck");

var $Ys6eO = parcelRequire("Ys6eO");

var $hktAr = parcelRequire("hktAr");

var $4Gk2R = parcelRequire("4Gk2R");

var $hcgl4 = parcelRequire("hcgl4");

var $7yQ2l = parcelRequire("7yQ2l");

var $gJoWh = parcelRequire("gJoWh");

var $3r0Rf = parcelRequire("3r0Rf");

var $2Lf9c = parcelRequire("2Lf9c");

var $7hl4L = parcelRequire("7hl4L");

var $7qIRb = parcelRequire("7qIRb");

var $hsHs2 = parcelRequire("hsHs2");
function $c3d8fa6db022cf25$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $c3d8fa6db022cf25$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $3r0Rf.isTransformProp)(key)) {
            var defaultType = (0, $7qIRb.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $c3d8fa6db022cf25$export$3735103072e4a80(domElement);
            return ((0, $7yQ2l.isCSSVariable)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $4Gk2R.getBoundingBox)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $cA1Ck.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $hktAr.getOrigin)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $hktAr.checkTargetForNewValues)(element, target, origin);
            var parsed = (0, $gJoWh.parseDomVariant)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $cA1Ck.__assign)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $2Lf9c.scrapeMotionValuesFromProps),
    build: function(element, renderState, latestValues, projection, layoutState, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $hcgl4.buildHTMLStyles)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $hsHs2.buildLayoutProjectionTransform) : undefined, isProjectionTranform ? (0, $hsHs2.buildLayoutProjectionTransformOrigin) : undefined);
    },
    render: (0, $7hl4L.renderHTML)
};
var $c3d8fa6db022cf25$export$9509f7c142585e92 = (0, $Ys6eO.visualElement)($c3d8fa6db022cf25$export$985b1494d4aeee90);

});
parcelRequire.register("Ys6eO", function(module, exports) {

$parcel$export(module.exports, "visualElement", function () { return $0b5b66b571e92df4$export$5ad594e944c33d76; });

var $cA1Ck = parcelRequire("cA1Ck");

var $7n4cL = parcelRequire("7n4cL");

var $kdCPt = parcelRequire("kdCPt");

var $4ZkPk = parcelRequire("4ZkPk");

var $fuMt1 = parcelRequire("fuMt1");

var $lfoD4 = parcelRequire("lfoD4");

var $hoJOf = parcelRequire("hoJOf");

var $hDhYG = parcelRequire("hDhYG");

var $7cogK = parcelRequire("7cogK");

var $8olpw = parcelRequire("8olpw");

var $hsHs2 = parcelRequire("hsHs2");

var $3cBt8 = parcelRequire("3cBt8");

var $4DC4l = parcelRequire("4DC4l");

var $h5yGb = parcelRequire("h5yGb");

var $54d9A = parcelRequire("54d9A");

var $3W0T2 = parcelRequire("3W0T2");

var $6xQyR = parcelRequire("6xQyR");

var $5KrvS = parcelRequire("5KrvS");

var $9wjMn = parcelRequire("9wjMn");

var $azcC7 = parcelRequire("azcC7");
var $0b5b66b571e92df4$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) options = {};
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender and onViewportBoxUpdate.
         */ var lifecycles = (0, $4DC4l.createLifecycles)();
        /**
         *
         */ var projection = (0, $3W0T2.createProjectionState)();
        /**
         * A reference to the nearest projecting parent. This is either
         * undefined if we haven't looked for the nearest projecting parent,
         * false if there is no parent performing layout projection, or a reference
         * to the projecting parent.
         */ var projectionParent;
        /**
         * This is a reference to the visual state of the "lead" visual element.
         * Usually, this will be this visual element. But if it shares a layoutId
         * with other visual elements, only one of them will be designated lead by
         * AnimateSharedLayout. All the other visual elements will take on the visual
         * appearance of the lead while they crossfade to it.
         */ var leadProjection = projection;
        var leadLatestValues = latestValues;
        var unsubscribeFromLeadVisualElement;
        /**
         * The latest layout measurements and calculated projections. This
         * is seperate from the target projection data in visualState as
         * many visual elements might point to the same piece of visualState as
         * a target, whereas they might each have different layouts and thus
         * projection calculations needed to project into the same viewport box.
         */ var layoutState = (0, $3W0T2.createLayoutState)();
        /**
         *
         */ var crossfader;
        /**
         * Keep track of whether the viewport box has been updated since the
         * last time the layout projection was re-calculated.
         */ var hasViewportBoxUpdated = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * x/y motion values that track the progress of initiated layout
         * animations.
         *
         * TODO: Target for removal
         */ var projectionTargetProgress;
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $cA1Ck.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         *
         */ function render() {
            if (!instance) return;
            if (element.isProjectionReady()) {
                /**
                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                 * This is the final box that we will then project into by calculating a transform delta and
                 * applying it to the corrected box.
                 */ (0, $hoJOf.applyBoxTransforms)(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                /**
                 * Update the delta between the corrected box and the final target box, after
                 * user-set transforms are applied to it. This will be used by the renderer to
                 * create a transform style that will reproject the element from its actual layout
                 * into the desired bounding box.
                 */ (0, $hDhYG.updateBoxDelta)(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
            }
            triggerBuild();
            renderInstance(instance, renderState);
        }
        function triggerBuild() {
            var valuesToRender = latestValues;
            if (crossfader && crossfader.isActive()) {
                var crossfadedValues = crossfader.getCrossfadeState(element);
                if (crossfadedValues) valuesToRender = crossfadedValues;
            }
            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function updateLayoutProjection() {
            if (!element.isProjectionReady()) return;
            var delta = layoutState.delta, treeScale = layoutState.treeScale;
            var prevTreeScaleX = treeScale.x;
            var prevTreeScaleY = treeScale.y;
            var prevDeltaTransform = layoutState.deltaTransform;
            (0, $54d9A.updateLayoutDeltas)(layoutState, leadProjection, element.path, latestValues);
            hasViewportBoxUpdated && element.notifyViewportBoxUpdate(leadProjection.target, delta);
            hasViewportBoxUpdated = false;
            var deltaTransform = (0, $hsHs2.buildLayoutProjectionTransform)(delta, treeScale);
            if (deltaTransform !== prevDeltaTransform || // Also compare calculated treeScale, for values that rely on this only for scale correction
            prevTreeScaleX !== treeScale.x || prevTreeScaleY !== treeScale.y) element.scheduleRender();
            layoutState.deltaTransform = deltaTransform;
        }
        function updateTreeLayoutProjection() {
            element.layoutTree.forEach($0b5b66b571e92df4$var$fireUpdateLayoutProjection);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $7n4cL.default).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $8olpw.isMotionValue)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $5KrvS.checkIfControllingVariants)(props);
        var isVariantNode = (0, $5KrvS.checkIfVariantNode)(props);
        var element = (0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             * An ancestor path back to the root visual element. This is used
             * by layout projection to quickly recurse back up the tree.
             */ path: parent ? (0, $cA1Ck.__spreadArray)((0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(parent.path)), [
                parent
            ]) : [],
            layoutTree: parent ? parent.layoutTree : new (0, $6xQyR.FlatTree)(),
            /**
             *
             */ presenceId: presenceId,
            projection: projection,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by AnimateSharedLayout, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                instance = element.current = newInstance;
                element.pointTo(element);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                parent === null || parent === void 0 || parent.children.add(element);
            },
            /**
             *
             */ unmount: function() {
                (0, $7n4cL.cancelSync).update(update);
                (0, $7n4cL.cancelSync).render(render);
                (0, $7n4cL.cancelSync).preRender(element.updateLayoutProjection);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                element.stopLayoutAnimation();
                element.layoutTree.remove(element);
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                lifecycles.clearAllListeners();
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * A method that schedules an update to layout projections throughout
             * the tree. We inherit from the parent so there's only ever one
             * job scheduled on the next frame - that of the root visual element.
             */ scheduleUpdateLayoutProjection: parent ? parent.scheduleUpdateLayoutProjection : function() {
                return (0, $7n4cL.default).preRender(element.updateTreeLayoutProjection, false, true);
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $7cogK.motionValue)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $8olpw.isMotionValue)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $7n4cL.default).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $h5yGb.updateMotionValuesFromProps)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $0b5b66b571e92df4$var$numVariantProps; i++){
                    var name_1 = $0b5b66b571e92df4$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $5KrvS.isVariantLabel)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            },
            // Layout projection ==============================
            /**
             * Enable layout projection for this visual element. Won't actually
             * occur until we also have hydrated layout measurements.
             */ enableLayoutProjection: function() {
                projection.isEnabled = true;
                element.layoutTree.add(element);
            },
            /**
             * Lock the projection target, for instance when dragging, so
             * nothing else can try and animate it.
             */ lockProjectionTarget: function() {
                projection.isTargetLocked = true;
            },
            unlockProjectionTarget: function() {
                element.stopLayoutAnimation();
                projection.isTargetLocked = false;
            },
            getLayoutState: function() {
                return layoutState;
            },
            setCrossfader: function(newCrossfader) {
                crossfader = newCrossfader;
            },
            isProjectionReady: function() {
                return projection.isEnabled && projection.isHydrated && layoutState.isHydrated;
            },
            /**
             * Start a layout animation on a given axis.
             */ startLayoutAnimation: function(axis, transition, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var progress = element.getProjectionAnimationProgress()[axis];
                var _a = isRelative ? projection.relativeTarget[axis] : projection.target[axis], min = _a.min, max = _a.max;
                var length = max - min;
                progress.clearListeners();
                progress.set(min);
                progress.set(min); // Set twice to hard-reset velocity
                progress.onChange(function(v) {
                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                });
                return element.animateMotionValue(axis, progress, 0, transition);
            },
            /**
             * Stop layout animations.
             */ stopLayoutAnimation: function() {
                (0, $fuMt1.eachAxis)(function(axis) {
                    return element.getProjectionAnimationProgress()[axis].stop();
                });
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function(withTransform) {
                if (withTransform === void 0) withTransform = true;
                var viewportBox = measureViewportBox(instance, options);
                if (!withTransform) (0, $hoJOf.removeBoxTransforms)(viewportBox, latestValues);
                return viewportBox;
            },
            /**
             * Get the motion values tracking the layout animations on each
             * axis. Lazy init if not already created.
             */ getProjectionAnimationProgress: function() {
                projectionTargetProgress || (projectionTargetProgress = {
                    x: (0, $7cogK.motionValue)(0),
                    y: (0, $7cogK.motionValue)(0)
                });
                return projectionTargetProgress;
            },
            /**
             * Update the projection of a single axis. Schedule an update to
             * the tree layout projection.
             */ setProjectionTargetAxis: function(axis, min, max, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var target;
                if (isRelative) {
                    if (!projection.relativeTarget) projection.relativeTarget = (0, $lfoD4.axisBox)();
                    target = projection.relativeTarget[axis];
                } else {
                    projection.relativeTarget = undefined;
                    target = projection.target[axis];
                }
                projection.isHydrated = true;
                target.min = min;
                target.max = max;
                // Flag that we want to fire the onViewportBoxUpdate event handler
                hasViewportBoxUpdated = true;
                lifecycles.notifySetAxisTarget();
            },
            /**
             * Rebase the projection target on top of the provided viewport box
             * or the measured layout. This ensures that non-animating elements
             * don't fall out of sync differences in measurements vs projections
             * after a page scroll or other relayout.
             */ rebaseProjectionTarget: function(force, box) {
                if (box === void 0) box = layoutState.layout;
                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                var shouldRebase = !projection.relativeTarget && !projection.isTargetLocked && !x.isAnimating() && !y.isAnimating();
                if (force || shouldRebase) (0, $fuMt1.eachAxis)(function(axis) {
                    var _a = box[axis], min = _a.min, max = _a.max;
                    element.setProjectionTargetAxis(axis, min, max);
                });
            },
            /**
             * Notify the visual element that its layout is up-to-date.
             * Currently Animate.tsx uses this to check whether a layout animation
             * needs to be performed.
             */ notifyLayoutReady: function(config) {
                (0, $9wjMn.setCurrentViewportBox)(element);
                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
            },
            /**
             * Temporarily reset the transform of the instance.
             */ resetTransform: function() {
                return resetTransform(element, instance, props);
            },
            restoreTransform: function() {
                return restoreTransform(instance, renderState);
            },
            updateLayoutProjection: updateLayoutProjection,
            updateTreeLayoutProjection: function() {
                element.layoutTree.forEach($0b5b66b571e92df4$var$fireResolveRelativeTargetBox);
                /**
                 * Schedule the projection updates at the end of the current preRender
                 * step. This will ensure that all layout trees will first resolve
                 * relative projection boxes into viewport boxes, and *then*
                 * update projections.
                 */ (0, $7n4cL.default).preRender(updateTreeLayoutProjection, false, true);
            // sync.postRender(() => element.scheduleUpdateLayoutProjection())
            },
            getProjectionParent: function() {
                if (projectionParent === undefined) {
                    var foundParent = false;
                    // Search backwards through the tree path
                    for(var i = element.path.length - 1; i >= 0; i--){
                        var ancestor = element.path[i];
                        if (ancestor.projection.isEnabled) {
                            foundParent = ancestor;
                            break;
                        }
                    }
                    projectionParent = foundParent;
                }
                return projectionParent;
            },
            resolveRelativeTargetBox: function() {
                var relativeParent = element.getProjectionParent();
                if (!projection.relativeTarget || !relativeParent) return;
                (0, $hDhYG.calcRelativeBox)(projection, relativeParent.projection);
                if ((0, $azcC7.isDraggable)(relativeParent)) {
                    var target = projection.target;
                    (0, $hoJOf.applyBoxTransforms)(target, target, relativeParent.getLatestValues());
                }
            },
            shouldResetTransform: function() {
                return Boolean(props._layoutResetTransform);
            },
            /**
             *
             */ pointTo: function(newLead) {
                leadProjection = newLead.projection;
                leadLatestValues = newLead.getLatestValues();
                /**
                 * Subscribe to lead component's layout animations
                 */ unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                unsubscribeFromLeadVisualElement = (0, $kdCPt.pipe)(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function() {
                    var _a;
                    if (element.isPresent) element.presence = (0, $4ZkPk.Presence).Present;
                    else (_a = element.layoutSafeToRemove) === null || _a === void 0 || _a.call(element);
                }));
            },
            // TODO: Clean this up
            isPresent: true,
            presence: (0, $4ZkPk.Presence).Entering
        });
        return element;
    };
};
function $0b5b66b571e92df4$var$fireResolveRelativeTargetBox(child) {
    child.resolveRelativeTargetBox();
}
function $0b5b66b571e92df4$var$fireUpdateLayoutProjection(child) {
    child.updateLayoutProjection();
}
var $0b5b66b571e92df4$var$variantProps = (0, $cA1Ck.__spreadArray)([
    "initial"
], (0, $cA1Ck.__read)((0, $3cBt8.variantPriorityOrder)));
var $0b5b66b571e92df4$var$numVariantProps = $0b5b66b571e92df4$var$variantProps.length;

});
parcelRequire.register("hsHs2", function(module, exports) {

$parcel$export(module.exports, "buildLayoutProjectionTransform", function () { return $cb66c1b9cc93ca00$export$d842ebfa32edc648; });
$parcel$export(module.exports, "buildLayoutProjectionTransformOrigin", function () { return $cb66c1b9cc93ca00$export$9df601cd9cfcf364; });

var $3W0T2 = parcelRequire("3W0T2");
/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */ function $cb66c1b9cc93ca00$export$d842ebfa32edc648(_a, treeScale, latestTransform) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(" + rotate + ") ";
        if (rotateX) transform += "rotateX(" + rotateX + ") ";
        if (rotateY) transform += "rotateY(" + rotateY + ") ";
    }
    transform += "scale(" + x.scale + ", " + y.scale + ")";
    return !latestTransform && transform === $cb66c1b9cc93ca00$export$f6730f82d2dcfda3 ? "" : transform;
}
/**
 * Take the calculated delta origin and apply it as a transform string.
 */ function $cb66c1b9cc93ca00$export$9df601cd9cfcf364(_a) {
    var deltaFinal = _a.deltaFinal;
    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var $cb66c1b9cc93ca00$export$f6730f82d2dcfda3 = $cb66c1b9cc93ca00$export$d842ebfa32edc648((0, $3W0T2.zeroLayout).delta, (0, $3W0T2.zeroLayout).treeScale, {
    x: 1,
    y: 1
});

});
parcelRequire.register("3W0T2", function(module, exports) {

$parcel$export(module.exports, "createProjectionState", function () { return $2dd779f96475b908$export$3cdcde773d12ad30; });
$parcel$export(module.exports, "createLayoutState", function () { return $2dd779f96475b908$export$e7071b3cce6bc4ce; });
$parcel$export(module.exports, "zeroLayout", function () { return $2dd779f96475b908$export$6ce978c1a0625804; });

var $lfoD4 = parcelRequire("lfoD4");
var $2dd779f96475b908$export$3cdcde773d12ad30 = function() {
    return {
        isEnabled: false,
        isHydrated: false,
        isTargetLocked: false,
        target: (0, $lfoD4.axisBox)(),
        targetFinal: (0, $lfoD4.axisBox)()
    };
};
function $2dd779f96475b908$export$e7071b3cce6bc4ce() {
    return {
        isHydrated: false,
        layout: (0, $lfoD4.axisBox)(),
        layoutCorrected: (0, $lfoD4.axisBox)(),
        treeScale: {
            x: 1,
            y: 1
        },
        delta: (0, $lfoD4.delta)(),
        deltaFinal: (0, $lfoD4.delta)(),
        deltaTransform: ""
    };
}
var $2dd779f96475b908$export$6ce978c1a0625804 = $2dd779f96475b908$export$e7071b3cce6bc4ce();

});


parcelRequire.register("4DC4l", function(module, exports) {

$parcel$export(module.exports, "createLifecycles", function () { return $360855a69975a745$export$f6841af6ea5003ab; });

var $cA1Ck = parcelRequire("cA1Ck");

var $hvyCr = parcelRequire("hvyCr");
var $360855a69975a745$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $360855a69975a745$export$f6841af6ea5003ab() {
    var managers = $360855a69975a745$var$names.map(function() {
        return new (0, $hvyCr.SubscriptionManager)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            return $360855a69975a745$var$names.forEach(function(name) {
                var _a;
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $360855a69975a745$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $360855a69975a745$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $cA1Ck.__spreadArray)([], (0, $cA1Ck.__read)(args)));
        };
    });
    return lifecycles;
}

});

parcelRequire.register("h5yGb", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $c70dcdea6b608936$export$9a552858d5197f6e; });

var $7cogK = parcelRequire("7cogK");

var $8olpw = parcelRequire("8olpw");
function $c70dcdea6b608936$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $8olpw.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $8olpw.isMotionValue)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $7cogK.motionValue)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $7cogK.motionValue)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRequire.register("54d9A", function(module, exports) {

$parcel$export(module.exports, "updateLayoutDeltas", function () { return $3b07877e4c57c956$export$1b3a41764b83e037; });

var $hoJOf = parcelRequire("hoJOf");

var $hDhYG = parcelRequire("hDhYG");
function $3b07877e4c57c956$export$1b3a41764b83e037(_a, _b, treePath, transformOrigin) {
    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
    var target = _b.target;
    /**
     * Reset the corrected box with the latest values from box, as we're then going
     * to perform mutative operations on it.
     */ (0, $hoJOf.resetBox)(layoutCorrected, layout);
    /**
     * Apply all the parent deltas to this box to produce the corrected box. This
     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
     */ (0, $hoJOf.applyTreeDeltas)(layoutCorrected, treeScale, treePath);
    /**
     * Update the delta between the corrected box and the target box before user-set transforms were applied.
     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
     * for our layout reprojection, but still allow them to be scaled correctly by the user.
     * It might be that to simplify this we may want to accept that user-set scale is also corrected
     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
     * to allow people to choose whether these styles are corrected based on just the
     * layout reprojection or the final bounding box.
     */ (0, $hDhYG.updateBoxDelta)(delta, layoutCorrected, target, transformOrigin);
}

});

parcelRequire.register("6xQyR", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $4c3e98b36b4e305e$export$1465d17e3de78a96; });

var $8tZP2 = parcelRequire("8tZP2");

var $7k3Fq = parcelRequire("7k3Fq");
var $4c3e98b36b4e305e$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $8tZP2.addUniqueItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $8tZP2.removeItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $7k3Fq.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();

});

parcelRequire.register("9wjMn", function(module, exports) {

$parcel$export(module.exports, "setCurrentViewportBox", function () { return $6ee671f96e34de7e$export$8a57a029e604f408; });

var $f8vBp = parcelRequire("f8vBp");

var $fuMt1 = parcelRequire("fuMt1");
function $6ee671f96e34de7e$export$8a57a029e604f408(visualElement) {
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) {
        visualElement.rebaseProjectionTarget();
        return;
    }
    var relativeOffset = (0, $f8vBp.calcRelativeOffset)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $fuMt1.eachAxis)(function(axis) {
        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
    });
}

});


parcelRequire.register("gJoWh", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", function () { return $c2e431a7176eacf9$export$5849e743e29831d6; });

var $dKRnh = parcelRequire("dKRnh");

var $36RBk = parcelRequire("36RBk");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $c2e431a7176eacf9$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $dKRnh.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $36RBk.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRequire.register("36RBk", function(module, exports) {

$parcel$export(module.exports, "unitConversion", function () { return $243b82b2d644b81c$export$9e04b0cab841a28; });

var $cA1Ck = parcelRequire("cA1Ck");

var $avOce = parcelRequire("avOce");
var $c1DuU = parcelRequire("c1DuU");

var $7L1pF = parcelRequire("7L1pF");

var $hrQbS = parcelRequire("hrQbS");

var $3r0Rf = parcelRequire("3r0Rf");

var $gU1yc = parcelRequire("gU1yc");
var $243b82b2d644b81c$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $243b82b2d644b81c$var$isPositionalKey = function(key) {
    return $243b82b2d644b81c$var$positionalKeys.has(key);
};
var $243b82b2d644b81c$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($243b82b2d644b81c$var$isPositionalKey);
};
var $243b82b2d644b81c$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $243b82b2d644b81c$var$isNumOrPxType = function(v) {
    return v === (0, $avOce.number) || v === (0, $c1DuU.px);
};
var $243b82b2d644b81c$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($243b82b2d644b81c$export$d0c75e4fa9e69db8 || ($243b82b2d644b81c$export$d0c75e4fa9e69db8 = {}));
var $243b82b2d644b81c$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $243b82b2d644b81c$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $243b82b2d644b81c$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $243b82b2d644b81c$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $243b82b2d644b81c$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $243b82b2d644b81c$var$nonTranslationalTransformKeys = (0, $3r0Rf.transformProps).filter(function(key) {
    return !$243b82b2d644b81c$var$transformKeys.has(key);
});
function $243b82b2d644b81c$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $243b82b2d644b81c$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $243b82b2d644b81c$var$positionalValues = {
    // Dimensions
    width: function(_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function(_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $243b82b2d644b81c$var$getTranslateFromMatrix(4, 13),
    y: $243b82b2d644b81c$var$getTranslateFromMatrix(5, 14)
};
var $243b82b2d644b81c$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        transform: transform
    };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $243b82b2d644b81c$var$setAndResetVelocity(value, $243b82b2d644b81c$var$positionalValues[key](originBbox, originComputedStyle));
        target[key] = $243b82b2d644b81c$var$positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $243b82b2d644b81c$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $cA1Ck.__assign)({}, target);
    transitionEnd = (0, $cA1Ck.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($243b82b2d644b81c$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var to = target[key];
        var fromType = (0, $gU1yc.findDimensionValueType)(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $7L1pF.isKeyframesTarget)(to)) {
            var numKeyframes = to.length;
            for(var i = to[0] === null ? 1 : 0; i < numKeyframes; i++)if (!toType) {
                toType = (0, $gU1yc.findDimensionValueType)(to[i]);
                (0, $hrQbS.invariant)(toType === fromType || $243b82b2d644b81c$var$isNumOrPxType(fromType) && $243b82b2d644b81c$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $hrQbS.invariant)((0, $gU1yc.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $gU1yc.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($243b82b2d644b81c$var$isNumOrPxType(fromType) && $243b82b2d644b81c$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $c1DuU.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $243b82b2d644b81c$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $243b82b2d644b81c$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = $243b82b2d644b81c$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $cA1Ck.__read)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $243b82b2d644b81c$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $243b82b2d644b81c$var$hasPositionalKey(target) ? $243b82b2d644b81c$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRequire.register("bC21j", function(module, exports) {

$parcel$export(module.exports, "svgVisualElement", function () { return $8744cf7803426916$export$3ba8992de7b705bc; });

var $cA1Ck = parcelRequire("cA1Ck");

var $Ys6eO = parcelRequire("Ys6eO");

var $keTze = parcelRequire("keTze");

var $gOuvl = parcelRequire("gOuvl");

var $hrXjD = parcelRequire("hrXjD");

var $jp6qR = parcelRequire("jp6qR");

var $7q4PB = parcelRequire("7q4PB");

var $3r0Rf = parcelRequire("3r0Rf");

var $ayzhm = parcelRequire("ayzhm");

var $7qIRb = parcelRequire("7qIRb");

var $hsHs2 = parcelRequire("hsHs2");
var $8744cf7803426916$export$3ba8992de7b705bc = (0, $Ys6eO.visualElement)((0, $cA1Ck.__assign)((0, $cA1Ck.__assign)({}, (0, $gOuvl.htmlConfig)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $3r0Rf.isTransformProp)(key)) return ((_a = (0, $7qIRb.getDefaultValueType)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $7q4PB.camelCaseAttributes).has(key) ? (0, $jp6qR.camelToDash)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $keTze.scrapeMotionValuesFromProps),
    build: function(_element, renderState, latestValues, projection, layoutState, options, props) {
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $hrXjD.buildSVGAttrs)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $hsHs2.buildLayoutProjectionTransform) : undefined, isProjectionTranform ? (0, $hsHs2.buildLayoutProjectionTransformOrigin) : undefined);
    },
    render: (0, $ayzhm.renderSVG)
}));

});



parcelRequire.register("fSoNm", function(module, exports) {
"use strict";
var $b8ef21ef9f846e1f$var$__assign = module.exports && module.exports.__assign || function() {
    $b8ef21ef9f846e1f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b8ef21ef9f846e1f$var$__assign.apply(this, arguments);
};
var $b8ef21ef9f846e1f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyledButtonWrapper = module.exports.StyledIconButton = module.exports.StyledIndicatorIconButton = module.exports.StyledFiberManualRecordIcon = module.exports.StyledIndicators = module.exports.StyledItemWrapper = module.exports.StyledItem = module.exports.StyledRoot = void 0;

var $b8ef21ef9f846e1f$var$FiberManualRecord_1 = $b8ef21ef9f846e1f$var$__importDefault((parcelRequire("cM0HX")));

var $8TDId = parcelRequire("8TDId");
var $kDBhE = parcelRequire("kDBhE");
module.exports.StyledRoot = (0, $kDBhE.default)("div")({
    position: "relative",
    overflow: "hidden"
});
module.exports.StyledItem = (0, $kDBhE.default)("div")({
    position: "absolute",
    height: "100%",
    width: "100%"
});
module.exports.StyledItemWrapper = (0, $kDBhE.default)("div")({
    position: "relative",
    width: "100%",
    height: "100%"
});
module.exports.StyledIndicators = (0, $kDBhE.default)("div")({
    width: "100%",
    marginTop: "10px",
    textAlign: "center"
});
module.exports.StyledFiberManualRecordIcon = (0, $kDBhE.default)($b8ef21ef9f846e1f$var$FiberManualRecord_1.default)({
    fontSize: "15px"
});
module.exports.StyledIndicatorIconButton = (0, $kDBhE.default)($8TDId.default, {
    shouldForwardProp: function(propName) {
        return !propName.startsWith("$");
    }
})(function(_a) {
    var $active = _a.$active;
    return {
        cursor: "pointer",
        transition: "200ms",
        padding: 0,
        color: $active ? "#494949" : "#afafaf",
        "&:hover": {
            color: $active ? "#494949" : "#1f1f1f"
        },
        "&:active": {
            color: $active ? "#494949" : "#1f1f1f"
        }
    };
});
module.exports.StyledIconButton = (0, $kDBhE.default)($8TDId.default, {
    shouldForwardProp: function(propName) {
        return !propName.startsWith("$");
    }
})(function(_a) {
    var $alwaysVisible = _a.$alwaysVisible;
    return {
        margin: "0 10px",
        position: "relative",
        backgroundColor: "#494949",
        top: "calc(50% - 20px) !important",
        color: "white",
        fontSize: "30px",
        transition: "200ms",
        cursor: "pointer",
        opacity: $alwaysVisible ? "1" : "0",
        "&:hover": {
            opacity: "0.6 !important"
        }
    };
});
module.exports.StyledButtonWrapper = (0, $kDBhE.default)("div", {
    shouldForwardProp: function(propName) {
        return !propName.startsWith("$");
    }
})(function(_a) {
    var $next = _a.$next, $prev = _a.$prev, $fullHeightHover = _a.$fullHeightHover;
    return $b8ef21ef9f846e1f$var$__assign($b8ef21ef9f846e1f$var$__assign($b8ef21ef9f846e1f$var$__assign({
        position: "absolute",
        height: "100px",
        backgroundColor: "transparent",
        zIndex: 1,
        top: "calc(50% - 70px)",
        "&:hover": {
            "& button": {
                backgroundColor: "black",
                filter: "brightness(120%)",
                opacity: "0.4"
            }
        }
    }, $fullHeightHover ? {
        height: "100%",
        top: "0"
    } : undefined), $next ? {
        right: 0
    } : undefined), $prev ? {
        left: 0
    } : undefined);
});

});
parcelRequire.register("cM0HX", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94ca84517cd3e5f0$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $94ca84517cd3e5f0$var$_default = (0, $94ca84517cd3e5f0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), "FiberManualRecord");
module.exports.default = $94ca84517cd3e5f0$var$_default;

});
parcelRequire.register("62qsu", function(module, exports) {
function $4657741705a128f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $4657741705a128f0$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("3xowt", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6PKLM.default;
    }
});

var $6PKLM = parcelRequire("6PKLM");

});
parcelRequire.register("6PKLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9bc8f83648f682$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $freJ2 = parcelRequire("freJ2");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $freJ2.default), (0, $kY3Ke.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $freJ2.default).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}

});
parcelRequire.register("freJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d4ccc5f426d62a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $6VWZo = parcelRequire("6VWZo");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6VWZo.getSvgIconUtilityClass), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $kDBhE.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $cFLic.default)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = "SvgIcon";
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;

});
parcelRequire.register("6VWZo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $50c5d2f6ad13a504$export$c7c50641356bdfa5; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $k6RDS.default)("MuiSvgIcon", slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $4jzsB.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;

});





parcelRequire.register("8TDId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a243c492197f3b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $3RNaF = parcelRequire("3RNaF");

var $b6UUh = parcelRequire("b6UUh");

var $10KNR = parcelRequire("10KNR");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $67a243c492197f3b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $b6UUh.default)(color)}`,
            edge && `edge${(0, $b6UUh.default)(edge)}`,
            `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $10KNR.getIconButtonUtilityClass), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $b6UUh.default)(ownerState.edge)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kY3Ke.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $kY3Ke.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $kY3Ke.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $10KNR.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $cFLic.default)(props, $67a243c492197f3b$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($67a243c492197f3b$var$IconButtonRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;

});
parcelRequire.register("3RNaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d0c76ae9ca5c817$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $6NwTb = parcelRequire("6NwTb");

var $1XFnq = parcelRequire("1XFnq");

var $ahx27 = parcelRequire("ahx27");

var $5rlhe = parcelRequire("5rlhe");

var $i9gyt = parcelRequire("i9gyt");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $i9gyt.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $kDBhE.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $i9gyt.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cFLic.default)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $6NwTb.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $ahx27.default)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $1XFnq.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $1XFnq.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $1XFnq.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $1XFnq.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $6NwTb.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $kY3Ke.default)({
        as: ComponentProp,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bbzbN.jsx)((0, $5rlhe.default), (0, $kY3Ke.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;

});
parcelRequire.register("6NwTb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f30d4c1188a58e6$export$2e2bcd8739ae039; });

var $jTdAm = parcelRequire("jTdAm");
"use client";
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $jTdAm.default);

});
parcelRequire.register("jTdAm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7adb12ba33c17bd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fx0uj = parcelRequire("fx0uj");
"use client";
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $fx0uj.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRequire.register("fx0uj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4ea50f2d27bbd24$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b4ea50f2d27bbd24$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRequire.register("1XFnq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16db65b1f19e65f7$export$2e2bcd8739ae039; });

var $giDhD = parcelRequire("giDhD");
"use client";
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $giDhD.default);

});
parcelRequire.register("giDhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bddccca9f6cee29b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");
"use client";
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $lJRRs.default)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;

});
parcelRequire.register("lJRRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3794ae41ea97a8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== "undefined" ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;

});



parcelRequire.register("ahx27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77c51d9bab7ec5dd$export$2e2bcd8739ae039; });

var $jeNDw = parcelRequire("jeNDw");
"use client";
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $jeNDw.default);

});
parcelRequire.register("jeNDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e015d3df8b2e1fd4$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
let $e015d3df8b2e1fd4$var$hadKeyboardEvent = true;
let $e015d3df8b2e1fd4$var$hadFocusVisibleRecently = false;
let $e015d3df8b2e1fd4$var$hadFocusVisibleRecentlyTimeout;
const $e015d3df8b2e1fd4$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $e015d3df8b2e1fd4$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $e015d3df8b2e1fd4$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $e015d3df8b2e1fd4$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $e015d3df8b2e1fd4$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $e015d3df8b2e1fd4$var$handlePointerDown() {
    $e015d3df8b2e1fd4$var$hadKeyboardEvent = false;
}
function $e015d3df8b2e1fd4$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($e015d3df8b2e1fd4$var$hadFocusVisibleRecently) $e015d3df8b2e1fd4$var$hadKeyboardEvent = true;
    }
}
function $e015d3df8b2e1fd4$var$prepare(doc) {
    doc.addEventListener("keydown", $e015d3df8b2e1fd4$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $e015d3df8b2e1fd4$var$handleVisibilityChange, true);
}
function $e015d3df8b2e1fd4$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $e015d3df8b2e1fd4$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $e015d3df8b2e1fd4$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $e015d3df8b2e1fd4$var$handleVisibilityChange, true);
}
function $e015d3df8b2e1fd4$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $e015d3df8b2e1fd4$var$hadKeyboardEvent || $e015d3df8b2e1fd4$var$focusTriggersKeyboardModality(target);
}
function $e015d3df8b2e1fd4$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $e015d3df8b2e1fd4$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $e015d3df8b2e1fd4$var$hadFocusVisibleRecently = true;
            window.clearTimeout($e015d3df8b2e1fd4$var$hadFocusVisibleRecentlyTimeout);
            $e015d3df8b2e1fd4$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $e015d3df8b2e1fd4$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($e015d3df8b2e1fd4$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRequire.register("5rlhe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5ffa895ad4456e$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $4axyc = parcelRequire("4axyc");

var $hngXp = parcelRequire("hngXp");

var $bpHMA = parcelRequire("bpHMA");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $5geXw = parcelRequire("5geXw");

var $lCBOk = parcelRequire("lCBOk");

var $bbzbN = parcelRequire("bbzbN");
"use client";
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$t, $3f5ffa895ad4456e$var$t1, $3f5ffa895ad4456e$var$t2, $3f5ffa895ad4456e$var$t3;
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_1 = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t || ($3f5ffa895ad4456e$var$t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t1 || ($3f5ffa895ad4456e$var$t1 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $bpHMA.keyframes)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t2 || ($3f5ffa895ad4456e$var$t2 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $kDBhE.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $kDBhE.default)((0, $5geXw.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t3 || ($3f5ffa895ad4456e$var$t3 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $lCBOk.default).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $lCBOk.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $lCBOk.default).child, (0, $lCBOk.default).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $lCBOk.default).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cFLic.default)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $7fPBF.useRef(0);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $hngXp.default)(classes.ripple, (0, $lCBOk.default).ripple),
                        rippleVisible: (0, $hngXp.default)(classes.rippleVisible, (0, $lCBOk.default).rippleVisible),
                        ripplePulsate: (0, $hngXp.default)(classes.ripplePulsate, (0, $lCBOk.default).ripplePulsate),
                        child: (0, $hngXp.default)(classes.child, (0, $lCBOk.default).child),
                        childLeaving: (0, $hngXp.default)(classes.childLeaving, (0, $lCBOk.default).childLeaving),
                        childPulsate: (0, $hngXp.default)(classes.childPulsate, (0, $lCBOk.default).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $3f5ffa895ad4456e$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)((0, $lCBOk.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4axyc.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;

});
parcelRequire.register("4axyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30921f11ad4ef55c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $3zeAJ = parcelRequire("3zeAJ");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $8ovTL = parcelRequire("8ovTL");

var $3CAnX = parcelRequire("3CAnX");
var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3zeAJ.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $3CAnX.getInitialChildMapping)(nextProps, handleExited) : (0, $3CAnX.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $3CAnX.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;

});
parcelRequire.register("3zeAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298ff58efa174465$export$2e2bcd8739ae039; });
function $298ff58efa174465$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("8ovTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c94efb1735eff6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);

});

parcelRequire.register("3CAnX", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $2a31251aa5f7eb4f$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $2a31251aa5f7eb4f$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $2a31251aa5f7eb4f$export$36fd1af28d383ec0; });

var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, "appear", props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, "exit", nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRequire.register("5geXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $hngXp.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $hngXp.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;

});

parcelRequire.register("lCBOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbda7a0931c56f58$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $k6RDS.default)("MuiTouchRipple", slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $4jzsB.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;

});


parcelRequire.register("i9gyt", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $d365e8bde1350eb0$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $d365e8bde1350eb0$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $k6RDS.default)("MuiButtonBase", slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $4jzsB.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;

});


parcelRequire.register("10KNR", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $0bca18aab596affa$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $0bca18aab596affa$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $k6RDS.default)("MuiIconButton", slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $4jzsB.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;

});




parcelRequire.register("gJFtO", function(module, exports) {
"use strict";
var $c2f1065451f1692e$var$__assign = module.exports && module.exports.__assign || function() {
    $c2f1065451f1692e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c2f1065451f1692e$var$__assign.apply(this, arguments);
};
var $c2f1065451f1692e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c2f1065451f1692e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c2f1065451f1692e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c2f1065451f1692e$var$__createBinding(result, mod, k);
    }
    $c2f1065451f1692e$var$__setModuleDefault(result, mod);
    return result;
};
var $c2f1065451f1692e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Indicators = void 0;

var $c2f1065451f1692e$var$react_1 = $c2f1065451f1692e$var$__importStar((parcelRequire("7fPBF")));

var $fSoNm = parcelRequire("fSoNm");
var $c2f1065451f1692e$var$Indicators = function(props) {
    var IndicatorIcon = (0, $c2f1065451f1692e$var$react_1.useMemo)(function() {
        return props.IndicatorIcon !== undefined ? props.IndicatorIcon : $c2f1065451f1692e$var$react_1.default.createElement($fSoNm.StyledFiberManualRecordIcon, null);
    }, [
        props.IndicatorIcon
    ]);
    var completeListIfRequired = (0, $c2f1065451f1692e$var$react_1.useCallback)(function(arrayOfIcons) {
        while(arrayOfIcons.length < props.length){
            var index = 0;
            arrayOfIcons.push(arrayOfIcons[index]);
            index += 1;
        }
    }, [
        props.length
    ]);
    var _a = props.indicatorIconButtonProps, indicatorIconButtonClass = _a.className, indicatorIconButtonStyle = _a.style, indicatorIconButtonProps = $c2f1065451f1692e$var$__rest(_a, [
        "className",
        "style"
    ]);
    var _b = props.activeIndicatorIconButtonProps, activeIndicatorIconButtonClass = _b.className, activeIndicatorIconButtonStyle = _b.style, activeIndicatorIconButtonProps = $c2f1065451f1692e$var$__rest(_b, [
        "className",
        "style"
    ]);
    var indicators = [];
    var _loop_1 = function(i) {
        var className = i === props.active ? indicatorIconButtonClass + " " + activeIndicatorIconButtonClass : "" + indicatorIconButtonClass;
        var style = i === props.active ? Object.assign({}, indicatorIconButtonStyle, activeIndicatorIconButtonStyle) : indicatorIconButtonStyle;
        var restProps = i === props.active ? Object.assign({}, indicatorIconButtonProps, activeIndicatorIconButtonProps) : indicatorIconButtonProps;
        if (restProps["aria-label"] === undefined) restProps["aria-label"] = "carousel indicator";
        var createIndicator = function(IndicatorIcon) {
            return $c2f1065451f1692e$var$react_1.default.createElement($fSoNm.StyledIndicatorIconButton, $c2f1065451f1692e$var$__assign({
                "$active": i === props.active,
                key: i,
                className: className,
                style: style,
                onClick: function() {
                    props.press(i);
                }
            }, restProps, {
                "aria-label": restProps["aria-label"] + " " + (i + 1)
            }), IndicatorIcon);
        };
        Array.isArray(IndicatorIcon) ? indicators.push(createIndicator(IndicatorIcon[i])) && completeListIfRequired(IndicatorIcon) : indicators.push(createIndicator(IndicatorIcon));
    };
    for(var i = 0; i < props.length; i++)_loop_1(i);
    var _c = props.indicatorContainerProps, indicatorContainerClass = _c.className, indicatorContainerStyle = _c.style, indicatorContainerProps = $c2f1065451f1692e$var$__rest(_c, [
        "className",
        "style"
    ]);
    return $c2f1065451f1692e$var$react_1.default.createElement($fSoNm.StyledIndicators, $c2f1065451f1692e$var$__assign({
        className: indicatorContainerClass,
        style: indicatorContainerStyle
    }, indicatorContainerProps), indicators);
};
module.exports.Indicators = $c2f1065451f1692e$var$Indicators;

});

parcelRequire.register("3mJq6", function(module, exports) {
"use strict";
var $2736a8a64eceb0fd$var$__assign = module.exports && module.exports.__assign || function() {
    $2736a8a64eceb0fd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2736a8a64eceb0fd$var$__assign.apply(this, arguments);
};
var $2736a8a64eceb0fd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2736a8a64eceb0fd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2736a8a64eceb0fd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2736a8a64eceb0fd$var$__createBinding(result, mod, k);
    }
    $2736a8a64eceb0fd$var$__setModuleDefault(result, mod);
    return result;
};
var $2736a8a64eceb0fd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2736a8a64eceb0fd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInterval = module.exports.sanitizeProps = module.exports.sanitizeNavProps = void 0;

var $2736a8a64eceb0fd$var$NavigateBefore_1 = $2736a8a64eceb0fd$var$__importDefault((parcelRequire("lXiC5")));

var $2736a8a64eceb0fd$var$NavigateNext_1 = $2736a8a64eceb0fd$var$__importDefault((parcelRequire("2Fr3r")));

var $2736a8a64eceb0fd$var$react_1 = $2736a8a64eceb0fd$var$__importStar((parcelRequire("7fPBF")));
var $2736a8a64eceb0fd$var$sanitizeNavProps = function(props) {
    var _a = props || {}, className = _a.className, style = _a.style, rest = $2736a8a64eceb0fd$var$__rest(_a, [
        "className",
        "style"
    ]);
    return props !== undefined ? $2736a8a64eceb0fd$var$__assign({
        style: props.style !== undefined ? props.style : {},
        className: props.className !== undefined ? props.className : ""
    }, rest) : $2736a8a64eceb0fd$var$__assign({
        style: {},
        className: ""
    }, rest);
};
module.exports.sanitizeNavProps = $2736a8a64eceb0fd$var$sanitizeNavProps;
var $2736a8a64eceb0fd$var$sanitizeProps = function(props) {
    var animation = props.animation !== undefined ? props.animation : "fade";
    var duration = props.duration !== undefined ? props.duration : animation === "fade" ? 500 : 200;
    return {
        sx: props.sx !== undefined ? props.sx : {},
        className: props.className !== undefined ? props.className : "",
        children: props.children ? props.children : [],
        height: props.height,
        index: props.index !== undefined ? props.index : 0,
        strictIndexing: props.strictIndexing !== undefined ? props.strictIndexing : true,
        autoPlay: props.autoPlay !== undefined ? props.autoPlay : true,
        stopAutoPlayOnHover: props.stopAutoPlayOnHover !== undefined ? props.stopAutoPlayOnHover : true,
        interval: props.interval !== undefined ? props.interval : 4000,
        animation: animation,
        duration: duration,
        swipe: props.swipe !== undefined ? props.swipe : true,
        navButtonsAlwaysInvisible: props.navButtonsAlwaysInvisible !== undefined ? props.navButtonsAlwaysInvisible : false,
        navButtonsAlwaysVisible: props.navButtonsAlwaysVisible !== undefined ? props.navButtonsAlwaysVisible : false,
        cycleNavigation: props.cycleNavigation !== undefined ? props.cycleNavigation : true,
        fullHeightHover: props.fullHeightHover !== undefined ? props.fullHeightHover : true,
        navButtonsWrapperProps: (0, module.exports.sanitizeNavProps)(props.navButtonsWrapperProps),
        navButtonsProps: (0, module.exports.sanitizeNavProps)(props.navButtonsProps),
        NavButton: props.NavButton,
        NextIcon: props.NextIcon !== undefined ? props.NextIcon : $2736a8a64eceb0fd$var$react_1.default.createElement($2736a8a64eceb0fd$var$NavigateNext_1.default, null),
        PrevIcon: props.PrevIcon !== undefined ? props.PrevIcon : $2736a8a64eceb0fd$var$react_1.default.createElement($2736a8a64eceb0fd$var$NavigateBefore_1.default, null),
        indicators: props.indicators !== undefined ? props.indicators : true,
        indicatorContainerProps: (0, module.exports.sanitizeNavProps)(props.indicatorContainerProps),
        indicatorIconButtonProps: (0, module.exports.sanitizeNavProps)(props.indicatorIconButtonProps),
        activeIndicatorIconButtonProps: (0, module.exports.sanitizeNavProps)(props.activeIndicatorIconButtonProps),
        IndicatorIcon: props.IndicatorIcon,
        onChange: props.onChange !== undefined ? props.onChange : function() {},
        changeOnFirstRender: props.changeOnFirstRender !== undefined ? props.changeOnFirstRender : false,
        next: props.next !== undefined ? props.next : function() {},
        prev: props.prev !== undefined ? props.prev : function() {}
    };
};
module.exports.sanitizeProps = $2736a8a64eceb0fd$var$sanitizeProps;
var $2736a8a64eceb0fd$var$useInterval = function(callback, delay) {
    var savedCallback = (0, $2736a8a64eceb0fd$var$react_1.useRef)(function() {});
    // Remember the latest callback.
    (0, $2736a8a64eceb0fd$var$react_1.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $2736a8a64eceb0fd$var$react_1.useEffect)(function() {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function() {
                return clearInterval(id_1);
            };
        }
        return function() {};
    }, [
        delay
    ]);
};
module.exports.useInterval = $2736a8a64eceb0fd$var$useInterval;

});
parcelRequire.register("lXiC5", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ffbd8bdd341196c1$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $ffbd8bdd341196c1$var$_default = (0, $ffbd8bdd341196c1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");
module.exports.default = $ffbd8bdd341196c1$var$_default;

});

parcelRequire.register("2Fr3r", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f14658d0d6cbe57$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $1f14658d0d6cbe57$var$_default = (0, $1f14658d0d6cbe57$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");
module.exports.default = $1f14658d0d6cbe57$var$_default;

});



parcelRequire.register("jQ4lF", function(module, exports) {

$parcel$export(module.exports, "StyledCard", function () { return $498fd29c695c4448$export$94fdbc1f5368d5e4; });
$parcel$export(module.exports, "StyledCardLabel", function () { return $498fd29c695c4448$export$d69e8e89ba492243; });
$parcel$export(module.exports, "StyledBox", function () { return $498fd29c695c4448$export$d675f139b342d51a; });
$parcel$export(module.exports, "StyledContactBox", function () { return $498fd29c695c4448$export$e0497cbc30db1a8d; });
$parcel$export(module.exports, "StyledContact", function () { return $498fd29c695c4448$export$b5d7243ac0b03a2a; });
$parcel$export(module.exports, "StyledStack", function () { return $498fd29c695c4448$export$8a7fb03b17c12e52; });
$parcel$export(module.exports, "StyledNameTitle", function () { return $498fd29c695c4448$export$d1970b2f62ca11ff; });
$parcel$export(module.exports, "StyledBookingBox", function () { return $498fd29c695c4448$export$5a56e040ee93f282; });
$parcel$export(module.exports, "StyledAlert", function () { return $498fd29c695c4448$export$38fb881472c4cc64; });
$parcel$export(module.exports, "StyledStackPrice", function () { return $498fd29c695c4448$export$32b8291adee7fa33; });
$parcel$export(module.exports, "StyledImageContainer", function () { return $498fd29c695c4448$export$1fdc50e443dc776c; });
$parcel$export(module.exports, "StyledImage", function () { return $498fd29c695c4448$export$7722b1870d9eec03; });
$parcel$export(module.exports, "StyledCardContent", function () { return $498fd29c695c4448$export$598c1eea1a67754e; });
$parcel$export(module.exports, "StyledLabel", function () { return $498fd29c695c4448$export$eea83358d9434634; });
$parcel$export(module.exports, "IconBox", function () { return $498fd29c695c4448$export$7b426249814eb7c3; });
$parcel$export(module.exports, "Category", function () { return $498fd29c695c4448$export$3a8840c5b2ecf003; });
$parcel$export(module.exports, "TaxesInfo", function () { return $498fd29c695c4448$export$fb5a825b4a8fa41d; });
$parcel$export(module.exports, "TermsAndConditionsLink", function () { return $498fd29c695c4448$export$b75371bfad52fa39; });
$parcel$export(module.exports, "TermsAndConditionsLabel", function () { return $498fd29c695c4448$export$e8f32d8d9333f66d; });
$parcel$export(module.exports, "StyledFormControlLabel", function () { return $498fd29c695c4448$export$6f84060eb2f13a27; });
$parcel$export(module.exports, "PaymentMethodLabel", function () { return $498fd29c695c4448$export$6432ae93579fcd1; });
$parcel$export(module.exports, "CreditCardBox", function () { return $498fd29c695c4448$export$ba227bb46c42c066; });

var $6hfZk = parcelRequire("6hfZk");

var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
var $gsokU = parcelRequire("gsokU");
var $c1d0r = parcelRequire("c1d0r");
var $2MkI1 = parcelRequire("2MkI1");
var $3loMv = parcelRequire("3loMv");
let $498fd29c695c4448$var$_ = (t)=>t, $498fd29c695c4448$var$t, $498fd29c695c4448$var$t1, $498fd29c695c4448$var$t2, $498fd29c695c4448$var$t3, $498fd29c695c4448$var$t4, $498fd29c695c4448$var$t5, $498fd29c695c4448$var$t6, $498fd29c695c4448$var$t7, $498fd29c695c4448$var$t8, $498fd29c695c4448$var$t9, $498fd29c695c4448$var$t10, $498fd29c695c4448$var$t11, $498fd29c695c4448$var$t12, $498fd29c695c4448$var$t13, $498fd29c695c4448$var$t14, $498fd29c695c4448$var$t15, $498fd29c695c4448$var$t16, $498fd29c695c4448$var$t17, $498fd29c695c4448$var$t18, $498fd29c695c4448$var$t19, $498fd29c695c4448$var$t20, $498fd29c695c4448$var$t21;
const $498fd29c695c4448$export$94fdbc1f5368d5e4 = (0, $6hfZk.default)((0, $gsokU.default))($498fd29c695c4448$var$t || ($498fd29c695c4448$var$t = $498fd29c695c4448$var$_`
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow: hidden;
`));
const $498fd29c695c4448$export$d69e8e89ba492243 = (0, $6hfZk.default)((0, $3loMv.default))($498fd29c695c4448$var$t1 || ($498fd29c695c4448$var$t1 = $498fd29c695c4448$var$_`
    font-size: 16px !important;
    font-weight: bold !important;
`));
const $498fd29c695c4448$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($498fd29c695c4448$var$t2 || ($498fd29c695c4448$var$t2 = $498fd29c695c4448$var$_`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0 1rem;
    margin-top: 20px;
    margin-bottom: 20px;

    @media (max-width: 600px) {
        padding: 0;
    },
`));
const $498fd29c695c4448$export$e0497cbc30db1a8d = (0, $6hfZk.default)((0, $aili3.default))($498fd29c695c4448$var$t3 || ($498fd29c695c4448$var$t3 = $498fd29c695c4448$var$_`
    display: grid;
    grid-template-columns: 50% auto;
    align-items: center;
    gap: 0.3rem;
`));
const $498fd29c695c4448$export$b5d7243ac0b03a2a = (0, $6hfZk.default).p($498fd29c695c4448$var$t4 || ($498fd29c695c4448$var$t4 = $498fd29c695c4448$var$_`
    color: var(--black-087);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
`));
const $498fd29c695c4448$export$8a7fb03b17c12e52 = (0, $6hfZk.default).div($498fd29c695c4448$var$t5 || ($498fd29c695c4448$var$t5 = $498fd29c695c4448$var$_`
    display: grid;
    grid-template-columns: auto auto;
    gap: 0.75rem;
`));
const $498fd29c695c4448$export$d1970b2f62ca11ff = (0, $6hfZk.default).h2($498fd29c695c4448$var$t6 || ($498fd29c695c4448$var$t6 = $498fd29c695c4448$var$_`
    color: var(--black-087);
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
`));
const $498fd29c695c4448$export$5a56e040ee93f282 = (0, $6hfZk.default)((0, $aili3.default))($498fd29c695c4448$var$t7 || ($498fd29c695c4448$var$t7 = $498fd29c695c4448$var$_`
    border-right: 1px solid lightgrey;
`));
const $498fd29c695c4448$export$38fb881472c4cc64 = (0, $6hfZk.default)((0, $gC25j.default))($498fd29c695c4448$var$t8 || ($498fd29c695c4448$var$t8 = $498fd29c695c4448$var$_`
    border-radius: 6px !important;
`));
const $498fd29c695c4448$export$32b8291adee7fa33 = (0, $6hfZk.default).div($498fd29c695c4448$var$t9 || ($498fd29c695c4448$var$t9 = $498fd29c695c4448$var$_`
    display: grid;
    grid-template-columns: 50% auto;
    gap: 0.75rem;
    background-color: #ebf3ff;
    padding: 8px;
`));
const $498fd29c695c4448$export$1fdc50e443dc776c = (0, $6hfZk.default).div($498fd29c695c4448$var$t10 || ($498fd29c695c4448$var$t10 = $498fd29c695c4448$var$_`
    margin: -1rem -1.5rem 0rem -1.5rem;
`));
const $498fd29c695c4448$export$7722b1870d9eec03 = (0, $6hfZk.default).img($498fd29c695c4448$var$t11 || ($498fd29c695c4448$var$t11 = $498fd29c695c4448$var$_`
    height: 104px;
    width: 100%;
    object-fit: cover;
    object-position: 0 50%;
`));
const $498fd29c695c4448$export$598c1eea1a67754e = (0, $6hfZk.default)((0, $c1d0r.default))($498fd29c695c4448$var$t12 || ($498fd29c695c4448$var$t12 = $498fd29c695c4448$var$_`
    display: flex !important;
    flex-direction: column;
    gap: 8px;
    padding: 8px !important;
`));
const $498fd29c695c4448$export$eea83358d9434634 = (0, $6hfZk.default).p($498fd29c695c4448$var$t13 || ($498fd29c695c4448$var$t13 = $498fd29c695c4448$var$_`
    color: var(--black-058);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    margin: 0;
`));
const $498fd29c695c4448$export$7b426249814eb7c3 = (0, $6hfZk.default).div($498fd29c695c4448$var$t14 || ($498fd29c695c4448$var$t14 = $498fd29c695c4448$var$_`
    display: flex;
    align-items: center;
    gap: 0.2rem;
`));
const $498fd29c695c4448$export$3a8840c5b2ecf003 = (0, $6hfZk.default).span($498fd29c695c4448$var$t15 || ($498fd29c695c4448$var$t15 = $498fd29c695c4448$var$_`
    text-transform: capitalize;
`));
const $498fd29c695c4448$export$fb5a825b4a8fa41d = (0, $6hfZk.default).p($498fd29c695c4448$var$t16 || ($498fd29c695c4448$var$t16 = $498fd29c695c4448$var$_`
    color: var(--black-058);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0;
`));
const $498fd29c695c4448$export$b75371bfad52fa39 = (0, $6hfZk.default).span($498fd29c695c4448$var$t17 || ($498fd29c695c4448$var$t17 = $498fd29c695c4448$var$_`
    font-size: 16px;
`));
const $498fd29c695c4448$export$e8f32d8d9333f66d = (0, $6hfZk.default).p($498fd29c695c4448$var$t18 || ($498fd29c695c4448$var$t18 = $498fd29c695c4448$var$_`
    color: var(--custom-secondary);
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
`));
const $498fd29c695c4448$export$6f84060eb2f13a27 = (0, $6hfZk.default)((0, $2MkI1.default))($498fd29c695c4448$var$t19 || ($498fd29c695c4448$var$t19 = $498fd29c695c4448$var$_`
    margin-right: 0 !important;
`));
const $498fd29c695c4448$export$6432ae93579fcd1 = (0, $6hfZk.default).div($498fd29c695c4448$var$t20 || ($498fd29c695c4448$var$t20 = $498fd29c695c4448$var$_`
    color: var(--black-06);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    display: flex;
    width: 460px;
    justify-content: space-between;

    @media (max-width: 600px) {
        width: 280px;
    },
`));
const $498fd29c695c4448$export$ba227bb46c42c066 = (0, $6hfZk.default)((0, $aili3.default))($498fd29c695c4448$var$t21 || ($498fd29c695c4448$var$t21 = $498fd29c695c4448$var$_`
    display: flex;
    gap: 8px;
`));

});
parcelRequire.register("6hfZk", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $4920bb85ed07bfd6$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $4920bb85ed07bfd6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "keyframes", function () { return $4920bb85ed07bfd6$export$d25ddfdf17c3ad3e; });

var $6GrTf = parcelRequire("6GrTf");
parcelRequire("9YmaI");

var $7fPBF = parcelRequire("7fPBF");

var $6m9fa = parcelRequire("6m9fa");

var $hCFAy = parcelRequire("hCFAy");

var $cfR4M = parcelRequire("cfR4M");

var $4ZL0H = parcelRequire("4ZL0H");
var $4920bb85ed07bfd6$var$f = ("undefined" != typeof $4ZL0H && void 0 !== $4ZL0H.env && undefined, "data-styled"), $4920bb85ed07bfd6$export$83d89fbfd8236492 = "6.0.7", $4920bb85ed07bfd6$var$y = "undefined" != typeof window && "HTMLElement" in window, $4920bb85ed07bfd6$var$v = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $4ZL0H && $4ZL0H.env, "undefined" != typeof $4ZL0H && $4ZL0H.env, false)), $4920bb85ed07bfd6$var$g = {}, $4920bb85ed07bfd6$var$S = /invalid hook call/i, $4920bb85ed07bfd6$var$w = new Set, $4920bb85ed07bfd6$var$b = function(t, n) {
    var o, s, i, a, e;
}, $4920bb85ed07bfd6$var$E = Object.freeze([]), $4920bb85ed07bfd6$var$N = Object.freeze({});
function $4920bb85ed07bfd6$var$P(e, t, n) {
    return void 0 === n && (n = $4920bb85ed07bfd6$var$N), e.theme !== n.theme && e.theme || t || n.theme;
}
var $4920bb85ed07bfd6$var$_ = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $4920bb85ed07bfd6$var$C = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $4920bb85ed07bfd6$var$I = /(^-|-$)/g;
function $4920bb85ed07bfd6$var$A(e) {
    return e.replace($4920bb85ed07bfd6$var$C, "-").replace($4920bb85ed07bfd6$var$I, "");
}
var $4920bb85ed07bfd6$var$O = /(a)(d)/gi, $4920bb85ed07bfd6$var$D = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $4920bb85ed07bfd6$var$R(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $4920bb85ed07bfd6$var$D(t % 52) + n;
    return ($4920bb85ed07bfd6$var$D(t % 52) + n).replace($4920bb85ed07bfd6$var$O, "$1-$2");
}
var $4920bb85ed07bfd6$var$T, $4920bb85ed07bfd6$var$k = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $4920bb85ed07bfd6$var$j = function(e) {
    return $4920bb85ed07bfd6$var$k(5381, e);
};
function $4920bb85ed07bfd6$var$x(e) {
    return $4920bb85ed07bfd6$var$R($4920bb85ed07bfd6$var$j(e) >>> 0);
}
function $4920bb85ed07bfd6$var$V(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $4920bb85ed07bfd6$var$M(e) {
    return "string" == typeof e && true;
}
var $4920bb85ed07bfd6$var$F = "function" == typeof Symbol && Symbol.for, $4920bb85ed07bfd6$var$$ = $4920bb85ed07bfd6$var$F ? Symbol.for("react.memo") : 60115, $4920bb85ed07bfd6$var$z = $4920bb85ed07bfd6$var$F ? Symbol.for("react.forward_ref") : 60112, $4920bb85ed07bfd6$var$B = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $4920bb85ed07bfd6$var$L = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $4920bb85ed07bfd6$var$G = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $4920bb85ed07bfd6$var$Y = (($4920bb85ed07bfd6$var$T = {})[$4920bb85ed07bfd6$var$z] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $4920bb85ed07bfd6$var$T[$4920bb85ed07bfd6$var$$] = $4920bb85ed07bfd6$var$G, $4920bb85ed07bfd6$var$T);
function $4920bb85ed07bfd6$var$W(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $4920bb85ed07bfd6$var$$ ? $4920bb85ed07bfd6$var$G : "$$typeof" in e ? $4920bb85ed07bfd6$var$Y[e.$$typeof] : $4920bb85ed07bfd6$var$B;
}
var $4920bb85ed07bfd6$var$q = Object.defineProperty, $4920bb85ed07bfd6$var$H = Object.getOwnPropertyNames, $4920bb85ed07bfd6$var$U = Object.getOwnPropertySymbols, $4920bb85ed07bfd6$var$J = Object.getOwnPropertyDescriptor, $4920bb85ed07bfd6$var$X = Object.getPrototypeOf, $4920bb85ed07bfd6$var$Z = Object.prototype;
function $4920bb85ed07bfd6$var$K(e, t, n) {
    if ("string" != typeof t) {
        if ($4920bb85ed07bfd6$var$Z) {
            var o = $4920bb85ed07bfd6$var$X(t);
            o && o !== $4920bb85ed07bfd6$var$Z && $4920bb85ed07bfd6$var$K(e, o, n);
        }
        var r = $4920bb85ed07bfd6$var$H(t);
        $4920bb85ed07bfd6$var$U && (r = r.concat($4920bb85ed07bfd6$var$U(t)));
        for(var s = $4920bb85ed07bfd6$var$W(e), i = $4920bb85ed07bfd6$var$W(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $4920bb85ed07bfd6$var$L || n && n[c] || i && c in i || s && c in s)) {
                var l = $4920bb85ed07bfd6$var$J(t, c);
                try {
                    $4920bb85ed07bfd6$var$q(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $4920bb85ed07bfd6$var$Q(e) {
    return "function" == typeof e;
}
function $4920bb85ed07bfd6$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $4920bb85ed07bfd6$var$te(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $4920bb85ed07bfd6$var$ne(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $4920bb85ed07bfd6$var$oe(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $4920bb85ed07bfd6$var$re(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$4920bb85ed07bfd6$var$oe(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $4920bb85ed07bfd6$var$re(e[o], t[o]);
    else if ($4920bb85ed07bfd6$var$oe(t)) for(var o in t)e[o] = $4920bb85ed07bfd6$var$re(e[o], t[o]);
    return e;
}
function $4920bb85ed07bfd6$var$se(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $4920bb85ed07bfd6$var$ie = {};
function $4920bb85ed07bfd6$var$ae() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $4920bb85ed07bfd6$var$ce(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $4920bb85ed07bfd6$var$le = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $4920bb85ed07bfd6$var$ce(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat("/*!sc*/\n");
        return t;
    }, e;
}(), $4920bb85ed07bfd6$var$ue = new Map, $4920bb85ed07bfd6$var$pe = new Map, $4920bb85ed07bfd6$var$de = 1, $4920bb85ed07bfd6$var$he = function(e) {
    if ($4920bb85ed07bfd6$var$ue.has(e)) return $4920bb85ed07bfd6$var$ue.get(e);
    for(; $4920bb85ed07bfd6$var$pe.has($4920bb85ed07bfd6$var$de);)$4920bb85ed07bfd6$var$de++;
    var t = $4920bb85ed07bfd6$var$de++;
    return $4920bb85ed07bfd6$var$ue.set(e, t), $4920bb85ed07bfd6$var$pe.set(t, e), t;
}, $4920bb85ed07bfd6$var$fe = function(e, t) {
    $4920bb85ed07bfd6$var$ue.set(e, t), $4920bb85ed07bfd6$var$pe.set(t, e);
}, $4920bb85ed07bfd6$var$me = "style[".concat($4920bb85ed07bfd6$var$f, "][").concat("data-styled-version", '="').concat("6.0.7", '"]'), $4920bb85ed07bfd6$var$ye = new RegExp("^".concat($4920bb85ed07bfd6$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $4920bb85ed07bfd6$var$ve = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $4920bb85ed07bfd6$var$ge = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split("/*!sc*/\n"), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($4920bb85ed07bfd6$var$ye);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($4920bb85ed07bfd6$var$fe(u, l), $4920bb85ed07bfd6$var$ve(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $4920bb85ed07bfd6$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $4920bb85ed07bfd6$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($4920bb85ed07bfd6$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($4920bb85ed07bfd6$var$f, "active"), o.setAttribute("data-styled-version", "6.0.7");
    var i = $4920bb85ed07bfd6$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $4920bb85ed07bfd6$var$be = function() {
    function e(e) {
        this.element = $4920bb85ed07bfd6$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $4920bb85ed07bfd6$var$ce(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $4920bb85ed07bfd6$var$Ee = function() {
    function e(e) {
        this.element = $4920bb85ed07bfd6$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $4920bb85ed07bfd6$var$Ne = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $4920bb85ed07bfd6$var$Pe = $4920bb85ed07bfd6$var$y, $4920bb85ed07bfd6$var$_e = {
    isServer: !$4920bb85ed07bfd6$var$y,
    useCSSOMInjection: !$4920bb85ed07bfd6$var$v
}, $4920bb85ed07bfd6$var$Ce = function() {
    function e(e, n, o) {
        void 0 === e && (e = $4920bb85ed07bfd6$var$N), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, $4920bb85ed07bfd6$var$_e), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $4920bb85ed07bfd6$var$y && $4920bb85ed07bfd6$var$Pe && ($4920bb85ed07bfd6$var$Pe = !1, function(e) {
            for(var t = document.querySelectorAll($4920bb85ed07bfd6$var$me), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && "active" !== r.getAttribute($4920bb85ed07bfd6$var$f) && ($4920bb85ed07bfd6$var$ge(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $4920bb85ed07bfd6$var$se(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $4920bb85ed07bfd6$var$pe.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($4920bb85ed07bfd6$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat("/*!sc*/\n");
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $4920bb85ed07bfd6$var$he(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $4920bb85ed07bfd6$var$Ne(n) : t ? new $4920bb85ed07bfd6$var$be(n) : new $4920bb85ed07bfd6$var$Ee(n);
        }(this.options), new $4920bb85ed07bfd6$var$le(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($4920bb85ed07bfd6$var$he(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($4920bb85ed07bfd6$var$he(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($4920bb85ed07bfd6$var$he(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $4920bb85ed07bfd6$var$Ie = /&/g, $4920bb85ed07bfd6$var$Ae = /^\s*\/\/.*$/gm;
function $4920bb85ed07bfd6$var$Oe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $4920bb85ed07bfd6$var$Oe(e.children, t)), e;
    });
}
function $4920bb85ed07bfd6$var$De(e) {
    var t, n, o, r = void 0 === e ? $4920bb85ed07bfd6$var$N : e, s = r.options, i = void 0 === s ? $4920bb85ed07bfd6$var$N : s, a = r.plugins, c = void 0 === a ? $4920bb85ed07bfd6$var$E : a, l = function(e, o, r) {
        return r === n || r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $hCFAy.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace($4920bb85ed07bfd6$var$Ie, n).replace(o, l));
    }), i.prefix && u.push($hCFAy.prefixer), u.push($hCFAy.stringify);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($4920bb85ed07bfd6$var$Ae, ""), l = $hCFAy.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $4920bb85ed07bfd6$var$Oe(l, i.namespace));
        var p = [];
        return $hCFAy.serialize(l, $hCFAy.middleware(u.concat($hCFAy.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $4920bb85ed07bfd6$var$ce(15), $4920bb85ed07bfd6$var$k(e, t.name);
    }, 5381).toString() : "", p;
}
var $4920bb85ed07bfd6$var$Re = new $4920bb85ed07bfd6$var$Ce, $4920bb85ed07bfd6$var$Te = $4920bb85ed07bfd6$var$De(), $4920bb85ed07bfd6$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $4920bb85ed07bfd6$var$Re,
    stylis: $4920bb85ed07bfd6$var$Te
}), $4920bb85ed07bfd6$export$91317688fc694efa = $4920bb85ed07bfd6$export$8c190ef828af4c86.Consumer, $4920bb85ed07bfd6$var$xe = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(void 0);
function $4920bb85ed07bfd6$var$Ve() {
    return (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$8c190ef828af4c86);
}
function $4920bb85ed07bfd6$export$a473771da2f0ff7c(e) {
    var t = (0, $7fPBF.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $4920bb85ed07bfd6$var$Ve().styleSheet, l = (0, $7fPBF.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $7fPBF.useMemo)(function() {
        return $4920bb85ed07bfd6$var$De({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    return (0, $7fPBF.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6m9fa)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$8c190ef828af4c86.Provider, {
        value: {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$var$xe.Provider, {
        value: u
    }, e.children));
}
var $4920bb85ed07bfd6$var$Fe = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $4920bb85ed07bfd6$var$Te);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $4920bb85ed07bfd6$var$se(this, function() {
            throw $4920bb85ed07bfd6$var$ce(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $4920bb85ed07bfd6$var$Te), this.name + e.hash;
    }, e;
}(), $4920bb85ed07bfd6$var$$e = function(e) {
    return e >= "A" && e <= "Z";
};
function $4920bb85ed07bfd6$var$ze(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $4920bb85ed07bfd6$var$$e(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $4920bb85ed07bfd6$var$Be = function(e) {
    return null == e || !1 === e || "" === e;
}, $4920bb85ed07bfd6$var$Le = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$4920bb85ed07bfd6$var$Be(i) && (Array.isArray(i) && i.isCss || $4920bb85ed07bfd6$var$Q(i) ? r.push("".concat($4920bb85ed07bfd6$var$ze(s), ":"), i, ";") : $4920bb85ed07bfd6$var$oe(i) ? r.push.apply(r, (0, $6GrTf.__spreadArray)((0, $6GrTf.__spreadArray)([
            "".concat(s, " {")
        ], $4920bb85ed07bfd6$var$Le(i), !1), [
            "}"
        ], !1)) : r.push("".concat($4920bb85ed07bfd6$var$ze(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $cfR4M.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $4920bb85ed07bfd6$var$Ge(e, t, n, o) {
    if ($4920bb85ed07bfd6$var$Be(e)) return [];
    if ($4920bb85ed07bfd6$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($4920bb85ed07bfd6$var$Q(e)) {
        if (!$4920bb85ed07bfd6$var$Q(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $4920bb85ed07bfd6$var$Ge(r, t, n, o);
    }
    var s;
    return e instanceof $4920bb85ed07bfd6$var$Fe ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $4920bb85ed07bfd6$var$oe(e) ? $4920bb85ed07bfd6$var$Le(e) : Array.isArray(e) ? Array.prototype.concat.apply($4920bb85ed07bfd6$var$E, e.map(function(e) {
        return $4920bb85ed07bfd6$var$Ge(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $4920bb85ed07bfd6$var$Ye(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($4920bb85ed07bfd6$var$Q(n) && !$4920bb85ed07bfd6$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $4920bb85ed07bfd6$var$We = $4920bb85ed07bfd6$var$j("6.0.7"), $4920bb85ed07bfd6$var$qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $4920bb85ed07bfd6$var$Ye(e), this.componentId = t, this.baseHash = $4920bb85ed07bfd6$var$k($4920bb85ed07bfd6$var$We, t), this.baseStyle = n, $4920bb85ed07bfd6$var$Ce.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $4920bb85ed07bfd6$var$te(o, this.staticRulesId);
            else {
                var r = $4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$var$Ge(this.rules, e, t, n)), s = $4920bb85ed07bfd6$var$R($4920bb85ed07bfd6$var$k(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $4920bb85ed07bfd6$var$te(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $4920bb85ed07bfd6$var$k(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$var$Ge(u, e, t, n));
                    a = $4920bb85ed07bfd6$var$k(a, p), c += p;
                }
            }
            if (c) {
                var d = $4920bb85ed07bfd6$var$R(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $4920bb85ed07bfd6$var$te(o, d);
            }
        }
        return o;
    }, e;
}(), $4920bb85ed07bfd6$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(void 0), $4920bb85ed07bfd6$export$b631efc24e9d5e2f = $4920bb85ed07bfd6$export$2c657da244d00bd6.Consumer;
function $4920bb85ed07bfd6$export$93d4e7f90805808f() {
    var e = (0, $7fPBF.useContext)($4920bb85ed07bfd6$export$2c657da244d00bd6);
    if (!e) throw $4920bb85ed07bfd6$var$ce(18);
    return e;
}
function $4920bb85ed07bfd6$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), r = (0, $7fPBF.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $4920bb85ed07bfd6$var$ce(14);
            if ($4920bb85ed07bfd6$var$Q(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $4920bb85ed07bfd6$var$ce(8);
            return n ? (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $4920bb85ed07bfd6$var$Ze = {}, $4920bb85ed07bfd6$var$Ke = new Set;
function $4920bb85ed07bfd6$var$Qe(e, r, s) {
    var i = $4920bb85ed07bfd6$export$7ba318d8d2f06c76(e), a = e, c = !$4920bb85ed07bfd6$var$M(e), p = r.attrs, d = void 0 === p ? $4920bb85ed07bfd6$var$E : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $4920bb85ed07bfd6$var$A(e);
        $4920bb85ed07bfd6$var$Ze[n] = ($4920bb85ed07bfd6$var$Ze[n] || 0) + 1;
        var o = "".concat(n, "-").concat($4920bb85ed07bfd6$var$x("6.0.7" + n + $4920bb85ed07bfd6$var$Ze[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $4920bb85ed07bfd6$var$M(e) ? "styled.".concat(e) : "Styled(".concat($4920bb85ed07bfd6$var$V(e), ")");
    }(e) : m, v = r.displayName && r.componentId ? "".concat($4920bb85ed07bfd6$var$A(r.displayName), "-").concat(r.componentId) : r.componentId || f, g = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, S = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var w = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var C = r.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && C(e, t);
            };
        } else S = w;
    }
    var I = new $4920bb85ed07bfd6$var$qe(s, v, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), m = $4920bb85ed07bfd6$var$Ve(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = function(e, n, o) {
                for(var r, s = (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $4920bb85ed07bfd6$var$Q(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $4920bb85ed07bfd6$var$te(s[c], a[c]) : "style" === c ? (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $4920bb85ed07bfd6$var$te(s.className, n.className)), s;
            }(i, r, $4920bb85ed07bfd6$var$P(r, f, c) || $4920bb85ed07bfd6$var$N), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w || ("forwardedAs" === w ? S.as = v.forwardedAs : y && !y(w, g) || (S[w] = v[w], y));
            var b = function(e, t) {
                var n = $4920bb85ed07bfd6$var$Ve(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, v);
            var E = $4920bb85ed07bfd6$var$te(p, d);
            return b && (E += " " + b), v.className && (E += " " + v.className), S[$4920bb85ed07bfd6$var$M(g) && !$4920bb85ed07bfd6$var$_.has(g) ? "class" : "className"] = E, S.ref = s, (0, $7fPBF.createElement)(g, S);
        }(D, e, r);
    }
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(O);
    return D.attrs = g, D.componentStyle = I, D.shouldForwardProp = S, D.foldedComponentIds = i ? $4920bb85ed07bfd6$var$te(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = v, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$4920bb85ed07bfd6$var$re(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $4920bb85ed07bfd6$var$se(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $4920bb85ed07bfd6$var$K(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $4920bb85ed07bfd6$var$et(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $4920bb85ed07bfd6$var$tt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $4920bb85ed07bfd6$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($4920bb85ed07bfd6$var$Q(t) || $4920bb85ed07bfd6$var$oe(t)) {
        var r = t;
        return $4920bb85ed07bfd6$var$tt($4920bb85ed07bfd6$var$Ge($4920bb85ed07bfd6$var$et($4920bb85ed07bfd6$var$E, (0, $6GrTf.__spreadArray)([
            r
        ], n, !0))));
    }
    var s = t;
    return 0 === n.length && 1 === s.length && "string" == typeof s[0] ? $4920bb85ed07bfd6$var$Ge(s) : $4920bb85ed07bfd6$var$tt($4920bb85ed07bfd6$var$Ge($4920bb85ed07bfd6$var$et(s, n)));
}
function $4920bb85ed07bfd6$var$ot(n, o, r) {
    if (void 0 === r && (r = $4920bb85ed07bfd6$var$N), !o) throw $4920bb85ed07bfd6$var$ce(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, (0, $6GrTf.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $4920bb85ed07bfd6$var$ot(n, o, (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $4920bb85ed07bfd6$var$ot(n, o, (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, r), e));
    }, s;
}
var $4920bb85ed07bfd6$var$rt = function(e) {
    return $4920bb85ed07bfd6$var$ot($4920bb85ed07bfd6$var$Qe, e);
}, $4920bb85ed07bfd6$export$2e2bcd8739ae039 = $4920bb85ed07bfd6$var$rt;
$4920bb85ed07bfd6$var$_.forEach(function(e) {
    $4920bb85ed07bfd6$export$2e2bcd8739ae039[e] = $4920bb85ed07bfd6$var$rt(e);
});
var $4920bb85ed07bfd6$var$it = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $4920bb85ed07bfd6$var$Ye(e), $4920bb85ed07bfd6$var$Ce.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$var$Ge(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $4920bb85ed07bfd6$var$Ce.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $4920bb85ed07bfd6$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, (0, $6GrTf.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat($4920bb85ed07bfd6$var$x(JSON.stringify(i))), c = new $4920bb85ed07bfd6$var$it(i, a);
    var l = function(e) {
        var t = $4920bb85ed07bfd6$var$Ve(), n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $4920bb85ed07bfd6$var$g, o, s);
        else {
            var i = (0, $6GrTf.__assign)((0, $6GrTf.__assign)({}, n), {
                theme: $4920bb85ed07bfd6$var$P(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo(l);
}
function $4920bb85ed07bfd6$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $4920bb85ed07bfd6$var$ne($4920bb85ed07bfd6$export$dbf350e5966cf602.apply(void 0, (0, $6GrTf.__spreadArray)([
        t
    ], n, !1))), s = $4920bb85ed07bfd6$var$x(r);
    return new $4920bb85ed07bfd6$var$Fe(s, r);
}
function $4920bb85ed07bfd6$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(n, r) {
        var s = $4920bb85ed07bfd6$var$P(n, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($4920bb85ed07bfd6$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(e, (0, $6GrTf.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return $4920bb85ed07bfd6$var$K(n, e);
}
var $4920bb85ed07bfd6$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $4920bb85ed07bfd6$var$Se(), o = $4920bb85ed07bfd6$var$ne([
                n && 'nonce="'.concat(n, '"'),
                "".concat($4920bb85ed07bfd6$var$f, '="true"'),
                "".concat("data-styled-version", '="').concat("6.0.7", '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $4920bb85ed07bfd6$var$ce(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $4920bb85ed07bfd6$var$ce(2);
            var r = ((n = {})[$4920bb85ed07bfd6$var$f] = "", n["data-styled-version"] = "6.0.7", n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $4920bb85ed07bfd6$var$Se();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("style", (0, $6GrTf.__assign)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $4920bb85ed07bfd6$var$Ce({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $4920bb85ed07bfd6$var$ce(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4920bb85ed07bfd6$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $4920bb85ed07bfd6$var$ce(3);
    }, e;
}(), $4920bb85ed07bfd6$export$5c87cfe6c475f500 = {
    StyleSheet: $4920bb85ed07bfd6$var$Ce,
    mainSheet: $4920bb85ed07bfd6$var$Re
};
var $4920bb85ed07bfd6$var$dt = "__sc-".concat($4920bb85ed07bfd6$var$f, "__");

});
parcelRequire.register("6GrTf", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $4ddc4cb13cba28a5$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__spreadArray", function () { return $4ddc4cb13cba28a5$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4ddc4cb13cba28a5$var$extendStatics = function(d, b) {
    $4ddc4cb13cba28a5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4ddc4cb13cba28a5$var$extendStatics(d, b);
};
function $4ddc4cb13cba28a5$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4ddc4cb13cba28a5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4ddc4cb13cba28a5$export$18ce0697a983be9b = function() {
    $4ddc4cb13cba28a5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ddc4cb13cba28a5$export$18ce0697a983be9b.apply(this, arguments);
};
function $4ddc4cb13cba28a5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4ddc4cb13cba28a5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4ddc4cb13cba28a5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4ddc4cb13cba28a5$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4ddc4cb13cba28a5$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4ddc4cb13cba28a5$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4ddc4cb13cba28a5$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4ddc4cb13cba28a5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4ddc4cb13cba28a5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4ddc4cb13cba28a5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4ddc4cb13cba28a5$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4ddc4cb13cba28a5$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4ddc4cb13cba28a5$export$45d3717a4c69092e(o, m, p);
}
function $4ddc4cb13cba28a5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4ddc4cb13cba28a5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4ddc4cb13cba28a5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4ddc4cb13cba28a5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4ddc4cb13cba28a5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4ddc4cb13cba28a5$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4ddc4cb13cba28a5$export$10c90e4f7922046c(v) {
    return this instanceof $4ddc4cb13cba28a5$export$10c90e4f7922046c ? (this.v = v, this) : new $4ddc4cb13cba28a5$export$10c90e4f7922046c(v);
}
function $4ddc4cb13cba28a5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4ddc4cb13cba28a5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4ddc4cb13cba28a5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4ddc4cb13cba28a5$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4ddc4cb13cba28a5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4ddc4cb13cba28a5$export$19a8beecd37a4c45 === "function" ? $4ddc4cb13cba28a5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4ddc4cb13cba28a5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4ddc4cb13cba28a5$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4ddc4cb13cba28a5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4ddc4cb13cba28a5$export$45d3717a4c69092e(result, mod, k);
    }
    $4ddc4cb13cba28a5$var$__setModuleDefault(result, mod);
    return result;
}
function $4ddc4cb13cba28a5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4ddc4cb13cba28a5$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4ddc4cb13cba28a5$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4ddc4cb13cba28a5$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4ddc4cb13cba28a5$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4ddc4cb13cba28a5$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4ddc4cb13cba28a5$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4ddc4cb13cba28a5$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4ddc4cb13cba28a5$export$2e2bcd8739ae039 = {
    __extends: $4ddc4cb13cba28a5$export$a8ba968b8961cb8a,
    __assign: $4ddc4cb13cba28a5$export$18ce0697a983be9b,
    __rest: $4ddc4cb13cba28a5$export$3c9a16f847548506,
    __decorate: $4ddc4cb13cba28a5$export$29e00dfd3077644b,
    __param: $4ddc4cb13cba28a5$export$d5ad3fd78186038f,
    __metadata: $4ddc4cb13cba28a5$export$f1db080c865becb9,
    __awaiter: $4ddc4cb13cba28a5$export$1050f835b63b671e,
    __generator: $4ddc4cb13cba28a5$export$67ebef60e6f28a6,
    __createBinding: $4ddc4cb13cba28a5$export$45d3717a4c69092e,
    __exportStar: $4ddc4cb13cba28a5$export$f33643c0debef087,
    __values: $4ddc4cb13cba28a5$export$19a8beecd37a4c45,
    __read: $4ddc4cb13cba28a5$export$8d051b38c9118094,
    __spread: $4ddc4cb13cba28a5$export$afc72e2116322959,
    __spreadArrays: $4ddc4cb13cba28a5$export$6388937ca91ccae8,
    __spreadArray: $4ddc4cb13cba28a5$export$1216008129fb82ed,
    __await: $4ddc4cb13cba28a5$export$10c90e4f7922046c,
    __asyncGenerator: $4ddc4cb13cba28a5$export$e427f37a30a4de9b,
    __asyncDelegator: $4ddc4cb13cba28a5$export$bbd80228419bb833,
    __asyncValues: $4ddc4cb13cba28a5$export$e3b29a3d6162315f,
    __makeTemplateObject: $4ddc4cb13cba28a5$export$4fb47efe1390b86f,
    __importStar: $4ddc4cb13cba28a5$export$c21735bcef00d192,
    __importDefault: $4ddc4cb13cba28a5$export$da59b14a69baef04,
    __classPrivateFieldGet: $4ddc4cb13cba28a5$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4ddc4cb13cba28a5$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4ddc4cb13cba28a5$export$81fdc39f203e4e04,
    __addDisposableResource: $4ddc4cb13cba28a5$export$88ac25d8e944e405,
    __disposeResources: $4ddc4cb13cba28a5$export$8f076105dc360e92
};

});

parcelRequire.register("6m9fa", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRequire.register("hCFAy", function(module, exports) {

$parcel$export(module.exports, "RULESET", function () { return $224fb5bfd01f6fb6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "compile", function () { return $224fb5bfd01f6fb6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $224fb5bfd01f6fb6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $224fb5bfd01f6fb6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $224fb5bfd01f6fb6$export$38bcb760f1d4871c; });
$parcel$export(module.exports, "prefixer", function () { return $224fb5bfd01f6fb6$export$e08c7d021b829b7a; });
var $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 = "-ms-";
var $224fb5bfd01f6fb6$export$2c0f367103c8d01c = "-moz-";
var $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 = "-webkit-";
var $224fb5bfd01f6fb6$export$a29989082612d0d9 = "comm";
var $224fb5bfd01f6fb6$export$aa3a2e812ca8570d = "rule";
var $224fb5bfd01f6fb6$export$527d108ccf083c2b = "decl";
var $224fb5bfd01f6fb6$export$d3d35020fa5b54f0 = "@page";
var $224fb5bfd01f6fb6$export$500415a86c544f73 = "@media";
var $224fb5bfd01f6fb6$export$a763edbf796b780a = "@import";
var $224fb5bfd01f6fb6$export$2790aeb8b4e5c826 = "@charset";
var $224fb5bfd01f6fb6$export$1cc683e23b84b133 = "@viewport";
var $224fb5bfd01f6fb6$export$9447a5efea57e862 = "@supports";
var $224fb5bfd01f6fb6$export$ef011b4e114b1fba = "@document";
var $224fb5bfd01f6fb6$export$6aad947bda0f3f46 = "@namespace";
var $224fb5bfd01f6fb6$export$b44a8529a35fcb60 = "@keyframes";
var $224fb5bfd01f6fb6$export$2c16de31893252e6 = "@font-face";
var $224fb5bfd01f6fb6$export$3d846dd52e150c6f = "@counter-style";
var $224fb5bfd01f6fb6$export$22314bfbb57653fe = "@font-feature-values";
var $224fb5bfd01f6fb6$export$d773506282b3cfe6 = "@layer";
var $224fb5bfd01f6fb6$export$2335f513bbd82c6d = Math.abs;
var $224fb5bfd01f6fb6$export$6788812c4e6611e6 = String.fromCharCode;
var $224fb5bfd01f6fb6$export$e6e34fd1f2686227 = Object.assign;
function $224fb5bfd01f6fb6$export$d6af199866bfb566(e, r) {
    return $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 0)) << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 1)) << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 2)) << 2 ^ $224fb5bfd01f6fb6$export$a9db5e087081082d(e, 3) : 0;
}
function $224fb5bfd01f6fb6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $224fb5bfd01f6fb6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $224fb5bfd01f6fb6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $224fb5bfd01f6fb6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $224fb5bfd01f6fb6$export$36776f635604f274(e) {
    return e.length;
}
function $224fb5bfd01f6fb6$export$f9084667e487ed46(e) {
    return e.length;
}
function $224fb5bfd01f6fb6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $224fb5bfd01f6fb6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $224fb5bfd01f6fb6$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$224fb5bfd01f6fb6$export$4659b591c19bdf3d(e, r);
    });
}
var $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c = 1;
var $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1;
var $224fb5bfd01f6fb6$export$f24224f1c91d8156 = 0;
var $224fb5bfd01f6fb6$export$5880b8b5730aff45 = 0;
var $224fb5bfd01f6fb6$export$c0306caf338ac095 = 0;
var $224fb5bfd01f6fb6$export$30a86d91af8ff6e6 = "";
function $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c,
        column: $224fb5bfd01f6fb6$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $224fb5bfd01f6fb6$export$784d13d8ee351f07(e, r) {
    return $224fb5bfd01f6fb6$export$e6e34fd1f2686227($224fb5bfd01f6fb6$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $224fb5bfd01f6fb6$export$590e8b2c435046d9(e) {
    while(e.root)e = $224fb5bfd01f6fb6$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $224fb5bfd01f6fb6$export$10d8903dec122b9d(e, e.siblings);
}
function $224fb5bfd01f6fb6$export$eba6f6f03b0a92e7() {
    return $224fb5bfd01f6fb6$export$c0306caf338ac095;
}
function $224fb5bfd01f6fb6$export$232faf9add678146() {
    $224fb5bfd01f6fb6$export$c0306caf338ac095 = $224fb5bfd01f6fb6$export$5880b8b5730aff45 > 0 ? $224fb5bfd01f6fb6$export$a9db5e087081082d($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, --$224fb5bfd01f6fb6$export$5880b8b5730aff45) : 0;
    if ($224fb5bfd01f6fb6$export$4e0c71f277ca26b3--, $224fb5bfd01f6fb6$export$c0306caf338ac095 === 10) $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1, $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c--;
    return $224fb5bfd01f6fb6$export$c0306caf338ac095;
}
function $224fb5bfd01f6fb6$export$48cfd1e771a65c4f() {
    $224fb5bfd01f6fb6$export$c0306caf338ac095 = $224fb5bfd01f6fb6$export$5880b8b5730aff45 < $224fb5bfd01f6fb6$export$f24224f1c91d8156 ? $224fb5bfd01f6fb6$export$a9db5e087081082d($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, $224fb5bfd01f6fb6$export$5880b8b5730aff45++) : 0;
    if ($224fb5bfd01f6fb6$export$4e0c71f277ca26b3++, $224fb5bfd01f6fb6$export$c0306caf338ac095 === 10) $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1, $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c++;
    return $224fb5bfd01f6fb6$export$c0306caf338ac095;
}
function $224fb5bfd01f6fb6$export$4d3fb11e950abb9e() {
    return $224fb5bfd01f6fb6$export$a9db5e087081082d($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, $224fb5bfd01f6fb6$export$5880b8b5730aff45);
}
function $224fb5bfd01f6fb6$export$e88cb2efb12ae807() {
    return $224fb5bfd01f6fb6$export$5880b8b5730aff45;
}
function $224fb5bfd01f6fb6$export$58adb3bec8346d0f(e, r) {
    return $224fb5bfd01f6fb6$export$2f35ab04d2335697($224fb5bfd01f6fb6$export$30a86d91af8ff6e6, e, r);
}
function $224fb5bfd01f6fb6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $224fb5bfd01f6fb6$export$2de70f21292aac9e(e) {
    return $224fb5bfd01f6fb6$export$53f1d5ea8de3d7c = $224fb5bfd01f6fb6$export$4e0c71f277ca26b3 = 1, $224fb5bfd01f6fb6$export$f24224f1c91d8156 = $224fb5bfd01f6fb6$export$36776f635604f274($224fb5bfd01f6fb6$export$30a86d91af8ff6e6 = e), $224fb5bfd01f6fb6$export$5880b8b5730aff45 = 0, [];
}
function $224fb5bfd01f6fb6$export$45918ac1574455b1(e) {
    return $224fb5bfd01f6fb6$export$30a86d91af8ff6e6 = "", e;
}
function $224fb5bfd01f6fb6$export$410ac95b9ec204b8(e) {
    return $224fb5bfd01f6fb6$export$87c2784dc9fc4ab($224fb5bfd01f6fb6$export$58adb3bec8346d0f($224fb5bfd01f6fb6$export$5880b8b5730aff45 - 1, $224fb5bfd01f6fb6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $224fb5bfd01f6fb6$export$660b2ee2d4fb4eff(e) {
    return $224fb5bfd01f6fb6$export$45918ac1574455b1($224fb5bfd01f6fb6$export$5f8c09e3ae6f64e1($224fb5bfd01f6fb6$export$2de70f21292aac9e(e)));
}
function $224fb5bfd01f6fb6$export$7af1228ff777d175(e) {
    while($224fb5bfd01f6fb6$export$c0306caf338ac095 = $224fb5bfd01f6fb6$export$4d3fb11e950abb9e())if ($224fb5bfd01f6fb6$export$c0306caf338ac095 < 33) $224fb5bfd01f6fb6$export$48cfd1e771a65c4f();
    else break;
    return $224fb5bfd01f6fb6$export$9e1725a4cfeada27(e) > 2 || $224fb5bfd01f6fb6$export$9e1725a4cfeada27($224fb5bfd01f6fb6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $224fb5bfd01f6fb6$export$5f8c09e3ae6f64e1(e) {
    while($224fb5bfd01f6fb6$export$48cfd1e771a65c4f())switch($224fb5bfd01f6fb6$export$9e1725a4cfeada27($224fb5bfd01f6fb6$export$c0306caf338ac095)){
        case 0:
            $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$c2ab62c7bf24634($224fb5bfd01f6fb6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$410ac95b9ec204b8($224fb5bfd01f6fb6$export$c0306caf338ac095), e);
            break;
        default:
            $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$6788812c4e6611e6($224fb5bfd01f6fb6$export$c0306caf338ac095), e);
    }
    return e;
}
function $224fb5bfd01f6fb6$export$955ba06d119e085e(e, r) {
    while(--r && $224fb5bfd01f6fb6$export$48cfd1e771a65c4f())if ($224fb5bfd01f6fb6$export$c0306caf338ac095 < 48 || $224fb5bfd01f6fb6$export$c0306caf338ac095 > 102 || $224fb5bfd01f6fb6$export$c0306caf338ac095 > 57 && $224fb5bfd01f6fb6$export$c0306caf338ac095 < 65 || $224fb5bfd01f6fb6$export$c0306caf338ac095 > 70 && $224fb5bfd01f6fb6$export$c0306caf338ac095 < 97) break;
    return $224fb5bfd01f6fb6$export$58adb3bec8346d0f(e, $224fb5bfd01f6fb6$export$e88cb2efb12ae807() + (r < 6 && $224fb5bfd01f6fb6$export$4d3fb11e950abb9e() == 32 && $224fb5bfd01f6fb6$export$48cfd1e771a65c4f() == 32));
}
function $224fb5bfd01f6fb6$export$c889f2fcc19dbf12(e) {
    while($224fb5bfd01f6fb6$export$48cfd1e771a65c4f())switch($224fb5bfd01f6fb6$export$c0306caf338ac095){
        case e:
            return $224fb5bfd01f6fb6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $224fb5bfd01f6fb6$export$c889f2fcc19dbf12($224fb5bfd01f6fb6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $224fb5bfd01f6fb6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $224fb5bfd01f6fb6$export$48cfd1e771a65c4f();
            break;
    }
    return $224fb5bfd01f6fb6$export$5880b8b5730aff45;
}
function $224fb5bfd01f6fb6$export$4254d4e2b3745c4c(e, r) {
    while($224fb5bfd01f6fb6$export$48cfd1e771a65c4f())if (e + $224fb5bfd01f6fb6$export$c0306caf338ac095 === 57) break;
    else if (e + $224fb5bfd01f6fb6$export$c0306caf338ac095 === 84 && $224fb5bfd01f6fb6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $224fb5bfd01f6fb6$export$58adb3bec8346d0f(r, $224fb5bfd01f6fb6$export$5880b8b5730aff45 - 1) + "*" + $224fb5bfd01f6fb6$export$6788812c4e6611e6(e === 47 ? e : $224fb5bfd01f6fb6$export$48cfd1e771a65c4f());
}
function $224fb5bfd01f6fb6$export$c2ab62c7bf24634(e) {
    while(!$224fb5bfd01f6fb6$export$9e1725a4cfeada27($224fb5bfd01f6fb6$export$4d3fb11e950abb9e()))$224fb5bfd01f6fb6$export$48cfd1e771a65c4f();
    return $224fb5bfd01f6fb6$export$58adb3bec8346d0f(e, $224fb5bfd01f6fb6$export$5880b8b5730aff45);
}
function $224fb5bfd01f6fb6$export$ef7acd7185315e22(e) {
    return $224fb5bfd01f6fb6$export$45918ac1574455b1($224fb5bfd01f6fb6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $224fb5bfd01f6fb6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $224fb5bfd01f6fb6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var m = c;
    var x = s;
    var y = n;
    var j = k;
    while(w)switch(h = g, g = $224fb5bfd01f6fb6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $224fb5bfd01f6fb6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($224fb5bfd01f6fb6$export$f8e21b1e77979a08(j += $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $224fb5bfd01f6fb6$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $224fb5bfd01f6fb6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $224fb5bfd01f6fb6$export$955ba06d119e085e($224fb5bfd01f6fb6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($224fb5bfd01f6fb6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$4a34f930e789283c($224fb5bfd01f6fb6$export$4254d4e2b3745c4c($224fb5bfd01f6fb6$export$48cfd1e771a65c4f(), $224fb5bfd01f6fb6$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $224fb5bfd01f6fb6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $224fb5bfd01f6fb6$export$36776f635604f274(j) - l) $224fb5bfd01f6fb6$export$10d8903dec122b9d(p > 32 ? $224fb5bfd01f6fb6$export$f8483753829ec8f3(j + ";", n, a, l - 1, i) : $224fb5bfd01f6fb6$export$f8483753829ec8f3($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $224fb5bfd01f6fb6$export$10d8903dec122b9d(y = $224fb5bfd01f6fb6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, k, m = [], x = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $224fb5bfd01f6fb6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $224fb5bfd01f6fb6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $224fb5bfd01f6fb6$export$98e6a39c04603d36(e, y, y, n && $224fb5bfd01f6fb6$export$10d8903dec122b9d($224fb5bfd01f6fb6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, k, c, m = [], l, x), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $224fb5bfd01f6fb6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = j = "", l = t;
            break;
        case 58:
            l = 1 + $224fb5bfd01f6fb6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $224fb5bfd01f6fb6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $224fb5bfd01f6fb6$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($224fb5bfd01f6fb6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($224fb5bfd01f6fb6$export$4d3fb11e950abb9e() === 45) j += $224fb5bfd01f6fb6$export$410ac95b9ec204b8($224fb5bfd01f6fb6$export$48cfd1e771a65c4f());
                    v = $224fb5bfd01f6fb6$export$4d3fb11e950abb9e(), o = l = $224fb5bfd01f6fb6$export$36776f635604f274(k = j += $224fb5bfd01f6fb6$export$c2ab62c7bf24634($224fb5bfd01f6fb6$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $224fb5bfd01f6fb6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $224fb5bfd01f6fb6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $224fb5bfd01f6fb6$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, p + 1, p = $224fb5bfd01f6fb6$export$2335f513bbd82c6d(d = u[w])), x = e; $ < b; ++$)if (x = $224fb5bfd01f6fb6$export$87c2784dc9fc4ab(d > 0 ? h[$] + " " + m : $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(m, /&\f/g, h[$]))) f[g++] = x;
    return $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, s === 0 ? $224fb5bfd01f6fb6$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $224fb5bfd01f6fb6$export$4a34f930e789283c(e, r, a, c) {
    return $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, $224fb5bfd01f6fb6$export$a29989082612d0d9, $224fb5bfd01f6fb6$export$6788812c4e6611e6($224fb5bfd01f6fb6$export$eba6f6f03b0a92e7()), $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $224fb5bfd01f6fb6$export$f8483753829ec8f3(e, r, a, n, c) {
    return $224fb5bfd01f6fb6$export$35059013cd4a06db(e, r, a, $224fb5bfd01f6fb6$export$527d108ccf083c2b, $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, 0, n), $224fb5bfd01f6fb6$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $224fb5bfd01f6fb6$export$82e9f45cca5ba907(n, c, s) {
    switch($224fb5bfd01f6fb6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $224fb5bfd01f6fb6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "box-$1$2" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-item-" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$224fb5bfd01f6fb6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "grid-row-" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-line-pack" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "box-" + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "box-pack:$3" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$224fb5bfd01f6fb6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "grid-column-align" + $224fb5bfd01f6fb6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $224fb5bfd01f6fb6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$224fb5bfd01f6fb6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$224fb5bfd01f6fb6$export$f8e21b1e77979a08(s, "span") ? $224fb5bfd01f6fb6$export$4659b591c19bdf3d(s, /\d+/) : +$224fb5bfd01f6fb6$export$4659b591c19bdf3d(s, /\d+/) - +$224fb5bfd01f6fb6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $224fb5bfd01f6fb6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($224fb5bfd01f6fb6$export$36776f635604f274(n) - 1 - c > 6) switch($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$224fb5bfd01f6fb6$export$f8e21b1e77979a08(n, "stretch") ? $224fb5bfd01f6fb6$export$82e9f45cca5ba907($224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, c + 6) === 121) return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, ":", ":" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($224fb5bfd01f6fb6$export$a9db5e087081082d(n, $224fb5bfd01f6fb6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + ($224fb5bfd01f6fb6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, ":", ":" + $224fb5bfd01f6fb6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $224fb5bfd01f6fb6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $224fb5bfd01f6fb6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $224fb5bfd01f6fb6$export$a763edbf796b780a:
        case $224fb5bfd01f6fb6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $224fb5bfd01f6fb6$export$a29989082612d0d9:
            return "";
        case $224fb5bfd01f6fb6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $224fb5bfd01f6fb6$export$aa3a2e812ca8570d:
            if (!$224fb5bfd01f6fb6$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $224fb5bfd01f6fb6$export$36776f635604f274(a = $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $224fb5bfd01f6fb6$export$5a7767152ae0305f(e) {
    var r = $224fb5bfd01f6fb6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $224fb5bfd01f6fb6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $224fb5bfd01f6fb6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $224fb5bfd01f6fb6$export$527d108ccf083c2b:
                n.return = $224fb5bfd01f6fb6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $224fb5bfd01f6fb6$export$b44a8529a35fcb60:
                return $224fb5bfd01f6fb6$export$dfdc1655ccc5b9cb([
                    $224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                        value: $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $224fb5bfd01f6fb6$export$aa3a2e812ca8570d:
                if (n.length) return $224fb5bfd01f6fb6$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($224fb5bfd01f6fb6$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$e6e34fd1f2686227(n, {
                                props: $224fb5bfd01f6fb6$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $224fb5bfd01f6fb6$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $224fb5bfd01f6fb6$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    $224fb5bfd01f6fb6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $224fb5bfd01f6fb6$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$590e8b2c435046d9($224fb5bfd01f6fb6$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $224fb5bfd01f6fb6$export$e6e34fd1f2686227(n, {
                                props: $224fb5bfd01f6fb6$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $224fb5bfd01f6fb6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $224fb5bfd01f6fb6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $224fb5bfd01f6fb6$export$1be1fc439b849fdf($224fb5bfd01f6fb6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($224fb5bfd01f6fb6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $224fb5bfd01f6fb6$export$2f35ab04d2335697(r, 1, $224fb5bfd01f6fb6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $224fb5bfd01f6fb6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $224fb5bfd01f6fb6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $224fb5bfd01f6fb6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = "browser";
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ""; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3a3153321729209f$var$process.cwd = function() {
    return "/";
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("gC25j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c181cff0789717b3$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $a2ay0 = parcelRequire("a2ay0");

var $7pK2a = parcelRequire("7pK2a");

var $8TDId = parcelRequire("8TDId");

var $6rSdx = parcelRequire("6rSdx");

var $etS48 = parcelRequire("etS48");

var $eNWP4 = parcelRequire("eNWP4");

var $kVEJr = parcelRequire("kVEJr");

var $bVWI3 = parcelRequire("bVWI3");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c181cff0789717b3$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $c181cff0789717b3$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $b6UUh.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7pK2a.getAlertUtilityClass), classes);
};
const $c181cff0789717b3$var$AlertRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $cxeT8.darken) : (0, $cxeT8.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $cxeT8.lighten) : (0, $cxeT8.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $kY3Ke.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $7pK2a.default).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "outlined" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $7pK2a.default).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "filled" && (0, $kY3Ke.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $c181cff0789717b3$var$AlertIcon = (0, $kDBhE.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $c181cff0789717b3$var$AlertMessage = (0, $kDBhE.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $c181cff0789717b3$var$AlertAction = (0, $kDBhE.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $c181cff0789717b3$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6rSdx.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $etS48.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eNWP4.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kVEJr.default), {
        fontSize: "inherit"
    })
};
const $c181cff0789717b3$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $c181cff0789717b3$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $c181cff0789717b3$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $c181cff0789717b3$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $8TDId.default);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $bVWI3.default);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($c181cff0789717b3$var$AlertRoot, (0, $kY3Ke.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $c181cff0789717b3$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(AlertCloseButton, (0, $kY3Ke.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(AlertCloseIcon, (0, $kY3Ke.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $c181cff0789717b3$export$2e2bcd8739ae039 = $c181cff0789717b3$var$Alert;

});
parcelRequire.register("a2ay0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e245c78e363f11$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $ckFUN = parcelRequire("ckFUN");

var $5j2OD = parcelRequire("5j2OD");


var $giMq6 = parcelRequire("giMq6");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $giMq6.getPaperUtilityClass), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $kDBhE.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kY3Ke.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $kY3Ke.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $cxeT8.alpha)("#fff", (0, $ckFUN.default)(ownerState.elevation))}, ${(0, $cxeT8.alpha)("#fff", (0, $ckFUN.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $cFLic.default)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;

});
parcelRequire.register("ckFUN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa7ddbbf42193a7$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;

});

parcelRequire.register("giMq6", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $bde3e2fffcaea664$export$29cdb466b9b6f20b; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $k6RDS.default)("MuiPaper", slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $4jzsB.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;

});


parcelRequire.register("7pK2a", function(module, exports) {

$parcel$export(module.exports, "getAlertUtilityClass", function () { return $565e939c768ed837$export$69aecd24bc2cf7e3; });
$parcel$export(module.exports, "default", function () { return $565e939c768ed837$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $565e939c768ed837$export$69aecd24bc2cf7e3(slot) {
    return (0, $k6RDS.default)("MuiAlert", slot);
}
const $565e939c768ed837$var$alertClasses = (0, $4jzsB.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $565e939c768ed837$export$2e2bcd8739ae039 = $565e939c768ed837$var$alertClasses;

});

parcelRequire.register("6rSdx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b1f521fdeb04ba7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $4b1f521fdeb04ba7$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");

});

parcelRequire.register("etS48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8adb66ebb93bcb3$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $a8adb66ebb93bcb3$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");

});

parcelRequire.register("eNWP4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac73453dd233d58d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $ac73453dd233d58d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");

});

parcelRequire.register("kVEJr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3c8ba0a935153e4$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $f3c8ba0a935153e4$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");

});

parcelRequire.register("bVWI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b028f185c60f26d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $8b028f185c60f26d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

});


parcelRequire.register("aili3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77ec199cefd4182a$export$2e2bcd8739ae039; });

var $ggBKj = parcelRequire("ggBKj");


var $kU6nt = parcelRequire("kU6nt");

var $hmhHQ = parcelRequire("hmhHQ");

var $jwhZE = parcelRequire("jwhZE");
"use client";
const $77ec199cefd4182a$var$defaultTheme = (0, $hmhHQ.default)();
const $77ec199cefd4182a$var$Box = (0, $ggBKj.default)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $kU6nt.default).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;

});
parcelRequire.register("ggBKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd7b6b8695507478$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $mqrnX = parcelRequire("mqrnX");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $4kWyf.default)(defaultTheme);
        const _extendSxProp = (0, $mqrnX.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $cFLic.default)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, (0, $kY3Ke.default)({
            as: component,
            ref: ref,
            className: (0, $hngXp.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});


parcelRequire.register("gsokU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb223886c302418$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $a2ay0 = parcelRequire("a2ay0");

var $bgCoQ = parcelRequire("bgCoQ");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bfb223886c302418$var$_excluded = [
    "className",
    "raised"
];
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bgCoQ.getCardUtilityClass), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $cFLic.default)(props, $bfb223886c302418$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        raised: raised
    });
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bfb223886c302418$var$CardRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;

});
parcelRequire.register("bgCoQ", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", function () { return $833ef9b800b82ea7$export$f3b76d2cce458caa; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $k6RDS.default)("MuiCard", slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $4jzsB.default)("MuiCard", [
    "root"
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;

});


parcelRequire.register("c1d0r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bffaacbbee0c705$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $gIW00 = parcelRequire("gIW00");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $8bffaacbbee0c705$var$_excluded = [
    "className",
    "component"
];
const $8bffaacbbee0c705$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $gIW00.getCardContentUtilityClass), classes);
};
const $8bffaacbbee0c705$var$CardContentRoot = (0, $kDBhE.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $8bffaacbbee0c705$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $cFLic.default)(props, $8bffaacbbee0c705$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component
    });
    const classes = $8bffaacbbee0c705$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8bffaacbbee0c705$var$CardContentRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8bffaacbbee0c705$export$2e2bcd8739ae039 = $8bffaacbbee0c705$var$CardContent;

});
parcelRequire.register("gIW00", function(module, exports) {

$parcel$export(module.exports, "getCardContentUtilityClass", function () { return $c2cdbecd165cb878$export$964336739a8c7119; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $c2cdbecd165cb878$export$964336739a8c7119(slot) {
    return (0, $k6RDS.default)("MuiCardContent", slot);
}
const $c2cdbecd165cb878$var$cardContentClasses = (0, $4jzsB.default)("MuiCardContent", [
    "root"
]);
var $c2cdbecd165cb878$export$2e2bcd8739ae039 = $c2cdbecd165cb878$var$cardContentClasses;

});


parcelRequire.register("2MkI1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $206020d7e70b2617$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $2jx1n = parcelRequire("2jx1n");

var $hG0Cb = parcelRequire("hG0Cb");

var $3loMv = parcelRequire("3loMv");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $aL9SA = parcelRequire("aL9SA");

var $jHiZl = parcelRequire("jHiZl");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $206020d7e70b2617$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $206020d7e70b2617$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $b6UUh.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $aL9SA.getFormControlLabelUtilityClasses), classes);
};
const $206020d7e70b2617$export$1b479270917a5676 = (0, $kDBhE.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $aL9SA.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $b6UUh.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $aL9SA.default).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $aL9SA.default).label}`]: {
            [`&.${(0, $aL9SA.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $206020d7e70b2617$var$AsteriskComponent = (0, $kDBhE.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $aL9SA.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $206020d7e70b2617$var$FormControlLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $cFLic.default)(props, $206020d7e70b2617$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $206020d7e70b2617$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $3loMv.default) && !disableTypography) label = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), (0, $kY3Ke.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $hngXp.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($206020d7e70b2617$export$1b479270917a5676, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                direction: "row",
                alignItems: "center",
                children: [
                    label,
                    /*#__PURE__*/ (0, $bbzbN.jsxs)($206020d7e70b2617$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            " ",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $206020d7e70b2617$export$2e2bcd8739ae039 = $206020d7e70b2617$var$FormControlLabel;

});
parcelRequire.register("2jx1n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1af6f86e160474f0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $kPqR2 = parcelRequire("kPqR2");
"use client";
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $kPqR2.default));
}

});
parcelRequire.register("kPqR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f29d66cab44a33c0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;

});


parcelRequire.register("aL9SA", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", function () { return $7d55f5085d222c99$export$717666c39ec07e12; });
$parcel$export(module.exports, "default", function () { return $7d55f5085d222c99$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $7d55f5085d222c99$export$717666c39ec07e12(slot) {
    return (0, $k6RDS.default)("MuiFormControlLabel", slot);
}
const $7d55f5085d222c99$var$formControlLabelClasses = (0, $4jzsB.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $7d55f5085d222c99$export$2e2bcd8739ae039 = $7d55f5085d222c99$var$formControlLabelClasses;

});

parcelRequire.register("jHiZl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e570c333aacea667$export$2e2bcd8739ae039; });
function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});



parcelRequire.register("g9bTP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc16b792e42cac5d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $4kWyf = parcelRequire("4kWyf");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");
"use client";
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $4kWyf.default)((0, $9P91Y.default));
    return theme[0, $jwhZE.default] || theme;
}

});

parcelRequire.register("8m7Fi", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof b;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new b(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var b = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, f = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(f), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return O.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return O.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return O.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return O.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return O.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return O.s(e.$s, 2, "0");
                        case "SSS":
                            return O.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = O.p(d), m = w(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return O.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : O.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), _ = b.prototype;
    return w.prototype = _, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        _[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, b, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});

});

parcelRequire.register("dkKmP", function(module, exports) {

$parcel$export(module.exports, "AppButton", function () { return $973015287f8dded5$export$a60bf519950b9485; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $hkfYR = parcelRequire("hkfYR");
const $973015287f8dded5$export$a60bf519950b9485 = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hkfYR.ButtonStyled), {
        ...props
    });
};

});
parcelRequire.register("hkfYR", function(module, exports) {

$parcel$export(module.exports, "ButtonStyled", function () { return $72b3ceaa1f9f74a5$export$f1c4195fa4a48d90; });

var $5ZeKC = parcelRequire("5ZeKC");

var $6hfZk = parcelRequire("6hfZk");
let $72b3ceaa1f9f74a5$var$_ = (t)=>t, $72b3ceaa1f9f74a5$var$t;
const $72b3ceaa1f9f74a5$export$f1c4195fa4a48d90 = (0, $6hfZk.default)((0, $5ZeKC.default))($72b3ceaa1f9f74a5$var$t || ($72b3ceaa1f9f74a5$var$t = $72b3ceaa1f9f74a5$var$_`
    height: 44px;
    box-shadow: none;
`));

});
parcelRequire.register("5ZeKC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45be1777d6a28263$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $aNaIu = parcelRequire("aNaIu");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $3RNaF = parcelRequire("3RNaF");

var $b6UUh = parcelRequire("b6UUh");

var $grOnY = parcelRequire("grOnY");

var $5zBGX = parcelRequire("5zBGX");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`,
            `${variant}Size${(0, $b6UUh.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $grOnY.getButtonUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $kY3Ke.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $kY3Ke.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $grOnY.default).focusVisible}`]: (0, $kY3Ke.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $grOnY.default).disabled}`]: (0, $kY3Ke.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $cxeT8.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $grOnY.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $grOnY.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $kDBhE.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $kDBhE.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $5zBGX.default));
    const resolvedProps = (0, $aNaIu.default)(contextProps, inProps);
    const props = (0, $5j2OD.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $cFLic.default)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $kY3Ke.default)({
        ownerState: ownerState,
        className: (0, $hngXp.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;

});
parcelRequire.register("grOnY", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $bf96407f1f5b4126$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $bf96407f1f5b4126$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $k6RDS.default)("MuiButton", slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $4jzsB.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;

});

parcelRequire.register("5zBGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40ed7573a59c2be9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;

});




parcelRequire.register("afCHG", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $6935625ff631eef8$export$f5b8910cec6cf069; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $6S70g = parcelRequire("6S70g");

var $aili3 = parcelRequire("aili3");
const $6935625ff631eef8$export$f5b8910cec6cf069 = ({ hasLabelTop: hasLabelTop, labelTop: labelTop, labelTopRequired: labelTopRequired = false, ...props })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        sx: {
            width: "100%"
        },
        children: [
            hasLabelTop && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6S70g.InputLabelStyled), {
                required: labelTopRequired,
                children: labelTop
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6S70g.TextFieldStyled), {
                ...props
            })
        ]
    });
};

});
parcelRequire.register("6S70g", function(module, exports) {

$parcel$export(module.exports, "TextFieldStyled", function () { return $31cbae42624dc36b$export$bec18608def21161; });
$parcel$export(module.exports, "InputLabelStyled", function () { return $31cbae42624dc36b$export$8017afc8f549e301; });

var $f6ezL = parcelRequire("f6ezL");

var $lHSFU = parcelRequire("lHSFU");

var $kDBhE = parcelRequire("kDBhE");
let $31cbae42624dc36b$var$_ = (t)=>t, $31cbae42624dc36b$var$t;
const $31cbae42624dc36b$export$bec18608def21161 = (0, $kDBhE.default)((0, $f6ezL.default))(({ theme: theme, error: error })=>({
        fontSize: "1rem",
        width: "100%",
        borderRadius: 4,
        background: error ? "transparent" : "white",
        "::before": {
            borderBottomStyle: "none"
        },
        "& .MuiInputBase-root": {
            background: theme.palette.background.paper
        },
        "& .MuiOutlinedInput-root": {
            borderColor: "transparent",
            background: error ? "#ffebee" : "white"
        },
        "& .Mui-disabled": {
            backgroundColor: "var(--grey-lighten-3)",
            "& .Mui-disabled:before": {
                borderBottomStyle: "none"
            }
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: error ? "red" : "transparent !important",
            boxShadow: "var(--default-boxShadow)"
        },
        "& .MuiFilledInput-root": {
            borderRadius: 4,
            "::after": {
                borderBottomStyle: "none"
            }
        },
        "& .MuiFilledInput-input": {
            borderRadius: 4,
            border: error ? "1px solid red" : "none",
            background: error ? "#ffebee" : "white"
        },
        "& .MuiError": {
            background: theme.palette.background.paper,
            borderRadius: 4
        },
        "& .MuiFormHelperText-root": {
            color: error ? "red" : "#424242"
        },
        "& .Mui-error": {
            "::before": {
                borderBottomStyle: "none"
            }
        }
    }));
const $31cbae42624dc36b$export$8017afc8f549e301 = (0, $kDBhE.default)((0, $lHSFU.default))($31cbae42624dc36b$var$t || ($31cbae42624dc36b$var$t = $31cbae42624dc36b$var$_`
    line-height: 2rem;
    color: var(--custom-secondary);
    font-size: 1rem;

    .MuiInputLabel-asterisk {
        color: red;
    }
`));

});
parcelRequire.register("f6ezL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe2b905acb8b9f6$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $jiLAb = parcelRequire("jiLAb");

var $lxNRp = parcelRequire("lxNRp");

var $6WEW6 = parcelRequire("6WEW6");

var $lHSFU = parcelRequire("lHSFU");

var $3jMGu = parcelRequire("3jMGu");

var $gFr0F = parcelRequire("gFr0F");

var $jh0sD = parcelRequire("jh0sD");

var $1VsKU = parcelRequire("1VsKU");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $afe2b905acb8b9f6$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $jiLAb.default),
    filled: (0, $lxNRp.default),
    outlined: (0, $6WEW6.default)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1VsKU.getTextFieldUtilityClass), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $kDBhE.default)((0, $3jMGu.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $cFLic.default)(props, $afe2b905acb8b9f6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $65Itt.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $bbzbN.jsx)(InputComponent, (0, $kY3Ke.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onClick: onClick,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($afe2b905acb8b9f6$var$TextFieldRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), (0, $kY3Ke.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jh0sD.default), (0, $kY3Ke.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFr0F.default), (0, $kY3Ke.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;

});
parcelRequire.register("65Itt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f5b561912058f9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
let $46f5b561912058f9$var$globalId = 0;
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $46f5b561912058f9$var$maybeReactUseId = $7fPBF["useId".toString()];
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}

});

parcelRequire.register("jiLAb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d49bb29c2f8b76$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $dYkRa = parcelRequire("dYkRa");

var $g1o71 = parcelRequire("g1o71");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $eFvie = parcelRequire("eFvie");

var $g1o71 = parcelRequire("g1o71");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e0d49bb29c2f8b76$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $eFvie.getInputUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $g1o71.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kY3Ke.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $eFvie.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $eFvie.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $eFvie.default).disabled}, .${(0, $eFvie.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $eFvie.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $e0d49bb29c2f8b76$var$InputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $e0d49bb29c2f8b76$var$_excluded);
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dYkRa.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e0d49bb29c2f8b76$var$Input.muiName = "Input";
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;

});
parcelRequire.register("g1o71", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $ba9f7182d6802613$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $ba9f7182d6802613$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $ba9f7182d6802613$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $ba9f7182d6802613$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $ba9f7182d6802613$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $e5zLi = parcelRequire("e5zLi");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $7HQQ4 = parcelRequire("7HQQ4");
var $d8zSb = parcelRequire("d8zSb");
var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $kPqR2 = parcelRequire("kPqR2");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $6NwTb = parcelRequire("6NwTb");

var $hQtyv = parcelRequire("hQtyv");

var $eaAgo = parcelRequire("eaAgo");

var $87FKv = parcelRequire("87FKv");

var $3HkEr = parcelRequire("3HkEr");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ba9f7182d6802613$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $3HkEr.getInputBaseUtilityClass), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $kDBhE.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $3HkEr.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $ba9f7182d6802613$export$a1ad29c901026019 = (0, $kDBhE.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $kY3Ke.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kY3Ke.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $3HkEr.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $3HkEr.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $ba9f7182d6802613$var$inputGlobalStyles = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eaAgo.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $cFLic.default)(props, $ba9f7182d6802613$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $6NwTb.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $87FKv.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $hQtyv.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $e5zLi.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick && !fcs.disabled) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $kY3Ke.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kY3Ke.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $d8zSb.TextareaAutosize);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$a1ad29c901026019;
    inputProps = (0, $kY3Ke.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $ba9f7182d6802613$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $7HQQ4.isHostComponent)(Root) && {
                ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $hngXp.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Input, (0, $kY3Ke.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $7HQQ4.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kY3Ke.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $hngXp.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kY3Ke.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;

});
parcelRequire.register("7HQQ4", function(module, exports) {

$parcel$export(module.exports, "isHostComponent", function () { return $59c589404b20ab2d$export$e28348cc2430497; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $59c589404b20ab2d$export$e28348cc2430497(element) {
    return typeof element === "string";
}

});

parcelRequire.register("d8zSb", function(module, exports) {

$parcel$export(module.exports, "TextareaAutosize", function () { return $9907d957cc1b52b6$export$d1710922ecaf577a; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $fw0lo = parcelRequire("fw0lo");

var $gHrsh = parcelRequire("gHrsh");
var $gE56a = parcelRequire("gE56a");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9907d957cc1b52b6$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $9907d957cc1b52b6$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $9907d957cc1b52b6$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $9907d957cc1b52b6$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $9907d957cc1b52b6$export$d1710922ecaf577a = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cFLic.default)(props, $9907d957cc1b52b6$var$_excluded);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(forwardedRef, inputRef);
    const shadowRef = $7fPBF.useRef(null);
    const renders = $7fPBF.useRef(0);
    const [state, setState] = $7fPBF.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $7fPBF.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $gE56a.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingBottom) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.paddingTop);
        const border = $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderBottomWidth) + $9907d957cc1b52b6$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $7fPBF.useCallback(()=>{
        const newState = getUpdatedState();
        if ($9907d957cc1b52b6$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($9907d957cc1b52b6$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $fw0lo.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $7fPBF.useEffect(()=>{
        const handleResize = (0, $gHrsh.default)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $gE56a.default)(input);
        containerWindow.addEventListener("resize", handleResize);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $lJRRs.default)(()=>{
        syncHeight();
    });
    $7fPBF.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", (0, $kY3Ke.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $kY3Ke.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $kY3Ke.default)({}, $9907d957cc1b52b6$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

});
parcelRequire.register("gHrsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c285f587ed4585eb$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRequire.register("gE56a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e4563498af7952$export$2e2bcd8739ae039; });

var $4CS7n = parcelRequire("4CS7n");
function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $4CS7n.default)(node);
    return doc.defaultView || window;
}

});
parcelRequire.register("4CS7n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e4b0c27d76b933$export$2e2bcd8739ae039; });
function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRequire.register("hQtyv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfde3819487a0686$export$2e2bcd8739ae039; });

var $lJRRs = parcelRequire("lJRRs");
"use client";
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $lJRRs.default);

});

parcelRequire.register("eaAgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a50e20ff7f02e09b$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $krgTN = parcelRequire("krgTN");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $krgTN.default), (0, $kY3Ke.default)({}, props, {
        defaultTheme: (0, $9P91Y.default),
        themeId: (0, $jwhZE.default)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;

});
parcelRequire.register("krgTN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee13700d4d997375$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");

var $4kWyf = parcelRequire("4kWyf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $4kWyf.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;

});


parcelRequire.register("87FKv", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $5e9f5ca6e3e911fc$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRequire.register("3HkEr", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $2b15682cef07fc0a$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $2b15682cef07fc0a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $k6RDS.default)("MuiInputBase", slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $4jzsB.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;

});


parcelRequire.register("eFvie", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $aadd2b32ac43594b$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $aadd2b32ac43594b$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $k6RDS.default)("MuiInput", slot);
}
const $aadd2b32ac43594b$var$inputClasses = (0, $kY3Ke.default)({}, (0, $3HkEr.default), (0, $4jzsB.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;

});


parcelRequire.register("lxNRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf35b44bb61ebfd$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $dYkRa = parcelRequire("dYkRa");


var $cFCqu = parcelRequire("cFCqu");

var $g1o71 = parcelRequire("g1o71");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $gImJ8 = parcelRequire("gImJ8");

var $g1o71 = parcelRequire("g1o71");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $faf35b44bb61ebfd$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $gImJ8.getFilledInputUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $g1o71.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $kY3Ke.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $gImJ8.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $gImJ8.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $gImJ8.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $gImJ8.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $gImJ8.default).disabled}, .${(0, $gImJ8.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $gImJ8.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $faf35b44bb61ebfd$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dYkRa.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$faf35b44bb61ebfd$var$FilledInput.muiName = "Input";
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;

});
parcelRequire.register("gImJ8", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $c2b262889cde4af1$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $c2b262889cde4af1$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $k6RDS.default)("MuiFilledInput", slot);
}
const $c2b262889cde4af1$var$filledInputClasses = (0, $kY3Ke.default)({}, (0, $3HkEr.default), (0, $4jzsB.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;

});


parcelRequire.register("6WEW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50e7e9efec2c0b8c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $cFCqu = parcelRequire("cFCqu");

var $eYwIX = parcelRequire("eYwIX");

var $2jx1n = parcelRequire("2jx1n");

var $jHiZl = parcelRequire("jHiZl");

var $kDBhE = parcelRequire("kDBhE");

var $lCN2y = parcelRequire("lCN2y");

var $g1o71 = parcelRequire("g1o71");

var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $50e7e9efec2c0b8c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $lCN2y.getOutlinedInputUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $kDBhE.default)((0, $g1o71.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $g1o71.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $kY3Ke.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $lCN2y.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $lCN2y.default).focused} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $lCN2y.default).error} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $lCN2y.default).disabled} .${(0, $lCN2y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $kDBhE.default)((0, $eYwIX.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $kDBhE.default)((0, $g1o71.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $g1o71.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $cFLic.default)(props, $50e7e9efec2c0b8c$var$_excluded);
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $50e7e9efec2c0b8c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g1o71.default), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bbzbN.jsx)($50e7e9efec2c0b8c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kY3Ke.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = "Input";
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;

});
parcelRequire.register("eYwIX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae700d9709d2b786$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $kDBhE.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $kDBhE.default)("legend")(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kY3Ke.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cFLic.default)(props, $ae700d9709d2b786$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, (0, $kY3Ke.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}

});

parcelRequire.register("lCN2y", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $fbe32ff46b8bf823$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $fbe32ff46b8bf823$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");

var $3HkEr = parcelRequire("3HkEr");
function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $k6RDS.default)("MuiOutlinedInput", slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = (0, $kY3Ke.default)({}, (0, $3HkEr.default), (0, $4jzsB.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;

});


parcelRequire.register("lHSFU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcd80672e9993aad$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");

var $hngXp = parcelRequire("hngXp");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $cnEvg = parcelRequire("cnEvg");
var $cN7rN = parcelRequire("cN7rN");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $3Ha1S = parcelRequire("3Ha1S");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fcd80672e9993aad$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size === "small" && "sizeSmall",
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $3Ha1S.getInputLabelUtilityClasses), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $kDBhE.default)((0, $cnEvg.default), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cN7rN.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $kY3Ke.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $kY3Ke.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $kY3Ke.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $5j2OD.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cFLic.default)(props, $fcd80672e9993aad$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fcd80672e9993aad$var$InputLabelRoot, (0, $kY3Ke.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;

});
parcelRequire.register("cnEvg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90370d1df15229dd$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $cN7rN = parcelRequire("cN7rN");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $90370d1df15229dd$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cN7rN.getFormLabelUtilityClasses), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $kDBhE.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $cN7rN.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $cN7rN.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $cN7rN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$AsteriskComponent = (0, $kDBhE.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $cN7rN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $cFLic.default)(props, $90370d1df15229dd$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    " ",
                    "*"
                ]
            })
        ]
    }));
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;

});
parcelRequire.register("cN7rN", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", function () { return $94ffd68a66aaae7e$export$f7d501e40371cd17; });
$parcel$export(module.exports, "default", function () { return $94ffd68a66aaae7e$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $k6RDS.default)("MuiFormLabel", slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $4jzsB.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;

});


parcelRequire.register("3Ha1S", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", function () { return $2b0d2ae144238f59$export$c1c4b4545ad2ea5f; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $k6RDS.default)("MuiInputLabel", slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $4jzsB.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;

});


parcelRequire.register("3jMGu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a8e925f0aa9998$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $87FKv = parcelRequire("87FKv");

var $b6UUh = parcelRequire("b6UUh");

var $91ID4 = parcelRequire("91ID4");

var $kPqR2 = parcelRequire("kPqR2");

var $9AiVZ = parcelRequire("9AiVZ");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $26a8e925f0aa9998$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $b6UUh.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $9AiVZ.getFormControlUtilityClasses), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $kDBhE.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, styles[`margin${(0, $b6UUh.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $cFLic.default)(props, $26a8e925f0aa9998$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $91ID4.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $91ID4.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $87FKv.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $91ID4.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $87FKv.isFilled)(child.props, true) || (0, $87FKv.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($26a8e925f0aa9998$var$FormControlRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;

});
parcelRequire.register("91ID4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6926d37cb7ff7774$export$2e2bcd8739ae039; });

var $902ku = parcelRequire("902ku");
var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $902ku.default);

});
parcelRequire.register("902ku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d5ebbaafb4376f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $68d5ebbaafb4376f$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});


parcelRequire.register("9AiVZ", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", function () { return $6fa629ce89e8ad57$export$149c8b8bab2289d1; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $k6RDS.default)("MuiFormControl", slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $4jzsB.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;

});


parcelRequire.register("gFr0F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0321a2cb63129955$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $b6UUh = parcelRequire("b6UUh");

var $1qExZ = parcelRequire("1qExZ");

var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $b6UUh.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1qExZ.getFormHelperTextUtilityClasses), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $kDBhE.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $1qExZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $1qExZ.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $cFLic.default)(props, $0321a2cb63129955$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0321a2cb63129955$var$FormHelperTextRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "notranslate",
            children: "​"
        })) : children
    }));
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;

});
parcelRequire.register("1qExZ", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", function () { return $10a7abfeb1405549$export$a394fa61b1d583a9; });
$parcel$export(module.exports, "default", function () { return $10a7abfeb1405549$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $k6RDS.default)("MuiFormHelperText", slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $4jzsB.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;

});


parcelRequire.register("jh0sD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e07ff65b28ac412d$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $dYkRa = parcelRequire("dYkRa");

var $7HA9s = parcelRequire("7HA9s");

var $jHiZl = parcelRequire("jHiZl");

var $2jx1n = parcelRequire("2jx1n");

var $aI4oF = parcelRequire("aI4oF");

var $jiLAb = parcelRequire("jiLAb");

var $avrPa = parcelRequire("avrPa");

var $lxNRp = parcelRequire("lxNRp");

var $6WEW6 = parcelRequire("6WEW6");

var $5j2OD = parcelRequire("5j2OD");

var $6NwTb = parcelRequire("6NwTb");

var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e07ff65b28ac412d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $e07ff65b28ac412d$var$StyledInput = (0, $kDBhE.default)((0, $jiLAb.default), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $kDBhE.default)((0, $6WEW6.default), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $kDBhE.default)((0, $lxNRp.default), $e07ff65b28ac412d$var$styledRootConfig)("");
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $5j2OD.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $aI4oF.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $cFLic.default)(props, $e07ff65b28ac412d$var$_excluded);
    const inputComponent = native ? (0, $avrPa.default) : (0, $7HA9s.default);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $6NwTb.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $kY3Ke.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kY3Ke.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kY3Ke.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $dYkRa.default)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $hngXp.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$e07ff65b28ac412d$var$Select.muiName = "Select";
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;

});
parcelRequire.register("7HA9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59b8977b1194262f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $e5zLi = parcelRequire("e5zLi");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cNbkS = parcelRequire("cNbkS");

var $b6UUh = parcelRequire("b6UUh");

var $gPL9h = parcelRequire("gPL9h");

var $avrPa = parcelRequire("avrPa");

var $87FKv = parcelRequire("87FKv");

var $kDBhE = parcelRequire("kDBhE");

var $6NwTb = parcelRequire("6NwTb");

var $568MF = parcelRequire("568MF");

var $87RNG = parcelRequire("87RNG");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $59b8977b1194262f$var$SelectSelect = (0, $kDBhE.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $87RNG.default).select}`]: styles.select
            },
            {
                [`&.${(0, $87RNG.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $87RNG.default).error}`]: styles.error
            },
            {
                [`&.${(0, $87RNG.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $avrPa.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $87RNG.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $kDBhE.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $avrPa.nativeSelectIconStyles));
const $59b8977b1194262f$var$SelectNativeInput = (0, $kDBhE.default)("input", {
    shouldForwardProp: (prop)=>(0, $kDBhE.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $87RNG.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $59b8977b1194262f$var$_excluded);
    const [value, setValueState] = (0, $568MF.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $568MF.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $6NwTb.default)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $cNbkS.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $87FKv.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $e5zLi.default)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectSelect, (0, $kY3Ke.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $hngXp.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectNativeInput, (0, $kY3Ke.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gPL9h.default), (0, $kY3Ke.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $kY3Ke.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $kY3Ke.default)({}, MenuProps.PaperProps, {
                    style: (0, $kY3Ke.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;

});
parcelRequire.register("j2VHG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("45MkT"));

});
parcelRequire.register("45MkT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $2fad1f91101d4119$export$998bcd577473dd93; }, function (v) { return $2fad1f91101d4119$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $2fad1f91101d4119$export$3d6c20d97e46b957; }, function (v) { return $2fad1f91101d4119$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$998bcd577473dd93;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$3d6c20d97e46b957;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
"use strict";
var $2fad1f91101d4119$var$b = Symbol.for("react.element"), $2fad1f91101d4119$var$c = Symbol.for("react.portal"), $2fad1f91101d4119$var$d = Symbol.for("react.fragment"), $2fad1f91101d4119$var$e = Symbol.for("react.strict_mode"), $2fad1f91101d4119$var$f = Symbol.for("react.profiler"), $2fad1f91101d4119$var$g = Symbol.for("react.provider"), $2fad1f91101d4119$var$h = Symbol.for("react.context"), $2fad1f91101d4119$var$k = Symbol.for("react.server_context"), $2fad1f91101d4119$var$l = Symbol.for("react.forward_ref"), $2fad1f91101d4119$var$m = Symbol.for("react.suspense"), $2fad1f91101d4119$var$n = Symbol.for("react.suspense_list"), $2fad1f91101d4119$var$p = Symbol.for("react.memo"), $2fad1f91101d4119$var$q = Symbol.for("react.lazy"), $2fad1f91101d4119$var$t = Symbol.for("react.offscreen"), $2fad1f91101d4119$var$u;
$2fad1f91101d4119$var$u = Symbol.for("react.module.reference");
function $2fad1f91101d4119$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $2fad1f91101d4119$var$b:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$d:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$h:
                            case $2fad1f91101d4119$var$l:
                            case $2fad1f91101d4119$var$q:
                            case $2fad1f91101d4119$var$p:
                            case $2fad1f91101d4119$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $2fad1f91101d4119$var$c:
                return r;
        }
    }
}
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$b;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$q;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$998bcd577473dd93 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$92387174baf9b227 = function() {
    return !1;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$b;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$q;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$m;
};
$2fad1f91101d4119$export$3d6c20d97e46b957 = function(a) {
    return $2fad1f91101d4119$var$v(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$d || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$n || a === $2fad1f91101d4119$var$t || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$q || a.$$typeof === $2fad1f91101d4119$var$p || a.$$typeof === $2fad1f91101d4119$var$g || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$l || a.$$typeof === $2fad1f91101d4119$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$v;

});


parcelRequire.register("cNbkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9502daaf177b272b$export$2e2bcd8739ae039; });

var $4CS7n = parcelRequire("4CS7n");
var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $4CS7n.default);

});

parcelRequire.register("gPL9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c415fb7f3f0f9d08$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $94ctx = parcelRequire("94ctx");


var $dseJp = parcelRequire("dseJp");

var $ahaA4 = parcelRequire("ahaA4");

var $kDBhE = parcelRequire("kDBhE");

var $g9bTP = parcelRequire("g9bTP");

var $5j2OD = parcelRequire("5j2OD");

var $ewYvI = parcelRequire("ewYvI");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c415fb7f3f0f9d08$var$_excluded = [
    "onEntering"
], $c415fb7f3f0f9d08$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ewYvI.getMenuUtilityClass), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $kDBhE.default)((0, $ahaA4.default), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $kDBhE.default)((0, $ahaA4.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $kDBhE.default)((0, $dseJp.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $c415fb7f3f0f9d08$var$_excluded), other = (0, $cFLic.default)(props, $c415fb7f3f0f9d08$var$_excluded2);
    const theme = (0, $g9bTP.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $c415fb7f3f0f9d08$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $94ctx.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $94ctx.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuRoot, (0, $kY3Ke.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kY3Ke.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuMenuList, (0, $kY3Ke.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $hngXp.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;

});
parcelRequire.register("94ctx", function(module, exports) {

$parcel$export(module.exports, "useSlotProps", function () { return $699e2a22f1708389$export$1e5c9e6e4e15efe3; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $jTdAm = parcelRequire("jTdAm");

var $62rTX = parcelRequire("62rTX");

var $3qqT4 = parcelRequire("3qqT4");

var $dUIft = parcelRequire("dUIft");
"use client";
const $699e2a22f1708389$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $699e2a22f1708389$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cFLic.default)(parameters, $699e2a22f1708389$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $dUIft.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $3qqT4.mergeSlotProps)((0, $kY3Ke.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $jTdAm.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $62rTX.appendOwnerState)(elementType, (0, $kY3Ke.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRequire.register("62rTX", function(module, exports) {

$parcel$export(module.exports, "appendOwnerState", function () { return $465892a610f5fa03$export$b089efb01a7bdf50; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7HQQ4 = parcelRequire("7HQQ4");
function $465892a610f5fa03$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7HQQ4.isHostComponent)(elementType)) return otherProps;
    return (0, $kY3Ke.default)({}, otherProps, {
        ownerState: (0, $kY3Ke.default)({}, otherProps.ownerState, ownerState)
    });
}

});

parcelRequire.register("3qqT4", function(module, exports) {

$parcel$export(module.exports, "mergeSlotProps", function () { return $27e8a811df72cf86$export$b01d1e419b049226; });

var $kY3Ke = parcelRequire("kY3Ke");

var $hngXp = parcelRequire("hngXp");

var $8SgXx = parcelRequire("8SgXx");

var $4RQxC = parcelRequire("4RQxC");
function $27e8a811df72cf86$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $hngXp.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $kY3Ke.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kY3Ke.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $8SgXx.extractEventHandlers)((0, $kY3Ke.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $4RQxC.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $4RQxC.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $hngXp.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kY3Ke.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kY3Ke.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRequire.register("8SgXx", function(module, exports) {

$parcel$export(module.exports, "extractEventHandlers", function () { return $676085a836f199f4$export$24d5698b57eff81c; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $676085a836f199f4$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRequire.register("4RQxC", function(module, exports) {

$parcel$export(module.exports, "omitEventHandlers", function () { return $38b4de40642d32ce$export$2ac0fa4d3a39be45; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $38b4de40642d32ce$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRequire.register("dUIft", function(module, exports) {

$parcel$export(module.exports, "resolveComponentProps", function () { return $029d34f88c9482cd$export$308c24034cde71de; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $029d34f88c9482cd$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

});


parcelRequire.register("dseJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb95136bc90d127$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $cNbkS = parcelRequire("cNbkS");

var $lAoIf = parcelRequire("lAoIf");

var $1RLwL = parcelRequire("1RLwL");

var $6NwTb = parcelRequire("6NwTb");

var $hQtyv = parcelRequire("hQtyv");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9cb95136bc90d127$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $cFLic.default)(props, $9cb95136bc90d127$var$_excluded);
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $hQtyv.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $1RLwL.default)((0, $cNbkS.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $cNbkS.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $6NwTb.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lAoIf.default), (0, $kY3Ke.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;

});
parcelRequire.register("lAoIf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb70212a09473954$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cMvyt = parcelRequire("cMvyt");

var $ik5ek = parcelRequire("ik5ek");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fb70212a09473954$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ik5ek.getListUtilityClass), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $kDBhE.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cFLic.default)(props, $fb70212a09473954$var$_excluded);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($fb70212a09473954$var$ListRoot, (0, $kY3Ke.default)({
            as: component,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;

});
parcelRequire.register("cMvyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94e271e17fd22222$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;

});

parcelRequire.register("ik5ek", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $d56e26d1d10ff784$export$c6bd6795ed6e3203; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $k6RDS.default)("MuiList", slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $4jzsB.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;

});


parcelRequire.register("1RLwL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15bf9ba27fbfc052$export$2e2bcd8739ae039; });

var $9ctIl = parcelRequire("9ctIl");
var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $9ctIl.default);

});
parcelRequire.register("9ctIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b2c48b06f3074b8$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $6b2c48b06f3074b8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRequire.register("ahaA4", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $77b3b30833fb8c12$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $77b3b30833fb8c12$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $7HQQ4 = parcelRequire("7HQQ4");
var $cFCqu = parcelRequire("cFCqu");
var $94ctx = parcelRequire("94ctx");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $52luK = parcelRequire("52luK");

var $cNbkS = parcelRequire("cNbkS");

var $9kBlI = parcelRequire("9kBlI");

var $6NwTb = parcelRequire("6NwTb");

var $aSK9T = parcelRequire("aSK9T");

var $ehw51 = parcelRequire("ehw51");

var $a2ay0 = parcelRequire("a2ay0");

var $edKHw = parcelRequire("edKHw");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $77b3b30833fb8c12$var$_excluded = [
    "onEntering"
], $77b3b30833fb8c12$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
], $77b3b30833fb8c12$var$_excluded3 = [
    "slotProps"
];
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $edKHw.getPopoverUtilityClass), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $kDBhE.default)((0, $ehw51.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $aSK9T.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $77b3b30833fb8c12$var$_excluded), other = (0, $cFLic.default)(props, $77b3b30833fb8c12$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $7fPBF.useRef();
    const handlePaperRef = (0, $6NwTb.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $cNbkS.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9kBlI.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $52luK.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9kBlI.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $cNbkS.default)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $77b3b30833fb8c12$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $77b3b30833fb8c12$export$821346c38a2d9390;
    const paperProps = (0, $94ctx.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kY3Ke.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kY3Ke.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cFLic.default)(_useSlotProps, $77b3b30833fb8c12$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, (0, $kY3Ke.default)({}, rootProps, !(0, $7HQQ4.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp
    }, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, (0, $kY3Ke.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;

});
parcelRequire.register("52luK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aadd01758bd49c1$export$2e2bcd8739ae039; });

var $gHrsh = parcelRequire("gHrsh");
var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $gHrsh.default);

});

parcelRequire.register("9kBlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cb2f4180c9526e0$export$2e2bcd8739ae039; });

var $gE56a = parcelRequire("gE56a");
var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $gE56a.default);

});

parcelRequire.register("aSK9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ec2c0aa92d4d29c$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $8qMCX = parcelRequire("8qMCX");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7ec2c0aa92d4d29c$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $7ec2c0aa92d4d29c$var$_excluded);
    const timer = $7fPBF.useRef();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $g9bTP.default)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2j7bs.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $7fPBF.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $7ec2c0aa92d4d29c$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;

});
parcelRequire.register("8qMCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623678cbb6daf054$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");


var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $bTMtR = parcelRequire("bTMtR");


var $8ovTL = parcelRequire("8ovTL");

var $kKJSm = parcelRequire("kKJSm");
var $623678cbb6daf054$export$bb38bb9a1161268 = "unmounted";
var $623678cbb6daf054$export$84cbff306f539230 = "exited";
var $623678cbb6daf054$export$df38205c966be359 = "entering";
var $623678cbb6daf054$export$78e9e6e3e014d60a = "entered";
var $623678cbb6daf054$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $kKJSm.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $8ovTL.default);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;

});
parcelRequire.register("bTMtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a9a7006a9b8efe4$export$2e2bcd8739ae039; });
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRequire.register("kKJSm", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $f1bbb084f2fb10b7$export$7d26bbb1236dafd6; });
var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRequire.register("2j7bs", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $1ae2edacd7be6319$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $1ae2edacd7be6319$export$8cb1e9b404609ae9; });
const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRequire.register("ehw51", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a65b89a1133e1fe4$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $1s3tz = parcelRequire("1s3tz");
var $gqbI7 = parcelRequire("gqbI7");

var $7HQQ4 = parcelRequire("7HQQ4");
var $dUIft = parcelRequire("dUIft");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $jPUa4 = parcelRequire("jPUa4");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a65b89a1133e1fe4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a65b89a1133e1fe4$export$eb211a494147b724 = (0, $gqbI7.modalClasses);
const $a65b89a1133e1fe4$var$ModalRoot = (0, $kDBhE.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $kDBhE.default)((0, $jPUa4.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $5j2OD.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classes, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, open: open, slotProps: slotProps, slots: slots, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $cFLic.default)(props, $a65b89a1133e1fe4$var$_excluded);
    const [exited, setExited] = $7fPBF.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $kY3Ke.default)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a65b89a1133e1fe4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1s3tz.Modal), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $kY3Ke.default)({}, (0, $dUIft.resolveComponentProps)(rootSlotProps, ownerState), !(0, $7HQQ4.isHostComponent)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $hngXp.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $kY3Ke.default)({}, BackdropProps, (0, $dUIft.resolveComponentProps)(backdropSlotProps, ownerState), {
                    className: (0, $hngXp.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;

});
parcelRequire.register("1s3tz", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $10eb1a32515068a9$export$2b77a92f1a5ad772; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $bHAwn = parcelRequire("bHAwn");
var $4CS7n = parcelRequire("4CS7n");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $cFCqu = parcelRequire("cFCqu");

var $f3PDk = parcelRequire("f3PDk");

var $gdYEg = parcelRequire("gdYEg");

var $bagbq = parcelRequire("bagbq");

var $gqbI7 = parcelRequire("gqbI7");

var $94ctx = parcelRequire("94ctx");

var $8mwOh = parcelRequire("8mwOh");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $10eb1a32515068a9$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $10eb1a32515068a9$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8mwOh.useClassNamesOverride)((0, $gqbI7.getModalUtilityClass)));
};
function $10eb1a32515068a9$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $10eb1a32515068a9$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $10eb1a32515068a9$var$defaultManager = new (0, $gdYEg.ModalManager)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base-ui/react-modal/components-api/#modal)
 */ const $10eb1a32515068a9$export$2b77a92f1a5ad772 = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children, closeAfterTransition: closeAfterTransition = false, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, // private
    manager: managerProp = $10eb1a32515068a9$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cFLic.default)(props, $10eb1a32515068a9$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $7fPBF.useState(!open);
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(modalRef, forwardedRef);
    const hasTransition = $10eb1a32515068a9$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $4CS7n.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $giDhD.default)(()=>{
        const resolvedContainer = $10eb1a32515068a9$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $7fPBF.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $giDhD.default)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $gdYEg.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $10eb1a32515068a9$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $bHAwn.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $bHAwn.default)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $94ctx.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $94ctx.useSlotProps)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f3PDk.Portal), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(BackdropComponent, (0, $kY3Ke.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bagbq.FocusTrap), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});

});
parcelRequire.register("bHAwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88500a39ccee70fd$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $88500a39ccee70fd$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRequire.register("f3PDk", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $af6f301d1bc38583$export$602eac185826482c; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $fx0uj = parcelRequire("fx0uj");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $af6f301d1bc38583$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $af6f301d1bc38583$export$602eac185826482c = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $jTdAm.default)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $lJRRs.default)(()=>{
        if (!disablePortal) setMountNode($af6f301d1bc38583$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $lJRRs.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $fx0uj.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $fx0uj.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: mountNode ? /*#__PURE__*/ $fw0lo.createPortal(children, mountNode) : mountNode
    });
});

});

parcelRequire.register("gdYEg", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $bcfce7bd902a4bd1$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "ModalManager", function () { return $bcfce7bd902a4bd1$export$ce11c4ecd08cea67; });

var $9ctIl = parcelRequire("9ctIl");
var $4CS7n = parcelRequire("4CS7n");
var $gE56a = parcelRequire("gE56a");
// Is a vertical scrollbar displayed?
function $bcfce7bd902a4bd1$var$isOverflowing(container) {
    const doc = (0, $4CS7n.default)(container);
    if (doc.body === container) return (0, $gE56a.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $bcfce7bd902a4bd1$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $bcfce7bd902a4bd1$var$getPaddingRight(element) {
    return parseInt((0, $gE56a.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $bcfce7bd902a4bd1$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $bcfce7bd902a4bd1$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$bcfce7bd902a4bd1$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $bcfce7bd902a4bd1$export$e1bd0c6150f13d96(element, show);
    });
}
function $bcfce7bd902a4bd1$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $bcfce7bd902a4bd1$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($bcfce7bd902a4bd1$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $9ctIl.default)((0, $4CS7n.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$bcfce7bd902a4bd1$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4CS7n.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$bcfce7bd902a4bd1$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4CS7n.default)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $gE56a.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $bcfce7bd902a4bd1$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $bcfce7bd902a4bd1$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $bcfce7bd902a4bd1$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $bcfce7bd902a4bd1$var$getHiddenSiblings(container);
        $bcfce7bd902a4bd1$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $bcfce7bd902a4bd1$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $bcfce7bd902a4bd1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $bcfce7bd902a4bd1$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $bcfce7bd902a4bd1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $bcfce7bd902a4bd1$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $bcfce7bd902a4bd1$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $bcfce7bd902a4bd1$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}

});

parcelRequire.register("bagbq", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", function () { return $820d2e8c6ed0c158$export$34eba2437817a67b; });

var $7fPBF = parcelRequire("7fPBF");


var $4CS7n = parcelRequire("4CS7n");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $820d2e8c6ed0c158$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $820d2e8c6ed0c158$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $820d2e8c6ed0c158$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $820d2e8c6ed0c158$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $820d2e8c6ed0c158$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($820d2e8c6ed0c158$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $820d2e8c6ed0c158$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$820d2e8c6ed0c158$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $820d2e8c6ed0c158$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $820d2e8c6ed0c158$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $820d2e8c6ed0c158$var$defaultGetTabbable, isEnabled: isEnabled = $820d2e8c6ed0c158$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $jTdAm.default)(children.ref, rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4CS7n.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4CS7n.default)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

});

parcelRequire.register("gqbI7", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $bf48288417a86559$export$67960e22b12a638d; });
$parcel$export(module.exports, "modalClasses", function () { return $bf48288417a86559$export$eb211a494147b724; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bf48288417a86559$export$67960e22b12a638d(slot) {
    return (0, $k6RDS.default)("MuiModal", slot);
}
const $bf48288417a86559$export$eb211a494147b724 = (0, $4jzsB.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);

});

parcelRequire.register("8mwOh", function(module, exports) {

$parcel$export(module.exports, "useClassNamesOverride", function () { return $6169d433b17180d2$export$b0f7603cd2f9ee15; });

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6169d433b17180d2$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6169d433b17180d2$var$ClassNameConfiguratorContext = /*#__PURE__*/ $7fPBF.createContext($6169d433b17180d2$var$defaultContextValue);
function $6169d433b17180d2$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $7fPBF.useContext($6169d433b17180d2$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $6169d433b17180d2$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $7fPBF.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6169d433b17180d2$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

});


parcelRequire.register("jPUa4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70e583d684cb5f4$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $8WhtA = parcelRequire("8WhtA");

var $4EOyv = parcelRequire("4EOyv");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e70e583d684cb5f4$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4EOyv.getBackdropUtilityClass), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $kDBhE.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $8WhtA.default), transitionDuration: transitionDuration } = props, other = (0, $cFLic.default)(props, $e70e583d684cb5f4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e70e583d684cb5f4$var$BackdropRoot, (0, $kY3Ke.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $hngXp.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;

});
parcelRequire.register("8WhtA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68214be7242cbfc8$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");


var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $68214be7242cbfc8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $g9bTP.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $68214be7242cbfc8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2j7bs.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $68214be7242cbfc8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;

});

parcelRequire.register("4EOyv", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $36421d1d94159248$export$9927a91fd93152bd; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $k6RDS.default)("MuiBackdrop", slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $4jzsB.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;

});



parcelRequire.register("edKHw", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $a5a68170633995c3$export$88f455dd56c95edb; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $k6RDS.default)("MuiPopover", slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $4jzsB.default)("MuiPopover", [
    "root",
    "paper"
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;

});


parcelRequire.register("ewYvI", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $a942fdfc6e6c5d42$export$2cf86a63a84fe23d; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $k6RDS.default)("MuiMenu", slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $4jzsB.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;

});


parcelRequire.register("avrPa", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $7a6261f84c63d345$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $7a6261f84c63d345$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $7a6261f84c63d345$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $ecolw = parcelRequire("ecolw");

var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7a6261f84c63d345$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ecolw.getNativeSelectUtilityClasses), classes);
};
const $7a6261f84c63d345$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $kY3Ke.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $ecolw.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $kDBhE.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $ecolw.default).multiple}`]: styles.multiple
            }
        ];
    }
})($7a6261f84c63d345$export$c1eccd1617458c87);
const $7a6261f84c63d345$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $ecolw.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $kDBhE.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7a6261f84c63d345$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $cFLic.default)(props, $7a6261f84c63d345$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectSelect, (0, $kY3Ke.default)({
                ownerState: ownerState,
                className: (0, $hngXp.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;

});
parcelRequire.register("ecolw", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $a5651256592f6f65$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $a5651256592f6f65$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $k6RDS.default)("MuiNativeSelect", slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $4jzsB.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;

});


parcelRequire.register("568MF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b64539a8a5729fa$export$2e2bcd8739ae039; });

var $gaYwN = parcelRequire("gaYwN");
"use client";
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $gaYwN.default);

});
parcelRequire.register("gaYwN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc6c881cebb96954$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRequire.register("87RNG", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $5ea8b5d2968b699c$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $5ea8b5d2968b699c$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $k6RDS.default)("MuiSelect", slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $4jzsB.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;

});


parcelRequire.register("aI4oF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cc16c93aade5bc5$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});


parcelRequire.register("1VsKU", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", function () { return $16716b95f6c79ff6$export$c1bdcbaf0596aeda; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $k6RDS.default)("MuiTextField", slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $4jzsB.default)("MuiTextField", [
    "root"
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;

});




parcelRequire.register("5Bnf5", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRequire.register("kspUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee4a86a3270f4470$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $38WAi = parcelRequire("38WAi");
var $84PRT = parcelRequire("84PRT");

var $hQtyv = parcelRequire("hQtyv");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $ee4a86a3270f4470$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $7fPBF.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $hQtyv.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore = $7fPBF.useSyncExternalStore;
function $ee4a86a3270f4470$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $7fPBF.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $7fPBF.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $7fPBF.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $ee4a86a3270f4470$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $84PRT.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $38WAi.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $ee4a86a3270f4470$var$maybeReactUseSyncExternalStore !== undefined ? $ee4a86a3270f4470$var$useMediaQueryNew : $ee4a86a3270f4470$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

});

parcelRequire.register("fnVR5", function(module, exports) {

$parcel$export(module.exports, "CommonContextProvider", function () { return $09a99a6e3bbaaa5f$export$67765c83da43dcae; });
$parcel$export(module.exports, "useCommon", function () { return $09a99a6e3bbaaa5f$export$1159db2d0d85016f; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $09a99a6e3bbaaa5f$export$c3fb6c37b0a212c0 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    modal: null,
    setModal: ()=>{},
    snackbar: null,
    setSnackbar: ()=>{},
    isShareButtonsVisible: true,
    setIsShareButtonsVisible: ()=>{}
});
const $09a99a6e3bbaaa5f$export$67765c83da43dcae = (props)=>{
    const [modal, setModal] = (0, $7fPBF.useState)(null);
    const [snackbar, setSnackbar] = (0, $7fPBF.useState)(null);
    const [isShareButtonsVisible, setIsShareButtonsVisible] = (0, $7fPBF.useState)(true);
    const values = {
        setModal: setModal,
        modal: modal,
        setSnackbar: setSnackbar,
        snackbar: snackbar,
        isShareButtonsVisible: isShareButtonsVisible,
        setIsShareButtonsVisible: setIsShareButtonsVisible
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($09a99a6e3bbaaa5f$export$c3fb6c37b0a212c0.Provider, {
        value: values,
        children: props.children
    });
};
const $09a99a6e3bbaaa5f$export$1159db2d0d85016f = ()=>(0, $7fPBF.useContext)($09a99a6e3bbaaa5f$export$c3fb6c37b0a212c0);

});

parcelRequire.register("9uOZr", function(module, exports) {

$parcel$export(module.exports, "Layout", function () { return $3ddb0acad4358b3f$export$c84671f46d6a1ca; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $1N52b = parcelRequire("1N52b");

var $fnVR5 = parcelRequire("fnVR5");

var $gQHM1 = parcelRequire("gQHM1");

var $l0tJh = parcelRequire("l0tJh");

var $dV5yl = parcelRequire("dV5yl");

var $3i4O5 = parcelRequire("3i4O5");

var $7f3i2 = parcelRequire("7f3i2");

var $aTZYb = parcelRequire("aTZYb");

var $4fBxD = parcelRequire("4fBxD");
const $3ddb0acad4358b3f$export$c84671f46d6a1ca = ({ children: children, withFooter: withFooter = false, headerType: headerType = "", hideClubIcon: hideClubIcon = false, maxWidth: maxWidth, ...remainingProps })=>{
    const { modal: modal, snackbar: snackbar } = (0, $fnVR5.useCommon)();
    const { isAuthenticated: isAuthenticated, role: role } = (0, $1N52b.useAuth)();
    const isSnackbarShowing = !!(snackbar && snackbar.open);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            headerType === "menu" && !isAuthenticated && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f3i2.default), {}),
            headerType === "menu" && isAuthenticated && role === "club-admin" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3i4O5.default), {}),
            headerType === "menu" && isAuthenticated && role === "player" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aTZYb.default), {}),
            headerType === "logo" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4fBxD.default), {}),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dV5yl.default), {
                maxWidth: maxWidth,
                ...remainingProps,
                children: [
                    children,
                    snackbar && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gQHM1.SnackbarAlert), {
                        ...snackbar,
                        open: isSnackbarShowing,
                        children: snackbar.children
                    }),
                    modal && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $l0tJh.ModalStyled), {
                        id: modal.id,
                        open: modal.open,
                        onClose: modal.onClose,
                        title: modal.title,
                        children: modal.children
                    })
                ]
            }),
            withFooter && /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                children: "Footer"
            })
        ]
    });
};

});
parcelRequire.register("1N52b", function(module, exports) {

$parcel$export(module.exports, "useAuth", function () { return $432825c1b41fd9ac$export$1d39dc5b47e56ff0; });

var $7fPBF = parcelRequire("7fPBF");

var $DCRi1 = parcelRequire("DCRi1");
const $432825c1b41fd9ac$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $7fPBF.useContext)((0, $DCRi1.AuthContext));
    return context;
};

});
parcelRequire.register("DCRi1", function(module, exports) {

$parcel$export(module.exports, "AuthContext", function () { return $0771c91fa4cea7bc$export$a0fd8390cfe8ae69; });
$parcel$export(module.exports, "AuthProvider", function () { return $0771c91fa4cea7bc$export$87091915187a1a85; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $0771c91fa4cea7bc$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $7fPBF.createContext)();
const $0771c91fa4cea7bc$export$87091915187a1a85 = ({ children: children })=>{
    const [token, setToken] = (0, $7fPBF.useState)(localStorage.getItem("token"));
    const [role, setRole] = (0, $7fPBF.useState)(localStorage.getItem("role"));
    const isAuthenticated = token !== null && token !== "";
    const refresh = ()=>{
        setToken(localStorage.getItem("token"));
        setRole(localStorage.getItem("role"));
    };
    const logout = ()=>{
        localStorage.removeItem("token");
        setToken(null);
        localStorage.removeItem("role");
        setRole(null);
    };
    const login = (token, role)=>{
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        refresh();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0771c91fa4cea7bc$export$a0fd8390cfe8ae69.Provider, {
        value: {
            token: token,
            isAuthenticated: isAuthenticated,
            role: role,
            refresh: refresh,
            logout: logout,
            login: login
        },
        children: children
    });
};

});


parcelRequire.register("gQHM1", function(module, exports) {

$parcel$export(module.exports, "SnackbarAlert", function () { return $88443de2eb083c10$export$861f535630ada168; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $gC25j = parcelRequire("gC25j");
var $gXHSV = parcelRequire("gXHSV");
var $eOgyS = parcelRequire("eOgyS");
const $88443de2eb083c10$export$861f535630ada168 = ({ open: open, setOpen: setOpen, children: children, vertical: vertical = "top", horizontal: horizontal = "center", variant: variant = "filled", severity: severity, title: title })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eOgyS.default), {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        open: open,
        onClose: ()=>setOpen(false),
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gC25j.default), {
            onClose: ()=>setOpen(false),
            variant: variant,
            severity: severity,
            sx: {
                width: "100%"
            },
            children: [
                title && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gXHSV.default), {
                    children: title
                }),
                children
            ]
        })
    });
};

});
parcelRequire.register("gXHSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59432ae4677d24e$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $3loMv = parcelRequire("3loMv");

var $5pwso = parcelRequire("5pwso");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c59432ae4677d24e$var$_excluded = [
    "className"
];
const $c59432ae4677d24e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $5pwso.getAlertTitleUtilityClass), classes);
};
const $c59432ae4677d24e$var$AlertTitleRoot = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $c59432ae4677d24e$var$AlertTitle = /*#__PURE__*/ $7fPBF.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $c59432ae4677d24e$var$_excluded);
    const ownerState = props;
    const classes = $c59432ae4677d24e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c59432ae4677d24e$var$AlertTitleRoot, (0, $kY3Ke.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $c59432ae4677d24e$export$2e2bcd8739ae039 = $c59432ae4677d24e$var$AlertTitle;

});
parcelRequire.register("5pwso", function(module, exports) {

$parcel$export(module.exports, "getAlertTitleUtilityClass", function () { return $3f0876d73e31abe9$export$5269a5bce2c2f987; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $3f0876d73e31abe9$export$5269a5bce2c2f987(slot) {
    return (0, $k6RDS.default)("MuiAlertTitle", slot);
}
const $3f0876d73e31abe9$var$alertTitleClasses = (0, $4jzsB.default)("MuiAlertTitle", [
    "root"
]);
var $3f0876d73e31abe9$export$2e2bcd8739ae039 = $3f0876d73e31abe9$var$alertTitleClasses;

});


parcelRequire.register("eOgyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac8294fb74a722b7$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $cFCqu = parcelRequire("cFCqu");
var $94ctx = parcelRequire("94ctx");

var $gyza0 = parcelRequire("gyza0");

var $afdJz = parcelRequire("afdJz");

var $kDBhE = parcelRequire("kDBhE");

var $g9bTP = parcelRequire("g9bTP");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $aSK9T = parcelRequire("aSK9T");

var $aVfPM = parcelRequire("aVfPM");

var $623lt = parcelRequire("623lt");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ac8294fb74a722b7$var$_excluded = [
    "onEnter",
    "onExited"
], $ac8294fb74a722b7$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ac8294fb74a722b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $b6UUh.default)(anchorOrigin.vertical)}${(0, $b6UUh.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $623lt.getSnackbarUtilityClass), classes);
};
const $ac8294fb74a722b7$var$SnackbarRoot = (0, $kDBhE.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $b6UUh.default)(ownerState.anchorOrigin.vertical)}${(0, $b6UUh.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $kY3Ke.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $kY3Ke.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $ac8294fb74a722b7$var$Snackbar = /*#__PURE__*/ $7fPBF.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $g9bTP.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $aSK9T.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $ac8294fb74a722b7$var$_excluded), other = (0, $cFLic.default)(props, $ac8294fb74a722b7$var$_excluded2);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ac8294fb74a722b7$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $afdJz.useSnackbar)((0, $kY3Ke.default)({}, ownerState));
    const [exited, setExited] = $7fPBF.useState(true);
    const rootProps = (0, $94ctx.useSlotProps)({
        elementType: $ac8294fb74a722b7$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gyza0.ClickAwayListener), (0, $kY3Ke.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ac8294fb74a722b7$var$SnackbarRoot, (0, $kY3Ke.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aVfPM.default), (0, $kY3Ke.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ac8294fb74a722b7$export$2e2bcd8739ae039 = $ac8294fb74a722b7$var$Snackbar;

});
parcelRequire.register("gyza0", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", function () { return $c0db186dabae4bb6$export$58385c17fee43f89; });

var $7fPBF = parcelRequire("7fPBF");


var $4CS7n = parcelRequire("4CS7n");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $c0db186dabae4bb6$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $c0db186dabae4bb6$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $c0db186dabae4bb6$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $jTdAm.default)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $giDhD.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4CS7n.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $c0db186dabae4bb6$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $7fPBF.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $c0db186dabae4bb6$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4CS7n.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $7fPBF.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $c0db186dabae4bb6$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4CS7n.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps)
    });
}

});

parcelRequire.register("afdJz", function(module, exports) {

$parcel$export(module.exports, "useSnackbar", function () { return $7755f55e879ae0c6$export$1c97ac2c9a6e7c09; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $giDhD = parcelRequire("giDhD");

var $8SgXx = parcelRequire("8SgXx");
"use client";
function $7755f55e879ae0c6$export$1c97ac2c9a6e7c09(parameters) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = $7fPBF.useRef();
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $giDhD.default)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $giDhD.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(()=>{
            handleClose(null, "timeout");
        }, autoHideDurationParam);
    });
    $7fPBF.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return ()=>{
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = ()=>{
        clearTimeout(timerAutoHide.current);
    };
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $7fPBF.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $7fPBF.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $8SgXx.extractEventHandlers)(parameters);
        const externalEventHandlers = (0, $kY3Ke.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kY3Ke.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}

});

parcelRequire.register("aVfPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f3b829aa55dc1b3$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $a2ay0 = parcelRequire("a2ay0");

var $7CnT7 = parcelRequire("7CnT7");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7f3b829aa55dc1b3$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $7f3b829aa55dc1b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7CnT7.getSnackbarContentUtilityClass), classes);
};
const $7f3b829aa55dc1b3$var$SnackbarContentRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $cxeT8.emphasize)(theme.palette.background.default, emphasis);
    return (0, $kY3Ke.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $7f3b829aa55dc1b3$var$SnackbarContentMessage = (0, $kDBhE.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $7f3b829aa55dc1b3$var$SnackbarContentAction = (0, $kDBhE.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $7f3b829aa55dc1b3$var$SnackbarContent = /*#__PURE__*/ $7fPBF.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $cFLic.default)(props, $7f3b829aa55dc1b3$var$_excluded);
    const ownerState = props;
    const classes = $7f3b829aa55dc1b3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7f3b829aa55dc1b3$var$SnackbarContentRoot, (0, $kY3Ke.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7f3b829aa55dc1b3$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $bbzbN.jsx)($7f3b829aa55dc1b3$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $7f3b829aa55dc1b3$export$2e2bcd8739ae039 = $7f3b829aa55dc1b3$var$SnackbarContent;

});
parcelRequire.register("7CnT7", function(module, exports) {

$parcel$export(module.exports, "getSnackbarContentUtilityClass", function () { return $58be9cb10f53ed84$export$def81488db1a3216; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $58be9cb10f53ed84$export$def81488db1a3216(slot) {
    return (0, $k6RDS.default)("MuiSnackbarContent", slot);
}
const $58be9cb10f53ed84$var$snackbarContentClasses = (0, $4jzsB.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $58be9cb10f53ed84$export$2e2bcd8739ae039 = $58be9cb10f53ed84$var$snackbarContentClasses;

});


parcelRequire.register("623lt", function(module, exports) {

$parcel$export(module.exports, "getSnackbarUtilityClass", function () { return $4645864a9a0034f9$export$6cb096457f5926f4; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $4645864a9a0034f9$export$6cb096457f5926f4(slot) {
    return (0, $k6RDS.default)("MuiSnackbar", slot);
}
const $4645864a9a0034f9$var$snackbarClasses = (0, $4jzsB.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $4645864a9a0034f9$export$2e2bcd8739ae039 = $4645864a9a0034f9$var$snackbarClasses;

});



parcelRequire.register("l0tJh", function(module, exports) {

$parcel$export(module.exports, "ModalStyled", function () { return $4be8f9b0616e6a46$export$5b3e7d7c0589918f; });

var $bbzbN = parcelRequire("bbzbN");

var $aUdfW = parcelRequire("aUdfW");

var $8TDId = parcelRequire("8TDId");
parcelRequire("7fPBF");

var $hKUqD = parcelRequire("hKUqD");

var $fnVR5 = parcelRequire("fnVR5");

var $7DtP1 = parcelRequire("7DtP1");
const $4be8f9b0616e6a46$export$5b3e7d7c0589918f = ({ open: open, title: title, onClose: onClose, children: children })=>{
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aUdfW.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7DtP1.StyledDialogTitle), {
                children: title
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                "aria-label": "close",
                onClick: ()=>setModal({
                        open: false,
                        children: null
                    }),
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hKUqD))), {})
            }),
            children
        ]
    });
};

});
parcelRequire.register("aUdfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f096abd658f7c85$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $65Itt = parcelRequire("65Itt");

var $b6UUh = parcelRequire("b6UUh");

var $ehw51 = parcelRequire("ehw51");

var $8WhtA = parcelRequire("8WhtA");

var $a2ay0 = parcelRequire("a2ay0");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $bqHow = parcelRequire("bqHow");

var $5wwR3 = parcelRequire("5wwR3");

var $jPUa4 = parcelRequire("jPUa4");

var $g9bTP = parcelRequire("g9bTP");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7f096abd658f7c85$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f096abd658f7c85$var$DialogBackdrop = (0, $kDBhE.default)((0, $jPUa4.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $b6UUh.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $b6UUh.default)(scroll)}`,
            `paperWidth${(0, $b6UUh.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bqHow.getDialogUtilityClass), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $kDBhE.default)((0, $ehw51.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $kDBhE.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $b6UUh.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $7f096abd658f7c85$var$DialogPaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $b6UUh.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $bqHow.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $g9bTP.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $a2ay0.default), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $8WhtA.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $7f096abd658f7c85$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $65Itt.default)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f096abd658f7c85$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kY3Ke.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogContainer, {
                className: (0, $hngXp.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogPaper, (0, $kY3Ke.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $hngXp.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5wwR3.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;

});
parcelRequire.register("bqHow", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", function () { return $8523c8ab2139cf2c$export$2177af0aa15c34c2; });
$parcel$export(module.exports, "default", function () { return $8523c8ab2139cf2c$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $k6RDS.default)("MuiDialog", slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $4jzsB.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;

});

parcelRequire.register("5wwR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40596d25b0f9c334$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;

});


parcelRequire.register("hKUqD", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ced2811cec92894a$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $ced2811cec92894a$var$_default = (0, $ced2811cec92894a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
module.exports.default = $ced2811cec92894a$var$_default;

});

parcelRequire.register("7DtP1", function(module, exports) {

$parcel$export(module.exports, "StyledDialogTitle", function () { return $7519aeec5a1beb23$export$7dce087514a71c07; });

var $eNZsp = parcelRequire("eNZsp");

var $6hfZk = parcelRequire("6hfZk");
let $7519aeec5a1beb23$var$_ = (t)=>t, $7519aeec5a1beb23$var$t;
const $7519aeec5a1beb23$export$7dce087514a71c07 = (0, $6hfZk.default)((0, $eNZsp.default))($7519aeec5a1beb23$var$t || ($7519aeec5a1beb23$var$t = $7519aeec5a1beb23$var$_`
    margin: 0;
    padding: 16px !important;
    @media (max-width: 600px) {
        font-size: 1rem !important;
    },
`));

});
parcelRequire.register("eNZsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac75506ecdb312f1$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $25LML = parcelRequire("25LML");

var $5wwR3 = parcelRequire("5wwR3");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ac75506ecdb312f1$var$_excluded = [
    "className",
    "id"
];
const $ac75506ecdb312f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $25LML.getDialogTitleUtilityClass), classes);
};
const $ac75506ecdb312f1$var$DialogTitleRoot = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $ac75506ecdb312f1$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $cFLic.default)(props, $ac75506ecdb312f1$var$_excluded);
    const ownerState = props;
    const classes = $ac75506ecdb312f1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $5wwR3.default));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ac75506ecdb312f1$var$DialogTitleRoot, (0, $kY3Ke.default)({
        component: "h2",
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ac75506ecdb312f1$export$2e2bcd8739ae039 = $ac75506ecdb312f1$var$DialogTitle;

});
parcelRequire.register("25LML", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", function () { return $18611d95980659c6$export$f5d2ec7e4c47e088; });
$parcel$export(module.exports, "default", function () { return $18611d95980659c6$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $k6RDS.default)("MuiDialogTitle", slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $4jzsB.default)("MuiDialogTitle", [
    "root"
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;

});




parcelRequire.register("dV5yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a224e7f09a1cd55c$export$2e2bcd8739ae039; });


var $aXuLY = parcelRequire("aXuLY");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");
"use client";
const $a224e7f09a1cd55c$var$Container = (0, $aXuLY.default)({
    createStyledComponent: (0, $kDBhE.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $5j2OD.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $a224e7f09a1cd55c$export$2e2bcd8739ae039 = $a224e7f09a1cd55c$var$Container;

});
parcelRequire.register("aXuLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fa748e340d672b7$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $iCiVn = parcelRequire("iCiVn");
var $cFCqu = parcelRequire("cFCqu");
var $k6RDS = parcelRequire("k6RDS");

var $9HPC7 = parcelRequire("9HPC7");

var $b9j48 = parcelRequire("b9j48");

var $2G6xE = parcelRequire("2G6xE");

var $bbzbN = parcelRequire("bbzbN");
const $7fa748e340d672b7$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $7fa748e340d672b7$var$defaultTheme = (0, $2G6xE.default)();
const $7fa748e340d672b7$var$defaultCreateStyledComponent = (0, $b9j48.default)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $iCiVn.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $7fa748e340d672b7$var$useThemePropsDefault = (inProps)=>(0, $9HPC7.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $7fa748e340d672b7$var$defaultTheme
    });
const $7fa748e340d672b7$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $k6RDS.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $iCiVn.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $cFCqu.default)(slots, getContainerUtilityClass, classes);
};
function $7fa748e340d672b7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $7fa748e340d672b7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $7fa748e340d672b7$var$useThemePropsDefault, componentName: componentName = "MuiContainer" } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $7fPBF.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $cFLic.default)(props, $7fa748e340d672b7$var$_excluded);
        const ownerState = (0, $kY3Ke.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $7fa748e340d672b7$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $bbzbN.jsx)(ContainerRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}

});


parcelRequire.register("3i4O5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7e3cf880ad41718$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7TOmr = parcelRequire("7TOmr");

var $aili3 = parcelRequire("aili3");

var $5Mrqo = parcelRequire("5Mrqo");

var $jEUN5 = parcelRequire("jEUN5");

var $i1fqN = parcelRequire("i1fqN");

var $8HmXW = parcelRequire("8HmXW");

var $kspUS = parcelRequire("kspUS");
var $g9bTP = parcelRequire("g9bTP");

var $5E3nd = parcelRequire("5E3nd");

var $jTm6v = parcelRequire("jTm6v");

var $ki8Af = parcelRequire("ki8Af");

var $fpWEH = parcelRequire("fpWEH");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
const $a7e3cf880ad41718$var$AdminNavbar = ({ hideMenu: hideMenu = false, hideClubIcon: hideClubIcon = false })=>{
    var _appClub_name;
    const [menuOpen, setMenuOpen] = (0, $7fPBF.useState)(false);
    const navigate = (0, $iIluI.useNavigate)();
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const appClub = appContext.club;
    const showTopMenu = window.location.pathname;
    const theme = (0, $g9bTP.default)();
    const isLargeScreen = (0, $kspUS.default)(theme.breakpoints.up("sm"));
    const clubName = appClub === null || appClub === void 0 ? void 0 : (_appClub_name = appClub.name) === null || _appClub_name === void 0 ? void 0 : _appClub_name.split(" ");
    const clubInitials = clubName && (clubName === null || clubName === void 0 ? void 0 : clubName.length) > 1 ? `${clubName[0][0]}${clubName[1][0]}` : (appClub === null || appClub === void 0 ? void 0 : appClub.name) ? appClub === null || appClub === void 0 ? void 0 : appClub.name[0] : "";
    const handleMenuOpen = ()=>setMenuOpen(true);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        sx: {
            flexGrow: 1
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7TOmr.default), {
                position: "static",
                sx: {
                    boxShadow: "var(--default-boxShadow)"
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5Mrqo.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between"
                        },
                        children: [
                            hideMenu ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledIconButton), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.MUIMenuIcon), {})
                            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $fpWEH.StyledMenuBox), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledIconButton), {
                                        onClick: handleMenuOpen,
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.MUIMenuIcon), {})
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.StyledName), {
                                        children: isLargeScreen ? appClub === null || appClub === void 0 ? void 0 : appClub.name : clubInitials
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.Image), {
                                src: "/logo_aveiro_tech_city_white.png",
                                alt: "FreeCourts: Courts for everyone"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "1rem"
                                },
                                children: [
                                    !showTopMenu.includes("/search") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E3nd))), {
                                        onClick: ()=>navigate("/search")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jTm6v.UserMenu), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ki8Af.TopMenu), {
                        selectedClub: appClub
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jEUN5.ClubAdminMenu), {
                open: menuOpen,
                setOpen: setMenuOpen,
                selectedClub: appClub,
                setSelectedClub: appContext.setClub
            })
        ]
    });
};
var $a7e3cf880ad41718$export$2e2bcd8739ae039 = $a7e3cf880ad41718$var$AdminNavbar;

});
parcelRequire.register("7TOmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c04bc14285128b0$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $a2ay0 = parcelRequire("a2ay0");

var $cjLM4 = parcelRequire("cjLM4");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $5c04bc14285128b0$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $5c04bc14285128b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`,
            `position${(0, $b6UUh.default)(position)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cjLM4.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $5c04bc14285128b0$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $5c04bc14285128b0$var$AppBarRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $kY3Ke.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $kY3Ke.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $kY3Ke.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $5c04bc14285128b0$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $5c04bc14285128b0$var$AppBar = /*#__PURE__*/ $7fPBF.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $cFLic.default)(props, $5c04bc14285128b0$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $5c04bc14285128b0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5c04bc14285128b0$var$AppBarRoot, (0, $kY3Ke.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $hngXp.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $5c04bc14285128b0$export$2e2bcd8739ae039 = $5c04bc14285128b0$var$AppBar;

});
parcelRequire.register("cjLM4", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", function () { return $8f7c5161bc7a509f$export$47a2da616e55e8e9; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $8f7c5161bc7a509f$export$47a2da616e55e8e9(slot) {
    return (0, $k6RDS.default)("MuiAppBar", slot);
}
const $8f7c5161bc7a509f$var$appBarClasses = (0, $4jzsB.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $8f7c5161bc7a509f$export$2e2bcd8739ae039 = $8f7c5161bc7a509f$var$appBarClasses;

});


parcelRequire.register("5Mrqo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4356b5696745688a$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $iU3EE = parcelRequire("iU3EE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4356b5696745688a$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $4356b5696745688a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $iU3EE.getToolbarUtilityClass), classes);
};
const $4356b5696745688a$var$ToolbarRoot = (0, $kDBhE.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $4356b5696745688a$var$Toolbar = /*#__PURE__*/ $7fPBF.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $cFLic.default)(props, $4356b5696745688a$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $4356b5696745688a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4356b5696745688a$var$ToolbarRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $4356b5696745688a$export$2e2bcd8739ae039 = $4356b5696745688a$var$Toolbar;

});
parcelRequire.register("iU3EE", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", function () { return $dc304ab6922390a3$export$b12cb262231eef32; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $dc304ab6922390a3$export$b12cb262231eef32(slot) {
    return (0, $k6RDS.default)("MuiToolbar", slot);
}
const $dc304ab6922390a3$var$toolbarClasses = (0, $4jzsB.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $dc304ab6922390a3$export$2e2bcd8739ae039 = $dc304ab6922390a3$var$toolbarClasses;

});


parcelRequire.register("jEUN5", function(module, exports) {

$parcel$export(module.exports, "ClubAdminMenu", function () { return $541ade1d9ed7dbf0$export$2315c522aad234e6; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $aeoYN = parcelRequire("aeoYN");
var $pF6j5 = parcelRequire("pF6j5");
var $lE3FT = parcelRequire("lE3FT");
var $57cKd = parcelRequire("57cKd");
var $dxMGW = parcelRequire("dxMGW");
var $58CWL = parcelRequire("58CWL");
var $dseJp = parcelRequire("dseJp");
var $abILr = parcelRequire("abILr");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $cAbNk = parcelRequire("cAbNk");

var $1quPt = parcelRequire("1quPt");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $fnVR5 = parcelRequire("fnVR5");

var $a8T0C = parcelRequire("a8T0C");

var $2rOQj = parcelRequire("2rOQj");

var $3Ou5w = parcelRequire("3Ou5w");

var $7qlUi = parcelRequire("7qlUi");

var $hyW56 = parcelRequire("hyW56");

var $8HmXW = parcelRequire("8HmXW");

var $i1fqN = parcelRequire("i1fqN");

var $hGobg = parcelRequire("hGobg");
const $541ade1d9ed7dbf0$export$2315c522aad234e6 = ({ open: open, setOpen: setOpen, selectedClub: selectedClub, setSelectedClub: setSelectedClub })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const { actions: { fetchClubFeatureToggles: fetchClubFeatureToggles } } = (0, $2rOQj.useFeatureToggles)();
    const userRole = localStorage.getItem("role");
    const { setActiveStep: setActiveStep } = (0, $hGobg.default)();
    const { data: clubs, isLoading: isLoading } = (0, $hyW56.useClubs)("private");
    const clubMenuItems = isLoading || clubs.length > 0 ? [
        {
            to: `/club-admin/club/${selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id}/areas`,
            str: t("clubAdmin.menu.clubAreas")
        },
        {
            to: `/club-admin/club-details`,
            str: t("clubAdmin.menu.editClub")
        }
    ] : [
        {
            to: "/club-admin/club-details",
            str: t("clubAdmin.menu.createClub")
        }
    ];
    (0, $7fPBF.useEffect)(()=>{
        if ((selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id) !== undefined || (selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id) !== "") fetchClubFeatureToggles(selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id);
        return ()=>appContext.setHasClubChanged(false);
    }, [
        selectedClub,
        setSelectedClub
    ]);
    const navigateTo = (to)=>{
        navigate(to);
        setOpen(false);
    };
    const handleClose = ()=>setOpen(false);
    const handleChangeClub = (club)=>{
        if ((selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id) === (club === null || club === void 0 ? void 0 : club.id)) return;
        setSelectedClub(club);
        localStorage.setItem("clubAdmin.selectedClub", JSON.stringify(club));
        appContext.setHasClubChanged(true);
        setActiveStep(0);
    };
    const handleNewClub = ()=>{
        localStorage.setItem("clubAdmin.selectedClub", JSON.stringify(null));
        setSelectedClub(null);
        navigate("/club-admin/club-details");
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lE3FT.default), {
        anchor: "left",
        variant: "temporary",
        open: open,
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            sx: {
                padding: "1rem 0"
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledIconButton), {
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1quPt))), {
                                color: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            onClick: ()=>navigate("/"),
                            src: "/logo_aveiro_tech_city.png",
                            alt: "FreeCourts: Courts for everyone",
                            height: 52
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledSpan), {})
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    direction: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    mt: "2rem",
                    p: "0 1rem",
                    children: [
                        isLoading ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                                    width: "100%",
                                    height: 32
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                                    width: "100%",
                                    height: 24
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    variant: "h6",
                                    children: t("clubAdmin.menu.selectedClub")
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    variant: "body1",
                                    children: clubs.length > 0 ? selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.name : t("clubAdmin.menu.noClubs")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
                            direction: "row",
                            spacing: 1,
                            mt: 1,
                            pb: 1,
                            width: 280,
                            useFlexGap: true,
                            sx: {
                                overflowX: "auto"
                            },
                            children: isLoading ? [
                                1,
                                2,
                                3,
                                4
                            ].map((value)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                                    variant: "circular",
                                    width: 48,
                                    height: 48
                                }, value)) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aeoYN.default), {
                                        onClick: handleNewClub,
                                        sx: {
                                            width: 48,
                                            height: 48,
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                            variant: "body1",
                                            children: "+"
                                        })
                                    }),
                                    clubs.map((club)=>{
                                        const name = club === null || club === void 0 ? void 0 : club.name.split(" ");
                                        const str = name.length > 1 ? name[0][0] + name[1][0] : name[0][0];
                                        const isActive = (selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id) === (club === null || club === void 0 ? void 0 : club.id);
                                        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aeoYN.default), {
                                            onClick: ()=>handleChangeClub(club),
                                            sx: {
                                                width: 48,
                                                height: 48,
                                                cursor: "pointer",
                                                bgcolor: isActive ? "#1976d2" : "auto",
                                                order: isActive ? 0 : 1
                                            },
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                variant: "body1",
                                                children: str
                                            })
                                        }, club.id);
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dseJp.default), {
                    sx: {
                        marginTop: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            onClick: ()=>navigateTo("/club-admin"),
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                children: t("bookings")
                            })
                        }),
                        selectedClub !== null && clubMenuItems.map((item)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                onClick: ()=>navigateTo(item.to),
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                    children: item.str
                                })
                            }, item.str)),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7qlUi.FeatureToggleBaseComponent), {
                            featureToggle: (0, $3Ou5w.FeatureToggles).RESERVATION_HISTORY,
                            children: selectedClub !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                onClick: ()=>{
                                    return navigateTo(`/club-admin/club/${selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id}/history`);
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                    children: t("clubAdmin.menu.historyData")
                                })
                            })
                        }),
                        selectedClub && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                            onClick: ()=>{
                                setModal({
                                    open: true,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a8T0C.DeleteClubForm), {
                                        clubId: selectedClub.id
                                    }),
                                    title: t("club.message.deleteClubTitle", {
                                        club: selectedClub.name
                                    })
                                });
                                setOpen(false);
                            },
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledListItemText), {
                                    children: t("clubAdmin.menu.deleteClub")
                                })
                            ]
                        }),
                        userRole === "player" && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {}),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                    onClick: ()=>navigateTo("/club-admin/edit-account"),
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                        children: t("clubAdmin.menu.editAccount")
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                    onClick: ()=>navigateTo("/terms-and-conditions"),
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                        children: t("termsAndConditions")
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                    onClick: ()=>navigateTo("/logout"),
                                    color: "primary",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $57cKd.default), {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cAbNk))), {
                                                color: "primary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                color: "primary",
                                                children: t("clubAdmin.menu.logout")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRequire.register("aeoYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $772e96a1af9615ac$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $ke2Sj = parcelRequire("ke2Sj");

var $ip8f1 = parcelRequire("ip8f1");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $772e96a1af9615ac$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $772e96a1af9615ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ip8f1.getAvatarUtilityClass), classes);
};
const $772e96a1af9615ac$var$AvatarRoot = (0, $kDBhE.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $772e96a1af9615ac$var$AvatarImg = (0, $kDBhE.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $772e96a1af9615ac$var$AvatarFallback = (0, $kDBhE.default)((0, $ke2Sj.default), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $772e96a1af9615ac$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $772e96a1af9615ac$var$Avatar = /*#__PURE__*/ $7fPBF.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $cFLic.default)(props, $772e96a1af9615ac$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $772e96a1af9615ac$var$useLoaded((0, $kY3Ke.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $772e96a1af9615ac$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $bbzbN.jsx)($772e96a1af9615ac$var$AvatarImg, (0, $kY3Ke.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $bbzbN.jsx)($772e96a1af9615ac$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($772e96a1af9615ac$var$AvatarRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $772e96a1af9615ac$export$2e2bcd8739ae039 = $772e96a1af9615ac$var$Avatar;

});
parcelRequire.register("ke2Sj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb97585ed36aff99$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $eb97585ed36aff99$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");

});

parcelRequire.register("ip8f1", function(module, exports) {

$parcel$export(module.exports, "getAvatarUtilityClass", function () { return $d660f45ac865db82$export$ffd560f22c0ecf04; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d660f45ac865db82$export$ffd560f22c0ecf04(slot) {
    return (0, $k6RDS.default)("MuiAvatar", slot);
}
const $d660f45ac865db82$var$avatarClasses = (0, $4jzsB.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $d660f45ac865db82$export$2e2bcd8739ae039 = $d660f45ac865db82$var$avatarClasses;

});


parcelRequire.register("pF6j5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04d237a94a6557e6$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $glmzs = parcelRequire("glmzs");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $04d237a94a6557e6$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $04d237a94a6557e6$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $glmzs.getDividerUtilityClass), classes);
};
const $04d237a94a6557e6$var$DividerRoot = (0, $kDBhE.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $cxeT8.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $04d237a94a6557e6$var$DividerWrapper = (0, $kDBhE.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $04d237a94a6557e6$var$Divider = /*#__PURE__*/ $7fPBF.forwardRef(function Divider(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $cFLic.default)(props, $04d237a94a6557e6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $04d237a94a6557e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($04d237a94a6557e6$var$DividerRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $bbzbN.jsx)($04d237a94a6557e6$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $04d237a94a6557e6$var$Divider.muiSkipListHighlight = true;
var $04d237a94a6557e6$export$2e2bcd8739ae039 = $04d237a94a6557e6$var$Divider;

});
parcelRequire.register("glmzs", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", function () { return $be601d991ccbe49a$export$46f01d01378ec5a2; });
$parcel$export(module.exports, "default", function () { return $be601d991ccbe49a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $k6RDS.default)("MuiDivider", slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $4jzsB.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;

});


parcelRequire.register("lE3FT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc202f2249b2dd6f$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $ehw51 = parcelRequire("ehw51");

var $e4MmV = parcelRequire("e4MmV");

var $a2ay0 = parcelRequire("a2ay0");

var $b6UUh = parcelRequire("b6UUh");

var $g9bTP = parcelRequire("g9bTP");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $lAUlD = parcelRequire("lAUlD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $fc202f2249b2dd6f$var$_excluded = [
    "BackdropProps"
], $fc202f2249b2dd6f$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $fc202f2249b2dd6f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $fc202f2249b2dd6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $b6UUh.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $b6UUh.default)(anchor)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $lAUlD.getDrawerUtilityClass), classes);
};
const $fc202f2249b2dd6f$var$DrawerRoot = (0, $kDBhE.default)((0, $ehw51.default), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $fc202f2249b2dd6f$var$DrawerDockedRoot = (0, $kDBhE.default)("div", {
    shouldForwardProp: (0, $kDBhE.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $fc202f2249b2dd6f$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $fc202f2249b2dd6f$var$DrawerPaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $b6UUh.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $b6UUh.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $fc202f2249b2dd6f$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $fc202f2249b2dd6f$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $fc202f2249b2dd6f$export$2a62b49acb270576(anchor) ? $fc202f2249b2dd6f$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $fc202f2249b2dd6f$var$Drawer = /*#__PURE__*/ $7fPBF.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $g9bTP.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $e4MmV.default), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary" } = props, ModalProps = (0, $cFLic.default)(props.ModalProps, $fc202f2249b2dd6f$var$_excluded), other = (0, $cFLic.default)(props, $fc202f2249b2dd6f$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $fc202f2249b2dd6f$export$830f4f08342d299e(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $fc202f2249b2dd6f$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerPaper, (0, $kY3Ke.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $hngXp.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        direction: $fc202f2249b2dd6f$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerDockedRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fc202f2249b2dd6f$var$DrawerRoot, (0, $kY3Ke.default)({
        BackdropProps: (0, $kY3Ke.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $hngXp.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $fc202f2249b2dd6f$export$2e2bcd8739ae039 = $fc202f2249b2dd6f$var$Drawer;

});
parcelRequire.register("e4MmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f6f5762623b961$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $8qMCX = parcelRequire("8qMCX");


var $52luK = parcelRequire("52luK");

var $6NwTb = parcelRequire("6NwTb");

var $g9bTP = parcelRequire("g9bTP");

var $2j7bs = parcelRequire("2j7bs");

var $9kBlI = parcelRequire("9kBlI");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a3f6f5762623b961$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $9kBlI.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a3f6f5762623b961$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a3f6f5762623b961$var$resolveContainer(containerProp);
    const transform = $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a3f6f5762623b961$var$Slide = /*#__PURE__*/ $7fPBF.forwardRef(function Slide(props, ref) {
    const theme = (0, $g9bTP.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $a3f6f5762623b961$var$_excluded);
    const childrenRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $2j7bs.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $kY3Ke.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $kY3Ke.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $2j7bs.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $7fPBF.useCallback(()=>{
        if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $52luK.default)(()=>{
            if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $9kBlI.default)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                ref: handleRef,
                style: (0, $kY3Ke.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $a3f6f5762623b961$export$2e2bcd8739ae039 = $a3f6f5762623b961$var$Slide;

});

parcelRequire.register("lAUlD", function(module, exports) {

$parcel$export(module.exports, "getDrawerUtilityClass", function () { return $fb88ab4f6dbff241$export$b801318a856c9cd2; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fb88ab4f6dbff241$export$b801318a856c9cd2(slot) {
    return (0, $k6RDS.default)("MuiDrawer", slot);
}
const $fb88ab4f6dbff241$var$drawerClasses = (0, $4jzsB.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $fb88ab4f6dbff241$export$2e2bcd8739ae039 = $fb88ab4f6dbff241$var$drawerClasses;

});


parcelRequire.register("57cKd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b977dfc67db1ec5$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $awhCL = parcelRequire("awhCL");

var $cMvyt = parcelRequire("cMvyt");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3b977dfc67db1ec5$var$_excluded = [
    "className"
];
const $3b977dfc67db1ec5$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $awhCL.getListItemIconUtilityClass), classes);
};
const $3b977dfc67db1ec5$var$ListItemIconRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $3b977dfc67db1ec5$var$ListItemIcon = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $3b977dfc67db1ec5$var$_excluded);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $3b977dfc67db1ec5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3b977dfc67db1ec5$var$ListItemIconRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $3b977dfc67db1ec5$export$2e2bcd8739ae039 = $3b977dfc67db1ec5$var$ListItemIcon;

});
parcelRequire.register("awhCL", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", function () { return $7a8a9052410fb062$export$81478e24460c57f2; });
$parcel$export(module.exports, "default", function () { return $7a8a9052410fb062$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $k6RDS.default)("MuiListItemIcon", slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $4jzsB.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;

});


parcelRequire.register("dxMGW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dc4208e00f56723$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $3loMv = parcelRequire("3loMv");

var $cMvyt = parcelRequire("cMvyt");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $3Er4K = parcelRequire("3Er4K");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9dc4208e00f56723$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $9dc4208e00f56723$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $3Er4K.getListItemTextUtilityClass), classes);
};
const $9dc4208e00f56723$var$ListItemTextRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3Er4K.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $3Er4K.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $9dc4208e00f56723$var$ListItemText = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $cFLic.default)(props, $9dc4208e00f56723$var$_excluded);
    const { dense: dense } = $7fPBF.useContext((0, $cMvyt.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $9dc4208e00f56723$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $3loMv.default) && !disableTypography) primary = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), (0, $kY3Ke.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $3loMv.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), (0, $kY3Ke.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($9dc4208e00f56723$var$ListItemTextRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $9dc4208e00f56723$export$2e2bcd8739ae039 = $9dc4208e00f56723$var$ListItemText;

});
parcelRequire.register("3Er4K", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", function () { return $2a8a1c268392e331$export$1061006a0db3aeb5; });
$parcel$export(module.exports, "default", function () { return $2a8a1c268392e331$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $k6RDS.default)("MuiListItemText", slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $4jzsB.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;

});


parcelRequire.register("58CWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bdbe9250415b022$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cMvyt = parcelRequire("cMvyt");

var $3RNaF = parcelRequire("3RNaF");

var $hQtyv = parcelRequire("hQtyv");

var $6NwTb = parcelRequire("6NwTb");

var $glmzs = parcelRequire("glmzs");

var $awhCL = parcelRequire("awhCL");

var $3Er4K = parcelRequire("3Er4K");

var $b9wlN = parcelRequire("b9wlN");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3bdbe9250415b022$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $b9wlN.getMenuItemUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $b9wlN.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b9wlN.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b9wlN.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $b9wlN.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b9wlN.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $glmzs.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $glmzs.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $3Er4K.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $3Er4K.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $awhCL.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $kY3Ke.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $awhCL.default).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $cFLic.default)(props, $3bdbe9250415b022$var$_excluded);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $hQtyv.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $6NwTb.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($3bdbe9250415b022$var$MenuItemRoot, (0, $kY3Ke.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $hngXp.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;

});
parcelRequire.register("b9wlN", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", function () { return $81e9a11bd449f186$export$515f8c67b5305377; });
$parcel$export(module.exports, "default", function () { return $81e9a11bd449f186$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $k6RDS.default)("MuiMenuItem", slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $4jzsB.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;

});


parcelRequire.register("abILr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76ada7aef489324c$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");


var $bpHMA = parcelRequire("bpHMA");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");
var $lvsHI = parcelRequire("lvsHI");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cZUk6 = parcelRequire("cZUk6");

var $bbzbN = parcelRequire("bbzbN");
"use client";
let $76ada7aef489324c$var$_ = (t)=>t, $76ada7aef489324c$var$t, $76ada7aef489324c$var$t1, $76ada7aef489324c$var$t2, $76ada7aef489324c$var$t3;
const $76ada7aef489324c$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $76ada7aef489324c$var$_1 = (t)=>t, $76ada7aef489324c$var$_t, $76ada7aef489324c$var$_t2, $76ada7aef489324c$var$_t3, $76ada7aef489324c$var$_t4;
const $76ada7aef489324c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cZUk6.getSkeletonUtilityClass), classes);
};
const $76ada7aef489324c$var$pulseKeyframe = (0, $bpHMA.keyframes)($76ada7aef489324c$var$_t || ($76ada7aef489324c$var$_t = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t || ($76ada7aef489324c$var$t = $76ada7aef489324c$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`))));
const $76ada7aef489324c$var$waveKeyframe = (0, $bpHMA.keyframes)($76ada7aef489324c$var$_t2 || ($76ada7aef489324c$var$_t2 = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t1 || ($76ada7aef489324c$var$t1 = $76ada7aef489324c$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`))));
const $76ada7aef489324c$var$SkeletonRoot = (0, $kDBhE.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $lvsHI.getUnit)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $lvsHI.toUnitless)(theme.shape.borderRadius);
    return (0, $kY3Ke.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $cxeT8.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $bpHMA.css)($76ada7aef489324c$var$_t3 || ($76ada7aef489324c$var$_t3 = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t2 || ($76ada7aef489324c$var$t2 = $76ada7aef489324c$var$_`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), 0)), $76ada7aef489324c$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $bpHMA.css)($76ada7aef489324c$var$_t4 || ($76ada7aef489324c$var$_t4 = $76ada7aef489324c$var$_1($76ada7aef489324c$var$t3 || ($76ada7aef489324c$var$t3 = $76ada7aef489324c$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), 0, 0)), $76ada7aef489324c$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $76ada7aef489324c$var$Skeleton = /*#__PURE__*/ $7fPBF.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $cFLic.default)(props, $76ada7aef489324c$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $76ada7aef489324c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($76ada7aef489324c$var$SkeletonRoot, (0, $kY3Ke.default)({
        as: component,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $kY3Ke.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $76ada7aef489324c$export$2e2bcd8739ae039 = $76ada7aef489324c$var$Skeleton;

});
parcelRequire.register("lvsHI", function(module, exports) {

$parcel$export(module.exports, "getUnit", function () { return $fa82c24039cb02ec$export$65f2564e9a9b9222; });
$parcel$export(module.exports, "toUnitless", function () { return $fa82c24039cb02ec$export$8af1d214c6c2f0f1; });
function $fa82c24039cb02ec$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $fa82c24039cb02ec$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $fa82c24039cb02ec$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $fa82c24039cb02ec$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $fa82c24039cb02ec$export$8af1d214c6c2f0f1(length) * $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $fa82c24039cb02ec$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $fa82c24039cb02ec$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $fa82c24039cb02ec$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $fa82c24039cb02ec$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRequire.register("cZUk6", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", function () { return $9766df26003dc3cf$export$c987db9fc844f86; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $9766df26003dc3cf$export$c987db9fc844f86(slot) {
    return (0, $k6RDS.default)("MuiSkeleton", slot);
}
const $9766df26003dc3cf$var$skeletonClasses = (0, $4jzsB.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $9766df26003dc3cf$export$2e2bcd8739ae039 = $9766df26003dc3cf$var$skeletonClasses;

});


parcelRequire.register("cAbNk", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9291ff02b1f1a303$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $9291ff02b1f1a303$var$_default = (0, $9291ff02b1f1a303$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
}), "Logout");
module.exports.default = $9291ff02b1f1a303$var$_default;

});

parcelRequire.register("1quPt", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10a02231be48b17e$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $10a02231be48b17e$var$_default = (0, $10a02231be48b17e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");
module.exports.default = $10a02231be48b17e$var$_default;

});

parcelRequire.register("a8T0C", function(module, exports) {

$parcel$export(module.exports, "DeleteClubForm", function () { return $cfaa7e2a4d763c05$export$5babf885b6efba50; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $fnVR5 = parcelRequire("fnVR5");

var $bmgat = parcelRequire("bmgat");

var $kIGHc = parcelRequire("kIGHc");
const $cfaa7e2a4d763c05$export$5babf885b6efba50 = ({ clubId: clubId })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const { mutate: mutate } = (0, $kIGHc.useDeleteClub)(clubId);
    const handleCloseModal = ()=>{
        setModal({
            open: false,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
        });
    };
    const handleDeleteClub = ()=>{
        mutate();
        setModal({
            open: false,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bmgat.Description), {
                children: t("club.message.deleteClubDescription")
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bmgat.ButtonBox), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bmgat.StyledAppButton), {
                        id: "cancel",
                        variant: "outlined",
                        type: "reset",
                        onClick: handleCloseModal,
                        children: t("cancel")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bmgat.StyledAppButton), {
                        id: "delete-club",
                        variant: "contained",
                        color: "error",
                        onClick: handleDeleteClub,
                        children: t("delete")
                    })
                ]
            })
        ]
    });
};

});
parcelRequire.register("bmgat", function(module, exports) {

$parcel$export(module.exports, "StyledAppButton", function () { return $f45ec2938b18f83e$export$e3da0e99c81a4b99; });
$parcel$export(module.exports, "Description", function () { return $f45ec2938b18f83e$export$393edc798c47379d; });
$parcel$export(module.exports, "ButtonBox", function () { return $f45ec2938b18f83e$export$5e37f977ae0514c2; });

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");

var $aili3 = parcelRequire("aili3");
let $f45ec2938b18f83e$var$_ = (t)=>t, $f45ec2938b18f83e$var$t, $f45ec2938b18f83e$var$t1, $f45ec2938b18f83e$var$t2;
const $f45ec2938b18f83e$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($f45ec2938b18f83e$var$t || ($f45ec2938b18f83e$var$t = $f45ec2938b18f83e$var$_`
    width: 100%;
`));
const $f45ec2938b18f83e$export$393edc798c47379d = (0, $6hfZk.default).p($f45ec2938b18f83e$var$t1 || ($f45ec2938b18f83e$var$t1 = $f45ec2938b18f83e$var$_`
    padding: 0 16px 16px 16px;
`));
const $f45ec2938b18f83e$export$5e37f977ae0514c2 = (0, $6hfZk.default)((0, $aili3.default))($f45ec2938b18f83e$var$t2 || ($f45ec2938b18f83e$var$t2 = $f45ec2938b18f83e$var$_`
    display: flex;
    gap: 8px;
    padding: 8px;
`));

});

parcelRequire.register("kIGHc", function(module, exports) {

$parcel$export(module.exports, "useDeleteClub", function () { return $baf55008211335ce$export$ed0c2e58f6ffcee2; });
parcelRequire("fI21S");
var $6V5bv = parcelRequire("6V5bv");
var $3irMb = parcelRequire("3irMb");

var $dNDci = parcelRequire("dNDci");

var $7fPBF = parcelRequire("7fPBF");

var $i1fqN = parcelRequire("i1fqN");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
function $baf55008211335ce$export$ed0c2e58f6ffcee2(clubId) {
    const appService = new (0, $dNDci.AppService)();
    const queryClient = (0, $6V5bv.useQueryClient)();
    const navigate = (0, $iIluI.useNavigate)();
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const refetchClubQuery = ()=>{
        queryClient.invalidateQueries("clubs");
        navigate("/club-admin");
        appContext.setClub(null);
    };
    const { isLoading: isLoading, data: data, mutate: mutate } = (0, $3irMb.useMutation)({
        mutationKey: [
            "deleteClub"
        ],
        mutationFn: async ()=>{
            const res = await appService.api_deleteClub(clubId);
            return res;
        },
        onSuccess: refetchClubQuery
    });
    return {
        data: data,
        isLoading: isLoading,
        mutate: mutate
    };
}

});
parcelRequire.register("i1fqN", function(module, exports) {

$parcel$export(module.exports, "AppContext", function () { return $058201ddbc14bcbd$export$122994dc05ba4308; });
$parcel$export(module.exports, "AppContextProvider", function () { return $058201ddbc14bcbd$export$20d2b7652facc723; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $058201ddbc14bcbd$export$122994dc05ba4308 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    club: null,
    setClub: ()=>{},
    hasClubChanged: false,
    setHasClubChanged: ()=>{},
    newBookings: false,
    setNewBookings: ()=>{},
    bookingUpdate: false,
    setBookingUpdate: ()=>{}
});
const $058201ddbc14bcbd$export$20d2b7652facc723 = (props)=>{
    const [club, setClub] = (0, $7fPBF.useState)(()=>{
        const storedClub = localStorage.getItem("clubAdmin.selectedClub");
        return storedClub ? JSON.parse(storedClub) : null;
    });
    const [hasClubChanged, setHasClubChanged] = (0, $7fPBF.useState)(false);
    const [newBookings, setNewBookings] = (0, $7fPBF.useState)(false);
    const [bookingUpdate, setBookingUpdate] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($058201ddbc14bcbd$export$122994dc05ba4308.Provider, {
        value: {
            club: club,
            setClub: setClub,
            newBookings: newBookings,
            setNewBookings: setNewBookings,
            bookingUpdate: bookingUpdate,
            setBookingUpdate: setBookingUpdate,
            hasClubChanged: hasClubChanged,
            setHasClubChanged: setHasClubChanged
        },
        children: props.children
    });
};

});



parcelRequire.register("2rOQj", function(module, exports) {

$parcel$export(module.exports, "useFeatureToggles", function () { return $e1bdc8752ff18c60$export$68d38bc471eccfe7; });

var $7fPBF = parcelRequire("7fPBF");

var $dNDci = parcelRequire("dNDci");

var $icsrd = parcelRequire("icsrd");
const $e1bdc8752ff18c60$export$68d38bc471eccfe7 = ()=>{
    const appService = new (0, $dNDci.AppService)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const { domainFeatureToggles: domainFeatureToggles, setDomainFeatureToggles: setDomainFeatureToggles, featureToggles: featureToggles, setFeatureToggles: setFeatureToggles } = (0, $icsrd.useFeatureTogglesContext)();
    const fetchClubFeatureToggles = (clubId)=>{
        if (clubId !== undefined) {
            if (Object.keys(featureToggles)[0] === clubId) return;
            setIsLoading(true);
            appService.api_getClubFeatureToggles("private", clubId).then((res)=>{
                if (res.status !== 200) throw new Error();
                setFeatureToggles({
                    [clubId]: res.data
                });
            }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
        }
    };
    const fetchDomainFeatureToggles = ()=>{
        setIsLoading(true);
        appService.api_getDomainFeatureToggles().then((res)=>{
            if (res.status !== 200) throw new Error();
            setDomainFeatureToggles(res.data);
            localStorage.setItem("domainFeatureToggles", JSON.stringify(res.data));
        }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
    };
    const hasFeatureToggle = (claim)=>{
        var _Object_values_;
        return (_Object_values_ = Object.values(featureToggles)[0]) === null || _Object_values_ === void 0 ? void 0 : _Object_values_.some((ft)=>ft.name === claim);
    };
    const hasDomainFeatureToggle = (domainClaim)=>{
        var _Object_values;
        return (_Object_values = Object.values(domainFeatureToggles)) === null || _Object_values === void 0 ? void 0 : _Object_values.some((ft)=>ft.name === domainClaim);
    };
    return {
        isLoading: isLoading,
        actions: {
            hasFeatureToggle: hasFeatureToggle,
            fetchClubFeatureToggles: fetchClubFeatureToggles,
            fetchDomainFeatureToggles: fetchDomainFeatureToggles,
            hasDomainFeatureToggle: hasDomainFeatureToggle
        }
    };
};

});
parcelRequire.register("icsrd", function(module, exports) {

$parcel$export(module.exports, "FeatureTogglesContext", function () { return $fa09dede99abcc30$export$129015ae45330ee6; });
$parcel$export(module.exports, "FeatureTogglesContextProvider", function () { return $fa09dede99abcc30$export$f8dfcc2e7bcb7b71; });
$parcel$export(module.exports, "useFeatureTogglesContext", function () { return $fa09dede99abcc30$export$537d889e6c4d96fe; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $fa09dede99abcc30$export$129015ae45330ee6 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isLoading: true,
    setIsLoading: ()=>{},
    featureToggles: {},
    setFeatureToggles: ()=>{},
    domainFeatureToggles: {},
    setDomainFeatureToggles: ()=>{}
});
const $fa09dede99abcc30$export$f8dfcc2e7bcb7b71 = (props)=>{
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [featureToggles, setFeatureToggles] = (0, $7fPBF.useState)({});
    const [domainFeatureToggles, setDomainFeatureToggles] = (0, $7fPBF.useState)(()=>{
        const storedDomainFeatureToggles = localStorage.getItem("domainFeatureToggles");
        return storedDomainFeatureToggles ? JSON.parse(storedDomainFeatureToggles) : {};
    });
    const values = {
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        featureToggles: featureToggles,
        setFeatureToggles: setFeatureToggles,
        domainFeatureToggles: domainFeatureToggles,
        setDomainFeatureToggles: setDomainFeatureToggles
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fa09dede99abcc30$export$129015ae45330ee6.Provider, {
        value: values,
        children: props.children
    });
};
const $fa09dede99abcc30$export$537d889e6c4d96fe = ()=>(0, $7fPBF.useContext)($fa09dede99abcc30$export$129015ae45330ee6);

});


parcelRequire.register("3Ou5w", function(module, exports) {

$parcel$export(module.exports, "FeatureToggles", function () { return $fb218e87b3a35126$export$93400b7ea76be473; });
$parcel$export(module.exports, "featureTogglesMap", function () { return $fb218e87b3a35126$export$a4194d8faa85095b; });
var $fb218e87b3a35126$export$93400b7ea76be473;
(function(FeatureToggles) {
    FeatureToggles["RESERVATION_HISTORY"] = "RESERVATION_HISTORY";
    FeatureToggles["RESERVATION_TYPES"] = "RESERVATION_TYPES";
    FeatureToggles["SET_ORGANIZATIONS"] = "SET_ORGANIZATIONS";
    FeatureToggles["GOOGLE_SSO"] = "GOOGLE_SSO";
    FeatureToggles["SHARE_AVAILABLE_SLOTS"] = "SHARE_AVAILABLE_SLOTS";
    FeatureToggles["BANK_TRANSFER"] = "BANK_TRANSFER";
    FeatureToggles["CASH"] = "CASH";
    FeatureToggles["MBWAY"] = "MBWAY";
    FeatureToggles["CREDIT_CARD"] = "CREDIT_CARD";
})($fb218e87b3a35126$export$93400b7ea76be473 || ($fb218e87b3a35126$export$93400b7ea76be473 = {}));
const $fb218e87b3a35126$export$a4194d8faa85095b = {
    RESERVATION_HISTORY: "RESERVATION_HISTORY",
    RESERVATION_TYPES: "RESERVATION_TYPES",
    SET_ORGANIZATIONS: "SET_ORGANIZATIONS",
    GOOGLE_SSO: "GOOGLE_SSO",
    SHARE_AVAILABLE_SLOTS: "SHARE_AVAILABLE_SLOTS",
    BANK_TRANSFER: "BANK_TRANSFER",
    CASH: "CASH",
    MBWAY: "MBWAY",
    CREDIT_CARD: "CREDIT_CARD"
};

});

parcelRequire.register("7qlUi", function(module, exports) {

$parcel$export(module.exports, "FeatureToggleBaseComponent", function () { return $8657a6e173fbba5c$export$b4743f1589f77055; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $2rOQj = parcelRequire("2rOQj");

var $iIluI = parcelRequire("iIluI");
const $8657a6e173fbba5c$export$b4743f1589f77055 = ({ featureToggle: featureToggle, redirect: redirect, children: children })=>{
    const { actions: { hasFeatureToggle: hasFeatureToggle, hasDomainFeatureToggle: hasDomainFeatureToggle } } = (0, $2rOQj.useFeatureToggles)();
    const hasClaim = hasFeatureToggle(featureToggle);
    const hasDomainClaim = hasDomainFeatureToggle(featureToggle);
    if (!hasClaim && redirect) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Navigate), {
        to: redirect
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            hasClaim ? children : null,
            hasDomainClaim ? children : null
        ]
    });
};

});

parcelRequire.register("hyW56", function(module, exports) {

$parcel$export(module.exports, "useClubs", function () { return $11ca26fc81ca7817$export$9b0e56d4637b3f2e; });
parcelRequire("fI21S");
var $1HW2x = parcelRequire("1HW2x");

var $dNDci = parcelRequire("dNDci");
function $11ca26fc81ca7817$export$9b0e56d4637b3f2e(role) {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, data: data = [] } = (0, $1HW2x.useQuery)({
        queryKey: [
            "clubs"
        ],
        queryFn: async ()=>{
            const res = await appService.api_getClubs(role);
            return res.data;
        }
    });
    return {
        data: data,
        isLoading: isLoading
    };
}

});

parcelRequire.register("8HmXW", function(module, exports) {

$parcel$export(module.exports, "StyledSpan", function () { return $d0ac857c7676f946$export$a074478385368bdf; });
$parcel$export(module.exports, "StyledIconButton", function () { return $d0ac857c7676f946$export$2e4108fd8c581ed2; });
$parcel$export(module.exports, "MUIMenuIcon", function () { return $d0ac857c7676f946$export$ea08a2f601308aa1; });
$parcel$export(module.exports, "StyledListItemText", function () { return $d0ac857c7676f946$export$6fbb8dcf01447d41; });
$parcel$export(module.exports, "Image", function () { return $d0ac857c7676f946$export$3e431a229df88919; });

var $6hfZk = parcelRequire("6hfZk");

var $aili3 = parcelRequire("aili3");
var $8TDId = parcelRequire("8TDId");
var $dxMGW = parcelRequire("dxMGW");

var $7A1zy = parcelRequire("7A1zy");
let $d0ac857c7676f946$var$_ = (t)=>t, $d0ac857c7676f946$var$t, $d0ac857c7676f946$var$t1, $d0ac857c7676f946$var$t2, $d0ac857c7676f946$var$t3, $d0ac857c7676f946$var$t4, $d0ac857c7676f946$var$t5, $d0ac857c7676f946$var$t6;
const $d0ac857c7676f946$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($d0ac857c7676f946$var$t || ($d0ac857c7676f946$var$t = $d0ac857c7676f946$var$_`
    display: flex;
    @media (max-width: 600px) {
        flex-direction: column;
    },
`));
const $d0ac857c7676f946$export$8a7fb03b17c12e52 = (0, $6hfZk.default)((0, $aili3.default))($d0ac857c7676f946$var$t1 || ($d0ac857c7676f946$var$t1 = $d0ac857c7676f946$var$_`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`));
const $d0ac857c7676f946$export$a074478385368bdf = (0, $6hfZk.default).span($d0ac857c7676f946$var$t2 || ($d0ac857c7676f946$var$t2 = $d0ac857c7676f946$var$_`
    width: 40px;
    height: 40px;
`));
const $d0ac857c7676f946$export$2e4108fd8c581ed2 = (0, $6hfZk.default)((0, $8TDId.default))($d0ac857c7676f946$var$t3 || ($d0ac857c7676f946$var$t3 = $d0ac857c7676f946$var$_`
    width: 50px !important;
    height: 50px !important;
`));
const $d0ac857c7676f946$export$ea08a2f601308aa1 = (0, $6hfZk.default)((0, (/*@__PURE__*/$parcel$interopDefault($7A1zy))))($d0ac857c7676f946$var$t4 || ($d0ac857c7676f946$var$t4 = $d0ac857c7676f946$var$_`
    color: #fff;
`));
const $d0ac857c7676f946$export$6fbb8dcf01447d41 = (0, $6hfZk.default)((0, $dxMGW.default))($d0ac857c7676f946$var$t5 || ($d0ac857c7676f946$var$t5 = $d0ac857c7676f946$var$_`
    color: #ff5252;
`));
const $d0ac857c7676f946$export$3e431a229df88919 = (0, $6hfZk.default).img($d0ac857c7676f946$var$t6 || ($d0ac857c7676f946$var$t6 = $d0ac857c7676f946$var$_`
    height: 45px;
    @media (max-width: 600px) {
        height: 25px;
    },
`));

});
parcelRequire.register("7A1zy", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $584d1d79bcf8f59f$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $584d1d79bcf8f59f$var$_default = (0, $584d1d79bcf8f59f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
module.exports.default = $584d1d79bcf8f59f$var$_default;

});


parcelRequire.register("hGobg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b665f09aa2005c09$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $fV1Xm = parcelRequire("fV1Xm");

var $c3xje = parcelRequire("c3xje");

var $dNDci = parcelRequire("dNDci");

var $fnVR5 = parcelRequire("fnVR5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $i1fqN = parcelRequire("i1fqN");
const $b665f09aa2005c09$export$8087df9978308c1d = ()=>{
    const role = (0, $c3xje.useRole)();
    const navigate = (0, $iIluI.useNavigate)();
    const { activeStep: activeStep, setActiveStep: setActiveStep, setIsLoading: setIsLoading, isLoading: isLoading } = (0, $fV1Xm.useClubs)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const [isFormVisible, setIsFormVisible] = (0, $7fPBF.useState)(false);
    const { t: t } = (0, $doyfp.useTranslation)();
    const isReady = (0, $7fPBF.useRef)(false);
    //AppContext
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const clubContext = appContext.club;
    const handleNext = ()=>{
        setActiveStep(activeStep + 1);
    };
    const handleBack = ()=>{
        setActiveStep(activeStep - 1);
    };
    const getClubById = (0, $7fPBF.useCallback)(async ()=>{
        const appService = new (0, $dNDci.AppService)();
        if (clubContext) await appService.api_getClubById(role, clubContext === null || clubContext === void 0 ? void 0 : clubContext.id).then((res)=>{
            if (res.status === 200) {
                localStorage.setItem("clubAdmin.selectedClub", JSON.stringify(res.data));
                appContext.setClub(res.data);
            }
            setIsLoading(false);
        }).catch(()=>{
            navigate("/club-admin/club-details");
        });
    }, [
        role,
        setIsLoading,
        navigate,
        appContext,
        clubContext
    ]);
    const createClubContact = (0, $7fPBF.useCallback)(async (formData)=>{
        const appService = new (0, $dNDci.AppService)();
        await appService.api_createClubContact(clubContext === null || clubContext === void 0 ? void 0 : clubContext.id, formData).then((res)=>{
            if (res.status !== 201) throw new Error(res);
            if (res.status === 201) {
                getClubById();
                setIsFormVisible(false);
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: t("clubDetails.contacts.message.success")
                });
            }
            setIsLoading(false);
        }).catch((error)=>{
            setIsFormVisible(false);
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubDetails.contacts.message.error")
            });
        });
    }, [
        clubContext,
        setIsLoading,
        getClubById,
        setIsFormVisible,
        setSnackbar,
        t
    ]);
    const deleteClubContact = (0, $7fPBF.useCallback)(async (contactId)=>{
        const appService = new (0, $dNDci.AppService)();
        await appService.api_deleteClubContact(contactId).then((res)=>{
            if (res.status !== 200) throw new Error(res);
            if (res.status === 200) {
                getClubById();
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: t("clubDetails.contacts.message.deleteSuccess")
                });
            }
            setIsLoading(false);
        }).catch((error)=>{
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubDetails.contacts.message.error")
            });
        });
    }, [
        setIsLoading,
        getClubById,
        setSnackbar,
        t
    ]);
    const updateClubContact = (0, $7fPBF.useCallback)(async (contactId, formData)=>{
        const appService = new (0, $dNDci.AppService)();
        await appService.api_updateClubContact(contactId, formData).then((res)=>{
            if (res.status !== 200) throw new Error(res);
            if (res.status === 200) {
                setIsFormVisible(false);
                getClubById();
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: t("clubDetails.contacts.message.updateSuccess")
                });
            }
            setIsLoading(false);
        }).catch((error)=>{
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubDetails.contacts.message.error")
            });
        });
    }, [
        setIsLoading,
        getClubById,
        setSnackbar,
        t
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isReady.current) return;
        isReady.current = true;
        getClubById();
        setIsLoading(false);
    }, [
        clubContext,
        getClubById,
        setIsLoading
    ]);
    return {
        isLoading: isLoading,
        activeStep: activeStep,
        handleNext: handleNext,
        handleBack: handleBack,
        setActiveStep: setActiveStep,
        createClubContact: createClubContact,
        isFormVisible: isFormVisible,
        setIsFormVisible: setIsFormVisible,
        deleteClubContact: deleteClubContact,
        updateClubContact: updateClubContact,
        getClubById: getClubById
    };
};
var $b665f09aa2005c09$export$2e2bcd8739ae039 = $b665f09aa2005c09$export$8087df9978308c1d;

});
parcelRequire.register("fV1Xm", function(module, exports) {

$parcel$export(module.exports, "ClubsContextProvider", function () { return $f9047e5a8ccb9abb$export$ce41fba7e49989e9; });
$parcel$export(module.exports, "useClubs", function () { return $f9047e5a8ccb9abb$export$9b0e56d4637b3f2e; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $f9047e5a8ccb9abb$export$e565f977f5caba11;
(function(ClubsContextKeys) {
    ClubsContextKeys["Club"] = "club";
})($f9047e5a8ccb9abb$export$e565f977f5caba11 || ($f9047e5a8ccb9abb$export$e565f977f5caba11 = {}));
const $f9047e5a8ccb9abb$export$c7a8915e61147535 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    club: null,
    setClub: ()=>{},
    isLoading: true,
    setIsLoading: ()=>{},
    activeStep: 0,
    setActiveStep: ()=>{}
});
const $f9047e5a8ccb9abb$export$ce41fba7e49989e9 = (props)=>{
    const [club, setClub] = (0, $7fPBF.useState)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [activeStep, setActiveStep] = (0, $7fPBF.useState)(0);
    const values = {
        club: club,
        setClub: setClub,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        activeStep: activeStep,
        setActiveStep: setActiveStep
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($f9047e5a8ccb9abb$export$c7a8915e61147535.Provider, {
        value: values,
        children: props.children
    });
};
const $f9047e5a8ccb9abb$export$9b0e56d4637b3f2e = ()=>(0, $7fPBF.useContext)($f9047e5a8ccb9abb$export$c7a8915e61147535);

});

parcelRequire.register("c3xje", function(module, exports) {

$parcel$export(module.exports, "useRole", function () { return $a32c9db3aa4f9d5a$export$f66572793fa256a1; });
function $a32c9db3aa4f9d5a$export$f66572793fa256a1() {
    const role = localStorage.getItem("role");
    if (role === "club-admin") return "private";
    else if (role === "admin") return "admin";
    else if (role === "player") return "public";
    else return "unknown";
}

});



parcelRequire.register("5E3nd", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41c34e1167891c88$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $41c34e1167891c88$var$_default = (0, $41c34e1167891c88$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
module.exports.default = $41c34e1167891c88$var$_default;

});

parcelRequire.register("jTm6v", function(module, exports) {

$parcel$export(module.exports, "UserMenu", function () { return $1c6283c0355a000d$export$72d0b49a56703654; });

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
var $57cKd = parcelRequire("57cKd");
var $dxMGW = parcelRequire("dxMGW");
var $58CWL = parcelRequire("58CWL");
var $3loMv = parcelRequire("3loMv");

var $7fPBF = parcelRequire("7fPBF");

var $bzrhL = parcelRequire("bzrhL");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $2Bwgd = parcelRequire("2Bwgd");

var $cAbNk = parcelRequire("cAbNk");

var $fpWEH = parcelRequire("fpWEH");
const $1c6283c0355a000d$export$72d0b49a56703654 = ()=>{
    const navigate = (0, $iIluI.useNavigate)();
    const [anchorEl, setAnchorEl] = (0, $7fPBF.useState)(null);
    const handleMenu = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                variant: "text",
                onClick: handleMenu,
                color: "white",
                endIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzrhL))), {}),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.MUIPersonIcon), {})
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $fpWEH.MUIMenu), {
                id: "menu-appbar",
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                keepMounted: true,
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                        onClick: ()=>navigate("/club-admin/edit-account"),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                            children: (0, $2Bwgd.t)("clubAdmin.menu.editAccount")
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                        onClick: ()=>navigate("/terms-and-conditions"),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                            children: (0, $2Bwgd.t)("termsAndConditions")
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                        onClick: ()=>navigate("/logout"),
                        color: "primary",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $57cKd.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cAbNk))), {
                                    color: "primary"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                    color: "primary",
                                    children: (0, $2Bwgd.t)("clubAdmin.menu.logout")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRequire.register("bzrhL", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86c820f13f14f9ac$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $86c820f13f14f9ac$var$_default = (0, $86c820f13f14f9ac$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
module.exports.default = $86c820f13f14f9ac$var$_default;

});

parcelRequire.register("2Bwgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e580fbd50c9e2d3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "t", function () { return $1e580fbd50c9e2d3$export$625550452a3fa3ec; });
const $1e580fbd50c9e2d3$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $1e580fbd50c9e2d3$var$Logger {
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $1e580fbd50c9e2d3$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $1e580fbd50c9e2d3$var$Logger(this.logger, options);
    }
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
}
var $1e580fbd50c9e2d3$var$baseLogger = new $1e580fbd50c9e2d3$var$Logger();
class $1e580fbd50c9e2d3$var$EventEmitter {
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
    constructor(){
        this.observers = {};
    }
}
function $1e580fbd50c9e2d3$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $1e580fbd50c9e2d3$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $1e580fbd50c9e2d3$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $1e580fbd50c9e2d3$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $1e580fbd50c9e2d3$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $1e580fbd50c9e2d3$var$getPath(object, path) {
    const { obj: obj, k: k } = $1e580fbd50c9e2d3$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key) {
    const value = $1e580fbd50c9e2d3$var$getPath(data, key);
    if (value !== undefined) return value;
    return $1e580fbd50c9e2d3$var$getPath(defaultData, key);
}
function $1e580fbd50c9e2d3$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $1e580fbd50c9e2d3$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $1e580fbd50c9e2d3$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $1e580fbd50c9e2d3$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $1e580fbd50c9e2d3$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$1e580fbd50c9e2d3$var$_entityMap[s]);
    return data;
}
const $1e580fbd50c9e2d3$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $1e580fbd50c9e2d3$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $1e580fbd50c9e2d3$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $1e580fbd50c9e2d3$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $1e580fbd50c9e2d3$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $1e580fbd50c9e2d3$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $1e580fbd50c9e2d3$var$ResourceStore extends $1e580fbd50c9e2d3$var$EventEmitter {
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $1e580fbd50c9e2d3$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $1e580fbd50c9e2d3$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $1e580fbd50c9e2d3$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $1e580fbd50c9e2d3$var$getPath(this.data, path) || {};
        if (deep) $1e580fbd50c9e2d3$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $1e580fbd50c9e2d3$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
}
var $1e580fbd50c9e2d3$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $1e580fbd50c9e2d3$var$checkedLoadedFor = {};
class $1e580fbd50c9e2d3$var$Translator extends $1e580fbd50c9e2d3$var$EventEmitter {
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$1e580fbd50c9e2d3$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $1e580fbd50c9e2d3$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $1e580fbd50c9e2d3$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $1e580fbd50c9e2d3$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $1e580fbd50c9e2d3$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create("translator");
    }
}
function $1e580fbd50c9e2d3$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $1e580fbd50c9e2d3$var$LanguageUtil {
    getScriptPartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $1e580fbd50c9e2d3$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $1e580fbd50c9e2d3$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $1e580fbd50c9e2d3$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $1e580fbd50c9e2d3$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create("languageUtils");
    }
}
let $1e580fbd50c9e2d3$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $1e580fbd50c9e2d3$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $1e580fbd50c9e2d3$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $1e580fbd50c9e2d3$var$intlVersions = [
    "v4"
];
const $1e580fbd50c9e2d3$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $1e580fbd50c9e2d3$var$createRules() {
    const rules = {};
    $1e580fbd50c9e2d3$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $1e580fbd50c9e2d3$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $1e580fbd50c9e2d3$var$PluralResolver {
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($1e580fbd50c9e2d3$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory1] - $1e580fbd50c9e2d3$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$1e580fbd50c9e2d3$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $1e580fbd50c9e2d3$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $1e580fbd50c9e2d3$var$createRules();
    }
}
function $1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $1e580fbd50c9e2d3$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $1e580fbd50c9e2d3$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $1e580fbd50c9e2d3$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $1e580fbd50c9e2d3$var$Interpolator {
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $1e580fbd50c9e2d3$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $1e580fbd50c9e2d3$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $1e580fbd50c9e2d3$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $1e580fbd50c9e2d3$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($1e580fbd50c9e2d3$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $1e580fbd50c9e2d3$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $1e580fbd50c9e2d3$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
}
function $1e580fbd50c9e2d3$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $1e580fbd50c9e2d3$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($1e580fbd50c9e2d3$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $1e580fbd50c9e2d3$var$Formatter {
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $1e580fbd50c9e2d3$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $1e580fbd50c9e2d3$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $1e580fbd50c9e2d3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $1e580fbd50c9e2d3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $1e580fbd50c9e2d3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $1e580fbd50c9e2d3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $1e580fbd50c9e2d3$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
}
function $1e580fbd50c9e2d3$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $1e580fbd50c9e2d3$var$Connector extends $1e580fbd50c9e2d3$var$EventEmitter {
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $1e580fbd50c9e2d3$var$pushPath(q.loaded, [
                lng
            ], ns);
            $1e580fbd50c9e2d3$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $1e580fbd50c9e2d3$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
}
function $1e580fbd50c9e2d3$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $1e580fbd50c9e2d3$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $1e580fbd50c9e2d3$var$noop() {}
function $1e580fbd50c9e2d3$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $1e580fbd50c9e2d3$var$I18n extends $1e580fbd50c9e2d3$var$EventEmitter {
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $1e580fbd50c9e2d3$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$1e580fbd50c9e2d3$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $1e580fbd50c9e2d3$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $1e580fbd50c9e2d3$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $1e580fbd50c9e2d3$var$Formatter;
            const lu = new $1e580fbd50c9e2d3$var$LanguageUtil(this.options);
            this.store = new $1e580fbd50c9e2d3$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $1e580fbd50c9e2d3$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $1e580fbd50c9e2d3$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $1e580fbd50c9e2d3$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $1e580fbd50c9e2d3$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $1e580fbd50c9e2d3$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $1e580fbd50c9e2d3$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1e580fbd50c9e2d3$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $1e580fbd50c9e2d3$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $1e580fbd50c9e2d3$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $1e580fbd50c9e2d3$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $1e580fbd50c9e2d3$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $1e580fbd50c9e2d3$var$LanguageUtil($1e580fbd50c9e2d3$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $1e580fbd50c9e2d3$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1e580fbd50c9e2d3$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $1e580fbd50c9e2d3$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $1e580fbd50c9e2d3$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $1e580fbd50c9e2d3$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $1e580fbd50c9e2d3$var$transformOptions(options);
        this.services = {};
        this.logger = $1e580fbd50c9e2d3$var$baseLogger;
        this.modules = {
            external: []
        };
        $1e580fbd50c9e2d3$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
}
const $1e580fbd50c9e2d3$export$2e2bcd8739ae039 = $1e580fbd50c9e2d3$var$I18n.createInstance();
$1e580fbd50c9e2d3$export$2e2bcd8739ae039.createInstance = $1e580fbd50c9e2d3$var$I18n.createInstance;
const $1e580fbd50c9e2d3$export$99152e8d49ca4e7d = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.createInstance;
const $1e580fbd50c9e2d3$export$147ec2801e896265 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.dir;
const $1e580fbd50c9e2d3$export$2cd8252107eb640b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.init;
const $1e580fbd50c9e2d3$export$d3d08d944062d7e = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadResources;
const $1e580fbd50c9e2d3$export$a5d9bf5d83fcab09 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.reloadResources;
const $1e580fbd50c9e2d3$export$1f96ae73734a86cc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.use;
const $1e580fbd50c9e2d3$export$61465194746e7fd2 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.changeLanguage;
const $1e580fbd50c9e2d3$export$f90d180fc7da3b3b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.getFixedT;
const $1e580fbd50c9e2d3$export$625550452a3fa3ec = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.t;
const $1e580fbd50c9e2d3$export$f7e9f41ea797a17 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.exists;
const $1e580fbd50c9e2d3$export$2b4b218e406d2d00 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.setDefaultNamespace;
const $1e580fbd50c9e2d3$export$93d9ee97c1ad3f31 = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.hasLoadedNamespace;
const $1e580fbd50c9e2d3$export$83be934b53fff43b = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadNamespaces;
const $1e580fbd50c9e2d3$export$8cd7e7a54fa865bc = $1e580fbd50c9e2d3$export$2e2bcd8739ae039.loadLanguages;

});

parcelRequire.register("fpWEH", function(module, exports) {

$parcel$export(module.exports, "StyledToolbar", function () { return $ee814f8a384a4a61$export$f3f426abf36f8c0; });
$parcel$export(module.exports, "MenuLink", function () { return $ee814f8a384a4a61$export$519285cd418d549c; });
$parcel$export(module.exports, "MUIPersonIcon", function () { return $ee814f8a384a4a61$export$87ae4d09eefeb899; });
$parcel$export(module.exports, "MUIMenu", function () { return $ee814f8a384a4a61$export$b04cb5252813effe; });
$parcel$export(module.exports, "StyledName", function () { return $ee814f8a384a4a61$export$8929325e2151fe55; });
$parcel$export(module.exports, "StyledMenuBox", function () { return $ee814f8a384a4a61$export$fd2ca43e4c3fac40; });
$parcel$export(module.exports, "StyledAppButton", function () { return $ee814f8a384a4a61$export$e3da0e99c81a4b99; });
$parcel$export(module.exports, "StyledDialogContent", function () { return $ee814f8a384a4a61$export$5a0bc68f6657e9db; });

var $aili3 = parcelRequire("aili3");
var $8wwTv = parcelRequire("8wwTv");
var $gPL9h = parcelRequire("gPL9h");
var $5Mrqo = parcelRequire("5Mrqo");
var $3loMv = parcelRequire("3loMv");

var $eQAbb = parcelRequire("eQAbb");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $ee814f8a384a4a61$var$_ = (t)=>t, $ee814f8a384a4a61$var$t, $ee814f8a384a4a61$var$t1, $ee814f8a384a4a61$var$t2, $ee814f8a384a4a61$var$t3, $ee814f8a384a4a61$var$t4, $ee814f8a384a4a61$var$t5, $ee814f8a384a4a61$var$t6, $ee814f8a384a4a61$var$t7;
const $ee814f8a384a4a61$export$f3f426abf36f8c0 = (0, $6hfZk.default)((0, $5Mrqo.default))($ee814f8a384a4a61$var$t || ($ee814f8a384a4a61$var$t = $ee814f8a384a4a61$var$_`
    background: white;
    display: flex;
    justify-content: center;

    @media (max-width: 600px) {
        overflow: auto;
        justify-content: flex-start;
    }
`));
const $ee814f8a384a4a61$export$519285cd418d549c = (0, $6hfZk.default)((0, $3loMv.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isActive"
})($ee814f8a384a4a61$var$t1 || ($ee814f8a384a4a61$var$t1 = $ee814f8a384a4a61$var$_`
    padding: 19px 16px;
    cursor: pointer;
    color: ${0};
    border-bottom: ${0};

    @media (max-width: 600px) {
        padding: 19px 6px;
        font-size: 12px !important;
        min-width: fit-content;
    }
`), ({ isActive: isActive })=>isActive ? "var(--color-primary)" : "var(--custom-secondary)", ({ isActive: isActive })=>isActive ? "2px solid var(--color-primary)" : "2px solid #fff");
const $ee814f8a384a4a61$export$87ae4d09eefeb899 = (0, $6hfZk.default)((0, (/*@__PURE__*/$parcel$interopDefault($eQAbb))))($ee814f8a384a4a61$var$t2 || ($ee814f8a384a4a61$var$t2 = $ee814f8a384a4a61$var$_`
    width: 30px;
    height: 30px;
    cursor: pointer;
    background-color: #1976d2;

    @media (max-width: 600px) {
        width: 20px;
        height: 20px;
    }
`));
const $ee814f8a384a4a61$export$b04cb5252813effe = (0, $6hfZk.default)((0, $gPL9h.default))($ee814f8a384a4a61$var$t3 || ($ee814f8a384a4a61$var$t3 = $ee814f8a384a4a61$var$_`
    top: 50px !important;
    left: 22px !important;

    @media (max-width: 600px) {
        top: 40px !important;
    }
`));
const $ee814f8a384a4a61$export$8929325e2151fe55 = (0, $6hfZk.default).div($ee814f8a384a4a61$var$t4 || ($ee814f8a384a4a61$var$t4 = $ee814f8a384a4a61$var$_`
    position: absolute;
    left: 50px;
    width: 300px;
`));
const $ee814f8a384a4a61$export$fd2ca43e4c3fac40 = (0, $6hfZk.default)((0, $aili3.default))($ee814f8a384a4a61$var$t5 || ($ee814f8a384a4a61$var$t5 = $ee814f8a384a4a61$var$_`
    display: flex;
    align-items: center;
    position: relative;
`));
const $ee814f8a384a4a61$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($ee814f8a384a4a61$var$t6 || ($ee814f8a384a4a61$var$t6 = $ee814f8a384a4a61$var$_`
    width: 100%;
`));
const $ee814f8a384a4a61$export$5a0bc68f6657e9db = (0, $6hfZk.default)((0, $8wwTv.default))($ee814f8a384a4a61$var$t7 || ($ee814f8a384a4a61$var$t7 = $ee814f8a384a4a61$var$_`
    @media (max-width: 600px) {
        padding: 10px !important;
    }
`));

});
parcelRequire.register("8wwTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634ad3fd5060cf75$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $8FpGF = parcelRequire("8FpGF");

var $25LML = parcelRequire("25LML");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $634ad3fd5060cf75$var$_excluded = [
    "className",
    "dividers"
];
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8FpGF.getDialogContentUtilityClass), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $kDBhE.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $25LML.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cFLic.default)(props, $634ad3fd5060cf75$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dividers: dividers
    });
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($634ad3fd5060cf75$var$DialogContentRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;

});
parcelRequire.register("8FpGF", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", function () { return $64f614045184fa19$export$61b0ee1f05fb344e; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $k6RDS.default)("MuiDialogContent", slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $4jzsB.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;

});


parcelRequire.register("eQAbb", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acf1fc829c45ea23$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $acf1fc829c45ea23$var$_default = (0, $acf1fc829c45ea23$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
module.exports.default = $acf1fc829c45ea23$var$_default;

});



parcelRequire.register("ki8Af", function(module, exports) {

$parcel$export(module.exports, "TopMenu", function () { return $db059d11cee5beeb$export$415d854973a8d22b; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $7qlUi = parcelRequire("7qlUi");

var $3Ou5w = parcelRequire("3Ou5w");

var $fpWEH = parcelRequire("fpWEH");

var $fnVR5 = parcelRequire("fnVR5");

var $e9iaK = parcelRequire("e9iaK");

var $8smOS = parcelRequire("8smOS");
const $db059d11cee5beeb$export$415d854973a8d22b = ({ selectedClub: selectedClub })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const active = window.location.pathname;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $fpWEH.StyledToolbar), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.MenuLink), {
                textAlign: "center",
                isActive: active === "/club-admin",
                onClick: ()=>navigate("/club-admin"),
                children: t("bookings")
            }),
            selectedClub !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7qlUi.FeatureToggleBaseComponent), {
                featureToggle: (0, $3Ou5w.FeatureToggles).RESERVATION_HISTORY,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.MenuLink), {
                    textAlign: "center",
                    isActive: active.includes("history"),
                    onClick: ()=>{
                        return navigate(`/club-admin/club/${selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id}/history`);
                    },
                    children: t("clubAdmin.menu.historyData")
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.MenuLink), {
                textAlign: "center",
                onClick: ()=>{
                    setModal({
                        open: true,
                        title: t("clubAdmin.menu.clubManagement"),
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.StyledDialogContent), {
                                    dividers: true,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e9iaK.default), {})
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8smOS.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.StyledAppButton), {
                                        id: "cancel",
                                        variant: "outlined",
                                        type: "reset",
                                        onClick: ()=>setModal({
                                                open: false,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                                            }),
                                        children: t("back")
                                    })
                                })
                            ]
                        })
                    });
                },
                children: t("clubAdmin.menu.clubManagement")
            }),
            selectedClub !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.MenuLink), {
                textAlign: "center",
                isActive: active.includes("areas"),
                onClick: ()=>{
                    return navigate(`/club-admin/club/${selectedClub === null || selectedClub === void 0 ? void 0 : selectedClub.id}/areas`);
                },
                children: t("clubAdmin.menu.clubAreas")
            })
        ]
    });
};

});
parcelRequire.register("e9iaK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6a46be4ce45bff1$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
var $8smOS = parcelRequire("8smOS");
var $8wwTv = parcelRequire("8wwTv");
var $8TDId = parcelRequire("8TDId");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $l5i9v = parcelRequire("l5i9v");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $gSx8R = parcelRequire("gSx8R");

var $6M0TM = parcelRequire("6M0TM");

var $hyW56 = parcelRequire("hyW56");

var $i1fqN = parcelRequire("i1fqN");

var $fnVR5 = parcelRequire("fnVR5");

var $bGIah = parcelRequire("bGIah");
var $iopmn = parcelRequire("iopmn");

var $a8T0C = parcelRequire("a8T0C");

var $jmzAX = parcelRequire("jmzAX");
const $b6a46be4ce45bff1$var$ClubsList = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const { data: clubs, isLoading: isLoading } = (0, $hyW56.useClubs)("private");
    //AppContext
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const appClub = appContext.club;
    const handleImageDefault = (clubId)=>{
        setModal({
            open: true,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8wwTv.default), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jmzAX.ClubImageDefaultForm), {
                            clubId: clubId
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8smOS.default), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.StyledGoBack), {
                            id: "cancel",
                            variant: "outlined",
                            type: "reset",
                            onClick: ()=>setModal({
                                    open: false,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                                }),
                            children: t("back")
                        })
                    })
                ]
            }),
            title: t("clubImageDefaultTitle")
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.ClubListContainer), {
        children: (clubs === null || clubs === void 0 ? void 0 : clubs.length) > 0 ? isLoading ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}) : clubs === null || clubs === void 0 ? void 0 : clubs.map((club)=>{
            var _club_areas;
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6M0TM.ClubListCard), {
                isActive: club.id === (appClub === null || appClub === void 0 ? void 0 : appClub.id),
                children: [
                    club.photos && club.photos.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                        children: club.photos.map((photo, index)=>{
                            if (photo.isDefault) return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6M0TM.ImageBox), {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.Image), {
                                        src: photo.photoUrl,
                                        alt: "",
                                        onClick: ()=>handleImageDefault(photo.clubId)
                                    }, index),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.StyledRemoveRedEyeIcon), {
                                        fontSize: "small"
                                    })
                                ]
                            });
                            else if (index === 0 && !club.photos.some((p)=>p.isDefault)) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.Image), {
                                src: photo.photoUrl,
                                alt: ""
                            }, index);
                            return null;
                        })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.Image), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($l5i9v))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6M0TM.CardContentStyled), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                sx: {
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.ClubName), {
                                        children: club.name
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                                                "aria-label": "delete",
                                                size: "small",
                                                color: "primary",
                                                onClick: ()=>{
                                                    setModal({
                                                        open: true,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a8T0C.DeleteClubForm), {
                                                            clubId: club.id
                                                        }),
                                                        title: t("club.message.deleteClubTitle", {
                                                            club: club.name
                                                        })
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bGIah.default), {})
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                                                "aria-label": "edit",
                                                size: "small",
                                                color: "primary",
                                                onClick: ()=>{
                                                    setModal({
                                                        open: false,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                                                    });
                                                    appContext.setClub(club);
                                                    localStorage.setItem("clubAdmin.selectedClub", JSON.stringify(club));
                                                    navigate(`/club-admin/club-details/${club.id}`);
                                                },
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iopmn.default), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6M0TM.AreaCount), {
                                children: [
                                    t("areasCount"),
                                    ": ",
                                    (_club_areas = club.areas) === null || _club_areas === void 0 ? void 0 : _club_areas.length
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6M0TM.StyledBox), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.StyledAppButton), {
                                        variant: "outlined",
                                        children: t("stop")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6M0TM.StyledAppButton), {
                                        variant: "contained",
                                        children: t("duplicate")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, club.id);
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
            severity: "info",
            children: t("noClubInfo")
        })
    });
};
var $b6a46be4ce45bff1$export$2e2bcd8739ae039 = $b6a46be4ce45bff1$var$ClubsList;

});
parcelRequire.register("8smOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6282a3c293a0d8c9$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4Ox9X = parcelRequire("4Ox9X");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6282a3c293a0d8c9$var$_excluded = [
    "className",
    "disableSpacing"
];
const $6282a3c293a0d8c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4Ox9X.getDialogActionsUtilityClass), classes);
};
const $6282a3c293a0d8c9$var$DialogActionsRoot = (0, $kDBhE.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $6282a3c293a0d8c9$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $cFLic.default)(props, $6282a3c293a0d8c9$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $6282a3c293a0d8c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6282a3c293a0d8c9$var$DialogActionsRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6282a3c293a0d8c9$export$2e2bcd8739ae039 = $6282a3c293a0d8c9$var$DialogActions;

});
parcelRequire.register("4Ox9X", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", function () { return $38158dbfc23b097a$export$5e57a444791c63be; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $38158dbfc23b097a$export$5e57a444791c63be(slot) {
    return (0, $k6RDS.default)("MuiDialogActions", slot);
}
const $38158dbfc23b097a$var$dialogActionsClasses = (0, $4jzsB.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $38158dbfc23b097a$export$2e2bcd8739ae039 = $38158dbfc23b097a$var$dialogActionsClasses;

});


parcelRequire.register("l5i9v", function(module, exports) {

module.exports = new URL((parcelRequire("4SSe9")).resolve("9uQBh"), import.meta.url).toString();

});

parcelRequire.register("gSx8R", function(module, exports) {

$parcel$export(module.exports, "Spinner", function () { return $c412dd13239f8976$export$7f7cbe89f1eacd2; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $fSBk9 = parcelRequire("fSBk9");

var $dV5yl = parcelRequire("dV5yl");
const $c412dd13239f8976$export$7f7cbe89f1eacd2 = ({ fullPage: fullPage })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dV5yl.default), {
        className: fullPage ? "fullPage" : "container",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($fSBk9))),
            alt: "spinner"
        })
    });
};

});
parcelRequire.register("fSBk9", function(module, exports) {

module.exports = new URL((parcelRequire("4SSe9")).resolve("fbzIm"), import.meta.url).toString();

});


parcelRequire.register("6M0TM", function(module, exports) {

$parcel$export(module.exports, "CardContentStyled", function () { return $db16e177e95a1e19$export$13dee2a040dd0752; });
$parcel$export(module.exports, "ClubListCard", function () { return $db16e177e95a1e19$export$3d8490597fe12e03; });
$parcel$export(module.exports, "ClubListContainer", function () { return $db16e177e95a1e19$export$3af2a10f19f6b4f4; });
$parcel$export(module.exports, "Image", function () { return $db16e177e95a1e19$export$3e431a229df88919; });
$parcel$export(module.exports, "ClubName", function () { return $db16e177e95a1e19$export$a6fd403a1a35df92; });
$parcel$export(module.exports, "AreaCount", function () { return $db16e177e95a1e19$export$848eeba328c974f8; });
$parcel$export(module.exports, "StyledBox", function () { return $db16e177e95a1e19$export$d675f139b342d51a; });
$parcel$export(module.exports, "StyledAppButton", function () { return $db16e177e95a1e19$export$e3da0e99c81a4b99; });
$parcel$export(module.exports, "StyledGoBack", function () { return $db16e177e95a1e19$export$f939013b90c77823; });
$parcel$export(module.exports, "StyledRemoveRedEyeIcon", function () { return $db16e177e95a1e19$export$67d424d6a2a4c29b; });
$parcel$export(module.exports, "ImageBox", function () { return $db16e177e95a1e19$export$68a3906f6694d512; });

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");

var $7DDQY = parcelRequire("7DDQY");
let $db16e177e95a1e19$var$_ = (t)=>t, $db16e177e95a1e19$var$t, $db16e177e95a1e19$var$t1, $db16e177e95a1e19$var$t2, $db16e177e95a1e19$var$t3, $db16e177e95a1e19$var$t4, $db16e177e95a1e19$var$t5, $db16e177e95a1e19$var$t6, $db16e177e95a1e19$var$t7, $db16e177e95a1e19$var$t8, $db16e177e95a1e19$var$t9, $db16e177e95a1e19$var$t10;
const $db16e177e95a1e19$export$13dee2a040dd0752 = (0, $6hfZk.default).div($db16e177e95a1e19$var$t || ($db16e177e95a1e19$var$t = $db16e177e95a1e19$var$_`
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 100%;
    height: 100%;
`));
const $db16e177e95a1e19$export$3d8490597fe12e03 = (0, $6hfZk.default).div.withConfig({
    shouldForwardProp: (prop)=>prop !== "isActive"
})($db16e177e95a1e19$var$t1 || ($db16e177e95a1e19$var$t1 = $db16e177e95a1e19$var$_`
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 8px;
    gap: 8px;
    align-self: stretch;
    color: ${0};
    background: ${0};
    border-left: ${0};

    @media (max-width: 600px) {
        flex-direction: column;
    }
`), ({ isActive: isActive })=>isActive ? "var(--color-primary)" : "var(--custom-secondary)", ({ isActive: isActive })=>isActive ? "rgba(25, 118, 210, 0.12)" : "var(--grey-lighten-5)", ({ isActive: isActive })=>isActive ? "5px solid var(--color-primary)" : "");
const $db16e177e95a1e19$export$3af2a10f19f6b4f4 = (0, $6hfZk.default).div($db16e177e95a1e19$var$t2 || ($db16e177e95a1e19$var$t2 = $db16e177e95a1e19$var$_`
    display: grid;
    grid-template-columns: auto;
    gap: 8px;
`));
const $db16e177e95a1e19$export$3e431a229df88919 = (0, $6hfZk.default).img($db16e177e95a1e19$var$t3 || ($db16e177e95a1e19$var$t3 = $db16e177e95a1e19$var$_`
    max-width: 100%;
    min-width: 141px;
    max-height: 100px;
    object-fit: cover;
`));
const $db16e177e95a1e19$export$a6fd403a1a35df92 = (0, $6hfZk.default).p($db16e177e95a1e19$var$t4 || ($db16e177e95a1e19$var$t4 = $db16e177e95a1e19$var$_`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0;
`));
const $db16e177e95a1e19$export$848eeba328c974f8 = (0, $6hfZk.default).p($db16e177e95a1e19$var$t5 || ($db16e177e95a1e19$var$t5 = $db16e177e95a1e19$var$_`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    margin: 0;
`));
const $db16e177e95a1e19$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($db16e177e95a1e19$var$t6 || ($db16e177e95a1e19$var$t6 = $db16e177e95a1e19$var$_`
    display: flex;
    gap: 8px;
`));
const $db16e177e95a1e19$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($db16e177e95a1e19$var$t7 || ($db16e177e95a1e19$var$t7 = $db16e177e95a1e19$var$_`
    padding: 0 16px !important;
    width: 128px;
    height: 24px;
`));
const $db16e177e95a1e19$export$f939013b90c77823 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($db16e177e95a1e19$var$t8 || ($db16e177e95a1e19$var$t8 = $db16e177e95a1e19$var$_`
    width: 100%;
`));
const $db16e177e95a1e19$export$67d424d6a2a4c29b = (0, $6hfZk.default)((0, (/*@__PURE__*/$parcel$interopDefault($7DDQY))))($db16e177e95a1e19$var$t9 || ($db16e177e95a1e19$var$t9 = $db16e177e95a1e19$var$_`
    position: absolute;
    color: #fff;
    top: 0;
    right: 0;
`));
const $db16e177e95a1e19$export$68a3906f6694d512 = (0, $6hfZk.default).span($db16e177e95a1e19$var$t10 || ($db16e177e95a1e19$var$t10 = $db16e177e95a1e19$var$_`
    position: relative;
`));

});
parcelRequire.register("7DDQY", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58fb16ff12cb3103$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $58fb16ff12cb3103$var$_default = (0, $58fb16ff12cb3103$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), "RemoveRedEye");
module.exports.default = $58fb16ff12cb3103$var$_default;

});


parcelRequire.register("bGIah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8825e02edbe1c553$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $8825e02edbe1c553$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");

});

parcelRequire.register("iopmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d63e23d581b05a43$export$2e2bcd8739ae039; });

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $d63e23d581b05a43$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Edit");

});

parcelRequire.register("jmzAX", function(module, exports) {

$parcel$export(module.exports, "ClubImageDefaultForm", function () { return $49eca8aee40c0204$export$279a77b30066c51b; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bthi4 = parcelRequire("bthi4");

var $j0ndM = parcelRequire("j0ndM");

var $fnVR5 = parcelRequire("fnVR5");

var $dNDci = parcelRequire("dNDci");

var $gSx8R = parcelRequire("gSx8R");
const $49eca8aee40c0204$export$279a77b30066c51b = ({ clubId: clubId })=>{
    var _club_photos;
    const { data: club, isLoading: isLoading } = (0, $j0ndM.useClubById)("private", clubId);
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const appService = new (0, $dNDci.AppService)();
    const handleDefaultImage = async (photoUrl)=>{
        const data = {
            isDefault: true,
            photoUrl: photoUrl
        };
        await appService.api_updateClubPhotoDefault(clubId, data).then(()=>{
            setModal({
                open: false,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
            });
        });
    };
    return isLoading ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {
        fullPage: false
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bthi4.ImageBox), {
        children: club === null || club === void 0 ? void 0 : (_club_photos = club.photos) === null || _club_photos === void 0 ? void 0 : _club_photos.map((photo, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $bthi4.ImageSmall), {
                isDefault: photo.isDefault,
                src: photo.photoUrl,
                alt: "",
                onClick: ()=>handleDefaultImage(photo.photoUrl)
            }, index))
    });
};

});
parcelRequire.register("bthi4", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $1e2284fff06f089b$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "GridBox", function () { return $1e2284fff06f089b$export$6ba7e6b9c666c09d; });
$parcel$export(module.exports, "LatLngBox", function () { return $1e2284fff06f089b$export$ed6f720af0fc0d95; });
$parcel$export(module.exports, "Title", function () { return $1e2284fff06f089b$export$f99233281efd08a0; });
$parcel$export(module.exports, "InputBox", function () { return $1e2284fff06f089b$export$5ac7b85d728a3568; });
$parcel$export(module.exports, "ButtonBox", function () { return $1e2284fff06f089b$export$5e37f977ae0514c2; });
$parcel$export(module.exports, "StyledMap", function () { return $1e2284fff06f089b$export$3ba510748aae365e; });
$parcel$export(module.exports, "FormControlStyled", function () { return $1e2284fff06f089b$export$c0c1cb9b64d53b56; });
$parcel$export(module.exports, "StyledError", function () { return $1e2284fff06f089b$export$4ea0ff3663964b59; });
$parcel$export(module.exports, "StyledFormLabel", function () { return $1e2284fff06f089b$export$d4857d41ad5ff79f; });
$parcel$export(module.exports, "StyledButton", function () { return $1e2284fff06f089b$export$2d5d2ba3c7c8c40b; });
$parcel$export(module.exports, "StyledAppButton", function () { return $1e2284fff06f089b$export$e3da0e99c81a4b99; });
$parcel$export(module.exports, "BoxGrid", function () { return $1e2284fff06f089b$export$4f4b93cf5bf3647b; });
$parcel$export(module.exports, "SuccessBox", function () { return $1e2284fff06f089b$export$7715d6c0b6e4e443; });
$parcel$export(module.exports, "SuccessTitle", function () { return $1e2284fff06f089b$export$f25e790a6345b4c7; });
$parcel$export(module.exports, "SuccessDescription", function () { return $1e2284fff06f089b$export$e838bb410ecac9ed; });
$parcel$export(module.exports, "Image", function () { return $1e2284fff06f089b$export$3e431a229df88919; });
$parcel$export(module.exports, "DisabledImage", function () { return $1e2284fff06f089b$export$c9c9fa8da086ca51; });
$parcel$export(module.exports, "StyledButtonBox", function () { return $1e2284fff06f089b$export$2d8f604653b9bea6; });
$parcel$export(module.exports, "PhotoContainer", function () { return $1e2284fff06f089b$export$b8d75e0ebeb224c8; });
$parcel$export(module.exports, "ImageSmall", function () { return $1e2284fff06f089b$export$826b0c324d0b032; });
$parcel$export(module.exports, "ImageBox", function () { return $1e2284fff06f089b$export$68a3906f6694d512; });

var $aili3 = parcelRequire("aili3");
var $3jMGu = parcelRequire("3jMGu");
var $cnEvg = parcelRequire("cnEvg");
var $jh0sD = parcelRequire("jh0sD");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");

var $i3L0M = parcelRequire("i3L0M");
let $1e2284fff06f089b$var$_ = (t)=>t, $1e2284fff06f089b$var$t, $1e2284fff06f089b$var$t1, $1e2284fff06f089b$var$t2, $1e2284fff06f089b$var$t3, $1e2284fff06f089b$var$t4, $1e2284fff06f089b$var$t5, $1e2284fff06f089b$var$t6, $1e2284fff06f089b$var$t7, $1e2284fff06f089b$var$t8, $1e2284fff06f089b$var$t9, $1e2284fff06f089b$var$t10, $1e2284fff06f089b$var$t11, $1e2284fff06f089b$var$t12, $1e2284fff06f089b$var$t13, $1e2284fff06f089b$var$t14, $1e2284fff06f089b$var$t15, $1e2284fff06f089b$var$t16, $1e2284fff06f089b$var$t17, $1e2284fff06f089b$var$t18, $1e2284fff06f089b$var$t19, $1e2284fff06f089b$var$t20, $1e2284fff06f089b$var$t21, $1e2284fff06f089b$var$t22;
const $1e2284fff06f089b$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($1e2284fff06f089b$var$t || ($1e2284fff06f089b$var$t = $1e2284fff06f089b$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
`));
const $1e2284fff06f089b$export$6ba7e6b9c666c09d = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t1 || ($1e2284fff06f089b$var$t1 = $1e2284fff06f089b$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
`));
const $1e2284fff06f089b$export$ed6f720af0fc0d95 = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t2 || ($1e2284fff06f089b$var$t2 = $1e2284fff06f089b$var$_`
    display: flex;
    gap: 1rem;
    width: 100%;
`));
const $1e2284fff06f089b$export$e7e6b99c949fd18a = (0, $6hfZk.default)((0, $jh0sD.default))($1e2284fff06f089b$var$t3 || ($1e2284fff06f089b$var$t3 = $1e2284fff06f089b$var$_`
    width: 100%;
    background-color: #fff;
    color: var(--custom-secondary);
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.2);
`));
const $1e2284fff06f089b$export$f99233281efd08a0 = (0, $6hfZk.default).p($1e2284fff06f089b$var$t4 || ($1e2284fff06f089b$var$t4 = $1e2284fff06f089b$var$_`
    color: var(--custom-secondary);
    font-size: 20px !important;
    font-weight: 400 !important;
    line-height: 32px !important;
    letter-spacing: 0.25px !important;
    margin: 0;
`));
const $1e2284fff06f089b$export$5ac7b85d728a3568 = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t5 || ($1e2284fff06f089b$var$t5 = $1e2284fff06f089b$var$_`
    display: grid;
    gap: 8px;
    padding: 10px 20px;
    background-color: #f1f1f1;
    border-radius: 4px;
`));
const $1e2284fff06f089b$export$5e37f977ae0514c2 = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t6 || ($1e2284fff06f089b$var$t6 = $1e2284fff06f089b$var$_`
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 8px 0;
`));
const $1e2284fff06f089b$export$3ba510748aae365e = (0, $6hfZk.default)((0, $i3L0M.Map))($1e2284fff06f089b$var$t7 || ($1e2284fff06f089b$var$t7 = $1e2284fff06f089b$var$_`
    width: 100%;
    height: 35rem;

    @media (max-width: 600px) {
        height: 20rem;
    }
`));
const $1e2284fff06f089b$export$c0c1cb9b64d53b56 = (0, $6hfZk.default)((0, $3jMGu.default))($1e2284fff06f089b$var$t8 || ($1e2284fff06f089b$var$t8 = $1e2284fff06f089b$var$_`
    width: 100% !important;
`));
const $1e2284fff06f089b$export$4ea0ff3663964b59 = (0, $6hfZk.default).p($1e2284fff06f089b$var$t9 || ($1e2284fff06f089b$var$t9 = $1e2284fff06f089b$var$_`
    color: #d32f2f;
    font-size: 12px;
    margin: 3px 14px 0 14px;
`));
const $1e2284fff06f089b$export$d4857d41ad5ff79f = (0, $6hfZk.default)((0, $cnEvg.default))($1e2284fff06f089b$var$t10 || ($1e2284fff06f089b$var$t10 = $1e2284fff06f089b$var$_`
    color: var(--custom-secondary) !important;
    font-size: 20px !important;
    font-weight: 400 !important;
    line-height: 32px !important;
    letter-spacing: 0.25px !important;
`));
const $1e2284fff06f089b$export$2d5d2ba3c7c8c40b = (0, $6hfZk.default)((0, $dkKmP.AppButton)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isHidden"
})($1e2284fff06f089b$var$t11 || ($1e2284fff06f089b$var$t11 = $1e2284fff06f089b$var$_`
    display: ${0};
`), ({ isHidden: isHidden })=>isHidden ? "none !important" : "flex !important");
const $1e2284fff06f089b$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($1e2284fff06f089b$var$t12 || ($1e2284fff06f089b$var$t12 = $1e2284fff06f089b$var$_`
    width: fit-content;
    border: 1px solid var(--color-primary);
`));
const $1e2284fff06f089b$export$4f4b93cf5bf3647b = (0, $6hfZk.default).div($1e2284fff06f089b$var$t13 || ($1e2284fff06f089b$var$t13 = $1e2284fff06f089b$var$_`
    display: grid;
    grid-template-columns: 50% auto;
    gap: 16px;

    @media (max-width: 600px) {
        grid-template-columns: auto;
    }
`));
const $1e2284fff06f089b$export$7715d6c0b6e4e443 = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t14 || ($1e2284fff06f089b$var$t14 = $1e2284fff06f089b$var$_`
    width: 100%;
    padding: 1rem 0 5rem;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
`));
const $1e2284fff06f089b$export$f25e790a6345b4c7 = (0, $6hfZk.default).p($1e2284fff06f089b$var$t15 || ($1e2284fff06f089b$var$t15 = $1e2284fff06f089b$var$_`
    font-size: 20px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0.25px;
    line-height: 32px;
    text-align: center;
    color: var(--custom-secondary);
`));
const $1e2284fff06f089b$export$e838bb410ecac9ed = (0, $6hfZk.default).p($1e2284fff06f089b$var$t16 || ($1e2284fff06f089b$var$t16 = $1e2284fff06f089b$var$_`
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0.5px;
    line-height: 24px;
    text-align: center;
    color: var(--custom-secondary);
`));
const $1e2284fff06f089b$export$3e431a229df88919 = (0, $6hfZk.default).img.withConfig({
    shouldForwardProp: (prop)=>prop !== "isDefault"
})($1e2284fff06f089b$var$t17 || ($1e2284fff06f089b$var$t17 = $1e2284fff06f089b$var$_`
    width: 100%;
    height: 286px;
    object-fit: cover;
    border: ${0};
    padding: ${0};

    &:hover {
        cursor: pointer;
    }
`), ({ isDefault: isDefault })=>isDefault ? "3px solid var(--color-primary)" : "", ({ isDefault: isDefault })=>isDefault ? "5px" : 0);
const $1e2284fff06f089b$export$c9c9fa8da086ca51 = (0, $6hfZk.default).img($1e2284fff06f089b$var$t18 || ($1e2284fff06f089b$var$t18 = $1e2284fff06f089b$var$_`
    width: 100%;
    height: 286px;
    object-fit: cover;
`));
const $1e2284fff06f089b$export$2d8f604653b9bea6 = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t19 || ($1e2284fff06f089b$var$t19 = $1e2284fff06f089b$var$_`
    position: relative;
    width: 100%;
`));
const $1e2284fff06f089b$export$b8d75e0ebeb224c8 = (0, $6hfZk.default).div($1e2284fff06f089b$var$t20 || ($1e2284fff06f089b$var$t20 = $1e2284fff06f089b$var$_`
    display: flex;
    flex-direction: column;
    gap: 8px;
`));
const $1e2284fff06f089b$export$826b0c324d0b032 = (0, $6hfZk.default).img.withConfig({
    shouldForwardProp: (prop)=>prop !== "isDefault"
})($1e2284fff06f089b$var$t21 || ($1e2284fff06f089b$var$t21 = $1e2284fff06f089b$var$_`
    width: 100%;
    height: 180px;
    object-fit: cover;
    border: ${0};
    padding: ${0};

    &:hover {
        cursor: pointer;
    }
`), ({ isDefault: isDefault })=>isDefault ? "3px solid var(--color-primary)" : "", ({ isDefault: isDefault })=>isDefault ? "5px" : 0);
const $1e2284fff06f089b$export$68a3906f6694d512 = (0, $6hfZk.default)((0, $aili3.default))($1e2284fff06f089b$var$t22 || ($1e2284fff06f089b$var$t22 = $1e2284fff06f089b$var$_`
    display: grid;
    gap: 8px;
    grid-template-columns: 50% auto;
`));

});
parcelRequire.register("i3L0M", function(module, exports) {

$parcel$export(module.exports, "Map", function () { return $15bbe7c891dc42f2$export$a5c7b93649eaf8f8; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kmWdx = parcelRequire("kmWdx");
var $jHcOi = parcelRequire("jHcOi");
var $2Rv35 = parcelRequire("2Rv35");
var $fLLW7 = parcelRequire("fLLW7");

var $hfJTG = parcelRequire("hfJTG");

var $inqfx = parcelRequire("inqfx");


var $7AKoP = parcelRequire("7AKoP");

var $iCL6J = parcelRequire("iCL6J");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $goR7t = parcelRequire("goR7t");

var $5ZeKC = parcelRequire("5ZeKC");

var $84nYO = parcelRequire("84nYO");

var $1N52b = parcelRequire("1N52b");

var $7vf1K = parcelRequire("7vf1K");
let $15bbe7c891dc42f2$var$DefaultIcon = (0, (/*@__PURE__*/$parcel$interopDefault($inqfx))).icon({
    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7AKoP))),
    shadowUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iCL6J))),
    iconAnchor: [
        17,
        46
    ],
    popupAnchor: [
        -3,
        -26
    ]
});
let $15bbe7c891dc42f2$var$HighlightIcon = (0, (/*@__PURE__*/$parcel$interopDefault($inqfx))).icon({
    iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7AKoP))),
    shadowUrl: (0, (/*@__PURE__*/$parcel$interopDefault($iCL6J))),
    iconAnchor: [
        17,
        46
    ],
    popupAnchor: [
        -3,
        -26
    ],
    className: "highlight"
});
const $15bbe7c891dc42f2$var$ChangeCenter = ({ center: center })=>{
    const map = (0, $fLLW7.useMap)();
    map.setView(center, map.getZoom());
    return null;
};
const $15bbe7c891dc42f2$var$ClickHandler = ({ onClickHandler: onClickHandler })=>{
    (0, $fLLW7.useMapEvents)({
        click (e) {
            onClickHandler(e.latlng);
        }
    });
    return null;
};
const $15bbe7c891dc42f2$export$a5c7b93649eaf8f8 = ({ center: center, mapInfos: mapInfos, zoom: zoom = 12, zoomControl: zoomControl = false, withPrice: withPrice = true, showPopUp: showPopUp, isActive: isActive = true, onClickHandler: onClickHandler, ...remaininProps })=>{
    const navigate = (0, $iIluI.useNavigate)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const { role: role } = (0, $1N52b.useAuth)();
    const { pin: pin } = (0, $goR7t.default)();
    const { searchObj: searchObj, categories: categories, setPin: setPin } = (0, $goR7t.default)();
    const markersRefs = (0, $7fPBF.useRef)([]);
    const handleBookingNavigation = (clubId, area, price)=>{
        if (searchObj.sport.length === 1) {
            const { url: url, state: state } = (0, $84nYO.getBookingUrlAndState)(role, searchObj, categories, clubId, area, price, searchObj.sport[0]);
            navigate(url, {
                state: {
                    ...state
                }
            });
        } else if (area.categories.length === 1) {
            const { url: url, state: state } = (0, $84nYO.getBookingUrlAndState)(role, searchObj, categories, clubId, area, price, area.categories[0]);
            navigate(url, {
                state: {
                    ...state
                }
            });
        } else {
            const url = (0, $7vf1K.fromObjectToQueryString)(searchObj);
            navigate(`/club/${clubId}?area=${area.id}${url}`);
        }
        return;
    };
    (0, $7fPBF.useEffect)(()=>{
        if (showPopUp && pin) {
            const markerIndex = mapInfos.findIndex((marker)=>marker.clubId === pin);
            if (markerIndex !== undefined) {
                var _element__icon, _element__icon_classList;
                const element = markersRefs.current[markerIndex];
                element.openPopup();
                (_element__icon = element._icon) === null || _element__icon === void 0 ? void 0 : (_element__icon_classList = _element__icon.classList) === null || _element__icon_classList === void 0 ? void 0 : _element__icon_classList.add("highlight");
            }
        }
    }, [
        pin
    ]);
    const popUpOpen = ()=>{
        setPin(pin);
    };
    const popUpClosed = ()=>{
        setPin(undefined);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kmWdx.MapContainer), {
        center: center,
        minZoom: 10,
        zoom: zoom,
        zoomControl: zoomControl,
        ...remaininProps,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2Rv35.TileLayer), {
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                attribution: '\xa9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }),
            mapInfos.map(({ center: center, clubId: clubId, clubName: clubName, address: address, areas: areas, clubPhoto: clubPhoto }, index)=>{
                const isHighlighted = pin === clubId;
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jHcOi.Marker), {
                    ref: (el)=>markersRefs.current[index] = el,
                    position: center,
                    icon: showPopUp && isHighlighted ? $15bbe7c891dc42f2$var$HighlightIcon : $15bbe7c891dc42f2$var$DefaultIcon,
                    zIndexOffset: showPopUp && isHighlighted ? 1000 : 1,
                    eventHandlers: {
                        popupopen: (e)=>{
                            var _e_target__icon, _e_target__icon_classList;
                            popUpOpen();
                            (_e_target__icon = e.target._icon) === null || _e_target__icon === void 0 ? void 0 : (_e_target__icon_classList = _e_target__icon.classList) === null || _e_target__icon_classList === void 0 ? void 0 : _e_target__icon_classList.add("highlight");
                        },
                        popupclose: (e)=>{
                            var _e_target__icon, _e_target__icon_classList;
                            popUpClosed();
                            (_e_target__icon = e.target._icon) === null || _e_target__icon === void 0 ? void 0 : (_e_target__icon_classList = _e_target__icon.classList) === null || _e_target__icon_classList === void 0 ? void 0 : _e_target__icon_classList.remove("highlight");
                        }
                    },
                    children: showPopUp && /*#__PURE__*/ (0, $bbzbN.jsxs)($hfJTG.StyledPopup, {
                        offset: [
                            0,
                            -5
                        ],
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)($hfJTG.Wrapper, {
                                children: [
                                    clubPhoto && /*#__PURE__*/ (0, $bbzbN.jsx)($hfJTG.AreaImage, {
                                        src: clubPhoto
                                    }),
                                    !!clubName && /*#__PURE__*/ (0, $bbzbN.jsx)($hfJTG.ClubName, {
                                        children: clubName
                                    }),
                                    !!address && /*#__PURE__*/ (0, $bbzbN.jsx)($hfJTG.ClubDescription, {
                                        children: address
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($hfJTG.Areas, {
                                children: areas === null || areas === void 0 ? void 0 : areas.map((area)=>/*#__PURE__*/ (0, $bbzbN.jsxs)($hfJTG.Area, {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)($hfJTG.AreaText, {
                                                children: area.name
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)($hfJTG.AreaPrice, {
                                                children: area.privacy !== "PUBLIC" ? `${Number(area.price).toFixed(2)} €` : "N/A"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                                id: "book-now",
                                                variant: "contained",
                                                disabled: !area.schedules.length || area.closedSchedules.length > 0,
                                                onClick: ()=>handleBookingNavigation(clubId, area, area.price),
                                                children: t("clubList.book")
                                            })
                                        ]
                                    }, area.id))
                            })
                        ]
                    })
                }, index);
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($15bbe7c891dc42f2$var$ChangeCenter, {
                center: center
            }),
            onClickHandler && /*#__PURE__*/ (0, $bbzbN.jsx)($15bbe7c891dc42f2$var$ClickHandler, {
                onClickHandler: onClickHandler
            })
        ]
    });
};

});
parcelRequire.register("kmWdx", function(module, exports) {

$parcel$export(module.exports, "MapContainer", function () { return $ed43057c7ad82c40$export$23f3dfd47374502b; });

var $h8Uor = parcelRequire("h8Uor");

var $inqfx = parcelRequire("inqfx");

var $7fPBF = parcelRequire("7fPBF");
function $ed43057c7ad82c40$var$_extends() {
    $ed43057c7ad82c40$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed43057c7ad82c40$var$_extends.apply(this, arguments);
}
function $ed43057c7ad82c40$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $7fPBF.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $7fPBF.useState)(null);
    var _context_map;
    (0, $7fPBF.useImperativeHandle)(forwardedRef, ()=>{
        return (_context_map = context === null || context === void 0 ? void 0 : context.map) !== null && _context_map !== void 0 ? _context_map : null;
    }, [
        context
    ]);
    const mapRef = (0, $7fPBF.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new (0, $inqfx.Map)(node, options);
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $h8Uor.createLeafletContext)(map));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            context === null || context === void 0 ? void 0 : context.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $h8Uor.LeafletProvider), {
        value: context
    }, children) : placeholder !== null && placeholder !== void 0 ? placeholder : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", $ed43057c7ad82c40$var$_extends({}, props, {
        ref: mapRef
    }), contents);
}
const $ed43057c7ad82c40$export$23f3dfd47374502b = /*#__PURE__*/ (0, $7fPBF.forwardRef)($ed43057c7ad82c40$var$MapContainerComponent);

});
parcelRequire.register("h8Uor", function(module, exports) {

$parcel$export(module.exports, "createLeafletContext", function () { return $c7aeed8ccd724f7c$export$fb237fa819e17281; });
$parcel$export(module.exports, "extendContext", function () { return $c7aeed8ccd724f7c$export$9efaf186a2224858; });
$parcel$export(module.exports, "LeafletProvider", function () { return $c7aeed8ccd724f7c$export$a24c9fc2f87814b2; });
$parcel$export(module.exports, "useLeafletContext", function () { return $c7aeed8ccd724f7c$export$ea59151b8430a4e9; });

var $7fPBF = parcelRequire("7fPBF");
const $c7aeed8ccd724f7c$export$b8efcc4bff45e15b = 1;
function $c7aeed8ccd724f7c$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $c7aeed8ccd724f7c$export$b8efcc4bff45e15b,
        map: map
    });
}
function $c7aeed8ccd724f7c$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $c7aeed8ccd724f7c$export$7de1b54b0142048f = (0, $7fPBF.createContext)(null);
const $c7aeed8ccd724f7c$export$a24c9fc2f87814b2 = $c7aeed8ccd724f7c$export$7de1b54b0142048f.Provider;
function $c7aeed8ccd724f7c$export$ea59151b8430a4e9() {
    const context = (0, $7fPBF.useContext)($c7aeed8ccd724f7c$export$7de1b54b0142048f);
    if (context == null) throw new Error("No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>");
    return context;
}

});

parcelRequire.register("inqfx", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});


parcelRequire.register("jHcOi", function(module, exports) {

$parcel$export(module.exports, "Marker", function () { return $e56bf851208bd201$export$e98856a975cab58e; });

var $8jAgM = parcelRequire("8jAgM");
var $fXSu4 = parcelRequire("fXSu4");
var $h8Uor = parcelRequire("h8Uor");

var $inqfx = parcelRequire("inqfx");
const $e56bf851208bd201$export$e98856a975cab58e = (0, $fXSu4.createLayerComponent)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $inqfx.Marker)(position, options);
    return (0, $8jAgM.createElementObject)(marker, (0, $h8Uor.extendContext)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});

});
parcelRequire.register("8jAgM", function(module, exports) {

$parcel$export(module.exports, "createElementObject", function () { return $60dc3b75e56036b4$export$a080ff44e8067a44; });
$parcel$export(module.exports, "createElementHook", function () { return $60dc3b75e56036b4$export$2e66ec8a7fb1892f; });

var $7fPBF = parcelRequire("7fPBF");
function $60dc3b75e56036b4$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $60dc3b75e56036b4$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $7fPBF.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $7fPBF.useRef)();
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $7fPBF.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $7fPBF.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

});

parcelRequire.register("fXSu4", function(module, exports) {

$parcel$export(module.exports, "createLayerComponent", function () { return $b9f6a113cb46355f$export$8a4d5778bce4c3ac; });
$parcel$export(module.exports, "createOverlayComponent", function () { return $b9f6a113cb46355f$export$7d18e209be943d7d; });
$parcel$export(module.exports, "createTileLayerComponent", function () { return $b9f6a113cb46355f$export$4f432c6de5c4ddb8; });

var $dbIFh = parcelRequire("dbIFh");

var $7EwJ9 = parcelRequire("7EwJ9");

var $8jAgM = parcelRequire("8jAgM");

var $aElJq = parcelRequire("aElJq");

var $9CENm = parcelRequire("9CENm");

var $2o7XG = parcelRequire("2o7XG");
function $b9f6a113cb46355f$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $8jAgM.createElementObject)(createInstance(props), context);
    }
    const useElement = (0, $8jAgM.createElementHook)(createElement);
    const useControl = (0, $7EwJ9.createControlHook)(useElement);
    return (0, $dbIFh.createLeafComponent)(useControl);
}
function $b9f6a113cb46355f$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $8jAgM.createElementHook)(createElement, updateElement);
    const useLayer = (0, $aElJq.createLayerHook)(useElement);
    return (0, $dbIFh.createContainerComponent)(useLayer);
}
function $b9f6a113cb46355f$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $8jAgM.createElementHook)(createElement);
    const useOverlay = (0, $9CENm.createDivOverlayHook)(useElement, useLifecycle);
    return (0, $dbIFh.createDivOverlayComponent)(useOverlay);
}
function $b9f6a113cb46355f$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $8jAgM.createElementHook)(createElement, updateElement);
    const usePath = (0, $2o7XG.createPathHook)(useElement);
    return (0, $dbIFh.createContainerComponent)(usePath);
}
function $b9f6a113cb46355f$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $8jAgM.createElementHook)(createElement, updateElement);
    const useLayer = (0, $aElJq.createLayerHook)(useElement);
    return (0, $dbIFh.createLeafComponent)(useLayer);
}

});
parcelRequire.register("dbIFh", function(module, exports) {

$parcel$export(module.exports, "createContainerComponent", function () { return $999ef2f720d9cf2a$export$96eac748c3f41e82; });
$parcel$export(module.exports, "createDivOverlayComponent", function () { return $999ef2f720d9cf2a$export$bc37ddc24ed05446; });
$parcel$export(module.exports, "createLeafComponent", function () { return $999ef2f720d9cf2a$export$18af5c7a9e9b3664; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $h8Uor = parcelRequire("h8Uor");
function $999ef2f720d9cf2a$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $7fPBF.useImperativeHandle)(forwardedRef, ()=>instance);
        return props.children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $h8Uor.LeafletProvider), {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(ContainerComponent);
}
function $999ef2f720d9cf2a$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $7fPBF.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $7fPBF.useImperativeHandle)(forwardedRef, ()=>instance);
        (0, $7fPBF.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $fw0lo.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(OverlayComponent);
}
function $999ef2f720d9cf2a$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $7fPBF.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(LeafComponent);
}

});

parcelRequire.register("7EwJ9", function(module, exports) {

$parcel$export(module.exports, "createControlHook", function () { return $5925a7c9420e477d$export$28d24ab3914549cd; });

var $7fPBF = parcelRequire("7fPBF");

var $h8Uor = parcelRequire("h8Uor");
function $5925a7c9420e477d$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $h8Uor.useLeafletContext)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $7fPBF.useRef)(props.position);
        const { position: position } = props;
        (0, $7fPBF.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $7fPBF.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}

});

parcelRequire.register("aElJq", function(module, exports) {

$parcel$export(module.exports, "useLayerLifecycle", function () { return $7c0e7f449e6636d0$export$cd00a227f8cfb2c2; });
$parcel$export(module.exports, "createLayerHook", function () { return $7c0e7f449e6636d0$export$73f852c6a5abdefa; });

var $7fPBF = parcelRequire("7fPBF");

var $kQNwx = parcelRequire("kQNwx");

var $h8Uor = parcelRequire("h8Uor");

var $QRrPD = parcelRequire("QRrPD");

var $49HTf = parcelRequire("49HTf");
function $7c0e7f449e6636d0$export$cd00a227f8cfb2c2(element, context) {
    (0, $7fPBF.useEffect)(function addLayer() {
        var _context_layerContainer;
        const container = (_context_layerContainer = context.layerContainer) !== null && _context_layerContainer !== void 0 ? _context_layerContainer : context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            var _context_layerContainer;
            (_context_layerContainer = context.layerContainer) === null || _context_layerContainer === void 0 ? void 0 : _context_layerContainer.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $7c0e7f449e6636d0$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $h8Uor.useLeafletContext)();
        const elementRef = useElement((0, $49HTf.withPane)(props, context), context);
        (0, $kQNwx.useAttribution)(context.map, props.attribution);
        (0, $QRrPD.useEventHandlers)(elementRef.current, props.eventHandlers);
        $7c0e7f449e6636d0$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}

});
parcelRequire.register("kQNwx", function(module, exports) {

$parcel$export(module.exports, "useAttribution", function () { return $f2df145b93b2adcd$export$46b870813daca3d4; });

var $7fPBF = parcelRequire("7fPBF");
function $f2df145b93b2adcd$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $7fPBF.useRef)(attribution);
    (0, $7fPBF.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

});

parcelRequire.register("QRrPD", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", function () { return $09ee511559720ccc$export$8ce912bc34d0dbea; });

var $7fPBF = parcelRequire("7fPBF");
function $09ee511559720ccc$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

});

parcelRequire.register("49HTf", function(module, exports) {

$parcel$export(module.exports, "withPane", function () { return $306a0c527347af10$export$6ee5d263358f5c0e; });
function $306a0c527347af10$export$6ee5d263358f5c0e(props, context) {
    var _props_pane;
    const pane = (_props_pane = props.pane) !== null && _props_pane !== void 0 ? _props_pane : context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}

});


parcelRequire.register("9CENm", function(module, exports) {

$parcel$export(module.exports, "createDivOverlayHook", function () { return $70174eb61f9e1a7f$export$d5eca53b0accc0e0; });

var $kQNwx = parcelRequire("kQNwx");

var $h8Uor = parcelRequire("h8Uor");

var $QRrPD = parcelRequire("QRrPD");

var $49HTf = parcelRequire("49HTf");
function $70174eb61f9e1a7f$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $h8Uor.useLeafletContext)();
        const elementRef = useElement((0, $49HTf.withPane)(props, context), context);
        (0, $kQNwx.useAttribution)(context.map, props.attribution);
        (0, $QRrPD.useEventHandlers)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

});

parcelRequire.register("2o7XG", function(module, exports) {

$parcel$export(module.exports, "createPathHook", function () { return $1bd3ffb27ad8ddc2$export$5fea2fe6048fc3db; });

var $7fPBF = parcelRequire("7fPBF");

var $h8Uor = parcelRequire("h8Uor");

var $QRrPD = parcelRequire("QRrPD");

var $aElJq = parcelRequire("aElJq");

var $49HTf = parcelRequire("49HTf");
function $1bd3ffb27ad8ddc2$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            var _props_pathOptions;
            const options = (_props_pathOptions = props.pathOptions) !== null && _props_pathOptions !== void 0 ? _props_pathOptions : {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $1bd3ffb27ad8ddc2$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $h8Uor.useLeafletContext)();
        const elementRef = useElement((0, $49HTf.withPane)(props, context), context);
        (0, $QRrPD.useEventHandlers)(elementRef.current, props.eventHandlers);
        (0, $aElJq.useLayerLifecycle)(elementRef.current, context);
        $1bd3ffb27ad8ddc2$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}

});



parcelRequire.register("2Rv35", function(module, exports) {

$parcel$export(module.exports, "TileLayer", function () { return $21589da744d7fae0$export$f52ee31d61d0b27b; });

var $8jAgM = parcelRequire("8jAgM");
var $fXSu4 = parcelRequire("fXSu4");
var $hkoE8 = parcelRequire("hkoE8");
var $49HTf = parcelRequire("49HTf");

var $inqfx = parcelRequire("inqfx");
const $21589da744d7fae0$export$f52ee31d61d0b27b = (0, $fXSu4.createTileLayerComponent)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $inqfx.TileLayer)(url, (0, $49HTf.withPane)(options, context));
    return (0, $8jAgM.createElementObject)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $hkoE8.updateGridLayer)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});

});
parcelRequire.register("hkoE8", function(module, exports) {

$parcel$export(module.exports, "updateGridLayer", function () { return $c9d76c2a7f764c7a$export$b39104a5f1b9296f; });
function $c9d76c2a7f764c7a$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}

});


parcelRequire.register("fLLW7", function(module, exports) {

$parcel$export(module.exports, "useMap", function () { return $b7b06df296fc5e2c$export$86f8f9f08863e403; });
$parcel$export(module.exports, "useMapEvents", function () { return $b7b06df296fc5e2c$export$1c51e2c234152172; });

var $h8Uor = parcelRequire("h8Uor");

var $7fPBF = parcelRequire("7fPBF");
function $b7b06df296fc5e2c$export$86f8f9f08863e403() {
    return (0, $h8Uor.useLeafletContext)().map;
}
function $b7b06df296fc5e2c$export$4c2959913f5c7962(type, handler) {
    const map = $b7b06df296fc5e2c$export$86f8f9f08863e403();
    (0, $7fPBF.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $b7b06df296fc5e2c$export$1c51e2c234152172(handlers) {
    const map = $b7b06df296fc5e2c$export$86f8f9f08863e403();
    (0, $7fPBF.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}

});

parcelRequire.register("hfJTG", function(module, exports) {

$parcel$export(module.exports, "StyledPopup", function () { return $4fcd61332a4cdd75$export$db7507d5e3c956c0; });
$parcel$export(module.exports, "Wrapper", function () { return $4fcd61332a4cdd75$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "ClubName", function () { return $4fcd61332a4cdd75$export$a6fd403a1a35df92; });
$parcel$export(module.exports, "ClubDescription", function () { return $4fcd61332a4cdd75$export$75591de432b8adb2; });
$parcel$export(module.exports, "Areas", function () { return $4fcd61332a4cdd75$export$be037cb0eb4aad7a; });
$parcel$export(module.exports, "Area", function () { return $4fcd61332a4cdd75$export$ea1a111407f37557; });
$parcel$export(module.exports, "AreaText", function () { return $4fcd61332a4cdd75$export$7f093a2006799ad8; });
$parcel$export(module.exports, "AreaPrice", function () { return $4fcd61332a4cdd75$export$40dbffe112efbdd7; });
$parcel$export(module.exports, "AreaImage", function () { return $4fcd61332a4cdd75$export$71219af9848f38ea; });

var $55gdp = parcelRequire("55gdp");
var $eTy0E = parcelRequire("eTy0E");

var $6hfZk = parcelRequire("6hfZk");
let $4fcd61332a4cdd75$var$_ = (t)=>t, $4fcd61332a4cdd75$var$t, $4fcd61332a4cdd75$var$t1, $4fcd61332a4cdd75$var$t2, $4fcd61332a4cdd75$var$t3, $4fcd61332a4cdd75$var$t4, $4fcd61332a4cdd75$var$t5, $4fcd61332a4cdd75$var$t6, $4fcd61332a4cdd75$var$t7, $4fcd61332a4cdd75$var$t8, $4fcd61332a4cdd75$var$t9;
const $4fcd61332a4cdd75$export$353e9bd501be795b = (0, $6hfZk.default)((0, $eTy0E.Tooltip))($4fcd61332a4cdd75$var$t || ($4fcd61332a4cdd75$var$t = $4fcd61332a4cdd75$var$_`
    border: unset;
    color: white;
    border-radius: 0;
    font-weight: bold;
    background-color: #000;
`));
const $4fcd61332a4cdd75$export$db7507d5e3c956c0 = (0, $6hfZk.default)((0, $55gdp.Popup))($4fcd61332a4cdd75$var$t1 || ($4fcd61332a4cdd75$var$t1 = $4fcd61332a4cdd75$var$_`
    .leaflet-popup-content-wrapper {
        border-radius: 6px;
        padding: 20px;
    }

    .leaflet-popup-content {
        /* max-height: 11rem; */
        overflow: auto;
        width: 25rem;
        margin: 0;
    }
`));
const $4fcd61332a4cdd75$export$e6dfd72ab29f8598 = (0, $6hfZk.default).div($4fcd61332a4cdd75$var$t2 || ($4fcd61332a4cdd75$var$t2 = $4fcd61332a4cdd75$var$_`
    display: flex;
    flex-direction: column;
`));
const $4fcd61332a4cdd75$export$a6fd403a1a35df92 = (0, $6hfZk.default).span($4fcd61332a4cdd75$var$t3 || ($4fcd61332a4cdd75$var$t3 = $4fcd61332a4cdd75$var$_`
    font-weight: bold;
    margin: 8px 0;
    font-size: 1rem;
`));
const $4fcd61332a4cdd75$export$75591de432b8adb2 = (0, $6hfZk.default).span($4fcd61332a4cdd75$var$t4 || ($4fcd61332a4cdd75$var$t4 = $4fcd61332a4cdd75$var$_`
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    margin-top: 5px;
    -webkit-box-orient: vertical;
`));
const $4fcd61332a4cdd75$export$be037cb0eb4aad7a = (0, $6hfZk.default).ul($4fcd61332a4cdd75$var$t5 || ($4fcd61332a4cdd75$var$t5 = $4fcd61332a4cdd75$var$_`
    padding: 0;
    margin-bottom: 0;
`));
const $4fcd61332a4cdd75$export$ea1a111407f37557 = (0, $6hfZk.default).li($4fcd61332a4cdd75$var$t6 || ($4fcd61332a4cdd75$var$t6 = $4fcd61332a4cdd75$var$_`
    border-bottom: 1px solid #cfcfcf;
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6px;
    padding-bottom: 6px;

    &:last-child {
        margin-bottom: 0;
    }
`));
const $4fcd61332a4cdd75$export$7f093a2006799ad8 = (0, $6hfZk.default).span($4fcd61332a4cdd75$var$t7 || ($4fcd61332a4cdd75$var$t7 = $4fcd61332a4cdd75$var$_`
    margin: 0;
    max-width: 9rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`));
const $4fcd61332a4cdd75$export$40dbffe112efbdd7 = (0, $6hfZk.default).p($4fcd61332a4cdd75$var$t8 || ($4fcd61332a4cdd75$var$t8 = $4fcd61332a4cdd75$var$_`
    flex: 1;
    margin: 0 !important;
    margin-right: 1rem !important;
    display: flex;
    flex-shrink: 0;
    text-align: end;
    font-size: 0.9rem;
    font-weight: bold;
    align-items: flex-end;
    justify-content: flex-end;
    white-space: nowrap;
`));
const $4fcd61332a4cdd75$export$71219af9848f38ea = (0, $6hfZk.default).img($4fcd61332a4cdd75$var$t9 || ($4fcd61332a4cdd75$var$t9 = $4fcd61332a4cdd75$var$_`
    height: 100%;
    display: block;
    object-fit: cover;
    width: 100%;
    max-height: 200px;
`));

});
parcelRequire.register("55gdp", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $3b39ff5fab6ee614$export$129a32eedafa97c5; });

var $8jAgM = parcelRequire("8jAgM");
var $fXSu4 = parcelRequire("fXSu4");

var $inqfx = parcelRequire("inqfx");

var $7fPBF = parcelRequire("7fPBF");
const $3b39ff5fab6ee614$export$129a32eedafa97c5 = (0, $fXSu4.createOverlayComponent)(function createPopup(props, context) {
    const popup = new (0, $inqfx.Popup)(props, context.overlayContainer);
    return (0, $8jAgM.createElementObject)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $7fPBF.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            var _context_overlayContainer;
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            (_context_overlayContainer = context.overlayContainer) === null || _context_overlayContainer === void 0 ? void 0 : _context_overlayContainer.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});

});

parcelRequire.register("eTy0E", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $ad80954fa84cab7a$export$28c660c63b792dea; });

var $8jAgM = parcelRequire("8jAgM");
var $fXSu4 = parcelRequire("fXSu4");

var $inqfx = parcelRequire("inqfx");

var $7fPBF = parcelRequire("7fPBF");
const $ad80954fa84cab7a$export$28c660c63b792dea = (0, $fXSu4.createOverlayComponent)(function createTooltip(props, context) {
    const tooltip = new (0, $inqfx.Tooltip)(props, context.overlayContainer);
    return (0, $8jAgM.createElementObject)(tooltip, context);
}, function useTooltipLifecycle(element, context, { position: position }, setOpen) {
    (0, $7fPBF.useEffect)(function addTooltip() {
        const container = context.overlayContainer;
        if (container == null) return;
        const { instance: instance } = element;
        const onTooltipOpen = (event)=>{
            if (event.tooltip === instance) {
                if (position != null) instance.setLatLng(position);
                instance.update();
                setOpen(true);
            }
        };
        const onTooltipClose = (event)=>{
            if (event.tooltip === instance) setOpen(false);
        };
        container.on({
            tooltipopen: onTooltipOpen,
            tooltipclose: onTooltipClose
        });
        container.bindTooltip(instance);
        return function removeTooltip() {
            container.off({
                tooltipopen: onTooltipOpen,
                tooltipclose: onTooltipClose
            });
            // @ts-ignore protected property
            if (container._map != null) container.unbindTooltip();
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});

});


parcelRequire.register("7AKoP", function(module, exports) {

module.exports = new URL((parcelRequire("4SSe9")).resolve("2822V"), import.meta.url).toString();

});

parcelRequire.register("iCL6J", function(module, exports) {

module.exports = new URL((parcelRequire("4SSe9")).resolve("eFkL3"), import.meta.url).toString();

});

parcelRequire.register("goR7t", function(module, exports) {

$parcel$export(module.exports, "SearchContextProvider", function () { return $7d7e73c05d4982d9$export$6bd70292443463a4; });
$parcel$export(module.exports, "default", function () { return $7d7e73c05d4982d9$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $a13Ew = parcelRequire("a13Ew");

var $1N52b = parcelRequire("1N52b");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $7d7e73c05d4982d9$var$defaultSearchObject = {
    sport: [],
    district: "Aveiro",
    date: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(),
    time: "",
    timeUnit: "",
    privacy: "NOT_SPECIFIED",
    environment: "NOT_SPECIFIED",
    clubName: [],
    domain: window.location.hostname
};
const $7d7e73c05d4982d9$export$abe847132b142195 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isLoading: false,
    setIsLoading: ()=>undefined,
    isLoadingFilters: true,
    setIsLoadingFilters: ()=>undefined,
    categories: undefined,
    setCategories: ()=>undefined,
    clubNames: [],
    setClubNames: ()=>undefined,
    searchObj: $7d7e73c05d4982d9$var$defaultSearchObject,
    setSearchObj: ()=>undefined,
    results: undefined,
    setResults: ()=>undefined,
    isFirstSearchPerformed: false,
    setIsFirstSearchPerformed: ()=>undefined,
    timeInterval: undefined,
    setTimeInterval: ()=>undefined,
    pin: undefined,
    setPin: ()=>undefined
});
const $7d7e73c05d4982d9$export$6bd70292443463a4 = (props)=>{
    const dataFetchedRef = (0, $7fPBF.useRef)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isLoadingFilters, setIsLoadingFilters] = (0, $7fPBF.useState)(true);
    const [categories, setCategories] = (0, $7fPBF.useState)(undefined);
    const [clubNames, setClubNames] = (0, $7fPBF.useState)([]);
    const [isFirstSearchPerformed, setIsFirstSearchPerformed] = (0, $7fPBF.useState)(false);
    const [timeInterval, setTimeInterval] = (0, $7fPBF.useState)(undefined);
    const [pin, setPin] = (0, $7fPBF.useState)();
    const { role: role } = (0, $1N52b.useAuth)();
    const [searchObj, setSearchObj] = (0, $7fPBF.useState)($7d7e73c05d4982d9$var$defaultSearchObject);
    const [results, setResults] = (0, $7fPBF.useState)(undefined);
    const { actions: { fetchEverything: fetchEverything } } = (0, $a13Ew.useSearch)();
    const values = (0, $7fPBF.useMemo)(()=>({
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            isLoadingFilters: isLoadingFilters,
            setIsLoadingFilters: setIsLoadingFilters,
            categories: categories,
            setCategories: setCategories,
            clubNames: clubNames,
            setClubNames: setClubNames,
            searchObj: searchObj,
            setSearchObj: setSearchObj,
            results: results,
            setResults: setResults,
            isFirstSearchPerformed: isFirstSearchPerformed,
            setIsFirstSearchPerformed: setIsFirstSearchPerformed,
            timeInterval: timeInterval,
            setTimeInterval: setTimeInterval,
            pin: pin,
            setPin: setPin
        }), [
        isLoading,
        setIsLoading,
        isLoadingFilters,
        setIsLoadingFilters,
        categories,
        setCategories,
        clubNames,
        setClubNames,
        searchObj,
        setSearchObj,
        results,
        setResults,
        isFirstSearchPerformed,
        setIsFirstSearchPerformed,
        timeInterval,
        setTimeInterval,
        pin,
        setPin
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (dataFetchedRef.current === role) return;
        if (!isLoadingFilters) setIsLoadingFilters(true);
        dataFetchedRef.current = role;
        fetchEverything(role === "club-admin" ? "private" : undefined).then(([categories, clubNames])=>{
            setCategories(categories);
            setClubNames(clubNames);
            setIsLoadingFilters(false);
        });
    }, [
        role
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7d7e73c05d4982d9$export$abe847132b142195.Provider, {
        value: values,
        ...props
    });
};
const $7d7e73c05d4982d9$var$useSearchContext = ()=>(0, $7fPBF.useContext)($7d7e73c05d4982d9$export$abe847132b142195);
var $7d7e73c05d4982d9$export$2e2bcd8739ae039 = $7d7e73c05d4982d9$var$useSearchContext;

});
parcelRequire.register("a13Ew", function(module, exports) {

$parcel$export(module.exports, "useSearch", function () { return $fe37280edef86602$export$bd221a7c56b93941; });

var $dNYY5 = parcelRequire("dNYY5");

var $dNDci = parcelRequire("dNDci");

var $k6mBf = parcelRequire("k6mBf");

var $goR7t = parcelRequire("goR7t");

var $3XFgI = parcelRequire("3XFgI");

var $8m7Fi = parcelRequire("8m7Fi");

var $foReD = parcelRequire("foReD");

var $6dZKG = parcelRequire("6dZKG");

var $c7SNK = parcelRequire("c7SNK");

var $7fPBF = parcelRequire("7fPBF");

var $1N52b = parcelRequire("1N52b");

var $jpsxw = parcelRequire("jpsxw");
const $fe37280edef86602$export$bd221a7c56b93941 = ()=>{
    const { role: role } = (0, $1N52b.useAuth)();
    const appService = new (0, $dNDci.AppService)();
    const [searchParams, setSearchParams] = (0, $dNYY5.useSearchParams)();
    const [availableHours, setAvailableHours] = (0, $7fPBF.useState)((0, $3XFgI.hours));
    const { setIsLoading: setIsLoading, searchObj: searchObj, setSearchObj: setSearchObj, setResults: setResults, isLoadingFilters: isLoadingFilters, isFirstSearchPerformed: isFirstSearchPerformed, setIsFirstSearchPerformed: setIsFirstSearchPerformed } = (0, $goR7t.default)();
    (0, $7fPBF.useEffect)(()=>{
        if (!isLoadingFilters) {
            if (searchObj.date) {
                const today = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))();
                if (searchObj.date.isSame(today, "day")) {
                    const timeStamp = (0, $6dZKG.fromDayjsToTimeStamp)(today);
                    setAvailableHours((0, $3XFgI.hours).reduce((acc, hour)=>{
                        if (timeStamp < Number(hour.value)) return [
                            ...acc,
                            hour
                        ];
                        return [
                            ...acc
                        ];
                    }, []));
                } else setAvailableHours((0, $3XFgI.hours));
            }
        }
    }, [
        searchObj.date
    ]);
    const fetchCategories = ()=>appService.api_getCategories().then((res)=>{
            if (res.status !== 200) throw new Error();
            return res.data;
        }).catch((error)=>console.log(error));
    const fecthClubNames = ()=>appService.api_getClubNames().then((res)=>{
            if (res.status !== 200) throw new Error();
            return res.data;
        }).catch((error)=>console.log(error));
    const fetchEverything = (role)=>Promise.all([
            fetchCategories(),
            fecthClubNames()
        ]);
    const checkQueryString = (inputObj = {})=>{
        var _searchParams_get, _searchParams_get1, _searchParams_get2, _searchParams_get3, _searchParams_get4, _searchParams_get5;
        let date = searchParams.get("date") ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(searchParams.get("date"))) : (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))();
        let time = searchParams.get("time") ? searchParams.get("time") : `${(0, $jpsxw.getNextHalfAnHour)()}`;
        if (!!date) {
            let today = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))();
            if (date.isSame(today, "day")) {
                if (time) {
                    const inputDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(time)).utc().format("HH:mm");
                    const todayDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(`1970-01-01 ${today.format("HH:mm")}`).format("HH:mm");
                    const inputTime = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(inputDate, "HH:mm");
                    const todayTime = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(todayDate, "HH:mm");
                    if (todayTime.isAfter(inputTime)) {
                        const minutes = today.minute();
                        const roundedMinutes = Math.ceil(minutes / 30) * 30;
                        if (roundedMinutes === 60) today = today.add(1, "hour").minute(0);
                        else today = today.minute(roundedMinutes);
                        const timeStamp = (0, $6dZKG.fromDayjsToTimeStamp)(today);
                        const option = (0, $3XFgI.hours).find((hour)=>Number(hour.value) === timeStamp);
                        if (!!option) time = `${option.value}`;
                        else {
                            date = date === null || date === void 0 ? void 0 : date.add(1, "day");
                            time = `${(0, $3XFgI.hours)[0].value}`;
                        }
                    }
                }
            }
        }
        if (time && !isNaN(Number(time))) {
            if (Number(time) < Number((0, $3XFgI.hours)[0].value)) time = `${(0, $3XFgI.hours)[0].value}`;
            else if (Number(time) > Number((0, $3XFgI.hours)[(0, $3XFgI.hours).length - 1].value)) {
                time = `${(0, $3XFgI.hours)[0].value}`;
                if (!!date) date = date === null || date === void 0 ? void 0 : date.add(1, "day");
            }
            if (!(0, $3XFgI.hours).find((hour)=>hour.value === time)) {
                for(let i = 0; i < (0, $3XFgI.hours).length; i++)if (parseInt((0, $3XFgI.hours)[i].value) > Number(time)) {
                    time = (0, $3XFgI.hours)[i].value;
                    break;
                }
            }
        }
        var _searchParams_get6;
        const searchObjFromQuery = {
            sport: searchParams.get("sport") ? (_searchParams_get = searchParams.get("sport")) === null || _searchParams_get === void 0 ? void 0 : _searchParams_get.split(";") : "",
            district: (0, $3XFgI.districts).includes(searchParams.get("district")) ? searchParams.get("district") : "Aveiro",
            date: date,
            time: time,
            timeUnit: (_searchParams_get6 = searchParams.get("timeUnit")) !== null && _searchParams_get6 !== void 0 ? _searchParams_get6 : "3600",
            privacy: (0, $3XFgI.privacies).includes((_searchParams_get1 = searchParams.get("privacy")) === null || _searchParams_get1 === void 0 ? void 0 : _searchParams_get1.toUpperCase()) ? (_searchParams_get2 = searchParams.get("privacy")) === null || _searchParams_get2 === void 0 ? void 0 : _searchParams_get2.toUpperCase() : "",
            environment: (0, $3XFgI.environments).includes((_searchParams_get3 = searchParams.get("environment")) === null || _searchParams_get3 === void 0 ? void 0 : _searchParams_get3.toUpperCase()) ? (_searchParams_get4 = searchParams.get("environment")) === null || _searchParams_get4 === void 0 ? void 0 : _searchParams_get4.toUpperCase() : "",
            clubName: searchParams.get("clubName") ? (_searchParams_get5 = searchParams.get("clubName")) === null || _searchParams_get5 === void 0 ? void 0 : _searchParams_get5.split(";") : ""
        };
        const cleanSearchObj = (0, $k6mBf.removeEmptyeKeys)(searchObjFromQuery);
        setSearchObj((previous)=>({
                ...previous,
                ...cleanSearchObj
            }));
        setSearchParams((searchParams)=>{
            Object.keys(cleanSearchObj).map((key)=>{
                searchParams.set(key, Array.isArray(cleanSearchObj[key]) ? cleanSearchObj[key].join(",") : (0, $foReD.threatSearchValues)(key, cleanSearchObj[key]));
            });
            return searchParams;
        });
        const error = (0, $c7SNK.checkIfFieldsAreValidAndReturnError)({
            ...cleanSearchObj,
            ...inputObj
        });
        if (error) return;
        search({
            ...cleanSearchObj,
            ...inputObj
        });
    };
    const handleInputChange = (name, value, inputObj = {})=>{
        setSearchObj((prev)=>{
            const newObj = {
                ...prev,
                [name]: value
            };
            if (!(0, $c7SNK.checkIfFieldsAreValidAndReturnError)(newObj)) search({
                ...newObj,
                ...inputObj
            });
            return newObj;
        });
        setSearchParams((searchParams)=>{
            searchParams.set(name, Array.isArray(value) ? value.join(";") : (0, $foReD.threatSearchValues)(name, value));
            return searchParams;
        });
    };
    const search = (searchObj)=>{
        const final = {
            ...searchObj,
            ...searchObj.date && {
                date: searchObj.date.format("YYYY-MM-DD")
            },
            ...searchObj.time && {
                time: (0, $3XFgI.hours).find((hour)=>hour.value === searchObj.time).label
            },
            ...searchObj.timeUnit && {
                timeUnit: (0, $3XFgI.timeUnits).find((timeUnit)=>timeUnit.value === searchObj.timeUnit).label
            }
        };
        appService.api_searchClubs({
            ...(0, $k6mBf.removeEmptyeKeys)(final)
        }, role === "club-admin" ? "private" : undefined).then((res)=>{
            if (res.status !== 200) throw new Error();
            if (!isFirstSearchPerformed) setIsFirstSearchPerformed(true);
            setResults(res.data);
        }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
    };
    return {
        availableHours: availableHours,
        actions: {
            search: search,
            checkQueryString: checkQueryString,
            fetchEverything: fetchEverything,
            handleInputChange: handleInputChange
        }
    };
};

});
parcelRequire.register("k6mBf", function(module, exports) {

$parcel$export(module.exports, "removeEmptyeKeys", function () { return $582d408e5075c3cd$export$ccbcc5bcbae11edb; });
const $582d408e5075c3cd$export$ccbcc5bcbae11edb = (obj, valuesDiscard = [])=>Object.keys(obj).reduce((acc, key)=>{
        return {
            ...acc,
            ...!!obj[key] && !valuesDiscard.includes(obj[key]) ? {
                [key]: obj[key]
            } : {}
        };
    }, {});

});

parcelRequire.register("3XFgI", function(module, exports) {

$parcel$export(module.exports, "districts", function () { return $609eb1729e42e504$export$d701fce4f6bdb9b3; });
$parcel$export(module.exports, "hours", function () { return $609eb1729e42e504$export$8d468796d69cdad1; });
$parcel$export(module.exports, "timeUnits", function () { return $609eb1729e42e504$export$833c398a55654bb7; });
$parcel$export(module.exports, "fieldsOrder", function () { return $609eb1729e42e504$export$ff1914f3602288fe; });
$parcel$export(module.exports, "privacies", function () { return $609eb1729e42e504$export$3baacd2e7b268065; });
$parcel$export(module.exports, "environments", function () { return $609eb1729e42e504$export$c67cb6e08c9d0d95; });
$parcel$export(module.exports, "notRequiredFields", function () { return $609eb1729e42e504$export$5680eab661839edc; });
$parcel$export(module.exports, "valuesToLowerCase", function () { return $609eb1729e42e504$export$9e59bd96b649806; });
$parcel$export(module.exports, "valuesToTimeStamp", function () { return $609eb1729e42e504$export$3e85d3093562d33; });

var $9CsDo = parcelRequire("9CsDo");
const $609eb1729e42e504$export$d701fce4f6bdb9b3 = [
    "Viana do Castelo",
    "Castelo Branco",
    "Braga",
    "Porto",
    "Aveiro",
    "Viseu",
    "Coimbra",
    "Leiria",
    "Santar\xe9m",
    "Lisboa",
    "Set\xfabal",
    "Alentejo",
    "Algarve",
    "Madeira",
    "A\xe7ores"
];
const $609eb1729e42e504$export$8d468796d69cdad1 = (0, $9CsDo.generateHoursArray)("8:00", "23:00");
const $609eb1729e42e504$export$833c398a55654bb7 = (0, $9CsDo.generateHoursArray)("01:00", "02:00");
const $609eb1729e42e504$export$ff1914f3602288fe = [
    "sport",
    "date",
    "time",
    "timeUnit",
    "district",
    "clubName"
];
const $609eb1729e42e504$export$3baacd2e7b268065 = [
    "NOT_SPECIFIED",
    "PRIVATE",
    "PUBLIC"
];
const $609eb1729e42e504$export$c67cb6e08c9d0d95 = [
    "NOT_SPECIFIED",
    "INDOOR",
    "OUTDOOR"
];
const $609eb1729e42e504$export$5680eab661839edc = [
    "sport",
    "clubName"
];
const $609eb1729e42e504$export$9e59bd96b649806 = [
    "sport",
    "privacy",
    "environment"
];
const $609eb1729e42e504$export$3e85d3093562d33 = [
    "date"
];

});
parcelRequire.register("9CsDo", function(module, exports) {

$parcel$export(module.exports, "generateHoursArray", function () { return $2d80fb1a68e99c96$export$84732e2eb9633397; });
const $2d80fb1a68e99c96$export$84732e2eb9633397 = (startingHour, endingHour)=>{
    const [startHour, startMinute] = startingHour.split(":").map(Number);
    const [endHour, endMinute] = endingHour.split(":").map(Number);
    const hours = [];
    for(let [hour, minute] = [
        startHour,
        startMinute
    ]; hour * 60 + minute <= endHour * 60 + endMinute; minute += 60){
        if (minute >= 60) [hour, minute] = [
            hour + 1,
            minute - 60
        ];
        hours.push({
            label: `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`,
            value: `${hour * 3600 + minute * 60}`
        });
    }
    return hours;
};

});


parcelRequire.register("foReD", function(module, exports) {

$parcel$export(module.exports, "threatSearchValues", function () { return $fc860a4b01c83135$export$ec4394720fb16bc0; });

var $8m7Fi = parcelRequire("8m7Fi");

var $3XFgI = parcelRequire("3XFgI");
const $fc860a4b01c83135$export$ec4394720fb16bc0 = (key, value)=>{
    if ((0, $3XFgI.valuesToLowerCase).includes(key)) return String(value).toUpperCase();
    else if ((0, $3XFgI.valuesToTimeStamp).includes(key)) {
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(value, "DD-MM-YYYY HH:mm").hour(0).minute(0).second(0);
        return date.unix();
    }
    return value;
};

});

parcelRequire.register("6dZKG", function(module, exports) {

$parcel$export(module.exports, "fromDayjsToTimeStamp", function () { return $1972157310a3b479$export$7e9da79731f6641d; });
const $1972157310a3b479$export$7e9da79731f6641d = (date)=>date.format("HH:mm").split(":").reduce((acc, key, index)=>{
        if (index === 0) return Number(key) * 3600;
        else return acc + Number(key) * 60;
    }, 0);

});

parcelRequire.register("c7SNK", function(module, exports) {

$parcel$export(module.exports, "checkIfFieldsAreValidAndReturnError", function () { return $65c296549fdf8b0b$export$e50614819103a049; });

var $3XFgI = parcelRequire("3XFgI");
const $65c296549fdf8b0b$export$e50614819103a049 = (searchObj)=>{
    let error;
    for (const key of (0, $3XFgI.fieldsOrder)){
        if ((0, $3XFgI.notRequiredFields).includes(key)) continue;
        if (!!!searchObj[key]) {
            error = {
                field: key
            };
            break;
        }
    }
    return error;
};

});

parcelRequire.register("jpsxw", function(module, exports) {

$parcel$export(module.exports, "mountQueryString", function () { return $ef3a1f6b2b62c8f4$export$4a8e6467315a14a; });
$parcel$export(module.exports, "getNextHalfAnHour", function () { return $ef3a1f6b2b62c8f4$export$b3a87904a3737d6a; });

var $8m7Fi = parcelRequire("8m7Fi");
const $ef3a1f6b2b62c8f4$export$4a8e6467315a14a = (inputParams = {})=>{
    const params = {
        ...inputParams
    };
    if (!("date" in params)) params.date = `${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().hour(0).minute(0).second(0).unix()}`;
    const timeStamp = $ef3a1f6b2b62c8f4$export$b3a87904a3737d6a();
    params.time = `${timeStamp}`;
    const defaultTimeUnit = `3600`;
    params.timeUnit = defaultTimeUnit;
    return `?${Object.keys(params).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join("&")}`;
};
const $ef3a1f6b2b62c8f4$export$b3a87904a3737d6a = ()=>{
    let time = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().add(2, "minutes");
    const minutes = time.minute();
    const roundedMinutes = Math.ceil(minutes / 30) * 30;
    if (roundedMinutes === 60) time = time.add(1, "hour").minute(0);
    else time = time.minute(roundedMinutes);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc("1970-01-01").hour(time.hour()).minute(time.minute()).diff((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc("1970-01-01"), "second");
};

});



parcelRequire.register("84nYO", function(module, exports) {

$parcel$export(module.exports, "getBookingUrlAndState", function () { return $fe71bd5f69b4cb24$export$c17138b5a64b6548; });

var $cRz8b = parcelRequire("cRz8b");

var $7vf1K = parcelRequire("7vf1K");
const $fe71bd5f69b4cb24$export$c17138b5a64b6548 = (role, searchObj, categories, clubId, area, price, sport)=>{
    const finalSearchObj = {
        ...searchObj,
        ...!!sport && {
            sport: sport.toLowerCase()
        }
    };
    if (role === "club-admin") {
        const from = finalSearchObj.date.add(Number(finalSearchObj.time) + 3600, "seconds");
        const to = from.add(Number(finalSearchObj.timeUnit), "seconds");
        const state = {
            area: area.name,
            areaId: area.id,
            from: from.toDate(),
            to: to.utc().toDate(),
            day: finalSearchObj.date.toDate(),
            timeUnit: (0, $cRz8b.getTimeUnit)(finalSearchObj.timeUnit),
            price: price,
            ...finalSearchObj.sport && {
                sport: categories === null || categories === void 0 ? void 0 : categories.find((cat)=>cat.toLowerCase() === finalSearchObj.sport)
            }
        };
        return {
            url: `/club-admin/club/${clubId}/bookings/create`,
            state: state
        };
    }
    const searchObjProps = (0, $7vf1K.fromObjectToQueryString)(finalSearchObj);
    const sportId = categories === null || categories === void 0 ? void 0 : categories.find((cat)=>cat.toLowerCase() === finalSearchObj.sport);
    return {
        url: `/booking?area=${area.id}&price=${price}${searchObjProps}&sportId=${sportId}`,
        state: {}
    };
};

});
parcelRequire.register("cRz8b", function(module, exports) {

$parcel$export(module.exports, "getTimeUnit", function () { return $86383b0b3dedea87$export$80af807a588288ab; });
const $86383b0b3dedea87$export$80af807a588288ab = (timeUnit)=>{
    switch(timeUnit){
        case "00:30":
        case "1800":
            return "TRINTA_MINUTOS";
        case "01:00":
        case "3600":
            return "UMA_HORA";
        case "01:30":
        case "5400":
            return "UMA_HORA_TRINTA_MINUTOS";
        case "02:00":
        case "7200":
            return "DUAS_HORA";
    }
};

});

parcelRequire.register("7vf1K", function(module, exports) {

$parcel$export(module.exports, "fromObjectToQueryString", function () { return $dc2e297081d52ebb$export$8ef4ae0b03c67308; });

var $foReD = parcelRequire("foReD");
const $dc2e297081d52ebb$export$8ef4ae0b03c67308 = (obj)=>Object.keys(obj).reduce((acc, key)=>`${acc}&${key}=${(0, $foReD.threatSearchValues)(key, obj[key])}`, "");

});




parcelRequire.register("j0ndM", function(module, exports) {

$parcel$export(module.exports, "useClubById", function () { return $99f15020fc80981b$export$8b0d8fe34c7d629a; });
parcelRequire("fI21S");
var $1HW2x = parcelRequire("1HW2x");

var $dNDci = parcelRequire("dNDci");
function $99f15020fc80981b$export$8b0d8fe34c7d629a(role, clubId) {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, data: data = [] } = (0, $1HW2x.useQuery)({
        queryKey: [
            "clubById"
        ],
        queryFn: async ()=>{
            const res = await appService.api_getClubById(role, clubId);
            return res.data;
        }
    });
    return {
        data: data,
        isLoading: isLoading
    };
}

});





parcelRequire.register("7f3i2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b38392db77605d45$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $hG0Cb = parcelRequire("hG0Cb");
var $kspUS = parcelRequire("kspUS");
var $g9bTP = parcelRequire("g9bTP");

var $dkKmP = parcelRequire("dkKmP");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $hxRgH = parcelRequire("hxRgH");
const $b38392db77605d45$var$NotAuthenticatedNavbar = ()=>{
    const navigate = (0, $iIluI.useNavigate)();
    const location = (0, $iIluI.useLocation)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const theme = (0, $g9bTP.default)();
    const isSmallScreen = (0, $kspUS.default)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
        sx: {
            padding: "1rem"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            direction: "row",
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                    onClick: ()=>navigate("/"),
                    src: "/logo_aveiro_tech_city.png",
                    alt: "FreeCourts: Courts for everyone",
                    height: 52
                }),
                isSmallScreen && /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hxRgH))), {
                    sx: {
                        fontSize: 40
                    },
                    color: "primary",
                    onClick: ()=>navigate(`/login?return_url=${encodeURIComponent(`${location.pathname}${location.search}`)}`)
                }),
                !isSmallScreen && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                    variant: "contained",
                    sx: {
                        width: "180px"
                    },
                    onClick: ()=>navigate(`/login?return_url=${encodeURIComponent(`${location.pathname}${location.search}`)}`),
                    children: t("signInSignUp")
                })
            ]
        })
    });
};
var $b38392db77605d45$export$2e2bcd8739ae039 = $b38392db77605d45$var$NotAuthenticatedNavbar;

});
parcelRequire.register("hxRgH", function(module, exports) {
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc5ed6ba3196faf3$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $cc5ed6ba3196faf3$var$_default = (0, $cc5ed6ba3196faf3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"
}), "AccountCircle");
module.exports.default = $cc5ed6ba3196faf3$var$_default;

});


parcelRequire.register("aTZYb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3711f68f2f9fb45d$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $aili3 = parcelRequire("aili3");
var $hG0Cb = parcelRequire("hG0Cb");

var $7fPBF = parcelRequire("7fPBF");

var $7A1zy = parcelRequire("7A1zy");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $iKyoS = parcelRequire("iKyoS");

var $8HmXW = parcelRequire("8HmXW");
const $3711f68f2f9fb45d$var$Navbar = (props)=>{
    const navigate = (0, $iIluI.useNavigate)();
    const [menuOpen, setMenuOpen] = (0, $7fPBF.useState)(false);
    const handleMenuOpen = ()=>setMenuOpen(true);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        sx: {
            padding: "1rem"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                direction: "row",
                justifyContent: "space-between",
                alignItems: "center",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledIconButton), {
                        onClick: handleMenuOpen,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7A1zy))), {
                            color: "primary",
                            style: {
                                opacity: props.hideMenu ? 0 : 1
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        onClick: ()=>navigate("/"),
                        src: "/logo_aveiro_tech_city.png",
                        alt: "FreeCourts: Courts for everyone",
                        height: 52
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledSpan), {})
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iKyoS.PlayerMenu), {
                open: menuOpen,
                onClose: ()=>setMenuOpen(false)
            })
        ]
    });
};
var $3711f68f2f9fb45d$export$2e2bcd8739ae039 = $3711f68f2f9fb45d$var$Navbar;

});
parcelRequire.register("iKyoS", function(module, exports) {

$parcel$export(module.exports, "PlayerMenu", function () { return $b865bf1b69fe2988$export$d890bacfb90ff51c; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $aeoYN = parcelRequire("aeoYN");
var $pF6j5 = parcelRequire("pF6j5");
var $lE3FT = parcelRequire("lE3FT");
var $57cKd = parcelRequire("57cKd");
var $dxMGW = parcelRequire("dxMGW");
var $58CWL = parcelRequire("58CWL");
var $dseJp = parcelRequire("dseJp");
var $abILr = parcelRequire("abILr");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $cAbNk = parcelRequire("cAbNk");

var $1quPt = parcelRequire("1quPt");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $28Esm = parcelRequire("28Esm");

var $8HmXW = parcelRequire("8HmXW");
const $b865bf1b69fe2988$export$d890bacfb90ff51c = ({ open: open, onClose: onClose })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { user: user, isLoading: isLoading } = (0, $28Esm.default)();
    const navigateTo = (to)=>{
        navigate(to);
        onClose();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lE3FT.default), {
        anchor: "left",
        variant: "temporary",
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            sx: {
                padding: "1rem 0"
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HmXW.StyledIconButton), {
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1quPt))), {
                                color: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            onClick: ()=>navigate("/"),
                            src: "/logo_aveiro_tech_city.png",
                            alt: "FreeCourts: Courts for everyone",
                            height: 52
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                            style: {
                                width: "40px"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
                    direction: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    mt: "2rem",
                    p: "0 1rem",
                    children: isLoading ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                                variant: "circular",
                                width: 48,
                                height: 48
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                                width: "100%",
                                height: 32
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                                width: "100%",
                                height: 24
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aeoYN.default), {
                                src: user === null || user === void 0 ? void 0 : user.photoUrl,
                                sx: {
                                    width: 48,
                                    height: 48,
                                    bgcolor: "#1976d2"
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "h6",
                                sx: {
                                    marginTop: 1
                                },
                                children: user === null || user === void 0 ? void 0 : user.name
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "body1",
                                children: user === null || user === void 0 ? void 0 : user.email
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dseJp.default), {
                    sx: {
                        marginTop: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            onClick: ()=>navigateTo("/"),
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                children: t("playerMenu.home")
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            onClick: ()=>navigateTo("/player/bookings"),
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                children: t("bookings")
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            onClick: ()=>navigateTo("/player/edit-account"),
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                children: t("playerMenu.editAccount")
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                            onClick: ()=>navigateTo("/terms-and-conditions"),
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                children: t("termsAndConditions")
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                            onClick: ()=>navigateTo("/logout"),
                            color: "primary",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $57cKd.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cAbNk))), {
                                        color: "primary"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                        color: "primary",
                                        children: t("playerMenu.logout")
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRequire.register("28Esm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbacf827b6c147bd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $3mPwx = parcelRequire("3mPwx");

var $dNDci = parcelRequire("dNDci");

var $fnVR5 = parcelRequire("fnVR5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
const $dbacf827b6c147bd$export$23bbbc4533528f03 = ()=>{
    const appService = new (0, $dNDci.AppService)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [error, setError] = (0, $7fPBF.useState)(false);
    const { user: user, setUser: setUser, setIsLoading: setIsLoading, isLoading: isLoading } = (0, $3mPwx.useUserContext)();
    const isReady = (0, $7fPBF.useRef)(false);
    const getUser = (0, $7fPBF.useCallback)(async ()=>{
        await appService.api_getUser().then((res)=>{
            if (res.status !== 200) throw new Error();
            if (res.data) setUser(res.data);
            setIsLoading(false);
        }).catch((error)=>console.log(error));
    }, [
        setUser,
        appService,
        setIsLoading
    ]);
    const updateUser = (0, $7fPBF.useCallback)(async (user)=>{
        const newUser = user;
        if (newUser.photoUrl !== "undefined") delete newUser.photoUrl;
        await appService.api_updateUser(user).then((res)=>{
            if (res.status !== 200) throw new Error();
            if (res.status === 200) {
                setError(false);
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: t("editAccount.success.userUpdate")
                });
                getUser();
            } else {
                setError(true);
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: t("editAccount.error.userUpdate")
                });
            }
            setIsLoading(false);
        }).catch((error)=>console.log(error));
    }, [
        getUser,
        appService,
        setIsLoading,
        setSnackbar,
        setError,
        t
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isReady.current) return;
        isReady.current = true;
        getUser();
        setIsLoading(false);
    }, [
        user,
        getUser,
        setIsLoading
    ]);
    return {
        user: user,
        isLoading: isLoading,
        setUser: setUser,
        updateUser: updateUser
    };
};
var $dbacf827b6c147bd$export$2e2bcd8739ae039 = $dbacf827b6c147bd$export$23bbbc4533528f03;

});
parcelRequire.register("3mPwx", function(module, exports) {

$parcel$export(module.exports, "UserContextProvider", function () { return $05528f814c646e0d$export$2e7f18b06f26b111; });
$parcel$export(module.exports, "useUserContext", function () { return $05528f814c646e0d$export$87c54b525b914dab; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $05528f814c646e0d$export$38ee920e59704589 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    user: null,
    setUser: ()=>{},
    isLoading: true,
    setIsLoading: ()=>{}
});
const $05528f814c646e0d$export$2e7f18b06f26b111 = (props)=>{
    const [user, setUser] = (0, $7fPBF.useState)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const values = {
        user: user,
        setUser: setUser,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($05528f814c646e0d$export$38ee920e59704589.Provider, {
        value: values,
        children: props.children
    });
};
const $05528f814c646e0d$export$87c54b525b914dab = ()=>(0, $7fPBF.useContext)($05528f814c646e0d$export$38ee920e59704589);

});




parcelRequire.register("4fBxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2669dd3a92f1c157$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $aili3 = parcelRequire("aili3");
var $hG0Cb = parcelRequire("hG0Cb");
parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
const $2669dd3a92f1c157$var$Header = ()=>{
    const navigate = (0, $iIluI.useNavigate)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
        sx: {
            padding: "1rem"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
            direction: "row",
            justifyContent: "center",
            alignItems: "center",
            spacing: 2,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                onClick: ()=>navigate("/"),
                src: "/logo_aveiro_tech_city.png",
                alt: "FreeCourts: Courts for everyone",
                height: 82
            })
        })
    });
};
var $2669dd3a92f1c157$export$2e2bcd8739ae039 = $2669dd3a92f1c157$var$Header;

});


parcelRequire.register("1ZNeQ", function(module, exports) {

$parcel$export(module.exports, "useFormik", function () { return $1741aead084fb83b$export$8e1b316dbace9aa7; });
$parcel$export(module.exports, "Formik", function () { return $1741aead084fb83b$export$6df21e1298c28640; });
$parcel$export(module.exports, "Form", function () { return $1741aead084fb83b$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "ErrorMessage", function () { return $1741aead084fb83b$export$915e9e7bd4f0f96d; });

var $4qrK2 = parcelRequire("4qrK2");

var $jvrjc = parcelRequire("jvrjc");

var $7fPBF = parcelRequire("7fPBF");

var $iC4RG = parcelRequire("iC4RG");

var $8knIu = parcelRequire("8knIu");

var $2eESg = parcelRequire("2eESg");

var $5yFbH = parcelRequire("5yFbH");

var $8Ae2G = parcelRequire("8Ae2G");

var $hVVj1 = parcelRequire("hVVj1");
function $1741aead084fb83b$var$_extends() {
    $1741aead084fb83b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1741aead084fb83b$var$_extends.apply(this, arguments);
}
function $1741aead084fb83b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $1741aead084fb83b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1741aead084fb83b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $1741aead084fb83b$export$1827d4b2bad9797b = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
$1741aead084fb83b$export$1827d4b2bad9797b.displayName = "FormikContext";
var $1741aead084fb83b$export$c32de3fec5d9dcc1 = $1741aead084fb83b$export$1827d4b2bad9797b.Provider;
var $1741aead084fb83b$export$c3662afe2941c81f = $1741aead084fb83b$export$1827d4b2bad9797b.Consumer;
function $1741aead084fb83b$export$ba7e877c5b835d9() {
    var formik = (0, $7fPBF.useContext)($1741aead084fb83b$export$1827d4b2bad9797b);
    !!!formik && (0, $8knIu.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var $1741aead084fb83b$export$4c0262a4f954db45 = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var $1741aead084fb83b$export$f6e2535fb5126e54 = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var $1741aead084fb83b$export$a6cdc56e425d0d0a = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var $1741aead084fb83b$export$a287f47fed4544b8 = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var $1741aead084fb83b$export$844ec244b1367d54 = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var $1741aead084fb83b$export$c9f5652083b8129d = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var $1741aead084fb83b$export$57a5d14e113bb8e1 = function isEmptyChildren(children) {
    return (0, $7fPBF.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var $1741aead084fb83b$export$4369c812aac99591 = function isPromise(value) {
    return $1741aead084fb83b$export$a6cdc56e425d0d0a(value) && $1741aead084fb83b$export$f6e2535fb5126e54(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var $1741aead084fb83b$export$4215e022093e324e = function isInputEvent(value) {
    return value && $1741aead084fb83b$export$a6cdc56e425d0d0a(value) && $1741aead084fb83b$export$a6cdc56e425d0d0a(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function $1741aead084fb83b$export$cd4e5573fbe2b576(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function $1741aead084fb83b$export$c52e5867d5879e24(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $5yFbH.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function $1741aead084fb83b$export$e6bdf135a54e021b(obj, path, value) {
    var res = (0, $2eESg.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $5yFbH.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = $1741aead084fb83b$export$c52e5867d5879e24(obj, pathArray.slice(0, i + 1));
        if (currentObj && ($1741aead084fb83b$export$a6cdc56e425d0d0a(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $2eESg.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = $1741aead084fb83b$export$a287f47fed4544b8(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function $1741aead084fb83b$export$e00b37dfa63d3cda(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if ($1741aead084fb83b$export$a6cdc56e425d0d0a(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                $1741aead084fb83b$export$e00b37dfa63d3cda(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function $1741aead084fb83b$var$formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return $1741aead084fb83b$var$_extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return $1741aead084fb83b$var$_extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(state.errors, msg.payload)) return state;
            return $1741aead084fb83b$var$_extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return $1741aead084fb83b$var$_extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return $1741aead084fb83b$var$_extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return $1741aead084fb83b$var$_extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return $1741aead084fb83b$var$_extends({}, state, {
                values: $1741aead084fb83b$export$e6bdf135a54e021b(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return $1741aead084fb83b$var$_extends({}, state, {
                touched: $1741aead084fb83b$export$e6bdf135a54e021b(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return $1741aead084fb83b$var$_extends({}, state, {
                errors: $1741aead084fb83b$export$e6bdf135a54e021b(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return $1741aead084fb83b$var$_extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return $1741aead084fb83b$var$_extends({}, state, {
                touched: $1741aead084fb83b$export$e00b37dfa63d3cda(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return $1741aead084fb83b$var$_extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return $1741aead084fb83b$var$_extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var $1741aead084fb83b$var$emptyErrors = {};
var $1741aead084fb83b$var$emptyTouched = {};
function $1741aead084fb83b$export$8e1b316dbace9aa7(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = $1741aead084fb83b$var$_extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $7fPBF.useRef)(props.initialValues);
    var initialErrors = (0, $7fPBF.useRef)(props.initialErrors || $1741aead084fb83b$var$emptyErrors);
    var initialTouched = (0, $7fPBF.useRef)(props.initialTouched || $1741aead084fb83b$var$emptyTouched);
    var initialStatus = (0, $7fPBF.useRef)(props.initialStatus);
    var isMounted = (0, $7fPBF.useRef)(false);
    var fieldRegistry = (0, $7fPBF.useRef)({});
    (0, $7fPBF.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $7fPBF.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $7fPBF.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || $1741aead084fb83b$var$emptyErrors,
        touched: props.initialTouched || $1741aead084fb83b$var$emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $7fPBF.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = $1741aead084fb83b$var$formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $7fPBF.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve($1741aead084fb83b$var$emptyErrors);
            else if ($1741aead084fb83b$export$4369c812aac99591(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || $1741aead084fb83b$var$emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $7fPBF.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = $1741aead084fb83b$export$f6e2535fb5126e54(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : $1741aead084fb83b$export$b970d11e0506b986(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve($1741aead084fb83b$var$emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve($1741aead084fb83b$export$413ed3624bd9407a(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $7fPBF.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $7fPBF.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return $1741aead084fb83b$export$f6e2535fb5126e54(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, $1741aead084fb83b$export$c52e5867d5879e24(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = $1741aead084fb83b$export$e6bdf135a54e021b(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $7fPBF.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $4qrK2.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: $1741aead084fb83b$var$arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = $1741aead084fb83b$var$useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $7fPBF.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $7fPBF.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if ($1741aead084fb83b$export$4369c812aac99591(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || $1741aead084fb83b$var$emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || $1741aead084fb83b$var$emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || $1741aead084fb83b$var$emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || $1741aead084fb83b$var$emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $7fPBF.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = $1741aead084fb83b$var$useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && $1741aead084fb83b$export$f6e2535fb5126e54(fieldRegistry.current[name].validate)) {
            var value = $1741aead084fb83b$export$c52e5867d5879e24(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if ($1741aead084fb83b$export$4369c812aac99591(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: $1741aead084fb83b$export$c52e5867d5879e24(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $7fPBF.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $7fPBF.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = $1741aead084fb83b$var$useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $7fPBF.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = $1741aead084fb83b$var$useEventCallback(function(values, shouldValidate) {
        var resolvedValues = $1741aead084fb83b$export$f6e2535fb5126e54(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $7fPBF.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = $1741aead084fb83b$var$useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority($1741aead084fb83b$export$e6bdf135a54e021b(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $7fPBF.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!$1741aead084fb83b$export$844ec244b1367d54(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? $1741aead084fb83b$var$getValueForCheckbox($1741aead084fb83b$export$c52e5867d5879e24(state.values, field), checked, value) : options && multiple // <select multiple>
             ? $1741aead084fb83b$var$getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = $1741aead084fb83b$var$useEventCallback(function(eventOrPath) {
        if ($1741aead084fb83b$export$844ec244b1367d54(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = $1741aead084fb83b$var$useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $7fPBF.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = $1741aead084fb83b$var$useEventCallback(function(eventOrString) {
        if ($1741aead084fb83b$export$844ec244b1367d54(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $7fPBF.useCallback)(function(stateOrCb) {
        if ($1741aead084fb83b$export$f6e2535fb5126e54(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $7fPBF.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $7fPBF.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = $1741aead084fb83b$var$useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = $1741aead084fb83b$var$useEventCallback(function(e) {
        if (e && e.preventDefault && $1741aead084fb83b$export$f6e2535fb5126e54(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && $1741aead084fb83b$export$f6e2535fb5126e54(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = $1741aead084fb83b$var$useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = $1741aead084fb83b$var$useEventCallback(function(e) {
        if (e && e.preventDefault && $1741aead084fb83b$export$f6e2535fb5126e54(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && $1741aead084fb83b$export$f6e2535fb5126e54(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $7fPBF.useCallback)(function(name) {
        return {
            value: $1741aead084fb83b$export$c52e5867d5879e24(state.values, name),
            error: $1741aead084fb83b$export$c52e5867d5879e24(state.errors, name),
            touched: !!$1741aead084fb83b$export$c52e5867d5879e24(state.touched, name),
            initialValue: $1741aead084fb83b$export$c52e5867d5879e24(initialValues.current, name),
            initialTouched: !!$1741aead084fb83b$export$c52e5867d5879e24(initialTouched.current, name),
            initialError: $1741aead084fb83b$export$c52e5867d5879e24(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $7fPBF.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $7fPBF.useCallback)(function(nameOrOptions) {
        var isAnObject = $1741aead084fb83b$export$a6cdc56e425d0d0a(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = $1741aead084fb83b$export$c52e5867d5879e24(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $7fPBF.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $7fPBF.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && $1741aead084fb83b$export$f6e2535fb5126e54(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = $1741aead084fb83b$var$_extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function $1741aead084fb83b$export$6df21e1298c28640(props) {
    var formikbag = $1741aead084fb83b$export$8e1b316dbace9aa7(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $7fPBF.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $7fPBF.createElement)($1741aead084fb83b$export$c32de3fec5d9dcc1, {
        value: formikbag
    }, component ? (0, $7fPBF.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? $1741aead084fb83b$export$f6e2535fb5126e54(children) ? children(formikbag) : !$1741aead084fb83b$export$57a5d14e113bb8e1(children) ? (0, $7fPBF.Children).only(children) : null : null);
}
function $1741aead084fb83b$var$warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function $1741aead084fb83b$export$413ed3624bd9407a(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return $1741aead084fb83b$export$e6bdf135a54e021b(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!$1741aead084fb83b$export$c52e5867d5879e24(errors, err.path)) errors = $1741aead084fb83b$export$e6bdf135a54e021b(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function $1741aead084fb83b$export$b970d11e0506b986(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = $1741aead084fb83b$export$aedfc217b3e9fc02(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function $1741aead084fb83b$export$aedfc217b3e9fc02(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $jvrjc.default)(value)) return $1741aead084fb83b$export$aedfc217b3e9fc02(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $jvrjc.default)(values[key])) data[key] = $1741aead084fb83b$export$aedfc217b3e9fc02(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function $1741aead084fb83b$var$arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $4qrK2.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $4qrK2.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function $1741aead084fb83b$var$getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function $1741aead084fb83b$var$getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var $1741aead084fb83b$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $1741aead084fb83b$var$useEventCallback(fn) {
    var ref = (0, $7fPBF.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    $1741aead084fb83b$var$useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $7fPBF.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function $1741aead084fb83b$export$294aa081a6c6f55d(propsOrFieldName) {
    var formik = $1741aead084fb83b$export$ba7e877c5b835d9();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = $1741aead084fb83b$export$a6cdc56e425d0d0a(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $7fPBF.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $8knIu.default)(false);
    var fieldHelpers = (0, $7fPBF.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function $1741aead084fb83b$export$a455218a85c89869(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = $1741aead084fb83b$export$ba7e877c5b835d9(), formik = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $7fPBF.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps($1741aead084fb83b$var$_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render($1741aead084fb83b$var$_extends({}, legacyBag, {
        meta: meta
    }));
    if ($1741aead084fb83b$export$f6e2535fb5126e54(children)) return children($1741aead084fb83b$var$_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $7fPBF.createElement)(component, $1741aead084fb83b$var$_extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, $7fPBF.createElement)(component, $1741aead084fb83b$var$_extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $7fPBF.createElement)(asElement, $1741aead084fb83b$var$_extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, $7fPBF.createElement)(asElement, $1741aead084fb83b$var$_extends({}, field, props), children);
}
var $1741aead084fb83b$export$a7fed597f4b8afd8 = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = $1741aead084fb83b$export$ba7e877c5b835d9(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $7fPBF.createElement)("form", $1741aead084fb83b$var$_extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
$1741aead084fb83b$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function $1741aead084fb83b$export$f728baf3dad7bb6c(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            $1741aead084fb83b$var$_inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return $1741aead084fb83b$export$f6e2535fb5126e54(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, $1741aead084fb83b$var$_extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $7fPBF.createElement)(Component$1, $1741aead084fb83b$var$_extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $7fPBF.createElement)($1741aead084fb83b$export$6df21e1298c28640, $1741aead084fb83b$var$_extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $7fPBF.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function $1741aead084fb83b$export$64605811ab45167f(Comp) {
    var C = function C(props) {
        return (0, $7fPBF.createElement)($1741aead084fb83b$export$c3662afe2941c81f, null, function(formik) {
            !!!formik && (0, $8knIu.default)(false);
            return (0, $7fPBF.createElement)(Comp, $1741aead084fb83b$var$_extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var $1741aead084fb83b$export$d947e5f4f4c48d48 = function move(array, from, to) {
    var copy = $1741aead084fb83b$var$copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var $1741aead084fb83b$export$b0e76d9850c64156 = function swap(arrayLike, indexA, indexB) {
    var copy = $1741aead084fb83b$var$copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var $1741aead084fb83b$export$21a5ca8aa77d35ff = function insert(arrayLike, index, value) {
    var copy = $1741aead084fb83b$var$copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var $1741aead084fb83b$export$77ad94ebf1c2b9ed = function replace(arrayLike, index, value) {
    var copy = $1741aead084fb83b$var$copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var $1741aead084fb83b$var$copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from($1741aead084fb83b$var$_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var $1741aead084fb83b$var$createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || $1741aead084fb83b$export$a6cdc56e425d0d0a(data)) {
            var clone = $1741aead084fb83b$var$copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var $1741aead084fb83b$var$FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    $1741aead084fb83b$var$_inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = $1741aead084fb83b$var$createAlterationHandler(alterErrors, fn);
                var updateTouched = $1741aead084fb83b$var$createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = $1741aead084fb83b$export$e6bdf135a54e021b(prevState.values, name, fn($1741aead084fb83b$export$c52e5867d5879e24(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors($1741aead084fb83b$export$c52e5867d5879e24(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched($1741aead084fb83b$export$c52e5867d5879e24(prevState.touched, name)) : undefined;
                if ($1741aead084fb83b$export$4c0262a4f954db45(fieldError)) fieldError = undefined;
                if ($1741aead084fb83b$export$4c0262a4f954db45(fieldTouched)) fieldTouched = undefined;
                return $1741aead084fb83b$var$_extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? $1741aead084fb83b$export$e6bdf135a54e021b(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? $1741aead084fb83b$export$e6bdf135a54e021b(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat($1741aead084fb83b$var$copyArrayLike(arrayLike), [
                    (0, $hVVj1.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return $1741aead084fb83b$export$b0e76d9850c64156(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return $1741aead084fb83b$export$d947e5f4f4c48d48(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return $1741aead084fb83b$export$21a5ca8aa77d35ff(array, index, value);
            }, function(array) {
                return $1741aead084fb83b$export$21a5ca8aa77d35ff(array, index, null);
            }, function(array) {
                return $1741aead084fb83b$export$21a5ca8aa77d35ff(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return $1741aead084fb83b$export$77ad94ebf1c2b9ed(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind($1741aead084fb83b$var$_assertThisInitialized(_this));
        _this.pop = _this.pop.bind($1741aead084fb83b$var$_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($iC4RG)))($1741aead084fb83b$export$c52e5867d5879e24(prevProps.formik.values, prevProps.name), $1741aead084fb83b$export$c52e5867d5879e24(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? $1741aead084fb83b$var$copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if ($1741aead084fb83b$export$f6e2535fb5126e54(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return $1741aead084fb83b$export$f6e2535fb5126e54(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = $1741aead084fb83b$var$_extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $7fPBF.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !$1741aead084fb83b$export$57a5d14e113bb8e1(children) ? (0, $7fPBF.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $7fPBF.Component));
$1741aead084fb83b$var$FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var $1741aead084fb83b$export$2683597413c8b91 = /*#__PURE__*/ $1741aead084fb83b$export$64605811ab45167f($1741aead084fb83b$var$FieldArrayInner);
var $1741aead084fb83b$var$ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    $1741aead084fb83b$var$_inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if ($1741aead084fb83b$export$c52e5867d5879e24(this.props.formik.errors, this.props.name) !== $1741aead084fb83b$export$c52e5867d5879e24(props.formik.errors, this.props.name) || $1741aead084fb83b$export$c52e5867d5879e24(this.props.formik.touched, this.props.name) !== $1741aead084fb83b$export$c52e5867d5879e24(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = $1741aead084fb83b$export$c52e5867d5879e24(formik.touched, name);
        var error = $1741aead084fb83b$export$c52e5867d5879e24(formik.errors, name);
        return !!touch && !!error ? render ? $1741aead084fb83b$export$f6e2535fb5126e54(render) ? render(error) : null : children ? $1741aead084fb83b$export$f6e2535fb5126e54(children) ? children(error) : null : component ? (0, $7fPBF.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $7fPBF.Component));
var $1741aead084fb83b$export$915e9e7bd4f0f96d = /*#__PURE__*/ $1741aead084fb83b$export$64605811ab45167f($1741aead084fb83b$var$ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var $1741aead084fb83b$var$FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    $1741aead084fb83b$var$_inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $8knIu.default)(false);
        !!(component && render) && (0, $8knIu.default)(false);
        !!(is && children && $1741aead084fb83b$export$f6e2535fb5126e54(children)) && (0, $8knIu.default)(false);
        !!(component && children && $1741aead084fb83b$export$f6e2535fb5126e54(children)) && (0, $8knIu.default)(false);
        !!(render && children && !$1741aead084fb83b$export$57a5d14e113bb8e1(children)) && (0, $8knIu.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || $1741aead084fb83b$export$c52e5867d5879e24(props.formik.values, this.props.name) !== $1741aead084fb83b$export$c52e5867d5879e24(this.props.formik.values, this.props.name) || $1741aead084fb83b$export$c52e5867d5879e24(props.formik.errors, this.props.name) !== $1741aead084fb83b$export$c52e5867d5879e24(this.props.formik.errors, this.props.name) || $1741aead084fb83b$export$c52e5867d5879e24(props.formik.touched, this.props.name) !== $1741aead084fb83b$export$c52e5867d5879e24(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps($1741aead084fb83b$var$_extends({
            name: name
        }, props));
        var meta = {
            value: $1741aead084fb83b$export$c52e5867d5879e24(formik.values, name),
            error: $1741aead084fb83b$export$c52e5867d5879e24(formik.errors, name),
            touched: !!$1741aead084fb83b$export$c52e5867d5879e24(formik.touched, name),
            initialValue: $1741aead084fb83b$export$c52e5867d5879e24(formik.initialValues, name),
            initialTouched: !!$1741aead084fb83b$export$c52e5867d5879e24(formik.initialTouched, name),
            initialError: $1741aead084fb83b$export$c52e5867d5879e24(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if ($1741aead084fb83b$export$f6e2535fb5126e54(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $7fPBF.createElement)(component, $1741aead084fb83b$var$_extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $7fPBF.createElement)(component, $1741aead084fb83b$var$_extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = $1741aead084fb83b$var$_objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $7fPBF.createElement)(asElement, $1741aead084fb83b$var$_extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $7fPBF.createElement)(asElement, $1741aead084fb83b$var$_extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $7fPBF.Component));
var $1741aead084fb83b$export$42763663c74f360c = /*#__PURE__*/ $1741aead084fb83b$export$64605811ab45167f($1741aead084fb83b$var$FastFieldInner);

});
parcelRequire.register("4qrK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $338f1c08ba41bd5f$export$2e2bcd8739ae039; });
var $338f1c08ba41bd5f$var$isMergeableObject = function isMergeableObject(value) {
    return $338f1c08ba41bd5f$var$isNonNullObject(value) && !$338f1c08ba41bd5f$var$isSpecial(value);
};
function $338f1c08ba41bd5f$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $338f1c08ba41bd5f$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $338f1c08ba41bd5f$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $338f1c08ba41bd5f$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $338f1c08ba41bd5f$var$REACT_ELEMENT_TYPE = $338f1c08ba41bd5f$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $338f1c08ba41bd5f$var$isReactElement(value) {
    return value.$$typeof === $338f1c08ba41bd5f$var$REACT_ELEMENT_TYPE;
}
function $338f1c08ba41bd5f$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $338f1c08ba41bd5f$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $338f1c08ba41bd5f$var$deepmerge($338f1c08ba41bd5f$var$emptyTarget(value), value, options) : value;
}
function $338f1c08ba41bd5f$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $338f1c08ba41bd5f$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $338f1c08ba41bd5f$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $338f1c08ba41bd5f$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $338f1c08ba41bd5f$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $338f1c08ba41bd5f$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $338f1c08ba41bd5f$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $338f1c08ba41bd5f$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $338f1c08ba41bd5f$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $338f1c08ba41bd5f$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $338f1c08ba41bd5f$var$mergeObject(target, source, options);
}
$338f1c08ba41bd5f$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $338f1c08ba41bd5f$var$deepmerge(prev, next, options);
    }, {});
};
var $338f1c08ba41bd5f$var$deepmerge_1 = $338f1c08ba41bd5f$var$deepmerge;
var $338f1c08ba41bd5f$export$2e2bcd8739ae039 = $338f1c08ba41bd5f$var$deepmerge_1;

});

parcelRequire.register("jvrjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3361884a25afbc9$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $4Quro = parcelRequire("4Quro");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $e3361884a25afbc9$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $e3361884a25afbc9$var$funcProto = Function.prototype, $e3361884a25afbc9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e3361884a25afbc9$var$funcToString = $e3361884a25afbc9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e3361884a25afbc9$var$hasOwnProperty = $e3361884a25afbc9$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $e3361884a25afbc9$var$objectCtorString = $e3361884a25afbc9$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $e3361884a25afbc9$var$isPlainObject(value) {
    if (!(0, $1KYPq.default)(value) || (0, $cy2CN.default)(value) != $e3361884a25afbc9$var$objectTag) return false;
    var proto = (0, $4Quro.default)(value);
    if (proto === null) return true;
    var Ctor = $e3361884a25afbc9$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $e3361884a25afbc9$var$funcToString.call(Ctor) == $e3361884a25afbc9$var$objectCtorString;
}
var $e3361884a25afbc9$export$2e2bcd8739ae039 = $e3361884a25afbc9$var$isPlainObject;

});
parcelRequire.register("cy2CN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922ab23a0aa3fa49$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");

var $jeqtU = parcelRequire("jeqtU");

var $lpgZt = parcelRequire("lpgZt");
/** `Object#toString` result references. */ var $922ab23a0aa3fa49$var$nullTag = "[object Null]", $922ab23a0aa3fa49$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $922ab23a0aa3fa49$var$symToStringTag = (0, $aojMU.default) ? (0, $aojMU.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $922ab23a0aa3fa49$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $922ab23a0aa3fa49$var$undefinedTag : $922ab23a0aa3fa49$var$nullTag;
    return $922ab23a0aa3fa49$var$symToStringTag && $922ab23a0aa3fa49$var$symToStringTag in Object(value) ? (0, $jeqtU.default)(value) : (0, $lpgZt.default)(value);
}
var $922ab23a0aa3fa49$export$2e2bcd8739ae039 = $922ab23a0aa3fa49$var$baseGetTag;

});
parcelRequire.register("aojMU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790b7ebfd2aaf0d6$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Built-in value references. */ var $790b7ebfd2aaf0d6$var$Symbol = (0, $lQuKh.default).Symbol;
var $790b7ebfd2aaf0d6$export$2e2bcd8739ae039 = $790b7ebfd2aaf0d6$var$Symbol;

});
parcelRequire.register("lQuKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe764daf825b3bb5$export$2e2bcd8739ae039; });

var $ggtzD = parcelRequire("ggtzD");
/** Detect free variable `self`. */ var $fe764daf825b3bb5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $fe764daf825b3bb5$var$root = (0, $ggtzD.default) || $fe764daf825b3bb5$var$freeSelf || Function("return this")();
var $fe764daf825b3bb5$export$2e2bcd8739ae039 = $fe764daf825b3bb5$var$root;

});
parcelRequire.register("ggtzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd7514b88a803907$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $bd7514b88a803907$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $bd7514b88a803907$export$2e2bcd8739ae039 = $bd7514b88a803907$var$freeGlobal;

});



parcelRequire.register("jeqtU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e003ddc4e0072000$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");
/** Used for built-in method references. */ var $e003ddc4e0072000$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e003ddc4e0072000$var$hasOwnProperty = $e003ddc4e0072000$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e003ddc4e0072000$var$nativeObjectToString = $e003ddc4e0072000$var$objectProto.toString;
/** Built-in value references. */ var $e003ddc4e0072000$var$symToStringTag = (0, $aojMU.default) ? (0, $aojMU.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e003ddc4e0072000$var$getRawTag(value) {
    var isOwn = $e003ddc4e0072000$var$hasOwnProperty.call(value, $e003ddc4e0072000$var$symToStringTag), tag = value[$e003ddc4e0072000$var$symToStringTag];
    try {
        value[$e003ddc4e0072000$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e003ddc4e0072000$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e003ddc4e0072000$var$symToStringTag] = tag;
        else delete value[$e003ddc4e0072000$var$symToStringTag];
    }
    return result;
}
var $e003ddc4e0072000$export$2e2bcd8739ae039 = $e003ddc4e0072000$var$getRawTag;

});

parcelRequire.register("lpgZt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9591cc02ad348d1$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $f9591cc02ad348d1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f9591cc02ad348d1$var$nativeObjectToString = $f9591cc02ad348d1$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f9591cc02ad348d1$var$objectToString(value) {
    return $f9591cc02ad348d1$var$nativeObjectToString.call(value);
}
var $f9591cc02ad348d1$export$2e2bcd8739ae039 = $f9591cc02ad348d1$var$objectToString;

});


parcelRequire.register("4Quro", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3873a1a9e0dd270c$export$2e2bcd8739ae039; });

var $4qlTy = parcelRequire("4qlTy");
/** Built-in value references. */ var $3873a1a9e0dd270c$var$getPrototype = (0, $4qlTy.default)(Object.getPrototypeOf, Object);
var $3873a1a9e0dd270c$export$2e2bcd8739ae039 = $3873a1a9e0dd270c$var$getPrototype;

});
parcelRequire.register("4qlTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $338a930bf5729178$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $338a930bf5729178$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $338a930bf5729178$export$2e2bcd8739ae039 = $338a930bf5729178$var$overArg;

});


parcelRequire.register("1KYPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1479459b2ec79a29$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1479459b2ec79a29$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $1479459b2ec79a29$export$2e2bcd8739ae039 = $1479459b2ec79a29$var$isObjectLike;

});


parcelRequire.register("iC4RG", function(module, exports) {
"use strict";
var $d8cf8ca5172c2b64$var$isArray = Array.isArray;
var $d8cf8ca5172c2b64$var$keyList = Object.keys;
var $d8cf8ca5172c2b64$var$hasProp = Object.prototype.hasOwnProperty;
var $d8cf8ca5172c2b64$var$hasElementType = typeof Element !== "undefined";
function $d8cf8ca5172c2b64$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $d8cf8ca5172c2b64$var$isArray(a), arrB = $d8cf8ca5172c2b64$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $d8cf8ca5172c2b64$var$keyList(a);
        length = keys.length;
        if (length !== $d8cf8ca5172c2b64$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$d8cf8ca5172c2b64$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($d8cf8ca5172c2b64$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$d8cf8ca5172c2b64$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $d8cf8ca5172c2b64$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRequire.register("8knIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6102969760a10d5a$export$2e2bcd8739ae039; });
var $6102969760a10d5a$var$isProduction = true;
function $6102969760a10d5a$var$warning(condition, message) {
    if (!$6102969760a10d5a$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $6102969760a10d5a$export$2e2bcd8739ae039 = $6102969760a10d5a$var$warning;

});

parcelRequire.register("2eESg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a0c985f32b80dd3$export$2e2bcd8739ae039; });

var $3kFHB = parcelRequire("3kFHB");
/** Used to compose bitmasks for cloning. */ var $1a0c985f32b80dd3$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $1a0c985f32b80dd3$var$clone(value) {
    return (0, $3kFHB.default)(value, $1a0c985f32b80dd3$var$CLONE_SYMBOLS_FLAG);
}
var $1a0c985f32b80dd3$export$2e2bcd8739ae039 = $1a0c985f32b80dd3$var$clone;

});
parcelRequire.register("3kFHB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26d396936dd7aae9$export$2e2bcd8739ae039; });

var $4lrQq = parcelRequire("4lrQq");

var $e2HqO = parcelRequire("e2HqO");

var $63H9W = parcelRequire("63H9W");

var $bkn5s = parcelRequire("bkn5s");

var $kdWVV = parcelRequire("kdWVV");

var $eWRTU = parcelRequire("eWRTU");

var $axhnQ = parcelRequire("axhnQ");

var $QlRlC = parcelRequire("QlRlC");

var $94uxN = parcelRequire("94uxN");

var $kjGCi = parcelRequire("kjGCi");

var $boZAC = parcelRequire("boZAC");

var $1if5w = parcelRequire("1if5w");

var $1VLyO = parcelRequire("1VLyO");

var $5JrOR = parcelRequire("5JrOR");

var $cFFwt = parcelRequire("cFFwt");

var $21thZ = parcelRequire("21thZ");

var $9VzRR = parcelRequire("9VzRR");

var $jgOzT = parcelRequire("jgOzT");

var $1i0Jy = parcelRequire("1i0Jy");

var $c6ppW = parcelRequire("c6ppW");

var $5Hbw4 = parcelRequire("5Hbw4");

var $kKvqE = parcelRequire("kKvqE");
/** Used to compose bitmasks for cloning. */ var $26d396936dd7aae9$var$CLONE_DEEP_FLAG = 1, $26d396936dd7aae9$var$CLONE_FLAT_FLAG = 2, $26d396936dd7aae9$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $26d396936dd7aae9$var$argsTag = "[object Arguments]", $26d396936dd7aae9$var$arrayTag = "[object Array]", $26d396936dd7aae9$var$boolTag = "[object Boolean]", $26d396936dd7aae9$var$dateTag = "[object Date]", $26d396936dd7aae9$var$errorTag = "[object Error]", $26d396936dd7aae9$var$funcTag = "[object Function]", $26d396936dd7aae9$var$genTag = "[object GeneratorFunction]", $26d396936dd7aae9$var$mapTag = "[object Map]", $26d396936dd7aae9$var$numberTag = "[object Number]", $26d396936dd7aae9$var$objectTag = "[object Object]", $26d396936dd7aae9$var$regexpTag = "[object RegExp]", $26d396936dd7aae9$var$setTag = "[object Set]", $26d396936dd7aae9$var$stringTag = "[object String]", $26d396936dd7aae9$var$symbolTag = "[object Symbol]", $26d396936dd7aae9$var$weakMapTag = "[object WeakMap]";
var $26d396936dd7aae9$var$arrayBufferTag = "[object ArrayBuffer]", $26d396936dd7aae9$var$dataViewTag = "[object DataView]", $26d396936dd7aae9$var$float32Tag = "[object Float32Array]", $26d396936dd7aae9$var$float64Tag = "[object Float64Array]", $26d396936dd7aae9$var$int8Tag = "[object Int8Array]", $26d396936dd7aae9$var$int16Tag = "[object Int16Array]", $26d396936dd7aae9$var$int32Tag = "[object Int32Array]", $26d396936dd7aae9$var$uint8Tag = "[object Uint8Array]", $26d396936dd7aae9$var$uint8ClampedTag = "[object Uint8ClampedArray]", $26d396936dd7aae9$var$uint16Tag = "[object Uint16Array]", $26d396936dd7aae9$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $26d396936dd7aae9$var$cloneableTags = {};
$26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$argsTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$arrayTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$arrayBufferTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$dataViewTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$boolTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$dateTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$float32Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$float64Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$int8Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$int16Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$int32Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$mapTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$numberTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$objectTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$regexpTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$setTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$stringTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$symbolTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint8Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint8ClampedTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint16Tag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$uint32Tag] = true;
$26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$errorTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$funcTag] = $26d396936dd7aae9$var$cloneableTags[$26d396936dd7aae9$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $26d396936dd7aae9$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $26d396936dd7aae9$var$CLONE_DEEP_FLAG, isFlat = bitmask & $26d396936dd7aae9$var$CLONE_FLAT_FLAG, isFull = bitmask & $26d396936dd7aae9$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $1i0Jy.default)(value)) return value;
    var isArr = (0, $21thZ.default)(value);
    if (isArr) {
        result = (0, $1VLyO.default)(value);
        if (!isDeep) return (0, $axhnQ.default)(value, result);
    } else {
        var tag = (0, $1if5w.default)(value), isFunc = tag == $26d396936dd7aae9$var$funcTag || tag == $26d396936dd7aae9$var$genTag;
        if ((0, $9VzRR.default)(value)) return (0, $eWRTU.default)(value, isDeep);
        if (tag == $26d396936dd7aae9$var$objectTag || tag == $26d396936dd7aae9$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $cFFwt.default)(value);
            if (!isDeep) return isFlat ? (0, $94uxN.default)(value, (0, $kdWVV.default)(result, value)) : (0, $QlRlC.default)(value, (0, $bkn5s.default)(result, value));
        } else {
            if (!$26d396936dd7aae9$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $5JrOR.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $4lrQq.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $c6ppW.default)(value)) value.forEach(function(subValue) {
        result.add($26d396936dd7aae9$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $jgOzT.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $26d396936dd7aae9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $boZAC.default) : (0, $kjGCi.default) : isFlat ? (0, $kKvqE.default) : (0, $5Hbw4.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $e2HqO.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $63H9W.default)(result, key, $26d396936dd7aae9$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $26d396936dd7aae9$export$2e2bcd8739ae039 = $26d396936dd7aae9$var$baseClone;

});
parcelRequire.register("4lrQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329eb8ed43809560$export$2e2bcd8739ae039; });

var $lizsJ = parcelRequire("lizsJ");

var $01rnI = parcelRequire("01rnI");

var $a7ip8 = parcelRequire("a7ip8");

var $cteQy = parcelRequire("cteQy");

var $coII5 = parcelRequire("coII5");

var $1oC4I = parcelRequire("1oC4I");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $329eb8ed43809560$var$Stack(entries) {
    var data = this.__data__ = new (0, $lizsJ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$329eb8ed43809560$var$Stack.prototype.clear = (0, $01rnI.default);
$329eb8ed43809560$var$Stack.prototype["delete"] = (0, $a7ip8.default);
$329eb8ed43809560$var$Stack.prototype.get = (0, $cteQy.default);
$329eb8ed43809560$var$Stack.prototype.has = (0, $coII5.default);
$329eb8ed43809560$var$Stack.prototype.set = (0, $1oC4I.default);
var $329eb8ed43809560$export$2e2bcd8739ae039 = $329eb8ed43809560$var$Stack;

});
parcelRequire.register("lizsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f816c97fdc0dadbf$export$2e2bcd8739ae039; });

var $izEq5 = parcelRequire("izEq5");

var $3GHv2 = parcelRequire("3GHv2");

var $gUBS1 = parcelRequire("gUBS1");

var $fz72Y = parcelRequire("fz72Y");

var $cxUY4 = parcelRequire("cxUY4");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f816c97fdc0dadbf$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f816c97fdc0dadbf$var$ListCache.prototype.clear = (0, $izEq5.default);
$f816c97fdc0dadbf$var$ListCache.prototype["delete"] = (0, $3GHv2.default);
$f816c97fdc0dadbf$var$ListCache.prototype.get = (0, $gUBS1.default);
$f816c97fdc0dadbf$var$ListCache.prototype.has = (0, $fz72Y.default);
$f816c97fdc0dadbf$var$ListCache.prototype.set = (0, $cxUY4.default);
var $f816c97fdc0dadbf$export$2e2bcd8739ae039 = $f816c97fdc0dadbf$var$ListCache;

});
parcelRequire.register("izEq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d85ad9618b6314ee$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d85ad9618b6314ee$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $d85ad9618b6314ee$export$2e2bcd8739ae039 = $d85ad9618b6314ee$var$listCacheClear;

});

parcelRequire.register("3GHv2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2af70975b2fe03d4$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/** Used for built-in method references. */ var $2af70975b2fe03d4$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $2af70975b2fe03d4$var$splice = $2af70975b2fe03d4$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2af70975b2fe03d4$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $lyoRX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $2af70975b2fe03d4$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $2af70975b2fe03d4$export$2e2bcd8739ae039 = $2af70975b2fe03d4$var$listCacheDelete;

});
parcelRequire.register("lyoRX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb101074f47c2985$export$2e2bcd8739ae039; });

var $8rNNR = parcelRequire("8rNNR");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $fb101074f47c2985$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $8rNNR.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $fb101074f47c2985$export$2e2bcd8739ae039 = $fb101074f47c2985$var$assocIndexOf;

});
parcelRequire.register("8rNNR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62677a336a9cd77c$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $62677a336a9cd77c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $62677a336a9cd77c$export$2e2bcd8739ae039 = $62677a336a9cd77c$var$eq;

});



parcelRequire.register("gUBS1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ff4092158a4a3a$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c4ff4092158a4a3a$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $lyoRX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $c4ff4092158a4a3a$export$2e2bcd8739ae039 = $c4ff4092158a4a3a$var$listCacheGet;

});

parcelRequire.register("fz72Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b54f97418d5bd4aa$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b54f97418d5bd4aa$var$listCacheHas(key) {
    return (0, $lyoRX.default)(this.__data__, key) > -1;
}
var $b54f97418d5bd4aa$export$2e2bcd8739ae039 = $b54f97418d5bd4aa$var$listCacheHas;

});

parcelRequire.register("cxUY4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9224c1c0e6c7b89e$export$2e2bcd8739ae039; });

var $lyoRX = parcelRequire("lyoRX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $9224c1c0e6c7b89e$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $lyoRX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $9224c1c0e6c7b89e$export$2e2bcd8739ae039 = $9224c1c0e6c7b89e$var$listCacheSet;

});


parcelRequire.register("01rnI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0045557d5d97eb5b$export$2e2bcd8739ae039; });

var $lizsJ = parcelRequire("lizsJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0045557d5d97eb5b$var$stackClear() {
    this.__data__ = new (0, $lizsJ.default);
    this.size = 0;
}
var $0045557d5d97eb5b$export$2e2bcd8739ae039 = $0045557d5d97eb5b$var$stackClear;

});

parcelRequire.register("a7ip8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75d8d5907d975735$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $75d8d5907d975735$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $75d8d5907d975735$export$2e2bcd8739ae039 = $75d8d5907d975735$var$stackDelete;

});

parcelRequire.register("cteQy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9143b5b6048cd4b0$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9143b5b6048cd4b0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $9143b5b6048cd4b0$export$2e2bcd8739ae039 = $9143b5b6048cd4b0$var$stackGet;

});

parcelRequire.register("coII5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $906a686a69714ba8$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $906a686a69714ba8$var$stackHas(key) {
    return this.__data__.has(key);
}
var $906a686a69714ba8$export$2e2bcd8739ae039 = $906a686a69714ba8$var$stackHas;

});

parcelRequire.register("1oC4I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $104591422169f56c$export$2e2bcd8739ae039; });

var $lizsJ = parcelRequire("lizsJ");

var $bYE5r = parcelRequire("bYE5r");

var $5fToR = parcelRequire("5fToR");
/** Used as the size to enable large array optimizations. */ var $104591422169f56c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $104591422169f56c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $lizsJ.default)) {
        var pairs = data.__data__;
        if (!(0, $bYE5r.default) || pairs.length < $104591422169f56c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5fToR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $104591422169f56c$export$2e2bcd8739ae039 = $104591422169f56c$var$stackSet;

});
parcelRequire.register("bYE5r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b8464aec82723f3$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $8b8464aec82723f3$var$Map = (0, $4sTIN.default)((0, $lQuKh.default), "Map");
var $8b8464aec82723f3$export$2e2bcd8739ae039 = $8b8464aec82723f3$var$Map;

});
parcelRequire.register("4sTIN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $340500181cf2f6f1$export$2e2bcd8739ae039; });

var $j51oq = parcelRequire("j51oq");

var $k1l8b = parcelRequire("k1l8b");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $340500181cf2f6f1$var$getNative(object, key) {
    var value = (0, $k1l8b.default)(object, key);
    return (0, $j51oq.default)(value) ? value : undefined;
}
var $340500181cf2f6f1$export$2e2bcd8739ae039 = $340500181cf2f6f1$var$getNative;

});
parcelRequire.register("j51oq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de3f908d22f72c13$export$2e2bcd8739ae039; });

var $7A1Sy = parcelRequire("7A1Sy");

var $jpzrG = parcelRequire("jpzrG");

var $1i0Jy = parcelRequire("1i0Jy");

var $e6A8i = parcelRequire("e6A8i");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $de3f908d22f72c13$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $de3f908d22f72c13$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $de3f908d22f72c13$var$funcProto = Function.prototype, $de3f908d22f72c13$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $de3f908d22f72c13$var$funcToString = $de3f908d22f72c13$var$funcProto.toString;
/** Used to check objects for own properties. */ var $de3f908d22f72c13$var$hasOwnProperty = $de3f908d22f72c13$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $de3f908d22f72c13$var$reIsNative = RegExp("^" + $de3f908d22f72c13$var$funcToString.call($de3f908d22f72c13$var$hasOwnProperty).replace($de3f908d22f72c13$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $de3f908d22f72c13$var$baseIsNative(value) {
    if (!(0, $1i0Jy.default)(value) || (0, $jpzrG.default)(value)) return false;
    var pattern = (0, $7A1Sy.default)(value) ? $de3f908d22f72c13$var$reIsNative : $de3f908d22f72c13$var$reIsHostCtor;
    return pattern.test((0, $e6A8i.default)(value));
}
var $de3f908d22f72c13$export$2e2bcd8739ae039 = $de3f908d22f72c13$var$baseIsNative;

});
parcelRequire.register("7A1Sy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $584d5a4a611d056a$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $1i0Jy = parcelRequire("1i0Jy");
/** `Object#toString` result references. */ var $584d5a4a611d056a$var$asyncTag = "[object AsyncFunction]", $584d5a4a611d056a$var$funcTag = "[object Function]", $584d5a4a611d056a$var$genTag = "[object GeneratorFunction]", $584d5a4a611d056a$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $584d5a4a611d056a$var$isFunction(value) {
    if (!(0, $1i0Jy.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $cy2CN.default)(value);
    return tag == $584d5a4a611d056a$var$funcTag || tag == $584d5a4a611d056a$var$genTag || tag == $584d5a4a611d056a$var$asyncTag || tag == $584d5a4a611d056a$var$proxyTag;
}
var $584d5a4a611d056a$export$2e2bcd8739ae039 = $584d5a4a611d056a$var$isFunction;

});
parcelRequire.register("1i0Jy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f080a9b60d5ea3a$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0f080a9b60d5ea3a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $0f080a9b60d5ea3a$export$2e2bcd8739ae039 = $0f080a9b60d5ea3a$var$isObject;

});


parcelRequire.register("jpzrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e21bd8d98d624893$export$2e2bcd8739ae039; });

var $tHLfN = parcelRequire("tHLfN");
/** Used to detect methods masquerading as native. */ var $e21bd8d98d624893$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $tHLfN.default) && (0, $tHLfN.default).keys && (0, $tHLfN.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e21bd8d98d624893$var$isMasked(func) {
    return !!$e21bd8d98d624893$var$maskSrcKey && $e21bd8d98d624893$var$maskSrcKey in func;
}
var $e21bd8d98d624893$export$2e2bcd8739ae039 = $e21bd8d98d624893$var$isMasked;

});
parcelRequire.register("tHLfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0594a79a4b211c30$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Used to detect overreaching core-js shims. */ var $0594a79a4b211c30$var$coreJsData = (0, $lQuKh.default)["__core-js_shared__"];
var $0594a79a4b211c30$export$2e2bcd8739ae039 = $0594a79a4b211c30$var$coreJsData;

});


parcelRequire.register("e6A8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44da776de597c7a$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $a44da776de597c7a$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $a44da776de597c7a$var$funcToString = $a44da776de597c7a$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $a44da776de597c7a$var$toSource(func) {
    if (func != null) {
        try {
            return $a44da776de597c7a$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $a44da776de597c7a$export$2e2bcd8739ae039 = $a44da776de597c7a$var$toSource;

});


parcelRequire.register("k1l8b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9344acc6d14c1ad$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e9344acc6d14c1ad$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $e9344acc6d14c1ad$export$2e2bcd8739ae039 = $e9344acc6d14c1ad$var$getValue;

});



parcelRequire.register("5fToR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d3953c0fbb00239$export$2e2bcd8739ae039; });

var $5WmXr = parcelRequire("5WmXr");

var $4SNgz = parcelRequire("4SNgz");

var $ahaWr = parcelRequire("ahaWr");

var $aEyWN = parcelRequire("aEyWN");

var $8IZ52 = parcelRequire("8IZ52");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d3953c0fbb00239$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3d3953c0fbb00239$var$MapCache.prototype.clear = (0, $5WmXr.default);
$3d3953c0fbb00239$var$MapCache.prototype["delete"] = (0, $4SNgz.default);
$3d3953c0fbb00239$var$MapCache.prototype.get = (0, $ahaWr.default);
$3d3953c0fbb00239$var$MapCache.prototype.has = (0, $aEyWN.default);
$3d3953c0fbb00239$var$MapCache.prototype.set = (0, $8IZ52.default);
var $3d3953c0fbb00239$export$2e2bcd8739ae039 = $3d3953c0fbb00239$var$MapCache;

});
parcelRequire.register("5WmXr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45342d6f20752fbb$export$2e2bcd8739ae039; });

var $dDo32 = parcelRequire("dDo32");

var $lizsJ = parcelRequire("lizsJ");

var $bYE5r = parcelRequire("bYE5r");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $45342d6f20752fbb$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $dDo32.default),
        "map": new ((0, $bYE5r.default) || (0, $lizsJ.default)),
        "string": new (0, $dDo32.default)
    };
}
var $45342d6f20752fbb$export$2e2bcd8739ae039 = $45342d6f20752fbb$var$mapCacheClear;

});
parcelRequire.register("dDo32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ed1924d94124fa1$export$2e2bcd8739ae039; });

var $3opPB = parcelRequire("3opPB");

var $3I1q4 = parcelRequire("3I1q4");

var $hRJag = parcelRequire("hRJag");

var $4odqQ = parcelRequire("4odqQ");

var $Zsusm = parcelRequire("Zsusm");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9ed1924d94124fa1$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9ed1924d94124fa1$var$Hash.prototype.clear = (0, $3opPB.default);
$9ed1924d94124fa1$var$Hash.prototype["delete"] = (0, $3I1q4.default);
$9ed1924d94124fa1$var$Hash.prototype.get = (0, $hRJag.default);
$9ed1924d94124fa1$var$Hash.prototype.has = (0, $4odqQ.default);
$9ed1924d94124fa1$var$Hash.prototype.set = (0, $Zsusm.default);
var $9ed1924d94124fa1$export$2e2bcd8739ae039 = $9ed1924d94124fa1$var$Hash;

});
parcelRequire.register("3opPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2787a690a3f7b66b$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $2787a690a3f7b66b$var$hashClear() {
    this.__data__ = (0, $lsHgg.default) ? (0, $lsHgg.default)(null) : {};
    this.size = 0;
}
var $2787a690a3f7b66b$export$2e2bcd8739ae039 = $2787a690a3f7b66b$var$hashClear;

});
parcelRequire.register("lsHgg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9fdc54930057611$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");
/* Built-in method references that are verified to be native. */ var $f9fdc54930057611$var$nativeCreate = (0, $4sTIN.default)(Object, "create");
var $f9fdc54930057611$export$2e2bcd8739ae039 = $f9fdc54930057611$var$nativeCreate;

});


parcelRequire.register("3I1q4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b36951009b4c955$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2b36951009b4c955$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2b36951009b4c955$export$2e2bcd8739ae039 = $2b36951009b4c955$var$hashDelete;

});

parcelRequire.register("hRJag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d01a6ba3c47b6536$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/** Used to stand-in for `undefined` hash values. */ var $d01a6ba3c47b6536$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $d01a6ba3c47b6536$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d01a6ba3c47b6536$var$hasOwnProperty = $d01a6ba3c47b6536$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d01a6ba3c47b6536$var$hashGet(key) {
    var data = this.__data__;
    if (0, $lsHgg.default) {
        var result = data[key];
        return result === $d01a6ba3c47b6536$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d01a6ba3c47b6536$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $d01a6ba3c47b6536$export$2e2bcd8739ae039 = $d01a6ba3c47b6536$var$hashGet;

});

parcelRequire.register("4odqQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3323d2a00560ea07$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/** Used for built-in method references. */ var $3323d2a00560ea07$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3323d2a00560ea07$var$hasOwnProperty = $3323d2a00560ea07$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3323d2a00560ea07$var$hashHas(key) {
    var data = this.__data__;
    return (0, $lsHgg.default) ? data[key] !== undefined : $3323d2a00560ea07$var$hasOwnProperty.call(data, key);
}
var $3323d2a00560ea07$export$2e2bcd8739ae039 = $3323d2a00560ea07$var$hashHas;

});

parcelRequire.register("Zsusm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b8bcc2fac715fe4$export$2e2bcd8739ae039; });

var $lsHgg = parcelRequire("lsHgg");
/** Used to stand-in for `undefined` hash values. */ var $0b8bcc2fac715fe4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $0b8bcc2fac715fe4$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $lsHgg.default) && value === undefined ? $0b8bcc2fac715fe4$var$HASH_UNDEFINED : value;
    return this;
}
var $0b8bcc2fac715fe4$export$2e2bcd8739ae039 = $0b8bcc2fac715fe4$var$hashSet;

});



parcelRequire.register("4SNgz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e26bce601ec806$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $38e26bce601ec806$var$mapCacheDelete(key) {
    var result = (0, $cJjTF.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $38e26bce601ec806$export$2e2bcd8739ae039 = $38e26bce601ec806$var$mapCacheDelete;

});
parcelRequire.register("cJjTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94491f1df2e31ee9$export$2e2bcd8739ae039; });

var $bGJ4J = parcelRequire("bGJ4J");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $94491f1df2e31ee9$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $bGJ4J.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $94491f1df2e31ee9$export$2e2bcd8739ae039 = $94491f1df2e31ee9$var$getMapData;

});
parcelRequire.register("bGJ4J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $882694fcdc1bf07f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $882694fcdc1bf07f$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $882694fcdc1bf07f$export$2e2bcd8739ae039 = $882694fcdc1bf07f$var$isKeyable;

});



parcelRequire.register("ahaWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01ee41faaac1d9d4$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $01ee41faaac1d9d4$var$mapCacheGet(key) {
    return (0, $cJjTF.default)(this, key).get(key);
}
var $01ee41faaac1d9d4$export$2e2bcd8739ae039 = $01ee41faaac1d9d4$var$mapCacheGet;

});

parcelRequire.register("aEyWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c18bf9970ec6687$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7c18bf9970ec6687$var$mapCacheHas(key) {
    return (0, $cJjTF.default)(this, key).has(key);
}
var $7c18bf9970ec6687$export$2e2bcd8739ae039 = $7c18bf9970ec6687$var$mapCacheHas;

});

parcelRequire.register("8IZ52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65a1d010d8cc020c$export$2e2bcd8739ae039; });

var $cJjTF = parcelRequire("cJjTF");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $65a1d010d8cc020c$var$mapCacheSet(key, value) {
    var data = (0, $cJjTF.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $65a1d010d8cc020c$export$2e2bcd8739ae039 = $65a1d010d8cc020c$var$mapCacheSet;

});




parcelRequire.register("e2HqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a392f12cc24a8c1b$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a392f12cc24a8c1b$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $a392f12cc24a8c1b$export$2e2bcd8739ae039 = $a392f12cc24a8c1b$var$arrayEach;

});

parcelRequire.register("63H9W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4694806cb0ba57b2$export$2e2bcd8739ae039; });

var $9tesX = parcelRequire("9tesX");

var $8rNNR = parcelRequire("8rNNR");
/** Used for built-in method references. */ var $4694806cb0ba57b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4694806cb0ba57b2$var$hasOwnProperty = $4694806cb0ba57b2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $4694806cb0ba57b2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($4694806cb0ba57b2$var$hasOwnProperty.call(object, key) && (0, $8rNNR.default)(objValue, value)) || value === undefined && !(key in object)) (0, $9tesX.default)(object, key, value);
}
var $4694806cb0ba57b2$export$2e2bcd8739ae039 = $4694806cb0ba57b2$var$assignValue;

});
parcelRequire.register("9tesX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e520b264f53a5d8$export$2e2bcd8739ae039; });

var $aLJRA = parcelRequire("aLJRA");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $6e520b264f53a5d8$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $aLJRA.default)) (0, $aLJRA.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $6e520b264f53a5d8$export$2e2bcd8739ae039 = $6e520b264f53a5d8$var$baseAssignValue;

});
parcelRequire.register("aLJRA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d71dea847c6593c$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");
var $7d71dea847c6593c$var$defineProperty = function() {
    try {
        var func = (0, $4sTIN.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $7d71dea847c6593c$export$2e2bcd8739ae039 = $7d71dea847c6593c$var$defineProperty;

});



parcelRequire.register("bkn5s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f3789711a9d613$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $5Hbw4 = parcelRequire("5Hbw4");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $83f3789711a9d613$var$baseAssign(object, source) {
    return object && (0, $eV9Y6.default)(source, (0, $5Hbw4.default)(source), object);
}
var $83f3789711a9d613$export$2e2bcd8739ae039 = $83f3789711a9d613$var$baseAssign;

});
parcelRequire.register("eV9Y6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adce1f12e2c6ad03$export$2e2bcd8739ae039; });

var $63H9W = parcelRequire("63H9W");

var $9tesX = parcelRequire("9tesX");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $adce1f12e2c6ad03$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $9tesX.default)(object, key, newValue);
        else (0, $63H9W.default)(object, key, newValue);
    }
    return object;
}
var $adce1f12e2c6ad03$export$2e2bcd8739ae039 = $adce1f12e2c6ad03$var$copyObject;

});

parcelRequire.register("5Hbw4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4259e6c7f3fa1298$export$2e2bcd8739ae039; });

var $kde2o = parcelRequire("kde2o");

var $12xWQ = parcelRequire("12xWQ");

var $22VAg = parcelRequire("22VAg");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $4259e6c7f3fa1298$var$keys(object) {
    return (0, $22VAg.default)(object) ? (0, $kde2o.default)(object) : (0, $12xWQ.default)(object);
}
var $4259e6c7f3fa1298$export$2e2bcd8739ae039 = $4259e6c7f3fa1298$var$keys;

});
parcelRequire.register("kde2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb6fe91d4b74a437$export$2e2bcd8739ae039; });

var $a0aAr = parcelRequire("a0aAr");

var $hgDUC = parcelRequire("hgDUC");

var $21thZ = parcelRequire("21thZ");

var $9VzRR = parcelRequire("9VzRR");

var $5J62f = parcelRequire("5J62f");

var $dayQm = parcelRequire("dayQm");
/** Used for built-in method references. */ var $eb6fe91d4b74a437$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eb6fe91d4b74a437$var$hasOwnProperty = $eb6fe91d4b74a437$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $eb6fe91d4b74a437$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $21thZ.default)(value), isArg = !isArr && (0, $hgDUC.default)(value), isBuff = !isArr && !isArg && (0, $9VzRR.default)(value), isType = !isArr && !isArg && !isBuff && (0, $dayQm.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $a0aAr.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $eb6fe91d4b74a437$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $5J62f.default)(key, length)))) result.push(key);
    return result;
}
var $eb6fe91d4b74a437$export$2e2bcd8739ae039 = $eb6fe91d4b74a437$var$arrayLikeKeys;

});
parcelRequire.register("a0aAr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74821dcb2e8e1d08$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $74821dcb2e8e1d08$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $74821dcb2e8e1d08$export$2e2bcd8739ae039 = $74821dcb2e8e1d08$var$baseTimes;

});

parcelRequire.register("hgDUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c922e408c6d5687e$export$2e2bcd8739ae039; });

var $e81IW = parcelRequire("e81IW");

var $1KYPq = parcelRequire("1KYPq");
/** Used for built-in method references. */ var $c922e408c6d5687e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c922e408c6d5687e$var$hasOwnProperty = $c922e408c6d5687e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $c922e408c6d5687e$var$propertyIsEnumerable = $c922e408c6d5687e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $c922e408c6d5687e$var$isArguments = (0, $e81IW.default)(function() {
    return arguments;
}()) ? (0, $e81IW.default) : function(value) {
    return (0, $1KYPq.default)(value) && $c922e408c6d5687e$var$hasOwnProperty.call(value, "callee") && !$c922e408c6d5687e$var$propertyIsEnumerable.call(value, "callee");
};
var $c922e408c6d5687e$export$2e2bcd8739ae039 = $c922e408c6d5687e$var$isArguments;

});
parcelRequire.register("e81IW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4932660b886c172$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $a4932660b886c172$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $a4932660b886c172$var$baseIsArguments(value) {
    return (0, $1KYPq.default)(value) && (0, $cy2CN.default)(value) == $a4932660b886c172$var$argsTag;
}
var $a4932660b886c172$export$2e2bcd8739ae039 = $a4932660b886c172$var$baseIsArguments;

});


parcelRequire.register("21thZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $179264f9ce543aee$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $179264f9ce543aee$var$isArray = Array.isArray;
var $179264f9ce543aee$export$2e2bcd8739ae039 = $179264f9ce543aee$var$isArray;

});

parcelRequire.register("9VzRR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a5427e4a118ab7$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");

var $gS81E = parcelRequire("gS81E");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $lQuKh.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $gS81E.default);
var $73a5427e4a118ab7$export$2e2bcd8739ae039 = isBuffer;

});
parcelRequire.register("gS81E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c487ea32e66aaed6$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $c487ea32e66aaed6$var$stubFalse() {
    return false;
}
var $c487ea32e66aaed6$export$2e2bcd8739ae039 = $c487ea32e66aaed6$var$stubFalse;

});


parcelRequire.register("5J62f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42b5d6334d9a7bef$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $42b5d6334d9a7bef$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $42b5d6334d9a7bef$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $42b5d6334d9a7bef$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $42b5d6334d9a7bef$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $42b5d6334d9a7bef$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $42b5d6334d9a7bef$export$2e2bcd8739ae039 = $42b5d6334d9a7bef$var$isIndex;

});

parcelRequire.register("dayQm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99673cbd809f8ae2$export$2e2bcd8739ae039; });

var $fmFRo = parcelRequire("fmFRo");

var $5vqVN = parcelRequire("5vqVN");

var $9nRTT = parcelRequire("9nRTT");
/* Node.js helper references. */ var $99673cbd809f8ae2$var$nodeIsTypedArray = (0, $9nRTT.default) && (0, $9nRTT.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $99673cbd809f8ae2$var$isTypedArray = $99673cbd809f8ae2$var$nodeIsTypedArray ? (0, $5vqVN.default)($99673cbd809f8ae2$var$nodeIsTypedArray) : (0, $fmFRo.default);
var $99673cbd809f8ae2$export$2e2bcd8739ae039 = $99673cbd809f8ae2$var$isTypedArray;

});
parcelRequire.register("fmFRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f961a53998d846$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $WvlOx = parcelRequire("WvlOx");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $b2f961a53998d846$var$argsTag = "[object Arguments]", $b2f961a53998d846$var$arrayTag = "[object Array]", $b2f961a53998d846$var$boolTag = "[object Boolean]", $b2f961a53998d846$var$dateTag = "[object Date]", $b2f961a53998d846$var$errorTag = "[object Error]", $b2f961a53998d846$var$funcTag = "[object Function]", $b2f961a53998d846$var$mapTag = "[object Map]", $b2f961a53998d846$var$numberTag = "[object Number]", $b2f961a53998d846$var$objectTag = "[object Object]", $b2f961a53998d846$var$regexpTag = "[object RegExp]", $b2f961a53998d846$var$setTag = "[object Set]", $b2f961a53998d846$var$stringTag = "[object String]", $b2f961a53998d846$var$weakMapTag = "[object WeakMap]";
var $b2f961a53998d846$var$arrayBufferTag = "[object ArrayBuffer]", $b2f961a53998d846$var$dataViewTag = "[object DataView]", $b2f961a53998d846$var$float32Tag = "[object Float32Array]", $b2f961a53998d846$var$float64Tag = "[object Float64Array]", $b2f961a53998d846$var$int8Tag = "[object Int8Array]", $b2f961a53998d846$var$int16Tag = "[object Int16Array]", $b2f961a53998d846$var$int32Tag = "[object Int32Array]", $b2f961a53998d846$var$uint8Tag = "[object Uint8Array]", $b2f961a53998d846$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b2f961a53998d846$var$uint16Tag = "[object Uint16Array]", $b2f961a53998d846$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $b2f961a53998d846$var$typedArrayTags = {};
$b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$float32Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$float64Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$int8Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$int16Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$int32Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint8Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint8ClampedTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint16Tag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$uint32Tag] = true;
$b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$argsTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$arrayTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$arrayBufferTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$boolTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$dataViewTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$dateTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$errorTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$funcTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$mapTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$numberTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$objectTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$regexpTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$setTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$stringTag] = $b2f961a53998d846$var$typedArrayTags[$b2f961a53998d846$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $b2f961a53998d846$var$baseIsTypedArray(value) {
    return (0, $1KYPq.default)(value) && (0, $WvlOx.default)(value.length) && !!$b2f961a53998d846$var$typedArrayTags[(0, $cy2CN.default)(value)];
}
var $b2f961a53998d846$export$2e2bcd8739ae039 = $b2f961a53998d846$var$baseIsTypedArray;

});
parcelRequire.register("WvlOx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0afdbc84c9df65f0$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $0afdbc84c9df65f0$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0afdbc84c9df65f0$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $0afdbc84c9df65f0$var$MAX_SAFE_INTEGER;
}
var $0afdbc84c9df65f0$export$2e2bcd8739ae039 = $0afdbc84c9df65f0$var$isLength;

});


parcelRequire.register("5vqVN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4024bcf711d20cd7$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $4024bcf711d20cd7$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $4024bcf711d20cd7$export$2e2bcd8739ae039 = $4024bcf711d20cd7$var$baseUnary;

});

parcelRequire.register("9nRTT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01c35b234f7d6a31$export$2e2bcd8739ae039; });

var $ggtzD = parcelRequire("ggtzD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $ggtzD.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $01c35b234f7d6a31$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRequire.register("12xWQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c204fb9bba198f6$export$2e2bcd8739ae039; });

var $aWscJ = parcelRequire("aWscJ");

var $KMimB = parcelRequire("KMimB");
/** Used for built-in method references. */ var $0c204fb9bba198f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0c204fb9bba198f6$var$hasOwnProperty = $0c204fb9bba198f6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0c204fb9bba198f6$var$baseKeys(object) {
    if (!(0, $aWscJ.default)(object)) return (0, $KMimB.default)(object);
    var result = [];
    for(var key in Object(object))if ($0c204fb9bba198f6$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $0c204fb9bba198f6$export$2e2bcd8739ae039 = $0c204fb9bba198f6$var$baseKeys;

});
parcelRequire.register("aWscJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f7532f83b2b457d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7f7532f83b2b457d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $7f7532f83b2b457d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $7f7532f83b2b457d$var$objectProto;
    return value === proto;
}
var $7f7532f83b2b457d$export$2e2bcd8739ae039 = $7f7532f83b2b457d$var$isPrototype;

});

parcelRequire.register("KMimB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08c9c2692486085b$export$2e2bcd8739ae039; });

var $4qlTy = parcelRequire("4qlTy");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $08c9c2692486085b$var$nativeKeys = (0, $4qlTy.default)(Object.keys, Object);
var $08c9c2692486085b$export$2e2bcd8739ae039 = $08c9c2692486085b$var$nativeKeys;

});


parcelRequire.register("22VAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17d86fa7581565f0$export$2e2bcd8739ae039; });

var $7A1Sy = parcelRequire("7A1Sy");

var $WvlOx = parcelRequire("WvlOx");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $17d86fa7581565f0$var$isArrayLike(value) {
    return value != null && (0, $WvlOx.default)(value.length) && !(0, $7A1Sy.default)(value);
}
var $17d86fa7581565f0$export$2e2bcd8739ae039 = $17d86fa7581565f0$var$isArrayLike;

});



parcelRequire.register("kdWVV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb92bc726751f5ff$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $kKvqE = parcelRequire("kKvqE");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $eb92bc726751f5ff$var$baseAssignIn(object, source) {
    return object && (0, $eV9Y6.default)(source, (0, $kKvqE.default)(source), object);
}
var $eb92bc726751f5ff$export$2e2bcd8739ae039 = $eb92bc726751f5ff$var$baseAssignIn;

});
parcelRequire.register("kKvqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b07baa806f24aa$export$2e2bcd8739ae039; });

var $kde2o = parcelRequire("kde2o");

var $4jo4S = parcelRequire("4jo4S");

var $22VAg = parcelRequire("22VAg");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $f1b07baa806f24aa$var$keysIn(object) {
    return (0, $22VAg.default)(object) ? (0, $kde2o.default)(object, true) : (0, $4jo4S.default)(object);
}
var $f1b07baa806f24aa$export$2e2bcd8739ae039 = $f1b07baa806f24aa$var$keysIn;

});
parcelRequire.register("4jo4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $323b9d1774e2a53a$export$2e2bcd8739ae039; });

var $1i0Jy = parcelRequire("1i0Jy");

var $aWscJ = parcelRequire("aWscJ");

var $gPG8d = parcelRequire("gPG8d");
/** Used for built-in method references. */ var $323b9d1774e2a53a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $323b9d1774e2a53a$var$hasOwnProperty = $323b9d1774e2a53a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $323b9d1774e2a53a$var$baseKeysIn(object) {
    if (!(0, $1i0Jy.default)(object)) return (0, $gPG8d.default)(object);
    var isProto = (0, $aWscJ.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$323b9d1774e2a53a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $323b9d1774e2a53a$export$2e2bcd8739ae039 = $323b9d1774e2a53a$var$baseKeysIn;

});
parcelRequire.register("gPG8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4121738b9afa34f$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c4121738b9afa34f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $c4121738b9afa34f$export$2e2bcd8739ae039 = $c4121738b9afa34f$var$nativeKeysIn;

});




parcelRequire.register("eWRTU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae204b0fcd037a62$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $lQuKh.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $ae204b0fcd037a62$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRequire.register("axhnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aba7877210b4da7$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7aba7877210b4da7$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $7aba7877210b4da7$export$2e2bcd8739ae039 = $7aba7877210b4da7$var$copyArray;

});

parcelRequire.register("QlRlC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09d5d0461fd2f821$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $ertEb = parcelRequire("ertEb");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $09d5d0461fd2f821$var$copySymbols(source, object) {
    return (0, $eV9Y6.default)(source, (0, $ertEb.default)(source), object);
}
var $09d5d0461fd2f821$export$2e2bcd8739ae039 = $09d5d0461fd2f821$var$copySymbols;

});
parcelRequire.register("ertEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a83a9596b02d4cea$export$2e2bcd8739ae039; });

var $9W7yx = parcelRequire("9W7yx");

var $6QHKG = parcelRequire("6QHKG");
/** Used for built-in method references. */ var $a83a9596b02d4cea$var$objectProto = Object.prototype;
/** Built-in value references. */ var $a83a9596b02d4cea$var$propertyIsEnumerable = $a83a9596b02d4cea$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a83a9596b02d4cea$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a83a9596b02d4cea$var$getSymbols = !$a83a9596b02d4cea$var$nativeGetSymbols ? (0, $6QHKG.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $9W7yx.default)($a83a9596b02d4cea$var$nativeGetSymbols(object), function(symbol) {
        return $a83a9596b02d4cea$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $a83a9596b02d4cea$export$2e2bcd8739ae039 = $a83a9596b02d4cea$var$getSymbols;

});
parcelRequire.register("9W7yx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73bf644ceb877fe7$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $73bf644ceb877fe7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $73bf644ceb877fe7$export$2e2bcd8739ae039 = $73bf644ceb877fe7$var$arrayFilter;

});

parcelRequire.register("6QHKG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fc989a067b78028$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $4fc989a067b78028$var$stubArray() {
    return [];
}
var $4fc989a067b78028$export$2e2bcd8739ae039 = $4fc989a067b78028$var$stubArray;

});



parcelRequire.register("94uxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69ac2e392040bbd6$export$2e2bcd8739ae039; });

var $eV9Y6 = parcelRequire("eV9Y6");

var $a9Xh9 = parcelRequire("a9Xh9");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $69ac2e392040bbd6$var$copySymbolsIn(source, object) {
    return (0, $eV9Y6.default)(source, (0, $a9Xh9.default)(source), object);
}
var $69ac2e392040bbd6$export$2e2bcd8739ae039 = $69ac2e392040bbd6$var$copySymbolsIn;

});
parcelRequire.register("a9Xh9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7658b99138951991$export$2e2bcd8739ae039; });

var $hoU2e = parcelRequire("hoU2e");

var $4Quro = parcelRequire("4Quro");

var $ertEb = parcelRequire("ertEb");

var $6QHKG = parcelRequire("6QHKG");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7658b99138951991$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7658b99138951991$var$getSymbolsIn = !$7658b99138951991$var$nativeGetSymbols ? (0, $6QHKG.default) : function(object) {
    var result = [];
    while(object){
        (0, $hoU2e.default)(result, (0, $ertEb.default)(object));
        object = (0, $4Quro.default)(object);
    }
    return result;
};
var $7658b99138951991$export$2e2bcd8739ae039 = $7658b99138951991$var$getSymbolsIn;

});
parcelRequire.register("hoU2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cab024f002660c74$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cab024f002660c74$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $cab024f002660c74$export$2e2bcd8739ae039 = $cab024f002660c74$var$arrayPush;

});



parcelRequire.register("kjGCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca6a3c3cc1072ab$export$2e2bcd8739ae039; });

var $aWyrS = parcelRequire("aWyrS");

var $ertEb = parcelRequire("ertEb");

var $5Hbw4 = parcelRequire("5Hbw4");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $eca6a3c3cc1072ab$var$getAllKeys(object) {
    return (0, $aWyrS.default)(object, (0, $5Hbw4.default), (0, $ertEb.default));
}
var $eca6a3c3cc1072ab$export$2e2bcd8739ae039 = $eca6a3c3cc1072ab$var$getAllKeys;

});
parcelRequire.register("aWyrS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f7a0af3faa3ac35$export$2e2bcd8739ae039; });

var $hoU2e = parcelRequire("hoU2e");

var $21thZ = parcelRequire("21thZ");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7f7a0af3faa3ac35$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $21thZ.default)(object) ? result : (0, $hoU2e.default)(result, symbolsFunc(object));
}
var $7f7a0af3faa3ac35$export$2e2bcd8739ae039 = $7f7a0af3faa3ac35$var$baseGetAllKeys;

});


parcelRequire.register("boZAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84d1b60390f8fc47$export$2e2bcd8739ae039; });

var $aWyrS = parcelRequire("aWyrS");

var $a9Xh9 = parcelRequire("a9Xh9");

var $kKvqE = parcelRequire("kKvqE");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $84d1b60390f8fc47$var$getAllKeysIn(object) {
    return (0, $aWyrS.default)(object, (0, $kKvqE.default), (0, $a9Xh9.default));
}
var $84d1b60390f8fc47$export$2e2bcd8739ae039 = $84d1b60390f8fc47$var$getAllKeysIn;

});

parcelRequire.register("1if5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f132d13782e2bd7$export$2e2bcd8739ae039; });

var $5bQpt = parcelRequire("5bQpt");

var $bYE5r = parcelRequire("bYE5r");

var $6yTOP = parcelRequire("6yTOP");

var $3F07B = parcelRequire("3F07B");

var $jx2Eb = parcelRequire("jx2Eb");

var $cy2CN = parcelRequire("cy2CN");

var $e6A8i = parcelRequire("e6A8i");
/** `Object#toString` result references. */ var $0f132d13782e2bd7$var$mapTag = "[object Map]", $0f132d13782e2bd7$var$objectTag = "[object Object]", $0f132d13782e2bd7$var$promiseTag = "[object Promise]", $0f132d13782e2bd7$var$setTag = "[object Set]", $0f132d13782e2bd7$var$weakMapTag = "[object WeakMap]";
var $0f132d13782e2bd7$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $0f132d13782e2bd7$var$dataViewCtorString = (0, $e6A8i.default)((0, $5bQpt.default)), $0f132d13782e2bd7$var$mapCtorString = (0, $e6A8i.default)((0, $bYE5r.default)), $0f132d13782e2bd7$var$promiseCtorString = (0, $e6A8i.default)((0, $6yTOP.default)), $0f132d13782e2bd7$var$setCtorString = (0, $e6A8i.default)((0, $3F07B.default)), $0f132d13782e2bd7$var$weakMapCtorString = (0, $e6A8i.default)((0, $jx2Eb.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0f132d13782e2bd7$var$getTag = (0, $cy2CN.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $5bQpt.default) && $0f132d13782e2bd7$var$getTag(new (0, $5bQpt.default)(new ArrayBuffer(1))) != $0f132d13782e2bd7$var$dataViewTag || (0, $bYE5r.default) && $0f132d13782e2bd7$var$getTag(new (0, $bYE5r.default)) != $0f132d13782e2bd7$var$mapTag || (0, $6yTOP.default) && $0f132d13782e2bd7$var$getTag((0, $6yTOP.default).resolve()) != $0f132d13782e2bd7$var$promiseTag || (0, $3F07B.default) && $0f132d13782e2bd7$var$getTag(new (0, $3F07B.default)) != $0f132d13782e2bd7$var$setTag || (0, $jx2Eb.default) && $0f132d13782e2bd7$var$getTag(new (0, $jx2Eb.default)) != $0f132d13782e2bd7$var$weakMapTag) $0f132d13782e2bd7$var$getTag = function(value) {
    var result = (0, $cy2CN.default)(value), Ctor = result == $0f132d13782e2bd7$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $e6A8i.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $0f132d13782e2bd7$var$dataViewCtorString:
            return $0f132d13782e2bd7$var$dataViewTag;
        case $0f132d13782e2bd7$var$mapCtorString:
            return $0f132d13782e2bd7$var$mapTag;
        case $0f132d13782e2bd7$var$promiseCtorString:
            return $0f132d13782e2bd7$var$promiseTag;
        case $0f132d13782e2bd7$var$setCtorString:
            return $0f132d13782e2bd7$var$setTag;
        case $0f132d13782e2bd7$var$weakMapCtorString:
            return $0f132d13782e2bd7$var$weakMapTag;
    }
    return result;
};
var $0f132d13782e2bd7$export$2e2bcd8739ae039 = $0f132d13782e2bd7$var$getTag;

});
parcelRequire.register("5bQpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c76a2572c0f23d7$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $3c76a2572c0f23d7$var$DataView = (0, $4sTIN.default)((0, $lQuKh.default), "DataView");
var $3c76a2572c0f23d7$export$2e2bcd8739ae039 = $3c76a2572c0f23d7$var$DataView;

});

parcelRequire.register("6yTOP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c71378715b84423$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $4c71378715b84423$var$Promise = (0, $4sTIN.default)((0, $lQuKh.default), "Promise");
var $4c71378715b84423$export$2e2bcd8739ae039 = $4c71378715b84423$var$Promise;

});

parcelRequire.register("3F07B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aa54b957a373224$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $2aa54b957a373224$var$Set = (0, $4sTIN.default)((0, $lQuKh.default), "Set");
var $2aa54b957a373224$export$2e2bcd8739ae039 = $2aa54b957a373224$var$Set;

});

parcelRequire.register("jx2Eb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e383270dab653f5b$export$2e2bcd8739ae039; });

var $4sTIN = parcelRequire("4sTIN");

var $lQuKh = parcelRequire("lQuKh");
/* Built-in method references that are verified to be native. */ var $e383270dab653f5b$var$WeakMap = (0, $4sTIN.default)((0, $lQuKh.default), "WeakMap");
var $e383270dab653f5b$export$2e2bcd8739ae039 = $e383270dab653f5b$var$WeakMap;

});


parcelRequire.register("1VLyO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $168001db92f1aea0$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $168001db92f1aea0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $168001db92f1aea0$var$hasOwnProperty = $168001db92f1aea0$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $168001db92f1aea0$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $168001db92f1aea0$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $168001db92f1aea0$export$2e2bcd8739ae039 = $168001db92f1aea0$var$initCloneArray;

});

parcelRequire.register("5JrOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c6bc11fc33d96c$export$2e2bcd8739ae039; });

var $8e2Q0 = parcelRequire("8e2Q0");

var $ci3fc = parcelRequire("ci3fc");

var $8KQwf = parcelRequire("8KQwf");

var $eMHiy = parcelRequire("eMHiy");

var $gFp2c = parcelRequire("gFp2c");
/** `Object#toString` result references. */ var $42c6bc11fc33d96c$var$boolTag = "[object Boolean]", $42c6bc11fc33d96c$var$dateTag = "[object Date]", $42c6bc11fc33d96c$var$mapTag = "[object Map]", $42c6bc11fc33d96c$var$numberTag = "[object Number]", $42c6bc11fc33d96c$var$regexpTag = "[object RegExp]", $42c6bc11fc33d96c$var$setTag = "[object Set]", $42c6bc11fc33d96c$var$stringTag = "[object String]", $42c6bc11fc33d96c$var$symbolTag = "[object Symbol]";
var $42c6bc11fc33d96c$var$arrayBufferTag = "[object ArrayBuffer]", $42c6bc11fc33d96c$var$dataViewTag = "[object DataView]", $42c6bc11fc33d96c$var$float32Tag = "[object Float32Array]", $42c6bc11fc33d96c$var$float64Tag = "[object Float64Array]", $42c6bc11fc33d96c$var$int8Tag = "[object Int8Array]", $42c6bc11fc33d96c$var$int16Tag = "[object Int16Array]", $42c6bc11fc33d96c$var$int32Tag = "[object Int32Array]", $42c6bc11fc33d96c$var$uint8Tag = "[object Uint8Array]", $42c6bc11fc33d96c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $42c6bc11fc33d96c$var$uint16Tag = "[object Uint16Array]", $42c6bc11fc33d96c$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $42c6bc11fc33d96c$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $42c6bc11fc33d96c$var$arrayBufferTag:
            return (0, $8e2Q0.default)(object);
        case $42c6bc11fc33d96c$var$boolTag:
        case $42c6bc11fc33d96c$var$dateTag:
            return new Ctor(+object);
        case $42c6bc11fc33d96c$var$dataViewTag:
            return (0, $ci3fc.default)(object, isDeep);
        case $42c6bc11fc33d96c$var$float32Tag:
        case $42c6bc11fc33d96c$var$float64Tag:
        case $42c6bc11fc33d96c$var$int8Tag:
        case $42c6bc11fc33d96c$var$int16Tag:
        case $42c6bc11fc33d96c$var$int32Tag:
        case $42c6bc11fc33d96c$var$uint8Tag:
        case $42c6bc11fc33d96c$var$uint8ClampedTag:
        case $42c6bc11fc33d96c$var$uint16Tag:
        case $42c6bc11fc33d96c$var$uint32Tag:
            return (0, $gFp2c.default)(object, isDeep);
        case $42c6bc11fc33d96c$var$mapTag:
            return new Ctor;
        case $42c6bc11fc33d96c$var$numberTag:
        case $42c6bc11fc33d96c$var$stringTag:
            return new Ctor(object);
        case $42c6bc11fc33d96c$var$regexpTag:
            return (0, $8KQwf.default)(object);
        case $42c6bc11fc33d96c$var$setTag:
            return new Ctor;
        case $42c6bc11fc33d96c$var$symbolTag:
            return (0, $eMHiy.default)(object);
    }
}
var $42c6bc11fc33d96c$export$2e2bcd8739ae039 = $42c6bc11fc33d96c$var$initCloneByTag;

});
parcelRequire.register("8e2Q0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd1d50b63be2ebc$export$2e2bcd8739ae039; });

var $4jys5 = parcelRequire("4jys5");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $5fd1d50b63be2ebc$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $4jys5.default)(result).set(new (0, $4jys5.default)(arrayBuffer));
    return result;
}
var $5fd1d50b63be2ebc$export$2e2bcd8739ae039 = $5fd1d50b63be2ebc$var$cloneArrayBuffer;

});
parcelRequire.register("4jys5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3243a934d462e803$export$2e2bcd8739ae039; });

var $lQuKh = parcelRequire("lQuKh");
/** Built-in value references. */ var $3243a934d462e803$var$Uint8Array = (0, $lQuKh.default).Uint8Array;
var $3243a934d462e803$export$2e2bcd8739ae039 = $3243a934d462e803$var$Uint8Array;

});


parcelRequire.register("ci3fc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f29aeb55987107c$export$2e2bcd8739ae039; });

var $8e2Q0 = parcelRequire("8e2Q0");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $8f29aeb55987107c$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $8e2Q0.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $8f29aeb55987107c$export$2e2bcd8739ae039 = $8f29aeb55987107c$var$cloneDataView;

});

parcelRequire.register("8KQwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65fb5bd4f46ae094$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $65fb5bd4f46ae094$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $65fb5bd4f46ae094$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $65fb5bd4f46ae094$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $65fb5bd4f46ae094$export$2e2bcd8739ae039 = $65fb5bd4f46ae094$var$cloneRegExp;

});

parcelRequire.register("eMHiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac37228034dd7306$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");
/** Used to convert symbols to primitives and strings. */ var $ac37228034dd7306$var$symbolProto = (0, $aojMU.default) ? (0, $aojMU.default).prototype : undefined, $ac37228034dd7306$var$symbolValueOf = $ac37228034dd7306$var$symbolProto ? $ac37228034dd7306$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $ac37228034dd7306$var$cloneSymbol(symbol) {
    return $ac37228034dd7306$var$symbolValueOf ? Object($ac37228034dd7306$var$symbolValueOf.call(symbol)) : {};
}
var $ac37228034dd7306$export$2e2bcd8739ae039 = $ac37228034dd7306$var$cloneSymbol;

});

parcelRequire.register("gFp2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c223e5036c1d56c3$export$2e2bcd8739ae039; });

var $8e2Q0 = parcelRequire("8e2Q0");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $c223e5036c1d56c3$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $8e2Q0.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $c223e5036c1d56c3$export$2e2bcd8739ae039 = $c223e5036c1d56c3$var$cloneTypedArray;

});


parcelRequire.register("cFFwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939985e73ed3ed8e$export$2e2bcd8739ae039; });

var $ewghx = parcelRequire("ewghx");

var $4Quro = parcelRequire("4Quro");

var $aWscJ = parcelRequire("aWscJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $939985e73ed3ed8e$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $aWscJ.default)(object) ? (0, $ewghx.default)((0, $4Quro.default)(object)) : {};
}
var $939985e73ed3ed8e$export$2e2bcd8739ae039 = $939985e73ed3ed8e$var$initCloneObject;

});
parcelRequire.register("ewghx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a920af115c4db8d5$export$2e2bcd8739ae039; });

var $1i0Jy = parcelRequire("1i0Jy");
/** Built-in value references. */ var $a920af115c4db8d5$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a920af115c4db8d5$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $1i0Jy.default)(proto)) return {};
        if ($a920af115c4db8d5$var$objectCreate) return $a920af115c4db8d5$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $a920af115c4db8d5$export$2e2bcd8739ae039 = $a920af115c4db8d5$var$baseCreate;

});


parcelRequire.register("jgOzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e076bea9d687c597$export$2e2bcd8739ae039; });

var $5wiMM = parcelRequire("5wiMM");

var $5vqVN = parcelRequire("5vqVN");

var $9nRTT = parcelRequire("9nRTT");
/* Node.js helper references. */ var $e076bea9d687c597$var$nodeIsMap = (0, $9nRTT.default) && (0, $9nRTT.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e076bea9d687c597$var$isMap = $e076bea9d687c597$var$nodeIsMap ? (0, $5vqVN.default)($e076bea9d687c597$var$nodeIsMap) : (0, $5wiMM.default);
var $e076bea9d687c597$export$2e2bcd8739ae039 = $e076bea9d687c597$var$isMap;

});
parcelRequire.register("5wiMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $404e8359b4044d6f$export$2e2bcd8739ae039; });

var $1if5w = parcelRequire("1if5w");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $404e8359b4044d6f$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $404e8359b4044d6f$var$baseIsMap(value) {
    return (0, $1KYPq.default)(value) && (0, $1if5w.default)(value) == $404e8359b4044d6f$var$mapTag;
}
var $404e8359b4044d6f$export$2e2bcd8739ae039 = $404e8359b4044d6f$var$baseIsMap;

});


parcelRequire.register("c6ppW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cf9c2ee70d3c1fc$export$2e2bcd8739ae039; });

var $k7W4N = parcelRequire("k7W4N");

var $5vqVN = parcelRequire("5vqVN");

var $9nRTT = parcelRequire("9nRTT");
/* Node.js helper references. */ var $8cf9c2ee70d3c1fc$var$nodeIsSet = (0, $9nRTT.default) && (0, $9nRTT.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $8cf9c2ee70d3c1fc$var$isSet = $8cf9c2ee70d3c1fc$var$nodeIsSet ? (0, $5vqVN.default)($8cf9c2ee70d3c1fc$var$nodeIsSet) : (0, $k7W4N.default);
var $8cf9c2ee70d3c1fc$export$2e2bcd8739ae039 = $8cf9c2ee70d3c1fc$var$isSet;

});
parcelRequire.register("k7W4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea7182d8a356a8ca$export$2e2bcd8739ae039; });

var $1if5w = parcelRequire("1if5w");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $ea7182d8a356a8ca$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $ea7182d8a356a8ca$var$baseIsSet(value) {
    return (0, $1KYPq.default)(value) && (0, $1if5w.default)(value) == $ea7182d8a356a8ca$var$setTag;
}
var $ea7182d8a356a8ca$export$2e2bcd8739ae039 = $ea7182d8a356a8ca$var$baseIsSet;

});




parcelRequire.register("5yFbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40c013bde851d67f$export$2e2bcd8739ae039; });

var $69ERV = parcelRequire("69ERV");

var $axhnQ = parcelRequire("axhnQ");

var $21thZ = parcelRequire("21thZ");

var $bOFLd = parcelRequire("bOFLd");

var $f9EQJ = parcelRequire("f9EQJ");

var $5K1Jf = parcelRequire("5K1Jf");

var $6qWbV = parcelRequire("6qWbV");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $40c013bde851d67f$var$toPath(value) {
    if ((0, $21thZ.default)(value)) return (0, $69ERV.default)(value, (0, $5K1Jf.default));
    return (0, $bOFLd.default)(value) ? [
        value
    ] : (0, $axhnQ.default)((0, $f9EQJ.default)((0, $6qWbV.default)(value)));
}
var $40c013bde851d67f$export$2e2bcd8739ae039 = $40c013bde851d67f$var$toPath;

});
parcelRequire.register("69ERV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47b34906cca9b943$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $47b34906cca9b943$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $47b34906cca9b943$export$2e2bcd8739ae039 = $47b34906cca9b943$var$arrayMap;

});

parcelRequire.register("bOFLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89a4c1ff51648a4e$export$2e2bcd8739ae039; });

var $cy2CN = parcelRequire("cy2CN");

var $1KYPq = parcelRequire("1KYPq");
/** `Object#toString` result references. */ var $89a4c1ff51648a4e$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $89a4c1ff51648a4e$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $1KYPq.default)(value) && (0, $cy2CN.default)(value) == $89a4c1ff51648a4e$var$symbolTag;
}
var $89a4c1ff51648a4e$export$2e2bcd8739ae039 = $89a4c1ff51648a4e$var$isSymbol;

});

parcelRequire.register("f9EQJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02d8e4ade81a7510$export$2e2bcd8739ae039; });

var $6ZrRy = parcelRequire("6ZrRy");
/** Used to match property names within property paths. */ var $02d8e4ade81a7510$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $02d8e4ade81a7510$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $02d8e4ade81a7510$var$stringToPath = (0, $6ZrRy.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($02d8e4ade81a7510$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($02d8e4ade81a7510$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $02d8e4ade81a7510$export$2e2bcd8739ae039 = $02d8e4ade81a7510$var$stringToPath;

});
parcelRequire.register("6ZrRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $516e0d8dc866f6a9$export$2e2bcd8739ae039; });

var $hahxe = parcelRequire("hahxe");
/** Used as the maximum memoize cache size. */ var $516e0d8dc866f6a9$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $516e0d8dc866f6a9$var$memoizeCapped(func) {
    var result = (0, $hahxe.default)(func, function(key) {
        if (cache.size === $516e0d8dc866f6a9$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $516e0d8dc866f6a9$export$2e2bcd8739ae039 = $516e0d8dc866f6a9$var$memoizeCapped;

});
parcelRequire.register("hahxe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7f0f8eefb3fb63a$export$2e2bcd8739ae039; });

var $5fToR = parcelRequire("5fToR");
/** Error message constants. */ var $c7f0f8eefb3fb63a$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c7f0f8eefb3fb63a$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($c7f0f8eefb3fb63a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c7f0f8eefb3fb63a$var$memoize.Cache || (0, $5fToR.default));
    return memoized;
}
// Expose `MapCache`.
$c7f0f8eefb3fb63a$var$memoize.Cache = (0, $5fToR.default);
var $c7f0f8eefb3fb63a$export$2e2bcd8739ae039 = $c7f0f8eefb3fb63a$var$memoize;

});



parcelRequire.register("5K1Jf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42e296ef19650489$export$2e2bcd8739ae039; });

var $bOFLd = parcelRequire("bOFLd");
/** Used as references for various `Number` constants. */ var $42e296ef19650489$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $42e296ef19650489$var$toKey(value) {
    if (typeof value == "string" || (0, $bOFLd.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$42e296ef19650489$var$INFINITY ? "-0" : result;
}
var $42e296ef19650489$export$2e2bcd8739ae039 = $42e296ef19650489$var$toKey;

});

parcelRequire.register("6qWbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4af24f5a0f17e4e4$export$2e2bcd8739ae039; });

var $6EH8L = parcelRequire("6EH8L");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4af24f5a0f17e4e4$var$toString(value) {
    return value == null ? "" : (0, $6EH8L.default)(value);
}
var $4af24f5a0f17e4e4$export$2e2bcd8739ae039 = $4af24f5a0f17e4e4$var$toString;

});
parcelRequire.register("6EH8L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d87f1452cbb9b8a$export$2e2bcd8739ae039; });

var $aojMU = parcelRequire("aojMU");

var $69ERV = parcelRequire("69ERV");

var $21thZ = parcelRequire("21thZ");

var $bOFLd = parcelRequire("bOFLd");
/** Used as references for various `Number` constants. */ var $4d87f1452cbb9b8a$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $4d87f1452cbb9b8a$var$symbolProto = (0, $aojMU.default) ? (0, $aojMU.default).prototype : undefined, $4d87f1452cbb9b8a$var$symbolToString = $4d87f1452cbb9b8a$var$symbolProto ? $4d87f1452cbb9b8a$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $4d87f1452cbb9b8a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $21thZ.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $69ERV.default)(value, $4d87f1452cbb9b8a$var$baseToString) + "";
    if ((0, $bOFLd.default)(value)) return $4d87f1452cbb9b8a$var$symbolToString ? $4d87f1452cbb9b8a$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$4d87f1452cbb9b8a$var$INFINITY ? "-0" : result;
}
var $4d87f1452cbb9b8a$export$2e2bcd8739ae039 = $4d87f1452cbb9b8a$var$baseToString;

});



parcelRequire.register("hVVj1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0e4364422aa32a9$export$2e2bcd8739ae039; });

var $3kFHB = parcelRequire("3kFHB");
/** Used to compose bitmasks for cloning. */ var $d0e4364422aa32a9$var$CLONE_DEEP_FLAG = 1, $d0e4364422aa32a9$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d0e4364422aa32a9$var$cloneDeep(value) {
    return (0, $3kFHB.default)(value, $d0e4364422aa32a9$var$CLONE_DEEP_FLAG | $d0e4364422aa32a9$var$CLONE_SYMBOLS_FLAG);
}
var $d0e4364422aa32a9$export$2e2bcd8739ae039 = $d0e4364422aa32a9$var$cloneDeep;

});


parcelRequire.register("9rh0m", function(module, exports) {

$parcel$export(module.exports, "passwordRegex", function () { return $181a677eeb6fe26f$export$ddd31b5c12262d9a; });
$parcel$export(module.exports, "isPasswordValid", function () { return $181a677eeb6fe26f$export$e36e0bbf46ae5cf3; });
$parcel$export(module.exports, "emailRegex", function () { return $181a677eeb6fe26f$export$976c37132e9c6a10; });
$parcel$export(module.exports, "postalCodeRegex", function () { return $181a677eeb6fe26f$export$832794dd916db462; });
$parcel$export(module.exports, "swiftRegex", function () { return $181a677eeb6fe26f$export$f4d39d832388a022; });
$parcel$export(module.exports, "ibanRegex", function () { return $181a677eeb6fe26f$export$66509278ca37d6c6; });
const $181a677eeb6fe26f$export$3cb752155e278b56 = "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^A-Za-z0-9]).{8,}$";
const $181a677eeb6fe26f$export$ddd31b5c12262d9a = new RegExp($181a677eeb6fe26f$export$3cb752155e278b56);
const $181a677eeb6fe26f$export$e36e0bbf46ae5cf3 = (password)=>{
    return $181a677eeb6fe26f$export$ddd31b5c12262d9a.test(password);
};
const $181a677eeb6fe26f$export$976c37132e9c6a10 = /^[\w-\.+]+@([\w-]+\.)+[\w-]{2,4}$/g;
const $181a677eeb6fe26f$export$7c6ca1c83a3454ea = (email)=>$181a677eeb6fe26f$export$976c37132e9c6a10.test(email);
const $181a677eeb6fe26f$export$832794dd916db462 = /^\d{4}(?:[-\s]\d{3})?$/g;
const $181a677eeb6fe26f$export$b53d5281dc708577 = (postalCode)=>$181a677eeb6fe26f$export$832794dd916db462.test(postalCode);
const $181a677eeb6fe26f$export$f4d39d832388a022 = /^[A-Z]{4}PT[A-Z]{2}$/g;
const $181a677eeb6fe26f$export$3ad25cca112c35ac = (swift)=>$181a677eeb6fe26f$export$f4d39d832388a022.test(swift);
const $181a677eeb6fe26f$export$66509278ca37d6c6 = /^(?:(?:[A-Z]{2}\d{2})(\d{4})(\d{4})(\d{11})(\w{0,16})|(\d{4})(\d{4})(\d{11})(\w{0,16}))$/g;
const $181a677eeb6fe26f$export$3d3f22d003b1a416 = (iban)=>$181a677eeb6fe26f$export$66509278ca37d6c6.test(iban);

});

parcelRequire.register("7xRAC", function(module, exports) {

$parcel$export(module.exports, "ref", function () { return $57e52f3b537dfd4b$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "string", function () { return $57e52f3b537dfd4b$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $57e52f3b537dfd4b$export$98e628dec113755e; });
$parcel$export(module.exports, "date", function () { return $57e52f3b537dfd4b$export$324d90190a8b822a; });
$parcel$export(module.exports, "object", function () { return $57e52f3b537dfd4b$export$be5493f9613cbbe; });
$parcel$export(module.exports, "array", function () { return $57e52f3b537dfd4b$export$2f23118c22fb2630; });
$parcel$export(module.exports, "addMethod", function () { return $57e52f3b537dfd4b$export$20be359f745f973c; });
$parcel$export(module.exports, "boolean", function () { return $57e52f3b537dfd4b$export$87b259aa03e3d267; });

var $8uOF5 = parcelRequire("8uOF5");

var $6vqGL = parcelRequire("6vqGL");

var $bGrpt = parcelRequire("bGrpt");
const $57e52f3b537dfd4b$var$toString = Object.prototype.toString;
const $57e52f3b537dfd4b$var$errorToString = Error.prototype.toString;
const $57e52f3b537dfd4b$var$regExpToString = RegExp.prototype.toString;
const $57e52f3b537dfd4b$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $57e52f3b537dfd4b$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $57e52f3b537dfd4b$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $57e52f3b537dfd4b$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $57e52f3b537dfd4b$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $57e52f3b537dfd4b$var$symbolToString.call(val).replace($57e52f3b537dfd4b$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $57e52f3b537dfd4b$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $57e52f3b537dfd4b$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $57e52f3b537dfd4b$var$regExpToString.call(val);
    return null;
}
function $57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $57e52f3b537dfd4b$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $57e52f3b537dfd4b$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $57e52f3b537dfd4b$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $57e52f3b537dfd4b$var$_Symbol$toStringTag, $57e52f3b537dfd4b$var$_Symbol$hasInstance, $57e52f3b537dfd4b$var$_Symbol$toStringTag2;
let $57e52f3b537dfd4b$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$57e52f3b537dfd4b$var$_Symbol$toStringTag = Symbol.toStringTag;
class $57e52f3b537dfd4b$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$57e52f3b537dfd4b$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $57e52f3b537dfd4b$var$toArray(errorOrErrors).forEach((err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$57e52f3b537dfd4b$var$_Symbol$hasInstance = Symbol.hasInstance;
$57e52f3b537dfd4b$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $57e52f3b537dfd4b$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($57e52f3b537dfd4b$var$strReg, (_, key)=>$57e52f3b537dfd4b$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    static [$57e52f3b537dfd4b$var$_Symbol$hasInstance](inst) {
        return $57e52f3b537dfd4b$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $57e52f3b537dfd4b$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$57e52f3b537dfd4b$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $57e52f3b537dfd4b$export$2191b9da168c6cf0);
    }
}
let $57e52f3b537dfd4b$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $57e52f3b537dfd4b$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $57e52f3b537dfd4b$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $57e52f3b537dfd4b$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $57e52f3b537dfd4b$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $57e52f3b537dfd4b$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $57e52f3b537dfd4b$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $57e52f3b537dfd4b$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$57e52f3b537dfd4b$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $57e52f3b537dfd4b$export$2191b9da168c6cf0.formatError($57e52f3b537dfd4b$var$mixed.notType, params);
    }
};
var $57e52f3b537dfd4b$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $57e52f3b537dfd4b$var$mixed,
    string: $57e52f3b537dfd4b$var$string,
    number: $57e52f3b537dfd4b$var$number,
    date: $57e52f3b537dfd4b$var$date,
    object: $57e52f3b537dfd4b$var$object,
    array: $57e52f3b537dfd4b$var$array,
    boolean: $57e52f3b537dfd4b$var$boolean,
    tuple: $57e52f3b537dfd4b$var$tuple
});
const $57e52f3b537dfd4b$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $57e52f3b537dfd4b$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $57e52f3b537dfd4b$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
}
const $57e52f3b537dfd4b$var$prefixes = {
    context: "$",
    value: "."
};
function $57e52f3b537dfd4b$export$eff4d24c3ff7876e(key, options) {
    return new $57e52f3b537dfd4b$var$Reference(key, options);
}
class $57e52f3b537dfd4b$var$Reference {
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $57e52f3b537dfd4b$var$prefixes.context;
        this.isValue = this.key[0] === $57e52f3b537dfd4b$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $57e52f3b537dfd4b$var$prefixes.context : this.isValue ? $57e52f3b537dfd4b$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $8uOF5.getter)(this.path, true);
        this.map = options.map;
    }
}
// @ts-ignore
$57e52f3b537dfd4b$var$Reference.prototype.__isYupRef = true;
const $57e52f3b537dfd4b$var$isAbsent = (value)=>value == null;
function $57e52f3b537dfd4b$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $57e52f3b537dfd4b$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $57e52f3b537dfd4b$export$2191b9da168c6cf0($57e52f3b537dfd4b$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $57e52f3b537dfd4b$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $57e52f3b537dfd4b$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $8uOF5.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $57e52f3b537dfd4b$export$cfedb76369cc7782(obj, path, value, context) {
    return $57e52f3b537dfd4b$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $57e52f3b537dfd4b$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($57e52f3b537dfd4b$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $57e52f3b537dfd4b$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $57e52f3b537dfd4b$var$clone(src, seen = new Map()) {
    if ($57e52f3b537dfd4b$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $57e52f3b537dfd4b$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $57e52f3b537dfd4b$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($57e52f3b537dfd4b$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $57e52f3b537dfd4b$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $57e52f3b537dfd4b$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $57e52f3b537dfd4b$var$isAbsent(result)) return result;
            let formattedValue = $57e52f3b537dfd4b$export$5790025c6e6c2ba6(value);
            let formattedResult = $57e52f3b537dfd4b$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $57e52f3b537dfd4b$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $57e52f3b537dfd4b$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($57e52f3b537dfd4b$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $57e52f3b537dfd4b$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $57e52f3b537dfd4b$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $57e52f3b537dfd4b$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $57e52f3b537dfd4b$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $57e52f3b537dfd4b$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $57e52f3b537dfd4b$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $57e52f3b537dfd4b$var$toArray(keys).map((key)=>new $57e52f3b537dfd4b$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $57e52f3b537dfd4b$var$Condition(deps, options) : $57e52f3b537dfd4b$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $57e52f3b537dfd4b$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $57e52f3b537dfd4b$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $57e52f3b537dfd4b$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $57e52f3b537dfd4b$var$ReferenceSet();
        this._blacklist = new $57e52f3b537dfd4b$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($57e52f3b537dfd4b$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
}
// @ts-expect-error
$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $57e52f3b537dfd4b$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[alias] = $57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$57e52f3b537dfd4b$export$19342e026b58ebb7.prototype[alias] = $57e52f3b537dfd4b$export$19342e026b58ebb7.prototype.notOneOf;
const $57e52f3b537dfd4b$var$returnsTrue = ()=>true;
function $57e52f3b537dfd4b$export$9b30b6294c1449a8(spec) {
    return new $57e52f3b537dfd4b$export$1e88358c94ddec71(spec);
}
class $57e52f3b537dfd4b$export$1e88358c94ddec71 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $57e52f3b537dfd4b$var$returnsTrue
        }, spec));
    }
}
$57e52f3b537dfd4b$export$9b30b6294c1449a8.prototype = $57e52f3b537dfd4b$export$1e88358c94ddec71.prototype;
function $57e52f3b537dfd4b$export$87b259aa03e3d267() {
    return new $57e52f3b537dfd4b$export$c7980688f11e1f49();
}
class $57e52f3b537dfd4b$export$c7980688f11e1f49 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    isTrue(message = $57e52f3b537dfd4b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $57e52f3b537dfd4b$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $57e52f3b537dfd4b$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $57e52f3b537dfd4b$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
}
$57e52f3b537dfd4b$export$87b259aa03e3d267.prototype = $57e52f3b537dfd4b$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $57e52f3b537dfd4b$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $57e52f3b537dfd4b$var$parseIsoDate(date) {
    const struct = $57e52f3b537dfd4b$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $57e52f3b537dfd4b$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $57e52f3b537dfd4b$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $57e52f3b537dfd4b$var$toNumber(regexResult[1]),
        month: $57e52f3b537dfd4b$var$toNumber(regexResult[2], 1) - 1,
        day: $57e52f3b537dfd4b$var$toNumber(regexResult[3], 1),
        hour: $57e52f3b537dfd4b$var$toNumber(regexResult[4]),
        minute: $57e52f3b537dfd4b$var$toNumber(regexResult[5]),
        second: $57e52f3b537dfd4b$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $57e52f3b537dfd4b$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $57e52f3b537dfd4b$var$toNumber(regexResult[10]),
        minuteOffset: $57e52f3b537dfd4b$var$toNumber(regexResult[11])
    };
}
function $57e52f3b537dfd4b$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $57e52f3b537dfd4b$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $57e52f3b537dfd4b$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $57e52f3b537dfd4b$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $57e52f3b537dfd4b$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $57e52f3b537dfd4b$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $57e52f3b537dfd4b$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $57e52f3b537dfd4b$var$rIsoDateTime = new RegExp(`${$57e52f3b537dfd4b$var$yearMonthDay}T${$57e52f3b537dfd4b$var$hourMinuteSecond}(\\.\\d+)?${$57e52f3b537dfd4b$var$zOrOffset}$`);
let $57e52f3b537dfd4b$var$isTrimmed = (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.trim();
let $57e52f3b537dfd4b$var$objStringTag = ({}).toString();
function $57e52f3b537dfd4b$export$22b082955e083ec3() {
    return new $57e52f3b537dfd4b$export$49bf8b2ede5138eb();
}
class $57e52f3b537dfd4b$export$49bf8b2ede5138eb extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $57e52f3b537dfd4b$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $57e52f3b537dfd4b$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $57e52f3b537dfd4b$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $57e52f3b537dfd4b$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $57e52f3b537dfd4b$var$string.email) {
        return this.matches($57e52f3b537dfd4b$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $57e52f3b537dfd4b$var$string.url) {
        return this.matches($57e52f3b537dfd4b$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $57e52f3b537dfd4b$var$string.uuid) {
        return this.matches($57e52f3b537dfd4b$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($57e52f3b537dfd4b$var$rIsoDateTime, {
            name: "datetime",
            message: message || $57e52f3b537dfd4b$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $57e52f3b537dfd4b$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $57e52f3b537dfd4b$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $57e52f3b537dfd4b$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $57e52f3b537dfd4b$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $57e52f3b537dfd4b$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $57e52f3b537dfd4b$var$isTrimmed
        });
    }
    lowercase(message = $57e52f3b537dfd4b$var$string.lowercase) {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $57e52f3b537dfd4b$var$string.uppercase) {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$57e52f3b537dfd4b$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $57e52f3b537dfd4b$var$objStringTag) return value;
                return strValue;
            });
        });
    }
}
$57e52f3b537dfd4b$export$22b082955e083ec3.prototype = $57e52f3b537dfd4b$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $57e52f3b537dfd4b$var$isNaN$1 = (value)=>value != +value;
function $57e52f3b537dfd4b$export$98e628dec113755e() {
    return new $57e52f3b537dfd4b$export$f192ec5e9228ab19();
}
class $57e52f3b537dfd4b$export$f192ec5e9228ab19 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    min(min, message = $57e52f3b537dfd4b$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $57e52f3b537dfd4b$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $57e52f3b537dfd4b$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $57e52f3b537dfd4b$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $57e52f3b537dfd4b$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $57e52f3b537dfd4b$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$57e52f3b537dfd4b$var$isAbsent(value) ? Math[method](value) : value);
    }
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$57e52f3b537dfd4b$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
}
$57e52f3b537dfd4b$export$98e628dec113755e.prototype = $57e52f3b537dfd4b$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $57e52f3b537dfd4b$var$invalidDate = new Date("");
let $57e52f3b537dfd4b$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $57e52f3b537dfd4b$export$324d90190a8b822a() {
    return new $57e52f3b537dfd4b$export$18ec3cc5a157503f();
}
class $57e52f3b537dfd4b$export$18ec3cc5a157503f extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    prepareParam(ref, name) {
        let param;
        if (!$57e52f3b537dfd4b$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $57e52f3b537dfd4b$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $57e52f3b537dfd4b$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
    constructor(){
        super({
            type: "date",
            check (v) {
                return $57e52f3b537dfd4b$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $57e52f3b537dfd4b$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $57e52f3b537dfd4b$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
}
$57e52f3b537dfd4b$export$18ec3cc5a157503f.INVALID_DATE = $57e52f3b537dfd4b$var$invalidDate;
$57e52f3b537dfd4b$export$324d90190a8b822a.prototype = $57e52f3b537dfd4b$export$18ec3cc5a157503f.prototype;
$57e52f3b537dfd4b$export$324d90190a8b822a.INVALID_DATE = $57e52f3b537dfd4b$var$invalidDate;
// @ts-expect-error
function $57e52f3b537dfd4b$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $8uOF5.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($57e52f3b537dfd4b$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($57e52f3b537dfd4b$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bGrpt))).array(Array.from(nodes), edges).reverse();
}
function $57e52f3b537dfd4b$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $57e52f3b537dfd4b$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $57e52f3b537dfd4b$var$findIndex(keys, a) - $57e52f3b537dfd4b$var$findIndex(keys, b);
    };
}
const $57e52f3b537dfd4b$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $57e52f3b537dfd4b$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $57e52f3b537dfd4b$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $57e52f3b537dfd4b$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($57e52f3b537dfd4b$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $57e52f3b537dfd4b$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $8uOF5.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $8uOF5.getter)((0, $8uOF5.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $57e52f3b537dfd4b$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $57e52f3b537dfd4b$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $57e52f3b537dfd4b$var$defaultSort = $57e52f3b537dfd4b$var$sortByKeyOrder([]);
function $57e52f3b537dfd4b$export$be5493f9613cbbe(spec) {
    return new $57e52f3b537dfd4b$export$18b4fc70ec7eccf8(spec);
}
class $57e52f3b537dfd4b$export$18b4fc70ec7eccf8 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $57e52f3b537dfd4b$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$57e52f3b537dfd4b$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $57e52f3b537dfd4b$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $57e52f3b537dfd4b$var$sortFields(shape, excludedEdges);
        next._sortErrors = $57e52f3b537dfd4b$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $57e52f3b537dfd4b$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $8uOF5.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($57e52f3b537dfd4b$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($57e52f3b537dfd4b$var$parseJson);
    }
    noUnknown(noAllow = true, message = $57e52f3b537dfd4b$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $57e52f3b537dfd4b$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $57e52f3b537dfd4b$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $6vqGL.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $6vqGL.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $6vqGL.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $57e52f3b537dfd4b$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $57e52f3b537dfd4b$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
}
$57e52f3b537dfd4b$export$be5493f9613cbbe.prototype = $57e52f3b537dfd4b$export$18b4fc70ec7eccf8.prototype;
function $57e52f3b537dfd4b$export$2f23118c22fb2630(type) {
    return new $57e52f3b537dfd4b$export$4347112b8447a7d(type);
}
class $57e52f3b537dfd4b$export$4347112b8447a7d extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($57e52f3b537dfd4b$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $57e52f3b537dfd4b$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $57e52f3b537dfd4b$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $57e52f3b537dfd4b$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $57e52f3b537dfd4b$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
}
$57e52f3b537dfd4b$export$2f23118c22fb2630.prototype = $57e52f3b537dfd4b$export$4347112b8447a7d.prototype;
// @ts-ignore
function $57e52f3b537dfd4b$export$65e3907585753458(schemas) {
    return new $57e52f3b537dfd4b$export$411c3b3687e8ecc8(schemas);
}
class $57e52f3b537dfd4b$export$411c3b3687e8ecc8 extends $57e52f3b537dfd4b$export$19342e026b58ebb7 {
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($57e52f3b537dfd4b$var$tuple.notType);
        });
    }
}
$57e52f3b537dfd4b$export$65e3907585753458.prototype = $57e52f3b537dfd4b$export$411c3b3687e8ecc8.prototype;
function $57e52f3b537dfd4b$export$488013bae63b21da(builder) {
    return new $57e52f3b537dfd4b$var$Lazy(builder);
}
class $57e52f3b537dfd4b$var$Lazy {
    clone(spec) {
        const next = new $57e52f3b537dfd4b$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
}
function $57e52f3b537dfd4b$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $57e52f3b537dfd4b$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $57e52f3b537dfd4b$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$57e52f3b537dfd4b$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRequire.register("8uOF5", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $62f86c6ad1e80146$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$62f86c6ad1e80146$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$62f86c6ad1e80146$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$62f86c6ad1e80146$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $62f86c6ad1e80146$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $62f86c6ad1e80146$var$DIGIT_REGEX = /^\d+$/, $62f86c6ad1e80146$var$LEAD_DIGIT_REGEX = /^\d/, $62f86c6ad1e80146$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $62f86c6ad1e80146$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $62f86c6ad1e80146$var$MAX_CACHE_SIZE = 512;
var $62f86c6ad1e80146$var$pathCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE), $62f86c6ad1e80146$var$setCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE), $62f86c6ad1e80146$var$getCache = new $62f86c6ad1e80146$var$Cache($62f86c6ad1e80146$var$MAX_CACHE_SIZE);
var $62f86c6ad1e80146$var$config;
module.exports = {
    Cache: $62f86c6ad1e80146$var$Cache,
    split: $62f86c6ad1e80146$var$split,
    normalizePath: $62f86c6ad1e80146$var$normalizePath,
    setter: function(path) {
        var parts = $62f86c6ad1e80146$var$normalizePath(path);
        return $62f86c6ad1e80146$var$setCache.get(path) || $62f86c6ad1e80146$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $62f86c6ad1e80146$var$normalizePath(path);
        return $62f86c6ad1e80146$var$getCache.get(path) || $62f86c6ad1e80146$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($62f86c6ad1e80146$var$isQuoted(part) || $62f86c6ad1e80146$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $62f86c6ad1e80146$var$forEach(Array.isArray(path) ? path : $62f86c6ad1e80146$var$split(path), cb, thisArg);
    }
};
function $62f86c6ad1e80146$var$normalizePath(path) {
    return $62f86c6ad1e80146$var$pathCache.get(path) || $62f86c6ad1e80146$var$pathCache.set(path, $62f86c6ad1e80146$var$split(path).map(function(part) {
        return part.replace($62f86c6ad1e80146$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $62f86c6ad1e80146$var$split(path) {
    return path.match($62f86c6ad1e80146$var$SPLIT_REGEX) || [
        ""
    ];
}
function $62f86c6ad1e80146$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($62f86c6ad1e80146$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $62f86c6ad1e80146$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $62f86c6ad1e80146$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $62f86c6ad1e80146$var$hasLeadingNumber(part) {
    return part.match($62f86c6ad1e80146$var$LEAD_DIGIT_REGEX) && !part.match($62f86c6ad1e80146$var$DIGIT_REGEX);
}
function $62f86c6ad1e80146$var$hasSpecialChars(part) {
    return $62f86c6ad1e80146$var$SPEC_CHAR_REGEX.test(part);
}
function $62f86c6ad1e80146$var$shouldBeQuoted(part) {
    return !$62f86c6ad1e80146$var$isQuoted(part) && ($62f86c6ad1e80146$var$hasLeadingNumber(part) || $62f86c6ad1e80146$var$hasSpecialChars(part));
}

});

parcelRequire.register("6vqGL", function(module, exports) {
const $4bca57257e8cec66$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $4bca57257e8cec66$var$words = (str)=>str.match($4bca57257e8cec66$var$reWords) || [];
const $4bca57257e8cec66$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $4bca57257e8cec66$var$join = (str, d)=>$4bca57257e8cec66$var$words(str).join(d).toLowerCase();
const $4bca57257e8cec66$var$camelCase = (str)=>$4bca57257e8cec66$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $4bca57257e8cec66$var$pascalCase = (str)=>$4bca57257e8cec66$var$upperFirst($4bca57257e8cec66$var$camelCase(str));
const $4bca57257e8cec66$var$snakeCase = (str)=>$4bca57257e8cec66$var$join(str, "_");
const $4bca57257e8cec66$var$kebabCase = (str)=>$4bca57257e8cec66$var$join(str, "-");
const $4bca57257e8cec66$var$sentenceCase = (str)=>$4bca57257e8cec66$var$upperFirst($4bca57257e8cec66$var$join(str, " "));
const $4bca57257e8cec66$var$titleCase = (str)=>$4bca57257e8cec66$var$words(str).map($4bca57257e8cec66$var$upperFirst).join(" ");
module.exports = {
    words: $4bca57257e8cec66$var$words,
    upperFirst: $4bca57257e8cec66$var$upperFirst,
    camelCase: $4bca57257e8cec66$var$camelCase,
    pascalCase: $4bca57257e8cec66$var$pascalCase,
    snakeCase: $4bca57257e8cec66$var$snakeCase,
    kebabCase: $4bca57257e8cec66$var$kebabCase,
    sentenceCase: $4bca57257e8cec66$var$sentenceCase,
    titleCase: $4bca57257e8cec66$var$titleCase
};

});

parcelRequire.register("bGrpt", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $8818e0f94c57edd0$var$toposort($8818e0f94c57edd0$var$uniqueNodes(edges), edges);
};
module.exports.array = $8818e0f94c57edd0$var$toposort;
function $8818e0f94c57edd0$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $8818e0f94c57edd0$var$makeOutgoingEdges(edges), nodesHash = $8818e0f94c57edd0$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $8818e0f94c57edd0$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $8818e0f94c57edd0$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $8818e0f94c57edd0$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRequire.register("5aR8Y", function(module, exports) {

var $jVWG9 = parcelRequire("jVWG9");
var $f1K9O = parcelRequire("f1K9O");

var $7xRAC = parcelRequire("7xRAC");
var $3c471c28f5a99ad5$var$YUP_PHONE_METHOD = "phone";
var $3c471c28f5a99ad5$var$isValidCountryCode = function isValidCountryCode(countryCode) {
    if (typeof countryCode !== "string") return false;
    return (0, $jVWG9.isSupportedCountry)(countryCode);
};
$7xRAC.addMethod($7xRAC.string, $3c471c28f5a99ad5$var$YUP_PHONE_METHOD, function yupPhoneLite(countryCode, errorMessage) {
    if (countryCode === void 0) countryCode = "US";
    var countryCodes = typeof countryCode === "string" ? [
        countryCode
    ] : [].concat(countryCode);
    var validCountryCodes = countryCodes.filter($3c471c28f5a99ad5$var$isValidCountryCode);
    if (!validCountryCodes.length) validCountryCodes = [
        "US"
    ];
    var errMsg = typeof errorMessage === "string" && errorMessage ? errorMessage : "${path} must be a valid phone number for region" + (validCountryCodes.length > 1 ? "s" : "") + " " + validCountryCodes.join(", ");
    return this.test($3c471c28f5a99ad5$var$YUP_PHONE_METHOD, errMsg, function(value) {
        try {
            if (value === undefined || value === "") return true;
            var isValid = validCountryCodes.reduce(function(isValidAccum, validCountryCode) {
                var isValidPhone = (0, $f1K9O.isValidPhoneNumber)(value, validCountryCode);
                return isValidAccum || isValidPhone;
            }, false);
            return isValid;
        } catch (_unused) {
            return false;
        }
    });
});

});
parcelRequire.register("jVWG9", function(module, exports) {

$parcel$export(module.exports, "isSupportedCountry", function () { return $e830db97b22d9e1a$export$bd9e113b8b17202a; });

var $jG9Bc = parcelRequire("jG9Bc");

var $2Ug2G = parcelRequire("2Ug2G");
function $e830db97b22d9e1a$export$bd9e113b8b17202a() {
    return (0, $jG9Bc.default)((0, $2Ug2G.isSupportedCountry), arguments);
}

});
parcelRequire.register("jG9Bc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e53962bbc5d1daee$export$2e2bcd8739ae039; });
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

var $iOA7p = parcelRequire("iOA7p");
function $e53962bbc5d1daee$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $iOA7p.default));
    return func.apply(this, args);
}

});
parcelRequire.register("iOA7p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db28e9e8d90db31e$export$2e2bcd8739ae039; });
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $db28e9e8d90db31e$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0(4(?:[14]4|56)|[579])?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1-$2",
                    [
                        "5(?:29|38)",
                        "5(?:29[1289]|389)",
                        "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|892",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "592(?:4[0-2]|93)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[47]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-579]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|[89]0",
                        "50(?:[0367]|88)|[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[59]|80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7|86"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-4]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[237-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|616)",
                        "5(?:[0-59]|6161)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                7,
                8,
                10,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "405|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "[0-36-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-36-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRequire.register("2Ug2G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21dd415f9e802d2f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getCountryCallingCode", function () { return $21dd415f9e802d2f$export$32876ca2f1919cf0; });
$parcel$export(module.exports, "isSupportedCountry", function () { return $21dd415f9e802d2f$export$bd9e113b8b17202a; });

var $3rdNn = parcelRequire("3rdNn");
function $21dd415f9e802d2f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $21dd415f9e802d2f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $21dd415f9e802d2f$var$_typeof(obj);
}
function $21dd415f9e802d2f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $21dd415f9e802d2f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $21dd415f9e802d2f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $21dd415f9e802d2f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $21dd415f9e802d2f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $21dd415f9e802d2f$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $21dd415f9e802d2f$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $21dd415f9e802d2f$var$V4 = "1.7.35";
var $21dd415f9e802d2f$var$DEFAULT_EXT_PREFIX = " ext. ";
var $21dd415f9e802d2f$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $21dd415f9e802d2f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $21dd415f9e802d2f$var$_classCallCheck(this, Metadata);
        $21dd415f9e802d2f$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $21dd415f9e802d2f$var$setVersion.call(this, metadata);
    }
    $21dd415f9e802d2f$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $21dd415f9e802d2f$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $21dd415f9e802d2f$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $21dd415f9e802d2f$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $21dd415f9e802d2f$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $21dd415f9e802d2f$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $21dd415f9e802d2f$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $21dd415f9e802d2f$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $21dd415f9e802d2f$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $21dd415f9e802d2f$var$getType(this.types(), _type2)) return new $21dd415f9e802d2f$var$Type($21dd415f9e802d2f$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $21dd415f9e802d2f$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $21dd415f9e802d2f$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $21dd415f9e802d2f$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $21dd415f9e802d2f$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $21dd415f9e802d2f$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$21dd415f9e802d2f$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $21dd415f9e802d2f$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $21dd415f9e802d2f$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $21dd415f9e802d2f$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $21dd415f9e802d2f$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $21dd415f9e802d2f$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $21dd415f9e802d2f$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!$21dd415f9e802d2f$var$is_object(metadata) || !$21dd415f9e802d2f$var$is_object(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($21dd415f9e802d2f$var$is_object(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $21dd415f9e802d2f$var$type_of(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $21dd415f9e802d2f$var$is_object = function is_object(_) {
    return $21dd415f9e802d2f$var$_typeof(_) === "object";
}; // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $21dd415f9e802d2f$var$type_of = function type_of(_) {
    return $21dd415f9e802d2f$var$_typeof(_);
};
function $21dd415f9e802d2f$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $21dd415f9e802d2f$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $21dd415f9e802d2f$var$DEFAULT_EXT_PREFIX;
}
function $21dd415f9e802d2f$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $21dd415f9e802d2f$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $21dd415f9e802d2f$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $21dd415f9e802d2f$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $3rdNn.default)(version, $21dd415f9e802d2f$var$V3) === -1) this.v2 = true;
        else if ((0, $3rdNn.default)(version, $21dd415f9e802d2f$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRequire.register("3rdNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $280e982bfc0b25e9$export$2e2bcd8739ae039; });
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $280e982bfc0b25e9$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});



parcelRequire.register("f1K9O", function(module, exports) {

$parcel$export(module.exports, "isValidPhoneNumber", function () { return $af0ac0dc0768f09c$export$992e2df24bec72ba; });

var $jG9Bc = parcelRequire("jG9Bc");

var $2XWbg = parcelRequire("2XWbg");
function $af0ac0dc0768f09c$export$992e2df24bec72ba() {
    return (0, $jG9Bc.default)((0, $2XWbg.default), arguments);
}

});
parcelRequire.register("2XWbg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $228e38f42775ec97$export$2e2bcd8739ae039; });

var $eZYg3 = parcelRequire("eZYg3");

var $iiYjl = parcelRequire("iiYjl");
function $228e38f42775ec97$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $228e38f42775ec97$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $228e38f42775ec97$var$ownKeys(Object(source), !0).forEach(function(key) {
            $228e38f42775ec97$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $228e38f42775ec97$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $228e38f42775ec97$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $228e38f42775ec97$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $eZYg3.default)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $228e38f42775ec97$var$_objectSpread($228e38f42775ec97$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $iiYjl.default)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}

});
parcelRequire.register("eZYg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeb5812de97eb75a$export$2e2bcd8739ae039; });
function $aeb5812de97eb75a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aeb5812de97eb75a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aeb5812de97eb75a$var$_typeof(obj);
}
function $aeb5812de97eb75a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aeb5812de97eb75a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aeb5812de97eb75a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aeb5812de97eb75a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aeb5812de97eb75a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aeb5812de97eb75a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aeb5812de97eb75a$var$_slicedToArray(arr, i) {
    return $aeb5812de97eb75a$var$_arrayWithHoles(arr) || $aeb5812de97eb75a$var$_iterableToArrayLimit(arr, i) || $aeb5812de97eb75a$var$_unsupportedIterableToArray(arr, i) || $aeb5812de97eb75a$var$_nonIterableRest();
}
function $aeb5812de97eb75a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aeb5812de97eb75a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aeb5812de97eb75a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aeb5812de97eb75a$var$_arrayLikeToArray(o, minLen);
}
function $aeb5812de97eb75a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aeb5812de97eb75a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aeb5812de97eb75a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $aeb5812de97eb75a$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $aeb5812de97eb75a$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $aeb5812de97eb75a$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ($aeb5812de97eb75a$var$isObject(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
} // Otherwise istanbul would show this as "branch not covered".
/* istanbul ignore next */ var $aeb5812de97eb75a$var$isObject = function isObject(_) {
    return $aeb5812de97eb75a$var$_typeof(_) === "object";
};

});

parcelRequire.register("iiYjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d538b0eedd3dade1$export$2e2bcd8739ae039; });

var $aX1oU = parcelRequire("aX1oU");

var $8OMe0 = parcelRequire("8OMe0");

var $2Ug2G = parcelRequire("2Ug2G");
function $d538b0eedd3dade1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d538b0eedd3dade1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d538b0eedd3dade1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d538b0eedd3dade1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d538b0eedd3dade1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d538b0eedd3dade1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d538b0eedd3dade1$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $2Ug2G.isSupportedCountry)(options.defaultCountry, metadata)) options = $d538b0eedd3dade1$var$_objectSpread($d538b0eedd3dade1$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $aX1oU.default)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $8OMe0.default)) ;
        else throw error;
    }
}

});
parcelRequire.register("aX1oU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f90803fcd782410$export$2e2bcd8739ae039; });

var $fBEBd = parcelRequire("fBEBd");
function $7f90803fcd782410$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7f90803fcd782410$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7f90803fcd782410$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7f90803fcd782410$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7f90803fcd782410$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7f90803fcd782410$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f90803fcd782410$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $fBEBd.default)(text, $7f90803fcd782410$var$_objectSpread($7f90803fcd782410$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}

});
parcelRequire.register("fBEBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5c9cddc11c35fa9$export$2e2bcd8739ae039; });
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $7am3F = parcelRequire("7am3F");

var $8OMe0 = parcelRequire("8OMe0");

var $2Ug2G = parcelRequire("2Ug2G");

var $jst1L = parcelRequire("jst1L");

var $kWt9u = parcelRequire("kWt9u");

var $5DRh1 = parcelRequire("5DRh1");

var $2Ug2G = parcelRequire("2Ug2G");

var $fq6DS = parcelRequire("fq6DS");

var $8IEU1 = parcelRequire("8IEU1");

var $hgNsR = parcelRequire("hgNsR");

var $10ax4 = parcelRequire("10ax4");

var $OZ06y = parcelRequire("OZ06y");


var $7zZyH = parcelRequire("7zZyH");

var $fCFdv = parcelRequire("fCFdv");
// This prevents malicious input from consuming CPU.
var $b5c9cddc11c35fa9$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $b5c9cddc11c35fa9$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $7am3F.PLUS_CHARS) + (0, $7am3F.VALID_DIGITS) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $b5c9cddc11c35fa9$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $7am3F.VALID_DIGITS) + "#" + "]+$");
var $b5c9cddc11c35fa9$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $b5c9cddc11c35fa9$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $2Ug2G.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $8OMe0.default)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $b5c9cddc11c35fa9$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $8OMe0.default)("TOO_SHORT");
            throw new (0, $8OMe0.default)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $b5c9cddc11c35fa9$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $8OMe0.default)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $7am3F.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $8OMe0.default)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $7am3F.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $8OMe0.default)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $8IEU1.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $hgNsR.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $b5c9cddc11c35fa9$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $fq6DS.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $b5c9cddc11c35fa9$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $b5c9cddc11c35fa9$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $8OMe0.default)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($b5c9cddc11c35fa9$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($b5c9cddc11c35fa9$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $b5c9cddc11c35fa9$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $fCFdv.default)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $b5c9cddc11c35fa9$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $jst1L.default)(number)) {
        if ((0, $jst1L.isViablePhoneNumberStart)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $kWt9u.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $b5c9cddc11c35fa9$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $b5c9cddc11c35fa9$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $10ax4.default)((0, $5DRh1.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($b5c9cddc11c35fa9$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $2Ug2G.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $OZ06y.default)((0, $5DRh1.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $7zZyH.default)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRequire.register("7am3F", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", function () { return $537a93dc04bbbe0e$export$cd8355bcbe13154; });
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", function () { return $537a93dc04bbbe0e$export$85ddd8c9b243679b; });
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", function () { return $537a93dc04bbbe0e$export$514717690676fb4a; });
$parcel$export(module.exports, "VALID_DIGITS", function () { return $537a93dc04bbbe0e$export$852d1d4a47329634; });
$parcel$export(module.exports, "VALID_PUNCTUATION", function () { return $537a93dc04bbbe0e$export$7f01587e28f9194; });
$parcel$export(module.exports, "PLUS_CHARS", function () { return $537a93dc04bbbe0e$export$207c99ccf3902df8; });
// The minimum length of the national significant number.
var $537a93dc04bbbe0e$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $537a93dc04bbbe0e$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $537a93dc04bbbe0e$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $537a93dc04bbbe0e$export$852d1d4a47329634 = "0-9０-９٠-٩۰-۹"; // `DASHES` will be right after the opening square bracket of the "character class"
var $537a93dc04bbbe0e$var$DASHES = "-‐-―−ー－";
var $537a93dc04bbbe0e$var$SLASHES = "／/";
var $537a93dc04bbbe0e$var$DOTS = "．.";
var $537a93dc04bbbe0e$export$20542845033f576e = " \xa0\xad​⁠　";
var $537a93dc04bbbe0e$var$BRACKETS = "()（）［］\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $537a93dc04bbbe0e$var$TILDES = "~⁓∼～"; // Regular expression of acceptable punctuation found in phone numbers. This
var $537a93dc04bbbe0e$export$7f01587e28f9194 = "".concat($537a93dc04bbbe0e$var$DASHES).concat($537a93dc04bbbe0e$var$SLASHES).concat($537a93dc04bbbe0e$var$DOTS).concat($537a93dc04bbbe0e$export$20542845033f576e).concat($537a93dc04bbbe0e$var$BRACKETS).concat($537a93dc04bbbe0e$var$TILDES);
var $537a93dc04bbbe0e$export$207c99ccf3902df8 = "+＋"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});

parcelRequire.register("8OMe0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66b866aee4c02049$export$2e2bcd8739ae039; });
function $66b866aee4c02049$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $66b866aee4c02049$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $66b866aee4c02049$var$_typeof(obj);
}
function $66b866aee4c02049$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $66b866aee4c02049$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $66b866aee4c02049$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $66b866aee4c02049$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $66b866aee4c02049$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $66b866aee4c02049$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $66b866aee4c02049$var$_setPrototypeOf(subClass, superClass);
}
function $66b866aee4c02049$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $66b866aee4c02049$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $66b866aee4c02049$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $66b866aee4c02049$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $66b866aee4c02049$var$_possibleConstructorReturn(this, result);
    };
}
function $66b866aee4c02049$var$_possibleConstructorReturn(self, call) {
    if (call && ($66b866aee4c02049$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $66b866aee4c02049$var$_assertThisInitialized(self);
}
function $66b866aee4c02049$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $66b866aee4c02049$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $66b866aee4c02049$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$66b866aee4c02049$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $66b866aee4c02049$var$_construct(Class, arguments, $66b866aee4c02049$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $66b866aee4c02049$var$_setPrototypeOf(Wrapper, Class);
    };
    return $66b866aee4c02049$var$_wrapNativeSuper(Class);
}
function $66b866aee4c02049$var$_construct(Parent, args, Class) {
    if ($66b866aee4c02049$var$_isNativeReflectConstruct()) $66b866aee4c02049$var$_construct = Reflect.construct;
    else $66b866aee4c02049$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $66b866aee4c02049$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $66b866aee4c02049$var$_construct.apply(null, arguments);
}
function $66b866aee4c02049$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $66b866aee4c02049$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $66b866aee4c02049$var$_setPrototypeOf(o, p) {
    $66b866aee4c02049$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $66b866aee4c02049$var$_setPrototypeOf(o, p);
}
function $66b866aee4c02049$var$_getPrototypeOf(o) {
    $66b866aee4c02049$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $66b866aee4c02049$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $66b866aee4c02049$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $66b866aee4c02049$var$_inherits(ParseError, _Error);
    var _super = $66b866aee4c02049$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $66b866aee4c02049$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($66b866aee4c02049$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $66b866aee4c02049$var$_createClass(ParseError);
}(/*#__PURE__*/ $66b866aee4c02049$var$_wrapNativeSuper(Error));

});

parcelRequire.register("jst1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2a7261183bcdf0c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isViablePhoneNumberStart", function () { return $e2a7261183bcdf0c$export$4c3f76c95c05197c; });

var $7am3F = parcelRequire("7am3F");

var $kLUof = parcelRequire("kLUof");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $e2a7261183bcdf0c$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $7am3F.VALID_DIGITS) + "]{" + (0, $7am3F.MIN_LENGTH_FOR_NSN) + "}"; //
var $e2a7261183bcdf0c$export$a77dd7471651eee = "[" + (0, $7am3F.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $7am3F.VALID_PUNCTUATION) + "]*" + "[" + (0, $7am3F.VALID_DIGITS) + "]" + "){3,}" + "[" + (0, $7am3F.VALID_PUNCTUATION) + (0, $7am3F.VALID_DIGITS) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $e2a7261183bcdf0c$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $7am3F.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $7am3F.VALID_PUNCTUATION) + "]*" + "[" + (0, $7am3F.VALID_DIGITS) + "]" + "){1,2}" + "$", "i");
var $e2a7261183bcdf0c$export$a2d12a04749c087d = $e2a7261183bcdf0c$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $kLUof.default)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $e2a7261183bcdf0c$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $e2a7261183bcdf0c$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $e2a7261183bcdf0c$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $e2a7261183bcdf0c$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $7am3F.MIN_LENGTH_FOR_NSN) && $e2a7261183bcdf0c$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $e2a7261183bcdf0c$export$4c3f76c95c05197c(number) {
    return $e2a7261183bcdf0c$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRequire.register("kLUof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f3f05a8b783035$export$2e2bcd8739ae039; });

var $7am3F = parcelRequire("7am3F");
var $f1f3f05a8b783035$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $f1f3f05a8b783035$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $7am3F.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $f1f3f05a8b783035$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.．]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|\xf3))?n?|ｅ?ｘｔｎ?|доб|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $f1f3f05a8b783035$var$RFC3966_EXTN_PREFIX + $f1f3f05a8b783035$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $f1f3f05a8b783035$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $f1f3f05a8b783035$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $f1f3f05a8b783035$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $f1f3f05a8b783035$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $f1f3f05a8b783035$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});


parcelRequire.register("kWt9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3efd66bd8ef04f0$export$2e2bcd8739ae039; });

var $kLUof = parcelRequire("kLUof");
// 1 or more valid digits, for use when parsing.
var $f3efd66bd8ef04f0$var$EXTN_PATTERN = new RegExp("(?:" + (0, $kLUof.default)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $f3efd66bd8ef04f0$export$2e2bcd8739ae039(number) {
    var start = number.search($f3efd66bd8ef04f0$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($f3efd66bd8ef04f0$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRequire.register("5DRh1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b9eb485728e33c$export$2e2bcd8739ae039; });

var $YzjZi = parcelRequire("YzjZi");
function $41b9eb485728e33c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $41b9eb485728e33c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $41b9eb485728e33c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $41b9eb485728e33c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $41b9eb485728e33c$var$_arrayLikeToArray(o, minLen);
}
function $41b9eb485728e33c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $41b9eb485728e33c$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $41b9eb485728e33c$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $41b9eb485728e33c$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $41b9eb485728e33c$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return "+";
    } // Allow digits.
    return (0, $YzjZi.parseDigit)(character);
}

});
parcelRequire.register("YzjZi", function(module, exports) {

$parcel$export(module.exports, "parseDigit", function () { return $0b6100cd488f3988$export$1d16fddea1437169; });
function $0b6100cd488f3988$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0b6100cd488f3988$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0b6100cd488f3988$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0b6100cd488f3988$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0b6100cd488f3988$var$_arrayLikeToArray(o, minLen);
}
function $0b6100cd488f3988$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $0b6100cd488f3988$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "０": "0",
    // Fullwidth digit 0
    "１": "1",
    // Fullwidth digit 1
    "２": "2",
    // Fullwidth digit 2
    "３": "3",
    // Fullwidth digit 3
    "４": "4",
    // Fullwidth digit 4
    "５": "5",
    // Fullwidth digit 5
    "６": "6",
    // Fullwidth digit 6
    "７": "7",
    // Fullwidth digit 7
    "８": "8",
    // Fullwidth digit 8
    "９": "9",
    // Fullwidth digit 9
    "٠": "0",
    // Arabic-indic digit 0
    "١": "1",
    // Arabic-indic digit 1
    "٢": "2",
    // Arabic-indic digit 2
    "٣": "3",
    // Arabic-indic digit 3
    "٤": "4",
    // Arabic-indic digit 4
    "٥": "5",
    // Arabic-indic digit 5
    "٦": "6",
    // Arabic-indic digit 6
    "٧": "7",
    // Arabic-indic digit 7
    "٨": "8",
    // Arabic-indic digit 8
    "٩": "9",
    // Arabic-indic digit 9
    "۰": "0",
    // Eastern-Arabic digit 0
    "۱": "1",
    // Eastern-Arabic digit 1
    "۲": "2",
    // Eastern-Arabic digit 2
    "۳": "3",
    // Eastern-Arabic digit 3
    "۴": "4",
    // Eastern-Arabic digit 4
    "۵": "5",
    // Eastern-Arabic digit 5
    "۶": "6",
    // Eastern-Arabic digit 6
    "۷": "7",
    // Eastern-Arabic digit 7
    "۸": "8",
    // Eastern-Arabic digit 8
    "۹": "9" // Eastern-Arabic digit 9
};
function $0b6100cd488f3988$export$1d16fddea1437169(character) {
    return $0b6100cd488f3988$export$2848f3d68c08fe69[character];
}
function $0b6100cd488f3988$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $0b6100cd488f3988$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $0b6100cd488f3988$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRequire.register("fq6DS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b39e6fbad9c95185$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPossibleNumber", function () { return $b39e6fbad9c95185$export$4f8890cedf1e0497; });

var $2Ug2G = parcelRequire("2Ug2G");

var $kmRhJ = parcelRequire("kmRhJ");
function $b39e6fbad9c95185$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $2Ug2G.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $b39e6fbad9c95185$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $b39e6fbad9c95185$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $kmRhJ.default)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRequire.register("kmRhJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed3f32064f145c5e$export$2e2bcd8739ae039; });

var $l0uKM = parcelRequire("l0uKM");
function $ed3f32064f145c5e$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $ed3f32064f145c5e$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $ed3f32064f145c5e$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $ed3f32064f145c5e$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $l0uKM.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}

});
parcelRequire.register("l0uKM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4b1740b6d93ad0c$export$2e2bcd8739ae039; });
function $f4b1740b6d93ad0c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f4b1740b6d93ad0c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f4b1740b6d93ad0c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f4b1740b6d93ad0c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f4b1740b6d93ad0c$var$_arrayLikeToArray(o, minLen);
}
function $f4b1740b6d93ad0c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f4b1740b6d93ad0c$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $f4b1740b6d93ad0c$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRequire.register("8IEU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65922933a5f6144b$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");

var $fq6DS = parcelRequire("fq6DS");

var $kOv1g = parcelRequire("kOv1g");

var $hJAfV = parcelRequire("hJAfV");

var $dlBBl = parcelRequire("dlBBl");

var $01fyh = parcelRequire("01fyh");
function $65922933a5f6144b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $65922933a5f6144b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $65922933a5f6144b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $65922933a5f6144b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $65922933a5f6144b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $65922933a5f6144b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $65922933a5f6144b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65922933a5f6144b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $65922933a5f6144b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $65922933a5f6144b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $65922933a5f6144b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $65922933a5f6144b$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $65922933a5f6144b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $65922933a5f6144b$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $65922933a5f6144b$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $65922933a5f6144b$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $dlBBl.default)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $fq6DS.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $kOv1g.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $2Ug2G.default)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $hJAfV.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $01fyh.default)(this, _format, options ? $65922933a5f6144b$var$_objectSpread($65922933a5f6144b$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $65922933a5f6144b$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $65922933a5f6144b$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $2Ug2G.default)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($65922933a5f6144b$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($65922933a5f6144b$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}

});
parcelRequire.register("kOv1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f27089f531cbcb12$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");

var $hgNsR = parcelRequire("hgNsR");

var $hJAfV = parcelRequire("hJAfV");
function $f27089f531cbcb12$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $2Ug2G.default)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $hJAfV.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $hgNsR.default)(nationalNumber, metadata.nationalNumberPattern());
}

});
parcelRequire.register("hgNsR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c92a4ce46fe47da6$export$2e2bcd8739ae039; });
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $c92a4ce46fe47da6$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}

});

parcelRequire.register("hJAfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce92c346dc6bcdfd$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");

var $hgNsR = parcelRequire("hgNsR");
function $ce92c346dc6bcdfd$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ce92c346dc6bcdfd$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ce92c346dc6bcdfd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce92c346dc6bcdfd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce92c346dc6bcdfd$var$_arrayLikeToArray(o, minLen);
}
function $ce92c346dc6bcdfd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ce92c346dc6bcdfd$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $ce92c346dc6bcdfd$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returned `{}`
    // meaning that the phone number is not a valid one.
    if (!input.country) return;
    metadata = new (0, $2Ug2G.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $hgNsR.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($ce92c346dc6bcdfd$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($ce92c346dc6bcdfd$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $ce92c346dc6bcdfd$var$_createForOfIteratorHelperLoose($ce92c346dc6bcdfd$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($ce92c346dc6bcdfd$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $ce92c346dc6bcdfd$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $hgNsR.default)(nationalNumber, type.pattern());
}

});


parcelRequire.register("dlBBl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7a67613356636c$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");
function $9b7a67613356636c$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $2Ug2G.default)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $9b7a67613356636c$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $9b7a67613356636c$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $2Ug2G.default)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}

});

parcelRequire.register("01fyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003c28636d074abe$export$2e2bcd8739ae039; });

var $hgNsR = parcelRequire("hgNsR");

var $9vBz8 = parcelRequire("9vBz8");

var $2Ug2G = parcelRequire("2Ug2G");

var $aaJ62 = parcelRequire("aaJ62");

var $6wFJ0 = parcelRequire("6wFJ0");
function $003c28636d074abe$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $003c28636d074abe$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $003c28636d074abe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $003c28636d074abe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $003c28636d074abe$var$_arrayLikeToArray(o, minLen);
}
function $003c28636d074abe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $003c28636d074abe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $003c28636d074abe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $003c28636d074abe$var$ownKeys(Object(source), !0).forEach(function(key) {
            $003c28636d074abe$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $003c28636d074abe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $003c28636d074abe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $003c28636d074abe$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $003c28636d074abe$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $003c28636d074abe$var$_objectSpread($003c28636d074abe$var$_objectSpread({}, $003c28636d074abe$var$DEFAULT_OPTIONS), options);
    else options = $003c28636d074abe$var$DEFAULT_OPTIONS;
    metadata = new (0, $2Ug2G.default)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $003c28636d074abe$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $003c28636d074abe$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $003c28636d074abe$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $003c28636d074abe$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $6wFJ0.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $003c28636d074abe$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $003c28636d074abe$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $003c28636d074abe$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $003c28636d074abe$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $9vBz8.default)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $003c28636d074abe$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $003c28636d074abe$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $hgNsR.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $003c28636d074abe$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $003c28636d074abe$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $2Ug2G.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $003c28636d074abe$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $aaJ62.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($003c28636d074abe$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}

});
parcelRequire.register("9vBz8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ec4261016f29099$export$2e2bcd8739ae039; });

var $9QYpY = parcelRequire("9QYpY");
var $6ec4261016f29099$export$4f32ad1c51a7a6be = /(\$\d)/;
function $6ec4261016f29099$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($6ec4261016f29099$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $9QYpY.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRequire.register("9QYpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72c7d61aafbf96f8$export$2e2bcd8739ae039; });

var $7am3F = parcelRequire("7am3F");
function $72c7d61aafbf96f8$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $7am3F.VALID_PUNCTUATION), "]+"), "g"), " ").trim();
}

});


parcelRequire.register("aaJ62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $767dd1c38f61c789$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $767dd1c38f61c789$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $767dd1c38f61c789$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $2Ug2G.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($767dd1c38f61c789$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});

parcelRequire.register("6wFJ0", function(module, exports) {

$parcel$export(module.exports, "formatRFC3966", function () { return $4c0618f1cd258edc$export$d4f2d2bc1159d115; });

var $jst1L = parcelRequire("jst1L");
function $4c0618f1cd258edc$var$_slicedToArray(arr, i) {
    return $4c0618f1cd258edc$var$_arrayWithHoles(arr) || $4c0618f1cd258edc$var$_iterableToArrayLimit(arr, i) || $4c0618f1cd258edc$var$_unsupportedIterableToArray(arr, i) || $4c0618f1cd258edc$var$_nonIterableRest();
}
function $4c0618f1cd258edc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4c0618f1cd258edc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4c0618f1cd258edc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4c0618f1cd258edc$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4c0618f1cd258edc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4c0618f1cd258edc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4c0618f1cd258edc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4c0618f1cd258edc$var$_arrayLikeToArray(o, minLen);
}
function $4c0618f1cd258edc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4c0618f1cd258edc$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $4c0618f1cd258edc$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $4c0618f1cd258edc$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $jst1L.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $4c0618f1cd258edc$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}

});



parcelRequire.register("10ax4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0badf605805eda00$export$2e2bcd8739ae039; });

var $djzOc = parcelRequire("djzOc");

var $9XhXU = parcelRequire("9XhXU");

var $2Ug2G = parcelRequire("2Ug2G");

var $7am3F = parcelRequire("7am3F");
function $0badf605805eda00$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $djzOc.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $9XhXU.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $2Ug2G.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $7am3F.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }

});
parcelRequire.register("djzOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b18d394f8285b20$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");

var $7am3F = parcelRequire("7am3F");
var $9b18d394f8285b20$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $7am3F.VALID_DIGITS) + "])");
function $9b18d394f8285b20$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $2Ug2G.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($9b18d394f8285b20$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}

});

parcelRequire.register("9XhXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73f78f4b29bafad8$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");

var $hgNsR = parcelRequire("hgNsR");

var $OZ06y = parcelRequire("OZ06y");

var $kmRhJ = parcelRequire("kmRhJ");

var $2Ug2G = parcelRequire("2Ug2G");
function $73f78f4b29bafad8$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $2Ug2G.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $2Ug2G.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $OZ06y.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $OZ06y.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $hgNsR.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $hgNsR.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $kmRhJ.default)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRequire.register("OZ06y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0993fd17b8db83dc$export$2e2bcd8739ae039; });

var $9VNkQ = parcelRequire("9VNkQ");

var $hgNsR = parcelRequire("hgNsR");

var $kmRhJ = parcelRequire("kmRhJ");
function $0993fd17b8db83dc$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $9VNkQ.default)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$0993fd17b8db83dc$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$0993fd17b8db83dc$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $0993fd17b8db83dc$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $hgNsR.default)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $hgNsR.default)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $0993fd17b8db83dc$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $kmRhJ.default)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}

});
parcelRequire.register("9VNkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73afb4e22942242c$export$2e2bcd8739ae039; });
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $73afb4e22942242c$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRequire.register("7zZyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $584b8d9179ceff3e$export$2e2bcd8739ae039; });

var $bWkFo = parcelRequire("bWkFo");
var $584b8d9179ceff3e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $584b8d9179ceff3e$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($584b8d9179ceff3e$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $bWkFo.default)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}

});
parcelRequire.register("bWkFo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b15246e3d4292b7$export$2e2bcd8739ae039; });

var $2Ug2G = parcelRequire("2Ug2G");

var $hJAfV = parcelRequire("hJAfV");
function $8b15246e3d4292b7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8b15246e3d4292b7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8b15246e3d4292b7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8b15246e3d4292b7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8b15246e3d4292b7$var$_arrayLikeToArray(o, minLen);
}
function $8b15246e3d4292b7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8b15246e3d4292b7$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $2Ug2G.default)(metadata);
    var matchingCountries = [];
    for(var _iterator = $8b15246e3d4292b7$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $hJAfV.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}

});


parcelRequire.register("fCFdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5fa60698f36dd19$export$2e2bcd8739ae039; });

var $jPPOR = parcelRequire("jPPOR");

var $8OMe0 = parcelRequire("8OMe0");
function $b5fa60698f36dd19$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $jPPOR.default)(numberToParse);
    if (!(0, $jPPOR.isPhoneContextValid)(phoneContext)) throw new (0, $8OMe0.default)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $jPPOR.PLUS_SIGN)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $jPPOR.RFC3966_PREFIX_));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $jPPOR.RFC3966_PREFIX_).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $jPPOR.RFC3966_PHONE_CONTEXT_));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $jPPOR.RFC3966_ISDN_SUBADDRESS_));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}

});
parcelRequire.register("jPPOR", function(module, exports) {

$parcel$export(module.exports, "PLUS_SIGN", function () { return $e70af9f725ae2b25$export$1ddc7eed78155f68; });
$parcel$export(module.exports, "RFC3966_PREFIX_", function () { return $e70af9f725ae2b25$export$70d485ce3f6de783; });
$parcel$export(module.exports, "RFC3966_PHONE_CONTEXT_", function () { return $e70af9f725ae2b25$export$f6d5879d582c3a27; });
$parcel$export(module.exports, "RFC3966_ISDN_SUBADDRESS_", function () { return $e70af9f725ae2b25$export$9e356e12edb00a81; });
$parcel$export(module.exports, "default", function () { return $e70af9f725ae2b25$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isPhoneContextValid", function () { return $e70af9f725ae2b25$export$474a4aa22ad6959a; });
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $7am3F = parcelRequire("7am3F");
var $e70af9f725ae2b25$export$1ddc7eed78155f68 = "+";
var $e70af9f725ae2b25$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $e70af9f725ae2b25$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $7am3F.VALID_DIGITS) + "]" + "|" + $e70af9f725ae2b25$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $e70af9f725ae2b25$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $e70af9f725ae2b25$export$1ddc7eed78155f68 + $e70af9f725ae2b25$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $7am3F.VALID_DIGITS) + "]" + $e70af9f725ae2b25$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $e70af9f725ae2b25$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($e70af9f725ae2b25$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $e70af9f725ae2b25$var$ALPHANUM_ = (0, $7am3F.VALID_DIGITS);
var $e70af9f725ae2b25$var$RFC3966_DOMAINLABEL_ = "[" + $e70af9f725ae2b25$var$ALPHANUM_ + "]+((\\-)*[" + $e70af9f725ae2b25$var$ALPHANUM_ + "])*";
var $e70af9f725ae2b25$var$VALID_ALPHA_ = "a-zA-Z";
var $e70af9f725ae2b25$var$RFC3966_TOPLABEL_ = "[" + $e70af9f725ae2b25$var$VALID_ALPHA_ + "]+((\\-)*[" + $e70af9f725ae2b25$var$ALPHANUM_ + "])*";
var $e70af9f725ae2b25$var$RFC3966_DOMAINNAME_ = "^(" + $e70af9f725ae2b25$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $e70af9f725ae2b25$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $e70af9f725ae2b25$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($e70af9f725ae2b25$var$RFC3966_DOMAINNAME_, "g");
var $e70af9f725ae2b25$export$70d485ce3f6de783 = "tel:";
var $e70af9f725ae2b25$export$f6d5879d582c3a27 = ";phone-context=";
var $e70af9f725ae2b25$export$9e356e12edb00a81 = ";isub=";
function $e70af9f725ae2b25$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($e70af9f725ae2b25$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $e70af9f725ae2b25$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $e70af9f725ae2b25$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $e70af9f725ae2b25$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $e70af9f725ae2b25$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

});








parcelRequire.register("930Hd", function(module, exports) {

$parcel$export(module.exports, "Select", function () { return $f135db640a6a2bb5$export$ef9b1a59e592288f; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");

var $jmrZT = parcelRequire("jmrZT");
const $f135db640a6a2bb5$export$ef9b1a59e592288f = ({ hasLabelTop: hasLabelTop, labelTop: labelTop, labelTopRequired: labelTopRequired = false, ...props })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        children: [
            hasLabelTop && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jmrZT.InputLabelStyled), {
                required: labelTopRequired,
                children: labelTop
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jmrZT.SelectStyled), {
                ...props
            })
        ]
    });
};

});
parcelRequire.register("jmrZT", function(module, exports) {

$parcel$export(module.exports, "SelectStyled", function () { return $eb0117638ef5f355$export$3d1b056be7d139f4; });
$parcel$export(module.exports, "InputLabelStyled", function () { return $eb0117638ef5f355$export$8017afc8f549e301; });

var $6hfZk = parcelRequire("6hfZk");

var $cnEvg = parcelRequire("cnEvg");
var $jh0sD = parcelRequire("jh0sD");
let $eb0117638ef5f355$var$_ = (t)=>t, $eb0117638ef5f355$var$t, $eb0117638ef5f355$var$t1;
const $eb0117638ef5f355$export$3d1b056be7d139f4 = (0, $6hfZk.default)((0, $jh0sD.default))($eb0117638ef5f355$var$t || ($eb0117638ef5f355$var$t = $eb0117638ef5f355$var$_`
    background-color: #fff;
    width: 100%;

    & .MuiOutlinedInput-notchedOutline {
        border-color: transparent !important;
        box-shadow: var(--default-boxShadow);
    }

    & .Mui-error {
        border: 1px solid red;
        background: #ffebee;
    }

    & .MuiSelect-select {
        display: flex;
        gap: 10px;
        align-items: center;
    }
`));
const $eb0117638ef5f355$export$8017afc8f549e301 = (0, $6hfZk.default)((0, $cnEvg.default))($eb0117638ef5f355$var$t1 || ($eb0117638ef5f355$var$t1 = $eb0117638ef5f355$var$_`
    line-height: 2rem;
    color: var(--custom-secondary);
    font-size: 1rem;

    &.MuiInputlabel-asterisk {
        color: red;
    }

    &.Mui-focused {
        color: var(--custom-secondary);
    }
`));

});


parcelRequire.register("1aJMc", function(module, exports) {

$parcel$export(module.exports, "findMatches", function () { return $205dc8b81012aadb$export$f4585c00f32d9257; });
$parcel$export(module.exports, "compareValues", function () { return $205dc8b81012aadb$export$6ab1df3197f7c641; });
$parcel$export(module.exports, "findAreaNameById", function () { return $205dc8b81012aadb$export$e8d907b69e582e19; });
$parcel$export(module.exports, "getAreaCategories", function () { return $205dc8b81012aadb$export$61b7979b9581dc7d; });
$parcel$export(module.exports, "getSelectedAreaInfo", function () { return $205dc8b81012aadb$export$38d9b8e132d5f3bb; });
$parcel$export(module.exports, "generateOpeningHours", function () { return $205dc8b81012aadb$export$c5a06db2eb51d1e3; });

var $8m7Fi = parcelRequire("8m7Fi");

var $5x2Vb = parcelRequire("5x2Vb");

var $5Bnf5 = parcelRequire("5Bnf5");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5x2Vb))));
const $205dc8b81012aadb$export$b29f828819edca8d = (array, callback)=>{
    return array.reduce((acc, e)=>{
        acc[callback(e) ? 0 : 1].push(e);
        return acc;
    }, [
        [],
        []
    ]);
};
const $205dc8b81012aadb$export$f4585c00f32d9257 = (selectedDomains, organizationObj)=>{
    const objectMatch = organizationObj.filter((object)=>{
        const smallCaps = object.domain.toLowerCase();
        return selectedDomains.includes(smallCaps);
    });
    const ids = objectMatch.map((obj)=>obj.id);
    return ids;
};
const $205dc8b81012aadb$export$6ab1df3197f7c641 = (a, b)=>{
    if (a.length !== b.length) return false;
    else {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
};
const $205dc8b81012aadb$export$e8d907b69e582e19 = (id, objectArray)=>{
    const matchingObject = objectArray.find((obj)=>obj.id === id);
    return matchingObject ? matchingObject.name : undefined;
};
const $205dc8b81012aadb$export$f4e6240e41111341 = (data)=>{
    const setUsers = new Set();
    data.forEach((item)=>{
        if (item.name && !setUsers.has(item.name)) setUsers.add(item.name);
        if (item.payedBy && item.payedBy.name && !setUsers.has(item.payedBy.name)) setUsers.add(item.payedBy.name);
        if (item.canceledBy && item.canceledBy.name && !setUsers.has(item.canceledBy.name)) setUsers.add(item.canceledBy.name);
        if (item.CreatedBy && item.CreatedBy.name && !setUsers.has(item.CreatedBy.name)) setUsers.add(item.CreatedBy.name);
    });
    return Array.from(setUsers);
};
const $205dc8b81012aadb$export$61b7979b9581dc7d = (areas, id)=>{
    const foundArea = areas === null || areas === void 0 ? void 0 : areas.find((area)=>area.id === id);
    // Check if the area with the given ID is found
    if (foundArea) return foundArea.AreaCategory;
    else return null;
};
const $205dc8b81012aadb$export$38d9b8e132d5f3bb = (areas, id)=>{
    const foundArea = areas === null || areas === void 0 ? void 0 : areas.find((area)=>area.id === id);
    // Check if the area with the given ID is found
    if (foundArea) return foundArea;
    else return null;
};
const $205dc8b81012aadb$export$7ad3f9cfefb05c3d = (openingHours, targetWeekday)=>{
    const targetDay = targetWeekday.toUpperCase();
    const matchingOpening = openingHours.find((hours)=>hours.openDay === targetDay);
    if (matchingOpening) {
        const fromTime = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(matchingOpening.from).utc().format("HH:mm");
        const toTime = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(matchingOpening.to).utc().format("HH:mm");
        return {
            from: fromTime,
            to: toTime
        };
    }
    return []; // No matching opening hours for the specified weekday
};
const $205dc8b81012aadb$export$c5a06db2eb51d1e3 = (areaSchedules, weekday)=>{
    // Find the schedule for the specified weekday
    const schedule = areaSchedules === null || areaSchedules === void 0 ? void 0 : areaSchedules.find((schedule)=>schedule.openDay === weekday.toUpperCase());
    // If no specific schedule is found, use default hours
    const defaultHours = {
        from: "1970-01-01T00:00:00.000Z",
        to: "1970-01-01T23:00:00.000Z"
    };
    const hours = schedule ? {
        from: schedule.from,
        to: schedule.to
    } : defaultHours;
    // Convert hours to numbers
    const fromHour = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(hours.from).utc().format("HH");
    const toHour = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(hours.to).utc().format("HH");
    return {
        from: fromHour,
        to: toHour
    };
};

});
parcelRequire.register("5x2Vb", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, v = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", h = +e;
            return (o.utc(v).valueOf() - (h -= h % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n = this.utcOffset(), i = this.toDate(), a = i.toLocaleString("en-US", {
                timeZone: t
            }), u = Math.round((i - new Date(a)) / 1e3 / 60), f = o(a).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - u, !0);
            if (e) {
                var s = f.utcOffset();
                f = f.add(n - s, "minute");
            }
            return f.$x.$timezone = t, f;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"));
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

});


parcelRequire.register("6F4ic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d99e6d55ec7d57a$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $93Yyz = parcelRequire("93Yyz");

var $6O8LD = parcelRequire("6O8LD");

var $iW8lA = parcelRequire("iW8lA");

var $ijlR1 = parcelRequire("ijlR1");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $79tmb = parcelRequire("79tmb");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4d99e6d55ec7d57a$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $4d99e6d55ec7d57a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $79tmb.getCheckboxUtilityClass), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $4d99e6d55ec7d57a$var$CheckboxRoot = (0, $kDBhE.default)((0, $93Yyz.default), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $79tmb.default).checked}, &.${(0, $79tmb.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $79tmb.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $4d99e6d55ec7d57a$var$defaultCheckedIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iW8lA.default), {});
const $4d99e6d55ec7d57a$var$defaultIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6O8LD.default), {});
const $4d99e6d55ec7d57a$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ijlR1.default), {});
const $4d99e6d55ec7d57a$var$Checkbox = /*#__PURE__*/ $7fPBF.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $4d99e6d55ec7d57a$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $4d99e6d55ec7d57a$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $4d99e6d55ec7d57a$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $cFLic.default)(props, $4d99e6d55ec7d57a$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $4d99e6d55ec7d57a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4d99e6d55ec7d57a$var$CheckboxRoot, (0, $kY3Ke.default)({
        type: "checkbox",
        inputProps: (0, $kY3Ke.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $4d99e6d55ec7d57a$export$2e2bcd8739ae039 = $4d99e6d55ec7d57a$var$Checkbox;

});
parcelRequire.register("93Yyz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69935e2350f58c79$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $568MF = parcelRequire("568MF");

var $2jx1n = parcelRequire("2jx1n");

var $3RNaF = parcelRequire("3RNaF");

var $7EAHX = parcelRequire("7EAHX");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $69935e2350f58c79$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $69935e2350f58c79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $b6UUh.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7EAHX.getSwitchBaseUtilityClass), classes);
};
const $69935e2350f58c79$var$SwitchBaseRoot = (0, $kDBhE.default)((0, $3RNaF.default))(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $69935e2350f58c79$var$SwitchBaseInput = (0, $kDBhE.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $69935e2350f58c79$var$SwitchBase = /*#__PURE__*/ $7fPBF.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $cFLic.default)(props, $69935e2350f58c79$var$_excluded);
    const [checked, setCheckedState] = (0, $568MF.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $2jx1n.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $69935e2350f58c79$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($69935e2350f58c79$var$SwitchBaseRoot, (0, $kY3Ke.default)({
        component: "span",
        className: (0, $hngXp.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($69935e2350f58c79$var$SwitchBaseInput, (0, $kY3Ke.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $69935e2350f58c79$export$2e2bcd8739ae039 = $69935e2350f58c79$var$SwitchBase;

});
parcelRequire.register("7EAHX", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", function () { return $5928be47f00793d2$export$baa0faa0c7ad8085; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5928be47f00793d2$export$baa0faa0c7ad8085(slot) {
    return (0, $k6RDS.default)("PrivateSwitchBase", slot);
}
const $5928be47f00793d2$var$switchBaseClasses = (0, $4jzsB.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $5928be47f00793d2$export$2e2bcd8739ae039 = $5928be47f00793d2$var$switchBaseClasses;

});


parcelRequire.register("6O8LD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f4e3692f5c75417$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $4f4e3692f5c75417$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRequire.register("iW8lA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc941e595b205c8e$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $dc941e595b205c8e$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRequire.register("ijlR1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d54af422e767409d$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $d54af422e767409d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRequire.register("79tmb", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", function () { return $5350254b5a4e1ee2$export$6c57c6e16b4063b; });
$parcel$export(module.exports, "default", function () { return $5350254b5a4e1ee2$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5350254b5a4e1ee2$export$6c57c6e16b4063b(slot) {
    return (0, $k6RDS.default)("MuiCheckbox", slot);
}
const $5350254b5a4e1ee2$var$checkboxClasses = (0, $4jzsB.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $5350254b5a4e1ee2$export$2e2bcd8739ae039 = $5350254b5a4e1ee2$var$checkboxClasses;

});


parcelRequire.register("2hGJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9e4fb2f535b4c3$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $aw34v = parcelRequire("aw34v");

var $6NwTb = parcelRequire("6NwTb");


var $b6UUh = parcelRequire("b6UUh");

var $3RNaF = parcelRequire("3RNaF");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $i8YSp = parcelRequire("i8YSp");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $1a9e4fb2f535b4c3$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $1a9e4fb2f535b4c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $b6UUh.default)(size)}`,
            `color${(0, $b6UUh.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $b6UUh.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $b6UUh.default)(color)}`,
            `${variant}${(0, $b6UUh.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $b6UUh.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $b6UUh.default)(size)}`,
            `avatarColor${(0, $b6UUh.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $b6UUh.default)(size)}`,
            `iconColor${(0, $b6UUh.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $b6UUh.default)(size)}`,
            `deleteIconColor${(0, $b6UUh.default)(color)}`,
            `deleteIcon${(0, $b6UUh.default)(variant)}Color${(0, $b6UUh.default)(color)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $i8YSp.getChipUtilityClass), classes);
};
const $1a9e4fb2f535b4c3$var$ChipRoot = (0, $kDBhE.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $i8YSp.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $i8YSp.default).avatar}`]: styles[`avatar${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $i8YSp.default).avatar}`]: styles[`avatarColor${(0, $b6UUh.default)(color)}`]
            },
            {
                [`& .${(0, $i8YSp.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $i8YSp.default).icon}`]: styles[`icon${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $i8YSp.default).icon}`]: styles[`iconColor${(0, $b6UUh.default)(iconColor)}`]
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles[`deleteIcon${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles[`deleteIconColor${(0, $b6UUh.default)(color)}`]
            },
            {
                [`& .${(0, $i8YSp.default).deleteIcon}`]: styles[`deleteIcon${(0, $b6UUh.default)(variant)}Color${(0, $b6UUh.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $b6UUh.default)(size)}`],
            styles[`color${(0, $b6UUh.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $b6UUh.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $b6UUh.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $b6UUh.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $kY3Ke.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $i8YSp.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $i8YSp.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $i8YSp.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $i8YSp.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $i8YSp.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $i8YSp.default).icon}`]: (0, $kY3Ke.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $kY3Ke.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $i8YSp.default).deleteIcon}`]: (0, $kY3Ke.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $cxeT8.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $cxeT8.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $i8YSp.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $i8YSp.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $i8YSp.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $i8YSp.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $i8YSp.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $i8YSp.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $i8YSp.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $i8YSp.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $i8YSp.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $i8YSp.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $cxeT8.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $1a9e4fb2f535b4c3$var$ChipLabel = (0, $kDBhE.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $b6UUh.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $1a9e4fb2f535b4c3$var$Chip = /*#__PURE__*/ $7fPBF.forwardRef(function Chip(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $cFLic.default)(props, $1a9e4fb2f535b4c3$var$_excluded);
    const chipRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $1a9e4fb2f535b4c3$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $3RNaF.default) : ComponentProp || "div";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $1a9e4fb2f535b4c3$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $3RNaF.default) ? (0, $kY3Ke.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $7fPBF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(deleteIconProp, {
        className: (0, $hngXp.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aw34v.default), {
        className: (0, $hngXp.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $7fPBF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $7fPBF.cloneElement(avatarProp, {
        className: (0, $hngXp.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $7fPBF.isValidElement(iconProp)) icon = /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $hngXp.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($1a9e4fb2f535b4c3$var$ChipRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $bbzbN.jsx)($1a9e4fb2f535b4c3$var$ChipLabel, {
                className: (0, $hngXp.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $1a9e4fb2f535b4c3$export$2e2bcd8739ae039 = $1a9e4fb2f535b4c3$var$Chip;

});
parcelRequire.register("aw34v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a7f4684365c8e73$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $7a7f4684365c8e73$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

});

parcelRequire.register("i8YSp", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", function () { return $d358322d03e9d644$export$31444911e4ee6fdd; });
$parcel$export(module.exports, "default", function () { return $d358322d03e9d644$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d358322d03e9d644$export$31444911e4ee6fdd(slot) {
    return (0, $k6RDS.default)("MuiChip", slot);
}
const $d358322d03e9d644$var$chipClasses = (0, $4jzsB.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $d358322d03e9d644$export$2e2bcd8739ae039 = $d358322d03e9d644$var$chipClasses;

});


parcelRequire.register("5Ju9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c22cb4ec1bd83192$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $4kQoR = parcelRequire("4kQoR");

var $huHez = parcelRequire("huHez");

var $2Q0LP = parcelRequire("2Q0LP");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $eYKx4 = parcelRequire("eYKx4");
var $iXs1l = parcelRequire("iXs1l");
const $c22cb4ec1bd83192$var$MUIDatePicker = ({ label: label, onChange: onChange, name: name, error: error, disablePast: disablePast = true, disableFuture: disableFuture = false })=>{
    const { i18n: i18n } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $huHez.LocalizationProvider), {
        dateAdapter: (0, $4kQoR.AdapterDayjs),
        adapterLocale: i18n.language,
        localeText: i18n.language === "pt" ? (0, $iXs1l.ptBR).components.MuiLocalizationProvider.defaultProps.localeText : (0, $eYKx4.enUS).components.MuiLocalizationProvider.defaultProps.localeText,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2Q0LP.StyledDatePicker), {
            format: "DD-MM-YYYY",
            label: label,
            disablePast: disablePast,
            disableFuture: disableFuture,
            slotProps: {
                textField: {
                    name: name
                }
            },
            onChange: onChange,
            sx: {
                border: error ? "1px solid red !important" : "#fff",
                backgroundColor: error ? "#ffebee !important" : "#fff"
            }
        })
    });
};
var $c22cb4ec1bd83192$export$2e2bcd8739ae039 = $c22cb4ec1bd83192$var$MUIDatePicker;

});
parcelRequire.register("4kQoR", function(module, exports) {

$parcel$export(module.exports, "AdapterDayjs", function () { return $3281ad3dbde45caa$export$33545c6a80bae043; });

var $kY3Ke = parcelRequire("kY3Ke");

var $8m7Fi = parcelRequire("8m7Fi");

var $8qXmG = parcelRequire("8qXmG");

var $kS304 = parcelRequire("kS304");

var $aF4df = parcelRequire("aF4df");

var $97Jiy = parcelRequire("97Jiy");

var $leDcR = parcelRequire("leDcR");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($kS304))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($aF4df))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($97Jiy))));
const $3281ad3dbde45caa$var$localeNotFoundWarning = (0, $leDcR.buildWarning)([
    "Your locale has not been found.",
    "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale",
    "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'",
    "fallback on English locale"
]);
const $3281ad3dbde45caa$var$formatTokenMap = {
    // Year
    YY: "year",
    YYYY: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    // Month
    M: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    MM: "month",
    MMM: {
        sectionType: "month",
        contentType: "letter"
    },
    MMMM: {
        sectionType: "month",
        contentType: "letter"
    },
    // Day of the month
    D: {
        sectionType: "day",
        contentType: "digit",
        maxLength: 2
    },
    DD: "day",
    Do: {
        sectionType: "day",
        contentType: "digit-with-letter"
    },
    // Day of the week
    d: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 2
    },
    dd: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    ddd: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    dddd: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    // Meridiem
    A: "meridiem",
    a: "meridiem",
    // Hours
    H: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    HH: "hours",
    h: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    hh: "hours",
    // Minutes
    m: {
        sectionType: "minutes",
        contentType: "digit",
        maxLength: 2
    },
    mm: "minutes",
    // Seconds
    s: {
        sectionType: "seconds",
        contentType: "digit",
        maxLength: 2
    },
    ss: "seconds"
};
const $3281ad3dbde45caa$var$defaultFormats = {
    year: "YYYY",
    month: "MMMM",
    monthShort: "MMM",
    dayOfMonth: "D",
    weekday: "dddd",
    weekdayShort: "ddd",
    hours24h: "HH",
    hours12h: "hh",
    meridiem: "A",
    minutes: "mm",
    seconds: "ss",
    fullDate: "ll",
    fullDateWithWeekday: "dddd, LL",
    keyboardDate: "L",
    shortDate: "MMM D",
    normalDate: "D MMMM",
    normalDateWithWeekday: "ddd, MMM D",
    monthAndYear: "MMMM YYYY",
    monthAndDate: "MMMM D",
    fullTime: "LT",
    fullTime12h: "hh:mm A",
    fullTime24h: "HH:mm",
    fullDateTime: "lll",
    fullDateTime12h: "ll hh:mm A",
    fullDateTime24h: "ll HH:mm",
    keyboardDateTime: "L LT",
    keyboardDateTime12h: "L hh:mm A",
    keyboardDateTime24h: "L HH:mm"
};
const $3281ad3dbde45caa$var$MISSING_UTC_PLUGIN = [
    "Missing UTC plugin",
    "To be able to use UTC or timezones, you have to enable the `utc` plugin",
    "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"
].join("\n");
const $3281ad3dbde45caa$var$MISSING_TIMEZONE_PLUGIN = [
    "Missing timezone plugin",
    "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin",
    "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"
].join("\n");
const $3281ad3dbde45caa$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $3281ad3dbde45caa$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats, instance: instance } = {}){
        var _this$rawDayJsInstanc;
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = "dayjs";
        this.rawDayJsInstance = void 0;
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: "[",
            end: "]"
        };
        this.formatTokenMap = $3281ad3dbde45caa$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        };
        this.hasUTCPlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc !== "undefined";
        this.hasTimezonePlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz !== "undefined";
        this.isSame = (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        };
        /**
     * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
     */ this.cleanTimezone = (timezone)=>{
            switch(timezone){
                case "default":
                    return undefined;
                case "system":
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz.guess();
                default:
                    return timezone;
            }
        };
        this.createSystemDate = (value)=>{
            // TODO v7: Stop using `this.rawDayJsInstance` (drop the `instance` param on the adapters)
            /* istanbul ignore next */ if (this.rawDayJsInstance) return this.rawDayJsInstance(value);
            if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
                const timezone = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz.guess();
                // We can't change the system timezone in the tests
                /* istanbul ignore next */ if (timezone !== "UTC") return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz(value, timezone);
                return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(value);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(value);
        };
        this.createUTCDate = (value)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_UTC_PLUGIN);
            return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(value);
        };
        this.createTZDate = (value, timezone)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_UTC_PLUGIN);
            /* istanbul ignore next */ if (!this.hasTimezonePlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_TIMEZONE_PLUGIN);
            const keepLocalTime = value !== undefined && !value.endsWith("Z");
            return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(value).tz(this.cleanTimezone(timezone), keepLocalTime);
        };
        this.getLocaleFormats = ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).Ls;
            const locale = this.locale || "en";
            let localeObject = locales[locale];
            if (localeObject === undefined) {
                $3281ad3dbde45caa$var$localeNotFoundWarning();
                localeObject = locales.en;
            }
            return localeObject.formats;
        };
        /**
     * If the new day does not have the same offset as the old one (when switching to summer day time for example),
     * Then dayjs will not automatically adjust the offset (moment does).
     * We have to parse again the value to make sure the `fixOffset` method is applied.
     * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
     */ this.adjustOffset = (value)=>{
            if (!this.hasTimezonePlugin()) return value;
            const timezone = this.getTimezone(value);
            if (timezone !== "UTC") {
                var _fixedValue$$offset, _value$$offset;
                const fixedValue = value.tz(this.cleanTimezone(timezone), true);
                // @ts-ignore
                if (((_fixedValue$$offset = fixedValue.$offset) != null ? _fixedValue$$offset : 0) === ((_value$$offset = value.$offset) != null ? _value$$offset : 0)) return value;
                return fixedValue;
            }
            return value;
        };
        this.date = (value)=>{
            if (value === null) return null;
            return this.dayjs(value);
        };
        this.dateWithTimezone = (value, timezone)=>{
            if (value === null) return null;
            let parsedValue;
            if (timezone === "UTC") parsedValue = this.createUTCDate(value);
            else if (timezone === "system" || timezone === "default" && !this.hasTimezonePlugin()) parsedValue = this.createSystemDate(value);
            else parsedValue = this.createTZDate(value, timezone);
            if (this.locale === undefined) return parsedValue;
            return parsedValue.locale(this.locale);
        };
        this.getTimezone = (value)=>{
            if (this.hasUTCPlugin() && value.isUTC()) return "UTC";
            if (this.hasTimezonePlugin()) {
                var _value$$x;
                // @ts-ignore
                const zone = (_value$$x = value.$x) == null ? void 0 : _value$$x.$timezone;
                return zone != null ? zone : "system";
            }
            return "system";
        };
        this.setTimezone = (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === "UTC") {
                /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($3281ad3dbde45caa$var$MISSING_UTC_PLUGIN);
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === "system") return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === "default") return value;
                /* istanbul ignore next */ throw new Error($3281ad3dbde45caa$var$MISSING_TIMEZONE_PLUGIN);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz(value, this.cleanTimezone(timezone));
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parseISO = (isoString)=>{
            return this.dayjs(isoString);
        };
        this.toISO = (value)=>{
            return value.toISOString();
        };
        this.parse = (value, format)=>{
            if (value === "") return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || "en";
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || "");
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/a/gi, "(a|p)m").toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.isValid = (value)=>{
            return this.dayjs(value).isValid();
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return this.dayjs(value).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (value, comparing, unit)=>{
            return value.diff(comparing, unit);
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return this.dayjs(value).toDate().getTime() === this.dayjs(comparing).toDate().getTime();
        };
        this.isSameYear = (value, comparing)=>{
            return this.isSame(value, comparing, "YYYY");
        };
        this.isSameMonth = (value, comparing)=>{
            return this.isSame(value, comparing, "YYYY-MM");
        };
        this.isSameDay = (value, comparing)=>{
            return this.isSame(value, comparing, "YYYY-MM-DD");
        };
        this.isSameHour = (value, comparing)=>{
            return value.isSame(comparing, "hour");
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, "year");
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        };
        this.isAfterDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, "day");
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, "year");
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        };
        this.isBeforeDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, "day");
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        };
        this.isWithinRange = (value, [start, end])=>{
            return value >= start && value <= end;
        };
        this.startOfYear = (value)=>{
            return this.adjustOffset(value.startOf("year"));
        };
        this.startOfMonth = (value)=>{
            return this.adjustOffset(value.startOf("month"));
        };
        this.startOfWeek = (value)=>{
            return this.adjustOffset(value.startOf("week"));
        };
        this.startOfDay = (value)=>{
            return this.adjustOffset(value.startOf("day"));
        };
        this.endOfYear = (value)=>{
            return this.adjustOffset(value.endOf("year"));
        };
        this.endOfMonth = (value)=>{
            return this.adjustOffset(value.endOf("month"));
        };
        this.endOfWeek = (value)=>{
            return this.adjustOffset(value.endOf("week"));
        };
        this.endOfDay = (value)=>{
            return this.adjustOffset(value.endOf("day"));
        };
        this.addYears = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "year") : value.add(amount, "year"));
        };
        this.addMonths = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "month") : value.add(amount, "month"));
        };
        this.addWeeks = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "week") : value.add(amount, "week"));
        };
        this.addDays = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "day") : value.add(amount, "day"));
        };
        this.addHours = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "hour") : value.add(amount, "hour"));
        };
        this.addMinutes = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "minute") : value.add(amount, "minute"));
        };
        this.addSeconds = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "second") : value.add(amount, "second"));
        };
        this.getYear = (value)=>{
            return value.year();
        };
        this.getMonth = (value)=>{
            return value.month();
        };
        this.getDate = (value)=>{
            return value.date();
        };
        this.getHours = (value)=>{
            return value.hour();
        };
        this.getMinutes = (value)=>{
            return value.minute();
        };
        this.getSeconds = (value)=>{
            return value.second();
        };
        this.getMilliseconds = (value)=>{
            return value.millisecond();
        };
        this.setYear = (value, year)=>{
            return this.adjustOffset(value.set("year", year));
        };
        this.setMonth = (value, month)=>{
            return this.adjustOffset(value.set("month", month));
        };
        this.setDate = (value, date)=>{
            return this.adjustOffset(value.set("date", date));
        };
        this.setHours = (value, hours)=>{
            return this.adjustOffset(value.set("hour", hours));
        };
        this.setMinutes = (value, minutes)=>{
            return this.adjustOffset(value.set("minute", minutes));
        };
        this.setSeconds = (value, seconds)=>{
            return this.adjustOffset(value.set("second", seconds));
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return this.adjustOffset(value.set("millisecond", milliseconds));
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth();
        };
        this.getNextMonth = (value)=>{
            return this.addMonths(value, 1);
        };
        this.getPreviousMonth = (value)=>{
            return this.addMonths(value, -1);
        };
        this.getMonthArray = (value)=>{
            const firstMonth = value.startOf("year");
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.addMonths(prevMonth, 1));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return dateParam.hour(timeParam.hour()).minute(timeParam.minute()).second(timeParam.second());
        };
        this.getWeekdays = ()=>{
            const start = this.dayjs().startOf("week");
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map((diff)=>this.formatByString(this.addDays(start, diff), "dd"));
        };
        this.getWeekArray = (value)=>{
            const cleanValue = this.setLocaleToValue(value);
            const start = cleanValue.startOf("month").startOf("week");
            const end = cleanValue.endOf("month").endOf("week");
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return value.week();
        };
        this.getYearRange = (start, end)=>{
            const startDate = start.startOf("year");
            const endDate = end.endOf("year");
            const years = [];
            let current = startDate;
            while(current < endDate){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.rawDayJsInstance = instance;
        this.dayjs = $3281ad3dbde45caa$var$withLocale((_this$rawDayJsInstanc = this.rawDayJsInstance) != null ? _this$rawDayJsInstanc : (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))), _locale);
        this.locale = _locale;
        this.formats = (0, $kY3Ke.default)({}, $3281ad3dbde45caa$var$defaultFormats, formats);
        (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($8qXmG))));
    }
}

});
parcelRequire.register("8qXmG", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

});

parcelRequire.register("kS304", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var a = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, f = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], h = function(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = function(e, t) {
        var n, r = o.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, d = {
        A: [
            i,
            function(e) {
                this.afternoon = u(e, !1);
            }
        ],
        a: [
            i,
            function(e) {
                this.afternoon = u(e, !0);
            }
        ],
        S: [
            /\d/,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            n,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            r,
            a("seconds")
        ],
        ss: [
            r,
            a("seconds")
        ],
        m: [
            r,
            a("minutes")
        ],
        mm: [
            r,
            a("minutes")
        ],
        H: [
            r,
            a("hours")
        ],
        h: [
            r,
            a("hours")
        ],
        HH: [
            r,
            a("hours")
        ],
        hh: [
            r,
            a("hours")
        ],
        D: [
            r,
            a("day")
        ],
        DD: [
            n,
            a("day")
        ],
        Do: [
            i,
            function(e) {
                var t = o.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        M: [
            r,
            a("month")
        ],
        MM: [
            n,
            a("month")
        ],
        MMM: [
            i,
            function(e) {
                var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            i,
            function(e) {
                var t = h("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            a("year")
        ],
        YY: [
            n,
            function(e) {
                this.year = s(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            a("year")
        ],
        Z: f,
        ZZ: f
    };
    function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = s.length, f = 0; f < a; f += 1){
            var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
            s[f] = l ? {
                regex: c,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = s[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, s = e.args;
            this.$u = r;
            var a = s[1];
            if ("string" == typeof a) {
                var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                        i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                        var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                        return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
            } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                s[1] = a[m - 1];
                var M = n.apply(this, s);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === l && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRequire.register("aF4df", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

});

parcelRequire.register("97Jiy", function(module, exports) {
!function(e, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});

});

parcelRequire.register("leDcR", function(module, exports) {

$parcel$export(module.exports, "buildWarning", function () { return $f75951614efca4a8$export$baf331755d84b871; });
const $f75951614efca4a8$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $f75951614efca4a8$export$baf331755d84b871 = (message, gravity = "warning")=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === "error") console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};

});


parcelRequire.register("huHez", function(module, exports) {

$parcel$export(module.exports, "MuiPickersAdapterContext", function () { return $cbc6c65ed9f8bf86$export$544976378534cf9; });
$parcel$export(module.exports, "LocalizationProvider", function () { return $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
const $cbc6c65ed9f8bf86$var$_excluded = [
    "localeText"
];
const $cbc6c65ed9f8bf86$export$544976378534cf9 = /*#__PURE__*/ $7fPBF.createContext(null);
const $cbc6c65ed9f8bf86$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $cFLic.default)(inProps, $cbc6c65ed9f8bf86$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $7fPBF.useContext($cbc6c65ed9f8bf86$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $5j2OD.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $7fPBF.useMemo(()=>(0, $kY3Ke.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $7fPBF.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            "MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`",
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $7fPBF.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $7fPBF.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($cbc6c65ed9f8bf86$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};

});

parcelRequire.register("2Q0LP", function(module, exports) {

$parcel$export(module.exports, "StyledDatePicker", function () { return $670f6a1b19fa6c8b$export$fe6e7db83e51bd64; });

var $lNdSG = parcelRequire("lNdSG");

var $6hfZk = parcelRequire("6hfZk");
const $670f6a1b19fa6c8b$export$fe6e7db83e51bd64 = (0, $6hfZk.default)((0, $lNdSG.DatePicker))(()=>({
        backgroundColor: "#fff",
        border: "transparent",
        borderRadius: "4px",
        boxShadow: "var(--default-boxShadow)",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent !important"
        }
    }));

});
parcelRequire.register("lNdSG", function(module, exports) {

$parcel$export(module.exports, "DatePicker", function () { return $fdd8f108deea5d70$export$5109c6dd95d8fb00; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $kspUS = parcelRequire("kspUS");

var $5j2OD = parcelRequire("5j2OD");

var $jMajc = parcelRequire("jMajc");

var $GTCV3 = parcelRequire("GTCV3");

var $jpuvJ = parcelRequire("jpuvJ");

var $bbzbN = parcelRequire("bbzbN");
const $fdd8f108deea5d70$var$_excluded = [
    "desktopModeMediaQuery"
];
const $fdd8f108deea5d70$export$5109c6dd95d8fb00 = /*#__PURE__*/ $7fPBF.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDatePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $jpuvJ.DEFAULT_DESKTOP_MODE_MEDIA_QUERY) } = props, other = (0, $cFLic.default)(props, $fdd8f108deea5d70$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $kspUS.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jMajc.DesktopDatePicker), (0, $kY3Ke.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $GTCV3.MobileDatePicker), (0, $kY3Ke.default)({
        ref: ref
    }, other));
});

});
parcelRequire.register("jMajc", function(module, exports) {

$parcel$export(module.exports, "DesktopDatePicker", function () { return $03b7231526638e49$export$5a73641f0156e1e4; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $dUIft = parcelRequire("dUIft");

var $blfb5 = parcelRequire("blfb5");

var $7cI1D = parcelRequire("7cI1D");

var $92mGG = parcelRequire("92mGG");
var $fq3Fh = parcelRequire("fq3Fh");

var $h6NE5 = parcelRequire("h6NE5");

var $3qBKp = parcelRequire("3qBKp");

var $7Fco7 = parcelRequire("7Fco7");

var $3GboI = parcelRequire("3GboI");

var $efc1W = parcelRequire("efc1W");

var $6CwGv = parcelRequire("6CwGv");
const $03b7231526638e49$export$5a73641f0156e1e4 = /*#__PURE__*/ $7fPBF.forwardRef(function DesktopDatePicker(inProps, ref) {
    var _defaultizedProps$yea, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $92mGG.useLocaleText)();
    const utils = (0, $92mGG.useUtils)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $7cI1D.useDatePickerDefaultizedProps)(inProps, "MuiDesktopDatePicker");
    const viewRenderers = (0, $kY3Ke.default)({
        day: (0, $efc1W.renderDateViewCalendar),
        month: (0, $efc1W.renderDateViewCalendar),
        year: (0, $efc1W.renderDateViewCalendar)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $kY3Ke.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $6CwGv.resolveDateFormat)(utils, defaultizedProps, false),
        yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
        slots: (0, $kY3Ke.default)({
            openPickerIcon: (0, $3qBKp.CalendarIcon),
            field: (0, $7Fco7.DateField)
        }, defaultizedProps.slots),
        slotProps: (0, $kY3Ke.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $kY3Ke.default)({}, (0, $dUIft.resolveComponentProps)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $3GboI.extractValidationProps)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $kY3Ke.default)({
                hidden: true
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $h6NE5.useDesktopPicker)({
        props: props,
        valueManager: (0, $blfb5.singleItemValueManager),
        valueType: "date",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $fq3Fh.validateDate)
    });
    return renderPicker();
});
$03b7231526638e49$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
        })
    ]),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "day",
        "month",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        3,
        4
    ])
};

});
parcelRequire.register("blfb5", function(module, exports) {

$parcel$export(module.exports, "singleItemValueManager", function () { return $841d6de1e4809c9b$export$2764b246aa3b75ba; });
$parcel$export(module.exports, "singleItemFieldValueManager", function () { return $841d6de1e4809c9b$export$b602c94f557316b4; });

var $cFLic = parcelRequire("cFLic");

var $6CwGv = parcelRequire("6CwGv");

var $kh1ja = parcelRequire("kh1ja");

var $ab9wb = parcelRequire("ab9wb");
const $841d6de1e4809c9b$var$_excluded = [
    "value",
    "referenceDate"
];
const $841d6de1e4809c9b$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $6CwGv.getTodayDate),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $cFLic.default)(_ref, $841d6de1e4809c9b$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $kh1ja.getDefaultReferenceDate)(params);
    },
    cleanValue: (0, $6CwGv.replaceInvalidDateByNull),
    areValuesEqual: (0, $6CwGv.areDatesEqual),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $841d6de1e4809c9b$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return (0, $ab9wb.addPositionPropertiesToSections)(getSectionsFromDate(date), isRTL);
    },
    getValueStrFromSections: (0, $ab9wb.createDateStrForInputFromSections),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};

});
parcelRequire.register("6CwGv", function(module, exports) {

$parcel$export(module.exports, "findClosestEnabledDate", function () { return $4d1fa529a9a32e76$export$ca1f317ae8db2ee8; });
$parcel$export(module.exports, "replaceInvalidDateByNull", function () { return $4d1fa529a9a32e76$export$36ca889e039badd5; });
$parcel$export(module.exports, "applyDefaultDate", function () { return $4d1fa529a9a32e76$export$eb73579ccade48fd; });
$parcel$export(module.exports, "areDatesEqual", function () { return $4d1fa529a9a32e76$export$8fabf9a4cbada414; });
$parcel$export(module.exports, "getMonthsInYear", function () { return $4d1fa529a9a32e76$export$62591b96a734eacd; });
$parcel$export(module.exports, "mergeDateAndTime", function () { return $4d1fa529a9a32e76$export$a98b123b8f29e004; });
$parcel$export(module.exports, "getTodayDate", function () { return $4d1fa529a9a32e76$export$1118e4272ea1e258; });
$parcel$export(module.exports, "formatMeridiem", function () { return $4d1fa529a9a32e76$export$fae94c0a662107ef; });
$parcel$export(module.exports, "isDatePickerView", function () { return $4d1fa529a9a32e76$export$b32dfef9f07dea64; });
$parcel$export(module.exports, "resolveDateFormat", function () { return $4d1fa529a9a32e76$export$bb1c921f313ec928; });

var $jWPa9 = parcelRequire("jWPa9");
const $4d1fa529a9a32e76$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $4d1fa529a9a32e76$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $4d1fa529a9a32e76$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $4d1fa529a9a32e76$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $4d1fa529a9a32e76$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $4d1fa529a9a32e76$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $4d1fa529a9a32e76$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === "date" ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const $4d1fa529a9a32e76$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === "am" ? 2 : 14);
    return utils.format(date, "meridiem");
};
const $4d1fa529a9a32e76$var$dateViews = [
    "year",
    "month",
    "day"
];
const $4d1fa529a9a32e76$export$b32dfef9f07dea64 = (view)=>$4d1fa529a9a32e76$var$dateViews.includes(view);
const $4d1fa529a9a32e76$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "year"
    ])) return formats.year;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "month"
    ])) return formats.month;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "day"
    ])) return formats.dayOfMonth;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "month",
        "year"
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "day",
        "month"
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};

});
parcelRequire.register("jWPa9", function(module, exports) {

$parcel$export(module.exports, "areViewsEqual", function () { return $e85b1ef30fae45b1$export$f07872cd524bec98; });
$parcel$export(module.exports, "applyDefaultViewProps", function () { return $e85b1ef30fae45b1$export$bdf8d867ddc968e; });
const $e85b1ef30fae45b1$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $e85b1ef30fae45b1$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views != null ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error("MUI: The `views` prop must contain at least one view");
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};

});


parcelRequire.register("kh1ja", function(module, exports) {

$parcel$export(module.exports, "SECTION_TYPE_GRANULARITY", function () { return $03cf12356675f79b$export$8f74e8f4ed8ae0ac; });
$parcel$export(module.exports, "getSectionTypeGranularity", function () { return $03cf12356675f79b$export$3f2547ddf892237a; });
$parcel$export(module.exports, "getDefaultReferenceDate", function () { return $03cf12356675f79b$export$6a31d56794238e4e; });

var $hEosq = parcelRequire("hEosq");

var $6CwGv = parcelRequire("6CwGv");
const $03cf12356675f79b$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $03cf12356675f79b$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULA;
        return (_SECTION_TYPE_GRANULA = $03cf12356675f79b$export$8f74e8f4ed8ae0ac[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
    }));
const $03cf12356675f79b$export$e7c8ae702868847 = (views)=>Math.max(...views.map((view)=>{
        var _SECTION_TYPE_GRANULA2;
        return (_SECTION_TYPE_GRANULA2 = $03cf12356675f79b$export$8f74e8f4ed8ae0ac[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
    }));
const $03cf12356675f79b$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $03cf12356675f79b$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $03cf12356675f79b$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $03cf12356675f79b$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    var _props$disableIgnorin;
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $03cf12356675f79b$var$roundDate(utils, granularity, (0, $6CwGv.getTodayDate)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $hEosq.createIsAfterIgnoreDatePart)((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $6CwGv.mergeDateAndTime)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $03cf12356675f79b$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $6CwGv.mergeDateAndTime)(utils, referenceDate, props.maxTime));
    return referenceDate;
};

});
parcelRequire.register("hEosq", function(module, exports) {

$parcel$export(module.exports, "isTimeView", function () { return $cd9924d2cafbe16d$export$8f04d380cefd5a0d; });
$parcel$export(module.exports, "getMeridiem", function () { return $cd9924d2cafbe16d$export$c3352ead7b032236; });
$parcel$export(module.exports, "convertValueToMeridiem", function () { return $cd9924d2cafbe16d$export$4159dc823695870e; });
$parcel$export(module.exports, "convertToMeridiem", function () { return $cd9924d2cafbe16d$export$c368d4ff66779998; });
$parcel$export(module.exports, "createIsAfterIgnoreDatePart", function () { return $cd9924d2cafbe16d$export$fb87c80b35a46b89; });
$parcel$export(module.exports, "resolveTimeFormat", function () { return $cd9924d2cafbe16d$export$3a6776b3863772fe; });

var $jWPa9 = parcelRequire("jWPa9");
const $cd9924d2cafbe16d$var$timeViews = [
    "hours",
    "minutes",
    "seconds"
];
const $cd9924d2cafbe16d$export$8f04d380cefd5a0d = (view)=>$cd9924d2cafbe16d$var$timeViews.includes(view);
const $cd9924d2cafbe16d$export$a3328136ac50623d = (view)=>$cd9924d2cafbe16d$var$timeViews.includes(view) || view === "meridiem";
const $cd9924d2cafbe16d$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const $cd9924d2cafbe16d$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const $cd9924d2cafbe16d$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $cd9924d2cafbe16d$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $cd9924d2cafbe16d$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $cd9924d2cafbe16d$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $cd9924d2cafbe16d$export$888a1ce13aa61986(dateLeft, utils) > $cd9924d2cafbe16d$export$888a1ce13aa61986(dateRight, utils);
    };
const $cd9924d2cafbe16d$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "hours"
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "minutes"
    ])) return formats.minutes;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "seconds"
    ])) return formats.seconds;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "minutes",
        "seconds"
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $jWPa9.areViewsEqual)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};

});


parcelRequire.register("ab9wb", function(module, exports) {

$parcel$export(module.exports, "getDateSectionConfigFromFormatToken", function () { return $7692508c11d587c8$export$2f3c5fac7a2a65f6; });
$parcel$export(module.exports, "getDaysInWeekStr", function () { return $7692508c11d587c8$export$c65c7173f879039f; });
$parcel$export(module.exports, "getLetterEditingOptions", function () { return $7692508c11d587c8$export$3ee1e7e19c2b047a; });
$parcel$export(module.exports, "cleanDigitSectionValue", function () { return $7692508c11d587c8$export$ef88db4bceade9fd; });
$parcel$export(module.exports, "adjustSectionValue", function () { return $7692508c11d587c8$export$5ed0f22513e58fe3; });
$parcel$export(module.exports, "cleanString", function () { return $7692508c11d587c8$export$cb0bbc88c7f09596; });
$parcel$export(module.exports, "addPositionPropertiesToSections", function () { return $7692508c11d587c8$export$8bb5d1c9951d10ca; });
$parcel$export(module.exports, "changeSectionValueFormat", function () { return $7692508c11d587c8$export$2816862a602354ce; });
$parcel$export(module.exports, "doesSectionFormatHaveLeadingZeros", function () { return $7692508c11d587c8$export$78b5830e2dd2de49; });
$parcel$export(module.exports, "splitFormatIntoSections", function () { return $7692508c11d587c8$export$fd71d82fe42bada1; });
$parcel$export(module.exports, "getDateFromDateSections", function () { return $7692508c11d587c8$export$b0c1bfd065bfe742; });
$parcel$export(module.exports, "createDateStrForInputFromSections", function () { return $7692508c11d587c8$export$e990c4332a617e3d; });
$parcel$export(module.exports, "getSectionsBoundaries", function () { return $7692508c11d587c8$export$360600f456ea7d5f; });
$parcel$export(module.exports, "validateSections", function () { return $7692508c11d587c8$export$ef6fbc09372bd65c; });
$parcel$export(module.exports, "mergeDateIntoReferenceDate", function () { return $7692508c11d587c8$export$6c6df982c77f60a9; });
$parcel$export(module.exports, "isAndroid", function () { return $7692508c11d587c8$export$a11b0059900ceec8; });
$parcel$export(module.exports, "clampDaySectionIfPossible", function () { return $7692508c11d587c8$export$c7a10a3e9bfc3786; });
$parcel$export(module.exports, "getSectionOrder", function () { return $7692508c11d587c8$export$7725fd6fe0a2aadf; });

var $kY3Ke = parcelRequire("kY3Ke");

var $6CwGv = parcelRequire("6CwGv");
const $7692508c11d587c8$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."
    ].join("\n"));
    if (typeof config === "string") return {
        type: config,
        contentType: config === "meridiem" ? "letter" : "digit",
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $7692508c11d587c8$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case "ArrowUp":
            return 1;
        case "ArrowDown":
            return -1;
        case "PageUp":
            return 5;
        case "PageDown":
            return -5;
        default:
            return 0;
    }
};
const $7692508c11d587c8$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.dateWithTimezone(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $7692508c11d587c8$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case "month":
            return (0, $6CwGv.getMonthsInYear)(utils, utils.dateWithTimezone(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case "weekDay":
            return $7692508c11d587c8$export$c65c7173f879039f(utils, timezone, format);
        case "meridiem":
            {
                const now = utils.dateWithTimezone(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $7692508c11d587c8$export$713c6d756c12fc27 = (utils, valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $7692508c11d587c8$export$ef88db4bceade9fd = (utils, timezone, value, sectionBoundaries, section)=>{
    if (section.type === "day" && section.contentType === "digit-with-letter") {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    const valueStr = value.toString();
    if (section.hasLeadingZerosInInput) return $7692508c11d587c8$export$713c6d756c12fc27(utils, valueStr, section.maxLength);
    return valueStr;
};
const $7692508c11d587c8$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttributes)=>{
    const delta = $7692508c11d587c8$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === "Home";
    const isEnd = keyCode === "End";
    const shouldSetAbsolute = section.value === "" || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$7692508c11d587c8$export$ef88db4bceade9fd(utils, timezone, value, sectionBoundaries, section);
        const step = section.type === "minutes" && stepsAttributes != null && stepsAttributes.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt(section.value, 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === "year" && !isEnd && !isStart) return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $7692508c11d587c8$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === "digit" || section.contentType === "digit-with-letter") return adjustDigitSection();
    return adjustLetterSection();
};
const $7692508c11d587c8$export$85daa91f6c6e875f = (section, target)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(value).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        "input-rtl",
        "input-ltr"
    ].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === "input-rtl") value = `\u2068${value}\u2069`;
    return value;
};
const $7692508c11d587c8$export$cb0bbc88c7f09596 = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
const $7692508c11d587c8$export$8bb5d1c9951d10ca = (sections, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = $7692508c11d587c8$export$85daa91f6c6e875f(section, isRTL ? "input-rtl" : "input-ltr");
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $7692508c11d587c8$export$cb0bbc88c7f09596(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $7692508c11d587c8$export$cb0bbc88c7f09596(renderedValue);
        const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $kY3Ke.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $7692508c11d587c8$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, currentTokenValue)=>{
    switch(sectionConfig.type){
        case "year":
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), currentTokenValue).length
            });
        case "month":
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType
            });
        case "day":
            return localeText.fieldDayPlaceholder();
        case "weekDay":
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType
            });
        case "hours":
            return localeText.fieldHoursPlaceholder();
        case "minutes":
            return localeText.fieldMinutesPlaceholder();
        case "seconds":
            return localeText.fieldSecondsPlaceholder();
        case "meridiem":
            return localeText.fieldMeridiemPlaceholder();
        default:
            return currentTokenValue;
    }
};
const $7692508c11d587c8$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $7692508c11d587c8$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const $7692508c11d587c8$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== "digit") return false;
    const now = utils.dateWithTimezone(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case "year":
            {
                if ($7692508c11d587c8$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === "0001";
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === "01";
            }
        case "month":
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case "day":
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case "weekDay":
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case "hours":
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case "minutes":
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case "seconds":
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        default:
            throw new Error("Invalid section type");
    }
};
const $7692508c11d587c8$var$getEscapedPartsFromFormat = (utils, format)=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(format))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $7692508c11d587c8$export$fd71d82fe42bada1 = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)=>{
    let startSeparator = "";
    const sections = [];
    const now = utils.date();
    const commitToken = (token)=>{
        if (token === "") return null;
        const sectionConfig = $7692508c11d587c8$export$2f3c5fac7a2a65f6(utils, token);
        const hasLeadingZerosInFormat = $7692508c11d587c8$export$78b5830e2dd2de49(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
        const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
        const isValidDate = date != null && utils.isValid(date);
        let sectionValue = isValidDate ? utils.formatByString(date, token) : "";
        let maxLength = null;
        if (hasLeadingZerosInInput) {
            if (hasLeadingZerosInFormat) maxLength = sectionValue === "" ? utils.formatByString(now, token).length : sectionValue.length;
            else {
                if (sectionConfig.maxLength == null) throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
                maxLength = sectionConfig.maxLength;
                if (isValidDate) sectionValue = $7692508c11d587c8$export$713c6d756c12fc27(utils, sectionValue, maxLength);
            }
        }
        sections.push((0, $kY3Ke.default)({}, sectionConfig, {
            format: token,
            maxLength: maxLength,
            value: sectionValue,
            placeholder: $7692508c11d587c8$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
            hasLeadingZeros: hasLeadingZerosInFormat,
            hasLeadingZerosInFormat: hasLeadingZerosInFormat,
            hasLeadingZerosInInput: hasLeadingZerosInInput,
            startSeparator: sections.length === 0 ? startSeparator : "",
            endSeparator: "",
            modified: false
        }));
        return null;
    };
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
    }
    const expandedFormat = nextFormat;
    // Get start/end indexes of escaped sections
    const escapedParts = $7692508c11d587c8$var$getEscapedPartsFromFormat(utils, expandedFormat);
    // This RegExp test if the beginning of a string correspond to a supported token
    const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).join("|")})`);
    let currentTokenValue = "";
    for(let i = 0; i < expandedFormat.length; i += 1){
        const escapedPartOfCurrentChar = escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
        const char = expandedFormat[i];
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
        if (!isEscapedChar && char.match(/([A-Za-z]+)/) && isTokenStartRegExp.test(potentialToken)) currentTokenValue += char;
        else {
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                commitToken(currentTokenValue);
                currentTokenValue = "";
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
        }
    }
    commitToken(currentTokenValue);
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(" ")) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === "spacious" && [
                "/",
                ".",
                "-"
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $7692508c11d587c8$export$b0c1bfd065bfe742 = (utils, sections)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === "day");
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($7692508c11d587c8$export$85daa91f6c6e875f(section, "non-input"));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(" ");
    const dateWithoutSeparatorStr = sectionValues.join(" ");
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $7692508c11d587c8$export$e990c4332a617e3d = (sections, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $7692508c11d587c8$export$85daa91f6c6e875f(section, isRTL ? "input-rtl" : "input-ltr");
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join("");
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $7692508c11d587c8$export$360600f456ea7d5f = (utils, timezone)=>{
    const today = utils.dateWithTimezone(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $6CwGv.getMonthsInYear)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $7692508c11d587c8$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === "digit") {
                const daysInWeek = $7692508c11d587c8$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(utils.formatByString(utils.startOfDay(today), format))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $7692508c11d587c8$var$warnedOnceInvalidSection = false;
const $7692508c11d587c8$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $7692508c11d587c8$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case "year":
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case "month":
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case "weekDay":
            {
                const formattedDaysInWeek = $7692508c11d587c8$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case "day":
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case "meridiem":
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case "hours":
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case "minutes":
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case "seconds":
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $7692508c11d587c8$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8
};
const $7692508c11d587c8$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$7692508c11d587c8$var$reliableSectionModificationOrder[a.type] - $7692508c11d587c8$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $7692508c11d587c8$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $7692508c11d587c8$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf("android") > -1;
const $7692508c11d587c8$export$c7a10a3e9bfc3786 = (utils, timezone, sections, sectionsValueBoundaries)=>{
    // We can only clamp the day value if:
    // 1. if all the sections are filled (except the week day section which can be empty)
    // 2. there is a day section
    const canClamp = sections.every((section)=>section.type === "weekDay" || section.value !== "") && sections.some((section)=>section.type === "day");
    if (!canClamp) return null;
    // We try to generate a valid date representing the start of the month of the invalid date typed by the user.
    const sectionsForStartOfMonth = sections.map((section)=>{
        if (section.type !== "day") return section;
        const dayBoundaries = sectionsValueBoundaries.day({
            currentDate: null,
            format: section.format,
            contentType: section.contentType
        });
        return (0, $kY3Ke.default)({}, section, {
            value: $7692508c11d587c8$export$ef88db4bceade9fd(utils, timezone, dayBoundaries.minimum, dayBoundaries, section)
        });
    });
    const startOfMonth = $7692508c11d587c8$export$b0c1bfd065bfe742(utils, sectionsForStartOfMonth);
    // Even the start of the month is invalid, we probably have other invalid sections, the clamping failed.
    if (startOfMonth == null || !utils.isValid(startOfMonth)) return null;
    // The only invalid section was the day of the month, we replace its value with the maximum boundary for the correct month.
    return sections.map((section)=>{
        if (section.type !== "day") return section;
        const dayBoundaries = sectionsValueBoundaries.day({
            currentDate: startOfMonth,
            format: section.format,
            contentType: section.contentType
        });
        if (Number(section.value) <= dayBoundaries.maximum) return section;
        return (0, $kY3Ke.default)({}, section, {
            value: dayBoundaries.maximum.toString()
        });
    });
};
const $7692508c11d587c8$export$7725fd6fe0a2aadf = (sections, isRTL)=>{
    const neighbors = {};
    if (!isRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>{
            var _section$endSeparator;
            return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(" ")) && // Special case where the spaces were not there in the initial input
            section.endSeparator !== " / ";
        });
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};

});


parcelRequire.register("7cI1D", function(module, exports) {

$parcel$export(module.exports, "useDatePickerDefaultizedProps", function () { return $53ebcde7c448f3c9$export$a552c17ed3587731; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $5j2OD = parcelRequire("5j2OD");

var $92mGG = parcelRequire("92mGG");

var $jWPa9 = parcelRequire("jWPa9");

var $6CwGv = parcelRequire("6CwGv");

var $c44SB = parcelRequire("c44SB");

var $fFgj2 = parcelRequire("fFgj2");
function $53ebcde7c448f3c9$export$a552c17ed3587731(props, name) {
    var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
    const utils = (0, $92mGG.useUtils)();
    const defaultDates = (0, $92mGG.useDefaultDates)();
    const themeProps = (0, $5j2OD.default)({
        props: props,
        name: name
    });
    const localeText = $7fPBF.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $kY3Ke.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $fFgj2.uncapitalizeObjectKeys)(themeProps.components);
    return (0, $kY3Ke.default)({}, themeProps, {
        localeText: localeText
    }, (0, $jWPa9.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "year",
            "day"
        ],
        defaultOpenTo: "day"
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $kY3Ke.default)({
            toolbar: (0, $c44SB.DatePickerToolbar)
        }, slots),
        slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
    });
}

});
parcelRequire.register("92mGG", function(module, exports) {

$parcel$export(module.exports, "useLocalizationContext", function () { return $6945e6366bb58773$export$4b5a24245de9f7f9; });
$parcel$export(module.exports, "useUtils", function () { return $6945e6366bb58773$export$1163b47e39508a46; });
$parcel$export(module.exports, "useDefaultDates", function () { return $6945e6366bb58773$export$7c38da3a2e90fa83; });
$parcel$export(module.exports, "useLocaleText", function () { return $6945e6366bb58773$export$24fdeaa0f591a73e; });
$parcel$export(module.exports, "useNow", function () { return $6945e6366bb58773$export$3a404aece3dff2fa; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $huHez = parcelRequire("huHez");

var $eYKx4 = parcelRequire("eYKx4");
const $6945e6366bb58773$export$4b5a24245de9f7f9 = ()=>{
    const localization = $7fPBF.useContext((0, $huHez.MuiPickersAdapterContext));
    if (localization === null) throw new Error([
        "MUI: Can not find the date and time pickers localization context.",
        "It looks like you forgot to wrap your component in LocalizationProvider.",
        "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"
    ].join("\n"));
    if (localization.utils === null) throw new Error([
        "MUI: Can not find the date and time pickers adapter from its localization context.",
        "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."
    ].join("\n"));
    const localeText = $7fPBF.useMemo(()=>(0, $kY3Ke.default)({}, (0, $eYKx4.DEFAULT_LOCALE), localization.localeText), [
        localization.localeText
    ]);
    return $7fPBF.useMemo(()=>(0, $kY3Ke.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $6945e6366bb58773$export$1163b47e39508a46 = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().utils;
const $6945e6366bb58773$export$7c38da3a2e90fa83 = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().defaultDates;
const $6945e6366bb58773$export$24fdeaa0f591a73e = ()=>$6945e6366bb58773$export$4b5a24245de9f7f9().localeText;
const $6945e6366bb58773$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $6945e6366bb58773$export$1163b47e39508a46();
    const now = $7fPBF.useRef();
    if (now.current === undefined) now.current = utils.dateWithTimezone(undefined, timezone);
    return now.current;
};

});
parcelRequire.register("eYKx4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", function () { return $ae7ac3a23918bc42$export$1af4c7e47ad72f44; });
$parcel$export(module.exports, "enUS", function () { return $ae7ac3a23918bc42$export$137380d9ce54f7f; });

var $buRa0 = parcelRequire("buRa0");
// This object is not Partial<PickersLocaleText> because it is the default values
const $ae7ac3a23918bc42$var$enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "open previous view",
    openNextView: "open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    // DateRange placeholders
    start: "Start",
    end: "End",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerToolbarTitle: "Select date",
    dateTimePickerToolbarTitle: "Select date & time",
    timePickerToolbarTitle: "Select time",
    dateRangePickerToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? "No time selected" : `Selected time is ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "Week number",
    calendarWeekNumberHeaderText: "#",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, "fullDate")}` : "Choose date",
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, "fullTime")}` : "Choose time",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"Y".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "MMMM" : "MM",
    fieldDayPlaceholder: ()=>"DD",
    fieldWeekDayPlaceholder: (params)=>params.contentType === "letter" ? "EEEE" : "EE",
    fieldHoursPlaceholder: ()=>"hh",
    fieldMinutesPlaceholder: ()=>"mm",
    fieldSecondsPlaceholder: ()=>"ss",
    fieldMeridiemPlaceholder: ()=>"aa"
};
const $ae7ac3a23918bc42$export$1af4c7e47ad72f44 = $ae7ac3a23918bc42$var$enUSPickers;
const $ae7ac3a23918bc42$export$137380d9ce54f7f = (0, $buRa0.getPickersLocalization)($ae7ac3a23918bc42$var$enUSPickers);

});
parcelRequire.register("buRa0", function(module, exports) {

$parcel$export(module.exports, "getPickersLocalization", function () { return $85ebbb99b2811e17$export$67c96d35a1b010b3; });

var $kY3Ke = parcelRequire("kY3Ke");
const $85ebbb99b2811e17$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $kY3Ke.default)({}, pickersTranslations)
                }
            }
        }
    };
};

});



parcelRequire.register("c44SB", function(module, exports) {

$parcel$export(module.exports, "DatePickerToolbar", function () { return $8c89a4c7302d5b4a$export$21b7f8ea763109eb; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $l7Pjh = parcelRequire("l7Pjh");

var $92mGG = parcelRequire("92mGG");

var $2FmWZ = parcelRequire("2FmWZ");

var $6CwGv = parcelRequire("6CwGv");

var $bbzbN = parcelRequire("bbzbN");
const $8c89a4c7302d5b4a$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views"
];
const $8c89a4c7302d5b4a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        title: [
            "title"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $2FmWZ.getDatePickerToolbarUtilityClass), classes);
};
const $8c89a4c7302d5b4a$var$DatePickerToolbarRoot = (0, $kDBhE.default)((0, $l7Pjh.PickersToolbar), {
    name: "MuiDatePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
/**
 * @ignore - do not document.
 */ const $8c89a4c7302d5b4a$var$DatePickerToolbarTitle = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiDatePickerToolbar",
    slot: "Title",
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.isLandscape && {
        margin: "auto 16px auto auto"
    }));
const $8c89a4c7302d5b4a$export$21b7f8ea763109eb = /*#__PURE__*/ $7fPBF.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDatePickerToolbar"
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "––", views: views } = props, other = (0, $cFLic.default)(props, $8c89a4c7302d5b4a$var$_excluded);
    const utils = (0, $92mGG.useUtils)();
    const localeText = (0, $92mGG.useLocaleText)();
    const classes = $8c89a4c7302d5b4a$var$useUtilityClasses(props);
    const dateText = $7fPBF.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $6CwGv.resolveDateFormat)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8c89a4c7302d5b4a$var$DatePickerToolbarRoot, (0, $kY3Ke.default)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($8c89a4c7302d5b4a$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? "left" : "center",
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});

});
parcelRequire.register("l7Pjh", function(module, exports) {

$parcel$export(module.exports, "PickersToolbar", function () { return $f6120d886b3f245b$export$eb3c4d84783d6feb; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $aXrmT = parcelRequire("aXrmT");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $lhd3F = parcelRequire("lhd3F");

var $bbzbN = parcelRequire("bbzbN");
const $f6120d886b3f245b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $lhd3F.getPickersToolbarUtilityClass), classes);
};
const $f6120d886b3f245b$var$PickersToolbarRoot = (0, $kDBhE.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: "auto",
        maxWidth: 160,
        padding: 16,
        justifyContent: "flex-start",
        flexWrap: "wrap"
    }));
const $f6120d886b3f245b$var$PickersToolbarContent = (0, $kDBhE.default)((0, $aXrmT.default), {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: 1
    }, !ownerState.isLandscape && {
        alignItems: "center"
    }));
const $f6120d886b3f245b$export$eb3c4d84783d6feb = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children: children, className: className, isLandscape: isLandscape, landscapeDirection: landscapeDirection = "column", toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props;
    const ownerState = props;
    const classes = $f6120d886b3f245b$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($f6120d886b3f245b$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($f6120d886b3f245b$var$PickersToolbarContent, {
                container: true,
                justifyContent: isLandscape ? "flex-start" : "space-between",
                className: classes.content,
                ownerState: ownerState,
                direction: isLandscape ? landscapeDirection : "row",
                alignItems: isLandscape ? "flex-start" : "flex-end",
                children: children
            })
        ]
    });
});

});
parcelRequire.register("aXrmT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fa4a4d669bc53fb$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cvrkU = parcelRequire("cvrkU");
var $mqrnX = parcelRequire("mqrnX");

var $cFCqu = parcelRequire("cFCqu");


var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $g9bTP = parcelRequire("g9bTP");

var $5d7YT = parcelRequire("5d7YT");

var $jY428 = parcelRequire("jY428");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7fa4a4d669bc53fb$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $7fa4a4d669bc53fb$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $7fa4a4d669bc53fb$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $cvrkU.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $kY3Ke.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $7fa4a4d669bc53fb$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $cvrkU.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $cvrkU.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $jY428.default).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $7fa4a4d669bc53fb$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingTop: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $cvrkU.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $7fa4a4d669bc53fb$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $cvrkU.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$7fa4a4d669bc53fb$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingLeft: $7fa4a4d669bc53fb$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $jY428.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $7fa4a4d669bc53fb$var$GridRoot = (0, $kDBhE.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $7fa4a4d669bc53fb$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $7fa4a4d669bc53fb$export$71d4225eeb1bc13e, $7fa4a4d669bc53fb$export$380604d7c79f9e8f, $7fa4a4d669bc53fb$export$4315fba5128fb4a1, $7fa4a4d669bc53fb$export$ca2a698f6020fda);
function $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $7fa4a4d669bc53fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $7fa4a4d669bc53fb$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $jY428.getGridUtilityClass), classes);
};
const $7fa4a4d669bc53fb$var$Grid = /*#__PURE__*/ $7fPBF.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $g9bTP.default)();
    const props = (0, $mqrnX.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $cFLic.default)(props, $7fa4a4d669bc53fb$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $7fPBF.useContext((0, $5d7YT.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $kY3Ke.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $7fa4a4d669bc53fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5d7YT.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($7fa4a4d669bc53fb$var$GridRoot, (0, $kY3Ke.default)({
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $7fa4a4d669bc53fb$export$2e2bcd8739ae039 = $7fa4a4d669bc53fb$var$Grid;

});
parcelRequire.register("5d7YT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cb45b8a02634c3b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 */ const $3cb45b8a02634c3b$var$GridContext = /*#__PURE__*/ $7fPBF.createContext();
var $3cb45b8a02634c3b$export$2e2bcd8739ae039 = $3cb45b8a02634c3b$var$GridContext;

});

parcelRequire.register("jY428", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", function () { return $e896bfd9730b7f7a$export$9973ac5fd0181f33; });
$parcel$export(module.exports, "default", function () { return $e896bfd9730b7f7a$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e896bfd9730b7f7a$export$9973ac5fd0181f33(slot) {
    return (0, $k6RDS.default)("MuiGrid", slot);
}
const $e896bfd9730b7f7a$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $e896bfd9730b7f7a$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $e896bfd9730b7f7a$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $e896bfd9730b7f7a$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $e896bfd9730b7f7a$var$gridClasses = (0, $4jzsB.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$e896bfd9730b7f7a$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$e896bfd9730b7f7a$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$e896bfd9730b7f7a$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$e896bfd9730b7f7a$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $e896bfd9730b7f7a$export$2e2bcd8739ae039 = $e896bfd9730b7f7a$var$gridClasses;

});


parcelRequire.register("lhd3F", function(module, exports) {

$parcel$export(module.exports, "getPickersToolbarUtilityClass", function () { return $f7d55096f286ac82$export$b109c489973c3d80; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $f7d55096f286ac82$export$b109c489973c3d80(slot) {
    return (0, $k6RDS.default)("MuiPickersToolbar", slot);
}
const $f7d55096f286ac82$export$59f09e5e2b3d9913 = (0, $4jzsB.default)("MuiPickersToolbar", [
    "root",
    "content"
]);

});


parcelRequire.register("2FmWZ", function(module, exports) {

$parcel$export(module.exports, "getDatePickerToolbarUtilityClass", function () { return $1f1136919bda5dde$export$a1c3879af2c3b694; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $1f1136919bda5dde$export$a1c3879af2c3b694(slot) {
    return (0, $k6RDS.default)("MuiDatePickerToolbar", slot);
}
const $1f1136919bda5dde$export$2e35fa7d24ef4179 = (0, $4jzsB.default)("MuiDatePickerToolbar", [
    "root",
    "title"
]);

});


parcelRequire.register("fFgj2", function(module, exports) {

$parcel$export(module.exports, "uncapitalizeObjectKeys", function () { return $b677556a4855b45c$export$ee17bc394843b249; });

var $kY3Ke = parcelRequire("kY3Ke");
const $b677556a4855b45c$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $kY3Ke.default)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};

});


parcelRequire.register("fq3Fh", function(module, exports) {

$parcel$export(module.exports, "validateDate", function () { return $b39c207604afaad4$export$ffb3d0046ef3a2; });

var $6CwGv = parcelRequire("6CwGv");
const $b39c207604afaad4$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const minDate = (0, $6CwGv.applyDefaultDate)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $6CwGv.applyDefaultDate)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return "shouldDisableDate";
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return "shouldDisableMonth";
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return "shouldDisableYear";
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};

});

parcelRequire.register("h6NE5", function(module, exports) {

$parcel$export(module.exports, "useDesktopPicker", function () { return $c74981cd2400164c$export$b1b70bc56ac5be0e; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $94ctx = parcelRequire("94ctx");

var $dQarR = parcelRequire("dQarR");

var $8TDId = parcelRequire("8TDId");

var $jTdAm = parcelRequire("jTdAm");

var $65Itt = parcelRequire("65Itt");

var $j9L6W = parcelRequire("j9L6W");

var $92mGG = parcelRequire("92mGG");

var $gKtnG = parcelRequire("gKtnG");

var $huHez = parcelRequire("huHez");

var $1fUy6 = parcelRequire("1fUy6");

var $bbzbN = parcelRequire("bbzbN");
const $c74981cd2400164c$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $c74981cd2400164c$var$_excluded2 = [
    "ownerState"
], $c74981cd2400164c$var$_excluded3 = [
    "ownerState"
];
const $c74981cd2400164c$export$b1b70bc56ac5be0e = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$inputAdornment, _slots$openPickerButt, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $cFLic.default)(_ref, $c74981cd2400164c$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText } = props;
    const utils = (0, $92mGG.useUtils)();
    const internalInputRef = $7fPBF.useRef(null);
    const containerRef = $7fPBF.useRef(null);
    const labelId = (0, $65Itt.default)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps } = (0, $gKtnG.usePicker)((0, $kY3Ke.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "desktop"
    }));
    const InputAdornment = (_slots$inputAdornment = slots.inputAdornment) != null ? _slots$inputAdornment : (0, $dQarR.default);
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.inputAdornment,
        additionalProps: {
            position: "end"
        },
        ownerState: props
    }), inputAdornmentProps = (0, $cFLic.default)(_useSlotProps, $c74981cd2400164c$var$_excluded2);
    const OpenPickerButton = (_slots$openPickerButt = slots.openPickerButton) != null ? _slots$openPickerButt : (0, $8TDId.default);
    const _useSlotProps2 = (0, $94ctx.useSlotProps)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: actions.onOpen,
            "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $cFLic.default)(_useSlotProps2, $c74981cd2400164c$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = (0, $94ctx.useSlotProps)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $kY3Ke.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $kY3Ke.default)({}, fieldProps.InputProps, {
        ref: containerRef,
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $bbzbN.jsx)(InputAdornment, (0, $kY3Ke.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(OpenPickerButton, (0, $kY3Ke.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(OpenPickerIcon, (0, $kY3Ke.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.openPickerIcon))
            }))
        }))
    });
    const slotsForField = (0, $kY3Ke.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $1fUy6.PickersLayout);
    const handleInputRef = (0, $jTdAm.default)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $kY3Ke.default)({}, innerSlotProps, {
        toolbar: (0, $kY3Ke.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        popper: (0, $kY3Ke.default)({
            "aria-labelledby": labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $huHez.LocalizationProvider), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)(Field, (0, $kY3Ke.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j9L6W.PickersPopper), (0, $kY3Ke.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(Layout, (0, $kY3Ke.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};

});
parcelRequire.register("dQarR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1383c8904b71ac9$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $3loMv = parcelRequire("3loMv");

var $kPqR2 = parcelRequire("kPqR2");

var $2jx1n = parcelRequire("2jx1n");

var $kDBhE = parcelRequire("kDBhE");

var $4oXX1 = parcelRequire("4oXX1");

var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $a1383c8904b71ac9$var$_span;
const $a1383c8904b71ac9$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $a1383c8904b71ac9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $b6UUh.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $a1383c8904b71ac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $b6UUh.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $4oXX1.getInputAdornmentUtilityClass), classes);
};
const $a1383c8904b71ac9$var$InputAdornmentRoot = (0, $kDBhE.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $a1383c8904b71ac9$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $4oXX1.default).positionStart}&:not(.${(0, $4oXX1.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $a1383c8904b71ac9$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cFLic.default)(props, $a1383c8904b71ac9$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $a1383c8904b71ac9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kPqR2.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($a1383c8904b71ac9$var$InputAdornmentRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $a1383c8904b71ac9$var$_span || ($a1383c8904b71ac9$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "notranslate",
                        children: "​"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $a1383c8904b71ac9$export$2e2bcd8739ae039 = $a1383c8904b71ac9$var$InputAdornment;

});
parcelRequire.register("4oXX1", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", function () { return $3347e858a7e1bb40$export$4b135a4b3a6c4550; });
$parcel$export(module.exports, "default", function () { return $3347e858a7e1bb40$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $3347e858a7e1bb40$export$4b135a4b3a6c4550(slot) {
    return (0, $k6RDS.default)("MuiInputAdornment", slot);
}
const $3347e858a7e1bb40$var$inputAdornmentClasses = (0, $4jzsB.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $3347e858a7e1bb40$export$2e2bcd8739ae039 = $3347e858a7e1bb40$var$inputAdornmentClasses;

});


parcelRequire.register("j9L6W", function(module, exports) {

$parcel$export(module.exports, "PickersPopper", function () { return $df2366d35b337352$export$96ce8482474de8a5; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $94ctx = parcelRequire("94ctx");

var $aSK9T = parcelRequire("aSK9T");

var $a2ay0 = parcelRequire("a2ay0");

var $41bfV = parcelRequire("41bfV");

var $bagbq = parcelRequire("bagbq");

var $cFCqu = parcelRequire("cFCqu");
var $4CS7n = parcelRequire("4CS7n");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $7dVBN = parcelRequire("7dVBN");

var $jpuvJ = parcelRequire("jpuvJ");

var $bbzbN = parcelRequire("bbzbN");
const $df2366d35b337352$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $7dVBN.getPickersPopperUtilityClass), classes);
};
const $df2366d35b337352$var$PickersPopperRoot = (0, $kDBhE.default)((0, $41bfV.default), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $df2366d35b337352$var$PickersPopperPaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        transformOrigin: "top center",
        outline: 0
    }, ownerState.placement === "top" && {
        transformOrigin: "bottom center"
    }));
function $df2366d35b337352$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $df2366d35b337352$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $giDhD.default)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4CS7n.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && $df2366d35b337352$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $7fPBF.useEffect(()=>{
        if (active) {
            const doc = (0, $4CS7n.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $7fPBF.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $4CS7n.default)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
function $df2366d35b337352$export$96ce8482474de8a5(inProps) {
    var _slots$desktopTransit, _slots$desktopTrapFoc, _slots$desktopPaper, _slots$popper;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps } = props;
    $7fPBF.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Blink?) use 'Esc'
            if (open && (nativeEvent.key === "Escape" || nativeEvent.key === "Esc")) onDismiss();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (role === "tooltip" || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $jpuvJ.getActiveElement)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $df2366d35b337352$var$useClickAwayListener(open, onBlur != null ? onBlur : onDismiss);
    const paperRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(paperRef, containerRef);
    const handlePaperRef = (0, $jTdAm.default)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $df2366d35b337352$var$useUtilityClasses(ownerState);
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = (_slots$desktopTransit = slots == null ? void 0 : slots.desktopTransition) != null ? _slots$desktopTransit : (0, $aSK9T.default);
    const TrapFocus = (_slots$desktopTrapFoc = slots == null ? void 0 : slots.desktopTrapFocus) != null ? _slots$desktopTrapFoc : (0, $bagbq.FocusTrap);
    const Paper = (_slots$desktopPaper = slots == null ? void 0 : slots.desktopPaper) != null ? _slots$desktopPaper : $df2366d35b337352$var$PickersPopperPaper;
    const paperProps = (0, $94ctx.useSlotProps)({
        elementType: Paper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.desktopPaper,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: handlePaperRef
        },
        className: classes.paper,
        ownerState: {} // Is overridden below to use `placement
    });
    const Popper = (_slots$popper = slots == null ? void 0 : slots.popper) != null ? _slots$popper : $df2366d35b337352$var$PickersPopperRoot;
    const popperProps = (0, $94ctx.useSlotProps)({
        elementType: Popper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Popper, (0, $kY3Ke.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $bbzbN.jsx)(TrapFocus, (0, $kY3Ke.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, slotProps == null ? void 0 : slotProps.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(Transition, (0, $kY3Ke.default)({}, TransitionProps, slotProps == null ? void 0 : slotProps.desktopTransition, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(Paper, (0, $kY3Ke.default)({}, paperProps, {
                        onClick: (event)=>{
                            var _paperProps$onClick;
                            onPaperClick(event);
                            (_paperProps$onClick = paperProps.onClick) == null || _paperProps$onClick.call(paperProps, event);
                        },
                        onTouchStart: (event)=>{
                            var _paperProps$onTouchSt;
                            onPaperTouchStart(event);
                            (_paperProps$onTouchSt = paperProps.onTouchStart) == null || _paperProps$onTouchSt.call(paperProps, event);
                        },
                        ownerState: (0, $kY3Ke.default)({}, ownerState, {
                            placement: popperPlacement
                        }),
                        children: children
                    }))
                }))
            }))
    }));
}

});
parcelRequire.register("41bfV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecffc9bd505b8cc$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7cmTB = parcelRequire("7cmTB");

var $84PRT = parcelRequire("84PRT");



var $7fPBF = parcelRequire("7fPBF");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2ecffc9bd505b8cc$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $2ecffc9bd505b8cc$var$PopperRoot = (0, $kDBhE.default)((0, $7cmTB.Popper), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $2ecffc9bd505b8cc$var$Popper = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $84PRT.default)();
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $cFLic.default)(props, $2ecffc9bd505b8cc$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $kY3Ke.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($2ecffc9bd505b8cc$var$PopperRoot, (0, $kY3Ke.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $2ecffc9bd505b8cc$export$2e2bcd8739ae039 = $2ecffc9bd505b8cc$var$Popper;

});
parcelRequire.register("7cmTB", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $53db6a0252cebd95$export$badac9ada3a0bdf9; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $4CS7n = parcelRequire("4CS7n");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");

var $efdLW = parcelRequire("efdLW");


var $cFCqu = parcelRequire("cFCqu");

var $f3PDk = parcelRequire("f3PDk");

var $ibZzm = parcelRequire("ibZzm");

var $94ctx = parcelRequire("94ctx");

var $8mwOh = parcelRequire("8mwOh");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $53db6a0252cebd95$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $53db6a0252cebd95$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $53db6a0252cebd95$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $53db6a0252cebd95$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $53db6a0252cebd95$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $53db6a0252cebd95$var$isVirtualElement(element) {
    return !$53db6a0252cebd95$var$isHTMLElement(element);
}
const $53db6a0252cebd95$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $8mwOh.useClassNamesOverride)((0, $ibZzm.getPopperUtilityClass)));
};
const $53db6a0252cebd95$var$defaultPopperOptions = {};
const $53db6a0252cebd95$var$PopperTooltip = /*#__PURE__*/ $7fPBF.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $53db6a0252cebd95$var$_excluded);
    const tooltipRef = $7fPBF.useRef(null);
    const ownRef = (0, $jTdAm.default)(tooltipRef, forwardedRef);
    const popperRef = $7fPBF.useRef(null);
    const handlePopperRef = (0, $jTdAm.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $7fPBF.useRef(handlePopperRef);
    (0, $lJRRs.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $7fPBF.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $53db6a0252cebd95$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $7fPBF.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $7fPBF.useState($53db6a0252cebd95$var$resolveAnchorEl(anchorEl));
    $7fPBF.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $7fPBF.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($53db6a0252cebd95$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $lJRRs.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $efdLW.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $kY3Ke.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $53db6a0252cebd95$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $94ctx.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $53db6a0252cebd95$export$badac9ada3a0bdf9 = /*#__PURE__*/ $7fPBF.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $53db6a0252cebd95$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $cFLic.default)(props, $53db6a0252cebd95$var$_excluded2);
    const [exited, setExited] = $7fPBF.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $53db6a0252cebd95$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $53db6a0252cebd95$var$isHTMLElement(resolvedAnchorEl) ? (0, $4CS7n.default)(resolvedAnchorEl).body : (0, $4CS7n.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f3PDk.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($53db6a0252cebd95$var$PopperTooltip, (0, $kY3Ke.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $kY3Ke.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});

});
parcelRequire.register("efdLW", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $a5ed26444bdb4d3e$export$8f7491d57c8f97a9; });

var $bDLFF = parcelRequire("bDLFF");

var $1PRym = parcelRequire("1PRym");

var $jh6oc = parcelRequire("jh6oc");

var $eWblW = parcelRequire("eWblW");

var $7TCz5 = parcelRequire("7TCz5");

var $eylfk = parcelRequire("eylfk");

var $exXrj = parcelRequire("exXrj");

var $hOZ6Q = parcelRequire("hOZ6Q");

var $jUFYE = parcelRequire("jUFYE");

var $a2tLm = parcelRequire("a2tLm");


var $a5ed26444bdb4d3e$export$d34966752335dd47 = [
    (0, $1PRym.default),
    (0, $jh6oc.default),
    (0, $eWblW.default),
    (0, $7TCz5.default),
    (0, $eylfk.default),
    (0, $exXrj.default),
    (0, $hOZ6Q.default),
    (0, $jUFYE.default),
    (0, $a2tLm.default)
];
var $a5ed26444bdb4d3e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bDLFF.popperGenerator)({
    defaultModifiers: $a5ed26444bdb4d3e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRequire.register("bDLFF", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $879850b738b0fd85$export$ed5e13716264f202; });

var $7A5zv = parcelRequire("7A5zv");

var $aooBM = parcelRequire("aooBM");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $1HbbS = parcelRequire("1HbbS");

var $6zw26 = parcelRequire("6zw26");

var $4irPP = parcelRequire("4irPP");


var $kWkO0 = parcelRequire("kWkO0");
var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kWkO0.isElement)(reference) ? (0, $5fhgl.default)(reference) : reference.contextElement ? (0, $5fhgl.default)(reference.contextElement) : [],
                    popper: (0, $5fhgl.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1HbbS.default)((0, $4irPP.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7A5zv.default)(reference, (0, $9vuui.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $aooBM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6zw26.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRequire.register("7A5zv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585037a155f95873$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $luMSI = parcelRequire("luMSI");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");

var $jhPl0 = parcelRequire("jhPl0");

var $aMuSx = parcelRequire("aMuSx");

var $dbfQ4 = parcelRequire("dbfQ4");

var $hsTEw = parcelRequire("hsTEw");
function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hsTEw.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hsTEw.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kWkO0.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kWkO0.isHTMLElement)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $aMuSx.default)(offsetParent);
    var rect = (0, $jTgmx.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fRINz.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $dbfQ4.default)(documentElement)) scroll = (0, $luMSI.default)(offsetParent);
        if ((0, $kWkO0.isHTMLElement)(offsetParent)) {
            offsets = (0, $jTgmx.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $jhPl0.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRequire.register("jTgmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7afd89efa353b85$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");

var $hsTEw = parcelRequire("hsTEw");

var $7LvDQ = parcelRequire("7LvDQ");

var $fv6RK = parcelRequire("fv6RK");
function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kWkO0.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hsTEw.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hsTEw.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kWkO0.isElement)(element) ? (0, $7LvDQ.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fv6RK.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRequire.register("kWkO0", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $f3e95cf60f991b3e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $f3e95cf60f991b3e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $f3e95cf60f991b3e$export$af51f0f06c0f328a; });

var $7LvDQ = parcelRequire("7LvDQ");
function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7LvDQ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7LvDQ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $7LvDQ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRequire.register("7LvDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7577945ba4d648$export$2e2bcd8739ae039; });
function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRequire.register("hsTEw", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $cb70389d1b75072d$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cb70389d1b75072d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cb70389d1b75072d$export$2077e0241d6afd3c; });
var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;

});

parcelRequire.register("fv6RK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48f13af3862f004$export$2e2bcd8739ae039; });

var $h7lOM = parcelRequire("h7lOM");
function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $h7lOM.default)());
}

});
parcelRequire.register("h7lOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c76403bd29ed319a$export$2e2bcd8739ae039; });
function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRequire.register("luMSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa62512f527d34a4$export$2e2bcd8739ae039; });

var $k28Ly = parcelRequire("k28Ly");

var $7LvDQ = parcelRequire("7LvDQ");

var $kWkO0 = parcelRequire("kWkO0");

var $91ESz = parcelRequire("91ESz");
function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $7LvDQ.default)(node) || !(0, $kWkO0.isHTMLElement)(node)) return (0, $k28Ly.default)(node);
    else return (0, $91ESz.default)(node);
}

});
parcelRequire.register("k28Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95acb4acf5ee909$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $7LvDQ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRequire.register("91ESz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6923eaccf7a43aef$export$2e2bcd8739ae039; });
function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRequire.register("fRINz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ce8e5214ef2302$export$2e2bcd8739ae039; });
function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRequire.register("jhPl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0a76d77d33c9d6e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $aMuSx = parcelRequire("aMuSx");

var $k28Ly = parcelRequire("k28Ly");
function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $jTgmx.default)((0, $aMuSx.default)(element)).left + (0, $k28Ly.default)(element).scrollLeft;
}

});
parcelRequire.register("aMuSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d9656f011992b2b$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kWkO0.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRequire.register("dbfQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998896b7349c78b7$export$2e2bcd8739ae039; });

var $5lm85 = parcelRequire("5lm85");
function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5lm85.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRequire.register("5lm85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e40145ffd569d9c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $7LvDQ.default)(element).getComputedStyle(element);
}

});



parcelRequire.register("aooBM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790f3bf845b39e8e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");
function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $jTgmx.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRequire.register("5fhgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1bbe7c8c599173$export$2e2bcd8739ae039; });

var $2vPbO = parcelRequire("2vPbO");

var $d8xUD = parcelRequire("d8xUD");

var $7LvDQ = parcelRequire("7LvDQ");

var $dbfQ4 = parcelRequire("dbfQ4");
function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2vPbO.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7LvDQ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $dbfQ4.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $d8xUD.default)(target)));
}

});
parcelRequire.register("2vPbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d462f2c86b4c65a$export$2e2bcd8739ae039; });

var $d8xUD = parcelRequire("d8xUD");

var $dbfQ4 = parcelRequire("dbfQ4");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $fRINz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kWkO0.isHTMLElement)(node) && (0, $dbfQ4.default)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $d8xUD.default)(node));
}

});
parcelRequire.register("d8xUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9906540837c752ea$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $aMuSx = parcelRequire("aMuSx");

var $kWkO0 = parcelRequire("kWkO0");
function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $fRINz.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kWkO0.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $aMuSx.default)(element) // fallback
    );
}

});



parcelRequire.register("9vuui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ebea87f6f98e49c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $fRINz = parcelRequire("fRINz");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $KQ9YG = parcelRequire("KQ9YG");

var $d8xUD = parcelRequire("d8xUD");

var $h7lOM = parcelRequire("h7lOM");
function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $kWkO0.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5lm85.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $h7lOM.default)());
    var isIE = /Trident/i.test((0, $h7lOM.default)());
    if (isIE && (0, $kWkO0.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5lm85.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $d8xUD.default)(element);
    if ((0, $kWkO0.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kWkO0.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $fRINz.default)(currentNode)) < 0){
        var css = (0, $5lm85.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $7LvDQ.default)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $KQ9YG.default)(offsetParent) && (0, $5lm85.default)(offsetParent).position === "static")offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fRINz.default)(offsetParent) === "html" || (0, $fRINz.default)(offsetParent) === "body" && (0, $5lm85.default)(offsetParent).position === "static")) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}

});
parcelRequire.register("KQ9YG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ccc1de57d53c59$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");
function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $fRINz.default)(element)) >= 0;
}

});


parcelRequire.register("1HbbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c27cceb4b24b2f$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");
function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $aHbEK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRequire.register("aHbEK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $7c96f63dd602b579$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $7c96f63dd602b579$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $7c96f63dd602b579$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $7c96f63dd602b579$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $7c96f63dd602b579$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $7c96f63dd602b579$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $7c96f63dd602b579$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $7c96f63dd602b579$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $7c96f63dd602b579$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $7c96f63dd602b579$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $7c96f63dd602b579$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $7c96f63dd602b579$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $7c96f63dd602b579$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $7c96f63dd602b579$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $7c96f63dd602b579$export$d087d3878fdf71d5; });
var $7c96f63dd602b579$export$1e95b668f3b82d = "top";
var $7c96f63dd602b579$export$40e543e69a8b3fbb = "bottom";
var $7c96f63dd602b579$export$79ffe56a765070d2 = "right";
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = "left";
var $7c96f63dd602b579$export$dfb5619354ba860 = "auto";
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = "start";
var $7c96f63dd602b579$export$bd5df0f255a350f8 = "end";
var $7c96f63dd602b579$export$390fd549c5303b4d = "clippingParents";
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = "viewport";
var $7c96f63dd602b579$export$ae5ab1c730825774 = "popper";
var $7c96f63dd602b579$export$ca50aac9f3ba507f = "reference";
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = "beforeRead";
var $7c96f63dd602b579$export$aafa59e2e03f2942 = "read";
var $7c96f63dd602b579$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = "beforeMain";
var $7c96f63dd602b579$export$f22da7240b7add18 = "main";
var $7c96f63dd602b579$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = "beforeWrite";
var $7c96f63dd602b579$export$68d8715fc104d294 = "write";
var $7c96f63dd602b579$export$70a6e5159acce2e6 = "afterWrite";
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];

});


parcelRequire.register("6zw26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8edc0cb4d5666b$export$2e2bcd8739ae039; });
function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRequire.register("4irPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320e6f4d2835a922$export$2e2bcd8739ae039; });
function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRequire.register("1PRym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1564186ea0096528$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7LvDQ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};

});

parcelRequire.register("jh6oc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0848fa64ca744df$export$2e2bcd8739ae039; });

var $gIQYz = parcelRequire("gIQYz");
function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gIQYz.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};

});
parcelRequire.register("gIQYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c9d9550c09d816$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $4p02M = parcelRequire("4p02M");

var $aHbEK = parcelRequire("aHbEK");
function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3ZGTg.default)(placement) : null;
    var variation = placement ? (0, $hD45i.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $aHbEK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $aHbEK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $aHbEK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $aHbEK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4p02M.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $aHbEK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $aHbEK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRequire.register("3ZGTg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e8856bdb677ff8e$export$2e2bcd8739ae039; });

function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRequire.register("hD45i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd593f453867f36a$export$2e2bcd8739ae039; });
function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRequire.register("4p02M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334987ecb6fc56c7$export$2e2bcd8739ae039; });
function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRequire.register("eWblW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adff49e8d09ee1e5$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $9vuui = parcelRequire("9vuui");

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $hsTEw = parcelRequire("hsTEw");
var $adff49e8d09ee1e5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hsTEw.round)(x * dpr) / dpr || 0,
        y: (0, $hsTEw.round)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $aHbEK.left);
    var sideY = (0, $aHbEK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9vuui.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $7LvDQ.default)(popper)) {
            offsetParent = (0, $aMuSx.default)(popper);
            if ((0, $5lm85.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $aHbEK.top) || (placement === (0, $aHbEK.left) || placement === (0, $aHbEK.right)) && variation === (0, $aHbEK.end)) {
            sideY = (0, $aHbEK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $aHbEK.left) || (placement === (0, $aHbEK.top) || placement === (0, $aHbEK.bottom)) && variation === (0, $aHbEK.end)) {
            sideX = (0, $aHbEK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7LvDQ.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3ZGTg.default)(state.placement),
        variation: (0, $hD45i.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};

});

parcelRequire.register("7TCz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfb95a331f35baa$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
// and applies them to the HTMLElements such as popper and arrow
function $5bfb95a331f35baa$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $kWkO0.isHTMLElement)(element) || !(0, $fRINz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $5bfb95a331f35baa$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $kWkO0.isHTMLElement)(element) || !(0, $fRINz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5bfb95a331f35baa$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $5bfb95a331f35baa$var$applyStyles,
    effect: $5bfb95a331f35baa$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRequire.register("eylfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a984b8b647b41eeb$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aHbEK = parcelRequire("aHbEK");
function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3ZGTg.default)(placement);
    var invertDistance = [
        (0, $aHbEK.left),
        (0, $aHbEK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $aHbEK.placements).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $a984b8b647b41eeb$var$offset
};

});

parcelRequire.register("exXrj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97241372b70cd07$export$2e2bcd8739ae039; });

var $910or = parcelRequire("910or");

var $3ZGTg = parcelRequire("3ZGTg");

var $1EPiP = parcelRequire("1EPiP");

var $74FGG = parcelRequire("74FGG");

var $ewHfg = parcelRequire("ewHfg");

var $aHbEK = parcelRequire("aHbEK");

var $hD45i = parcelRequire("hD45i");
function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto)) return [];
    var oppositePlacement = (0, $910or.default)(placement);
    return [
        (0, $1EPiP.default)(placement),
        oppositePlacement,
        (0, $1EPiP.default)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3ZGTg.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $910or.default)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto) ? (0, $ewHfg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3ZGTg.default)(placement);
        var isStartVariation = (0, $hD45i.default)(placement) === (0, $aHbEK.start);
        var isVertical = [
            (0, $aHbEK.top),
            (0, $aHbEK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $aHbEK.right) : (0, $aHbEK.left) : isStartVariation ? (0, $aHbEK.bottom) : (0, $aHbEK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $910or.default)(mainVariationSide);
        var altVariationSide = (0, $910or.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRequire.register("910or", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690483208b9a3207$export$2e2bcd8739ae039; });
var $690483208b9a3207$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}

});

parcelRequire.register("1EPiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13515282412eb271$export$2e2bcd8739ae039; });
var $13515282412eb271$var$hash = {
    start: "end",
    end: "start"
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}

});

parcelRequire.register("74FGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52693e6050d55014$export$2e2bcd8739ae039; });

var $bxNPU = parcelRequire("bxNPU");

var $aMuSx = parcelRequire("aMuSx");

var $jTgmx = parcelRequire("jTgmx");

var $gIQYz = parcelRequire("gIQYz");

var $245PV = parcelRequire("245PV");

var $aHbEK = parcelRequire("aHbEK");

var $kWkO0 = parcelRequire("kWkO0");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");
function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $aHbEK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $aHbEK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $aHbEK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $lVDOe.default)(typeof padding !== "number" ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
    var altContext = elementContext === (0, $aHbEK.popper) ? (0, $aHbEK.reference) : (0, $aHbEK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $bxNPU.default)((0, $kWkO0.isElement)(element) ? element : element.contextElement || (0, $aMuSx.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $jTgmx.default)(state.elements.reference);
    var popperOffsets = (0, $gIQYz.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $245PV.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $aHbEK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $aHbEK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $aHbEK.right),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $aHbEK.top),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRequire.register("bxNPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86796f3d3717fc99$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $tIQGN = parcelRequire("tIQGN");

var $kNUmP = parcelRequire("kNUmP");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $jTgmx = parcelRequire("jTgmx");

var $d8xUD = parcelRequire("d8xUD");

var $ltVxa = parcelRequire("ltVxa");

var $fRINz = parcelRequire("fRINz");

var $245PV = parcelRequire("245PV");

var $hsTEw = parcelRequire("hsTEw");
function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $jTgmx.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $aHbEK.viewport) ? (0, $245PV.default)((0, $tIQGN.default)(element, strategy)) : (0, $kWkO0.isElement)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $245PV.default)((0, $kNUmP.default)((0, $aMuSx.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $5fhgl.default)((0, $d8xUD.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $5lm85.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kWkO0.isHTMLElement)(element) ? (0, $9vuui.default)(element) : element;
    if (!(0, $kWkO0.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kWkO0.isElement)(clippingParent) && (0, $ltVxa.default)(clippingParent, clipperElement) && (0, $fRINz.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hsTEw.max)(rect.top, accRect.top);
        accRect.right = (0, $hsTEw.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hsTEw.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hsTEw.max)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRequire.register("tIQGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05957f974ad3b041$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $jhPl0 = parcelRequire("jhPl0");

var $fv6RK = parcelRequire("fv6RK");
function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $7LvDQ.default)(element);
    var html = (0, $aMuSx.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fv6RK.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $jhPl0.default)(element),
        y: y
    };
}

});

parcelRequire.register("kNUmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2541b971d258cf0$export$2e2bcd8739ae039; });

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $jhPl0 = parcelRequire("jhPl0");

var $k28Ly = parcelRequire("k28Ly");

var $hsTEw = parcelRequire("hsTEw");
function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $aMuSx.default)(element);
    var winScroll = (0, $k28Ly.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hsTEw.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hsTEw.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $jhPl0.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5lm85.default)(body || html).direction === "rtl") x += (0, $hsTEw.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRequire.register("ltVxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa38ef77d76834a0$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kWkO0.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRequire.register("245PV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18107b7e48021ffa$export$2e2bcd8739ae039; });
function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRequire.register("lVDOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6dcd1b0906e9b8$export$2e2bcd8739ae039; });

var $2CmeP = parcelRequire("2CmeP");
function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2CmeP.default)(), paddingObject);
}

});
parcelRequire.register("2CmeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e806166c2cdf48d$export$2e2bcd8739ae039; });
function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRequire.register("hf3yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d699eb93b3090c$export$2e2bcd8739ae039; });
function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRequire.register("ewHfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a935996b3496591b$export$2e2bcd8739ae039; });

var $hD45i = parcelRequire("hD45i");

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");

var $3ZGTg = parcelRequire("3ZGTg");
function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $aHbEK.placements) : _options$allowedAutoP;
    var variation = (0, $hD45i.default)(placement);
    var placements = variation ? flipVariations ? (0, $aHbEK.variationPlacements) : (0, $aHbEK.variationPlacements).filter(function(placement) {
        return (0, $hD45i.default)(placement) === variation;
    }) : (0, $aHbEK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3ZGTg.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRequire.register("hOZ6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf968237b9d7dd4a$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $3ZGTg = parcelRequire("3ZGTg");

var $4p02M = parcelRequire("4p02M");

var $c8xyK = parcelRequire("c8xyK");

var $1MeQS = parcelRequire("1MeQS");

var $aooBM = parcelRequire("aooBM");

var $9vuui = parcelRequire("9vuui");

var $74FGG = parcelRequire("74FGG");

var $hD45i = parcelRequire("hD45i");

var $2CmeP = parcelRequire("2CmeP");

var $hsTEw = parcelRequire("hsTEw");
function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $74FGG.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var variation = (0, $hD45i.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4p02M.default)(basePlacement);
    var altAxis = (0, $c8xyK.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var altSide = mainAxis === "y" ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $aHbEK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $aHbEK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $aooBM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $2CmeP.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1MeQS.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9vuui.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1MeQS.within)(tether ? (0, $hsTEw.min)(min, tetherMin) : min, offset, tether ? (0, $hsTEw.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var _altSide = mainAxis === "x" ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $aHbEK.top),
            (0, $aHbEK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1MeQS.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1MeQS.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRequire.register("c8xyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d60439f259d6a8c$export$2e2bcd8739ae039; });
function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRequire.register("1MeQS", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $14b5cb667dce379f$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $14b5cb667dce379f$export$86c8af6d3ef0b4a; });

var $hsTEw = parcelRequire("hsTEw");
function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $hsTEw.max)(min, (0, $hsTEw.min)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRequire.register("jUFYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7f3cf13e0769248$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aooBM = parcelRequire("aooBM");

var $ltVxa = parcelRequire("ltVxa");

var $9vuui = parcelRequire("9vuui");

var $4p02M = parcelRequire("4p02M");

var $1MeQS = parcelRequire("1MeQS");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");

var $aHbEK = parcelRequire("aHbEK");
var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $lVDOe.default)(typeof padding !== "number" ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var axis = (0, $4p02M.default)(basePlacement);
    var isVertical = [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $aooBM.default)(arrowElement);
    var minProp = axis === "y" ? (0, $aHbEK.top) : (0, $aHbEK.left);
    var maxProp = axis === "y" ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9vuui.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1MeQS.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ltVxa.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRequire.register("a2tLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f12d998f890694$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");
function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $aHbEK.top),
        (0, $aHbEK.right),
        (0, $aHbEK.bottom),
        (0, $aHbEK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $74FGG.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $74FGG.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $74f12d998f890694$var$hide
};

});


parcelRequire.register("ibZzm", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", function () { return $d3e903795686cbee$export$1b69b6cd0fa638a1; });

var $k6RDS = parcelRequire("k6RDS");

var $4jzsB = parcelRequire("4jzsB");
function $d3e903795686cbee$export$1b69b6cd0fa638a1(slot) {
    return (0, $k6RDS.default)("MuiPopper", slot);
}
const $d3e903795686cbee$export$b6aa214021e734b0 = (0, $4jzsB.default)("MuiPopper", [
    "root"
]);

});



parcelRequire.register("7dVBN", function(module, exports) {

$parcel$export(module.exports, "getPickersPopperUtilityClass", function () { return $54266f2fc78d1fbb$export$5519b4d4bf80ce6f; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $54266f2fc78d1fbb$export$5519b4d4bf80ce6f(slot) {
    return (0, $k6RDS.default)("MuiPickersPopper", slot);
}
const $54266f2fc78d1fbb$export$46e9184c9b1af0ce = (0, $4jzsB.default)("MuiPickersPopper", [
    "root",
    "paper"
]);

});

parcelRequire.register("jpuvJ", function(module, exports) {

$parcel$export(module.exports, "arrayIncludes", function () { return $e21804eb4bb13208$export$22012a5c726bef55; });
$parcel$export(module.exports, "onSpaceOrEnter", function () { return $e21804eb4bb13208$export$4467fe8634707c85; });
$parcel$export(module.exports, "getActiveElement", function () { return $e21804eb4bb13208$export$cd4e5573fbe2b576; });
$parcel$export(module.exports, "DEFAULT_DESKTOP_MODE_MEDIA_QUERY", function () { return $e21804eb4bb13208$export$9ae5b19305db48ce; });
/* Use it instead of .includes method for IE support */ function $e21804eb4bb13208$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $e21804eb4bb13208$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $e21804eb4bb13208$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $e21804eb4bb13208$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $e21804eb4bb13208$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $e21804eb4bb13208$export$9ae5b19305db48ce = "@media (pointer: fine)";

});


parcelRequire.register("gKtnG", function(module, exports) {

$parcel$export(module.exports, "usePicker", function () { return $c317bbaffa35b5af$export$fc3313977ac596c4; });

var $68enk = parcelRequire("68enk");

var $cvB6Q = parcelRequire("cvB6Q");

var $5JnaI = parcelRequire("5JnaI");

var $leDcR = parcelRequire("leDcR");
const $c317bbaffa35b5af$var$warnRenderInputIsDefined = (0, $leDcR.buildWarning)([
    "The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.",
    "You can replace it with the `textField` component slot in most cases.",
    "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."
]);
const $c317bbaffa35b5af$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, inputRef: inputRef, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView })=>{
    const pickerValueResponse = (0, $68enk.usePickerValue)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $cvB6Q.usePickerViews)({
        props: props,
        inputRef: inputRef,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        propsFromPickerValue: pickerValueResponse.viewProps
    });
    const pickerLayoutResponse = (0, $5JnaI.usePickerLayoutProps)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};

});
parcelRequire.register("68enk", function(module, exports) {

$parcel$export(module.exports, "usePickerValue", function () { return $476ea41559631918$export$799b22a7b7fffaa3; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $gaYwN = parcelRequire("gaYwN");

var $giDhD = parcelRequire("giDhD");

var $d1lbr = parcelRequire("d1lbr");

var $92mGG = parcelRequire("92mGG");

var $4gtp2 = parcelRequire("4gtp2");

var $dZX2W = parcelRequire("dZX2W");
/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $476ea41559631918$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === "setValueFromField") return true;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState !== "shallow") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromShortcut") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $476ea41559631918$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState === "finish" && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept" && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $476ea41559631918$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === "setValueFromAction") return true;
    if (action.name === "setValueFromView") return action.selectionState === "finish" && closeOnSelect;
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept";
    return false;
};
const $476ea41559631918$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === "desktop", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp } = props;
    const { current: defaultValue } = $7fPBF.useRef(inDefaultValue);
    const { current: isControlled } = $7fPBF.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $92mGG.useUtils)();
    const adapter = (0, $92mGG.useLocalizationContext)();
    const [selectedSections, setSelectedSections] = (0, $gaYwN.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: "usePickerValue",
        state: "selectedSections"
    });
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $d1lbr.useOpenState)(props);
    const [dateState, setDateState] = $7fPBF.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $dZX2W.useValueWithTimezone)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $4gtp2.useValidation)((0, $kY3Ke.default)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $giDhD.default)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $476ea41559631918$var$shouldPublishValue(updaterParams);
        const shouldCommit = $476ea41559631918$var$shouldCommitValue(updaterParams);
        const shouldClose = $476ea41559631918$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $kY3Ke.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === "setValueFromField" ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $kY3Ke.default)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $kY3Ke.default)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $giDhD.default)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: "setValueFromAction",
            pickerAction: "clear"
        });
    });
    const handleAccept = (0, $giDhD.default)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "accept"
        });
    });
    const handleDismiss = (0, $giDhD.default)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "dismiss"
        });
    });
    const handleCancel = (0, $giDhD.default)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: "setValueFromAction",
            pickerAction: "cancel"
        });
    });
    const handleSetToday = (0, $giDhD.default)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: "setValueFromAction",
            pickerAction: "today"
        });
    });
    const handleOpen = (0, $giDhD.default)(()=>setIsOpen(true));
    const handleClose = (0, $giDhD.default)(()=>setIsOpen(false));
    const handleChange = (0, $giDhD.default)((newValue, selectionState = "partial")=>updateDate({
            name: "setValueFromView",
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $giDhD.default)((newValue, changeImportance)=>updateDate({
            name: "setValueFromShortcut",
            value: newValue,
            changeImportance: changeImportance != null ? changeImportance : "accept"
        }));
    const handleChangeFromField = (0, $giDhD.default)((newValue, context)=>updateDate({
            name: "setValueFromField",
            value: newValue,
            context: context
        }));
    const handleFieldSelectedSectionsChange = (0, $giDhD.default)((newSelectedSections)=>{
        setSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    });
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField,
        selectedSections: selectedSections,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const viewValue = $7fPBF.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $kY3Ke.default)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $kY3Ke.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};

});
parcelRequire.register("d1lbr", function(module, exports) {

$parcel$export(module.exports, "useOpenState", function () { return $97abccf8a6b96579$export$7d3a09d5141ab1f4; });

var $7fPBF = parcelRequire("7fPBF");
const $97abccf8a6b96579$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $7fPBF.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = $7fPBF.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $7fPBF.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $7fPBF.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};

});

parcelRequire.register("4gtp2", function(module, exports) {

$parcel$export(module.exports, "useValidation", function () { return $31af76dae84b836c$export$87fe492f99f25a20; });

var $7fPBF = parcelRequire("7fPBF");

var $92mGG = parcelRequire("92mGG");
function $31af76dae84b836c$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $92mGG.useLocalizationContext)();
    const previousValidationErrorRef = $7fPBF.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $7fPBF.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}

});

parcelRequire.register("dZX2W", function(module, exports) {

$parcel$export(module.exports, "useValueWithTimezone", function () { return $a30ec645234d5ab0$export$c7e050e908c1b2bc; });
$parcel$export(module.exports, "useControlledValueWithTimezone", function () { return $a30ec645234d5ab0$export$174d749f3b4c0f49; });

var $7fPBF = parcelRequire("7fPBF");

var $giDhD = parcelRequire("giDhD");

var $gaYwN = parcelRequire("gaYwN");

var $92mGG = parcelRequire("92mGG");
const $a30ec645234d5ab0$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    var _ref, _ref2;
    const utils = (0, $92mGG.useUtils)();
    const firstDefaultValue = $7fPBF.useRef(defaultValue);
    const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
    const inputTimezone = $7fPBF.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $giDhD.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : "default";
    const valueWithTimezoneToRender = $7fPBF.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $giDhD.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $a30ec645234d5ab0$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $gaYwN.default)({
        name: name,
        state: "value",
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : valueManager.emptyValue
    });
    const onChange = (0, $giDhD.default)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp == null || onChangeProp(newValue, ...otherParams);
    });
    return $a30ec645234d5ab0$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};

});


parcelRequire.register("cvB6Q", function(module, exports) {

$parcel$export(module.exports, "usePickerViews", function () { return $91b52a6f82eabdf2$export$c0a71b697a2df210; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $giDhD = parcelRequire("giDhD");

var $7vFJ6 = parcelRequire("7vFJ6");

var $hEosq = parcelRequire("hEosq");
const $91b52a6f82eabdf2$var$_excluded = [
    "className",
    "sx"
];
const $91b52a6f82eabdf2$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, inputRef: inputRef, autoFocusView: autoFocusView })=>{
    const { onChange: onChange, open: open, onSelectedSectionsChange: onSelectedSectionsChange, onClose: onClose } = propsFromPickerValue;
    const { views: views, openTo: openTo, onViewChange: onViewChange, disableOpenPicker: disableOpenPicker, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $cFLic.default)(props, $91b52a6f82eabdf2$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $7vFJ6.useViews)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (disableOpenPicker) viewMode = "field";
            else if (viewRenderers[viewForReduce] != null) viewMode = "UI";
            else viewMode = "field";
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === "UI") acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = $7fPBF.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $hEosq.isTimeView)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $giDhD.default)(()=>currentViewMode === "UI");
    const [popperView, setPopperView] = $7fPBF.useState(currentViewMode === "UI" ? view : null);
    if (popperView !== view && viewModeLookup[view] === "UI") setPopperView(view);
    (0, $lJRRs.default)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === "field" && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
                inputRef == null || inputRef.current.focus();
                onSelectedSectionsChange(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $lJRRs.default)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === "field" && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            return renderer((0, $kY3Ke.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            }));
        }
    };
};

});
parcelRequire.register("7vFJ6", function(module, exports) {

$parcel$export(module.exports, "useViews", function () { return $577bcba5433b0e3c$export$9b46cba8f8ccd954; });

var $7fPBF = parcelRequire("7fPBF");

var $giDhD = parcelRequire("giDhD");

var $gaYwN = parcelRequire("gaYwN");
let $577bcba5433b0e3c$var$warnedOnceNotValidView = false;
function $577bcba5433b0e3c$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $7fPBF.useRef(openTo);
    const previousViews = $7fPBF.useRef(views);
    const defaultView = $7fPBF.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $gaYwN.default)({
        name: "useViews",
        state: "view",
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $7fPBF.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $gaYwN.default)({
        name: "useViews",
        state: "focusedView",
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $7fPBF.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleFocusedViewChange = (0, $giDhD.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $giDhD.default)((newView)=>{
        if (newView === view) return;
        setView(newView);
        handleFocusedViewChange(newView, true);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $giDhD.default)(()=>{
        if (nextView) handleChangeView(nextView);
        handleFocusedViewChange(nextView, true);
    });
    const setValueAndGoToNextView = (0, $giDhD.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but we it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
        onChange(value, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    const setValueAndGoToView = (0, $giDhD.default)((value, newView, selectedView)=>{
        onChange(value, newView ? "partial" : "finish", selectedView);
        if (newView) {
            handleChangeView(newView);
            handleFocusedViewChange(newView, true);
        }
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        defaultView: defaultView.current,
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView,
        setValueAndGoToView: setValueAndGoToView
    };
}

});


parcelRequire.register("5JnaI", function(module, exports) {

$parcel$export(module.exports, "usePickerLayoutProps", function () { return $42c3212b5eaac64d$export$4e5139e5825b7b27; });

var $kY3Ke = parcelRequire("kY3Ke");

var $Qe5kW = parcelRequire("Qe5kW");
const $42c3212b5eaac64d$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $Qe5kW.useIsLandscape)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $kY3Ke.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};

});
parcelRequire.register("Qe5kW", function(module, exports) {

$parcel$export(module.exports, "useIsLandscape", function () { return $09cfc8723d2df359$export$6f60b24e37af6448; });

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $jpuvJ = parcelRequire("jpuvJ");
function $09cfc8723d2df359$var$getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const $09cfc8723d2df359$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $7fPBF.useState($09cfc8723d2df359$var$getOrientation);
    (0, $lJRRs.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($09cfc8723d2df359$var$getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, $jpuvJ.arrayIncludes)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};

});



parcelRequire.register("1fUy6", function(module, exports) {

$parcel$export(module.exports, "PickersLayout", function () { return $0ea30ea295446df9$export$647f604ea2397c05; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $hngXp = parcelRequire("hngXp");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $lGTXp = parcelRequire("lGTXp");

var $b50Sb = parcelRequire("b50Sb");

var $bbzbN = parcelRequire("bbzbN");
const $0ea30ea295446df9$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $lGTXp.getPickersLayoutUtilityClass), classes);
};
const $0ea30ea295446df9$export$9a9363506c13836 = (0, $kDBhE.default)("div", {
    name: "MuiPickersLayout",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        display: "grid",
        gridAutoColumns: "max-content auto max-content",
        gridAutoRows: "max-content auto max-content",
        [`& .${(0, $lGTXp.pickersLayoutClasses).toolbar}`]: ownerState.isLandscape ? {
            gridColumn: theme.direction === "rtl" ? 3 : 1,
            gridRow: "2 / 3"
        } : {
            gridColumn: "2 / 4",
            gridRow: 1
        },
        [`.${(0, $lGTXp.pickersLayoutClasses).shortcuts}`]: ownerState.isLandscape ? {
            gridColumn: "2 / 4",
            gridRow: 1
        } : {
            gridColumn: theme.direction === "rtl" ? 3 : 1,
            gridRow: "2 / 3"
        },
        [`& .${(0, $lGTXp.pickersLayoutClasses).actionBar}`]: {
            gridColumn: "1 / 4",
            gridRow: 3
        }
    }));
$0ea30ea295446df9$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ])
};
const $0ea30ea295446df9$export$bc1494d918129235 = (0, $kDBhE.default)("div", {
    name: "MuiPickersLayout",
    slot: "ContentWrapper",
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: "flex",
    flexDirection: "column"
});
const $0ea30ea295446df9$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersLayout"
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $b50Sb.default)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $0ea30ea295446df9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($0ea30ea295446df9$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $hngXp.default)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $bbzbN.jsx)($0ea30ea295446df9$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === "desktop" ? /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};

});
parcelRequire.register("lGTXp", function(module, exports) {

$parcel$export(module.exports, "getPickersLayoutUtilityClass", function () { return $fca8ed2355aa4314$export$1671c31de798d429; });
$parcel$export(module.exports, "pickersLayoutClasses", function () { return $fca8ed2355aa4314$export$7a6dac186703fe4c; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $fca8ed2355aa4314$export$1671c31de798d429(slot) {
    return (0, $k6RDS.default)("MuiPickersLayout", slot);
}
const $fca8ed2355aa4314$export$7a6dac186703fe4c = (0, $4jzsB.default)("MuiPickersLayout", [
    "root",
    "landscape",
    "contentWrapper",
    "toolbar",
    "actionBar",
    "shortcuts"
]);

});

parcelRequire.register("b50Sb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8110d6ade26cbc5c$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $94ctx = parcelRequire("94ctx");

var $cFCqu = parcelRequire("cFCqu");

var $ckMbp = parcelRequire("ckMbp");

var $lGTXp = parcelRequire("lGTXp");

var $aR52R = parcelRequire("aR52R");

var $fFgj2 = parcelRequire("fFgj2");

var $bbzbN = parcelRequire("bbzbN");
function $8110d6ade26cbc5c$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $8110d6ade26cbc5c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ],
        toolbar: [
            "toolbar"
        ],
        actionBar: [
            "actionBar"
        ],
        tabs: [
            "tabs"
        ],
        landscape: [
            "landscape"
        ],
        shortcuts: [
            "shortcuts"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $lGTXp.getPickersLayoutUtilityClass), classes);
};
const $8110d6ade26cbc5c$var$usePickerLayout = (props)=>{
    var _slots$actionBar, _slots$shortcuts;
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps } = props;
    const slots = innerSlots != null ? innerSlots : (0, $fFgj2.uncapitalizeObjectKeys)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const classes = $8110d6ade26cbc5c$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : (0, $ckMbp.PickersActionBar);
    const actionBarProps = (0, $94ctx.useSlotProps)({
        elementType: ActionBar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === "desktop" ? [] : [
                "cancel",
                "accept"
            ],
            className: classes.actionBar
        },
        ownerState: (0, $kY3Ke.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $bbzbN.jsx)(ActionBar, (0, $kY3Ke.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots == null ? void 0 : slots.toolbar;
    const toolbarProps = (0, $94ctx.useSlotProps)({
        elementType: Toolbar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $kY3Ke.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $8110d6ade26cbc5c$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $bbzbN.jsx)(Toolbar, (0, $kY3Ke.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots == null ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $bbzbN.jsx)(Tabs, (0, $kY3Ke.default)({
        view: view,
        onViewChange: onViewChange
    }, slotProps == null ? void 0 : slotProps.tabs)) : null;
    // Shortcuts
    const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : (0, $aR52R.PickersShortcuts);
    const shortcutsProps = (0, $94ctx.useSlotProps)({
        elementType: Shortcuts,
        externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $bbzbN.jsx)(Shortcuts, (0, $kY3Ke.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $8110d6ade26cbc5c$export$2e2bcd8739ae039 = $8110d6ade26cbc5c$var$usePickerLayout;

});
parcelRequire.register("ckMbp", function(module, exports) {

$parcel$export(module.exports, "PickersActionBar", function () { return $8facba742bfbb34f$export$72ffda3bb7ecf665; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $5ZeKC = parcelRequire("5ZeKC");

var $8smOS = parcelRequire("8smOS");

var $92mGG = parcelRequire("92mGG");

var $bbzbN = parcelRequire("bbzbN");
const $8facba742bfbb34f$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
function $8facba742bfbb34f$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $cFLic.default)(props, $8facba742bfbb34f$var$_excluded);
    const localeText = (0, $92mGG.useLocaleText)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions == null ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8smOS.default), (0, $kY3Ke.default)({}, other, {
        children: buttons
    }));
}

});

parcelRequire.register("aR52R", function(module, exports) {

$parcel$export(module.exports, "PickersShortcuts", function () { return $7e72c47dc598913d$export$8ba8fc65919fa1fe; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $lAoIf = parcelRequire("lAoIf");

var $3MLTY = parcelRequire("3MLTY");

var $2hGJ2 = parcelRequire("2hGJ2");

var $l04BV = parcelRequire("l04BV");

var $bbzbN = parcelRequire("bbzbN");
const $7e72c47dc598913d$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
];
function $7e72c47dc598913d$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance, onChange: onChange, isValid: isValid } = props, other = (0, $cFLic.default)(props, $7e72c47dc598913d$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((item)=>{
        const newValue = item.getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lAoIf.default), (0, $kY3Ke.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $l04BV.VIEW_HEIGHT),
                maxWidth: 200,
                overflow: "auto"
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3MLTY.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), (0, $kY3Ke.default)({}, item))
            }, item.label);
        })
    }));
}

});
parcelRequire.register("3MLTY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c1b031ce0fa2278$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $7HQQ4 = parcelRequire("7HQQ4");
var $cFCqu = parcelRequire("cFCqu");


var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $3RNaF = parcelRequire("3RNaF");

var $91ID4 = parcelRequire("91ID4");

var $hQtyv = parcelRequire("hQtyv");

var $6NwTb = parcelRequire("6NwTb");

var $cMvyt = parcelRequire("cMvyt");

var $15jOT = parcelRequire("15jOT");

var $7OeXd = parcelRequire("7OeXd");

var $e9Nto = parcelRequire("e9Nto");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $2c1b031ce0fa2278$var$_excluded = [
    "className"
], $2c1b031ce0fa2278$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $2c1b031ce0fa2278$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $2c1b031ce0fa2278$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $15jOT.getListItemUtilityClass), classes);
};
const $2c1b031ce0fa2278$export$aed538f7519abe89 = (0, $kDBhE.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $2c1b031ce0fa2278$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $kY3Ke.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $7OeXd.default).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $15jOT.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $15jOT.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $15jOT.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $15jOT.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $15jOT.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $2c1b031ce0fa2278$var$ListItemContainer = (0, $kDBhE.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $2c1b031ce0fa2278$var$ListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $cFLic.default)(props.ContainerProps, $2c1b031ce0fa2278$var$_excluded), other = (0, $cFLic.default)(props, $2c1b031ce0fa2278$var$_excluded2);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $7fPBF.useRef(null);
    (0, $hQtyv.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $7fPBF.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $91ID4.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $2c1b031ce0fa2278$var$useUtilityClasses(ownerState);
    const handleRef = (0, $6NwTb.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $2c1b031ce0fa2278$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $hngXp.default)((0, $15jOT.default).focusVisible, focusVisibleClassName);
        Component = (0, $3RNaF.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)($2c1b031ce0fa2278$var$ListItemContainer, (0, $kY3Ke.default)({
                as: ContainerComponent,
                className: (0, $hngXp.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $7HQQ4.isHostComponent)(Root) && {
                        as: Component,
                        ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cMvyt.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $7HQQ4.isHostComponent)(Root) && {
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e9Nto.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $2c1b031ce0fa2278$export$2e2bcd8739ae039 = $2c1b031ce0fa2278$var$ListItem;

});
parcelRequire.register("15jOT", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", function () { return $0ca5a1e6788dced6$export$5682c366c0c669d9; });
$parcel$export(module.exports, "default", function () { return $0ca5a1e6788dced6$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0ca5a1e6788dced6$export$5682c366c0c669d9(slot) {
    return (0, $k6RDS.default)("MuiListItem", slot);
}
const $0ca5a1e6788dced6$var$listItemClasses = (0, $4jzsB.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $0ca5a1e6788dced6$export$2e2bcd8739ae039 = $0ca5a1e6788dced6$var$listItemClasses;

});

parcelRequire.register("7OeXd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af8cd7874d684d8$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $5af8cd7874d684d8$export$c09531d8563c67a5(slot) {
    return (0, $k6RDS.default)("MuiListItemButton", slot);
}
const $5af8cd7874d684d8$var$listItemButtonClasses = (0, $4jzsB.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $5af8cd7874d684d8$export$2e2bcd8739ae039 = $5af8cd7874d684d8$var$listItemButtonClasses;

});

parcelRequire.register("e9Nto", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4e848490d2ab66f$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $cMvyt = parcelRequire("cMvyt");

var $cpeX4 = parcelRequire("cpeX4");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a4e848490d2ab66f$var$_excluded = [
    "className"
];
const $a4e848490d2ab66f$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $cpeX4.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $a4e848490d2ab66f$var$ListItemSecondaryActionRoot = (0, $kDBhE.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $a4e848490d2ab66f$var$ListItemSecondaryAction = /*#__PURE__*/ $7fPBF.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $a4e848490d2ab66f$var$_excluded);
    const context = $7fPBF.useContext((0, $cMvyt.default));
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $a4e848490d2ab66f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a4e848490d2ab66f$var$ListItemSecondaryActionRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$a4e848490d2ab66f$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $a4e848490d2ab66f$export$2e2bcd8739ae039 = $a4e848490d2ab66f$var$ListItemSecondaryAction;

});
parcelRequire.register("cpeX4", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", function () { return $90836af743b99227$export$ccdb26aeba48a86e; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $90836af743b99227$export$ccdb26aeba48a86e(slot) {
    return (0, $k6RDS.default)("MuiListItemSecondaryAction", slot);
}
const $90836af743b99227$var$listItemSecondaryActionClasses = (0, $4jzsB.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $90836af743b99227$export$2e2bcd8739ae039 = $90836af743b99227$var$listItemSecondaryActionClasses;

});



parcelRequire.register("l04BV", function(module, exports) {

$parcel$export(module.exports, "DAY_SIZE", function () { return $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0; });
$parcel$export(module.exports, "DAY_MARGIN", function () { return $f49d2ca225f7bed5$export$dde58b009b497666; });
$parcel$export(module.exports, "DIALOG_WIDTH", function () { return $f49d2ca225f7bed5$export$ee46b8a74d6c94d3; });
$parcel$export(module.exports, "VIEW_HEIGHT", function () { return $f49d2ca225f7bed5$export$f2fef360e2df0cb7; });
$parcel$export(module.exports, "DIGITAL_CLOCK_VIEW_HEIGHT", function () { return $f49d2ca225f7bed5$export$1c2eabda4acea0e4; });
$parcel$export(module.exports, "MULTI_SECTION_CLOCK_SECTION_WIDTH", function () { return $f49d2ca225f7bed5$export$a462ceb9cfdb5d71; });
const $f49d2ca225f7bed5$export$3f0060ce4cc8f4d0 = 36;
const $f49d2ca225f7bed5$export$dde58b009b497666 = 2;
const $f49d2ca225f7bed5$export$ee46b8a74d6c94d3 = 320;
const $f49d2ca225f7bed5$export$f2fef360e2df0cb7 = 358;
const $f49d2ca225f7bed5$export$1c2eabda4acea0e4 = 232;
const $f49d2ca225f7bed5$export$a462ceb9cfdb5d71 = 48;

});





parcelRequire.register("3qBKp", function(module, exports) {

$parcel$export(module.exports, "ArrowDropDownIcon", function () { return $27f114a7ae98fe28$export$ed0fe318cc298673; });
$parcel$export(module.exports, "ArrowLeftIcon", function () { return $27f114a7ae98fe28$export$8afed21ef5c2afa5; });
$parcel$export(module.exports, "ArrowRightIcon", function () { return $27f114a7ae98fe28$export$9ca09caa9c849d9c; });
$parcel$export(module.exports, "CalendarIcon", function () { return $27f114a7ae98fe28$export$5fda1783bb83f57b; });
$parcel$export(module.exports, "ClockIcon", function () { return $27f114a7ae98fe28$export$8099ab97743c966c; });

var $6PKLM = parcelRequire("6PKLM");

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
const $27f114a7ae98fe28$export$ed0fe318cc298673 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $27f114a7ae98fe28$export$8afed21ef5c2afa5 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const $27f114a7ae98fe28$export$9ca09caa9c849d9c = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const $27f114a7ae98fe28$export$5fda1783bb83f57b = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const $27f114a7ae98fe28$export$8099ab97743c966c = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const $27f114a7ae98fe28$export$90a8eab2a2411720 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const $27f114a7ae98fe28$export$7e95adcf912503e3 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
    children: [
        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");

});

parcelRequire.register("7Fco7", function(module, exports) {

$parcel$export(module.exports, "DateField", function () { return $5945f8b72dcc769b$export$d9781c7894a82487; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $f6ezL = parcelRequire("f6ezL");

var $5j2OD = parcelRequire("5j2OD");

var $94ctx = parcelRequire("94ctx");

var $iJKDb = parcelRequire("iJKDb");

var $bbzbN = parcelRequire("bbzbN");
const $5945f8b72dcc769b$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $5945f8b72dcc769b$var$_excluded2 = [
    "inputRef"
], $5945f8b72dcc769b$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly"
];
const $5945f8b72dcc769b$export$d9781c7894a82487 = /*#__PURE__*/ $7fPBF.forwardRef(function DateField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDateField"
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $cFLic.default)(themeProps, $5945f8b72dcc769b$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $f6ezL.default);
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $cFLic.default)(_useSlotProps, $5945f8b72dcc769b$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $kY3Ke.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $kY3Ke.default)({}, InputProps, textFieldProps.InputProps);
    const _useDateField = (0, $iJKDb.useDateField)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly } = _useDateField, fieldProps = (0, $cFLic.default)(_useDateField, $5945f8b72dcc769b$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TextField, (0, $kY3Ke.default)({
        ref: ref
    }, fieldProps, {
        InputProps: (0, $kY3Ke.default)({}, fieldProps.InputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $kY3Ke.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});

});
parcelRequire.register("iJKDb", function(module, exports) {

$parcel$export(module.exports, "useDateField", function () { return $da4099eec06cd7d9$export$5591b0b878c1a989; });

var $kY3Ke = parcelRequire("kY3Ke");

var $blfb5 = parcelRequire("blfb5");

var $3BLrA = parcelRequire("3BLrA");

var $fq3Fh = parcelRequire("fq3Fh");

var $6CwGv = parcelRequire("6CwGv");

var $92mGG = parcelRequire("92mGG");

var $gMdDk = parcelRequire("gMdDk");
const $da4099eec06cd7d9$var$useDefaultizedDateField = (props)=>{
    var _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $92mGG.useUtils)();
    const defaultDates = (0, $92mGG.useDefaultDates)();
    return (0, $kY3Ke.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
        minDate: (0, $6CwGv.applyDefaultDate)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $6CwGv.applyDefaultDate)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $da4099eec06cd7d9$export$5591b0b878c1a989 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $da4099eec06cd7d9$var$useDefaultizedDateField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $gMdDk.splitFieldInternalAndForwardedProps)(props, "date");
    return (0, $3BLrA.useField)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $blfb5.singleItemValueManager),
        fieldValueManager: (0, $blfb5.singleItemFieldValueManager),
        validator: (0, $fq3Fh.validateDate),
        valueType: "date"
    });
};

});
parcelRequire.register("3BLrA", function(module, exports) {

$parcel$export(module.exports, "useField", function () { return $2a09a13200d5a2c7$export$294aa081a6c6f55d; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $lJRRs = parcelRequire("lJRRs");

var $giDhD = parcelRequire("giDhD");

var $jTdAm = parcelRequire("jTdAm");

var $g9bTP = parcelRequire("g9bTP");

var $4gtp2 = parcelRequire("4gtp2");

var $92mGG = parcelRequire("92mGG");

var $ab9wb = parcelRequire("ab9wb");

var $eIw0Z = parcelRequire("eIw0Z");

var $j5iAh = parcelRequire("j5iAh");

var $jpuvJ = parcelRequire("jpuvJ");
const $2a09a13200d5a2c7$var$_excluded = [
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onMouseUp",
    "onPaste",
    "error"
];
const $2a09a13200d5a2c7$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $92mGG.useUtils)();
    const { state: state, selectedSectionIndexes: selectedSectionIndexes, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, placeholder: placeholder, timezone: timezone } = (0, $eIw0Z.useFieldState)(params);
    const { inputRef: inputRefProp, internalProps: internalProps, internalProps: { readOnly: readOnly = false, unstableFieldRef: unstableFieldRef, minutesStep: minutesStep }, forwardedProps: { onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp, onPaste: onPaste, error: error }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params, otherForwardedProps = (0, $cFLic.default)(params.forwardedProps, $2a09a13200d5a2c7$var$_excluded);
    const { applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery } = (0, $j5iAh.useFieldCharacterEditing)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const inputRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(inputRefProp, inputRef);
    const focusTimeoutRef = $7fPBF.useRef(undefined);
    const theme = (0, $g9bTP.default)();
    const isRTL = theme.direction === "rtl";
    const sectionOrder = $7fPBF.useMemo(()=>(0, $ab9wb.getSectionOrder)(state.sections, isRTL), [
        state.sections,
        isRTL
    ]);
    const syncSelectionFromDOM = ()=>{
        var _selectionStart;
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
        let nextSectionIndex;
        if (browserStartIndex <= state.sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputClick = (0, $giDhD.default)((...args)=>{
        onClick == null || onClick(...args);
        syncSelectionFromDOM();
    });
    const handleInputMouseUp = (0, $giDhD.default)((event)=>{
        onMouseUp == null || onMouseUp(event);
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handleInputFocus = (0, $giDhD.default)((...args)=>{
        onFocus == null || onFocus(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        window.clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (selectedSectionIndexes != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections("all");
            else syncSelectionFromDOM();
        });
    });
    const handleInputBlur = (0, $giDhD.default)((...args)=>{
        onBlur == null || onBlur(...args);
        setSelectedSections(null);
    });
    const handleInputPaste = (0, $giDhD.default)((event)=>{
        onPaste == null || onPaste(event);
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData("text");
        if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
            if (isValidPastedValue) // Early return to let the paste update section, value
            return;
            if (lettersOnly || digitsOnly) {
                // The pasted value correspond to a single section but not the expected type
                // skip the modification
                event.preventDefault();
                return;
            }
        }
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleInputChange = (0, $giDhD.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = (0, $ab9wb.cleanString)(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (selectedSectionIndexes == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = (0, $ab9wb.cleanString)(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - (0, $ab9wb.cleanString)(activeSection.endSeparator || "").length;
            keyPressed = cleanValueStr.slice(activeSection.start + (0, $ab9wb.cleanString)(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
        }
        if ((0, $ab9wb.isAndroid)() && keyPressed.length === 0) {
            setTempAndroidValueStr(valueStr);
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: selectedSectionIndexes.startIndex
        });
    });
    const handleInputKeyDown = (0, $giDhD.default)((event)=>{
        onKeyDown == null || onKeyDown(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case event.key === "a" && (event.ctrlKey || event.metaKey):
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections("all");
                break;
            // Move selection to next section
            case event.key === "ArrowRight":
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.startIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === "ArrowLeft":
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.endIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case [
                "Backspace",
                "Delete"
            ].includes(event.key):
                event.preventDefault();
                if (readOnly) break;
                if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
                "PageUp",
                "PageDown"
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || selectedSectionIndexes == null) break;
                    const activeSection = state.sections[selectedSectionIndexes.startIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $ab9wb.adjustSectionValue)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $lJRRs.default)(()=>{
        if (!inputRef.current) return;
        if (selectedSectionIndexes == null) {
            if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
            // setting selection range to 0 causes issues in Safari.
            // https://bugs.webkit.org/show_bug.cgi?id=224425
            inputRef.current.scrollLeft = 0;
            return;
        }
        const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
        const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
        let selectionStart = firstSelectedSection.startInInput;
        let selectionEnd = lastSelectedSection.endInInput;
        if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
            selectionStart -= firstSelectedSection.startSeparator.length;
            selectionEnd += lastSelectedSection.endSeparator.length;
        }
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            // On multi input range pickers we want to update selection range only for the active input
            // This helps avoiding the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current === (0, $jpuvJ.getActiveElement)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
    });
    const validationError = (0, $4gtp2.useValidation)((0, $kY3Ke.default)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $7fPBF.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $7fPBF.useEffect(()=>{
        if (!inputError && !selectedSectionIndexes) resetCharacterQuery();
    }, [
        state.referenceValue,
        selectedSectionIndexes,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(()=>{
        // Select the right section when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === document.activeElement) setSelectedSections("all");
        return ()=>window.clearTimeout(focusTimeoutRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $7fPBF.useEffect(()=>{
        if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.tempValueStrAndroid
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const valueStr = $7fPBF.useMemo(()=>{
        var _state$tempValueStrAn;
        return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
    }, [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        isRTL
    ]);
    const inputMode = $7fPBF.useMemo(()=>{
        if (selectedSectionIndexes == null) return "text";
        if (state.sections[selectedSectionIndexes.startIndex].contentType === "letter") return "text";
        return "numeric";
    }, [
        selectedSectionIndexes,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $jpuvJ.getActiveElement)(document);
    const shouldShowPlaceholder = !inputHasFocus && valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    $7fPBF.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                var _selectionStart2, _selectionEnd;
                const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
                const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (activeSectionIndex)=>setSelectedSections(activeSectionIndex)
        }));
    return (0, $kY3Ke.default)({
        placeholder: placeholder,
        autoComplete: "off"
    }, otherForwardedProps, {
        value: shouldShowPlaceholder ? "" : valueStr,
        inputMode: inputMode,
        readOnly: readOnly,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onPaste: handleInputPaste,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onMouseUp: handleInputMouseUp,
        error: inputError,
        ref: handleRef
    });
};

});
parcelRequire.register("eIw0Z", function(module, exports) {

$parcel$export(module.exports, "useFieldState", function () { return $ab6e023aa9d06979$export$4e8d6353e50062e7; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $gaYwN = parcelRequire("gaYwN");

var $g9bTP = parcelRequire("g9bTP");

var $92mGG = parcelRequire("92mGG");

var $ab9wb = parcelRequire("ab9wb");

var $dZX2W = parcelRequire("dZX2W");

var $kh1ja = parcelRequire("kh1ja");
const $ab6e023aa9d06979$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $92mGG.useUtils)();
    const localeText = (0, $92mGG.useLocaleText)();
    const adapter = (0, $92mGG.useLocalizationContext)();
    const theme = (0, $g9bTP.default)();
    const isRTL = theme.direction === "rtl";
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = "dense", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $dZX2W.useValueWithTimezone)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const sectionsValueBoundaries = $7fPBF.useMemo(()=>(0, $ab9wb.getSectionsBoundaries)(utils, timezone), [
        utils,
        timezone
    ]);
    const getSectionsFromValue = $7fPBF.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, (date)=>(0, $ab9wb.splitFormatIntoSections)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [
        fieldValueManager,
        format,
        localeText,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone
    ]);
    const placeholder = $7fPBF.useMemo(()=>fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        isRTL
    ]);
    const [state, setState] = $7fPBF.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $ab9wb.validateSections)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $kh1ja.getSectionTypeGranularity)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $kY3Ke.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $gaYwN.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: "useField",
        state: "selectedSectionIndexes"
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
        setState((prevState)=>(0, $kY3Ke.default)({}, prevState, {
                selectedSectionQuery: null
            }));
    };
    const selectedSectionIndexes = $7fPBF.useMemo(()=>{
        if (selectedSections == null) return null;
        if (selectedSections === "all") return {
            startIndex: 0,
            endIndex: state.sections.length - 1,
            shouldSelectBoundarySelectors: true
        };
        if (typeof selectedSections === "number") return {
            startIndex: selectedSections,
            endIndex: selectedSections
        };
        if (typeof selectedSections === "string") {
            const selectedSectionIndex = state.sections.findIndex((section)=>section.type === selectedSections);
            return {
                startIndex: selectedSectionIndex,
                endIndex: selectedSectionIndex
            };
        }
        return selectedSections;
    }, [
        selectedSections,
        state.sections
    ]);
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $kY3Ke.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $kY3Ke.default)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $kY3Ke.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return (0, $ab9wb.addPositionPropertiesToSections)(newSections, isRTL);
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue)) return;
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (selectedSectionIndexes == null) return;
        const activeSection = state.sections[selectedSectionIndexes.startIndex];
        if (activeSection.value === "") return;
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== "").length;
        const isTheOnlyNonEmptySection = nonEmptySectionCountBefore === 1;
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, "");
        const newActiveDate = isTheOnlyNonEmptySection ? null : utils.date(new Date(""));
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) publishValue((0, $kY3Ke.default)({}, newValues, {
            sections: newSections
        }));
        else setState((prevState)=>(0, $kY3Ke.default)({}, prevState, newValues, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $ab9wb.splitFormatIntoSections)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
            return (0, $ab9wb.mergeDateIntoReferenceDate)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) setSelectedSections(selectedSectionIndexes.startIndex + 1);
        else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        let newActiveDate = (0, $ab9wb.getDateFromDateSections)(utils, newActiveDateSections);
        let shouldRegenSections = false;
        /**
     * If the date is invalid,
     * Then we can try to clamp the day section to see if that produces a valid date.
     * This can be useful if the month has fewer days than the day value currently provided.
     */ if (!utils.isValid(newActiveDate)) {
            const clampedSections = (0, $ab9wb.clampDaySectionIfPossible)(utils, timezone, newActiveDateSections, sectionsValueBoundaries);
            if (clampedSections != null) {
                shouldRegenSections = true;
                newActiveDate = (0, $ab9wb.getDateFromDateSections)(utils, clampedSections);
            }
        }
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $ab9wb.mergeDateIntoReferenceDate)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * If the value has been modified (to clamp the day).
     * Then we need to re-generate the sections to make sure they also have this change.
     */ const sections = shouldRegenSections ? getSectionsFromValue(values.value, state.sections) : newSections;
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $kY3Ke.default)({}, values, {
            sections: sections
        }));
        return setState((prevState)=>(0, $kY3Ke.default)({}, prevState, values, {
                sections: sections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $kY3Ke.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $7fPBF.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $ab9wb.validateSections)(sections, valueType);
        setState((prevState)=>(0, $kY3Ke.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $7fPBF.useEffect(()=>{
        let shouldUpdate = false;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $kY3Ke.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        selectedSectionIndexes: selectedSectionIndexes,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        sectionsValueBoundaries: sectionsValueBoundaries,
        placeholder: placeholder,
        timezone: timezone
    };
};

});

parcelRequire.register("j5iAh", function(module, exports) {

$parcel$export(module.exports, "useFieldCharacterEditing", function () { return $de4ce65a55c75bbb$export$66d00048b8bb82f6; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $giDhD = parcelRequire("giDhD");

var $92mGG = parcelRequire("92mGG");

var $ab9wb = parcelRequire("ab9wb");
/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $de4ce65a55c75bbb$var$QUERY_LIFE_DURATION_MS = 5000;
const $de4ce65a55c75bbb$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $de4ce65a55c75bbb$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $92mGG.useUtils)();
    const [query, setQuery] = $7fPBF.useState(null);
    const resetQuery = (0, $giDhD.default)(()=>setQuery(null));
    $7fPBF.useEffect(()=>{
        var _sections$query$secti;
        if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $7fPBF.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $de4ce65a55c75bbb$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                window.clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenated value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $ab9wb.getLetterEditingOptions)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === "letter") return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $ab9wb.getDateSectionConfigFromFormatToken)(utils, fallbackFormat).contentType === "letter") {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $kY3Ke.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case "month":
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $ab9wb.changeSectionValueFormat)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case "weekDay":
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case "meridiem":
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const queryValueNumber = Number(`${queryValue}`);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $ab9wb.cleanDigitSectionValue)(utils, timezone, queryValueNumber, sectionBoundaries, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === "month") {
                const hasLeadingZerosInFormat = (0, $ab9wb.doesSectionFormatHaveLeadingZeros)(utils, timezone, "digit", "month", "MM");
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: "MM",
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: "digit",
                    maxLength: 2
                });
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $ab9wb.changeSectionValueFormat)(utils, response.sectionValue, "MM", activeSection.format);
                return (0, $kY3Ke.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === "weekDay") {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($de4ce65a55c75bbb$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $ab9wb.getDaysInWeekStr)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $kY3Ke.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>!Number.isNaN(Number(queryValue)));
    };
    const applyCharacterEditing = (0, $giDhD.default)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = !Number.isNaN(Number(params.keyPressed));
        const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
        if (response == null) setTempAndroidValueStr(null);
        else updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};

});


parcelRequire.register("gMdDk", function(module, exports) {

$parcel$export(module.exports, "splitFieldInternalAndForwardedProps", function () { return $c36bb456184413d3$export$cdde224d2939fd84; });

var $kY3Ke = parcelRequire("kY3Ke");

var $3GboI = parcelRequire("3GboI");
const $c36bb456184413d3$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    "value",
    "defaultValue",
    "referenceDate",
    "format",
    "formatDensity",
    "onChange",
    "timezone",
    "readOnly",
    "onError",
    "shouldRespectLeadingZeros",
    "selectedSections",
    "onSelectedSectionsChange",
    "unstableFieldRef"
];
const $c36bb456184413d3$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $kY3Ke.default)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $c36bb456184413d3$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === "date") (0, $3GboI.DATE_VALIDATION_PROP_NAMES).forEach(extractProp);
    else if (valueType === "time") (0, $3GboI.TIME_VALIDATION_PROP_NAMES).forEach(extractProp);
    else if (valueType === "date-time") {
        (0, $3GboI.DATE_VALIDATION_PROP_NAMES).forEach(extractProp);
        (0, $3GboI.TIME_VALIDATION_PROP_NAMES).forEach(extractProp);
        (0, $3GboI.DATE_TIME_VALIDATION_PROP_NAMES).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};

});
parcelRequire.register("3GboI", function(module, exports) {

$parcel$export(module.exports, "DATE_VALIDATION_PROP_NAMES", function () { return $2ade22a6fd91393f$export$430d9fc64cf058d6; });
$parcel$export(module.exports, "TIME_VALIDATION_PROP_NAMES", function () { return $2ade22a6fd91393f$export$fd5e0f8b4115a8c7; });
$parcel$export(module.exports, "DATE_TIME_VALIDATION_PROP_NAMES", function () { return $2ade22a6fd91393f$export$1df62d3ba2121371; });
$parcel$export(module.exports, "extractValidationProps", function () { return $2ade22a6fd91393f$export$5890f750904acddb; });
const $2ade22a6fd91393f$export$430d9fc64cf058d6 = [
    "disablePast",
    "disableFuture",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear"
];
const $2ade22a6fd91393f$export$fd5e0f8b4115a8c7 = [
    "disablePast",
    "disableFuture",
    "minTime",
    "maxTime",
    "shouldDisableClock",
    "shouldDisableTime",
    "minutesStep",
    "ampm",
    "disableIgnoringDatePartForTimeValidation"
];
const $2ade22a6fd91393f$export$1df62d3ba2121371 = [
    "minDateTime",
    "maxDateTime"
];
const $2ade22a6fd91393f$var$VALIDATION_PROP_NAMES = [
    ...$2ade22a6fd91393f$export$430d9fc64cf058d6,
    ...$2ade22a6fd91393f$export$fd5e0f8b4115a8c7,
    ...$2ade22a6fd91393f$export$1df62d3ba2121371
];
const $2ade22a6fd91393f$export$5890f750904acddb = (props)=>$2ade22a6fd91393f$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});

});




parcelRequire.register("efc1W", function(module, exports) {

$parcel$export(module.exports, "renderDateViewCalendar", function () { return $02ad17f0efd035e0$export$69888ffe06193e5e; });
parcelRequire("7fPBF");

var $gV4lx = parcelRequire("gV4lx");

var $6CwGv = parcelRequire("6CwGv");

var $bbzbN = parcelRequire("bbzbN");
const $02ad17f0efd035e0$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gV4lx.DateCalendar), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $6CwGv.isDatePickerView)),
        focusedView: focusedView && (0, $6CwGv.isDatePickerView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        defaultCalendarMonth: defaultCalendarMonth,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });

});
parcelRequire.register("gV4lx", function(module, exports) {

$parcel$export(module.exports, "DateCalendar", function () { return $c515574e4bff3014$export$68078fe5d2bf8909; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $94ctx = parcelRequire("94ctx");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $giDhD = parcelRequire("giDhD");
var $65Itt = parcelRequire("65Itt");

var $fMbyK = parcelRequire("fMbyK");

var $92mGG = parcelRequire("92mGG");

var $cUICR = parcelRequire("cUICR");

var $gJ3t2 = parcelRequire("gJ3t2");

var $6vtTj = parcelRequire("6vtTj");

var $7XqRE = parcelRequire("7XqRE");

var $7vFJ6 = parcelRequire("7vFJ6");

var $aMle3 = parcelRequire("aMle3");

var $6CwGv = parcelRequire("6CwGv");

var $5VM6C = parcelRequire("5VM6C");

var $7aVCm = parcelRequire("7aVCm");

var $kbH27 = parcelRequire("kbH27");

var $dZX2W = parcelRequire("dZX2W");

var $blfb5 = parcelRequire("blfb5");

var $bbzbN = parcelRequire("bbzbN");
const $c515574e4bff3014$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $c515574e4bff3014$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $kbH27.getDateCalendarUtilityClass), classes);
};
function $c515574e4bff3014$var$useDateCalendarDefaultizedProps(props, name) {
    var _themeProps$loading, _themeProps$disablePa, _themeProps$disableFu, _themeProps$openTo, _themeProps$views, _themeProps$reduceAni, _themeProps$renderLoa;
    const utils = (0, $92mGG.useUtils)();
    const defaultDates = (0, $92mGG.useDefaultDates)();
    const defaultReduceAnimations = (0, $7aVCm.useDefaultReduceAnimations)();
    const themeProps = (0, $5j2OD.default)({
        props: props,
        name: name
    });
    return (0, $kY3Ke.default)({}, themeProps, {
        loading: (_themeProps$loading = themeProps.loading) != null ? _themeProps$loading : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        openTo: (_themeProps$openTo = themeProps.openTo) != null ? _themeProps$openTo : "day",
        views: (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
            "year",
            "day"
        ],
        reduceAnimations: (_themeProps$reduceAni = themeProps.reduceAnimations) != null ? _themeProps$reduceAni : defaultReduceAnimations,
        renderLoading: (_themeProps$renderLoa = themeProps.renderLoading) != null ? _themeProps$renderLoa : ()=>/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: "..."
            }),
        minDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $c515574e4bff3014$var$DateCalendarRoot = (0, $kDBhE.default)((0, $5VM6C.PickerViewRoot), {
    name: "MuiDateCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column"
});
const $c515574e4bff3014$var$DateCalendarViewTransitionContainer = (0, $kDBhE.default)((0, $cUICR.PickersFadeTransitionGroup), {
    name: "MuiDateCalendar",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $c515574e4bff3014$export$68078fe5d2bf8909 = /*#__PURE__*/ $7fPBF.forwardRef(function DateCalendar(inProps, ref) {
    var _ref, _slots$calendarHeader, _slotProps$calendarHe;
    const utils = (0, $92mGG.useUtils)();
    const id = (0, $65Itt.default)();
    const props = $c515574e4bff3014$var$useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $cFLic.default)(props, $c515574e4bff3014$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $dZX2W.useControlledValueWithTimezone)({
        name: "DateCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $blfb5.singleItemValueManager)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $7vFJ6.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $fMbyK.useCalendarState)({
        value: value,
        defaultCalendarMonth: defaultCalendarMonth,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = (_ref = (_slots$calendarHeader = slots == null ? void 0 : slots.calendarHeader) != null ? _slots$calendarHeader : components == null ? void 0 : components.CalendarHeader) != null ? _ref : (0, $aMle3.PickersCalendarHeader);
    const calendarHeaderProps = (0, $94ctx.useSlotProps)({
        elementType: CalendarHeader,
        externalSlotProps: (_slotProps$calendarHe = slotProps == null ? void 0 : slotProps.calendarHeader) != null ? _slotProps$calendarHe : componentsProps == null ? void 0 : componentsProps.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $giDhD.default)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $6CwGv.findClosestEnabledDate)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $giDhD.default)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $6CwGv.findClosestEnabledDate)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $giDhD.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $6CwGv.mergeDateAndTime)(utils, day, value != null ? value : referenceDate), "finish");
        return handleValueChange(day, "finish");
    });
    $7fPBF.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $c515574e4bff3014$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone
    };
    const prevOpenViewRef = $7fPBF.useRef(view);
    $7fPBF.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $7fPBF.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($c515574e4bff3014$var$DateCalendarRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)(CalendarHeader, (0, $kY3Ke.default)({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, $bbzbN.jsx)($c515574e4bff3014$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        view === "year" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7XqRE.YearCalendar), (0, $kY3Ke.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("year", isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "month" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6vtTj.MonthCalendar), (0, $kY3Ke.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("month", isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "day" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gJ3t2.DayCalendar), (0, $kY3Ke.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("day", isViewFocused),
                            gridLabelId: gridLabelId,
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            components: components,
                            componentsProps: componentsProps,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});

});
parcelRequire.register("fMbyK", function(module, exports) {

$parcel$export(module.exports, "useCalendarState", function () { return $b7c44e28b3ec1424$export$6d095e787d2b5e1f; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $giDhD = parcelRequire("giDhD");

var $3msiD = parcelRequire("3msiD");

var $92mGG = parcelRequire("92mGG");

var $blfb5 = parcelRequire("blfb5");

var $kh1ja = parcelRequire("kh1ja");
const $b7c44e28b3ec1424$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, $kY3Ke.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "finishMonthSwitchingAnimation":
                return (0, $kY3Ke.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $kY3Ke.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const $b7c44e28b3ec1424$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const now = (0, $92mGG.useNow)(timezone);
    const utils = (0, $92mGG.useUtils)();
    const reducerFn = $7fPBF.useRef($b7c44e28b3ec1424$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $7fPBF.useMemo(()=>{
        let externalReferenceDate = null;
        if (referenceDateProp) externalReferenceDate = referenceDateProp;
        else if (defaultCalendarMonth) // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
        externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
        return (0, $blfb5.singleItemValueManager).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: externalReferenceDate,
            granularity: (0, $kh1ja.SECTION_TYPE_GRANULARITY).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $7fPBF.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: value || now,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: "left"
    });
    const handleChangeMonth = $7fPBF.useCallback((payload)=>{
        dispatch((0, $kY3Ke.default)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $7fPBF.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $3msiD.useIsDateDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $7fPBF.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = (0, $giDhD.default)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};

});
parcelRequire.register("3msiD", function(module, exports) {

$parcel$export(module.exports, "useIsDateDisabled", function () { return $272960e2556e540f$export$7d1a419f34475191; });

var $7fPBF = parcelRequire("7fPBF");

var $fq3Fh = parcelRequire("fq3Fh");

var $92mGG = parcelRequire("92mGG");
const $272960e2556e540f$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $92mGG.useLocalizationContext)();
    return $7fPBF.useCallback((day)=>(0, $fq3Fh.validateDate)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};

});


parcelRequire.register("cUICR", function(module, exports) {

$parcel$export(module.exports, "PickersFadeTransitionGroup", function () { return $966d54c4b5737349$export$5262185daf493fee; });
parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $8WhtA = parcelRequire("8WhtA");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $4axyc = parcelRequire("4axyc");

var $eEvT1 = parcelRequire("eEvT1");

var $bbzbN = parcelRequire("bbzbN");
const $966d54c4b5737349$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $eEvT1.getPickersFadeTransitionGroupUtilityClass), classes);
};
const $966d54c4b5737349$var$animationDuration = 500;
const $966d54c4b5737349$var$PickersFadeTransitionGroupRoot = (0, $kDBhE.default)((0, $4axyc.default), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function $966d54c4b5737349$export$5262185daf493fee(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $966d54c4b5737349$var$useUtilityClasses(props);
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $bbzbN.jsx)($966d54c4b5737349$var$PickersFadeTransitionGroupRoot, {
        className: (0, $hngXp.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8WhtA.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: $966d54c4b5737349$var$animationDuration,
                enter: $966d54c4b5737349$var$animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

});
parcelRequire.register("eEvT1", function(module, exports) {

$parcel$export(module.exports, "getPickersFadeTransitionGroupUtilityClass", function () { return $aaad891d0da306eb$export$5b0bb0174eb448ca; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
const $aaad891d0da306eb$export$5b0bb0174eb448ca = (slot)=>(0, $k6RDS.default)("MuiPickersFadeTransitionGroup", slot);
const $aaad891d0da306eb$export$1461f245817ac559 = (0, $4jzsB.default)("MuiPickersFadeTransitionGroup", [
    "root"
]);

});


parcelRequire.register("gJ3t2", function(module, exports) {

$parcel$export(module.exports, "DayCalendar", function () { return $c2d389da60812d08$export$8fb56b32a5df6314; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $giDhD = parcelRequire("giDhD");

var $3loMv = parcelRequire("3loMv");

var $94ctx = parcelRequire("94ctx");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $gaYwN = parcelRequire("gaYwN");

var $hngXp = parcelRequire("hngXp");

var $ioCrx = parcelRequire("ioCrx");

var $92mGG = parcelRequire("92mGG");

var $l04BV = parcelRequire("l04BV");

var $7suFa = parcelRequire("7suFa");

var $3msiD = parcelRequire("3msiD");

var $6CwGv = parcelRequire("6CwGv");

var $eYpDf = parcelRequire("eYpDf");

var $bbzbN = parcelRequire("bbzbN");
const $c2d389da60812d08$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $c2d389da60812d08$var$_excluded2 = [
    "ownerState"
];
const $c2d389da60812d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ],
        weekNumberLabel: [
            "weekNumberLabel"
        ],
        weekNumber: [
            "weekNumber"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $eYpDf.getDayCalendarUtilityClass), classes);
};
const $c2d389da60812d08$var$defaultDayOfWeekFormatter = (day)=>day.charAt(0).toUpperCase();
const $c2d389da60812d08$var$weeksContainerHeight = ((0, $l04BV.DAY_SIZE) + (0, $l04BV.DAY_MARGIN) * 2) * 6;
const $c2d389da60812d08$var$PickersCalendarDayHeader = (0, $kDBhE.default)("div", {
    name: "MuiDayCalendar",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $c2d389da60812d08$var$PickersCalendarWeekDayLabel = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiDayCalendar",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: (theme.vars || theme).palette.text.secondary
    }));
const $c2d389da60812d08$var$PickersCalendarWeekNumberLabel = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiDayPicker",
    slot: "WeekNumberLabel",
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.disabled
    }));
const $c2d389da60812d08$var$PickersCalendarWeekNumber = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiDayPicker",
    slot: "WeekNumber",
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $kY3Ke.default)({}, theme.typography.caption, {
        width: (0, $l04BV.DAY_SIZE),
        height: (0, $l04BV.DAY_SIZE),
        padding: 0,
        margin: `0 ${(0, $l04BV.DAY_MARGIN)}px`,
        color: theme.palette.text.disabled,
        fontSize: "0.75rem",
        alignItems: "center",
        justifyContent: "center",
        display: "inline-flex"
    }));
const $c2d389da60812d08$var$PickersCalendarLoadingContainer = (0, $kDBhE.default)("div", {
    name: "MuiDayCalendar",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: $c2d389da60812d08$var$weeksContainerHeight
});
const $c2d389da60812d08$var$PickersCalendarSlideTransition = (0, $kDBhE.default)((0, $7suFa.PickersSlideTransition), {
    name: "MuiDayCalendar",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $c2d389da60812d08$var$weeksContainerHeight
});
const $c2d389da60812d08$var$PickersCalendarWeekContainer = (0, $kDBhE.default)("div", {
    name: "MuiDayCalendar",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const $c2d389da60812d08$var$PickersCalendarWeek = (0, $kDBhE.default)("div", {
    name: "MuiDayCalendar",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $l04BV.DAY_MARGIN)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function $c2d389da60812d08$var$WrappedDay(_ref) {
    var _ref2, _slots$day, _slotProps$day;
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $cFLic.default)(_ref, $c2d389da60812d08$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $92mGG.useUtils)();
    const now = (0, $92mGG.useNow)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : (0, $ioCrx.PickersDay);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: Day,
        externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
        additionalProps: (0, $kY3Ke.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: "gridcell",
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            "data-timestamp": utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $kY3Ke.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $cFLic.default)(_useSlotProps, $c2d389da60812d08$var$_excluded2);
    const isDisabled = $7fPBF.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $7fPBF.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $7fPBF.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $7fPBF.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Day, (0, $kY3Ke.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? "date" : undefined
    }));
}
function $c2d389da60812d08$export$8fb56b32a5df6314(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDayCalendar"
    });
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = $c2d389da60812d08$var$defaultDayOfWeekFormatter, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $92mGG.useNow)(timezone);
    const utils = (0, $92mGG.useUtils)();
    const classes = $c2d389da60812d08$var$useUtilityClasses(props);
    const theme = (0, $g9bTP.default)();
    const isRTL = theme.direction === "rtl";
    const isDateDisabled = (0, $3msiD.useIsDateDisabled)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $92mGG.useLocaleText)();
    const [internalHasFocus, setInternalHasFocus] = (0, $gaYwN.default)({
        name: "DayCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $7fPBF.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $giDhD.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange == null || onFocusedViewChange(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $giDhD.default)((event, day)=>{
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $6CwGv.findClosestEnabledDate)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $6CwGv.findClosestEnabledDate)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $giDhD.default)((event, day)=>focusDay(day));
    const handleBlur = (0, $giDhD.default)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange == null || onFocusedViewChange(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = $7fPBF.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $7fPBF.useMemo(()=>/*#__PURE__*/ $7fPBF.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $7fPBF.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $6CwGv.findClosestEnabledDate)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $7fPBF.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        role: "grid",
        "aria-labelledby": gridLabelId,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($c2d389da60812d08$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    utils.getWeekdays().map((day, i)=>{
                        var _dayOfWeekFormatter;
                        return /*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), "weekday"),
                            className: classes.weekDayLabel,
                            children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
                        }, day + i.toString());
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$PickersCalendarSlideTransition, (0, $kY3Ke.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $hngXp.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)($c2d389da60812d08$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $bbzbN.jsx)($c2d389da60812d08$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

});
parcelRequire.register("ioCrx", function(module, exports) {

$parcel$export(module.exports, "PickersDay", function () { return $d64849e0226d1a8f$export$d7378e6e864346fa; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $3RNaF = parcelRequire("3RNaF");

var $cFCqu = parcelRequire("cFCqu");
var $lJRRs = parcelRequire("lJRRs");
var $jTdAm = parcelRequire("jTdAm");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $92mGG = parcelRequire("92mGG");

var $l04BV = parcelRequire("l04BV");

var $adwJ7 = parcelRequire("adwJ7");

var $bbzbN = parcelRequire("bbzbN");
const $d64849e0226d1a8f$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $d64849e0226d1a8f$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            "root",
            selected && !isHiddenDaySpacingFiller && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $adwJ7.getPickersDayUtilityClass), classes);
};
const $d64849e0226d1a8f$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.caption, {
        width: (0, $l04BV.DAY_SIZE),
        height: (0, $l04BV.DAY_SIZE),
        borderRadius: "50%",
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: "transparent",
        color: (theme.vars || theme).palette.text.primary,
        "@media (pointer: fine)": {
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $adwJ7.pickersDayClasses).selected}`]: {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $adwJ7.pickersDayClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $adwJ7.pickersDayClasses).disabled}:not(.${(0, $adwJ7.pickersDayClasses).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $adwJ7.pickersDayClasses).disabled}&.${(0, $adwJ7.pickersDayClasses).selected}`]: {
            opacity: 0.6
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $l04BV.DAY_MARGIN}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $adwJ7.pickersDayClasses).selected})`]: {
            border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
        }
    });
const $d64849e0226d1a8f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $d64849e0226d1a8f$var$PickersDayRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $d64849e0226d1a8f$var$overridesResolver
})($d64849e0226d1a8f$var$styleArg);
const $d64849e0226d1a8f$var$PickersDayFiller = (0, $kDBhE.default)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $d64849e0226d1a8f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, $d64849e0226d1a8f$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const $d64849e0226d1a8f$var$noop = ()=>{};
const $d64849e0226d1a8f$var$PickersDayRaw = /*#__PURE__*/ $7fPBF.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $d64849e0226d1a8f$var$noop, onBlur: onBlur = $d64849e0226d1a8f$var$noop, onKeyDown: onKeyDown = $d64849e0226d1a8f$var$noop, onMouseDown: onMouseDown = $d64849e0226d1a8f$var$noop, onMouseEnter: onMouseEnter = $d64849e0226d1a8f$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $cFLic.default)(props, $d64849e0226d1a8f$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $d64849e0226d1a8f$var$useUtilityClasses(ownerState);
    const utils = (0, $92mGG.useUtils)();
    const ref = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $lJRRs.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $bbzbN.jsx)($d64849e0226d1a8f$var$PickersDayFiller, {
        className: (0, $hngXp.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d64849e0226d1a8f$var$PickersDayRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const $d64849e0226d1a8f$export$d7378e6e864346fa = /*#__PURE__*/ $7fPBF.memo($d64849e0226d1a8f$var$PickersDayRaw);

});
parcelRequire.register("adwJ7", function(module, exports) {

$parcel$export(module.exports, "getPickersDayUtilityClass", function () { return $7704811ff6d1667b$export$4b25deb0350d3e53; });
$parcel$export(module.exports, "pickersDayClasses", function () { return $7704811ff6d1667b$export$68b221ad3c35e288; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $7704811ff6d1667b$export$4b25deb0350d3e53(slot) {
    return (0, $k6RDS.default)("MuiPickersDay", slot);
}
const $7704811ff6d1667b$export$68b221ad3c35e288 = (0, $4jzsB.default)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);

});


parcelRequire.register("7suFa", function(module, exports) {

$parcel$export(module.exports, "PickersSlideTransition", function () { return $56e2eef78447d2ae$export$e868fcc7557d3a06; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $lsaFT = parcelRequire("lsaFT");
var $4axyc = parcelRequire("4axyc");

var $fjaIT = parcelRequire("fjaIT");

var $bbzbN = parcelRequire("bbzbN");
const $56e2eef78447d2ae$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $56e2eef78447d2ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        exit: [
            "slideExit"
        ],
        enterActive: [
            "slideEnterActive"
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $fjaIT.getPickersSlideTransitionUtilityClass), classes);
};
const $56e2eef78447d2ae$export$ee7cc8ee8a5215ec = 350;
const $56e2eef78447d2ae$var$PickersSlideTransitionRoot = (0, $kDBhE.default)((0, $4axyc.default), {
    name: "MuiPickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $fjaIT.pickersSlideTransitionClasses)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, $fjaIT.pickersSlideTransitionClasses)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, $fjaIT.pickersSlideTransitionClasses).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $fjaIT.pickersSlideTransitionClasses).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $fjaIT.pickersSlideTransitionClasses)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, $fjaIT.pickersSlideTransitionClasses)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: $56e2eef78447d2ae$export$ee7cc8ee8a5215ec,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $fjaIT.pickersSlideTransitionClasses)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, $fjaIT.pickersSlideTransitionClasses)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, $fjaIT.pickersSlideTransitionClasses).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, $fjaIT.pickersSlideTransitionClasses).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, $fjaIT.pickersSlideTransitionClasses)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $fjaIT.pickersSlideTransitionClasses)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $56e2eef78447d2ae$export$e868fcc7557d3a06(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersSlideTransition"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $cFLic.default)(props, $56e2eef78447d2ae$var$_excluded);
    const classes = $56e2eef78447d2ae$var$useUtilityClasses(props);
    if (reduceAnimations) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $hngXp.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($56e2eef78447d2ae$var$PickersSlideTransitionRoot, {
        className: (0, $hngXp.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $7fPBF.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lsaFT.default), (0, $kY3Ke.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: $56e2eef78447d2ae$export$ee7cc8ee8a5215ec,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}

});
parcelRequire.register("lsaFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9e47e451b39ae9f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");


var $2B0G6 = parcelRequire("2B0G6");

var $bQbU1 = parcelRequire("bQbU1");

var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");


var $kKJSm = parcelRequire("kKJSm");
var $f9e47e451b39ae9f$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $2B0G6.default)(node, c);
    });
};
var $f9e47e451b39ae9f$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $bQbU1.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $f9e47e451b39ae9f$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $kKJSm.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $f9e47e451b39ae9f$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $f9e47e451b39ae9f$var$removeClass(node, baseClassName);
        if (activeClassName) $f9e47e451b39ae9f$var$removeClass(node, activeClassName);
        if (doneClassName) $f9e47e451b39ae9f$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $cFLic.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8qMCX.default), (0, $kY3Ke.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$f9e47e451b39ae9f$var$CSSTransition.defaultProps = {
    classNames: ""
};
$f9e47e451b39ae9f$var$CSSTransition.propTypes = {};
var $f9e47e451b39ae9f$export$2e2bcd8739ae039 = $f9e47e451b39ae9f$var$CSSTransition;

});
parcelRequire.register("2B0G6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3f901d29816e8c$export$2e2bcd8739ae039; });

var $85lB0 = parcelRequire("85lB0");
function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $85lB0.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRequire.register("85lB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRequire.register("bQbU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89edc8a1840ff9c1$export$2e2bcd8739ae039; });
function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});


parcelRequire.register("fjaIT", function(module, exports) {

$parcel$export(module.exports, "getPickersSlideTransitionUtilityClass", function () { return $b250f2b85e5b8968$export$e98c1b6c3bbc3c59; });
$parcel$export(module.exports, "pickersSlideTransitionClasses", function () { return $b250f2b85e5b8968$export$d251a58673156a67; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
const $b250f2b85e5b8968$export$e98c1b6c3bbc3c59 = (slot)=>(0, $k6RDS.default)("MuiPickersSlideTransition", slot);
const $b250f2b85e5b8968$export$d251a58673156a67 = (0, $4jzsB.default)("MuiPickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);

});


parcelRequire.register("eYpDf", function(module, exports) {

$parcel$export(module.exports, "getDayCalendarUtilityClass", function () { return $ae6a8d447141a6ad$export$fbe827982a69894a; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
const $ae6a8d447141a6ad$export$fbe827982a69894a = (slot)=>(0, $k6RDS.default)("MuiDayCalendar", slot);
const $ae6a8d447141a6ad$export$e0770f35b28ac552 = (0, $4jzsB.default)("MuiDayCalendar", [
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer",
    "weekNumberLabel",
    "weekNumber"
]);

});


parcelRequire.register("6vtTj", function(module, exports) {

$parcel$export(module.exports, "MonthCalendar", function () { return $4bccd319eb983de3$export$d7a7c85c0f5afc4a; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $4kWyf = parcelRequire("4kWyf");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $gaYwN = parcelRequire("gaYwN");
var $giDhD = parcelRequire("giDhD");

var $jqidG = parcelRequire("jqidG");

var $92mGG = parcelRequire("92mGG");

var $1vC85 = parcelRequire("1vC85");

var $6CwGv = parcelRequire("6CwGv");

var $blfb5 = parcelRequire("blfb5");

var $kh1ja = parcelRequire("kh1ja");

var $dZX2W = parcelRequire("dZX2W");

var $bbzbN = parcelRequire("bbzbN");
const $4bccd319eb983de3$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone"
];
const $4bccd319eb983de3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $1vC85.getMonthCalendarUtilityClass), classes);
};
function $4bccd319eb983de3$export$5b6e066572408095(props, name) {
    const utils = (0, $92mGG.useUtils)();
    const defaultDates = (0, $92mGG.useDefaultDates)();
    const themeProps = (0, $5j2OD.default)({
        props: props,
        name: name
    });
    return (0, $kY3Ke.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $4bccd319eb983de3$var$MonthCalendarRoot = (0, $kDBhE.default)("div", {
    name: "MuiMonthCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    padding: "0 4px",
    width: 320
});
const $4bccd319eb983de3$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $7fPBF.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $4bccd319eb983de3$export$5b6e066572408095(inProps, "MuiMonthCalendar");
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp } = props, other = (0, $cFLic.default)(props, $4bccd319eb983de3$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $dZX2W.useControlledValueWithTimezone)({
        name: "MonthCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $blfb5.singleItemValueManager)
    });
    const now = (0, $92mGG.useNow)(timezone);
    const theme = (0, $4kWyf.default)();
    const utils = (0, $92mGG.useUtils)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $blfb5.singleItemValueManager).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $kh1ja.SECTION_TYPE_GRANULARITY).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $4bccd319eb983de3$var$useUtilityClasses(ownerState);
    const todayMonth = $7fPBF.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $7fPBF.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        if (disableHighlightToday) return null;
        return utils.getMonth(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedMonth, setFocusedMonth] = $7fPBF.useState(()=>selectedMonth || todayMonth);
    const [internalHasFocus, setInternalHasFocus] = (0, $gaYwN.default)({
        name: "MonthCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $giDhD.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $7fPBF.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $giDhD.default)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value != null ? value : referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $giDhD.default)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $giDhD.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + month + (theme.direction === "ltr" ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + month + (theme.direction === "ltr" ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $giDhD.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $giDhD.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4bccd319eb983de3$var$MonthCalendarRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: (0, $6CwGv.getMonthsInYear)(utils, value != null ? value : referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jqidG.PickersMonth), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? "date" : undefined,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});

});
parcelRequire.register("jqidG", function(module, exports) {

$parcel$export(module.exports, "PickersMonth", function () { return $e23e94166bf12d18$export$bc52fdb7f02f591a; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $lJRRs = parcelRequire("lJRRs");

var $fKVQu = parcelRequire("fKVQu");

var $bbzbN = parcelRequire("bbzbN");
const $e23e94166bf12d18$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "monthsPerRow"
];
const $e23e94166bf12d18$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthButton: [
            "monthButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $fKVQu.getPickersMonthUtilityClass), classes);
};
const $e23e94166bf12d18$var$PickersMonthRoot = (0, $kDBhE.default)("div", {
    name: "MuiPickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.monthsPerRow === 3 ? "33.3%" : "25%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }));
const $e23e94166bf12d18$var$PickersMonthButton = (0, $kDBhE.default)("button", {
    name: "MuiPickersMonth",
    slot: "MonthButton",
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $fKVQu.pickersMonthClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $fKVQu.pickersMonthClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $kY3Ke.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $fKVQu.pickersMonthClasses).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $fKVQu.pickersMonthClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $e23e94166bf12d18$export$bc52fdb7f02f591a = /*#__PURE__*/ $7fPBF.memo(function PickersMonth(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersMonth"
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent } = props, other = (0, $cFLic.default)(props, $e23e94166bf12d18$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const classes = $e23e94166bf12d18$var$useUtilityClasses(props);
    (0, $lJRRs.default)(()=>{
        if (autoFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($e23e94166bf12d18$var$PickersMonthRoot, (0, $kY3Ke.default)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e23e94166bf12d18$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});

});
parcelRequire.register("fKVQu", function(module, exports) {

$parcel$export(module.exports, "getPickersMonthUtilityClass", function () { return $b78805cd45b35333$export$db90a620ac957a73; });
$parcel$export(module.exports, "pickersMonthClasses", function () { return $b78805cd45b35333$export$911e3973fa70a12b; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $b78805cd45b35333$export$db90a620ac957a73(slot) {
    return (0, $k6RDS.default)("MuiPickersMonth", slot);
}
const $b78805cd45b35333$export$911e3973fa70a12b = (0, $4jzsB.default)("MuiPickersMonth", [
    "root",
    "monthButton",
    "disabled",
    "selected"
]);

});


parcelRequire.register("1vC85", function(module, exports) {

$parcel$export(module.exports, "getMonthCalendarUtilityClass", function () { return $1196436c7c3fe2c3$export$da0c97315339ebd9; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $1196436c7c3fe2c3$export$da0c97315339ebd9(slot) {
    return (0, $k6RDS.default)("MuiMonthCalendar", slot);
}
const $1196436c7c3fe2c3$export$edf77d5566c7007c = (0, $4jzsB.default)("MuiMonthCalendar", [
    "root"
]);

});


parcelRequire.register("7XqRE", function(module, exports) {

$parcel$export(module.exports, "YearCalendar", function () { return $5cb2e1cea88096ca$export$657f9200591b2b71; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $4kWyf = parcelRequire("4kWyf");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $gaYwN = parcelRequire("gaYwN");
var $giDhD = parcelRequire("giDhD");
var $jTdAm = parcelRequire("jTdAm");

var $1jszM = parcelRequire("1jszM");

var $92mGG = parcelRequire("92mGG");

var $2Wwbg = parcelRequire("2Wwbg");

var $6CwGv = parcelRequire("6CwGv");

var $blfb5 = parcelRequire("blfb5");

var $kh1ja = parcelRequire("kh1ja");

var $dZX2W = parcelRequire("dZX2W");

var $bbzbN = parcelRequire("bbzbN");
const $5cb2e1cea88096ca$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone"
];
const $5cb2e1cea88096ca$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $2Wwbg.getYearCalendarUtilityClass), classes);
};
function $5cb2e1cea88096ca$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $92mGG.useUtils)();
    const defaultDates = (0, $92mGG.useDefaultDates)();
    const themeProps = (0, $5j2OD.default)({
        props: props,
        name: name
    });
    return (0, $kY3Ke.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        minDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $6CwGv.applyDefaultDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $5cb2e1cea88096ca$var$YearCalendarRoot = (0, $kDBhE.default)("div", {
    name: "MuiYearCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    width: 320,
    maxHeight: 304
});
const $5cb2e1cea88096ca$export$657f9200591b2b71 = /*#__PURE__*/ $7fPBF.forwardRef(function YearCalendar(inProps, ref) {
    const props = $5cb2e1cea88096ca$var$useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow = 3, timezone: timezoneProp } = props, other = (0, $cFLic.default)(props, $5cb2e1cea88096ca$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $dZX2W.useControlledValueWithTimezone)({
        name: "YearCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $blfb5.singleItemValueManager)
    });
    const now = (0, $92mGG.useNow)(timezone);
    const theme = (0, $4kWyf.default)();
    const utils = (0, $92mGG.useUtils)();
    const referenceDate = $7fPBF.useMemo(()=>(0, $blfb5.singleItemValueManager).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $kh1ja.SECTION_TYPE_GRANULARITY).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $5cb2e1cea88096ca$var$useUtilityClasses(ownerState);
    const todayYear = $7fPBF.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $7fPBF.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        if (disableHighlightToday) return null;
        return utils.getYear(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedYear, setFocusedYear] = $7fPBF.useState(()=>selectedYear || todayYear);
    const [internalHasFocus, setInternalHasFocus] = (0, $gaYwN.default)({
        name: "YearCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $giDhD.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $7fPBF.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $giDhD.default)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value != null ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $giDhD.default)((year)=>{
        if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    });
    $7fPBF.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $giDhD.default)((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year + (theme.direction === "ltr" ? -1 : 1));
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + (theme.direction === "ltr" ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $giDhD.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $giDhD.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(ref, scrollerRef);
    $7fPBF.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5cb2e1cea88096ca$var$YearCalendarRoot, (0, $kY3Ke.default)({
        ref: handleRef,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1jszM.PickersYear), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? "date" : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    }));
});

});
parcelRequire.register("1jszM", function(module, exports) {

$parcel$export(module.exports, "PickersYear", function () { return $0f4dbb6707104d23$export$261f3fbd5fd5814d; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $e4Xf3 = parcelRequire("e4Xf3");

var $bbzbN = parcelRequire("bbzbN");
const $0f4dbb6707104d23$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $0f4dbb6707104d23$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $e4Xf3.getPickersYearUtilityClass), classes);
};
const $0f4dbb6707104d23$var$PickersYearRoot = (0, $kDBhE.default)("div", {
    name: "MuiPickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.yearsPerRow === 3 ? "33.3%" : "25%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }));
const $0f4dbb6707104d23$var$PickersYearButton = (0, $kDBhE.default)("button", {
    name: "MuiPickersYear",
    slot: "YearButton",
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $e4Xf3.pickersYearClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $e4Xf3.pickersYearClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $kY3Ke.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $e4Xf3.pickersYearClasses).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $e4Xf3.pickersYearClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $0f4dbb6707104d23$export$261f3fbd5fd5814d = /*#__PURE__*/ $7fPBF.memo(function PickersYear(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersYear"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent } = props, other = (0, $cFLic.default)(props, $0f4dbb6707104d23$var$_excluded);
    const ref = $7fPBF.useRef(null);
    const classes = $0f4dbb6707104d23$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $7fPBF.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0f4dbb6707104d23$var$PickersYearRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($0f4dbb6707104d23$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});

});
parcelRequire.register("e4Xf3", function(module, exports) {

$parcel$export(module.exports, "getPickersYearUtilityClass", function () { return $a3ff649e8dd46250$export$183c9f339a61cd79; });
$parcel$export(module.exports, "pickersYearClasses", function () { return $a3ff649e8dd46250$export$4ef58a3d9c6f4296; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $a3ff649e8dd46250$export$183c9f339a61cd79(slot) {
    return (0, $k6RDS.default)("MuiPickersYear", slot);
}
const $a3ff649e8dd46250$export$4ef58a3d9c6f4296 = (0, $4jzsB.default)("MuiPickersYear", [
    "root",
    "yearButton",
    "selected",
    "disabled"
]);

});


parcelRequire.register("2Wwbg", function(module, exports) {

$parcel$export(module.exports, "getYearCalendarUtilityClass", function () { return $2249f5f50aa75a9e$export$4477acc520094dec; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $2249f5f50aa75a9e$export$4477acc520094dec(slot) {
    return (0, $k6RDS.default)("MuiYearCalendar", slot);
}
const $2249f5f50aa75a9e$export$e42d427cd9fe5fd7 = (0, $4jzsB.default)("MuiYearCalendar", [
    "root"
]);

});


parcelRequire.register("aMle3", function(module, exports) {

$parcel$export(module.exports, "PickersCalendarHeader", function () { return $7d8eda0f006682a1$export$6801ffebb353f473; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $8WhtA = parcelRequire("8WhtA");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $94ctx = parcelRequire("94ctx");

var $cFCqu = parcelRequire("cFCqu");

var $8TDId = parcelRequire("8TDId");

var $92mGG = parcelRequire("92mGG");

var $cUICR = parcelRequire("cUICR");

var $3qBKp = parcelRequire("3qBKp");

var $k7WO5 = parcelRequire("k7WO5");

var $81Pww = parcelRequire("81Pww");

var $k8j0j = parcelRequire("k8j0j");

var $bbzbN = parcelRequire("bbzbN");
const $7d8eda0f006682a1$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone"
], $7d8eda0f006682a1$var$_excluded2 = [
    "ownerState"
];
const $7d8eda0f006682a1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $k8j0j.getPickersCalendarHeaderUtilityClass), classes);
};
const $7d8eda0f006682a1$var$PickersCalendarHeaderRoot = (0, $kDBhE.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderLabelContainer = (0, $kDBhE.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $kY3Ke.default)({
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $7d8eda0f006682a1$var$PickersCalendarHeaderLabel = (0, $kDBhE.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewButton = (0, $kDBhE.default)((0, $8TDId.default), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        marginRight: "auto"
    }, ownerState.view === "year" && {
        [`.${(0, $k8j0j.pickersCalendarHeaderClasses).switchViewIcon}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewIcon = (0, $kDBhE.default)((0, $3qBKp.ArrowDropDownIcon), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }));
const $7d8eda0f006682a1$export$6801ffebb353f473 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersCalendarHeader(inProps, ref) {
    var _slots$switchViewButt, _slots$switchViewIcon;
    const localeText = (0, $92mGG.useLocaleText)();
    const utils = (0, $92mGG.useUtils)();
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone } = props, other = (0, $cFLic.default)(props, $7d8eda0f006682a1$var$_excluded);
    const ownerState = props;
    const classes = $7d8eda0f006682a1$var$useUtilityClasses(props);
    const SwitchViewButton = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $94ctx.useSlotProps)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: "small",
            "aria-label": localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : $7d8eda0f006682a1$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $cFLic.default)(_useSlotProps, $7d8eda0f006682a1$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), "right");
    const isNextMonthDisabled = (0, $81Pww.useNextMonthDisabled)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $81Pww.usePreviousMonthDisabled)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7d8eda0f006682a1$var$PickersCalendarHeaderRoot, (0, $kY3Ke.default)({}, other, {
        ownerState: ownerState,
        className: (0, $hngXp.default)(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($7d8eda0f006682a1$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cUICR.PickersFadeTransitionGroup), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, "monthAndYear"),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($7d8eda0f006682a1$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, "monthAndYear")
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $bbzbN.jsx)(SwitchViewButton, (0, $kY3Ke.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(SwitchViewIcon, (0, $kY3Ke.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8WhtA.default), {
                in: view === "day",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k7WO5.PickersArrowSwitcher), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});

});
parcelRequire.register("k7WO5", function(module, exports) {

$parcel$export(module.exports, "PickersArrowSwitcher", function () { return $ea7213ea38575b9f$export$597b7cbdb7b2a24c; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $94ctx = parcelRequire("94ctx");

var $8TDId = parcelRequire("8TDId");

var $3qBKp = parcelRequire("3qBKp");

var $9eogS = parcelRequire("9eogS");

var $bbzbN = parcelRequire("bbzbN");
const $ea7213ea38575b9f$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $ea7213ea38575b9f$var$_excluded2 = [
    "ownerState"
], $ea7213ea38575b9f$var$_excluded3 = [
    "ownerState"
];
const $ea7213ea38575b9f$var$PickersArrowSwitcherRoot = (0, $kDBhE.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const $ea7213ea38575b9f$var$PickersArrowSwitcherSpacer = (0, $kDBhE.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $ea7213ea38575b9f$var$PickersArrowSwitcherButton = (0, $kDBhE.default)((0, $8TDId.default), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.hidden && {
        visibility: "hidden"
    }));
const $ea7213ea38575b9f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $9eogS.getPickersArrowSwitcherUtilityClass), classes);
};
const $ea7213ea38575b9f$export$597b7cbdb7b2a24c = /*#__PURE__*/ $7fPBF.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $g9bTP.default)();
    const isRTL = theme.direction === "rtl";
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $cFLic.default)(props, $ea7213ea38575b9f$var$_excluded);
    const ownerState = props;
    const classes = $ea7213ea38575b9f$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const [leftProps, rightProps] = isRTL ? [
        nextProps,
        previousProps
    ] : [
        previousProps,
        nextProps
    ];
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $ea7213ea38575b9f$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $94ctx.useSlotProps)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: "medium",
            title: leftProps.label,
            "aria-label": leftProps.label,
            disabled: leftProps.isDisabled,
            edge: "end",
            onClick: leftProps.goTo
        },
        ownerState: (0, $kY3Ke.default)({}, ownerState, {
            hidden: leftProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $ea7213ea38575b9f$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $94ctx.useSlotProps)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: "medium",
            title: rightProps.label,
            "aria-label": rightProps.label,
            disabled: rightProps.isDisabled,
            edge: "start",
            onClick: rightProps.goTo
        },
        ownerState: (0, $kY3Ke.default)({}, ownerState, {
            hidden: rightProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $3qBKp.ArrowLeftIcon);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $cFLic.default)(_useSlotProps, $ea7213ea38575b9f$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $3qBKp.ArrowRightIcon);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $94ctx.useSlotProps)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $cFLic.default)(_useSlotProps2, $ea7213ea38575b9f$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($ea7213ea38575b9f$var$PickersArrowSwitcherRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)(PreviousIconButton, (0, $kY3Ke.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $bbzbN.jsx)(RightArrowIcon, (0, $kY3Ke.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $bbzbN.jsx)(LeftArrowIcon, (0, $kY3Ke.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)($ea7213ea38575b9f$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)(NextIconButton, (0, $kY3Ke.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $bbzbN.jsx)(LeftArrowIcon, (0, $kY3Ke.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $bbzbN.jsx)(RightArrowIcon, (0, $kY3Ke.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});

});
parcelRequire.register("9eogS", function(module, exports) {

$parcel$export(module.exports, "getPickersArrowSwitcherUtilityClass", function () { return $6b883f9bf65a96c2$export$cef978c25740de90; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $6b883f9bf65a96c2$export$cef978c25740de90(slot) {
    return (0, $k6RDS.default)("MuiPickersArrowSwitcher", slot);
}
const $6b883f9bf65a96c2$export$f8819209558cd362 = (0, $4jzsB.default)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button"
]);

});


parcelRequire.register("81Pww", function(module, exports) {

$parcel$export(module.exports, "useNextMonthDisabled", function () { return $5d866238f9e5c9d0$export$923e8cc135843169; });
$parcel$export(module.exports, "usePreviousMonthDisabled", function () { return $5d866238f9e5c9d0$export$3b46d38ff4932cf7; });
$parcel$export(module.exports, "useMeridiemMode", function () { return $5d866238f9e5c9d0$export$6aaabc31cb076d17; });

var $7fPBF = parcelRequire("7fPBF");

var $92mGG = parcelRequire("92mGG");

var $hEosq = parcelRequire("hEosq");
function $5d866238f9e5c9d0$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $92mGG.useUtils)();
    return $7fPBF.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $5d866238f9e5c9d0$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $92mGG.useUtils)();
    return $7fPBF.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $5d866238f9e5c9d0$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $92mGG.useUtils)();
    const meridiemMode = (0, $hEosq.getMeridiem)(date, utils);
    const handleMeridiemChange = $7fPBF.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $hEosq.convertToMeridiem)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState != null ? selectionState : "partial");
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}

});

parcelRequire.register("k8j0j", function(module, exports) {

$parcel$export(module.exports, "getPickersCalendarHeaderUtilityClass", function () { return $ea834bcc9ade85be$export$457ac4d3a1ad92b4; });
$parcel$export(module.exports, "pickersCalendarHeaderClasses", function () { return $ea834bcc9ade85be$export$63db7afb9247cb91; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
const $ea834bcc9ade85be$export$457ac4d3a1ad92b4 = (slot)=>(0, $k6RDS.default)("MuiPickersCalendarHeader", slot);
const $ea834bcc9ade85be$export$63db7afb9247cb91 = (0, $4jzsB.default)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);

});


parcelRequire.register("5VM6C", function(module, exports) {

$parcel$export(module.exports, "PickerViewRoot", function () { return $451797722941b1b3$export$512b066b8abdfde4; });

var $kDBhE = parcelRequire("kDBhE");

var $l04BV = parcelRequire("l04BV");
const $451797722941b1b3$export$512b066b8abdfde4 = (0, $kDBhE.default)("div")({
    overflow: "hidden",
    width: (0, $l04BV.DIALOG_WIDTH),
    maxHeight: (0, $l04BV.VIEW_HEIGHT),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});

});

parcelRequire.register("7aVCm", function(module, exports) {

$parcel$export(module.exports, "useDefaultReduceAnimations", function () { return $015921b28af57dd9$export$ce40fb97be7f02d9; });

var $kspUS = parcelRequire("kspUS");
const $015921b28af57dd9$var$PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
const $015921b28af57dd9$export$96ab2969580bcdae = typeof navigator !== "undefined" && /(android)/i.test(navigator.userAgent);
const $015921b28af57dd9$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $kspUS.default)($015921b28af57dd9$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $015921b28af57dd9$export$96ab2969580bcdae;
};

});

parcelRequire.register("kbH27", function(module, exports) {

$parcel$export(module.exports, "getDateCalendarUtilityClass", function () { return $eb26373463fec8d8$export$da8c2318897a6672; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
const $eb26373463fec8d8$export$da8c2318897a6672 = (slot)=>(0, $k6RDS.default)("MuiDateCalendar", slot);
const $eb26373463fec8d8$export$d0237e2bb9598e8d = (0, $4jzsB.default)("MuiDateCalendar", [
    "root",
    "viewTransitionContainer"
]);

});




parcelRequire.register("GTCV3", function(module, exports) {

$parcel$export(module.exports, "MobileDatePicker", function () { return $080f12ab26da8443$export$97b476d7a92fee62; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $dUIft = parcelRequire("dUIft");

var $i4xIP = parcelRequire("i4xIP");

var $7cI1D = parcelRequire("7cI1D");

var $92mGG = parcelRequire("92mGG");
var $fq3Fh = parcelRequire("fq3Fh");

var $7Fco7 = parcelRequire("7Fco7");

var $3GboI = parcelRequire("3GboI");

var $blfb5 = parcelRequire("blfb5");

var $efc1W = parcelRequire("efc1W");

var $6CwGv = parcelRequire("6CwGv");
const $080f12ab26da8443$export$97b476d7a92fee62 = /*#__PURE__*/ $7fPBF.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $92mGG.useLocaleText)();
    const utils = (0, $92mGG.useUtils)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $7cI1D.useDatePickerDefaultizedProps)(inProps, "MuiMobileDatePicker");
    const viewRenderers = (0, $kY3Ke.default)({
        day: (0, $efc1W.renderDateViewCalendar),
        month: (0, $efc1W.renderDateViewCalendar),
        year: (0, $efc1W.renderDateViewCalendar)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $kY3Ke.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $6CwGv.resolveDateFormat)(utils, defaultizedProps, false),
        slots: (0, $kY3Ke.default)({
            field: (0, $7Fco7.DateField)
        }, defaultizedProps.slots),
        slotProps: (0, $kY3Ke.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $kY3Ke.default)({}, (0, $dUIft.resolveComponentProps)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $3GboI.extractValidationProps)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $kY3Ke.default)({
                hidden: false
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $i4xIP.useMobilePicker)({
        props: props,
        valueManager: (0, $blfb5.singleItemValueManager),
        valueType: "date",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $fq3Fh.validateDate)
    });
    return renderPicker();
});
$080f12ab26da8443$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
        })
    ]),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "day",
        "month",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        3,
        4
    ])
};

});
parcelRequire.register("i4xIP", function(module, exports) {

$parcel$export(module.exports, "useMobilePicker", function () { return $d282c2379e3abcb7$export$5ca0153a626a7dd7; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $94ctx = parcelRequire("94ctx");

var $jTdAm = parcelRequire("jTdAm");

var $65Itt = parcelRequire("65Itt");

var $76vlQ = parcelRequire("76vlQ");

var $gKtnG = parcelRequire("gKtnG");

var $jpuvJ = parcelRequire("jpuvJ");

var $92mGG = parcelRequire("92mGG");

var $huHez = parcelRequire("huHez");

var $1fUy6 = parcelRequire("1fUy6");

var $bbzbN = parcelRequire("bbzbN");
const $d282c2379e3abcb7$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $d282c2379e3abcb7$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $cFLic.default)(_ref, $d282c2379e3abcb7$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $92mGG.useUtils)();
    const internalInputRef = $7fPBF.useRef(null);
    const labelId = (0, $65Itt.default)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $gKtnG.usePicker)((0, $kY3Ke.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "mobile"
    }));
    const Field = slots.field;
    const fieldProps = (0, $94ctx.useSlotProps)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $kY3Ke.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $jpuvJ.onSpaceOrEnter)(actions.onOpen)
        }, {
            readOnly: readOnly != null ? readOnly : true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $kY3Ke.default)({}, fieldProps.inputProps, {
        "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $kY3Ke.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $1fUy6.PickersLayout);
    const handleInputRef = (0, $jTdAm.default)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $kY3Ke.default)({}, innerSlotProps, {
        toolbar: (0, $kY3Ke.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $kY3Ke.default)({
            "aria-labelledby": labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $huHez.LocalizationProvider), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)(Field, (0, $kY3Ke.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $76vlQ.PickersModalDialog), (0, $kY3Ke.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(Layout, (0, $kY3Ke.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};

});
parcelRequire.register("76vlQ", function(module, exports) {

$parcel$export(module.exports, "PickersModalDialog", function () { return $52c169ad4ec0e8fd$export$99f83c99e1491f77; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $8wwTv = parcelRequire("8wwTv");

var $8WhtA = parcelRequire("8WhtA");

var $aUdfW = parcelRequire("aUdfW");
var $bqHow = parcelRequire("bqHow");

var $kDBhE = parcelRequire("kDBhE");

var $l04BV = parcelRequire("l04BV");

var $bbzbN = parcelRequire("bbzbN");
const $52c169ad4ec0e8fd$var$PickersModalDialogRoot = (0, $kDBhE.default)((0, $aUdfW.default))({
    [`& .${(0, $bqHow.default).container}`]: {
        outline: 0
    },
    [`& .${(0, $bqHow.default).paper}`]: {
        outline: 0,
        minWidth: (0, $l04BV.DIALOG_WIDTH)
    }
});
const $52c169ad4ec0e8fd$var$PickersModalDialogContent = (0, $kDBhE.default)((0, $8wwTv.default))({
    "&:first-of-type": {
        padding: 0
    }
});
function $52c169ad4ec0e8fd$export$99f83c99e1491f77(props) {
    var _slots$dialog, _slots$mobileTransiti;
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : $52c169ad4ec0e8fd$var$PickersModalDialogRoot;
    const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : (0, $8WhtA.default);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Dialog, (0, $kY3Ke.default)({
        open: open,
        onClose: onDismiss
    }, slotProps == null ? void 0 : slotProps.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
        PaperComponent: slots == null ? void 0 : slots.mobilePaper,
        PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($52c169ad4ec0e8fd$var$PickersModalDialogContent, {
            children: children
        })
    }));
}

});





parcelRequire.register("iXs1l", function(module, exports) {

$parcel$export(module.exports, "ptBR", function () { return $dcd378fe1bd7911c$export$93dd81123f5ddbcd; });

var $buRa0 = parcelRequire("buRa0");
const $dcd378fe1bd7911c$var$timeViews = {
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
    meridiem: "meridiano"
};
const $dcd378fe1bd7911c$var$ptBRPickers = {
    // Calendar navigation
    previousMonth: "M\xeas anterior",
    nextMonth: "Pr\xf3ximo m\xeas",
    // View navigation
    openPreviousView: "Abrir pr\xf3xima sele\xe7\xe3o",
    openNextView: "Abrir sele\xe7\xe3o anterior",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "Sele\xe7\xe3o de ano est\xe1 aberta, alternando para sele\xe7\xe3o de calend\xe1rio" : "Sele\xe7\xe3o de calend\xe1rios est\xe1 aberta, alternando para sele\xe7\xe3o de ano",
    // DateRange placeholders
    start: "In\xedcio",
    end: "Fim",
    // Action bar
    cancelButtonLabel: "Cancelar",
    clearButtonLabel: "Limpar",
    okButtonLabel: "OK",
    todayButtonLabel: "Hoje",
    // Toolbar titles
    datePickerToolbarTitle: "Selecione a data",
    dateTimePickerToolbarTitle: "Selecione data e hora",
    timePickerToolbarTitle: "Selecione a hora",
    dateRangePickerToolbarTitle: "Selecione o intervalo entre datas",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Selecione ${$dcd378fe1bd7911c$var$timeViews[view]}. ${time === null ? "Hora n\xe3o selecionada" : `Selecionado a hora ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} horas`,
    minutesClockNumberText: (minutes)=>`${minutes} minutos`,
    secondsClockNumberText: (seconds)=>`${seconds} segundos`,
    // Digital clock labels
    selectViewText: (view)=>`Selecione ${$dcd378fe1bd7911c$var$timeViews[view]}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "N\xfamero da semana",
    calendarWeekNumberHeaderText: "#",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Semana ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Escolha uma data, data selecionada ${utils.format(value, "fullDate")}` : "Escolha uma data",
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Escolha uma hora, hora selecionada ${utils.format(value, "fullTime")}` : "Escolha uma hora",
    // Table labels
    timeTableLabel: "escolha uma hora",
    dateTableLabel: "escolha uma data",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"A".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "MMMM" : "MM",
    fieldDayPlaceholder: ()=>"DD",
    fieldWeekDayPlaceholder: (params)=>params.contentType === "letter" ? "SSSS" : "SS",
    fieldHoursPlaceholder: ()=>"hh",
    fieldMinutesPlaceholder: ()=>"mm",
    fieldSecondsPlaceholder: ()=>"ss",
    fieldMeridiemPlaceholder: ()=>"aa"
};
const $dcd378fe1bd7911c$export$93dd81123f5ddbcd = (0, $buRa0.getPickersLocalization)($dcd378fe1bd7911c$var$ptBRPickers);

});


parcelRequire.register("8pNrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6207032cc256a7e6$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");


var $8qMCX = parcelRequire("8qMCX");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $kjiCM = parcelRequire("kjiCM");

var $2j7bs = parcelRequire("2j7bs");

var $g9bTP = parcelRequire("g9bTP");

var $6NwTb = parcelRequire("6NwTb");

var $kK1R2 = parcelRequire("kK1R2");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6207032cc256a7e6$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $6207032cc256a7e6$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $kK1R2.getCollapseUtilityClass), classes);
};
const $6207032cc256a7e6$var$CollapseRoot = (0, $kDBhE.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $kY3Ke.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $6207032cc256a7e6$var$CollapseWrapper = (0, $kDBhE.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $6207032cc256a7e6$var$CollapseWrapperInner = (0, $kDBhE.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $6207032cc256a7e6$var$Collapse = /*#__PURE__*/ $7fPBF.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $kjiCM.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8qMCX.default) } = props, other = (0, $cFLic.default)(props, $6207032cc256a7e6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $6207032cc256a7e6$var$useUtilityClasses(ownerState);
    const theme = (0, $g9bTP.default)();
    const timer = $7fPBF.useRef();
    const wrapperRef = $7fPBF.useRef(null);
    const autoTransitionDuration = $7fPBF.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    $7fPBF.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $6NwTb.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $2j7bs.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)($6207032cc256a7e6$var$CollapseRoot, (0, $kY3Ke.default)({
                as: component,
                className: (0, $hngXp.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $kY3Ke.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $kY3Ke.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($6207032cc256a7e6$var$CollapseWrapper, {
                    ownerState: (0, $kY3Ke.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)($6207032cc256a7e6$var$CollapseWrapperInner, {
                        ownerState: (0, $kY3Ke.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$6207032cc256a7e6$var$Collapse.muiSupportAuto = true;
var $6207032cc256a7e6$export$2e2bcd8739ae039 = $6207032cc256a7e6$var$Collapse;

});
parcelRequire.register("kK1R2", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", function () { return $f1998ac7e19a4022$export$5162da8f798e0959; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $f1998ac7e19a4022$export$5162da8f798e0959(slot) {
    return (0, $k6RDS.default)("MuiCollapse", slot);
}
const $f1998ac7e19a4022$var$collapseClasses = (0, $4jzsB.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $f1998ac7e19a4022$export$2e2bcd8739ae039 = $f1998ac7e19a4022$var$collapseClasses;

});


parcelRequire.register("ga3mZ", function(module, exports) {

$parcel$export(module.exports, "MobileFilter", function () { return $8cb01fdc9d05f7ea$export$18fbd793efee61f; });
$parcel$export(module.exports, "DesktopFilter", function () { return $8cb01fdc9d05f7ea$export$a00c712da48b4cb5; });
$parcel$export(module.exports, "FilterButton", function () { return $8cb01fdc9d05f7ea$export$fb46dd9777cc6db0; });
$parcel$export(module.exports, "SelectGrid", function () { return $8cb01fdc9d05f7ea$export$3bb2bce6bb6f0906; });
$parcel$export(module.exports, "StyledSelectControl", function () { return $8cb01fdc9d05f7ea$export$11a57430e0363667; });
$parcel$export(module.exports, "StyledAlert", function () { return $8cb01fdc9d05f7ea$export$38fb881472c4cc64; });
$parcel$export(module.exports, "StyledContainer", function () { return $8cb01fdc9d05f7ea$export$1d41361302b577a1; });
$parcel$export(module.exports, "StyledError", function () { return $8cb01fdc9d05f7ea$export$4ea0ff3663964b59; });

var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
var $3jMGu = parcelRequire("3jMGu");
var $3loMv = parcelRequire("3loMv");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $8cb01fdc9d05f7ea$var$_ = (t)=>t, $8cb01fdc9d05f7ea$var$t, $8cb01fdc9d05f7ea$var$t1, $8cb01fdc9d05f7ea$var$t2, $8cb01fdc9d05f7ea$var$t3, $8cb01fdc9d05f7ea$var$t4, $8cb01fdc9d05f7ea$var$t5, $8cb01fdc9d05f7ea$var$t6, $8cb01fdc9d05f7ea$var$t7;
const $8cb01fdc9d05f7ea$export$18fbd793efee61f = (0, $6hfZk.default)((0, $aili3.default))($8cb01fdc9d05f7ea$var$t || ($8cb01fdc9d05f7ea$var$t = $8cb01fdc9d05f7ea$var$_`
    display: none;
    flex-direction: row;
    gap: 0.75rem;
    flex-wrap: wrap;
    align-item: center;
    width: 100%;
    margin-bottom: 1rem;

    @media (max-width: 600px) {
        display: flex;
    }
`));
const $8cb01fdc9d05f7ea$export$a00c712da48b4cb5 = (0, $6hfZk.default)((0, $aili3.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isFilterOpen"
})($8cb01fdc9d05f7ea$var$t1 || ($8cb01fdc9d05f7ea$var$t1 = $8cb01fdc9d05f7ea$var$_`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: left;
    gap: 1rem;

    @media (max-width: 600px) {
        display: ${0};
    }
`), ({ isFilterOpen: isFilterOpen })=>isFilterOpen ? "flex" : "none");
const $8cb01fdc9d05f7ea$export$fb46dd9777cc6db0 = (0, $6hfZk.default)((0, $dkKmP.AppButton)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isFilterOpen"
})($8cb01fdc9d05f7ea$var$t2 || ($8cb01fdc9d05f7ea$var$t2 = $8cb01fdc9d05f7ea$var$_`
    width: ${0};
    max-height: 58px !important;
    height: 100% !important;
`), ({ isFilterOpen: isFilterOpen })=>isFilterOpen ? "100%" : "fit-content !important");
const $8cb01fdc9d05f7ea$export$3bb2bce6bb6f0906 = (0, $6hfZk.default).div($8cb01fdc9d05f7ea$var$t3 || ($8cb01fdc9d05f7ea$var$t3 = $8cb01fdc9d05f7ea$var$_`
    display: grid;
    width: 100%;
    grid-template-columns: 20% 20% 15% 15% auto auto;
    gap: 8px;

    @media (max-width: 900px) {
        grid-template-columns: auto auto auto;
        gap: 1rem;
    }
    @media (max-width: 600px) {
        grid-template-columns: auto;
        gap: 1rem;
    }
`));
const $8cb01fdc9d05f7ea$export$11a57430e0363667 = (0, $6hfZk.default)((0, $3jMGu.default))($8cb01fdc9d05f7ea$var$t4 || ($8cb01fdc9d05f7ea$var$t4 = $8cb01fdc9d05f7ea$var$_`
    width: 100%;
`));
const $8cb01fdc9d05f7ea$export$38fb881472c4cc64 = (0, $6hfZk.default)((0, $gC25j.default))($8cb01fdc9d05f7ea$var$t5 || ($8cb01fdc9d05f7ea$var$t5 = $8cb01fdc9d05f7ea$var$_`
    width: 100%;
`));
const $8cb01fdc9d05f7ea$export$1d41361302b577a1 = (0, $6hfZk.default).div($8cb01fdc9d05f7ea$var$t6 || ($8cb01fdc9d05f7ea$var$t6 = $8cb01fdc9d05f7ea$var$_`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`));
const $8cb01fdc9d05f7ea$export$4ea0ff3663964b59 = (0, $6hfZk.default)((0, $3loMv.default))($8cb01fdc9d05f7ea$var$t7 || ($8cb01fdc9d05f7ea$var$t7 = $8cb01fdc9d05f7ea$var$_`
    color: #d32f2f;
    font-size: 12px !important;
    margin: 3px 14px 0 14px !important;
`));

});

parcelRequire.register("5LV4O", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
var $433d9dc7b7117565$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $433d9dc7b7117565$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$433d9dc7b7117565$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($433d9dc7b7117565$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($433d9dc7b7117565$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($433d9dc7b7117565$var$isNull(x) || !$433d9dc7b7117565$var$isObject(x)) str += " " + x;
    else str += " " + $433d9dc7b7117565$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $4ZL0H !== "undefined" && $4ZL0H.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $4ZL0H === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($4ZL0H.throwDeprecation) throw new Error(msg);
            else if ($4ZL0H.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $433d9dc7b7117565$var$debugs = {};
var $433d9dc7b7117565$var$debugEnvRegex = /^$/;
var $433d9dc7b7117565$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$433d9dc7b7117565$var$debugs[set]) {
        if ($433d9dc7b7117565$var$debugEnvRegex.test(set)) {
            var pid = $4ZL0H.pid;
            $433d9dc7b7117565$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $433d9dc7b7117565$var$debugs[set] = function() {};
    }
    return $433d9dc7b7117565$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $433d9dc7b7117565$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $433d9dc7b7117565$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($433d9dc7b7117565$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($433d9dc7b7117565$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($433d9dc7b7117565$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($433d9dc7b7117565$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($433d9dc7b7117565$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $433d9dc7b7117565$var$stylizeWithColor;
    return $433d9dc7b7117565$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $433d9dc7b7117565$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$433d9dc7b7117565$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$433d9dc7b7117565$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $433d9dc7b7117565$var$stylizeWithColor(str, styleType) {
    var style = $433d9dc7b7117565$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $433d9dc7b7117565$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $433d9dc7b7117565$var$inspect.colors[style][1] + "m";
    else return str;
}
function $433d9dc7b7117565$var$stylizeNoColor(str, styleType) {
    return str;
}
function $433d9dc7b7117565$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $433d9dc7b7117565$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $433d9dc7b7117565$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$433d9dc7b7117565$var$isString(ret)) ret = $433d9dc7b7117565$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $433d9dc7b7117565$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $433d9dc7b7117565$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($433d9dc7b7117565$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $433d9dc7b7117565$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($433d9dc7b7117565$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($433d9dc7b7117565$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($433d9dc7b7117565$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($433d9dc7b7117565$var$isError(value)) return $433d9dc7b7117565$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($433d9dc7b7117565$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($433d9dc7b7117565$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($433d9dc7b7117565$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($433d9dc7b7117565$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($433d9dc7b7117565$var$isError(value)) base = " " + $433d9dc7b7117565$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($433d9dc7b7117565$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $433d9dc7b7117565$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $433d9dc7b7117565$var$reduceToSingleString(output, base, braces);
}
function $433d9dc7b7117565$var$formatPrimitive(ctx, value) {
    if ($433d9dc7b7117565$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($433d9dc7b7117565$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($433d9dc7b7117565$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($433d9dc7b7117565$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($433d9dc7b7117565$var$isNull(value)) return ctx.stylize("null", "null");
}
function $433d9dc7b7117565$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $433d9dc7b7117565$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($433d9dc7b7117565$var$hasOwnProperty(value, String(i))) output.push($433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$433d9dc7b7117565$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($433d9dc7b7117565$var$isNull(recurseTimes)) str = $433d9dc7b7117565$var$formatValue(ctx, desc.value, null);
            else str = $433d9dc7b7117565$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($433d9dc7b7117565$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $433d9dc7b7117565$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("84NGl"));
function $433d9dc7b7117565$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $433d9dc7b7117565$var$isArray;
function $433d9dc7b7117565$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $433d9dc7b7117565$var$isBoolean;
function $433d9dc7b7117565$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $433d9dc7b7117565$var$isNull;
function $433d9dc7b7117565$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $433d9dc7b7117565$var$isNullOrUndefined;
function $433d9dc7b7117565$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $433d9dc7b7117565$var$isNumber;
function $433d9dc7b7117565$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $433d9dc7b7117565$var$isString;
function $433d9dc7b7117565$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $433d9dc7b7117565$var$isSymbol;
function $433d9dc7b7117565$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $433d9dc7b7117565$var$isUndefined;
function $433d9dc7b7117565$var$isRegExp(re) {
    return $433d9dc7b7117565$var$isObject(re) && $433d9dc7b7117565$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $433d9dc7b7117565$var$isRegExp;
module.exports.types.isRegExp = $433d9dc7b7117565$var$isRegExp;
function $433d9dc7b7117565$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $433d9dc7b7117565$var$isObject;
function $433d9dc7b7117565$var$isDate(d) {
    return $433d9dc7b7117565$var$isObject(d) && $433d9dc7b7117565$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $433d9dc7b7117565$var$isDate;
module.exports.types.isDate = $433d9dc7b7117565$var$isDate;
function $433d9dc7b7117565$var$isError(e) {
    return $433d9dc7b7117565$var$isObject(e) && ($433d9dc7b7117565$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $433d9dc7b7117565$var$isError;
module.exports.types.isNativeError = $433d9dc7b7117565$var$isError;
function $433d9dc7b7117565$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $433d9dc7b7117565$var$isFunction;
function $433d9dc7b7117565$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $433d9dc7b7117565$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("15hNQ"));
function $433d9dc7b7117565$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $433d9dc7b7117565$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $433d9dc7b7117565$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $433d9dc7b7117565$var$timestamp() {
    var d = new Date();
    var time = [
        $433d9dc7b7117565$var$pad(d.getHours()),
        $433d9dc7b7117565$var$pad(d.getMinutes()),
        $433d9dc7b7117565$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $433d9dc7b7117565$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $433d9dc7b7117565$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dhT4G"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$433d9dc7b7117565$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $433d9dc7b7117565$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $433d9dc7b7117565$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($433d9dc7b7117565$var$kCustomPromisifiedSymbol && original[$433d9dc7b7117565$var$kCustomPromisifiedSymbol]) {
        var fn = original[$433d9dc7b7117565$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $433d9dc7b7117565$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($433d9dc7b7117565$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $433d9dc7b7117565$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $433d9dc7b7117565$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $433d9dc7b7117565$var$kCustomPromisifiedSymbol;
function $433d9dc7b7117565$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $433d9dc7b7117565$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4ZL0H.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4ZL0H.nextTick($433d9dc7b7117565$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $433d9dc7b7117565$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $433d9dc7b7117565$var$callbackify;

});
parcelRequire.register("84NGl", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $1CYP9 = parcelRequire("1CYP9");

var $hPT6u = parcelRequire("hPT6u");

var $3y8Uz = parcelRequire("3y8Uz");

var $3v1VX = parcelRequire("3v1VX");
function $5e153c455be43079$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $5e153c455be43079$var$BigIntSupported = typeof BigInt !== "undefined";
var $5e153c455be43079$var$SymbolSupported = typeof Symbol !== "undefined";
var $5e153c455be43079$var$ObjectToString = $5e153c455be43079$var$uncurryThis(Object.prototype.toString);
var $5e153c455be43079$var$numberValue = $5e153c455be43079$var$uncurryThis(Number.prototype.valueOf);
var $5e153c455be43079$var$stringValue = $5e153c455be43079$var$uncurryThis(String.prototype.valueOf);
var $5e153c455be43079$var$booleanValue = $5e153c455be43079$var$uncurryThis(Boolean.prototype.valueOf);
if ($5e153c455be43079$var$BigIntSupported) var $5e153c455be43079$var$bigIntValue = $5e153c455be43079$var$uncurryThis(BigInt.prototype.valueOf);
if ($5e153c455be43079$var$SymbolSupported) var $5e153c455be43079$var$symbolValue = $5e153c455be43079$var$uncurryThis(Symbol.prototype.valueOf);
function $5e153c455be43079$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $1CYP9;
module.exports.isGeneratorFunction = $hPT6u;
module.exports.isTypedArray = $3v1VX;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $5e153c455be43079$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $5e153c455be43079$var$isPromise;
function $5e153c455be43079$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $3v1VX(value) || $5e153c455be43079$var$isDataView(value);
}
module.exports.isArrayBufferView = $5e153c455be43079$var$isArrayBufferView;
function $5e153c455be43079$var$isUint8Array(value) {
    return $3y8Uz(value) === "Uint8Array";
}
module.exports.isUint8Array = $5e153c455be43079$var$isUint8Array;
function $5e153c455be43079$var$isUint8ClampedArray(value) {
    return $3y8Uz(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $5e153c455be43079$var$isUint8ClampedArray;
function $5e153c455be43079$var$isUint16Array(value) {
    return $3y8Uz(value) === "Uint16Array";
}
module.exports.isUint16Array = $5e153c455be43079$var$isUint16Array;
function $5e153c455be43079$var$isUint32Array(value) {
    return $3y8Uz(value) === "Uint32Array";
}
module.exports.isUint32Array = $5e153c455be43079$var$isUint32Array;
function $5e153c455be43079$var$isInt8Array(value) {
    return $3y8Uz(value) === "Int8Array";
}
module.exports.isInt8Array = $5e153c455be43079$var$isInt8Array;
function $5e153c455be43079$var$isInt16Array(value) {
    return $3y8Uz(value) === "Int16Array";
}
module.exports.isInt16Array = $5e153c455be43079$var$isInt16Array;
function $5e153c455be43079$var$isInt32Array(value) {
    return $3y8Uz(value) === "Int32Array";
}
module.exports.isInt32Array = $5e153c455be43079$var$isInt32Array;
function $5e153c455be43079$var$isFloat32Array(value) {
    return $3y8Uz(value) === "Float32Array";
}
module.exports.isFloat32Array = $5e153c455be43079$var$isFloat32Array;
function $5e153c455be43079$var$isFloat64Array(value) {
    return $3y8Uz(value) === "Float64Array";
}
module.exports.isFloat64Array = $5e153c455be43079$var$isFloat64Array;
function $5e153c455be43079$var$isBigInt64Array(value) {
    return $3y8Uz(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $5e153c455be43079$var$isBigInt64Array;
function $5e153c455be43079$var$isBigUint64Array(value) {
    return $3y8Uz(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $5e153c455be43079$var$isBigUint64Array;
function $5e153c455be43079$var$isMapToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object Map]";
}
$5e153c455be43079$var$isMapToString.working = typeof Map !== "undefined" && $5e153c455be43079$var$isMapToString(new Map());
function $5e153c455be43079$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $5e153c455be43079$var$isMapToString.working ? $5e153c455be43079$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $5e153c455be43079$var$isMap;
function $5e153c455be43079$var$isSetToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object Set]";
}
$5e153c455be43079$var$isSetToString.working = typeof Set !== "undefined" && $5e153c455be43079$var$isSetToString(new Set());
function $5e153c455be43079$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $5e153c455be43079$var$isSetToString.working ? $5e153c455be43079$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $5e153c455be43079$var$isSet;
function $5e153c455be43079$var$isWeakMapToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object WeakMap]";
}
$5e153c455be43079$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $5e153c455be43079$var$isWeakMapToString(new WeakMap());
function $5e153c455be43079$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $5e153c455be43079$var$isWeakMapToString.working ? $5e153c455be43079$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $5e153c455be43079$var$isWeakMap;
function $5e153c455be43079$var$isWeakSetToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object WeakSet]";
}
$5e153c455be43079$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $5e153c455be43079$var$isWeakSetToString(new WeakSet());
function $5e153c455be43079$var$isWeakSet(value) {
    return $5e153c455be43079$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $5e153c455be43079$var$isWeakSet;
function $5e153c455be43079$var$isArrayBufferToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$5e153c455be43079$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $5e153c455be43079$var$isArrayBufferToString(new ArrayBuffer());
function $5e153c455be43079$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $5e153c455be43079$var$isArrayBufferToString.working ? $5e153c455be43079$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $5e153c455be43079$var$isArrayBuffer;
function $5e153c455be43079$var$isDataViewToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object DataView]";
}
$5e153c455be43079$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $5e153c455be43079$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $5e153c455be43079$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $5e153c455be43079$var$isDataViewToString.working ? $5e153c455be43079$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $5e153c455be43079$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $5e153c455be43079$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $5e153c455be43079$var$isSharedArrayBufferToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $5e153c455be43079$var$isSharedArrayBuffer(value) {
    if (typeof $5e153c455be43079$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $5e153c455be43079$var$isSharedArrayBufferToString.working === "undefined") $5e153c455be43079$var$isSharedArrayBufferToString.working = $5e153c455be43079$var$isSharedArrayBufferToString(new $5e153c455be43079$var$SharedArrayBufferCopy());
    return $5e153c455be43079$var$isSharedArrayBufferToString.working ? $5e153c455be43079$var$isSharedArrayBufferToString(value) : value instanceof $5e153c455be43079$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $5e153c455be43079$var$isSharedArrayBuffer;
function $5e153c455be43079$var$isAsyncFunction(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $5e153c455be43079$var$isAsyncFunction;
function $5e153c455be43079$var$isMapIterator(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $5e153c455be43079$var$isMapIterator;
function $5e153c455be43079$var$isSetIterator(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $5e153c455be43079$var$isSetIterator;
function $5e153c455be43079$var$isGeneratorObject(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $5e153c455be43079$var$isGeneratorObject;
function $5e153c455be43079$var$isWebAssemblyCompiledModule(value) {
    return $5e153c455be43079$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $5e153c455be43079$var$isWebAssemblyCompiledModule;
function $5e153c455be43079$var$isNumberObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$numberValue);
}
module.exports.isNumberObject = $5e153c455be43079$var$isNumberObject;
function $5e153c455be43079$var$isStringObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$stringValue);
}
module.exports.isStringObject = $5e153c455be43079$var$isStringObject;
function $5e153c455be43079$var$isBooleanObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$booleanValue);
}
module.exports.isBooleanObject = $5e153c455be43079$var$isBooleanObject;
function $5e153c455be43079$var$isBigIntObject(value) {
    return $5e153c455be43079$var$BigIntSupported && $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$bigIntValue);
}
module.exports.isBigIntObject = $5e153c455be43079$var$isBigIntObject;
function $5e153c455be43079$var$isSymbolObject(value) {
    return $5e153c455be43079$var$SymbolSupported && $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$symbolValue);
}
module.exports.isSymbolObject = $5e153c455be43079$var$isSymbolObject;
function $5e153c455be43079$var$isBoxedPrimitive(value) {
    return $5e153c455be43079$var$isNumberObject(value) || $5e153c455be43079$var$isStringObject(value) || $5e153c455be43079$var$isBooleanObject(value) || $5e153c455be43079$var$isBigIntObject(value) || $5e153c455be43079$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $5e153c455be43079$var$isBoxedPrimitive;
function $5e153c455be43079$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($5e153c455be43079$var$isArrayBuffer(value) || $5e153c455be43079$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $5e153c455be43079$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("1CYP9", function(module, exports) {
"use strict";

var $12f8857680b8d243$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $42mQn = parcelRequire("42mQn");
var $12f8857680b8d243$var$$toString = $42mQn("Object.prototype.toString");
var $12f8857680b8d243$var$isStandardArguments = function isArguments(value) {
    if ($12f8857680b8d243$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $12f8857680b8d243$var$$toString(value) === "[object Arguments]";
};
var $12f8857680b8d243$var$isLegacyArguments = function isArguments(value) {
    if ($12f8857680b8d243$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $12f8857680b8d243$var$$toString(value) !== "[object Array]" && $12f8857680b8d243$var$$toString(value.callee) === "[object Function]";
};
var $12f8857680b8d243$var$supportsStandardArguments = function() {
    return $12f8857680b8d243$var$isStandardArguments(arguments);
}();
$12f8857680b8d243$var$isStandardArguments.isLegacyArguments = $12f8857680b8d243$var$isLegacyArguments; // for tests
module.exports = $12f8857680b8d243$var$supportsStandardArguments ? $12f8857680b8d243$var$isStandardArguments : $12f8857680b8d243$var$isLegacyArguments;

});
parcelRequire.register("1Zhkx", function(module, exports) {
"use strict";

var $f2BFz = parcelRequire("f2BFz");
module.exports = function hasToStringTagShams() {
    return $f2BFz() && !!Symbol.toStringTag;
};

});
parcelRequire.register("f2BFz", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("42mQn", function(module, exports) {
"use strict";

var $hkNzn = parcelRequire("hkNzn");

var $e6nwk = parcelRequire("e6nwk");
var $2f0911a0619d4e42$var$$indexOf = $e6nwk($hkNzn("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $hkNzn(name, !!allowMissing);
    if (typeof intrinsic === "function" && $2f0911a0619d4e42$var$$indexOf(name, ".prototype.") > -1) return $e6nwk(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("hkNzn", function(module, exports) {
"use strict";
var $c9eac16840c8f75d$var$undefined;
var $c9eac16840c8f75d$var$$SyntaxError = SyntaxError;
var $c9eac16840c8f75d$var$$Function = Function;
var $c9eac16840c8f75d$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $c9eac16840c8f75d$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($c9eac16840c8f75d$var$$gOPD) try {
    $c9eac16840c8f75d$var$$gOPD({}, "");
} catch (e) {
    $c9eac16840c8f75d$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $c9eac16840c8f75d$var$$TypeError();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $c9eac16840c8f75d$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $c9eac16840c8f75d$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();

var $c9eac16840c8f75d$var$hasProto = (parcelRequire("hNVka"))();
var $c9eac16840c8f75d$var$getProto = Object.getPrototypeOf || ($c9eac16840c8f75d$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === "undefined" || !$c9eac16840c8f75d$var$getProto ? $c9eac16840c8f75d$var$undefined : $c9eac16840c8f75d$var$getProto(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $c9eac16840c8f75d$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $c9eac16840c8f75d$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $c9eac16840c8f75d$var$hasSymbols && $c9eac16840c8f75d$var$getProto ? $c9eac16840c8f75d$var$getProto([][Symbol.iterator]()) : $c9eac16840c8f75d$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $c9eac16840c8f75d$var$undefined,
    "%AsyncFunction%": $c9eac16840c8f75d$var$needsEval,
    "%AsyncGenerator%": $c9eac16840c8f75d$var$needsEval,
    "%AsyncGeneratorFunction%": $c9eac16840c8f75d$var$needsEval,
    "%AsyncIteratorPrototype%": $c9eac16840c8f75d$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $c9eac16840c8f75d$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $c9eac16840c8f75d$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $c9eac16840c8f75d$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $c9eac16840c8f75d$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $c9eac16840c8f75d$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $c9eac16840c8f75d$var$undefined : FinalizationRegistry,
    "%Function%": $c9eac16840c8f75d$var$$Function,
    "%GeneratorFunction%": $c9eac16840c8f75d$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $c9eac16840c8f75d$var$hasSymbols && $c9eac16840c8f75d$var$getProto ? $c9eac16840c8f75d$var$getProto($c9eac16840c8f75d$var$getProto([][Symbol.iterator]())) : $c9eac16840c8f75d$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $c9eac16840c8f75d$var$undefined,
    "%Map%": typeof Map === "undefined" ? $c9eac16840c8f75d$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$c9eac16840c8f75d$var$hasSymbols || !$c9eac16840c8f75d$var$getProto ? $c9eac16840c8f75d$var$undefined : $c9eac16840c8f75d$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $c9eac16840c8f75d$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $c9eac16840c8f75d$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $c9eac16840c8f75d$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $c9eac16840c8f75d$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$c9eac16840c8f75d$var$hasSymbols || !$c9eac16840c8f75d$var$getProto ? $c9eac16840c8f75d$var$undefined : $c9eac16840c8f75d$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $c9eac16840c8f75d$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $c9eac16840c8f75d$var$hasSymbols && $c9eac16840c8f75d$var$getProto ? $c9eac16840c8f75d$var$getProto(""[Symbol.iterator]()) : $c9eac16840c8f75d$var$undefined,
    "%Symbol%": $c9eac16840c8f75d$var$hasSymbols ? Symbol : $c9eac16840c8f75d$var$undefined,
    "%SyntaxError%": $c9eac16840c8f75d$var$$SyntaxError,
    "%ThrowTypeError%": $c9eac16840c8f75d$var$ThrowTypeError,
    "%TypedArray%": $c9eac16840c8f75d$var$TypedArray,
    "%TypeError%": $c9eac16840c8f75d$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $c9eac16840c8f75d$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $c9eac16840c8f75d$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $c9eac16840c8f75d$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $c9eac16840c8f75d$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $c9eac16840c8f75d$var$undefined : WeakSet
};
if ($c9eac16840c8f75d$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $c9eac16840c8f75d$var$getProto($c9eac16840c8f75d$var$getProto(e));
    $c9eac16840c8f75d$var$INTRINSICS["%Error.prototype%"] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $c9eac16840c8f75d$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $c9eac16840c8f75d$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $c9eac16840c8f75d$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $c9eac16840c8f75d$var$getProto) value = $c9eac16840c8f75d$var$getProto(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $eQ7C3 = parcelRequire("eQ7C3");

var $hAsRP = parcelRequire("hAsRP");
var $c9eac16840c8f75d$var$$concat = $eQ7C3.call(Function.call, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $eQ7C3.call(Function.apply, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $eQ7C3.call(Function.call, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $eQ7C3.call(Function.call, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $eQ7C3.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $c9eac16840c8f75d$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $c9eac16840c8f75d$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($hAsRP($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($hAsRP($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $c9eac16840c8f75d$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $c9eac16840c8f75d$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $c9eac16840c8f75d$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $c9eac16840c8f75d$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $c9eac16840c8f75d$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $c9eac16840c8f75d$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($hAsRP($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $c9eac16840c8f75d$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($c9eac16840c8f75d$var$$gOPD && i + 1 >= parts.length) {
                var desc = $c9eac16840c8f75d$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $hAsRP(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("4qQ7b", function(module, exports) {
"use strict";
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $f2BFz = parcelRequire("f2BFz");
module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $33a204135f6b8445$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $f2BFz();
};

});

parcelRequire.register("hNVka", function(module, exports) {
"use strict";
var $cf637ab3aa846755$var$test = {
    foo: {}
};
var $cf637ab3aa846755$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $cf637ab3aa846755$var$test
    }).foo === $cf637ab3aa846755$var$test.foo && !(({
        __proto__: null
    }) instanceof $cf637ab3aa846755$var$$Object);
};

});

parcelRequire.register("eQ7C3", function(module, exports) {
"use strict";

var $gfKZG = parcelRequire("gfKZG");
module.exports = Function.prototype.bind || $gfKZG;

});
parcelRequire.register("gfKZG", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $bd52800b6fae4c57$var$slice = Array.prototype.slice;
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $bd52800b6fae4c57$var$toStr.call(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($bd52800b6fae4c57$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($bd52800b6fae4c57$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("hAsRP", function(module, exports) {
"use strict";

var $eQ7C3 = parcelRequire("eQ7C3");
module.exports = $eQ7C3.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("e6nwk", function(module, exports) {
"use strict";

var $eQ7C3 = parcelRequire("eQ7C3");

var $hkNzn = parcelRequire("hkNzn");
var $a443dee468039121$var$$apply = $hkNzn("%Function.prototype.apply%");
var $a443dee468039121$var$$call = $hkNzn("%Function.prototype.call%");
var $a443dee468039121$var$$reflectApply = $hkNzn("%Reflect.apply%", true) || $eQ7C3.call($a443dee468039121$var$$call, $a443dee468039121$var$$apply);
var $a443dee468039121$var$$gOPD = $hkNzn("%Object.getOwnPropertyDescriptor%", true);
var $a443dee468039121$var$$defineProperty = $hkNzn("%Object.defineProperty%", true);
var $a443dee468039121$var$$max = $hkNzn("%Math.max%");
if ($a443dee468039121$var$$defineProperty) try {
    $a443dee468039121$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $a443dee468039121$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $a443dee468039121$var$$reflectApply($eQ7C3, $a443dee468039121$var$$call, arguments);
    if ($a443dee468039121$var$$gOPD && $a443dee468039121$var$$defineProperty) {
        var desc = $a443dee468039121$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $a443dee468039121$var$$defineProperty(func, "length", {
            value: 1 + $a443dee468039121$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $a443dee468039121$var$applyBind = function applyBind() {
    return $a443dee468039121$var$$reflectApply($eQ7C3, $a443dee468039121$var$$apply, arguments);
};
if ($a443dee468039121$var$$defineProperty) $a443dee468039121$var$$defineProperty(module.exports, "apply", {
    value: $a443dee468039121$var$applyBind
});
else module.exports.apply = $a443dee468039121$var$applyBind;

});



parcelRequire.register("hPT6u", function(module, exports) {
"use strict";
var $cfc1f18425c87f72$var$toStr = Object.prototype.toString;
var $cfc1f18425c87f72$var$fnToStr = Function.prototype.toString;
var $cfc1f18425c87f72$var$isFnRegex = /^\s*(?:function)?\*/;

var $cfc1f18425c87f72$var$hasToStringTag = (parcelRequire("1Zhkx"))();
var $cfc1f18425c87f72$var$getProto = Object.getPrototypeOf;
var $cfc1f18425c87f72$var$getGeneratorFunc = function() {
    if (!$cfc1f18425c87f72$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $cfc1f18425c87f72$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($cfc1f18425c87f72$var$isFnRegex.test($cfc1f18425c87f72$var$fnToStr.call(fn))) return true;
    if (!$cfc1f18425c87f72$var$hasToStringTag) {
        var str = $cfc1f18425c87f72$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$cfc1f18425c87f72$var$getProto) return false;
    if (typeof $cfc1f18425c87f72$var$GeneratorFunction === "undefined") {
        var generatorFunc = $cfc1f18425c87f72$var$getGeneratorFunc();
        $cfc1f18425c87f72$var$GeneratorFunction = generatorFunc ? $cfc1f18425c87f72$var$getProto(generatorFunc) : false;
    }
    return $cfc1f18425c87f72$var$getProto(fn) === $cfc1f18425c87f72$var$GeneratorFunction;
};

});

parcelRequire.register("3y8Uz", function(module, exports) {
"use strict";

var $4t3RV = parcelRequire("4t3RV");

var $gxzn4 = parcelRequire("gxzn4");

var $e6nwk = parcelRequire("e6nwk");

var $42mQn = parcelRequire("42mQn");

var $gNKV7 = parcelRequire("gNKV7");
var $295b75af42290f89$var$$toString = $42mQn("Object.prototype.toString");

var $295b75af42290f89$var$hasToStringTag = (parcelRequire("1Zhkx"))();
var $295b75af42290f89$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $295b75af42290f89$var$typedArrays = $gxzn4();
var $295b75af42290f89$var$$slice = $42mQn("String.prototype.slice");
var $295b75af42290f89$var$toStrTags = {
    __proto__: null
};
var $295b75af42290f89$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($295b75af42290f89$var$hasToStringTag && $gNKV7 && $295b75af42290f89$var$getPrototypeOf) $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    if (typeof $295b75af42290f89$var$g[typedArray] === "function") {
        var arr = new $295b75af42290f89$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $295b75af42290f89$var$getPrototypeOf(arr);
            var descriptor = $gNKV7(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $295b75af42290f89$var$getPrototypeOf(proto);
                descriptor = $gNKV7(superProto, Symbol.toStringTag);
            }
            $295b75af42290f89$var$toStrTags[typedArray] = $e6nwk(descriptor.get);
        }
    }
});
var $295b75af42290f89$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $4t3RV($295b75af42290f89$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $3v1VX = parcelRequire("3v1VX");
module.exports = function whichTypedArray(value) {
    if (!$3v1VX(value)) return false;
    if (!$295b75af42290f89$var$hasToStringTag || !(Symbol.toStringTag in value)) return $295b75af42290f89$var$$slice($295b75af42290f89$var$$toString(value), 8, -1);
    return $295b75af42290f89$var$tryTypedArrays(value);
};

});
parcelRequire.register("4t3RV", function(module, exports) {
"use strict";

var $jUn8P = parcelRequire("jUn8P");
var $340cdf18336e158b$var$toStr = Object.prototype.toString;
var $340cdf18336e158b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $340cdf18336e158b$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($340cdf18336e158b$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $340cdf18336e158b$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $340cdf18336e158b$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($340cdf18336e158b$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $340cdf18336e158b$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$jUn8P(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($340cdf18336e158b$var$toStr.call(list) === "[object Array]") $340cdf18336e158b$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $340cdf18336e158b$var$forEachString(list, iterator, receiver);
    else $340cdf18336e158b$var$forEachObject(list, iterator, receiver);
};
module.exports = $340cdf18336e158b$var$forEach;

});
parcelRequire.register("jUn8P", function(module, exports) {
"use strict";
var $e7e532a9f9e12dda$var$fnToStr = Function.prototype.toString;
var $e7e532a9f9e12dda$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $e7e532a9f9e12dda$var$badArrayLike;
var $e7e532a9f9e12dda$var$isCallableMarker;
if (typeof $e7e532a9f9e12dda$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $e7e532a9f9e12dda$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $e7e532a9f9e12dda$var$isCallableMarker;
        }
    });
    $e7e532a9f9e12dda$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $e7e532a9f9e12dda$var$reflectApply(function() {
        throw 42;
    }, null, $e7e532a9f9e12dda$var$badArrayLike);
} catch (_) {
    if (_ !== $e7e532a9f9e12dda$var$isCallableMarker) $e7e532a9f9e12dda$var$reflectApply = null;
}
else $e7e532a9f9e12dda$var$reflectApply = null;
var $e7e532a9f9e12dda$var$constructorRegex = /^\s*class\b/;
var $e7e532a9f9e12dda$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $e7e532a9f9e12dda$var$fnToStr.call(value);
        return $e7e532a9f9e12dda$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $e7e532a9f9e12dda$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
        $e7e532a9f9e12dda$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $e7e532a9f9e12dda$var$toStr = Object.prototype.toString;
var $e7e532a9f9e12dda$var$objectClass = "[object Object]";
var $e7e532a9f9e12dda$var$fnClass = "[object Function]";
var $e7e532a9f9e12dda$var$genClass = "[object GeneratorFunction]";
var $e7e532a9f9e12dda$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $e7e532a9f9e12dda$var$ddaClass2 = "[object HTML document.all class]";
var $e7e532a9f9e12dda$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $e7e532a9f9e12dda$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $e7e532a9f9e12dda$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $e7e532a9f9e12dda$var$all = document.all;
    if ($e7e532a9f9e12dda$var$toStr.call($e7e532a9f9e12dda$var$all) === $e7e532a9f9e12dda$var$toStr.call(document.all)) $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($e7e532a9f9e12dda$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $e7e532a9f9e12dda$var$toStr.call(value);
            return (str === $e7e532a9f9e12dda$var$ddaClass || str === $e7e532a9f9e12dda$var$ddaClass2 || str === $e7e532a9f9e12dda$var$ddaClass3 // opera 12.16
             || str === $e7e532a9f9e12dda$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $e7e532a9f9e12dda$var$reflectApply ? function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $e7e532a9f9e12dda$var$reflectApply(value, null, $e7e532a9f9e12dda$var$badArrayLike);
    } catch (e) {
        if (e !== $e7e532a9f9e12dda$var$isCallableMarker) return false;
    }
    return !$e7e532a9f9e12dda$var$isES6ClassFn(value) && $e7e532a9f9e12dda$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($e7e532a9f9e12dda$var$hasToStringTag) return $e7e532a9f9e12dda$var$tryFunctionObject(value);
    if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
    var strClass = $e7e532a9f9e12dda$var$toStr.call(value);
    if (strClass !== $e7e532a9f9e12dda$var$fnClass && strClass !== $e7e532a9f9e12dda$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $e7e532a9f9e12dda$var$tryFunctionObject(value);
};

});


parcelRequire.register("gxzn4", function(module, exports) {
"use strict";
var $c0ab2a592dd1c9f4$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $c0ab2a592dd1c9f4$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $c0ab2a592dd1c9f4$var$possibleNames.length; i++)if (typeof $c0ab2a592dd1c9f4$var$g[$c0ab2a592dd1c9f4$var$possibleNames[i]] === "function") out[out.length] = $c0ab2a592dd1c9f4$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("gNKV7", function(module, exports) {
"use strict";

var $hkNzn = parcelRequire("hkNzn");
var $c3b59e512f612c17$var$$gOPD = $hkNzn("%Object.getOwnPropertyDescriptor%", true);
if ($c3b59e512f612c17$var$$gOPD) try {
    $c3b59e512f612c17$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$var$$gOPD = null;
}
module.exports = $c3b59e512f612c17$var$$gOPD;

});

parcelRequire.register("3v1VX", function(module, exports) {
"use strict";

var $4t3RV = parcelRequire("4t3RV");

var $gxzn4 = parcelRequire("gxzn4");

var $42mQn = parcelRequire("42mQn");
var $28c5c457465d169b$var$$toString = $42mQn("Object.prototype.toString");

var $28c5c457465d169b$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $gNKV7 = parcelRequire("gNKV7");
var $28c5c457465d169b$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $28c5c457465d169b$var$typedArrays = $gxzn4();
var $28c5c457465d169b$var$$indexOf = $42mQn("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $28c5c457465d169b$var$$slice = $42mQn("String.prototype.slice");
var $28c5c457465d169b$var$toStrTags = {};
var $28c5c457465d169b$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($28c5c457465d169b$var$hasToStringTag && $gNKV7 && $28c5c457465d169b$var$getPrototypeOf) $4t3RV($28c5c457465d169b$var$typedArrays, function(typedArray) {
    var arr = new $28c5c457465d169b$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $28c5c457465d169b$var$getPrototypeOf(arr);
        var descriptor = $gNKV7(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $28c5c457465d169b$var$getPrototypeOf(proto);
            descriptor = $gNKV7(superProto, Symbol.toStringTag);
        }
        $28c5c457465d169b$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $28c5c457465d169b$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $4t3RV($28c5c457465d169b$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$28c5c457465d169b$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $28c5c457465d169b$var$$slice($28c5c457465d169b$var$$toString(value), 8, -1);
        return $28c5c457465d169b$var$$indexOf($28c5c457465d169b$var$typedArrays, tag) > -1;
    }
    if (!$gNKV7) return false;
    return $28c5c457465d169b$var$tryTypedArrays(value);
};

});



parcelRequire.register("15hNQ", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRequire.register("dhT4G", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("h1RhN", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
"use strict";
function $c65bdd22acd63589$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c65bdd22acd63589$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c65bdd22acd63589$var$_typeof(o);
}
function $c65bdd22acd63589$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c65bdd22acd63589$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c65bdd22acd63589$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c65bdd22acd63589$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c65bdd22acd63589$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c65bdd22acd63589$var$_toPropertyKey(arg) {
    var key = $c65bdd22acd63589$var$_toPrimitive(arg, "string");
    return $c65bdd22acd63589$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c65bdd22acd63589$var$_toPrimitive(input, hint) {
    if ($c65bdd22acd63589$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c65bdd22acd63589$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c65bdd22acd63589$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h03I0 = parcelRequire("h03I0");
var $c65bdd22acd63589$var$_require$codes = $h03I0.codes, $c65bdd22acd63589$var$ERR_AMBIGUOUS_ARGUMENT = $c65bdd22acd63589$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE = $c65bdd22acd63589$var$_require$codes.ERR_INVALID_ARG_TYPE, $c65bdd22acd63589$var$ERR_INVALID_ARG_VALUE = $c65bdd22acd63589$var$_require$codes.ERR_INVALID_ARG_VALUE, $c65bdd22acd63589$var$ERR_INVALID_RETURN_VALUE = $c65bdd22acd63589$var$_require$codes.ERR_INVALID_RETURN_VALUE, $c65bdd22acd63589$var$ERR_MISSING_ARGS = $c65bdd22acd63589$var$_require$codes.ERR_MISSING_ARGS;

var $53qBH = parcelRequire("53qBH");

var $5LV4O = parcelRequire("5LV4O");
var $c65bdd22acd63589$var$inspect = $5LV4O.inspect;

var $5LV4O = parcelRequire("5LV4O");
var $c65bdd22acd63589$require$_require$types = $5LV4O.types;
var $c65bdd22acd63589$var$isPromise = $c65bdd22acd63589$require$_require$types.isPromise, $c65bdd22acd63589$var$isRegExp = $c65bdd22acd63589$require$_require$types.isRegExp;

var $c65bdd22acd63589$var$objectAssign = (parcelRequire("2utFF"))();

var $c65bdd22acd63589$var$objectIs = (parcelRequire("dKyGU"))();

var $c65bdd22acd63589$var$RegExpPrototypeTest = (parcelRequire("42mQn"))("RegExp.prototype.test");
var $c65bdd22acd63589$var$errorCache = new Map();
var $c65bdd22acd63589$var$isDeepEqual;
var $c65bdd22acd63589$var$isDeepStrictEqual;
var $c65bdd22acd63589$var$parseExpressionAt;
var $c65bdd22acd63589$var$findNodeAround;
var $c65bdd22acd63589$var$decoder;

function $c65bdd22acd63589$var$lazyLoadComparison() {
    var comparison = (parcelRequire("5Ptnz"));
    $c65bdd22acd63589$var$isDeepEqual = comparison.isDeepEqual;
    $c65bdd22acd63589$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $c65bdd22acd63589$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $c65bdd22acd63589$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $c65bdd22acd63589$var$escapeFn = function escapeFn(str) {
    return $c65bdd22acd63589$var$meta[str.charCodeAt(0)];
};
var $c65bdd22acd63589$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $c65bdd22acd63589$var$assert = module.exports = $c65bdd22acd63589$var$ok;
var $c65bdd22acd63589$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $c65bdd22acd63589$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $53qBH(obj);
}
function $c65bdd22acd63589$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($c65bdd22acd63589$var$warned === false) {
            $c65bdd22acd63589$var$warned = true;
            var warn = $4ZL0H.emitWarning ? $4ZL0H.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $c65bdd22acd63589$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $53qBH(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$c65bdd22acd63589$var$assert.fail = $c65bdd22acd63589$var$fail;
// The AssertionError is defined in internal/error.
$c65bdd22acd63589$var$assert.AssertionError = $53qBH;
function $c65bdd22acd63589$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $53qBH({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $c65bdd22acd63589$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c65bdd22acd63589$var$innerOk.apply(void 0, [
        $c65bdd22acd63589$var$ok,
        args.length
    ].concat(args));
}
$c65bdd22acd63589$var$assert.ok = $c65bdd22acd63589$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $c65bdd22acd63589$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$c65bdd22acd63589$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$c65bdd22acd63589$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    if ($c65bdd22acd63589$var$isDeepEqual === undefined) $c65bdd22acd63589$var$lazyLoadComparison();
    if (!$c65bdd22acd63589$var$isDeepEqual(actual, expected)) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$c65bdd22acd63589$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    if ($c65bdd22acd63589$var$isDeepEqual === undefined) $c65bdd22acd63589$var$lazyLoadComparison();
    if ($c65bdd22acd63589$var$isDeepEqual(actual, expected)) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $c65bdd22acd63589$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    if ($c65bdd22acd63589$var$isDeepEqual === undefined) $c65bdd22acd63589$var$lazyLoadComparison();
    if (!$c65bdd22acd63589$var$isDeepStrictEqual(actual, expected)) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$c65bdd22acd63589$var$assert.notDeepStrictEqual = $c65bdd22acd63589$var$notDeepStrictEqual;
function $c65bdd22acd63589$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    if ($c65bdd22acd63589$var$isDeepEqual === undefined) $c65bdd22acd63589$var$lazyLoadComparison();
    if ($c65bdd22acd63589$var$isDeepStrictEqual(actual, expected)) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $c65bdd22acd63589$var$notDeepStrictEqual
    });
}
$c65bdd22acd63589$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$c65bdd22acd63589$var$objectIs(actual, expected)) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$c65bdd22acd63589$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $c65bdd22acd63589$var$ERR_MISSING_ARGS("actual", "expected");
    if ($c65bdd22acd63589$var$objectIs(actual, expected)) $c65bdd22acd63589$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $c65bdd22acd63589$var$Comparison = /*#__PURE__*/ $c65bdd22acd63589$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $c65bdd22acd63589$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $c65bdd22acd63589$var$isRegExp(obj[key]) && $c65bdd22acd63589$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $c65bdd22acd63589$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$c65bdd22acd63589$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $c65bdd22acd63589$var$Comparison(actual, keys);
            var b = new $c65bdd22acd63589$var$Comparison(expected, keys, actual);
            var err = new $53qBH({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $c65bdd22acd63589$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $c65bdd22acd63589$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($c65bdd22acd63589$var$isRegExp(expected)) return $c65bdd22acd63589$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($c65bdd22acd63589$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $53qBH({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($c65bdd22acd63589$var$isDeepEqual === undefined) $c65bdd22acd63589$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $c65bdd22acd63589$var$isRegExp(expected[key]) && $c65bdd22acd63589$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $c65bdd22acd63589$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $c65bdd22acd63589$var$getActual(fn) {
    if (typeof fn !== "function") throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $c65bdd22acd63589$var$NO_EXCEPTION_SENTINEL;
}
function $c65bdd22acd63589$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $c65bdd22acd63589$var$isPromise(obj) || obj !== null && $c65bdd22acd63589$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $c65bdd22acd63589$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$c65bdd22acd63589$var$checkIsPromise(resultPromise)) throw new $c65bdd22acd63589$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($c65bdd22acd63589$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $c65bdd22acd63589$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $c65bdd22acd63589$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($c65bdd22acd63589$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $c65bdd22acd63589$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $c65bdd22acd63589$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $c65bdd22acd63589$var$_typeof(error) !== "object" && typeof error !== "function") throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $c65bdd22acd63589$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $c65bdd22acd63589$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$c65bdd22acd63589$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $c65bdd22acd63589$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $c65bdd22acd63589$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $c65bdd22acd63589$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $c65bdd22acd63589$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$c65bdd22acd63589$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $c65bdd22acd63589$var$expectsError.apply(void 0, [
        throws,
        $c65bdd22acd63589$var$getActual(promiseFn)
    ].concat(args));
};
$c65bdd22acd63589$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $c65bdd22acd63589$var$waitForActual(promiseFn).then(function(result) {
        return $c65bdd22acd63589$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$c65bdd22acd63589$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $c65bdd22acd63589$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $c65bdd22acd63589$var$getActual(fn)
    ].concat(args));
};
$c65bdd22acd63589$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $c65bdd22acd63589$var$waitForActual(fn).then(function(result) {
        return $c65bdd22acd63589$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$c65bdd22acd63589$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($c65bdd22acd63589$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $c65bdd22acd63589$var$inspect(err);
        var newErr = new $53qBH({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $c65bdd22acd63589$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$c65bdd22acd63589$var$isRegExp(regexp)) throw new $c65bdd22acd63589$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $c65bdd22acd63589$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($c65bdd22acd63589$var$_typeof(string), " (").concat($c65bdd22acd63589$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($c65bdd22acd63589$var$inspect(regexp), ". Input:\n\n").concat($c65bdd22acd63589$var$inspect(string), "\n"));
        var err = new $53qBH({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$c65bdd22acd63589$var$assert.match = function match(string, regexp, message) {
    $c65bdd22acd63589$var$internalMatch(string, regexp, message, match, "match");
};
$c65bdd22acd63589$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $c65bdd22acd63589$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $c65bdd22acd63589$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $c65bdd22acd63589$var$innerOk.apply(void 0, [
        $c65bdd22acd63589$var$strict,
        args.length
    ].concat(args));
}
$c65bdd22acd63589$var$assert.strict = $c65bdd22acd63589$var$objectAssign($c65bdd22acd63589$var$strict, $c65bdd22acd63589$var$assert, {
    equal: $c65bdd22acd63589$var$assert.strictEqual,
    deepEqual: $c65bdd22acd63589$var$assert.deepStrictEqual,
    notEqual: $c65bdd22acd63589$var$assert.notStrictEqual,
    notDeepEqual: $c65bdd22acd63589$var$assert.notDeepStrictEqual
});
$c65bdd22acd63589$var$assert.strict.strict = $c65bdd22acd63589$var$assert.strict;

});
parcelRequire.register("h03I0", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $c605503dccaf885d$export$e45cb6485273080e; }, function (v) { return $c605503dccaf885d$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $c605503dccaf885d$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $c605503dccaf885d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c605503dccaf885d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c605503dccaf885d$var$_typeof(o);
}
function $c605503dccaf885d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c605503dccaf885d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c605503dccaf885d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c605503dccaf885d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c605503dccaf885d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c605503dccaf885d$var$_toPropertyKey(arg) {
    var key = $c605503dccaf885d$var$_toPrimitive(arg, "string");
    return $c605503dccaf885d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c605503dccaf885d$var$_toPrimitive(input, hint) {
    if ($c605503dccaf885d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c605503dccaf885d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c605503dccaf885d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c605503dccaf885d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c605503dccaf885d$var$_setPrototypeOf(subClass, superClass);
}
function $c605503dccaf885d$var$_setPrototypeOf(o, p) {
    $c605503dccaf885d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c605503dccaf885d$var$_setPrototypeOf(o, p);
}
function $c605503dccaf885d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c605503dccaf885d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c605503dccaf885d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c605503dccaf885d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c605503dccaf885d$var$_possibleConstructorReturn(this, result);
    };
}
function $c605503dccaf885d$var$_possibleConstructorReturn(self, call) {
    if (call && ($c605503dccaf885d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c605503dccaf885d$var$_assertThisInitialized(self);
}
function $c605503dccaf885d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c605503dccaf885d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c605503dccaf885d$var$_getPrototypeOf(o) {
    $c605503dccaf885d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c605503dccaf885d$var$_getPrototypeOf(o);
}
var $c605503dccaf885d$var$codes = {};
// Lazy loaded
var $c605503dccaf885d$var$assert;
var $c605503dccaf885d$var$util;
function $c605503dccaf885d$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $c605503dccaf885d$var$_inherits(NodeError, _Base);
        var _super = $c605503dccaf885d$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $c605503dccaf885d$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $c605503dccaf885d$var$_createClass(NodeError);
    }(Base);
    $c605503dccaf885d$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $c605503dccaf885d$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $c605503dccaf885d$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c605503dccaf885d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $c605503dccaf885d$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$c605503dccaf885d$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$c605503dccaf885d$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($c605503dccaf885d$var$assert === undefined) $c605503dccaf885d$var$assert = (parcelRequire("h1RhN"));
    $c605503dccaf885d$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $c605503dccaf885d$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($c605503dccaf885d$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($c605503dccaf885d$var$oneOf(expected, "type"));
    else {
        var type = $c605503dccaf885d$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($c605503dccaf885d$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($c605503dccaf885d$var$_typeof(actual));
    return msg;
}, TypeError);

$c605503dccaf885d$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($c605503dccaf885d$var$util === undefined) $c605503dccaf885d$var$util = (parcelRequire("5LV4O"));
    var inspected = $c605503dccaf885d$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$c605503dccaf885d$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($c605503dccaf885d$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$c605503dccaf885d$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($c605503dccaf885d$var$assert === undefined) $c605503dccaf885d$var$assert = (parcelRequire("h1RhN"));
    $c605503dccaf885d$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$c605503dccaf885d$export$e45cb6485273080e = $c605503dccaf885d$var$codes;

});

parcelRequire.register("53qBH", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $4ZL0H = parcelRequire("4ZL0H");
"use strict";
function $3ae1df31a1a5d17b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ae1df31a1a5d17b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ae1df31a1a5d17b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3ae1df31a1a5d17b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ae1df31a1a5d17b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3ae1df31a1a5d17b$var$_defineProperty(obj, key, value) {
    key = $3ae1df31a1a5d17b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3ae1df31a1a5d17b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3ae1df31a1a5d17b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3ae1df31a1a5d17b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3ae1df31a1a5d17b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3ae1df31a1a5d17b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3ae1df31a1a5d17b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3ae1df31a1a5d17b$var$_toPropertyKey(arg) {
    var key = $3ae1df31a1a5d17b$var$_toPrimitive(arg, "string");
    return $3ae1df31a1a5d17b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3ae1df31a1a5d17b$var$_toPrimitive(input, hint) {
    if ($3ae1df31a1a5d17b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3ae1df31a1a5d17b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3ae1df31a1a5d17b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3ae1df31a1a5d17b$var$_setPrototypeOf(subClass, superClass);
}
function $3ae1df31a1a5d17b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3ae1df31a1a5d17b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3ae1df31a1a5d17b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3ae1df31a1a5d17b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3ae1df31a1a5d17b$var$_possibleConstructorReturn(this, result);
    };
}
function $3ae1df31a1a5d17b$var$_possibleConstructorReturn(self, call) {
    if (call && ($3ae1df31a1a5d17b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3ae1df31a1a5d17b$var$_assertThisInitialized(self);
}
function $3ae1df31a1a5d17b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3ae1df31a1a5d17b$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3ae1df31a1a5d17b$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3ae1df31a1a5d17b$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3ae1df31a1a5d17b$var$_construct(Class, arguments, $3ae1df31a1a5d17b$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3ae1df31a1a5d17b$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3ae1df31a1a5d17b$var$_wrapNativeSuper(Class);
}
function $3ae1df31a1a5d17b$var$_construct(Parent, args, Class) {
    if ($3ae1df31a1a5d17b$var$_isNativeReflectConstruct()) $3ae1df31a1a5d17b$var$_construct = Reflect.construct.bind();
    else $3ae1df31a1a5d17b$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3ae1df31a1a5d17b$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3ae1df31a1a5d17b$var$_construct.apply(null, arguments);
}
function $3ae1df31a1a5d17b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3ae1df31a1a5d17b$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3ae1df31a1a5d17b$var$_setPrototypeOf(o, p) {
    $3ae1df31a1a5d17b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3ae1df31a1a5d17b$var$_setPrototypeOf(o, p);
}
function $3ae1df31a1a5d17b$var$_getPrototypeOf(o) {
    $3ae1df31a1a5d17b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3ae1df31a1a5d17b$var$_getPrototypeOf(o);
}
function $3ae1df31a1a5d17b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3ae1df31a1a5d17b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3ae1df31a1a5d17b$var$_typeof(o);
}

var $5LV4O = parcelRequire("5LV4O");
var $3ae1df31a1a5d17b$var$inspect = $5LV4O.inspect;

var $h03I0 = parcelRequire("h03I0");
var $3ae1df31a1a5d17b$var$ERR_INVALID_ARG_TYPE = $h03I0.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $3ae1df31a1a5d17b$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $3ae1df31a1a5d17b$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $3ae1df31a1a5d17b$var$blue = "";
var $3ae1df31a1a5d17b$var$green = "";
var $3ae1df31a1a5d17b$var$red = "";
var $3ae1df31a1a5d17b$var$white = "";
var $3ae1df31a1a5d17b$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $3ae1df31a1a5d17b$var$kMaxShortLength = 10;
function $3ae1df31a1a5d17b$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $3ae1df31a1a5d17b$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $3ae1df31a1a5d17b$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $3ae1df31a1a5d17b$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $3ae1df31a1a5d17b$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $3ae1df31a1a5d17b$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $3ae1df31a1a5d17b$var$_typeof(actual) === "object" && $3ae1df31a1a5d17b$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $3ae1df31a1a5d17b$var$kMaxShortLength) {
            if (($3ae1df31a1a5d17b$var$_typeof(actual) !== "object" || actual === null) && ($3ae1df31a1a5d17b$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($3ae1df31a1a5d17b$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $4ZL0H.stderr && $4ZL0H.stderr.isTTY ? $4ZL0H.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($3ae1df31a1a5d17b$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($3ae1df31a1a5d17b$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $3ae1df31a1a5d17b$var$kReadableOperator[operator] + "\n".concat($3ae1df31a1a5d17b$var$green, "+ actual").concat($3ae1df31a1a5d17b$var$white, " ").concat($3ae1df31a1a5d17b$var$red, "- expected").concat($3ae1df31a1a5d17b$var$white);
    var skippedMsg = " ".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($3ae1df31a1a5d17b$var$red, "-").concat($3ae1df31a1a5d17b$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($3ae1df31a1a5d17b$var$green, "+").concat($3ae1df31a1a5d17b$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$3ae1df31a1a5d17b$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $3ae1df31a1a5d17b$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($3ae1df31a1a5d17b$var$green, "+").concat($3ae1df31a1a5d17b$var$white, " ").concat(actualLine);
                other += "\n".concat($3ae1df31a1a5d17b$var$red, "-").concat($3ae1df31a1a5d17b$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white).concat(other, "\n") + "".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $3ae1df31a1a5d17b$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $3ae1df31a1a5d17b$var$_inherits(AssertionError, _Error);
    var _super = $3ae1df31a1a5d17b$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $3ae1df31a1a5d17b$var$_classCallCheck(this, AssertionError);
        if ($3ae1df31a1a5d17b$var$_typeof(options) !== "object" || options === null) throw new $3ae1df31a1a5d17b$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($4ZL0H.stderr && $4ZL0H.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($4ZL0H.stderr && $4ZL0H.stderr.getColorDepth && $4ZL0H.stderr.getColorDepth() !== 1) {
                    $3ae1df31a1a5d17b$var$blue = "\x1b[34m";
                    $3ae1df31a1a5d17b$var$green = "\x1b[32m";
                    $3ae1df31a1a5d17b$var$white = "\x1b[39m";
                    $3ae1df31a1a5d17b$var$red = "\x1b[31m";
                } else {
                    $3ae1df31a1a5d17b$var$blue = "";
                    $3ae1df31a1a5d17b$var$green = "";
                    $3ae1df31a1a5d17b$var$white = "";
                    $3ae1df31a1a5d17b$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($3ae1df31a1a5d17b$var$_typeof(actual) === "object" && actual !== null && $3ae1df31a1a5d17b$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $3ae1df31a1a5d17b$var$copyError(actual);
                expected = $3ae1df31a1a5d17b$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $3ae1df31a1a5d17b$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $3ae1df31a1a5d17b$var$kReadableOperator[operator];
                var res = $3ae1df31a1a5d17b$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $3ae1df31a1a5d17b$var$_typeof(actual) === "object" && actual !== null) base = $3ae1df31a1a5d17b$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($3ae1df31a1a5d17b$var$blue, "...").concat($3ae1df31a1a5d17b$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $3ae1df31a1a5d17b$var$inspectValue(actual);
                var other = "";
                var knownOperators = $3ae1df31a1a5d17b$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($3ae1df31a1a5d17b$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($3ae1df31a1a5d17b$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($3ae1df31a1a5d17b$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($3ae1df31a1a5d17b$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $3ae1df31a1a5d17b$var$_possibleConstructorReturn(_this);
    }
    $3ae1df31a1a5d17b$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $3ae1df31a1a5d17b$var$inspect(this, $3ae1df31a1a5d17b$var$_objectSpread($3ae1df31a1a5d17b$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $3ae1df31a1a5d17b$var$_wrapNativeSuper(Error), $3ae1df31a1a5d17b$var$inspect.custom);
module.exports = $3ae1df31a1a5d17b$var$AssertionError;

});

parcelRequire.register("2utFF", function(module, exports) {
"use strict";

var $gdh7i = parcelRequire("gdh7i");
var $1d056626caae6d10$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $1d056626caae6d10$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $gdh7i;
    if ($1d056626caae6d10$var$lacksProperEnumerationOrder()) return $gdh7i;
    if ($1d056626caae6d10$var$assignHasPendingExceptions()) return $gdh7i;
    return Object.assign;
};

});
parcelRequire.register("gdh7i", function(module, exports) {
"use strict";

var $dHIbP = parcelRequire("dHIbP");

var $bcdb23419e63cbfd$var$hasSymbols = (parcelRequire("f2BFz"))();

var $42mQn = parcelRequire("42mQn");
var $bcdb23419e63cbfd$var$toObject = Object;
var $bcdb23419e63cbfd$var$$push = $42mQn("Array.prototype.push");
var $bcdb23419e63cbfd$var$$propIsEnumerable = $42mQn("Object.prototype.propertyIsEnumerable");
var $bcdb23419e63cbfd$var$originalGetSymbols = $bcdb23419e63cbfd$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $bcdb23419e63cbfd$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $bcdb23419e63cbfd$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $dHIbP(from);
        var getSymbols = $bcdb23419e63cbfd$var$hasSymbols && (Object.getOwnPropertySymbols || $bcdb23419e63cbfd$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($bcdb23419e63cbfd$var$$propIsEnumerable(from, key)) $bcdb23419e63cbfd$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($bcdb23419e63cbfd$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRequire.register("dHIbP", function(module, exports) {
"use strict";
var $9fa191b168d63e16$var$slice = Array.prototype.slice;

var $cCblW = parcelRequire("cCblW");
var $9fa191b168d63e16$var$origKeys = Object.keys;

var $9fa191b168d63e16$var$keysShim = $9fa191b168d63e16$var$origKeys ? function keys(o) {
    return $9fa191b168d63e16$var$origKeys(o);
} : (parcelRequire("97n2C"));
var $9fa191b168d63e16$var$originalKeys = Object.keys;
$9fa191b168d63e16$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($cCblW(object)) return $9fa191b168d63e16$var$originalKeys($9fa191b168d63e16$var$slice.call(object));
            return $9fa191b168d63e16$var$originalKeys(object);
        };
    } else Object.keys = $9fa191b168d63e16$var$keysShim;
    return Object.keys || $9fa191b168d63e16$var$keysShim;
};
module.exports = $9fa191b168d63e16$var$keysShim;

});
parcelRequire.register("cCblW", function(module, exports) {
"use strict";
var $92f1d712df62e495$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $92f1d712df62e495$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $92f1d712df62e495$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("97n2C", function(module, exports) {
"use strict";
var $6a36a405c3374313$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $6a36a405c3374313$var$has = Object.prototype.hasOwnProperty;
    var $6a36a405c3374313$var$toStr = Object.prototype.toString;
    var $6a36a405c3374313$var$isArgs = (parcelRequire("cCblW")); // eslint-disable-line global-require
    var $6a36a405c3374313$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $6a36a405c3374313$var$hasDontEnumBug = !$6a36a405c3374313$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $6a36a405c3374313$var$hasProtoEnumBug = $6a36a405c3374313$var$isEnumerable.call(function() {}, "prototype");
    var $6a36a405c3374313$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $6a36a405c3374313$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $6a36a405c3374313$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $6a36a405c3374313$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$6a36a405c3374313$var$excludedKeys["$" + k] && $6a36a405c3374313$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $6a36a405c3374313$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $6a36a405c3374313$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$6a36a405c3374313$var$hasAutomationEqualityBug) return $6a36a405c3374313$var$equalsConstructorPrototype(o);
        try {
            return $6a36a405c3374313$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $6a36a405c3374313$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $6a36a405c3374313$var$toStr.call(object) === "[object Function]";
        var isArguments = $6a36a405c3374313$var$isArgs(object);
        var isString = isObject && $6a36a405c3374313$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $6a36a405c3374313$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$6a36a405c3374313$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $6a36a405c3374313$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($6a36a405c3374313$var$hasDontEnumBug) {
            var skipConstructor = $6a36a405c3374313$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $6a36a405c3374313$var$dontEnums.length; ++k)if (!(skipConstructor && $6a36a405c3374313$var$dontEnums[k] === "constructor") && $6a36a405c3374313$var$has.call(object, $6a36a405c3374313$var$dontEnums[k])) theKeys.push($6a36a405c3374313$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $6a36a405c3374313$var$keysShim;

});




parcelRequire.register("dKyGU", function(module, exports) {
"use strict";

var $1o6tu = parcelRequire("1o6tu");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $1o6tu;
};

});
parcelRequire.register("1o6tu", function(module, exports) {
"use strict";
var $102d0e106da177b5$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($102d0e106da177b5$var$numberIsNaN(a) && $102d0e106da177b5$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRequire.register("5Ptnz", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $43e88147feffe586$var$_slicedToArray(arr, i) {
    return $43e88147feffe586$var$_arrayWithHoles(arr) || $43e88147feffe586$var$_iterableToArrayLimit(arr, i) || $43e88147feffe586$var$_unsupportedIterableToArray(arr, i) || $43e88147feffe586$var$_nonIterableRest();
}
function $43e88147feffe586$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $43e88147feffe586$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $43e88147feffe586$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $43e88147feffe586$var$_arrayLikeToArray(o, minLen);
}
function $43e88147feffe586$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $43e88147feffe586$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $43e88147feffe586$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $43e88147feffe586$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $43e88147feffe586$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $43e88147feffe586$var$_typeof(o);
}
var $43e88147feffe586$var$regexFlagsSupported = /a/g.flags !== undefined;
var $43e88147feffe586$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $43e88147feffe586$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $43e88147feffe586$var$objectIs = Object.is ? Object.is : (parcelRequire("aYmok"));
var $43e88147feffe586$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $43e88147feffe586$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("gtsSU"));
function $43e88147feffe586$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $43e88147feffe586$var$hasOwnProperty = $43e88147feffe586$var$uncurryThis(Object.prototype.hasOwnProperty);
var $43e88147feffe586$var$propertyIsEnumerable = $43e88147feffe586$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $43e88147feffe586$var$objectToString = $43e88147feffe586$var$uncurryThis(Object.prototype.toString);

var $5LV4O = parcelRequire("5LV4O");
var $43e88147feffe586$require$_require$types = $5LV4O.types;
var $43e88147feffe586$var$isAnyArrayBuffer = $43e88147feffe586$require$_require$types.isAnyArrayBuffer, $43e88147feffe586$var$isArrayBufferView = $43e88147feffe586$require$_require$types.isArrayBufferView, $43e88147feffe586$var$isDate = $43e88147feffe586$require$_require$types.isDate, $43e88147feffe586$var$isMap = $43e88147feffe586$require$_require$types.isMap, $43e88147feffe586$var$isRegExp = $43e88147feffe586$require$_require$types.isRegExp, $43e88147feffe586$var$isSet = $43e88147feffe586$require$_require$types.isSet, $43e88147feffe586$var$isNativeError = $43e88147feffe586$require$_require$types.isNativeError, $43e88147feffe586$var$isBoxedPrimitive = $43e88147feffe586$require$_require$types.isBoxedPrimitive, $43e88147feffe586$var$isNumberObject = $43e88147feffe586$require$_require$types.isNumberObject, $43e88147feffe586$var$isStringObject = $43e88147feffe586$require$_require$types.isStringObject, $43e88147feffe586$var$isBooleanObject = $43e88147feffe586$require$_require$types.isBooleanObject, $43e88147feffe586$var$isBigIntObject = $43e88147feffe586$require$_require$types.isBigIntObject, $43e88147feffe586$var$isSymbolObject = $43e88147feffe586$require$_require$types.isSymbolObject, $43e88147feffe586$var$isFloat32Array = $43e88147feffe586$require$_require$types.isFloat32Array, $43e88147feffe586$var$isFloat64Array = $43e88147feffe586$require$_require$types.isFloat64Array;
function $43e88147feffe586$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $43e88147feffe586$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($43e88147feffe586$var$isNonIndex).concat($43e88147feffe586$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $43e88147feffe586$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $43e88147feffe586$var$ONLY_ENUMERABLE = undefined;
var $43e88147feffe586$var$kStrict = true;
var $43e88147feffe586$var$kLoose = false;
var $43e88147feffe586$var$kNoIterator = 0;
var $43e88147feffe586$var$kIsArray = 1;
var $43e88147feffe586$var$kIsSet = 2;
var $43e88147feffe586$var$kIsMap = 3;
// Check if they have the same source and flags
function $43e88147feffe586$var$areSimilarRegExps(a, b) {
    return $43e88147feffe586$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $43e88147feffe586$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $43e88147feffe586$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $43e88147feffe586$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $43e88147feffe586$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $43e88147feffe586$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $43e88147feffe586$var$isEqualBoxedPrimitive(val1, val2) {
    if ($43e88147feffe586$var$isNumberObject(val1)) return $43e88147feffe586$var$isNumberObject(val2) && $43e88147feffe586$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($43e88147feffe586$var$isStringObject(val1)) return $43e88147feffe586$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($43e88147feffe586$var$isBooleanObject(val1)) return $43e88147feffe586$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($43e88147feffe586$var$isBigIntObject(val1)) return $43e88147feffe586$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $43e88147feffe586$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $43e88147feffe586$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $43e88147feffe586$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($43e88147feffe586$var$_typeof(val1) !== "object") return typeof val1 === "number" && $43e88147feffe586$var$numberIsNaN(val1) && $43e88147feffe586$var$numberIsNaN(val2);
        if ($43e88147feffe586$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $43e88147feffe586$var$_typeof(val1) !== "object") {
            if (val2 === null || $43e88147feffe586$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $43e88147feffe586$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $43e88147feffe586$var$objectToString(val1);
    var val2Tag = $43e88147feffe586$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $43e88147feffe586$var$getOwnNonIndexProperties(val1, $43e88147feffe586$var$ONLY_ENUMERABLE);
        var keys2 = $43e88147feffe586$var$getOwnNonIndexProperties(val2, $43e88147feffe586$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $43e88147feffe586$var$keyCheck(val1, val2, strict, memos, $43e88147feffe586$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$43e88147feffe586$var$isMap(val1) && $43e88147feffe586$var$isMap(val2) || !$43e88147feffe586$var$isSet(val1) && $43e88147feffe586$var$isSet(val2)) return false;
    }
    if ($43e88147feffe586$var$isDate(val1)) {
        if (!$43e88147feffe586$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($43e88147feffe586$var$isRegExp(val1)) {
        if (!$43e88147feffe586$var$isRegExp(val2) || !$43e88147feffe586$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($43e88147feffe586$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($43e88147feffe586$var$isArrayBufferView(val1)) {
        if (!strict && ($43e88147feffe586$var$isFloat32Array(val1) || $43e88147feffe586$var$isFloat64Array(val1))) {
            if (!$43e88147feffe586$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$43e88147feffe586$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $43e88147feffe586$var$getOwnNonIndexProperties(val1, $43e88147feffe586$var$ONLY_ENUMERABLE);
        var _keys2 = $43e88147feffe586$var$getOwnNonIndexProperties(val2, $43e88147feffe586$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $43e88147feffe586$var$keyCheck(val1, val2, strict, memos, $43e88147feffe586$var$kNoIterator, _keys);
    } else if ($43e88147feffe586$var$isSet(val1)) {
        if (!$43e88147feffe586$var$isSet(val2) || val1.size !== val2.size) return false;
        return $43e88147feffe586$var$keyCheck(val1, val2, strict, memos, $43e88147feffe586$var$kIsSet);
    } else if ($43e88147feffe586$var$isMap(val1)) {
        if (!$43e88147feffe586$var$isMap(val2) || val1.size !== val2.size) return false;
        return $43e88147feffe586$var$keyCheck(val1, val2, strict, memos, $43e88147feffe586$var$kIsMap);
    } else if ($43e88147feffe586$var$isAnyArrayBuffer(val1)) {
        if (!$43e88147feffe586$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($43e88147feffe586$var$isBoxedPrimitive(val1) && !$43e88147feffe586$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $43e88147feffe586$var$keyCheck(val1, val2, strict, memos, $43e88147feffe586$var$kNoIterator);
}
function $43e88147feffe586$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $43e88147feffe586$var$propertyIsEnumerable(val, k);
    });
}
function $43e88147feffe586$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$43e88147feffe586$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $43e88147feffe586$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($43e88147feffe586$var$propertyIsEnumerable(val1, key)) {
                    if (!$43e88147feffe586$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($43e88147feffe586$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $43e88147feffe586$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $43e88147feffe586$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $43e88147feffe586$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $43e88147feffe586$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $43e88147feffe586$var$kNoIterator || iterationType === $43e88147feffe586$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $43e88147feffe586$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $43e88147feffe586$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $43e88147feffe586$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($43e88147feffe586$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $43e88147feffe586$var$findLooseMatchingPrimitives(prim) {
    switch($43e88147feffe586$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($43e88147feffe586$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $43e88147feffe586$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $43e88147feffe586$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $43e88147feffe586$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $43e88147feffe586$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$43e88147feffe586$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $43e88147feffe586$var$innerDeepEqual(item, curB, false, memo);
}
function $43e88147feffe586$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $43e88147feffe586$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($43e88147feffe586$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$43e88147feffe586$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $43e88147feffe586$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($43e88147feffe586$var$_typeof(_val) === "object" && _val !== null) {
                if (!$43e88147feffe586$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$43e88147feffe586$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $43e88147feffe586$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $43e88147feffe586$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($43e88147feffe586$var$innerDeepEqual(key1, key2, strict, memo) && $43e88147feffe586$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $43e88147feffe586$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $43e88147feffe586$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $43e88147feffe586$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($43e88147feffe586$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$43e88147feffe586$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$43e88147feffe586$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $43e88147feffe586$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $43e88147feffe586$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($43e88147feffe586$var$_typeof(_key) === "object" && _key !== null) {
                if (!$43e88147feffe586$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$43e88147feffe586$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$43e88147feffe586$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $43e88147feffe586$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $43e88147feffe586$var$kIsSet) {
        if (!$43e88147feffe586$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $43e88147feffe586$var$kIsMap) {
        if (!$43e88147feffe586$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $43e88147feffe586$var$kIsArray) for(; i < a.length; i++){
        if ($43e88147feffe586$var$hasOwnProperty(a, i)) {
            if (!$43e88147feffe586$var$hasOwnProperty(b, i) || !$43e88147feffe586$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($43e88147feffe586$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$43e88147feffe586$var$hasOwnProperty(b, key) || !$43e88147feffe586$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$43e88147feffe586$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $43e88147feffe586$var$isDeepEqual(val1, val2) {
    return $43e88147feffe586$var$innerDeepEqual(val1, val2, $43e88147feffe586$var$kLoose);
}
function $43e88147feffe586$var$isDeepStrictEqual(val1, val2) {
    return $43e88147feffe586$var$innerDeepEqual(val1, val2, $43e88147feffe586$var$kStrict);
}
module.exports = {
    isDeepEqual: $43e88147feffe586$var$isDeepEqual,
    isDeepStrictEqual: $43e88147feffe586$var$isDeepStrictEqual
};

});
parcelRequire.register("aYmok", function(module, exports) {
"use strict";

var $ixqjl = parcelRequire("ixqjl");

var $e6nwk = parcelRequire("e6nwk");

var $1o6tu = parcelRequire("1o6tu");

var $dKyGU = parcelRequire("dKyGU");

var $1JZNL = parcelRequire("1JZNL");
var $7fd0e0710055087a$var$polyfill = $e6nwk($dKyGU(), Object);
$ixqjl($7fd0e0710055087a$var$polyfill, {
    getPolyfill: $dKyGU,
    implementation: $1o6tu,
    shim: $1JZNL
});
module.exports = $7fd0e0710055087a$var$polyfill;

});
parcelRequire.register("ixqjl", function(module, exports) {
"use strict";

var $dHIbP = parcelRequire("dHIbP");
var $d7efb7e4249e63b9$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $d7efb7e4249e63b9$var$toStr = Object.prototype.toString;
var $d7efb7e4249e63b9$var$concat = Array.prototype.concat;
var $d7efb7e4249e63b9$var$origDefineProperty = Object.defineProperty;
var $d7efb7e4249e63b9$var$isFunction = function(fn) {
    return typeof fn === "function" && $d7efb7e4249e63b9$var$toStr.call(fn) === "[object Function]";
};

var $d7efb7e4249e63b9$var$hasPropertyDescriptors = (parcelRequire("iSORN"))();
var $d7efb7e4249e63b9$var$supportsDescriptors = $d7efb7e4249e63b9$var$origDefineProperty && $d7efb7e4249e63b9$var$hasPropertyDescriptors;
var $d7efb7e4249e63b9$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$d7efb7e4249e63b9$var$isFunction(predicate) || !predicate()) return;
    }
    if ($d7efb7e4249e63b9$var$supportsDescriptors) $d7efb7e4249e63b9$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $d7efb7e4249e63b9$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $dHIbP(map);
    if ($d7efb7e4249e63b9$var$hasSymbols) props = $d7efb7e4249e63b9$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$d7efb7e4249e63b9$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$d7efb7e4249e63b9$var$defineProperties.supportsDescriptors = !!$d7efb7e4249e63b9$var$supportsDescriptors;
module.exports = $d7efb7e4249e63b9$var$defineProperties;

});
parcelRequire.register("iSORN", function(module, exports) {
"use strict";

var $hkNzn = parcelRequire("hkNzn");
var $dbf4ba30baa712f1$var$$defineProperty = $hkNzn("%Object.defineProperty%", true);
var $dbf4ba30baa712f1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($dbf4ba30baa712f1$var$$defineProperty) try {
        $dbf4ba30baa712f1$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$dbf4ba30baa712f1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$dbf4ba30baa712f1$var$hasPropertyDescriptors()) return null;
    try {
        return $dbf4ba30baa712f1$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $dbf4ba30baa712f1$var$hasPropertyDescriptors;

});


parcelRequire.register("1JZNL", function(module, exports) {
"use strict";

var $dKyGU = parcelRequire("dKyGU");

var $ixqjl = parcelRequire("ixqjl");
module.exports = function shimObjectIs() {
    var polyfill = $dKyGU();
    $ixqjl(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRequire.register("gtsSU", function(module, exports) {
"use strict";

var $e6nwk = parcelRequire("e6nwk");

var $ixqjl = parcelRequire("ixqjl");

var $dYKac = parcelRequire("dYKac");

var $eo3p3 = parcelRequire("eo3p3");

var $alKxx = parcelRequire("alKxx");
var $bfe5c2aaf702e819$var$polyfill = $e6nwk($eo3p3(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $ixqjl($bfe5c2aaf702e819$var$polyfill, {
    getPolyfill: $eo3p3,
    implementation: $dYKac,
    shim: $alKxx
});
module.exports = $bfe5c2aaf702e819$var$polyfill;

});
parcelRequire.register("dYKac", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRequire.register("eo3p3", function(module, exports) {
"use strict";

var $dYKac = parcelRequire("dYKac");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $dYKac;
};

});

parcelRequire.register("alKxx", function(module, exports) {
"use strict";

var $ixqjl = parcelRequire("ixqjl");

var $eo3p3 = parcelRequire("eo3p3");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $eo3p3();
    $ixqjl(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRequire.register("682k2", function(module, exports) {

$parcel$export(module.exports, "timeUnitToTimeString", function () { return $1d7da799f8c01fa9$export$1432704957c66644; });
$parcel$export(module.exports, "timeStringToMinutes", function () { return $1d7da799f8c01fa9$export$2198ef172edc5f42; });
$parcel$export(module.exports, "formatDate", function () { return $1d7da799f8c01fa9$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "weekDays", function () { return $1d7da799f8c01fa9$export$cdd545160e720df0; });
$parcel$export(module.exports, "timeUnit", function () { return $1d7da799f8c01fa9$export$a37c2d802be87f33; });
function $1d7da799f8c01fa9$export$448fd9115ffd03cd(today) {
    const currentDay = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    // Calculate the start and end dates of the current week
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - currentDay + 1); // Set to Monday of the current week
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + (6 - currentDay) + 1); // Set to Sunday of the current week
    return {
        startDate: startDate,
        endDate: endDate
    };
}
const $1d7da799f8c01fa9$export$1432704957c66644 = (key)=>{
    const times = {
        TRINTA_MINUTOS: "00:30",
        UMA_HORA: "01:00",
        UMA_HORA_TRINTA_MINUTOS: "01:30",
        DUAS_HORA: "02:00"
    };
    return times[key];
};
const $1d7da799f8c01fa9$export$2198ef172edc5f42 = (key)=>{
    const times = {
        "00:30": 30,
        "01:00": 60,
        "01:30": 90,
        "02:00": 120
    };
    return times[key];
};
const $1d7da799f8c01fa9$export$3ae94a2503e890a1 = (date)=>{
    return `${date.format("YYYY-MM-DD HH:mm:ss").split(" ").join("T")}Z`;
};
const $1d7da799f8c01fa9$export$cdd545160e720df0 = [
    "SUNDAY",
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY"
];
const $1d7da799f8c01fa9$export$a37c2d802be87f33 = [
    "TRINTA_MINUTOS",
    "UMA_HORA",
    "UMA_HORA_TRINTA_MINUTOS",
    "DUAS_HORA"
];

});

parcelRequire.register("YuiwO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7f5a95862c2b599$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $4kQoR = parcelRequire("4kQoR");

var $huHez = parcelRequire("huHez");

var $chh5P = parcelRequire("chh5P");
const $a7f5a95862c2b599$var$MUITimePicker = ({ label: label, onChange: onChange, name: name, error: error, value: value, disablePast: disablePast, disableFuture: disableFuture, minTime: minTime, maxTime: maxTime })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $huHez.LocalizationProvider), {
        dateAdapter: (0, $4kQoR.AdapterDayjs),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $chh5P.StyledTimePicker), {
            format: "HH:mm",
            label: label,
            disablePast: disablePast,
            disableFuture: disableFuture,
            ampm: false,
            disableIgnoringDatePartForTimeValidation: true,
            minTime: minTime,
            maxTime: maxTime,
            slotProps: {
                textField: {
                    name: name,
                    error: error
                }
            },
            timeSteps: {
                hours: 1,
                minutes: 15
            },
            value: value,
            onChange: onChange,
            sx: {
                backgroundColor: error ? "#ffebee !important" : "#fff"
            }
        })
    });
};
var $a7f5a95862c2b599$export$2e2bcd8739ae039 = $a7f5a95862c2b599$var$MUITimePicker;

});
parcelRequire.register("chh5P", function(module, exports) {

$parcel$export(module.exports, "StyledTimePicker", function () { return $be7b2ff38bb07ad6$export$3c3e7d5f1b3b9173; });

var $9GzxW = parcelRequire("9GzxW");

var $6hfZk = parcelRequire("6hfZk");
const $be7b2ff38bb07ad6$export$3c3e7d5f1b3b9173 = (0, $6hfZk.default)((0, $9GzxW.TimePicker))(()=>({
        backgroundColor: "#fff",
        border: "transparent",
        borderRadius: "4px",
        boxShadow: "var(--default-boxShadow)"
    }));

});
parcelRequire.register("9GzxW", function(module, exports) {

$parcel$export(module.exports, "TimePicker", function () { return $70d39c1b83e497d8$export$5f876910ea565cd3; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $kspUS = parcelRequire("kspUS");

var $5j2OD = parcelRequire("5j2OD");

var $R3X8R = parcelRequire("R3X8R");

var $klKgp = parcelRequire("klKgp");

var $jpuvJ = parcelRequire("jpuvJ");

var $bbzbN = parcelRequire("bbzbN");
const $70d39c1b83e497d8$var$_excluded = [
    "desktopModeMediaQuery"
];
const $70d39c1b83e497d8$export$5f876910ea565cd3 = /*#__PURE__*/ $7fPBF.forwardRef(function TimePicker(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTimePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $jpuvJ.DEFAULT_DESKTOP_MODE_MEDIA_QUERY) } = props, other = (0, $cFLic.default)(props, $70d39c1b83e497d8$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $kspUS.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $R3X8R.DesktopTimePicker), (0, $kY3Ke.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $klKgp.MobileTimePicker), (0, $kY3Ke.default)({
        ref: ref
    }, other));
});

});
parcelRequire.register("R3X8R", function(module, exports) {

$parcel$export(module.exports, "DesktopTimePicker", function () { return $09f80450e4e8fc9f$export$c2eea9c279c6035b; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $dUIft = parcelRequire("dUIft");

var $blfb5 = parcelRequire("blfb5");

var $7DInd = parcelRequire("7DInd");

var $68sLg = parcelRequire("68sLg");

var $92mGG = parcelRequire("92mGG");

var $gxEUP = parcelRequire("gxEUP");

var $3qBKp = parcelRequire("3qBKp");

var $h6NE5 = parcelRequire("h6NE5");

var $3GboI = parcelRequire("3GboI");

var $boMFm = parcelRequire("boMFm");

var $hEosq = parcelRequire("hEosq");
const $09f80450e4e8fc9f$export$c2eea9c279c6035b = /*#__PURE__*/ $7fPBF.forwardRef(function DesktopTimePicker(inProps, ref) {
    var _defaultizedProps$thr, _defaultizedProps$amp, _viewRenderers$hours, _defaultizedProps$slo2, _defaultizedProps$slo3, _props$localeText$ope, _props$localeText;
    const localeText = (0, $92mGG.useLocaleText)();
    const utils = (0, $92mGG.useUtils)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $68sLg.useTimePickerDefaultizedProps)(inProps, "MuiDesktopTimePicker");
    const thresholdToRenderTimeInASingleColumn = (_defaultizedProps$thr = defaultizedProps.thresholdToRenderTimeInASingleColumn) != null ? _defaultizedProps$thr : 24;
    const timeSteps = (0, $kY3Ke.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, defaultizedProps.timeSteps);
    const shouldRenderTimeInASingleColumn = 1440 / (timeSteps.hours * timeSteps.minutes) <= thresholdToRenderTimeInASingleColumn;
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $boMFm.renderDigitalClockTimeView) : (0, $boMFm.renderMultiSectionDigitalClockTimeView);
    const viewRenderers = (0, $kY3Ke.default)({
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : true;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        "accept"
    ];
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = ((_viewRenderers$hours = viewRenderers.hours) == null ? void 0 : _viewRenderers$hours.name) === (0, $boMFm.renderMultiSectionDigitalClockTimeView).name;
    const views = defaultizedProps.ampm && shouldHoursRendererContainMeridiemView ? [
        ...defaultizedProps.views,
        "meridiem"
    ] : defaultizedProps.views;
    // Props with the default values specific to the desktop variant
    const props = (0, $kY3Ke.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        viewRenderers: viewRenderers,
        format: (0, $hEosq.resolveTimeFormat)(utils, defaultizedProps),
        // Setting only `hours` time view in case of single column time picker
        // Allows for easy view lifecycle management
        views: shouldRenderTimeInASingleColumn ? [
            "hours"
        ] : views,
        slots: (0, $kY3Ke.default)({
            field: (0, $7DInd.TimeField),
            openPickerIcon: (0, $3qBKp.ClockIcon)
        }, defaultizedProps.slots),
        slotProps: (0, $kY3Ke.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $kY3Ke.default)({}, (0, $dUIft.resolveComponentProps)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $3GboI.extractValidationProps)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $kY3Ke.default)({
                hidden: true,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar),
            actionBar: (0, $kY3Ke.default)({
                actions: actionBarActions
            }, (_defaultizedProps$slo3 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo3.actionBar)
        })
    });
    const { renderPicker: renderPicker } = (0, $h6NE5.useDesktopPicker)({
        props: props,
        valueManager: (0, $blfb5.singleItemValueManager),
        valueType: "time",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openTimePickerDialogue) != null ? _props$localeText$ope : localeText.openTimePickerDialogue,
        validator: (0, $gxEUP.validateTime)
    });
    return renderPicker();
});
$09f80450e4e8fc9f$export$c2eea9c279c6035b.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
        })
    ]),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "hours",
        "meridiem",
        "minutes",
        "seconds"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "hours",
        "meridiem",
        "minutes",
        "seconds"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]).isRequired)
};

});
parcelRequire.register("7DInd", function(module, exports) {

$parcel$export(module.exports, "TimeField", function () { return $58fe9893207f11ce$export$5eaee2322dd727eb; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $f6ezL = parcelRequire("f6ezL");

var $5j2OD = parcelRequire("5j2OD");

var $94ctx = parcelRequire("94ctx");

var $l4Unb = parcelRequire("l4Unb");

var $bbzbN = parcelRequire("bbzbN");
const $58fe9893207f11ce$var$_excluded = [
    "slots",
    "slotProps",
    "components",
    "componentsProps",
    "InputProps",
    "inputProps"
], $58fe9893207f11ce$var$_excluded2 = [
    "inputRef"
], $58fe9893207f11ce$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly"
];
const $58fe9893207f11ce$export$5eaee2322dd727eb = /*#__PURE__*/ $7fPBF.forwardRef(function TimeField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTimeField"
    });
    const { slots: slots, slotProps: slotProps, components: components, componentsProps: componentsProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $cFLic.default)(themeProps, $58fe9893207f11ce$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $f6ezL.default);
    const _useSlotProps = (0, $94ctx.useSlotProps)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $cFLic.default)(_useSlotProps, $58fe9893207f11ce$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $kY3Ke.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $kY3Ke.default)({}, InputProps, textFieldProps.InputProps);
    const _useTimeField = (0, $l4Unb.useTimeField)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly } = _useTimeField, fieldProps = (0, $cFLic.default)(_useTimeField, $58fe9893207f11ce$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TextField, (0, $kY3Ke.default)({
        ref: ref
    }, fieldProps, {
        InputProps: (0, $kY3Ke.default)({}, fieldProps.InputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $kY3Ke.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});

});
parcelRequire.register("l4Unb", function(module, exports) {

$parcel$export(module.exports, "useTimeField", function () { return $f585b33312ecae0b$export$4c842f6a241dc825; });

var $kY3Ke = parcelRequire("kY3Ke");

var $blfb5 = parcelRequire("blfb5");

var $3BLrA = parcelRequire("3BLrA");

var $gxEUP = parcelRequire("gxEUP");

var $92mGG = parcelRequire("92mGG");

var $gMdDk = parcelRequire("gMdDk");
const $f585b33312ecae0b$var$useDefaultizedTimeField = (props)=>{
    var _props$ampm, _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $92mGG.useUtils)();
    const ampm = (_props$ampm = props.ampm) != null ? _props$ampm : utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $kY3Ke.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : defaultFormat
    });
};
const $f585b33312ecae0b$export$4c842f6a241dc825 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $f585b33312ecae0b$var$useDefaultizedTimeField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $gMdDk.splitFieldInternalAndForwardedProps)(props, "time");
    return (0, $3BLrA.useField)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $blfb5.singleItemValueManager),
        fieldValueManager: (0, $blfb5.singleItemFieldValueManager),
        validator: (0, $gxEUP.validateTime),
        valueType: "time"
    });
};

});
parcelRequire.register("gxEUP", function(module, exports) {

$parcel$export(module.exports, "validateTime", function () { return $c0af7769d9ded00b$export$7bd013ac69eb590c; });

var $hEosq = parcelRequire("hEosq");
const $c0af7769d9ded00b$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const isAfter = (0, $hEosq.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(minTime && isAfter(minTime, value)):
            return "minTime";
        case Boolean(maxTime && isAfter(value, maxTime)):
            return "maxTime";
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return "disablePast";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "hours")):
            return "shouldDisableTime-hours";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "minutes")):
            return "shouldDisableTime-minutes";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "seconds")):
            return "shouldDisableTime-seconds";
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getHours(value), "hours")):
            return "shouldDisableClock-hours";
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getMinutes(value), "minutes")):
            return "shouldDisableClock-minutes";
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getSeconds(value), "seconds")):
            return "shouldDisableClock-seconds";
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return "minutesStep";
        default:
            return null;
    }
};

});



parcelRequire.register("68sLg", function(module, exports) {

$parcel$export(module.exports, "useTimePickerDefaultizedProps", function () { return $01272034ffec51f8$export$586c31b46cc238ba; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $5j2OD = parcelRequire("5j2OD");

var $92mGG = parcelRequire("92mGG");

var $jmGr5 = parcelRequire("jmGr5");

var $jWPa9 = parcelRequire("jWPa9");

var $fFgj2 = parcelRequire("fFgj2");
function $01272034ffec51f8$export$586c31b46cc238ba(props, name) {
    var _themeProps$ampm, _themeProps$slots, _themeProps$slotProps, _themeProps$disableFu, _themeProps$disablePa;
    const utils = (0, $92mGG.useUtils)();
    const themeProps = (0, $5j2OD.default)({
        props: props,
        name: name
    });
    const ampm = (_themeProps$ampm = themeProps.ampm) != null ? _themeProps$ampm : utils.is12HourCycleInCurrentLocale();
    const localeText = $7fPBF.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $kY3Ke.default)({}, themeProps.localeText, {
            timePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $fFgj2.uncapitalizeObjectKeys)(themeProps.components);
    const slotProps = (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps;
    return (0, $kY3Ke.default)({}, themeProps, {
        ampm: ampm,
        localeText: localeText
    }, (0, $jWPa9.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "hours",
            "minutes"
        ],
        defaultOpenTo: "hours"
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        slots: (0, $kY3Ke.default)({
            toolbar: (0, $jmGr5.TimePickerToolbar)
        }, slots),
        slotProps: (0, $kY3Ke.default)({}, slotProps, {
            toolbar: (0, $kY3Ke.default)({
                ampm: ampm,
                ampmInClock: themeProps.ampmInClock
            }, slotProps == null ? void 0 : slotProps.toolbar)
        })
    });
}

});
parcelRequire.register("jmGr5", function(module, exports) {

$parcel$export(module.exports, "TimePickerToolbar", function () { return $e190fd4b518d296a$export$76f7aa019fd43cd9; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $kDBhE = parcelRequire("kDBhE");
var $g9bTP = parcelRequire("g9bTP");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $2ecV5 = parcelRequire("2ecV5");

var $jOLXk = parcelRequire("jOLXk");

var $l7Pjh = parcelRequire("l7Pjh");

var $jpuvJ = parcelRequire("jpuvJ");

var $92mGG = parcelRequire("92mGG");

var $81Pww = parcelRequire("81Pww");

var $iZYo4 = parcelRequire("iZYo4");

var $6CwGv = parcelRequire("6CwGv");

var $bbzbN = parcelRequire("bbzbN");
const $e190fd4b518d296a$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "isLandscape",
    "onChange",
    "view",
    "onViewChange",
    "views",
    "disabled",
    "readOnly"
];
const $e190fd4b518d296a$var$useUtilityClasses = (ownerState)=>{
    const { theme: theme, isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        separator: [
            "separator"
        ],
        hourMinuteLabel: [
            "hourMinuteLabel",
            isLandscape && "hourMinuteLabelLandscape",
            theme.direction === "rtl" && "hourMinuteLabelReverse"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $iZYo4.getTimePickerToolbarUtilityClass), classes);
};
const $e190fd4b518d296a$var$TimePickerToolbarRoot = (0, $kDBhE.default)((0, $l7Pjh.PickersToolbar), {
    name: "MuiTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $e190fd4b518d296a$var$TimePickerToolbarSeparator = (0, $kDBhE.default)((0, $2ecV5.PickersToolbarText), {
    name: "MuiTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    outline: 0,
    margin: "0 4px 0 2px",
    cursor: "default"
});
const $e190fd4b518d296a$var$TimePickerToolbarHourMinuteLabel = (0, $kDBhE.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "HourMinuteLabel",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $iZYo4.timePickerToolbarClasses).hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${(0, $iZYo4.timePickerToolbarClasses).hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end"
    }, ownerState.isLandscape && {
        marginTop: "auto"
    }, theme.direction === "rtl" && {
        flexDirection: "row-reverse"
    }));
$e190fd4b518d296a$var$TimePickerToolbarHourMinuteLabel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ])
};
const $e190fd4b518d296a$var$TimePickerToolbarAmPmSelection = (0, $kDBhE.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $iZYo4.timePickerToolbarClasses).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $iZYo4.timePickerToolbarClasses).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column",
        marginRight: "auto",
        marginLeft: 12
    }, ownerState.isLandscape && {
        margin: "4px 0 auto",
        flexDirection: "row",
        justifyContent: "space-around",
        flexBasis: "100%"
    }, {
        [`& .${(0, $iZYo4.timePickerToolbarClasses).ampmLabel}`]: {
            fontSize: 17
        }
    }));
$e190fd4b518d296a$var$TimePickerToolbarAmPmSelection.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ])
};
function $e190fd4b518d296a$export$76f7aa019fd43cd9(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, isLandscape: isLandscape, onChange: onChange, view: view, onViewChange: onViewChange, views: views, disabled: disabled, readOnly: readOnly } = props, other = (0, $cFLic.default)(props, $e190fd4b518d296a$var$_excluded);
    const utils = (0, $92mGG.useUtils)();
    const localeText = (0, $92mGG.useLocaleText)();
    const theme = (0, $g9bTP.default)();
    const showAmPmControl = Boolean(ampm && !ampmInClock && views.includes("hours"));
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $81Pww.useMeridiemMode)(value, ampm, onChange);
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const ownerState = props;
    const classes = $e190fd4b518d296a$var$useUtilityClasses((0, $kY3Ke.default)({}, ownerState, {
        theme: theme
    }));
    const separator = /*#__PURE__*/ (0, $bbzbN.jsx)($e190fd4b518d296a$var$TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($e190fd4b518d296a$var$TimePickerToolbarRoot, (0, $kY3Ke.default)({
        landscapeDirection: "row",
        toolbarTitle: localeText.timePickerToolbarTitle,
        isLandscape: isLandscape,
        ownerState: ownerState,
        className: classes.root
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($e190fd4b518d296a$var$TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, $jpuvJ.arrayIncludes)(views, "hours") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jOLXk.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange("hours"),
                        selected: view === "hours",
                        value: value ? formatHours(value) : "--"
                    }),
                    (0, $jpuvJ.arrayIncludes)(views, [
                        "hours",
                        "minutes"
                    ]) && separator,
                    (0, $jpuvJ.arrayIncludes)(views, "minutes") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jOLXk.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange("minutes"),
                        selected: view === "minutes",
                        value: value ? utils.format(value, "minutes") : "--"
                    }),
                    (0, $jpuvJ.arrayIncludes)(views, [
                        "minutes",
                        "seconds"
                    ]) && separator,
                    (0, $jpuvJ.arrayIncludes)(views, "seconds") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jOLXk.PickersToolbarButton), {
                        variant: "h3",
                        onClick: ()=>onViewChange("seconds"),
                        selected: view === "seconds",
                        value: value ? utils.format(value, "seconds") : "--"
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, $bbzbN.jsxs)($e190fd4b518d296a$var$TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jOLXk.PickersToolbarButton), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "am",
                        typographyClassName: classes.ampmLabel,
                        value: (0, $6CwGv.formatMeridiem)(utils, "am"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jOLXk.PickersToolbarButton), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "pm",
                        typographyClassName: classes.ampmLabel,
                        value: (0, $6CwGv.formatMeridiem)(utils, "pm"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}

});
parcelRequire.register("2ecV5", function(module, exports) {

$parcel$export(module.exports, "PickersToolbarText", function () { return $19f6e92b6ca67410$export$2006bc630443fa2; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $jJ577 = parcelRequire("jJ577");

var $bbzbN = parcelRequire("bbzbN");
const $19f6e92b6ca67410$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $19f6e92b6ca67410$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $jJ577.getPickersToolbarTextUtilityClass), classes);
};
const $19f6e92b6ca67410$var$PickersToolbarTextRoot = (0, $kDBhE.default)((0, $3loMv.default), {
    name: "MuiPickersToolbarText",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $jJ577.pickersToolbarTextClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create("color"),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $jJ577.pickersToolbarTextClasses).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $19f6e92b6ca67410$export$2006bc630443fa2 = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersToolbarText"
    });
    const { className: className, value: value } = props, other = (0, $cFLic.default)(props, $19f6e92b6ca67410$var$_excluded);
    const classes = $19f6e92b6ca67410$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($19f6e92b6ca67410$var$PickersToolbarTextRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $hngXp.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});

});
parcelRequire.register("jJ577", function(module, exports) {

$parcel$export(module.exports, "getPickersToolbarTextUtilityClass", function () { return $e5c62fc38704a318$export$2aab7addfa1bc589; });
$parcel$export(module.exports, "pickersToolbarTextClasses", function () { return $e5c62fc38704a318$export$4ca7b92014bf2e56; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $e5c62fc38704a318$export$2aab7addfa1bc589(slot) {
    return (0, $k6RDS.default)("MuiPickersToolbarText", slot);
}
const $e5c62fc38704a318$export$4ca7b92014bf2e56 = (0, $4jzsB.default)("MuiPickersToolbarText", [
    "root",
    "selected"
]);

});


parcelRequire.register("jOLXk", function(module, exports) {

$parcel$export(module.exports, "PickersToolbarButton", function () { return $e6d7e2dccb3a29fb$export$614ed940168c780c; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $5ZeKC = parcelRequire("5ZeKC");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $2ecV5 = parcelRequire("2ecV5");

var $lhd3F = parcelRequire("lhd3F");

var $bbzbN = parcelRequire("bbzbN");
const $e6d7e2dccb3a29fb$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $e6d7e2dccb3a29fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $lhd3F.getPickersToolbarUtilityClass), classes);
};
const $e6d7e2dccb3a29fb$var$PickersToolbarButtonRoot = (0, $kDBhE.default)((0, $5ZeKC.default), {
    name: "MuiPickersToolbarButton",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: "none"
});
const $e6d7e2dccb3a29fb$export$614ed940168c780c = /*#__PURE__*/ $7fPBF.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiPickersToolbarButton"
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $cFLic.default)(props, $e6d7e2dccb3a29fb$var$_excluded);
    const classes = $e6d7e2dccb3a29fb$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($e6d7e2dccb3a29fb$var$PickersToolbarButtonRoot, (0, $kY3Ke.default)({
        variant: "text",
        ref: ref,
        className: (0, $hngXp.default)(className, classes.root)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ecV5.PickersToolbarText), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

});

parcelRequire.register("iZYo4", function(module, exports) {

$parcel$export(module.exports, "getTimePickerToolbarUtilityClass", function () { return $dd4cc4205fad9d9c$export$56e751cdf7deddcb; });
$parcel$export(module.exports, "timePickerToolbarClasses", function () { return $dd4cc4205fad9d9c$export$b6febfcac6caa550; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $dd4cc4205fad9d9c$export$56e751cdf7deddcb(slot) {
    return (0, $k6RDS.default)("MuiTimePickerToolbar", slot);
}
const $dd4cc4205fad9d9c$export$b6febfcac6caa550 = (0, $4jzsB.default)("MuiTimePickerToolbar", [
    "root",
    "separator",
    "hourMinuteLabel",
    "hourMinuteLabelLandscape",
    "hourMinuteLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);

});



parcelRequire.register("boMFm", function(module, exports) {

$parcel$export(module.exports, "renderTimeViewClock", function () { return $84c7afb04abd5f2a$export$a3ad21a1b07c504f; });
$parcel$export(module.exports, "renderDigitalClockTimeView", function () { return $84c7afb04abd5f2a$export$a2917c76dc0aa7e; });
$parcel$export(module.exports, "renderMultiSectionDigitalClockTimeView", function () { return $84c7afb04abd5f2a$export$48a290886291c531; });
parcelRequire("7fPBF");

var $uJQ82 = parcelRequire("uJQ82");

var $5u2YG = parcelRequire("5u2YG");

var $6fl9w = parcelRequire("6fl9w");

var $hEosq = parcelRequire("hEosq");

var $bbzbN = parcelRequire("bbzbN");
const $84c7afb04abd5f2a$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $uJQ82.TimeClock), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $hEosq.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $hEosq.isTimeView)),
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $84c7afb04abd5f2a$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $5u2YG.DigitalClock), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $hEosq.isTimeView)),
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps == null ? void 0 : timeSteps.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $84c7afb04abd5f2a$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $6fl9w.MultiSectionDigitalClock), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $hEosq.isTimeView)),
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });

});
parcelRequire.register("uJQ82", function(module, exports) {

$parcel$export(module.exports, "TimeClock", function () { return $05c65c487d96f335$export$7e96244e18c4be57; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");


var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $65Itt = parcelRequire("65Itt");

var $92mGG = parcelRequire("92mGG");

var $k7WO5 = parcelRequire("k7WO5");

var $hEosq = parcelRequire("hEosq");

var $7vFJ6 = parcelRequire("7vFJ6");

var $81Pww = parcelRequire("81Pww");

var $5VM6C = parcelRequire("5VM6C");

var $dEKju = parcelRequire("dEKju");

var $cURaI = parcelRequire("cURaI");

var $4x4pS = parcelRequire("4x4pS");

var $dZX2W = parcelRequire("dZX2W");

var $blfb5 = parcelRequire("blfb5");

var $fFgj2 = parcelRequire("fFgj2");

var $7trs4 = parcelRequire("7trs4");

var $bbzbN = parcelRequire("bbzbN");
const $05c65c487d96f335$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $05c65c487d96f335$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $dEKju.getTimeClockUtilityClass), classes);
};
const $05c65c487d96f335$var$TimeClockRoot = (0, $kDBhE.default)((0, $5VM6C.PickerViewRoot), {
    name: "MuiTimeClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    position: "relative"
});
const $05c65c487d96f335$var$TimeClockArrowSwitcher = (0, $kDBhE.default)((0, $k7WO5.PickersArrowSwitcher), {
    name: "MuiTimeClock",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const $05c65c487d96f335$var$TIME_CLOCK_DEFAULT_VIEWS = [
    "hours",
    "minutes"
];
const $05c65c487d96f335$export$7e96244e18c4be57 = /*#__PURE__*/ $7fPBF.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $92mGG.useUtils)();
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTimeClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $05c65c487d96f335$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $cFLic.default)(props, $05c65c487d96f335$var$_excluded);
    const slots = innerSlots != null ? innerSlots : (0, $fFgj2.uncapitalizeObjectKeys)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $dZX2W.useControlledValueWithTimezone)({
        name: "TimeClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $blfb5.singleItemValueManager)
    });
    const valueOrReferenceDate = (0, $7trs4.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const localeText = (0, $92mGG.useLocaleText)();
    const now = (0, $92mGG.useNow)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $7vFJ6.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $81Pww.useMeridiemMode)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $7fPBF.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $hEosq.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $hEosq.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $65Itt.default)();
    const viewProps = $7fPBF.useMemo(()=>{
        switch(view){
            case "hours":
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $hEosq.convertValueToMeridiem)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $4x4pS.getHourNumbers)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, "hours"),
                            selectedId: selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish);
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $4x4pS.getMinutesNumbers)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, "minutes"),
                            selectedId: selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish);
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $4x4pS.getMinutesNumbers)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, "seconds"),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $05c65c487d96f335$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($05c65c487d96f335$var$TimeClockRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cURaI.Clock), (0, $kY3Ke.default)({
                autoFocus: autoFocus != null ? autoFocus : !!focusedView,
                ampmInClock: ampmInClock && views.includes("hours"),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $bbzbN.jsx)($05c65c487d96f335$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});

});
parcelRequire.register("dEKju", function(module, exports) {

$parcel$export(module.exports, "getTimeClockUtilityClass", function () { return $9f12efabb8f76db3$export$148b188041a720e4; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $9f12efabb8f76db3$export$148b188041a720e4(slot) {
    return (0, $k6RDS.default)("MuiTimeClock", slot);
}
const $9f12efabb8f76db3$export$191dec874db3257b = (0, $4jzsB.default)("MuiTimeClock", [
    "root",
    "arrowSwitcher"
]);

});

parcelRequire.register("cURaI", function(module, exports) {

$parcel$export(module.exports, "Clock", function () { return $9673f5cf42a73bc6$export$9735c82c4bae3302; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $8TDId = parcelRequire("8TDId");

var $3loMv = parcelRequire("3loMv");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");
var $lJRRs = parcelRequire("lJRRs");

var $6uA3Y = parcelRequire("6uA3Y");

var $92mGG = parcelRequire("92mGG");

var $9kTPm = parcelRequire("9kTPm");

var $857Wv = parcelRequire("857Wv");

var $bbzbN = parcelRequire("bbzbN");
const $9673f5cf42a73bc6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton"
        ],
        pmButton: [
            "pmButton"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $857Wv.getClockUtilityClass), classes);
};
const $9673f5cf42a73bc6$var$ClockRoot = (0, $kDBhE.default)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const $9673f5cf42a73bc6$var$ClockClock = (0, $kDBhE.default)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const $9673f5cf42a73bc6$var$ClockWrapper = (0, $kDBhE.default)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const $9673f5cf42a73bc6$var$ClockSquareMask = (0, $kDBhE.default)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: "100%",
        height: "100%",
        position: "absolute",
        pointerEvents: "auto",
        outline: 0,
        // Disable scroll capabilities.
        touchAction: "none",
        userSelect: "none"
    }, ownerState.disabled ? {} : {
        "@media (pointer: fine)": {
            cursor: "pointer",
            borderRadius: "50%"
        },
        "&:active": {
            cursor: "move"
        }
    }));
const $9673f5cf42a73bc6$var$ClockPin = (0, $kDBhE.default)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const $9673f5cf42a73bc6$var$ClockAmButton = (0, $kDBhE.default)((0, $8TDId.default), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        zIndex: 1,
        position: "absolute",
        bottom: 8,
        left: 8
    }, ownerState.meridiemMode === "am" && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $9673f5cf42a73bc6$var$ClockPmButton = (0, $kDBhE.default)((0, $8TDId.default), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        zIndex: 1,
        position: "absolute",
        bottom: 8,
        right: 8
    }, ownerState.meridiemMode === "pm" && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
function $9673f5cf42a73bc6$export$9735c82c4bae3302(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $92mGG.useUtils)();
    const localeText = (0, $92mGG.useLocaleText)();
    const isMoving = $7fPBF.useRef(false);
    const classes = $9673f5cf42a73bc6$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === "hours" && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, $9kTPm.getMinutes)(offsetX, offsetY, minutesStep) : (0, $9kTPm.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = $7fPBF.useMemo(()=>{
        if (type === "hours") return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = $7fPBF.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $lJRRs.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // annulate both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(viewValue + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(viewValue - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($9673f5cf42a73bc6$var$ClockRoot, {
        className: (0, $hngXp.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($9673f5cf42a73bc6$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($9673f5cf42a73bc6$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)($9673f5cf42a73bc6$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6uA3Y.ClockPointer), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($9673f5cf42a73bc6$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($9673f5cf42a73bc6$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "caption",
                            children: "AM"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($9673f5cf42a73bc6$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "caption",
                            children: "PM"
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRequire.register("6uA3Y", function(module, exports) {

$parcel$export(module.exports, "ClockPointer", function () { return $4ba184cba211a500$export$f257f213e6c08f97; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $9kTPm = parcelRequire("9kTPm");

var $6hj5E = parcelRequire("6hj5E");

var $bbzbN = parcelRequire("bbzbN");
const $4ba184cba211a500$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $4ba184cba211a500$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6hj5E.getClockPointerUtilityClass), classes);
};
const $4ba184cba211a500$var$ClockPointerRoot = (0, $kDBhE.default)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px"
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            "transform",
            "height"
        ])
    }));
const $4ba184cba211a500$var$ClockPointerThumb = (0, $kDBhE.default)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, $9kTPm.CLOCK_HOUR_WIDTH) / 2}px)`,
        border: `${((0, $9kTPm.CLOCK_HOUR_WIDTH) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: "content-box"
    }, ownerState.hasSelected && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }));
function $4ba184cba211a500$export$f257f213e6c08f97(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $cFLic.default)(props, $4ba184cba211a500$var$_excluded);
    const previousType = $7fPBF.useRef(type);
    $7fPBF.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $4ba184cba211a500$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === "hours" && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $9kTPm.CLOCK_WIDTH)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($4ba184cba211a500$var$ClockPointerRoot, (0, $kY3Ke.default)({
        style: getAngleStyle(),
        className: (0, $hngXp.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($4ba184cba211a500$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

});
parcelRequire.register("9kTPm", function(module, exports) {

$parcel$export(module.exports, "CLOCK_WIDTH", function () { return $6cc14976b5690ded$export$8c8ec20d3854d7e6; });
$parcel$export(module.exports, "CLOCK_HOUR_WIDTH", function () { return $6cc14976b5690ded$export$729c0e543e4dc21d; });
$parcel$export(module.exports, "getMinutes", function () { return $6cc14976b5690ded$export$b7f1bc3ea3ac4145; });
$parcel$export(module.exports, "getHours", function () { return $6cc14976b5690ded$export$257b40f71c07d58f; });
const $6cc14976b5690ded$export$8c8ec20d3854d7e6 = 220;
const $6cc14976b5690ded$export$729c0e543e4dc21d = 36;
const $6cc14976b5690ded$var$clockCenter = {
    x: $6cc14976b5690ded$export$8c8ec20d3854d7e6 / 2,
    y: $6cc14976b5690ded$export$8c8ec20d3854d7e6 / 2
};
const $6cc14976b5690ded$var$baseClockPoint = {
    x: $6cc14976b5690ded$var$clockCenter.x,
    y: 0
};
const $6cc14976b5690ded$var$cx = $6cc14976b5690ded$var$baseClockPoint.x - $6cc14976b5690ded$var$clockCenter.x;
const $6cc14976b5690ded$var$cy = $6cc14976b5690ded$var$baseClockPoint.y - $6cc14976b5690ded$var$clockCenter.y;
const $6cc14976b5690ded$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $6cc14976b5690ded$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $6cc14976b5690ded$var$clockCenter.x;
    const y = offsetY - $6cc14976b5690ded$var$clockCenter.y;
    const atan = Math.atan2($6cc14976b5690ded$var$cx, $6cc14976b5690ded$var$cy) - Math.atan2(x, y);
    let deg = $6cc14976b5690ded$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $6cc14976b5690ded$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $6cc14976b5690ded$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $6cc14976b5690ded$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $6cc14976b5690ded$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $6cc14976b5690ded$export$8c8ec20d3854d7e6 / 2 - $6cc14976b5690ded$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};

});

parcelRequire.register("6hj5E", function(module, exports) {

$parcel$export(module.exports, "getClockPointerUtilityClass", function () { return $49232388e6f00fc6$export$12faa62796978e2f; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $49232388e6f00fc6$export$12faa62796978e2f(slot) {
    return (0, $k6RDS.default)("MuiClockPointer", slot);
}
const $49232388e6f00fc6$export$64afeec9352615cb = (0, $4jzsB.default)("MuiClockPointer", [
    "root",
    "thumb"
]);

});


parcelRequire.register("857Wv", function(module, exports) {

$parcel$export(module.exports, "getClockUtilityClass", function () { return $5e24f396aae514cd$export$e44ecab24167799b; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $5e24f396aae514cd$export$e44ecab24167799b(slot) {
    return (0, $k6RDS.default)("MuiClock", slot);
}
const $5e24f396aae514cd$export$4626e3a61e161c64 = (0, $4jzsB.default)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton"
]);

});


parcelRequire.register("4x4pS", function(module, exports) {

$parcel$export(module.exports, "getHourNumbers", function () { return $34cdab7e580a7b08$export$10850582eda9a8c7; });
$parcel$export(module.exports, "getMinutesNumbers", function () { return $34cdab7e580a7b08$export$2c440057d7a731e4; });
parcelRequire("7fPBF");

var $dt2Sw = parcelRequire("dt2Sw");

var $bbzbN = parcelRequire("bbzbN");
const $34cdab7e580a7b08$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $bbzbN.jsx)((0, $dt2Sw.ClockNumber), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $34cdab7e580a7b08$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dt2Sw.ClockNumber), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};

});
parcelRequire.register("dt2Sw", function(module, exports) {

$parcel$export(module.exports, "ClockNumber", function () { return $9ce037615460d2ce$export$6d5c4c748c9cc92c; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $9kTPm = parcelRequire("9kTPm");

var $21a8x = parcelRequire("21a8x");

var $bbzbN = parcelRequire("bbzbN");
const $9ce037615460d2ce$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $9ce037615460d2ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $21a8x.getClockNumberUtilityClass), classes);
};
const $9ce037615460d2ce$var$ClockNumberRoot = (0, $kDBhE.default)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $21a8x.clockNumberClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $21a8x.clockNumberClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: (0, $9kTPm.CLOCK_HOUR_WIDTH),
        width: (0, $9kTPm.CLOCK_HOUR_WIDTH),
        position: "absolute",
        left: `calc((100% - ${(0, $9kTPm.CLOCK_HOUR_WIDTH)}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $21a8x.clockNumberClasses).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $21a8x.clockNumberClasses).disabled}`]: {
            pointerEvents: "none",
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.inner && (0, $kY3Ke.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary
    })));
function $9ce037615460d2ce$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $cFLic.default)(props, $9ce037615460d2ce$var$_excluded);
    const ownerState = props;
    const classes = $9ce037615460d2ce$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $9kTPm.CLOCK_WIDTH) - (0, $9kTPm.CLOCK_HOUR_WIDTH) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($9ce037615460d2ce$var$ClockNumberRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $9kTPm.CLOCK_WIDTH) - (0, $9kTPm.CLOCK_HOUR_WIDTH)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

});
parcelRequire.register("21a8x", function(module, exports) {

$parcel$export(module.exports, "getClockNumberUtilityClass", function () { return $178389b6b094ca35$export$527226d166658911; });
$parcel$export(module.exports, "clockNumberClasses", function () { return $178389b6b094ca35$export$c8efb3a779c9844a; });

var $k6RDS = parcelRequire("k6RDS");
var $4jzsB = parcelRequire("4jzsB");
function $178389b6b094ca35$export$527226d166658911(slot) {
    return (0, $k6RDS.default)("MuiClockNumber", slot);
}
const $178389b6b094ca35$export$c8efb3a779c9844a = (0, $4jzsB.default)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);

});



parcelRequire.register("7trs4", function(module, exports) {

$parcel$export(module.exports, "useClockReferenceDate", function () { return $5710892b9bfbdb2e$export$86ee3b7a301faaa3; });

var $7fPBF = parcelRequire("7fPBF");

var $blfb5 = parcelRequire("blfb5");

var $6CwGv = parcelRequire("6CwGv");

var $kh1ja = parcelRequire("kh1ja");
const $5710892b9bfbdb2e$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $7fPBF.useMemo(()=>(0, $blfb5.singleItemValueManager).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $kh1ja.SECTION_TYPE_GRANULARITY).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $6CwGv.getTodayDate)(utils, timezone, "date")
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value != null ? value : referenceDate;
};

});


parcelRequire.register("5u2YG", function(module, exports) {

$parcel$export(module.exports, "DigitalClock", function () { return $3fe210705d1a4e6f$export$9a2b219a5b06deb7; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");


var $94ctx = parcelRequire("94ctx");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $giDhD = parcelRequire("giDhD");

var $cFCqu = parcelRequire("cFCqu");

var $58CWL = parcelRequire("58CWL");

var $dseJp = parcelRequire("dseJp");

var $jTdAm = parcelRequire("jTdAm");

var $92mGG = parcelRequire("92mGG");

var $hEosq = parcelRequire("hEosq");

var $5VM6C = parcelRequire("5VM6C");

var $jGMOZ = parcelRequire("jGMOZ");

var $7vFJ6 = parcelRequire("7vFJ6");

var $l04BV = parcelRequire("l04BV");

var $dZX2W = parcelRequire("dZX2W");

var $blfb5 = parcelRequire("blfb5");

var $7trs4 = parcelRequire("7trs4");

var $bbzbN = parcelRequire("bbzbN");
const $3fe210705d1a4e6f$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $3fe210705d1a4e6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        list: [
            "list"
        ],
        item: [
            "item"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $jGMOZ.getDigitalClockUtilityClass), classes);
};
const $3fe210705d1a4e6f$var$DigitalClockRoot = (0, $kDBhE.default)((0, $5VM6C.PickerViewRoot), {
    name: "MuiDigitalClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        overflowY: "auto",
        width: "100%",
        scrollBehavior: ownerState.alreadyRendered ? "smooth" : "auto",
        maxHeight: (0, $l04BV.DIGITAL_CLOCK_VIEW_HEIGHT)
    }));
const $3fe210705d1a4e6f$var$DigitalClockList = (0, $kDBhE.default)((0, $dseJp.default), {
    name: "MuiDigitalClock",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $3fe210705d1a4e6f$var$DigitalClockItem = (0, $kDBhE.default)((0, $58CWL.default), {
    name: "MuiDigitalClock",
    slot: "Item",
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: "8px 16px",
        margin: "2px 4px",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $3fe210705d1a4e6f$export$9a2b219a5b06deb7 = /*#__PURE__*/ $7fPBF.forwardRef(function DigitalClock(inProps, ref) {
    var _ref, _slots$digitalClockIt, _slotProps$digitalClo;
    const utils = (0, $92mGG.useUtils)();
    const containerRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(ref, containerRef);
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        "hours"
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $cFLic.default)(props, $3fe210705d1a4e6f$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $dZX2W.useControlledValueWithTimezone)({
        name: "DigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $blfb5.singleItemValueManager)
    });
    const localeText = (0, $92mGG.useLocaleText)();
    const now = (0, $92mGG.useNow)(timezone);
    const ownerState = $7fPBF.useMemo(()=>(0, $kY3Ke.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $3fe210705d1a4e6f$var$useUtilityClasses(ownerState);
    const ClockItem = (_ref = (_slots$digitalClockIt = slots == null ? void 0 : slots.digitalClockItem) != null ? _slots$digitalClockIt : components == null ? void 0 : components.DigitalClockItem) != null ? _ref : $3fe210705d1a4e6f$var$DigitalClockItem;
    const clockItemProps = (0, $94ctx.useSlotProps)({
        elementType: ClockItem,
        externalSlotProps: (_slotProps$digitalClo = slotProps == null ? void 0 : slotProps.digitalClockItem) != null ? _slotProps$digitalClo : componentsProps == null ? void 0 : componentsProps.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $7trs4.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $giDhD.default)((newValue)=>handleRawValueChange(newValue, "finish"));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $7vFJ6.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $giDhD.default)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish");
    });
    $7fPBF.useEffect(()=>{
        if (containerRef.current === null) return;
        const selectedItem = containerRef.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
        if (!selectedItem) return;
        const offsetTop = selectedItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $7fPBF.useCallback((valueToCheck)=>{
        const isAfter = (0, $hEosq.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(utils.toJsDate(valueToCheck).getTime(), "hours")) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, "hours");
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime
    ]);
    const timeOptions = $7fPBF.useMemo(()=>{
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        return [
            startOfDay,
            ...Array.from({
                length: Math.ceil(1440 / timeStep) - 1
            }, (_, index)=>utils.addMinutes(startOfDay, timeStep * (index + 1)))
        ];
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3fe210705d1a4e6f$var$DigitalClockRoot, (0, $kY3Ke.default)({
        ref: handleRef,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($3fe210705d1a4e6f$var$DigitalClockList, {
            autoFocusItem: autoFocus || !!focusedView,
            role: "listbox",
            "aria-label": localeText.timePickerToolbarTitle,
            className: classes.list,
            children: timeOptions.map((option)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                return /*#__PURE__*/ (0, $bbzbN.jsx)(ClockItem, (0, $kY3Ke.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected
                }, clockItemProps, {
                    children: utils.format(option, ampm ? "fullTime12h" : "fullTime24h")
                }), utils.toISO(option));
            })
        })
    }));
});

});
parcelRequire.register("jGMOZ", function(module, exports) {

$parcel$export(module.exports, "getDigitalClockUtilityClass", function () { return $e557cf7832622661$export$aeb645018b209578; });

var $k6RDS = parcelRequire("k6RDS");

var $4jzsB = parcelRequire("4jzsB");
function $e557cf7832622661$export$aeb645018b209578(slot) {
    return (0, $k6RDS.default)("MuiDigitalClock", slot);
}
const $e557cf7832622661$export$baf91642e79c8163 = (0, $4jzsB.default)("MuiDigitalClock", [
    "root",
    "list",
    "item"
]);

});


parcelRequire.register("6fl9w", function(module, exports) {

$parcel$export(module.exports, "MultiSectionDigitalClock", function () { return $48c48d3e68367bff$export$c48dada788ff933b; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");


var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $giDhD = parcelRequire("giDhD");

var $cFCqu = parcelRequire("cFCqu");

var $92mGG = parcelRequire("92mGG");

var $hEosq = parcelRequire("hEosq");

var $7vFJ6 = parcelRequire("7vFJ6");

var $81Pww = parcelRequire("81Pww");

var $5VM6C = parcelRequire("5VM6C");

var $luP9r = parcelRequire("luP9r");

var $oWfqC = parcelRequire("oWfqC");

var $7N1Rv = parcelRequire("7N1Rv");

var $dZX2W = parcelRequire("dZX2W");

var $blfb5 = parcelRequire("blfb5");

var $7trs4 = parcelRequire("7trs4");

var $6CwGv = parcelRequire("6CwGv");

var $bbzbN = parcelRequire("bbzbN");
const $48c48d3e68367bff$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $48c48d3e68367bff$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $luP9r.getMultiSectionDigitalClockUtilityClass), classes);
};
const $48c48d3e68367bff$var$MultiSectionDigitalClockRoot = (0, $kDBhE.default)((0, $5VM6C.PickerViewRoot), {
    name: "MuiMultiSectionDigitalClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $48c48d3e68367bff$export$c48dada788ff933b = /*#__PURE__*/ $7fPBF.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $92mGG.useUtils)();
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        "hours",
        "minutes"
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $cFLic.default)(props, $48c48d3e68367bff$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $dZX2W.useControlledValueWithTimezone)({
        name: "MultiSectionDigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $blfb5.singleItemValueManager)
    });
    const localeText = (0, $92mGG.useLocaleText)();
    const now = (0, $92mGG.useNow)(timezone);
    const timeSteps = $7fPBF.useMemo(()=>(0, $kY3Ke.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $7trs4.useClockReferenceDate)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $giDhD.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $7fPBF.useMemo(()=>{
        if (!ampm || !inViews.includes("hours")) return inViews;
        return inViews.includes("meridiem") ? inViews : [
            ...inViews,
            "meridiem"
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToView: setValueAndGoToView, focusedView: focusedView } = (0, $7vFJ6.useViews)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $giDhD.default)((newValue)=>{
        setValueAndGoToView(newValue, null, "meridiem");
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $81Pww.useMeridiemMode)(valueOrReferenceDate, ampm, handleMeridiemValueChange, "finish");
    const isTimeDisabled = $7fPBF.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $hEosq.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $hEosq.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const handleSectionChange = (0, $giDhD.default)((sectionView, newValue)=>{
        const viewIndex = views.indexOf(sectionView);
        const nextView = views[viewIndex + 1];
        setValueAndGoToView(newValue, nextView, sectionView);
    });
    const buildViewProps = $7fPBF.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case "hours":
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $hEosq.convertValueToMeridiem)(hours, meridiemMode, ampm);
                        handleSectionChange("hours", utils.setHours(valueOrReferenceDate, valueWithMeridiem));
                    },
                    items: (0, $7N1Rv.getHourSectionOptions)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>disabled || isTimeDisabled(hours, "hours"),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: localeText.hoursClockNumberText
                    })
                };
            case "minutes":
                return {
                    onChange: (minutes)=>{
                        handleSectionChange("minutes", utils.setMinutes(valueOrReferenceDate, minutes));
                    },
                    items: (0, $7N1Rv.getTimeSectionOptions)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        isDisabled: (minutes)=>disabled || isTimeDisabled(minutes, "minutes"),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), "minutes"),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.minutesClockNumberText
                    })
                };
            case "seconds":
                return {
                    onChange: (seconds)=>{
                        handleSectionChange("seconds", utils.setSeconds(valueOrReferenceDate, seconds));
                    },
                    items: (0, $7N1Rv.getTimeSectionOptions)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        isDisabled: (seconds)=>disabled || isTimeDisabled(seconds, "seconds"),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), "seconds"),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.secondsClockNumberText
                    })
                };
            case "meridiem":
                {
                    const amLabel = (0, $6CwGv.formatMeridiem)(utils, "am");
                    const pmLabel = (0, $6CwGv.formatMeridiem)(utils, "pm");
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: "am",
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === "am",
                                ariaLabel: amLabel
                            },
                            {
                                value: "pm",
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === "pm",
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        handleSectionChange,
        valueOrReferenceDate,
        disabled,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewTimeOptions = $7fPBF.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $kY3Ke.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $48c48d3e68367bff$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($48c48d3e68367bff$var$MultiSectionDigitalClockRoot, (0, $kY3Ke.default)({
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: Object.entries(viewTimeOptions).map(([timeView, viewOptions])=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $oWfqC.MultiSectionDigitalClockSection), {
                items: viewOptions.items,
                onChange: viewOptions.onChange,
                active: view === timeView,
                autoFocus: autoFocus != null ? autoFocus : focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots != null ? slots : components,
                slotProps: slotProps != null ? slotProps : componentsProps,
                skipDisabled: skipDisabled,
                "aria-label": localeText.selectViewText(timeView)
            }, timeView))
    }));
});

});
parcelRequire.register("luP9r", function(module, exports) {

$parcel$export(module.exports, "getMultiSectionDigitalClockUtilityClass", function () { return $fa6413e7f31224fa$export$b828b7724b7b2890; });

var $k6RDS = parcelRequire("k6RDS");

var $4jzsB = parcelRequire("4jzsB");
function $fa6413e7f31224fa$export$b828b7724b7b2890(slot) {
    return (0, $k6RDS.default)("MuiMultiSectionDigitalClock", slot);
}
const $fa6413e7f31224fa$export$f2277d947b8f7a8a = (0, $4jzsB.default)("MuiMultiSectionDigitalClock", [
    "root"
]);

});

parcelRequire.register("oWfqC", function(module, exports) {

$parcel$export(module.exports, "MultiSectionDigitalClockSection", function () { return $04af6cd06e89ef50$export$f971f93dc8464c; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $cxeT8 = parcelRequire("cxeT8");
var $kDBhE = parcelRequire("kDBhE");
var $5j2OD = parcelRequire("5j2OD");

var $cFCqu = parcelRequire("cFCqu");

var $dseJp = parcelRequire("dseJp");

var $58CWL = parcelRequire("58CWL");

var $jTdAm = parcelRequire("jTdAm");

var $b5dNJ = parcelRequire("b5dNJ");

var $l04BV = parcelRequire("l04BV");

var $bbzbN = parcelRequire("bbzbN");
const $04af6cd06e89ef50$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $04af6cd06e89ef50$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        item: [
            "item"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $b5dNJ.getMultiSectionDigitalClockSectionUtilityClass), classes);
};
const $04af6cd06e89ef50$var$MultiSectionDigitalClockSectionRoot = (0, $kDBhE.default)((0, $dseJp.default), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        maxHeight: (0, $l04BV.DIGITAL_CLOCK_VIEW_HEIGHT),
        width: 56,
        padding: 0,
        overflow: "hidden",
        scrollBehavior: ownerState.alreadyRendered ? "smooth" : "auto",
        "&:hover": {
            overflowY: "auto"
        },
        "&:not(:first-of-type)": {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        "&:after": {
            display: "block",
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: "calc(100% - 40px - 6px)"
        }
    }));
const $04af6cd06e89ef50$var$MultiSectionDigitalClockSectionItem = (0, $kDBhE.default)((0, $58CWL.default), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Item",
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: "2px 4px",
        width: (0, $l04BV.MULTI_SECTION_CLOCK_SECTION_WIDTH),
        justifyContent: "center",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $04af6cd06e89ef50$export$f971f93dc8464c = /*#__PURE__*/ $7fPBF.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    var _slots$digitalClockSe;
    const containerRef = $7fPBF.useRef(null);
    const handleRef = (0, $jTdAm.default)(ref, containerRef);
    const previousSelected = $7fPBF.useRef(null);
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClockSection"
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $cFLic.default)(props, $04af6cd06e89ef50$var$_excluded);
    const ownerState = $7fPBF.useMemo(()=>(0, $kY3Ke.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $04af6cd06e89ef50$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = (_slots$digitalClockSe = slots == null ? void 0 : slots.digitalClockSectionItem) != null ? _slots$digitalClockSe : $04af6cd06e89ef50$var$MultiSectionDigitalClockSectionItem;
    $7fPBF.useEffect(()=>{
        if (containerRef.current === null) return;
        const selectedItem = containerRef.current.querySelector('[role="option"][aria-selected="true"]');
        if (!selectedItem || previousSelected.current === selectedItem) {
            // Handle setting the ref to null if the selected item is ever reset via UI
            if (previousSelected.current !== selectedItem) previousSelected.current = selectedItem;
            return;
        }
        previousSelected.current = selectedItem;
        if (active && autoFocus) selectedItem.focus();
        const offsetTop = selectedItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($04af6cd06e89ef50$var$MultiSectionDigitalClockSectionRoot, (0, $kY3Ke.default)({
        ref: handleRef,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox"
    }, other, {
        children: items.map((option)=>{
            var _option$isDisabled, _option$isDisabled2;
            if (skipDisabled && (_option$isDisabled = option.isDisabled) != null && _option$isDisabled.call(option, option.value)) return null;
            const isSelected = option.isSelected(option.value);
            return /*#__PURE__*/ (0, $bbzbN.jsx)(DigitalClockSectionItem, (0, $kY3Ke.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: disabled || ((_option$isDisabled2 = option.isDisabled) == null ? void 0 : _option$isDisabled2.call(option, option.value)),
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected
            }, slotProps == null ? void 0 : slotProps.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});

});
parcelRequire.register("b5dNJ", function(module, exports) {

$parcel$export(module.exports, "getMultiSectionDigitalClockSectionUtilityClass", function () { return $811addf00e3e5266$export$ab23463cad6963ff; });

var $k6RDS = parcelRequire("k6RDS");

var $4jzsB = parcelRequire("4jzsB");
function $811addf00e3e5266$export$ab23463cad6963ff(slot) {
    return (0, $k6RDS.default)("MuiMultiSectionDigitalClock", slot);
}
const $811addf00e3e5266$export$eaf2b63fa45eff23 = (0, $4jzsB.default)("MuiMultiSectionDigitalClock", [
    "root",
    "item"
]);

});


parcelRequire.register("7N1Rv", function(module, exports) {

$parcel$export(module.exports, "getHourSectionOptions", function () { return $5abe8dc3355b219c$export$9101aa7ba362bb4e; });
$parcel$export(module.exports, "getTimeSectionOptions", function () { return $5abe8dc3355b219c$export$e7b56db95f8a7b9c; });
const $5abe8dc3355b219c$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? "hours12h" : "hours24h");
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $5abe8dc3355b219c$export$e7b56db95f8a7b9c = ({ value: value, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: resolveLabel(timeValue),
                isDisabled: isDisabled,
                isSelected: isSelected,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};

});




parcelRequire.register("klKgp", function(module, exports) {

$parcel$export(module.exports, "MobileTimePicker", function () { return $ed09a7cdfe601471$export$984018df37898b81; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $dUIft = parcelRequire("dUIft");

var $blfb5 = parcelRequire("blfb5");

var $7DInd = parcelRequire("7DInd");

var $68sLg = parcelRequire("68sLg");

var $92mGG = parcelRequire("92mGG");

var $gxEUP = parcelRequire("gxEUP");

var $i4xIP = parcelRequire("i4xIP");

var $3GboI = parcelRequire("3GboI");

var $boMFm = parcelRequire("boMFm");

var $hEosq = parcelRequire("hEosq");
const $ed09a7cdfe601471$export$984018df37898b81 = /*#__PURE__*/ $7fPBF.forwardRef(function MobileTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $92mGG.useLocaleText)();
    const utils = (0, $92mGG.useUtils)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $68sLg.useTimePickerDefaultizedProps)(inProps, "MuiMobileTimePicker");
    const viewRenderers = (0, $kY3Ke.default)({
        hours: (0, $boMFm.renderTimeViewClock),
        minutes: (0, $boMFm.renderTimeViewClock),
        seconds: (0, $boMFm.renderTimeViewClock)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : false;
    // Props with the default values specific to the mobile variant
    const props = (0, $kY3Ke.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        viewRenderers: viewRenderers,
        format: (0, $hEosq.resolveTimeFormat)(utils, defaultizedProps),
        slots: (0, $kY3Ke.default)({
            field: (0, $7DInd.TimeField)
        }, defaultizedProps.slots),
        slotProps: (0, $kY3Ke.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $kY3Ke.default)({}, (0, $dUIft.resolveComponentProps)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $3GboI.extractValidationProps)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $kY3Ke.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $i4xIP.useMobilePicker)({
        props: props,
        valueManager: (0, $blfb5.singleItemValueManager),
        valueType: "time",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openTimePickerDialogue) != null ? _props$localeText$ope : localeText.openTimePickerDialogue,
        validator: (0, $gxEUP.validateTime)
    });
    return renderPicker();
});
$ed09a7cdfe601471$export$984018df37898b81.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
        })
    ]),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]).isRequired)
};

});




parcelRequire.register("8FqGL", function(module, exports) {
"use strict";
function $64f6dae37b56553a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $64f6dae37b56553a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $64f6dae37b56553a$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $64f6dae37b56553a$var$_react = $64f6dae37b56553a$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $cHkI0 = parcelRequire("cHkI0");

var $64f6dae37b56553a$var$_json2mq = $64f6dae37b56553a$var$_interopRequireDefault((parcelRequire("d1b3p")));

var $64f6dae37b56553a$var$_defaultProps = $64f6dae37b56553a$var$_interopRequireDefault((parcelRequire("3CQWE")));

var $4h5YK = parcelRequire("4h5YK");
function $64f6dae37b56553a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $64f6dae37b56553a$var$_extends() {
    $64f6dae37b56553a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $64f6dae37b56553a$var$_extends.apply(this, arguments);
}
function $64f6dae37b56553a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64f6dae37b56553a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $64f6dae37b56553a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $64f6dae37b56553a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $64f6dae37b56553a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $64f6dae37b56553a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $64f6dae37b56553a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $64f6dae37b56553a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $64f6dae37b56553a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $64f6dae37b56553a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $64f6dae37b56553a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $64f6dae37b56553a$var$_setPrototypeOf(subClass, superClass);
}
function $64f6dae37b56553a$var$_setPrototypeOf(o, p) {
    $64f6dae37b56553a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $64f6dae37b56553a$var$_setPrototypeOf(o, p);
}
function $64f6dae37b56553a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $64f6dae37b56553a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $64f6dae37b56553a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $64f6dae37b56553a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $64f6dae37b56553a$var$_possibleConstructorReturn(this, result);
    };
}
function $64f6dae37b56553a$var$_possibleConstructorReturn(self, call) {
    if (call && ($64f6dae37b56553a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $64f6dae37b56553a$var$_assertThisInitialized(self);
}
function $64f6dae37b56553a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $64f6dae37b56553a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $64f6dae37b56553a$var$_getPrototypeOf(o) {
    $64f6dae37b56553a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $64f6dae37b56553a$var$_getPrototypeOf(o);
}
function $64f6dae37b56553a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $64f6dae37b56553a$var$enquire = (0, $4h5YK.canUseDOM)() && (parcelRequire("azLOe"));
var $64f6dae37b56553a$var$Slider = /*#__PURE__*/ function(_React$Component) {
    $64f6dae37b56553a$var$_inherits(Slider, _React$Component);
    var _super = $64f6dae37b56553a$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $64f6dae37b56553a$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $64f6dae37b56553a$var$_defineProperty($64f6dae37b56553a$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $64f6dae37b56553a$var$_defineProperty($64f6dae37b56553a$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $64f6dae37b56553a$var$_defineProperty($64f6dae37b56553a$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $64f6dae37b56553a$var$_defineProperty($64f6dae37b56553a$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $64f6dae37b56553a$var$_defineProperty($64f6dae37b56553a$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $64f6dae37b56553a$var$_defineProperty($64f6dae37b56553a$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $64f6dae37b56553a$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $64f6dae37b56553a$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    }); // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $64f6dae37b56553a$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $64f6dae37b56553a$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                         // when not using server side rendering
                        (0, $4h5YK.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    }); // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $64f6dae37b56553a$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $4h5YK.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $64f6dae37b56553a$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $64f6dae37b56553a$var$_objectSpread($64f6dae37b56553a$var$_objectSpread($64f6dae37b56553a$var$_objectSpread({}, $64f6dae37b56553a$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $64f6dae37b56553a$var$_objectSpread($64f6dae37b56553a$var$_objectSpread({}, $64f6dae37b56553a$var$_defaultProps["default"]), this.props);
                 // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                } // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                } // makes sure that children is an array, even when there is only 1 child
                var children = $64f6dae37b56553a$var$_react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                }); // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $64f6dae37b56553a$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $64f6dae37b56553a$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $64f6dae37b56553a$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $64f6dae37b56553a$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $64f6dae37b56553a$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ $64f6dae37b56553a$var$_react["default"].createElement($cHkI0.InnerSlider, $64f6dae37b56553a$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, settings), newChildren);
            }
        }
    ]);
    return Slider;
}($64f6dae37b56553a$var$_react["default"].Component);
module.exports["default"] = $64f6dae37b56553a$var$Slider;

});
parcelRequire.register("cHkI0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $93e99084ddd2e37f$var$_react = $93e99084ddd2e37f$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $93e99084ddd2e37f$var$_initialState = $93e99084ddd2e37f$var$_interopRequireDefault((parcelRequire("3m1FP")));

var $93e99084ddd2e37f$var$_lodash = $93e99084ddd2e37f$var$_interopRequireDefault((parcelRequire("bbKUP")));

var $93e99084ddd2e37f$var$_classnames = $93e99084ddd2e37f$var$_interopRequireDefault((parcelRequire("jicu4")));

var $4h5YK = parcelRequire("4h5YK");

var $v0gbh = parcelRequire("v0gbh");

var $2v4r0 = parcelRequire("2v4r0");

var $jS9gR = parcelRequire("jS9gR");

var $93e99084ddd2e37f$var$_resizeObserverPolyfill = $93e99084ddd2e37f$var$_interopRequireDefault((parcelRequire("2e0Bh")));
function $93e99084ddd2e37f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $93e99084ddd2e37f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $93e99084ddd2e37f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $93e99084ddd2e37f$var$_typeof(obj);
}
function $93e99084ddd2e37f$var$_extends() {
    $93e99084ddd2e37f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $93e99084ddd2e37f$var$_extends.apply(this, arguments);
}
function $93e99084ddd2e37f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $93e99084ddd2e37f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $93e99084ddd2e37f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $93e99084ddd2e37f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $93e99084ddd2e37f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $93e99084ddd2e37f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $93e99084ddd2e37f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $93e99084ddd2e37f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $93e99084ddd2e37f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $93e99084ddd2e37f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $93e99084ddd2e37f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $93e99084ddd2e37f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $93e99084ddd2e37f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $93e99084ddd2e37f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $93e99084ddd2e37f$var$_setPrototypeOf(subClass, superClass);
}
function $93e99084ddd2e37f$var$_setPrototypeOf(o, p) {
    $93e99084ddd2e37f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $93e99084ddd2e37f$var$_setPrototypeOf(o, p);
}
function $93e99084ddd2e37f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $93e99084ddd2e37f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $93e99084ddd2e37f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $93e99084ddd2e37f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $93e99084ddd2e37f$var$_possibleConstructorReturn(this, result);
    };
}
function $93e99084ddd2e37f$var$_possibleConstructorReturn(self, call) {
    if (call && ($93e99084ddd2e37f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $93e99084ddd2e37f$var$_assertThisInitialized(self);
}
function $93e99084ddd2e37f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $93e99084ddd2e37f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $93e99084ddd2e37f$var$_getPrototypeOf(o) {
    $93e99084ddd2e37f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $93e99084ddd2e37f$var$_getPrototypeOf(o);
}
function $93e99084ddd2e37f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $93e99084ddd2e37f$var$InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $93e99084ddd2e37f$var$_inherits(InnerSlider, _React$Component);
    var _super = $93e99084ddd2e37f$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $93e99084ddd2e37f$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
                _this.list.style.height = (0, $4h5YK.getHeight)(elem) + "px";
            }
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $4h5YK.getOnDemandLazySlides)($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $93e99084ddd2e37f$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $93e99084ddd2e37f$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $4h5YK.getOnDemandLazySlides)($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            } // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $93e99084ddd2e37f$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $93e99084ddd2e37f$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $93e99084ddd2e37f$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            }); // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $4h5YK.initializedState)(spec);
            spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $4h5YK.getTrackLeft)(spec);
            spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $4h5YK.getTrackCSS)(spec);
            if (setTrackStyle || $93e99084ddd2e37f$var$_react["default"].Children.count(_this.props.children) !== $93e99084ddd2e37f$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $4h5YK.getPreClones)($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $4h5YK.getPostClones)($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $93e99084ddd2e37f$var$_react["default"].Children.count(_this.props.children);
            var spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $4h5YK.getPreClones)(spec) + (0, $4h5YK.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $4h5YK.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function() {
                        prevClickHandler();
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $4h5YK.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $4h5YK.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $4h5YK.slideHandler)($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $93e99084ddd2e37f$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $4h5YK.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $4h5YK.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $4h5YK.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $4h5YK.swipeMove)(e, $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $4h5YK.swipeEnd)(e, $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $4h5YK.canGoNext)($93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $93e99084ddd2e37f$var$_defineProperty($93e99084ddd2e37f$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $93e99084ddd2e37f$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $4h5YK.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $4h5YK.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $93e99084ddd2e37f$var$_react["default"].createElement($2v4r0.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $4h5YK.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $93e99084ddd2e37f$var$_react["default"].createElement($jS9gR.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $93e99084ddd2e37f$var$_react["default"].createElement($jS9gR.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $93e99084ddd2e37f$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $93e99084ddd2e37f$var$_react["default"].createElement("div", $93e99084ddd2e37f$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $93e99084ddd2e37f$var$_react["default"].createElement($v0gbh.Track, $93e99084ddd2e37f$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, $93e99084ddd2e37f$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            slideCount: $93e99084ddd2e37f$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $93e99084ddd2e37f$var$_objectSpread($93e99084ddd2e37f$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $93e99084ddd2e37f$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($93e99084ddd2e37f$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $93e99084ddd2e37f$var$_react["default"].Children.count(this.props.children) !== $93e99084ddd2e37f$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($93e99084ddd2e37f$var$_react["default"].Component);
module.exports.InnerSlider = $93e99084ddd2e37f$var$InnerSlider;

});
parcelRequire.register("3m1FP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $2714b986f67a7850$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $2714b986f67a7850$var$_default = $2714b986f67a7850$var$initialState;
module.exports["default"] = $2714b986f67a7850$var$_default;

});

parcelRequire.register("bbKUP", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $82551d4318ed8ff3$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $82551d4318ed8ff3$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $82551d4318ed8ff3$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $82551d4318ed8ff3$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $82551d4318ed8ff3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $82551d4318ed8ff3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $82551d4318ed8ff3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $82551d4318ed8ff3$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $82551d4318ed8ff3$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $82551d4318ed8ff3$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $82551d4318ed8ff3$var$root = $82551d4318ed8ff3$var$freeGlobal || $82551d4318ed8ff3$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $82551d4318ed8ff3$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $82551d4318ed8ff3$var$objectToString = $82551d4318ed8ff3$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $82551d4318ed8ff3$var$nativeMax = Math.max, $82551d4318ed8ff3$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $82551d4318ed8ff3$var$now = function() {
    return $82551d4318ed8ff3$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $82551d4318ed8ff3$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($82551d4318ed8ff3$var$FUNC_ERROR_TEXT);
    wait = $82551d4318ed8ff3$var$toNumber(wait) || 0;
    if ($82551d4318ed8ff3$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $82551d4318ed8ff3$var$nativeMax($82551d4318ed8ff3$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $82551d4318ed8ff3$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $82551d4318ed8ff3$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($82551d4318ed8ff3$var$now());
    }
    function debounced() {
        var time = $82551d4318ed8ff3$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $82551d4318ed8ff3$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $82551d4318ed8ff3$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $82551d4318ed8ff3$var$isSymbol(value) {
    return typeof value == "symbol" || $82551d4318ed8ff3$var$isObjectLike(value) && $82551d4318ed8ff3$var$objectToString.call(value) == $82551d4318ed8ff3$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $82551d4318ed8ff3$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($82551d4318ed8ff3$var$isSymbol(value)) return $82551d4318ed8ff3$var$NAN;
    if ($82551d4318ed8ff3$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $82551d4318ed8ff3$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($82551d4318ed8ff3$var$reTrim, "");
    var isBinary = $82551d4318ed8ff3$var$reIsBinary.test(value);
    return isBinary || $82551d4318ed8ff3$var$reIsOctal.test(value) ? $82551d4318ed8ff3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $82551d4318ed8ff3$var$reIsBadHex.test(value) ? $82551d4318ed8ff3$var$NAN : +value;
}
module.exports = $82551d4318ed8ff3$var$debounce;

});

parcelRequire.register("jicu4", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("4h5YK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $31cd6335b61c5b56$var$clamp;
module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = module.exports.extractObject = void 0;

var $31cd6335b61c5b56$var$_react = $31cd6335b61c5b56$var$_interopRequireDefault((parcelRequire("7fPBF")));
function $31cd6335b61c5b56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $31cd6335b61c5b56$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $31cd6335b61c5b56$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $31cd6335b61c5b56$var$ownKeys(Object(source), !0).forEach(function(key) {
            $31cd6335b61c5b56$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $31cd6335b61c5b56$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $31cd6335b61c5b56$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $31cd6335b61c5b56$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $31cd6335b61c5b56$var$safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
module.exports.safePreventDefault = $31cd6335b61c5b56$var$safePreventDefault;
var $31cd6335b61c5b56$var$getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $31cd6335b61c5b56$var$lazyStartIndex(spec);
    var endIndex = $31cd6335b61c5b56$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
}; // return list of slides that need to be present
module.exports.getOnDemandLazySlides = $31cd6335b61c5b56$var$getOnDemandLazySlides;
var $31cd6335b61c5b56$var$getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $31cd6335b61c5b56$var$lazyStartIndex(spec);
    var endIndex = $31cd6335b61c5b56$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
}; // startIndex that needs to be present
module.exports.getRequiredLazySlides = $31cd6335b61c5b56$var$getRequiredLazySlides;
var $31cd6335b61c5b56$var$lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $31cd6335b61c5b56$var$lazySlidesOnLeft(spec);
};
module.exports.lazyStartIndex = $31cd6335b61c5b56$var$lazyStartIndex;
var $31cd6335b61c5b56$var$lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $31cd6335b61c5b56$var$lazySlidesOnRight(spec);
};
module.exports.lazyEndIndex = $31cd6335b61c5b56$var$lazyEndIndex;
var $31cd6335b61c5b56$var$lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
module.exports.lazySlidesOnLeft = $31cd6335b61c5b56$var$lazySlidesOnLeft;
var $31cd6335b61c5b56$var$lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element
module.exports.lazySlidesOnRight = $31cd6335b61c5b56$var$lazySlidesOnRight;
var $31cd6335b61c5b56$var$getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
module.exports.getWidth = $31cd6335b61c5b56$var$getWidth;
var $31cd6335b61c5b56$var$getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
module.exports.getHeight = $31cd6335b61c5b56$var$getHeight;
var $31cd6335b61c5b56$var$getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
}; // whether or not we can go next
module.exports.getSwipeDirection = $31cd6335b61c5b56$var$getSwipeDirection;
var $31cd6335b61c5b56$var$canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
}; // given an object and a list of keys, return new object with given keys
module.exports.canGoNext = $31cd6335b61c5b56$var$canGoNext;
var $31cd6335b61c5b56$var$extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
}; // get initialized state
module.exports.extractObject = $31cd6335b61c5b56$var$extractObject;
var $31cd6335b61c5b56$var$initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $31cd6335b61c5b56$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($31cd6335b61c5b56$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($31cd6335b61c5b56$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $31cd6335b61c5b56$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $31cd6335b61c5b56$var$getOnDemandLazySlides($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
module.exports.initializedState = $31cd6335b61c5b56$var$initializedState;
var $31cd6335b61c5b56$var$slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $31cd6335b61c5b56$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$31cd6335b61c5b56$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $31cd6335b61c5b56$var$getTrackLeft($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $31cd6335b61c5b56$var$getTrackLeft($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($31cd6335b61c5b56$var$getOnDemandLazySlides($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $31cd6335b61c5b56$var$getTrackCSS($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $31cd6335b61c5b56$var$getTrackAnimateCSS($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $31cd6335b61c5b56$var$getTrackCSS($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
module.exports.slideHandler = $31cd6335b61c5b56$var$slideHandler;
var $31cd6335b61c5b56$var$changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $31cd6335b61c5b56$var$siblingDirection($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
module.exports.changeSlide = $31cd6335b61c5b56$var$changeSlide;
var $31cd6335b61c5b56$var$keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
module.exports.keyHandler = $31cd6335b61c5b56$var$keyHandler;
var $31cd6335b61c5b56$var$swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $31cd6335b61c5b56$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
module.exports.swipeStart = $31cd6335b61c5b56$var$swipeStart;
var $31cd6335b61c5b56$var$swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $31cd6335b61c5b56$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $31cd6335b61c5b56$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $31cd6335b61c5b56$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $31cd6335b61c5b56$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$31cd6335b61c5b56$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $31cd6335b61c5b56$var$getTrackCSS($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $31cd6335b61c5b56$var$safePreventDefault(e);
    }
    return state;
};
module.exports.swipeMove = $31cd6335b61c5b56$var$swipeMove;
var $31cd6335b61c5b56$var$swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $31cd6335b61c5b56$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $31cd6335b61c5b56$var$getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $31cd6335b61c5b56$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $31cd6335b61c5b56$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $31cd6335b61c5b56$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $31cd6335b61c5b56$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $31cd6335b61c5b56$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $31cd6335b61c5b56$var$getTrackLeft(spec);
        state["trackStyle"] = $31cd6335b61c5b56$var$getTrackAnimateCSS($31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
module.exports.swipeEnd = $31cd6335b61c5b56$var$swipeEnd;
var $31cd6335b61c5b56$var$getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
module.exports.getNavigableIndexes = $31cd6335b61c5b56$var$getNavigableIndexes;
var $31cd6335b61c5b56$var$checkNavigable = function checkNavigable(spec, index) {
    var navigables = $31cd6335b61c5b56$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
module.exports.checkNavigable = $31cd6335b61c5b56$var$checkNavigable;
var $31cd6335b61c5b56$var$getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $31cd6335b61c5b56$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $31cd6335b61c5b56$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
module.exports.getSlideCount = $31cd6335b61c5b56$var$getSlideCount;
var $31cd6335b61c5b56$var$checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
module.exports.checkSpecKeys = $31cd6335b61c5b56$var$checkSpecKeys;
var $31cd6335b61c5b56$var$getTrackCSS = function getTrackCSS(spec) {
    $31cd6335b61c5b56$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $31cd6335b61c5b56$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $31cd6335b61c5b56$var$_objectSpread($31cd6335b61c5b56$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight; // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
module.exports.getTrackCSS = $31cd6335b61c5b56$var$getTrackCSS;
var $31cd6335b61c5b56$var$getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $31cd6335b61c5b56$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $31cd6335b61c5b56$var$getTrackCSS(spec); // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
module.exports.getTrackAnimateCSS = $31cd6335b61c5b56$var$getTrackAnimateCSS;
var $31cd6335b61c5b56$var$getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $31cd6335b61c5b56$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$31cd6335b61c5b56$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
         // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $31cd6335b61c5b56$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $31cd6335b61c5b56$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
module.exports.getTrackLeft = $31cd6335b61c5b56$var$getTrackLeft;
var $31cd6335b61c5b56$var$getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
module.exports.getPreClones = $31cd6335b61c5b56$var$getPreClones;
var $31cd6335b61c5b56$var$getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
module.exports.getPostClones = $31cd6335b61c5b56$var$getPostClones;
var $31cd6335b61c5b56$var$getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $31cd6335b61c5b56$var$getPreClones(spec) + spec.slideCount + $31cd6335b61c5b56$var$getPostClones(spec);
};
module.exports.getTotalSlides = $31cd6335b61c5b56$var$getTotalSlides;
var $31cd6335b61c5b56$var$siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $31cd6335b61c5b56$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $31cd6335b61c5b56$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
module.exports.siblingDirection = $31cd6335b61c5b56$var$siblingDirection;
var $31cd6335b61c5b56$var$slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
module.exports.slidesOnRight = $31cd6335b61c5b56$var$slidesOnRight;
var $31cd6335b61c5b56$var$slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
module.exports.slidesOnLeft = $31cd6335b61c5b56$var$slidesOnLeft;
var $31cd6335b61c5b56$var$canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
module.exports.canUseDOM = $31cd6335b61c5b56$var$canUseDOM;

});

parcelRequire.register("v0gbh", function(module, exports) {
"use strict";
function $05d318fe06573025$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $05d318fe06573025$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $05d318fe06573025$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $05d318fe06573025$var$_react = $05d318fe06573025$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $05d318fe06573025$var$_classnames = $05d318fe06573025$var$_interopRequireDefault((parcelRequire("jicu4")));

var $4h5YK = parcelRequire("4h5YK");
function $05d318fe06573025$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $05d318fe06573025$var$_extends() {
    $05d318fe06573025$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $05d318fe06573025$var$_extends.apply(this, arguments);
}
function $05d318fe06573025$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $05d318fe06573025$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $05d318fe06573025$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $05d318fe06573025$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $05d318fe06573025$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $05d318fe06573025$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $05d318fe06573025$var$_setPrototypeOf(subClass, superClass);
}
function $05d318fe06573025$var$_setPrototypeOf(o, p) {
    $05d318fe06573025$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $05d318fe06573025$var$_setPrototypeOf(o, p);
}
function $05d318fe06573025$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $05d318fe06573025$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $05d318fe06573025$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $05d318fe06573025$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $05d318fe06573025$var$_possibleConstructorReturn(this, result);
    };
}
function $05d318fe06573025$var$_possibleConstructorReturn(self, call) {
    if (call && ($05d318fe06573025$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $05d318fe06573025$var$_assertThisInitialized(self);
}
function $05d318fe06573025$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $05d318fe06573025$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $05d318fe06573025$var$_getPrototypeOf(o) {
    $05d318fe06573025$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $05d318fe06573025$var$_getPrototypeOf(o);
}
function $05d318fe06573025$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $05d318fe06573025$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $05d318fe06573025$var$ownKeys(Object(source), !0).forEach(function(key) {
            $05d318fe06573025$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $05d318fe06573025$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $05d318fe06573025$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $05d318fe06573025$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $05d318fe06573025$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $05d318fe06573025$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $05d318fe06573025$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $05d318fe06573025$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $4h5YK.lazyStartIndex)(spec);
    var endIndex = (0, $4h5YK.lazyEndIndex)(spec);
    $05d318fe06573025$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        }; // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $05d318fe06573025$var$_react["default"].createElement("div", null);
        var childStyle = $05d318fe06573025$var$getSlideStyle($05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $05d318fe06573025$var$getSlideClasses($05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({}, spec), {}, {
            index: index
        })); // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $05d318fe06573025$var$_react["default"].cloneElement(child, {
            key: "original" + $05d318fe06573025$var$getKey(child, index),
            "data-index": index,
            className: (0, $05d318fe06573025$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        })); // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $4h5YK.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $05d318fe06573025$var$getSlideClasses($05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $05d318fe06573025$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $05d318fe06573025$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $05d318fe06573025$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (childrenCount !== spec.slidesToShow) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $05d318fe06573025$var$getSlideClasses($05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ $05d318fe06573025$var$_react["default"].cloneElement(child, {
                    key: "postcloned" + $05d318fe06573025$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $05d318fe06573025$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $05d318fe06573025$var$_objectSpread($05d318fe06573025$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $05d318fe06573025$var$Track = /*#__PURE__*/ function(_React$PureComponent) {
    $05d318fe06573025$var$_inherits(Track, _React$PureComponent);
    var _super = $05d318fe06573025$var$_createSuper(Track);
    function Track() {
        var _this;
        $05d318fe06573025$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $05d318fe06573025$var$_defineProperty($05d318fe06573025$var$_assertThisInitialized(_this), "node", null);
        $05d318fe06573025$var$_defineProperty($05d318fe06573025$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $05d318fe06573025$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $05d318fe06573025$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $05d318fe06573025$var$_react["default"].createElement("div", $05d318fe06573025$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($05d318fe06573025$var$_react["default"].PureComponent);
module.exports.Track = $05d318fe06573025$var$Track;

});

parcelRequire.register("2v4r0", function(module, exports) {
"use strict";
function $1d21eaa31862b43c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1d21eaa31862b43c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1d21eaa31862b43c$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $1d21eaa31862b43c$var$_react = $1d21eaa31862b43c$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $1d21eaa31862b43c$var$_classnames = $1d21eaa31862b43c$var$_interopRequireDefault((parcelRequire("jicu4")));

var $4h5YK = parcelRequire("4h5YK");
function $1d21eaa31862b43c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1d21eaa31862b43c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1d21eaa31862b43c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1d21eaa31862b43c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1d21eaa31862b43c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1d21eaa31862b43c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1d21eaa31862b43c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d21eaa31862b43c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d21eaa31862b43c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1d21eaa31862b43c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1d21eaa31862b43c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1d21eaa31862b43c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1d21eaa31862b43c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1d21eaa31862b43c$var$_setPrototypeOf(subClass, superClass);
}
function $1d21eaa31862b43c$var$_setPrototypeOf(o, p) {
    $1d21eaa31862b43c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1d21eaa31862b43c$var$_setPrototypeOf(o, p);
}
function $1d21eaa31862b43c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1d21eaa31862b43c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1d21eaa31862b43c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1d21eaa31862b43c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1d21eaa31862b43c$var$_possibleConstructorReturn(this, result);
    };
}
function $1d21eaa31862b43c$var$_possibleConstructorReturn(self, call) {
    if (call && ($1d21eaa31862b43c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1d21eaa31862b43c$var$_assertThisInitialized(self);
}
function $1d21eaa31862b43c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1d21eaa31862b43c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1d21eaa31862b43c$var$_getPrototypeOf(o) {
    $1d21eaa31862b43c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1d21eaa31862b43c$var$_getPrototypeOf(o);
}
var $1d21eaa31862b43c$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $1d21eaa31862b43c$var$Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $1d21eaa31862b43c$var$_inherits(Dots, _React$PureComponent);
    var _super = $1d21eaa31862b43c$var$_createSuper(Dots);
    function Dots() {
        $1d21eaa31862b43c$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $1d21eaa31862b43c$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $1d21eaa31862b43c$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $4h5YK.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $4h5YK.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $1d21eaa31862b43c$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $1d21eaa31862b43c$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $1d21eaa31862b43c$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $1d21eaa31862b43c$var$_react["default"].cloneElement(this.props.appendDots(dots), $1d21eaa31862b43c$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($1d21eaa31862b43c$var$_react["default"].PureComponent);
module.exports.Dots = $1d21eaa31862b43c$var$Dots;

});

parcelRequire.register("jS9gR", function(module, exports) {
"use strict";
function $e77a40803e403659$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e77a40803e403659$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e77a40803e403659$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $e77a40803e403659$var$_react = $e77a40803e403659$var$_interopRequireDefault((parcelRequire("7fPBF")));

var $e77a40803e403659$var$_classnames = $e77a40803e403659$var$_interopRequireDefault((parcelRequire("jicu4")));

var $4h5YK = parcelRequire("4h5YK");
function $e77a40803e403659$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e77a40803e403659$var$_extends() {
    $e77a40803e403659$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e77a40803e403659$var$_extends.apply(this, arguments);
}
function $e77a40803e403659$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e77a40803e403659$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e77a40803e403659$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e77a40803e403659$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e77a40803e403659$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e77a40803e403659$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e77a40803e403659$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e77a40803e403659$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e77a40803e403659$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e77a40803e403659$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e77a40803e403659$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e77a40803e403659$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e77a40803e403659$var$_setPrototypeOf(subClass, superClass);
}
function $e77a40803e403659$var$_setPrototypeOf(o, p) {
    $e77a40803e403659$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e77a40803e403659$var$_setPrototypeOf(o, p);
}
function $e77a40803e403659$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e77a40803e403659$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e77a40803e403659$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e77a40803e403659$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e77a40803e403659$var$_possibleConstructorReturn(this, result);
    };
}
function $e77a40803e403659$var$_possibleConstructorReturn(self, call) {
    if (call && ($e77a40803e403659$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e77a40803e403659$var$_assertThisInitialized(self);
}
function $e77a40803e403659$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e77a40803e403659$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e77a40803e403659$var$_getPrototypeOf(o) {
    $e77a40803e403659$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e77a40803e403659$var$_getPrototypeOf(o);
}
var $e77a40803e403659$var$PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $e77a40803e403659$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $e77a40803e403659$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $e77a40803e403659$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $e77a40803e403659$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $e77a40803e403659$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $e77a40803e403659$var$_react["default"].cloneElement(this.props.prevArrow, $e77a40803e403659$var$_objectSpread($e77a40803e403659$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $e77a40803e403659$var$_react["default"].createElement("button", $e77a40803e403659$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($e77a40803e403659$var$_react["default"].PureComponent);
module.exports.PrevArrow = $e77a40803e403659$var$PrevArrow;
var $e77a40803e403659$var$NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $e77a40803e403659$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $e77a40803e403659$var$_createSuper(NextArrow);
    function NextArrow() {
        $e77a40803e403659$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $e77a40803e403659$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $4h5YK.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $e77a40803e403659$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $e77a40803e403659$var$_react["default"].cloneElement(this.props.nextArrow, $e77a40803e403659$var$_objectSpread($e77a40803e403659$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $e77a40803e403659$var$_react["default"].createElement("button", $e77a40803e403659$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($e77a40803e403659$var$_react["default"].PureComponent);
module.exports.NextArrow = $e77a40803e403659$var$NextArrow;

});

parcelRequire.register("2e0Bh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $19ed5ac92d0c9dbe$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $19ed5ac92d0c9dbe$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $19ed5ac92d0c9dbe$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $19ed5ac92d0c9dbe$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $19ed5ac92d0c9dbe$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($19ed5ac92d0c9dbe$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $19ed5ac92d0c9dbe$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $19ed5ac92d0c9dbe$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $19ed5ac92d0c9dbe$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $19ed5ac92d0c9dbe$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $19ed5ac92d0c9dbe$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $19ed5ac92d0c9dbe$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $19ed5ac92d0c9dbe$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $19ed5ac92d0c9dbe$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $19ed5ac92d0c9dbe$var$throttle(this.refresh.bind(this), $19ed5ac92d0c9dbe$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$19ed5ac92d0c9dbe$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($19ed5ac92d0c9dbe$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$19ed5ac92d0c9dbe$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $19ed5ac92d0c9dbe$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $19ed5ac92d0c9dbe$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $19ed5ac92d0c9dbe$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $19ed5ac92d0c9dbe$var$global$1;
};
// Placeholder of an empty content rectangle.
var $19ed5ac92d0c9dbe$var$emptyRect = $19ed5ac92d0c9dbe$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $19ed5ac92d0c9dbe$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $19ed5ac92d0c9dbe$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $19ed5ac92d0c9dbe$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $19ed5ac92d0c9dbe$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $19ed5ac92d0c9dbe$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $19ed5ac92d0c9dbe$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $19ed5ac92d0c9dbe$var$emptyRect;
    var styles = $19ed5ac92d0c9dbe$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $19ed5ac92d0c9dbe$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $19ed5ac92d0c9dbe$var$toFloat(styles.width), height = $19ed5ac92d0c9dbe$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $19ed5ac92d0c9dbe$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $19ed5ac92d0c9dbe$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$19ed5ac92d0c9dbe$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $19ed5ac92d0c9dbe$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $19ed5ac92d0c9dbe$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $19ed5ac92d0c9dbe$var$isDocumentElement(target) {
    return target === $19ed5ac92d0c9dbe$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$getContentRect(target) {
    if (!$19ed5ac92d0c9dbe$var$isBrowser) return $19ed5ac92d0c9dbe$var$emptyRect;
    if ($19ed5ac92d0c9dbe$var$isSVGGraphicsElement(target)) return $19ed5ac92d0c9dbe$var$getSVGContentRect(target);
    return $19ed5ac92d0c9dbe$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $19ed5ac92d0c9dbe$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $19ed5ac92d0c9dbe$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $19ed5ac92d0c9dbe$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $19ed5ac92d0c9dbe$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $19ed5ac92d0c9dbe$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $19ed5ac92d0c9dbe$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $19ed5ac92d0c9dbe$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $19ed5ac92d0c9dbe$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $19ed5ac92d0c9dbe$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $19ed5ac92d0c9dbe$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $19ed5ac92d0c9dbe$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $19ed5ac92d0c9dbe$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $19ed5ac92d0c9dbe$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $19ed5ac92d0c9dbe$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $19ed5ac92d0c9dbe$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $19ed5ac92d0c9dbe$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $19ed5ac92d0c9dbe$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $19ed5ac92d0c9dbe$var$ResizeObserverController.getInstance();
        var observer = new $19ed5ac92d0c9dbe$var$ResizeObserverSPI(callback, controller, this);
        $19ed5ac92d0c9dbe$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $19ed5ac92d0c9dbe$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $19ed5ac92d0c9dbe$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $19ed5ac92d0c9dbe$var$index = function() {
    // Export existing implementation if available.
    if (typeof $19ed5ac92d0c9dbe$var$global$1.ResizeObserver !== "undefined") return $19ed5ac92d0c9dbe$var$global$1.ResizeObserver;
    return $19ed5ac92d0c9dbe$var$ResizeObserver;
}();
var $19ed5ac92d0c9dbe$export$2e2bcd8739ae039 = $19ed5ac92d0c9dbe$var$index;

});


parcelRequire.register("d1b3p", function(module, exports) {

var $33zBk = parcelRequire("33zBk");
var $97a3f16d142745ed$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $97a3f16d142745ed$var$obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $33zBk(feature);
        // Add px to dimension features
        if ($97a3f16d142745ed$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $97a3f16d142745ed$var$json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $97a3f16d142745ed$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $97a3f16d142745ed$var$obj2mq(query);
};
module.exports = $97a3f16d142745ed$var$json2mq;

});
parcelRequire.register("33zBk", function(module, exports) {
var $239d448e3616a878$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $239d448e3616a878$var$camel2hyphen;

});


parcelRequire.register("3CQWE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2a3dfd791857b8ef$var$_react = $2a3dfd791857b8ef$var$_interopRequireDefault((parcelRequire("7fPBF")));
function $2a3dfd791857b8ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $2a3dfd791857b8ef$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $2a3dfd791857b8ef$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $2a3dfd791857b8ef$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true
};
var $2a3dfd791857b8ef$var$_default = $2a3dfd791857b8ef$var$defaultProps;
module.exports["default"] = $2a3dfd791857b8ef$var$_default;

});

parcelRequire.register("azLOe", function(module, exports) {

var $2XB8U = parcelRequire("2XB8U");
module.exports = new $2XB8U();

});
parcelRequire.register("2XB8U", function(module, exports) {

var $iaCqa = parcelRequire("iaCqa");

var $i440G = parcelRequire("i440G");
var $227de73c887ebcc2$var$each = $i440G.each;
var $227de73c887ebcc2$var$isFunction = $i440G.isFunction;
var $227de73c887ebcc2$var$isArray = $i440G.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $227de73c887ebcc2$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia("only all").matches;
}
$227de73c887ebcc2$var$MediaQueryDispatch.prototype = {
    constructor: $227de73c887ebcc2$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $iaCqa(q, isUnconditional);
        //normalise to object in an array
        if ($227de73c887ebcc2$var$isFunction(options)) options = {
            match: options
        };
        if (!$227de73c887ebcc2$var$isArray(options)) options = [
            options
        ];
        $227de73c887ebcc2$var$each(options, function(handler) {
            if ($227de73c887ebcc2$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $227de73c887ebcc2$var$MediaQueryDispatch;

});
parcelRequire.register("iaCqa", function(module, exports) {

var $2ljdv = parcelRequire("2ljdv");

var $i440G = parcelRequire("i440G");
var $d3a6f6c4c4c485a2$require$each = $i440G.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $d3a6f6c4c4c485a2$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$d3a6f6c4c4c485a2$var$MediaQuery.prototype = {
    constuctor: $d3a6f6c4c4c485a2$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function(handler) {
        var qh = new $2ljdv(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function(handler) {
        var handlers = this.handlers;
        $d3a6f6c4c4c485a2$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function() {
        $d3a6f6c4c4c485a2$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function() {
        var action = this.matches() ? "on" : "off";
        $d3a6f6c4c4c485a2$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $d3a6f6c4c4c485a2$var$MediaQuery;

});
parcelRequire.register("2ljdv", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $1b4c72fe89c8d6ba$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$1b4c72fe89c8d6ba$var$QueryHandler.prototype = {
    constructor: $1b4c72fe89c8d6ba$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $1b4c72fe89c8d6ba$var$QueryHandler;

});

parcelRequire.register("i440G", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $d26bb6085250209f$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $d26bb6085250209f$var$isArray(target) {
    return Object.prototype.toString.apply(target) === "[object Array]";
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $d26bb6085250209f$var$isFunction(target) {
    return typeof target === "function";
}
module.exports = {
    isFunction: $d26bb6085250209f$var$isFunction,
    isArray: $d26bb6085250209f$var$isArray,
    each: $d26bb6085250209f$var$each
};

});





parcelRequire.register("hC78m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd2b84e36aef1fba$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b5EKA = parcelRequire("b5EKA");

var $2jx1n = parcelRequire("2jx1n");

var $jHiZl = parcelRequire("jHiZl");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $cd2b84e36aef1fba$var$_excluded = [
    "className",
    "row"
];
const $cd2b84e36aef1fba$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $b5EKA.getFormGroupUtilityClass), classes);
};
const $cd2b84e36aef1fba$var$FormGroupRoot = (0, $kDBhE.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $cd2b84e36aef1fba$var$FormGroup = /*#__PURE__*/ $7fPBF.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $cFLic.default)(props, $cd2b84e36aef1fba$var$_excluded);
    const muiFormControl = (0, $2jx1n.default)();
    const fcs = (0, $jHiZl.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $cd2b84e36aef1fba$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($cd2b84e36aef1fba$var$FormGroupRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $cd2b84e36aef1fba$export$2e2bcd8739ae039 = $cd2b84e36aef1fba$var$FormGroup;

});
parcelRequire.register("b5EKA", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", function () { return $812fc58290adb713$export$d72d4cbdc30b331f; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $812fc58290adb713$export$d72d4cbdc30b331f(slot) {
    return (0, $k6RDS.default)("MuiFormGroup", slot);
}
const $812fc58290adb713$var$formGroupClasses = (0, $4jzsB.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $812fc58290adb713$export$2e2bcd8739ae039 = $812fc58290adb713$var$formGroupClasses;

});


parcelRequire.register("j4xM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de28970229c88fa7$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $93Yyz = parcelRequire("93Yyz");

var $5j2OD = parcelRequire("5j2OD");

var $cWiZV = parcelRequire("cWiZV");

var $b6UUh = parcelRequire("b6UUh");

var $1eJd4 = parcelRequire("1eJd4");

var $ggX67 = parcelRequire("ggX67");

var $k3Hy8 = parcelRequire("k3Hy8");

var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $de28970229c88fa7$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $de28970229c88fa7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $b6UUh.default)(color)}`
        ]
    };
    return (0, $kY3Ke.default)({}, classes, (0, $cFCqu.default)(slots, (0, $k3Hy8.getRadioUtilityClass), classes));
};
const $de28970229c88fa7$var$RadioRoot = (0, $kDBhE.default)((0, $93Yyz.default), {
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $cxeT8.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $k3Hy8.default).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $k3Hy8.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $de28970229c88fa7$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $de28970229c88fa7$var$defaultCheckedIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cWiZV.default), {
    checked: true
});
const $de28970229c88fa7$var$defaultIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cWiZV.default), {});
const $de28970229c88fa7$var$Radio = /*#__PURE__*/ $7fPBF.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $de28970229c88fa7$var$defaultCheckedIcon, color: color = "primary", icon: icon = $de28970229c88fa7$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $cFLic.default)(props, $de28970229c88fa7$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $de28970229c88fa7$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $ggX67.default)();
    let checked = checkedProp;
    const onChange = (0, $1eJd4.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $de28970229c88fa7$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($de28970229c88fa7$var$RadioRoot, (0, $kY3Ke.default)({
        type: "radio",
        icon: /*#__PURE__*/ $7fPBF.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $de28970229c88fa7$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $7fPBF.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $de28970229c88fa7$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $de28970229c88fa7$export$2e2bcd8739ae039 = $de28970229c88fa7$var$Radio;

});
parcelRequire.register("cWiZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96b9a35dc7d8e11f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $eNTdL = parcelRequire("eNTdL");

var $4ILFC = parcelRequire("4ILFC");

var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $96b9a35dc7d8e11f$var$RadioButtonIconRoot = (0, $kDBhE.default)("span")({
    position: "relative",
    display: "flex"
});
const $96b9a35dc7d8e11f$var$RadioButtonIconBackground = (0, $kDBhE.default)((0, $eNTdL.default))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $96b9a35dc7d8e11f$var$RadioButtonIconDot = (0, $kDBhE.default)((0, $4ILFC.default))(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $96b9a35dc7d8e11f$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($96b9a35dc7d8e11f$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($96b9a35dc7d8e11f$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($96b9a35dc7d8e11f$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $96b9a35dc7d8e11f$export$2e2bcd8739ae039 = $96b9a35dc7d8e11f$var$RadioButtonIcon;

});
parcelRequire.register("eNTdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac707a057545a407$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $ac707a057545a407$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");

});

parcelRequire.register("4ILFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37003fd2171922a7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $37003fd2171922a7$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");

});


parcelRequire.register("1eJd4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e6a2af606f99b7f$export$2e2bcd8739ae039; });

var $bHAwn = parcelRequire("bHAwn");
var $0e6a2af606f99b7f$export$2e2bcd8739ae039 = (0, $bHAwn.default);

});

parcelRequire.register("ggX67", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8bfb8e1742ab4f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $b9Y4V = parcelRequire("b9Y4V");
"use client";
function $bd8bfb8e1742ab4f$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $b9Y4V.default));
}

});
parcelRequire.register("b9Y4V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81ff23480207fa97$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $81ff23480207fa97$var$RadioGroupContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $81ff23480207fa97$export$2e2bcd8739ae039 = $81ff23480207fa97$var$RadioGroupContext;

});


parcelRequire.register("k3Hy8", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", function () { return $e9a5de8192a35b89$export$192f7b2363c77155; });
$parcel$export(module.exports, "default", function () { return $e9a5de8192a35b89$export$2e2bcd8739ae039; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e9a5de8192a35b89$export$192f7b2363c77155(slot) {
    return (0, $k6RDS.default)("MuiRadio", slot);
}
const $e9a5de8192a35b89$var$radioClasses = (0, $4jzsB.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary"
]);
var $e9a5de8192a35b89$export$2e2bcd8739ae039 = $e9a5de8192a35b89$var$radioClasses;

});


parcelRequire.register("joOxH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1f776e3a27ad5dc$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hC78m = parcelRequire("hC78m");

var $6NwTb = parcelRequire("6NwTb");

var $568MF = parcelRequire("568MF");

var $b9Y4V = parcelRequire("b9Y4V");

var $bwizY = parcelRequire("bwizY");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e1f776e3a27ad5dc$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $e1f776e3a27ad5dc$var$RadioGroup = /*#__PURE__*/ $7fPBF.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $cFLic.default)(props, $e1f776e3a27ad5dc$var$_excluded);
    const rootRef = $7fPBF.useRef(null);
    const [value, setValueState] = (0, $568MF.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $7fPBF.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $6NwTb.default)(ref, rootRef);
    const name = (0, $bwizY.default)(nameProp);
    const contextValue = $7fPBF.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b9Y4V.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hC78m.default), (0, $kY3Ke.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $e1f776e3a27ad5dc$export$2e2bcd8739ae039 = $e1f776e3a27ad5dc$var$RadioGroup;

});
parcelRequire.register("bwizY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8631184a92cee7e5$export$2e2bcd8739ae039; });

var $65Itt = parcelRequire("65Itt");
"use client";
var $8631184a92cee7e5$export$2e2bcd8739ae039 = (0, $65Itt.default);

});


parcelRequire.register("6CVVo", function(module, exports) {

$parcel$export(module.exports, "useReservation", function () { return $adbd02c3e33a6593$export$dba8ba4729e1fba8; });

var $7fPBF = parcelRequire("7fPBF");

var $dNDci = parcelRequire("dNDci");
const $adbd02c3e33a6593$export$dba8ba4729e1fba8 = ()=>{
    const api_service = new (0, $dNDci.AppService)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [booking, setBooking] = (0, $7fPBF.useState)(undefined);
    const fetch_booking = (bookingId)=>{
        api_service.api_getBookingById(bookingId).then((res)=>{
            if (res.status !== 200) throw new Error();
            setBooking(res.data);
        }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
    };
    const setAsDeleted = ()=>{
        setBooking((prev)=>({
                ...prev,
                canceled: true
            }));
    };
    return {
        isLoading: isLoading,
        booking: booking,
        actions: {
            fetch_booking: fetch_booking,
            setAsDeleted: setAsDeleted
        }
    };
};

});

parcelRequire.register("86kTa", function(module, exports) {

$parcel$export(module.exports, "AreasContextProvider", function () { return $93923eb8418ea9b6$export$74233fe1db9fb4e4; });
$parcel$export(module.exports, "useAreas", function () { return $93923eb8418ea9b6$export$1c614defd37d5cae; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $93923eb8418ea9b6$export$d4ab5d2fb4ef05f5;
(function(AreasContextKeys) {
    AreasContextKeys["Area"] = "area";
})($93923eb8418ea9b6$export$d4ab5d2fb4ef05f5 || ($93923eb8418ea9b6$export$d4ab5d2fb4ef05f5 = {}));
const $93923eb8418ea9b6$export$bc3bf3a006458a0e = /*#__PURE__*/ (0, $7fPBF.createContext)({
    area: null,
    setArea: ()=>{},
    isLoading: true,
    setIsLoading: ()=>{},
    activeStep: 0,
    setActiveStep: ()=>{}
});
const $93923eb8418ea9b6$export$74233fe1db9fb4e4 = (props)=>{
    const [area, setArea] = (0, $7fPBF.useState)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [activeStep, setActiveStep] = (0, $7fPBF.useState)(0);
    const values = {
        area: area,
        setArea: setArea,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        activeStep: activeStep,
        setActiveStep: setActiveStep
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($93923eb8418ea9b6$export$bc3bf3a006458a0e.Provider, {
        value: values,
        children: props.children
    });
};
const $93923eb8418ea9b6$export$1c614defd37d5cae = ()=>(0, $7fPBF.useContext)($93923eb8418ea9b6$export$bc3bf3a006458a0e);

});

parcelRequire.register("3rqz0", function(module, exports) {

$parcel$export(module.exports, "FormLabelStyled", function () { return $f255eeaa7b13b528$export$7a27cd4ac3d5dad; });
$parcel$export(module.exports, "StyledFormControl", function () { return $f255eeaa7b13b528$export$a0b9cd92af5af43b; });
$parcel$export(module.exports, "FormLabelDescription", function () { return $f255eeaa7b13b528$export$934da839f509649c; });
$parcel$export(module.exports, "Description", function () { return $f255eeaa7b13b528$export$393edc798c47379d; });
$parcel$export(module.exports, "SelectGrid", function () { return $f255eeaa7b13b528$export$3bb2bce6bb6f0906; });
$parcel$export(module.exports, "StyledContainer", function () { return $f255eeaa7b13b528$export$1d41361302b577a1; });
$parcel$export(module.exports, "StyledErrorBox", function () { return $f255eeaa7b13b528$export$69351aca2b6ab5c3; });
$parcel$export(module.exports, "StyledImageContainer", function () { return $f255eeaa7b13b528$export$1fdc50e443dc776c; });
$parcel$export(module.exports, "StyledButtonBox", function () { return $f255eeaa7b13b528$export$2d8f604653b9bea6; });
$parcel$export(module.exports, "StyledDeleteButton", function () { return $f255eeaa7b13b528$export$e5aa014779ff2b01; });
$parcel$export(module.exports, "StyledScheduleCard", function () { return $f255eeaa7b13b528$export$20a3d001d2891b34; });
$parcel$export(module.exports, "FormBox", function () { return $f255eeaa7b13b528$export$8cd7ca2dd7ba6f89; });
$parcel$export(module.exports, "StyledButton", function () { return $f255eeaa7b13b528$export$2d5d2ba3c7c8c40b; });
$parcel$export(module.exports, "ButtonBox", function () { return $f255eeaa7b13b528$export$5e37f977ae0514c2; });
$parcel$export(module.exports, "StyledSelectControl", function () { return $f255eeaa7b13b528$export$11a57430e0363667; });
$parcel$export(module.exports, "StyledStack", function () { return $f255eeaa7b13b528$export$8a7fb03b17c12e52; });
$parcel$export(module.exports, "ScheduleBox", function () { return $f255eeaa7b13b528$export$b25dd2982af207a6; });
$parcel$export(module.exports, "StyledDateBox", function () { return $f255eeaa7b13b528$export$de99894e40613e75; });
$parcel$export(module.exports, "Title", function () { return $f255eeaa7b13b528$export$f99233281efd08a0; });
$parcel$export(module.exports, "Image", function () { return $f255eeaa7b13b528$export$3e431a229df88919; });
$parcel$export(module.exports, "ScheduleCard", function () { return $f255eeaa7b13b528$export$80a97840e65fb86b; });
$parcel$export(module.exports, "Form", function () { return $f255eeaa7b13b528$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "StyledAppButton", function () { return $f255eeaa7b13b528$export$e3da0e99c81a4b99; });
$parcel$export(module.exports, "Weekday", function () { return $f255eeaa7b13b528$export$94dd8a9f089c7f53; });
$parcel$export(module.exports, "ClosedScheduleCard", function () { return $f255eeaa7b13b528$export$ea9ebdbd1be35aaa; });
$parcel$export(module.exports, "ModalButtons", function () { return $f255eeaa7b13b528$export$84a561cbbd8c1d66; });

var $aili3 = parcelRequire("aili3");
var $5ZeKC = parcelRequire("5ZeKC");
var $3jMGu = parcelRequire("3jMGu");
var $cnEvg = parcelRequire("cnEvg");
var $jh0sD = parcelRequire("jh0sD");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $f255eeaa7b13b528$var$_ = (t)=>t, $f255eeaa7b13b528$var$t, $f255eeaa7b13b528$var$t1, $f255eeaa7b13b528$var$t2, $f255eeaa7b13b528$var$t3, $f255eeaa7b13b528$var$t4, $f255eeaa7b13b528$var$t5, $f255eeaa7b13b528$var$t6, $f255eeaa7b13b528$var$t7, $f255eeaa7b13b528$var$t8, $f255eeaa7b13b528$var$t9, $f255eeaa7b13b528$var$t10, $f255eeaa7b13b528$var$t11, $f255eeaa7b13b528$var$t12, $f255eeaa7b13b528$var$t13, $f255eeaa7b13b528$var$t14, $f255eeaa7b13b528$var$t15, $f255eeaa7b13b528$var$t16, $f255eeaa7b13b528$var$t17, $f255eeaa7b13b528$var$t18, $f255eeaa7b13b528$var$t19, $f255eeaa7b13b528$var$t20, $f255eeaa7b13b528$var$t21, $f255eeaa7b13b528$var$t22, $f255eeaa7b13b528$var$t23, $f255eeaa7b13b528$var$t24, $f255eeaa7b13b528$var$t25, $f255eeaa7b13b528$var$t26, $f255eeaa7b13b528$var$t27, $f255eeaa7b13b528$var$t28;
const $f255eeaa7b13b528$export$7a27cd4ac3d5dad = (0, $6hfZk.default)((0, $cnEvg.default))($f255eeaa7b13b528$var$t || ($f255eeaa7b13b528$var$t = $f255eeaa7b13b528$var$_`
    color: #424242;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0.25px;

    &.Mui-focused {
        color: var(--custom-secondary);
    }

    & .MuiFormLabel-asterisk {
        color: red;
    }
`));
const $f255eeaa7b13b528$export$a0b9cd92af5af43b = (0, $6hfZk.default)((0, $3jMGu.default))($f255eeaa7b13b528$var$t1 || ($f255eeaa7b13b528$var$t1 = $f255eeaa7b13b528$var$_`
    display: grid;
    gap: 16px;
`));
const $f255eeaa7b13b528$export$934da839f509649c = (0, $6hfZk.default)((0, $cnEvg.default))($f255eeaa7b13b528$var$t2 || ($f255eeaa7b13b528$var$t2 = $f255eeaa7b13b528$var$_`
    color: #424242;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;

    &.Mui-focused {
        color: #424242;
    }

    & .MuiFormLabel-asterisk {
        color: red;
    }
`));
const $f255eeaa7b13b528$export$393edc798c47379d = (0, $6hfZk.default).p($f255eeaa7b13b528$var$t3 || ($f255eeaa7b13b528$var$t3 = $f255eeaa7b13b528$var$_`
    color: #424242;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    margin: 0;

    @media (min-width: 600px) {
        font-size: 20px;
        margin: 16px 0;
    }
`));
const $f255eeaa7b13b528$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t4 || ($f255eeaa7b13b528$var$t4 = $f255eeaa7b13b528$var$_`
    color: red;
`));
const $f255eeaa7b13b528$export$3bb2bce6bb6f0906 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t5 || ($f255eeaa7b13b528$var$t5 = $f255eeaa7b13b528$var$_`
    display: grid;
    grid-template-columns: 50% auto;
    gap: 8px;
`));
const $f255eeaa7b13b528$export$1d41361302b577a1 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t6 || ($f255eeaa7b13b528$var$t6 = $f255eeaa7b13b528$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`));
const $f255eeaa7b13b528$export$69351aca2b6ab5c3 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t7 || ($f255eeaa7b13b528$var$t7 = $f255eeaa7b13b528$var$_`
    display: flex;
    margin-top: 8px;
`));
const $f255eeaa7b13b528$export$1fdc50e443dc776c = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t8 || ($f255eeaa7b13b528$var$t8 = $f255eeaa7b13b528$var$_`
    display: grid;
    grid-template-columns: 50% auto;
    gap: 5px;
`));
const $f255eeaa7b13b528$export$2d8f604653b9bea6 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t9 || ($f255eeaa7b13b528$var$t9 = $f255eeaa7b13b528$var$_`
    position: relative;
    width: 100%;
`));
const $f255eeaa7b13b528$export$e5aa014779ff2b01 = (0, $6hfZk.default)((0, $5ZeKC.default))($f255eeaa7b13b528$var$t10 || ($f255eeaa7b13b528$var$t10 = $f255eeaa7b13b528$var$_`
    position: absolute !important;
    min-width: auto;
    bottom: 10px;
    right: 10px;
    padding: 5px;
`));
const $f255eeaa7b13b528$export$20a3d001d2891b34 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t11 || ($f255eeaa7b13b528$var$t11 = $f255eeaa7b13b528$var$_`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`));
const $f255eeaa7b13b528$export$8cd7ca2dd7ba6f89 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t12 || ($f255eeaa7b13b528$var$t12 = $f255eeaa7b13b528$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`));
const $f255eeaa7b13b528$export$2d5d2ba3c7c8c40b = (0, $6hfZk.default)((0, $dkKmP.AppButton)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isHidden"
})($f255eeaa7b13b528$var$t13 || ($f255eeaa7b13b528$var$t13 = $f255eeaa7b13b528$var$_`
    display: ${0};
`), ({ isHidden: isHidden })=>isHidden ? "none" : "flex");
const $f255eeaa7b13b528$export$5e37f977ae0514c2 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t14 || ($f255eeaa7b13b528$var$t14 = $f255eeaa7b13b528$var$_`
    display: flex;
    gap: 6px;
`));
const $f255eeaa7b13b528$export$5ac7b85d728a3568 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t15 || ($f255eeaa7b13b528$var$t15 = $f255eeaa7b13b528$var$_`
    display: grid;
    gap: 8px;
    padding: 16px;
    background-color: #f1f1f1;
    border-radius: 4px;
`));
const $f255eeaa7b13b528$export$11a57430e0363667 = (0, $6hfZk.default)((0, $3jMGu.default))($f255eeaa7b13b528$var$t16 || ($f255eeaa7b13b528$var$t16 = $f255eeaa7b13b528$var$_`
    width: 100%;
`));
const $f255eeaa7b13b528$export$8a7fb03b17c12e52 = (0, $6hfZk.default).div($f255eeaa7b13b528$var$t17 || ($f255eeaa7b13b528$var$t17 = $f255eeaa7b13b528$var$_`
    display: flex;
    flex-direction: column;
    gap: 32px;
`));
const $f255eeaa7b13b528$export$b25dd2982af207a6 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t18 || ($f255eeaa7b13b528$var$t18 = $f255eeaa7b13b528$var$_`
    display: grid;
    grid-template-columns: 33% 33% 33%;
    gap: 16px;

    @media (max-width: 600px) {
        grid-template-columns: auto;
    }
`));
const $f255eeaa7b13b528$export$de99894e40613e75 = (0, $6hfZk.default)((0, $aili3.default))($f255eeaa7b13b528$var$t19 || ($f255eeaa7b13b528$var$t19 = $f255eeaa7b13b528$var$_`
    display: grid;
    gap: 1rem;
    grid-template-columns: 50% auto;

    @media (max-width: 600px) {
        grid-template-columns: auto;
    }
`));
const $f255eeaa7b13b528$export$f99233281efd08a0 = (0, $6hfZk.default).p($f255eeaa7b13b528$var$t20 || ($f255eeaa7b13b528$var$t20 = $f255eeaa7b13b528$var$_`
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    text-align: center;
`));
const $f255eeaa7b13b528$export$3d1b056be7d139f4 = (0, $6hfZk.default)((0, $jh0sD.default))($f255eeaa7b13b528$var$t21 || ($f255eeaa7b13b528$var$t21 = $f255eeaa7b13b528$var$_`
    background-color: #fff;
    width: 100%;

    & .MuiOutlinedInput-notchedOutline {
        border-color: transparent !important;
        box-shadow: var(--default-boxShadow);
    }

    & .Mui-error {
        border: 1px solid red;
        background: #ffebee;
    }
`));
const $f255eeaa7b13b528$export$3e431a229df88919 = (0, $6hfZk.default).img($f255eeaa7b13b528$var$t22 || ($f255eeaa7b13b528$var$t22 = $f255eeaa7b13b528$var$_`
    width: 100%;
    height: 100%;
    max-height: 350px;
    object-fit: cover;
`));
const $f255eeaa7b13b528$export$80a97840e65fb86b = (0, $6hfZk.default).div($f255eeaa7b13b528$var$t23 || ($f255eeaa7b13b528$var$t23 = $f255eeaa7b13b528$var$_`
    padding: 16px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
`));
const $f255eeaa7b13b528$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($f255eeaa7b13b528$var$t24 || ($f255eeaa7b13b528$var$t24 = $f255eeaa7b13b528$var$_`
    display: flex;
    flex-direction: column;
    gap: 20px;
`));
const $f255eeaa7b13b528$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($f255eeaa7b13b528$var$t25 || ($f255eeaa7b13b528$var$t25 = $f255eeaa7b13b528$var$_`
    display: flex;
    justify-content: end;
    padding: 0;
`));
const $f255eeaa7b13b528$export$94dd8a9f089c7f53 = (0, $6hfZk.default).div($f255eeaa7b13b528$var$t26 || ($f255eeaa7b13b528$var$t26 = $f255eeaa7b13b528$var$_`
    font-size: 14px;
    text-transform: uppercase;
    color: var(--color-primary);
`));
const $f255eeaa7b13b528$export$ea9ebdbd1be35aaa = (0, $6hfZk.default).div($f255eeaa7b13b528$var$t27 || ($f255eeaa7b13b528$var$t27 = $f255eeaa7b13b528$var$_`
    padding: 0;
`));
const $f255eeaa7b13b528$export$84a561cbbd8c1d66 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($f255eeaa7b13b528$var$t28 || ($f255eeaa7b13b528$var$t28 = $f255eeaa7b13b528$var$_`
    width: 100%;
`));

});

parcelRequire.register("EOZxw", function(module, exports) {

module.exports = import("./" + (parcelRequire("4SSe9")).resolve("789Tz")).then(()=>parcelRequire("fwBwG"));

});

parcelRequire.register("97h5N", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("4SSe9")).resolve("bEJxq")),
    import("./" + (parcelRequire("4SSe9")).resolve("aGogQ"))
]).then(()=>parcelRequire("gDrqa"));

});

parcelRequire.register("frhhm", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("4SSe9")).resolve("bEJxq")),
    import("./" + (parcelRequire("4SSe9")).resolve("6iP4e"))
]).then(()=>parcelRequire("gDKoO"));

});

parcelRequire.register("14MaG", function(module, exports) {

module.exports = import("./" + (parcelRequire("4SSe9")).resolve("fJvph")).then(()=>parcelRequire("9VIyL"));

});

parcelRequire.register("b72qa", function(module, exports) {

module.exports = import("./" + (parcelRequire("4SSe9")).resolve("1LIp3")).then(()=>parcelRequire("cW9ZE"));

});

parcelRequire.register("7I5on", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $59d0d34335a132ed$var$_gtag = $59d0d34335a132ed$var$_interopRequireDefault((parcelRequire("ccbX0")));

var $59d0d34335a132ed$var$_format = $59d0d34335a132ed$var$_interopRequireDefault((parcelRequire("jnTW5")));
var $59d0d34335a132ed$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $59d0d34335a132ed$var$_excluded2 = [
    "title",
    "location"
], $59d0d34335a132ed$var$_excluded3 = [
    "page",
    "hitType"
];
function $59d0d34335a132ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $59d0d34335a132ed$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $59d0d34335a132ed$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $59d0d34335a132ed$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $59d0d34335a132ed$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $59d0d34335a132ed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $59d0d34335a132ed$var$_typeof(obj);
}
function $59d0d34335a132ed$var$_toConsumableArray(arr) {
    return $59d0d34335a132ed$var$_arrayWithoutHoles(arr) || $59d0d34335a132ed$var$_iterableToArray(arr) || $59d0d34335a132ed$var$_unsupportedIterableToArray(arr) || $59d0d34335a132ed$var$_nonIterableSpread();
}
function $59d0d34335a132ed$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $59d0d34335a132ed$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $59d0d34335a132ed$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $59d0d34335a132ed$var$_arrayLikeToArray(arr);
}
function $59d0d34335a132ed$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $59d0d34335a132ed$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $59d0d34335a132ed$var$ownKeys(Object(source), !0).forEach(function(key) {
            $59d0d34335a132ed$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $59d0d34335a132ed$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $59d0d34335a132ed$var$_slicedToArray(arr, i) {
    return $59d0d34335a132ed$var$_arrayWithHoles(arr) || $59d0d34335a132ed$var$_iterableToArrayLimit(arr, i) || $59d0d34335a132ed$var$_unsupportedIterableToArray(arr, i) || $59d0d34335a132ed$var$_nonIterableRest();
}
function $59d0d34335a132ed$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $59d0d34335a132ed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $59d0d34335a132ed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $59d0d34335a132ed$var$_arrayLikeToArray(o, minLen);
}
function $59d0d34335a132ed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $59d0d34335a132ed$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $59d0d34335a132ed$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $59d0d34335a132ed$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $59d0d34335a132ed$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $59d0d34335a132ed$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $59d0d34335a132ed$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $59d0d34335a132ed$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $59d0d34335a132ed$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $59d0d34335a132ed$var$_defineProperty(obj, key, value) {
    key = $59d0d34335a132ed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $59d0d34335a132ed$var$_toPropertyKey(arg) {
    var key = $59d0d34335a132ed$var$_toPrimitive(arg, "string");
    return $59d0d34335a132ed$var$_typeof(key) === "symbol" ? key : String(key);
}
function $59d0d34335a132ed$var$_toPrimitive(input, hint) {
    if ($59d0d34335a132ed$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($59d0d34335a132ed$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $59d0d34335a132ed$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $59d0d34335a132ed$var$_classCallCheck(this, GA4);
        $59d0d34335a132ed$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $59d0d34335a132ed$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $59d0d34335a132ed$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $59d0d34335a132ed$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread({}, _this._toGtagOptions($59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $59d0d34335a132ed$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $59d0d34335a132ed$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($59d0d34335a132ed$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $59d0d34335a132ed$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $59d0d34335a132ed$var$_objectWithoutProperties(_args$, $59d0d34335a132ed$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $59d0d34335a132ed$var$_objectWithoutProperties(_this$_toGtagOptions, $59d0d34335a132ed$var$_excluded2);
                _this._gtag("event", "page_view", $59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread($59d0d34335a132ed$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $59d0d34335a132ed$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $59d0d34335a132ed$var$_objectWithoutProperties(_args$2, $59d0d34335a132ed$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $59d0d34335a132ed$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $59d0d34335a132ed$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $59d0d34335a132ed$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $59d0d34335a132ed$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $59d0d34335a132ed$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $59d0d34335a132ed$var$_format["default"])(category),
                    eventAction: (0, $59d0d34335a132ed$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $59d0d34335a132ed$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $59d0d34335a132ed$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $59d0d34335a132ed$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $59d0d34335a132ed$var$GA4;
var $59d0d34335a132ed$var$_default = new $59d0d34335a132ed$var$GA4();
module.exports["default"] = $59d0d34335a132ed$var$_default;

});
parcelRequire.register("ccbX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $8e0fe02dd3d87e71$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $8e0fe02dd3d87e71$var$_default = $8e0fe02dd3d87e71$var$gtag;
module.exports["default"] = $8e0fe02dd3d87e71$var$_default;

});

parcelRequire.register("jnTW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e1cb8dfd668c3b27$var$format;
var $e1cb8dfd668c3b27$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $e1cb8dfd668c3b27$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($e1cb8dfd668c3b27$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $e1cb8dfd668c3b27$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $e1cb8dfd668c3b27$var$redacted = "REDACTED (Potential Email Address)";
function $e1cb8dfd668c3b27$var$redactEmail(string) {
    if ($e1cb8dfd668c3b27$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $e1cb8dfd668c3b27$var$redacted;
    }
    return string;
}
function $e1cb8dfd668c3b27$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $e1cb8dfd668c3b27$var$toTitleCase(s);
    if (redactingEmail) _str = $e1cb8dfd668c3b27$var$redactEmail(_str);
    return _str;
}

});



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
"use strict";

var $fw0lo = parcelRequire("fw0lo");
var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $fw0lo.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $fw0lo.hydrateRoot;



var $2Bwgd = parcelRequire("2Bwgd");
function $5e94ee2b5c33482b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5e94ee2b5c33482b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5e94ee2b5c33482b$var$_typeof(obj);
}
var $5e94ee2b5c33482b$var$arr = [];
var $5e94ee2b5c33482b$var$each = $5e94ee2b5c33482b$var$arr.forEach;
var $5e94ee2b5c33482b$var$slice = $5e94ee2b5c33482b$var$arr.slice;
function $5e94ee2b5c33482b$export$ebe90cb607ad99e(obj) {
    $5e94ee2b5c33482b$var$each.call($5e94ee2b5c33482b$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $5e94ee2b5c33482b$export$87022daa49baf612() {
    return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $5e94ee2b5c33482b$var$_typeof(XMLHttpRequest)) === "object";
}
function $5e94ee2b5c33482b$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
function $5e94ee2b5c33482b$export$1625492ec82002b9(maybePromise) {
    if ($5e94ee2b5c33482b$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $8ac3c7fe865e4864$exports = {};
var $8ac3c7fe865e4864$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $8ac3c7fe865e4864$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $8ac3c7fe865e4864$var$fetchApi = window.fetch;
    else $8ac3c7fe865e4864$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $8ac3c7fe865e4864$var$f = $8ac3c7fe865e4864$var$fetchApi || (parcelRequire("fVMg8"));
    if ($8ac3c7fe865e4864$var$f.default) $8ac3c7fe865e4864$var$f = $8ac3c7fe865e4864$var$f.default;
    $8ac3c7fe865e4864$exports.default = $8ac3c7fe865e4864$var$f;
    $8ac3c7fe865e4864$exports = $8ac3c7fe865e4864$exports.default;
}


function $115a9e8b8151a003$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $115a9e8b8151a003$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $115a9e8b8151a003$var$_typeof(obj);
}
var $115a9e8b8151a003$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $115a9e8b8151a003$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $115a9e8b8151a003$var$fetchApi = window.fetch;
    else $115a9e8b8151a003$var$fetchApi = fetch;
}
var $115a9e8b8151a003$var$XmlHttpRequestApi;
if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $115a9e8b8151a003$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $115a9e8b8151a003$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $115a9e8b8151a003$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$115a9e8b8151a003$var$fetchApi && $8ac3c7fe865e4864$exports && !$115a9e8b8151a003$var$XmlHttpRequestApi && !$115a9e8b8151a003$var$ActiveXObjectApi) $115a9e8b8151a003$var$fetchApi = $8ac3c7fe865e4864$exports.default || $8ac3c7fe865e4864$exports;
if (typeof $115a9e8b8151a003$var$fetchApi !== "function") $115a9e8b8151a003$var$fetchApi = undefined;
var $115a9e8b8151a003$var$addQueryString = function addQueryString(url, params) {
    if (params && $115a9e8b8151a003$var$_typeof(params) === "object") {
        var queryString = "";
        for(var paramName in params)queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
var $115a9e8b8151a003$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    $115a9e8b8151a003$var$fetchApi(url, fetchOptions).then(function(response) {
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    }).catch(callback);
};
var $115a9e8b8151a003$var$omitFetchOptions = false;
var $115a9e8b8151a003$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $5e94ee2b5c33482b$export$ebe90cb607ad99e)({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
    if (payload) headers["Content-Type"] = "application/json";
    var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $5e94ee2b5c33482b$export$ebe90cb607ad99e)({
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $115a9e8b8151a003$var$omitFetchOptions ? {} : reqOptions);
    try {
        $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $115a9e8b8151a003$var$fetchIt(url, fetchOptions, callback);
            $115a9e8b8151a003$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $115a9e8b8151a003$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $115a9e8b8151a003$var$_typeof(payload) === "object") payload = $115a9e8b8151a003$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $115a9e8b8151a003$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($115a9e8b8151a003$var$XmlHttpRequestApi) x = new $115a9e8b8151a003$var$XmlHttpRequestApi();
        else x = new $115a9e8b8151a003$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        var h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $115a9e8b8151a003$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($115a9e8b8151a003$var$fetchApi && url.indexOf("file:") !== 0) return $115a9e8b8151a003$var$requestWithFetch(options, url, payload, callback);
    if ((0, $5e94ee2b5c33482b$export$87022daa49baf612)() || typeof ActiveXObject === "function") return $115a9e8b8151a003$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $115a9e8b8151a003$export$2e2bcd8739ae039 = $115a9e8b8151a003$var$request;


function $fcb831e2a23edeea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fcb831e2a23edeea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fcb831e2a23edeea$var$_typeof(obj);
}
function $fcb831e2a23edeea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fcb831e2a23edeea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fcb831e2a23edeea$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fcb831e2a23edeea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fcb831e2a23edeea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcb831e2a23edeea$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fcb831e2a23edeea$var$_defineProperty(obj, key, value) {
    key = $fcb831e2a23edeea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fcb831e2a23edeea$var$_toPropertyKey(arg) {
    var key = $fcb831e2a23edeea$var$_toPrimitive(arg, "string");
    return $fcb831e2a23edeea$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fcb831e2a23edeea$var$_toPrimitive(input, hint) {
    if ($fcb831e2a23edeea$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fcb831e2a23edeea$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $fcb831e2a23edeea$var$getDefaults = function getDefaults() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        allowMultiLoading: false,
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $fcb831e2a23edeea$var$_defineProperty({}, key, fallbackValue || "");
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $115a9e8b8151a003$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $fcb831e2a23edeea$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $fcb831e2a23edeea$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    $fcb831e2a23edeea$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $5e94ee2b5c33482b$export$ebe90cb607ad99e)(options, this.options || {}, $fcb831e2a23edeea$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $5e94ee2b5c33482b$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join("+"),
                        ns: namespaces.join("+")
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === "string" ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === "string" ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url + "; status code: " + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url + "; status code: " + res.status, false);
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url + ": " + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === "string") ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === "string") languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === "function") addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === "function") callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$fcb831e2a23edeea$var$Backend.type = "backend";
var $fcb831e2a23edeea$export$2e2bcd8739ae039 = $fcb831e2a23edeea$var$Backend;


function $009b183922525d46$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}



function $27f18dd8fc16da3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $505ebcb184373782$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $505ebcb184373782$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $7fddabb4b045308c$export$2e2bcd8739ae039(t) {
    var i = (0, $27f18dd8fc16da3b$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $505ebcb184373782$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $381be8fad7784fe9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $381be8fad7784fe9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $381be8fad7784fe9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


var $f73f86de2138df56$var$arr = [];
var $f73f86de2138df56$var$each = $f73f86de2138df56$var$arr.forEach;
var $f73f86de2138df56$var$slice = $f73f86de2138df56$var$arr.slice;
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$each.call($f73f86de2138df56$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $f73f86de2138df56$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $f73f86de2138df56$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $f73f86de2138df56$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $f73f86de2138df56$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hasLocalStorageSupport = null;
var $f73f86de2138df56$var$localStorageAvailable = function localStorageAvailable() {
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $f73f86de2138df56$var$hasSessionStorageSupport = null;
var $f73f86de2138df56$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $f73f86de2138df56$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $f73f86de2138df56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace("-", "_");
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($f73f86de2138df56$var$cookie$1);
                this.addDetector($f73f86de2138df56$var$querystring);
                this.addDetector($f73f86de2138df56$var$localStorage);
                this.addDetector($f73f86de2138df56$var$sessionStorage);
                this.addDetector($f73f86de2138df56$var$navigator$1);
                this.addDetector($f73f86de2138df56$var$htmlTag);
                this.addDetector($f73f86de2138df56$var$path);
                this.addDetector($f73f86de2138df56$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$f73f86de2138df56$export$2e2bcd8739ae039.type = "languageDetector";


parcelRequire("3GBGj");
var $NDJJg = parcelRequire("NDJJg");
var $312aabd780fb2656$exports = {};
var $ff0b6f62bfc1762d$exports = {};
$ff0b6f62bfc1762d$exports = JSON.parse('{"welcome":"Welcome!","generalError":"Something unexpected happened. Please try again.","and":"and","or":"or","error":"Error","less":"Less","more":"More","price":"Price","back":"Back","iban":"IBAN","bic":"BIC/SWIFT","email":"E-mail","continue":"Continue","finish":"Finish","return":"Return","cancel":"Cancel","canceled":"Canceled","contact":"Contact","query":"Query","stop":"Stop","stopped":"Closed","duplicate":"Duplicate","filter":"Filter","delete":"Delete","details":"Details","termsAndConditions":"Terms & Conditions","pageNotFound":"Oops, the page you were looking for does not exist.","goToHomepage":"Go to homepage","signInSignUp":"Sign In/Sign Up","paymentConfirmed":"Payment confirmed","paymentNotConfirmed":"Payment not confirmed","bookings":"Bookings","noBookings":"No bookings","cancelBooking":"Cancel booking","cancelBookingReservation":"Cancel booking {{booking}}","cancelBookingMessage":"An e-mail will be sent to {{clientEmail}} informing about the cancellation of the reservation.","bookingIsPaid":"Booking {{id}} marked as paid.","bookingIsNotPaid":"Booking {{id}} marked as not paid.","newClub":"New sport facility","selectClub":"Select a sport facility:","area":"Area","areasOfClub":"Areas of sports facility","noAreas":"No areas","newArea":"New area","areaIsClosed":"The area is currently closed. Closing period: {{schedule}}","areaDelete":"Delete area","areaDeleteDescription":"If you delete this area, you will automatically cancel all reservations for this area. This action is permanent and cannot be reversed.","scanThisQRCode":"This QR Code allows you to access the booking details.","missingInfo":"Missing information","areasCount":"Number of areas","privacy":"Privacy","environment":"Environment","not_specified":"Any","private":"Private","public":"Public","indoor":"Indoor","outdoor":"Outdoor","clubCreated":"Sports facility successfully created!","createAreaInfo":"Now create an area for each zone of the sports facility with different conditions/prices.","createArea":"Create Area","noClubInfo":"There is no sports facility created. Please create a new sports facility using the + NEW SPORTS FACILITY button.","addContact":"Add contact","bookingDetails":"Detalhes da Reserva","sport":"Sport","day":"Day","schedule":"Schedule","noContactsTitle":"No Contacts","noContactsInfo":"No other contacts created","save":"Save","close":"Close","from":"From","to":"to","password":"Password","alreadyBooked":"Already booked at this time","clubImageDefaultTitle":"Standard photo of the sports facility","availableSlotsMessage":"Get ready for an unforgettable game! \uD83C\uDFC0\uD83C\uDFD3⚽️ Book your timetable and join in the sporting fun.","availableSlotsDate":"\uD83D\uDCC5 Time slots available for: {{date}}","shareAvailableSlotsMessage":"Get ready for an unforgettable game! \uD83C\uDFC0\uD83C\uDFD3⚽️\\nBook your timetable and join in the sporting fun.\\n\\n\uD83D\uDCC5 Time slots available for:\\n{{date}}\\n\\n\uD83D\uDCCD Sports facility:\\n{{clubName}}\\n\\n ⛳️ Area(s):\\n{{area}}\\n\uD83D\uDD17 Visit our website and book now:\\n{{link}} ","shareAvailableSlotsNoSchedulesError":"This area has no time slot available for tomorrow.","fileUploadInput":"Drag \'n\' drop some files here, or click to select files","fileUploadInputRules":"You can only upload a .jpeg or .png image of up to 2MB","fileUploadErrorMaxFiles":"Image limit exceeded. Only one image can be uploaded.","fileUploadErrorMaxSize":"Image too large. Only one image up to 2MB may be uploaded.","cancelBookingAlertMessage":{"200":"Reservation canceled successfully.","403":"You don\'t have permissions to cancel the reservation.","404":"There is no reservation with the indicated number.","500":"An error occurred while canceling your reservation, please try again.","noData":"An unexpected error occurred, please try again."},"newBooking":"New booking","checkout":{"message":"Welcome back! Please log in to proceed with your booking"},"validation":{"requiredPassword":"Password required.","requiredName":"The name field is mandatory.","requiredClubName":"The sport facility name field is mandatory.","requiredValidEmail":"Please enter a valid e-mail.","requiredEmail":"The e-mail field is mandatory.","requiredPhone":"The phone field is mandatory.","requiredValidPhone":"Please enter a valid phone number.","oldPassword":"Old password is required.","newPassword":"New password is required.","confirmPassword":"Password must match","toShort":"Field must have at least {{char}} characters.","toLong":"Field must have a maximum of {{char}} characters.","fiscalNumberOnlyNumber":"The tax number field should only contain digits.","fiscalNumberMinNumber":"The tax number field must have at least 9 digits.","fiscalNumberMaxNumber":"The tax number field must have a maximum of 9 digits.","phoneOnlyNumber":"The mobile phone number field should only contain digits.","invalidPrivacy":"The selected property is invalid.","invalidEnvironment":"AThe selected environment is invalid.","invalidTimeUnit":"The selected time unit is invalid.","requiredField":"This field is required.","requiredPaymentMethod":"You must select the payment method.","requiredTermsAndConditions":"Before proceeding, you must accept the terms and conditions.","requiredMinimumField":"You must select at least one option.","dateTo":"Closing time should be longer than opening time.","minEndDate":"The end date must be greater than the start date.","invalidPassword":"Password is not valid.","requiredValidIban":"Invalid IBAN. Remove spaces and type PT followed by 23 digits.","requiredValidPostalCode":"Invalid postcode. Enter a postcode in the format 0000-000.","invalidSSO":"Verify if the e-mail is being used in another account."},"login":{"forgotPassword":"Forgot password?","login":"Login","loginWithGoogle":"Login with Google","loginWithFacebook":"Login with Facebook","register":"Not registered yet? Create an account","clubAdminLogin":"Club Admin Login","adminLogin":"Admin Login","okButton":"OK","error":{"wrongEmailOrPassword":"Incorrect e-mail or password, please try again."}},"verify":{"verificationCode":"VERIFICATION CODE","errorMessage":"Unverified e-mail! Try again!","successMessage":"Your account has been verified!","okButton":"OK","error":{"notVerified":"Unverified e-mail! Try again!"}},"paymentProof":{"message":{"failedUpload":"The payment receipt has failed to load. Please try again.","successUpload":"Payment proof uploaded successfully."}},"clubAdmin":{"requestAccount":{"title":"Account creation request","adminName":"Name of the sports facility manager","clubName":"Name of the sports facility","email":"E-mail","phone":"Phone number","observations":"Comments","success":"Submission made successfully.","submitButton":"Submit","error":{"onSubmit":"Error submitting form! Try again, please!"}},"recoverPassword":{"title":"Change password","verificationCode":"Verification code","verificationCodeLabel":"Enter the verification code","newPassword":"New password","newPasswordLabel":"Enter the new password","confirmNewPasswordLabel":"Confirm the new password","success":"Password changed successfully.","emailSent":"An e-mail with the verification code for password reset has been sent.","submitButton":"Change password","error":{"passwordNotValid":"Your password must have at least 8 characters, including at least one uppercase and one lowercase letter, a number and a special character.","passwordNotMatching":"The password provided in the two fields is different! Please try again!","onSubmit":"Error submitting form! Please try again!","emailNotSent":"Could not send password reset e-mail. Try again."}},"menu":{"home":"Home","noClubs":"No sports facilities","createClub":"Create sports facility","selectedClub":"Selected sports facility","clubManagement":"Sports facilities management","clubAreas":"Areas","reviews":"Rates","temporaryStop":"Stop temporarily","editAccount":"Edit Account","help":"Help","logout":"Logout","deleteClub":"Delete sports facility","historyData":"History Data","editClub":"Edit sports facility"},"bookings":{"allClubs":"Select sports facility","bookings":"BOOKINGS","noBookings":"Without bookings","noBookingsResult":"There are no bookings made with the search criteria selected.","newBooking":"New booking","allAreas":"All areas","calendarButton":"Calendar","listButton":"List","selectCategory":"Select sports","selectDate":"Select date","selectStartHour":"Select starting hour","timeUnit":"Select time unit","TRINTA_MINUTOS":"30 Minutes","UMA_HORA":"1 Hour","UMA_HORA_TRINTA_MINUTOS":"1 Hour and 30 Minutes","DUAS_HORA":"2 Hours","selectArea":"Select area","selectDay":"Day","selectTime":"Time","showFilterButton":"Filters","selectReservationType":"Select booking type","allReservationType":"All categories","reservationTypes":{"selectReservationType":"Select the booking type","private":"Private","classes":"Classes","classes_pack":"Classes pack","team_building":"Team building","tournament":"Tournament"},"payment":"Proof of payment","inputLabel":{"search":"Booking ID, name or phone contact","clientName":"Client name","clientEmail":"Client e-mail","selectedDay":"Day","selectedTime":"Time","selectedSport":"Sport","reservationType":"Type"},"inputPlaceholder":{"clientName":"Client name","clientEmail":"Client e-mail"},"success":{"201":"{{area}} booked. The {{area}} was reserved on the name of {{clientName}}, in {{day}}, at {{from}}-{{to}}. The confirmation was sent by e-mail to {{email}}.","title":"{{area}} booked"},"error":{"400":"We were unable to process your reservation. Schedules are not defined for this area.","403":"You don\'t have permissions to complete the order.","409":"There is already a booking for the selected time period.","500":"Error. An error occurred while booking, please try again.","noSelectedClubTitle":"Select sports facility","noSelectedClub":"You must select a sports facility in order to proceed with the booking.","scheduleError":"It is not possible to make bookings outside the hours defined in the selected field.","pastDate":"It is not possible to make bookings outside the hours defined in the selected field.","notAreaSelected":"To create a new booking, please select an area in the filters.","invalidInterval":"Time not allowed. Please select intervals of {{time}}.","overlappingEvents":"A valid booking already exists in the selected interval.","noData":"Error. An error occurred while filtering areas, please try again."},"modal":{"title":"Booking details","clientName":"Client name","clientEmail":"Customer e-mail","mobilePhone":"Customer telephone contact","day":"Day","time":"Time","cancelButton":"Cancel booking","reservationTypeUpdateSuccess":"Booking type successfully updated.","reservationTypeUpdateError":"We were unable to update the booking type, please try again."}},"newCalendarBookingModal":{"title":"New booking","description":"Create a new reservation from {{start}} to {{end}}?","bookButton":"Book"},"clubAreas":{"error":{"serverError":"This operation could not be completed. Please try again later.","failedUpload":"Photo upload failed. Please try again.","failedDelete":"The selected photo could not be deleted. Please try again."},"success":{"defaultClubImage":"The standard image of the sports facility has been successfully defined."}},"historyData":{"selectUsers":"Select Users","selectEndDate":"Select end date","selectStartDate":"Select start date","createdBy":"Created by","at":"at","canceledBy":"Canceled by","paidBy":"Paid by","noHistory":"No reservations for this filter.","selectFilterToShowResults":"Apply the desired filters and click on the FILTER button to see the results.","accordionTitle":"History of actions"}},"editAccount":{"username":"Username","phoneNumber":"Mobile phone","fiscalNumber":"Tax number","address":"Address","success":{"changePassword":"Password successfully updated.","userUpdate":"Information successfully updated.","delete":"Account canceled successfully."},"error":{"forbiden":"You don\'t have permissions to change the password.","serverError":"Unable to complete this operation. Please try again later.","userUpdate":"Unable to update your account information. Please try again later."},"emailNote":{"noLink":"To change your e-mail, please ","link":"contact the support team."},"button":{"changePassword":"Change password","deleteAccount":"Delete account","cancel":"Cancel"},"modal":{"delete":{"title":"Delete account","description":"If you delete your Freecourts account, you understand that you will lose access to all future and past bookings and all data entered. This action is permanent and cannot be undone.","helperText":"To confirm account deletion","error":{"wrongPassword":"Incorrect password! Try again!"}},"change":{"title":"Change password","label":{"oldPassword":"Enter the old password.","newPassword":"Enter a new password.","confirmPassword":"Confirm the new password."},"inputLabel":{"newPassword":"New password","oldPassword":"Old password","confirmPassword":"New password"}}}},"searchArea":"Search Area","searchAvailableArea":"Search Available Area","noDataFound":"Nenhum dado encontrado","requiredFields":"Enter all required fields","book":"Book","booking":{"label":{"clubInfo":"Sports facility information","bookingInfo":"Booking information","interested":"Interested","name":"Name","payment":"Bank transfer","acceptance":"I accept the","termsAndConditions":"Terms & Conditions","sportsFacility":"of this sports facility.","priceSummary":"Price summary","details":"Enter your details","total":"Total","includedTaxes":"Includes taxes and fees","publicAreaInfo":"This field is public, it may be busy.","transferObservation":"Mention in the bank transfer notes the ","paymentNote":"IMPORTANT: The deadline for payment and sending the receipt by e-mail is 24 hours, after this period the reservation will be canceled. Confirmation can take up to 2 days.","importantNote":"IMPORTANT: This payment method requires payment and sending the receipt of the bank transfer by e-mail within 24 hours of scheduling the reservation.","reservationNote":"If the reservation has not yet been confirmed by the sports facility, it may be necessary to present receipt of transfer on site.","bookingSuccess":"Reservation process started successfully.","paymentConfirmed":"Reservation payment confirmed.","paymentMethods":"Payment Methods","creditCardNote":"Credit or debit card payments: for greater security, the 3D-Secure authentication system has been reinforced. Confirm your purchase on your mobile phone, via your bank\'s app, or enter the code sent via SMS on the authentication page. For more information, please contact your bank."},"placeholder":{"name":"Insert name","email":"Insert e-mail"},"lockerRoomType":{"both":"Male and female locker rooms","male":"Male locker rooms","female":"Female locker rooms","mixed":"Mixed locker rooms","noLockerRoom":"No locker rooms"},"button":{"book":"Book","shareBooking":"Share booking","next":"Book","share":"Share"},"details":"Booking details","payment":"Payment","paymentDetails":"Payment details","userInfo":"Booker information","nameLabel":"Name","bookings":"See bookings","shareAvailableSlots":"Share available slots"},"timeUnit":"Reserve Unit","priceUnit":"Price per unit","bookArea":"Book area","clubDetails":{"contacts":{"noContactsTitle":"No contacts","noContactsInfo":"No other contacts created","contactList":"Contacts list","message":{"success":"Contact created successfully","deleteSuccess":"Contact deleted successfully","updateSuccess":"Contact updated successfully","error":"Error! Contact could not be created. Please try again later."}},"step":{"label":{"clubData":"Sports facility data","clubPhotos":"Sports facility photos","paymentMethods":"Payment Methods","infrastructures":"Sports facilities","schedules":"Schedules","clubContacts":"Other contacts","clubAddress":"Address of the sports facility"},"inputLabel":{"clubName":"Sports facility name","offersAndNews":"I want to receive exclusive offers and news from the FreeCourts community.","clubPhone":"Telephone","clubMobile":"Mobile","clubAddress":"Address","clubDescription":"Sports facility description","clubPhotos":"Sports facility photos","paymentMethods":"Select all supported payment methods","organizations":"Organizations","contactName":"Name","address":"Address","postalCode":"Zip Code","district":"District","county":"County","lat":"Latitude","lng":"Longitude"},"inputPlaceholder":{"clubName":"Sports facility name","clubEmail":"Sports facility e-mail","clubPhone":"Telephone contact","clubMobile":"Alternative telephone contact","clubAddress":"Address","clubDescription":"Available equipment and indications if they are paid or free.","clubPhotos":"Upload photos","contactName":"Name","address":"Street, avenue, place or road","postalCode":"Zip Code","lat":"Latitude","lng":"Longitude"}},"message":{"getOrganizationsError":"An error occurred when loading the list of organizations.","createOrganizationSuccess":"List of organizations successfully created.","createOrganizationError":"An error occurred when trying to update the list of organizations.","updateOrganizationSuccess":"List of organizations successfully updated.","defaultImage":"After uploading the photos of the sports facility, you can choose the default image by clicking on the image you want."}},"submitSuccess":"Successful submission","search":{"labels":{"sport":"Select the sport","date":"Select the date","startDate":"Start date","endDate":"End date","time":"Select the start time","timeUnit":"Select duration","district":"Select location","clubName":"Search by sports facility name","selectInfrastructure":"Select sports facilities","noInfrastructures":"No options"},"fields":{"sport":"Sport","date":"Date","time":"Start time","endTime":"End time","timeUnit":"Duration","district":"Location","clubName":"Sports facility name"},"sports":{"any":"Any","padel":"Padel","tenis":"Tennis","basquetebol":"Basketball","andebol":"Handball","futebol":"Football","fut7":"Fut7","futsal":"Futsal","squash":"Squash","hoquei_patins":"Roller Hockey","fut5":"Fut5","voleibol":"Volley"},"cta":"Search","errors":{"isRequired":"The field {{field}} is required"}},"clubList":{"book":"Proceed","emptyList":"No sports facilities matching the current search criteria were found","club":{"club_unavailable":"Sports facility unavailable","schedule_error":"Selected date is outside the sports facility regular schedule","closed_schedule_error":"Sports facility will be sporadically closed from {from} to {to}"},"area":{"club_unavailable":"Field unavailable","schedule_error":"Selected date is outside the fields\'s regular schedule","closed_schedule_error":"Field will be sporadically closed from {{from}} to {{to}}"}},"club":{"tabs":{"description":"Description","areas":"Areas"},"headers":{"description":"Description","paymentMethods":"Payment methods","parking":"Parking","lockerooms":"Locker Rooms","schedules":"Schedules","location":"Location","closed":"Closing Dates","sports":"Sports","reservations":"Reservations","priceByTimeUnit":"Price / Time interval","selectAllSportsAvailable":"Select all sports available at the sports facility","whiciSportsOffer":"What sports do you offer?","clubGallery":"Photo gallery"},"paymentMethods":{"emptyList":"There are no payment methods available","cash":"Cash","mbway":"MB Way","credit_card":"Credit Card","bank_transfer":"Bank transfer"},"lockerooms":{"noInformation":"There is no information regarding locker rooms","no_locker_room":"There are no locker rooms","women_locker_room":"There are only women\'s locker rooms","men_locker_room":"There are only mes\'s locker rooms","mixed_locker_room":"Mixed locker rooms","both_locker_room":"Male and female locker rooms"},"parking":{"noInformation":"There is no parking information","none":"There are no parking lots","free":"Free parking","paid":"Paid parking"},"schedules":{"noInformation":"There is no schedule information","weekdays":{"monday":"Monday","tuesday":"Tuesday","wednesday":"Wednesday","thursday":"Thursday","friday":"Friday","saturday":"Saturday","sunday":"Sunday"}},"gallery":{"emptyList":"There are no images of the sports facility to show"},"closed":{"noInformation":"There is no closing information."},"reservations":{"noInformation":"No reservations have been made","success":"Booking successful..","error":"An error occurred while trying to make a booking. Please check that you have timetables created in this area and that the desired booking is within the defined timetable."},"areas":{"noAreas":"There are no available areas for this sports facility.","noCategories":"There are no sports available in this area"},"message":{"deleteClubTitle":"Delete {{club}}","deleteClubDescription":"If you delete this club, you will automatically cancel all reservations for this club. This action is permanent and cannot be reversed."}},"clubAreas":{"step":{"label":{"areaData":"Area Data","areaSports":"Sports offer","areaSportsOffer":"What sports do you offer?","areaSportsSelect":"Select all the sports available in this area","areaPhotos":"Area Photos","areaSchedules":"Schedules","repeatSchedule":"Repeat schedules","activityPeriod":"Activity Period","closedPeriod":"Closing Period"},"inputLabel":{"areaName":"Area name","areaDescription":"Area description","areaPhotos":"Area Photos","areaSchedules":"Set opening and closing times","areaClosedSchedules":"Set the start and end date of the closing period"},"inputPlaceholder":{"areaName":"Area name","areaDescription":"Equipment available, type of flooring, etc...","areaPhotos":"Upload pictures"}},"message":{"noSportInfoTitle":"No sport","noSportInfoDescription":"Selected sport does not exist in this field.","areaScheduleSuccess":"Operation successfully completed.","areaScheduleError":"An error has occurred. Please try again.","schedules":{"409":"J\xe1 existe um hor\xe1rio definido para a hora de abertura e fecho selecionado."},"closedSchedules":{"409":"J\xe1 existe um per\xedodo de encerramento definido para as datas de in\xedcio e de fim selecionadas."}},"allWeekdays":"Todos os dias","timeUnit":"Time unit","newSchedule":"New Schedule","newClosedSchedule":"New Closed Schedule","repeat":"Repeat","startDate":"Start date","endDate":"End date","open":"Opening","close":"Closing","schedules":{"noSchedulesTitle":"No opening schedules","noSchedulesInfo":"There are no timetables created for this area.","noClosedSchedulesTitle":"No closing schedules","noClosedSchedulesInfo":"There are no closure periods created for this area."},"address":{"selectCoordinatesTitle":"Select coordinates","selectCoordinatesInfo":"Select the location of the sports facility on the map to collect the coordinates."}},"register":{"title":"CREATE YOUR ACCOUNT","name":{"label":"Name","required":"Name is required."},"email":{"label":"E-mail","invalid":"The e-mail is invalid.","required":"E-mail is required."},"password":{"invalid":"Your password must have at least 8 characters, including at least one uppercase and one lowercase letter, a number and a special character.","required":"Password is required."},"phone":{"label":"Phone","invalid":"Phone is invalid."},"nif":{"label":"NIF","invalid":"NIF is invalid."},"address":{"label":"Address","invalid":"Address is invalid."},"submitButton":"Create account","success":"Account created successfully.","error":{"409":"The user {{email}}","onSubmit":"Account creation failed. Please, try again."}},"recoverPassword":{"title":"Change password","verificationCode":"Verification code","newPassword":"New password","success":"Password changed successfully.","emailSent":"An e-mail with the verification code for password reset has been sent.","submitButton":"Change password","labels":{"verificationCode":"Enter the verification code","newPassword":"Enter the new password","confirmNewPassword":"Confirm the new password"},"error":{"passwordNotValid":"Your password must have at least 8 characters, including at least one uppercase and one lowercase letter, a number and a special character.","passwordNotMatching":"The password provided in the two fields is different! Please try again!","onSubmit":"Error submitting form! Please, try again.","emailNotSent":"Could not send password reset e-mail. Please, try again."}},"playerMenu":{"home":"Home","editAccount":"Edit Account","help":"Help","logout":"Logout"},"shareBooking":{"bookingOf":"Booking of {{name}}","shareLink":"Share booking link","imInterested":"I\'m interested","imNotInterested":"I\'m not interested","interestedString":{"0":"Be the first to show interest.","2":"{{name1}} and {{name2}} are interested.","3":"{{name1}}, {{name2}} and {{number}} more are interested.","1a":"{{name}} are interested.","1b":"{{name}} is interested."},"shareTitle":"Share the booking","copyLink":"Copy link","copied":"Copied","message":"⚽️ I just made a booking on FreeCourts!\\n\\n\uD83D\uDCC5 At {{date}} we\'ll play {{category}} from {{startTime}} to {{endTime}}.\\n\\n\uD83D\uDCCD Place:\\n- {{clubName}}, {{areaName}}\\n- {{clubAddress}}, {{clubPostalCode}} {{clubCounty}}\\n\\n\uD83D\uDC69‍\uD83D\uDC68‍\uD83D\uDC66‍\uD83D\uDC67 Who already confirmed: {{names}}\\n\\n\uD83D\uDD17 Link for confirmation and see the details:\\n{{url}}","shareMessage":"Share message","shareOnWhatsapp":"Share on Whatsapp","shareOnTwitter":"Share on Twitter","shareOnFacebook":"Share on Facebook"},"firstLogin":{"title":"Change password","description":"For security reasons, you need to change your password.","newPassword":"New password","newPasswordLabel":"Insert new password","confirmNewPasswordLabel":"Confirm the new password","success":"Password changed successfully.","submitButton":"Change password","error":{"passwordNotValid":"Your password must have at least 8 characters, including at least one uppercase and one lowercase letter, a number and a special character.","passwordNotMatching":"The password provided in the two fields is different! Please try again!","onSubmit":"Error submitting form! Please, try again."}},"genericErrors":{"fileSizeExceed":"Selected file size exceed 10mb","maxNumberExceed":"You have exceeded the limit of {{number}} images allowed for upload."},"homepage":{"title":"Search, book and have fun","steps":{"title":"As simple as 1,2,3","search":"Find a place","book":"Book a court","share":"Invite your friends"},"statistics":{"title":"Locations","text":"The municipality of Aveiro has sports pavilions, publicly accessible spaces where you can play sports such as basketball, football, futsal, volleyball and handball, among others. Find a space that suits you and come and play sport.","locations":"Available locations","sports":"Different sports","fun":"Endless fun"},"book":{"title":"Ready to start a game?","bookNow":"Book now"},"advantages":{"title":"Advantages","first_text":"Physical activity is good for the heart, body and mind. When done regularly, it helps reduce the incidence of heart disease and helps with symptoms of depression and anxiety.","first_subtext":"WHO guidelines via fundacaodesporto.pt","second_text":"Alternating between moderate and high-intensity sports helps to maximise the benefits of sport. There is a need to practise different types of sport.","second_subtext":"WHO guidelines via fundacaodesporto.pt","third_text":"A citizen\'s level of personal and social responsibility increases when there is a positive attitude towards competitive group sports.","third_subtext":"Ul-FMH PhD dissertation"},"footer":{"courts":"Courts","sports":"Sports","tennis":"Tennis","basketball":"Basketball","soccer":"Soccer","volleyball":"Volleyball","padel":"Padel","futsal":"Futsal","help":"Help"}}}');


var $83e328ec989cd256$exports = {};
$83e328ec989cd256$exports = JSON.parse('{"welcome":"Bem-Vindo!","generalError":"Aconteceu algo inesperado. Por favor, tente novamente.","and":"e","or":"ou","error":"Erro","less":"Menos","more":"Mais","price":"Pre\xe7o","back":"Retroceder","iban":"IBAN","bic":"BIC/SWIFT","email":"E-mail","continue":"Seguinte","finish":"Terminar","return":"Retroceder","cancel":"Cancelar","canceled":"Cancelada","contact":"Contactar","query":"Consulta","stop":"Parar","stopped":"Parada","duplicate":"Duplicar","filter":"Filtrar","delete":"Apagar","details":"Detalhes","termsAndConditions":"Termos & Condi\xe7\xf5es","pageNotFound":"Oops, a p\xe1gina que procura n\xe3o existe.","goToHomepage":"Voltar para a p\xe1gina inicial","signInSignUp":"Entrar/Registar","paymentConfirmed":"Pagamento confirmado","paymentNotConfirmed":"Pagamento por confirmar","bookings":"Reservas","noBookings":"Sem reservas","cancelBooking":"Cancelar reserva","cancelBookingReservation":"Cancelar reserva {{booking}}","cancelBookingMessage":"Ser\xe1 enviado um e-mail a {{email}} a informar do cancelamento da reserva.","bookingIsPaid":"Reserva {{id}} marcada como paga.","bookingIsNotPaid":"Reserva {{id}} marcada como n\xe3o paga.","newClub":"Nova instala\xe7\xe3o desportiva","selectClub":"Selecione uma instala\xe7\xe3o desportiva:","area":"\xc1rea","areasOfClub":"\xc1reas da instala\xe7\xe3o desportiva","noAreas":"Sem \xe1reas","newArea":"Nova \xe1rea","areaIsClosed":"A \xe1rea encontra-se parada. Per\xedodo de encerramento: {{schedule}}","areaDelete":"Apagar \xe1rea","areaDeleteDescription":"Se apagar esta \xe1rea, compreende que ir\xe1 cancelar automaticamente as reservas para a mesma. Esta a\xe7\xe3o \xe9 permanente e n\xe3o pode ser anulada.","scanThisQRCode":"Este QR Code permite aceder aos detalhes da reserva.","missingInfo":"Informa\xe7\xe3o em falta","areasCount":"N\xfamero de \xe1reas","privacy":"Propriedade","environment":"Ambiente","not_specified":"Qualquer","private":"Privado","public":"P\xfablico","indoor":"Interior","outdoor":"Exterior","clubCreated":"Instala\xe7\xe3o desportiva criada com sucesso!","createAreaInfo":"Crie agora uma \xe1rea para cada zona da instala\xe7\xe3o desportiva com condi\xe7\xf5es/pre\xe7os diferentes.","createArea":"Criar \xc1rea","noClubInfo":"N\xe3o existe nenhuma instala\xe7\xe3o desportiva criada. Por favor, crie uma nova instala\xe7\xe3o desportiva no bot\xe3o + NOVA INSTALA\xc7\xc3O DESPORTIVA","addContact":"Adicionar contacto","bookingDetails":"Detalhes da Reserva","sport":"Desporto","day":"Dia","schedule":"Hor\xe1rio","noContactsTitle":"Sem contactos","noContactsInfo":"N\xe3o existem outros contactos criados","save":"Guardar","close":"Fechar","from":"De","to":"a","password":"Palavra-passe","alreadyBooked":"J\xe1 est\xe1 reservado neste hor\xe1rio","clubImageDefaultTitle":"Foto padr\xe3o da instala\xe7\xe3o desportiva","availableSlotsMessage":"Prepara-te para um jogo inesquec\xedvel! \uD83C\uDFC0\uD83C\uDFD3⚽️ Reserva o teu hor\xe1rio e junta-te \xe0 divers\xe3o desportiva.","availableSlotsDate":"\uD83D\uDCC5 Hor\xe1rios dispon\xedveis para: {{date}}","shareAvailableSlotsMessage":"Prepara-te para um jogo inesquec\xedvel! \uD83C\uDFC0\uD83C\uDFD3⚽️\\nReserva o teu hor\xe1rio e junta-te \xe0 divers\xe3o desportiva.\\n\\n\uD83D\uDCC5 Hor\xe1rios dispon\xedveis para:\\n{{date}}\\n\\n\uD83D\uDCCD Instala\xe7\xe3o desportiva:\\n{{clubName}}\\n\\n ⛳️ \xc1rea(s):\\n{{area}}\\n\uD83D\uDD17 Visita o nosso site e faz j\xe1 a tua reserva:\\n{{link}} ","shareAvailableSlotsNoSchedulesError":"Esta \xe1rea n\xe3o tem hor\xe1rio dispon\xedvel para amanh\xe3.","fileUploadInput":"Arraste e solte o arquivo aqui ou clique para selecionar","fileUploadInputRules":"Apenas \xe9 permitido carregar uma imagem .jpeg ou .png at\xe9 2MB","fileUploadErrorMaxFiles":"Limite de imagens ultrassado. Apenas \xe9 permitido o carregamento de uma imagem.","fileUploadErrorMaxSize":"Imagem demasiado grande. Apenas \xe9 permitido o carregamento de uma imagem at\xe9 2MB.","cancelBookingAlertMessage":{"200":"Reserva cancelada com sucesso.","403":"N\xe3o tem permiss\xf5es para cancelar a reserva.","404":"N\xe3o existe nenhuma reserva com o m\xfamero indicado.","500":"Ocorreu um erro durante o cancelamento da reserva, por favor tente novamente.","noData":"Ocorreu um erro inesperado, por favor tente novamente."},"newBooking":"Nova Reserva","checkout":{"message":"Bem-vindo de volta! Por favor, fa\xe7a o login para prosseguir com a reserva"},"validation":{"requiredPassword":"Palavra-passe \xe9 obrigat\xf3ria.","requiredName":"O campo nome \xe9 de preenchimento obrigat\xf3rio.","requiredClubName":"O campo nome da instala\xe7\xe3o desportiva \xe9 de preenchimento obrigat\xf3rio.","requiredValidEmail":"Por favor, introduza um e-mail v\xe1lido.","requiredEmail":"O campo e-mail \xe9 de preenchimento obrigat\xf3rio.","requiredPhone":"O campo telefone \xe9 de preenchimento obrigat\xf3rio.","requiredValidPhone":"Por favor, introduza um n\xfamero de telefone v\xe1lido.","oldPassword":"Palavra-passe antiga \xe9 de preenchimento obrigat\xf3rio.","newPassword":"Palavra-passe nova \xe9 de preenchimento obrigat\xf3rio.","confirmPassword":"A password deve coincidir.","toShort":"Este campo deve ter no m\xednimo {{char}} carateres.","toLong":"Este campo deve ter no m\xe1ximo {{char}} carateres.","fiscalNumberOnlyNumber":"Campo NIF deve conter apenas d\xedgitos.","fiscalNumberMinNumber":"Campo NIF deve ter no m\xednimo 9 d\xedgitos.","fiscalNumberMaxNumber":"Campo NIF deve ter no m\xe1ximo 9 d\xedgitos.","phoneOnlyNumber":"Campo n\xfamero de telem\xf3vel deve conter apenas d\xedgitos.","invalidPrivacy":"Propriedade selecionada \xe9 inv\xe1lida.","invalidEnvironment":"Ambiente selecionado \xe9 inv\xe1lido.","invalidTimeUnit":"Unidade de tempo selecionada \xe9 inv\xe1lida.","requiredField":"Este campo \xe9 obrigat\xf3rio.","requiredPaymentMethod":"Deve selecionar o m\xe9todo de pagamento.","requiredTermsAndConditions":"Antes de avan\xe7ar deve aceitar os termos e condi\xe7\xf5es.","requiredMinimumField":"Deve selecionar pelo menos uma op\xe7\xe3o.","dateTo":"O hor\xe1rio de fecho dever\xe1 ser superior ao hor\xe1rio de abertura.","minEndDate":"Data de fim dever\xe1 ser superior \xe0 data de in\xedcio.","invalidPassword":"Palavra-passe n\xe3o \xe9 v\xe1lida.","requiredValidIban":"IBAN inv\xe1lido. Remova espa\xe7os e digite PT seguido de 23 d\xedgitos.","requiredValidPostalCode":"C\xf3digo postal inv\xe1lido. Digite um c\xf3digo postal no formato 0000-000.","invalidSSO":"Verifique se o e-mail \xe9 utilizado noutra conta."},"login":{"forgotPassword":"Recupera\xe7\xe3o da Palavra-Passe","login":"Login","loginWithGoogle":"Login com Google","loginWithFacebook":"Login com Facebook","register":"Ainda n\xe3o registado? Criar conta","clubAdminLogin":"Admin Login","adminLogin":"Suporte Login","okButton":"OK","error":{"wrongEmailOrPassword":"E-mail ou palavra-passe incorretos, tente novamente."}},"verify":{"verificationCode":"C\xd3DIGO DE VERIFICA\xc7\xc3O","errorMessage":"E-mail n\xe3o verificado! Tente novamente!","successMessage":"A sua conta foi verificada!","okButton":"OK","error":{"notVerified":"E-mail n\xe3o-verificado! Tente novamente!"}},"paymentProof":{"message":{"failedUpload":"O carregamento do comprovativo de pagamento falhou. Por favor, tente novamente.","successUpload":"Comprovativo carregado com sucesso."}},"clubAdmin":{"requestAccount":{"title":"Pedido de cria\xe7\xe3o de conta","adminName":"Nome do gestor da instala\xe7\xe3o desportiva","clubName":"Nome da instala\xe7\xe3o desportiva","email":"E-mail","phone":"N\xfamero de telefone","observations":"Observa\xe7\xf5es","success":"Submiss\xe3o efetuada com sucesso.","submitButton":"Submeter","error":{"onSubmit":"Erro ao submeter formul\xe1rio! Tente novamente, por favor!"}},"recoverPassword":{"title":"Alterar palavra-passe","verificationCode":"C\xf3digo de verifica\xe7\xe3o","verificationCodeLabel":"Introduzir o c\xf3digo de verifica\xe7\xe3o","newPassword":"Palavra-passe nova","newPasswordLabel":"Introduzir a nova palavra-passe","confirmNewPasswordLabel":"Confirme a nova palavra-passe","success":"Palavra-passe alterada com sucesso.","emailSent":"Foi enviado um e-mail com o c\xf3digo de verifica\xe7\xe3o para redefini\xe7\xe3o da palavra-passe.","submitButton":"Alterar palavra-passe","error":{"passwordNotValid":"A sua palavra-passe deve ter pelo menos 8 caracteres, dos quais pelo menos uma letra mai\xfascula e uma min\xfascula, um n\xfamero e um caracter especial.","passwordNotMatching":"A password fornecida nos dois campos \xe9 diferente! Por favor, tente novamente!","onSubmit":"Erro ao submeter formul\xe1rio! Tente novamente, por favor!","emailNotSent":"N\xe3o foi poss\xedvel enviar o e-mail de redefini\xe7\xe3o da palavra-passe. Tente novamente."}},"menu":{"home":"Home","noClubs":"Sem instala\xe7\xf5es desportivas","createClub":"Criar instala\xe7\xe3o desportiva","selectedClub":"Instala\xe7\xe3o desportiva selecionada","clubManagement":"Gest\xe3o de Instala\xe7\xf5es desportivas","clubAreas":"\xc1reas","reviews":"Avalia\xe7\xf5es","temporaryStop":"Parar temporariamente","editAccount":"Editar conta","help":"Ajuda","logout":"Sair","deleteClub":"Apagar instala\xe7\xe3o desportiva","historyData":"Hist\xf3rico de A\xe7\xf5es","editClub":"Editar instala\xe7\xe3o desportiva"},"bookings":{"allClubs":"Selecionar instala\xe7\xe3o desportiva","bookings":"RESERVAS","noBookings":"Sem reservas","noBookingsResult":"N\xe3o h\xe1 reservas efetuadas com os crit\xe9rios de pesquisa selecionados.","newBooking":"Nova Reserva","allAreas":"Todas as \xe1reas","calendarButton":"Calend\xe1rio","listButton":"Lista","selectCategory":"Selecionar desportos","selectDate":"Selecionar data","selectStartHour":"Selecionar hora de \xednicio","timeUnit":"Selecionar unidade de tempo ","TRINTA_MINUTOS":"30 Minutos","UMA_HORA":"1 Hora","UMA_HORA_TRINTA_MINUTOS":"1 Hora and 30 Minutos","DUAS_HORA":"2 Horas","selectArea":"Selecionar \xe1rea","selectDay":"Dia","selectTime":"Hora","showFilterButton":"Filtros","selectReservationType":"Selecionar categoria da reserva","allReservationType":"Todas as categorias","reservationTypes":{"selectReservationType":"Selecione o tipo da reserva","private":"Privado","classes":"Aulas","classes_pack":"Conjunto de aulas","team_building":"Team building","tournament":"Torneio"},"payment":"Comprovativo de pagamento","inputLabel":{"search":"ID de reserva, nome ou contacto telef\xf3nico","clientName":"Nome do cliente","clientEmail":"E-mail do cliente","selectedDay":"Dia","selectedTime":"Hora","selectedSport":"Desporto","reservationType":"Tipo"},"inputPlaceholder":{"clientName":"Nome do cliente","clientEmail":"E-mail do cliente"},"success":{"201":"O {{area}} foi reservado em nome de {{clientName}}, para o dia {{day}}, das {{from}}-{{to}} horas. A confirma\xe7\xe3o foi enviada para {{email}}.","title":"{{area}} reservado"},"error":{"400":"N\xe3o foi poss\xedvel processar a sua reserva. O campo n\xe3o se encontra aberto no hor\xe1rio selecionado.","403":"N\xe3o tem permiss\xf5es para finalizar o pedido","409":"J\xe1 existe uma reserva no per\xedodo de tempo selecionado.","500":"Erro. Ocorreu um erro durante a reserva, por favor tente de novo.","noSelectedClubTitle":"Selecione instala\xe7\xe3o desportiva","noSelectedClub":"Deve selecionar uma instala\xe7\xe3o desportiva para poder prosseguir com a reserva.","scheduleError":"N\xe3o \xe9 poss\xedvel efetuar reservas fora do hor\xe1rio definido no campo selecionado.","pastDate":"N\xe3o \xe9 poss\xedvel fazer reservas em hor\xe1rios anteriores h\xe1 data e hora atual.","notAreaSelected":"Para criar uma reserva, por favor selecione uma \xe1rea nos filtros.","invalidInterval":"Hor\xe1rio n\xe3o permitido. Por favor, selecione intervalos de {{time}}.","overlappingEvents":"J\xe1 existe uma reserva v\xe1lida no periodo selecionado.","noData":"Erro. Ocorreu um erro durante a filtragem de \xe1reas, por favor tente novamente."},"modal":{"title":"Detalhes da reserva","clientName":"Nome do cliente","clientEmail":"E-mail do cliente","mobilePhone":"Contacto telef\xf3nico do cliente","day":"Dia","time":"Hora","cancelButton":"Cancelar reserva","reservationTypeUpdateSuccess":"Tipo da reserva atualizada com sucesso.","reservationTypeUpdateError":"N\xe3o foi poss\xedvel atualizar o tipo da reserva, por favor tente novamente."}},"newCalendarBookingModal":{"title":"Nova reserva","description":"Criar nova reserva das {{start}} \xe0s {{end}}?","bookButton":"Reservar"},"clubAreas":{"error":{"serverError":"N\xe3o foi poss\xedvel completar esta opera\xe7\xe3o. Por favor, tente mais tarde.","failedUpload":"O carregamento de fotos falhou. Por favor, tente novamente.","failedDelete":"N\xe3o foi poss\xedvel apagar a foto selecionada. Por favor, tente novamente."},"success":{"defaultClubImage":"Definida com sucesso a imagem padr\xe3o da instala\xe7\xe3o desportiva."}},"historyData":{"selectUsers":"Selecionar utilizador","selectEndDate":"Selecionar data fim","selectStartDate":"Selecionar data in\xedcio","createdBy":"Criado por","at":"a","canceledBy":"Cancelado por","paidBy":"Pago por","noHistory":"Sem reservas para este filtro.","selectFilterToShowResults":"Aplique os filtros pretendidos e clique no bot\xe3o FILTRAR para ver os resultados.","accordionTitle":"Hist\xf3rico de a\xe7\xf5es"}},"editAccount":{"username":"Nome de utilizador","phoneNumber":"N\xfamero de telem\xf3vel","fiscalNumber":"NIF","address":"Morada","success":{"changePassword":"Password atualizada com sucesso.","userUpdate":"Informa\xe7\xe3o atualizada com sucesso.","delete":"Conta cancelada com sucesso."},"error":{"forbiden":"N\xe3o tem permiss\xf5es para alterar a palavra-passe.","serverError":"N\xe3o foi poss\xedvel completar esta opera\xe7\xe3o. Por favor, tente mais tarde.","userUpdate":"N\xe3o foi poss\xedvel atualizar a sua informa\xe7\xe3o de conta. Por favor, tente mais tarde."},"emailNote":{"noLink":"Para alterar o seu e-mail, entre em ","link":"contacto com a equipa de suporte."},"button":{"changePassword":"Alterar Palavra-Passe","deleteAccount":"Apagar conta","cancel":"Cancelar"},"modal":{"delete":{"title":"Apagar conta","description":"Se apagar a sua conta Freecourts, compreende que ir\xe1 perder acesso a todas as reservas futuras e passadas e todos os dados inseridos. Esta a\xe7\xe3o \xe9 permanente e n\xe3o pode ser anulada.","helperText":"Para confirmar a elimina\xe7\xe3o da conta","error":{"wrongPassword":"Password incorreta! Tente novamente!"}},"change":{"title":"Alterar palavra-passe","label":{"oldPassword":"Introduza a palavra-passe antiga.","newPassword":"Introduza uma palavra-passe nova.","confirmPassword":"Confirme a palavra-passe nova."},"inputLabel":{"newPassword":"Palavra-passe nova","oldPassword":"Palavra-passe antiga","confirmPassword":"Palavra-passe nova"}}}},"searchArea":"Procurar \xc1rea","searchAvailableArea":"Procurar \xc1rea Livre","noDataFound":"Sem registos","requiredFields":"Introuza todos os campos obrigat\xf3ros","book":"Reservar","booking":{"label":{"clubInfo":"Informa\xe7\xe3o da instala\xe7\xe3o desportiva","bookingInfo":"Informa\xe7\xe3o da reserva","interested":"Interessados","name":"Nome","payment":"Transfer\xeancia banc\xe1ria","acceptance":"Aceito os","termsAndConditions":"Termos & Condi\xe7\xf5es","sportsFacility":"desta instala\xe7\xe3o desportiva.","priceSummary":"Resumo de pre\xe7o","details":"Insira os seus dados","total":"Total","includedTaxes":"Inclui impostos e taxas","publicAreaInfo":"Este campo \xe9 p\xfablico, poder\xe1 estar ocupado.","transferObservation":"Mencione nas observa\xe7\xf5es da transfer\xeancia banc\xe1ria o n\xfamero: ","paymentNote":"IMPORTANTE: O prazo para pagamento e envio do comprovativo por e-mail \xe9 de 24 horas, ap\xf3s esse per\xedodo a reserva ser\xe1 anulada. A confirma\xe7\xe3o pode ocorrer at\xe9 2 dias.","importantNote":"IMPORTANTE: Este m\xe9todo de pagamento requer o pagamento e o envio do comprovativo da transfer\xeancia banc\xe1ria por e-mail at\xe9 24 horas ap\xf3s agendar a reserva.","bookingSuccess":"Processo de reserva iniciado com sucesso.","reservationNote":"Caso a reserva ainda n\xe3o tenha sido confirmada pela instala\xe7\xe3o desportiva, poder\xe1 ser necess\xe1rio apresentar o comprovativo da transfer\xeancia no local.","paymentConfirmed":"Pagamento da reserva confirmado.","paymentMethods":"M\xe9todos de Pagamento","creditCardNote":"Pagamentos com cart\xe3o de cr\xe9dito ou d\xe9bito: para maior seguran\xe7a, o sistema de autentica\xe7\xe3o 3D-Secure foi refor\xe7ado. Confirme a sua compra no seu telem\xf3vel, via app do seu banco, ou introduza o c\xf3digo enviado via SMS na p\xe1gina de autentica\xe7\xe3o. Para mais informa\xe7\xf5es consulte o seu banco."},"placeholder":{"name":"Inserir o nome","email":"Inserir e-mail"},"lockerRoomType":{"both":"Balne\xe1rios masculinos e femininos","male":"Balne\xe1rios masculinos","female":"Balne\xe1rios femininos","mixed":"Balne\xe1rios mistos","noLockerRoom":"Sem balne\xe1rios"},"button":{"book":"Reservar","shareBooking":"Partilhar reserva","next":"Reservar","share":"Partilhar"},"details":"Resumo da reserva #{{bookingId}}","payment":"Pagamento","paymentDetails":"Detalhes do pagamento","userInfo":"Informa\xe7\xe3o da Reserva","nameLabel":"Nome","bookings":"Ver Reservas","shareAvailableSlots":"Partilhe os hor\xe1rios dispon\xedveis"},"timeUnit":"Unidade de reserva","priceUnit":"Pre\xe7o por unidade","bookArea":"Reservar \xc1rea","clubDetails":{"contacts":{"noContactsTitle":"Sem contactos","noContactsInfo":"N\xe3o existem outros contactos criados","contactList":"Lista de contactos","message":{"success":"Contacto criado com sucesso","deleteSuccess":"Contacto apagado com sucesso","updateSuccess":"Contacto atualizado com sucesso","error":"Erro! N\xe3o foi poss\xedvel criar o contacto. Por favor, tente mais tarde."}},"step":{"label":{"clubData":"Dados da instala\xe7\xe3o desportiva","clubPhotos":"Fotos da instala\xe7\xe3o desportiva","paymentMethods":"M\xe9todos de pagamento","infrastructures":"Instala\xe7\xf5es desportivas","schedules":"Hor\xe1rios","clubContacts":"Outros contactos","clubAddress":"Morada da instala\xe7\xe3o desportiva"},"inputLabel":{"clubName":"Nome da instala\xe7\xe3o desportiva","offersAndNews":"Quero receber ofertas exclusivas e not\xedcias da comunidade FreeCourts.","clubPhone":"Telefone","clubMobile":"Telem\xf3vel","clubAddress":"Morada","clubDescription":"Descri\xe7\xe3o da instala\xe7\xe3o desportiva","clubPhotos":"Fotos da instala\xe7\xe3o desportiva","paymentMethods":"Selecione todos os m\xe9todos de pagamento suportados","contactName":"Nome","organizations":"Organiza\xe7\xf5es","address":"Morada","postalCode":"C\xf3digo postal","district":"Distrito","county":"Concelho","lat":"Latitude","lng":"Longitude"},"inputPlaceholder":{"clubName":"Nome da instala\xe7\xe3o desportiva","clubEmail":"E-mail da instala\xe7\xe3o desportiva","clubPhone":"Contacto telef\xf3nico","clubMobile":"Contacto telef\xf3nico alternativo","clubAddress":"Morada","clubDescription":"Equipamentos dispon\xedveis e indica\xe7\xf5es se s\xe3o pagos ou gratuitos.","clubPhotos":"Carregar fotos","contactName":"Nome","address":"Rua, avenida, lugar, estrada","postalCode":"C\xf3digo Postal","lat":"Latitude","lng":"Longitude"}},"message":{"getOrganizationsError":"Ocorreu um erro ao carregar a lista de organiza\xe7\xf5es.","createOrganizationSuccess":"Lista de organiza\xe7\xf5es criada com sucesso","createOrganizationError":"Ocorreu um erro quando tentava atualizar a lista de organiza\xe7\xf5es.","updateOrganizationSuccess":"Lista de organiza\xe7\xf5es atualizada com sucesso","defaultImage":"Depois de carregar as fotos da instala\xe7\xe3o desportiva, poder\xe1 escolher a imagem padr\xe3o ao clicar na imagem pretendida."}},"submitSuccess":"Submiss\xe3o efetuada com sucesso","search":{"labels":{"sport":"Desporto","date":"Data","startDate":"Data inicial","endDate":"Data final","time":"Hora de in\xedcio","timeUnit":"Dura\xe7\xe3o","district":"Localiza\xe7\xe3o","clubName":"Instala\xe7\xe3o desportiva","selectInfrastructure":"Instala\xe7\xf5es desportivas","noInfrastructures":"N\xe3o existem op\xe7\xf5es"},"fields":{"sport":"Desporto","date":"Data","time":"Hora de in\xedcio","endTime":"Hora de fim","timeUnit":"Dura\xe7\xe3o","district":"Localiza\xe7\xe3o","clubName":"Nome da instala\xe7\xe3o desportiva"},"sports":{"any":"Todos","padel":"Padel","tenis":"T\xe9nis","basquetebol":"Basquetebol","andebol":"Andebol","futebol":"Futebol","fut7":"Fut7","futsal":"Futsal","squash":"Squash","hoquei_patins":"H\xf3quei em Patins","fut5":"Fut5","voleibol":"Voleibol"},"cta":"Procurar","errors":{"isRequired":"O campo {{field}} \xe9 obrigat\xf3rio"}},"clubList":{"book":"Reservar","emptyList":"N\xe3o foram encontradas instala\xe7\xf5es desportivas que correspondam aos crit\xe9rios de pesquisa atuais","club":{"club_unavailable":"Instala\xe7\xe3o desportiva indispon\xedvel","schedule_error":"Data escolhida \xe9 fora do horario de funcionamento da instala\xe7\xe3o desportiva","closed_schedule_error":"Instala\xe7\xe3o desportiva temporariamente fechada de {{from}} a {{to}}"},"area":{"club_unavailable":"Campo indispon\xedvel","schedule_error":"Data escolhida \xe9 fora do horario de funcionamento do campo","closed_schedule_error":"Campo temporariamente fechado de {{from}} a {{to}}"}},"club":{"tabs":{"description":"Descri\xe7\xe3o","areas":"Areas"},"headers":{"description":"Descri\xe7\xe3o","paymentMethods":"M\xe9todos de Pagamento","parking":"Estacionamento","lockerooms":"Balne\xe1rios","schedules":"Hor\xe1rios","location":"Localiza\xe7\xe3o","closed":"Datas de Fecho","sports":"Desportos","reservations":"Reservas","priceByTimeUnit":"Pre\xe7o / Intervalo de tempo","selectAllSportsAvailable":"Selecione todos os desportos dispon\xedveis na instala\xe7\xe3o desportiva","whiciSportsOffer":"Quais os desportos que oferecem?","clubGallery":"Galeria de imagens"},"paymentMethods":{"emptyList":"N\xe3o h\xe1 m\xe9todos de pagamento dispon\xedveis","cash":"Dinheiro","mbway":"MB Way","credit_card":"Cart\xe3o de d\xe9bito/cr\xe9dito","bank_transfer":"Transfer\xeancia banc\xe1ria"},"lockerooms":{"noInformation":"N\xe3o h\xe1 informa\xe7\xe3o relativa a balne\xe1rios","no_locker_room":"N\xe3o existem balne\xe1rios","women_locker_room":"S\xf3 h\xe1 balne\xe1rio feminino","men_locker_room":"S\xf3 h\xe1 balne\xe1rio masculino","mixed_locker_room":"Balne\xe1rios mistos","both_locker_room":"Balne\xe1rios masculinos e femininos"},"parking":{"noInformation":"N\xe3o h\xe1 informa\xe7\xe3o relativa a estacionamentos","none":"N\xe3o existem estacionamentos","free":"Estacionamento gr\xe1tis","paid":"Estacionamento pago"},"schedules":{"noInformation":"N\xe3o h\xe1 informa\xe7\xe3o relativa a hor\xe1rios","weekdays":{"monday":"Segunda-feira","tuesday":"Ter\xe7a-feira","wednesday":"Quarta-feira","thursday":"Quinta-feira","friday":"Sexta-feira","saturday":"S\xe1bado","sunday":"Domingo"}},"gallery":{"emptyList":"N\xe3o h\xe1 imagens da instala\xe7\xe3o desportiva para mostrar"},"closed":{"noInformation":"N\xe3o h\xe1 indica\xe7\xf5es de fecho."},"reservations":{"noInformation":"N\xe3o h\xe1 reservas feitas","success":"Reserva efetuada com sucesso.","error":"Ocorreu um erro enquanto tentava efetuar uma reserva. Por favor, verifique se tem hor\xe1rios criados nesta \xe1rea e se a reserva desejada se encontra dentro do hor\xe1rio definido."},"areas":{"noAreas":"N\xe3o h\xe1 \xe1reas dispon\xedveis para esta instala\xe7\xe3o desportiva","noCategories":"N\xe3o h\xe1 desportos dispon\xedveis nesta \xe1rea"},"message":{"deleteClubTitle":"Apagar {{club}}","deleteClubDescription":"Se apagar esta instala\xe7\xe3o desportiva, compreende que ir\xe1 cancelar automaticamente as reservas para o mesmo. Esta a\xe7\xe3o \xe9 permanente e n\xe3o pode ser anulada."}},"clubAreas":{"step":{"label":{"areaData":"Dados da \xc1rea","areaSports":"Oferta de Desportos","areaSportsOffer":"Qual a oferta de desportos?","areaSportsSelect":"Selecione todos os desportos dispon\xedveis nesta \xe1rea","areaPhotos":"Fotos da \xc1rea","areaSchedules":"Hor\xe1rios","repeatSchedule":"Repetir hor\xe1rio","activityPeriod":"Per\xedodo de Atividade","closedPeriod":"Per\xedodo de Encerramento"},"inputLabel":{"areaName":"Nome da \xc1rea","areaDescription":"Descri\xe7\xe3o da \xe1rea","areaPhotos":"Fotos da \xc1rea","areaSchedules":"Defina hor\xe1rio de abertura e de fecho","areaClosedSchedules":"Defina data de in\xedcio e fim de per\xedodo de encerramento"},"inputPlaceholder":{"areaName":"Nome da \xe1rea","areaDescription":"Equipamentos dispon\xedveis, tipo de pavimento, etc...","areaPhotos":"Carregar fotos"}},"message":{"noSportInfoTitle":"Sem desporto","noSportInfoDescription":"Desporto selecionado n\xe3o existe neste campo.","areaScheduleSuccess":"Opera\xe7\xe3o efetuada com sucesso.","areaScheduleError":"Ocorreu um erro. Por favor, tente novamente.","schedules":{"409":"J\xe1 existe um hor\xe1rio definido para a hora de abertura e fecho selecionado."},"closedSchedules":{"409":"J\xe1 existe um per\xedodo de encerramento definido para as datas de in\xedcio e de fim selecionadas."}},"allWeekdays":"Todos os dias","timeUnit":"Unidade de tempo","newSchedule":"Novo Hor\xe1rio","newClosedSchedule":"Novo Fecho","repeat":"Dia","startDate":"Data de In\xedcio","endDate":"Data de Fim","open":"Abertura","close":"Fecho","schedules":{"noSchedulesTitle":"Sem hor\xe1rios","noSchedulesInfo":"N\xe3o existem hor\xe1rios de abertura criados para esta \xe1rea.","noClosedSchedulesTitle":"Sem per\xedodos de encerramento.","noClosedSchedulesInfo":"N\xe3o existem per\xedodos de encerramento criados para esta \xe1rea."},"address":{"selectCoordinatesTitle":"Selecionar coordenadas","selectCoordinatesInfo":"Selecione no mapa a localiza\xe7\xe3o da instala\xe7\xe3o desportiva para recolher as coordenadas."}},"register":{"title":"CRIE A SUA CONTA","name":{"label":"Nome","required":"Nome \xe9 obrigat\xf3rio."},"email":{"label":"E-mail","invalid":"O e-mail \xe9 inv\xe1lido.","required":"E-mail \xe9 obrigat\xf3rio."},"password":{"invalid":"A sua palavra-passe deve ter pelo menos 8 caracteres, dos quais pelo menos uma letra mai\xfascula e uma min\xfascula, um n\xfamero e um caracter especial.","required":"Palavra-passe \xe9 obrigat\xf3rio."},"phone":{"label":"N\xfamero de telem\xf3vel","invalid":"O n\xfamero \xe9 inv\xe1lido."},"nif":{"label":"NIF","invalid":"O NIF \xe9 inv\xe1lido."},"address":{"label":"Morada","invalid":"A morada \xe9 inv\xe1lida."},"submitButton":"Criar conta","success":"Conta criada com sucesso.","error":{"409":"O utilizador {{email}}","onSubmit":"Falha na cria\xe7\xe3o de conta! Tente novamente!"}},"recoverPassword":{"title":"Alterar palavra-passe","verificationCode":"C\xf3digo de verifica\xe7\xe3o","newPassword":"Palavra-passe nova","success":"Palavra-passe alterada com sucesso.","emailSent":"Foi enviado um e-mail com o c\xf3digo de verifica\xe7\xe3o para redefini\xe7\xe3o da palavra-passe.","submitButton":"Alterar palavra-passe","labels":{"verificationCode":"Introduzir o c\xf3digo de verifica\xe7\xe3o","newPassword":"Introduzir a nova palavra-passe","confirmNewPassword":"Confirme a nova palavra-passe"},"error":{"passwordNotValid":"A sua palavra-passe deve ter pelo menos 8 caracteres, dos quais pelo menos uma letra mai\xfascula e uma min\xfascula, um n\xfamero e um caracter especial.","passwordNotMatching":"A password fornecida nos dois campos \xe9 diferente! Por favor, tente novamente!","onSubmit":"Erro ao submeter formul\xe1rio! Tente novamente, por favor!","emailNotSent":"N\xe3o foi poss\xedvel enviar o e-mail de redefini\xe7\xe3o da palavra-passe. Tente novamente."}},"playerMenu":{"home":"Home","editAccount":"Editar conta","help":"Ajuda","logout":"Sair"},"shareBooking":{"bookingOf":"Reserva de {{name}}","shareLink":"Partilhar link da reserva","imInterested":"Estou interessado","imNotInterested":"N\xe3o estou interessado","interestedString":{"0":"S\xea o primeiro a mostrar interesse.","2":"{{name1}} e {{name2}} est\xe3o interessados.","3":"{{name1}}, {{name2}} e mais {{number}} est\xe3o interessados.","1a":"{{name}} est\xe1s interessado.","1b":"{{name}} est\xe1 interessado."},"shareTitle":"Partilhe a reserva","copyLink":"Copiar link","copied":"Copiado","message":"⚽️ Acabei de fazer uma reserva na FreeCourts!\\n\\n\uD83D\uDCC5 No dia {{date}} vamos jogar {{category}} das {{startTime}} as {{endTime}}.\\n\\n\uD83D\uDCCD Local:\\n- {{clubName}}, {{areaName}}\\n- {{clubAddress}}, {{clubPostalCode}} {{clubCounty}}\\n\\n\uD83D\uDC69‍\uD83D\uDC68‍\uD83D\uDC66‍\uD83D\uDC67 Quem ja confirmou: {{names}}\\n\\n\uD83D\uDD17 Link para confirmarem a vossa presen\xe7a e ver mais detalhes:\\n{{url}}","shareMessage":"Partilhar mensagem","shareOnWhatsapp":"Partilhar no Whatsapp","shareOnTwitter":"Partilhar no Twitter","shareOnFacebook":"Partilhar no Facebook"},"firstLogin":{"title":"Alterar palavra-passe","description":"Por raz\xf5es de seguran\xe7a deve alterar a sua palavra-passe.","newPassword":"Palavra-passe nova","newPasswordLabel":"Introduzir a nova palavra-passe","confirmNewPasswordLabel":"Confirme a nova palavra-passe","success":"Palavra-passe alterada com sucesso.","submitButton":"Alterar palavra-passe","error":{"passwordNotValid":"A sua palavra-passe deve ter pelo menos 8 caracteres, dos quais pelo menos uma letra mai\xfascula e uma min\xfascula, um n\xfamero e um caracter especial.","passwordNotMatching":"A password fornecida nos dois campos \xe9 diferente! Por favor, tente novamente!","onSubmit":"Erro ao submeter formul\xe1rio! Tente novamente, por favor!"}},"genericErrors":{"fileSizeExceed":"O arquivo selecionado excede o tamanho de 10mb","maxNumberExceed":"Excedeu o limite de {{number}} imagens permitidas para upload."},"homepage":{"title":"Um campo para todos","steps":{"title":"T\xe3o simples como 1,2,3","search":"Encontra o sitio","book":"Reserva o espa\xe7o","share":"Convida os teus amigos"},"statistics":{"title":"Locais","text":"O concelho de Aveiro disp\xf5e de pavilh\xf5es desportivos, espa\xe7os de acesso p\xfablico que permitem praticar desportos desde Basquetebol, Futebol, Futsal, Voleibol, Andebol entre outros. Encontra um espa\xe7o que te encha as medidas e vem praticar desporto","locations":"Locais dispon\xedveis","sports":"Diferentes desportos","fun":"Divers\xe3o infinita"},"book":{"title":"Pronto para come\xe7ar o jogo?","bookNow":"Reserve j\xe1"},"advantages":{"title":"Vantagens","first_text":"A actividade fisica \xe9 boa para o cora\xe7\xe3o, o corpo e a mente. Quando feita regularmente ajuda a reduzir a incidencia de doen\xe7as cardiacas e ajuda com sintomas de depress\xe3o e ansiedade.","first_subtext":"Directrizes da OMS via fundacaodesporto.pt","second_text":"A altern\xe2ncia entre desportos considerados moderados e de alta intensidade ajuda  uma potencia\xe7\xe3o maior dos beneficios do desporto. Havendo a necessidade de praticar diferentes tipos de desportos.","second_subtext":"Directrizes da OMS via fundacaodesporto.pt","third_text":"O nivel de responsabilidade pessoal e social, de um cidad\xe3o, aumenta quando existe uma atitude positiva na pr\xe1tica competitiva de desportos de grupo","third_subtext":"Disserta\xe7\xe3o Doutoramento da Ul-FMH"},"footer":{"courts":"Instala\xe7\xf5es desportivas","sports":"Desportos","tennis":"T\xe9nis","basketball":"Basquetebol","soccer":"Futebol","volleyball":"Voleibol","padel":"Padel","futsal":"Futsal","help":"Ajuda"}}}');


$312aabd780fb2656$exports = {
    "en": {
        "common": $ff0b6f62bfc1762d$exports
    },
    "pt": {
        "common": $83e328ec989cd256$exports
    }
};


//import "./locales/pt/common.json"
//import "./locales/en/common.json"
async function $1e5f1623097d3546$var$loadResources(lng, ns) {
    const translations = await import(`./locales/${lng}/${ns}.json`);
    return translations;
}
(0, $2Bwgd.default).use((0, $NDJJg.initReactI18next)).use((0, $fcb831e2a23edeea$export$2e2bcd8739ae039)).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).init({
    backend: {
        loadPath: "{{lng}}|{{ns}}",
        request: async (_, url, __, cb)=>{
            const [lng, ns] = url.split("|");
            const translations = $312aabd780fb2656$exports[lng][ns];
            if (translations) cb(null, {
                data: JSON.stringify(translations),
                status: 200
            });
            else cb(null, {
                data: JSON.stringify({}),
                status: 404
            });
        }
    },
    defaultNS: "common",
    ns: [
        "common"
    ],
    detection: {
        order: [
            "localStorage",
            "sessionStorage"
        ],
        caches: [
            "localStorage"
        ]
    },
    fallbackLng: "pt",
    react: {
        useSuspense: true
    }
});
var $1e5f1623097d3546$export$2e2bcd8739ae039 = (0, $2Bwgd.default);





var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $dNYY5 = parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
parcelRequire("fI21S");
var $3lDoJ = parcelRequire("3lDoJ");
var $6V5bv = parcelRequire("6V5bv");

var $7fPBF = parcelRequire("7fPBF");
/* eslint-disable react-hooks/exhaustive-deps */ 
var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $dNYY5 = parcelRequire("dNYY5");
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");
function $6b332e946dc6bafc$var$Admin() {
    const client_id = "ctdoikq17k5icfk5uhf05s19k";
    const redirect_uri = "http://localhost:3000/admin";
    const logout_uri = "http://localhost:3000";
    const api_url = "http://localhost:3001/api/private";
    const aws_token_url = "https://conexa-admin.auth.us-east-1.amazoncognito.com/oauth2/token";
    const aws_logout_url = `https://conexa-admin.auth.us-east-1.amazoncognito.com/logout?client_id=${client_id}&logout_uri=${logout_uri}`;
    const [message, setMessage] = (0, $7fPBF.useState)("");
    (0, $7fPBF.useEffect)(()=>{
        getToken();
    }, []);
    async function getToken() {
        try {
            const url = window.location.href;
            const parsedUrl = new URL(url);
            const code = parsedUrl.searchParams.get("code");
            if (!code) return;
            const params = new URLSearchParams();
            params.append("grant_type", "authorization_code");
            params.append("client_id", client_id);
            params.append("code", code);
            params.append("redirect_uri", redirect_uri);
            const response = await (0, $a04va.default).post(aws_token_url, params.toString(), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            });
            await getAdminInfo(response.data.access_token);
        } catch (error) {
            console.log("error", error);
        }
    }
    async function getAdminInfo(access_token) {
        try {
            console.log("token", access_token);
            const response = await (0, $a04va.default).get(api_url, {
                headers: {
                    Authorization: `Bearer ${access_token}`
                }
            });
            setMessage(response.data.message);
        } catch (error) {
            console.log("error Admin", error);
        }
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        children: message.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                    children: message
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.Link), {
                    to: aws_logout_url,
                    children: "LOGOUT"
                })
            ]
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
            children: "Loading..."
        })
    });
}
var $6b332e946dc6bafc$export$2e2bcd8739ae039 = $6b332e946dc6bafc$var$Admin;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $c1d0r = parcelRequire("c1d0r");
var $abILr = parcelRequire("abILr");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $dNDci = parcelRequire("dNDci");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
var $2b2f9356127c80f0$exports = {};
"use strict";
var $2b2f9356127c80f0$var$__importDefault = $2b2f9356127c80f0$exports && $2b2f9356127c80f0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2b2f9356127c80f0$exports, "__esModule", {
    value: true
});

var $2b2f9356127c80f0$var$Carousel_1 = $2b2f9356127c80f0$var$__importDefault((parcelRequire("7uzyD")));
$2b2f9356127c80f0$exports.default = $2b2f9356127c80f0$var$Carousel_1.default;


var $639cf2d093bbb4ad$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($639cf2d093bbb4ad$exports, "__esModule", {
    value: true
});
$639cf2d093bbb4ad$exports.default = void 0;

var $639cf2d093bbb4ad$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $639cf2d093bbb4ad$var$_default = (0, $639cf2d093bbb4ad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), "Lock");
$639cf2d093bbb4ad$exports.default = $639cf2d093bbb4ad$var$_default;


var $f3d319a6f13a7f1a$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($f3d319a6f13a7f1a$exports, "__esModule", {
    value: true
});
$f3d319a6f13a7f1a$exports.default = void 0;

var $f3d319a6f13a7f1a$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $f3d319a6f13a7f1a$var$_default = (0, $f3d319a6f13a7f1a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.27L20 17.17V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.21 0-4.07 1.45-4.73 3.44L8.9 6.07V6zM2.1 2.1.69 3.51 5.3 8.13C4.55 8.42 4 9.15 4 10v10c0 1.1.9 2 2 2h12c.34 0 .65-.09.93-.24l1.56 1.56 1.41-1.41L2.1 2.1zM12 17c-1.1 0-2-.9-2-2 0-.59.27-1.12.68-1.49l2.81 2.81c-.37.41-.9.68-1.49.68z"
}), "NoEncryptionGmailerrorred");
$f3d319a6f13a7f1a$exports.default = $f3d319a6f13a7f1a$var$_default;


var $ea0de4c2ab813d5e$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($ea0de4c2ab813d5e$exports, "__esModule", {
    value: true
});
$ea0de4c2ab813d5e$exports.default = void 0;

var $ea0de4c2ab813d5e$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $ea0de4c2ab813d5e$var$_default = (0, $ea0de4c2ab813d5e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M22 21V7L12 3 2 7v14h5v-9h10v9h5zm-11-2H9v2h2v-2zm2-3h-2v2h2v-2zm2 3h-2v2h2v-2z"
}), "Warehouse");
$ea0de4c2ab813d5e$exports.default = $ea0de4c2ab813d5e$var$_default;



var $jQ4lF = parcelRequire("jQ4lF");

var $aili3 = parcelRequire("aili3");
var $633320af39ee7ce3$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($633320af39ee7ce3$exports, "__esModule", {
    value: true
});
$633320af39ee7ce3$exports.default = void 0;

var $633320af39ee7ce3$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $633320af39ee7ce3$var$_default = (0, $633320af39ee7ce3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
}), "LocalParking");
$633320af39ee7ce3$exports.default = $633320af39ee7ce3$var$_default;


var $950b5d811df8743c$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($950b5d811df8743c$exports, "__esModule", {
    value: true
});
$950b5d811df8743c$exports.default = void 0;

var $950b5d811df8743c$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $950b5d811df8743c$var$_default = (0, $950b5d811df8743c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), "LocationOn");
$950b5d811df8743c$exports.default = $950b5d811df8743c$var$_default;


var $53964059809e8148$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($53964059809e8148$exports, "__esModule", {
    value: true
});
$53964059809e8148$exports.default = void 0;

var $53964059809e8148$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $53964059809e8148$var$_default = (0, $53964059809e8148$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
}), "Email");
$53964059809e8148$exports.default = $53964059809e8148$var$_default;


var $3ad597515af9cd13$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($3ad597515af9cd13$exports, "__esModule", {
    value: true
});
$3ad597515af9cd13$exports.default = void 0;

var $3ad597515af9cd13$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $3ad597515af9cd13$var$_default = (0, $3ad597515af9cd13$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
}), "Call");
$3ad597515af9cd13$exports.default = $3ad597515af9cd13$var$_default;


var $0e979bbad9fc1510$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($0e979bbad9fc1510$exports, "__esModule", {
    value: true
});
$0e979bbad9fc1510$exports.default = void 0;

var $0e979bbad9fc1510$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $0e979bbad9fc1510$var$_default = (0, $0e979bbad9fc1510$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
}), "CallMade");
$0e979bbad9fc1510$exports.default = $0e979bbad9fc1510$var$_default;


var $493aa4bc6d5b1843$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($493aa4bc6d5b1843$exports, "__esModule", {
    value: true
});
$493aa4bc6d5b1843$exports.default = void 0;

var $493aa4bc6d5b1843$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $493aa4bc6d5b1843$var$_default = (0, $493aa4bc6d5b1843$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.96v-4H21z"
}), "Park");
$493aa4bc6d5b1843$exports.default = $493aa4bc6d5b1843$var$_default;


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dNYY5 = parcelRequire("dNYY5");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
var $52e2efeb5d4d3157$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($52e2efeb5d4d3157$exports, "__esModule", {
    value: true
});
$52e2efeb5d4d3157$exports.default = void 0;

var $52e2efeb5d4d3157$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $52e2efeb5d4d3157$var$_default = (0, $52e2efeb5d4d3157$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
}), "Wc");
$52e2efeb5d4d3157$exports.default = $52e2efeb5d4d3157$var$_default;


var $4e9a202accba6b20$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($4e9a202accba6b20$exports, "__esModule", {
    value: true
});
$4e9a202accba6b20$exports.default = void 0;

var $4e9a202accba6b20$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $4e9a202accba6b20$var$_default = (0, $4e9a202accba6b20$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
        d: "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z"
    }, "0"),
    /*#__PURE__*/ (0, $bbzbN.jsx)("circle", {
        cx: "12",
        cy: "4",
        r: "2"
    }, "1")
], "Man");
$4e9a202accba6b20$exports.default = $4e9a202accba6b20$var$_default;


var $6bcecdbc7bf35dc1$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($6bcecdbc7bf35dc1$exports, "__esModule", {
    value: true
});
$6bcecdbc7bf35dc1$exports.default = void 0;

var $6bcecdbc7bf35dc1$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $6bcecdbc7bf35dc1$var$_default = (0, $6bcecdbc7bf35dc1$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
        d: "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3v6h4v-6h3l-3.06-7.69z"
    }, "0"),
    /*#__PURE__*/ (0, $bbzbN.jsx)("circle", {
        cx: "12",
        cy: "4",
        r: "2"
    }, "1")
], "Woman");
$6bcecdbc7bf35dc1$exports.default = $6bcecdbc7bf35dc1$var$_default;


var $96c12147c3951215$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($96c12147c3951215$exports, "__esModule", {
    value: true
});
$96c12147c3951215$exports.default = void 0;

var $96c12147c3951215$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $96c12147c3951215$var$_default = (0, $96c12147c3951215$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
}), "DoNotDisturbAlt");
$96c12147c3951215$exports.default = $96c12147c3951215$var$_default;



var $jQ4lF = parcelRequire("jQ4lF");
const $33e08d4193a7a61e$var$LockerRoomDetails = ({ lockerRoomType: lockerRoomType })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    switch(lockerRoomType){
        case "BOTH_LOCKER_ROOM":
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($52e2efeb5d4d3157$exports))), {
                        sx: {
                            width: "16px",
                            height: "16px"
                        },
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledLabel), {
                        children: t("booking.lockerRoomType.both")
                    })
                ]
            });
        case "WOMEN_LOCKER_ROOM":
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6bcecdbc7bf35dc1$exports))), {
                        sx: {
                            width: "16px",
                            height: "16px"
                        },
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledLabel), {
                        children: t("booking.lockerRoomType.female")
                    })
                ]
            });
        case "MIXED_LOCKER_ROOM":
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($52e2efeb5d4d3157$exports))), {
                        sx: {
                            width: "16px",
                            height: "16px"
                        },
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledLabel), {
                        children: t("booking.lockerRoomType.mixed")
                    })
                ]
            });
        case "MEN_LOCKER_ROOM":
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4e9a202accba6b20$exports))), {
                        sx: {
                            width: "16px",
                            height: "16px"
                        },
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledLabel), {
                        children: t("booking.lockerRoomType.male")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96c12147c3951215$exports))), {
                        sx: {
                            width: "16px",
                            height: "16px"
                        },
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledLabel), {
                        children: t("booking.lockerRoomType.noLockerRoom")
                    })
                ]
            });
    }
};
var $33e08d4193a7a61e$export$2e2bcd8739ae039 = $33e08d4193a7a61e$var$LockerRoomDetails;


const $45ae9643aaece5b5$export$4162f0f332955ca9 = ({ club: club, area: area, category: category, date: date, from: from, to: to })=>{
    var _club_photos, _club_photos1, _club_photos2, _club_photos3, _area_photos, _area_photos1, _area_photos2, _area_photos3;
    const { t: t } = (0, $doyfp.useTranslation)();
    const address = club.address.address.replaceAll(" ", "+").replace(",", "");
    const navigationURL = club.address.lat != 0 && club.address.lng != 0 ? `//maps.google.com/maps?&saddr=Current+Location&daddr=@${club.address.lat},${club.address.lng}` : `//maps.google.com/maps?&saddr=Current+Location&daddr=${address}+${club.address.district}+${club.address.postalCode}`;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCard), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardContent), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledImageContainer), {
                            children: ((_club_photos = club.photos) === null || _club_photos === void 0 ? void 0 : _club_photos.length) > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2b2f9356127c80f0$exports))), {
                                className: "carousel",
                                autoPlay: false,
                                navButtonsAlwaysVisible: ((_club_photos1 = club.photos) === null || _club_photos1 === void 0 ? void 0 : _club_photos1.length) > 1 ? true : false,
                                indicators: ((_club_photos2 = club.photos) === null || _club_photos2 === void 0 ? void 0 : _club_photos2.length) > 1 ? true : false,
                                navButtonsProps: {
                                    className: "carousel-nav-buttons"
                                },
                                children: (_club_photos3 = club.photos) === null || _club_photos3 === void 0 ? void 0 : _club_photos3.map((photo, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledImage), {
                                        src: photo.photoUrl,
                                        alt: ""
                                    }, i))
                            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledImage), {
                                src: "https://placehold.co/400"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledNameTitle), {
                            children: club.name
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledContact), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($950b5d811df8743c$exports))), {
                                    sx: {
                                        width: "16px",
                                        height: "16px"
                                    },
                                    className: "mr-1"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("a", {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: navigationURL,
                                    children: [
                                        club.address.address,
                                        ", ",
                                        club.address.postalCode,
                                        ", ",
                                        club.address.district,
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0e979bbad9fc1510$exports))), {
                                            fontSize: "small",
                                            className: "p-2"
                                        })
                                    ]
                                })
                            ]
                        }),
                        club.mobilePhone && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledContact), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ad597515af9cd13$exports))), {
                                    sx: {
                                        width: "16px",
                                        height: "16px"
                                    },
                                    className: "mr-1"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dNYY5.Link), {
                                    to: `tel:${club.mobilePhone}`,
                                    children: [
                                        club.mobilePhone,
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0e979bbad9fc1510$exports))), {
                                            fontSize: "small",
                                            className: "p-2"
                                        })
                                    ]
                                })
                            ]
                        }),
                        club.email && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledContact), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53964059809e8148$exports))), {
                                    sx: {
                                        width: "16px",
                                        height: "16px"
                                    },
                                    className: "mr-1"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dNYY5.Link), {
                                    to: `mailto:${club.email}`,
                                    children: [
                                        club.email,
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0e979bbad9fc1510$exports))), {
                                            fontSize: "small",
                                            className: "p-2"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledContactBox), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($633320af39ee7ce3$exports))), {
                                            sx: {
                                                width: "16px",
                                                height: "16px"
                                            },
                                            color: "disabled"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledLabel), {
                                            children: t(`club.parking.${club.carParkType}`.toLowerCase())
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $33e08d4193a7a61e$export$2e2bcd8739ae039), {
                                    lockerRoomType: club.lockerRoomType
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCard), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardContent), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledImageContainer), {
                            children: ((_area_photos = area.photos) === null || _area_photos === void 0 ? void 0 : _area_photos.length) > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2b2f9356127c80f0$exports))), {
                                className: "carousel",
                                autoPlay: false,
                                navButtonsAlwaysVisible: ((_area_photos1 = area.photos) === null || _area_photos1 === void 0 ? void 0 : _area_photos1.length) > 1 ? true : false,
                                indicators: ((_area_photos2 = area.photos) === null || _area_photos2 === void 0 ? void 0 : _area_photos2.length) > 1 ? true : false,
                                navButtonsProps: {
                                    className: "carousel-nav-buttons"
                                },
                                children: (_area_photos3 = area.photos) === null || _area_photos3 === void 0 ? void 0 : _area_photos3.map((photo, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledImage), {
                                        src: photo.photoUrl,
                                        alt: ""
                                    }, i))
                            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledImage), {
                                src: "https://placehold.co/400"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledNameTitle), {
                            children: [
                                area.name,
                                " - ",
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.Category), {
                                    children: category.toLowerCase()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledContactBox), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                                    children: [
                                        area.privacy === "PRIVATE" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($639cf2d093bbb4ad$exports))), {
                                            color: "disabled",
                                            sx: {
                                                width: "16px",
                                                height: "16px"
                                            }
                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3d319a6f13a7f1a$exports))), {
                                            color: "disabled",
                                            sx: {
                                                width: "16px",
                                                height: "16px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledContact), {
                                            children: area.privacy ? t(`${area.privacy}`.toLowerCase()) : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.IconBox), {
                                    children: [
                                        area.environment === "INDOOR" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ea0de4c2ab813d5e$exports))), {
                                            sx: {
                                                width: "16px",
                                                height: "16px"
                                            },
                                            color: "disabled"
                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($493aa4bc6d5b1843$exports))), {
                                            sx: {
                                                width: "16px",
                                                height: "16px"
                                            },
                                            color: "disabled"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledContact), {
                                            children: area.environment ? t(`${area.environment}`.toLowerCase()) : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledContact), {
                            children: area.description
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledStack), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledBookingBox), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCardLabel), {
                                            children: date
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledContact), {
                                            children: from
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCardLabel), {
                                            children: date
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledContact), {
                                            children: to
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            area.price && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCard), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCardContent), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCardLabel), {
                            children: t("booking.label.priceSummary")
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledStackPrice), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCardLabel), {
                                children: t("booking.label.total")
                            }),
                            area.privacy === "PRIVATE" ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardLabel), {
                                        children: [
                                            "€ ",
                                            area.price
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.TaxesInfo), {
                                        children: t("booking.label.includedTaxes")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardLabel), {
                                        children: [
                                            "€ ",
                                            0
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledContact), {
                                        children: t("booking.label.publicAreaInfo")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $8m7Fi = parcelRequire("8m7Fi");

var $dkKmP = parcelRequire("dkKmP");

var $jQ4lF = parcelRequire("jQ4lF");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $aUdfW = parcelRequire("aUdfW");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $afCHG = parcelRequire("afCHG");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $bbzbN = parcelRequire("bbzbN");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $69df59329b725c14$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
}), "ContentCopy");

parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $1a1655aa354be6d6$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), "Facebook");

parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $ae1c80d53c4a6d5f$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
}), "Twitter");

parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
var $60e71f73488d89ab$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
}), "WhatsApp");



var $kspUS = parcelRequire("kspUS");
var $g9bTP = parcelRequire("g9bTP");

var $2Bwgd = parcelRequire("2Bwgd");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $aili3 = parcelRequire("aili3");
var $8TDId = parcelRequire("8TDId");
var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $62rTX = parcelRequire("62rTX");
var $cFCqu = parcelRequire("cFCqu");

var $cxeT8 = parcelRequire("cxeT8");

var $kDBhE = parcelRequire("kDBhE");

var $g9bTP = parcelRequire("g9bTP");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $aSK9T = parcelRequire("aSK9T");

var $41bfV = parcelRequire("41bfV");

var $1XFnq = parcelRequire("1XFnq");

var $6NwTb = parcelRequire("6NwTb");

var $bwizY = parcelRequire("bwizY");

var $ahx27 = parcelRequire("ahx27");

var $568MF = parcelRequire("568MF");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $684603ff395d34b1$export$837848f5f6cee923(slot) {
    return (0, $k6RDS.default)("MuiTooltip", slot);
}
const $684603ff395d34b1$var$tooltipClasses = (0, $4jzsB.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $684603ff395d34b1$export$2e2bcd8739ae039 = $684603ff395d34b1$var$tooltipClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ea99f2520fe8509d$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $ea99f2520fe8509d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $ea99f2520fe8509d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $b6UUh.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $684603ff395d34b1$export$837848f5f6cee923), classes);
};
const $ea99f2520fe8509d$var$TooltipPopper = (0, $kDBhE.default)((0, $41bfV.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $kY3Ke.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: (0, $kY3Ke.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $684603ff395d34b1$export$2e2bcd8739ae039).arrow}`]: (0, $kY3Ke.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $ea99f2520fe8509d$var$TooltipTooltip = (0, $kDBhE.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $b6UUh.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $cxeT8.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$ea99f2520fe8509d$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $kY3Ke.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $kY3Ke.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $kY3Ke.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $kY3Ke.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $684603ff395d34b1$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $kY3Ke.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $ea99f2520fe8509d$var$TooltipArrow = (0, $kDBhE.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $cxeT8.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $ea99f2520fe8509d$var$hystersisOpen = false;
let $ea99f2520fe8509d$var$hystersisTimer = null;
let $ea99f2520fe8509d$var$cursorPosition = {
    x: 0,
    y: 0
};
function $ea99f2520fe8509d$export$b9ee5a7ace0541f8() {
    $ea99f2520fe8509d$var$hystersisOpen = false;
    clearTimeout($ea99f2520fe8509d$var$hystersisTimer);
}
function $ea99f2520fe8509d$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $ea99f2520fe8509d$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $aSK9T.default), TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $ea99f2520fe8509d$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $7fPBF.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $g9bTP.default)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $7fPBF.useState();
    const [arrowRef, setArrowRef] = $7fPBF.useState(null);
    const ignoreNonTouchEvents = $7fPBF.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $7fPBF.useRef();
    const enterTimer = $7fPBF.useRef();
    const leaveTimer = $7fPBF.useRef();
    const touchTimer = $7fPBF.useRef();
    const [openState, setOpenState] = (0, $568MF.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $bwizY.default)(idProp);
    const prevUserSelect = $7fPBF.useRef();
    const stopTouchInteraction = $7fPBF.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $7fPBF.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($ea99f2520fe8509d$var$hystersisTimer);
        $ea99f2520fe8509d$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $1XFnq.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($ea99f2520fe8509d$var$hystersisTimer);
        $ea99f2520fe8509d$var$hystersisTimer = setTimeout(()=>{
            $ea99f2520fe8509d$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $ea99f2520fe8509d$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $ea99f2520fe8509d$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $ahx27.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $7fPBF.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $6NwTb.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $7fPBF.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $ea99f2520fe8509d$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $kY3Ke.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $hngXp.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $ea99f2520fe8509d$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $ea99f2520fe8509d$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $ea99f2520fe8509d$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $ea99f2520fe8509d$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $7fPBF.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $kY3Ke.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $ea99f2520fe8509d$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $ea99f2520fe8509d$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $aSK9T.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $ea99f2520fe8509d$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $ea99f2520fe8509d$var$TooltipArrow;
    const popperProps = (0, $62rTX.appendOwnerState)(PopperComponent, (0, $kY3Ke.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $hngXp.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $62rTX.appendOwnerState)(TransitionComponent, (0, $kY3Ke.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $62rTX.appendOwnerState)(TooltipComponent, (0, $kY3Ke.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $hngXp.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $62rTX.appendOwnerState)(ArrowComponent, (0, $kY3Ke.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $hngXp.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $bbzbN.jsx)(PopperComponent, (0, $kY3Ke.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $41bfV.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $ea99f2520fe8509d$var$cursorPosition.y,
                            left: $ea99f2520fe8509d$var$cursorPosition.x,
                            right: $ea99f2520fe8509d$var$cursorPosition.x,
                            bottom: $ea99f2520fe8509d$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(TooltipComponent, (0, $kY3Ke.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $bbzbN.jsx)(ArrowComponent, (0, $kY3Ke.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $ea99f2520fe8509d$export$2e2bcd8739ae039 = $ea99f2520fe8509d$var$Tooltip;


parcelRequire("7fPBF");
const $925a8095849aad7d$export$be92a4a0f46f95de = ({ icon: icon, text: text, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
            title: text,
            arrow: true,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                size: "large",
                ...rest,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick();
                },
                "aria-label": text,
                children: icon
            })
        })
    });
};



var $fnVR5 = parcelRequire("fnVR5");
var $f159ab129bd778b8$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($f159ab129bd778b8$exports, "__esModule", {
    value: true
});
$f159ab129bd778b8$exports.default = void 0;

var $f159ab129bd778b8$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $f159ab129bd778b8$var$_default = (0, $f159ab129bd778b8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
}), "Share");
$f159ab129bd778b8$exports.default = $f159ab129bd778b8$var$_default;


const $40aa70e50709aa5f$export$6065a61077043bd0 = ({ currUrl: currUrl, message: message })=>{
    const theme = (0, $g9bTP.default)();
    const isLargeScreen = (0, $kspUS.default)(theme.breakpoints.up("sm"));
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const handleShareMessage = ()=>{
        if (!navigator.share) setSnackbar({
            open: true,
            severity: "error",
            children: (0, $2Bwgd.t)("shareBooking.cannotShare"),
            setOpen: ()=>{
                setSnackbar({
                    open: false,
                    children: null,
                    setOpen: ()=>{}
                });
            }
        });
        navigator.share({
            url: currUrl,
            title: (0, $2Bwgd.t)("shareBooking.share"),
            text: message
        });
    };
    const handleCopyLink = ()=>{
        navigator.clipboard.writeText(currUrl);
        setSnackbar({
            open: true,
            severity: "info",
            children: (0, $2Bwgd.t)("shareBooking.copied"),
            setOpen: ()=>{
                setSnackbar({
                    open: false,
                    children: null,
                    setOpen: ()=>{}
                });
            }
        });
    };
    const handleExternalLink = (link)=>window.open(link, "_blank");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $925a8095849aad7d$export$be92a4a0f46f95de), {
                icon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $69df59329b725c14$export$2e2bcd8739ae039), {
                    fontSize: "inherit"
                }),
                text: (0, $2Bwgd.t)("shareBooking.copyLink"),
                onClick: handleCopyLink
            }),
            !isLargeScreen && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $925a8095849aad7d$export$be92a4a0f46f95de), {
                icon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f159ab129bd778b8$exports))), {
                    fontSize: "inherit"
                }),
                text: (0, $2Bwgd.t)("shareBooking.shareMessage"),
                onClick: handleShareMessage
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $925a8095849aad7d$export$be92a4a0f46f95de), {
                icon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $60e71f73488d89ab$export$2e2bcd8739ae039), {
                    fontSize: "inherit"
                }),
                text: (0, $2Bwgd.t)("shareBooking.shareOnWhatsapp"),
                onClick: ()=>handleExternalLink(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $925a8095849aad7d$export$be92a4a0f46f95de), {
                icon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ae1c80d53c4a6d5f$export$2e2bcd8739ae039), {
                    fontSize: "inherit"
                }),
                text: (0, $2Bwgd.t)("shareBooking.shareOnTwitter"),
                onClick: ()=>handleExternalLink(`https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $925a8095849aad7d$export$be92a4a0f46f95de), {
                icon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1a1655aa354be6d6$export$2e2bcd8739ae039), {
                    fontSize: "inherit"
                }),
                text: (0, $2Bwgd.t)("shareBooking.shareOnFacebook"),
                onClick: ()=>handleExternalLink(`https://facebook.com/sharer/share?u=${encodeURIComponent(currUrl)}&t=${encodeURIComponent(message)}`)
            })
        ]
    });
};


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $f626810b4000bbbe$export$eb64062c68bca198 = ({ booking: booking, open: open, onClose: onClose })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const currUrl = (0, $7fPBF.useMemo)(()=>`${window.location.origin}/booking/share/${booking.shareId}`, [
        booking
    ]);
    const message = (0, $7fPBF.useMemo)(()=>{
        var _booking_club_address, _booking_club_address1, _booking_club_address2;
        const dateStart = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).utc().format("DD-MM-YYYY");
        const timeStart = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.from).utc().format("HH:mm");
        const timeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.to).utc().format("HH:mm");
        var _booking_interested;
        const interested = (_booking_interested = booking.interested) !== null && _booking_interested !== void 0 ? _booking_interested : [];
        const names = [
            booking.name,
            ...interested.map((a)=>a.name)
        ].map((name)=>`\n- ${name}`);
        return t("shareBooking.message", {
            date: dateStart,
            category: booking.category,
            startTime: timeStart,
            endTime: timeEnd,
            clubName: booking.club.name,
            areaName: booking.area.name,
            clubAddress: (_booking_club_address = booking.club.address) === null || _booking_club_address === void 0 ? void 0 : _booking_club_address.address,
            clubPostalCode: (_booking_club_address1 = booking.club.address) === null || _booking_club_address1 === void 0 ? void 0 : _booking_club_address1.postalCode,
            clubCounty: (_booking_club_address2 = booking.club.address) === null || _booking_club_address2 === void 0 ? void 0 : _booking_club_address2.county,
            names: names
        }).replace("{{url}}", currUrl);
    }, [
        booking
    ]);
    const handleModalClose = ()=>{
        onClose();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aUdfW.default), {
        open: open,
        onClose: handleModalClose,
        maxWidth: "sm",
        fullWidth: true,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            p: 2,
            spacing: 2,
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    variant: "h6",
                    children: t("shareBooking.shareTitle")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    multiline: true,
                    maxRows: 6,
                    value: message,
                    "aria-readonly": true
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
                    direction: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40aa70e50709aa5f$export$6065a61077043bd0), {
                        currUrl: currUrl,
                        message: message
                    })
                })
            ]
        })
    });
};



var $1N52b = parcelRequire("1N52b");

var $9uOZr = parcelRequire("9uOZr");
const $81f70df8dc2d1c1b$var$buildString = (t, names)=>{
    if (!names) return "";
    if (names.length === 0) return t("shareBooking.interestedString.0");
    if (names.length === 1) return t("shareBooking.interestedString.1b").replace("{{name}}", names[0]);
    if (names.length === 2) return t("shareBooking.interestedString.2").replace("{{name1}}", names[0]).replace("{{name2}}", names[1]);
    return t("shareBooking.interestedString.3").replace("{{name1}}", names[0]).replace("{{name2}}", names[1]).replace("{{number}}", (names.length - 2).toString());
};
const $81f70df8dc2d1c1b$var$separateIdAndName = (arr)=>{
    if (!arr) return {
        ids: [],
        names: []
    };
    return arr.reduce((result, item)=>{
        result.ids.push(item.id);
        result.names.push(item.name);
        return result;
    }, {
        ids: [],
        names: []
    });
};
const $81f70df8dc2d1c1b$var$ShareBooking = ()=>{
    var _booking_club_address, _booking_club_address1, _booking_club_address2, _booking_club_address3, _booking_club_address4;
    const { isAuthenticated: isAuthenticated } = (0, $1N52b.useAuth)();
    const navigate = (0, $iIluI.useNavigate)();
    const { id: shareId } = (0, $iIluI.useParams)();
    const { t: t, i18n: i18n } = (0, $doyfp.useTranslation)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [booking, setBooking] = (0, $7fPBF.useState)(null);
    const [currUser, setCurrUser] = (0, $7fPBF.useState)(null);
    const [shareModalOpen, setShareModalOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const appService = new (0, $dNDci.AppService)();
        appService.api_getBookingByShareId({
            shareId: shareId
        }).then((res)=>{
            if (res.status !== 200) throw res;
            setBooking(res.data);
            if (searchParams.get("action") === "share") setShareModalOpen(true);
        }).catch((error)=>{
            console.log(error);
            navigate("/");
        });
        if (!isAuthenticated) return;
        appService.api_getUser().then((res)=>{
            if (res.status !== 200) throw res;
            setCurrUser(res.data);
        }).catch((error)=>{
            console.log(error);
        });
    }, [
        shareId
    ]);
    const handleChangeInInterest = (isInterested)=>{
        setLoading(true);
        new (0, $dNDci.AppService)().api_setInterestInBooking({
            id: booking.id,
            isInterested: isInterested
        }).then((res)=>{
            if (![
                200,
                201,
                204
            ].includes(res.status)) throw res;
            if (isInterested) setBooking((prev)=>({
                    ...prev,
                    interested: [
                        ...prev.interested,
                        currUser
                    ]
                }));
            else {
                const userList = booking.interested.filter((a)=>a.id !== currUser.id);
                setBooking((prev)=>({
                        ...prev,
                        interested: userList
                    }));
            }
        }).catch((error)=>{
            console.log(error);
        }).finally(()=>setLoading(false));
    };
    const handleInterestClick = (isInterested)=>{
        if (!isAuthenticated) {
            navigate(`/login?return_url=${encodeURIComponent(`/booking/share/${shareId}`)}`);
            return;
        }
        handleChangeInInterest(isInterested);
    };
    const interested = $81f70df8dc2d1c1b$var$separateIdAndName(booking === null || booking === void 0 ? void 0 : booking.interested);
    const isInterested = interested.ids.includes(currUser === null || currUser === void 0 ? void 0 : currUser.id);
    const interestedPeopleString = $81f70df8dc2d1c1b$var$buildString(t, [
        booking === null || booking === void 0 ? void 0 : booking.name,
        ...interested.names
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
            spacing: 2,
            mt: 2,
            mb: 5,
            children: booking ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        variant: "h5",
                        sx: {
                            textAlign: "center"
                        },
                        children: t("shareBooking.bookingOf", {
                            name: booking.name
                        }).toUpperCase()
                    }),
                    booking.canceled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                        variant: "h5",
                        color: "error",
                        sx: {
                            textAlign: "center"
                        },
                        children: t("canceled").toUpperCase()
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45ae9643aaece5b5$export$4162f0f332955ca9), {
                        club: {
                            name: booking.club.name,
                            mobilePhone: booking.club.mobilePhone,
                            email: booking.club.email,
                            carParkType: booking.club.carParkType,
                            lockerRoomType: booking.club.lockerRoomType,
                            address: {
                                address: (_booking_club_address = booking.club.address) === null || _booking_club_address === void 0 ? void 0 : _booking_club_address.address,
                                postalCode: (_booking_club_address1 = booking.club.address) === null || _booking_club_address1 === void 0 ? void 0 : _booking_club_address1.postalCode,
                                district: (_booking_club_address2 = booking.club.address) === null || _booking_club_address2 === void 0 ? void 0 : _booking_club_address2.district,
                                lat: (_booking_club_address3 = booking.club.address) === null || _booking_club_address3 === void 0 ? void 0 : _booking_club_address3.lat,
                                lng: (_booking_club_address4 = booking.club.address) === null || _booking_club_address4 === void 0 ? void 0 : _booking_club_address4.lng
                            },
                            photos: booking.club.photos.map((photo)=>({
                                    photoUrl: photo.photoUrl
                                }))
                        },
                        area: {
                            name: booking.area.name,
                            description: booking.area.description,
                            price: booking.price,
                            privacy: booking.area.privacy,
                            environment: booking.area.environment,
                            photos: booking.area.photos.map((photo)=>({
                                    photoUrl: photo.photoUrl
                                }))
                        },
                        category: booking.category,
                        date: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).locale(i18n.language).utc().format("ddd, DD MMMM YYYY"),
                        from: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.from).utc().format("HH:mm"),
                        to: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.to).utc().format("HH:mm")
                    }),
                    (currUser === null || currUser === void 0 ? void 0 : currUser.id) === booking.userId ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCard), {
                        sx: {
                            marginBottom: "240px"
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCardLabel), {
                                        children: t("booking.label.interested")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                        variant: "body1",
                                        children: [
                                            booking.name,
                                            ...interested.names
                                        ].join(", ")
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                        children: !booking.canceled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCard), {
                            sx: {
                                marginBottom: "240px"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1d0r.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                    spacing: {
                                        xs: 1,
                                        sm: 3
                                    },
                                    alignItems: "center",
                                    direction: {
                                        xs: "column",
                                        sm: "row"
                                    },
                                    useFlexGap: true,
                                    children: [
                                        !isInterested ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                            variant: "outlined",
                                            sx: {
                                                width: "auto"
                                            },
                                            onClick: ()=>handleInterestClick(true),
                                            disabled: loading,
                                            children: t("shareBooking.imInterested")
                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                            variant: "contained",
                                            sx: {
                                                width: "auto"
                                            },
                                            onClick: ()=>handleInterestClick(false),
                                            disabled: loading,
                                            children: t("shareBooking.imNotInterested")
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                            sx: {
                                                flex: 2
                                            },
                                            children: interestedPeopleString
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    !booking.canceled && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                variant: "contained",
                                onClick: ()=>setShareModalOpen(true),
                                children: t("shareBooking.shareLink")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f626810b4000bbbe$export$eb64062c68bca198), {
                                booking: booking,
                                open: shareModalOpen,
                                onClose: ()=>setShareModalOpen(false)
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                        variant: "rounded",
                        width: "100%",
                        height: 32
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                        variant: "rounded",
                        width: "100%",
                        height: 264
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                        variant: "rounded",
                        width: "100%",
                        height: 332
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                        variant: "rounded",
                        width: "100%",
                        height: 84
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $abILr.default), {
                        variant: "rounded",
                        width: "100%",
                        height: 44
                    })
                ]
            })
        })
    });
};
var $81f70df8dc2d1c1b$export$2e2bcd8739ae039 = $81f70df8dc2d1c1b$var$ShareBooking;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $aili3 = parcelRequire("aili3");
var $5ZeKC = parcelRequire("5ZeKC");

var $afCHG = parcelRequire("afCHG");

var $9uOZr = parcelRequire("9uOZr");

var $bbzbN = parcelRequire("bbzbN");

var $5ZeKC = parcelRequire("5ZeKC");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $1quPt = parcelRequire("1quPt");
parcelRequire("7fPBF");
const $c01e87b5e315da77$export$3a4deda42b6182b7 = ({ to: to = "/", color: color = "white" })=>{
    const navigate = (0, $iIluI.useNavigate)();
    const handleGoBack = ()=>{
        navigate(to);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
        onClick: handleGoBack,
        sx: {
            width: "40px",
            height: "40px"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1quPt))), {
            color: color
        })
    });
};


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $gQHM1 = parcelRequire("gQHM1");
const $711f8784a526fd26$export$6a5c05795461ca18 = (to, return_url)=>{
    return return_url ? `${to}?return_url=${encodeURIComponent(return_url)}` : to;
};



var $6hfZk = parcelRequire("6hfZk");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $6hfZk = parcelRequire("6hfZk");
let $f5f8f9af897fbc84$var$_ = (t)=>t, $f5f8f9af897fbc84$var$t;
const $f5f8f9af897fbc84$export$1446d14bdc196a47 = (0, $6hfZk.default).img($f5f8f9af897fbc84$var$t || ($f5f8f9af897fbc84$var$t = $f5f8f9af897fbc84$var$_`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    object-fit: cover;
    object-position: center;
    z-index: -1;
`));


const $1013941d713eda09$export$3d0b85b7d4419b92 = ({ src: src, alt: alt = "Background Image", ...rest })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f5f8f9af897fbc84$export$1446d14bdc196a47), {
        src: src,
        alt: alt,
        ...rest
    });
};


let $95d77929a11e5518$var$_ = (t)=>t, $95d77929a11e5518$var$t;
const $95d77929a11e5518$export$1446d14bdc196a47 = (0, $6hfZk.default)((0, $1013941d713eda09$export$3d0b85b7d4419b92))($95d77929a11e5518$var$t || ($95d77929a11e5518$var$t = $95d77929a11e5518$var$_`
    filter: brightness(0.4);
`));


const $0565e9788296f70a$var$VerifyAccount = ()=>{
    const navigate = (0, $iIluI.useNavigate)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const [code, setCode] = (0, $7fPBF.useState)("");
    const [errorAlertOpen, setErrorAlertOpen] = (0, $7fPBF.useState)(false);
    const email = searchParams.get("email") || "";
    const return_url = searchParams.get("return_url");
    //Translation
    const { t: t } = (0, $doyfp.useTranslation)();
    (0, $7fPBF.useEffect)(()=>{
        if (email === "") navigate((0, $711f8784a526fd26$export$6a5c05795461ca18)("/login", return_url));
    }, [
        email,
        navigate
    ]);
    const handleSubmit = async ()=>{
        if (code === "") return;
        try {
            const res = await (0, $a04va.default).post(`${window.location.origin}/api/auth/player/validate`, {
                email: email,
                code: code
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (res.status !== 200) throw new Error(t("verify.error.notVerified"));
            alert(t("verify.successMessage"));
            navigate((0, $711f8784a526fd26$export$6a5c05795461ca18)("/login", return_url));
            return;
        } catch (e) {
            var _e_response, _e_response_data;
            const error = ((_e_response = e.response) === null || _e_response === void 0 ? void 0 : (_e_response_data = _e_response.data) === null || _e_response_data === void 0 ? void 0 : _e_response_data.message) || e.message || t("generalError");
            console.log(error);
            setErrorAlertOpen(true);
            return;
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9uOZr.Layout), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        sx: {
                            width: "100%",
                            padding: "1rem 0 5rem",
                            minHeight: "100vh",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                sx: {
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c01e87b5e315da77$export$3a4deda42b6182b7), {
                                    to: "/login"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                src: "/logo_aveiro_tech_city_white.png",
                                alt: "FreeCourts: Courts for everyone",
                                style: {
                                    margin: "24px auto",
                                    height: "82px",
                                    width: "fit-content"
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "1rem",
                                    marginTop: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                        type: "number",
                                        label: t("verify.verificationCode"),
                                        variant: "filled",
                                        value: code,
                                        onChange: (e)=>setCode(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                        variant: "contained",
                                        onClick: handleSubmit,
                                        children: t("verify.okButton")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gQHM1.SnackbarAlert), {
                        vertical: "top",
                        horizontal: "center",
                        open: errorAlertOpen,
                        setOpen: setErrorAlertOpen,
                        variant: "filled",
                        severity: "error",
                        children: t("verify.error.notVerified")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95d77929a11e5518$export$1446d14bdc196a47), {
                src: "/images/basketball.jpg",
                alt: "Basketball background image"
            })
        ]
    });
};
var $0565e9788296f70a$export$2e2bcd8739ae039 = $0565e9788296f70a$var$VerifyAccount;



var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $1N52b = parcelRequire("1N52b");
const $911b334883a2df86$var$Logout = ()=>{
    const { logout: logout } = (0, $1N52b.useAuth)();
    const navigate = (0, $iIluI.useNavigate)();
    console.log("Logging out...");
    (0, $7fPBF.useEffect)(()=>{
        logout();
        sessionStorage.clear();
        const keysToRemove = [
            "clubAdmin.selectedClub"
        ];
        keysToRemove.forEach((key)=>localStorage.removeItem(key));
        navigate("/");
    }, []);
    return null;
};
var $911b334883a2df86$export$2e2bcd8739ae039 = $911b334883a2df86$var$Logout;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dkKmP = parcelRequire("dkKmP");

var $9uOZr = parcelRequire("9uOZr");
const $9607625e138e8af6$var$NotFound = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            spacing: 4,
            mt: 4,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    variant: "h1",
                    textAlign: "center",
                    children: "404"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    variant: "h5",
                    textAlign: "center",
                    children: t("pageNotFound")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                    variant: "contained",
                    onClick: ()=>navigate("/"),
                    children: t("goToHomepage")
                })
            ]
        })
    });
};
var $9607625e138e8af6$export$2e2bcd8739ae039 = $9607625e138e8af6$var$NotFound;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $pF6j5 = parcelRequire("pF6j5");
var $hG0Cb = parcelRequire("hG0Cb");

var $dkKmP = parcelRequire("dkKmP");
var $d6a40c1aa52d185d$exports = {};
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($d6a40c1aa52d185d$exports, "__esModule", {
    value: true
});
$d6a40c1aa52d185d$exports.default = void 0;

var $d6a40c1aa52d185d$var$React = $d6a40c1aa52d185d$var$_interopRequireWildcard((parcelRequire("7fPBF")));

var $d6a40c1aa52d185d$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
function $d6a40c1aa52d185d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d6a40c1aa52d185d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d6a40c1aa52d185d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d6a40c1aa52d185d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $d6a40c1aa52d185d$var$_default = (0, $d6a40c1aa52d185d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12.545,10.239v3.821h5.445c-0.712,2.315-2.647,3.972-5.445,3.972c-3.332,0-6.033-2.701-6.033-6.032s2.701-6.032,6.033-6.032c1.498,0,2.866,0.549,3.921,1.453l2.814-2.814C17.503,2.988,15.139,2,12.545,2C7.021,2,2.543,6.477,2.543,12s4.478,10,10.002,10c8.396,0,10.249-7.85,9.426-11.748L12.545,10.239z"
}), "Google");
$d6a40c1aa52d185d$exports.default = $d6a40c1aa52d185d$var$_default;



var $9uOZr = parcelRequire("9uOZr");

parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");

let $c3d938b4e7bc9cfd$var$_ = (t)=>t, $c3d938b4e7bc9cfd$var$t, $c3d938b4e7bc9cfd$var$t1, $c3d938b4e7bc9cfd$var$t2, $c3d938b4e7bc9cfd$var$t3, $c3d938b4e7bc9cfd$var$t4, $c3d938b4e7bc9cfd$var$t5, $c3d938b4e7bc9cfd$var$t6, $c3d938b4e7bc9cfd$var$t7;
const $c3d938b4e7bc9cfd$export$8cd7ca2dd7ba6f89 = (0, $6hfZk.default)((0, $aili3.default))($c3d938b4e7bc9cfd$var$t || ($c3d938b4e7bc9cfd$var$t = $c3d938b4e7bc9cfd$var$_`
    width: 100%;
    padding: 1rem 0 5rem;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`));
const $c3d938b4e7bc9cfd$export$62593f30e57962cc = (0, $6hfZk.default)((0, $aili3.default))($c3d938b4e7bc9cfd$var$t1 || ($c3d938b4e7bc9cfd$var$t1 = $c3d938b4e7bc9cfd$var$_`
    display: flex;
`));
const $c3d938b4e7bc9cfd$export$4d2d061eae5a2bee = (0, $6hfZk.default)((0, $aili3.default))($c3d938b4e7bc9cfd$var$t2 || ($c3d938b4e7bc9cfd$var$t2 = $c3d938b4e7bc9cfd$var$_`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: auto;
`));
const $c3d938b4e7bc9cfd$export$3e431a229df88919 = (0, $6hfZk.default).img($c3d938b4e7bc9cfd$var$t3 || ($c3d938b4e7bc9cfd$var$t3 = $c3d938b4e7bc9cfd$var$_`
    margin: 24px auto 50px auto;
    height: 82px;
    width: fit-content;
`));
const $c3d938b4e7bc9cfd$export$3205ecf6997ef75f = (0, $6hfZk.default).img($c3d938b4e7bc9cfd$var$t4 || ($c3d938b4e7bc9cfd$var$t4 = $c3d938b4e7bc9cfd$var$_`
    margin: auto;
    height: auto;
    max-width: 246px;
`));
const $c3d938b4e7bc9cfd$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($c3d938b4e7bc9cfd$var$t5 || ($c3d938b4e7bc9cfd$var$t5 = $c3d938b4e7bc9cfd$var$_`
    padding: 8px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`));
const $c3d938b4e7bc9cfd$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($c3d938b4e7bc9cfd$var$t6 || ($c3d938b4e7bc9cfd$var$t6 = $c3d938b4e7bc9cfd$var$_`
    width: 100%;
`));
const $c3d938b4e7bc9cfd$export$1446d14bdc196a47 = (0, $6hfZk.default)((0, $1013941d713eda09$export$3d0b85b7d4419b92))($c3d938b4e7bc9cfd$var$t7 || ($c3d938b4e7bc9cfd$var$t7 = $c3d938b4e7bc9cfd$var$_`
    filter: brightness(0.4);
    background: var(--black-054), rgba(0, 0, 0, 0.54);
`));



var $3Ou5w = parcelRequire("3Ou5w");

var $7qlUi = parcelRequire("7qlUi");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $1ZNeQ = parcelRequire("1ZNeQ");

var $8smOS = parcelRequire("8smOS");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $afCHG = parcelRequire("afCHG");

var $dNDci = parcelRequire("dNDci");

var $1N52b = parcelRequire("1N52b");

var $dkKmP = parcelRequire("dkKmP");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $afCHG = parcelRequire("afCHG");

var $hG0Cb = parcelRequire("hG0Cb");

var $dkKmP = parcelRequire("dkKmP");

var $dNDci = parcelRequire("dNDci");

var $gQHM1 = parcelRequire("gQHM1");

var $aUdfW = parcelRequire("aUdfW");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $9rh0m = parcelRequire("9rh0m");
const $cd3fd0c9111cb421$var$formInitialValue = {
    newPassword: "",
    confirmNewPassword: ""
};
const $cd3fd0c9111cb421$export$8bbf944b59634a81 = ({ open: open, onClose: onClose, email: email, password: password })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const [sendingForm, setSendingForm] = (0, $7fPBF.useState)(false);
    const [formData, setFormData] = (0, $7fPBF.useState)($cd3fd0c9111cb421$var$formInitialValue);
    const [alertOpen, setAlertOpen] = (0, $7fPBF.useState)(false);
    const [alert, setAlert] = (0, $7fPBF.useState)({
        severity: "error",
        message: "Erro"
    });
    const handleInputChange = (e)=>{
        const { name: name, value: value } = e.target;
        setFormData((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const validatePassword = (password)=>{
        return (0, $9rh0m.isPasswordValid)(password);
    };
    const passwordIsValid = formData.newPassword === "" || validatePassword(formData.newPassword);
    const passwordsMatch = formData.confirmNewPassword === "" || formData.newPassword === formData.confirmNewPassword;
    const handleReset = ()=>{
        setFormData($cd3fd0c9111cb421$var$formInitialValue);
        onClose();
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (formData.newPassword === "" || formData.confirmNewPassword === "" || !passwordIsValid || !passwordsMatch || sendingForm) return;
        const data = {
            ...formData,
            email: email,
            password: password
        };
        setSendingForm(true);
        new (0, $dNDci.AppService)().api_changeTemporaryPassword("club-admin", data).then((res)=>{
            if (res.status !== 200) throw new Error();
            setAlert({
                severity: "success",
                message: t("firstLogin.success")
            });
            setAlertOpen(true);
            handleReset();
        }).catch((error)=>{
            console.log(error);
            setAlert({
                severity: "error",
                message: t("firstLogin.error.onSubmit")
            });
            setAlertOpen(true);
        }).finally(()=>setSendingForm(false));
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aUdfW.default), {
                open: open,
                onClose: handleReset,
                maxWidth: "xs",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("form", {
                    onSubmit: handleSubmit,
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        spacing: 2,
                        p: 2,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "h6",
                                children: t("firstLogin.title")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "body1",
                                children: t("firstLogin.description")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                style: {
                                    marginTop: 24
                                },
                                htmlFor: "newPassword",
                                children: t("firstLogin.newPasswordLabel")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                id: "newPassword",
                                name: "newPassword",
                                label: t("firstLogin.newPassword"),
                                type: "password",
                                variant: "filled",
                                autoComplete: "off",
                                error: !passwordIsValid,
                                helperText: !passwordIsValid ? t("firstLogin.error.passwordNotValid") : undefined,
                                required: true,
                                value: formData.newPassword,
                                onChange: handleInputChange
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                style: {
                                    marginTop: 24
                                },
                                htmlFor: "confirmNewPassword",
                                children: t("firstLogin.confirmNewPasswordLabel")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                id: "confirmNewPassword",
                                name: "confirmNewPassword",
                                label: t("firstLogin.newPassword"),
                                type: "password",
                                variant: "filled",
                                autoComplete: "off",
                                error: !passwordsMatch,
                                helperText: !passwordsMatch ? t("firstLogin.error.passwordNotMatching") : undefined,
                                required: true,
                                value: formData.confirmNewPassword,
                                onChange: handleInputChange
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                variant: "contained",
                                type: "submit",
                                disabled: sendingForm,
                                children: t("firstLogin.submitButton")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                variant: "outlined",
                                onClick: handleReset,
                                children: t("cancel")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gQHM1.SnackbarAlert), {
                open: alertOpen,
                setOpen: setAlertOpen,
                severity: alert.severity,
                children: alert.message
            })
        ]
    });
};



var $fnVR5 = parcelRequire("fnVR5");

var $7xRAC = parcelRequire("7xRAC");

var $9rh0m = parcelRequire("9rh0m");
const $5abd2105f8a45ac9$export$535c6326fd176912 = (t)=>{
    return $7xRAC.object({
        email: $7xRAC.string().matches((0, $9rh0m.emailRegex), t("validation.requiredValidEmail")).required(t("validation.requiredEmail")),
        password: $7xRAC.string().required(t("validation.invalidPassword"))
    });
};



var $dkKmP = parcelRequire("dkKmP");

var $6hfZk = parcelRequire("6hfZk");
let $c0fbf2675f5426b4$var$_ = (t)=>t, $c0fbf2675f5426b4$var$t;
const $c0fbf2675f5426b4$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isColorBlack"
})($c0fbf2675f5426b4$var$t || ($c0fbf2675f5426b4$var$t = $c0fbf2675f5426b4$var$_`
console.log(isColorBlack)
    padding: 0 !important;
    justify-content: left !important;
    color: ${0};
`), ({ isColorBlack: isColorBlack })=>isColorBlack ? "black !important" : "white !important");



var $fpWEH = parcelRequire("fpWEH");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $afCHG = parcelRequire("afCHG");

var $aili3 = parcelRequire("aili3");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $6hfZk = parcelRequire("6hfZk");
let $56fe94472d761025$var$_ = (t)=>t, $56fe94472d761025$var$t;
const $56fe94472d761025$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($56fe94472d761025$var$t || ($56fe94472d761025$var$t = $56fe94472d761025$var$_`
    display: flex;
    flex-direction: column;
    gap: 16px;
`));



var $fnVR5 = parcelRequire("fnVR5");

var $1ZNeQ = parcelRequire("1ZNeQ");

var $3loMv = parcelRequire("3loMv");

var $6hfZk = parcelRequire("6hfZk");
let $c56e92abe02e471f$var$_ = (t)=>t, $c56e92abe02e471f$var$t, $c56e92abe02e471f$var$t1;
const $c56e92abe02e471f$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($c56e92abe02e471f$var$t || ($c56e92abe02e471f$var$t = $c56e92abe02e471f$var$_`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`));
const $c56e92abe02e471f$export$4ea0ff3663964b59 = (0, $6hfZk.default)((0, $3loMv.default))($c56e92abe02e471f$var$t1 || ($c56e92abe02e471f$var$t1 = $c56e92abe02e471f$var$_`
    color: #d32f2f;
    font-size: 12px !important;
    margin: 3px 14px 0 14px !important;
`));



var $7xRAC = parcelRequire("7xRAC");
parcelRequire("5aR8Y");

var $9rh0m = parcelRequire("9rh0m");
const $9deed3881a9fd102$export$a34f8e0c91de9144 = (t)=>{
    return $7xRAC.object({
        newPassword: $7xRAC.string().required(t("validation.newPassword")).matches((0, $9rh0m.passwordRegex), t("register.password.invalid")),
        confirmNewPassword: $7xRAC.string().oneOf([
            $7xRAC.ref("newPassword")
        ], t("validation.confirmPassword")),
        verificationCode: $7xRAC.string().required(t("validation.requiredValidationCode"))
    });
};


parcelRequire("fI21S");
var $3irMb = parcelRequire("3irMb");

var $dNDci = parcelRequire("dNDci");
function $9f6713ca2a6ad600$export$25e6995a1d664b5e(role) {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, mutate: mutate, isError: isError } = (0, $3irMb.useMutation)({
        mutationKey: [
            "resetPassword"
        ],
        mutationFn: async (userData)=>{
            const res = await appService.api_resetPassword(role, userData);
            return res;
        },
        retry: false
    });
    return {
        isLoading: isLoading,
        mutate: mutate,
        isError: isError
    };
}


const $918110bfce91144d$var$initialValues = {
    newPassword: "",
    confirmNewPassword: "",
    verificationCode: ""
};
const $918110bfce91144d$export$6630bff6ccf72719 = ({ email: email, role: role })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { mutate: resetPassword } = (0, $9f6713ca2a6ad600$export$25e6995a1d664b5e)(role);
    const { setModal: setModal, setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
        initialValues: $918110bfce91144d$var$initialValues,
        validationSchema: (0, $9deed3881a9fd102$export$a34f8e0c91de9144)(t),
        onSubmit: async (values, { resetForm: resetForm })=>{
            const formData = {
                ...values,
                email: email
            };
            resetPassword(formData, {
                onSuccess: (data)=>{
                    if (data.status !== 200) throw new Error();
                    resetForm();
                    setSnackbar({
                        open: true,
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "success",
                        children: t("recoverPassword.success")
                    });
                    setModal({
                        open: false,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                    });
                },
                onError: ()=>{
                    resetForm();
                    setSnackbar({
                        open: true,
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "error",
                        children: t("recoverPassword.error.onSubmit")
                    });
                    setModal({
                        open: false,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                    });
                }
            });
        },
        children: (props)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $56fe94472d761025$export$a7fed597f4b8afd8), {
                onSubmit: props.handleSubmit,
                id: "form-resetPassword",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            id: "verificationCode",
                            name: "verificationCode",
                            hasLabelTop: true,
                            labelTop: t("recoverPassword.labels.verificationCode"),
                            placeholder: t("recoverPassword.verificationCode"),
                            type: "text",
                            autoComplete: "off",
                            required: true,
                            value: props.values.verificationCode,
                            onChange: props.handleChange
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                id: "newPassword",
                                name: "newPassword",
                                hasLabelTop: true,
                                labelTop: t("recoverPassword.labels.newPassword"),
                                placeholder: t("recoverPassword.newPassword"),
                                type: "password",
                                autoComplete: "off",
                                error: props.touched.newPassword && Boolean(props.errors.newPassword),
                                required: true,
                                value: props.values.newPassword,
                                onChange: props.handleChange
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "newPassword",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                id: "confirmNewPassword",
                                name: "confirmNewPassword",
                                hasLabelTop: true,
                                labelTop: t("recoverPassword.labels.confirmNewPassword"),
                                placeholder: t("recoverPassword.newPassword"),
                                type: "password",
                                autoComplete: "off",
                                error: props.touched.confirmNewPassword && Boolean(props.errors.confirmNewPassword),
                                required: true,
                                value: props.values.confirmNewPassword,
                                onChange: props.handleChange
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "confirmNewPassword",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    })
                ]
            })
    });
};


const $d968782d7a2b7181$export$1f58f750f20f344b = ({ userType: userType, redirect: redirect = "/" })=>{
    const navigate = (0, $iIluI.useNavigate)();
    const { login: login } = (0, $1N52b.useAuth)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const { setSnackbar: setSnackbar, setModal: setModal } = (0, $fnVR5.useCommon)();
    const [recoverPasswordModalOpen, setRecoverPasswordModalOpen] = (0, $7fPBF.useState)(searchParams.get("action") === "recover-password");
    const [firstLoginModalOpen, setFirstLoginModalOpen] = (0, $7fPBF.useState)(false);
    const handleSubmit = (values, formikHelpers)=>{
        new (0, $dNDci.AppService)().api_login(userType, values).then((res)=>{
            if (res.status !== 200) throw res;
            if (userType === "club-admin" && res.data === "changePasswordRequired") {
                setFirstLoginModalOpen(true);
                return;
            }
            login(res.data, userType);
            navigate(redirect);
        }).catch((error)=>{
            console.log(error);
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("login.error.wrongEmailOrPassword")
            });
        }).finally(()=>formikHelpers.setSubmitting(false));
    };
    const formik = (0, $1ZNeQ.useFormik)({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: (0, $5abd2105f8a45ac9$export$535c6326fd176912)(t),
        onSubmit: handleSubmit
    });
    const handleForgotPasswordClick = ()=>{
        if (!!formik.errors.email || formik.values.email === formik.initialValues.email) {
            formik.setFieldTouched("email");
            formik.setFieldError("email", t("login.error.invalidEmail"));
            return;
        }
        new (0, $dNDci.AppService)().api_requestCodeForResetPassword(userType, {
            email: formik.values.email
        }).then((res)=>{
            if (res.status !== 200) throw new Error(res);
            setRecoverPasswordModalOpen(true);
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "success",
                children: t("recoverPassword.emailSent")
            });
        }).catch((error)=>{
            console.log(error);
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("recoverPassword.error.emailNotSent")
            });
        });
    };
    const handleFirstLoginClose = ()=>{
        formik.setFieldTouched("password", false);
        formik.setFieldValue("password", "");
        setFirstLoginModalOpen(false);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("form", {
                onSubmit: formik.handleSubmit,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "email",
                            label: t("email"),
                            type: "text",
                            variant: "filled",
                            required: true,
                            autoComplete: "off",
                            value: formik.values.email,
                            onChange: formik.handleChange,
                            error: formik.touched.email && !!formik.errors.email
                        }),
                        formik.touched.email && formik.errors.email && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            color: "common.white",
                            variant: "body2",
                            sx: {
                                transform: "translateY(-8px)"
                            },
                            children: formik.errors.email
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "password",
                            label: t("password"),
                            type: "password",
                            variant: "filled",
                            required: true,
                            autoComplete: "off",
                            value: formik.values.password,
                            onChange: formik.handleChange,
                            error: formik.touched.password && !!formik.errors.password
                        }),
                        formik.touched.password && formik.errors.password && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            color: "common.white",
                            variant: "body2",
                            sx: {
                                transform: "translateY(-8px)"
                            },
                            children: formik.errors.password
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c0fbf2675f5426b4$export$e3da0e99c81a4b99), {
                            variant: "text",
                            onClick: ()=>{
                                handleForgotPasswordClick();
                                setModal({
                                    open: true,
                                    title: t("recoverPassword.title"),
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fpWEH.StyledDialogContent), {
                                                dividers: true,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $918110bfce91144d$export$6630bff6ccf72719), {
                                                    email: formik.values.email,
                                                    role: userType
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8smOS.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                                        id: "cancel",
                                                        variant: "outlined",
                                                        type: "reset",
                                                        sx: {
                                                            width: "100%"
                                                        },
                                                        onClick: ()=>setModal({
                                                                open: false,
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                                                            }),
                                                        children: t("cancel")
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                                        variant: "contained",
                                                        type: "submit",
                                                        form: "form-resetPassword",
                                                        sx: {
                                                            width: "100%"
                                                        },
                                                        children: t("recoverPassword.submitButton")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            },
                            isColorBlack: window.location.pathname.includes("checkout"),
                            children: t("login.forgotPassword")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                            variant: "contained",
                            type: "submit",
                            disabled: formik.isSubmitting,
                            children: t("login.login")
                        })
                    ]
                })
            }),
            userType === "club-admin" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cd3fd0c9111cb421$export$8bbf944b59634a81), {
                open: firstLoginModalOpen,
                onClose: handleFirstLoginClose,
                email: formik.values.email,
                password: formik.values.password
            })
        ]
    });
};



var $2rOQj = parcelRequire("2rOQj");
const $60f73f8cc1267854$var$Login = ()=>{
    const { actions: { fetchDomainFeatureToggles: fetchDomainFeatureToggles } } = (0, $2rOQj.useFeatureToggles)();
    const clientId = "3e8e4fv584qslg0on1k69i2d5r";
    const redirectUrL = "https://freecourts.pt/external-provider";
    const cognitoDomain = "https://conexa-player-pool-production.auth.eu-west-1.amazoncognito.com";
    const googleProvider = `${cognitoDomain}/oauth2/authorize?identity_provider=Google&redirect_uri=${redirectUrL}&response_type=CODE&client_id=${clientId}&scope=aws.cognito.signin.user.admin email openid phone profile`;
    const navigate = (0, $iIluI.useNavigate)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const return_url = searchParams.get("return_url");
    const isFeatureToggleReady = (0, $7fPBF.useRef)(false);
    const handleGoogleLogin = ()=>{
        if (return_url) sessionStorage.setItem("google.returnURL", return_url);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (isFeatureToggleReady.current) return;
        isFeatureToggleReady.current = true;
        fetchDomainFeatureToggles();
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
                maxWidth: "sm",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c3d938b4e7bc9cfd$export$8cd7ca2dd7ba6f89), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3d938b4e7bc9cfd$export$3205ecf6997ef75f), {
                            src: "/logo_aveiro_tech_city_white.png",
                            alt: "FreeCourts: Courts for everyone"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c3d938b4e7bc9cfd$export$4d2d061eae5a2bee), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7qlUi.FeatureToggleBaseComponent), {
                                    featureToggle: (0, $3Ou5w.FeatureToggles).GOOGLE_SSO,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.Link), {
                                            to: googleProvider,
                                            onClick: handleGoogleLogin,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3d938b4e7bc9cfd$export$e3da0e99c81a4b99), {
                                                variant: "outlined",
                                                color: "white",
                                                startIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6a40c1aa52d185d$exports))), {}),
                                                children: t("login.loginWithGoogle")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {
                                            light: true,
                                            children: t("or")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d968782d7a2b7181$export$1f58f750f20f344b), {
                                    userType: "player",
                                    redirect: return_url ? return_url : "/"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                    variant: "outlined",
                                    color: "white",
                                    onClick: ()=>navigate((0, $711f8784a526fd26$export$6a5c05795461ca18)("/signup", return_url)),
                                    children: t("login.register")
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                    direction: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.Link), {
                                            to: (0, $711f8784a526fd26$export$6a5c05795461ca18)("/admin/login", return_url),
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                                variant: "text",
                                                color: "white",
                                                sx: {
                                                    padding: 0
                                                },
                                                children: t("login.clubAdminLogin")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.Link), {
                                            to: (0, $711f8784a526fd26$export$6a5c05795461ca18)("/login/admin", return_url),
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                                variant: "text",
                                                color: "white",
                                                sx: {
                                                    padding: 0
                                                },
                                                children: t("login.adminLogin")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3d938b4e7bc9cfd$export$1446d14bdc196a47), {
                src: "/images/football.jpg"
            })
        ]
    });
};
var $60f73f8cc1267854$export$2e2bcd8739ae039 = $60f73f8cc1267854$var$Login;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $aili3 = parcelRequire("aili3");
var $3loMv = parcelRequire("3loMv");


var $9uOZr = parcelRequire("9uOZr");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $1ZNeQ = parcelRequire("1ZNeQ");

var $dkKmP = parcelRequire("dkKmP");

var $afCHG = parcelRequire("afCHG");

var $dNDci = parcelRequire("dNDci");


var $7xRAC = parcelRequire("7xRAC");
parcelRequire("5aR8Y");

var $9rh0m = parcelRequire("9rh0m");
const $8bd527c82b47253d$export$391a015c1ec4b567 = (t)=>{
    return $7xRAC.object({
        name: $7xRAC.string().required(t("register.name.required")).min(3, t("validation.toShort", {
            char: "3"
        })).max(50, t("validation.toLong", {
            char: "50"
        })),
        email: $7xRAC.string().matches((0, $9rh0m.emailRegex), t("validation.requiredValidEmail")).required(t("validation.requiredEmail")),
        password: $7xRAC.string().matches((0, $9rh0m.passwordRegex), t("register.password.invalid")).required(t("register.password.required")),
        phone: $7xRAC.string().matches(/^[0-9]+$/, t("validation.phoneOnlyNumber")).phone("PT", t("validation.requiredValidPhone")),
        nif: $7xRAC.string().matches(/^[0-9]+$/, t("validation.fiscalNumberOnlyNumber")).min(9, t("validation.fiscalNumberMinNumber")).max(9, t("validation.fiscalNumberMaxNumber")),
        address: $7xRAC.string().min(3, t("validation.toShort", {
            char: "3"
        })).max(200, t("validation.toLong", {
            char: "200"
        }))
    });
};



var $fnVR5 = parcelRequire("fnVR5");

const $36d500beb4456b8b$var$Register = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const return_url = searchParams.get("return_url");
    const handleFormSubmit = (values, formikHelpers)=>{
        new (0, $dNDci.AppService)().api_registerUser("player", values).then((res)=>{
            if (res.status !== 201) throw new Error();
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "success",
                children: t("register.success")
            });
            setTimeout(()=>{
                navigate(`/verify?email=${values.email}${return_url ? `&return_url=${return_url}` : ""}`);
            }, 2000);
        }).catch((error)=>{
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t(`register.error.${error.response.status}`, {
                    email: error.response.data.message
                })
            });
            formikHelpers.setSubmitting(false);
        });
    };
    const initialValues = {
        name: "",
        email: "",
        password: "",
        phone: "",
        nif: "",
        address: ""
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
                maxWidth: "sm",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c3d938b4e7bc9cfd$export$8cd7ca2dd7ba6f89), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3d938b4e7bc9cfd$export$62593f30e57962cc), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c01e87b5e315da77$export$3a4deda42b6182b7), {
                                to: (0, $711f8784a526fd26$export$6a5c05795461ca18)("/login", return_url)
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3d938b4e7bc9cfd$export$3e431a229df88919), {
                            src: "/logo_aveiro_tech_city_white.png",
                            alt: "FreeCourts: Courts for everyone"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            color: "common.white",
                            variant: "h5",
                            textAlign: "center",
                            children: t("register.title")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
                            initialValues: initialValues,
                            validationSchema: (0, $8bd527c82b47253d$export$391a015c1ec4b567)(t),
                            onSubmit: handleFormSubmit,
                            children: (props)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c3d938b4e7bc9cfd$export$a7fed597f4b8afd8), {
                                    onSubmit: props.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                    name: "name",
                                                    label: t("register.name.label"),
                                                    type: "text",
                                                    variant: "filled",
                                                    autoComplete: "off",
                                                    value: props.values.name,
                                                    onChange: props.handleChange,
                                                    error: props.touched.name && !!props.errors.name
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                    name: "name",
                                                    children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                            color: "common.white",
                                                            variant: "body2",
                                                            children: msg
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                    name: "email",
                                                    label: t("register.email.label"),
                                                    type: "text",
                                                    variant: "filled",
                                                    autoComplete: "off",
                                                    value: props.values.email,
                                                    onChange: props.handleChange,
                                                    error: props.touched.email && !!props.errors.email
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                    name: "email",
                                                    children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                            color: "common.white",
                                                            variant: "body2",
                                                            children: msg
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                    name: "password",
                                                    label: t("password"),
                                                    type: "password",
                                                    variant: "filled",
                                                    autoComplete: "off",
                                                    value: props.values.password,
                                                    onChange: props.handleChange,
                                                    error: props.touched.password && !!props.errors.password
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                    name: "password",
                                                    children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                            color: "common.white",
                                                            variant: "body2",
                                                            children: msg
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                    name: "phone",
                                                    label: t("register.phone.label"),
                                                    type: "tel",
                                                    variant: "filled",
                                                    autoComplete: "off",
                                                    value: props.values.phone,
                                                    onChange: props.handleChange,
                                                    error: props.touched.phone && !!props.errors.phone
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                    name: "phone",
                                                    children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                            color: "common.white",
                                                            variant: "body2",
                                                            children: msg
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                    name: "nif",
                                                    label: t("register.nif.label"),
                                                    type: "text",
                                                    variant: "filled",
                                                    autoComplete: "off",
                                                    value: props.values.nif,
                                                    onChange: props.handleChange,
                                                    error: props.touched.nif && !!props.errors.nif
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                    name: "nif",
                                                    children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                            color: "common.white",
                                                            variant: "body2",
                                                            children: msg
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                    name: "address",
                                                    label: t("register.address.label"),
                                                    type: "text",
                                                    variant: "filled",
                                                    autoComplete: "off",
                                                    value: props.values.address,
                                                    onChange: props.handleChange,
                                                    error: props.touched.address && !!props.errors.address
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                    name: "address",
                                                    children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                            color: "common.white",
                                                            variant: "body2",
                                                            children: msg
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                            variant: "contained",
                                            type: "submit",
                                            disabled: props.isSubmitting,
                                            children: t("register.submitButton")
                                        })
                                    ]
                                })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3d938b4e7bc9cfd$export$1446d14bdc196a47), {
                src: "/images/football.jpg"
            })
        ]
    });
};
var $36d500beb4456b8b$export$2e2bcd8739ae039 = $36d500beb4456b8b$var$Register;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $8smOS = parcelRequire("8smOS");

var $dkKmP = parcelRequire("dkKmP");

var $9uOZr = parcelRequire("9uOZr");

parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");



var $dNYY5 = parcelRequire("dNYY5");


var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $afCHG = parcelRequire("afCHG");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $fnVR5 = parcelRequire("fnVR5");

var $7xRAC = parcelRequire("7xRAC");
parcelRequire("5aR8Y");

var $9rh0m = parcelRequire("9rh0m");
const $eae03f81b0c182fe$export$d33331c255960c96 = (t)=>{
    return $7xRAC.object({
        name: $7xRAC.string().required(t("register.name.required")).min(3, t("validation.toShort", {
            char: "3"
        })).max(50, t("validation.toLong", {
            char: "50"
        })),
        clubName: $7xRAC.string().required(t("register.name.required")).min(3, t("validation.toShort", {
            char: "3"
        })).max(50, t("validation.toLong", {
            char: "50"
        })),
        email: $7xRAC.string().matches((0, $9rh0m.emailRegex), t("validation.requiredValidEmail")).required(t("validation.requiredEmail")),
        phone: $7xRAC.string().matches(/^[0-9]+$/, t("validation.phoneOnlyNumber")).phone("PT", t("validation.requiredValidPhone")).required(t("validation.requiredField")),
        observations: $7xRAC.string().min(3, t("validation.toShort", {
            char: "3"
        })).max(200, t("validation.toLong", {
            char: "200"
        }))
    });
};



var $1ZNeQ = parcelRequire("1ZNeQ");

var $aili3 = parcelRequire("aili3");

parcelRequire("fI21S");
var $3irMb = parcelRequire("3irMb");

var $dNDci = parcelRequire("dNDci");
function $c4f00e58e8d5eb9a$export$bff49d877537702b() {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, mutate: mutate, isError: isError } = (0, $3irMb.useMutation)({
        mutationKey: [
            "requestAccount"
        ],
        mutationFn: async (userData)=>{
            const res = await appService.api_requestClubAdminAccount(userData);
            return res;
        },
        retry: false
    });
    return {
        isLoading: isLoading,
        mutate: mutate,
        isError: isError
    };
}


const $357767a0532a78bf$export$eb3a4db2f90d90ab = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setSnackbar: setSnackbar, setModal: setModal } = (0, $fnVR5.useCommon)();
    const { mutate: requestAccount } = (0, $c4f00e58e8d5eb9a$export$bff49d877537702b)();
    const initialValues = {
        name: "",
        clubName: "",
        email: "",
        phone: "",
        observations: ""
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $eae03f81b0c182fe$export$d33331c255960c96)(t),
        onSubmit: async (values, { resetForm: resetForm })=>{
            requestAccount(values, {
                onSuccess: (data)=>{
                    if (data.status !== 200) throw new Error();
                    setSnackbar({
                        open: true,
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "success",
                        children: t("clubAdmin.requestAccount.success")
                    });
                    resetForm();
                    setModal({
                        open: false,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                    });
                },
                onError: ()=>{
                    setSnackbar({
                        open: true,
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "error",
                        children: t("clubAdmin.requestAccount.error.onSubmit")
                    });
                    setModal({
                        open: false,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                    });
                }
            });
        },
        children: (props)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c56e92abe02e471f$export$a7fed597f4b8afd8), {
                onSubmit: props.handleSubmit,
                id: "form-clubAdminRegister",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                name: "name",
                                labelTop: t("clubAdmin.requestAccount.adminName"),
                                placeholder: t("clubAdmin.requestAccount.adminName"),
                                labelTopRequired: true,
                                type: "text",
                                hasLabelTop: true,
                                autoComplete: "off",
                                value: props.values.name,
                                onChange: props.handleChange,
                                error: props.touched.name && Boolean(props.errors.name)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "name",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                name: "clubName",
                                labelTopRequired: true,
                                hasLabelTop: true,
                                labelTop: t("clubAdmin.requestAccount.clubName"),
                                placeholder: t("clubAdmin.requestAccount.clubName"),
                                type: "text",
                                autoComplete: "off",
                                value: props.values.clubName,
                                onChange: props.handleChange,
                                error: props.touched.clubName && Boolean(props.errors.clubName)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "clubName",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                name: "email",
                                labelTopRequired: true,
                                hasLabelTop: true,
                                labelTop: t("clubAdmin.requestAccount.email"),
                                placeholder: t("clubAdmin.requestAccount.email"),
                                type: "text",
                                autoComplete: "off",
                                value: props.values.email,
                                onChange: props.handleChange,
                                error: props.touched.email && Boolean(props.errors.email)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "email",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                name: "phone",
                                labelTopRequired: true,
                                hasLabelTop: true,
                                labelTop: t("clubAdmin.requestAccount.phone"),
                                placeholder: t("clubAdmin.requestAccount.phone"),
                                type: "text",
                                autoComplete: "off",
                                value: props.values.phone,
                                onChange: props.handleChange,
                                error: props.touched.phone && Boolean(props.errors.phone)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "phone",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                name: "observations",
                                hasLabelTop: true,
                                labelTop: t("clubAdmin.requestAccount.observations"),
                                placeholder: t("clubAdmin.requestAccount.observations"),
                                type: "text",
                                autoComplete: "off",
                                value: props.values.observations,
                                onChange: props.handleChange,
                                error: props.touched.observations && Boolean(props.errors.observations)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                name: "observations",
                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $c56e92abe02e471f$export$4ea0ff3663964b59), {
                                        children: msg
                                    })
                            })
                        ]
                    })
                ]
            })
    });
};



var $fnVR5 = parcelRequire("fnVR5");

var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
var $8smOS = parcelRequire("8smOS");
var $8wwTv = parcelRequire("8wwTv");
var $58CWL = parcelRequire("58CWL");
var $3loMv = parcelRequire("3loMv");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");

var $930Hd = parcelRequire("930Hd");
let $b095e62db41017b4$var$_ = (t)=>t, $b095e62db41017b4$var$t, $b095e62db41017b4$var$t1, $b095e62db41017b4$var$t2, $b095e62db41017b4$var$t3, $b095e62db41017b4$var$t4, $b095e62db41017b4$var$t5, $b095e62db41017b4$var$t6, $b095e62db41017b4$var$t7, $b095e62db41017b4$var$t8, $b095e62db41017b4$var$t9, $b095e62db41017b4$var$t10, $b095e62db41017b4$var$t11, $b095e62db41017b4$var$t12, $b095e62db41017b4$var$t13, $b095e62db41017b4$var$t14, $b095e62db41017b4$var$t15, $b095e62db41017b4$var$t16, $b095e62db41017b4$var$t17;
const $b095e62db41017b4$export$18fbd793efee61f = (0, $6hfZk.default)((0, $aili3.default))($b095e62db41017b4$var$t || ($b095e62db41017b4$var$t = $b095e62db41017b4$var$_`
    display: none;
    flex-direction: row;
    gap: 0.75rem;
    flex-wrap: wrap;
    align-item: center;
    width: 100%;
    margin-bottom: 1rem;

    @media (max-width: 600px) {
        display: flex;
    }
`));
const $b095e62db41017b4$export$a00c712da48b4cb5 = (0, $6hfZk.default)((0, $aili3.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "isFilterOpen"
})($b095e62db41017b4$var$t1 || ($b095e62db41017b4$var$t1 = $b095e62db41017b4$var$_`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: left;
    gap: 1rem;

    @media (max-width: 600px) {
        display: ${0};
`), ({ isFilterOpen: isFilterOpen })=>isFilterOpen ? "flex" : "none");
const $b095e62db41017b4$export$fb46dd9777cc6db0 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($b095e62db41017b4$var$t2 || ($b095e62db41017b4$var$t2 = $b095e62db41017b4$var$_`
    width: 114px;
    max-height: 58px;
    height: 100%;
    @media (max-width: 600px) {
        width: 100%;
        max-height: 42px;
    }
`));
const $b095e62db41017b4$export$4ca10aae50aa7bfa = (0, $6hfZk.default)((0, $dkKmP.AppButton))($b095e62db41017b4$var$t3 || ($b095e62db41017b4$var$t3 = $b095e62db41017b4$var$_`
    width: 117px;
    max-height: 58px;
    height: 100%;
    @media (max-width: 600px) {
        width: 100%;
        max-height: 42px;
    }
`));
const $b095e62db41017b4$export$4f3af3718caba8c4 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($b095e62db41017b4$var$t4 || ($b095e62db41017b4$var$t4 = $b095e62db41017b4$var$_`
    width: fit-content;
    max-height: 58px !important;
    height: 100%;
    @media (max-width: 600px) {
        width: 100%;
    }
`));
const $b095e62db41017b4$export$eb3377d33cf857d6 = (0, $6hfZk.default)((0, $930Hd.Select))($b095e62db41017b4$var$t5 || ($b095e62db41017b4$var$t5 = $b095e62db41017b4$var$_`
    background-color: transparent;
    & .MuiOutlinedInput-notchedOutline {
        box-shadow: none;
    }
`));
const $b095e62db41017b4$export$3bb2bce6bb6f0906 = (0, $6hfZk.default).div($b095e62db41017b4$var$t6 || ($b095e62db41017b4$var$t6 = $b095e62db41017b4$var$_`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 1rem;
    margin-bottom: 32px;
    margin-top: 15px;
`));
const $b095e62db41017b4$export$ab66e4aae63018c1 = (0, $6hfZk.default)((0, $aili3.default))($b095e62db41017b4$var$t7 || ($b095e62db41017b4$var$t7 = $b095e62db41017b4$var$_`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`));
const $b095e62db41017b4$export$38fb881472c4cc64 = (0, $6hfZk.default)((0, $gC25j.default))($b095e62db41017b4$var$t8 || ($b095e62db41017b4$var$t8 = $b095e62db41017b4$var$_`
    width: 100%;
`));
const $b095e62db41017b4$export$1d41361302b577a1 = (0, $6hfZk.default).div($b095e62db41017b4$var$t9 || ($b095e62db41017b4$var$t9 = $b095e62db41017b4$var$_`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`));
const $b095e62db41017b4$export$4ea0ff3663964b59 = (0, $6hfZk.default)((0, $3loMv.default))($b095e62db41017b4$var$t10 || ($b095e62db41017b4$var$t10 = $b095e62db41017b4$var$_`
    color: #d32f2f;
    font-size: 12px !important;
    margin: 3px 14px 0 14px !important;
`));
const $b095e62db41017b4$export$acdc83b53a3e85ba = (0, $6hfZk.default)((0, $aili3.default))($b095e62db41017b4$var$t11 || ($b095e62db41017b4$var$t11 = $b095e62db41017b4$var$_`
    width: 100%;
    display: grid;
    grid-template-columns: auto auto;
    gap: 1rem;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`));
const $b095e62db41017b4$export$579a1e9bab103f15 = (0, $6hfZk.default)((0, $aili3.default))($b095e62db41017b4$var$t12 || ($b095e62db41017b4$var$t12 = $b095e62db41017b4$var$_`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;

    @media (max-width: 600px) {
        display: flex;
        text-align: center;
        flex-direction: column-reverse;
    }
`));
const $b095e62db41017b4$export$45d6f9185881613c = (0, $6hfZk.default)((0, $aili3.default))($b095e62db41017b4$var$t13 || ($b095e62db41017b4$var$t13 = $b095e62db41017b4$var$_`
    width: 343px !important;
    @media (max-width: 600px) {
        width: 100%;
    }
`));
const $b095e62db41017b4$export$df46a447c7e512e7 = (0, $6hfZk.default)((0, $aili3.default))($b095e62db41017b4$var$t14 || ($b095e62db41017b4$var$t14 = $b095e62db41017b4$var$_`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`));
const $b095e62db41017b4$export$cae703c457e46f23 = (0, $6hfZk.default)((0, $58CWL.default))($b095e62db41017b4$var$t15 || ($b095e62db41017b4$var$t15 = $b095e62db41017b4$var$_`
    display: flex;
    gap: 10px;
    align-items: center;
`));
const $b095e62db41017b4$export$5a0bc68f6657e9db = (0, $6hfZk.default)((0, $8wwTv.default))($b095e62db41017b4$var$t16 || ($b095e62db41017b4$var$t16 = $b095e62db41017b4$var$_`
    padding: 0 !important;
`));
const $b095e62db41017b4$export$b54ac9d7963ef6f6 = (0, $6hfZk.default)((0, $8smOS.default))($b095e62db41017b4$var$t17 || ($b095e62db41017b4$var$t17 = $b095e62db41017b4$var$_`
    justify-content: space-between !important;
`));



var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $710ebbe44120c3f0$var$_ = (t)=>t, $710ebbe44120c3f0$var$t;
const $710ebbe44120c3f0$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($710ebbe44120c3f0$var$t || ($710ebbe44120c3f0$var$t = $710ebbe44120c3f0$var$_`
    width: 100%;
`));


const $14054902dd55656f$var$Login = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const return_url = searchParams.get("return_url");
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
                maxWidth: "sm",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                    sx: {
                        width: "100%",
                        padding: "1rem 0 5rem",
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                            sx: {
                                display: "flex"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c01e87b5e315da77$export$3a4deda42b6182b7), {
                                to: (0, $711f8784a526fd26$export$6a5c05795461ca18)("/login", return_url)
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            src: "/logo_aveiro_tech_city_white.png",
                            alt: "FreeCourts: Courts for everyone",
                            style: {
                                margin: "24px auto",
                                height: "82px",
                                width: "fit-content"
                            }
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                                marginTop: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d968782d7a2b7181$export$1f58f750f20f344b), {
                                    userType: "club-admin",
                                    redirect: "/club-admin"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                    variant: "outlined",
                                    color: "white",
                                    onClick: ()=>{
                                        setModal({
                                            open: true,
                                            title: t("clubAdmin.requestAccount.title"),
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$5a0bc68f6657e9db), {
                                                        dividers: true,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $357767a0532a78bf$export$eb3a4db2f90d90ab), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8smOS.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $710ebbe44120c3f0$export$e3da0e99c81a4b99), {
                                                                id: "cancel",
                                                                variant: "outlined",
                                                                type: "reset",
                                                                onClick: ()=>setModal({
                                                                        open: false,
                                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
                                                                    }),
                                                                children: t("cancel")
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $710ebbe44120c3f0$export$e3da0e99c81a4b99), {
                                                                variant: "contained",
                                                                type: "submit",
                                                                form: "form-clubAdminRegister",
                                                                children: t("clubAdmin.requestAccount.submitButton")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        });
                                    },
                                    children: t("login.register")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95d77929a11e5518$export$1446d14bdc196a47), {
                src: "/images/swimming.jpg"
            })
        ]
    });
};
var $14054902dd55656f$export$2e2bcd8739ae039 = $14054902dd55656f$var$Login;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $1ZNeQ = parcelRequire("1ZNeQ");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dNDci = parcelRequire("dNDci");

var $9uOZr = parcelRequire("9uOZr");

var $1aJMc = parcelRequire("1aJMc");


var $aili3 = parcelRequire("aili3");
var $6F4ic = parcelRequire("6F4ic");
var $2hGJ2 = parcelRequire("2hGJ2");
var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $3RNaF = parcelRequire("3RNaF");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $71bbdb12745e92cd$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $k6RDS.default)("MuiFab", slot);
}
const $71bbdb12745e92cd$var$fabClasses = (0, $4jzsB.default)("MuiFab", [
    "root",
    "primary",
    "secondary",
    "extended",
    "circular",
    "focusVisible",
    "disabled",
    "colorInherit",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "info",
    "error",
    "warning",
    "success"
]);
var $71bbdb12745e92cd$export$2e2bcd8739ae039 = $71bbdb12745e92cd$var$fabClasses;



var $kDBhE = parcelRequire("kDBhE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $efd6aa927c8a73df$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $efd6aa927c8a73df$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `size${(0, $b6UUh.default)(size)}`,
            color === "inherit" ? "colorInherit" : color
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $71bbdb12745e92cd$export$e2cfa0ca4bce1fc2), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $efd6aa927c8a73df$var$FabRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: "MuiFab",
    slot: "Root",
    shouldForwardProp: (prop)=>(0, $kDBhE.rootShouldForwardProp)(prop) || prop === "classes",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            styles[(0, $b6UUh.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: "50%",
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: "none"
        },
        [`&.${(0, $71bbdb12745e92cd$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === "small" && {
        width: 40,
        height: 40
    }, ownerState.size === "medium" && {
        width: 48,
        height: 48
    }, ownerState.variant === "extended" && {
        borderRadius: 24,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
    }, ownerState.variant === "extended" && ownerState.size === "small" && {
        width: "auto",
        padding: "0 8px",
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === "extended" && ownerState.size === "medium" && {
        width: "auto",
        padding: "0 16px",
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === "inherit" && {
        color: "inherit"
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.color !== "inherit" && ownerState.color !== "default" && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $71bbdb12745e92cd$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $efd6aa927c8a73df$var$Fab = /*#__PURE__*/ $7fPBF.forwardRef(function Fab(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiFab"
    });
    const { children: children, className: className, color: color = "default", component: component = "button", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = "large", variant: variant = "circular" } = props, other = (0, $cFLic.default)(props, $efd6aa927c8a73df$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $efd6aa927c8a73df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($efd6aa927c8a73df$var$FabRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $efd6aa927c8a73df$export$2e2bcd8739ae039 = $efd6aa927c8a73df$var$Fab;


var $3jMGu = parcelRequire("3jMGu");
var $8TDId = parcelRequire("8TDId");
var $lHSFU = parcelRequire("lHSFU");
var $dxMGW = parcelRequire("dxMGW");
var $58CWL = parcelRequire("58CWL");
var $hG0Cb = parcelRequire("hG0Cb");
var $kspUS = parcelRequire("kspUS");
var $g9bTP = parcelRequire("g9bTP");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $bfcdfa3f5a216ca0$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $c486dcd59b0b2597$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
}), "CalendarToday");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $e92d05408ee3d3db$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $433fb023fc001063$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19.79 5.61C20.3 4.95 19.83 4 19 4H6.83l7.97 7.97 4.99-6.36zM2.81 2.81 1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z"
}), "FilterAltOff");


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $11220c52e16775ba$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
}), "List");



var $5Ju9q = parcelRequire("5Ju9q");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $5x2Vb = parcelRequire("5x2Vb");

var $aili3 = parcelRequire("aili3");
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $f652a0e37ee35e91$var$n, $f652a0e37ee35e91$export$41c562ebe57d11e2, $f652a0e37ee35e91$var$u, $f652a0e37ee35e91$export$a8257692ac88316c, $f652a0e37ee35e91$var$t, $f652a0e37ee35e91$var$r, $f652a0e37ee35e91$var$o, $f652a0e37ee35e91$var$f, $f652a0e37ee35e91$var$e, $f652a0e37ee35e91$var$c = {}, $f652a0e37ee35e91$var$s = [], $f652a0e37ee35e91$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $f652a0e37ee35e91$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $f652a0e37ee35e91$var$v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $f652a0e37ee35e91$export$c8a8987d4410bf2d(l, u, i) {
    var t, r, o, f = {};
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $f652a0e37ee35e91$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === f[o] && (f[o] = l.defaultProps[o]);
    return $f652a0e37ee35e91$var$p(l, f, t, r, null);
}
function $f652a0e37ee35e91$var$p(n, i, t, r, o) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$f652a0e37ee35e91$var$u : o
    };
    return null == o && null != $f652a0e37ee35e91$export$41c562ebe57d11e2.vnode && $f652a0e37ee35e91$export$41c562ebe57d11e2.vnode(f), f;
}
function $f652a0e37ee35e91$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $f652a0e37ee35e91$export$ffb0004e005737fa(n) {
    return n.children;
}
function $f652a0e37ee35e91$var$k(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || $f652a0e37ee35e91$var$g(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || $f652a0e37ee35e91$var$g(n, r, l[r], u[r], i);
}
function $f652a0e37ee35e91$var$b(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $f652a0e37ee35e91$var$a.test(l) ? u : u + "px";
}
function $f652a0e37ee35e91$var$g(n, l, u, i, t) {
    var r;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $f652a0e37ee35e91$var$b(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $f652a0e37ee35e91$var$b(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) r = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? i || n.addEventListener(l, r ? $f652a0e37ee35e91$var$w : $f652a0e37ee35e91$var$m, r) : n.removeEventListener(l, r ? $f652a0e37ee35e91$var$w : $f652a0e37ee35e91$var$m, r);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && -1 == l.indexOf("-") ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $f652a0e37ee35e91$var$m(n) {
    $f652a0e37ee35e91$var$t = !0;
    try {
        return this.l[n.type + !1]($f652a0e37ee35e91$export$41c562ebe57d11e2.event ? $f652a0e37ee35e91$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $f652a0e37ee35e91$var$t = !1;
    }
}
function $f652a0e37ee35e91$var$w(n) {
    $f652a0e37ee35e91$var$t = !0;
    try {
        return this.l[n.type + !0]($f652a0e37ee35e91$export$41c562ebe57d11e2.event ? $f652a0e37ee35e91$export$41c562ebe57d11e2.event(n) : n);
    } finally{
        $f652a0e37ee35e91$var$t = !1;
    }
}
function $f652a0e37ee35e91$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $f652a0e37ee35e91$var$A(n, l) {
    if (null == l) return n.__ ? $f652a0e37ee35e91$var$A(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $f652a0e37ee35e91$var$A(n) : null;
}
function $f652a0e37ee35e91$var$P(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $f652a0e37ee35e91$var$P(n);
    }
}
function $f652a0e37ee35e91$var$C(n) {
    $f652a0e37ee35e91$var$t ? setTimeout(n) : $f652a0e37ee35e91$var$f(n);
}
function $f652a0e37ee35e91$var$T(n) {
    (!n.__d && (n.__d = !0) && $f652a0e37ee35e91$var$r.push(n) && !$f652a0e37ee35e91$var$$.__r++ || $f652a0e37ee35e91$var$o !== $f652a0e37ee35e91$export$41c562ebe57d11e2.debounceRendering) && (($f652a0e37ee35e91$var$o = $f652a0e37ee35e91$export$41c562ebe57d11e2.debounceRendering) || $f652a0e37ee35e91$var$C)($f652a0e37ee35e91$var$$);
}
function $f652a0e37ee35e91$var$$() {
    var n, l, u, i, t, o, f, e;
    for($f652a0e37ee35e91$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }); n = $f652a0e37ee35e91$var$r.shift();)n.__d && (l = $f652a0e37ee35e91$var$r.length, i = void 0, t = void 0, f = (o = (u = n).__v).__e, (e = u.__P) && (i = [], (t = $f652a0e37ee35e91$var$h({}, o)).__v = o.__v + 1, $f652a0e37ee35e91$var$M(e, o, t, u.__n, void 0 !== e.ownerSVGElement, null != o.__h ? [
        f
    ] : null, i, null == f ? $f652a0e37ee35e91$var$A(o) : f, o.__h), $f652a0e37ee35e91$var$N(i, o), o.__e != f && $f652a0e37ee35e91$var$P(o)), $f652a0e37ee35e91$var$r.length > l && $f652a0e37ee35e91$var$r.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }));
    $f652a0e37ee35e91$var$$.__r = 0;
}
function $f652a0e37ee35e91$var$H(n, l, u, i, t, r, o, f, e, a) {
    var h, v, y, d, k, b, g, m = i && i.__k || $f652a0e37ee35e91$var$s, w = m.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (d = u.__k[h] = null == (d = l[h]) || "boolean" == typeof d ? null : "string" == typeof d || "number" == typeof d || "bigint" == typeof d ? $f652a0e37ee35e91$var$p(null, d, null, null, d) : Array.isArray(d) ? $f652a0e37ee35e91$var$p($f652a0e37ee35e91$export$ffb0004e005737fa, {
        children: d
    }, null, null, null) : d.__b > 0 ? $f652a0e37ee35e91$var$p(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : d)) {
        if (d.__ = u, d.__b = u.__b + 1, null === (y = m[h]) || y && d.key == y.key && d.type === y.type) m[h] = void 0;
        else for(v = 0; v < w; v++){
            if ((y = m[v]) && d.key == y.key && d.type === y.type) {
                m[v] = void 0;
                break;
            }
            y = null;
        }
        $f652a0e37ee35e91$var$M(n, d, y = y || $f652a0e37ee35e91$var$c, t, r, o, f, e, a), k = d.__e, (v = d.ref) && y.ref != v && (g || (g = []), y.ref && g.push(y.ref, null, d), g.push(v, d.__c || k, d)), null != k ? (null == b && (b = k), "function" == typeof d.type && d.__k === y.__k ? d.__d = e = $f652a0e37ee35e91$var$I(d, e, n) : e = $f652a0e37ee35e91$var$z(n, d, y, m, k, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $f652a0e37ee35e91$var$A(y));
    }
    for(u.__e = b, h = w; h--;)null != m[h] && ("function" == typeof u.type && null != m[h].__e && m[h].__e == u.__d && (u.__d = $f652a0e37ee35e91$var$L(i).nextSibling), $f652a0e37ee35e91$var$q(m[h], m[h]));
    if (g) for(h = 0; h < g.length; h++)$f652a0e37ee35e91$var$S(g[h], g[++h], g[++h]);
}
function $f652a0e37ee35e91$var$I(n, l, u) {
    for(var i, t = n.__k, r = 0; t && r < t.length; r++)(i = t[r]) && (i.__ = n, l = "function" == typeof i.type ? $f652a0e37ee35e91$var$I(i, l, u) : $f652a0e37ee35e91$var$z(u, i, i, t, i.__e, l));
    return l;
}
function $f652a0e37ee35e91$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $f652a0e37ee35e91$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $f652a0e37ee35e91$var$z(n, l, u, i, t, r) {
    var o, f, e;
    if (void 0 !== l.__d) o = l.__d, l.__d = void 0;
    else if (null == u || t != r || null == t.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(t), o = null;
    else {
        for(f = r, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, r), o = r;
    }
    return void 0 !== o ? o : t.nextSibling;
}
function $f652a0e37ee35e91$var$L(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $f652a0e37ee35e91$var$L(u))) return i;
    }
    return null;
}
function $f652a0e37ee35e91$var$M(n, u, i, t, r, o, f, e, c) {
    var s, a, v, y, p, d, k, b, g, m, w, A, P, C, T, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, o = [
        e
    ]), (s = $f652a0e37ee35e91$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (b = u.props, g = (s = $.contextType) && t[s.__c], m = s ? g ? g.props.value : s.__ : t, i.__c ? k = (a = u.__c = i.__c).__ = a.__E : ("prototype" in $ && $.prototype.render ? u.__c = a = new $(b, m) : (u.__c = a = new $f652a0e37ee35e91$export$16fa2f45be04daa8(b, m), a.constructor = $, a.render = $f652a0e37ee35e91$var$B), g && g.sub(a), a.props = b, a.state || (a.state = {}), a.context = m, a.__n = t, v = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != $.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $f652a0e37ee35e91$var$h({}, a.__s)), $f652a0e37ee35e91$var$h(a.__s, $.getDerivedStateFromProps(b, a.__s))), y = a.props, p = a.state, a.__v = u, v) null == $.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && b !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(b, m), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(b, a.__s, m) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = b, a.state = a.__s, a.__d = !1), u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), w = 0; w < a._sb.length; w++)a.__h.push(a._sb[w]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(b, a.__s, m), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, p, d);
                });
            }
            if (a.context = m, a.props = b, a.__P = n, A = $f652a0e37ee35e91$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) {
                for(a.state = a.__s, a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                a._sb = [];
            } else do a.__d = !1, A && A(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++P < 25);
            a.state = a.__s, null != a.getChildContext && (t = $f652a0e37ee35e91$var$h($f652a0e37ee35e91$var$h({}, t), a.getChildContext())), v || null == a.getSnapshotBeforeUpdate || (d = a.getSnapshotBeforeUpdate(y, p)), T = null != s && s.type === $f652a0e37ee35e91$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $f652a0e37ee35e91$var$H(n, Array.isArray(T) ? T : [
                T
            ], u, i, t, r, o, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), k && (a.__E = a.__ = null), a.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $f652a0e37ee35e91$var$O(i.__e, u, i, t, r, o, f, c);
        (s = $f652a0e37ee35e91$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != o) && (u.__e = e, u.__h = !!c, o[o.indexOf(e)] = null), $f652a0e37ee35e91$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $f652a0e37ee35e91$var$N(n, u) {
    $f652a0e37ee35e91$export$41c562ebe57d11e2.__c && $f652a0e37ee35e91$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $f652a0e37ee35e91$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $f652a0e37ee35e91$var$O(l, u, i, t, r, o, f, e) {
    var s, a, h, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (r = !0), null != o) {
        for(; _ < o.length; _++)if ((s = o[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, o[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = r ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), o = null, e = !1;
    }
    if (null === d) y === p || e && l.data === p || (l.data = p);
    else {
        if (o = o && $f652a0e37ee35e91$var$n.call(l.childNodes), a = (y = i.props || $f652a0e37ee35e91$var$c).dangerouslySetInnerHTML, h = p.dangerouslySetInnerHTML, !e) {
            if (null != o) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($f652a0e37ee35e91$var$k(l, p, y, r, e), h) u.__k = [];
        else if (_ = u.props.children, $f652a0e37ee35e91$var$H(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, r && "foreignObject" !== d, o, f, o ? o[0] : i.__k && $f652a0e37ee35e91$var$A(i, 0), e), null != o) for(_ = o.length; _--;)null != o[_] && $f652a0e37ee35e91$var$v(o[_]);
        e || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $f652a0e37ee35e91$var$g(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $f652a0e37ee35e91$var$g(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $f652a0e37ee35e91$var$S(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $f652a0e37ee35e91$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $f652a0e37ee35e91$var$q(n, u, i) {
    var t, r;
    if ($f652a0e37ee35e91$export$41c562ebe57d11e2.unmount && $f652a0e37ee35e91$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $f652a0e37ee35e91$var$S(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $f652a0e37ee35e91$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(r = 0; r < t.length; r++)t[r] && $f652a0e37ee35e91$var$q(t[r], u, i || "function" != typeof n.type);
    i || null == n.__e || $f652a0e37ee35e91$var$v(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $f652a0e37ee35e91$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $f652a0e37ee35e91$export$b3890eb0ae9dca99(u, i, t) {
    var r, o, f;
    $f652a0e37ee35e91$export$41c562ebe57d11e2.__ && $f652a0e37ee35e91$export$41c562ebe57d11e2.__(u, i), o = (r = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $f652a0e37ee35e91$var$M(i, u = (!r && t || i).__k = $f652a0e37ee35e91$export$c8a8987d4410bf2d($f652a0e37ee35e91$export$ffb0004e005737fa, null, [
        u
    ]), o || $f652a0e37ee35e91$var$c, $f652a0e37ee35e91$var$c, void 0 !== i.ownerSVGElement, !r && t ? [
        t
    ] : o ? null : i.firstChild ? $f652a0e37ee35e91$var$n.call(i.childNodes) : null, f, !r && t ? t : o ? o.__e : i.firstChild, r), $f652a0e37ee35e91$var$N(f, u);
}
function $f652a0e37ee35e91$export$fa8d919ba61d84db(n, l) {
    $f652a0e37ee35e91$export$b3890eb0ae9dca99(n, l, $f652a0e37ee35e91$export$fa8d919ba61d84db);
}
function $f652a0e37ee35e91$export$e530037191fcd5d7(l, u, i) {
    var t, r, o, f = $f652a0e37ee35e91$var$h({}, l.props);
    for(o in u)"key" == o ? t = u[o] : "ref" == o ? r = u[o] : f[o] = u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $f652a0e37ee35e91$var$n.call(arguments, 2) : i), $f652a0e37ee35e91$var$p(l.type, f, t || l.key, r || l.ref, null);
}
function $f652a0e37ee35e91$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $f652a0e37ee35e91$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $f652a0e37ee35e91$var$T(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$f652a0e37ee35e91$var$n = $f652a0e37ee35e91$var$s.slice, $f652a0e37ee35e91$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, r, o; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((r = t.constructor) && null != r.getDerivedStateFromError && (t.setState(r.getDerivedStateFromError(n)), o = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), o = t.__d), o) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $f652a0e37ee35e91$var$u = 0, $f652a0e37ee35e91$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $f652a0e37ee35e91$var$t = !1, $f652a0e37ee35e91$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $f652a0e37ee35e91$var$h({}, this.state), "function" == typeof n && (n = n($f652a0e37ee35e91$var$h({}, u), this.props)), n && $f652a0e37ee35e91$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $f652a0e37ee35e91$var$T(this));
}, $f652a0e37ee35e91$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $f652a0e37ee35e91$var$T(this));
}, $f652a0e37ee35e91$export$16fa2f45be04daa8.prototype.render = $f652a0e37ee35e91$export$ffb0004e005737fa, $f652a0e37ee35e91$var$r = [], $f652a0e37ee35e91$var$f = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $f652a0e37ee35e91$var$$.__r = 0, $f652a0e37ee35e91$var$e = 0;




var $99dbe43b44310798$var$t, $99dbe43b44310798$var$r, $99dbe43b44310798$var$u, $99dbe43b44310798$var$i, $99dbe43b44310798$var$o = 0, $99dbe43b44310798$var$f = [], $99dbe43b44310798$var$c = [], $99dbe43b44310798$var$e = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__b, $99dbe43b44310798$var$a = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__r, $99dbe43b44310798$var$v = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).diffed, $99dbe43b44310798$var$l = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__c, $99dbe43b44310798$var$m = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).unmount;
function $99dbe43b44310798$var$d(t, u) {
    (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__h && (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__h($99dbe43b44310798$var$r, t, $99dbe43b44310798$var$o || u), $99dbe43b44310798$var$o = 0;
    var i = $99dbe43b44310798$var$r.__H || ($99dbe43b44310798$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $99dbe43b44310798$var$c
    }), i.__[t];
}
function $99dbe43b44310798$export$60241385465d0a34(n) {
    return $99dbe43b44310798$var$o = 1, $99dbe43b44310798$export$13e3392192263954($99dbe43b44310798$var$B, n);
}
function $99dbe43b44310798$export$13e3392192263954(n, u, i) {
    var o = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $99dbe43b44310798$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $99dbe43b44310798$var$r, !$99dbe43b44310798$var$r.u)) {
        $99dbe43b44310798$var$r.u = !0;
        var f = $99dbe43b44310798$var$r.shouldComponentUpdate;
        $99dbe43b44310798$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !f || f.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!f || f.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $99dbe43b44310798$export$6d9c69b0de29b591(u, i) {
    var o = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 3);
    !(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__s && $99dbe43b44310798$var$z(o.__H, i) && (o.__ = u, o.i = i, $99dbe43b44310798$var$r.__H.__h.push(o));
}
function $99dbe43b44310798$export$e5c5a5f917a5871c(u, i) {
    var o = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 4);
    !(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__s && $99dbe43b44310798$var$z(o.__H, i) && (o.__ = u, o.i = i, $99dbe43b44310798$var$r.__h.push(o));
}
function $99dbe43b44310798$export$b8f5890fc79d6aca(n) {
    return $99dbe43b44310798$var$o = 5, $99dbe43b44310798$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $99dbe43b44310798$export$d5a552a76deda3c2(n, t, r) {
    $99dbe43b44310798$var$o = 6, $99dbe43b44310798$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $99dbe43b44310798$export$1538c33de8887b59(n, r) {
    var u = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 7);
    return $99dbe43b44310798$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $99dbe43b44310798$export$35808ee640e87ca7(n, t) {
    return $99dbe43b44310798$var$o = 8, $99dbe43b44310798$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $99dbe43b44310798$export$fae74005e78b1a27(n) {
    var u = $99dbe43b44310798$var$r.context[n.__c], i = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($99dbe43b44310798$var$r)), u.props.value) : n.__;
}
function $99dbe43b44310798$export$dc8fbce3eb94dc1e(t, r) {
    (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).useDebugValue && (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $99dbe43b44310798$export$c052f6604b7d51fe(n) {
    var u = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 10), i = $99dbe43b44310798$export$60241385465d0a34();
    return u.__ = n, $99dbe43b44310798$var$r.componentDidCatch || ($99dbe43b44310798$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $99dbe43b44310798$export$f680877a34711e37() {
    var n = $99dbe43b44310798$var$d($99dbe43b44310798$var$t++, 11);
    if (!n.__) {
        for(var u = $99dbe43b44310798$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $99dbe43b44310798$var$b() {
    for(var t; t = $99dbe43b44310798$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($99dbe43b44310798$var$k), t.__H.__h.forEach($99dbe43b44310798$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__b = function(n) {
    $99dbe43b44310798$var$r = null, $99dbe43b44310798$var$e && $99dbe43b44310798$var$e(n);
}, (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__r = function(n) {
    $99dbe43b44310798$var$a && $99dbe43b44310798$var$a(n), $99dbe43b44310798$var$t = 0;
    var i = ($99dbe43b44310798$var$r = n.__c).__H;
    i && ($99dbe43b44310798$var$u === $99dbe43b44310798$var$r ? (i.__h = [], $99dbe43b44310798$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $99dbe43b44310798$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($99dbe43b44310798$var$k), i.__h.forEach($99dbe43b44310798$var$w), i.__h = [])), $99dbe43b44310798$var$u = $99dbe43b44310798$var$r;
}, (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).diffed = function(t) {
    $99dbe43b44310798$var$v && $99dbe43b44310798$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $99dbe43b44310798$var$f.push(o) && $99dbe43b44310798$var$i === (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).requestAnimationFrame || (($99dbe43b44310798$var$i = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).requestAnimationFrame) || $99dbe43b44310798$var$j)($99dbe43b44310798$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $99dbe43b44310798$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $99dbe43b44310798$var$c;
    })), $99dbe43b44310798$var$u = $99dbe43b44310798$var$r = null;
}, (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($99dbe43b44310798$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $99dbe43b44310798$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $99dbe43b44310798$var$l && $99dbe43b44310798$var$l(t, r);
}, (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).unmount = function(t) {
    $99dbe43b44310798$var$m && $99dbe43b44310798$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $99dbe43b44310798$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $99dbe43b44310798$var$g = "function" == typeof requestAnimationFrame;
function $99dbe43b44310798$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $99dbe43b44310798$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $99dbe43b44310798$var$g && (t = requestAnimationFrame(r));
}
function $99dbe43b44310798$var$k(n) {
    var t = $99dbe43b44310798$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $99dbe43b44310798$var$r = t;
}
function $99dbe43b44310798$var$w(n) {
    var t = $99dbe43b44310798$var$r;
    n.__c = n.__(), $99dbe43b44310798$var$r = t;
}
function $99dbe43b44310798$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $99dbe43b44310798$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $851e87f7aebddd87$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $851e87f7aebddd87$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $851e87f7aebddd87$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $851e87f7aebddd87$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $851e87f7aebddd87$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $851e87f7aebddd87$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($851e87f7aebddd87$export$221d75b3f55bb0bd.prototype = new (0, $f652a0e37ee35e91$export$16fa2f45be04daa8)).isPureReactComponent = !0, $851e87f7aebddd87$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $851e87f7aebddd87$var$C(this.props, n) || $851e87f7aebddd87$var$C(this.state, t);
};
var $851e87f7aebddd87$var$x = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__b;
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $851e87f7aebddd87$var$x && $851e87f7aebddd87$var$x(n);
};
var $851e87f7aebddd87$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $851e87f7aebddd87$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $851e87f7aebddd87$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $851e87f7aebddd87$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $851e87f7aebddd87$var$A = function(n, t) {
    return null == n ? null : (0, $f652a0e37ee35e91$export$47e4c5b300681277)((0, $f652a0e37ee35e91$export$47e4c5b300681277)(n).map(t));
}, $851e87f7aebddd87$export$dca3b0875bd9a954 = {
    map: $851e87f7aebddd87$var$A,
    forEach: $851e87f7aebddd87$var$A,
    count: function(n) {
        return n ? (0, $f652a0e37ee35e91$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $f652a0e37ee35e91$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $f652a0e37ee35e91$export$47e4c5b300681277)
}, $851e87f7aebddd87$var$T = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__e;
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $851e87f7aebddd87$var$T(n, t, e, r);
};
var $851e87f7aebddd87$var$I = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).unmount;
function $851e87f7aebddd87$var$L(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $851e87f7aebddd87$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $851e87f7aebddd87$var$L(n, t, e);
    })), n;
}
function $851e87f7aebddd87$var$U(n, t, e) {
    return n && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $851e87f7aebddd87$var$U(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $851e87f7aebddd87$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $851e87f7aebddd87$var$F(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $851e87f7aebddd87$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $851e87f7aebddd87$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $851e87f7aebddd87$var$I && $851e87f7aebddd87$var$I(n);
}, ($851e87f7aebddd87$export$74bf444e3cd11ea5.prototype = new (0, $f652a0e37ee35e91$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $851e87f7aebddd87$var$F(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $851e87f7aebddd87$var$U(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $851e87f7aebddd87$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $851e87f7aebddd87$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $851e87f7aebddd87$var$L(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__h = null), [
        (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $851e87f7aebddd87$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $851e87f7aebddd87$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $851e87f7aebddd87$var$$(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $f652a0e37ee35e91$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), n.__v ? (e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $f652a0e37ee35e91$export$b3890eb0ae9dca99)((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($851e87f7aebddd87$var$P, {
        context: e.context
    }, n.__v), e.l)) : e.l && e.componentWillUnmount();
}
function $851e87f7aebddd87$export$d39a5bbd09211389(n, e) {
    var r = (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($851e87f7aebddd87$var$$, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($851e87f7aebddd87$export$998bcd577473dd93.prototype = new (0, $f652a0e37ee35e91$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $851e87f7aebddd87$var$F(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $851e87f7aebddd87$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $851e87f7aebddd87$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $f652a0e37ee35e91$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $851e87f7aebddd87$export$998bcd577473dd93.prototype.componentDidUpdate = $851e87f7aebddd87$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $851e87f7aebddd87$var$W(n, e, t);
    });
};
var $851e87f7aebddd87$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $851e87f7aebddd87$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $851e87f7aebddd87$var$H = "undefined" != typeof document, $851e87f7aebddd87$var$Z = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $851e87f7aebddd87$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $f652a0e37ee35e91$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $851e87f7aebddd87$export$fa8d919ba61d84db(n, t, e) {
    return (0, $f652a0e37ee35e91$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $f652a0e37ee35e91$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $f652a0e37ee35e91$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $851e87f7aebddd87$var$G = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).event;
function $851e87f7aebddd87$var$J() {}
function $851e87f7aebddd87$var$K() {
    return this.cancelBubble;
}
function $851e87f7aebddd87$var$Q() {
    return this.defaultPrevented;
}
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).event = function(n) {
    return $851e87f7aebddd87$var$G && (n = $851e87f7aebddd87$var$G(n)), n.persist = $851e87f7aebddd87$var$J, n.isPropagationStopped = $851e87f7aebddd87$var$K, n.isDefaultPrevented = $851e87f7aebddd87$var$Q, n.nativeEvent = n;
};
var $851e87f7aebddd87$var$X, $851e87f7aebddd87$var$nn = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $851e87f7aebddd87$var$tn = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).vnode;
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).vnode = function(n) {
    var t = n.type, e = n.props, u = e;
    if ("string" == typeof t) {
        var o = -1 === t.indexOf("-");
        for(var i in u = {}, e){
            var l = e[i];
            $851e87f7aebddd87$var$H && "children" === i && "noscript" === t || "value" === i && "defaultValue" in e && null == l || ("defaultValue" === i && "value" in e && null == e.value ? i = "value" : "download" === i && !0 === l ? l = "" : /ondoubleclick/i.test(i) ? i = "ondblclick" : /^onchange(textarea|input)/i.test(i + t) && !$851e87f7aebddd87$var$Z(e.type) ? i = "oninput" : /^onfocus$/i.test(i) ? i = "onfocusin" : /^onblur$/i.test(i) ? i = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i) ? i = i.toLowerCase() : o && $851e87f7aebddd87$var$B.test(i) ? i = i.replace(/[A-Z0-9]/g, "-$&").toLowerCase() : null === l && (l = void 0), /^oninput$/i.test(i) && (i = i.toLowerCase(), u[i] && (i = "oninputCapture")), u[i] = l);
        }
        "select" == t && u.multiple && Array.isArray(u.value) && (u.value = (0, $f652a0e37ee35e91$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == t && null != u.defaultValue && (u.value = (0, $f652a0e37ee35e91$export$47e4c5b300681277)(e.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), n.props = u, e.class != e.className && ($851e87f7aebddd87$var$nn.enumerable = "className" in e, null != e.className && (u.class = e.className), Object.defineProperty(u, "className", $851e87f7aebddd87$var$nn));
    }
    n.$$typeof = $851e87f7aebddd87$var$z, $851e87f7aebddd87$var$tn && $851e87f7aebddd87$var$tn(n);
};
var $851e87f7aebddd87$var$en = (0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__r;
(0, $f652a0e37ee35e91$export$41c562ebe57d11e2).__r = function(n) {
    $851e87f7aebddd87$var$en && $851e87f7aebddd87$var$en(n), $851e87f7aebddd87$var$X = n.__c;
};
var $851e87f7aebddd87$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $851e87f7aebddd87$var$X.__n[n.__c].props.value;
            }
        }
    }
}, $851e87f7aebddd87$export$83d89fbfd8236492 = "17.0.2";
function $851e87f7aebddd87$export$d38cd72104c1f0e9(n) {
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d).bind(null, n);
}
function $851e87f7aebddd87$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $851e87f7aebddd87$var$z;
}
function $851e87f7aebddd87$export$e530037191fcd5d7(n) {
    return $851e87f7aebddd87$export$a8257692ac88316c(n) ? (0, $f652a0e37ee35e91$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $851e87f7aebddd87$export$502457920280e6be(n) {
    return !!n.__k && ((0, $f652a0e37ee35e91$export$b3890eb0ae9dca99)(null, n), !0);
}
function $851e87f7aebddd87$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $851e87f7aebddd87$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $851e87f7aebddd87$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $851e87f7aebddd87$export$5f8d39834fd61797 = (0, $f652a0e37ee35e91$export$ffb0004e005737fa);
function $851e87f7aebddd87$export$7568632d0d33d16d(n) {
    n();
}
function $851e87f7aebddd87$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $851e87f7aebddd87$export$7b286972b8d8ccbf() {
    return [
        !1,
        $851e87f7aebddd87$export$7568632d0d33d16d
    ];
}
var $851e87f7aebddd87$export$aaabe4eda9ed9969 = (0, $99dbe43b44310798$export$e5c5a5f917a5871c);
function $851e87f7aebddd87$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $99dbe43b44310798$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $99dbe43b44310798$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $851e87f7aebddd87$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $99dbe43b44310798$export$6d9c69b0de29b591)(function() {
        return $851e87f7aebddd87$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $851e87f7aebddd87$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $851e87f7aebddd87$export$2e2bcd8739ae039 = {
    useState: (0, $99dbe43b44310798$export$60241385465d0a34),
    useId: (0, $99dbe43b44310798$export$f680877a34711e37),
    useReducer: (0, $99dbe43b44310798$export$13e3392192263954),
    useEffect: (0, $99dbe43b44310798$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $99dbe43b44310798$export$e5c5a5f917a5871c),
    useInsertionEffect: $851e87f7aebddd87$export$aaabe4eda9ed9969,
    useTransition: $851e87f7aebddd87$export$7b286972b8d8ccbf,
    useDeferredValue: $851e87f7aebddd87$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $851e87f7aebddd87$export$306c0aa65ff9ec16,
    startTransition: $851e87f7aebddd87$export$7568632d0d33d16d,
    useRef: (0, $99dbe43b44310798$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $99dbe43b44310798$export$d5a552a76deda3c2),
    useMemo: (0, $99dbe43b44310798$export$1538c33de8887b59),
    useCallback: (0, $99dbe43b44310798$export$35808ee640e87ca7),
    useContext: (0, $99dbe43b44310798$export$fae74005e78b1a27),
    useDebugValue: (0, $99dbe43b44310798$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $851e87f7aebddd87$export$dca3b0875bd9a954,
    render: $851e87f7aebddd87$export$b3890eb0ae9dca99,
    hydrate: $851e87f7aebddd87$export$fa8d919ba61d84db,
    unmountComponentAtNode: $851e87f7aebddd87$export$502457920280e6be,
    createPortal: $851e87f7aebddd87$export$d39a5bbd09211389,
    createElement: (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d),
    createContext: (0, $f652a0e37ee35e91$export$fd42f52fd3ae1109),
    createFactory: $851e87f7aebddd87$export$d38cd72104c1f0e9,
    cloneElement: $851e87f7aebddd87$export$e530037191fcd5d7,
    createRef: (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43),
    Fragment: (0, $f652a0e37ee35e91$export$ffb0004e005737fa),
    isValidElement: $851e87f7aebddd87$export$a8257692ac88316c,
    findDOMNode: $851e87f7aebddd87$export$466bfc07425424d5,
    Component: (0, $f652a0e37ee35e91$export$16fa2f45be04daa8),
    PureComponent: $851e87f7aebddd87$export$221d75b3f55bb0bd,
    memo: $851e87f7aebddd87$export$7c73462e0d25e514,
    forwardRef: $851e87f7aebddd87$export$257a8862b851cb5b,
    flushSync: $851e87f7aebddd87$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $851e87f7aebddd87$export$c78a37762a8d58e1,
    StrictMode: $851e87f7aebddd87$export$5f8d39834fd61797,
    Suspense: $851e87f7aebddd87$export$74bf444e3cd11ea5,
    SuspenseList: $851e87f7aebddd87$export$998bcd577473dd93,
    lazy: $851e87f7aebddd87$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $851e87f7aebddd87$export$ae55be85d98224ed
};


const $200f5cce291452b2$var$styleTexts = [];
const $200f5cce291452b2$var$styleEls = new Map();
function $200f5cce291452b2$export$c373adc892eb6355(styleText) {
    $200f5cce291452b2$var$styleTexts.push(styleText);
    $200f5cce291452b2$var$styleEls.forEach((styleEl)=>{
        $200f5cce291452b2$var$appendStylesTo(styleEl, styleText);
    });
}
function $200f5cce291452b2$export$4c3d22f3d993c33f(el) {
    if (el.isConnected) $200f5cce291452b2$var$registerStylesRoot(el.getRootNode());
}
function $200f5cce291452b2$var$registerStylesRoot(rootNode) {
    let styleEl = $200f5cce291452b2$var$styleEls.get(rootNode);
    if (!styleEl || !styleEl.isConnected) {
        styleEl = rootNode.querySelector("style[data-fullcalendar]");
        if (!styleEl) {
            styleEl = document.createElement("style");
            styleEl.setAttribute("data-fullcalendar", "");
            const nonce = $200f5cce291452b2$var$getNonceValue();
            if (nonce) styleEl.nonce = nonce;
            const parentEl = rootNode === document ? document.head : rootNode;
            const insertBefore = rootNode === document ? parentEl.querySelector("script,link[rel=stylesheet],link[as=style],style") : parentEl.firstChild;
            parentEl.insertBefore(styleEl, insertBefore);
        }
        $200f5cce291452b2$var$styleEls.set(rootNode, styleEl);
        $200f5cce291452b2$var$hydrateStylesRoot(styleEl);
    }
}
function $200f5cce291452b2$var$hydrateStylesRoot(styleEl) {
    for (const styleText of $200f5cce291452b2$var$styleTexts)$200f5cce291452b2$var$appendStylesTo(styleEl, styleText);
}
function $200f5cce291452b2$var$appendStylesTo(styleEl, styleText) {
    const { sheet: sheet } = styleEl;
    const ruleCnt = sheet.cssRules.length;
    styleText.split("}").forEach((styleStr, i)=>{
        styleStr = styleStr.trim();
        if (styleStr) sheet.insertRule(styleStr + "}", ruleCnt + i);
    });
}
// nonce
// -------------------------------------------------------------------------------------------------
let $200f5cce291452b2$var$queriedNonceValue;
function $200f5cce291452b2$var$getNonceValue() {
    if ($200f5cce291452b2$var$queriedNonceValue === undefined) $200f5cce291452b2$var$queriedNonceValue = $200f5cce291452b2$var$queryNonceValue();
    return $200f5cce291452b2$var$queriedNonceValue;
}
/*
TODO: discourage meta tag and instead put nonce attribute on placeholder <style> tag
*/ function $200f5cce291452b2$var$queryNonceValue() {
    const metaWithNonce = document.querySelector('meta[name="csp-nonce"]');
    if (metaWithNonce && metaWithNonce.hasAttribute("content")) return metaWithNonce.getAttribute("content");
    const elWithNonce = document.querySelector("script[nonce]");
    if (elWithNonce) return elWithNonce.nonce || "";
    return "";
}
// main
// -------------------------------------------------------------------------------------------------
if (typeof document !== "undefined") $200f5cce291452b2$var$registerStylesRoot(document);
var $200f5cce291452b2$var$css_248z = ':root{--fc-small-font-size:.85em;--fc-page-bg-color:#fff;--fc-neutral-bg-color:hsla(0,0%,82%,.3);--fc-neutral-text-color:grey;--fc-border-color:#ddd;--fc-button-text-color:#fff;--fc-button-bg-color:#2c3e50;--fc-button-border-color:#2c3e50;--fc-button-hover-bg-color:#1e2b37;--fc-button-hover-border-color:#1a252f;--fc-button-active-bg-color:#1a252f;--fc-button-active-border-color:#151e27;--fc-event-bg-color:#3788d8;--fc-event-border-color:#3788d8;--fc-event-text-color:#fff;--fc-event-selected-overlay-color:rgba(0,0,0,.25);--fc-more-link-bg-color:#d0d0d0;--fc-more-link-text-color:inherit;--fc-event-resizer-thickness:8px;--fc-event-resizer-dot-total-width:8px;--fc-event-resizer-dot-border-width:1px;--fc-non-business-color:hsla(0,0%,84%,.3);--fc-bg-event-color:#8fdf82;--fc-bg-event-opacity:0.3;--fc-highlight-color:rgba(188,232,241,.3);--fc-today-bg-color:rgba(255,220,40,.15);--fc-now-indicator-color:red}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc{display:flex;flex-direction:column;font-size:1em}.fc,.fc *,.fc :after,.fc :before{box-sizing:border-box}.fc table{border-collapse:collapse;border-spacing:0;font-size:1em}.fc th{text-align:center}.fc td,.fc th{padding:0;vertical-align:top}.fc a[data-navlink]{cursor:pointer}.fc a[data-navlink]:hover{text-decoration:underline}.fc-direction-ltr{direction:ltr;text-align:left}.fc-direction-rtl{direction:rtl;text-align:right}.fc-theme-standard td,.fc-theme-standard th{border:1px solid var(--fc-border-color)}.fc-liquid-hack td,.fc-liquid-hack th{position:relative}@font-face{font-family:fcicons;font-style:normal;font-weight:400;src:url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")}.fc-icon{speak:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;font-family:fcicons!important;font-style:normal;font-variant:normal;font-weight:400;height:1em;line-height:1;text-align:center;text-transform:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:1em}.fc-icon-chevron-left:before{content:"\\e900"}.fc-icon-chevron-right:before{content:"\\e901"}.fc-icon-chevrons-left:before{content:"\\e902"}.fc-icon-chevrons-right:before{content:"\\e903"}.fc-icon-minus-square:before{content:"\\e904"}.fc-icon-plus-square:before{content:"\\e905"}.fc-icon-x:before{content:"\\e906"}.fc .fc-button{border-radius:0;font-family:inherit;font-size:inherit;line-height:inherit;margin:0;overflow:visible;text-transform:none}.fc .fc-button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.fc .fc-button{-webkit-appearance:button}.fc .fc-button:not(:disabled){cursor:pointer}.fc .fc-button{background-color:transparent;border:1px solid transparent;border-radius:.25em;display:inline-block;font-size:1em;font-weight:400;line-height:1.5;padding:.4em .65em;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.fc .fc-button:hover{text-decoration:none}.fc .fc-button:focus{box-shadow:0 0 0 .2rem rgba(44,62,80,.25);outline:0}.fc .fc-button:disabled{opacity:.65}.fc .fc-button-primary{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:hover{background-color:var(--fc-button-hover-bg-color);border-color:var(--fc-button-hover-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:disabled{background-color:var(--fc-button-bg-color);border-color:var(--fc-button-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button-primary:not(:disabled).fc-button-active,.fc .fc-button-primary:not(:disabled):active{background-color:var(--fc-button-active-bg-color);border-color:var(--fc-button-active-border-color);color:var(--fc-button-text-color)}.fc .fc-button-primary:not(:disabled).fc-button-active:focus,.fc .fc-button-primary:not(:disabled):active:focus{box-shadow:0 0 0 .2rem rgba(76,91,106,.5)}.fc .fc-button .fc-icon{font-size:1.5em;vertical-align:middle}.fc .fc-button-group{display:inline-flex;position:relative;vertical-align:middle}.fc .fc-button-group>.fc-button{flex:1 1 auto;position:relative}.fc .fc-button-group>.fc-button.fc-button-active,.fc .fc-button-group>.fc-button:active,.fc .fc-button-group>.fc-button:focus,.fc .fc-button-group>.fc-button:hover{z-index:1}.fc-direction-ltr .fc-button-group>.fc-button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.fc-direction-ltr .fc-button-group>.fc-button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.fc-direction-rtl .fc-button-group>.fc-button:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.fc-direction-rtl .fc-button-group>.fc-button:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0}.fc .fc-toolbar{align-items:center;display:flex;justify-content:space-between}.fc .fc-toolbar.fc-header-toolbar{margin-bottom:1.5em}.fc .fc-toolbar.fc-footer-toolbar{margin-top:1.5em}.fc .fc-toolbar-title{font-size:1.75em;margin:0}.fc-direction-ltr .fc-toolbar>*>:not(:first-child){margin-left:.75em}.fc-direction-rtl .fc-toolbar>*>:not(:first-child){margin-right:.75em}.fc-direction-rtl .fc-toolbar-ltr{flex-direction:row-reverse}.fc .fc-scroller{-webkit-overflow-scrolling:touch;position:relative}.fc .fc-scroller-liquid{height:100%}.fc .fc-scroller-liquid-absolute{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-scroller-harness{direction:ltr;overflow:hidden;position:relative}.fc .fc-scroller-harness-liquid{height:100%}.fc-direction-rtl .fc-scroller-harness>.fc-scroller{direction:rtl}.fc-theme-standard .fc-scrollgrid{border:1px solid var(--fc-border-color)}.fc .fc-scrollgrid,.fc .fc-scrollgrid table{table-layout:fixed;width:100%}.fc .fc-scrollgrid table{border-left-style:hidden;border-right-style:hidden;border-top-style:hidden}.fc .fc-scrollgrid{border-bottom-width:0;border-collapse:separate;border-right-width:0}.fc .fc-scrollgrid-liquid{height:100%}.fc .fc-scrollgrid-section,.fc .fc-scrollgrid-section table,.fc .fc-scrollgrid-section>td{height:1px}.fc .fc-scrollgrid-section-liquid>td{height:100%}.fc .fc-scrollgrid-section>*{border-left-width:0;border-top-width:0}.fc .fc-scrollgrid-section-footer>*,.fc .fc-scrollgrid-section-header>*{border-bottom-width:0}.fc .fc-scrollgrid-section-body table,.fc .fc-scrollgrid-section-footer table{border-bottom-style:hidden}.fc .fc-scrollgrid-section-sticky>*{background:var(--fc-page-bg-color);position:sticky;z-index:3}.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky>*{top:0}.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky>*{bottom:0}.fc .fc-scrollgrid-sticky-shim{height:1px;margin-bottom:-1px}.fc-sticky{position:sticky}.fc .fc-view-harness{flex-grow:1;position:relative}.fc .fc-view-harness-active>.fc-view{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-col-header-cell-cushion{display:inline-block;padding:2px 4px}.fc .fc-bg-event,.fc .fc-highlight,.fc .fc-non-business{bottom:0;left:0;position:absolute;right:0;top:0}.fc .fc-non-business{background:var(--fc-non-business-color)}.fc .fc-bg-event{background:var(--fc-bg-event-color);opacity:var(--fc-bg-event-opacity)}.fc .fc-bg-event .fc-event-title{font-size:var(--fc-small-font-size);font-style:italic;margin:.5em}.fc .fc-highlight{background:var(--fc-highlight-color)}.fc .fc-cell-shaded,.fc .fc-day-disabled{background:var(--fc-neutral-bg-color)}a.fc-event,a.fc-event:hover{text-decoration:none}.fc-event.fc-event-draggable,.fc-event[href]{cursor:pointer}.fc-event .fc-event-main{position:relative;z-index:2}.fc-event-dragging:not(.fc-event-selected){opacity:.75}.fc-event-dragging.fc-event-selected{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-event .fc-event-resizer{display:none;position:absolute;z-index:4}.fc-event-selected .fc-event-resizer,.fc-event:hover .fc-event-resizer{display:block}.fc-event-selected .fc-event-resizer{background:var(--fc-page-bg-color);border-color:inherit;border-radius:calc(var(--fc-event-resizer-dot-total-width)/2);border-style:solid;border-width:var(--fc-event-resizer-dot-border-width);height:var(--fc-event-resizer-dot-total-width);width:var(--fc-event-resizer-dot-total-width)}.fc-event-selected .fc-event-resizer:before{bottom:-20px;content:"";left:-20px;position:absolute;right:-20px;top:-20px}.fc-event-selected,.fc-event:focus{box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event-selected:before,.fc-event:focus:before{bottom:0;content:"";left:0;position:absolute;right:0;top:0;z-index:3}.fc-event-selected:after,.fc-event:focus:after{background:var(--fc-event-selected-overlay-color);bottom:-1px;content:"";left:-1px;position:absolute;right:-1px;top:-1px;z-index:1}.fc-h-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-h-event .fc-event-main{color:var(--fc-event-text-color)}.fc-h-event .fc-event-main-frame{display:flex}.fc-h-event .fc-event-time{max-width:100%;overflow:hidden}.fc-h-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-width:0}.fc-h-event .fc-event-title{display:inline-block;left:0;max-width:100%;overflow:hidden;right:0;vertical-align:top}.fc-h-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end){border-bottom-left-radius:0;border-left-width:0;border-top-left-radius:0}.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start){border-bottom-right-radius:0;border-right-width:0;border-top-right-radius:0}.fc-h-event:not(.fc-event-selected) .fc-event-resizer{bottom:0;top:0;width:var(--fc-event-resizer-thickness)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end{cursor:w-resize;left:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start{cursor:e-resize;right:calc(var(--fc-event-resizer-thickness)*-.5)}.fc-h-event.fc-event-selected .fc-event-resizer{margin-top:calc(var(--fc-event-resizer-dot-total-width)*-.5);top:50%}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end{left:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start{right:calc(var(--fc-event-resizer-dot-total-width)*-.5)}.fc .fc-popover{box-shadow:0 2px 6px rgba(0,0,0,.15);position:absolute;z-index:9999}.fc .fc-popover-header{align-items:center;display:flex;flex-direction:row;justify-content:space-between;padding:3px 4px}.fc .fc-popover-title{margin:0 2px}.fc .fc-popover-close{cursor:pointer;font-size:1.1em;opacity:.65}.fc-theme-standard .fc-popover{background:var(--fc-page-bg-color);border:1px solid var(--fc-border-color)}.fc-theme-standard .fc-popover-header{background:var(--fc-neutral-bg-color)}';
$200f5cce291452b2$export$c373adc892eb6355($200f5cce291452b2$var$css_248z);
function $200f5cce291452b2$export$c03999cb2f36933f(el) {
    if (el.parentNode) el.parentNode.removeChild(el);
}
// Querying
// ----------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$export$3d8c2f653ac9d0b9(el, selector) {
    if (el.closest) return el.closest(selector);
    if (!document.documentElement.contains(el)) return null;
    do {
        if ($200f5cce291452b2$export$f96d196f7728bb5(el, selector)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $200f5cce291452b2$export$f96d196f7728bb5(el, selector) {
    let method = el.matches || el.matchesSelector || el.msMatchesSelector;
    return method.call(el, selector);
}
// accepts multiple subject els
// returns a real array. good for methods like forEach
// TODO: accept the document
function $200f5cce291452b2$export$9f4f30ee63539e24(container, selector) {
    let containers = container instanceof HTMLElement ? [
        container
    ] : container;
    let allMatches = [];
    for(let i = 0; i < containers.length; i += 1){
        let matches = containers[i].querySelectorAll(selector);
        for(let j = 0; j < matches.length; j += 1)allMatches.push(matches[j]);
    }
    return allMatches;
}
// accepts multiple subject els
// only queries direct child elements // TODO: rename to findDirectChildren!
function $200f5cce291452b2$export$faec65b429be379(parent, selector) {
    let parents = parent instanceof HTMLElement ? [
        parent
    ] : parent;
    let allMatches = [];
    for(let i = 0; i < parents.length; i += 1){
        let childNodes = parents[i].children; // only ever elements
        for(let j = 0; j < childNodes.length; j += 1){
            let childNode = childNodes[j];
            if (!selector || $200f5cce291452b2$export$f96d196f7728bb5(childNode, selector)) allMatches.push(childNode);
        }
    }
    return allMatches;
}
// Style
// ----------------------------------------------------------------------------------------------------------------
const $200f5cce291452b2$var$PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
function $200f5cce291452b2$export$2ed0fc6709e59212(el, props) {
    for(let propName in props)$200f5cce291452b2$export$f787f51d84a910ad(el, propName, props[propName]);
}
function $200f5cce291452b2$export$f787f51d84a910ad(el, name, val) {
    if (val == null) el.style[name] = "";
    else if (typeof val === "number" && $200f5cce291452b2$var$PIXEL_PROP_RE.test(name)) el.style[name] = `${val}px`;
    else el.style[name] = val;
}
// Event Handling
// ----------------------------------------------------------------------------------------------------------------
// if intercepting bubbled events at the document/window/body level,
// and want to see originating element (the 'target'), use this util instead
// of `ev.target` because it goes within web-component boundaries.
function $200f5cce291452b2$export$738ab4df8bf92ae9(ev) {
    var _a, _b;
    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
}
// Unique ID for DOM attribute
let $200f5cce291452b2$var$guid$1 = 0;
function $200f5cce291452b2$export$a8550f7dbe79f93a() {
    $200f5cce291452b2$var$guid$1 += 1;
    return "fc-dom-" + $200f5cce291452b2$var$guid$1;
}
// Stops a mouse/touch event from doing it's native browser action
function $200f5cce291452b2$export$d29e374196577086(ev) {
    ev.preventDefault();
}
// Event Delegation
// ----------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$var$buildDelegationHandler(selector, handler) {
    return (ev)=>{
        let matchedChild = $200f5cce291452b2$export$3d8c2f653ac9d0b9(ev.target, selector);
        if (matchedChild) handler.call(matchedChild, ev, matchedChild);
    };
}
function $200f5cce291452b2$export$3c2fa207a37baaea(container, eventType, selector, handler) {
    let attachedHandler = $200f5cce291452b2$var$buildDelegationHandler(selector, handler);
    container.addEventListener(eventType, attachedHandler);
    return ()=>{
        container.removeEventListener(eventType, attachedHandler);
    };
}
function $200f5cce291452b2$export$ce26c07117d59d6a(container, selector, onMouseEnter, onMouseLeave) {
    let currentMatchedChild;
    return $200f5cce291452b2$export$3c2fa207a37baaea(container, "mouseover", selector, (mouseOverEv, matchedChild)=>{
        if (matchedChild !== currentMatchedChild) {
            currentMatchedChild = matchedChild;
            onMouseEnter(mouseOverEv, matchedChild);
            let realOnMouseLeave = (mouseLeaveEv)=>{
                currentMatchedChild = null;
                onMouseLeave(mouseLeaveEv, matchedChild);
                matchedChild.removeEventListener("mouseleave", realOnMouseLeave);
            };
            // listen to the next mouseleave, and then unattach
            matchedChild.addEventListener("mouseleave", realOnMouseLeave);
        }
    });
}
// Animation
// ----------------------------------------------------------------------------------------------------------------
const $200f5cce291452b2$var$transitionEventNames = [
    "webkitTransitionEnd",
    "otransitionend",
    "oTransitionEnd",
    "msTransitionEnd",
    "transitionend"
];
// triggered only when the next single subsequent transition finishes
function $200f5cce291452b2$export$2ec5befb9e6c97d4(el, callback) {
    let realCallback = (ev)=>{
        callback(ev);
        $200f5cce291452b2$var$transitionEventNames.forEach((eventName)=>{
            el.removeEventListener(eventName, realCallback);
        });
    };
    $200f5cce291452b2$var$transitionEventNames.forEach((eventName)=>{
        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
    });
}
// ARIA workarounds
// ----------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$var$createAriaClickAttrs(handler) {
    return Object.assign({
        onClick: handler
    }, $200f5cce291452b2$var$createAriaKeyboardAttrs(handler));
}
function $200f5cce291452b2$var$createAriaKeyboardAttrs(handler) {
    return {
        tabIndex: 0,
        onKeyDown (ev) {
            if (ev.key === "Enter" || ev.key === " ") {
                handler(ev);
                ev.preventDefault(); // if space, don't scroll down page
            }
        }
    };
}
let $200f5cce291452b2$var$guidNumber = 0;
function $200f5cce291452b2$export$39b482c5e57630a8() {
    $200f5cce291452b2$var$guidNumber += 1;
    return String($200f5cce291452b2$var$guidNumber);
}
/* FullCalendar-specific DOM Utilities
----------------------------------------------------------------------------------------------------------------------*/ // Make the mouse cursor express that an event is not allowed in the current area
function $200f5cce291452b2$export$9fa96a7d116ea3ce() {
    document.body.classList.add("fc-not-allowed");
}
// Returns the mouse cursor to its original look
function $200f5cce291452b2$export$92108d983e8ee699() {
    document.body.classList.remove("fc-not-allowed");
}
/* Selection
----------------------------------------------------------------------------------------------------------------------*/ function $200f5cce291452b2$export$d24c54395ce0c509(el) {
    el.style.userSelect = "none";
    el.addEventListener("selectstart", $200f5cce291452b2$export$d29e374196577086);
}
function $200f5cce291452b2$export$6554612db691658e(el) {
    el.style.userSelect = "";
    el.removeEventListener("selectstart", $200f5cce291452b2$export$d29e374196577086);
}
/* Context Menu
----------------------------------------------------------------------------------------------------------------------*/ function $200f5cce291452b2$export$493d36ec626b6698(el) {
    el.addEventListener("contextmenu", $200f5cce291452b2$export$d29e374196577086);
}
function $200f5cce291452b2$export$1fbe638ecf81657e(el) {
    el.removeEventListener("contextmenu", $200f5cce291452b2$export$d29e374196577086);
}
function $200f5cce291452b2$export$7a38258bbe170828(input) {
    let specs = [];
    let tokens = [];
    let i;
    let token;
    if (typeof input === "string") tokens = input.split(/\s*,\s*/);
    else if (typeof input === "function") tokens = [
        input
    ];
    else if (Array.isArray(input)) tokens = input;
    for(i = 0; i < tokens.length; i += 1){
        token = tokens[i];
        if (typeof token === "string") specs.push(token.charAt(0) === "-" ? {
            field: token.substring(1),
            order: -1
        } : {
            field: token,
            order: 1
        });
        else if (typeof token === "function") specs.push({
            func: token
        });
    }
    return specs;
}
function $200f5cce291452b2$export$2f6ca3d3b1f80bf5(obj0, obj1, fieldSpecs) {
    let i;
    let cmp;
    for(i = 0; i < fieldSpecs.length; i += 1){
        cmp = $200f5cce291452b2$var$compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
        if (cmp) return cmp;
    }
    return 0;
}
function $200f5cce291452b2$var$compareByFieldSpec(obj0, obj1, fieldSpec) {
    if (fieldSpec.func) return fieldSpec.func(obj0, obj1);
    return $200f5cce291452b2$export$8a5498727ef6be21(obj0[fieldSpec.field], obj1[fieldSpec.field]) * (fieldSpec.order || 1);
}
function $200f5cce291452b2$export$8a5498727ef6be21(a, b) {
    if (!a && !b) return 0;
    if (b == null) return -1;
    if (a == null) return 1;
    if (typeof a === "string" || typeof b === "string") return String(a).localeCompare(String(b));
    return a - b;
}
/* String Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $200f5cce291452b2$export$1a82df3d29112e01(val, len) {
    let s = String(val);
    return "000".substr(0, len - s.length) + s;
}
function $200f5cce291452b2$export$342063e11d6c3cad(formatter, args, fallbackText) {
    if (typeof formatter === "function") return formatter(...args);
    if (typeof formatter === "string") return args.reduce((str, arg, index)=>str.replace("$" + index, arg || ""), formatter);
    return fallbackText;
}
/* Number Utilities
----------------------------------------------------------------------------------------------------------------------*/ function $200f5cce291452b2$export$d66dc83d8cfc8dd(a, b) {
    return a - b;
}
function $200f5cce291452b2$export$306ddfe3a8403e2(n) {
    return n % 1 === 0;
}
/* FC-specific DOM dimension stuff
----------------------------------------------------------------------------------------------------------------------*/ function $200f5cce291452b2$var$computeSmallestCellWidth(cellEl) {
    let allWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-frame");
    let contentWidthEl = cellEl.querySelector(".fc-scrollgrid-shrink-cushion");
    if (!allWidthEl) throw new Error("needs fc-scrollgrid-shrink-frame className"); // TODO: use const
    if (!contentWidthEl) throw new Error("needs fc-scrollgrid-shrink-cushion className");
    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
    contentWidthEl.getBoundingClientRect().width;
}
const $200f5cce291452b2$var$INTERNAL_UNITS = [
    "years",
    "months",
    "days",
    "milliseconds"
];
const $200f5cce291452b2$var$PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
// Parsing and Creation
function $200f5cce291452b2$export$4368d992c4eafac0(input, unit) {
    if (typeof input === "string") return $200f5cce291452b2$var$parseString(input);
    if (typeof input === "object" && input) return $200f5cce291452b2$var$parseObject(input);
    if (typeof input === "number") return $200f5cce291452b2$var$parseObject({
        [unit || "milliseconds"]: input
    });
    return null;
}
function $200f5cce291452b2$var$parseString(s) {
    let m = $200f5cce291452b2$var$PARSE_RE.exec(s);
    if (m) {
        let sign = m[1] ? -1 : 1;
        return {
            years: 0,
            months: 0,
            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 3600000 + // hours
            (m[4] ? parseInt(m[4], 10) : 0) * 60000 + // minutes
            (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
            (m[6] ? parseInt(m[6], 10) : 0 // ms
            ))
        };
    }
    return null;
}
function $200f5cce291452b2$var$parseObject(obj) {
    let duration = {
        years: obj.years || obj.year || 0,
        months: obj.months || obj.month || 0,
        days: obj.days || obj.day || 0,
        milliseconds: (obj.hours || obj.hour || 0) * 3600000 + // hours
        (obj.minutes || obj.minute || 0) * 60000 + // minutes
        (obj.seconds || obj.second || 0) * 1000 + // seconds
        (obj.milliseconds || obj.millisecond || obj.ms || 0)
    };
    let weeks = obj.weeks || obj.week;
    if (weeks) {
        duration.days += weeks * 7;
        duration.specifiedWeeks = true;
    }
    return duration;
}
// Equality
function $200f5cce291452b2$var$durationsEqual(d0, d1) {
    return d0.years === d1.years && d0.months === d1.months && d0.days === d1.days && d0.milliseconds === d1.milliseconds;
}
function $200f5cce291452b2$export$acf3ba20e47771d(dur) {
    if (!dur.years && !dur.months && !dur.milliseconds) return dur.days;
    return 0;
}
// Simple Math
function $200f5cce291452b2$export$b169257caa88022a(d0, d1) {
    return {
        years: d0.years + d1.years,
        months: d0.months + d1.months,
        days: d0.days + d1.days,
        milliseconds: d0.milliseconds + d1.milliseconds
    };
}
function $200f5cce291452b2$export$2408f22a0fab9ae5(d1, d0) {
    return {
        years: d1.years - d0.years,
        months: d1.months - d0.months,
        days: d1.days - d0.days,
        milliseconds: d1.milliseconds - d0.milliseconds
    };
}
function $200f5cce291452b2$export$847533e5bf524f5f(d, n) {
    return {
        years: d.years * n,
        months: d.months * n,
        days: d.days * n,
        milliseconds: d.milliseconds * n
    };
}
// Conversions
// "Rough" because they are based on average-case Gregorian months/years
function $200f5cce291452b2$var$asRoughYears(dur) {
    return $200f5cce291452b2$var$asRoughDays(dur) / 365;
}
function $200f5cce291452b2$var$asRoughMonths(dur) {
    return $200f5cce291452b2$var$asRoughDays(dur) / 30;
}
function $200f5cce291452b2$var$asRoughDays(dur) {
    return $200f5cce291452b2$export$4e222d082f82ee97(dur) / 864e5;
}
function $200f5cce291452b2$export$4b170465d7badfa1(dur) {
    return $200f5cce291452b2$export$4e222d082f82ee97(dur) / 60000;
}
function $200f5cce291452b2$export$479ac0420f53ed26(dur) {
    return $200f5cce291452b2$export$4e222d082f82ee97(dur) / 1000;
}
function $200f5cce291452b2$export$4e222d082f82ee97(dur) {
    return dur.years * (365 * 864e5) + dur.months * (30 * 864e5) + dur.days * 864e5 + dur.milliseconds;
}
// Advanced Math
function $200f5cce291452b2$export$56350196709588fc(numerator, denominator) {
    let res = null;
    for(let i = 0; i < $200f5cce291452b2$var$INTERNAL_UNITS.length; i += 1){
        let unit = $200f5cce291452b2$var$INTERNAL_UNITS[i];
        if (denominator[unit]) {
            let localRes = numerator[unit] / denominator[unit];
            if (!$200f5cce291452b2$export$306ddfe3a8403e2(localRes) || res !== null && res !== localRes) return null;
            res = localRes;
        } else if (numerator[unit]) // needs to divide by something but can't!
        return null;
    }
    return res;
}
function $200f5cce291452b2$export$db3b6bfb95261072(dur) {
    let ms = dur.milliseconds;
    if (ms) {
        if (ms % 1000 !== 0) return {
            unit: "millisecond",
            value: ms
        };
        if (ms % 60000 !== 0) return {
            unit: "second",
            value: ms / 1000
        };
        if (ms % 3600000 !== 0) return {
            unit: "minute",
            value: ms / 60000
        };
        if (ms) return {
            unit: "hour",
            value: ms / 3600000
        };
    }
    if (dur.days) {
        if (dur.specifiedWeeks && dur.days % 7 === 0) return {
            unit: "week",
            value: dur.days / 7
        };
        return {
            unit: "day",
            value: dur.days
        };
    }
    if (dur.months) return {
        unit: "month",
        value: dur.months
    };
    if (dur.years) return {
        unit: "year",
        value: dur.years
    };
    return {
        unit: "millisecond",
        value: 0
    };
}
const { hasOwnProperty: $200f5cce291452b2$var$hasOwnProperty } = Object.prototype;
// Merges an array of objects into a single object.
// The second argument allows for an array of property names who's object values will be merged together.
function $200f5cce291452b2$export$953cecd6e717a553(propObjs, complexPropsMap) {
    let dest = {};
    if (complexPropsMap) {
        for(let name in complexPropsMap)if (complexPropsMap[name] === $200f5cce291452b2$var$isMaybeObjectsEqual) {
            let complexObjs = [];
            // collect the trailing object values, stopping when a non-object is discovered
            for(let i = propObjs.length - 1; i >= 0; i -= 1){
                let val = propObjs[i][name];
                if (typeof val === "object" && val) complexObjs.unshift(val);
                else if (val !== undefined) {
                    dest[name] = val; // if there were no objects, this value will be used
                    break;
                }
            }
            // if the trailing values were objects, use the merged value
            if (complexObjs.length) dest[name] = $200f5cce291452b2$export$953cecd6e717a553(complexObjs);
        }
    }
    // copy values into the destination, going from last to first
    for(let i = propObjs.length - 1; i >= 0; i -= 1){
        let props = propObjs[i];
        for(let name in props)if (!(name in dest)) dest[name] = props[name];
    }
    return dest;
}
function $200f5cce291452b2$export$dda1d9f60106f0e9(hash, func) {
    let filtered = {};
    for(let key in hash)if (func(hash[key], key)) filtered[key] = hash[key];
    return filtered;
}
function $200f5cce291452b2$export$407448d2b89b1813(hash, func) {
    let newHash = {};
    for(let key in hash)newHash[key] = func(hash[key], key);
    return newHash;
}
function $200f5cce291452b2$export$2d1720544b23b823(a) {
    let hash = {};
    for (let item of a)hash[item] = true;
    return hash;
}
// TODO: reassess browser support
// https://caniuse.com/?search=object.values
function $200f5cce291452b2$export$90a7f3efeed30595(obj) {
    let a = [];
    for(let key in obj)a.push(obj[key]);
    return a;
}
function $200f5cce291452b2$export$a9c23c6ac3fc3eca(obj0, obj1) {
    if (obj0 === obj1) return true;
    for(let key in obj0)if ($200f5cce291452b2$var$hasOwnProperty.call(obj0, key)) {
        if (!(key in obj1)) return false;
    }
    for(let key in obj1)if ($200f5cce291452b2$var$hasOwnProperty.call(obj1, key)) {
        if (obj0[key] !== obj1[key]) return false;
    }
    return true;
}
const $200f5cce291452b2$var$HANDLER_RE = /^on[A-Z]/;
function $200f5cce291452b2$var$isNonHandlerPropsEqual(obj0, obj1) {
    const keys = $200f5cce291452b2$var$getUnequalProps(obj0, obj1);
    for (let key of keys){
        if (!$200f5cce291452b2$var$HANDLER_RE.test(key)) return false;
    }
    return true;
}
function $200f5cce291452b2$var$getUnequalProps(obj0, obj1) {
    let keys = [];
    for(let key in obj0){
        if ($200f5cce291452b2$var$hasOwnProperty.call(obj0, key)) {
            if (!(key in obj1)) keys.push(key);
        }
    }
    for(let key in obj1){
        if ($200f5cce291452b2$var$hasOwnProperty.call(obj1, key)) {
            if (obj0[key] !== obj1[key]) keys.push(key);
        }
    }
    return keys;
}
function $200f5cce291452b2$export$23ebac1979863676(oldProps, newProps, equalityFuncs = {}) {
    if (oldProps === newProps) return true;
    for(let key in newProps){
        if (key in oldProps && $200f5cce291452b2$var$isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
        else return false;
    }
    // check for props that were omitted in the new
    for(let key in oldProps){
        if (!(key in newProps)) return false;
    }
    return true;
}
/*
assumed "true" equality for handler names like "onReceiveSomething"
*/ function $200f5cce291452b2$var$isObjValsEqual(val0, val1, comparator) {
    if (val0 === val1 || comparator === true) return true;
    if (comparator) return comparator(val0, val1);
    return false;
}
function $200f5cce291452b2$export$91477dc880baac21(hash, startIndex = 0, endIndex, step = 1) {
    let res = [];
    if (endIndex == null) endIndex = Object.keys(hash).length;
    for(let i = startIndex; i < endIndex; i += step){
        let val = hash[i];
        if (val !== undefined) res.push(val);
    }
    return res;
}
// TODO: new util arrayify?
function $200f5cce291452b2$export$9d398bebfec1c039(array, exactVal) {
    let removeCnt = 0;
    let i = 0;
    while(i < array.length)if (array[i] === exactVal) {
        array.splice(i, 1);
        removeCnt += 1;
    } else i += 1;
    return removeCnt;
}
function $200f5cce291452b2$export$23f2a1d2818174ef(a0, a1, equalityFunc) {
    if (a0 === a1) return true;
    let len = a0.length;
    let i;
    if (len !== a1.length) return false;
    for(i = 0; i < len; i += 1){
        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) return false;
    }
    return true;
}
const $200f5cce291452b2$var$DAY_IDS = [
    "sun",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat"
];
// Adding
function $200f5cce291452b2$export$31e67cf12fc9668(m, n) {
    let a = $200f5cce291452b2$var$dateToUtcArray(m);
    a[2] += n * 7;
    return $200f5cce291452b2$var$arrayToUtcDate(a);
}
function $200f5cce291452b2$export$625550452a3fa3ec(m, n) {
    let a = $200f5cce291452b2$var$dateToUtcArray(m);
    a[2] += n;
    return $200f5cce291452b2$var$arrayToUtcDate(a);
}
function $200f5cce291452b2$export$136fd86de524d3c2(m, n) {
    let a = $200f5cce291452b2$var$dateToUtcArray(m);
    a[6] += n;
    return $200f5cce291452b2$var$arrayToUtcDate(a);
}
// Diffing (all return floats)
// TODO: why not use ranges?
function $200f5cce291452b2$export$62d08d6fa708df47(m0, m1) {
    return $200f5cce291452b2$export$a36fb7d24305ed9d(m0, m1) / 7;
}
function $200f5cce291452b2$export$a36fb7d24305ed9d(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 86400000;
}
function $200f5cce291452b2$var$diffHours(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 3600000;
}
function $200f5cce291452b2$var$diffMinutes(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 60000;
}
function $200f5cce291452b2$var$diffSeconds(m0, m1) {
    return (m1.valueOf() - m0.valueOf()) / 1000;
}
function $200f5cce291452b2$export$5521614468b862fb(m0, m1) {
    let m0day = $200f5cce291452b2$export$9e5f44173e64f162(m0);
    let m1day = $200f5cce291452b2$export$9e5f44173e64f162(m1);
    return {
        years: 0,
        months: 0,
        days: Math.round($200f5cce291452b2$export$a36fb7d24305ed9d(m0day, m1day)),
        milliseconds: m1.valueOf() - m1day.valueOf() - (m0.valueOf() - m0day.valueOf())
    };
}
// Diffing Whole Units
function $200f5cce291452b2$export$b4d5ecaefe2b27f3(m0, m1) {
    let d = $200f5cce291452b2$export$4a5767248b18ef41(m0, m1);
    if (d !== null && d % 7 === 0) return d / 7;
    return null;
}
function $200f5cce291452b2$export$4a5767248b18ef41(m0, m1) {
    if ($200f5cce291452b2$var$timeAsMs(m0) === $200f5cce291452b2$var$timeAsMs(m1)) return Math.round($200f5cce291452b2$export$a36fb7d24305ed9d(m0, m1));
    return null;
}
// Start-Of
function $200f5cce291452b2$export$9e5f44173e64f162(m) {
    return $200f5cce291452b2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate()
    ]);
}
function $200f5cce291452b2$var$startOfHour(m) {
    return $200f5cce291452b2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours()
    ]);
}
function $200f5cce291452b2$var$startOfMinute(m) {
    return $200f5cce291452b2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes()
    ]);
}
function $200f5cce291452b2$var$startOfSecond(m) {
    return $200f5cce291452b2$var$arrayToUtcDate([
        m.getUTCFullYear(),
        m.getUTCMonth(),
        m.getUTCDate(),
        m.getUTCHours(),
        m.getUTCMinutes(),
        m.getUTCSeconds()
    ]);
}
// Week Computation
function $200f5cce291452b2$var$weekOfYear(marker, dow, doy) {
    let y = marker.getUTCFullYear();
    let w = $200f5cce291452b2$var$weekOfGivenYear(marker, y, dow, doy);
    if (w < 1) return $200f5cce291452b2$var$weekOfGivenYear(marker, y - 1, dow, doy);
    let nextW = $200f5cce291452b2$var$weekOfGivenYear(marker, y + 1, dow, doy);
    if (nextW >= 1) return Math.min(w, nextW);
    return w;
}
function $200f5cce291452b2$var$weekOfGivenYear(marker, year, dow, doy) {
    let firstWeekStart = $200f5cce291452b2$var$arrayToUtcDate([
        year,
        0,
        1 + $200f5cce291452b2$var$firstWeekOffset(year, dow, doy)
    ]);
    let dayStart = $200f5cce291452b2$export$9e5f44173e64f162(marker);
    let days = Math.round($200f5cce291452b2$export$a36fb7d24305ed9d(firstWeekStart, dayStart));
    return Math.floor(days / 7) + 1; // zero-indexed
}
// start-of-first-week - start-of-year
function $200f5cce291452b2$var$firstWeekOffset(year, dow, doy) {
    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
    let fwd = 7 + dow - doy;
    // first-week day local weekday -- which local weekday is fwd
    let fwdlw = (7 + $200f5cce291452b2$var$arrayToUtcDate([
        year,
        0,
        fwd
    ]).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
}
// Array Conversion
function $200f5cce291452b2$var$dateToLocalArray(date) {
    return [
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    ];
}
function $200f5cce291452b2$var$arrayToLocalDate(a) {
    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], a[3] || 0, a[4] || 0, a[5] || 0);
}
function $200f5cce291452b2$var$dateToUtcArray(date) {
    return [
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    ];
}
function $200f5cce291452b2$var$arrayToUtcDate(a) {
    // according to web standards (and Safari), a month index is required.
    // massage if only given a year.
    if (a.length === 1) a = a.concat([
        0
    ]);
    return new Date(Date.UTC(...a));
}
// Other Utils
function $200f5cce291452b2$export$55ff3cc1821e8445(m) {
    return !isNaN(m.valueOf());
}
function $200f5cce291452b2$var$timeAsMs(m) {
    return m.getUTCHours() * 3600000 + m.getUTCMinutes() * 60000 + m.getUTCSeconds() * 1000 + m.getUTCMilliseconds();
}
// timeZoneOffset is in minutes
function $200f5cce291452b2$export$45d219bdcd8ac53c(marker, timeZoneOffset, stripZeroTime = false) {
    let s = marker.toISOString();
    s = s.replace(".000", "");
    if (stripZeroTime) s = s.replace("T00:00:00Z", "");
    if (s.length > 10) {
        if (timeZoneOffset == null) s = s.replace("Z", "");
        else if (timeZoneOffset !== 0) s = s.replace("Z", $200f5cce291452b2$var$formatTimeZoneOffset(timeZoneOffset, true));
    // otherwise, its UTC-0 and we want to keep the Z
    }
    return s;
}
// formats the date, but with no time part
// TODO: somehow merge with buildIsoString and stripZeroTime
// TODO: rename. omit "string"
function $200f5cce291452b2$export$5dbe06c6d8c68cfb(marker) {
    return marker.toISOString().replace(/T.*$/, "");
}
function $200f5cce291452b2$export$26a0a7676ca7aa04(marker) {
    return marker.toISOString().match(/^\d{4}-\d{2}/)[0];
}
// TODO: use Date::toISOString and use everything after the T?
function $200f5cce291452b2$export$f438b12253c2b499(marker) {
    return $200f5cce291452b2$export$1a82df3d29112e01(marker.getUTCHours(), 2) + ":" + $200f5cce291452b2$export$1a82df3d29112e01(marker.getUTCMinutes(), 2) + ":" + $200f5cce291452b2$export$1a82df3d29112e01(marker.getUTCSeconds(), 2);
}
function $200f5cce291452b2$var$formatTimeZoneOffset(minutes, doIso = false) {
    let sign = minutes < 0 ? "-" : "+";
    let abs = Math.abs(minutes);
    let hours = Math.floor(abs / 60);
    let mins = Math.round(abs % 60);
    if (doIso) return `${sign + $200f5cce291452b2$export$1a82df3d29112e01(hours, 2)}:${$200f5cce291452b2$export$1a82df3d29112e01(mins, 2)}`;
    return `GMT${sign}${hours}${mins ? `:${$200f5cce291452b2$export$1a82df3d29112e01(mins, 2)}` : ""}`;
}
function $200f5cce291452b2$export$df995fae86a55f06(workerFunc, resEquality, teardownFunc) {
    let currentArgs;
    let currentRes;
    return function(...newArgs) {
        if (!currentArgs) currentRes = workerFunc.apply(this, newArgs);
        else if (!$200f5cce291452b2$export$23f2a1d2818174ef(currentArgs, newArgs)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.apply(this, newArgs);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArgs = newArgs;
        return currentRes;
    };
}
function $200f5cce291452b2$export$ebd11618f299a286(workerFunc, resEquality, teardownFunc) {
    let currentArg;
    let currentRes;
    return (newArg)=>{
        if (!currentArg) currentRes = workerFunc.call(this, newArg);
        else if (!$200f5cce291452b2$export$a9c23c6ac3fc3eca(currentArg, newArg)) {
            if (teardownFunc) teardownFunc(currentRes);
            let res = workerFunc.call(this, newArg);
            if (!resEquality || !resEquality(res, currentRes)) currentRes = res;
        }
        currentArg = newArg;
        return currentRes;
    };
}
function $200f5cce291452b2$export$890c4ad488842ce7(workerFunc, resEquality, teardownFunc) {
    let currentArgSets = [];
    let currentResults = [];
    return (newArgSets)=>{
        let currentLen = currentArgSets.length;
        let newLen = newArgSets.length;
        let i = 0;
        for(; i < currentLen; i += 1){
            if (!newArgSets[i]) {
                if (teardownFunc) teardownFunc(currentResults[i]);
            } else if (!$200f5cce291452b2$export$23f2a1d2818174ef(currentArgSets[i], newArgSets[i])) {
                if (teardownFunc) teardownFunc(currentResults[i]);
                let res = workerFunc.apply(this, newArgSets[i]);
                if (!resEquality || !resEquality(res, currentResults[i])) currentResults[i] = res;
            }
        }
        for(; i < newLen; i += 1)currentResults[i] = workerFunc.apply(this, newArgSets[i]);
        currentArgSets = newArgSets;
        currentResults.splice(newLen); // remove excess
        return currentResults;
    };
}
function $200f5cce291452b2$export$24baa2b76016ce0e(workerFunc, resEquality, teardownFunc) {
    let currentArgHash = {};
    let currentResHash = {};
    return (newArgHash)=>{
        let newResHash = {};
        for(let key in newArgHash){
            if (!currentResHash[key]) newResHash[key] = workerFunc.apply(this, newArgHash[key]);
            else if (!$200f5cce291452b2$export$23f2a1d2818174ef(currentArgHash[key], newArgHash[key])) {
                if (teardownFunc) teardownFunc(currentResHash[key]);
                let res = workerFunc.apply(this, newArgHash[key]);
                newResHash[key] = resEquality && resEquality(res, currentResHash[key]) ? currentResHash[key] : res;
            } else newResHash[key] = currentResHash[key];
        }
        currentArgHash = newArgHash;
        currentResHash = newResHash;
        return newResHash;
    };
}
const $200f5cce291452b2$var$EXTENDED_SETTINGS_AND_SEVERITIES = {
    week: 3,
    separator: 0,
    omitZeroMinute: 0,
    meridiem: 0,
    omitCommas: 0
};
const $200f5cce291452b2$var$STANDARD_DATE_PROP_SEVERITIES = {
    timeZoneName: 7,
    era: 6,
    year: 5,
    month: 4,
    day: 2,
    weekday: 2,
    hour: 1,
    minute: 1,
    second: 1
};
const $200f5cce291452b2$var$MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
const $200f5cce291452b2$var$COMMA_RE = /,/g; // we need re for globalness
const $200f5cce291452b2$var$MULTI_SPACE_RE = /\s+/g;
const $200f5cce291452b2$var$LTR_RE = /\u200e/g; // control character
const $200f5cce291452b2$var$UTC_RE = /UTC|GMT/;
class $200f5cce291452b2$var$NativeFormatter {
    format(date, context) {
        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        let { standardDateProps: standardDateProps, extendedSettings: extendedSettings } = this;
        let diffSeverity = $200f5cce291452b2$var$computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
        if (!diffSeverity) return this.format(start, context);
        let biggestUnitForPartial = diffSeverity;
        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
        (standardDateProps.year === "numeric" || standardDateProps.year === "2-digit") && (standardDateProps.month === "numeric" || standardDateProps.month === "2-digit") && (standardDateProps.day === "numeric" || standardDateProps.day === "2-digit")) biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
        let full0 = this.format(start, context);
        let full1 = this.format(end, context);
        if (full0 === full1) return full0;
        let partialDateProps = $200f5cce291452b2$var$computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
        let partialFormattingFunc = $200f5cce291452b2$var$buildFormattingFunc(partialDateProps, extendedSettings, context);
        let partial0 = partialFormattingFunc(start);
        let partial1 = partialFormattingFunc(end);
        let insertion = $200f5cce291452b2$var$findCommonInsertion(full0, partial0, full1, partial1);
        let separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || "";
        if (insertion) return insertion.before + partial0 + separator + partial1 + insertion.after;
        return full0 + separator + full1;
    }
    getLargestUnit() {
        switch(this.severity){
            case 7:
            case 6:
            case 5:
                return "year";
            case 4:
                return "month";
            case 3:
                return "week";
            case 2:
                return "day";
            default:
                return "time"; // really?
        }
    }
    constructor(formatSettings){
        let standardDateProps = {};
        let extendedSettings = {};
        let severity = 0;
        for(let name in formatSettings)if (name in $200f5cce291452b2$var$EXTENDED_SETTINGS_AND_SEVERITIES) {
            extendedSettings[name] = formatSettings[name];
            severity = Math.max($200f5cce291452b2$var$EXTENDED_SETTINGS_AND_SEVERITIES[name], severity);
        } else {
            standardDateProps[name] = formatSettings[name];
            if (name in $200f5cce291452b2$var$STANDARD_DATE_PROP_SEVERITIES) severity = Math.max($200f5cce291452b2$var$STANDARD_DATE_PROP_SEVERITIES[name], severity);
        }
        this.standardDateProps = standardDateProps;
        this.extendedSettings = extendedSettings;
        this.severity = severity;
        this.buildFormattingFunc = $200f5cce291452b2$export$df995fae86a55f06($200f5cce291452b2$var$buildFormattingFunc);
    }
}
function $200f5cce291452b2$var$buildFormattingFunc(standardDateProps, extendedSettings, context) {
    let standardDatePropCnt = Object.keys(standardDateProps).length;
    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === "short") return (date)=>$200f5cce291452b2$var$formatTimeZoneOffset(date.timeZoneOffset);
    if (standardDatePropCnt === 0 && extendedSettings.week) return (date)=>$200f5cce291452b2$var$formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week);
    return $200f5cce291452b2$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
}
function $200f5cce291452b2$var$buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
    standardDateProps = Object.assign({}, standardDateProps); // copy
    extendedSettings = Object.assign({}, extendedSettings); // copy
    $200f5cce291452b2$var$sanitizeSettings(standardDateProps, extendedSettings);
    standardDateProps.timeZone = "UTC"; // we leverage the only guaranteed timeZone for our UTC markers
    let normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
    let zeroFormat; // needed?
    if (extendedSettings.omitZeroMinute) {
        let zeroProps = Object.assign({}, standardDateProps);
        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
    }
    return (date)=>{
        let { marker: marker } = date;
        let format;
        if (zeroFormat && !marker.getUTCMinutes()) format = zeroFormat;
        else format = normalFormat;
        let s = format.format(marker);
        return $200f5cce291452b2$var$postProcess(s, date, standardDateProps, extendedSettings, context);
    };
}
function $200f5cce291452b2$var$sanitizeSettings(standardDateProps, extendedSettings) {
    // deal with a browser inconsistency where formatting the timezone
    // requires that the hour/minute be present.
    if (standardDateProps.timeZoneName) {
        if (!standardDateProps.hour) standardDateProps.hour = "2-digit";
        if (!standardDateProps.minute) standardDateProps.minute = "2-digit";
    }
    // only support short timezone names
    if (standardDateProps.timeZoneName === "long") standardDateProps.timeZoneName = "short";
    // if requesting to display seconds, MUST display minutes
    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) delete extendedSettings.omitZeroMinute;
}
function $200f5cce291452b2$var$postProcess(s, date, standardDateProps, extendedSettings, context) {
    s = s.replace($200f5cce291452b2$var$LTR_RE, ""); // remove left-to-right control chars. do first. good for other regexes
    if (standardDateProps.timeZoneName === "short") s = $200f5cce291452b2$var$injectTzoStr(s, context.timeZone === "UTC" || date.timeZoneOffset == null ? "UTC" : $200f5cce291452b2$var$formatTimeZoneOffset(date.timeZoneOffset));
    if (extendedSettings.omitCommas) s = s.replace($200f5cce291452b2$var$COMMA_RE, "").trim();
    if (extendedSettings.omitZeroMinute) s = s.replace(":00", ""); // zeroFormat doesn't always achieve this
    // ^ do anything that might create adjacent spaces before this point,
    // because MERIDIEM_RE likes to eat up loading spaces
    if (extendedSettings.meridiem === false) s = s.replace($200f5cce291452b2$var$MERIDIEM_RE, "").trim();
    else if (extendedSettings.meridiem === "narrow") s = s.replace($200f5cce291452b2$var$MERIDIEM_RE, (m0, m1)=>m1.toLocaleLowerCase());
    else if (extendedSettings.meridiem === "short") s = s.replace($200f5cce291452b2$var$MERIDIEM_RE, (m0, m1)=>`${m1.toLocaleLowerCase()}m`);
    else if (extendedSettings.meridiem === "lowercase") s = s.replace($200f5cce291452b2$var$MERIDIEM_RE, (m0)=>m0.toLocaleLowerCase());
    s = s.replace($200f5cce291452b2$var$MULTI_SPACE_RE, " ");
    s = s.trim();
    return s;
}
function $200f5cce291452b2$var$injectTzoStr(s, tzoStr) {
    let replaced = false;
    s = s.replace($200f5cce291452b2$var$UTC_RE, ()=>{
        replaced = true;
        return tzoStr;
    });
    // IE11 doesn't include UTC/GMT in the original string, so append to end
    if (!replaced) s += ` ${tzoStr}`;
    return s;
}
function $200f5cce291452b2$var$formatWeekNumber(num, weekText, weekTextLong, locale, display) {
    let parts = [];
    if (display === "long") parts.push(weekTextLong);
    else if (display === "short" || display === "narrow") parts.push(weekText);
    if (display === "long" || display === "short") parts.push(" ");
    parts.push(locale.simpleNumberFormat.format(num));
    if (locale.options.direction === "rtl") parts.reverse();
    return parts.join("");
}
// Range Formatting Utils
// 0 = exactly the same
// 1 = different by time
// and bigger
function $200f5cce291452b2$var$computeMarkerDiffSeverity(d0, d1, ca) {
    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) return 5;
    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) return 4;
    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) return 2;
    if ($200f5cce291452b2$var$timeAsMs(d0) !== $200f5cce291452b2$var$timeAsMs(d1)) return 1;
    return 0;
}
function $200f5cce291452b2$var$computePartialFormattingOptions(options, biggestUnit) {
    let partialOptions = {};
    for(let name in options)if (!(name in $200f5cce291452b2$var$STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
    $200f5cce291452b2$var$STANDARD_DATE_PROP_SEVERITIES[name] <= biggestUnit) partialOptions[name] = options[name];
    return partialOptions;
}
function $200f5cce291452b2$var$findCommonInsertion(full0, partial0, full1, partial1) {
    let i0 = 0;
    while(i0 < full0.length){
        let found0 = full0.indexOf(partial0, i0);
        if (found0 === -1) break;
        let before0 = full0.substr(0, found0);
        i0 = found0 + partial0.length;
        let after0 = full0.substr(i0);
        let i1 = 0;
        while(i1 < full1.length){
            let found1 = full1.indexOf(partial1, i1);
            if (found1 === -1) break;
            let before1 = full1.substr(0, found1);
            i1 = found1 + partial1.length;
            let after1 = full1.substr(i1);
            if (before0 === before1 && after0 === after1) return {
                before: before0,
                after: after0
            };
        }
    }
    return null;
}
function $200f5cce291452b2$var$expandZonedMarker(dateInfo, calendarSystem) {
    let a = calendarSystem.markerToArray(dateInfo.marker);
    return {
        marker: dateInfo.marker,
        timeZoneOffset: dateInfo.timeZoneOffset,
        array: a,
        year: a[0],
        month: a[1],
        day: a[2],
        hour: a[3],
        minute: a[4],
        second: a[5],
        millisecond: a[6]
    };
}
function $200f5cce291452b2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
    let startInfo = $200f5cce291452b2$var$expandZonedMarker(start, context.calendarSystem);
    let endInfo = end ? $200f5cce291452b2$var$expandZonedMarker(end, context.calendarSystem) : null;
    return {
        date: startInfo,
        start: startInfo,
        end: endInfo,
        timeZone: context.timeZone,
        localeCodes: context.locale.codes,
        defaultSeparator: betterDefaultSeparator || context.defaultSeparator
    };
}
/*
TODO: fix the terminology of "formatter" vs "formatting func"
*/ /*
At the time of instantiation, this object does not know which cmd-formatting system it will use.
It receives this at the time of formatting, as a setting.
*/ class $200f5cce291452b2$var$CmdFormatter {
    format(date, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $200f5cce291452b2$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return context.cmdFormatter(this.cmdStr, $200f5cce291452b2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
    constructor(cmdStr){
        this.cmdStr = cmdStr;
    }
}
class $200f5cce291452b2$var$FuncFormatter {
    format(date, context, betterDefaultSeparator) {
        return this.func($200f5cce291452b2$var$createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
    }
    formatRange(start, end, context, betterDefaultSeparator) {
        return this.func($200f5cce291452b2$var$createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
    }
    constructor(func){
        this.func = func;
    }
}
function $200f5cce291452b2$export$d141bba7fdc215a3(input) {
    if (typeof input === "object" && input) return new $200f5cce291452b2$var$NativeFormatter(input);
    if (typeof input === "string") return new $200f5cce291452b2$var$CmdFormatter(input);
    if (typeof input === "function") return new $200f5cce291452b2$var$FuncFormatter(input);
    return null;
}
// base options
// ------------
const $200f5cce291452b2$export$a07804094c3ecf2d = {
    navLinkDayClick: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    navLinkWeekClick: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    duration: $200f5cce291452b2$export$4368d992c4eafac0,
    bootstrapFontAwesome: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    buttonIcons: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    customButtons: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    defaultAllDayEventDuration: $200f5cce291452b2$export$4368d992c4eafac0,
    defaultTimedEventDuration: $200f5cce291452b2$export$4368d992c4eafac0,
    nextDayThreshold: $200f5cce291452b2$export$4368d992c4eafac0,
    scrollTime: $200f5cce291452b2$export$4368d992c4eafac0,
    scrollTimeReset: Boolean,
    slotMinTime: $200f5cce291452b2$export$4368d992c4eafac0,
    slotMaxTime: $200f5cce291452b2$export$4368d992c4eafac0,
    dayPopoverFormat: $200f5cce291452b2$export$d141bba7fdc215a3,
    slotDuration: $200f5cce291452b2$export$4368d992c4eafac0,
    snapDuration: $200f5cce291452b2$export$4368d992c4eafac0,
    headerToolbar: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    footerToolbar: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    defaultRangeSeparator: String,
    titleRangeSeparator: String,
    forceEventDuration: Boolean,
    dayHeaders: Boolean,
    dayHeaderFormat: $200f5cce291452b2$export$d141bba7fdc215a3,
    dayHeaderClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayHeaderContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayHeaderDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayHeaderWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayCellClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayCellContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayCellDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayCellWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    initialView: String,
    aspectRatio: Number,
    weekends: Boolean,
    weekNumberCalculation: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    weekNumbers: Boolean,
    weekNumberClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    weekNumberContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    weekNumberDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    weekNumberWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    editable: Boolean,
    viewClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    viewDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    viewWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    nowIndicator: Boolean,
    nowIndicatorClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    nowIndicatorContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    nowIndicatorDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    nowIndicatorWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    showNonCurrentDates: Boolean,
    lazyFetching: Boolean,
    startParam: String,
    endParam: String,
    timeZoneParam: String,
    timeZone: String,
    locales: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    locale: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    themeSystem: String,
    dragRevertDuration: Number,
    dragScroll: Boolean,
    allDayMaintainDuration: Boolean,
    unselectAuto: Boolean,
    dropAccept: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventOrder: $200f5cce291452b2$export$7a38258bbe170828,
    eventOrderStrict: Boolean,
    handleWindowResize: Boolean,
    windowResizeDelay: Number,
    longPressDelay: Number,
    eventDragMinDistance: Number,
    expandRows: Boolean,
    height: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    contentHeight: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    direction: String,
    weekNumberFormat: $200f5cce291452b2$export$d141bba7fdc215a3,
    eventResizableFromStart: Boolean,
    displayEventTime: Boolean,
    displayEventEnd: Boolean,
    weekText: String,
    weekTextLong: String,
    progressiveEventRendering: Boolean,
    businessHours: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    initialDate: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    now: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    stickyHeaderDates: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    stickyFooterScrollbar: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    viewHeight: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    defaultAllDay: Boolean,
    eventSourceFailure: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventSourceSuccess: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventDisplay: String,
    eventStartEditable: Boolean,
    eventDurationEditable: Boolean,
    eventOverlap: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventConstraint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventAllow: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventBackgroundColor: String,
    eventBorderColor: String,
    eventTextColor: String,
    eventColor: String,
    eventClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    selectConstraint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    selectOverlap: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    selectAllow: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    droppable: Boolean,
    unselectCancel: String,
    slotLabelFormat: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLaneClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLaneContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLaneDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLaneWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLabelClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLabelContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLabelDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotLabelWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayMaxEvents: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayMaxEventRows: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    dayMinWidth: Number,
    slotLabelInterval: $200f5cce291452b2$export$4368d992c4eafac0,
    allDayText: String,
    allDayClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    allDayContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    allDayDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    allDayWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    slotMinWidth: Number,
    navLinks: Boolean,
    eventTimeFormat: $200f5cce291452b2$export$d141bba7fdc215a3,
    rerenderDelay: Number,
    moreLinkText: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    moreLinkHint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    selectMinDistance: Number,
    selectable: Boolean,
    selectLongPressDelay: Number,
    eventLongPressDelay: Number,
    selectMirror: Boolean,
    eventMaxStack: Number,
    eventMinHeight: Number,
    eventMinWidth: Number,
    eventShortHeight: Number,
    slotEventOverlap: Boolean,
    plugins: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    firstDay: Number,
    dayCount: Number,
    dateAlignment: String,
    dateIncrement: $200f5cce291452b2$export$4368d992c4eafac0,
    hiddenDays: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    fixedWeekCount: Boolean,
    validRange: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    visibleRange: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    titleFormat: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventInteractive: Boolean,
    // only used by list-view, but languages define the value, so we need it in base options
    noEventsText: String,
    viewHint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    navLinkHint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    closeHint: String,
    timeHint: String,
    eventHint: String,
    moreLinkClick: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    moreLinkClassNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    moreLinkContent: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    moreLinkDidMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    moreLinkWillUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    monthStartFormat: $200f5cce291452b2$export$d141bba7fdc215a3,
    // for connectors
    // (can't be part of plugin system b/c must be provided at runtime)
    handleCustomRendering: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    customRenderingMetaMap: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    customRenderingReplacesEl: Boolean
};
// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
// raw values.
const $200f5cce291452b2$export$f1e1789686576879 = {
    eventDisplay: "auto",
    defaultRangeSeparator: " - ",
    titleRangeSeparator: " – ",
    defaultTimedEventDuration: "01:00:00",
    defaultAllDayEventDuration: {
        day: 1
    },
    forceEventDuration: false,
    nextDayThreshold: "00:00:00",
    dayHeaders: true,
    initialView: "",
    aspectRatio: 1.35,
    headerToolbar: {
        start: "title",
        center: "",
        end: "today prev,next"
    },
    weekends: true,
    weekNumbers: false,
    weekNumberCalculation: "local",
    editable: false,
    nowIndicator: false,
    scrollTime: "06:00:00",
    scrollTimeReset: true,
    slotMinTime: "00:00:00",
    slotMaxTime: "24:00:00",
    showNonCurrentDates: true,
    lazyFetching: true,
    startParam: "start",
    endParam: "end",
    timeZoneParam: "timeZone",
    timeZone: "local",
    locales: [],
    locale: "",
    themeSystem: "standard",
    dragRevertDuration: 500,
    dragScroll: true,
    allDayMaintainDuration: false,
    unselectAuto: true,
    dropAccept: "*",
    eventOrder: "start,-duration,allDay,title",
    dayPopoverFormat: {
        month: "long",
        day: "numeric",
        year: "numeric"
    },
    handleWindowResize: true,
    windowResizeDelay: 100,
    longPressDelay: 1000,
    eventDragMinDistance: 5,
    expandRows: false,
    navLinks: false,
    selectable: false,
    eventMinHeight: 15,
    eventMinWidth: 30,
    eventShortHeight: 30,
    monthStartFormat: {
        month: "long",
        day: "numeric"
    }
};
// calendar listeners
// ------------------
const $200f5cce291452b2$export$c4ce752e73470fba = {
    datesSet: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventsSet: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventAdd: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventChange: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventRemove: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    windowResize: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventClick: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventMouseEnter: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventMouseLeave: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    select: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    unselect: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    loading: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    // internal
    _unmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    _beforeprint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    _afterprint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    _noEventDrop: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    _noEventResize: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    _resize: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    _scrollRequest: $200f5cce291452b2$export$7ccc53e8f1e7dfc5
};
// calendar-specific options
// -------------------------
const $200f5cce291452b2$export$56c0d5a1e737357d = {
    buttonText: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    buttonHints: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    views: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    plugins: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    initialEvents: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    events: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventSources: $200f5cce291452b2$export$7ccc53e8f1e7dfc5
};
const $200f5cce291452b2$export$3722cfe417b6ed86 = {
    headerToolbar: $200f5cce291452b2$var$isMaybeObjectsEqual,
    footerToolbar: $200f5cce291452b2$var$isMaybeObjectsEqual,
    buttonText: $200f5cce291452b2$var$isMaybeObjectsEqual,
    buttonHints: $200f5cce291452b2$var$isMaybeObjectsEqual,
    buttonIcons: $200f5cce291452b2$var$isMaybeObjectsEqual,
    dateIncrement: $200f5cce291452b2$var$isMaybeObjectsEqual,
    plugins: $200f5cce291452b2$var$isMaybeArraysEqual,
    events: $200f5cce291452b2$var$isMaybeArraysEqual,
    eventSources: $200f5cce291452b2$var$isMaybeArraysEqual,
    ["resources"]: $200f5cce291452b2$var$isMaybeArraysEqual
};
function $200f5cce291452b2$var$isMaybeObjectsEqual(a, b) {
    if (typeof a === "object" && typeof b === "object" && a && b) return $200f5cce291452b2$export$a9c23c6ac3fc3eca(a, b);
    return a === b;
}
function $200f5cce291452b2$var$isMaybeArraysEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return $200f5cce291452b2$export$23f2a1d2818174ef(a, b);
    return a === b;
}
// view-specific options
// ---------------------
const $200f5cce291452b2$export$db202ddc8be9136 = {
    type: String,
    component: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    buttonText: String,
    buttonTextKey: String,
    dateProfileGeneratorClass: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    usesMinMaxTime: Boolean,
    classNames: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    content: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    didMount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    willUnmount: $200f5cce291452b2$export$7ccc53e8f1e7dfc5
};
// util funcs
// ----------------------------------------------------------------------------------------------------
function $200f5cce291452b2$export$3a1a48c8f6ef640e(optionSets) {
    return $200f5cce291452b2$export$953cecd6e717a553(optionSets, $200f5cce291452b2$export$3722cfe417b6ed86);
}
function $200f5cce291452b2$export$f38c853ae54ed474(input, refiners) {
    let refined = {};
    let extra = {};
    for(let propName in refiners)if (propName in input) refined[propName] = refiners[propName](input[propName]);
    for(let propName in input)if (!(propName in refiners)) extra[propName] = input[propName];
    return {
        refined: refined,
        extra: extra
    };
}
function $200f5cce291452b2$export$7ccc53e8f1e7dfc5(raw) {
    return raw;
}
function $200f5cce291452b2$export$3b513254972cfc9c(defId, range, forcedStartTzo, forcedEndTzo) {
    return {
        instanceId: $200f5cce291452b2$export$39b482c5e57630a8(),
        defId: defId,
        range: range,
        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo
    };
}
function $200f5cce291452b2$var$parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
    for(let i = 0; i < recurringTypes.length; i += 1){
        let parsed = recurringTypes[i].parse(refined, dateEnv);
        if (parsed) {
            let { allDay: allDay } = refined;
            if (allDay == null) {
                allDay = defaultAllDay;
                if (allDay == null) {
                    allDay = parsed.allDayGuess;
                    if (allDay == null) allDay = false;
                }
            }
            return {
                allDay: allDay,
                duration: parsed.duration,
                typeData: parsed.typeData,
                typeId: i
            };
        }
    }
    return null;
}
function $200f5cce291452b2$var$expandRecurring(eventStore, framingRange, context) {
    let { dateEnv: dateEnv, pluginHooks: pluginHooks, options: options } = context;
    let { defs: defs, instances: instances } = eventStore;
    // remove existing recurring instances
    // TODO: bad. always expand events as a second step
    instances = $200f5cce291452b2$export$dda1d9f60106f0e9(instances, (instance)=>!defs[instance.defId].recurringDef);
    for(let defId in defs){
        let def = defs[defId];
        if (def.recurringDef) {
            let { duration: duration } = def.recurringDef;
            if (!duration) duration = def.allDay ? options.defaultAllDayEventDuration : options.defaultTimedEventDuration;
            let starts = $200f5cce291452b2$var$expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
            for (let start of starts){
                let instance = $200f5cce291452b2$export$3b513254972cfc9c(defId, {
                    start: start,
                    end: dateEnv.add(start, duration)
                });
                instances[instance.instanceId] = instance;
            }
        }
    }
    return {
        defs: defs,
        instances: instances
    };
}
/*
Event MUST have a recurringDef
*/ function $200f5cce291452b2$var$expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
    let typeDef = recurringTypes[eventDef.recurringDef.typeId];
    let markers = typeDef.expand(eventDef.recurringDef.typeData, {
        start: dateEnv.subtract(framingRange.start, duration),
        end: framingRange.end
    }, dateEnv);
    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
    if (eventDef.allDay) markers = markers.map($200f5cce291452b2$export$9e5f44173e64f162);
    return markers;
}
function $200f5cce291452b2$var$parseEvents(rawEvents, eventSource, context, allowOpenRange, defIdMap, instanceIdMap) {
    let eventStore = $200f5cce291452b2$export$9bb611d729802a56();
    let eventRefiners = $200f5cce291452b2$var$buildEventRefiners(context);
    for (let rawEvent of rawEvents){
        let tuple = $200f5cce291452b2$var$parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners, defIdMap, instanceIdMap);
        if (tuple) $200f5cce291452b2$export$9d0e2d13d04f7070(tuple, eventStore);
    }
    return eventStore;
}
function $200f5cce291452b2$export$9d0e2d13d04f7070(tuple, eventStore = $200f5cce291452b2$export$9bb611d729802a56()) {
    eventStore.defs[tuple.def.defId] = tuple.def;
    if (tuple.instance) eventStore.instances[tuple.instance.instanceId] = tuple.instance;
    return eventStore;
}
// retrieves events that have the same groupId as the instance specified by `instanceId`
// or they are the same as the instance.
// why might instanceId not be in the store? an event from another calendar?
function $200f5cce291452b2$export$1ee57be6f6687d2c(eventStore, instanceId) {
    let instance = eventStore.instances[instanceId];
    if (instance) {
        let def = eventStore.defs[instance.defId];
        // get events/instances with same group
        let newStore = $200f5cce291452b2$var$filterEventStoreDefs(eventStore, (lookDef)=>$200f5cce291452b2$var$isEventDefsGrouped(def, lookDef));
        // add the original
        // TODO: wish we could use eventTupleToStore or something like it
        newStore.defs[def.defId] = def;
        newStore.instances[instance.instanceId] = instance;
        return newStore;
    }
    return $200f5cce291452b2$export$9bb611d729802a56();
}
function $200f5cce291452b2$var$isEventDefsGrouped(def0, def1) {
    return Boolean(def0.groupId && def0.groupId === def1.groupId);
}
function $200f5cce291452b2$export$9bb611d729802a56() {
    return {
        defs: {},
        instances: {}
    };
}
function $200f5cce291452b2$export$317a3d46287192d8(store0, store1) {
    return {
        defs: Object.assign(Object.assign({}, store0.defs), store1.defs),
        instances: Object.assign(Object.assign({}, store0.instances), store1.instances)
    };
}
function $200f5cce291452b2$var$filterEventStoreDefs(eventStore, filterFunc) {
    let defs = $200f5cce291452b2$export$dda1d9f60106f0e9(eventStore.defs, filterFunc);
    let instances = $200f5cce291452b2$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>defs[instance.defId] // still exists?
    );
    return {
        defs: defs,
        instances: instances
    };
}
function $200f5cce291452b2$var$excludeSubEventStore(master, sub) {
    let { defs: defs, instances: instances } = master;
    let filteredDefs = {};
    let filteredInstances = {};
    for(let defId in defs)if (!sub.defs[defId]) filteredDefs[defId] = defs[defId];
    for(let instanceId in instances)if (!sub.instances[instanceId] && // not explicitly excluded
    filteredDefs[instances[instanceId].defId] // def wasn't filtered away
    ) filteredInstances[instanceId] = instances[instanceId];
    return {
        defs: filteredDefs,
        instances: filteredInstances
    };
}
function $200f5cce291452b2$var$normalizeConstraint(input, context) {
    if (Array.isArray(input)) return $200f5cce291452b2$var$parseEvents(input, null, context, true); // allowOpenRange=true
    if (typeof input === "object" && input) return $200f5cce291452b2$var$parseEvents([
        input
    ], null, context, true); // allowOpenRange=true
    if (input != null) return String(input);
    return null;
}
function $200f5cce291452b2$export$d377dcb2b61d6c4e(raw) {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "string") return raw.split(/\s+/);
    return [];
}
// TODO: better called "EventSettings" or "EventConfig"
// TODO: move this file into structs
// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
const $200f5cce291452b2$var$EVENT_UI_REFINERS = {
    display: String,
    editable: Boolean,
    startEditable: Boolean,
    durationEditable: Boolean,
    constraint: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    overlap: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    allow: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    className: $200f5cce291452b2$export$d377dcb2b61d6c4e,
    classNames: $200f5cce291452b2$export$d377dcb2b61d6c4e,
    color: String,
    backgroundColor: String,
    borderColor: String,
    textColor: String
};
const $200f5cce291452b2$var$EMPTY_EVENT_UI = {
    display: null,
    startEditable: null,
    durationEditable: null,
    constraints: [],
    overlap: null,
    allows: [],
    backgroundColor: "",
    borderColor: "",
    textColor: "",
    classNames: []
};
function $200f5cce291452b2$export$71cec2538cb2c617(refined, context) {
    let constraint = $200f5cce291452b2$var$normalizeConstraint(refined.constraint, context);
    return {
        display: refined.display || null,
        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
        constraints: constraint != null ? [
            constraint
        ] : [],
        overlap: refined.overlap != null ? refined.overlap : null,
        allows: refined.allow != null ? [
            refined.allow
        ] : [],
        backgroundColor: refined.backgroundColor || refined.color || "",
        borderColor: refined.borderColor || refined.color || "",
        textColor: refined.textColor || "",
        classNames: (refined.className || []).concat(refined.classNames || [])
    };
}
// TODO: prevent against problems with <2 args!
function $200f5cce291452b2$export$1a8f5705751d8277(uis) {
    return uis.reduce($200f5cce291452b2$var$combineTwoEventUis, $200f5cce291452b2$var$EMPTY_EVENT_UI);
}
function $200f5cce291452b2$var$combineTwoEventUis(item0, item1) {
    return {
        display: item1.display != null ? item1.display : item0.display,
        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
        constraints: item0.constraints.concat(item1.constraints),
        overlap: typeof item1.overlap === "boolean" ? item1.overlap : item0.overlap,
        allows: item0.allows.concat(item1.allows),
        backgroundColor: item1.backgroundColor || item0.backgroundColor,
        borderColor: item1.borderColor || item0.borderColor,
        textColor: item1.textColor || item0.textColor,
        classNames: item0.classNames.concat(item1.classNames)
    };
}
const $200f5cce291452b2$var$EVENT_NON_DATE_REFINERS = {
    id: String,
    groupId: String,
    title: String,
    url: String,
    interactive: Boolean
};
const $200f5cce291452b2$var$EVENT_DATE_REFINERS = {
    start: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    end: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    date: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
const $200f5cce291452b2$var$EVENT_REFINERS = Object.assign(Object.assign(Object.assign({}, $200f5cce291452b2$var$EVENT_NON_DATE_REFINERS), $200f5cce291452b2$var$EVENT_DATE_REFINERS), {
    extendedProps: $200f5cce291452b2$export$7ccc53e8f1e7dfc5
});
function $200f5cce291452b2$var$parseEvent(raw, eventSource, context, allowOpenRange, refiners = $200f5cce291452b2$var$buildEventRefiners(context), defIdMap, instanceIdMap) {
    let { refined: refined, extra: extra } = $200f5cce291452b2$export$ab83b03e4111b1d0(raw, context, refiners);
    let defaultAllDay = $200f5cce291452b2$var$computeIsDefaultAllDay(eventSource, context);
    let recurringRes = $200f5cce291452b2$var$parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
    if (recurringRes) {
        let def = $200f5cce291452b2$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : "", recurringRes.allDay, Boolean(recurringRes.duration), context, defIdMap);
        def.recurringDef = {
            typeId: recurringRes.typeId,
            typeData: recurringRes.typeData,
            duration: recurringRes.duration
        };
        return {
            def: def,
            instance: null
        };
    }
    let singleRes = $200f5cce291452b2$var$parseSingle(refined, defaultAllDay, context, allowOpenRange);
    if (singleRes) {
        let def = $200f5cce291452b2$export$21579262ef46735b(refined, extra, eventSource ? eventSource.sourceId : "", singleRes.allDay, singleRes.hasEnd, context, defIdMap);
        let instance = $200f5cce291452b2$export$3b513254972cfc9c(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
        if (instanceIdMap && def.publicId && instanceIdMap[def.publicId]) instance.instanceId = instanceIdMap[def.publicId];
        return {
            def: def,
            instance: instance
        };
    }
    return null;
}
function $200f5cce291452b2$export$ab83b03e4111b1d0(raw, context, refiners = $200f5cce291452b2$var$buildEventRefiners(context)) {
    return $200f5cce291452b2$export$f38c853ae54ed474(raw, refiners);
}
function $200f5cce291452b2$var$buildEventRefiners(context) {
    return Object.assign(Object.assign(Object.assign({}, $200f5cce291452b2$var$EVENT_UI_REFINERS), $200f5cce291452b2$var$EVENT_REFINERS), context.pluginHooks.eventRefiners);
}
/*
Will NOT populate extendedProps with the leftover properties.
Will NOT populate date-related props.
*/ function $200f5cce291452b2$export$21579262ef46735b(refined, extra, sourceId, allDay, hasEnd, context, defIdMap) {
    let def = {
        title: refined.title || "",
        groupId: refined.groupId || "",
        publicId: refined.id || "",
        url: refined.url || "",
        recurringDef: null,
        defId: (defIdMap && refined.id ? defIdMap[refined.id] : "") || $200f5cce291452b2$export$39b482c5e57630a8(),
        sourceId: sourceId,
        allDay: allDay,
        hasEnd: hasEnd,
        interactive: refined.interactive,
        ui: $200f5cce291452b2$export$71cec2538cb2c617(refined, context),
        extendedProps: Object.assign(Object.assign({}, refined.extendedProps || {}), extra)
    };
    for (let memberAdder of context.pluginHooks.eventDefMemberAdders)Object.assign(def, memberAdder(refined));
    // help out EventImpl from having user modify props
    Object.freeze(def.ui.classNames);
    Object.freeze(def.extendedProps);
    return def;
}
function $200f5cce291452b2$var$parseSingle(refined, defaultAllDay, context, allowOpenRange) {
    let { allDay: allDay } = refined;
    let startMeta;
    let startMarker = null;
    let hasEnd = false;
    let endMeta;
    let endMarker = null;
    let startInput = refined.start != null ? refined.start : refined.date;
    startMeta = context.dateEnv.createMarkerMeta(startInput);
    if (startMeta) startMarker = startMeta.marker;
    else if (!allowOpenRange) return null;
    if (refined.end != null) endMeta = context.dateEnv.createMarkerMeta(refined.end);
    if (allDay == null) {
        if (defaultAllDay != null) allDay = defaultAllDay;
        else // fall back to the date props LAST
        allDay = (!startMeta || startMeta.isTimeUnspecified) && (!endMeta || endMeta.isTimeUnspecified);
    }
    if (allDay && startMarker) startMarker = $200f5cce291452b2$export$9e5f44173e64f162(startMarker);
    if (endMeta) {
        endMarker = endMeta.marker;
        if (allDay) endMarker = $200f5cce291452b2$export$9e5f44173e64f162(endMarker);
        if (startMarker && endMarker <= startMarker) endMarker = null;
    }
    if (endMarker) hasEnd = true;
    else if (!allowOpenRange) {
        hasEnd = context.options.forceEventDuration || false;
        endMarker = context.dateEnv.add(startMarker, allDay ? context.options.defaultAllDayEventDuration : context.options.defaultTimedEventDuration);
    }
    return {
        allDay: allDay,
        hasEnd: hasEnd,
        range: {
            start: startMarker,
            end: endMarker
        },
        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
        forcedEndTzo: endMeta ? endMeta.forcedTzo : null
    };
}
function $200f5cce291452b2$var$computeIsDefaultAllDay(eventSource, context) {
    let res = null;
    if (eventSource) res = eventSource.defaultAllDay;
    if (res == null) res = context.options.defaultAllDay;
    return res;
}
const $200f5cce291452b2$var$DEF_DEFAULTS = {
    startTime: "09:00",
    endTime: "17:00",
    daysOfWeek: [
        1,
        2,
        3,
        4,
        5
    ],
    display: "inverse-background",
    classNames: "fc-non-business",
    groupId: "_businessHours"
};
/*
TODO: pass around as EventDefHash!!!
*/ function $200f5cce291452b2$export$78acf4525d8a74c4(input, context) {
    return $200f5cce291452b2$var$parseEvents($200f5cce291452b2$var$refineInputs(input), null, context);
}
function $200f5cce291452b2$var$refineInputs(input) {
    let rawDefs;
    if (input === true) rawDefs = [
        {}
    ]; // will get DEF_DEFAULTS verbatim
    else if (Array.isArray(input)) // if specifying an array, every sub-definition NEEDS a day-of-week
    rawDefs = input.filter((rawDef)=>rawDef.daysOfWeek);
    else if (typeof input === "object" && input) rawDefs = [
        input
    ];
    else rawDefs = [];
    rawDefs = rawDefs.map((rawDef)=>Object.assign(Object.assign({}, $200f5cce291452b2$var$DEF_DEFAULTS), rawDef));
    return rawDefs;
}
/* Date stuff that doesn't belong in datelib core
----------------------------------------------------------------------------------------------------------------------*/ // given a timed range, computes an all-day range that has the same exact duration,
// but whose start time is aligned with the start of the day.
function $200f5cce291452b2$var$computeAlignedDayRange(timedRange) {
    let dayCnt = Math.floor($200f5cce291452b2$export$a36fb7d24305ed9d(timedRange.start, timedRange.end)) || 1;
    let start = $200f5cce291452b2$export$9e5f44173e64f162(timedRange.start);
    let end = $200f5cce291452b2$export$625550452a3fa3ec(start, dayCnt);
    return {
        start: start,
        end: end
    };
}
// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
// TODO: give nextDayThreshold a default arg
function $200f5cce291452b2$export$28f7fcd39efa255(timedRange, nextDayThreshold = $200f5cce291452b2$export$4368d992c4eafac0(0)) {
    let startDay = null;
    let endDay = null;
    if (timedRange.end) {
        endDay = $200f5cce291452b2$export$9e5f44173e64f162(timedRange.end);
        let endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
        // If the end time is actually inclusively part of the next day and is equal to or
        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
        if (endTimeMS && endTimeMS >= $200f5cce291452b2$export$4e222d082f82ee97(nextDayThreshold)) endDay = $200f5cce291452b2$export$625550452a3fa3ec(endDay, 1);
    }
    if (timedRange.start) {
        startDay = $200f5cce291452b2$export$9e5f44173e64f162(timedRange.start); // the beginning of the day the range starts
        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
        if (endDay && endDay <= startDay) endDay = $200f5cce291452b2$export$625550452a3fa3ec(startDay, 1);
    }
    return {
        start: startDay,
        end: endDay
    };
}
// spans from one day into another?
function $200f5cce291452b2$export$3d12bd131bb975d1(range) {
    let visibleRange = $200f5cce291452b2$export$28f7fcd39efa255(range);
    return $200f5cce291452b2$export$a36fb7d24305ed9d(visibleRange.start, visibleRange.end) > 1;
}
function $200f5cce291452b2$export$91c6e00c14e7e6fd(date0, date1, dateEnv, largeUnit) {
    if (largeUnit === "year") return $200f5cce291452b2$export$4368d992c4eafac0(dateEnv.diffWholeYears(date0, date1), "year");
    if (largeUnit === "month") return $200f5cce291452b2$export$4368d992c4eafac0(dateEnv.diffWholeMonths(date0, date1), "month");
    return $200f5cce291452b2$export$5521614468b862fb(date0, date1); // returns a duration
}
function $200f5cce291452b2$export$cf2f7c5792f80b46(point, rect) {
    return point.left >= rect.left && point.left < rect.right && point.top >= rect.top && point.top < rect.bottom;
}
// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
function $200f5cce291452b2$export$158acd800e1ef08b(rect1, rect2) {
    let res = {
        left: Math.max(rect1.left, rect2.left),
        right: Math.min(rect1.right, rect2.right),
        top: Math.max(rect1.top, rect2.top),
        bottom: Math.min(rect1.bottom, rect2.bottom)
    };
    if (res.left < res.right && res.top < res.bottom) return res;
    return false;
}
function $200f5cce291452b2$export$a05254e7c3aeba6e(rect, deltaX, deltaY) {
    return {
        left: rect.left + deltaX,
        right: rect.right + deltaX,
        top: rect.top + deltaY,
        bottom: rect.bottom + deltaY
    };
}
// Returns a new point that will have been moved to reside within the given rectangle
function $200f5cce291452b2$export$53a70dd1ebbae346(point, rect) {
    return {
        left: Math.min(Math.max(point.left, rect.left), rect.right),
        top: Math.min(Math.max(point.top, rect.top), rect.bottom)
    };
}
// Returns a point that is the center of the given rectangle
function $200f5cce291452b2$export$a33b77bbdbb8366c(rect) {
    return {
        left: (rect.left + rect.right) / 2,
        top: (rect.top + rect.bottom) / 2
    };
}
// Subtracts point2's coordinates from point1's coordinates, returning a delta
function $200f5cce291452b2$export$b9a6b53f9be3734(point1, point2) {
    return {
        left: point1.left - point2.left,
        top: point1.top - point2.top
    };
}
let $200f5cce291452b2$var$canVGrowWithinCell;
function $200f5cce291452b2$export$667d3bf0c5f83305() {
    if ($200f5cce291452b2$var$canVGrowWithinCell == null) $200f5cce291452b2$var$canVGrowWithinCell = $200f5cce291452b2$var$computeCanVGrowWithinCell();
    return $200f5cce291452b2$var$canVGrowWithinCell;
}
function $200f5cce291452b2$var$computeCanVGrowWithinCell() {
    // for SSR, because this function is call immediately at top-level
    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
    if (typeof document === "undefined") return true;
    let el = document.createElement("div");
    el.style.position = "absolute";
    el.style.top = "0px";
    el.style.left = "0px";
    el.innerHTML = "<table><tr><td><div></div></td></tr></table>";
    el.querySelector("table").style.height = "100px";
    el.querySelector("div").style.height = "100%";
    document.body.appendChild(el);
    let div = el.querySelector("div");
    let possible = div.offsetHeight > 0;
    document.body.removeChild(el);
    return possible;
}
const $200f5cce291452b2$var$EMPTY_EVENT_STORE = $200f5cce291452b2$export$9bb611d729802a56(); // for purecomponents. TODO: keep elsewhere
class $200f5cce291452b2$export$e171bab687b50e0 {
    splitProps(props) {
        let keyInfos = this.getKeyInfo(props);
        let defKeys = this.getKeysForEventDefs(props.eventStore);
        let dateSelections = this.splitDateSelection(props.dateSelection);
        let individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
        let eventStores = this.splitEventStore(props.eventStore, defKeys);
        let eventDrags = this.splitEventDrag(props.eventDrag);
        let eventResizes = this.splitEventResize(props.eventResize);
        let splitProps = {};
        this.eventUiBuilders = $200f5cce291452b2$export$407448d2b89b1813(keyInfos, (info, key)=>this.eventUiBuilders[key] || $200f5cce291452b2$export$df995fae86a55f06($200f5cce291452b2$var$buildEventUiForKey));
        for(let key in keyInfos){
            let keyInfo = keyInfos[key];
            let eventStore = eventStores[key] || $200f5cce291452b2$var$EMPTY_EVENT_STORE;
            let buildEventUi = this.eventUiBuilders[key];
            splitProps[key] = {
                businessHours: keyInfo.businessHours || props.businessHours,
                dateSelection: dateSelections[key] || null,
                eventStore: eventStore,
                eventUiBases: buildEventUi(props.eventUiBases[""], keyInfo.ui, individualUi[key]),
                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : "",
                eventDrag: eventDrags[key] || null,
                eventResize: eventResizes[key] || null
            };
        }
        return splitProps;
    }
    _splitDateSpan(dateSpan) {
        let dateSpans = {};
        if (dateSpan) {
            let keys = this.getKeysForDateSpan(dateSpan);
            for (let key of keys)dateSpans[key] = dateSpan;
        }
        return dateSpans;
    }
    _getKeysForEventDefs(eventStore) {
        return $200f5cce291452b2$export$407448d2b89b1813(eventStore.defs, (eventDef)=>this.getKeysForEventDef(eventDef));
    }
    _splitEventStore(eventStore, defKeys) {
        let { defs: defs, instances: instances } = eventStore;
        let splitStores = {};
        for(let defId in defs)for (let key of defKeys[defId]){
            if (!splitStores[key]) splitStores[key] = $200f5cce291452b2$export$9bb611d729802a56();
            splitStores[key].defs[defId] = defs[defId];
        }
        for(let instanceId in instances){
            let instance = instances[instanceId];
            for (let key of defKeys[instance.defId])if (splitStores[key]) splitStores[key].instances[instanceId] = instance;
        }
        return splitStores;
    }
    _splitIndividualUi(eventUiBases, defKeys) {
        let splitHashes = {};
        for(let defId in eventUiBases){
            if (defId) for (let key of defKeys[defId]){
                if (!splitHashes[key]) splitHashes[key] = {};
                splitHashes[key][defId] = eventUiBases[defId];
            }
        }
        return splitHashes;
    }
    _splitInteraction(interaction) {
        let splitStates = {};
        if (interaction) {
            let affectedStores = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
            // can't rely on defKeys because event data is mutated
            let mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
            let mutatedStores = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
            let populate = (key)=>{
                if (!splitStates[key]) splitStates[key] = {
                    affectedEvents: affectedStores[key] || $200f5cce291452b2$var$EMPTY_EVENT_STORE,
                    mutatedEvents: mutatedStores[key] || $200f5cce291452b2$var$EMPTY_EVENT_STORE,
                    isEvent: interaction.isEvent
                };
            };
            for(let key in affectedStores)populate(key);
            for(let key in mutatedStores)populate(key);
        }
        return splitStates;
    }
    constructor(){
        this.getKeysForEventDefs = $200f5cce291452b2$export$df995fae86a55f06(this._getKeysForEventDefs);
        this.splitDateSelection = $200f5cce291452b2$export$df995fae86a55f06(this._splitDateSpan);
        this.splitEventStore = $200f5cce291452b2$export$df995fae86a55f06(this._splitEventStore);
        this.splitIndividualUi = $200f5cce291452b2$export$df995fae86a55f06(this._splitIndividualUi);
        this.splitEventDrag = $200f5cce291452b2$export$df995fae86a55f06(this._splitInteraction);
        this.splitEventResize = $200f5cce291452b2$export$df995fae86a55f06(this._splitInteraction);
        this.eventUiBuilders = {}; // TODO: typescript protection
    }
}
function $200f5cce291452b2$var$buildEventUiForKey(allUi, eventUiForKey, individualUi) {
    let baseParts = [];
    if (allUi) baseParts.push(allUi);
    if (eventUiForKey) baseParts.push(eventUiForKey);
    let stuff = {
        "": $200f5cce291452b2$export$1a8f5705751d8277(baseParts)
    };
    if (individualUi) Object.assign(stuff, individualUi);
    return stuff;
}
function $200f5cce291452b2$var$parseRange(input, dateEnv) {
    let start = null;
    let end = null;
    if (input.start) start = dateEnv.createMarker(input.start);
    if (input.end) end = dateEnv.createMarker(input.end);
    if (!start && !end) return null;
    if (start && end && end < start) return null;
    return {
        start: start,
        end: end
    };
}
// SIDE-EFFECT: will mutate ranges.
// Will return a new array result.
function $200f5cce291452b2$var$invertRanges(ranges, constraintRange) {
    let invertedRanges = [];
    let { start: start } = constraintRange; // the end of the previous range. the start of the new range
    let i;
    let dateRange;
    // ranges need to be in order. required for our date-walking algorithm
    ranges.sort($200f5cce291452b2$var$compareRanges);
    for(i = 0; i < ranges.length; i += 1){
        dateRange = ranges[i];
        // add the span of time before the event (if there is any)
        if (dateRange.start > start) invertedRanges.push({
            start: start,
            end: dateRange.start
        });
        if (dateRange.end > start) start = dateRange.end;
    }
    // add the span of time after the last event (if there is any)
    if (start < constraintRange.end) invertedRanges.push({
        start: start,
        end: constraintRange.end
    });
    return invertedRanges;
}
function $200f5cce291452b2$var$compareRanges(range0, range1) {
    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
}
function $200f5cce291452b2$export$ae1af26003f05816(range0, range1) {
    let { start: start, end: end } = range0;
    let newRange = null;
    if (range1.start !== null) {
        if (start === null) start = range1.start;
        else start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
    }
    if (range1.end != null) {
        if (end === null) end = range1.end;
        else end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
    }
    if (start === null || end === null || start < end) newRange = {
        start: start,
        end: end
    };
    return newRange;
}
function $200f5cce291452b2$export$f074adc9fbd50943(range0, range1) {
    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) && (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
}
function $200f5cce291452b2$export$ad4aebacdcaf47f8(range0, range1) {
    return (range0.end === null || range1.start === null || range0.end > range1.start) && (range0.start === null || range1.end === null || range0.start < range1.end);
}
function $200f5cce291452b2$export$4ae495d48253603d(outerRange, innerRange) {
    return (outerRange.start === null || innerRange.start !== null && innerRange.start >= outerRange.start) && (outerRange.end === null || innerRange.end !== null && innerRange.end <= outerRange.end);
}
function $200f5cce291452b2$export$7f8ddf7c7c20b3cd(range, date) {
    return (range.start === null || date >= range.start) && (range.end === null || date < range.end);
}
// If the given date is not within the given range, move it inside.
// (If it's past the end, make it one millisecond before the end).
function $200f5cce291452b2$var$constrainMarkerToRange(date, range) {
    if (range.start != null && date < range.start) return range.start;
    if (range.end != null && date >= range.end) return new Date(range.end.valueOf() - 1);
    return date;
}
function $200f5cce291452b2$export$a17c37559e1db147(date, todayRange, nowDate, dateProfile) {
    return {
        dow: date.getUTCDay(),
        isDisabled: Boolean(dateProfile && !$200f5cce291452b2$export$7f8ddf7c7c20b3cd(dateProfile.activeRange, date)),
        isOther: Boolean(dateProfile && !$200f5cce291452b2$export$7f8ddf7c7c20b3cd(dateProfile.currentRange, date)),
        isToday: Boolean(todayRange && $200f5cce291452b2$export$7f8ddf7c7c20b3cd(todayRange, date)),
        isPast: Boolean(nowDate ? date < nowDate : todayRange ? date < todayRange.start : false),
        isFuture: Boolean(nowDate ? date > nowDate : todayRange ? date >= todayRange.end : false)
    };
}
function $200f5cce291452b2$export$527e9aa3390079e9(meta, theme) {
    let classNames = [
        "fc-day",
        `fc-day-${$200f5cce291452b2$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push("fc-day-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-day-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-day-past");
        if (meta.isFuture) classNames.push("fc-day-future");
        if (meta.isOther) classNames.push("fc-day-other");
    }
    return classNames;
}
function $200f5cce291452b2$export$fef3dfd9bad05307(meta, theme) {
    let classNames = [
        "fc-slot",
        `fc-slot-${$200f5cce291452b2$var$DAY_IDS[meta.dow]}`
    ];
    if (meta.isDisabled) classNames.push("fc-slot-disabled");
    else {
        if (meta.isToday) {
            classNames.push("fc-slot-today");
            classNames.push(theme.getClass("today"));
        }
        if (meta.isPast) classNames.push("fc-slot-past");
        if (meta.isFuture) classNames.push("fc-slot-future");
    }
    return classNames;
}
const $200f5cce291452b2$var$DAY_FORMAT = $200f5cce291452b2$export$d141bba7fdc215a3({
    year: "numeric",
    month: "long",
    day: "numeric"
});
const $200f5cce291452b2$var$WEEK_FORMAT = $200f5cce291452b2$export$d141bba7fdc215a3({
    week: "long"
});
function $200f5cce291452b2$export$8c78c7c36408ea29(context, dateMarker, viewType = "day", isTabbable = true) {
    const { dateEnv: dateEnv, options: options, calendarApi: calendarApi } = context;
    let dateStr = dateEnv.format(dateMarker, viewType === "week" ? $200f5cce291452b2$var$WEEK_FORMAT : $200f5cce291452b2$var$DAY_FORMAT);
    if (options.navLinks) {
        let zonedDate = dateEnv.toDate(dateMarker);
        const handleInteraction = (ev)=>{
            let customAction = viewType === "day" ? options.navLinkDayClick : viewType === "week" ? options.navLinkWeekClick : null;
            if (typeof customAction === "function") customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
            else {
                if (typeof customAction === "string") viewType = customAction;
                calendarApi.zoomTo(dateMarker, viewType);
            }
        };
        return Object.assign({
            title: $200f5cce291452b2$export$342063e11d6c3cad(options.navLinkHint, [
                dateStr,
                zonedDate
            ], dateStr),
            "data-navlink": ""
        }, isTabbable ? $200f5cce291452b2$var$createAriaClickAttrs(handleInteraction) : {
            onClick: handleInteraction
        });
    }
    return {
        "aria-label": dateStr
    };
}
let $200f5cce291452b2$var$_isRtlScrollbarOnLeft = null;
function $200f5cce291452b2$export$6735ce526161c7bd() {
    if ($200f5cce291452b2$var$_isRtlScrollbarOnLeft === null) $200f5cce291452b2$var$_isRtlScrollbarOnLeft = $200f5cce291452b2$var$computeIsRtlScrollbarOnLeft();
    return $200f5cce291452b2$var$_isRtlScrollbarOnLeft;
}
function $200f5cce291452b2$var$computeIsRtlScrollbarOnLeft() {
    let outerEl = document.createElement("div");
    $200f5cce291452b2$export$2ed0fc6709e59212(outerEl, {
        position: "absolute",
        top: -1000,
        left: 0,
        border: 0,
        padding: 0,
        overflow: "scroll",
        direction: "rtl"
    });
    outerEl.innerHTML = "<div></div>";
    document.body.appendChild(outerEl);
    let innerEl = outerEl.firstChild;
    let res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
    $200f5cce291452b2$export$c03999cb2f36933f(outerEl);
    return res;
}
let $200f5cce291452b2$var$_scrollbarWidths;
function $200f5cce291452b2$export$c7ca7e4bc4f8a16e() {
    if (!$200f5cce291452b2$var$_scrollbarWidths) $200f5cce291452b2$var$_scrollbarWidths = $200f5cce291452b2$var$computeScrollbarWidths();
    return $200f5cce291452b2$var$_scrollbarWidths;
}
function $200f5cce291452b2$var$computeScrollbarWidths() {
    let el = document.createElement("div");
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    let res = $200f5cce291452b2$var$computeScrollbarWidthsForEl(el);
    document.body.removeChild(el);
    return res;
}
// WARNING: will include border
function $200f5cce291452b2$var$computeScrollbarWidthsForEl(el) {
    return {
        x: el.offsetHeight - el.clientHeight,
        y: el.offsetWidth - el.clientWidth
    };
}
function $200f5cce291452b2$export$39c1cc7c062529d4(el, getPadding = false) {
    let computedStyle = window.getComputedStyle(el);
    let borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
    let borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
    let borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
    let borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
    let badScrollbarWidths = $200f5cce291452b2$var$computeScrollbarWidthsForEl(el); // includes border!
    let scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
    let scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
    let res = {
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderTop: borderTop,
        borderBottom: borderBottom,
        scrollbarBottom: scrollbarBottom,
        scrollbarLeft: 0,
        scrollbarRight: 0
    };
    if ($200f5cce291452b2$export$6735ce526161c7bd() && computedStyle.direction === "rtl") res.scrollbarLeft = scrollbarLeftRight;
    else res.scrollbarRight = scrollbarLeftRight;
    if (getPadding) {
        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
    }
    return res;
}
function $200f5cce291452b2$export$53c86fa97d611818(el, goWithinPadding = false, doFromWindowViewport) {
    let outerRect = doFromWindowViewport ? el.getBoundingClientRect() : $200f5cce291452b2$export$c18d01048907ea92(el);
    let edges = $200f5cce291452b2$export$39c1cc7c062529d4(el, goWithinPadding);
    let res = {
        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
        top: outerRect.top + edges.borderTop,
        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom
    };
    if (goWithinPadding) {
        res.left += edges.paddingLeft;
        res.right -= edges.paddingRight;
        res.top += edges.paddingTop;
        res.bottom -= edges.paddingBottom;
    }
    return res;
}
function $200f5cce291452b2$export$c18d01048907ea92(el) {
    let rect = el.getBoundingClientRect();
    return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset
    };
}
function $200f5cce291452b2$var$computeClippedClientRect(el) {
    let clippingParents = $200f5cce291452b2$export$7a0bdf7d4a91ea88(el);
    let rect = el.getBoundingClientRect();
    for (let clippingParent of clippingParents){
        let intersection = $200f5cce291452b2$export$158acd800e1ef08b(rect, clippingParent.getBoundingClientRect());
        if (intersection) rect = intersection;
        else return null;
    }
    return rect;
}
// does not return window
function $200f5cce291452b2$export$7a0bdf7d4a91ea88(el) {
    let parents = [];
    while(el instanceof HTMLElement){
        let computedStyle = window.getComputedStyle(el);
        if (computedStyle.position === "fixed") break;
        if (/(auto|scroll)/.test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) parents.push(el);
        el = el.parentNode;
    }
    return parents;
}
/*
given a function that resolves a result asynchronously.
the function can either call passed-in success and failure callbacks,
or it can return a promise.
if you need to pass additional params to func, bind them first.
*/ function $200f5cce291452b2$export$3b14a55fb2447963(func, normalizedSuccessCallback, normalizedFailureCallback) {
    // guard against success/failure callbacks being called more than once
    // and guard against a promise AND callback being used together.
    let isResolved = false;
    let wrappedSuccess = function(res) {
        if (!isResolved) {
            isResolved = true;
            normalizedSuccessCallback(res);
        }
    };
    let wrappedFailure = function(error) {
        if (!isResolved) {
            isResolved = true;
            normalizedFailureCallback(error);
        }
    };
    let res = func(wrappedSuccess, wrappedFailure);
    if (res && typeof res.then === "function") res.then(wrappedSuccess, wrappedFailure);
}
class $200f5cce291452b2$export$d66501df72047452 {
    setThisContext(thisContext) {
        this.thisContext = thisContext;
    }
    setOptions(options) {
        this.options = options;
    }
    on(type, handler) {
        $200f5cce291452b2$var$addToHash(this.handlers, type, handler);
    }
    off(type, handler) {
        $200f5cce291452b2$var$removeFromHash(this.handlers, type, handler);
    }
    trigger(type, ...args) {
        let attachedHandlers = this.handlers[type] || [];
        let optionHandler = this.options && this.options[type];
        let handlers = [].concat(optionHandler || [], attachedHandlers);
        for (let handler of handlers)handler.apply(this.thisContext, args);
    }
    hasHandlers(type) {
        return Boolean(this.handlers[type] && this.handlers[type].length || this.options && this.options[type]);
    }
    constructor(){
        this.handlers = {};
        this.thisContext = null;
    }
}
function $200f5cce291452b2$var$addToHash(hash, type, handler) {
    (hash[type] || (hash[type] = [])).push(handler);
}
function $200f5cce291452b2$var$removeFromHash(hash, type, handler) {
    if (handler) {
        if (hash[type]) hash[type] = hash[type].filter((func)=>func !== handler);
    } else delete hash[type]; // remove all handler funcs for this type
}
/*
Records offset information for a set of elements, relative to an origin element.
Can record the left/right OR the top/bottom OR both.
Provides methods for querying the cache by position.
*/ class $200f5cce291452b2$export$7060da4b5db56fb9 {
    // Populates the left/right internal coordinate arrays
    buildElHorizontals(originClientLeft) {
        let lefts = [];
        let rights = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            lefts.push(rect.left - originClientLeft);
            rights.push(rect.right - originClientLeft);
        }
        this.lefts = lefts;
        this.rights = rights;
    }
    // Populates the top/bottom internal coordinate arrays
    buildElVerticals(originClientTop) {
        let tops = [];
        let bottoms = [];
        for (let el of this.els){
            let rect = el.getBoundingClientRect();
            tops.push(rect.top - originClientTop);
            bottoms.push(rect.bottom - originClientTop);
        }
        this.tops = tops;
        this.bottoms = bottoms;
    }
    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
    // If no intersection is made, returns undefined.
    leftToIndex(leftPosition) {
        let { lefts: lefts, rights: rights } = this;
        let len = lefts.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (leftPosition >= lefts[i] && leftPosition < rights[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
    // If no intersection is made, returns undefined.
    topToIndex(topPosition) {
        let { tops: tops, bottoms: bottoms } = this;
        let len = tops.length;
        let i;
        for(i = 0; i < len; i += 1){
            if (topPosition >= tops[i] && topPosition < bottoms[i]) return i;
        }
        return undefined; // TODO: better
    }
    // Gets the width of the element at the given index
    getWidth(leftIndex) {
        return this.rights[leftIndex] - this.lefts[leftIndex];
    }
    // Gets the height of the element at the given index
    getHeight(topIndex) {
        return this.bottoms[topIndex] - this.tops[topIndex];
    }
    similarTo(otherCache) {
        return $200f5cce291452b2$var$similarNumArrays(this.tops || [], otherCache.tops || []) && $200f5cce291452b2$var$similarNumArrays(this.bottoms || [], otherCache.bottoms || []) && $200f5cce291452b2$var$similarNumArrays(this.lefts || [], otherCache.lefts || []) && $200f5cce291452b2$var$similarNumArrays(this.rights || [], otherCache.rights || []);
    }
    constructor(originEl, els, isHorizontal, isVertical){
        this.els = els;
        let originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
        if (isHorizontal) this.buildElHorizontals(originClientRect.left);
        if (isVertical) this.buildElVerticals(originClientRect.top);
    }
}
function $200f5cce291452b2$var$similarNumArrays(a, b) {
    const len = a.length;
    if (len !== b.length) return false;
    for(let i = 0; i < len; i++){
        if (Math.round(a[i]) !== Math.round(b[i])) return false;
    }
    return true;
}
/* eslint max-classes-per-file: "off" */ /*
An object for getting/setting scroll-related information for an element.
Internally, this is done very differently for window versus DOM element,
so this object serves as a common interface.
*/ class $200f5cce291452b2$export$c5d1328b37d47994 {
    getMaxScrollTop() {
        return this.getScrollHeight() - this.getClientHeight();
    }
    getMaxScrollLeft() {
        return this.getScrollWidth() - this.getClientWidth();
    }
    canScrollVertically() {
        return this.getMaxScrollTop() > 0;
    }
    canScrollHorizontally() {
        return this.getMaxScrollLeft() > 0;
    }
    canScrollUp() {
        return this.getScrollTop() > 0;
    }
    canScrollDown() {
        return this.getScrollTop() < this.getMaxScrollTop();
    }
    canScrollLeft() {
        return this.getScrollLeft() > 0;
    }
    canScrollRight() {
        return this.getScrollLeft() < this.getMaxScrollLeft();
    }
}
class $200f5cce291452b2$export$d22783b3c2400a3a extends $200f5cce291452b2$export$c5d1328b37d47994 {
    getScrollTop() {
        return this.el.scrollTop;
    }
    getScrollLeft() {
        return this.el.scrollLeft;
    }
    setScrollTop(top) {
        this.el.scrollTop = top;
    }
    setScrollLeft(left) {
        this.el.scrollLeft = left;
    }
    getScrollWidth() {
        return this.el.scrollWidth;
    }
    getScrollHeight() {
        return this.el.scrollHeight;
    }
    getClientHeight() {
        return this.el.clientHeight;
    }
    getClientWidth() {
        return this.el.clientWidth;
    }
    constructor(el){
        super();
        this.el = el;
    }
}
class $200f5cce291452b2$export$7f557e5eb95176c2 extends $200f5cce291452b2$export$c5d1328b37d47994 {
    getScrollTop() {
        return window.pageYOffset;
    }
    getScrollLeft() {
        return window.pageXOffset;
    }
    setScrollTop(n) {
        window.scroll(window.pageXOffset, n);
    }
    setScrollLeft(n) {
        window.scroll(n, window.pageYOffset);
    }
    getScrollWidth() {
        return document.documentElement.scrollWidth;
    }
    getScrollHeight() {
        return document.documentElement.scrollHeight;
    }
    getClientHeight() {
        return document.documentElement.clientHeight;
    }
    getClientWidth() {
        return document.documentElement.clientWidth;
    }
}
class $200f5cce291452b2$export$971d5caa766a69d7 {
    setIconOverride(iconOverrideHash) {
        let iconClassesCopy;
        let buttonName;
        if (typeof iconOverrideHash === "object" && iconOverrideHash) {
            iconClassesCopy = Object.assign({}, this.iconClasses);
            for(buttonName in iconOverrideHash)iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
            this.iconClasses = iconClassesCopy;
        } else if (iconOverrideHash === false) this.iconClasses = {};
    }
    applyIconOverridePrefix(className) {
        let prefix = this.iconOverridePrefix;
        if (prefix && className.indexOf(prefix) !== 0) className = prefix + className;
        return className;
    }
    getClass(key) {
        return this.classes[key] || "";
    }
    getIconClass(buttonName, isRtl) {
        let className;
        if (isRtl && this.rtlIconClasses) className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
        else className = this.iconClasses[buttonName];
        if (className) return `${this.baseIconClass} ${className}`;
        return "";
    }
    getCustomButtonIconClass(customButtonProps) {
        let className;
        if (this.iconOverrideCustomButtonOption) {
            className = customButtonProps[this.iconOverrideCustomButtonOption];
            if (className) return `${this.baseIconClass} ${this.applyIconOverridePrefix(className)}`;
        }
        return "";
    }
    constructor(calendarOptions){
        if (this.iconOverrideOption) this.setIconOverride(calendarOptions[this.iconOverrideOption]);
    }
}
$200f5cce291452b2$export$971d5caa766a69d7.prototype.classes = {};
$200f5cce291452b2$export$971d5caa766a69d7.prototype.iconClasses = {};
$200f5cce291452b2$export$971d5caa766a69d7.prototype.baseIconClass = "";
$200f5cce291452b2$export$971d5caa766a69d7.prototype.iconOverridePrefix = "";
/*
NOTE: this can be a public API, especially createElement for hooks.
See examples/typescript-scheduler/src/index.ts
*/ function $200f5cce291452b2$export$7910e0436ed8d1de(runBeforeFlush) {
    runBeforeFlush();
    let oldDebounceRendering = $f652a0e37ee35e91$export$41c562ebe57d11e2.debounceRendering; // orig
    let callbackQ = [];
    function execCallbackSync(callback) {
        callbackQ.push(callback);
    }
    $f652a0e37ee35e91$export$41c562ebe57d11e2.debounceRendering = execCallbackSync;
    $f652a0e37ee35e91$export$b3890eb0ae9dca99($f652a0e37ee35e91$export$c8a8987d4410bf2d($200f5cce291452b2$var$FakeComponent, {}), document.createElement("div"));
    while(callbackQ.length)callbackQ.shift()();
    $f652a0e37ee35e91$export$41c562ebe57d11e2.debounceRendering = oldDebounceRendering;
}
class $200f5cce291452b2$var$FakeComponent extends $f652a0e37ee35e91$export$16fa2f45be04daa8 {
    render() {
        return $f652a0e37ee35e91$export$c8a8987d4410bf2d("div", {});
    }
    componentDidMount() {
        this.setState({});
    }
}
// TODO: use preact/compat instead?
function $200f5cce291452b2$export$995eb9fca571757(defaultValue) {
    let ContextType = $f652a0e37ee35e91$export$fd42f52fd3ae1109(defaultValue);
    let origProvider = ContextType.Provider;
    ContextType.Provider = function() {
        let isNew = !this.getChildContext;
        let children = origProvider.apply(this, arguments); // eslint-disable-line prefer-rest-params
        if (isNew) {
            let subs = [];
            this.shouldComponentUpdate = (_props)=>{
                if (this.props.value !== _props.value) subs.forEach((c)=>{
                    c.context = _props.value;
                    c.forceUpdate();
                });
            };
            this.sub = (c)=>{
                subs.push(c);
                let old = c.componentWillUnmount;
                c.componentWillUnmount = ()=>{
                    subs.splice(subs.indexOf(c), 1);
                    old && old.call(c);
                };
            };
        }
        return children;
    };
    return ContextType;
}
class $200f5cce291452b2$export$c5d7c1ac98841e53 {
    detach() {
        this.emitter.off("_scrollRequest", this.handleScrollRequest);
    }
    update(isDatesNew) {
        if (isDatesNew && this.scrollTimeReset) this.fireInitialScroll(); // will drain
        else this.drain();
    }
    fireInitialScroll() {
        this.handleScrollRequest({
            time: this.scrollTime
        });
    }
    drain() {
        if (this.queuedRequest && this.execFunc(this.queuedRequest)) this.queuedRequest = null;
    }
    constructor(execFunc, emitter, scrollTime, scrollTimeReset){
        this.execFunc = execFunc;
        this.emitter = emitter;
        this.scrollTime = scrollTime;
        this.scrollTimeReset = scrollTimeReset;
        this.handleScrollRequest = (request)=>{
            this.queuedRequest = Object.assign({}, this.queuedRequest || {}, request);
            this.drain();
        };
        emitter.on("_scrollRequest", this.handleScrollRequest);
        this.fireInitialScroll();
    }
}
const $200f5cce291452b2$export$e7c866399fa523f5 = $200f5cce291452b2$export$995eb9fca571757({}); // for Components
function $200f5cce291452b2$export$efca4cbe5dd06740(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
    return {
        dateEnv: dateEnv,
        options: viewOptions,
        pluginHooks: pluginHooks,
        emitter: emitter,
        dispatch: dispatch,
        getCurrentData: getCurrentData,
        calendarApi: calendarApi,
        viewSpec: viewSpec,
        viewApi: viewApi,
        dateProfileGenerator: dateProfileGenerator,
        theme: theme,
        isRtl: viewOptions.direction === "rtl",
        addResizeHandler (handler) {
            emitter.on("_resize", handler);
        },
        removeResizeHandler (handler) {
            emitter.off("_resize", handler);
        },
        createScrollResponder (execFunc) {
            return new $200f5cce291452b2$export$c5d7c1ac98841e53(execFunc, emitter, $200f5cce291452b2$export$4368d992c4eafac0(viewOptions.scrollTime), viewOptions.scrollTimeReset);
        },
        registerInteractiveComponent: registerInteractiveComponent,
        unregisterInteractiveComponent: unregisterInteractiveComponent
    };
}
/* eslint max-classes-per-file: off */ class $200f5cce291452b2$export$6559d589eb85fbb6 extends (0, $f652a0e37ee35e91$export$16fa2f45be04daa8) {
    shouldComponentUpdate(nextProps, nextState) {
        if (this.debug) // eslint-disable-next-line no-console
        console.log($200f5cce291452b2$var$getUnequalProps(nextProps, this.props), $200f5cce291452b2$var$getUnequalProps(nextState, this.state));
        return !$200f5cce291452b2$export$23ebac1979863676(this.props, nextProps, this.propEquality) || !$200f5cce291452b2$export$23ebac1979863676(this.state, nextState, this.stateEquality);
    }
    // HACK for freakin' React StrictMode
    safeSetState(newState) {
        if (!$200f5cce291452b2$export$23ebac1979863676(this.state, Object.assign(Object.assign({}, this.state), newState), this.stateEquality)) this.setState(newState);
    }
}
$200f5cce291452b2$export$6559d589eb85fbb6.addPropsEquality = $200f5cce291452b2$var$addPropsEquality;
$200f5cce291452b2$export$6559d589eb85fbb6.addStateEquality = $200f5cce291452b2$var$addStateEquality;
$200f5cce291452b2$export$6559d589eb85fbb6.contextType = $200f5cce291452b2$export$e7c866399fa523f5;
$200f5cce291452b2$export$6559d589eb85fbb6.prototype.propEquality = {};
$200f5cce291452b2$export$6559d589eb85fbb6.prototype.stateEquality = {};
class $200f5cce291452b2$export$ef35774e6d314e91 extends $200f5cce291452b2$export$6559d589eb85fbb6 {
}
$200f5cce291452b2$export$ef35774e6d314e91.contextType = $200f5cce291452b2$export$e7c866399fa523f5;
function $200f5cce291452b2$var$addPropsEquality(propEquality) {
    let hash = Object.create(this.prototype.propEquality);
    Object.assign(hash, propEquality);
    this.prototype.propEquality = hash;
}
function $200f5cce291452b2$var$addStateEquality(stateEquality) {
    let hash = Object.create(this.prototype.stateEquality);
    Object.assign(hash, stateEquality);
    this.prototype.stateEquality = hash;
}
// use other one
function $200f5cce291452b2$export$8743009a87fcb00f(ref, current) {
    if (typeof ref === "function") ref(current);
    else if (ref) // see https://github.com/facebook/react/issues/13029
    ref.current = current;
}
/*
an INTERACTABLE date component

PURPOSES:
- hook up to fg, fill, and mirror renderers
- interface for dragging and hits
*/ class $200f5cce291452b2$export$51b138e5a065c2bb extends $200f5cce291452b2$export$ef35774e6d314e91 {
    // Hit System
    // -----------------------------------------------------------------------------------------------------------------
    prepareHits() {}
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        return null; // this should be abstract
    }
    // Pointer Interaction Utils
    // -----------------------------------------------------------------------------------------------------------------
    isValidSegDownEl(el) {
        return !this.props.eventDrag && // HACK
        !this.props.eventResize && // HACK
        !$200f5cce291452b2$export$3d8c2f653ac9d0b9(el, ".fc-event-mirror");
    }
    isValidDateDownEl(el) {
        return !$200f5cce291452b2$export$3d8c2f653ac9d0b9(el, ".fc-event:not(.fc-bg-event)") && !$200f5cce291452b2$export$3d8c2f653ac9d0b9(el, ".fc-more-link") && // a "more.." link
        !$200f5cce291452b2$export$3d8c2f653ac9d0b9(el, "a[data-navlink]") && // a clickable nav link
        !$200f5cce291452b2$export$3d8c2f653ac9d0b9(el, ".fc-popover"); // hack
    }
    constructor(){
        super(...arguments);
        this.uid = $200f5cce291452b2$export$39b482c5e57630a8();
    }
}
function $200f5cce291452b2$export$b4171a6734a65d42(currentDate, action) {
    switch(action.type){
        case "CHANGE_DATE":
            return action.dateMarker;
        default:
            return currentDate;
    }
}
function $200f5cce291452b2$export$2329c99376c9d0a4(options, dateEnv) {
    let initialDateInput = options.initialDate;
    // compute the initial ambig-timezone date
    if (initialDateInput != null) return dateEnv.createMarker(initialDateInput);
    return $200f5cce291452b2$export$c3950d9923825c02(options.now, dateEnv); // getNow already returns unzoned
}
function $200f5cce291452b2$export$c3950d9923825c02(nowInput, dateEnv) {
    if (typeof nowInput === "function") nowInput = nowInput();
    if (nowInput == null) return dateEnv.createNowMarker();
    return dateEnv.createMarker(nowInput);
}
class $200f5cce291452b2$export$3a6d5c9ae78a2c08 {
    /* Date Range Computation
    ------------------------------------------------------------------------------------------------------------------*/ // Builds a structure with info about what the dates/ranges will be for the "prev" view.
    buildPrev(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(prevDate, -1, forceToValid);
    }
    // Builds a structure with info about what the dates/ranges will be for the "next" view.
    buildNext(currentDateProfile, currentDate, forceToValid) {
        let { dateEnv: dateEnv } = this.props;
        let nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), currentDateProfile.dateIncrement);
        return this.build(nextDate, 1, forceToValid);
    }
    // Builds a structure holding dates/ranges for rendering around the given date.
    // Optional direction param indicates whether the date is being incremented/decremented
    // from its previous value. decremented = -1, incremented = 1 (default).
    build(currentDate, direction, forceToValid = true) {
        let { props: props } = this;
        let validRange;
        let currentInfo;
        let isRangeAllDay;
        let renderRange;
        let activeRange;
        let isValid;
        validRange = this.buildValidRange();
        validRange = this.trimHiddenDays(validRange);
        if (forceToValid) currentDate = $200f5cce291452b2$var$constrainMarkerToRange(currentDate, validRange);
        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
        renderRange = this.trimHiddenDays(renderRange);
        activeRange = renderRange;
        if (!props.showNonCurrentDates) activeRange = $200f5cce291452b2$export$ae1af26003f05816(activeRange, currentInfo.range);
        activeRange = this.adjustActiveRange(activeRange);
        activeRange = $200f5cce291452b2$export$ae1af26003f05816(activeRange, validRange); // might return null
        // it's invalid if the originally requested date is not contained,
        // or if the range is completely outside of the valid range.
        isValid = $200f5cce291452b2$export$ad4aebacdcaf47f8(currentInfo.range, validRange);
        // HACK: constrain to render-range so `currentDate` is more useful to view rendering
        if (!$200f5cce291452b2$export$7f8ddf7c7c20b3cd(renderRange, currentDate)) currentDate = renderRange.start;
        return {
            currentDate: currentDate,
            validRange: // constraint for where prev/next operations can go and where events can be dragged/resized to.
            // an object with optional start and end properties.
            validRange,
            // range the view is formally responsible for.
            // for example, a month view might have 1st-31st, excluding padded dates
            currentRange: currentInfo.range,
            // name of largest unit being displayed, like "month" or "week"
            currentRangeUnit: currentInfo.unit,
            isRangeAllDay: isRangeAllDay,
            activeRange: // dates that display events and accept drag-n-drop
            // will be `null` if no dates accept events
            activeRange,
            renderRange: // date range with a rendered skeleton
            // includes not-active days that need some sort of DOM
            renderRange,
            // Duration object that denotes the first visible time of any given day
            slotMinTime: props.slotMinTime,
            // Duration object that denotes the exclusive visible end time of any given day
            slotMaxTime: props.slotMaxTime,
            isValid: isValid,
            // how far the current date will move for a prev/next operation
            dateIncrement: this.buildDateIncrement(currentInfo.duration)
        };
    }
    // Builds an object with optional start/end properties.
    // Indicates the minimum/maximum dates to display.
    // not responsible for trimming hidden days.
    buildValidRange() {
        let input = this.props.validRangeInput;
        let simpleInput = typeof input === "function" ? input.call(this.props.calendarApi, this.nowDate) : input;
        return this.refineRange(simpleInput) || {
            start: null,
            end: null
        }; // completely open-ended
    }
    // Builds a structure with info about the "current" range, the range that is
    // highlighted as being the current month for example.
    // See build() for a description of `direction`.
    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
    buildCurrentRangeInfo(date, direction) {
        let { props: props } = this;
        let duration = null;
        let unit = null;
        let range = null;
        let dayCount;
        if (props.duration) {
            duration = props.duration;
            unit = props.durationUnit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        } else if (dayCount = this.props.dayCount) {
            unit = "day";
            range = this.buildRangeFromDayCount(date, direction, dayCount);
        } else if (range = this.buildCustomVisibleRange(date)) unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
        else {
            duration = this.getFallbackDuration();
            unit = $200f5cce291452b2$export$db3b6bfb95261072(duration).unit;
            range = this.buildRangeFromDuration(date, direction, duration, unit);
        }
        return {
            duration: duration,
            unit: unit,
            range: range
        };
    }
    getFallbackDuration() {
        return $200f5cce291452b2$export$4368d992c4eafac0({
            day: 1
        });
    }
    // Returns a new activeRange to have time values (un-ambiguate)
    // slotMinTime or slotMaxTime causes the range to expand.
    adjustActiveRange(range) {
        let { dateEnv: dateEnv, usesMinMaxTime: usesMinMaxTime, slotMinTime: slotMinTime, slotMaxTime: slotMaxTime } = this.props;
        let { start: start, end: end } = range;
        if (usesMinMaxTime) {
            // expand active range if slotMinTime is negative (why not when positive?)
            if ($200f5cce291452b2$var$asRoughDays(slotMinTime) < 0) {
                start = $200f5cce291452b2$export$9e5f44173e64f162(start); // necessary?
                start = dateEnv.add(start, slotMinTime);
            }
            // expand active range if slotMaxTime is beyond one day (why not when negative?)
            if ($200f5cce291452b2$var$asRoughDays(slotMaxTime) > 1) {
                end = $200f5cce291452b2$export$9e5f44173e64f162(end); // necessary?
                end = $200f5cce291452b2$export$625550452a3fa3ec(end, -1);
                end = dateEnv.add(end, slotMaxTime);
            }
        }
        return {
            start: start,
            end: end
        };
    }
    // Builds the "current" range when it is specified as an explicit duration.
    // `unit` is the already-computed greatestDurationDenominator unit of duration.
    buildRangeFromDuration(date, direction, duration, unit) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let start;
        let end;
        let res;
        // compute what the alignment should be
        if (!dateAlignment) {
            let { dateIncrement: dateIncrement } = this.props;
            if (dateIncrement) {
                // use the smaller of the two units
                if ($200f5cce291452b2$export$4e222d082f82ee97(dateIncrement) < $200f5cce291452b2$export$4e222d082f82ee97(duration)) dateAlignment = $200f5cce291452b2$export$db3b6bfb95261072(dateIncrement).unit;
                else dateAlignment = unit;
            } else dateAlignment = unit;
        }
        // if the view displays a single day or smaller
        if ($200f5cce291452b2$var$asRoughDays(duration) <= 1) {
            if (this.isHiddenDay(start)) {
                start = this.skipHiddenDays(start, direction);
                start = $200f5cce291452b2$export$9e5f44173e64f162(start);
            }
        }
        function computeRes() {
            start = dateEnv.startOf(date, dateAlignment);
            end = dateEnv.add(start, duration);
            res = {
                start: start,
                end: end
            };
        }
        computeRes();
        // if range is completely enveloped by hidden days, go past the hidden days
        if (!this.trimHiddenDays(res)) {
            date = this.skipHiddenDays(date, direction);
            computeRes();
        }
        return res;
    }
    // Builds the "current" range when a dayCount is specified.
    buildRangeFromDayCount(date, direction, dayCount) {
        let { dateEnv: dateEnv, dateAlignment: dateAlignment } = this.props;
        let runningCount = 0;
        let start = date;
        let end;
        if (dateAlignment) start = dateEnv.startOf(start, dateAlignment);
        start = $200f5cce291452b2$export$9e5f44173e64f162(start);
        start = this.skipHiddenDays(start, direction);
        end = start;
        do {
            end = $200f5cce291452b2$export$625550452a3fa3ec(end, 1);
            if (!this.isHiddenDay(end)) runningCount += 1;
        }while (runningCount < dayCount);
        return {
            start: start,
            end: end
        };
    }
    // Builds a normalized range object for the "visible" range,
    // which is a way to define the currentRange and activeRange at the same time.
    buildCustomVisibleRange(date) {
        let { props: props } = this;
        let input = props.visibleRangeInput;
        let simpleInput = typeof input === "function" ? input.call(props.calendarApi, props.dateEnv.toDate(date)) : input;
        let range = this.refineRange(simpleInput);
        if (range && (range.start == null || range.end == null)) return null;
        return range;
    }
    // Computes the range that will represent the element/cells for *rendering*,
    // but which may have voided days/times.
    // not responsible for trimming hidden days.
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        return currentRange;
    }
    // Compute the duration value that should be added/substracted to the current date
    // when a prev/next operation happens.
    buildDateIncrement(fallback) {
        let { dateIncrement: dateIncrement } = this.props;
        let customAlignment;
        if (dateIncrement) return dateIncrement;
        if (customAlignment = this.props.dateAlignment) return $200f5cce291452b2$export$4368d992c4eafac0(1, customAlignment);
        if (fallback) return fallback;
        return $200f5cce291452b2$export$4368d992c4eafac0({
            days: 1
        });
    }
    refineRange(rangeInput) {
        if (rangeInput) {
            let range = $200f5cce291452b2$var$parseRange(rangeInput, this.props.dateEnv);
            if (range) range = $200f5cce291452b2$export$28f7fcd39efa255(range);
            return range;
        }
        return null;
    }
    /* Hidden Days
    ------------------------------------------------------------------------------------------------------------------*/ // Initializes internal variables related to calculating hidden days-of-week
    initHiddenDays() {
        let hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
        let isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
        let dayCnt = 0;
        let i;
        if (this.props.weekends === false) hiddenDays.push(0, 6); // 0=sunday, 6=saturday
        for(i = 0; i < 7; i += 1)if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) dayCnt += 1;
        if (!dayCnt) throw new Error("invalid hiddenDays"); // all days were hidden? bad.
        this.isHiddenDayHash = isHiddenDayHash;
    }
    // Remove days from the beginning and end of the range that are computed as hidden.
    // If the whole range is trimmed off, returns null
    trimHiddenDays(range) {
        let { start: start, end: end } = range;
        if (start) start = this.skipHiddenDays(start);
        if (end) end = this.skipHiddenDays(end, -1, true);
        if (start == null || end == null || start < end) return {
            start: start,
            end: end
        };
        return null;
    }
    // Is the current day hidden?
    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
    isHiddenDay(day) {
        if (day instanceof Date) day = day.getUTCDay();
        return this.isHiddenDayHash[day];
    }
    // Incrementing the current day until it is no longer a hidden day, returning a copy.
    // DOES NOT CONSIDER validRange!
    // If the initial value of `date` is not a hidden day, don't do anything.
    // Pass `isExclusive` as `true` if you are dealing with an end date.
    // `inc` defaults to `1` (increment one day forward each time)
    skipHiddenDays(date, inc = 1, isExclusive = false) {
        while(this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7])date = $200f5cce291452b2$export$625550452a3fa3ec(date, inc);
        return date;
    }
    constructor(props){
        this.props = props;
        this.nowDate = $200f5cce291452b2$export$c3950d9923825c02(props.nowInput, props.dateEnv);
        this.initHiddenDays();
    }
}
function $200f5cce291452b2$export$9ddbdd0bfc5623a(selection, pev, context) {
    context.emitter.trigger("select", Object.assign(Object.assign({}, $200f5cce291452b2$var$buildDateSpanApiWithContext(selection, context)), {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    }));
}
function $200f5cce291452b2$var$triggerDateUnselect(pev, context) {
    context.emitter.trigger("unselect", {
        jsEvent: pev ? pev.origEvent : null,
        view: context.viewApi || context.calendarApi.view
    });
}
function $200f5cce291452b2$var$buildDateSpanApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.dateSpanTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $200f5cce291452b2$var$buildDateSpanApi(dateSpan, context.dateEnv));
    return props;
}
// Given an event's allDay status and start date, return what its fallback end date should be.
// TODO: rename to computeDefaultEventEnd
function $200f5cce291452b2$export$1776704b6532a19a(allDay, marker, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let end = marker;
    if (allDay) {
        end = $200f5cce291452b2$export$9e5f44173e64f162(end);
        end = dateEnv.add(end, options.defaultAllDayEventDuration);
    } else end = dateEnv.add(end, options.defaultTimedEventDuration);
    return end;
}
// applies the mutation to ALL defs/instances within the event store
function $200f5cce291452b2$export$6d1e945284085e64(eventStore, eventConfigBase, mutation, context) {
    let eventConfigs = $200f5cce291452b2$var$compileEventUis(eventStore.defs, eventConfigBase);
    let dest = $200f5cce291452b2$export$9bb611d729802a56();
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        dest.defs[defId] = $200f5cce291452b2$var$applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = dest.defs[instance.defId]; // important to grab the newly modified def
        dest.instances[instanceId] = $200f5cce291452b2$var$applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
    }
    return dest;
}
function $200f5cce291452b2$var$applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
    let standardProps = mutation.standardProps || {};
    // if hasEnd has not been specified, guess a good value based on deltas.
    // if duration will change, there's no way the default duration will persist,
    // and thus, we need to mark the event as having a real end
    if (standardProps.hasEnd == null && eventConfig.durationEditable && (mutation.startDelta || mutation.endDelta)) standardProps.hasEnd = true; // TODO: is this mutation okay?
    let copy = Object.assign(Object.assign(Object.assign({}, eventDef), standardProps), {
        ui: Object.assign(Object.assign({}, eventDef.ui), standardProps.ui)
    });
    if (mutation.extendedProps) copy.extendedProps = Object.assign(Object.assign({}, copy.extendedProps), mutation.extendedProps);
    for (let applier of context.pluginHooks.eventDefMutationAppliers)applier(copy, mutation, context);
    if (!copy.hasEnd && context.options.forceEventDuration) copy.hasEnd = true;
    return copy;
}
function $200f5cce291452b2$var$applyMutationToEventInstance(eventInstance, eventDef, eventConfig, mutation, context) {
    let { dateEnv: dateEnv } = context;
    let forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
    let clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
    let copy = Object.assign({}, eventInstance);
    if (forceAllDay) copy.range = $200f5cce291452b2$var$computeAlignedDayRange(copy.range);
    if (mutation.datesDelta && eventConfig.startEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.datesDelta),
        end: dateEnv.add(copy.range.end, mutation.datesDelta)
    };
    if (mutation.startDelta && eventConfig.durationEditable) copy.range = {
        start: dateEnv.add(copy.range.start, mutation.startDelta),
        end: copy.range.end
    };
    if (mutation.endDelta && eventConfig.durationEditable) copy.range = {
        start: copy.range.start,
        end: dateEnv.add(copy.range.end, mutation.endDelta)
    };
    if (clearEnd) copy.range = {
        start: copy.range.start,
        end: $200f5cce291452b2$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context)
    };
    // in case event was all-day but the supplied deltas were not
    // better util for this?
    if (eventDef.allDay) copy.range = {
        start: $200f5cce291452b2$export$9e5f44173e64f162(copy.range.start),
        end: $200f5cce291452b2$export$9e5f44173e64f162(copy.range.end)
    };
    // handle invalid durations
    if (copy.range.end < copy.range.start) copy.range.end = $200f5cce291452b2$export$1776704b6532a19a(eventDef.allDay, copy.range.start, context);
    return copy;
}
class $200f5cce291452b2$var$EventSourceImpl {
    remove() {
        this.context.dispatch({
            type: "REMOVE_EVENT_SOURCE",
            sourceId: this.internalEventSource.sourceId
        });
    }
    refetch() {
        this.context.dispatch({
            type: "FETCH_EVENT_SOURCES",
            sourceIds: [
                this.internalEventSource.sourceId
            ],
            isRefetch: true
        });
    }
    get id() {
        return this.internalEventSource.publicId;
    }
    get url() {
        return this.internalEventSource.meta.url;
    }
    get format() {
        return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
    }
    constructor(context, internalEventSource){
        this.context = context;
        this.internalEventSource = internalEventSource;
    }
}
class $200f5cce291452b2$export$34aec0b863436764 {
    /*
    TODO: make event struct more responsible for this
    */ setProp(name, val) {
        if (name in $200f5cce291452b2$var$EVENT_DATE_REFINERS) console.warn("Could not set date-related prop 'name'. Use one of the date-related methods instead.");
        else if (name === "id") {
            val = $200f5cce291452b2$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    publicId: val
                }
            });
        } else if (name in $200f5cce291452b2$var$EVENT_NON_DATE_REFINERS) {
            val = $200f5cce291452b2$var$EVENT_NON_DATE_REFINERS[name](val);
            this.mutate({
                standardProps: {
                    [name]: val
                }
            });
        } else if (name in $200f5cce291452b2$var$EVENT_UI_REFINERS) {
            let ui = $200f5cce291452b2$var$EVENT_UI_REFINERS[name](val);
            if (name === "color") ui = {
                backgroundColor: val,
                borderColor: val
            };
            else if (name === "editable") ui = {
                startEditable: val,
                durationEditable: val
            };
            else ui = {
                [name]: val
            };
            this.mutate({
                standardProps: {
                    ui: ui
                }
            });
        } else console.warn(`Could not set prop '${name}'. Use setExtendedProp instead.`);
    }
    setExtendedProp(name, val) {
        this.mutate({
            extendedProps: {
                [name]: val
            }
        });
    }
    setStart(startInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let start = dateEnv.createMarker(startInput);
        if (start && this._instance) {
            let instanceRange = this._instance.range;
            let startDelta = $200f5cce291452b2$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
            if (options.maintainDuration) this.mutate({
                datesDelta: startDelta
            });
            else this.mutate({
                startDelta: startDelta
            });
        }
    }
    setEnd(endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let end;
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return; // TODO: warning if parsed bad
        }
        if (this._instance) {
            if (end) {
                let endDelta = $200f5cce291452b2$export$91c6e00c14e7e6fd(this._instance.range.end, end, dateEnv, options.granularity);
                this.mutate({
                    endDelta: endDelta
                });
            } else this.mutate({
                standardProps: {
                    hasEnd: false
                }
            });
        }
    }
    setDates(startInput, endInput, options = {}) {
        let { dateEnv: dateEnv } = this._context;
        let standardProps = {
            allDay: options.allDay
        };
        let start = dateEnv.createMarker(startInput);
        let end;
        if (!start) return; // TODO: warning if parsed bad
        if (endInput != null) {
            end = dateEnv.createMarker(endInput);
            if (!end) return;
        }
        if (this._instance) {
            let instanceRange = this._instance.range;
            // when computing the diff for an event being converted to all-day,
            // compute diff off of the all-day values the way event-mutation does.
            if (options.allDay === true) instanceRange = $200f5cce291452b2$var$computeAlignedDayRange(instanceRange);
            let startDelta = $200f5cce291452b2$export$91c6e00c14e7e6fd(instanceRange.start, start, dateEnv, options.granularity);
            if (end) {
                let endDelta = $200f5cce291452b2$export$91c6e00c14e7e6fd(instanceRange.end, end, dateEnv, options.granularity);
                if ($200f5cce291452b2$var$durationsEqual(startDelta, endDelta)) this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
                else this.mutate({
                    startDelta: startDelta,
                    endDelta: endDelta,
                    standardProps: standardProps
                });
            } else {
                standardProps.hasEnd = false;
                this.mutate({
                    datesDelta: startDelta,
                    standardProps: standardProps
                });
            }
        }
    }
    moveStart(deltaInput) {
        let delta = $200f5cce291452b2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            startDelta: delta
        });
    }
    moveEnd(deltaInput) {
        let delta = $200f5cce291452b2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            endDelta: delta
        });
    }
    moveDates(deltaInput) {
        let delta = $200f5cce291452b2$export$4368d992c4eafac0(deltaInput);
        if (delta) this.mutate({
            datesDelta: delta
        });
    }
    setAllDay(allDay, options = {}) {
        let standardProps = {
            allDay: allDay
        };
        let { maintainDuration: maintainDuration } = options;
        if (maintainDuration == null) maintainDuration = this._context.options.allDayMaintainDuration;
        if (this._def.allDay !== allDay) standardProps.hasEnd = maintainDuration;
        this.mutate({
            standardProps: standardProps
        });
    }
    formatRange(formatInput) {
        let { dateEnv: dateEnv } = this._context;
        let instance = this._instance;
        let formatter = $200f5cce291452b2$export$d141bba7fdc215a3(formatInput);
        if (this._def.hasEnd) return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
            forcedStartTzo: instance.forcedStartTzo,
            forcedEndTzo: instance.forcedEndTzo
        });
        return dateEnv.format(instance.range.start, formatter, {
            forcedTzo: instance.forcedStartTzo
        });
    }
    mutate(mutation) {
        let instance = this._instance;
        if (instance) {
            let def = this._def;
            let context = this._context;
            let { eventStore: eventStore } = context.getCurrentData();
            let relevantEvents = $200f5cce291452b2$export$1ee57be6f6687d2c(eventStore, instance.instanceId);
            let eventConfigBase = {
                "": {
                    display: "",
                    startEditable: true,
                    durationEditable: true,
                    constraints: [],
                    overlap: null,
                    allows: [],
                    backgroundColor: "",
                    borderColor: "",
                    textColor: "",
                    classNames: []
                }
            };
            relevantEvents = $200f5cce291452b2$export$6d1e945284085e64(relevantEvents, eventConfigBase, mutation, context);
            let oldEvent = new $200f5cce291452b2$export$34aec0b863436764(context, def, instance); // snapshot
            this._def = relevantEvents.defs[def.defId];
            this._instance = relevantEvents.instances[instance.instanceId];
            context.dispatch({
                type: "MERGE_EVENTS",
                eventStore: relevantEvents
            });
            context.emitter.trigger("eventChange", {
                oldEvent: oldEvent,
                event: this,
                relatedEvents: $200f5cce291452b2$export$efccba1c4a2ef57b(relevantEvents, context, instance),
                revert () {
                    context.dispatch({
                        type: "RESET_EVENTS",
                        eventStore: eventStore
                    });
                }
            });
        }
    }
    remove() {
        let context = this._context;
        let asStore = $200f5cce291452b2$var$eventApiToStore(this);
        context.dispatch({
            type: "REMOVE_EVENTS",
            eventStore: asStore
        });
        context.emitter.trigger("eventRemove", {
            event: this,
            relatedEvents: [],
            revert () {
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: asStore
                });
            }
        });
    }
    get source() {
        let { sourceId: sourceId } = this._def;
        if (sourceId) return new $200f5cce291452b2$var$EventSourceImpl(this._context, this._context.getCurrentData().eventSources[sourceId]);
        return null;
    }
    get start() {
        return this._instance ? this._context.dateEnv.toDate(this._instance.range.start) : null;
    }
    get end() {
        return this._instance && this._def.hasEnd ? this._context.dateEnv.toDate(this._instance.range.end) : null;
    }
    get startStr() {
        let instance = this._instance;
        if (instance) return this._context.dateEnv.formatIso(instance.range.start, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedStartTzo
        });
        return "";
    }
    get endStr() {
        let instance = this._instance;
        if (instance && this._def.hasEnd) return this._context.dateEnv.formatIso(instance.range.end, {
            omitTime: this._def.allDay,
            forcedTzo: instance.forcedEndTzo
        });
        return "";
    }
    // computable props that all access the def
    // TODO: find a TypeScript-compatible way to do this at scale
    get id() {
        return this._def.publicId;
    }
    get groupId() {
        return this._def.groupId;
    }
    get allDay() {
        return this._def.allDay;
    }
    get title() {
        return this._def.title;
    }
    get url() {
        return this._def.url;
    }
    get display() {
        return this._def.ui.display || "auto";
    }
    get startEditable() {
        return this._def.ui.startEditable;
    }
    get durationEditable() {
        return this._def.ui.durationEditable;
    }
    get constraint() {
        return this._def.ui.constraints[0] || null;
    }
    get overlap() {
        return this._def.ui.overlap;
    }
    get allow() {
        return this._def.ui.allows[0] || null;
    }
    get backgroundColor() {
        return this._def.ui.backgroundColor;
    }
    get borderColor() {
        return this._def.ui.borderColor;
    }
    get textColor() {
        return this._def.ui.textColor;
    }
    // NOTE: user can't modify these because Object.freeze was called in event-def parsing
    get classNames() {
        return this._def.ui.classNames;
    }
    get extendedProps() {
        return this._def.extendedProps;
    }
    toPlainObject(settings = {}) {
        let def = this._def;
        let { ui: ui } = def;
        let { startStr: startStr, endStr: endStr } = this;
        let res = {
            allDay: def.allDay
        };
        if (def.title) res.title = def.title;
        if (startStr) res.start = startStr;
        if (endStr) res.end = endStr;
        if (def.publicId) res.id = def.publicId;
        if (def.groupId) res.groupId = def.groupId;
        if (def.url) res.url = def.url;
        if (ui.display && ui.display !== "auto") res.display = ui.display;
        // TODO: what about recurring-event properties???
        // TODO: include startEditable/durationEditable/constraint/overlap/allow
        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) res.color = ui.backgroundColor;
        else {
            if (ui.backgroundColor) res.backgroundColor = ui.backgroundColor;
            if (ui.borderColor) res.borderColor = ui.borderColor;
        }
        if (ui.textColor) res.textColor = ui.textColor;
        if (ui.classNames.length) res.classNames = ui.classNames;
        if (Object.keys(def.extendedProps).length) {
            if (settings.collapseExtendedProps) Object.assign(res, def.extendedProps);
            else res.extendedProps = def.extendedProps;
        }
        return res;
    }
    toJSON() {
        return this.toPlainObject();
    }
    // instance will be null if expressing a recurring event that has no current instances,
    // OR if trying to validate an incoming external event that has no dates assigned
    constructor(context, def, instance){
        this._context = context;
        this._def = def;
        this._instance = instance || null;
    }
}
function $200f5cce291452b2$var$eventApiToStore(eventApi) {
    let def = eventApi._def;
    let instance = eventApi._instance;
    return {
        defs: {
            [def.defId]: def
        },
        instances: instance ? {
            [instance.instanceId]: instance
        } : {}
    };
}
function $200f5cce291452b2$export$efccba1c4a2ef57b(eventStore, context, excludeInstance) {
    let { defs: defs, instances: instances } = eventStore;
    let eventApis = [];
    let excludeInstanceId = excludeInstance ? excludeInstance.instanceId : "";
    for(let id in instances){
        let instance = instances[id];
        let def = defs[instance.defId];
        if (instance.instanceId !== excludeInstanceId) eventApis.push(new $200f5cce291452b2$export$34aec0b863436764(context, def, instance));
    }
    return eventApis;
}
/*
Specifying nextDayThreshold signals that all-day ranges should be sliced.
*/ function $200f5cce291452b2$export$c9170ad7d4cd7e57(eventStore, eventUiBases, framingRange, nextDayThreshold) {
    let inverseBgByGroupId = {};
    let inverseBgByDefId = {};
    let defByGroupId = {};
    let bgRanges = [];
    let fgRanges = [];
    let eventUis = $200f5cce291452b2$var$compileEventUis(eventStore.defs, eventUiBases);
    for(let defId in eventStore.defs){
        let def = eventStore.defs[defId];
        let ui = eventUis[def.defId];
        if (ui.display === "inverse-background") {
            if (def.groupId) {
                inverseBgByGroupId[def.groupId] = [];
                if (!defByGroupId[def.groupId]) defByGroupId[def.groupId] = def;
            } else inverseBgByDefId[defId] = [];
        }
    }
    for(let instanceId in eventStore.instances){
        let instance = eventStore.instances[instanceId];
        let def = eventStore.defs[instance.defId];
        let ui = eventUis[def.defId];
        let origRange = instance.range;
        let normalRange = !def.allDay && nextDayThreshold ? $200f5cce291452b2$export$28f7fcd39efa255(origRange, nextDayThreshold) : origRange;
        let slicedRange = $200f5cce291452b2$export$ae1af26003f05816(normalRange, framingRange);
        if (slicedRange) {
            if (ui.display === "inverse-background") {
                if (def.groupId) inverseBgByGroupId[def.groupId].push(slicedRange);
                else inverseBgByDefId[instance.defId].push(slicedRange);
            } else if (ui.display !== "none") (ui.display === "background" ? bgRanges : fgRanges).push({
                def: def,
                ui: ui,
                instance: instance,
                range: slicedRange,
                isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
                isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf()
            });
        }
    }
    for(let groupId in inverseBgByGroupId){
        let ranges = inverseBgByGroupId[groupId];
        let invertedRanges = $200f5cce291452b2$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges){
            let def = defByGroupId[groupId];
            let ui = eventUis[def.defId];
            bgRanges.push({
                def: def,
                ui: ui,
                instance: null,
                range: invertedRange,
                isStart: false,
                isEnd: false
            });
        }
    }
    for(let defId in inverseBgByDefId){
        let ranges = inverseBgByDefId[defId];
        let invertedRanges = $200f5cce291452b2$var$invertRanges(ranges, framingRange);
        for (let invertedRange of invertedRanges)bgRanges.push({
            def: eventStore.defs[defId],
            ui: eventUis[defId],
            instance: null,
            range: invertedRange,
            isStart: false,
            isEnd: false
        });
    }
    return {
        bg: bgRanges,
        fg: fgRanges
    };
}
function $200f5cce291452b2$export$a91cd623adc48128(def) {
    return def.ui.display === "background" || def.ui.display === "inverse-background";
}
function $200f5cce291452b2$var$setElSeg(el, seg) {
    el.fcSeg = seg;
}
function $200f5cce291452b2$export$71511d61b312f219(el) {
    return el.fcSeg || el.parentNode.fcSeg || // for the harness
    null;
}
// event ui computation
function $200f5cce291452b2$var$compileEventUis(eventDefs, eventUiBases) {
    return $200f5cce291452b2$export$407448d2b89b1813(eventDefs, (eventDef)=>$200f5cce291452b2$var$compileEventUi(eventDef, eventUiBases));
}
function $200f5cce291452b2$var$compileEventUi(eventDef, eventUiBases) {
    let uis = [];
    if (eventUiBases[""]) uis.push(eventUiBases[""]);
    if (eventUiBases[eventDef.defId]) uis.push(eventUiBases[eventDef.defId]);
    uis.push(eventDef.ui);
    return $200f5cce291452b2$export$1a8f5705751d8277(uis);
}
function $200f5cce291452b2$export$4d522598b426bb73(segs, eventOrderSpecs) {
    let objs = segs.map($200f5cce291452b2$var$buildSegCompareObj);
    objs.sort((obj0, obj1)=>$200f5cce291452b2$export$2f6ca3d3b1f80bf5(obj0, obj1, eventOrderSpecs));
    return objs.map((c)=>c._seg);
}
// returns a object with all primitive props that can be compared
function $200f5cce291452b2$var$buildSegCompareObj(seg) {
    let { eventRange: eventRange } = seg;
    let eventDef = eventRange.def;
    let range = eventRange.instance ? eventRange.instance.range : eventRange.range;
    let start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
    let end = range.end ? range.end.valueOf() : 0; // "
    return Object.assign(Object.assign(Object.assign({}, eventDef.extendedProps), eventDef), {
        id: eventDef.publicId,
        start: start,
        end: end,
        duration: end - start,
        allDay: Number(eventDef.allDay),
        _seg: seg
    });
}
function $200f5cce291452b2$var$computeSegDraggable(seg, context) {
    let { pluginHooks: pluginHooks } = context;
    let transformers = pluginHooks.isDraggableTransformers;
    let { def: def, ui: ui } = seg.eventRange;
    let val = ui.startEditable;
    for (let transformer of transformers)val = transformer(val, def, ui, context);
    return val;
}
function $200f5cce291452b2$var$computeSegStartResizable(seg, context) {
    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
}
function $200f5cce291452b2$var$computeSegEndResizable(seg, context) {
    return seg.isEnd && seg.eventRange.ui.durationEditable;
}
function $200f5cce291452b2$export$993a080e5cb62d74(seg, timeFormat, context, defaultDisplayEventTime, defaultDisplayEventEnd, startOverride, endOverride) {
    let { dateEnv: dateEnv, options: options } = context;
    let { displayEventTime: displayEventTime, displayEventEnd: displayEventEnd } = options;
    let eventDef = seg.eventRange.def;
    let eventInstance = seg.eventRange.instance;
    if (displayEventTime == null) displayEventTime = defaultDisplayEventTime !== false;
    if (displayEventEnd == null) displayEventEnd = defaultDisplayEventEnd !== false;
    let wholeEventStart = eventInstance.range.start;
    let wholeEventEnd = eventInstance.range.end;
    let segStart = startOverride || seg.start || seg.eventRange.range.start;
    let segEnd = endOverride || seg.end || seg.eventRange.range.end;
    let isStartDay = $200f5cce291452b2$export$9e5f44173e64f162(wholeEventStart).valueOf() === $200f5cce291452b2$export$9e5f44173e64f162(segStart).valueOf();
    let isEndDay = $200f5cce291452b2$export$9e5f44173e64f162($200f5cce291452b2$export$136fd86de524d3c2(wholeEventEnd, -1)).valueOf() === $200f5cce291452b2$export$9e5f44173e64f162($200f5cce291452b2$export$136fd86de524d3c2(segEnd, -1)).valueOf();
    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
        segStart = isStartDay ? wholeEventStart : segStart;
        segEnd = isEndDay ? wholeEventEnd : segEnd;
        if (displayEventEnd && eventDef.hasEnd) return dateEnv.formatRange(segStart, segEnd, timeFormat, {
            forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
            forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo
        });
        return dateEnv.format(segStart, timeFormat, {
            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo
        });
    }
    return "";
}
function $200f5cce291452b2$export$6dabbe08653f866f(seg, todayRange, nowDate) {
    let segRange = seg.eventRange.range;
    return {
        isPast: segRange.end < (nowDate || todayRange.start),
        isFuture: segRange.start >= (nowDate || todayRange.end),
        isToday: todayRange && $200f5cce291452b2$export$7f8ddf7c7c20b3cd(todayRange, segRange.start)
    };
}
function $200f5cce291452b2$var$getEventClassNames(props) {
    let classNames = [
        "fc-event"
    ];
    if (props.isMirror) classNames.push("fc-event-mirror");
    if (props.isDraggable) classNames.push("fc-event-draggable");
    if (props.isStartResizable || props.isEndResizable) classNames.push("fc-event-resizable");
    if (props.isDragging) classNames.push("fc-event-dragging");
    if (props.isResizing) classNames.push("fc-event-resizing");
    if (props.isSelected) classNames.push("fc-event-selected");
    if (props.isStart) classNames.push("fc-event-start");
    if (props.isEnd) classNames.push("fc-event-end");
    if (props.isPast) classNames.push("fc-event-past");
    if (props.isToday) classNames.push("fc-event-today");
    if (props.isFuture) classNames.push("fc-event-future");
    return classNames;
}
function $200f5cce291452b2$export$1314441b8d04e1d5(eventRange) {
    return eventRange.instance ? eventRange.instance.instanceId : `${eventRange.def.defId}:${eventRange.range.start.toISOString()}`;
// inverse-background events don't have specific instances. TODO: better solution
}
function $200f5cce291452b2$export$e0c3a065614c6254(seg, context) {
    let { def: def, instance: instance } = seg.eventRange;
    let { url: url } = def;
    if (url) return {
        href: url
    };
    let { emitter: emitter, options: options } = context;
    let { eventInteractive: eventInteractive } = options;
    if (eventInteractive == null) {
        eventInteractive = def.interactive;
        if (eventInteractive == null) eventInteractive = Boolean(emitter.hasHandlers("eventClick"));
    }
    // mock what happens in EventClicking
    if (eventInteractive) // only attach keyboard-related handlers because click handler is already done in EventClicking
    return $200f5cce291452b2$var$createAriaKeyboardAttrs((ev)=>{
        emitter.trigger("eventClick", {
            el: ev.target,
            event: new $200f5cce291452b2$export$34aec0b863436764(context, def, instance),
            jsEvent: ev,
            view: context.viewApi
        });
    });
    return {};
}
const $200f5cce291452b2$var$STANDARD_PROPS = {
    start: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    end: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    allDay: Boolean
};
function $200f5cce291452b2$var$parseDateSpan(raw, dateEnv, defaultDuration) {
    let span = $200f5cce291452b2$var$parseOpenDateSpan(raw, dateEnv);
    let { range: range } = span;
    if (!range.start) return null;
    if (!range.end) {
        if (defaultDuration == null) return null;
        range.end = dateEnv.add(range.start, defaultDuration);
    }
    return span;
}
/*
TODO: somehow combine with parseRange?
Will return null if the start/end props were present but parsed invalidly.
*/ function $200f5cce291452b2$var$parseOpenDateSpan(raw, dateEnv) {
    let { refined: standardProps, extra: extra } = $200f5cce291452b2$export$f38c853ae54ed474(raw, $200f5cce291452b2$var$STANDARD_PROPS);
    let startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
    let endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
    let { allDay: allDay } = standardProps;
    if (allDay == null) allDay = startMeta && startMeta.isTimeUnspecified && (!endMeta || endMeta.isTimeUnspecified);
    return Object.assign({
        range: {
            start: startMeta ? startMeta.marker : null,
            end: endMeta ? endMeta.marker : null
        },
        allDay: allDay
    }, extra);
}
function $200f5cce291452b2$export$151db275011178c4(span0, span1) {
    return $200f5cce291452b2$export$f074adc9fbd50943(span0.range, span1.range) && span0.allDay === span1.allDay && $200f5cce291452b2$var$isSpanPropsEqual(span0, span1);
}
// the NON-DATE-RELATED props
function $200f5cce291452b2$var$isSpanPropsEqual(span0, span1) {
    for(let propName in span1)if (propName !== "range" && propName !== "allDay") {
        if (span0[propName] !== span1[propName]) return false;
    }
    // are there any props that span0 has that span1 DOESN'T have?
    // both have range/allDay, so no need to special-case.
    for(let propName in span0){
        if (!(propName in span1)) return false;
    }
    return true;
}
function $200f5cce291452b2$var$buildDateSpanApi(span, dateEnv) {
    return Object.assign(Object.assign({}, $200f5cce291452b2$var$buildRangeApi(span.range, dateEnv, span.allDay)), {
        allDay: span.allDay
    });
}
function $200f5cce291452b2$export$882b5998b3b9117c(range, dateEnv, omitTime) {
    return Object.assign(Object.assign({}, $200f5cce291452b2$var$buildRangeApi(range, dateEnv, omitTime)), {
        timeZone: dateEnv.timeZone
    });
}
function $200f5cce291452b2$var$buildRangeApi(range, dateEnv, omitTime) {
    return {
        start: dateEnv.toDate(range.start),
        end: dateEnv.toDate(range.end),
        startStr: dateEnv.formatIso(range.start, {
            omitTime: omitTime
        }),
        endStr: dateEnv.formatIso(range.end, {
            omitTime: omitTime
        })
    };
}
function $200f5cce291452b2$var$fabricateEventRange(dateSpan, eventUiBases, context) {
    let res = $200f5cce291452b2$export$ab83b03e4111b1d0({
        editable: false
    }, context);
    let def = $200f5cce291452b2$export$21579262ef46735b(res.refined, res.extra, "", dateSpan.allDay, true, context);
    return {
        def: def,
        ui: $200f5cce291452b2$var$compileEventUi(def, eventUiBases),
        instance: $200f5cce291452b2$export$3b513254972cfc9c(def.defId, dateSpan.range),
        range: dateSpan.range,
        isStart: true,
        isEnd: true
    };
}
let $200f5cce291452b2$var$calendarSystemClassMap = {};
function $200f5cce291452b2$var$registerCalendarSystem(name, theClass) {
    $200f5cce291452b2$var$calendarSystemClassMap[name] = theClass;
}
function $200f5cce291452b2$var$createCalendarSystem(name) {
    return new $200f5cce291452b2$var$calendarSystemClassMap[name]();
}
class $200f5cce291452b2$var$GregorianCalendarSystem {
    getMarkerYear(d) {
        return d.getUTCFullYear();
    }
    getMarkerMonth(d) {
        return d.getUTCMonth();
    }
    getMarkerDay(d) {
        return d.getUTCDate();
    }
    arrayToMarker(arr) {
        return $200f5cce291452b2$var$arrayToUtcDate(arr);
    }
    markerToArray(marker) {
        return $200f5cce291452b2$var$dateToUtcArray(marker);
    }
}
$200f5cce291452b2$var$registerCalendarSystem("gregory", $200f5cce291452b2$var$GregorianCalendarSystem);
const $200f5cce291452b2$var$ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
function $200f5cce291452b2$export$674f8f4247a5112e(str) {
    let m = $200f5cce291452b2$var$ISO_RE.exec(str);
    if (m) {
        let marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number(`0.${m[12]}`) * 1000 : 0));
        if ($200f5cce291452b2$export$55ff3cc1821e8445(marker)) {
            let timeZoneOffset = null;
            if (m[13]) timeZoneOffset = (m[15] === "-" ? -1 : 1) * (Number(m[16] || 0) * 60 + Number(m[18] || 0));
            return {
                marker: marker,
                isTimeUnspecified: !m[6],
                timeZoneOffset: timeZoneOffset
            };
        }
    }
    return null;
}
class $200f5cce291452b2$export$25ce5a424b770e84 {
    // Creating / Parsing
    createMarker(input) {
        let meta = this.createMarkerMeta(input);
        if (meta === null) return null;
        return meta.marker;
    }
    createNowMarker() {
        if (this.canComputeOffset) return this.timestampToMarker(new Date().valueOf());
        // if we can't compute the current date val for a timezone,
        // better to give the current local date vals than UTC
        return $200f5cce291452b2$var$arrayToUtcDate($200f5cce291452b2$var$dateToLocalArray(new Date()));
    }
    createMarkerMeta(input) {
        if (typeof input === "string") return this.parse(input);
        let marker = null;
        if (typeof input === "number") marker = this.timestampToMarker(input);
        else if (input instanceof Date) {
            input = input.valueOf();
            if (!isNaN(input)) marker = this.timestampToMarker(input);
        } else if (Array.isArray(input)) marker = $200f5cce291452b2$var$arrayToUtcDate(input);
        if (marker === null || !$200f5cce291452b2$export$55ff3cc1821e8445(marker)) return null;
        return {
            marker: marker,
            isTimeUnspecified: false,
            forcedTzo: null
        };
    }
    parse(s) {
        let parts = $200f5cce291452b2$export$674f8f4247a5112e(s);
        if (parts === null) return null;
        let { marker: marker } = parts;
        let forcedTzo = null;
        if (parts.timeZoneOffset !== null) {
            if (this.canComputeOffset) marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60000);
            else forcedTzo = parts.timeZoneOffset;
        }
        return {
            marker: marker,
            isTimeUnspecified: parts.isTimeUnspecified,
            forcedTzo: forcedTzo
        };
    }
    // Accessors
    getYear(marker) {
        return this.calendarSystem.getMarkerYear(marker);
    }
    getMonth(marker) {
        return this.calendarSystem.getMarkerMonth(marker);
    }
    getDay(marker) {
        return this.calendarSystem.getMarkerDay(marker);
    }
    // Adding / Subtracting
    add(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += dur.years;
        a[1] += dur.months;
        a[2] += dur.days;
        a[6] += dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    subtract(marker, dur) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] -= dur.years;
        a[1] -= dur.months;
        a[2] -= dur.days;
        a[6] -= dur.milliseconds;
        return this.calendarSystem.arrayToMarker(a);
    }
    addYears(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[0] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    addMonths(marker, n) {
        let a = this.calendarSystem.markerToArray(marker);
        a[1] += n;
        return this.calendarSystem.arrayToMarker(a);
    }
    // Diffing Whole Units
    diffWholeYears(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($200f5cce291452b2$var$timeAsMs(m0) === $200f5cce291452b2$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) && calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
        return null;
    }
    diffWholeMonths(m0, m1) {
        let { calendarSystem: calendarSystem } = this;
        if ($200f5cce291452b2$var$timeAsMs(m0) === $200f5cce291452b2$var$timeAsMs(m1) && calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) return calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0) + (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
        return null;
    }
    // Range / Duration
    greatestWholeUnit(m0, m1) {
        let n = this.diffWholeYears(m0, m1);
        if (n !== null) return {
            unit: "year",
            value: n
        };
        n = this.diffWholeMonths(m0, m1);
        if (n !== null) return {
            unit: "month",
            value: n
        };
        n = $200f5cce291452b2$export$b4d5ecaefe2b27f3(m0, m1);
        if (n !== null) return {
            unit: "week",
            value: n
        };
        n = $200f5cce291452b2$export$4a5767248b18ef41(m0, m1);
        if (n !== null) return {
            unit: "day",
            value: n
        };
        n = $200f5cce291452b2$var$diffHours(m0, m1);
        if ($200f5cce291452b2$export$306ddfe3a8403e2(n)) return {
            unit: "hour",
            value: n
        };
        n = $200f5cce291452b2$var$diffMinutes(m0, m1);
        if ($200f5cce291452b2$export$306ddfe3a8403e2(n)) return {
            unit: "minute",
            value: n
        };
        n = $200f5cce291452b2$var$diffSeconds(m0, m1);
        if ($200f5cce291452b2$export$306ddfe3a8403e2(n)) return {
            unit: "second",
            value: n
        };
        return {
            unit: "millisecond",
            value: m1.valueOf() - m0.valueOf()
        };
    }
    countDurationsBetween(m0, m1, d) {
        // TODO: can use greatestWholeUnit
        let diff;
        if (d.years) {
            diff = this.diffWholeYears(m0, m1);
            if (diff !== null) return diff / $200f5cce291452b2$var$asRoughYears(d);
        }
        if (d.months) {
            diff = this.diffWholeMonths(m0, m1);
            if (diff !== null) return diff / $200f5cce291452b2$var$asRoughMonths(d);
        }
        if (d.days) {
            diff = $200f5cce291452b2$export$4a5767248b18ef41(m0, m1);
            if (diff !== null) return diff / $200f5cce291452b2$var$asRoughDays(d);
        }
        return (m1.valueOf() - m0.valueOf()) / $200f5cce291452b2$export$4e222d082f82ee97(d);
    }
    // Start-Of
    // these DON'T return zoned-dates. only UTC start-of dates
    startOf(m, unit) {
        if (unit === "year") return this.startOfYear(m);
        if (unit === "month") return this.startOfMonth(m);
        if (unit === "week") return this.startOfWeek(m);
        if (unit === "day") return $200f5cce291452b2$export$9e5f44173e64f162(m);
        if (unit === "hour") return $200f5cce291452b2$var$startOfHour(m);
        if (unit === "minute") return $200f5cce291452b2$var$startOfMinute(m);
        if (unit === "second") return $200f5cce291452b2$var$startOfSecond(m);
        return null;
    }
    startOfYear(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m)
        ]);
    }
    startOfMonth(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m)
        ]);
    }
    startOfWeek(m) {
        return this.calendarSystem.arrayToMarker([
            this.calendarSystem.getMarkerYear(m),
            this.calendarSystem.getMarkerMonth(m),
            m.getUTCDate() - (m.getUTCDay() - this.weekDow + 7) % 7
        ]);
    }
    // Week Number
    computeWeekNumber(marker) {
        if (this.weekNumberFunc) return this.weekNumberFunc(this.toDate(marker));
        return $200f5cce291452b2$var$weekOfYear(marker, this.weekDow, this.weekDoy);
    }
    // TODO: choke on timeZoneName: long
    format(marker, formatter, dateOptions = {}) {
        return formatter.format({
            marker: marker,
            timeZoneOffset: dateOptions.forcedTzo != null ? dateOptions.forcedTzo : this.offsetForMarker(marker)
        }, this);
    }
    formatRange(start, end, formatter, dateOptions = {}) {
        if (dateOptions.isEndExclusive) end = $200f5cce291452b2$export$136fd86de524d3c2(end, -1);
        return formatter.formatRange({
            marker: start,
            timeZoneOffset: dateOptions.forcedStartTzo != null ? dateOptions.forcedStartTzo : this.offsetForMarker(start)
        }, {
            marker: end,
            timeZoneOffset: dateOptions.forcedEndTzo != null ? dateOptions.forcedEndTzo : this.offsetForMarker(end)
        }, this, dateOptions.defaultSeparator);
    }
    /*
    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
    might as well use buildIsoString or some other util directly
    */ formatIso(marker, extraOptions = {}) {
        let timeZoneOffset = null;
        if (!extraOptions.omitTimeZoneOffset) {
            if (extraOptions.forcedTzo != null) timeZoneOffset = extraOptions.forcedTzo;
            else timeZoneOffset = this.offsetForMarker(marker);
        }
        return $200f5cce291452b2$export$45d219bdcd8ac53c(marker, timeZoneOffset, extraOptions.omitTime);
    }
    // TimeZone
    timestampToMarker(ms) {
        if (this.timeZone === "local") return $200f5cce291452b2$var$arrayToUtcDate($200f5cce291452b2$var$dateToLocalArray(new Date(ms)));
        if (this.timeZone === "UTC" || !this.namedTimeZoneImpl) return new Date(ms);
        return $200f5cce291452b2$var$arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
    }
    offsetForMarker(m) {
        if (this.timeZone === "local") return -$200f5cce291452b2$var$arrayToLocalDate($200f5cce291452b2$var$dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
        if (this.timeZone === "UTC") return 0;
        if (this.namedTimeZoneImpl) return this.namedTimeZoneImpl.offsetForArray($200f5cce291452b2$var$dateToUtcArray(m));
        return null;
    }
    // Conversion
    toDate(m, forcedTzo) {
        if (this.timeZone === "local") return $200f5cce291452b2$var$arrayToLocalDate($200f5cce291452b2$var$dateToUtcArray(m));
        if (this.timeZone === "UTC") return new Date(m.valueOf()); // make sure it's a copy
        if (!this.namedTimeZoneImpl) return new Date(m.valueOf() - (forcedTzo || 0));
        return new Date(m.valueOf() - this.namedTimeZoneImpl.offsetForArray($200f5cce291452b2$var$dateToUtcArray(m)) * 60000);
    }
    constructor(settings){
        let timeZone = this.timeZone = settings.timeZone;
        let isNamedTimeZone = timeZone !== "local" && timeZone !== "UTC";
        if (settings.namedTimeZoneImpl && isNamedTimeZone) this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
        this.calendarSystem = $200f5cce291452b2$var$createCalendarSystem(settings.calendarSystem);
        this.locale = settings.locale;
        this.weekDow = settings.locale.week.dow;
        this.weekDoy = settings.locale.week.doy;
        if (settings.weekNumberCalculation === "ISO") {
            this.weekDow = 1;
            this.weekDoy = 4;
        }
        if (typeof settings.firstDay === "number") this.weekDow = settings.firstDay;
        if (typeof settings.weekNumberCalculation === "function") this.weekNumberFunc = settings.weekNumberCalculation;
        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
        this.cmdFormatter = settings.cmdFormatter;
        this.defaultSeparator = settings.defaultSeparator;
    }
}
class $200f5cce291452b2$export$766bf7dcfb630b6c {
    constructor(timeZoneName){
        this.timeZoneName = timeZoneName;
    }
}
class $200f5cce291452b2$export$2e63b696b2c9441b {
    addSegs(inputs) {
        let hiddenEntries = [];
        for (let input of inputs)this.insertEntry(input, hiddenEntries);
        return hiddenEntries;
    }
    insertEntry(entry, hiddenEntries) {
        let insertion = this.findInsertion(entry);
        if (this.isInsertionValid(insertion, entry)) {
            this.insertEntryAt(entry, insertion);
            return 1;
        }
        return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    isInsertionValid(insertion, entry) {
        return (this.maxCoord === -1 || insertion.levelCoord + entry.thickness <= this.maxCoord) && (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
    }
    // returns number of new entries inserted
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        if (this.allowReslicing && insertion.touchingEntry) return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
        hiddenEntries.push(entry);
        return 0;
    }
    splitEntry(entry, barrier, hiddenEntries) {
        let partCnt = 0;
        let splitHiddenEntries = [];
        let entrySpan = entry.span;
        let barrierSpan = barrier.span;
        if (entrySpan.start < barrierSpan.start) partCnt += this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: entrySpan.start,
                end: barrierSpan.start
            }
        }, splitHiddenEntries);
        if (entrySpan.end > barrierSpan.end) partCnt += this.insertEntry({
            index: entry.index,
            thickness: entry.thickness,
            span: {
                start: barrierSpan.end,
                end: entrySpan.end
            }
        }, splitHiddenEntries);
        if (partCnt) {
            hiddenEntries.push({
                index: entry.index,
                thickness: entry.thickness,
                span: $200f5cce291452b2$export$b2bcef12bcefba04(barrierSpan, entrySpan)
            }, ...splitHiddenEntries);
            return partCnt;
        }
        hiddenEntries.push(entry);
        return 0;
    }
    insertEntryAt(entry, insertion) {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        if (insertion.lateral === -1) {
            // create a new level
            $200f5cce291452b2$var$insertAt(levelCoords, insertion.level, insertion.levelCoord);
            $200f5cce291452b2$var$insertAt(entriesByLevel, insertion.level, [
                entry
            ]);
        } else // insert into existing level
        $200f5cce291452b2$var$insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
        this.stackCnts[$200f5cce291452b2$export$eb84e45a33f6ba7c(entry)] = insertion.stackCnt;
    }
    findInsertion(newEntry) {
        let { levelCoords: levelCoords, entriesByLevel: entriesByLevel, strictOrder: strictOrder, stackCnts: stackCnts } = this;
        let levelCnt = levelCoords.length;
        let candidateCoord = 0;
        let touchingLevel = -1;
        let touchingLateral = -1;
        let touchingEntry = null;
        let stackCnt = 0;
        for(let trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1){
            let trackingCoord = levelCoords[trackingLevel];
            // if the current level is past the placed entry, we have found a good empty space and can stop.
            // if strictOrder, keep finding more lateral intersections.
            if (!strictOrder && trackingCoord >= candidateCoord + newEntry.thickness) break;
            let trackingEntries = entriesByLevel[trackingLevel];
            let trackingEntry;
            let searchRes = $200f5cce291452b2$export$b0165a7e514844(trackingEntries, newEntry.span.start, $200f5cce291452b2$export$d76842aa27385215); // find first entry after newEntry's end
            let lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
            while((trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
            trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
            ){
                let trackingEntryBottom = trackingCoord + trackingEntry.thickness;
                // intersects into the top of the candidate?
                if (trackingEntryBottom > candidateCoord) {
                    candidateCoord = trackingEntryBottom;
                    touchingEntry = trackingEntry;
                    touchingLevel = trackingLevel;
                    touchingLateral = lateralIndex;
                }
                // butts up against top of candidate? (will happen if just intersected as well)
                if (trackingEntryBottom === candidateCoord) // accumulate the highest possible stackCnt of the trackingEntries that butt up
                stackCnt = Math.max(stackCnt, stackCnts[$200f5cce291452b2$export$eb84e45a33f6ba7c(trackingEntry)] + 1);
                lateralIndex += 1;
            }
        }
        // the destination level will be after touchingEntry's level. find it
        let destLevel = 0;
        if (touchingEntry) {
            destLevel = touchingLevel + 1;
            while(destLevel < levelCnt && levelCoords[destLevel] < candidateCoord)destLevel += 1;
        }
        // if adding to an existing level, find where to insert
        let destLateral = -1;
        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) destLateral = $200f5cce291452b2$export$b0165a7e514844(entriesByLevel[destLevel], newEntry.span.end, $200f5cce291452b2$export$d76842aa27385215)[0];
        return {
            touchingLevel: touchingLevel,
            touchingLateral: touchingLateral,
            touchingEntry: touchingEntry,
            stackCnt: stackCnt,
            levelCoord: candidateCoord,
            level: destLevel,
            lateral: destLateral
        };
    }
    // sorted by levelCoord (lowest to highest)
    toRects() {
        let { entriesByLevel: entriesByLevel, levelCoords: levelCoords } = this;
        let levelCnt = entriesByLevel.length;
        let rects = [];
        for(let level = 0; level < levelCnt; level += 1){
            let entries = entriesByLevel[level];
            let levelCoord = levelCoords[level];
            for (let entry of entries)rects.push(Object.assign(Object.assign({}, entry), {
                levelCoord: levelCoord
            }));
        }
        return rects;
    }
    constructor(){
        // settings
        this.strictOrder = false;
        this.allowReslicing = false;
        this.maxCoord = -1; // -1 means no max
        this.maxStackCnt = -1; // -1 means no max
        this.levelCoords = []; // ordered
        this.entriesByLevel = []; // parallel with levelCoords
        this.stackCnts = {}; // TODO: use better technique!?
    }
}
function $200f5cce291452b2$export$d76842aa27385215(entry) {
    return entry.span.end;
}
function $200f5cce291452b2$export$eb84e45a33f6ba7c(entry) {
    return entry.index + ":" + entry.span.start;
}
// returns groups with entries sorted by input order
function $200f5cce291452b2$export$381353cf1dd55255(entries) {
    let merges = [];
    for (let entry of entries){
        let filteredMerges = [];
        let hungryMerge = {
            span: entry.span,
            entries: [
                entry
            ]
        };
        for (let merge of merges)if ($200f5cce291452b2$export$b2bcef12bcefba04(merge.span, hungryMerge.span)) hungryMerge = {
            entries: merge.entries.concat(hungryMerge.entries),
            span: $200f5cce291452b2$var$joinSpans(merge.span, hungryMerge.span)
        };
        else filteredMerges.push(merge);
        filteredMerges.push(hungryMerge);
        merges = filteredMerges;
    }
    return merges;
}
function $200f5cce291452b2$var$joinSpans(span0, span1) {
    return {
        start: Math.min(span0.start, span1.start),
        end: Math.max(span0.end, span1.end)
    };
}
function $200f5cce291452b2$export$b2bcef12bcefba04(span0, span1) {
    let start = Math.max(span0.start, span1.start);
    let end = Math.min(span0.end, span1.end);
    if (start < end) return {
        start: start,
        end: end
    };
    return null;
}
// general util
// ---------------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$var$insertAt(arr, index, item) {
    arr.splice(index, 0, item);
}
function $200f5cce291452b2$export$b0165a7e514844(a, searchVal, getItemVal) {
    let startIndex = 0;
    let endIndex = a.length; // exclusive
    if (!endIndex || searchVal < getItemVal(a[startIndex])) return [
        0,
        0
    ];
    if (searchVal > getItemVal(a[endIndex - 1])) return [
        endIndex,
        0
    ];
    while(startIndex < endIndex){
        let middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
        let middleVal = getItemVal(a[middleIndex]);
        if (searchVal < middleVal) endIndex = middleIndex;
        else if (searchVal > middleVal) startIndex = middleIndex + 1;
        else return [
            middleIndex,
            1
        ];
    }
    return [
        startIndex,
        0
    ];
}
class $200f5cce291452b2$export$dc98b0b04f4c7758 {
    destroy() {}
    constructor(settings){
        this.component = settings.component;
        this.isHitComboAllowed = settings.isHitComboAllowed || null;
    }
}
function $200f5cce291452b2$export$2e2af4578d910ddf(component, input) {
    return {
        component: component,
        el: input.el,
        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
        isHitComboAllowed: input.isHitComboAllowed || null
    };
}
function $200f5cce291452b2$export$aff10ba49ece4b91(settings) {
    return {
        [settings.component.uid]: settings
    };
}
// global state
const $200f5cce291452b2$export$a93c5207d687da10 = {};
/*
An abstraction for a dragging interaction originating on an event.
Does higher-level things than PointerDragger, such as possibly:
- a "mirror" that moves with the pointer
- a minimum number of pixels or other criteria for a true drag to begin

subclasses must emit:
- pointerdown
- dragstart
- dragmove
- pointerup
- dragend
*/ class $200f5cce291452b2$export$60bb826a6acf3081 {
    destroy() {}
    setMirrorIsVisible(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setMirrorNeedsRevert(bool) {
    // optional if subclass doesn't want to support a mirror
    }
    setAutoScrollEnabled(bool) {
    // optional
    }
    constructor(el, selector){
        this.emitter = new $200f5cce291452b2$export$d66501df72047452();
    }
}
// TODO: get rid of this in favor of options system,
// tho it's really easy to access this globally rather than pass thru options.
const $200f5cce291452b2$export$27d1aff6bea49709 = {};
/*
Information about what will happen when an external element is dragged-and-dropped
onto a calendar. Contains information for creating an event.
*/ const $200f5cce291452b2$var$DRAG_META_REFINERS = {
    startTime: $200f5cce291452b2$export$4368d992c4eafac0,
    duration: $200f5cce291452b2$export$4368d992c4eafac0,
    create: Boolean,
    sourceId: String
};
function $200f5cce291452b2$export$1abb261478089fe6(raw) {
    let { refined: refined, extra: extra } = $200f5cce291452b2$export$f38c853ae54ed474(raw, $200f5cce291452b2$var$DRAG_META_REFINERS);
    return {
        startTime: refined.startTime || null,
        duration: refined.duration || null,
        create: refined.create != null ? refined.create : true,
        sourceId: refined.sourceId,
        leftoverProps: extra
    };
}
class $200f5cce291452b2$export$555508cbc6add439 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { options: options } = props;
        let { forPrint: forPrint } = this.state;
        let isHeightAuto = forPrint || options.height === "auto" || options.contentHeight === "auto";
        let height = !isHeightAuto && options.height != null ? options.height : "";
        let classNames = [
            "fc",
            forPrint ? "fc-media-print" : "fc-media-screen",
            `fc-direction-${options.direction}`,
            props.theme.getClass("root")
        ];
        if (!$200f5cce291452b2$export$667d3bf0c5f83305()) classNames.push("fc-liquid-hack");
        return props.children(classNames, height, isHeightAuto, forPrint);
    }
    componentDidMount() {
        let { emitter: emitter } = this.props;
        emitter.on("_beforeprint", this.handleBeforePrint);
        emitter.on("_afterprint", this.handleAfterPrint);
    }
    componentWillUnmount() {
        let { emitter: emitter } = this.props;
        emitter.off("_beforeprint", this.handleBeforePrint);
        emitter.off("_afterprint", this.handleAfterPrint);
    }
    constructor(){
        super(...arguments);
        this.state = {
            forPrint: false
        };
        this.handleBeforePrint = ()=>{
            this.setState({
                forPrint: true
            });
        };
        this.handleAfterPrint = ()=>{
            this.setState({
                forPrint: false
            });
        };
    }
}
// Computes a default column header formatting string if `colFormat` is not explicitly defined
function $200f5cce291452b2$export$1ddf2d01943a3512(datesRepDistinctDays, dayCnt) {
    // if more than one week row, or if there are a lot of columns with not much space,
    // put just the day numbers will be in each cell
    if (!datesRepDistinctDays || dayCnt > 10) return $200f5cce291452b2$export$d141bba7fdc215a3({
        weekday: "short"
    }); // "Sat"
    if (dayCnt > 1) return $200f5cce291452b2$export$d141bba7fdc215a3({
        weekday: "short",
        month: "numeric",
        day: "numeric",
        omitCommas: true
    }); // "Sat 11/12"
    return $200f5cce291452b2$export$d141bba7fdc215a3({
        weekday: "long"
    }); // "Saturday"
}
const $200f5cce291452b2$var$CLASS_NAME = "fc-col-header-cell"; // do the cushion too? no
function $200f5cce291452b2$var$renderInner$1(renderProps) {
    return renderProps.text;
}
class $200f5cce291452b2$var$ContentInjector extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { customGenerator: customGenerator, defaultGenerator: defaultGenerator, renderProps: renderProps } = props;
        const attrs = $200f5cce291452b2$export$a274e22fb40f762e(props);
        let useDefault = false;
        let innerContent;
        let queuedDomNodes = [];
        let currentGeneratorMeta;
        if (customGenerator != null) {
            const customGeneratorRes = typeof customGenerator === "function" ? customGenerator(renderProps, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)) : customGenerator;
            if (customGeneratorRes === true) useDefault = true;
            else {
                const isObject = customGeneratorRes && typeof customGeneratorRes === "object"; // non-null
                if (isObject && "html" in customGeneratorRes) attrs.dangerouslySetInnerHTML = {
                    __html: customGeneratorRes.html
                };
                else if (isObject && "domNodes" in customGeneratorRes) queuedDomNodes = Array.prototype.slice.call(customGeneratorRes.domNodes);
                else if (!isObject && typeof customGeneratorRes !== "function") // primitive value (like string or number)
                innerContent = customGeneratorRes;
                else // an exotic object for handleCustomRendering
                currentGeneratorMeta = customGeneratorRes;
            }
        } else useDefault = !$200f5cce291452b2$var$hasCustomRenderingHandler(props.generatorName, options);
        if (useDefault && defaultGenerator) innerContent = defaultGenerator(renderProps);
        this.queuedDomNodes = queuedDomNodes;
        this.currentGeneratorMeta = currentGeneratorMeta;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(props.elTag, attrs, innerContent);
    }
    componentDidMount() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentDidUpdate() {
        this.applyQueueudDomNodes();
        this.triggerCustomRendering(true);
    }
    componentWillUnmount() {
        this.triggerCustomRendering(false); // TODO: different API for removal?
    }
    triggerCustomRendering(isActive) {
        var _a;
        const { props: props, context: context } = this;
        const { handleCustomRendering: handleCustomRendering, customRenderingMetaMap: customRenderingMetaMap } = context.options;
        if (handleCustomRendering) {
            const generatorMeta = (_a = this.currentGeneratorMeta) !== null && _a !== void 0 ? _a : customRenderingMetaMap === null || customRenderingMetaMap === void 0 ? void 0 : customRenderingMetaMap[props.generatorName];
            if (generatorMeta) handleCustomRendering(Object.assign(Object.assign({
                id: this.id,
                isActive: isActive,
                containerEl: this.base,
                reportNewContainerEl: this.handleEl,
                generatorMeta: generatorMeta
            }, props), {
                elClasses: (props.elClasses || []).filter($200f5cce291452b2$var$isTruthy)
            }));
        }
    }
    applyQueueudDomNodes() {
        const { queuedDomNodes: queuedDomNodes, currentDomNodes: currentDomNodes } = this;
        const el = this.base;
        if (!$200f5cce291452b2$export$23f2a1d2818174ef(queuedDomNodes, currentDomNodes)) {
            currentDomNodes.forEach($200f5cce291452b2$export$c03999cb2f36933f);
            for (let newNode of queuedDomNodes)el.appendChild(newNode);
            this.currentDomNodes = queuedDomNodes;
        }
    }
    constructor(){
        super(...arguments);
        this.id = $200f5cce291452b2$export$39b482c5e57630a8();
        this.queuedDomNodes = [];
        this.currentDomNodes = [];
        this.handleEl = (el)=>{
            if (this.props.elRef) $200f5cce291452b2$export$8743009a87fcb00f(this.props.elRef, el);
        };
    }
}
$200f5cce291452b2$var$ContentInjector.addPropsEquality({
    elClasses: $200f5cce291452b2$export$23f2a1d2818174ef,
    elStyle: $200f5cce291452b2$export$a9c23c6ac3fc3eca,
    elAttrs: $200f5cce291452b2$var$isNonHandlerPropsEqual,
    renderProps: $200f5cce291452b2$export$a9c23c6ac3fc3eca
});
// Util
/*
Does UI-framework provide custom way of rendering?
*/ function $200f5cce291452b2$var$hasCustomRenderingHandler(generatorName, options) {
    var _a;
    return Boolean(options.handleCustomRendering && generatorName && ((_a = options.customRenderingMetaMap) === null || _a === void 0 ? void 0 : _a[generatorName]));
}
function $200f5cce291452b2$export$a274e22fb40f762e(props, extraClassNames) {
    const attrs = Object.assign(Object.assign({}, props.elAttrs), {
        ref: props.elRef
    });
    if (props.elClasses || extraClassNames) attrs.className = (props.elClasses || []).concat(extraClassNames || []).concat(attrs.className || []).filter(Boolean).join(" ");
    if (props.elStyle) attrs.style = props.elStyle;
    return attrs;
}
function $200f5cce291452b2$var$isTruthy(val) {
    return Boolean(val);
}
const $200f5cce291452b2$export$2219238a014317b0 = $200f5cce291452b2$export$995eb9fca571757(0);
class $200f5cce291452b2$export$e7094788287c5e9b extends (0, $f652a0e37ee35e91$export$16fa2f45be04daa8) {
    render() {
        const { props: props } = this;
        const generatedClassNames = $200f5cce291452b2$var$generateClassNames(props.classNameGenerator, props.renderProps);
        if (props.children) {
            const elAttrs = $200f5cce291452b2$export$a274e22fb40f762e(props, generatedClassNames);
            const children = props.children(this.InnerContent, props.renderProps, elAttrs);
            if (props.elTag) return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(props.elTag, elAttrs, children);
            else return children;
        } else return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$var$ContentInjector, Object.assign(Object.assign({}, props), {
            elRef: this.handleRootEl,
            elTag: props.elTag || "div",
            elClasses: (props.elClasses || []).concat(generatedClassNames),
            renderId: this.context
        }));
    }
    componentDidMount() {
        var _a, _b;
        (_b = (_a = this.props).didMount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.rootEl || this.base
        }));
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.props).willUnmount) === null || _b === void 0 || _b.call(_a, Object.assign(Object.assign({}, this.props.renderProps), {
            el: this.rootEl || this.base
        }));
    }
    constructor(){
        super(...arguments);
        this.InnerContent = $200f5cce291452b2$var$InnerContentInjector.bind(undefined, this);
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $200f5cce291452b2$export$8743009a87fcb00f(this.props.elRef, el);
        };
    }
}
$200f5cce291452b2$export$e7094788287c5e9b.contextType = $200f5cce291452b2$export$2219238a014317b0;
function $200f5cce291452b2$var$InnerContentInjector(containerComponent, props) {
    const parentProps = containerComponent.props;
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$var$ContentInjector, Object.assign({
        renderProps: parentProps.renderProps,
        generatorName: parentProps.generatorName,
        customGenerator: parentProps.customGenerator,
        defaultGenerator: parentProps.defaultGenerator,
        renderId: containerComponent.context
    }, props));
}
// Utils
function $200f5cce291452b2$var$generateClassNames(classNameGenerator, renderProps) {
    const classNames = typeof classNameGenerator === "function" ? classNameGenerator(renderProps) : classNameGenerator || [];
    return typeof classNames === "string" ? [
        classNames
    ] : classNames;
}
// BAD name for this class now. used in the Header
class $200f5cce291452b2$export$ebb8f7cd71856fb9 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { dateEnv: dateEnv, options: options, theme: theme, viewApi: viewApi } = this.context;
        let { props: props } = this;
        let { date: date, dateProfile: dateProfile } = props;
        let dayMeta = $200f5cce291452b2$export$a17c37559e1db147(date, props.todayRange, null, dateProfile);
        let classNames = [
            $200f5cce291452b2$var$CLASS_NAME
        ].concat($200f5cce291452b2$export$527e9aa3390079e9(dayMeta, theme));
        let text = dateEnv.format(date, props.dayHeaderFormat);
        // if colCnt is 1, we are already in a day-view and don't need a navlink
        let navLinkAttrs = !dayMeta.isDisabled && props.colCnt > 1 ? $200f5cce291452b2$export$8c78c7c36408ea29(this.context, date) : {};
        let renderProps = Object.assign(Object.assign(Object.assign({
            date: dateEnv.toDate(date),
            view: viewApi
        }, props.extraRenderProps), {
            text: text
        }), dayMeta);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: classNames,
            elAttrs: Object.assign({
                role: "columnheader",
                colSpan: props.colSpan,
                "data-date": !dayMeta.isDisabled ? $200f5cce291452b2$export$5dbe06c6d8c68cfb(date) : undefined
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $200f5cce291452b2$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContainer)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, !dayMeta.isDisabled && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContainer, {
                elTag: "a",
                elAttrs: navLinkAttrs,
                elClasses: [
                    "fc-col-header-cell-cushion",
                    props.isSticky && "fc-sticky"
                ]
            })));
    }
}
const $200f5cce291452b2$var$WEEKDAY_FORMAT = $200f5cce291452b2$export$d141bba7fdc215a3({
    weekday: "long"
});
class $200f5cce291452b2$export$45aabb5431c2d04f extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { dateEnv: dateEnv, theme: theme, viewApi: viewApi, options: options } = this.context;
        let date = $200f5cce291452b2$export$625550452a3fa3ec(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
        let dateMeta = {
            dow: props.dow,
            isDisabled: false,
            isFuture: false,
            isPast: false,
            isToday: false,
            isOther: false
        };
        let text = dateEnv.format(date, props.dayHeaderFormat);
        let renderProps = Object.assign(Object.assign(Object.assign(Object.assign({
            date: date
        }, dateMeta), {
            view: viewApi
        }), props.extraRenderProps), {
            text: text
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, {
            elTag: "th",
            elClasses: [
                $200f5cce291452b2$var$CLASS_NAME,
                ...$200f5cce291452b2$export$527e9aa3390079e9(dateMeta, theme),
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: "columnheader",
                colSpan: props.colSpan
            }, props.extraDataAttrs),
            renderProps: renderProps,
            generatorName: "dayHeaderContent",
            customGenerator: options.dayHeaderContent,
            defaultGenerator: $200f5cce291452b2$var$renderInner$1,
            classNameGenerator: options.dayHeaderClassNames,
            didMount: options.dayHeaderDidMount,
            willUnmount: options.dayHeaderWillUnmount
        }, (InnerContent)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-scrollgrid-sync-inner"
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    "fc-col-header-cell-cushion",
                    props.isSticky && "fc-sticky"
                ],
                elAttrs: {
                    "aria-label": dateEnv.format(date, $200f5cce291452b2$var$WEEKDAY_FORMAT)
                }
            })));
    }
}
class $200f5cce291452b2$export$6e4b1d19c6e2e012 extends (0, $f652a0e37ee35e91$export$16fa2f45be04daa8) {
    render() {
        let { props: props, state: state } = this;
        return props.children(state.nowDate, state.todayRange);
    }
    componentDidMount() {
        this.setTimeout();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.unit !== this.props.unit) {
            this.clearTimeout();
            this.setTimeout();
        }
    }
    componentWillUnmount() {
        this.clearTimeout();
    }
    computeTiming() {
        let { props: props, context: context } = this;
        let unroundedNow = $200f5cce291452b2$export$136fd86de524d3c2(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
        let currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
        let nextUnitStart = context.dateEnv.add(currentUnitStart, $200f5cce291452b2$export$4368d992c4eafac0(1, props.unit));
        let waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
        // ensure no longer than a day
        waitMs = Math.min(86400000, waitMs);
        return {
            currentState: {
                nowDate: currentUnitStart,
                todayRange: $200f5cce291452b2$var$buildDayRange(currentUnitStart)
            },
            nextState: {
                nowDate: nextUnitStart,
                todayRange: $200f5cce291452b2$var$buildDayRange(nextUnitStart)
            },
            waitMs: waitMs
        };
    }
    setTimeout() {
        let { nextState: nextState, waitMs: waitMs } = this.computeTiming();
        this.timeoutId = setTimeout(()=>{
            this.setState(nextState, ()=>{
                this.setTimeout();
            });
        }, waitMs);
    }
    clearTimeout() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
    constructor(props, context){
        super(props, context);
        this.initialNowDate = $200f5cce291452b2$export$c3950d9923825c02(context.options.now, context.dateEnv);
        this.initialNowQueriedMs = new Date().valueOf();
        this.state = this.computeTiming().currentState;
    }
}
$200f5cce291452b2$export$6e4b1d19c6e2e012.contextType = $200f5cce291452b2$export$e7c866399fa523f5;
function $200f5cce291452b2$var$buildDayRange(date) {
    let start = $200f5cce291452b2$export$9e5f44173e64f162(date);
    let end = $200f5cce291452b2$export$625550452a3fa3ec(start, 1);
    return {
        start: start,
        end: end
    };
}
class $200f5cce291452b2$export$ebc5e65867841cbe extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { context: context } = this;
        let { dates: dates, dateProfile: dateProfile, datesRepDistinctDays: datesRepDistinctDays, renderIntro: renderIntro } = this.props;
        let dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$6e4b1d19c6e2e012, {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                role: "row"
            }, renderIntro && renderIntro("day"), dates.map((date)=>datesRepDistinctDays ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$ebb8f7cd71856fb9, {
                    key: date.toISOString(),
                    date: date,
                    dateProfile: dateProfile,
                    todayRange: todayRange,
                    colCnt: dates.length,
                    dayHeaderFormat: dayHeaderFormat
                }) : (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$45aabb5431c2d04f, {
                    key: date.getUTCDay(),
                    dow: date.getUTCDay(),
                    dayHeaderFormat: dayHeaderFormat
                }))));
    }
    constructor(){
        super(...arguments);
        this.createDayHeaderFormatter = $200f5cce291452b2$export$df995fae86a55f06($200f5cce291452b2$var$createDayHeaderFormatter);
    }
}
function $200f5cce291452b2$var$createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
    return explicitFormat || $200f5cce291452b2$export$1ddf2d01943a3512(datesRepDistinctDays, dateCnt);
}
class $200f5cce291452b2$export$2538633961795d6b {
    sliceRange(range) {
        let firstIndex = this.getDateDayIndex(range.start); // inclusive first index
        let lastIndex = this.getDateDayIndex($200f5cce291452b2$export$625550452a3fa3ec(range.end, -1)); // inclusive last index
        let clippedFirstIndex = Math.max(0, firstIndex);
        let clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
        // deal with in-between indices
        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
        if (clippedFirstIndex <= clippedLastIndex) return {
            firstIndex: clippedFirstIndex,
            lastIndex: clippedLastIndex,
            isStart: firstIndex === clippedFirstIndex,
            isEnd: lastIndex === clippedLastIndex
        };
        return null;
    }
    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
    // If before the first offset, returns a negative number.
    // If after the last offset, returns an offset past the last cell offset.
    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
    getDateDayIndex(date) {
        let { indices: indices } = this;
        let dayOffset = Math.floor($200f5cce291452b2$export$a36fb7d24305ed9d(this.dates[0], date));
        if (dayOffset < 0) return indices[0] - 1;
        if (dayOffset >= indices.length) return indices[indices.length - 1] + 1;
        return indices[dayOffset];
    }
    constructor(range, dateProfileGenerator){
        let date = range.start;
        let { end: end } = range;
        let indices = [];
        let dates = [];
        let dayIndex = -1;
        while(date < end){
            if (dateProfileGenerator.isHiddenDay(date)) indices.push(dayIndex + 0.5); // mark that it's between indices
            else {
                dayIndex += 1;
                indices.push(dayIndex);
                dates.push(date);
            }
            date = $200f5cce291452b2$export$625550452a3fa3ec(date, 1);
        }
        this.dates = dates;
        this.indices = indices;
        this.cnt = dates.length;
    }
}
class $200f5cce291452b2$export$dabba94403d45c8e {
    buildCells() {
        let rows = [];
        for(let row = 0; row < this.rowCnt; row += 1){
            let cells = [];
            for(let col = 0; col < this.colCnt; col += 1)cells.push(this.buildCell(row, col));
            rows.push(cells);
        }
        return rows;
    }
    buildCell(row, col) {
        let date = this.daySeries.dates[row * this.colCnt + col];
        return {
            key: date.toISOString(),
            date: date
        };
    }
    buildHeaderDates() {
        let dates = [];
        for(let col = 0; col < this.colCnt; col += 1)dates.push(this.cells[0][col].date);
        return dates;
    }
    sliceRange(range) {
        let { colCnt: colCnt } = this;
        let seriesSeg = this.daySeries.sliceRange(range);
        let segs = [];
        if (seriesSeg) {
            let { firstIndex: firstIndex, lastIndex: lastIndex } = seriesSeg;
            let index = firstIndex;
            while(index <= lastIndex){
                let row = Math.floor(index / colCnt);
                let nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
                segs.push({
                    row: row,
                    firstCol: index % colCnt,
                    lastCol: (nextIndex - 1) % colCnt,
                    isStart: seriesSeg.isStart && index === firstIndex,
                    isEnd: seriesSeg.isEnd && nextIndex - 1 === lastIndex
                });
                index = nextIndex;
            }
        }
        return segs;
    }
    constructor(daySeries, breakOnWeeks){
        let { dates: dates } = daySeries;
        let daysPerRow;
        let firstDay;
        let rowCnt;
        if (breakOnWeeks) {
            // count columns until the day-of-week repeats
            firstDay = dates[0].getUTCDay();
            for(daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1){
                if (dates[daysPerRow].getUTCDay() === firstDay) break;
            }
            rowCnt = Math.ceil(dates.length / daysPerRow);
        } else {
            rowCnt = 1;
            daysPerRow = dates.length;
        }
        this.rowCnt = rowCnt;
        this.colCnt = daysPerRow;
        this.daySeries = daySeries;
        this.cells = this.buildCells();
        this.headerDates = this.buildHeaderDates();
    }
}
class $200f5cce291452b2$export$6b179bb11f7fd3a0 {
    sliceProps(props, dateProfile, nextDayThreshold, context, ...extraArgs) {
        let { eventUiBases: eventUiBases } = props;
        let eventSegs = this.sliceEventStore(props.eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs);
        return {
            dateSelectionSegs: this.sliceDateSelection(props.dateSelection, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs),
            businessHourSegs: this.sliceBusinessHours(props.businessHours, dateProfile, nextDayThreshold, context, ...extraArgs),
            fgEventSegs: eventSegs.fg,
            bgEventSegs: eventSegs.bg,
            eventDrag: this.sliceEventDrag(props.eventDrag, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventResize: this.sliceEventResize(props.eventResize, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs),
            eventSelection: props.eventSelection
        }; // TODO: give interactionSegs?
    }
    sliceNowDate(date, dateProfile, nextDayThreshold, context, ...extraArgs) {
        return this._sliceDateSpan({
            range: {
                start: date,
                end: $200f5cce291452b2$export$136fd86de524d3c2(date, 1)
            },
            allDay: false
        }, dateProfile, nextDayThreshold, {}, context, ...extraArgs);
    }
    _sliceBusinessHours(businessHours, dateProfile, nextDayThreshold, context, ...extraArgs) {
        if (!businessHours) return [];
        return this._sliceEventStore($200f5cce291452b2$var$expandRecurring(businessHours, $200f5cce291452b2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context), {}, dateProfile, nextDayThreshold, ...extraArgs).bg;
    }
    _sliceEventStore(eventStore, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (eventStore) {
            let rangeRes = $200f5cce291452b2$export$c9170ad7d4cd7e57(eventStore, eventUiBases, $200f5cce291452b2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
            return {
                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
                fg: this.sliceEventRanges(rangeRes.fg, extraArgs)
            };
        }
        return {
            bg: [],
            fg: []
        };
    }
    _sliceInteraction(interaction, eventUiBases, dateProfile, nextDayThreshold, ...extraArgs) {
        if (!interaction) return null;
        let rangeRes = $200f5cce291452b2$export$c9170ad7d4cd7e57(interaction.mutatedEvents, eventUiBases, $200f5cce291452b2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
        return {
            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
            affectedInstances: interaction.affectedEvents.instances,
            isEvent: interaction.isEvent
        };
    }
    _sliceDateSpan(dateSpan, dateProfile, nextDayThreshold, eventUiBases, context, ...extraArgs) {
        if (!dateSpan) return [];
        let activeRange = $200f5cce291452b2$var$computeActiveRange(dateProfile, Boolean(nextDayThreshold));
        let activeDateSpanRange = $200f5cce291452b2$export$ae1af26003f05816(dateSpan.range, activeRange);
        if (activeDateSpanRange) {
            dateSpan = Object.assign(Object.assign({}, dateSpan), {
                range: activeDateSpanRange
            });
            let eventRange = $200f5cce291452b2$var$fabricateEventRange(dateSpan, eventUiBases, context);
            let segs = this.sliceRange(dateSpan.range, ...extraArgs);
            for (let seg of segs)seg.eventRange = eventRange;
            return segs;
        }
        return [];
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRanges(eventRanges, extraArgs) {
        let segs = [];
        for (let eventRange of eventRanges)segs.push(...this.sliceEventRange(eventRange, extraArgs));
        return segs;
    }
    /*
    "complete" seg means it has component and eventRange
    */ sliceEventRange(eventRange, extraArgs) {
        let dateRange = eventRange.range;
        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
        if (this.forceDayIfListItem && eventRange.ui.display === "list-item") dateRange = {
            start: dateRange.start,
            end: $200f5cce291452b2$export$625550452a3fa3ec(dateRange.start, 1)
        };
        let segs = this.sliceRange(dateRange, ...extraArgs);
        for (let seg of segs){
            seg.eventRange = eventRange;
            seg.isStart = eventRange.isStart && seg.isStart;
            seg.isEnd = eventRange.isEnd && seg.isEnd;
        }
        return segs;
    }
    constructor(){
        this.sliceBusinessHours = $200f5cce291452b2$export$df995fae86a55f06(this._sliceBusinessHours);
        this.sliceDateSelection = $200f5cce291452b2$export$df995fae86a55f06(this._sliceDateSpan);
        this.sliceEventStore = $200f5cce291452b2$export$df995fae86a55f06(this._sliceEventStore);
        this.sliceEventDrag = $200f5cce291452b2$export$df995fae86a55f06(this._sliceInteraction);
        this.sliceEventResize = $200f5cce291452b2$export$df995fae86a55f06(this._sliceInteraction);
        this.forceDayIfListItem = false; // hack
    }
}
/*
for incorporating slotMinTime/slotMaxTime if appropriate
TODO: should be part of DateProfile!
TimelineDateProfile already does this btw
*/ function $200f5cce291452b2$var$computeActiveRange(dateProfile, isComponentAllDay) {
    let range = dateProfile.activeRange;
    if (isComponentAllDay) return range;
    return {
        start: $200f5cce291452b2$export$136fd86de524d3c2(range.start, dateProfile.slotMinTime.milliseconds),
        end: $200f5cce291452b2$export$136fd86de524d3c2(range.end, dateProfile.slotMaxTime.milliseconds - 864e5)
    };
}
function $200f5cce291452b2$export$3466f893ebf79586(eventStore, action, eventSources, dateProfile, context) {
    switch(action.type){
        case "RECEIVE_EVENTS":
            return $200f5cce291452b2$var$receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
        case "RESET_RAW_EVENTS":
            return $200f5cce291452b2$var$resetRawEvents(eventStore, eventSources[action.sourceId], action.rawEvents, dateProfile.activeRange, context);
        case "ADD_EVENTS":
            return $200f5cce291452b2$var$addEvent(eventStore, action.eventStore, dateProfile ? dateProfile.activeRange : null, context);
        case "RESET_EVENTS":
            return action.eventStore;
        case "MERGE_EVENTS":
            return $200f5cce291452b2$export$317a3d46287192d8(eventStore, action.eventStore);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $200f5cce291452b2$var$expandRecurring(eventStore, dateProfile.activeRange, context);
            return eventStore;
        case "REMOVE_EVENTS":
            return $200f5cce291452b2$var$excludeSubEventStore(eventStore, action.eventStore);
        case "REMOVE_EVENT_SOURCE":
            return $200f5cce291452b2$var$excludeEventsBySourceId(eventStore, action.sourceId);
        case "REMOVE_ALL_EVENT_SOURCES":
            return $200f5cce291452b2$var$filterEventStoreDefs(eventStore, (eventDef)=>!eventDef.sourceId // only keep events with no source id
            );
        case "REMOVE_ALL_EVENTS":
            return $200f5cce291452b2$export$9bb611d729802a56();
        default:
            return eventStore;
    }
}
function $200f5cce291452b2$var$receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
    ) {
        let subset = $200f5cce291452b2$var$parseEvents($200f5cce291452b2$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context);
        if (fetchRange) subset = $200f5cce291452b2$var$expandRecurring(subset, fetchRange, context);
        return $200f5cce291452b2$export$317a3d46287192d8($200f5cce291452b2$var$excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
    }
    return eventStore;
}
function $200f5cce291452b2$var$resetRawEvents(existingEventStore, eventSource, rawEvents, activeRange, context) {
    const { defIdMap: defIdMap, instanceIdMap: instanceIdMap } = $200f5cce291452b2$var$buildPublicIdMaps(existingEventStore);
    let newEventStore = $200f5cce291452b2$var$parseEvents($200f5cce291452b2$var$transformRawEvents(rawEvents, eventSource, context), eventSource, context, false, defIdMap, instanceIdMap);
    return $200f5cce291452b2$var$expandRecurring(newEventStore, activeRange, context);
}
function $200f5cce291452b2$var$transformRawEvents(rawEvents, eventSource, context) {
    let calEachTransform = context.options.eventDataTransform;
    let sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
    if (sourceEachTransform) rawEvents = $200f5cce291452b2$var$transformEachRawEvent(rawEvents, sourceEachTransform);
    if (calEachTransform) rawEvents = $200f5cce291452b2$var$transformEachRawEvent(rawEvents, calEachTransform);
    return rawEvents;
}
function $200f5cce291452b2$var$transformEachRawEvent(rawEvents, func) {
    let refinedEvents;
    if (!func) refinedEvents = rawEvents;
    else {
        refinedEvents = [];
        for (let rawEvent of rawEvents){
            let refinedEvent = func(rawEvent);
            if (refinedEvent) refinedEvents.push(refinedEvent);
            else if (refinedEvent == null) refinedEvents.push(rawEvent);
             // if a different falsy value, do nothing
        }
    }
    return refinedEvents;
}
function $200f5cce291452b2$var$addEvent(eventStore, subset, expandRange, context) {
    if (expandRange) subset = $200f5cce291452b2$var$expandRecurring(subset, expandRange, context);
    return $200f5cce291452b2$export$317a3d46287192d8(eventStore, subset);
}
function $200f5cce291452b2$export$61196ced6d74a310(eventStore, oldDateEnv, newDateEnv) {
    let { defs: defs } = eventStore;
    let instances = $200f5cce291452b2$export$407448d2b89b1813(eventStore.instances, (instance)=>{
        let def = defs[instance.defId];
        if (def.allDay) return instance; // isn't dependent on timezone
        return Object.assign(Object.assign({}, instance), {
            range: {
                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo))
            },
            forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo,
            forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo
        });
    });
    return {
        defs: defs,
        instances: instances
    };
}
function $200f5cce291452b2$var$excludeEventsBySourceId(eventStore, sourceId) {
    return $200f5cce291452b2$var$filterEventStoreDefs(eventStore, (eventDef)=>eventDef.sourceId !== sourceId);
}
// QUESTION: why not just return instances? do a general object-property-exclusion util
function $200f5cce291452b2$var$excludeInstances(eventStore, removals) {
    return {
        defs: eventStore.defs,
        instances: $200f5cce291452b2$export$dda1d9f60106f0e9(eventStore.instances, (instance)=>!removals[instance.instanceId])
    };
}
function $200f5cce291452b2$var$buildPublicIdMaps(eventStore) {
    const { defs: defs, instances: instances } = eventStore;
    const defIdMap = {};
    const instanceIdMap = {};
    for(let defId in defs){
        const def = defs[defId];
        const { publicId: publicId } = def;
        if (publicId) defIdMap[publicId] = defId;
    }
    for(let instanceId in instances){
        const instance = instances[instanceId];
        const def = defs[instance.defId];
        const { publicId: publicId } = def;
        if (publicId) instanceIdMap[publicId] = instanceId;
    }
    return {
        defIdMap: defIdMap,
        instanceIdMap: instanceIdMap
    };
}
// high-level segmenting-aware tester functions
// ------------------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$export$c667925124dac624(interaction, dateProfile, context) {
    let { instances: instances } = interaction.mutatedEvents;
    for(let instanceId in instances){
        if (!$200f5cce291452b2$export$4ae495d48253603d(dateProfile.validRange, instances[instanceId].range)) return false;
    }
    return $200f5cce291452b2$var$isNewPropsValid({
        eventDrag: interaction
    }, context); // HACK: the eventDrag props is used for ALL interactions
}
function $200f5cce291452b2$export$c69d65aa55814164(dateSelection, dateProfile, context) {
    if (!$200f5cce291452b2$export$4ae495d48253603d(dateProfile.validRange, dateSelection.range)) return false;
    return $200f5cce291452b2$var$isNewPropsValid({
        dateSelection: dateSelection
    }, context);
}
function $200f5cce291452b2$var$isNewPropsValid(newProps, context) {
    let calendarState = context.getCurrentData();
    let props = Object.assign({
        businessHours: calendarState.businessHours,
        dateSelection: "",
        eventStore: calendarState.eventStore,
        eventUiBases: calendarState.eventUiBases,
        eventSelection: "",
        eventDrag: null,
        eventResize: null
    }, newProps);
    return (context.pluginHooks.isPropsValid || $200f5cce291452b2$export$545a72cc0d3f00b0)(props, context);
}
function $200f5cce291452b2$export$545a72cc0d3f00b0(state, context, dateSpanMeta = {}, filterConfig) {
    if (state.eventDrag && !$200f5cce291452b2$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    if (state.dateSelection && !$200f5cce291452b2$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) return false;
    return true;
}
// Moving Event Validation
// ------------------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$var$isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let currentState = context.getCurrentData();
    let interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
    let subjectEventStore = interaction.mutatedEvents;
    let subjectDefs = subjectEventStore.defs;
    let subjectInstances = subjectEventStore.instances;
    let subjectConfigs = $200f5cce291452b2$var$compileEventUis(subjectDefs, interaction.isEvent ? state.eventUiBases : {
        "": currentState.selectionConfig
    });
    if (filterConfig) subjectConfigs = $200f5cce291452b2$export$407448d2b89b1813(subjectConfigs, filterConfig);
    // exclude the subject events. TODO: exclude defs too?
    let otherEventStore = $200f5cce291452b2$var$excludeInstances(state.eventStore, interaction.affectedEvents.instances);
    let otherDefs = otherEventStore.defs;
    let otherInstances = otherEventStore.instances;
    let otherConfigs = $200f5cce291452b2$var$compileEventUis(otherDefs, state.eventUiBases);
    for(let subjectInstanceId in subjectInstances){
        let subjectInstance = subjectInstances[subjectInstanceId];
        let subjectRange = subjectInstance.range;
        let subjectConfig = subjectConfigs[subjectInstance.defId];
        let subjectDef = subjectDefs[subjectInstance.defId];
        // constraint
        if (!$200f5cce291452b2$var$allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) return false;
        // overlap
        let { eventOverlap: eventOverlap } = context.options;
        let eventOverlapFunc = typeof eventOverlap === "function" ? eventOverlap : null;
        for(let otherInstanceId in otherInstances){
            let otherInstance = otherInstances[otherInstanceId];
            // intersect! evaluate
            if ($200f5cce291452b2$export$ad4aebacdcaf47f8(subjectRange, otherInstance.range)) {
                let otherOverlap = otherConfigs[otherInstance.defId].overlap;
                // consider the other event's overlap. only do this if the subject event is a "real" event
                if (otherOverlap === false && interaction.isEvent) return false;
                if (subjectConfig.overlap === false) return false;
                if (eventOverlapFunc && !eventOverlapFunc(new $200f5cce291452b2$export$34aec0b863436764(context, otherDefs[otherInstance.defId], otherInstance), new $200f5cce291452b2$export$34aec0b863436764(context, subjectDef, subjectInstance))) return false;
            }
        }
        // allow (a function)
        let calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
        for (let subjectAllow of subjectConfig.allows){
            let subjectDateSpan = Object.assign(Object.assign({}, dateSpanMeta), {
                range: subjectInstance.range,
                allDay: subjectDef.allDay
            });
            let origDef = calendarEventStore.defs[subjectDef.defId];
            let origInstance = calendarEventStore.instances[subjectInstanceId];
            let eventApi;
            if (origDef) eventApi = new $200f5cce291452b2$export$34aec0b863436764(context, origDef, origInstance);
            else eventApi = new $200f5cce291452b2$export$34aec0b863436764(context, subjectDef); // no instance, because had no dates
            if (!subjectAllow($200f5cce291452b2$var$buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) return false;
        }
    }
    return true;
}
// Date Selection Validation
// ------------------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$var$isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
    let relevantEventStore = state.eventStore;
    let relevantDefs = relevantEventStore.defs;
    let relevantInstances = relevantEventStore.instances;
    let selection = state.dateSelection;
    let selectionRange = selection.range;
    let { selectionConfig: selectionConfig } = context.getCurrentData();
    if (filterConfig) selectionConfig = filterConfig(selectionConfig);
    // constraint
    if (!$200f5cce291452b2$var$allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) return false;
    // overlap
    let { selectOverlap: selectOverlap } = context.options;
    let selectOverlapFunc = typeof selectOverlap === "function" ? selectOverlap : null;
    for(let relevantInstanceId in relevantInstances){
        let relevantInstance = relevantInstances[relevantInstanceId];
        // intersect! evaluate
        if ($200f5cce291452b2$export$ad4aebacdcaf47f8(selectionRange, relevantInstance.range)) {
            if (selectionConfig.overlap === false) return false;
            if (selectOverlapFunc && !selectOverlapFunc(new $200f5cce291452b2$export$34aec0b863436764(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) return false;
        }
    }
    // allow (a function)
    for (let selectionAllow of selectionConfig.allows){
        let fullDateSpan = Object.assign(Object.assign({}, dateSpanMeta), selection);
        if (!selectionAllow($200f5cce291452b2$var$buildDateSpanApiWithContext(fullDateSpan, context), null)) return false;
    }
    return true;
}
// Constraint Utils
// ------------------------------------------------------------------------------------------------------------------------
function $200f5cce291452b2$var$allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    for (let constraint of constraints){
        if (!$200f5cce291452b2$var$anyRangesContainRange($200f5cce291452b2$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) return false;
    }
    return true;
}
function $200f5cce291452b2$var$constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
    if (constraint === "businessHours") return $200f5cce291452b2$var$eventStoreToRanges($200f5cce291452b2$var$expandRecurring(businessHoursUnexpanded, subjectRange, context));
    if (typeof constraint === "string") return $200f5cce291452b2$var$eventStoreToRanges($200f5cce291452b2$var$filterEventStoreDefs(otherEventStore, (eventDef)=>eventDef.groupId === constraint));
    if (typeof constraint === "object" && constraint) return $200f5cce291452b2$var$eventStoreToRanges($200f5cce291452b2$var$expandRecurring(constraint, subjectRange, context));
    return []; // if it's false
}
// TODO: move to event-store file?
function $200f5cce291452b2$var$eventStoreToRanges(eventStore) {
    let { instances: instances } = eventStore;
    let ranges = [];
    for(let instanceId in instances)ranges.push(instances[instanceId].range);
    return ranges;
}
// TODO: move to geom file?
function $200f5cce291452b2$var$anyRangesContainRange(outerRanges, innerRange) {
    for (let outerRange of outerRanges){
        if ($200f5cce291452b2$export$4ae495d48253603d(outerRange, innerRange)) return true;
    }
    return false;
}
class $200f5cce291452b2$export$ee7c8ad385a60b7b extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
function $200f5cce291452b2$export$43caf9889c228507(method, url, params) {
    method = method.toUpperCase();
    const fetchOptions = {
        method: method
    };
    if (method === "GET") url += (url.indexOf("?") === -1 ? "?" : "&") + new URLSearchParams(params);
    else {
        fetchOptions.body = new URLSearchParams(params);
        fetchOptions.headers = {
            "Content-Type": "application/x-www-form-urlencoded"
        };
    }
    return fetch(url, fetchOptions).then((fetchRes)=>{
        if (fetchRes.ok) return fetchRes.json().then((parsedResponse)=>{
            return [
                parsedResponse,
                fetchRes
            ];
        }, ()=>{
            throw new $200f5cce291452b2$export$ee7c8ad385a60b7b("Failure parsing JSON", fetchRes);
        });
        else throw new $200f5cce291452b2$export$ee7c8ad385a60b7b("Request failed", fetchRes);
    });
}
class $200f5cce291452b2$export$96f57966bedc81b4 {
    request(delay) {
        this.isDirty = true;
        if (!this.isPaused()) {
            this.clearTimeout();
            if (delay == null) this.tryDrain();
            else this.timeoutId = setTimeout(this.tryDrain.bind(this), delay);
        }
    }
    pause(scope = "") {
        let { pauseDepths: pauseDepths } = this;
        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
        this.clearTimeout();
    }
    resume(scope = "", force) {
        let { pauseDepths: pauseDepths } = this;
        if (scope in pauseDepths) {
            if (force) delete pauseDepths[scope];
            else {
                pauseDepths[scope] -= 1;
                let depth = pauseDepths[scope];
                if (depth <= 0) delete pauseDepths[scope];
            }
            this.tryDrain();
        }
    }
    isPaused() {
        return Object.keys(this.pauseDepths).length;
    }
    tryDrain() {
        if (!this.isRunning && !this.isPaused()) {
            this.isRunning = true;
            while(this.isDirty){
                this.isDirty = false;
                this.drained(); // might set isDirty to true again
            }
            this.isRunning = false;
        }
    }
    clear() {
        this.clearTimeout();
        this.isDirty = false;
        this.pauseDepths = {};
    }
    clearTimeout() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
    drained() {
        if (this.drainedOption) this.drainedOption();
    }
    constructor(drainedOption){
        this.drainedOption = drainedOption;
        this.isRunning = false;
        this.isDirty = false;
        this.pauseDepths = {};
        this.timeoutId = 0;
    }
}
const $200f5cce291452b2$var$VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
class $200f5cce291452b2$export$807f1ba34db587c7 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { liquid: liquid, liquidIsAbsolute: liquidIsAbsolute } = props;
        let isAbsolute = liquid && liquidIsAbsolute;
        let className = [
            "fc-scroller"
        ];
        if (liquid) {
            if (liquidIsAbsolute) className.push("fc-scroller-liquid-absolute");
            else className.push("fc-scroller-liquid");
        }
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            ref: this.handleEl,
            className: className.join(" "),
            style: {
                overflowX: props.overflowX,
                overflowY: props.overflowY,
                left: isAbsolute && -(props.overcomeLeft || 0) || "",
                right: isAbsolute && -(props.overcomeRight || 0) || "",
                bottom: isAbsolute && -(props.overcomeBottom || 0) || "",
                marginLeft: !isAbsolute && -(props.overcomeLeft || 0) || "",
                marginRight: !isAbsolute && -(props.overcomeRight || 0) || "",
                marginBottom: !isAbsolute && -(props.overcomeBottom || 0) || "",
                maxHeight: props.maxHeight || ""
            }
        }, props.children);
    }
    needsXScrolling() {
        if ($200f5cce291452b2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return false;
        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().width > realClientWidth) return true;
        }
        return false;
    }
    needsYScrolling() {
        if ($200f5cce291452b2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return false;
        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
        // inner-child margins and absolute positioning
        let { el: el } = this;
        let realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
        let { children: children } = el;
        for(let i = 0; i < children.length; i += 1){
            let childEl = children[i];
            if (childEl.getBoundingClientRect().height > realClientHeight) return true;
        }
        return false;
    }
    getXScrollbarWidth() {
        if ($200f5cce291452b2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowX)) return 0;
        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    getYScrollbarWidth() {
        if ($200f5cce291452b2$var$VISIBLE_HIDDEN_RE.test(this.props.overflowY)) return 0;
        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
    }
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            $200f5cce291452b2$export$8743009a87fcb00f(this.props.elRef, el);
        };
    }
}
/*
TODO: somehow infer OtherArgs from masterCallback?
TODO: infer RefType from masterCallback if provided
*/ class $200f5cce291452b2$export$49e6ee724f7f1ace {
    createRef(key) {
        let refCallback = this.callbackMap[key];
        if (!refCallback) refCallback = this.callbackMap[key] = (val)=>{
            this.handleValue(val, String(key));
        };
        return refCallback;
    }
    // TODO: check callers that don't care about order. should use getAll instead
    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
    collect(startIndex, endIndex, step) {
        return $200f5cce291452b2$export$91477dc880baac21(this.currentMap, startIndex, endIndex, step);
    }
    getAll() {
        return $200f5cce291452b2$export$90a7f3efeed30595(this.currentMap);
    }
    constructor(masterCallback){
        this.masterCallback = masterCallback;
        this.currentMap = {};
        this.depths = {};
        this.callbackMap = {};
        this.handleValue = (val, key)=>{
            let { depths: depths, currentMap: currentMap } = this;
            let removed = false;
            let added = false;
            if (val !== null) {
                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
                removed = key in currentMap;
                currentMap[key] = val;
                depths[key] = (depths[key] || 0) + 1;
                added = true;
            } else {
                depths[key] -= 1;
                if (!depths[key]) {
                    delete currentMap[key];
                    delete this.callbackMap[key];
                    removed = true;
                }
            }
            if (this.masterCallback) {
                if (removed) this.masterCallback(null, String(key));
                if (added) this.masterCallback(val, String(key));
            }
        };
    }
}
function $200f5cce291452b2$export$f5339a28e56d1baf(chunkEls) {
    let shrinkCells = $200f5cce291452b2$export$9f4f30ee63539e24(chunkEls, ".fc-scrollgrid-shrink");
    let largestWidth = 0;
    for (let shrinkCell of shrinkCells)largestWidth = Math.max(largestWidth, $200f5cce291452b2$var$computeSmallestCellWidth(shrinkCell));
    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
}
function $200f5cce291452b2$export$4f33f238a5c1ad77(props, sectionConfig) {
    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
}
function $200f5cce291452b2$export$7fe88b5920ffddd2(props, sectionConfig) {
    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
    $200f5cce291452b2$export$4f33f238a5c1ad77(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
}
// TODO: ONLY use `arg`. force out internal function to use same API
function $200f5cce291452b2$export$df7c425476ed4f2(sectionConfig, chunkConfig, arg, isHeader) {
    let { expandRows: expandRows } = arg;
    let content = typeof chunkConfig.content === "function" ? chunkConfig.content(arg) : (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("table", {
        role: "presentation",
        className: [
            chunkConfig.tableClassName,
            sectionConfig.syncRowHeights ? "fc-scrollgrid-sync-table" : ""
        ].join(" "),
        style: {
            minWidth: arg.tableMinWidth,
            width: arg.clientWidth,
            height: expandRows ? arg.clientHeight : ""
        }
    }, arg.tableColGroupNode, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(isHeader ? "thead" : "tbody", {
        role: "presentation"
    }, typeof chunkConfig.rowContent === "function" ? chunkConfig.rowContent(arg) : chunkConfig.rowContent));
    return content;
}
function $200f5cce291452b2$export$4ad369a19af21c23(cols0, cols1) {
    return $200f5cce291452b2$export$23f2a1d2818174ef(cols0, cols1, $200f5cce291452b2$export$a9c23c6ac3fc3eca);
}
function $200f5cce291452b2$export$101619b11a34a0bd(cols, shrinkWidth) {
    let colNodes = [];
    /*
    for ColProps with spans, it would have been great to make a single <col span="">
    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
    SOLUTION: making individual <col> elements makes Chrome behave.
    */ for (let colProps of cols){
        let span = colProps.span || 1;
        for(let i = 0; i < span; i += 1)colNodes.push((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("col", {
            style: {
                width: colProps.width === "shrink" ? $200f5cce291452b2$export$1ec7a8278ebd1290(shrinkWidth) : colProps.width || "",
                minWidth: colProps.minWidth || ""
            }
        }));
    }
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("colgroup", {}, ...colNodes);
}
function $200f5cce291452b2$export$1ec7a8278ebd1290(shrinkWidth) {
    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
    4 accounts for 2 2-pixel borders. TODO: better solution? */ return shrinkWidth == null ? 4 : shrinkWidth;
}
function $200f5cce291452b2$export$65ab0ebced932b79(cols) {
    for (let col of cols){
        if (col.width === "shrink") return true;
    }
    return false;
}
function $200f5cce291452b2$export$60e660859c376841(liquid, context) {
    let classNames = [
        "fc-scrollgrid",
        context.theme.getClass("table")
    ];
    if (liquid) classNames.push("fc-scrollgrid-liquid");
    return classNames;
}
function $200f5cce291452b2$export$df838d0240c938cf(sectionConfig, wholeTableVGrow) {
    let classNames = [
        "fc-scrollgrid-section",
        `fc-scrollgrid-section-${sectionConfig.type}`,
        sectionConfig.className
    ];
    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) classNames.push("fc-scrollgrid-section-liquid");
    if (sectionConfig.isSticky) classNames.push("fc-scrollgrid-section-sticky");
    return classNames;
}
function $200f5cce291452b2$export$89e9012e902952b6(arg) {
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-scrollgrid-sticky-shim",
        style: {
            width: arg.clientWidth,
            minWidth: arg.tableMinWidth
        }
    });
}
function $200f5cce291452b2$export$a1edd97dd51cd48d(options) {
    let { stickyHeaderDates: stickyHeaderDates } = options;
    if (stickyHeaderDates == null || stickyHeaderDates === "auto") stickyHeaderDates = options.height === "auto" || options.viewHeight === "auto";
    return stickyHeaderDates;
}
function $200f5cce291452b2$export$54c4fabc2291e9c0(options) {
    let { stickyFooterScrollbar: stickyFooterScrollbar } = options;
    if (stickyFooterScrollbar == null || stickyFooterScrollbar === "auto") stickyFooterScrollbar = options.height === "auto" || options.viewHeight === "auto";
    return stickyFooterScrollbar;
}
class $200f5cce291452b2$export$add49c223b9ce4ea extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props, state: state, context: context } = this;
        let sectionConfigs = props.sections || [];
        let cols = this.processCols(props.cols);
        let microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
        let classNames = $200f5cce291452b2$export$60e660859c376841(props.liquid, context);
        if (props.collapsibleWidth) classNames.push("fc-scrollgrid-collapsible");
        // TODO: make DRY
        let configCnt = sectionConfigs.length;
        let configI = 0;
        let currentConfig;
        let headSectionNodes = [];
        let bodySectionNodes = [];
        let footSectionNodes = [];
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "header"){
            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "body"){
            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
            configI += 1;
        }
        while(configI < configCnt && (currentConfig = sectionConfigs[configI]).type === "footer"){
            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
            configI += 1;
        }
        // firefox bug: when setting height on table and there is a thead or tfoot,
        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
        // if so, use a simpler dom structure, jam everything into a lone tbody.
        let isBuggy = !$200f5cce291452b2$export$667d3bf0c5f83305();
        const roleAttrs = {
            role: "rowgroup"
        };
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("table", {
            role: "grid",
            className: classNames.join(" "),
            style: {
                height: props.height
            }
        }, Boolean(!isBuggy && headSectionNodes.length) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("thead", roleAttrs, ...headSectionNodes), Boolean(!isBuggy && bodySectionNodes.length) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tbody", roleAttrs, ...bodySectionNodes), Boolean(!isBuggy && footSectionNodes.length) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tfoot", roleAttrs, ...footSectionNodes), isBuggy && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tbody", roleAttrs, ...headSectionNodes, ...bodySectionNodes, ...footSectionNodes));
    }
    renderSection(sectionConfig, microColGroupNode, isHeader) {
        if ("outerContent" in sectionConfig) return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), {
            key: sectionConfig.key
        }, sectionConfig.outerContent);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
            key: sectionConfig.key,
            role: "presentation",
            className: $200f5cce291452b2$export$df838d0240c938cf(sectionConfig, this.props.liquid).join(" ")
        }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader));
    }
    renderChunkTd(sectionConfig, microColGroupNode, chunkConfig, isHeader) {
        if ("outerContent" in chunkConfig) return chunkConfig.outerContent;
        let { props: props } = this;
        let { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights } = this.state;
        let needsYScrolling = $200f5cce291452b2$export$7fe88b5920ffddd2(props, sectionConfig); // TODO: do lazily. do in section config?
        let isLiquid = $200f5cce291452b2$export$4f33f238a5c1ad77(props, sectionConfig);
        // for `!props.liquid` - is WHOLE scrollgrid natural height?
        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
        let overflowY = !props.liquid ? "visible" : forceYScrollbars ? "scroll" : !needsYScrolling ? "hidden" : "auto";
        let sectionKey = sectionConfig.key;
        let content = $200f5cce291452b2$export$df7c425476ed4f2(sectionConfig, chunkConfig, {
            tableColGroupNode: microColGroupNode,
            tableMinWidth: "",
            clientWidth: !props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined ? scrollerClientWidths[sectionKey] : null,
            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
            expandRows: sectionConfig.expandRows,
            syncRowHeights: false,
            rowSyncHeights: [],
            reportRowHeightChange: ()=>{}
        }, isHeader);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(isHeader ? "th" : "td", {
            ref: chunkConfig.elRef,
            role: "presentation"
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: `fc-scroller-harness${isLiquid ? " fc-scroller-harness-liquid" : ""}`
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$807f1ba34db587c7, {
            ref: this.scrollerRefs.createRef(sectionKey),
            elRef: this.scrollerElRefs.createRef(sectionKey),
            overflowY: overflowY,
            overflowX: !props.liquid ? "visible" : "hidden" /* natural height? */ ,
            maxHeight: sectionConfig.maxHeight,
            liquid: isLiquid,
            liquidIsAbsolute: true
        }, content)));
    }
    _handleScrollerEl(scrollerEl, key) {
        let section = $200f5cce291452b2$var$getSectionByKey(this.props.sections, key);
        if (section) $200f5cce291452b2$export$8743009a87fcb00f(section.chunk.scrollerElRef, scrollerEl);
    }
    componentDidMount() {
        this.handleSizing();
        this.context.addResizeHandler(this.handleSizing);
    }
    componentDidUpdate() {
        // TODO: need better solution when state contains non-sizing things
        this.handleSizing();
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleSizing);
    }
    computeShrinkWidth() {
        return $200f5cce291452b2$export$65ab0ebced932b79(this.props.cols) ? $200f5cce291452b2$export$f5339a28e56d1baf(this.scrollerElRefs.getAll()) : 0;
    }
    computeScrollerDims() {
        let scrollbarWidth = $200f5cce291452b2$export$c7ca7e4bc4f8a16e();
        let { scrollerRefs: scrollerRefs, scrollerElRefs: scrollerElRefs } = this;
        let forceYScrollbars = false;
        let scrollerClientWidths = {};
        let scrollerClientHeights = {};
        for(let sectionKey in scrollerRefs.currentMap){
            let scroller = scrollerRefs.currentMap[sectionKey];
            if (scroller && scroller.needsYScrolling()) {
                forceYScrollbars = true;
                break;
            }
        }
        for (let section of this.props.sections){
            let sectionKey = section.key;
            let scrollerEl = scrollerElRefs.currentMap[sectionKey];
            if (scrollerEl) {
                let harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
                 : 0));
                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
            }
        }
        return {
            forceYScrollbars: forceYScrollbars,
            scrollerClientWidths: scrollerClientWidths,
            scrollerClientHeights: scrollerClientHeights
        };
    }
    constructor(){
        super(...arguments);
        this.processCols = $200f5cce291452b2$export$df995fae86a55f06((a)=>a, $200f5cce291452b2$export$4ad369a19af21c23); // so we get same `cols` props every time
        // yucky to memoize VNodes, but much more efficient for consumers
        this.renderMicroColGroup = $200f5cce291452b2$export$df995fae86a55f06($200f5cce291452b2$export$101619b11a34a0bd);
        this.scrollerRefs = new $200f5cce291452b2$export$49e6ee724f7f1ace();
        this.scrollerElRefs = new $200f5cce291452b2$export$49e6ee724f7f1ace(this._handleScrollerEl.bind(this));
        this.state = {
            shrinkWidth: null,
            forceYScrollbars: false,
            scrollerClientWidths: {},
            scrollerClientHeights: {}
        };
        // TODO: can do a really simple print-view. dont need to join rows
        this.handleSizing = ()=>{
            this.safeSetState(Object.assign({
                shrinkWidth: this.computeShrinkWidth()
            }, this.computeScrollerDims()));
        };
    }
}
$200f5cce291452b2$export$add49c223b9ce4ea.addStateEquality({
    scrollerClientWidths: $200f5cce291452b2$export$a9c23c6ac3fc3eca,
    scrollerClientHeights: $200f5cce291452b2$export$a9c23c6ac3fc3eca
});
function $200f5cce291452b2$var$getSectionByKey(sections, key) {
    for (let section of sections){
        if (section.key === key) return section;
    }
    return null;
}
class $200f5cce291452b2$export$1343a74baacb0543 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        const { props: props, context: context } = this;
        const { options: options } = context;
        const { seg: seg } = props;
        const { eventRange: eventRange } = seg;
        const { ui: ui } = eventRange;
        const renderProps = {
            event: new $200f5cce291452b2$export$34aec0b863436764(context, eventRange.def, eventRange.instance),
            view: context.viewApi,
            timeText: props.timeText,
            textColor: ui.textColor,
            backgroundColor: ui.backgroundColor,
            borderColor: ui.borderColor,
            isDraggable: !props.disableDragging && $200f5cce291452b2$var$computeSegDraggable(seg, context),
            isStartResizable: !props.disableResizing && $200f5cce291452b2$var$computeSegStartResizable(seg, context),
            isEndResizable: !props.disableResizing && $200f5cce291452b2$var$computeSegEndResizable(seg),
            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
            isStart: Boolean(seg.isStart),
            isEnd: Boolean(seg.isEnd),
            isPast: Boolean(props.isPast),
            isFuture: Boolean(props.isFuture),
            isToday: Boolean(props.isToday),
            isSelected: Boolean(props.isSelected),
            isDragging: Boolean(props.isDragging),
            isResizing: Boolean(props.isResizing)
        };
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, Object.assign({}, props /* contains children */ , {
            elRef: this.handleEl,
            elClasses: [
                ...$200f5cce291452b2$var$getEventClassNames(renderProps),
                ...seg.eventRange.ui.classNames,
                ...props.elClasses || []
            ],
            renderProps: renderProps,
            generatorName: "eventContent",
            customGenerator: options.eventContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: options.eventClassNames,
            didMount: options.eventDidMount,
            willUnmount: options.eventWillUnmount
        }));
    }
    componentDidUpdate(prevProps) {
        if (this.el && this.props.seg !== prevProps.seg) $200f5cce291452b2$var$setElSeg(this.el, this.props.seg);
    }
    constructor(){
        super(...arguments);
        this.handleEl = (el)=>{
            this.el = el;
            if (el) $200f5cce291452b2$var$setElSeg(el, this.props.seg);
        };
    }
}
// should not be a purecomponent
class $200f5cce291452b2$export$d92db8a7dc823bb0 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let { ui: ui } = seg.eventRange;
        let timeFormat = options.eventTimeFormat || props.defaultTimeFormat;
        let timeText = $200f5cce291452b2$export$993a080e5cb62d74(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$1343a74baacb0543, Object.assign({}, props /* includes elRef */ , {
            elTag: "a",
            elStyle: {
                borderColor: ui.borderColor,
                backgroundColor: ui.backgroundColor
            },
            elAttrs: $200f5cce291452b2$export$e0c3a065614c6254(seg, context),
            defaultGenerator: $200f5cce291452b2$var$renderInnerContent$1,
            timeText: timeText
        }), (InnerContent, eventContentArg)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-event-main"
                ],
                elStyle: {
                    color: eventContentArg.textColor
                }
            }), Boolean(eventContentArg.isStartResizable) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-start"
            }), Boolean(eventContentArg.isEndResizable) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-event-resizer fc-event-resizer-end"
            })));
    }
}
function $200f5cce291452b2$var$renderInnerContent$1(innerProps) {
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-main-frame"
    }, innerProps.timeText && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, innerProps.timeText), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title-container"
    }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title fc-sticky"
    }, innerProps.event.title || (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, "\xa0"))));
}
const $200f5cce291452b2$export$c1df809846363ebe = (props)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { options: options } = context;
        let renderProps = {
            isAxis: props.isAxis,
            date: context.dateEnv.toDate(props.date),
            view: context.viewApi
        };
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elTag: props.elTag || "div",
            renderProps: renderProps,
            generatorName: "nowIndicatorContent",
            customGenerator: options.nowIndicatorContent,
            classNameGenerator: options.nowIndicatorClassNames,
            didMount: options.nowIndicatorDidMount,
            willUnmount: options.nowIndicatorWillUnmount
        }));
    });
const $200f5cce291452b2$var$DAY_NUM_FORMAT = $200f5cce291452b2$export$d141bba7fdc215a3({
    day: "numeric"
});
class $200f5cce291452b2$export$b975d55abac2bbe3 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = this.refineRenderProps({
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            isMonthStart: props.isMonthStart || false,
            showDayNumber: props.showDayNumber,
            extraRenderProps: props.extraRenderProps,
            viewApi: context.viewApi,
            dateEnv: context.dateEnv,
            monthStartFormat: options.monthStartFormat
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, Object.assign({}, props /* includes children */ , {
            elClasses: [
                ...$200f5cce291452b2$export$527e9aa3390079e9(renderProps, context.theme),
                ...props.elClasses || []
            ],
            elAttrs: Object.assign(Object.assign({}, props.elAttrs), renderProps.isDisabled ? {} : {
                "data-date": $200f5cce291452b2$export$5dbe06c6d8c68cfb(props.date)
            }),
            renderProps: renderProps,
            generatorName: "dayCellContent",
            customGenerator: options.dayCellContent,
            defaultGenerator: props.defaultGenerator,
            classNameGenerator: // don't use custom classNames if disabled
            renderProps.isDisabled ? undefined : options.dayCellClassNames,
            didMount: options.dayCellDidMount,
            willUnmount: options.dayCellWillUnmount
        }));
    }
    constructor(){
        super(...arguments);
        this.refineRenderProps = $200f5cce291452b2$export$ebd11618f299a286($200f5cce291452b2$var$refineRenderProps);
    }
}
function $200f5cce291452b2$export$b02498c06ddfef28(options) {
    return Boolean(options.dayCellContent || $200f5cce291452b2$var$hasCustomRenderingHandler("dayCellContent", options));
}
function $200f5cce291452b2$var$refineRenderProps(raw) {
    let { date: date, dateEnv: dateEnv, dateProfile: dateProfile, isMonthStart: isMonthStart } = raw;
    let dayMeta = $200f5cce291452b2$export$a17c37559e1db147(date, raw.todayRange, null, dateProfile);
    let dayNumberText = raw.showDayNumber ? dateEnv.format(date, isMonthStart ? raw.monthStartFormat : $200f5cce291452b2$var$DAY_NUM_FORMAT) : "";
    return Object.assign(Object.assign(Object.assign({
        date: dateEnv.toDate(date),
        view: raw.viewApi
    }, dayMeta), {
        isMonthStart: isMonthStart,
        dayNumberText: dayNumberText
    }), raw.extraRenderProps);
}
class $200f5cce291452b2$export$cd571ca6d1702b73 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props } = this;
        let { seg: seg } = props;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$1343a74baacb0543, {
            elTag: "div",
            elClasses: [
                "fc-bg-event"
            ],
            elStyle: {
                backgroundColor: seg.eventRange.ui.backgroundColor
            },
            defaultGenerator: $200f5cce291452b2$var$renderInnerContent,
            seg: seg,
            timeText: "",
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: false,
            isPast: props.isPast,
            isFuture: props.isFuture,
            isToday: props.isToday,
            disableDragging: true,
            disableResizing: true
        });
    }
}
function $200f5cce291452b2$var$renderInnerContent(props) {
    let { title: title } = props.event;
    return title && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, props.event.title);
}
function $200f5cce291452b2$export$87b6ab1c2cb8b955(fillType) {
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: `fc-${fillType}`
    });
}
const $200f5cce291452b2$export$a3c9165b94390bcd = (props)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7c866399fa523f5.Consumer, null, (context)=>{
        let { dateEnv: dateEnv, options: options } = context;
        let { date: date } = props;
        let format = options.weekNumberFormat || props.defaultFormat;
        let num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
        let text = dateEnv.format(date, format);
        let renderProps = {
            num: num,
            text: text,
            date: date
        };
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b // why isn't WeekNumberContentArg being auto-detected?
        , Object.assign({}, props /* includes children */ , {
            renderProps: renderProps,
            generatorName: "weekNumberContent",
            customGenerator: options.weekNumberContent,
            defaultGenerator: $200f5cce291452b2$var$renderInner,
            classNameGenerator: options.weekNumberClassNames,
            didMount: options.weekNumberDidMount,
            willUnmount: options.weekNumberWillUnmount
        }));
    });
function $200f5cce291452b2$var$renderInner(innerProps) {
    return innerProps.text;
}
const $200f5cce291452b2$var$PADDING_FROM_VIEWPORT = 10;
class $200f5cce291452b2$var$Popover extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { theme: theme, options: options } = this.context;
        let { props: props, state: state } = this;
        let classNames = [
            "fc-popover",
            theme.getClass("popover")
        ].concat(props.extraClassNames || []);
        return (0, $851e87f7aebddd87$export$d39a5bbd09211389)((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", Object.assign({}, props.extraAttrs, {
            id: props.id,
            className: classNames.join(" "),
            "aria-labelledby": state.titleId,
            ref: this.handleRootEl
        }), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-popover-header " + theme.getClass("popoverHeader")
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("span", {
            className: "fc-popover-title",
            id: state.titleId
        }, props.title), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("span", {
            className: "fc-popover-close " + theme.getIconClass("close"),
            title: options.closeHint,
            onClick: this.handleCloseClick
        })), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-popover-body " + theme.getClass("popoverContent")
        }, props.children)), props.parentEl);
    }
    componentDidMount() {
        document.addEventListener("mousedown", this.handleDocumentMouseDown);
        document.addEventListener("keydown", this.handleDocumentKeyDown);
        this.updateSize();
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleDocumentMouseDown);
        document.removeEventListener("keydown", this.handleDocumentKeyDown);
    }
    updateSize() {
        let { isRtl: isRtl } = this.context;
        let { alignmentEl: alignmentEl, alignGridTop: alignGridTop } = this.props;
        let { rootEl: rootEl } = this;
        let alignmentRect = $200f5cce291452b2$var$computeClippedClientRect(alignmentEl);
        if (alignmentRect) {
            let popoverDims = rootEl.getBoundingClientRect();
            // position relative to viewport
            let popoverTop = alignGridTop ? $200f5cce291452b2$export$3d8c2f653ac9d0b9(alignmentEl, ".fc-scrollgrid").getBoundingClientRect().top : alignmentRect.top;
            let popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
            // constrain
            popoverTop = Math.max(popoverTop, $200f5cce291452b2$var$PADDING_FROM_VIEWPORT);
            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - $200f5cce291452b2$var$PADDING_FROM_VIEWPORT - popoverDims.width);
            popoverLeft = Math.max(popoverLeft, $200f5cce291452b2$var$PADDING_FROM_VIEWPORT);
            let origin = rootEl.offsetParent.getBoundingClientRect();
            $200f5cce291452b2$export$2ed0fc6709e59212(rootEl, {
                top: popoverTop - origin.top,
                left: popoverLeft - origin.left
            });
        }
    }
    constructor(){
        super(...arguments);
        this.state = {
            titleId: $200f5cce291452b2$export$a8550f7dbe79f93a()
        };
        this.handleRootEl = (el)=>{
            this.rootEl = el;
            if (this.props.elRef) $200f5cce291452b2$export$8743009a87fcb00f(this.props.elRef, el);
        };
        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
        this.handleDocumentMouseDown = (ev)=>{
            // only hide the popover if the click happened outside the popover
            const target = $200f5cce291452b2$export$738ab4df8bf92ae9(ev);
            if (!this.rootEl.contains(target)) this.handleCloseClick();
        };
        this.handleDocumentKeyDown = (ev)=>{
            if (ev.key === "Escape") this.handleCloseClick();
        };
        this.handleCloseClick = ()=>{
            let { onClose: onClose } = this.props;
            if (onClose) onClose();
        };
    }
}
class $200f5cce291452b2$var$MorePopover extends $200f5cce291452b2$export$51b138e5a065c2bb {
    render() {
        let { options: options, dateEnv: dateEnv } = this.context;
        let { props: props } = this;
        let { startDate: startDate, todayRange: todayRange, dateProfile: dateProfile } = props;
        let title = dateEnv.format(startDate, options.dayPopoverFormat);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$b975d55abac2bbe3, {
            elRef: this.handleRootEl,
            date: startDate,
            dateProfile: dateProfile,
            todayRange: todayRange
        }, (InnerContent, renderProps, elAttrs)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$var$Popover, {
                elRef: elAttrs.ref,
                id: props.id,
                title: title,
                extraClassNames: [
                    "fc-more-popover"
                ].concat(elAttrs.className || []),
                extraAttrs: elAttrs /* TODO: make these time-based when not whole-day? */ ,
                parentEl: props.parentEl,
                alignmentEl: props.alignmentEl,
                alignGridTop: props.alignGridTop,
                onClose: props.onClose
            }, $200f5cce291452b2$export$b02498c06ddfef28(options) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-more-popover-misc"
                ]
            }), props.children));
    }
    queryHit(positionLeft, positionTop, elWidth, elHeight) {
        let { rootEl: rootEl, props: props } = this;
        if (positionLeft >= 0 && positionLeft < elWidth && positionTop >= 0 && positionTop < elHeight) return {
            dateProfile: props.dateProfile,
            dateSpan: Object.assign({
                allDay: !props.forceTimed,
                range: {
                    start: props.startDate,
                    end: props.endDate
                }
            }, props.extraDateSpan),
            dayEl: rootEl,
            rect: {
                left: 0,
                top: 0,
                right: elWidth,
                bottom: elHeight
            },
            layer: 1
        };
        return null;
    }
    constructor(){
        super(...arguments);
        this.handleRootEl = (rootEl)=>{
            this.rootEl = rootEl;
            if (rootEl) this.context.registerInteractiveComponent(this, {
                el: rootEl,
                useEventCenter: false
            });
            else this.context.unregisterInteractiveComponent(this);
        };
    }
}
class $200f5cce291452b2$export$cbfbec548517f2b6 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props, state: state } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7c866399fa523f5.Consumer, null, (context)=>{
            let { viewApi: viewApi, options: options, calendarApi: calendarApi } = context;
            let { moreLinkText: moreLinkText } = options;
            let { moreCnt: moreCnt } = props;
            let range = $200f5cce291452b2$var$computeRange(props);
            let text = typeof moreLinkText === "function" // TODO: eventually use formatWithOrdinals
             ? moreLinkText.call(calendarApi, moreCnt) : `+${moreCnt} ${moreLinkText}`;
            let hint = $200f5cce291452b2$export$342063e11d6c3cad(options.moreLinkHint, [
                moreCnt
            ], text);
            let renderProps = {
                num: moreCnt,
                shortText: `+${moreCnt}`,
                text: text,
                view: viewApi
            };
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, Boolean(props.moreCnt) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, {
                elTag: props.elTag || "a",
                elRef: this.handleLinkEl,
                elClasses: [
                    ...props.elClasses || [],
                    "fc-more-link"
                ],
                elStyle: props.elStyle,
                elAttrs: Object.assign(Object.assign(Object.assign({}, props.elAttrs), $200f5cce291452b2$var$createAriaClickAttrs(this.handleClick)), {
                    title: hint,
                    "aria-expanded": state.isPopoverOpen,
                    "aria-controls": state.isPopoverOpen ? state.popoverId : ""
                }),
                renderProps: renderProps,
                generatorName: "moreLinkContent",
                customGenerator: options.moreLinkContent,
                defaultGenerator: props.defaultGenerator || $200f5cce291452b2$var$renderMoreLinkInner,
                classNameGenerator: options.moreLinkClassNames,
                didMount: options.moreLinkDidMount,
                willUnmount: options.moreLinkWillUnmount
            }, props.children), state.isPopoverOpen && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$var$MorePopover, {
                id: state.popoverId,
                startDate: range.start,
                endDate: range.end,
                dateProfile: props.dateProfile,
                todayRange: props.todayRange,
                extraDateSpan: props.extraDateSpan,
                parentEl: this.parentEl,
                alignmentEl: props.alignmentElRef ? props.alignmentElRef.current : this.linkEl,
                alignGridTop: props.alignGridTop,
                forceTimed: props.forceTimed,
                onClose: this.handlePopoverClose
            }, props.popoverContent()));
        });
    }
    componentDidMount() {
        this.updateParentEl();
    }
    componentDidUpdate() {
        this.updateParentEl();
    }
    updateParentEl() {
        if (this.linkEl) this.parentEl = $200f5cce291452b2$export$3d8c2f653ac9d0b9(this.linkEl, ".fc-view-harness");
    }
    constructor(){
        super(...arguments);
        this.state = {
            isPopoverOpen: false,
            popoverId: $200f5cce291452b2$export$a8550f7dbe79f93a()
        };
        this.handleLinkEl = (linkEl)=>{
            this.linkEl = linkEl;
            if (this.props.elRef) $200f5cce291452b2$export$8743009a87fcb00f(this.props.elRef, linkEl);
        };
        this.handleClick = (ev)=>{
            let { props: props, context: context } = this;
            let { moreLinkClick: moreLinkClick } = context.options;
            let date = $200f5cce291452b2$var$computeRange(props).start;
            function buildPublicSeg(seg) {
                let { def: def, instance: instance, range: range } = seg.eventRange;
                return {
                    event: new $200f5cce291452b2$export$34aec0b863436764(context, def, instance),
                    start: context.dateEnv.toDate(range.start),
                    end: context.dateEnv.toDate(range.end),
                    isStart: seg.isStart,
                    isEnd: seg.isEnd
                };
            }
            if (typeof moreLinkClick === "function") moreLinkClick = moreLinkClick({
                date: date,
                allDay: Boolean(props.allDayDate),
                allSegs: props.allSegs.map(buildPublicSeg),
                hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
                jsEvent: ev,
                view: context.viewApi
            });
            if (!moreLinkClick || moreLinkClick === "popover") this.setState({
                isPopoverOpen: true
            });
            else if (typeof moreLinkClick === "string") context.calendarApi.zoomTo(date, moreLinkClick);
        };
        this.handlePopoverClose = ()=>{
            this.setState({
                isPopoverOpen: false
            });
        };
    }
}
function $200f5cce291452b2$var$renderMoreLinkInner(props) {
    return props.text;
}
function $200f5cce291452b2$var$computeRange(props) {
    if (props.allDayDate) return {
        start: props.allDayDate,
        end: $200f5cce291452b2$export$625550452a3fa3ec(props.allDayDate, 1)
    };
    let { hiddenSegs: hiddenSegs } = props;
    return {
        start: $200f5cce291452b2$export$bde1ed0f60b38f2f(hiddenSegs),
        end: $200f5cce291452b2$var$computeLatestSegEnd(hiddenSegs)
    };
}
function $200f5cce291452b2$export$bde1ed0f60b38f2f(segs) {
    return segs.reduce($200f5cce291452b2$var$pickEarliestStart).eventRange.range.start;
}
function $200f5cce291452b2$var$pickEarliestStart(seg0, seg1) {
    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
}
function $200f5cce291452b2$var$computeLatestSegEnd(segs) {
    return segs.reduce($200f5cce291452b2$var$pickLatestEnd).eventRange.range.end;
}
function $200f5cce291452b2$var$pickLatestEnd(seg0, seg1) {
    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
}
class $200f5cce291452b2$export$e9316ff9106cdb75 extends $200f5cce291452b2$export$ef35774e6d314e91 {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let renderProps = {
            view: context.viewApi
        };
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($200f5cce291452b2$export$e7094788287c5e9b, Object.assign({}, props, {
            elTag: props.elTag || "div",
            elClasses: [
                ...$200f5cce291452b2$export$8b22cf2602fb60ce(props.viewSpec),
                ...props.elClasses || []
            ],
            renderProps: renderProps,
            classNameGenerator: options.viewClassNames,
            generatorName: undefined,
            didMount: options.viewDidMount,
            willUnmount: options.viewWillUnmount
        }), ()=>props.children);
    }
}
function $200f5cce291452b2$export$8b22cf2602fb60ce(viewSpec) {
    return [
        `fc-${viewSpec.type}-view`,
        "fc-view"
    ];
}
const $200f5cce291452b2$var$EVENT_SOURCE_REFINERS = {
    id: String,
    defaultAllDay: Boolean,
    url: String,
    format: String,
    events: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    eventDataTransform: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    // for any network-related sources
    success: $200f5cce291452b2$export$7ccc53e8f1e7dfc5,
    failure: $200f5cce291452b2$export$7ccc53e8f1e7dfc5
};
function $200f5cce291452b2$export$ffb5f4729a158638(raw, context, refiners = $200f5cce291452b2$export$35e795649ee09318(context)) {
    let rawObj;
    if (typeof raw === "string") rawObj = {
        url: raw
    };
    else if (typeof raw === "function" || Array.isArray(raw)) rawObj = {
        events: raw
    };
    else if (typeof raw === "object" && raw) rawObj = raw;
    if (rawObj) {
        let { refined: refined, extra: extra } = $200f5cce291452b2$export$f38c853ae54ed474(rawObj, refiners);
        let metaRes = $200f5cce291452b2$var$buildEventSourceMeta(refined, context);
        if (metaRes) return {
            _raw: raw,
            isFetching: false,
            latestFetchId: "",
            fetchRange: null,
            defaultAllDay: refined.defaultAllDay,
            eventDataTransform: refined.eventDataTransform,
            success: refined.success,
            failure: refined.failure,
            publicId: refined.id || "",
            sourceId: $200f5cce291452b2$export$39b482c5e57630a8(),
            sourceDefId: metaRes.sourceDefId,
            meta: metaRes.meta,
            ui: $200f5cce291452b2$export$71cec2538cb2c617(refined, context),
            extendedProps: extra
        };
    }
    return null;
}
function $200f5cce291452b2$export$35e795649ee09318(context) {
    return Object.assign(Object.assign(Object.assign({}, $200f5cce291452b2$var$EVENT_UI_REFINERS), $200f5cce291452b2$var$EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
}
function $200f5cce291452b2$var$buildEventSourceMeta(raw, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    for(let i = defs.length - 1; i >= 0; i -= 1){
        let def = defs[i];
        let meta = def.parseMeta(raw);
        if (meta) return {
            sourceDefId: i,
            meta: meta
        };
    }
    return null;
}
class $200f5cce291452b2$export$a9c996f45e5784d0 {
    getCurrentData() {
        return this.currentDataManager.getCurrentData();
    }
    dispatch(action) {
        this.currentDataManager.dispatch(action);
    }
    get view() {
        return this.getCurrentData().viewApi;
    }
    batchRendering(callback) {
        callback();
    }
    updateSize() {
        this.trigger("_resize", true);
    }
    // Options
    // -----------------------------------------------------------------------------------------------------------------
    setOption(name, val) {
        this.dispatch({
            type: "SET_OPTION",
            optionName: name,
            rawOptionValue: val
        });
    }
    getOption(name) {
        return this.currentDataManager.currentCalendarOptionsInput[name];
    }
    getAvailableLocaleCodes() {
        return Object.keys(this.getCurrentData().availableRawLocales);
    }
    // Trigger
    // -----------------------------------------------------------------------------------------------------------------
    on(handlerName, handler) {
        let { currentDataManager: currentDataManager } = this;
        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) currentDataManager.emitter.on(handlerName, handler);
        else console.warn(`Unknown listener name '${handlerName}'`);
    }
    off(handlerName, handler) {
        this.currentDataManager.emitter.off(handlerName, handler);
    }
    // not meant for public use
    trigger(handlerName, ...args) {
        this.currentDataManager.emitter.trigger(handlerName, ...args);
    }
    // View
    // -----------------------------------------------------------------------------------------------------------------
    changeView(viewType, dateOrRange) {
        this.batchRendering(()=>{
            this.unselect();
            if (dateOrRange) {
                if (dateOrRange.start && dateOrRange.end) {
                    this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType
                    });
                    this.dispatch({
                        type: "SET_OPTION",
                        optionName: "visibleRange",
                        rawOptionValue: dateOrRange
                    });
                } else {
                    let { dateEnv: dateEnv } = this.getCurrentData();
                    this.dispatch({
                        type: "CHANGE_VIEW_TYPE",
                        viewType: viewType,
                        dateMarker: dateEnv.createMarker(dateOrRange)
                    });
                }
            } else this.dispatch({
                type: "CHANGE_VIEW_TYPE",
                viewType: viewType
            });
        });
    }
    // Forces navigation to a view for the given date.
    // `viewType` can be a specific view name or a generic one like "week" or "day".
    // needs to change
    zoomTo(dateMarker, viewType) {
        let state = this.getCurrentData();
        let spec;
        viewType = viewType || "day"; // day is default zoom
        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
        this.unselect();
        if (spec) this.dispatch({
            type: "CHANGE_VIEW_TYPE",
            viewType: spec.type,
            dateMarker: dateMarker
        });
        else this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: dateMarker
        });
    }
    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
    // Preference is given to views that have corresponding buttons.
    getUnitViewSpec(unit) {
        let { viewSpecs: viewSpecs, toolbarConfig: toolbarConfig } = this.getCurrentData();
        let viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
        let i;
        let spec;
        for(let viewType in viewSpecs)viewTypes.push(viewType);
        for(i = 0; i < viewTypes.length; i += 1){
            spec = viewSpecs[viewTypes[i]];
            if (spec) {
                if (spec.singleUnit === unit) return spec;
            }
        }
        return null;
    }
    // Current Date
    // -----------------------------------------------------------------------------------------------------------------
    prev() {
        this.unselect();
        this.dispatch({
            type: "PREV"
        });
    }
    next() {
        this.unselect();
        this.dispatch({
            type: "NEXT"
        });
    }
    prevYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.addYears(state.currentDate, -1)
        });
    }
    nextYear() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.addYears(state.currentDate, 1)
        });
    }
    today() {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: $200f5cce291452b2$export$c3950d9923825c02(state.calendarOptions.now, state.dateEnv)
        });
    }
    gotoDate(zonedDateInput) {
        let state = this.getCurrentData();
        this.unselect();
        this.dispatch({
            type: "CHANGE_DATE",
            dateMarker: state.dateEnv.createMarker(zonedDateInput)
        });
    }
    incrementDate(deltaInput) {
        let state = this.getCurrentData();
        let delta = $200f5cce291452b2$export$4368d992c4eafac0(deltaInput);
        if (delta) {
            this.unselect();
            this.dispatch({
                type: "CHANGE_DATE",
                dateMarker: state.dateEnv.add(state.currentDate, delta)
            });
        }
    }
    getDate() {
        let state = this.getCurrentData();
        return state.dateEnv.toDate(state.currentDate);
    }
    // Date Formatting Utils
    // -----------------------------------------------------------------------------------------------------------------
    formatDate(d, formatter) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.format(dateEnv.createMarker(d), $200f5cce291452b2$export$d141bba7fdc215a3(formatter));
    }
    // `settings` is for formatter AND isEndExclusive
    formatRange(d0, d1, settings) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), $200f5cce291452b2$export$d141bba7fdc215a3(settings), settings);
    }
    formatIso(d, omitTime) {
        let { dateEnv: dateEnv } = this.getCurrentData();
        return dateEnv.formatIso(dateEnv.createMarker(d), {
            omitTime: omitTime
        });
    }
    // Date Selection / Event Selection / DayClick
    // -----------------------------------------------------------------------------------------------------------------
    select(dateOrObj, endDate) {
        let selectionInput;
        if (endDate == null) {
            if (dateOrObj.start != null) selectionInput = dateOrObj;
            else selectionInput = {
                start: dateOrObj,
                end: null
            };
        } else selectionInput = {
            start: dateOrObj,
            end: endDate
        };
        let state = this.getCurrentData();
        let selection = $200f5cce291452b2$var$parseDateSpan(selectionInput, state.dateEnv, $200f5cce291452b2$export$4368d992c4eafac0({
            days: 1
        }));
        if (selection) {
            this.dispatch({
                type: "SELECT_DATES",
                selection: selection
            });
            $200f5cce291452b2$export$9ddbdd0bfc5623a(selection, null, state);
        }
    }
    unselect(pev) {
        let state = this.getCurrentData();
        if (state.dateSelection) {
            this.dispatch({
                type: "UNSELECT_DATES"
            });
            $200f5cce291452b2$var$triggerDateUnselect(pev, state);
        }
    }
    // Public Events API
    // -----------------------------------------------------------------------------------------------------------------
    addEvent(eventInput, sourceInput) {
        if (eventInput instanceof $200f5cce291452b2$export$34aec0b863436764) {
            let def = eventInput._def;
            let instance = eventInput._instance;
            let currentData = this.getCurrentData();
            // not already present? don't want to add an old snapshot
            if (!currentData.eventStore.defs[def.defId]) {
                this.dispatch({
                    type: "ADD_EVENTS",
                    eventStore: $200f5cce291452b2$export$9d0e2d13d04f7070({
                        def: def,
                        instance: instance
                    })
                });
                this.triggerEventAdd(eventInput);
            }
            return eventInput;
        }
        let state = this.getCurrentData();
        let eventSource;
        if (sourceInput instanceof $200f5cce291452b2$var$EventSourceImpl) eventSource = sourceInput.internalEventSource;
        else if (typeof sourceInput === "boolean") {
            if (sourceInput) [eventSource] = $200f5cce291452b2$export$90a7f3efeed30595(state.eventSources);
        } else if (sourceInput != null) {
            let sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
            if (!sourceApi) {
                console.warn(`Could not find an event source with ID "${sourceInput}"`); // TODO: test
                return null;
            }
            eventSource = sourceApi.internalEventSource;
        }
        let tuple = $200f5cce291452b2$var$parseEvent(eventInput, eventSource, state, false);
        if (tuple) {
            let newEventApi = new $200f5cce291452b2$export$34aec0b863436764(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
            this.dispatch({
                type: "ADD_EVENTS",
                eventStore: $200f5cce291452b2$export$9d0e2d13d04f7070(tuple)
            });
            this.triggerEventAdd(newEventApi);
            return newEventApi;
        }
        return null;
    }
    triggerEventAdd(eventApi) {
        let { emitter: emitter } = this.getCurrentData();
        emitter.trigger("eventAdd", {
            event: eventApi,
            relatedEvents: [],
            revert: ()=>{
                this.dispatch({
                    type: "REMOVE_EVENTS",
                    eventStore: $200f5cce291452b2$var$eventApiToStore(eventApi)
                });
            }
        });
    }
    // TODO: optimize
    getEventById(id) {
        let state = this.getCurrentData();
        let { defs: defs, instances: instances } = state.eventStore;
        id = String(id);
        for(let defId in defs){
            let def = defs[defId];
            if (def.publicId === id) {
                if (def.recurringDef) return new $200f5cce291452b2$export$34aec0b863436764(state, def, null);
                for(let instanceId in instances){
                    let instance = instances[instanceId];
                    if (instance.defId === def.defId) return new $200f5cce291452b2$export$34aec0b863436764(state, def, instance);
                }
            }
        }
        return null;
    }
    getEvents() {
        let currentData = this.getCurrentData();
        return $200f5cce291452b2$export$efccba1c4a2ef57b(currentData.eventStore, currentData);
    }
    removeAllEvents() {
        this.dispatch({
            type: "REMOVE_ALL_EVENTS"
        });
    }
    // Public Event Sources API
    // -----------------------------------------------------------------------------------------------------------------
    getEventSources() {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        let sourceApis = [];
        for(let internalId in sourceHash)sourceApis.push(new $200f5cce291452b2$var$EventSourceImpl(state, sourceHash[internalId]));
        return sourceApis;
    }
    getEventSourceById(id) {
        let state = this.getCurrentData();
        let sourceHash = state.eventSources;
        id = String(id);
        for(let sourceId in sourceHash){
            if (sourceHash[sourceId].publicId === id) return new $200f5cce291452b2$var$EventSourceImpl(state, sourceHash[sourceId]);
        }
        return null;
    }
    addEventSource(sourceInput) {
        let state = this.getCurrentData();
        if (sourceInput instanceof $200f5cce291452b2$var$EventSourceImpl) {
            // not already present? don't want to add an old snapshot
            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) this.dispatch({
                type: "ADD_EVENT_SOURCES",
                sources: [
                    sourceInput.internalEventSource
                ]
            });
            return sourceInput;
        }
        let eventSource = $200f5cce291452b2$export$ffb5f4729a158638(sourceInput, state);
        if (eventSource) {
            this.dispatch({
                type: "ADD_EVENT_SOURCES",
                sources: [
                    eventSource
                ]
            });
            return new $200f5cce291452b2$var$EventSourceImpl(state, eventSource);
        }
        return null;
    }
    removeAllEventSources() {
        this.dispatch({
            type: "REMOVE_ALL_EVENT_SOURCES"
        });
    }
    refetchEvents() {
        this.dispatch({
            type: "FETCH_EVENT_SOURCES",
            isRefetch: true
        });
    }
    // Scroll
    // -----------------------------------------------------------------------------------------------------------------
    scrollToTime(timeInput) {
        let time = $200f5cce291452b2$export$4368d992c4eafac0(timeInput);
        if (time) this.trigger("_scrollRequest", {
            time: time
        });
    }
}
class $200f5cce291452b2$var$Store {
    set(value) {
        this.currentValue = value;
        for (let handler of this.handlers)handler(value);
    }
    subscribe(handler) {
        this.handlers.push(handler);
        if (this.currentValue !== undefined) handler(this.currentValue);
    }
    constructor(){
        this.handlers = [];
    }
}
/*
Subscribers will get a LIST of CustomRenderings
*/ class $200f5cce291452b2$export$aea64bc1b6f8f415 extends $200f5cce291452b2$var$Store {
    // for consistent order
    handle(customRendering) {
        const { map: map } = this;
        let updated = false;
        if (customRendering.isActive) {
            map.set(customRendering.id, customRendering);
            updated = true;
        } else if (map.has(customRendering.id)) {
            map.delete(customRendering.id);
            updated = true;
        }
        if (updated) this.set(map);
    }
    constructor(){
        super(...arguments);
        this.map = new Map();
    }
}




const $76a516e930faac74$export$794e7bef9c0b12d9 = [];
const $76a516e930faac74$var$MINIMAL_RAW_EN_LOCALE = {
    code: "en",
    week: {
        dow: 0,
        doy: 4
    },
    direction: "ltr",
    buttonText: {
        prev: "prev",
        next: "next",
        prevYear: "prev year",
        nextYear: "next year",
        year: "year",
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        list: "list"
    },
    weekText: "W",
    weekTextLong: "Week",
    closeHint: "Close",
    timeHint: "Time",
    eventHint: "Event",
    allDayText: "all-day",
    moreLinkText: "more",
    noEventsText: "No events to display"
};
const $76a516e930faac74$var$RAW_EN_LOCALE = Object.assign(Object.assign({}, $76a516e930faac74$var$MINIMAL_RAW_EN_LOCALE), {
    // Includes things we don't want other locales to inherit,
    // things that derive from other translatable strings.
    buttonHints: {
        prev: "Previous $0",
        next: "Next $0",
        today (buttonText, unit) {
            return unit === "day" ? "Today" : `This ${buttonText}`;
        }
    },
    viewHint: "$0 view",
    navLinkHint: "Go to $0",
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? "" : "s"}`;
    }
});
function $76a516e930faac74$var$organizeRawLocales(explicitRawLocales) {
    let defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : "en";
    let allRawLocales = $76a516e930faac74$export$794e7bef9c0b12d9.concat(explicitRawLocales);
    let rawLocaleMap = {
        en: $76a516e930faac74$var$RAW_EN_LOCALE
    };
    for (let rawLocale of allRawLocales)rawLocaleMap[rawLocale.code] = rawLocale;
    return {
        map: rawLocaleMap,
        defaultCode: defaultCode
    };
}
function $76a516e930faac74$var$buildLocale(inputSingular, available) {
    if (typeof inputSingular === "object" && !Array.isArray(inputSingular)) return $76a516e930faac74$var$parseLocale(inputSingular.code, [
        inputSingular.code
    ], inputSingular);
    return $76a516e930faac74$var$queryLocale(inputSingular, available);
}
function $76a516e930faac74$var$queryLocale(codeArg, available) {
    let codes = [].concat(codeArg || []); // will convert to array
    let raw = $76a516e930faac74$var$queryRawLocale(codes, available) || $76a516e930faac74$var$RAW_EN_LOCALE;
    return $76a516e930faac74$var$parseLocale(codeArg, codes, raw);
}
function $76a516e930faac74$var$queryRawLocale(codes, available) {
    for(let i = 0; i < codes.length; i += 1){
        let parts = codes[i].toLocaleLowerCase().split("-");
        for(let j = parts.length; j > 0; j -= 1){
            let simpleId = parts.slice(0, j).join("-");
            if (available[simpleId]) return available[simpleId];
        }
    }
    return null;
}
function $76a516e930faac74$var$parseLocale(codeArg, codes, raw) {
    let merged = (0, $200f5cce291452b2$export$953cecd6e717a553)([
        $76a516e930faac74$var$MINIMAL_RAW_EN_LOCALE,
        raw
    ], [
        "buttonText"
    ]);
    delete merged.code; // don't want this part of the options
    let { week: week } = merged;
    delete merged.week;
    return {
        codeArg: codeArg,
        codes: codes,
        week: week,
        simpleNumberFormat: new Intl.NumberFormat(codeArg),
        options: merged
    };
}
// TODO: easier way to add new hooks? need to update a million things
function $76a516e930faac74$export$ae829ec7b2625219(input) {
    return {
        id: (0, $200f5cce291452b2$export$39b482c5e57630a8)(),
        name: input.name,
        premiumReleaseDate: input.premiumReleaseDate ? new Date(input.premiumReleaseDate) : undefined,
        deps: input.deps || [],
        reducers: input.reducers || [],
        isLoadingFuncs: input.isLoadingFuncs || [],
        contextInit: [].concat(input.contextInit || []),
        eventRefiners: input.eventRefiners || {},
        eventDefMemberAdders: input.eventDefMemberAdders || [],
        eventSourceRefiners: input.eventSourceRefiners || {},
        isDraggableTransformers: input.isDraggableTransformers || [],
        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
        dateSelectionTransformers: input.dateSelectionTransformers || [],
        datePointTransforms: input.datePointTransforms || [],
        dateSpanTransforms: input.dateSpanTransforms || [],
        views: input.views || {},
        viewPropsTransformers: input.viewPropsTransformers || [],
        isPropsValid: input.isPropsValid || null,
        externalDefTransforms: input.externalDefTransforms || [],
        viewContainerAppends: input.viewContainerAppends || [],
        eventDropTransformers: input.eventDropTransformers || [],
        componentInteractions: input.componentInteractions || [],
        calendarInteractions: input.calendarInteractions || [],
        themeClasses: input.themeClasses || {},
        eventSourceDefs: input.eventSourceDefs || [],
        cmdFormatter: input.cmdFormatter,
        recurringTypes: input.recurringTypes || [],
        namedTimeZonedImpl: input.namedTimeZonedImpl,
        initialView: input.initialView || "",
        elementDraggingImpl: input.elementDraggingImpl,
        optionChangeHandlers: input.optionChangeHandlers || {},
        scrollGridImpl: input.scrollGridImpl || null,
        listenerRefiners: input.listenerRefiners || {},
        optionRefiners: input.optionRefiners || {},
        propSetHandlers: input.propSetHandlers || {}
    };
}
function $76a516e930faac74$var$buildPluginHooks(pluginDefs, globalDefs) {
    let currentPluginIds = {};
    let hooks = {
        premiumReleaseDate: undefined,
        reducers: [],
        isLoadingFuncs: [],
        contextInit: [],
        eventRefiners: {},
        eventDefMemberAdders: [],
        eventSourceRefiners: {},
        isDraggableTransformers: [],
        eventDragMutationMassagers: [],
        eventDefMutationAppliers: [],
        dateSelectionTransformers: [],
        datePointTransforms: [],
        dateSpanTransforms: [],
        views: {},
        viewPropsTransformers: [],
        isPropsValid: null,
        externalDefTransforms: [],
        viewContainerAppends: [],
        eventDropTransformers: [],
        componentInteractions: [],
        calendarInteractions: [],
        themeClasses: {},
        eventSourceDefs: [],
        cmdFormatter: null,
        recurringTypes: [],
        namedTimeZonedImpl: null,
        initialView: "",
        elementDraggingImpl: null,
        optionChangeHandlers: {},
        scrollGridImpl: null,
        listenerRefiners: {},
        optionRefiners: {},
        propSetHandlers: {}
    };
    function addDefs(defs) {
        for (let def of defs){
            const pluginName = def.name;
            const currentId = currentPluginIds[pluginName];
            if (currentId === undefined) {
                currentPluginIds[pluginName] = def.id;
                addDefs(def.deps);
                hooks = $76a516e930faac74$var$combineHooks(hooks, def);
            } else if (currentId !== def.id) // different ID than the one already added
            console.warn(`Duplicate plugin '${pluginName}'`);
        }
    }
    if (pluginDefs) addDefs(pluginDefs);
    addDefs(globalDefs);
    return hooks;
}
function $76a516e930faac74$var$buildBuildPluginHooks() {
    let currentOverrideDefs = [];
    let currentGlobalDefs = [];
    let currentHooks;
    return (overrideDefs, globalDefs)=>{
        if (!currentHooks || !(0, $200f5cce291452b2$export$23f2a1d2818174ef)(overrideDefs, currentOverrideDefs) || !(0, $200f5cce291452b2$export$23f2a1d2818174ef)(globalDefs, currentGlobalDefs)) currentHooks = $76a516e930faac74$var$buildPluginHooks(overrideDefs, globalDefs);
        currentOverrideDefs = overrideDefs;
        currentGlobalDefs = globalDefs;
        return currentHooks;
    };
}
function $76a516e930faac74$var$combineHooks(hooks0, hooks1) {
    return {
        premiumReleaseDate: $76a516e930faac74$var$compareOptionalDates(hooks0.premiumReleaseDate, hooks1.premiumReleaseDate),
        reducers: hooks0.reducers.concat(hooks1.reducers),
        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
        eventRefiners: Object.assign(Object.assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
        eventSourceRefiners: Object.assign(Object.assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
        views: Object.assign(Object.assign({}, hooks0.views), hooks1.views),
        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
        themeClasses: Object.assign(Object.assign({}, hooks0.themeClasses), hooks1.themeClasses),
        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
        initialView: hooks0.initialView || hooks1.initialView,
        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
        optionChangeHandlers: Object.assign(Object.assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
        listenerRefiners: Object.assign(Object.assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
        optionRefiners: Object.assign(Object.assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
        propSetHandlers: Object.assign(Object.assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers)
    };
}
function $76a516e930faac74$var$compareOptionalDates(date0, date1) {
    if (date0 === undefined) return date1;
    if (date1 === undefined) return date0;
    return new Date(Math.max(date0.valueOf(), date1.valueOf()));
}
class $76a516e930faac74$var$StandardTheme extends (0, $200f5cce291452b2$export$971d5caa766a69d7) {
}
$76a516e930faac74$var$StandardTheme.prototype.classes = {
    root: "fc-theme-standard",
    tableCellShaded: "fc-cell-shaded",
    buttonGroup: "fc-button-group",
    button: "fc-button fc-button-primary",
    buttonActive: "fc-button-active"
};
$76a516e930faac74$var$StandardTheme.prototype.baseIconClass = "fc-icon";
$76a516e930faac74$var$StandardTheme.prototype.iconClasses = {
    close: "fc-icon-x",
    prev: "fc-icon-chevron-left",
    next: "fc-icon-chevron-right",
    prevYear: "fc-icon-chevrons-left",
    nextYear: "fc-icon-chevrons-right"
};
$76a516e930faac74$var$StandardTheme.prototype.rtlIconClasses = {
    prev: "fc-icon-chevron-right",
    next: "fc-icon-chevron-left",
    prevYear: "fc-icon-chevrons-right",
    nextYear: "fc-icon-chevrons-left"
};
$76a516e930faac74$var$StandardTheme.prototype.iconOverrideOption = "buttonIcons"; // TODO: make TS-friendly
$76a516e930faac74$var$StandardTheme.prototype.iconOverrideCustomButtonOption = "icon";
$76a516e930faac74$var$StandardTheme.prototype.iconOverridePrefix = "fc-icon-";
function $76a516e930faac74$var$compileViewDefs(defaultConfigs, overrideConfigs) {
    let hash = {};
    let viewType;
    for(viewType in defaultConfigs)$76a516e930faac74$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    for(viewType in overrideConfigs)$76a516e930faac74$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    return hash;
}
function $76a516e930faac74$var$ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    if (hash[viewType]) return hash[viewType];
    let viewDef = $76a516e930faac74$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
    if (viewDef) hash[viewType] = viewDef;
    return viewDef;
}
function $76a516e930faac74$var$buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
    let defaultConfig = defaultConfigs[viewType];
    let overrideConfig = overrideConfigs[viewType];
    let queryProp = (name)=>defaultConfig && defaultConfig[name] !== null ? defaultConfig[name] : overrideConfig && overrideConfig[name] !== null ? overrideConfig[name] : null;
    let theComponent = queryProp("component");
    let superType = queryProp("superType");
    let superDef = null;
    if (superType) {
        if (superType === viewType) throw new Error("Can't have a custom view type that references itself");
        superDef = $76a516e930faac74$var$ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
    }
    if (!theComponent && superDef) theComponent = superDef.component;
    if (!theComponent) return null; // don't throw a warning, might be settings for a single-unit view
    return {
        type: viewType,
        component: theComponent,
        defaults: Object.assign(Object.assign({}, superDef ? superDef.defaults : {}), defaultConfig ? defaultConfig.rawOptions : {}),
        overrides: Object.assign(Object.assign({}, superDef ? superDef.overrides : {}), overrideConfig ? overrideConfig.rawOptions : {})
    };
}
function $76a516e930faac74$var$parseViewConfigs(inputs) {
    return (0, $200f5cce291452b2$export$407448d2b89b1813)(inputs, $76a516e930faac74$var$parseViewConfig);
}
function $76a516e930faac74$var$parseViewConfig(input) {
    let rawOptions = typeof input === "function" ? {
        component: input
    } : input;
    let { component: component } = rawOptions;
    if (rawOptions.content) // TODO: remove content/classNames/didMount/etc from options?
    component = $76a516e930faac74$var$createViewHookComponent(rawOptions);
    else if (component && !(component.prototype instanceof (0, $200f5cce291452b2$export$ef35774e6d314e91))) // WHY?: people were using `component` property for `content`
    // TODO: converge on one setting name
    component = $76a516e930faac74$var$createViewHookComponent(Object.assign(Object.assign({}, rawOptions), {
        content: component
    }));
    return {
        superType: rawOptions.type,
        component: component,
        rawOptions: rawOptions
    };
}
function $76a516e930faac74$var$createViewHookComponent(options) {
    return (viewProps)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7c866399fa523f5).Consumer, null, (context)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7094788287c5e9b), {
                elTag: "div",
                elClasses: (0, $200f5cce291452b2$export$8b22cf2602fb60ce)(context.viewSpec),
                renderProps: Object.assign(Object.assign({}, viewProps), {
                    nextDayThreshold: context.options.nextDayThreshold
                }),
                generatorName: undefined,
                customGenerator: options.content,
                classNameGenerator: options.classNames,
                didMount: options.didMount,
                willUnmount: options.willUnmount
            }));
}
function $76a516e930faac74$var$buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let defaultConfigs = $76a516e930faac74$var$parseViewConfigs(defaultInputs);
    let overrideConfigs = $76a516e930faac74$var$parseViewConfigs(optionOverrides.views);
    let viewDefs = $76a516e930faac74$var$compileViewDefs(defaultConfigs, overrideConfigs);
    return (0, $200f5cce291452b2$export$407448d2b89b1813)(viewDefs, (viewDef)=>$76a516e930faac74$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults));
}
function $76a516e930faac74$var$buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
    let durationInput = viewDef.overrides.duration || viewDef.defaults.duration || dynamicOptionOverrides.duration || optionOverrides.duration;
    let duration = null;
    let durationUnit = "";
    let singleUnit = "";
    let singleUnitOverrides = {};
    if (durationInput) {
        duration = $76a516e930faac74$var$createDurationCached(durationInput);
        if (duration) {
            let denom = (0, $200f5cce291452b2$export$db3b6bfb95261072)(duration);
            durationUnit = denom.unit;
            if (denom.value === 1) {
                singleUnit = durationUnit;
                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
            }
        }
    }
    let queryButtonText = (optionsSubset)=>{
        let buttonTextMap = optionsSubset.buttonText || {};
        let buttonTextKey = viewDef.defaults.buttonTextKey;
        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) return buttonTextMap[buttonTextKey];
        if (buttonTextMap[viewDef.type] != null) return buttonTextMap[viewDef.type];
        if (buttonTextMap[singleUnit] != null) return buttonTextMap[singleUnit];
        return null;
    };
    let queryButtonTitle = (optionsSubset)=>{
        let buttonHints = optionsSubset.buttonHints || {};
        let buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
        if (buttonKey != null && buttonHints[buttonKey] != null) return buttonHints[buttonKey];
        if (buttonHints[viewDef.type] != null) return buttonHints[viewDef.type];
        if (buttonHints[singleUnit] != null) return buttonHints[singleUnit];
        return null;
    };
    return {
        type: viewDef.type,
        component: viewDef.component,
        duration: duration,
        durationUnit: durationUnit,
        singleUnit: singleUnit,
        optionDefaults: viewDef.defaults,
        optionOverrides: Object.assign(Object.assign({}, singleUnitOverrides), viewDef.overrides),
        buttonTextOverride: queryButtonText(dynamicOptionOverrides) || queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
        viewDef.overrides.buttonText,
        buttonTextDefault: queryButtonText(localeDefaults) || viewDef.defaults.buttonText || queryButtonText((0, $200f5cce291452b2$export$f1e1789686576879)) || viewDef.type,
        // not DRY
        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) || queryButtonTitle(optionOverrides) || viewDef.overrides.buttonHint,
        buttonTitleDefault: queryButtonTitle(localeDefaults) || viewDef.defaults.buttonHint || queryButtonTitle((0, $200f5cce291452b2$export$f1e1789686576879))
    };
}
// hack to get memoization working
let $76a516e930faac74$var$durationInputMap = {};
function $76a516e930faac74$var$createDurationCached(durationInput) {
    let json = JSON.stringify(durationInput);
    let res = $76a516e930faac74$var$durationInputMap[json];
    if (res === undefined) {
        res = (0, $200f5cce291452b2$export$4368d992c4eafac0)(durationInput);
        $76a516e930faac74$var$durationInputMap[json] = res;
    }
    return res;
}
function $76a516e930faac74$var$reduceViewType(viewType, action) {
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            viewType = action.viewType;
    }
    return viewType;
}
function $76a516e930faac74$var$reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
    switch(action.type){
        case "SET_OPTION":
            return Object.assign(Object.assign({}, dynamicOptionOverrides), {
                [action.optionName]: action.rawOptionValue
            });
        default:
            return dynamicOptionOverrides;
    }
}
function $76a516e930faac74$var$reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
    let dp;
    switch(action.type){
        case "CHANGE_VIEW_TYPE":
            return dateProfileGenerator.build(action.dateMarker || currentDate);
        case "CHANGE_DATE":
            return dateProfileGenerator.build(action.dateMarker);
        case "PREV":
            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
        case "NEXT":
            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
            if (dp.isValid) return dp;
            break;
    }
    return currentDateProfile;
}
function $76a516e930faac74$var$initEventSources(calendarOptions, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null;
    return $76a516e930faac74$var$addSources({}, $76a516e930faac74$var$parseInitialSources(calendarOptions, context), activeRange, context);
}
function $76a516e930faac74$var$reduceEventSources(eventSources, action, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    switch(action.type){
        case "ADD_EVENT_SOURCES":
            return $76a516e930faac74$var$addSources(eventSources, action.sources, activeRange, context);
        case "REMOVE_EVENT_SOURCE":
            return $76a516e930faac74$var$removeSource(eventSources, action.sourceId);
        case "PREV":
        case "NEXT":
        case "CHANGE_DATE":
        case "CHANGE_VIEW_TYPE":
            if (dateProfile) return $76a516e930faac74$var$fetchDirtySources(eventSources, activeRange, context);
            return eventSources;
        case "FETCH_EVENT_SOURCES":
            return $76a516e930faac74$var$fetchSourcesByIds(eventSources, action.sourceIds ? (0, $200f5cce291452b2$export$2d1720544b23b823)(action.sourceIds) : $76a516e930faac74$var$excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
        case "RECEIVE_EVENTS":
        case "RECEIVE_EVENT_ERROR":
            return $76a516e930faac74$var$receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
        case "REMOVE_ALL_EVENT_SOURCES":
            return {};
        default:
            return eventSources;
    }
}
function $76a516e930faac74$var$reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
    let activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
    return $76a516e930faac74$var$fetchSourcesByIds(eventSources, $76a516e930faac74$var$excludeStaticSources(eventSources, context), activeRange, true, context);
}
function $76a516e930faac74$var$computeEventSourcesLoading(eventSources) {
    for(let sourceId in eventSources){
        if (eventSources[sourceId].isFetching) return true;
    }
    return false;
}
function $76a516e930faac74$var$addSources(eventSourceHash, sources, fetchRange, context) {
    let hash = {};
    for (let source of sources)hash[source.sourceId] = source;
    if (fetchRange) hash = $76a516e930faac74$var$fetchDirtySources(hash, fetchRange, context);
    return Object.assign(Object.assign({}, eventSourceHash), hash);
}
function $76a516e930faac74$var$removeSource(eventSourceHash, sourceId) {
    return (0, $200f5cce291452b2$export$dda1d9f60106f0e9)(eventSourceHash, (eventSource)=>eventSource.sourceId !== sourceId);
}
function $76a516e930faac74$var$fetchDirtySources(sourceHash, fetchRange, context) {
    return $76a516e930faac74$var$fetchSourcesByIds(sourceHash, (0, $200f5cce291452b2$export$dda1d9f60106f0e9)(sourceHash, (eventSource)=>$76a516e930faac74$var$isSourceDirty(eventSource, fetchRange, context)), fetchRange, false, context);
}
function $76a516e930faac74$var$isSourceDirty(eventSource, fetchRange, context) {
    if (!$76a516e930faac74$var$doesSourceNeedRange(eventSource, context)) return !eventSource.latestFetchId;
    return !context.options.lazyFetching || !eventSource.fetchRange || eventSource.isFetching || // always cancel outdated in-progress fetches
    fetchRange.start < eventSource.fetchRange.start || fetchRange.end > eventSource.fetchRange.end;
}
function $76a516e930faac74$var$fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
    let nextSources = {};
    for(let sourceId in prevSources){
        let source = prevSources[sourceId];
        if (sourceIdHash[sourceId]) nextSources[sourceId] = $76a516e930faac74$var$fetchSource(source, fetchRange, isRefetch, context);
        else nextSources[sourceId] = source;
    }
    return nextSources;
}
function $76a516e930faac74$var$fetchSource(eventSource, fetchRange, isRefetch, context) {
    let { options: options, calendarApi: calendarApi } = context;
    let sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
    let fetchId = (0, $200f5cce291452b2$export$39b482c5e57630a8)();
    sourceDef.fetch({
        eventSource: eventSource,
        range: fetchRange,
        isRefetch: isRefetch,
        context: context
    }, (res)=>{
        let { rawEvents: rawEvents } = res;
        if (options.eventSourceSuccess) rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.response) || rawEvents;
        if (eventSource.success) rawEvents = eventSource.success.call(calendarApi, rawEvents, res.response) || rawEvents;
        context.dispatch({
            type: "RECEIVE_EVENTS",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            rawEvents: rawEvents
        });
    }, (error)=>{
        let errorHandled = false;
        if (options.eventSourceFailure) {
            options.eventSourceFailure.call(calendarApi, error);
            errorHandled = true;
        }
        if (eventSource.failure) {
            eventSource.failure(error);
            errorHandled = true;
        }
        if (!errorHandled) console.warn(error.message, error);
        context.dispatch({
            type: "RECEIVE_EVENT_ERROR",
            sourceId: eventSource.sourceId,
            fetchId: fetchId,
            fetchRange: fetchRange,
            error: error
        });
    });
    return Object.assign(Object.assign({}, eventSource), {
        isFetching: true,
        latestFetchId: fetchId
    });
}
function $76a516e930faac74$var$receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
    let eventSource = sourceHash[sourceId];
    if (eventSource && // not already removed
    fetchId === eventSource.latestFetchId) return Object.assign(Object.assign({}, sourceHash), {
        [sourceId]: Object.assign(Object.assign({}, eventSource), {
            isFetching: false,
            fetchRange: fetchRange
        })
    });
    return sourceHash;
}
function $76a516e930faac74$var$excludeStaticSources(eventSources, context) {
    return (0, $200f5cce291452b2$export$dda1d9f60106f0e9)(eventSources, (eventSource)=>$76a516e930faac74$var$doesSourceNeedRange(eventSource, context));
}
function $76a516e930faac74$var$parseInitialSources(rawOptions, context) {
    let refiners = (0, $200f5cce291452b2$export$35e795649ee09318)(context);
    let rawSources = [].concat(rawOptions.eventSources || []);
    let sources = []; // parsed
    if (rawOptions.initialEvents) rawSources.unshift(rawOptions.initialEvents);
    if (rawOptions.events) rawSources.unshift(rawOptions.events);
    for (let rawSource of rawSources){
        let source = (0, $200f5cce291452b2$export$ffb5f4729a158638)(rawSource, context, refiners);
        if (source) sources.push(source);
    }
    return sources;
}
function $76a516e930faac74$var$doesSourceNeedRange(eventSource, context) {
    let defs = context.pluginHooks.eventSourceDefs;
    return !defs[eventSource.sourceDefId].ignoreRange;
}
function $76a516e930faac74$var$reduceDateSelection(currentSelection, action) {
    switch(action.type){
        case "UNSELECT_DATES":
            return null;
        case "SELECT_DATES":
            return action.selection;
        default:
            return currentSelection;
    }
}
function $76a516e930faac74$var$reduceSelectedEvent(currentInstanceId, action) {
    switch(action.type){
        case "UNSELECT_EVENT":
            return "";
        case "SELECT_EVENT":
            return action.eventInstanceId;
        default:
            return currentInstanceId;
    }
}
function $76a516e930faac74$var$reduceEventDrag(currentDrag, action) {
    let newDrag;
    switch(action.type){
        case "UNSET_EVENT_DRAG":
            return null;
        case "SET_EVENT_DRAG":
            newDrag = action.state;
            return {
                affectedEvents: newDrag.affectedEvents,
                mutatedEvents: newDrag.mutatedEvents,
                isEvent: newDrag.isEvent
            };
        default:
            return currentDrag;
    }
}
function $76a516e930faac74$var$reduceEventResize(currentResize, action) {
    let newResize;
    switch(action.type){
        case "UNSET_EVENT_RESIZE":
            return null;
        case "SET_EVENT_RESIZE":
            newResize = action.state;
            return {
                affectedEvents: newResize.affectedEvents,
                mutatedEvents: newResize.mutatedEvents,
                isEvent: newResize.isEvent
            };
        default:
            return currentResize;
    }
}
function $76a516e930faac74$var$parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let header = calendarOptions.headerToolbar ? $76a516e930faac74$var$parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    let footer = calendarOptions.footerToolbar ? $76a516e930faac74$var$parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
    return {
        header: header,
        footer: footer
    };
}
function $76a516e930faac74$var$parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let sectionWidgets = {};
    let viewsWithButtons = [];
    let hasTitle = false;
    for(let sectionName in sectionStrHash){
        let sectionStr = sectionStrHash[sectionName];
        let sectionRes = $76a516e930faac74$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
        sectionWidgets[sectionName] = sectionRes.widgets;
        viewsWithButtons.push(...sectionRes.viewsWithButtons);
        hasTitle = hasTitle || sectionRes.hasTitle;
    }
    return {
        sectionWidgets: sectionWidgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
/*
BAD: querying icons and text here. should be done at render time
*/ function $76a516e930faac74$var$parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
    let isRtl = calendarOptions.direction === "rtl";
    let calendarCustomButtons = calendarOptions.customButtons || {};
    let calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
    let calendarButtonText = calendarOptions.buttonText || {};
    let calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
    let calendarButtonHints = calendarOptions.buttonHints || {};
    let sectionSubstrs = sectionStr ? sectionStr.split(" ") : [];
    let viewsWithButtons = [];
    let hasTitle = false;
    let widgets = sectionSubstrs.map((buttonGroupStr)=>buttonGroupStr.split(",").map((buttonName)=>{
            if (buttonName === "title") {
                hasTitle = true;
                return {
                    buttonName: buttonName
                };
            }
            let customButtonProps;
            let viewSpec;
            let buttonClick;
            let buttonIcon; // only one of these will be set
            let buttonText; // "
            let buttonHint;
            // ^ for the title="" attribute, for accessibility
            if (customButtonProps = calendarCustomButtons[buttonName]) {
                buttonClick = (ev)=>{
                    if (customButtonProps.click) customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
                };
                (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = customButtonProps.text);
                buttonHint = customButtonProps.hint || customButtonProps.text;
            } else if (viewSpec = viewSpecs[buttonName]) {
                viewsWithButtons.push(buttonName);
                buttonClick = ()=>{
                    calendarApi.changeView(buttonName);
                };
                (buttonText = viewSpec.buttonTextOverride) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = viewSpec.buttonTextDefault);
                let textFallback = viewSpec.buttonTextOverride || viewSpec.buttonTextDefault;
                buttonHint = (0, $200f5cce291452b2$export$342063e11d6c3cad)(viewSpec.buttonTitleOverride || viewSpec.buttonTitleDefault || calendarOptions.viewHint, [
                    textFallback,
                    buttonName
                ], textFallback);
            } else if (calendarApi[buttonName]) {
                buttonClick = ()=>{
                    calendarApi[buttonName]();
                };
                (buttonText = calendarButtonTextOverrides[buttonName]) || (buttonIcon = theme.getIconClass(buttonName, isRtl)) || (buttonText = calendarButtonText[buttonName]); // everything else is considered default
                if (buttonName === "prevYear" || buttonName === "nextYear") {
                    let prevOrNext = buttonName === "prevYear" ? "prev" : "next";
                    buttonHint = (0, $200f5cce291452b2$export$342063e11d6c3cad)(calendarButtonHintOverrides[prevOrNext] || calendarButtonHints[prevOrNext], [
                        calendarButtonText.year || "year",
                        "year"
                    ], calendarButtonText[buttonName]);
                } else buttonHint = (navUnit)=>(0, $200f5cce291452b2$export$342063e11d6c3cad)(calendarButtonHintOverrides[buttonName] || calendarButtonHints[buttonName], [
                        calendarButtonText[navUnit] || navUnit,
                        navUnit
                    ], calendarButtonText[buttonName]);
            }
            return {
                buttonName: buttonName,
                buttonClick: buttonClick,
                buttonIcon: buttonIcon,
                buttonText: buttonText,
                buttonHint: buttonHint
            };
        }));
    return {
        widgets: widgets,
        viewsWithButtons: viewsWithButtons,
        hasTitle: hasTitle
    };
}
// always represents the current view. otherwise, it'd need to change value every time date changes
class $76a516e930faac74$var$ViewImpl {
    get calendar() {
        return this.getCurrentData().calendarApi;
    }
    get title() {
        return this.getCurrentData().viewTitle;
    }
    get activeStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
    }
    get activeEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
    }
    get currentStart() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
    }
    get currentEnd() {
        return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
    }
    getOption(name) {
        return this.getCurrentData().options[name]; // are the view-specific options
    }
    constructor(type, getCurrentData, dateEnv){
        this.type = type;
        this.getCurrentData = getCurrentData;
        this.dateEnv = dateEnv;
    }
}
let $76a516e930faac74$var$eventSourceDef$2 = {
    ignoreRange: true,
    parseMeta (refined) {
        if (Array.isArray(refined.events)) return refined.events;
        return null;
    },
    fetch (arg, successCallback) {
        successCallback({
            rawEvents: arg.eventSource.meta
        });
    }
};
const $76a516e930faac74$var$arrayEventSourcePlugin = $76a516e930faac74$export$ae829ec7b2625219({
    name: "array-event-source",
    eventSourceDefs: [
        $76a516e930faac74$var$eventSourceDef$2
    ]
});
let $76a516e930faac74$var$eventSourceDef$1 = {
    parseMeta (refined) {
        if (typeof refined.events === "function") return refined.events;
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { dateEnv: dateEnv } = arg.context;
        const func = arg.eventSource.meta;
        (0, $200f5cce291452b2$export$3b14a55fb2447963)(func.bind(null, (0, $200f5cce291452b2$export$882b5998b3b9117c)(arg.range, dateEnv)), (rawEvents)=>successCallback({
                rawEvents: rawEvents
            }), errorCallback);
    }
};
const $76a516e930faac74$var$funcEventSourcePlugin = $76a516e930faac74$export$ae829ec7b2625219({
    name: "func-event-source",
    eventSourceDefs: [
        $76a516e930faac74$var$eventSourceDef$1
    ]
});
const $76a516e930faac74$var$JSON_FEED_EVENT_SOURCE_REFINERS = {
    method: String,
    extraParams: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    startParam: String,
    endParam: String,
    timeZoneParam: String
};
let $76a516e930faac74$var$eventSourceDef = {
    parseMeta (refined) {
        if (refined.url && (refined.format === "json" || !refined.format)) return {
            url: refined.url,
            format: "json",
            method: (refined.method || "GET").toUpperCase(),
            extraParams: refined.extraParams,
            startParam: refined.startParam,
            endParam: refined.endParam,
            timeZoneParam: refined.timeZoneParam
        };
        return null;
    },
    fetch (arg, successCallback, errorCallback) {
        const { meta: meta } = arg.eventSource;
        const requestParams = $76a516e930faac74$var$buildRequestParams(meta, arg.range, arg.context);
        (0, $200f5cce291452b2$export$43caf9889c228507)(meta.method, meta.url, requestParams).then(([rawEvents, response])=>{
            successCallback({
                rawEvents: rawEvents,
                response: response
            });
        }, errorCallback);
    }
};
const $76a516e930faac74$var$jsonFeedEventSourcePlugin = $76a516e930faac74$export$ae829ec7b2625219({
    name: "json-event-source",
    eventSourceRefiners: $76a516e930faac74$var$JSON_FEED_EVENT_SOURCE_REFINERS,
    eventSourceDefs: [
        $76a516e930faac74$var$eventSourceDef
    ]
});
function $76a516e930faac74$var$buildRequestParams(meta, range, context) {
    let { dateEnv: dateEnv, options: options } = context;
    let startParam;
    let endParam;
    let timeZoneParam;
    let customRequestParams;
    let params = {};
    startParam = meta.startParam;
    if (startParam == null) startParam = options.startParam;
    endParam = meta.endParam;
    if (endParam == null) endParam = options.endParam;
    timeZoneParam = meta.timeZoneParam;
    if (timeZoneParam == null) timeZoneParam = options.timeZoneParam;
    // retrieve any outbound GET/POST data from the options
    if (typeof meta.extraParams === "function") // supplied as a function that returns a key/value object
    customRequestParams = meta.extraParams();
    else // probably supplied as a straight key/value object
    customRequestParams = meta.extraParams || {};
    Object.assign(params, customRequestParams);
    params[startParam] = dateEnv.formatIso(range.start);
    params[endParam] = dateEnv.formatIso(range.end);
    if (dateEnv.timeZone !== "local") params[timeZoneParam] = dateEnv.timeZone;
    return params;
}
const $76a516e930faac74$var$SIMPLE_RECURRING_REFINERS = {
    daysOfWeek: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    startTime: (0, $200f5cce291452b2$export$4368d992c4eafac0),
    endTime: (0, $200f5cce291452b2$export$4368d992c4eafac0),
    duration: (0, $200f5cce291452b2$export$4368d992c4eafac0),
    startRecur: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    endRecur: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5)
};
let $76a516e930faac74$var$recurring = {
    parse (refined, dateEnv) {
        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
            let recurringData = {
                daysOfWeek: refined.daysOfWeek || null,
                startTime: refined.startTime || null,
                endTime: refined.endTime || null,
                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null
            };
            let duration;
            if (refined.duration) duration = refined.duration;
            if (!duration && refined.startTime && refined.endTime) duration = (0, $200f5cce291452b2$export$2408f22a0fab9ae5)(refined.endTime, refined.startTime);
            return {
                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
                duration: duration,
                typeData: recurringData
            };
        }
        return null;
    },
    expand (typeData, framingRange, dateEnv) {
        let clippedFramingRange = (0, $200f5cce291452b2$export$ae1af26003f05816)(framingRange, {
            start: typeData.startRecur,
            end: typeData.endRecur
        });
        if (clippedFramingRange) return $76a516e930faac74$var$expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
        return [];
    }
};
const $76a516e930faac74$var$simpleRecurringEventsPlugin = $76a516e930faac74$export$ae829ec7b2625219({
    name: "simple-recurring-event",
    recurringTypes: [
        $76a516e930faac74$var$recurring
    ],
    eventRefiners: $76a516e930faac74$var$SIMPLE_RECURRING_REFINERS
});
function $76a516e930faac74$var$expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
    let dowHash = daysOfWeek ? (0, $200f5cce291452b2$export$2d1720544b23b823)(daysOfWeek) : null;
    let dayMarker = (0, $200f5cce291452b2$export$9e5f44173e64f162)(framingRange.start);
    let endMarker = framingRange.end;
    let instanceStarts = [];
    while(dayMarker < endMarker){
        let instanceStart;
        // if everyday, or this particular day-of-week
        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
            if (startTime) instanceStart = dateEnv.add(dayMarker, startTime);
            else instanceStart = dayMarker;
            instanceStarts.push(instanceStart);
        }
        dayMarker = (0, $200f5cce291452b2$export$625550452a3fa3ec)(dayMarker, 1);
    }
    return instanceStarts;
}
const $76a516e930faac74$var$changeHandlerPlugin = $76a516e930faac74$export$ae829ec7b2625219({
    name: "change-handler",
    optionChangeHandlers: {
        events (events, context) {
            $76a516e930faac74$var$handleEventSources([
                events
            ], context);
        },
        eventSources: $76a516e930faac74$var$handleEventSources
    }
});
/*
BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
*/ function $76a516e930faac74$var$handleEventSources(inputs, context) {
    let unfoundSources = (0, $200f5cce291452b2$export$90a7f3efeed30595)(context.getCurrentData().eventSources);
    if (unfoundSources.length === 1 && inputs.length === 1 && Array.isArray(unfoundSources[0]._raw) && Array.isArray(inputs[0])) {
        context.dispatch({
            type: "RESET_RAW_EVENTS",
            sourceId: unfoundSources[0].sourceId,
            rawEvents: inputs[0]
        });
        return;
    }
    let newInputs = [];
    for (let input of inputs){
        let inputFound = false;
        for(let i = 0; i < unfoundSources.length; i += 1)if (unfoundSources[i]._raw === input) {
            unfoundSources.splice(i, 1); // delete
            inputFound = true;
            break;
        }
        if (!inputFound) newInputs.push(input);
    }
    for (let unfoundSource of unfoundSources)context.dispatch({
        type: "REMOVE_EVENT_SOURCE",
        sourceId: unfoundSource.sourceId
    });
    for (let newInput of newInputs)context.calendarApi.addEventSource(newInput);
}
function $76a516e930faac74$var$handleDateProfile(dateProfile, context) {
    context.emitter.trigger("datesSet", Object.assign(Object.assign({}, (0, $200f5cce291452b2$export$882b5998b3b9117c)(dateProfile.activeRange, context.dateEnv)), {
        view: context.viewApi
    }));
}
function $76a516e930faac74$var$handleEventStore(eventStore, context) {
    let { emitter: emitter } = context;
    if (emitter.hasHandlers("eventsSet")) emitter.trigger("eventsSet", (0, $200f5cce291452b2$export$efccba1c4a2ef57b)(eventStore, context));
}
/*
this array is exposed on the root namespace so that UMD plugins can add to it.
see the rollup-bundles script.
*/ const $76a516e930faac74$export$905153d94e0757fa = [
    $76a516e930faac74$var$arrayEventSourcePlugin,
    $76a516e930faac74$var$funcEventSourcePlugin,
    $76a516e930faac74$var$jsonFeedEventSourcePlugin,
    $76a516e930faac74$var$simpleRecurringEventsPlugin,
    $76a516e930faac74$var$changeHandlerPlugin,
    $76a516e930faac74$export$ae829ec7b2625219({
        name: "misc",
        isLoadingFuncs: [
            (state)=>$76a516e930faac74$var$computeEventSourcesLoading(state.eventSources)
        ],
        propSetHandlers: {
            dateProfile: $76a516e930faac74$var$handleDateProfile,
            eventStore: $76a516e930faac74$var$handleEventStore
        }
    })
];
class $76a516e930faac74$var$TaskRunner {
    request(task, delay) {
        this.queue.push(task);
        this.delayedRunner.request(delay);
    }
    pause(scope) {
        this.delayedRunner.pause(scope);
    }
    resume(scope, force) {
        this.delayedRunner.resume(scope, force);
    }
    drain() {
        let { queue: queue } = this;
        while(queue.length){
            let completedTasks = [];
            let task;
            while(task = queue.shift()){
                this.runTask(task);
                completedTasks.push(task);
            }
            this.drained(completedTasks);
        } // keep going, in case new tasks were added in the drained handler
    }
    runTask(task) {
        if (this.runTaskOption) this.runTaskOption(task);
    }
    drained(completedTasks) {
        if (this.drainedOption) this.drainedOption(completedTasks);
    }
    constructor(runTaskOption, drainedOption){
        this.runTaskOption = runTaskOption;
        this.drainedOption = drainedOption;
        this.queue = [];
        this.delayedRunner = new (0, $200f5cce291452b2$export$96f57966bedc81b4)(this.drain.bind(this));
    }
}
// Computes what the title at the top of the calendarApi should be for this view
function $76a516e930faac74$var$buildTitle(dateProfile, viewOptions, dateEnv) {
    let range;
    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) range = dateProfile.currentRange;
    else range = dateProfile.activeRange;
    return dateEnv.formatRange(range.start, range.end, (0, $200f5cce291452b2$export$d141bba7fdc215a3)(viewOptions.titleFormat || $76a516e930faac74$var$buildTitleFormat(dateProfile)), {
        isEndExclusive: dateProfile.isRangeAllDay,
        defaultSeparator: viewOptions.titleRangeSeparator
    });
}
// Generates the format string that should be used to generate the title for the current date range.
// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
function $76a516e930faac74$var$buildTitleFormat(dateProfile) {
    let { currentRangeUnit: currentRangeUnit } = dateProfile;
    if (currentRangeUnit === "year") return {
        year: "numeric"
    };
    if (currentRangeUnit === "month") return {
        year: "numeric",
        month: "long"
    }; // like "September 2014"
    let days = (0, $200f5cce291452b2$export$4a5767248b18ef41)(dateProfile.currentRange.start, dateProfile.currentRange.end);
    if (days !== null && days > 1) // multi-day range. shorter, like "Sep 9 - 10 2014"
    return {
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    // one day. longer, like "September 9 2014"
    return {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
}
// in future refactor, do the redux-style function(state=initial) for initial-state
// also, whatever is happening in constructor, have it happen in action queue too
class $76a516e930faac74$var$CalendarDataManager {
    resetOptions(optionOverrides, changedOptionNames) {
        let { props: props } = this;
        if (changedOptionNames === undefined) props.optionOverrides = optionOverrides;
        else {
            props.optionOverrides = Object.assign(Object.assign({}, props.optionOverrides || {}), optionOverrides);
            this.optionsForRefining.push(...changedOptionNames);
        }
        if (changedOptionNames === undefined || changedOptionNames.length) this.actionRunner.request({
            type: "NOTHING"
        });
    }
    _handleAction(action) {
        let { props: props, state: state, emitter: emitter } = this;
        let dynamicOptionOverrides = $76a516e930faac74$var$reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = $76a516e930faac74$var$reduceViewType(state.currentViewType, action);
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        emitter.setThisContext(props.calendarApi);
        emitter.setOptions(currentViewData.options);
        let calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: emitter,
            getCurrentData: this.getCurrentData
        };
        let { currentDate: currentDate, dateProfile: dateProfile } = state;
        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        currentDate = (0, $200f5cce291452b2$export$b4171a6734a65d42)(currentDate, action);
        dateProfile = $76a516e930faac74$var$reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
        if (action.type === "PREV" || // TODO: move this logic into DateProfileGenerator
        action.type === "NEXT" || // "
        !(0, $200f5cce291452b2$export$7f8ddf7c7c20b3cd)(dateProfile.currentRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let eventSources = $76a516e930faac74$var$reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
        let eventStore = (0, $200f5cce291452b2$export$3466f893ebf79586)(state.eventStore, action, eventSources, dateProfile, calendarContext);
        let isEventsLoading = $76a516e930faac74$var$computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
        let renderableEventStore = isEventsLoading && !currentViewData.options.progressiveEventRendering ? state.renderableEventStore || eventStore : eventStore;
        let { eventUiSingleBase: eventUiSingleBase, selectionConfig: selectionConfig } = this.buildViewUiProps(calendarContext); // will memoize obj
        let eventUiBySource = this.buildEventUiBySource(eventSources);
        let eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
        let newState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            eventSources: eventSources,
            eventStore: eventStore,
            renderableEventStore: renderableEventStore,
            selectionConfig: selectionConfig,
            eventUiBases: eventUiBases,
            businessHours: this.parseContextBusinessHours(calendarContext),
            dateSelection: $76a516e930faac74$var$reduceDateSelection(state.dateSelection, action),
            eventSelection: $76a516e930faac74$var$reduceSelectedEvent(state.eventSelection, action),
            eventDrag: $76a516e930faac74$var$reduceEventDrag(state.eventDrag, action),
            eventResize: $76a516e930faac74$var$reduceEventResize(state.eventResize, action)
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), newState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
        let wasLoading = $76a516e930faac74$var$computeIsLoading(state, calendarContext);
        let isLoading = $76a516e930faac74$var$computeIsLoading(newState, calendarContext);
        // TODO: use propSetHandlers in plugin system
        if (!wasLoading && isLoading) emitter.trigger("loading", true);
        else if (wasLoading && !isLoading) emitter.trigger("loading", false);
        this.state = newState;
        if (props.onAction) props.onAction(action);
    }
    updateData() {
        let { props: props, state: state } = this;
        let oldData = this.data;
        let optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
        let currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
        let data = this.data = Object.assign(Object.assign(Object.assign({
            viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv),
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        }, optionsData), currentViewData), state);
        let changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
        let oldCalendarOptions = oldData && oldData.calendarOptions;
        let newCalendarOptions = optionsData.calendarOptions;
        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
                // hack
                state.eventSources = data.eventSources = $76a516e930faac74$var$reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
                state.eventStore = data.eventStore = (0, $200f5cce291452b2$export$61196ced6d74a310)(data.eventStore, oldData.dateEnv, data.dateEnv);
                state.renderableEventStore = data.renderableEventStore = (0, $200f5cce291452b2$export$61196ced6d74a310)(data.renderableEventStore, oldData.dateEnv, data.dateEnv);
            }
            for(let optionName in changeHandlers)if (this.optionsForHandling.indexOf(optionName) !== -1 || oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) changeHandlers[optionName](newCalendarOptions[optionName], data);
        }
        this.optionsForHandling = [];
        if (props.onData) props.onData(data);
    }
    computeOptionsData(optionOverrides, dynamicOptionOverrides, calendarApi) {
        // TODO: blacklist options that are handled by optionChangeHandlers
        if (!this.optionsForRefining.length && optionOverrides === this.stableOptionOverrides && dynamicOptionOverrides === this.stableDynamicOptionOverrides) return this.stableCalendarOptionsData;
        let { refinedOptions: refinedOptions, pluginHooks: pluginHooks, localeDefaults: localeDefaults, availableLocaleData: availableLocaleData, extra: extra } = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides);
        $76a516e930faac74$var$warnUnknownOptions(extra);
        let dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
        let viewSpecs = this.buildViewSpecs(pluginHooks.views, this.stableOptionOverrides, this.stableDynamicOptionOverrides, localeDefaults);
        let theme = this.buildTheme(refinedOptions, pluginHooks);
        let toolbarConfig = this.parseToolbars(refinedOptions, this.stableOptionOverrides, theme, viewSpecs, calendarApi);
        return this.stableCalendarOptionsData = {
            calendarOptions: refinedOptions,
            pluginHooks: pluginHooks,
            dateEnv: dateEnv,
            viewSpecs: viewSpecs,
            theme: theme,
            toolbarConfig: toolbarConfig,
            localeDefaults: localeDefaults,
            availableRawLocales: availableLocaleData.map
        };
    }
    // always called from behind a memoizer
    processRawCalendarOptions(optionOverrides, dynamicOptionOverrides) {
        let { locales: locales, locale: locale } = (0, $200f5cce291452b2$export$3a1a48c8f6ef640e)([
            (0, $200f5cce291452b2$export$f1e1789686576879),
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let availableLocaleData = this.organizeRawLocales(locales);
        let availableRawLocales = availableLocaleData.map;
        let localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
        let pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], $76a516e930faac74$export$905153d94e0757fa);
        let refiners = this.currentCalendarOptionsRefiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $200f5cce291452b2$export$a07804094c3ecf2d)), (0, $200f5cce291452b2$export$c4ce752e73470fba)), (0, $200f5cce291452b2$export$56c0d5a1e737357d)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let extra = {};
        let raw = (0, $200f5cce291452b2$export$3a1a48c8f6ef640e)([
            (0, $200f5cce291452b2$export$f1e1789686576879),
            localeDefaults,
            optionOverrides,
            dynamicOptionOverrides
        ]);
        let refined = {};
        let currentRaw = this.currentCalendarOptionsInput;
        let currentRefined = this.currentCalendarOptionsRefined;
        let anyChanges = false;
        for(let optionName in raw){
            if (this.optionsForRefining.indexOf(optionName) === -1 && (raw[optionName] === currentRaw[optionName] || (0, $200f5cce291452b2$export$3722cfe417b6ed86)[optionName] && optionName in currentRaw && (0, $200f5cce291452b2$export$3722cfe417b6ed86)[optionName](currentRaw[optionName], raw[optionName]))) refined[optionName] = currentRefined[optionName];
            else if (refiners[optionName]) {
                refined[optionName] = refiners[optionName](raw[optionName]);
                anyChanges = true;
            } else extra[optionName] = currentRaw[optionName];
        }
        if (anyChanges) {
            this.currentCalendarOptionsInput = raw;
            this.currentCalendarOptionsRefined = refined;
            this.stableOptionOverrides = optionOverrides;
            this.stableDynamicOptionOverrides = dynamicOptionOverrides;
        }
        this.optionsForHandling.push(...this.optionsForRefining);
        this.optionsForRefining = [];
        return {
            rawOptions: this.currentCalendarOptionsInput,
            refinedOptions: this.currentCalendarOptionsRefined,
            pluginHooks: pluginHooks,
            availableLocaleData: availableLocaleData,
            localeDefaults: localeDefaults,
            extra: extra
        };
    }
    _computeCurrentViewData(viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
        let viewSpec = optionsData.viewSpecs[viewType];
        if (!viewSpec) throw new Error(`viewType "${viewType}" is not available. Please make sure you've loaded all neccessary plugins`);
        let { refinedOptions: refinedOptions, extra: extra } = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides);
        $76a516e930faac74$var$warnUnknownOptions(extra);
        let dateProfileGenerator = this.buildDateProfileGenerator({
            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
            duration: viewSpec.duration,
            durationUnit: viewSpec.durationUnit,
            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
            dateEnv: optionsData.dateEnv,
            calendarApi: this.props.calendarApi,
            slotMinTime: refinedOptions.slotMinTime,
            slotMaxTime: refinedOptions.slotMaxTime,
            showNonCurrentDates: refinedOptions.showNonCurrentDates,
            dayCount: refinedOptions.dayCount,
            dateAlignment: refinedOptions.dateAlignment,
            dateIncrement: refinedOptions.dateIncrement,
            hiddenDays: refinedOptions.hiddenDays,
            weekends: refinedOptions.weekends,
            nowInput: refinedOptions.now,
            validRangeInput: refinedOptions.validRange,
            visibleRangeInput: refinedOptions.visibleRange,
            fixedWeekCount: refinedOptions.fixedWeekCount
        });
        let viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
        return {
            viewSpec: viewSpec,
            options: refinedOptions,
            dateProfileGenerator: dateProfileGenerator,
            viewApi: viewApi
        };
    }
    processRawViewOptions(viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
        let raw = (0, $200f5cce291452b2$export$3a1a48c8f6ef640e)([
            (0, $200f5cce291452b2$export$f1e1789686576879),
            viewSpec.optionDefaults,
            localeDefaults,
            optionOverrides,
            viewSpec.optionOverrides,
            dynamicOptionOverrides
        ]);
        let refiners = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $200f5cce291452b2$export$a07804094c3ecf2d)), (0, $200f5cce291452b2$export$c4ce752e73470fba)), (0, $200f5cce291452b2$export$56c0d5a1e737357d)), (0, $200f5cce291452b2$export$db202ddc8be9136)), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
        let refined = {};
        let currentRaw = this.currentViewOptionsInput;
        let currentRefined = this.currentViewOptionsRefined;
        let anyChanges = false;
        let extra = {};
        for(let optionName in raw)if (raw[optionName] === currentRaw[optionName] || (0, $200f5cce291452b2$export$3722cfe417b6ed86)[optionName] && (0, $200f5cce291452b2$export$3722cfe417b6ed86)[optionName](raw[optionName], currentRaw[optionName])) refined[optionName] = currentRefined[optionName];
        else {
            if (raw[optionName] === this.currentCalendarOptionsInput[optionName] || (0, $200f5cce291452b2$export$3722cfe417b6ed86)[optionName] && (0, $200f5cce291452b2$export$3722cfe417b6ed86)[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName])) {
                if (optionName in this.currentCalendarOptionsRefined) refined[optionName] = this.currentCalendarOptionsRefined[optionName];
            } else if (refiners[optionName]) refined[optionName] = refiners[optionName](raw[optionName]);
            else extra[optionName] = raw[optionName];
            anyChanges = true;
        }
        if (anyChanges) {
            this.currentViewOptionsInput = raw;
            this.currentViewOptionsRefined = refined;
        }
        return {
            rawOptions: this.currentViewOptionsInput,
            refinedOptions: this.currentViewOptionsRefined,
            extra: extra
        };
    }
    constructor(props){
        this.computeCurrentViewData = (0, $200f5cce291452b2$export$df995fae86a55f06)(this._computeCurrentViewData);
        this.organizeRawLocales = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$organizeRawLocales);
        this.buildLocale = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildLocale);
        this.buildPluginHooks = $76a516e930faac74$var$buildBuildPluginHooks();
        this.buildDateEnv = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildDateEnv$1);
        this.buildTheme = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildTheme);
        this.parseToolbars = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$parseToolbars);
        this.buildViewSpecs = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildViewSpecs);
        this.buildDateProfileGenerator = (0, $200f5cce291452b2$export$ebd11618f299a286)($76a516e930faac74$var$buildDateProfileGenerator);
        this.buildViewApi = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildViewApi);
        this.buildViewUiProps = (0, $200f5cce291452b2$export$ebd11618f299a286)($76a516e930faac74$var$buildViewUiProps);
        this.buildEventUiBySource = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildEventUiBySource, (0, $200f5cce291452b2$export$a9c23c6ac3fc3eca));
        this.buildEventUiBases = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildEventUiBases);
        this.parseContextBusinessHours = (0, $200f5cce291452b2$export$ebd11618f299a286)($76a516e930faac74$var$parseContextBusinessHours);
        this.buildTitle = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildTitle);
        this.emitter = new (0, $200f5cce291452b2$export$d66501df72047452)();
        this.actionRunner = new $76a516e930faac74$var$TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
        this.currentCalendarOptionsInput = {};
        this.currentCalendarOptionsRefined = {};
        this.currentViewOptionsInput = {};
        this.currentViewOptionsRefined = {};
        this.currentCalendarOptionsRefiners = {};
        this.optionsForRefining = [];
        this.optionsForHandling = [];
        this.getCurrentData = ()=>this.data;
        this.dispatch = (action)=>{
            this.actionRunner.request(action); // protects against recursive calls to _handleAction
        };
        this.props = props;
        this.actionRunner.pause();
        let dynamicOptionOverrides = {};
        let optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
        let currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
        let currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
        // wire things up
        // TODO: not DRY
        props.calendarApi.currentDataManager = this;
        this.emitter.setThisContext(props.calendarApi);
        this.emitter.setOptions(currentViewData.options);
        let currentDate = (0, $200f5cce291452b2$export$2329c99376c9d0a4)(optionsData.calendarOptions, optionsData.dateEnv);
        let dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
        if (!(0, $200f5cce291452b2$export$7f8ddf7c7c20b3cd)(dateProfile.activeRange, currentDate)) currentDate = dateProfile.currentRange.start;
        let calendarContext = {
            dateEnv: optionsData.dateEnv,
            options: optionsData.calendarOptions,
            pluginHooks: optionsData.pluginHooks,
            calendarApi: props.calendarApi,
            dispatch: this.dispatch,
            emitter: this.emitter,
            getCurrentData: this.getCurrentData
        };
        // needs to be after setThisContext
        for (let callback of optionsData.pluginHooks.contextInit)callback(calendarContext);
        // NOT DRY
        let eventSources = $76a516e930faac74$var$initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
        let initialState = {
            dynamicOptionOverrides: dynamicOptionOverrides,
            currentViewType: currentViewType,
            currentDate: currentDate,
            dateProfile: dateProfile,
            businessHours: this.parseContextBusinessHours(calendarContext),
            eventSources: eventSources,
            eventUiBases: {},
            eventStore: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
            renderableEventStore: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
            dateSelection: null,
            eventSelection: "",
            eventDrag: null,
            eventResize: null,
            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig
        };
        let contextAndState = Object.assign(Object.assign({}, calendarContext), initialState);
        for (let reducer of optionsData.pluginHooks.reducers)Object.assign(initialState, reducer(null, null, contextAndState));
        if ($76a516e930faac74$var$computeIsLoading(initialState, calendarContext)) this.emitter.trigger("loading", true); // NOT DRY
        this.state = initialState;
        this.updateData();
        this.actionRunner.resume();
    }
}
function $76a516e930faac74$var$buildDateEnv$1(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
    let locale = $76a516e930faac74$var$buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
    return new (0, $200f5cce291452b2$export$25ce5a424b770e84)({
        calendarSystem: "gregory",
        timeZone: timeZone,
        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
        locale: locale,
        weekNumberCalculation: weekNumberCalculation,
        firstDay: firstDay,
        weekText: weekText,
        cmdFormatter: pluginHooks.cmdFormatter,
        defaultSeparator: defaultSeparator
    });
}
function $76a516e930faac74$var$buildTheme(options, pluginHooks) {
    let ThemeClass = pluginHooks.themeClasses[options.themeSystem] || $76a516e930faac74$var$StandardTheme;
    return new ThemeClass(options);
}
function $76a516e930faac74$var$buildDateProfileGenerator(props) {
    let DateProfileGeneratorClass = props.dateProfileGeneratorClass || (0, $200f5cce291452b2$export$3a6d5c9ae78a2c08);
    return new DateProfileGeneratorClass(props);
}
function $76a516e930faac74$var$buildViewApi(type, getCurrentData, dateEnv) {
    return new $76a516e930faac74$var$ViewImpl(type, getCurrentData, dateEnv);
}
function $76a516e930faac74$var$buildEventUiBySource(eventSources) {
    return (0, $200f5cce291452b2$export$407448d2b89b1813)(eventSources, (eventSource)=>eventSource.ui);
}
function $76a516e930faac74$var$buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
    let eventUiBases = {
        "": eventUiSingleBase
    };
    for(let defId in eventDefs){
        let def = eventDefs[defId];
        if (def.sourceId && eventUiBySource[def.sourceId]) eventUiBases[defId] = eventUiBySource[def.sourceId];
    }
    return eventUiBases;
}
function $76a516e930faac74$var$buildViewUiProps(calendarContext) {
    let { options: options } = calendarContext;
    return {
        eventUiSingleBase: (0, $200f5cce291452b2$export$71cec2538cb2c617)({
            display: options.eventDisplay,
            editable: options.editable,
            startEditable: options.eventStartEditable,
            durationEditable: options.eventDurationEditable,
            constraint: options.eventConstraint,
            overlap: typeof options.eventOverlap === "boolean" ? options.eventOverlap : undefined,
            allow: options.eventAllow,
            backgroundColor: options.eventBackgroundColor,
            borderColor: options.eventBorderColor,
            textColor: options.eventTextColor,
            color: options.eventColor
        }, calendarContext),
        selectionConfig: (0, $200f5cce291452b2$export$71cec2538cb2c617)({
            constraint: options.selectConstraint,
            overlap: typeof options.selectOverlap === "boolean" ? options.selectOverlap : undefined,
            allow: options.selectAllow
        }, calendarContext)
    };
}
function $76a516e930faac74$var$computeIsLoading(state, context) {
    for (let isLoadingFunc of context.pluginHooks.isLoadingFuncs){
        if (isLoadingFunc(state)) return true;
    }
    return false;
}
function $76a516e930faac74$var$parseContextBusinessHours(calendarContext) {
    return (0, $200f5cce291452b2$export$78acf4525d8a74c4)(calendarContext.options.businessHours, calendarContext);
}
function $76a516e930faac74$var$warnUnknownOptions(options, viewName) {
    for(let optionName in options)console.warn(`Unknown option '${optionName}'` + (viewName ? ` for view '${viewName}'` : ""));
}
class $76a516e930faac74$var$ToolbarSection extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let children = this.props.widgetGroups.map((widgetGroup)=>this.renderWidgetGroup(widgetGroup));
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-toolbar-chunk"
        }, ...children);
    }
    renderWidgetGroup(widgetGroup) {
        let { props: props } = this;
        let { theme: theme } = this.context;
        let children = [];
        let isOnlyButtons = true;
        for (let widget of widgetGroup){
            let { buttonName: buttonName, buttonClick: buttonClick, buttonText: buttonText, buttonIcon: buttonIcon, buttonHint: buttonHint } = widget;
            if (buttonName === "title") {
                isOnlyButtons = false;
                children.push((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("h2", {
                    className: "fc-toolbar-title",
                    id: props.titleId
                }, props.title));
            } else {
                let isPressed = buttonName === props.activeButton;
                let isDisabled = !props.isTodayEnabled && buttonName === "today" || !props.isPrevEnabled && buttonName === "prev" || !props.isNextEnabled && buttonName === "next";
                let buttonClasses = [
                    `fc-${buttonName}-button`,
                    theme.getClass("button")
                ];
                if (isPressed) buttonClasses.push(theme.getClass("buttonActive"));
                children.push((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("button", {
                    type: "button",
                    title: typeof buttonHint === "function" ? buttonHint(props.navUnit) : buttonHint,
                    disabled: isDisabled,
                    "aria-pressed": isPressed,
                    className: buttonClasses.join(" "),
                    onClick: buttonClick
                }, buttonText || (buttonIcon ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("span", {
                    className: buttonIcon
                }) : "")));
            }
        }
        if (children.length > 1) {
            let groupClassName = isOnlyButtons && theme.getClass("buttonGroup") || "";
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: groupClassName
            }, ...children);
        }
        return children[0];
    }
}
class $76a516e930faac74$var$Toolbar extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { model: model, extraClassName: extraClassName } = this.props;
        let forceLtr = false;
        let startContent;
        let endContent;
        let sectionWidgets = model.sectionWidgets;
        let centerContent = sectionWidgets.center;
        if (sectionWidgets.left) {
            forceLtr = true;
            startContent = sectionWidgets.left;
        } else startContent = sectionWidgets.start;
        if (sectionWidgets.right) {
            forceLtr = true;
            endContent = sectionWidgets.right;
        } else endContent = sectionWidgets.end;
        let classNames = [
            extraClassName || "",
            "fc-toolbar",
            forceLtr ? "fc-toolbar-ltr" : ""
        ];
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: classNames.join(" ")
        }, this.renderSection("start", startContent || []), this.renderSection("center", centerContent || []), this.renderSection("end", endContent || []));
    }
    renderSection(key, widgetGroups) {
        let { props: props } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($76a516e930faac74$var$ToolbarSection, {
            key: key,
            widgetGroups: widgetGroups,
            title: props.title,
            navUnit: props.navUnit,
            activeButton: props.activeButton,
            isTodayEnabled: props.isTodayEnabled,
            isPrevEnabled: props.isPrevEnabled,
            isNextEnabled: props.isNextEnabled,
            titleId: props.titleId
        });
    }
}
class $76a516e930faac74$var$ViewHarness extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props, state: state } = this;
        let { aspectRatio: aspectRatio } = props;
        let classNames = [
            "fc-view-harness",
            aspectRatio || props.liquid || props.height ? "fc-view-harness-active" // harness controls the height
             : "fc-view-harness-passive"
        ];
        let height = "";
        let paddingBottom = "";
        if (aspectRatio) {
            if (state.availableWidth !== null) height = state.availableWidth / aspectRatio;
            else // while waiting to know availableWidth, we can't set height to *zero*
            // because will cause lots of unnecessary scrollbars within scrollgrid.
            // BETTER: don't start rendering ANYTHING yet until we know container width
            // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
            paddingBottom = `${1 / aspectRatio * 100}%`;
        } else height = props.height || "";
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            "aria-labelledby": props.labeledById,
            ref: this.handleEl,
            className: classNames.join(" "),
            style: {
                height: height,
                paddingBottom: paddingBottom
            }
        }, props.children);
    }
    componentDidMount() {
        this.context.addResizeHandler(this.handleResize);
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    updateAvailableWidth() {
        if (this.el && // needed. but why?
        this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
        ) this.setState({
            availableWidth: this.el.offsetWidth
        });
    }
    constructor(){
        super(...arguments);
        this.state = {
            availableWidth: null
        };
        this.handleEl = (el)=>{
            this.el = el;
            (0, $200f5cce291452b2$export$8743009a87fcb00f)(this.props.elRef, el);
            this.updateAvailableWidth();
        };
        this.handleResize = ()=>{
            this.updateAvailableWidth();
        };
    }
}
/*
Detects when the user clicks on an event within a DateComponent
*/ class $76a516e930faac74$var$EventClicking extends (0, $200f5cce291452b2$export$dc98b0b04f4c7758) {
    constructor(settings){
        super(settings);
        this.handleSegClick = (ev, segEl)=>{
            let { component: component } = this;
            let { context: context } = component;
            let seg = (0, $200f5cce291452b2$export$71511d61b312f219)(segEl);
            if (seg && // might be the <div> surrounding the more link
            component.isValidSegDownEl(ev.target)) {
                // our way to simulate a link click for elements that can't be <a> tags
                // grab before trigger fired in case trigger trashes DOM thru rerendering
                let hasUrlContainer = (0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(ev.target, ".fc-event-forced-url");
                let url = hasUrlContainer ? hasUrlContainer.querySelector("a[href]").href : "";
                context.emitter.trigger("eventClick", {
                    el: segEl,
                    event: new (0, $200f5cce291452b2$export$34aec0b863436764)(component.context, seg.eventRange.def, seg.eventRange.instance),
                    jsEvent: ev,
                    view: context.viewApi
                });
                if (url && !ev.defaultPrevented) window.location.href = url;
            }
        };
        this.destroy = (0, $200f5cce291452b2$export$3c2fa207a37baaea)(settings.el, "click", ".fc-event", this.handleSegClick);
    }
}
/*
Triggers events and adds/removes core classNames when the user's pointer
enters/leaves event-elements of a component.
*/ class $76a516e930faac74$var$EventHovering extends (0, $200f5cce291452b2$export$dc98b0b04f4c7758) {
    destroy() {
        this.removeHoverListeners();
    }
    triggerEvent(publicEvName, ev, segEl) {
        let { component: component } = this;
        let { context: context } = component;
        let seg = (0, $200f5cce291452b2$export$71511d61b312f219)(segEl);
        if (!ev || component.isValidSegDownEl(ev.target)) context.emitter.trigger(publicEvName, {
            el: segEl,
            event: new (0, $200f5cce291452b2$export$34aec0b863436764)(context, seg.eventRange.def, seg.eventRange.instance),
            jsEvent: ev,
            view: context.viewApi
        });
    }
    constructor(settings){
        super(settings);
        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
        this.handleEventElRemove = (el)=>{
            if (el === this.currentSegEl) this.handleSegLeave(null, this.currentSegEl);
        };
        this.handleSegEnter = (ev, segEl)=>{
            if ((0, $200f5cce291452b2$export$71511d61b312f219)(segEl)) {
                this.currentSegEl = segEl;
                this.triggerEvent("eventMouseEnter", ev, segEl);
            }
        };
        this.handleSegLeave = (ev, segEl)=>{
            if (this.currentSegEl) {
                this.currentSegEl = null;
                this.triggerEvent("eventMouseLeave", ev, segEl);
            }
        };
        this.removeHoverListeners = (0, $200f5cce291452b2$export$ce26c07117d59d6a)(settings.el, ".fc-event", this.handleSegEnter, this.handleSegLeave);
    }
}
class $76a516e930faac74$var$CalendarContent extends (0, $200f5cce291452b2$export$6559d589eb85fbb6) {
    /*
    renders INSIDE of an outer div
    */ render() {
        let { props: props } = this;
        let { toolbarConfig: toolbarConfig, options: options } = props;
        let toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, (0, $200f5cce291452b2$export$c3950d9923825c02)(props.options.now, props.dateEnv), props.viewTitle);
        let viewVGrow = false;
        let viewHeight = "";
        let viewAspectRatio;
        if (props.isHeightAuto || props.forPrint) viewHeight = "";
        else if (options.height != null) viewVGrow = true;
        else if (options.contentHeight != null) viewHeight = options.contentHeight;
        else viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
        let viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
        let viewLabelId = toolbarConfig.header && toolbarConfig.header.hasTitle ? this.state.viewLabelId : "";
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7c866399fa523f5).Provider, {
            value: viewContext
        }, toolbarConfig.header && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($76a516e930faac74$var$Toolbar, Object.assign({
            ref: this.headerRef,
            extraClassName: "fc-header-toolbar",
            model: toolbarConfig.header,
            titleId: viewLabelId
        }, toolbarProps)), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($76a516e930faac74$var$ViewHarness, {
            liquid: viewVGrow,
            height: viewHeight,
            aspectRatio: viewAspectRatio,
            labeledById: viewLabelId
        }, this.renderView(props), this.buildAppendContent()), toolbarConfig.footer && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($76a516e930faac74$var$Toolbar, Object.assign({
            ref: this.footerRef,
            extraClassName: "fc-footer-toolbar",
            model: toolbarConfig.footer,
            titleId: ""
        }, toolbarProps)));
    }
    componentDidMount() {
        let { props: props } = this;
        this.calendarInteractions = props.pluginHooks.calendarInteractions.map((CalendarInteractionClass)=>new CalendarInteractionClass(props));
        window.addEventListener("resize", this.handleWindowResize);
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)propSetHandlers[propName](props[propName], props);
    }
    componentDidUpdate(prevProps) {
        let { props: props } = this;
        let { propSetHandlers: propSetHandlers } = props.pluginHooks;
        for(let propName in propSetHandlers)if (props[propName] !== prevProps[propName]) propSetHandlers[propName](props[propName], props);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowResize);
        this.resizeRunner.clear();
        for (let interaction of this.calendarInteractions)interaction.destroy();
        this.props.emitter.trigger("_unmount");
    }
    buildAppendContent() {
        let { props: props } = this;
        let children = props.pluginHooks.viewContainerAppends.map((buildAppendContent)=>buildAppendContent(props));
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), {}, ...children);
    }
    renderView(props) {
        let { pluginHooks: pluginHooks } = props;
        let { viewSpec: viewSpec } = props;
        let viewProps = {
            dateProfile: props.dateProfile,
            businessHours: props.businessHours,
            eventStore: props.renderableEventStore,
            eventUiBases: props.eventUiBases,
            dateSelection: props.dateSelection,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            isHeightAuto: props.isHeightAuto,
            forPrint: props.forPrint
        };
        let transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
        for (let transformer of transformers)Object.assign(viewProps, transformer.transform(viewProps, props));
        let ViewComponent = viewSpec.component;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(ViewComponent, Object.assign({}, viewProps));
    }
    constructor(){
        super(...arguments);
        this.buildViewContext = (0, $200f5cce291452b2$export$df995fae86a55f06)((0, $200f5cce291452b2$export$efca4cbe5dd06740));
        this.buildViewPropTransformers = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildViewPropTransformers);
        this.buildToolbarProps = (0, $200f5cce291452b2$export$df995fae86a55f06)($76a516e930faac74$var$buildToolbarProps);
        this.headerRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.footerRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.interactionsStore = {};
        // eslint-disable-next-line
        this.state = {
            viewLabelId: (0, $200f5cce291452b2$export$a8550f7dbe79f93a)()
        };
        // Component Registration
        // -----------------------------------------------------------------------------------------------------------------
        this.registerInteractiveComponent = (component, settingsInput)=>{
            let settings = (0, $200f5cce291452b2$export$2e2af4578d910ddf)(component, settingsInput);
            let DEFAULT_INTERACTIONS = [
                $76a516e930faac74$var$EventClicking,
                $76a516e930faac74$var$EventHovering
            ];
            let interactionClasses = DEFAULT_INTERACTIONS.concat(this.props.pluginHooks.componentInteractions);
            let interactions = interactionClasses.map((TheInteractionClass)=>new TheInteractionClass(settings));
            this.interactionsStore[component.uid] = interactions;
            (0, $200f5cce291452b2$export$a93c5207d687da10)[component.uid] = settings;
        };
        this.unregisterInteractiveComponent = (component)=>{
            let listeners = this.interactionsStore[component.uid];
            if (listeners) {
                for (let listener of listeners)listener.destroy();
                delete this.interactionsStore[component.uid];
            }
            delete (0, $200f5cce291452b2$export$a93c5207d687da10)[component.uid];
        };
        // Resizing
        // -----------------------------------------------------------------------------------------------------------------
        this.resizeRunner = new (0, $200f5cce291452b2$export$96f57966bedc81b4)(()=>{
            this.props.emitter.trigger("_resize", true); // should window resizes be considered "forced" ?
            this.props.emitter.trigger("windowResize", {
                view: this.props.viewApi
            });
        });
        this.handleWindowResize = (ev)=>{
            let { options: options } = this.props;
            if (options.handleWindowResize && ev.target === window // avoid jqui events
            ) this.resizeRunner.request(options.windowResizeDelay);
        };
    }
}
function $76a516e930faac74$var$buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
    let todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
    let prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
    let nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
    return {
        title: title,
        activeButton: viewSpec.type,
        navUnit: viewSpec.singleUnit,
        isTodayEnabled: todayInfo.isValid && !(0, $200f5cce291452b2$export$7f8ddf7c7c20b3cd)(dateProfile.currentRange, now),
        isPrevEnabled: prevInfo.isValid,
        isNextEnabled: nextInfo.isValid
    };
}
// Plugin
// -----------------------------------------------------------------------------------------------------------------
function $76a516e930faac74$var$buildViewPropTransformers(theClasses) {
    return theClasses.map((TheClass)=>new TheClass());
}
class $76a516e930faac74$export$e1aef45b828286de extends (0, $200f5cce291452b2$export$a9c996f45e5784d0) {
    render() {
        let wasRendering = this.isRendering;
        if (!wasRendering) this.isRendering = true;
        else this.customContentRenderId += 1;
        this.renderRunner.request();
        if (wasRendering) this.updateSize();
    }
    destroy() {
        if (this.isRendering) {
            this.isRendering = false;
            this.renderRunner.request();
        }
    }
    updateSize() {
        (0, $200f5cce291452b2$export$7910e0436ed8d1de)(()=>{
            super.updateSize();
        });
    }
    batchRendering(func) {
        this.renderRunner.pause("batchRendering");
        func();
        this.renderRunner.resume("batchRendering");
    }
    pauseRendering() {
        this.renderRunner.pause("pauseRendering");
    }
    resumeRendering() {
        this.renderRunner.resume("pauseRendering", true);
    }
    resetOptions(optionOverrides, changedOptionNames) {
        this.currentDataManager.resetOptions(optionOverrides, changedOptionNames);
    }
    setClassNames(classNames) {
        if (!(0, $200f5cce291452b2$export$23f2a1d2818174ef)(classNames, this.currentClassNames)) {
            let { classList: classList } = this.el;
            for (let className of this.currentClassNames)classList.remove(className);
            for (let className of classNames)classList.add(className);
            this.currentClassNames = classNames;
        }
    }
    setHeight(height) {
        (0, $200f5cce291452b2$export$f787f51d84a910ad)(this.el, "height", height);
    }
    constructor(el, optionOverrides = {}){
        super();
        this.isRendering = false;
        this.isRendered = false;
        this.currentClassNames = [];
        this.customContentRenderId = 0;
        this.handleAction = (action)=>{
            // actions we know we want to render immediately
            switch(action.type){
                case "SET_EVENT_DRAG":
                case "SET_EVENT_RESIZE":
                    this.renderRunner.tryDrain();
            }
        };
        this.handleData = (data)=>{
            this.currentData = data;
            this.renderRunner.request(data.calendarOptions.rerenderDelay);
        };
        this.handleRenderRequest = ()=>{
            if (this.isRendering) {
                this.isRendered = true;
                let { currentData: currentData } = this;
                (0, $200f5cce291452b2$export$7910e0436ed8d1de)(()=>{
                    (0, $f652a0e37ee35e91$export$b3890eb0ae9dca99)((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$555508cbc6add439), {
                        options: currentData.calendarOptions,
                        theme: currentData.theme,
                        emitter: currentData.emitter
                    }, (classNames, height, isHeightAuto, forPrint)=>{
                        this.setClassNames(classNames);
                        this.setHeight(height);
                        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$2219238a014317b0).Provider, {
                            value: this.customContentRenderId
                        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($76a516e930faac74$var$CalendarContent, Object.assign({
                            isHeightAuto: isHeightAuto,
                            forPrint: forPrint
                        }, currentData)));
                    }), this.el);
                });
            } else if (this.isRendered) {
                this.isRendered = false;
                (0, $f652a0e37ee35e91$export$b3890eb0ae9dca99)(null, this.el);
                this.setClassNames([]);
                this.setHeight("");
            }
        };
        (0, $200f5cce291452b2$export$4c3d22f3d993c33f)(el);
        this.el = el;
        this.renderRunner = new (0, $200f5cce291452b2$export$96f57966bedc81b4)(this.handleRenderRequest);
        new $76a516e930faac74$var$CalendarDataManager({
            optionOverrides: optionOverrides,
            calendarApi: this,
            onAction: this.handleAction,
            onData: this.handleData
        });
    }
}
function $76a516e930faac74$export$3ae94a2503e890a1(dateInput, options = {}) {
    let dateEnv = $76a516e930faac74$var$buildDateEnv(options);
    let formatter = (0, $200f5cce291452b2$export$d141bba7fdc215a3)(options);
    let dateMeta = dateEnv.createMarkerMeta(dateInput);
    if (!dateMeta) return "";
    return dateEnv.format(dateMeta.marker, formatter, {
        forcedTzo: dateMeta.forcedTzo
    });
}
function $76a516e930faac74$export$9b1080e2eec9158(startInput, endInput, options) {
    let dateEnv = $76a516e930faac74$var$buildDateEnv(typeof options === "object" && options ? options : {}); // pass in if non-null object
    let formatter = (0, $200f5cce291452b2$export$d141bba7fdc215a3)(options);
    let startMeta = dateEnv.createMarkerMeta(startInput);
    let endMeta = dateEnv.createMarkerMeta(endInput);
    if (!startMeta || !endMeta) return "";
    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
        forcedStartTzo: startMeta.forcedTzo,
        forcedEndTzo: endMeta.forcedTzo,
        isEndExclusive: options.isEndExclusive,
        defaultSeparator: (0, $200f5cce291452b2$export$f1e1789686576879).defaultRangeSeparator
    });
}
// TODO: more DRY and optimized
function $76a516e930faac74$var$buildDateEnv(settings) {
    let locale = $76a516e930faac74$var$buildLocale(settings.locale || "en", $76a516e930faac74$var$organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
    return new (0, $200f5cce291452b2$export$25ce5a424b770e84)(Object.assign(Object.assign({
        timeZone: (0, $200f5cce291452b2$export$f1e1789686576879).timeZone,
        calendarSystem: "gregory"
    }, settings), {
        locale: locale
    }));
}
// HELPERS
/*
if nextDayThreshold is specified, slicing is done in an all-day fashion.
you can get nextDayThreshold from context.nextDayThreshold
*/ function $76a516e930faac74$export$3b384895d0cca0f2(props, allDay) {
    return (0, $200f5cce291452b2$export$c9170ad7d4cd7e57)(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
}
const $76a516e930faac74$export$83d89fbfd8236492 = "6.1.8";



class $ebe887ed207f0a89$export$2e2bcd8739ae039 extends (0, $7fPBF.Component) {
    render() {
        const customRenderingNodes = [];
        for (const customRendering of this.state.customRenderingMap.values())customRenderingNodes.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ebe887ed207f0a89$var$CustomRenderingComponent, {
            key: customRendering.id,
            customRendering: customRendering
        }));
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            ref: this.elRef
        }, customRenderingNodes);
    }
    componentDidMount() {
        const customRenderingStore = new (0, $200f5cce291452b2$export$aea64bc1b6f8f415)();
        this.handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
        this.calendar = new (0, $76a516e930faac74$export$e1aef45b828286de)(this.elRef.current, Object.assign(Object.assign({}, this.props), {
            handleCustomRendering: this.handleCustomRendering
        }));
        this.calendar.render();
        let lastRequestTimestamp;
        customRenderingStore.subscribe((customRenderingMap)=>{
            const requestTimestamp = Date.now();
            const isMounting = !lastRequestTimestamp;
            const runFunc = isMounting || this.isUpdating || this.isUnmounting || requestTimestamp - lastRequestTimestamp < 100 // rerendering frequently
             ? $ebe887ed207f0a89$var$runNow // either sync rendering (first-time or React 17) or async (React 18)
             : (0, $fw0lo.flushSync); // guaranteed sync rendering
            runFunc(()=>{
                this.setState({
                    customRenderingMap: customRenderingMap
                }, ()=>{
                    lastRequestTimestamp = requestTimestamp;
                    if (isMounting) this.doResize();
                    else this.requestResize();
                });
            });
        });
    }
    componentDidUpdate() {
        this.isUpdating = true;
        this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), {
            handleCustomRendering: this.handleCustomRendering
        }));
        this.isUpdating = false;
    }
    componentWillUnmount() {
        this.isUnmounting = true;
        this.cancelResize();
        this.calendar.destroy();
    }
    doResize() {
        this.calendar.updateSize();
    }
    cancelResize() {
        if (this.resizeId !== undefined) {
            cancelAnimationFrame(this.resizeId);
            this.resizeId = undefined;
        }
    }
    getApi() {
        return this.calendar;
    }
    constructor(){
        super(...arguments);
        this.elRef = (0, $7fPBF.createRef)();
        this.isUpdating = false;
        this.isUnmounting = false;
        this.state = {
            customRenderingMap: new Map()
        };
        this.requestResize = ()=>{
            if (!this.isUnmounting) {
                this.cancelResize();
                this.resizeId = requestAnimationFrame(()=>{
                    this.doResize();
                });
            }
        };
    }
}
$ebe887ed207f0a89$export$2e2bcd8739ae039.act = $ebe887ed207f0a89$var$runNow; // DEPRECATED. Not leveraged anymore
class $ebe887ed207f0a89$var$CustomRenderingComponent extends (0, $7fPBF.PureComponent) {
    render() {
        const { customRendering: customRendering } = this.props;
        const { generatorMeta: generatorMeta } = customRendering;
        const vnode = typeof generatorMeta === "function" ? generatorMeta(customRendering.renderProps) : generatorMeta;
        return (0, $fw0lo.createPortal)(vnode, customRendering.containerEl);
    }
}
// Util
// -------------------------------------------------------------------------------------------------
function $ebe887ed207f0a89$var$runNow(f) {
    f();
}





var $cc06286d62b8a4b0$var$css_248z = ':root{--fc-daygrid-event-dot-width:8px}.fc-daygrid-day-events:after,.fc-daygrid-day-events:before,.fc-daygrid-day-frame:after,.fc-daygrid-day-frame:before,.fc-daygrid-event-harness:after,.fc-daygrid-event-harness:before{clear:both;content:"";display:table}.fc .fc-daygrid-body{position:relative;z-index:1}.fc .fc-daygrid-day.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-daygrid-day-frame{min-height:100%;position:relative}.fc .fc-daygrid-day-top{display:flex;flex-direction:row-reverse}.fc .fc-day-other .fc-daygrid-day-top{opacity:.3}.fc .fc-daygrid-day-number{padding:4px;position:relative;z-index:4}.fc .fc-daygrid-month-start{font-size:1.1em;font-weight:700}.fc .fc-daygrid-day-events{margin-top:1px}.fc .fc-daygrid-body-balanced .fc-daygrid-day-events{left:0;position:absolute;right:0}.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events{min-height:2em;position:relative}.fc .fc-daygrid-body-natural .fc-daygrid-day-events{margin-bottom:1em}.fc .fc-daygrid-event-harness{position:relative}.fc .fc-daygrid-event-harness-abs{left:0;position:absolute;right:0;top:0}.fc .fc-daygrid-bg-harness{bottom:0;position:absolute;top:0}.fc .fc-daygrid-day-bg .fc-non-business{z-index:1}.fc .fc-daygrid-day-bg .fc-bg-event{z-index:2}.fc .fc-daygrid-day-bg .fc-highlight{z-index:3}.fc .fc-daygrid-event{margin-top:1px;z-index:6}.fc .fc-daygrid-event.fc-event-mirror{z-index:7}.fc .fc-daygrid-day-bottom{font-size:.85em;margin:0 2px}.fc .fc-daygrid-day-bottom:after,.fc .fc-daygrid-day-bottom:before{clear:both;content:"";display:table}.fc .fc-daygrid-more-link{border-radius:3px;cursor:pointer;line-height:1;margin-top:1px;max-width:100%;overflow:hidden;padding:2px;position:relative;white-space:nowrap;z-index:4}.fc .fc-daygrid-more-link:hover{background-color:rgba(0,0,0,.1)}.fc .fc-daygrid-week-number{background-color:var(--fc-neutral-bg-color);color:var(--fc-neutral-text-color);min-width:1.5em;padding:2px;position:absolute;text-align:center;top:0;z-index:5}.fc .fc-more-popover .fc-popover-body{min-width:220px;padding:10px}.fc-direction-ltr .fc-daygrid-event.fc-event-start,.fc-direction-rtl .fc-daygrid-event.fc-event-end{margin-left:2px}.fc-direction-ltr .fc-daygrid-event.fc-event-end,.fc-direction-rtl .fc-daygrid-event.fc-event-start{margin-right:2px}.fc-direction-ltr .fc-daygrid-more-link{float:left}.fc-direction-ltr .fc-daygrid-week-number{border-radius:0 0 3px 0;left:0}.fc-direction-rtl .fc-daygrid-more-link{float:right}.fc-direction-rtl .fc-daygrid-week-number{border-radius:0 0 0 3px;right:0}.fc-liquid-hack .fc-daygrid-day-frame{position:static}.fc-daygrid-event{border-radius:3px;font-size:var(--fc-small-font-size);position:relative;white-space:nowrap}.fc-daygrid-block-event .fc-event-time{font-weight:700}.fc-daygrid-block-event .fc-event-time,.fc-daygrid-block-event .fc-event-title{padding:1px}.fc-daygrid-dot-event{align-items:center;display:flex;padding:2px 0}.fc-daygrid-dot-event .fc-event-title{flex-grow:1;flex-shrink:1;font-weight:700;min-width:0;overflow:hidden}.fc-daygrid-dot-event.fc-event-mirror,.fc-daygrid-dot-event:hover{background:rgba(0,0,0,.1)}.fc-daygrid-dot-event.fc-event-selected:before{bottom:-10px;top:-10px}.fc-daygrid-event-dot{border:calc(var(--fc-daygrid-event-dot-width)/2) solid var(--fc-event-border-color);border-radius:calc(var(--fc-daygrid-event-dot-width)/2);box-sizing:content-box;height:0;margin:0 4px;width:0}.fc-direction-ltr .fc-daygrid-event .fc-event-time{margin-right:3px}.fc-direction-rtl .fc-daygrid-event .fc-event-time{margin-left:3px}';
(0, $200f5cce291452b2$export$c373adc892eb6355)($cc06286d62b8a4b0$var$css_248z);
function $cc06286d62b8a4b0$var$splitSegsByRow(segs, rowCnt) {
    let byRow = [];
    for(let i = 0; i < rowCnt; i += 1)byRow[i] = [];
    for (let seg of segs)byRow[seg.row].push(seg);
    return byRow;
}
function $cc06286d62b8a4b0$var$splitSegsByFirstCol(segs, colCnt) {
    let byCol = [];
    for(let i = 0; i < colCnt; i += 1)byCol[i] = [];
    for (let seg of segs)byCol[seg.firstCol].push(seg);
    return byCol;
}
function $cc06286d62b8a4b0$var$splitInteractionByRow(ui, rowCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < rowCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < rowCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.row].segs.push(seg);
    }
    return byRow;
}
const $cc06286d62b8a4b0$var$DEFAULT_TABLE_EVENT_TIME_FORMAT = (0, $200f5cce291452b2$export$d141bba7fdc215a3)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "narrow"
});
function $cc06286d62b8a4b0$var$hasListItemDisplay(seg) {
    let { display: display } = seg.eventRange.ui;
    return display === "list-item" || display === "auto" && !seg.eventRange.def.allDay && seg.firstCol === seg.lastCol && // can't be multi-day
    seg.isStart && // "
    seg.isEnd // "
    ;
}
class $cc06286d62b8a4b0$var$TableBlockEvent extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$d92db8a7dc823bb0), Object.assign({}, props, {
            elClasses: [
                "fc-daygrid-event",
                "fc-daygrid-block-event",
                "fc-h-event"
            ],
            defaultTimeFormat: $cc06286d62b8a4b0$var$DEFAULT_TABLE_EVENT_TIME_FORMAT,
            defaultDisplayEventEnd: props.defaultDisplayEventEnd,
            disableResizing: !props.seg.eventRange.def.allDay
        }));
    }
}
class $cc06286d62b8a4b0$var$TableListItemEvent extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { seg: seg } = props;
        let timeFormat = options.eventTimeFormat || $cc06286d62b8a4b0$var$DEFAULT_TABLE_EVENT_TIME_FORMAT;
        let timeText = (0, $200f5cce291452b2$export$993a080e5cb62d74)(seg, timeFormat, context, true, props.defaultDisplayEventEnd);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$1343a74baacb0543), Object.assign({}, props, {
            elTag: "a",
            elClasses: [
                "fc-daygrid-event",
                "fc-daygrid-dot-event"
            ],
            elAttrs: (0, $200f5cce291452b2$export$e0c3a065614c6254)(props.seg, context),
            defaultGenerator: $cc06286d62b8a4b0$var$renderInnerContent,
            timeText: timeText,
            isResizing: false,
            isDateSelecting: false
        }));
    }
}
function $cc06286d62b8a4b0$var$renderInnerContent(renderProps) {
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-daygrid-event-dot",
        style: {
            borderColor: renderProps.borderColor || renderProps.backgroundColor
        }
    }), renderProps.timeText && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-time"
    }, renderProps.timeText), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
        className: "fc-event-title"
    }, renderProps.event.title || (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, "\xa0")));
}
class $cc06286d62b8a4b0$var$TableCellMoreLink extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        let { allSegs: allSegs, invisibleSegs: invisibleSegs } = this.compileSegs(props.singlePlacements);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$cbfbec548517f2b6), {
            elClasses: [
                "fc-daygrid-more-link"
            ],
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            allDayDate: props.allDayDate,
            moreCnt: props.moreCnt,
            allSegs: allSegs,
            hiddenSegs: invisibleSegs,
            alignmentElRef: props.alignmentElRef,
            alignGridTop: props.alignGridTop,
            extraDateSpan: props.extraDateSpan,
            popoverContent: ()=>{
                let isForcedInvisible = (props.eventDrag ? props.eventDrag.affectedInstances : null) || (props.eventResize ? props.eventResize.affectedInstances : null) || {};
                return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, allSegs.map((seg)=>{
                    let instanceId = seg.eventRange.instance.instanceId;
                    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                        className: "fc-daygrid-event-harness",
                        key: instanceId,
                        style: {
                            visibility: isForcedInvisible[instanceId] ? "hidden" : ""
                        }
                    }, $cc06286d62b8a4b0$var$hasListItemDisplay(seg) ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableListItemEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, props.todayRange))) : (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableBlockEvent, Object.assign({
                        seg: seg,
                        isDragging: false,
                        isResizing: false,
                        isDateSelecting: false,
                        isSelected: instanceId === props.eventSelection,
                        defaultDisplayEventEnd: false
                    }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, props.todayRange))));
                }));
            }
        });
    }
    constructor(){
        super(...arguments);
        this.compileSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$compileSegs);
    }
}
function $cc06286d62b8a4b0$var$compileSegs(singlePlacements) {
    let allSegs = [];
    let invisibleSegs = [];
    for (let placement of singlePlacements){
        allSegs.push(placement.seg);
        if (!placement.isVisible) invisibleSegs.push(placement.seg);
    }
    return {
        allSegs: allSegs,
        invisibleSegs: invisibleSegs
    };
}
const $cc06286d62b8a4b0$var$DEFAULT_WEEK_NUM_FORMAT = (0, $200f5cce291452b2$export$d141bba7fdc215a3)({
    week: "narrow"
});
class $cc06286d62b8a4b0$var$TableCell extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { context: context, props: props, state: state, rootElRef: rootElRef } = this;
        let { options: options, dateEnv: dateEnv } = context;
        let { date: date, dateProfile: dateProfile } = props;
        // TODO: memoize this?
        const isMonthStart = props.showDayNumber && $cc06286d62b8a4b0$var$shouldDisplayMonthStart(date, dateProfile.currentRange, dateEnv);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$b975d55abac2bbe3), {
            elTag: "td",
            elRef: this.handleRootEl,
            elClasses: [
                "fc-daygrid-day",
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign(Object.assign(Object.assign({}, props.extraDataAttrs), props.showDayNumber ? {
                "aria-labelledby": state.dayNumberId
            } : {}), {
                role: "gridcell"
            }),
            defaultGenerator: $cc06286d62b8a4b0$var$renderTopInner,
            date: date,
            dateProfile: dateProfile,
            todayRange: props.todayRange,
            showDayNumber: props.showDayNumber,
            isMonthStart: isMonthStart,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent, renderProps)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                ref: props.innerElRef,
                className: "fc-daygrid-day-frame fc-scrollgrid-sync-inner",
                style: {
                    minHeight: props.minHeight
                }
            }, props.showWeekNumber && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$a3c9165b94390bcd), {
                elTag: "a",
                elClasses: [
                    "fc-daygrid-week-number"
                ],
                elAttrs: (0, $200f5cce291452b2$export$8c78c7c36408ea29)(context, date, "week"),
                date: date,
                defaultFormat: $cc06286d62b8a4b0$var$DEFAULT_WEEK_NUM_FORMAT
            }), !renderProps.isDisabled && (props.showDayNumber || (0, $200f5cce291452b2$export$b02498c06ddfef28)(options) || props.forceDayTop) ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top"
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "a",
                elClasses: [
                    "fc-daygrid-day-number",
                    isMonthStart && "fc-daygrid-month-start"
                ],
                elAttrs: Object.assign(Object.assign({}, (0, $200f5cce291452b2$export$8c78c7c36408ea29)(context, date)), {
                    id: state.dayNumberId
                })
            })) : props.showDayNumber ? // for creating correct amount of space (see issue #7162)
            (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-top",
                style: {
                    visibility: "hidden"
                }
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("a", {
                className: "fc-daygrid-day-number"
            }, "\xa0")) : undefined, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-events",
                ref: props.fgContentElRef
            }, props.fgContent, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bottom",
                style: {
                    marginTop: props.moreMarginTop
                }
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableCellMoreLink, {
                allDayDate: date,
                singlePlacements: props.singlePlacements,
                moreCnt: props.moreCnt,
                alignmentElRef: rootElRef,
                alignGridTop: !props.showDayNumber,
                extraDateSpan: props.extraDateSpan,
                dateProfile: props.dateProfile,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                todayRange: props.todayRange
            }))), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-day-bg"
            }, props.bgContent)));
    }
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.state = {
            dayNumberId: (0, $200f5cce291452b2$export$a8550f7dbe79f93a)()
        };
        this.handleRootEl = (el)=>{
            (0, $200f5cce291452b2$export$8743009a87fcb00f)(this.rootElRef, el);
            (0, $200f5cce291452b2$export$8743009a87fcb00f)(this.props.elRef, el);
        };
    }
}
function $cc06286d62b8a4b0$var$renderTopInner(props) {
    return props.dayNumberText || (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, "\xa0");
}
function $cc06286d62b8a4b0$var$shouldDisplayMonthStart(date, currentRange, dateEnv) {
    const { start: currentStart, end: currentEnd } = currentRange;
    const currentEndIncl = (0, $200f5cce291452b2$export$136fd86de524d3c2)(currentEnd, -1);
    const currentFirstYear = dateEnv.getYear(currentStart);
    const currentFirstMonth = dateEnv.getMonth(currentStart);
    const currentLastYear = dateEnv.getYear(currentEndIncl);
    const currentLastMonth = dateEnv.getMonth(currentEndIncl);
    // spans more than one month?
    return !(currentFirstYear === currentLastYear && currentFirstMonth === currentLastMonth) && Boolean(// first date in current view?
    date.valueOf() === currentStart.valueOf() || // a month-start that's within the current range?
    dateEnv.getDay(date) === 1 && date.valueOf() < currentEnd.valueOf());
}
function $cc06286d62b8a4b0$var$computeFgSegPlacement(segs, dayMaxEvents, dayMaxEventRows, strictOrder, eventInstanceHeights, maxContentHeight, cells) {
    let hierarchy = new $cc06286d62b8a4b0$var$DayGridSegHierarchy();
    hierarchy.allowReslicing = true;
    hierarchy.strictOrder = strictOrder;
    if (dayMaxEvents === true || dayMaxEventRows === true) {
        hierarchy.maxCoord = maxContentHeight;
        hierarchy.hiddenConsumes = true;
    } else if (typeof dayMaxEvents === "number") hierarchy.maxStackCnt = dayMaxEvents;
    else if (typeof dayMaxEventRows === "number") {
        hierarchy.maxStackCnt = dayMaxEventRows;
        hierarchy.hiddenConsumes = true;
    }
    // create segInputs only for segs with known heights
    let segInputs = [];
    let unknownHeightSegs = [];
    for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let { instanceId: instanceId } = seg.eventRange.instance;
        let eventHeight = eventInstanceHeights[instanceId];
        if (eventHeight != null) segInputs.push({
            index: i,
            thickness: eventHeight,
            span: {
                start: seg.firstCol,
                end: seg.lastCol + 1
            }
        });
        else unknownHeightSegs.push(seg);
    }
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let segRects = hierarchy.toRects();
    let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, leftoverMargins: leftoverMargins } = $cc06286d62b8a4b0$var$placeRects(segRects, segs, cells);
    let moreCnts = [];
    let moreMarginTops = [];
    // add segs with unknown heights
    for (let seg of unknownHeightSegs){
        multiColPlacements[seg.firstCol].push({
            seg: seg,
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = seg.firstCol; col <= seg.lastCol; col += 1)singleColPlacements[col].push({
            seg: $cc06286d62b8a4b0$var$resliceSeg(seg, col, col + 1, cells),
            isVisible: false,
            isAbsolute: false,
            absoluteTop: 0,
            marginTop: 0
        });
    }
    // add the hidden entries
    for(let col = 0; col < cells.length; col += 1)moreCnts.push(0);
    for (let hiddenEntry of hiddenEntries){
        let seg = segs[hiddenEntry.index];
        let hiddenSpan = hiddenEntry.span;
        multiColPlacements[hiddenSpan.start].push({
            seg: $cc06286d62b8a4b0$var$resliceSeg(seg, hiddenSpan.start, hiddenSpan.end, cells),
            isVisible: false,
            isAbsolute: true,
            absoluteTop: 0,
            marginTop: 0
        });
        for(let col = hiddenSpan.start; col < hiddenSpan.end; col += 1){
            moreCnts[col] += 1;
            singleColPlacements[col].push({
                seg: $cc06286d62b8a4b0$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: false,
                isAbsolute: false,
                absoluteTop: 0,
                marginTop: 0
            });
        }
    }
    // deal with leftover margins
    for(let col = 0; col < cells.length; col += 1)moreMarginTops.push(leftoverMargins[col]);
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        moreCnts: moreCnts,
        moreMarginTops: moreMarginTops
    };
}
// rects ordered by top coord, then left
function $cc06286d62b8a4b0$var$placeRects(allRects, segs, cells) {
    let rectsByEachCol = $cc06286d62b8a4b0$var$groupRectsByEachCol(allRects, cells.length);
    let singleColPlacements = [];
    let multiColPlacements = [];
    let leftoverMargins = [];
    for(let col = 0; col < cells.length; col += 1){
        let rects = rectsByEachCol[col];
        // compute all static segs in singlePlacements
        let singlePlacements = [];
        let currentHeight = 0;
        let currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            singlePlacements.push({
                seg: $cc06286d62b8a4b0$var$resliceSeg(seg, col, col + 1, cells),
                isVisible: true,
                isAbsolute: false,
                absoluteTop: rect.levelCoord,
                marginTop: rect.levelCoord - currentHeight
            });
            currentHeight = rect.levelCoord + rect.thickness;
        }
        // compute mixed static/absolute segs in multiPlacements
        let multiPlacements = [];
        currentHeight = 0;
        currentMarginTop = 0;
        for (let rect of rects){
            let seg = segs[rect.index];
            let isAbsolute = rect.span.end - rect.span.start > 1; // multi-column?
            let isFirstCol = rect.span.start === col;
            currentMarginTop += rect.levelCoord - currentHeight; // amount of space since bottom of previous seg
            currentHeight = rect.levelCoord + rect.thickness; // height will now be bottom of current seg
            if (isAbsolute) {
                currentMarginTop += rect.thickness;
                if (isFirstCol) multiPlacements.push({
                    seg: $cc06286d62b8a4b0$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: true,
                    absoluteTop: rect.levelCoord,
                    marginTop: 0
                });
            } else if (isFirstCol) {
                multiPlacements.push({
                    seg: $cc06286d62b8a4b0$var$resliceSeg(seg, rect.span.start, rect.span.end, cells),
                    isVisible: true,
                    isAbsolute: false,
                    absoluteTop: rect.levelCoord,
                    marginTop: currentMarginTop
                });
                currentMarginTop = 0;
            }
        }
        singleColPlacements.push(singlePlacements);
        multiColPlacements.push(multiPlacements);
        leftoverMargins.push(currentMarginTop);
    }
    return {
        singleColPlacements: singleColPlacements,
        multiColPlacements: multiColPlacements,
        leftoverMargins: leftoverMargins
    };
}
function $cc06286d62b8a4b0$var$groupRectsByEachCol(rects, colCnt) {
    let rectsByEachCol = [];
    for(let col = 0; col < colCnt; col += 1)rectsByEachCol.push([]);
    for (let rect of rects)for(let col = rect.span.start; col < rect.span.end; col += 1)rectsByEachCol[col].push(rect);
    return rectsByEachCol;
}
function $cc06286d62b8a4b0$var$resliceSeg(seg, spanStart, spanEnd, cells) {
    if (seg.firstCol === spanStart && seg.lastCol === spanEnd - 1) return seg;
    let eventRange = seg.eventRange;
    let origRange = eventRange.range;
    let slicedRange = (0, $200f5cce291452b2$export$ae1af26003f05816)(origRange, {
        start: cells[spanStart].date,
        end: (0, $200f5cce291452b2$export$625550452a3fa3ec)(cells[spanEnd - 1].date, 1)
    });
    return Object.assign(Object.assign({}, seg), {
        firstCol: spanStart,
        lastCol: spanEnd - 1,
        eventRange: {
            def: eventRange.def,
            ui: Object.assign(Object.assign({}, eventRange.ui), {
                durationEditable: false
            }),
            instance: eventRange.instance,
            range: slicedRange
        },
        isStart: seg.isStart && slicedRange.start.valueOf() === origRange.start.valueOf(),
        isEnd: seg.isEnd && slicedRange.end.valueOf() === origRange.end.valueOf()
    });
}
class $cc06286d62b8a4b0$var$DayGridSegHierarchy extends (0, $200f5cce291452b2$export$2e63b696b2c9441b) {
    addSegs(segInputs) {
        const hiddenSegs = super.addSegs(segInputs);
        const { entriesByLevel: entriesByLevel } = this;
        const excludeHidden = (entry)=>!this.forceHidden[(0, $200f5cce291452b2$export$eb84e45a33f6ba7c)(entry)];
        // remove the forced-hidden segs
        for(let level = 0; level < entriesByLevel.length; level += 1)entriesByLevel[level] = entriesByLevel[level].filter(excludeHidden);
        return hiddenSegs;
    }
    handleInvalidInsertion(insertion, entry, hiddenEntries) {
        const { entriesByLevel: entriesByLevel, forceHidden: forceHidden } = this;
        const { touchingEntry: touchingEntry, touchingLevel: touchingLevel, touchingLateral: touchingLateral } = insertion;
        if (this.hiddenConsumes && touchingEntry) {
            const touchingEntryId = (0, $200f5cce291452b2$export$eb84e45a33f6ba7c)(touchingEntry);
            // if not already hidden
            if (!forceHidden[touchingEntryId]) {
                if (this.allowReslicing) {
                    const placeholderEntry = Object.assign(Object.assign({}, touchingEntry), {
                        span: (0, $200f5cce291452b2$export$b2bcef12bcefba04)(touchingEntry.span, entry.span)
                    });
                    const placeholderEntryId = (0, $200f5cce291452b2$export$eb84e45a33f6ba7c)(placeholderEntry);
                    forceHidden[placeholderEntryId] = true;
                    entriesByLevel[touchingLevel][touchingLateral] = placeholderEntry; // replace touchingEntry with our placeholder
                    this.splitEntry(touchingEntry, entry, hiddenEntries); // split up the touchingEntry, reinsert it
                } else {
                    forceHidden[touchingEntryId] = true;
                    hiddenEntries.push(touchingEntry);
                }
            }
        }
        return super.handleInvalidInsertion(insertion, entry, hiddenEntries);
    }
    constructor(){
        super(...arguments);
        // config
        this.hiddenConsumes = false;
        // allows us to keep hidden entries in the hierarchy so they take up space
        this.forceHidden = {};
    }
}
class $cc06286d62b8a4b0$var$TableRow extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { props: props, state: state, context: context } = this;
        let { options: options } = context;
        let colCnt = props.cells.length;
        let businessHoursByCol = $cc06286d62b8a4b0$var$splitSegsByFirstCol(props.businessHourSegs, colCnt);
        let bgEventSegsByCol = $cc06286d62b8a4b0$var$splitSegsByFirstCol(props.bgEventSegs, colCnt);
        let highlightSegsByCol = $cc06286d62b8a4b0$var$splitSegsByFirstCol(this.getHighlightSegs(), colCnt);
        let mirrorSegsByCol = $cc06286d62b8a4b0$var$splitSegsByFirstCol(this.getMirrorSegs(), colCnt);
        let { singleColPlacements: singleColPlacements, multiColPlacements: multiColPlacements, moreCnts: moreCnts, moreMarginTops: moreMarginTops } = $cc06286d62b8a4b0$var$computeFgSegPlacement((0, $200f5cce291452b2$export$4d522598b426bb73)(props.fgEventSegs, options.eventOrder), props.dayMaxEvents, props.dayMaxEventRows, options.eventOrderStrict, state.eventInstanceHeights, state.maxContentHeight, props.cells);
        let isForcedInvisible = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
            ref: this.rootElRef,
            role: "row"
        }, props.renderIntro && props.renderIntro(), props.cells.map((cell, col)=>{
            let normalFgNodes = this.renderFgSegs(col, props.forPrint ? singleColPlacements[col] : multiColPlacements[col], props.todayRange, isForcedInvisible);
            let mirrorFgNodes = this.renderFgSegs(col, $cc06286d62b8a4b0$var$buildMirrorPlacements(mirrorSegsByCol[col], multiColPlacements), props.todayRange, {}, Boolean(props.eventDrag), Boolean(props.eventResize), false);
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableCell, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                innerElRef: this.frameElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                showDayNumber: props.showDayNumbers,
                showWeekNumber: props.showWeekNumbers && col === 0,
                forceDayTop: props.showWeekNumbers /* even displaying weeknum for row, not necessarily day */ ,
                todayRange: props.todayRange,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                moreCnt: moreCnts[col],
                moreMarginTop: moreMarginTops[col],
                singlePlacements: singleColPlacements[col],
                fgContentElRef: this.fgElRefs.createRef(cell.key),
                fgContent: (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, normalFgNodes), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, mirrorFgNodes)),
                bgContent: (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, this.renderFillSegs(highlightSegsByCol[col], "highlight"), this.renderFillSegs(businessHoursByCol[col], "non-business"), this.renderFillSegs(bgEventSegsByCol[col], "bg-event")),
                minHeight: props.cellMinHeight
            });
        }));
    }
    componentDidMount() {
        this.updateSizing(true);
        this.context.addResizeHandler(this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        let currentProps = this.props;
        this.updateSizing(!(0, $200f5cce291452b2$export$a9c23c6ac3fc3eca)(prevProps, currentProps));
    }
    componentWillUnmount() {
        this.context.removeResizeHandler(this.handleResize);
    }
    getHighlightSegs() {
        let { props: props } = this;
        if (props.eventDrag && props.eventDrag.segs.length) return props.eventDrag.segs;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return props.dateSelectionSegs;
    }
    getMirrorSegs() {
        let { props: props } = this;
        if (props.eventResize && props.eventResize.segs.length) return props.eventResize.segs;
        return [];
    }
    renderFgSegs(col, segPlacements, todayRange, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
        let { context: context } = this;
        let { eventSelection: eventSelection } = this.props;
        let { framePositions: framePositions } = this.state;
        let defaultDisplayEventEnd = this.props.cells.length === 1; // colCnt === 1
        let isMirror = isDragging || isResizing || isDateSelecting;
        let nodes = [];
        if (framePositions) for (let placement of segPlacements){
            let { seg: seg } = placement;
            let { instanceId: instanceId } = seg.eventRange.instance;
            let key = instanceId + ":" + col;
            let isVisible = placement.isVisible && !isForcedInvisible[instanceId];
            let isAbsolute = placement.isAbsolute;
            let left = "";
            let right = "";
            if (isAbsolute) {
                if (context.isRtl) {
                    right = 0;
                    left = framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol];
                } else {
                    left = 0;
                    right = framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol];
                }
            }
            /*
                known bug: events that are force to be list-item but span multiple days still take up space in later columns
                todo: in print view, for multi-day events, don't display title within non-start/end segs
                */ nodes.push((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-daygrid-event-harness" + (isAbsolute ? " fc-daygrid-event-harness-abs" : ""),
                key: key,
                ref: isMirror ? null : this.segHarnessRefs.createRef(key),
                style: {
                    visibility: isVisible ? "" : "hidden",
                    marginTop: isAbsolute ? "" : placement.marginTop,
                    top: isAbsolute ? placement.absoluteTop : "",
                    left: left,
                    right: right
                }
            }, $cc06286d62b8a4b0$var$hasListItemDisplay(seg) ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableListItemEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, todayRange))) : (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableBlockEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                defaultDisplayEventEnd: defaultDisplayEventEnd
            }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, todayRange)))));
        }
        return nodes;
    }
    renderFillSegs(segs, fillType) {
        let { isRtl: isRtl } = this.context;
        let { todayRange: todayRange } = this.props;
        let { framePositions: framePositions } = this.state;
        let nodes = [];
        if (framePositions) for (let seg of segs){
            let leftRightCss = isRtl ? {
                right: 0,
                left: framePositions.lefts[seg.lastCol] - framePositions.lefts[seg.firstCol]
            } : {
                left: 0,
                right: framePositions.rights[seg.firstCol] - framePositions.rights[seg.lastCol]
            };
            nodes.push((0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                key: (0, $200f5cce291452b2$export$1314441b8d04e1d5)(seg.eventRange),
                className: "fc-daygrid-bg-harness",
                style: leftRightCss
            }, fillType === "bg-event" ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$cd571ca6d1702b73), Object.assign({
                seg: seg
            }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, todayRange))) : (0, $200f5cce291452b2$export$87b6ab1c2cb8b955)(fillType)));
        }
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), {}, ...nodes);
    }
    updateSizing(isExternalSizingChange) {
        let { props: props, state: state, frameElRefs: frameElRefs } = this;
        if (!props.forPrint && props.clientWidth !== null // positioning ready?
        ) {
            if (isExternalSizingChange) {
                let frameEls = props.cells.map((cell)=>frameElRefs.currentMap[cell.key]);
                if (frameEls.length) {
                    let originEl = this.rootElRef.current;
                    let newPositionCache = new (0, $200f5cce291452b2$export$7060da4b5db56fb9)(originEl, frameEls, true, false);
                    if (!state.framePositions || !state.framePositions.similarTo(newPositionCache)) this.setState({
                        framePositions: new (0, $200f5cce291452b2$export$7060da4b5db56fb9)(originEl, frameEls, true, false)
                    });
                }
            }
            const oldInstanceHeights = this.state.eventInstanceHeights;
            const newInstanceHeights = this.queryEventInstanceHeights();
            const limitByContentHeight = props.dayMaxEvents === true || props.dayMaxEventRows === true;
            this.safeSetState({
                // HACK to prevent oscillations of events being shown/hidden from max-event-rows
                // Essentially, once you compute an element's height, never null-out.
                // TODO: always display all events, as visibility:hidden?
                eventInstanceHeights: Object.assign(Object.assign({}, oldInstanceHeights), newInstanceHeights),
                maxContentHeight: limitByContentHeight ? this.computeMaxContentHeight() : null
            });
        }
    }
    queryEventInstanceHeights() {
        let segElMap = this.segHarnessRefs.currentMap;
        let eventInstanceHeights = {};
        // get the max height amongst instance segs
        for(let key in segElMap){
            let height = Math.round(segElMap[key].getBoundingClientRect().height);
            let instanceId = key.split(":")[0]; // deconstruct how renderFgSegs makes the key
            eventInstanceHeights[instanceId] = Math.max(eventInstanceHeights[instanceId] || 0, height);
        }
        return eventInstanceHeights;
    }
    computeMaxContentHeight() {
        let firstKey = this.props.cells[0].key;
        let cellEl = this.cellElRefs.currentMap[firstKey];
        let fcContainerEl = this.fgElRefs.currentMap[firstKey];
        return cellEl.getBoundingClientRect().bottom - fcContainerEl.getBoundingClientRect().top;
    }
    getCellEls() {
        let elMap = this.cellElRefs.currentMap;
        return this.props.cells.map((cell)=>elMap[cell.key]);
    }
    constructor(){
        super(...arguments);
        this.cellElRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)(); // the <td>
        this.frameElRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)(); // the fc-daygrid-day-frame
        this.fgElRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)(); // the fc-daygrid-day-events
        this.segHarnessRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)(); // indexed by "instanceId:firstCol"
        this.rootElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.state = {
            framePositions: null,
            maxContentHeight: null,
            eventInstanceHeights: {}
        };
        this.handleResize = (isForced)=>{
            if (isForced) this.updateSizing(true); // isExternal=true
        };
    }
}
$cc06286d62b8a4b0$var$TableRow.addStateEquality({
    eventInstanceHeights: (0, $200f5cce291452b2$export$a9c23c6ac3fc3eca)
});
function $cc06286d62b8a4b0$var$buildMirrorPlacements(mirrorSegs, colPlacements) {
    if (!mirrorSegs.length) return [];
    let topsByInstanceId = $cc06286d62b8a4b0$var$buildAbsoluteTopHash(colPlacements); // TODO: cache this at first render?
    return mirrorSegs.map((seg)=>({
            seg: seg,
            isVisible: true,
            isAbsolute: true,
            absoluteTop: topsByInstanceId[seg.eventRange.instance.instanceId],
            marginTop: 0
        }));
}
function $cc06286d62b8a4b0$var$buildAbsoluteTopHash(colPlacements) {
    let topsByInstanceId = {};
    for (let placements of colPlacements)for (let placement of placements)topsByInstanceId[placement.seg.eventRange.instance.instanceId] = placement.absoluteTop;
    return topsByInstanceId;
}
class $cc06286d62b8a4b0$export$d955b1c53830e05a extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { props: props, context: context } = this;
        let rowCnt = props.cells.length;
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, rowCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, rowCnt);
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, rowCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, rowCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, rowCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, rowCnt);
        // for DayGrid view with many rows, force a min-height on cells so doesn't appear squished
        // choose 7 because a month view will have max 6 rows
        let cellMinHeight = rowCnt >= 7 && props.clientWidth ? props.clientWidth / context.options.aspectRatio / 6 : null;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$6e4b1d19c6e2e012), {
            unit: "day"
        }, (nowDate, todayRange)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, props.cells.map((cells, row)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$var$TableRow, {
                    ref: this.rowRefs.createRef(row),
                    key: cells.length ? cells[0].date.toISOString() : row // in case there are no cells (like when resource view is loading)
                    ,
                    showDayNumbers: rowCnt > 1,
                    showWeekNumbers: props.showWeekNumbers,
                    todayRange: todayRange,
                    dateProfile: props.dateProfile,
                    cells: cells,
                    renderIntro: props.renderRowIntro,
                    businessHourSegs: businessHourSegsByRow[row],
                    eventSelection: props.eventSelection,
                    bgEventSegs: bgEventSegsByRow[row].filter($cc06286d62b8a4b0$var$isSegAllDay),
                    fgEventSegs: fgEventSegsByRow[row],
                    dateSelectionSegs: dateSelectionSegsByRow[row],
                    eventDrag: eventDragByRow[row],
                    eventResize: eventResizeByRow[row],
                    dayMaxEvents: props.dayMaxEvents,
                    dayMaxEventRows: props.dayMaxEventRows,
                    clientWidth: props.clientWidth,
                    clientHeight: props.clientHeight,
                    cellMinHeight: cellMinHeight,
                    forPrint: props.forPrint
                }))));
    }
    componentDidMount() {
        // HACK: need a daygrid wrapper parent to do positioning
        // NOTE: a daygrid resource view w/o resources can have zero cells
        const firstCellEl = this.rowRefs.currentMap[0].getCellEls()[0];
        this.rootEl = firstCellEl ? firstCellEl.closest(".fc-daygrid-body") : null;
        if (this.rootEl) this.context.registerInteractiveComponent(this, {
            el: this.rootEl,
            isHitComboAllowed: this.props.isHitComboAllowed
        });
    }
    componentWillUnmount() {
        if (this.rootEl) {
            this.context.unregisterInteractiveComponent(this);
            this.rootEl = null;
        }
    }
    // Hit System
    // ----------------------------------------------------------------------------------------------------
    prepareHits() {
        this.rowPositions = new (0, $200f5cce291452b2$export$7060da4b5db56fb9)(this.rootEl, this.rowRefs.collect().map((rowObj)=>rowObj.getCellEls()[0]), false, true);
        this.colPositions = new (0, $200f5cce291452b2$export$7060da4b5db56fb9)(this.rootEl, this.rowRefs.currentMap[0].getCellEls(), true, false);
    }
    queryHit(positionLeft, positionTop) {
        let { colPositions: colPositions, rowPositions: rowPositions } = this;
        let col = colPositions.leftToIndex(positionLeft);
        let row = rowPositions.topToIndex(positionTop);
        if (row != null && col != null) {
            let cell = this.props.cells[row][col];
            return {
                dateProfile: this.props.dateProfile,
                dateSpan: Object.assign({
                    range: this.getCellRange(row, col),
                    allDay: true
                }, cell.extraDateSpan),
                dayEl: this.getCellEl(row, col),
                rect: {
                    left: colPositions.lefts[col],
                    right: colPositions.rights[col],
                    top: rowPositions.tops[row],
                    bottom: rowPositions.bottoms[row]
                },
                layer: 0
            };
        }
        return null;
    }
    getCellEl(row, col) {
        return this.rowRefs.currentMap[row].getCellEls()[col]; // TODO: not optimal
    }
    getCellRange(row, col) {
        let start = this.props.cells[row][col].date;
        let end = (0, $200f5cce291452b2$export$625550452a3fa3ec)(start, 1);
        return {
            start: start,
            end: end
        };
    }
    constructor(){
        super(...arguments);
        this.splitBusinessHourSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$splitSegsByRow);
        this.splitBgEventSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$splitSegsByRow);
        this.splitFgEventSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$splitSegsByRow);
        this.splitDateSelectionSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$splitSegsByRow);
        this.splitEventDrag = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$splitInteractionByRow);
        this.splitEventResize = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$var$splitInteractionByRow);
        this.rowRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)();
    }
}
function $cc06286d62b8a4b0$var$isSegAllDay(seg) {
    return seg.eventRange.def.allDay;
}
class $cc06286d62b8a4b0$export$54ec01a60f47d33d extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { props: props } = this;
        let { dayMaxEventRows: dayMaxEventRows, dayMaxEvents: dayMaxEvents, expandRows: expandRows } = props;
        let limitViaBalanced = dayMaxEvents === true || dayMaxEventRows === true;
        // if rows can't expand to fill fixed height, can't do balanced-height event limit
        // TODO: best place to normalize these options?
        if (limitViaBalanced && !expandRows) {
            limitViaBalanced = false;
            dayMaxEventRows = null;
            dayMaxEvents = null;
        }
        let classNames = [
            "fc-daygrid-body",
            limitViaBalanced ? "fc-daygrid-body-balanced" : "fc-daygrid-body-unbalanced",
            expandRows ? "" : "fc-daygrid-body-natural"
        ];
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            ref: this.elRef,
            className: classNames.join(" "),
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("table", {
            role: "presentation",
            className: "fc-scrollgrid-sync-table",
            style: {
                width: props.clientWidth,
                minWidth: props.tableMinWidth,
                height: expandRows ? props.clientHeight : ""
            }
        }, props.colGroupNode, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tbody", {
            role: "presentation"
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$export$d955b1c53830e05a, {
            dateProfile: props.dateProfile,
            cells: props.cells,
            renderRowIntro: props.renderRowIntro,
            showWeekNumbers: props.showWeekNumbers,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows,
            forPrint: props.forPrint,
            isHitComboAllowed: props.isHitComboAllowed
        }))));
    }
    componentDidMount() {
        this.requestScrollReset();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dateProfile !== this.props.dateProfile) this.requestScrollReset();
        else this.flushScrollReset();
    }
    requestScrollReset() {
        this.needsScrollReset = true;
        this.flushScrollReset();
    }
    flushScrollReset() {
        if (this.needsScrollReset && this.props.clientWidth // sizes computed?
        ) {
            const subjectEl = $cc06286d62b8a4b0$var$getScrollSubjectEl(this.elRef.current, this.props.dateProfile);
            if (subjectEl) {
                const originEl = subjectEl.closest(".fc-daygrid-body");
                const scrollEl = originEl.closest(".fc-scroller");
                const scrollTop = subjectEl.getBoundingClientRect().top - originEl.getBoundingClientRect().top;
                scrollEl.scrollTop = scrollTop ? scrollTop + 1 : 0; // overcome border
            }
            this.needsScrollReset = false;
        }
    }
    constructor(){
        super(...arguments);
        this.elRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.needsScrollReset = false;
    }
}
function $cc06286d62b8a4b0$var$getScrollSubjectEl(containerEl, dateProfile) {
    let el;
    if (dateProfile.currentRangeUnit.match(/year|month/)) el = containerEl.querySelector(`[data-date="${(0, $200f5cce291452b2$export$26a0a7676ca7aa04)(dateProfile.currentDate)}-01"]`);
    if (!el) el = containerEl.querySelector(`[data-date="${(0, $200f5cce291452b2$export$5dbe06c6d8c68cfb)(dateProfile.currentDate)}"]`);
    return el;
}
class $cc06286d62b8a4b0$export$eb38be9553e58392 extends (0, $200f5cce291452b2$export$6b179bb11f7fd3a0) {
    sliceRange(dateRange, dayTableModel) {
        return dayTableModel.sliceRange(dateRange);
    }
    constructor(){
        super(...arguments);
        this.forceDayIfListItem = true;
    }
}
class $cc06286d62b8a4b0$export$cd402b7558adf371 extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { props: props, context: context } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$export$54ec01a60f47d33d, Object.assign({
            ref: this.tableRef
        }, this.slicer.sliceProps(props, props.dateProfile, props.nextDayThreshold, context, props.dayTableModel), {
            dateProfile: props.dateProfile,
            cells: props.dayTableModel.cells,
            colGroupNode: props.colGroupNode,
            tableMinWidth: props.tableMinWidth,
            renderRowIntro: props.renderRowIntro,
            dayMaxEvents: props.dayMaxEvents,
            dayMaxEventRows: props.dayMaxEventRows,
            showWeekNumbers: props.showWeekNumbers,
            expandRows: props.expandRows,
            headerAlignElRef: props.headerAlignElRef,
            clientWidth: props.clientWidth,
            clientHeight: props.clientHeight,
            forPrint: props.forPrint
        }));
    }
    constructor(){
        super(...arguments);
        this.slicer = new $cc06286d62b8a4b0$export$eb38be9553e58392();
        this.tableRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
    }
}
class $cc06286d62b8a4b0$export$9fcce6e2d16ec31d extends (0, $200f5cce291452b2$export$3a6d5c9ae78a2c08) {
    // Computes the date range that will be rendered
    buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay) {
        let renderRange = super.buildRenderRange(currentRange, currentRangeUnit, isRangeAllDay);
        let { props: props } = this;
        return $cc06286d62b8a4b0$export$a2ad67969be9f247({
            currentRange: renderRange,
            snapToWeek: /^(year|month)$/.test(currentRangeUnit),
            fixedWeekCount: props.fixedWeekCount,
            dateEnv: props.dateEnv
        });
    }
}
function $cc06286d62b8a4b0$export$a2ad67969be9f247(props) {
    let { dateEnv: dateEnv, currentRange: currentRange } = props;
    let { start: start, end: end } = currentRange;
    let endOfWeek;
    // year and month views should be aligned with weeks. this is already done for week
    if (props.snapToWeek) {
        start = dateEnv.startOfWeek(start);
        // make end-of-week if not already
        endOfWeek = dateEnv.startOfWeek(end);
        if (endOfWeek.valueOf() !== end.valueOf()) end = (0, $200f5cce291452b2$export$31e67cf12fc9668)(endOfWeek, 1);
    }
    // ensure 6 weeks
    if (props.fixedWeekCount) {
        // TODO: instead of these date-math gymnastics (for multimonth view),
        // compute dateprofiles of all months, then use start of first and end of last.
        let lastMonthRenderStart = dateEnv.startOfWeek(dateEnv.startOfMonth((0, $200f5cce291452b2$export$625550452a3fa3ec)(currentRange.end, -1)));
        let rowCnt = Math.ceil((0, $200f5cce291452b2$export$62d08d6fa708df47)(lastMonthRenderStart, end));
        end = (0, $200f5cce291452b2$export$31e67cf12fc9668)(end, 6 - rowCnt);
    }
    return {
        start: start,
        end: end
    };
}
/* An abstract class for the daygrid views, as well as month view. Renders one or more rows of day cells.
----------------------------------------------------------------------------------------------------------------------*/ // It is a manager for a Table subcomponent, which does most of the heavy lifting.
// It is responsible for managing width/height.
class $cc06286d62b8a4b0$export$b3c27e869d856b7 extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    renderSimpleLayout(headerRowContent, bodyContent) {
        let { props: props, context: context } = this;
        let sections = [];
        let stickyHeaderDates = (0, $200f5cce291452b2$export$a1edd97dd51cd48d)(context.options);
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: "fc-col-header",
                rowContent: headerRowContent
            }
        });
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            chunk: {
                content: bodyContent
            }
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e9316ff9106cdb75), {
            elClasses: [
                "fc-daygrid"
            ],
            viewSpec: context.viewSpec
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$add49c223b9ce4ea), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, bodyContent, colCnt, dayMinWidth) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
        let { props: props, context: context } = this;
        let stickyHeaderDates = !props.forPrint && (0, $200f5cce291452b2$export$a1edd97dd51cd48d)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $200f5cce291452b2$export$54c4fabc2291e9c0)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunks: [
                {
                    key: "main",
                    elRef: this.headerElRef,
                    tableClassName: "fc-col-header",
                    rowContent: headerRowContent
                }
            ]
        });
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            chunks: [
                {
                    key: "main",
                    content: bodyContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            type: "footer",
            key: "footer",
            isSticky: true,
            chunks: [
                {
                    key: "main",
                    content: (0, $200f5cce291452b2$export$89e9012e902952b6)
                }
            ]
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e9316ff9106cdb75), {
            elClasses: [
                "fc-daygrid"
            ],
            viewSpec: context.viewSpec
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: props.forPrint,
            colGroups: [
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
    constructor(){
        super(...arguments);
        this.headerElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
    }
}
class $cc06286d62b8a4b0$export$39eed66de95896e5 extends $cc06286d62b8a4b0$export$b3c27e869d856b7 {
    render() {
        let { options: options, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let dayTableModel = this.buildDayTableModel(props.dateProfile, dateProfileGenerator);
        let headerContent = options.dayHeaders && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$ebc5e65867841cbe), {
            ref: this.headerRef,
            dateProfile: props.dateProfile,
            dates: dayTableModel.headerDates,
            datesRepDistinctDays: dayTableModel.rowCnt === 1
        });
        let bodyContent = (contentArg)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($cc06286d62b8a4b0$export$cd402b7558adf371, {
                ref: this.tableRef,
                dateProfile: props.dateProfile,
                dayTableModel: dayTableModel,
                businessHours: props.businessHours,
                dateSelection: props.dateSelection,
                eventStore: props.eventStore,
                eventUiBases: props.eventUiBases,
                eventSelection: props.eventSelection,
                eventDrag: props.eventDrag,
                eventResize: props.eventResize,
                nextDayThreshold: options.nextDayThreshold,
                colGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                dayMaxEvents: options.dayMaxEvents,
                dayMaxEventRows: options.dayMaxEventRows,
                showWeekNumbers: options.weekNumbers,
                expandRows: !props.isHeightAuto,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            });
        return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, dayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
    constructor(){
        super(...arguments);
        this.buildDayTableModel = (0, $200f5cce291452b2$export$df995fae86a55f06)($cc06286d62b8a4b0$export$61e79f95d746b006);
        this.headerRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.tableRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
    // can't override any lifecycle methods from parent
    }
}
function $cc06286d62b8a4b0$export$61e79f95d746b006(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $200f5cce291452b2$export$2538633961795d6b)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $200f5cce291452b2$export$dabba94403d45c8e)(daySeries, /year|month|week/.test(dateProfile.currentRangeUnit));
}




var $a4a6497eb8588cfa$export$2e2bcd8739ae039 = (0, $76a516e930faac74$export$ae829ec7b2625219)({
    name: "@fullcalendar/daygrid",
    initialView: "dayGridMonth",
    views: {
        dayGrid: {
            component: (0, $cc06286d62b8a4b0$export$39eed66de95896e5),
            dateProfileGeneratorClass: (0, $cc06286d62b8a4b0$export$9fcce6e2d16ec31d)
        },
        dayGridDay: {
            type: "dayGrid",
            duration: {
                days: 1
            }
        },
        dayGridWeek: {
            type: "dayGrid",
            duration: {
                weeks: 1
            }
        },
        dayGridMonth: {
            type: "dayGrid",
            duration: {
                months: 1
            },
            fixedWeekCount: true
        },
        dayGridYear: {
            type: "dayGrid",
            duration: {
                years: 1
            }
        }
    }
});






var $705208976f9ef87b$var$css_248z = '.fc-v-event{background-color:var(--fc-event-bg-color);border:1px solid var(--fc-event-border-color);display:block}.fc-v-event .fc-event-main{color:var(--fc-event-text-color);height:100%}.fc-v-event .fc-event-main-frame{display:flex;flex-direction:column;height:100%}.fc-v-event .fc-event-time{flex-grow:0;flex-shrink:0;max-height:100%;overflow:hidden}.fc-v-event .fc-event-title-container{flex-grow:1;flex-shrink:1;min-height:0}.fc-v-event .fc-event-title{bottom:0;max-height:100%;overflow:hidden;top:0}.fc-v-event:not(.fc-event-start){border-top-left-radius:0;border-top-right-radius:0;border-top-width:0}.fc-v-event:not(.fc-event-end){border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-width:0}.fc-v-event.fc-event-selected:before{left:-10px;right:-10px}.fc-v-event .fc-event-resizer-start{cursor:n-resize}.fc-v-event .fc-event-resizer-end{cursor:s-resize}.fc-v-event:not(.fc-event-selected) .fc-event-resizer{height:var(--fc-event-resizer-thickness);left:0;right:0}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start{top:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-thickness)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer{left:50%;margin-left:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-start{top:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc-v-event.fc-event-selected .fc-event-resizer-end{bottom:calc(var(--fc-event-resizer-dot-total-width)/-2)}.fc .fc-timegrid .fc-daygrid-body{z-index:2}.fc .fc-timegrid-divider{padding:0 0 2px}.fc .fc-timegrid-body{min-height:100%;position:relative;z-index:1}.fc .fc-timegrid-axis-chunk{position:relative}.fc .fc-timegrid-axis-chunk>table,.fc .fc-timegrid-slots{position:relative;z-index:1}.fc .fc-timegrid-slot{border-bottom:0;height:1.5em}.fc .fc-timegrid-slot:empty:before{content:"\\00a0"}.fc .fc-timegrid-slot-minor{border-top-style:dotted}.fc .fc-timegrid-slot-label-cushion{display:inline-block;white-space:nowrap}.fc .fc-timegrid-slot-label{vertical-align:middle}.fc .fc-timegrid-axis-cushion,.fc .fc-timegrid-slot-label-cushion{padding:0 4px}.fc .fc-timegrid-axis-frame-liquid{height:100%}.fc .fc-timegrid-axis-frame{align-items:center;display:flex;justify-content:flex-end;overflow:hidden}.fc .fc-timegrid-axis-cushion{flex-shrink:0;max-width:60px}.fc-direction-ltr .fc-timegrid-slot-label-frame{text-align:right}.fc-direction-rtl .fc-timegrid-slot-label-frame{text-align:left}.fc-liquid-hack .fc-timegrid-axis-frame-liquid{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col.fc-day-today{background-color:var(--fc-today-bg-color)}.fc .fc-timegrid-col-frame{min-height:100%;position:relative}.fc-media-screen.fc-liquid-hack .fc-timegrid-col-frame{bottom:0;height:auto;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols{bottom:0;left:0;position:absolute;right:0;top:0}.fc-media-screen .fc-timegrid-cols>table{height:100%}.fc-media-screen .fc-timegrid-col-bg,.fc-media-screen .fc-timegrid-col-events,.fc-media-screen .fc-timegrid-now-indicator-container{left:0;position:absolute;right:0;top:0}.fc .fc-timegrid-col-bg{z-index:2}.fc .fc-timegrid-col-bg .fc-non-business{z-index:1}.fc .fc-timegrid-col-bg .fc-bg-event{z-index:2}.fc .fc-timegrid-col-bg .fc-highlight{z-index:3}.fc .fc-timegrid-bg-harness{left:0;position:absolute;right:0}.fc .fc-timegrid-col-events{z-index:3}.fc .fc-timegrid-now-indicator-container{bottom:0;overflow:hidden}.fc-direction-ltr .fc-timegrid-col-events{margin:0 2.5% 0 2px}.fc-direction-rtl .fc-timegrid-col-events{margin:0 2px 0 2.5%}.fc-timegrid-event-harness{position:absolute}.fc-timegrid-event-harness>.fc-timegrid-event{bottom:0;left:0;position:absolute;right:0;top:0}.fc-timegrid-event-harness-inset .fc-timegrid-event,.fc-timegrid-event.fc-event-mirror,.fc-timegrid-more-link{box-shadow:0 0 0 1px var(--fc-page-bg-color)}.fc-timegrid-event,.fc-timegrid-more-link{border-radius:3px;font-size:var(--fc-small-font-size)}.fc-timegrid-event{margin-bottom:1px}.fc-timegrid-event .fc-event-main{padding:1px 1px 0}.fc-timegrid-event .fc-event-time{font-size:var(--fc-small-font-size);margin-bottom:1px;white-space:nowrap}.fc-timegrid-event-short .fc-event-main-frame{flex-direction:row;overflow:hidden}.fc-timegrid-event-short .fc-event-time:after{content:"\\00a0-\\00a0"}.fc-timegrid-event-short .fc-event-title{font-size:var(--fc-small-font-size)}.fc-timegrid-more-link{background:var(--fc-more-link-bg-color);color:var(--fc-more-link-text-color);cursor:pointer;margin-bottom:1px;position:absolute;z-index:9999}.fc-timegrid-more-link-inner{padding:3px 2px;top:0}.fc-direction-ltr .fc-timegrid-more-link{right:0}.fc-direction-rtl .fc-timegrid-more-link{left:0}.fc .fc-timegrid-now-indicator-line{border-color:var(--fc-now-indicator-color);border-style:solid;border-width:1px 0 0;left:0;position:absolute;right:0;z-index:4}.fc .fc-timegrid-now-indicator-arrow{border-color:var(--fc-now-indicator-color);border-style:solid;margin-top:-5px;position:absolute;z-index:4}.fc-direction-ltr .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 0 5px 6px;left:0}.fc-direction-rtl .fc-timegrid-now-indicator-arrow{border-bottom-color:transparent;border-top-color:transparent;border-width:5px 6px 5px 0;right:0}';
(0, $200f5cce291452b2$export$c373adc892eb6355)($705208976f9ef87b$var$css_248z);
class $705208976f9ef87b$var$AllDaySplitter extends (0, $200f5cce291452b2$export$e171bab687b50e0) {
    getKeyInfo() {
        return {
            allDay: {},
            timed: {}
        };
    }
    getKeysForDateSpan(dateSpan) {
        if (dateSpan.allDay) return [
            "allDay"
        ];
        return [
            "timed"
        ];
    }
    getKeysForEventDef(eventDef) {
        if (!eventDef.allDay) return [
            "timed"
        ];
        if ((0, $200f5cce291452b2$export$a91cd623adc48128)(eventDef)) return [
            "timed",
            "allDay"
        ];
        return [
            "allDay"
        ];
    }
}
const $705208976f9ef87b$var$DEFAULT_SLAT_LABEL_FORMAT = (0, $200f5cce291452b2$export$d141bba7fdc215a3)({
    hour: "numeric",
    minute: "2-digit",
    omitZeroMinute: true,
    meridiem: "short"
});
function $705208976f9ef87b$var$TimeColsAxisCell(props) {
    let classNames = [
        "fc-timegrid-slot",
        "fc-timegrid-slot-label",
        props.isLabeled ? "fc-scrollgrid-shrink" : "fc-timegrid-slot-minor"
    ];
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7c866399fa523f5).Consumer, null, (context)=>{
        if (!props.isLabeled) return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("td", {
            className: classNames.join(" "),
            "data-time": props.isoTimeStr
        });
        let { dateEnv: dateEnv, options: options, viewApi: viewApi } = context;
        let labelFormat = options.slotLabelFormat == null ? $705208976f9ef87b$var$DEFAULT_SLAT_LABEL_FORMAT : Array.isArray(options.slotLabelFormat) ? (0, $200f5cce291452b2$export$d141bba7fdc215a3)(options.slotLabelFormat[0]) : (0, $200f5cce291452b2$export$d141bba7fdc215a3)(options.slotLabelFormat);
        let renderProps = {
            level: 0,
            time: props.time,
            date: dateEnv.toDate(props.date),
            view: viewApi,
            text: dateEnv.format(props.date, labelFormat)
        };
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7094788287c5e9b), {
            elTag: "td",
            elClasses: classNames,
            elAttrs: {
                "data-time": props.isoTimeStr
            },
            renderProps: renderProps,
            generatorName: "slotLabelContent",
            customGenerator: options.slotLabelContent,
            defaultGenerator: $705208976f9ef87b$var$renderInnerContent,
            classNameGenerator: options.slotLabelClassNames,
            didMount: options.slotLabelDidMount,
            willUnmount: options.slotLabelWillUnmount
        }, (InnerContent)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-slot-label-frame fc-scrollgrid-shrink-frame"
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-timegrid-slot-label-cushion",
                    "fc-scrollgrid-shrink-cushion"
                ]
            })));
    });
}
function $705208976f9ef87b$var$renderInnerContent(props) {
    return props.text;
}
class $705208976f9ef87b$var$TimeBodyAxis extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        return this.props.slatMetas.map((slatMeta)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                key: slatMeta.key
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColsAxisCell, Object.assign({}, slatMeta))));
    }
}
const $705208976f9ef87b$var$DEFAULT_WEEK_NUM_FORMAT = (0, $200f5cce291452b2$export$d141bba7fdc215a3)({
    week: "short"
});
const $705208976f9ef87b$var$AUTO_ALL_DAY_MAX_EVENT_ROWS = 5;
class $705208976f9ef87b$export$667ac525945c6ff8 extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    // rendering
    // ----------------------------------------------------------------------------------------------------
    renderSimpleLayout(headerRowContent, allDayContent, timeContent) {
        let { context: context, props: props } = this;
        let sections = [];
        let stickyHeaderDates = (0, $200f5cce291452b2$export$a1edd97dd51cd48d)(context.options);
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            chunk: {
                elRef: this.headerElRef,
                tableClassName: "fc-col-header",
                rowContent: headerRowContent
            }
        });
        if (allDayContent) {
            sections.push({
                type: "body",
                key: "all-day",
                chunk: {
                    content: allDayContent
                }
            });
            sections.push({
                type: "body",
                key: "all-day-divider",
                outerContent: (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("td", {
                    className: "fc-timegrid-divider " + context.theme.getClass("tableCellShaded")
                }))
            });
        }
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunk: {
                scrollerElRef: this.scrollerElRef,
                content: timeContent
            }
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e9316ff9106cdb75), {
            elRef: this.rootElRef,
            elClasses: [
                "fc-timegrid"
            ],
            viewSpec: context.viewSpec
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$add49c223b9ce4ea), {
            liquid: !props.isHeightAuto && !props.forPrint,
            collapsibleWidth: props.forPrint,
            cols: [
                {
                    width: "shrink"
                }
            ],
            sections: sections
        }));
    }
    renderHScrollLayout(headerRowContent, allDayContent, timeContent, colCnt, dayMinWidth, slatMetas, slatCoords) {
        let ScrollGrid = this.context.pluginHooks.scrollGridImpl;
        if (!ScrollGrid) throw new Error("No ScrollGrid implementation");
        let { context: context, props: props } = this;
        let stickyHeaderDates = !props.forPrint && (0, $200f5cce291452b2$export$a1edd97dd51cd48d)(context.options);
        let stickyFooterScrollbar = !props.forPrint && (0, $200f5cce291452b2$export$54c4fabc2291e9c0)(context.options);
        let sections = [];
        if (headerRowContent) sections.push({
            type: "header",
            key: "header",
            isSticky: stickyHeaderDates,
            syncRowHeights: true,
            chunks: [
                {
                    key: "axis",
                    rowContent: (arg)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                            role: "presentation"
                        }, this.renderHeadAxis("day", arg.rowSyncHeights[0]))
                },
                {
                    key: "cols",
                    elRef: this.headerElRef,
                    tableClassName: "fc-col-header",
                    rowContent: headerRowContent
                }
            ]
        });
        if (allDayContent) {
            sections.push({
                type: "body",
                key: "all-day",
                syncRowHeights: true,
                chunks: [
                    {
                        key: "axis",
                        rowContent: (contentArg)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                                role: "presentation"
                            }, this.renderTableRowAxis(contentArg.rowSyncHeights[0]))
                    },
                    {
                        key: "cols",
                        content: allDayContent
                    }
                ]
            });
            sections.push({
                key: "all-day-divider",
                type: "body",
                outerContent: (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                    role: "presentation",
                    className: "fc-scrollgrid-section"
                }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("td", {
                    colSpan: 2,
                    className: "fc-timegrid-divider " + context.theme.getClass("tableCellShaded")
                }))
            });
        }
        let isNowIndicator = context.options.nowIndicator;
        sections.push({
            type: "body",
            key: "body",
            liquid: true,
            expandRows: Boolean(context.options.expandRows),
            chunks: [
                {
                    key: "axis",
                    content: (arg)=>// TODO: make this now-indicator arrow more DRY with TimeColsContent
                        (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                            className: "fc-timegrid-axis-chunk"
                        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("table", {
                            "aria-hidden": true,
                            style: {
                                height: arg.expandRows ? arg.clientHeight : ""
                            }
                        }, arg.tableColGroupNode, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tbody", null, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeBodyAxis, {
                            slatMetas: slatMetas
                        }))), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                            className: "fc-timegrid-now-indicator-container"
                        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$6e4b1d19c6e2e012), {
                            unit: isNowIndicator ? "minute" : "day" /* hacky */ 
                        }, (nowDate)=>{
                            let nowIndicatorTop = isNowIndicator && slatCoords && slatCoords.safeComputeTop(nowDate); // might return void
                            if (typeof nowIndicatorTop === "number") return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$c1df809846363ebe), {
                                elClasses: [
                                    "fc-timegrid-now-indicator-arrow"
                                ],
                                elStyle: {
                                    top: nowIndicatorTop
                                },
                                isAxis: true,
                                date: nowDate
                            });
                            return null;
                        })))
                },
                {
                    key: "cols",
                    scrollerElRef: this.scrollerElRef,
                    content: timeContent
                }
            ]
        });
        if (stickyFooterScrollbar) sections.push({
            key: "footer",
            type: "footer",
            isSticky: true,
            chunks: [
                {
                    key: "axis",
                    content: (0, $200f5cce291452b2$export$89e9012e902952b6)
                },
                {
                    key: "cols",
                    content: (0, $200f5cce291452b2$export$89e9012e902952b6)
                }
            ]
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e9316ff9106cdb75), {
            elRef: this.rootElRef,
            elClasses: [
                "fc-timegrid"
            ],
            viewSpec: context.viewSpec
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(ScrollGrid, {
            liquid: !props.isHeightAuto && !props.forPrint,
            forPrint: props.forPrint,
            collapsibleWidth: false,
            colGroups: [
                {
                    width: "shrink",
                    cols: [
                        {
                            width: "shrink"
                        }
                    ]
                },
                {
                    cols: [
                        {
                            span: colCnt,
                            minWidth: dayMinWidth
                        }
                    ]
                }
            ],
            sections: sections
        }));
    }
    /* Dimensions
    ------------------------------------------------------------------------------------------------------------------*/ getAllDayMaxEventProps() {
        let { dayMaxEvents: dayMaxEvents, dayMaxEventRows: dayMaxEventRows } = this.context.options;
        if (dayMaxEvents === true || dayMaxEventRows === true) {
            dayMaxEvents = undefined;
            dayMaxEventRows = $705208976f9ef87b$var$AUTO_ALL_DAY_MAX_EVENT_ROWS; // make sure "auto" goes to a real number
        }
        return {
            dayMaxEvents: dayMaxEvents,
            dayMaxEventRows: dayMaxEventRows
        };
    }
    constructor(){
        super(...arguments);
        this.allDaySplitter = new $705208976f9ef87b$var$AllDaySplitter(); // for use by subclasses
        this.headerElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.rootElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.scrollerElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.state = {
            slatCoords: null
        };
        this.handleScrollTopRequest = (scrollTop)=>{
            let scrollerEl = this.scrollerElRef.current;
            if (scrollerEl) scrollerEl.scrollTop = scrollTop;
        };
        /* Header Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ this.renderHeadAxis = (rowKey, frameHeight = "")=>{
            let { options: options } = this.context;
            let { dateProfile: dateProfile } = this.props;
            let range = dateProfile.renderRange;
            let dayCnt = (0, $200f5cce291452b2$export$a36fb7d24305ed9d)(range.start, range.end);
            // only do in day views (to avoid doing in week views that dont need it)
            let navLinkAttrs = dayCnt === 1 ? (0, $200f5cce291452b2$export$8c78c7c36408ea29)(this.context, range.start, "week") : {};
            if (options.weekNumbers && rowKey === "day") return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$a3c9165b94390bcd), {
                elTag: "th",
                elClasses: [
                    "fc-timegrid-axis",
                    "fc-scrollgrid-shrink"
                ],
                elAttrs: {
                    "aria-hidden": true
                },
                date: range.start,
                defaultFormat: $705208976f9ef87b$var$DEFAULT_WEEK_NUM_FORMAT
            }, (InnerContent)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                    className: [
                        "fc-timegrid-axis-frame",
                        "fc-scrollgrid-shrink-frame",
                        "fc-timegrid-axis-frame-liquid"
                    ].join(" "),
                    style: {
                        height: frameHeight
                    }
                }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                    elTag: "a",
                    elClasses: [
                        "fc-timegrid-axis-cushion",
                        "fc-scrollgrid-shrink-cushion",
                        "fc-scrollgrid-sync-inner"
                    ],
                    elAttrs: navLinkAttrs
                })));
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("th", {
                "aria-hidden": true,
                className: "fc-timegrid-axis"
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-axis-frame",
                style: {
                    height: frameHeight
                }
            }));
        };
        /* Table Component Render Methods
        ------------------------------------------------------------------------------------------------------------------*/ // only a one-way height sync. we don't send the axis inner-content height to the DayGrid,
        // but DayGrid still needs to have classNames on inner elements in order to measure.
        this.renderTableRowAxis = (rowHeight)=>{
            let { options: options, viewApi: viewApi } = this.context;
            let renderProps = {
                text: options.allDayText,
                view: viewApi
            };
            return(// TODO: make reusable hook. used in list view too
            (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7094788287c5e9b), {
                elTag: "td",
                elClasses: [
                    "fc-timegrid-axis",
                    "fc-scrollgrid-shrink"
                ],
                elAttrs: {
                    "aria-hidden": true
                },
                renderProps: renderProps,
                generatorName: "allDayContent",
                customGenerator: options.allDayContent,
                defaultGenerator: $705208976f9ef87b$var$renderAllDayInner,
                classNameGenerator: options.allDayClassNames,
                didMount: options.allDayDidMount,
                willUnmount: options.allDayWillUnmount
            }, (InnerContent)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                    className: [
                        "fc-timegrid-axis-frame",
                        "fc-scrollgrid-shrink-frame",
                        rowHeight == null ? " fc-timegrid-axis-frame-liquid" : ""
                    ].join(" "),
                    style: {
                        height: rowHeight
                    }
                }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                    elTag: "span",
                    elClasses: [
                        "fc-timegrid-axis-cushion",
                        "fc-scrollgrid-shrink-cushion",
                        "fc-scrollgrid-sync-inner"
                    ]
                }))));
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
        };
    }
}
function $705208976f9ef87b$var$renderAllDayInner(renderProps) {
    return renderProps.text;
}
class $705208976f9ef87b$export$bbb5c25f46ae511d {
    safeComputeTop(date) {
        let { dateProfile: dateProfile } = this;
        if ((0, $200f5cce291452b2$export$7f8ddf7c7c20b3cd)(dateProfile.currentRange, date)) {
            let startOfDayDate = (0, $200f5cce291452b2$export$9e5f44173e64f162)(date);
            let timeMs = date.valueOf() - startOfDayDate.valueOf();
            if (timeMs >= (0, $200f5cce291452b2$export$4e222d082f82ee97)(dateProfile.slotMinTime) && timeMs < (0, $200f5cce291452b2$export$4e222d082f82ee97)(dateProfile.slotMaxTime)) return this.computeTimeTop((0, $200f5cce291452b2$export$4368d992c4eafac0)(timeMs));
        }
        return null;
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given date.
    // A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
    computeDateTop(when, startOfDayDate) {
        if (!startOfDayDate) startOfDayDate = (0, $200f5cce291452b2$export$9e5f44173e64f162)(when);
        return this.computeTimeTop((0, $200f5cce291452b2$export$4368d992c4eafac0)(when.valueOf() - startOfDayDate.valueOf()));
    }
    // Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
    // This is a makeshify way to compute the time-top. Assumes all slatMetas dates are uniform.
    // Eventually allow computation with arbirary slat dates.
    computeTimeTop(duration) {
        let { positions: positions, dateProfile: dateProfile } = this;
        let len = positions.els.length;
        // floating-point value of # of slots covered
        let slatCoverage = (duration.milliseconds - (0, $200f5cce291452b2$export$4e222d082f82ee97)(dateProfile.slotMinTime)) / (0, $200f5cce291452b2$export$4e222d082f82ee97)(this.slotDuration);
        let slatIndex;
        let slatRemainder;
        // compute a floating-point number for how many slats should be progressed through.
        // from 0 to number of slats (inclusive)
        // constrained because slotMinTime/slotMaxTime might be customized.
        slatCoverage = Math.max(0, slatCoverage);
        slatCoverage = Math.min(len, slatCoverage);
        // an integer index of the furthest whole slat
        // from 0 to number slats (*exclusive*, so len-1)
        slatIndex = Math.floor(slatCoverage);
        slatIndex = Math.min(slatIndex, len - 1);
        // how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
        // could be 1.0 if slatCoverage is covering *all* the slots
        slatRemainder = slatCoverage - slatIndex;
        return positions.tops[slatIndex] + positions.getHeight(slatIndex) * slatRemainder;
    }
    constructor(positions, dateProfile, slotDuration){
        this.positions = positions;
        this.dateProfile = dateProfile;
        this.slotDuration = slotDuration;
    }
}
class $705208976f9ef87b$var$TimeColsSlatsBody extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let { slatElRefs: slatElRefs } = props;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tbody", null, props.slatMetas.map((slatMeta, i)=>{
            let renderProps = {
                time: slatMeta.time,
                date: context.dateEnv.toDate(slatMeta.date),
                view: context.viewApi
            };
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
                key: slatMeta.key,
                ref: slatElRefs.createRef(slatMeta.key)
            }, props.axis && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColsAxisCell, Object.assign({}, slatMeta)), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$e7094788287c5e9b), {
                elTag: "td",
                elClasses: [
                    "fc-timegrid-slot",
                    "fc-timegrid-slot-lane",
                    !slatMeta.isLabeled && "fc-timegrid-slot-minor"
                ],
                elAttrs: {
                    "data-time": slatMeta.isoTimeStr
                },
                renderProps: renderProps,
                generatorName: "slotLaneContent",
                customGenerator: options.slotLaneContent,
                classNameGenerator: options.slotLaneClassNames,
                didMount: options.slotLaneDidMount,
                willUnmount: options.slotLaneWillUnmount
            }));
        }));
    }
}
/*
for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
*/ class $705208976f9ef87b$var$TimeColsSlats extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            ref: this.rootElRef,
            className: "fc-timegrid-slots"
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("table", {
            "aria-hidden": true,
            className: context.theme.getClass("table"),
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth,
                height: props.minHeight
            }
        }, props.tableColGroupNode /* relies on there only being a single <col> for the axis */ , (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColsSlatsBody, {
            slatElRefs: this.slatElRefs,
            axis: props.axis,
            slatMetas: props.slatMetas
        })));
    }
    componentDidMount() {
        this.updateSizing();
    }
    componentDidUpdate() {
        this.updateSizing();
    }
    componentWillUnmount() {
        if (this.props.onCoords) this.props.onCoords(null);
    }
    updateSizing() {
        let { context: context, props: props } = this;
        if (props.onCoords && props.clientWidth !== null // means sizing has stabilized
        ) {
            let rootEl = this.rootElRef.current;
            if (rootEl.offsetHeight) props.onCoords(new $705208976f9ef87b$export$bbb5c25f46ae511d(new (0, $200f5cce291452b2$export$7060da4b5db56fb9)(this.rootElRef.current, $705208976f9ef87b$var$collectSlatEls(this.slatElRefs.currentMap, props.slatMetas), false, true), this.props.dateProfile, context.options.slotDuration));
        }
    }
    constructor(){
        super(...arguments);
        this.rootElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.slatElRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)();
    }
}
function $705208976f9ef87b$var$collectSlatEls(elMap, slatMetas) {
    return slatMetas.map((slatMeta)=>elMap[slatMeta.key]);
}
function $705208976f9ef87b$var$splitSegsByCol(segs, colCnt) {
    let segsByCol = [];
    let i;
    for(i = 0; i < colCnt; i += 1)segsByCol.push([]);
    if (segs) for(i = 0; i < segs.length; i += 1)segsByCol[segs[i].col].push(segs[i]);
    return segsByCol;
}
function $705208976f9ef87b$var$splitInteractionByCol(ui, colCnt) {
    let byRow = [];
    if (!ui) for(let i = 0; i < colCnt; i += 1)byRow[i] = null;
    else {
        for(let i = 0; i < colCnt; i += 1)byRow[i] = {
            affectedInstances: ui.affectedInstances,
            isEvent: ui.isEvent,
            segs: []
        };
        for (let seg of ui.segs)byRow[seg.col].segs.push(seg);
    }
    return byRow;
}
class $705208976f9ef87b$var$TimeColMoreLink extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$cbfbec548517f2b6), {
            elClasses: [
                "fc-timegrid-more-link"
            ],
            elStyle: {
                top: props.top,
                bottom: props.bottom
            },
            allDayDate: null,
            moreCnt: props.hiddenSegs.length,
            allSegs: props.hiddenSegs,
            hiddenSegs: props.hiddenSegs,
            extraDateSpan: props.extraDateSpan,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            popoverContent: ()=>$705208976f9ef87b$var$renderPlainFgSegs(props.hiddenSegs, props),
            defaultGenerator: $705208976f9ef87b$var$renderMoreLinkInner,
            forceTimed: true
        }, (InnerContent)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-timegrid-more-link-inner",
                    "fc-sticky"
                ]
            }));
    }
}
function $705208976f9ef87b$var$renderMoreLinkInner(props) {
    return props.shortText;
}
// segInputs assumed sorted
function $705208976f9ef87b$var$buildPositioning(segInputs, strictOrder, maxStackCnt) {
    let hierarchy = new (0, $200f5cce291452b2$export$2e63b696b2c9441b)();
    if (strictOrder != null) hierarchy.strictOrder = strictOrder;
    if (maxStackCnt != null) hierarchy.maxStackCnt = maxStackCnt;
    let hiddenEntries = hierarchy.addSegs(segInputs);
    let hiddenGroups = (0, $200f5cce291452b2$export$381353cf1dd55255)(hiddenEntries);
    let web = $705208976f9ef87b$var$buildWeb(hierarchy);
    web = $705208976f9ef87b$var$stretchWeb(web, 1); // all levelCoords/thickness will have 0.0-1.0
    let segRects = $705208976f9ef87b$var$webToRects(web);
    return {
        segRects: segRects,
        hiddenGroups: hiddenGroups
    };
}
function $705208976f9ef87b$var$buildWeb(hierarchy) {
    const { entriesByLevel: entriesByLevel } = hierarchy;
    const buildNode = $705208976f9ef87b$var$cacheable((level, lateral)=>level + ":" + lateral, (level, lateral)=>{
        let siblingRange = $705208976f9ef87b$var$findNextLevelSegs(hierarchy, level, lateral);
        let nextLevelRes = $705208976f9ef87b$var$buildNodes(siblingRange, buildNode);
        let entry = entriesByLevel[level][lateral];
        return [
            Object.assign(Object.assign({}, entry), {
                nextLevelNodes: nextLevelRes[0]
            }),
            entry.thickness + nextLevelRes[1]
        ];
    });
    return $705208976f9ef87b$var$buildNodes(entriesByLevel.length ? {
        level: 0,
        lateralStart: 0,
        lateralEnd: entriesByLevel[0].length
    } : null, buildNode)[0];
}
function $705208976f9ef87b$var$buildNodes(siblingRange, buildNode) {
    if (!siblingRange) return [
        [],
        0
    ];
    let { level: level, lateralStart: lateralStart, lateralEnd: lateralEnd } = siblingRange;
    let lateral = lateralStart;
    let pairs = [];
    while(lateral < lateralEnd){
        pairs.push(buildNode(level, lateral));
        lateral += 1;
    }
    pairs.sort($705208976f9ef87b$var$cmpDescPressures);
    return [
        pairs.map($705208976f9ef87b$var$extractNode),
        pairs[0][1]
    ];
}
function $705208976f9ef87b$var$cmpDescPressures(a, b) {
    return b[1] - a[1];
}
function $705208976f9ef87b$var$extractNode(a) {
    return a[0];
}
function $705208976f9ef87b$var$findNextLevelSegs(hierarchy, subjectLevel, subjectLateral) {
    let { levelCoords: levelCoords, entriesByLevel: entriesByLevel } = hierarchy;
    let subjectEntry = entriesByLevel[subjectLevel][subjectLateral];
    let afterSubject = levelCoords[subjectLevel] + subjectEntry.thickness;
    let levelCnt = levelCoords.length;
    let level = subjectLevel;
    // skip past levels that are too high up
    for(; level < levelCnt && levelCoords[level] < afterSubject; level += 1); // do nothing
    for(; level < levelCnt; level += 1){
        let entries = entriesByLevel[level];
        let entry;
        let searchIndex = (0, $200f5cce291452b2$export$b0165a7e514844)(entries, subjectEntry.span.start, (0, $200f5cce291452b2$export$d76842aa27385215));
        let lateralStart = searchIndex[0] + searchIndex[1]; // if exact match (which doesn't collide), go to next one
        let lateralEnd = lateralStart;
        while((entry = entries[lateralEnd]) && // but not past the whole seg list
        entry.span.start < subjectEntry.span.end)lateralEnd += 1;
        if (lateralStart < lateralEnd) return {
            level: level,
            lateralStart: lateralStart,
            lateralEnd: lateralEnd
        };
    }
    return null;
}
function $705208976f9ef87b$var$stretchWeb(topLevelNodes, totalThickness) {
    const stretchNode = $705208976f9ef87b$var$cacheable((node, startCoord, prevThickness)=>(0, $200f5cce291452b2$export$eb84e45a33f6ba7c)(node), (node, startCoord, prevThickness)=>{
        let { nextLevelNodes: nextLevelNodes, thickness: thickness } = node;
        let allThickness = thickness + prevThickness;
        let thicknessFraction = thickness / allThickness;
        let endCoord;
        let newChildren = [];
        if (!nextLevelNodes.length) endCoord = totalThickness;
        else {
            for (let childNode of nextLevelNodes)if (endCoord === undefined) {
                let res = stretchNode(childNode, startCoord, allThickness);
                endCoord = res[0];
                newChildren.push(res[1]);
            } else {
                let res = stretchNode(childNode, endCoord, 0);
                newChildren.push(res[1]);
            }
        }
        let newThickness = (endCoord - startCoord) * thicknessFraction;
        return [
            endCoord - newThickness,
            Object.assign(Object.assign({}, node), {
                thickness: newThickness,
                nextLevelNodes: newChildren
            })
        ];
    });
    return topLevelNodes.map((node)=>stretchNode(node, 0, 0)[1]);
}
// not sorted in any particular order
function $705208976f9ef87b$var$webToRects(topLevelNodes) {
    let rects = [];
    const processNode = $705208976f9ef87b$var$cacheable((node, levelCoord, stackDepth)=>(0, $200f5cce291452b2$export$eb84e45a33f6ba7c)(node), (node, levelCoord, stackDepth)=>{
        let rect = Object.assign(Object.assign({}, node), {
            levelCoord: levelCoord,
            stackDepth: stackDepth,
            stackForward: 0
        });
        rects.push(rect);
        return rect.stackForward = processNodes(node.nextLevelNodes, levelCoord + node.thickness, stackDepth + 1) + 1;
    });
    function processNodes(nodes, levelCoord, stackDepth) {
        let stackForward = 0;
        for (let node of nodes)stackForward = Math.max(processNode(node, levelCoord, stackDepth), stackForward);
        return stackForward;
    }
    processNodes(topLevelNodes, 0, 0);
    return rects; // TODO: sort rects by levelCoord to be consistent with toRects?
}
// TODO: move to general util
function $705208976f9ef87b$var$cacheable(keyFunc, workFunc) {
    const cache = {};
    return (...args)=>{
        let key = keyFunc(...args);
        return key in cache ? cache[key] : cache[key] = workFunc(...args);
    };
}
function $705208976f9ef87b$var$computeSegVCoords(segs, colDate, slatCoords = null, eventMinHeight = 0) {
    let vcoords = [];
    if (slatCoords) for(let i = 0; i < segs.length; i += 1){
        let seg = segs[i];
        let spanStart = slatCoords.computeDateTop(seg.start, colDate);
        let spanEnd = Math.max(spanStart + (eventMinHeight || 0), slatCoords.computeDateTop(seg.end, colDate));
        vcoords.push({
            start: Math.round(spanStart),
            end: Math.round(spanEnd)
        });
    }
    return vcoords;
}
function $705208976f9ef87b$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack) {
    let segInputs = [];
    let dumbSegs = []; // segs without coords
    for(let i = 0; i < segs.length; i += 1){
        let vcoords = segVCoords[i];
        if (vcoords) segInputs.push({
            index: i,
            thickness: 1,
            span: vcoords
        });
        else dumbSegs.push(segs[i]);
    }
    let { segRects: segRects, hiddenGroups: hiddenGroups } = $705208976f9ef87b$var$buildPositioning(segInputs, eventOrderStrict, eventMaxStack);
    let segPlacements = [];
    for (let segRect of segRects)segPlacements.push({
        seg: segs[segRect.index],
        rect: segRect
    });
    for (let dumbSeg of dumbSegs)segPlacements.push({
        seg: dumbSeg,
        rect: null
    });
    return {
        segPlacements: segPlacements,
        hiddenGroups: hiddenGroups
    };
}
const $705208976f9ef87b$var$DEFAULT_TIME_FORMAT = (0, $200f5cce291452b2$export$d141bba7fdc215a3)({
    hour: "numeric",
    minute: "2-digit",
    meridiem: false
});
class $705208976f9ef87b$var$TimeColEvent extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$d92db8a7dc823bb0), Object.assign({}, this.props, {
            elClasses: [
                "fc-timegrid-event",
                "fc-v-event",
                this.props.isShort && "fc-timegrid-event-short"
            ],
            defaultTimeFormat: $705208976f9ef87b$var$DEFAULT_TIME_FORMAT
        }));
    }
}
class $705208976f9ef87b$var$TimeCol extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    // TODO: memoize event-placement?
    render() {
        let { props: props, context: context } = this;
        let { options: options } = context;
        let isSelectMirror = options.selectMirror;
        let mirrorSegs = props.eventDrag && props.eventDrag.segs || props.eventResize && props.eventResize.segs || isSelectMirror && props.dateSelectionSegs || [];
        let interactionAffectedInstances = props.eventDrag && props.eventDrag.affectedInstances || props.eventResize && props.eventResize.affectedInstances || {};
        let sortedFgSegs = this.sortEventSegs(props.fgEventSegs, options.eventOrder);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$b975d55abac2bbe3), {
            elTag: "td",
            elRef: props.elRef,
            elClasses: [
                "fc-timegrid-col",
                ...props.extraClassNames || []
            ],
            elAttrs: Object.assign({
                role: "gridcell"
            }, props.extraDataAttrs),
            date: props.date,
            dateProfile: props.dateProfile,
            todayRange: props.todayRange,
            extraRenderProps: props.extraRenderProps
        }, (InnerContent)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-frame"
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-bg"
            }, this.renderFillSegs(props.businessHourSegs, "non-business"), this.renderFillSegs(props.bgEventSegs, "bg-event"), this.renderFillSegs(props.dateSelectionSegs, "highlight")), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(sortedFgSegs, interactionAffectedInstances, false, false, false)), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-col-events"
            }, this.renderFgSegs(mirrorSegs, {}, Boolean(props.eventDrag), Boolean(props.eventResize), Boolean(isSelectMirror), "mirror")), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-now-indicator-container"
            }, this.renderNowIndicator(props.nowIndicatorSegs)), (0, $200f5cce291452b2$export$b02498c06ddfef28)(options) && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)(InnerContent, {
                elTag: "div",
                elClasses: [
                    "fc-timegrid-col-misc"
                ]
            })));
    }
    renderFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { props: props } = this;
        if (props.forPrint) return $705208976f9ef87b$var$renderPlainFgSegs(sortedFgSegs, props);
        return this.renderPositionedFgSegs(sortedFgSegs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey);
    }
    renderPositionedFgSegs(segs, segIsInvisible, isDragging, isResizing, isDateSelecting, forcedKey) {
        let { eventMaxStack: eventMaxStack, eventShortHeight: eventShortHeight, eventOrderStrict: eventOrderStrict, eventMinHeight: eventMinHeight } = this.context.options;
        let { date: date, slatCoords: slatCoords, eventSelection: eventSelection, todayRange: todayRange, nowDate: nowDate } = this.props;
        let isMirror = isDragging || isResizing || isDateSelecting;
        let segVCoords = $705208976f9ef87b$var$computeSegVCoords(segs, date, slatCoords, eventMinHeight);
        let { segPlacements: segPlacements, hiddenGroups: hiddenGroups } = $705208976f9ef87b$var$computeFgSegPlacements(segs, segVCoords, eventOrderStrict, eventMaxStack);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, this.renderHiddenGroups(hiddenGroups, segs), segPlacements.map((segPlacement)=>{
            let { seg: seg, rect: rect } = segPlacement;
            let instanceId = seg.eventRange.instance.instanceId;
            let isVisible = isMirror || Boolean(!segIsInvisible[instanceId] && rect);
            let vStyle = $705208976f9ef87b$var$computeSegVStyle(rect && rect.span);
            let hStyle = !isMirror && rect ? this.computeSegHStyle(rect) : {
                left: 0,
                right: 0
            };
            let isInset = Boolean(rect) && rect.stackForward > 0;
            let isShort = Boolean(rect) && rect.span.end - rect.span.start < eventShortHeight; // look at other places for this problem
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                className: "fc-timegrid-event-harness" + (isInset ? " fc-timegrid-event-harness-inset" : ""),
                key: forcedKey || instanceId,
                style: Object.assign(Object.assign({
                    visibility: isVisible ? "" : "hidden"
                }, vStyle), hStyle)
            }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColEvent, Object.assign({
                seg: seg,
                isDragging: isDragging,
                isResizing: isResizing,
                isDateSelecting: isDateSelecting,
                isSelected: instanceId === eventSelection,
                isShort: isShort
            }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, todayRange, nowDate))));
        }));
    }
    // will already have eventMinHeight applied because segInputs already had it
    renderHiddenGroups(hiddenGroups, segs) {
        let { extraDateSpan: extraDateSpan, dateProfile: dateProfile, todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize } = this.props;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, hiddenGroups.map((hiddenGroup)=>{
            let positionCss = $705208976f9ef87b$var$computeSegVStyle(hiddenGroup.span);
            let hiddenSegs = $705208976f9ef87b$var$compileSegsFromEntries(hiddenGroup.entries, segs);
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColMoreLink, {
                key: (0, $200f5cce291452b2$export$45d219bdcd8ac53c)((0, $200f5cce291452b2$export$bde1ed0f60b38f2f)(hiddenSegs)),
                hiddenSegs: hiddenSegs,
                top: positionCss.top,
                bottom: positionCss.bottom,
                extraDateSpan: extraDateSpan,
                dateProfile: dateProfile,
                todayRange: todayRange,
                nowDate: nowDate,
                eventSelection: eventSelection,
                eventDrag: eventDrag,
                eventResize: eventResize
            });
        }));
    }
    renderFillSegs(segs, fillType) {
        let { props: props, context: context } = this;
        let segVCoords = $705208976f9ef87b$var$computeSegVCoords(segs, props.date, props.slatCoords, context.options.eventMinHeight); // don't assume all populated
        let children = segVCoords.map((vcoords, i)=>{
            let seg = segs[i];
            return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
                key: (0, $200f5cce291452b2$export$1314441b8d04e1d5)(seg.eventRange),
                className: "fc-timegrid-bg-harness",
                style: $705208976f9ef87b$var$computeSegVStyle(vcoords)
            }, fillType === "bg-event" ? (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$cd571ca6d1702b73), Object.assign({
                seg: seg
            }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, props.todayRange, props.nowDate))) : (0, $200f5cce291452b2$export$87b6ab1c2cb8b955)(fillType));
        });
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, children);
    }
    renderNowIndicator(segs) {
        let { slatCoords: slatCoords, date: date } = this.props;
        if (!slatCoords) return null;
        return segs.map((seg, i)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$c1df809846363ebe), {
                // key doesn't matter. will only ever be one
                key: i,
                elClasses: [
                    "fc-timegrid-now-indicator-line"
                ],
                elStyle: {
                    top: slatCoords.computeDateTop(seg.start, date)
                },
                isAxis: false,
                date: date
            }));
    }
    computeSegHStyle(segHCoords) {
        let { isRtl: isRtl, options: options } = this.context;
        let shouldOverlap = options.slotEventOverlap;
        let nearCoord = segHCoords.levelCoord; // the left side if LTR. the right side if RTL. floating-point
        let farCoord = segHCoords.levelCoord + segHCoords.thickness; // the right side if LTR. the left side if RTL. floating-point
        let left; // amount of space from left edge, a fraction of the total width
        let right; // amount of space from right edge, a fraction of the total width
        if (shouldOverlap) // double the width, but don't go beyond the maximum forward coordinate (1.0)
        farCoord = Math.min(1, nearCoord + (farCoord - nearCoord) * 2);
        if (isRtl) {
            left = 1 - farCoord;
            right = nearCoord;
        } else {
            left = nearCoord;
            right = 1 - farCoord;
        }
        let props = {
            zIndex: segHCoords.stackDepth + 1,
            left: left * 100 + "%",
            right: right * 100 + "%"
        };
        if (shouldOverlap && !segHCoords.stackForward) // add padding to the edge so that forward stacked events don't cover the resizer's icon
        props[isRtl ? "marginLeft" : "marginRight"] = 20; // 10 is a guesstimate of the icon's width
        return props;
    }
    constructor(){
        super(...arguments);
        this.sortEventSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)((0, $200f5cce291452b2$export$4d522598b426bb73));
    }
}
function $705208976f9ef87b$var$renderPlainFgSegs(sortedFgSegs, { todayRange: todayRange, nowDate: nowDate, eventSelection: eventSelection, eventDrag: eventDrag, eventResize: eventResize }) {
    let hiddenInstances = (eventDrag ? eventDrag.affectedInstances : null) || (eventResize ? eventResize.affectedInstances : null) || {};
    return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $f652a0e37ee35e91$export$ffb0004e005737fa), null, sortedFgSegs.map((seg)=>{
        let instanceId = seg.eventRange.instance.instanceId;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            key: instanceId,
            style: {
                visibility: hiddenInstances[instanceId] ? "hidden" : ""
            }
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColEvent, Object.assign({
            seg: seg,
            isDragging: false,
            isResizing: false,
            isDateSelecting: false,
            isSelected: instanceId === eventSelection,
            isShort: false
        }, (0, $200f5cce291452b2$export$6dabbe08653f866f)(seg, todayRange, nowDate))));
    }));
}
function $705208976f9ef87b$var$computeSegVStyle(segVCoords) {
    if (!segVCoords) return {
        top: "",
        bottom: ""
    };
    return {
        top: segVCoords.start,
        bottom: -segVCoords.end
    };
}
function $705208976f9ef87b$var$compileSegsFromEntries(segEntries, allSegs) {
    return segEntries.map((segEntry)=>allSegs[segEntry.index]);
}
class $705208976f9ef87b$var$TimeColsContent extends (0, $200f5cce291452b2$export$ef35774e6d314e91) {
    render() {
        let { props: props, context: context } = this;
        let nowIndicatorTop = context.options.nowIndicator && props.slatCoords && props.slatCoords.safeComputeTop(props.nowDate); // might return void
        let colCnt = props.cells.length;
        let fgEventSegsByRow = this.splitFgEventSegs(props.fgEventSegs, colCnt);
        let bgEventSegsByRow = this.splitBgEventSegs(props.bgEventSegs, colCnt);
        let businessHourSegsByRow = this.splitBusinessHourSegs(props.businessHourSegs, colCnt);
        let nowIndicatorSegsByRow = this.splitNowIndicatorSegs(props.nowIndicatorSegs, colCnt);
        let dateSelectionSegsByRow = this.splitDateSelectionSegs(props.dateSelectionSegs, colCnt);
        let eventDragByRow = this.splitEventDrag(props.eventDrag, colCnt);
        let eventResizeByRow = this.splitEventResize(props.eventResize, colCnt);
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-cols",
            ref: this.rootElRef
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("table", {
            role: "presentation",
            style: {
                minWidth: props.tableMinWidth,
                width: props.clientWidth
            }
        }, props.tableColGroupNode, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tbody", {
            role: "presentation"
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("tr", {
            role: "row"
        }, props.axis && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("td", {
            "aria-hidden": true,
            className: "fc-timegrid-col fc-timegrid-axis"
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-col-frame"
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-now-indicator-container"
        }, typeof nowIndicatorTop === "number" && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$c1df809846363ebe), {
            elClasses: [
                "fc-timegrid-now-indicator-arrow"
            ],
            elStyle: {
                top: nowIndicatorTop
            },
            isAxis: true,
            date: props.nowDate
        })))), props.cells.map((cell, i)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeCol, {
                key: cell.key,
                elRef: this.cellElRefs.createRef(cell.key),
                dateProfile: props.dateProfile,
                date: cell.date,
                nowDate: props.nowDate,
                todayRange: props.todayRange,
                extraRenderProps: cell.extraRenderProps,
                extraDataAttrs: cell.extraDataAttrs,
                extraClassNames: cell.extraClassNames,
                extraDateSpan: cell.extraDateSpan,
                fgEventSegs: fgEventSegsByRow[i],
                bgEventSegs: bgEventSegsByRow[i],
                businessHourSegs: businessHourSegsByRow[i],
                nowIndicatorSegs: nowIndicatorSegsByRow[i],
                dateSelectionSegs: dateSelectionSegsByRow[i],
                eventDrag: eventDragByRow[i],
                eventResize: eventResizeByRow[i],
                slatCoords: props.slatCoords,
                eventSelection: props.eventSelection,
                forPrint: props.forPrint
            }))))));
    }
    componentDidMount() {
        this.updateCoords();
    }
    componentDidUpdate() {
        this.updateCoords();
    }
    updateCoords() {
        let { props: props } = this;
        if (props.onColCoords && props.clientWidth !== null // means sizing has stabilized
        ) props.onColCoords(new (0, $200f5cce291452b2$export$7060da4b5db56fb9)(this.rootElRef.current, $705208976f9ef87b$var$collectCellEls(this.cellElRefs.currentMap, props.cells), true, false));
    }
    constructor(){
        super(...arguments);
        this.splitFgEventSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitSegsByCol);
        this.splitBgEventSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitSegsByCol);
        this.splitBusinessHourSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitSegsByCol);
        this.splitNowIndicatorSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitSegsByCol);
        this.splitDateSelectionSegs = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitSegsByCol);
        this.splitEventDrag = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitInteractionByCol);
        this.splitEventResize = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$splitInteractionByCol);
        this.rootElRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
        this.cellElRefs = new (0, $200f5cce291452b2$export$49e6ee724f7f1ace)();
    }
}
function $705208976f9ef87b$var$collectCellEls(elMap, cells) {
    return cells.map((cell)=>elMap[cell.key]);
}
/* A component that renders one or more columns of vertical time slots
----------------------------------------------------------------------------------------------------------------------*/ class $705208976f9ef87b$export$6d0b14d80f61b392 extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { props: props, state: state } = this;
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)("div", {
            className: "fc-timegrid-body",
            ref: this.handleRootEl,
            style: {
                // these props are important to give this wrapper correct dimensions for interactions
                // TODO: if we set it here, can we avoid giving to inner tables?
                width: props.clientWidth,
                minWidth: props.tableMinWidth
            }
        }, (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColsSlats, {
            axis: props.axis,
            dateProfile: props.dateProfile,
            slatMetas: props.slatMetas,
            clientWidth: props.clientWidth,
            minHeight: props.expandRows ? props.clientHeight : "",
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.axis ? props.tableColGroupNode : null,
            onCoords: this.handleSlatCoords
        }), (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$var$TimeColsContent, {
            cells: props.cells,
            axis: props.axis,
            dateProfile: props.dateProfile,
            businessHourSegs: props.businessHourSegs,
            bgEventSegs: props.bgEventSegs,
            fgEventSegs: props.fgEventSegs,
            dateSelectionSegs: props.dateSelectionSegs,
            eventSelection: props.eventSelection,
            eventDrag: props.eventDrag,
            eventResize: props.eventResize,
            todayRange: props.todayRange,
            nowDate: props.nowDate,
            nowIndicatorSegs: props.nowIndicatorSegs,
            clientWidth: props.clientWidth,
            tableMinWidth: props.tableMinWidth,
            tableColGroupNode: props.tableColGroupNode,
            slatCoords: state.slatCoords,
            onColCoords: this.handleColCoords,
            forPrint: props.forPrint
        }));
    }
    componentDidMount() {
        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
    }
    componentDidUpdate(prevProps) {
        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
    }
    componentWillUnmount() {
        this.scrollResponder.detach();
    }
    queryHit(positionLeft, positionTop) {
        let { dateEnv: dateEnv, options: options } = this.context;
        let { colCoords: colCoords } = this;
        let { dateProfile: dateProfile } = this.props;
        let { slatCoords: slatCoords } = this.state;
        let { snapDuration: snapDuration, snapsPerSlot: snapsPerSlot } = this.processSlotOptions(this.props.slotDuration, options.snapDuration);
        let colIndex = colCoords.leftToIndex(positionLeft);
        let slatIndex = slatCoords.positions.topToIndex(positionTop);
        if (colIndex != null && slatIndex != null) {
            let cell = this.props.cells[colIndex];
            let slatTop = slatCoords.positions.tops[slatIndex];
            let slatHeight = slatCoords.positions.getHeight(slatIndex);
            let partial = (positionTop - slatTop) / slatHeight; // floating point number between 0 and 1
            let localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
            let snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
            let dayDate = this.props.cells[colIndex].date;
            let time = (0, $200f5cce291452b2$export$b169257caa88022a)(dateProfile.slotMinTime, (0, $200f5cce291452b2$export$847533e5bf524f5f)(snapDuration, snapIndex));
            let start = dateEnv.add(dayDate, time);
            let end = dateEnv.add(start, snapDuration);
            return {
                dateProfile: dateProfile,
                dateSpan: Object.assign({
                    range: {
                        start: start,
                        end: end
                    },
                    allDay: false
                }, cell.extraDateSpan),
                dayEl: colCoords.els[colIndex],
                rect: {
                    left: colCoords.lefts[colIndex],
                    right: colCoords.rights[colIndex],
                    top: slatTop,
                    bottom: slatTop + slatHeight
                },
                layer: 0
            };
        }
        return null;
    }
    constructor(){
        super(...arguments);
        this.processSlotOptions = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$var$processSlotOptions);
        this.state = {
            slatCoords: null
        };
        this.handleRootEl = (el)=>{
            if (el) this.context.registerInteractiveComponent(this, {
                el: el,
                isHitComboAllowed: this.props.isHitComboAllowed
            });
            else this.context.unregisterInteractiveComponent(this);
        };
        this.handleScrollRequest = (request)=>{
            let { onScrollTopRequest: onScrollTopRequest } = this.props;
            let { slatCoords: slatCoords } = this.state;
            if (onScrollTopRequest && slatCoords) {
                if (request.time) {
                    let top = slatCoords.computeTimeTop(request.time);
                    top = Math.ceil(top); // zoom can give weird floating-point values. rather scroll a little bit further
                    if (top) top += 1; // to overcome top border that slots beyond the first have. looks better
                    onScrollTopRequest(top);
                }
                return true;
            }
            return false;
        };
        this.handleColCoords = (colCoords)=>{
            this.colCoords = colCoords;
        };
        this.handleSlatCoords = (slatCoords)=>{
            this.setState({
                slatCoords: slatCoords
            });
            if (this.props.onSlatCoords) this.props.onSlatCoords(slatCoords);
        };
    }
}
function $705208976f9ef87b$var$processSlotOptions(slotDuration, snapDurationOverride) {
    let snapDuration = snapDurationOverride || slotDuration;
    let snapsPerSlot = (0, $200f5cce291452b2$export$56350196709588fc)(slotDuration, snapDuration);
    if (snapsPerSlot === null) {
        snapDuration = slotDuration;
        snapsPerSlot = 1;
    // TODO: say warning?
    }
    return {
        snapDuration: snapDuration,
        snapsPerSlot: snapsPerSlot
    };
}
class $705208976f9ef87b$export$ca63779cde537f3d extends (0, $200f5cce291452b2$export$6b179bb11f7fd3a0) {
    sliceRange(range, dayRanges) {
        let segs = [];
        for(let col = 0; col < dayRanges.length; col += 1){
            let segRange = (0, $200f5cce291452b2$export$ae1af26003f05816)(range, dayRanges[col]);
            if (segRange) segs.push({
                start: segRange.start,
                end: segRange.end,
                isStart: segRange.start.valueOf() === range.start.valueOf(),
                isEnd: segRange.end.valueOf() === range.end.valueOf(),
                col: col
            });
        }
        return segs;
    }
}
class $705208976f9ef87b$export$a1033d45b156b3eb extends (0, $200f5cce291452b2$export$51b138e5a065c2bb) {
    render() {
        let { props: props, context: context } = this;
        let { dateProfile: dateProfile, dayTableModel: dayTableModel } = props;
        let { nowIndicator: nowIndicator, nextDayThreshold: nextDayThreshold } = context.options;
        let dayRanges = this.buildDayRanges(dayTableModel, dateProfile, context.dateEnv);
        // give it the first row of cells
        // TODO: would move this further down hierarchy, but sliceNowDate needs it
        return (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$6e4b1d19c6e2e012), {
            unit: nowIndicator ? "minute" : "day"
        }, (nowDate, todayRange)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$export$6d0b14d80f61b392, Object.assign({
                ref: this.timeColsRef
            }, this.slicer.sliceProps(props, dateProfile, null, context, dayRanges), {
                forPrint: props.forPrint,
                axis: props.axis,
                dateProfile: dateProfile,
                slatMetas: props.slatMetas,
                slotDuration: props.slotDuration,
                cells: dayTableModel.cells[0],
                tableColGroupNode: props.tableColGroupNode,
                tableMinWidth: props.tableMinWidth,
                clientWidth: props.clientWidth,
                clientHeight: props.clientHeight,
                expandRows: props.expandRows,
                nowDate: nowDate,
                nowIndicatorSegs: nowIndicator && this.slicer.sliceNowDate(nowDate, dateProfile, nextDayThreshold, context, dayRanges),
                todayRange: todayRange,
                onScrollTopRequest: props.onScrollTopRequest,
                onSlatCoords: props.onSlatCoords
            })));
    }
    constructor(){
        super(...arguments);
        this.buildDayRanges = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$export$718c171dfac2fa3a);
        this.slicer = new $705208976f9ef87b$export$ca63779cde537f3d();
        this.timeColsRef = (0, $f652a0e37ee35e91$export$7d1e3a5e95ceca43)();
    }
}
function $705208976f9ef87b$export$718c171dfac2fa3a(dayTableModel, dateProfile, dateEnv) {
    let ranges = [];
    for (let date of dayTableModel.headerDates)ranges.push({
        start: dateEnv.add(date, dateProfile.slotMinTime),
        end: dateEnv.add(date, dateProfile.slotMaxTime)
    });
    return ranges;
}
// potential nice values for the slot-duration and interval-duration
// from largest to smallest
const $705208976f9ef87b$var$STOCK_SUB_DURATIONS = [
    {
        hours: 1
    },
    {
        minutes: 30
    },
    {
        minutes: 15
    },
    {
        seconds: 30
    },
    {
        seconds: 15
    }
];
function $705208976f9ef87b$export$717bdb379477c13e(slotMinTime, slotMaxTime, explicitLabelInterval, slotDuration, dateEnv) {
    let dayStart = new Date(0);
    let slatTime = slotMinTime;
    let slatIterator = (0, $200f5cce291452b2$export$4368d992c4eafac0)(0);
    let labelInterval = explicitLabelInterval || $705208976f9ef87b$var$computeLabelInterval(slotDuration);
    let metas = [];
    while((0, $200f5cce291452b2$export$4e222d082f82ee97)(slatTime) < (0, $200f5cce291452b2$export$4e222d082f82ee97)(slotMaxTime)){
        let date = dateEnv.add(dayStart, slatTime);
        let isLabeled = (0, $200f5cce291452b2$export$56350196709588fc)(slatIterator, labelInterval) !== null;
        metas.push({
            date: date,
            time: slatTime,
            key: date.toISOString(),
            isoTimeStr: (0, $200f5cce291452b2$export$f438b12253c2b499)(date),
            isLabeled: isLabeled
        });
        slatTime = (0, $200f5cce291452b2$export$b169257caa88022a)(slatTime, slotDuration);
        slatIterator = (0, $200f5cce291452b2$export$b169257caa88022a)(slatIterator, slotDuration);
    }
    return metas;
}
// Computes an automatic value for slotLabelInterval
function $705208976f9ef87b$var$computeLabelInterval(slotDuration) {
    let i;
    let labelInterval;
    let slotsPerLabel;
    // find the smallest stock label interval that results in more than one slots-per-label
    for(i = $705208976f9ef87b$var$STOCK_SUB_DURATIONS.length - 1; i >= 0; i -= 1){
        labelInterval = (0, $200f5cce291452b2$export$4368d992c4eafac0)($705208976f9ef87b$var$STOCK_SUB_DURATIONS[i]);
        slotsPerLabel = (0, $200f5cce291452b2$export$56350196709588fc)(labelInterval, slotDuration);
        if (slotsPerLabel !== null && slotsPerLabel > 1) return labelInterval;
    }
    return slotDuration; // fall back
}
class $705208976f9ef87b$export$4b78a540ee976f33 extends $705208976f9ef87b$export$667ac525945c6ff8 {
    render() {
        let { options: options, dateEnv: dateEnv, dateProfileGenerator: dateProfileGenerator } = this.context;
        let { props: props } = this;
        let { dateProfile: dateProfile } = props;
        let dayTableModel = this.buildTimeColsModel(dateProfile, dateProfileGenerator);
        let splitProps = this.allDaySplitter.splitProps(props);
        let slatMetas = this.buildSlatMetas(dateProfile.slotMinTime, dateProfile.slotMaxTime, options.slotLabelInterval, options.slotDuration, dateEnv);
        let { dayMinWidth: dayMinWidth } = options;
        let hasAttachedAxis = !dayMinWidth;
        let hasDetachedAxis = dayMinWidth;
        let headerContent = options.dayHeaders && (0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $200f5cce291452b2$export$ebc5e65867841cbe), {
            dates: dayTableModel.headerDates,
            dateProfile: dateProfile,
            datesRepDistinctDays: true,
            renderIntro: hasAttachedAxis ? this.renderHeadAxis : null
        });
        let allDayContent = options.allDaySlot !== false && ((contentArg)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)((0, $cc06286d62b8a4b0$export$cd402b7558adf371), Object.assign({}, splitProps.allDay, {
                dateProfile: dateProfile,
                dayTableModel: dayTableModel,
                nextDayThreshold: options.nextDayThreshold,
                tableMinWidth: contentArg.tableMinWidth,
                colGroupNode: contentArg.tableColGroupNode,
                renderRowIntro: hasAttachedAxis ? this.renderTableRowAxis : null,
                showWeekNumbers: false,
                expandRows: false,
                headerAlignElRef: this.headerElRef,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                forPrint: props.forPrint
            }, this.getAllDayMaxEventProps())));
        let timeGridContent = (contentArg)=>(0, $f652a0e37ee35e91$export$c8a8987d4410bf2d)($705208976f9ef87b$export$a1033d45b156b3eb, Object.assign({}, splitProps.timed, {
                dayTableModel: dayTableModel,
                dateProfile: dateProfile,
                axis: hasAttachedAxis,
                slotDuration: options.slotDuration,
                slatMetas: slatMetas,
                forPrint: props.forPrint,
                tableColGroupNode: contentArg.tableColGroupNode,
                tableMinWidth: contentArg.tableMinWidth,
                clientWidth: contentArg.clientWidth,
                clientHeight: contentArg.clientHeight,
                onSlatCoords: this.handleSlatCoords,
                expandRows: contentArg.expandRows,
                onScrollTopRequest: this.handleScrollTopRequest
            }));
        return hasDetachedAxis ? this.renderHScrollLayout(headerContent, allDayContent, timeGridContent, dayTableModel.colCnt, dayMinWidth, slatMetas, this.state.slatCoords) : this.renderSimpleLayout(headerContent, allDayContent, timeGridContent);
    }
    constructor(){
        super(...arguments);
        this.buildTimeColsModel = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$export$5596a640484dddd2);
        this.buildSlatMetas = (0, $200f5cce291452b2$export$df995fae86a55f06)($705208976f9ef87b$export$717bdb379477c13e);
    }
}
function $705208976f9ef87b$export$5596a640484dddd2(dateProfile, dateProfileGenerator) {
    let daySeries = new (0, $200f5cce291452b2$export$2538633961795d6b)(dateProfile.renderRange, dateProfileGenerator);
    return new (0, $200f5cce291452b2$export$dabba94403d45c8e)(daySeries, false);
}





const $481fb9d4622654d7$var$OPTION_REFINERS = {
    allDaySlot: Boolean
};
var $481fb9d4622654d7$export$2e2bcd8739ae039 = (0, $76a516e930faac74$export$ae829ec7b2625219)({
    name: "@fullcalendar/timegrid",
    initialView: "timeGridWeek",
    optionRefiners: $481fb9d4622654d7$var$OPTION_REFINERS,
    views: {
        timeGrid: {
            component: (0, $705208976f9ef87b$export$4b78a540ee976f33),
            usesMinMaxTime: true,
            allDaySlot: true,
            slotDuration: "00:30:00",
            slotEventOverlap: true
        },
        timeGridDay: {
            type: "timeGrid",
            duration: {
                days: 1
            }
        },
        timeGridWeek: {
            type: "timeGrid",
            duration: {
                weeks: 1
            }
        }
    }
});




(0, $200f5cce291452b2$export$27d1aff6bea49709).touchMouseIgnoreWait = 500;
let $a4d9a0c10526343d$var$ignoreMouseDepth = 0;
let $a4d9a0c10526343d$var$listenerCnt = 0;
let $a4d9a0c10526343d$var$isWindowTouchMoveCancelled = false;
/*
Uses a "pointer" abstraction, which monitors UI events for both mouse and touch.
Tracks when the pointer "drags" on a certain element, meaning down+move+up.

Also, tracks if there was touch-scrolling.
Also, can prevent touch-scrolling from happening.
Also, can fire pointermove events when scrolling happens underneath, even when no real pointer movement.

emits:
- pointerdown
- pointermove
- pointerup
*/ class $a4d9a0c10526343d$var$PointerDragging {
    destroy() {
        this.containerEl.removeEventListener("mousedown", this.handleMouseDown);
        this.containerEl.removeEventListener("touchstart", this.handleTouchStart, {
            passive: true
        });
        $a4d9a0c10526343d$var$listenerDestroyed();
    }
    tryStart(ev) {
        let subjectEl = this.querySubjectEl(ev);
        let downEl = ev.target;
        if (subjectEl && (!this.handleSelector || (0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(downEl, this.handleSelector))) {
            this.subjectEl = subjectEl;
            this.isDragging = true; // do this first so cancelTouchScroll will work
            this.wasTouchScroll = false;
            return true;
        }
        return false;
    }
    cleanup() {
        $a4d9a0c10526343d$var$isWindowTouchMoveCancelled = false;
        this.isDragging = false;
        this.subjectEl = null;
        // keep wasTouchScroll around for later access
        this.destroyScrollWatch();
    }
    querySubjectEl(ev) {
        if (this.selector) return (0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(ev.target, this.selector);
        return this.containerEl;
    }
    shouldIgnoreMouse() {
        return $a4d9a0c10526343d$var$ignoreMouseDepth || this.isTouchDragging;
    }
    // can be called by user of this class, to cancel touch-based scrolling for the current drag
    cancelTouchScroll() {
        if (this.isDragging) $a4d9a0c10526343d$var$isWindowTouchMoveCancelled = true;
    }
    // Scrolling that simulates pointermoves
    // ----------------------------------------------------------------------------------------------------
    initScrollWatch(ev) {
        if (this.shouldWatchScroll) {
            this.recordCoords(ev);
            window.addEventListener("scroll", this.handleScroll, true); // useCapture=true
        }
    }
    recordCoords(ev) {
        if (this.shouldWatchScroll) {
            this.prevPageX = ev.pageX;
            this.prevPageY = ev.pageY;
            this.prevScrollX = window.pageXOffset;
            this.prevScrollY = window.pageYOffset;
        }
    }
    destroyScrollWatch() {
        if (this.shouldWatchScroll) window.removeEventListener("scroll", this.handleScroll, true); // useCaptured=true
    }
    // Event Normalization
    // ----------------------------------------------------------------------------------------------------
    createEventFromMouse(ev, isFirst) {
        let deltaX = 0;
        let deltaY = 0;
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = ev.pageX;
            this.origPageY = ev.pageY;
        } else {
            deltaX = ev.pageX - this.origPageX;
            deltaY = ev.pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: false,
            subjectEl: this.subjectEl,
            pageX: ev.pageX,
            pageY: ev.pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    }
    createEventFromTouch(ev, isFirst) {
        let touches = ev.touches;
        let pageX;
        let pageY;
        let deltaX = 0;
        let deltaY = 0;
        // if touch coords available, prefer,
        // because FF would give bad ev.pageX ev.pageY
        if (touches && touches.length) {
            pageX = touches[0].pageX;
            pageY = touches[0].pageY;
        } else {
            pageX = ev.pageX;
            pageY = ev.pageY;
        }
        // TODO: repeat code
        if (isFirst) {
            this.origPageX = pageX;
            this.origPageY = pageY;
        } else {
            deltaX = pageX - this.origPageX;
            deltaY = pageY - this.origPageY;
        }
        return {
            origEvent: ev,
            isTouch: true,
            subjectEl: this.subjectEl,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY
        };
    }
    constructor(containerEl){
        this.subjectEl = null;
        // options that can be directly assigned by caller
        this.selector = ""; // will cause subjectEl in all emitted events to be this element
        this.handleSelector = "";
        this.shouldIgnoreMove = false;
        this.shouldWatchScroll = true; // for simulating pointermove on scroll
        // internal states
        this.isDragging = false;
        this.isTouchDragging = false;
        this.wasTouchScroll = false;
        // Mouse
        // ----------------------------------------------------------------------------------------------------
        this.handleMouseDown = (ev)=>{
            if (!this.shouldIgnoreMouse() && $a4d9a0c10526343d$var$isPrimaryMouseButton(ev) && this.tryStart(ev)) {
                let pev = this.createEventFromMouse(ev, true);
                this.emitter.trigger("pointerdown", pev);
                this.initScrollWatch(pev);
                if (!this.shouldIgnoreMove) document.addEventListener("mousemove", this.handleMouseMove);
                document.addEventListener("mouseup", this.handleMouseUp);
            }
        };
        this.handleMouseMove = (ev)=>{
            let pev = this.createEventFromMouse(ev);
            this.recordCoords(pev);
            this.emitter.trigger("pointermove", pev);
        };
        this.handleMouseUp = (ev)=>{
            document.removeEventListener("mousemove", this.handleMouseMove);
            document.removeEventListener("mouseup", this.handleMouseUp);
            this.emitter.trigger("pointerup", this.createEventFromMouse(ev));
            this.cleanup(); // call last so that pointerup has access to props
        };
        // Touch
        // ----------------------------------------------------------------------------------------------------
        this.handleTouchStart = (ev)=>{
            if (this.tryStart(ev)) {
                this.isTouchDragging = true;
                let pev = this.createEventFromTouch(ev, true);
                this.emitter.trigger("pointerdown", pev);
                this.initScrollWatch(pev);
                // unlike mouse, need to attach to target, not document
                // https://stackoverflow.com/a/45760014
                let targetEl = ev.target;
                if (!this.shouldIgnoreMove) targetEl.addEventListener("touchmove", this.handleTouchMove);
                targetEl.addEventListener("touchend", this.handleTouchEnd);
                targetEl.addEventListener("touchcancel", this.handleTouchEnd); // treat it as a touch end
                // attach a handler to get called when ANY scroll action happens on the page.
                // this was impossible to do with normal on/off because 'scroll' doesn't bubble.
                // http://stackoverflow.com/a/32954565/96342
                window.addEventListener("scroll", this.handleTouchScroll, true);
            }
        };
        this.handleTouchMove = (ev)=>{
            let pev = this.createEventFromTouch(ev);
            this.recordCoords(pev);
            this.emitter.trigger("pointermove", pev);
        };
        this.handleTouchEnd = (ev)=>{
            if (this.isDragging) {
                let targetEl = ev.target;
                targetEl.removeEventListener("touchmove", this.handleTouchMove);
                targetEl.removeEventListener("touchend", this.handleTouchEnd);
                targetEl.removeEventListener("touchcancel", this.handleTouchEnd);
                window.removeEventListener("scroll", this.handleTouchScroll, true); // useCaptured=true
                this.emitter.trigger("pointerup", this.createEventFromTouch(ev));
                this.cleanup(); // call last so that pointerup has access to props
                this.isTouchDragging = false;
                $a4d9a0c10526343d$var$startIgnoringMouse();
            }
        };
        this.handleTouchScroll = ()=>{
            this.wasTouchScroll = true;
        };
        this.handleScroll = (ev)=>{
            if (!this.shouldIgnoreMove) {
                let pageX = window.pageXOffset - this.prevScrollX + this.prevPageX;
                let pageY = window.pageYOffset - this.prevScrollY + this.prevPageY;
                this.emitter.trigger("pointermove", {
                    origEvent: ev,
                    isTouch: this.isTouchDragging,
                    subjectEl: this.subjectEl,
                    pageX: pageX,
                    pageY: pageY,
                    deltaX: pageX - this.origPageX,
                    deltaY: pageY - this.origPageY
                });
            }
        };
        this.containerEl = containerEl;
        this.emitter = new (0, $200f5cce291452b2$export$d66501df72047452)();
        containerEl.addEventListener("mousedown", this.handleMouseDown);
        containerEl.addEventListener("touchstart", this.handleTouchStart, {
            passive: true
        });
        $a4d9a0c10526343d$var$listenerCreated();
    }
}
// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
function $a4d9a0c10526343d$var$isPrimaryMouseButton(ev) {
    return ev.button === 0 && !ev.ctrlKey;
}
// Ignoring fake mouse events generated by touch
// ----------------------------------------------------------------------------------------------------
function $a4d9a0c10526343d$var$startIgnoringMouse() {
    $a4d9a0c10526343d$var$ignoreMouseDepth += 1;
    setTimeout(()=>{
        $a4d9a0c10526343d$var$ignoreMouseDepth -= 1;
    }, (0, $200f5cce291452b2$export$27d1aff6bea49709).touchMouseIgnoreWait);
}
// We want to attach touchmove as early as possible for Safari
// ----------------------------------------------------------------------------------------------------
function $a4d9a0c10526343d$var$listenerCreated() {
    $a4d9a0c10526343d$var$listenerCnt += 1;
    if ($a4d9a0c10526343d$var$listenerCnt === 1) window.addEventListener("touchmove", $a4d9a0c10526343d$var$onWindowTouchMove, {
        passive: false
    });
}
function $a4d9a0c10526343d$var$listenerDestroyed() {
    $a4d9a0c10526343d$var$listenerCnt -= 1;
    if (!$a4d9a0c10526343d$var$listenerCnt) window.removeEventListener("touchmove", $a4d9a0c10526343d$var$onWindowTouchMove, {
        passive: false
    });
}
function $a4d9a0c10526343d$var$onWindowTouchMove(ev) {
    if ($a4d9a0c10526343d$var$isWindowTouchMoveCancelled) ev.preventDefault();
}
/*
An effect in which an element follows the movement of a pointer across the screen.
The moving element is a clone of some other element.
Must call start + handleMove + stop.
*/ class $a4d9a0c10526343d$var$ElementMirror {
    start(sourceEl, pageX, pageY) {
        this.sourceEl = sourceEl;
        this.sourceElRect = this.sourceEl.getBoundingClientRect();
        this.origScreenX = pageX - window.pageXOffset;
        this.origScreenY = pageY - window.pageYOffset;
        this.deltaX = 0;
        this.deltaY = 0;
        this.updateElPosition();
    }
    handleMove(pageX, pageY) {
        this.deltaX = pageX - window.pageXOffset - this.origScreenX;
        this.deltaY = pageY - window.pageYOffset - this.origScreenY;
        this.updateElPosition();
    }
    // can be called before start
    setIsVisible(bool) {
        if (bool) {
            if (!this.isVisible) {
                if (this.mirrorEl) this.mirrorEl.style.display = "";
                this.isVisible = bool; // needs to happen before updateElPosition
                this.updateElPosition(); // because was not updating the position while invisible
            }
        } else if (this.isVisible) {
            if (this.mirrorEl) this.mirrorEl.style.display = "none";
            this.isVisible = bool;
        }
    }
    // always async
    stop(needsRevertAnimation, callback) {
        let done = ()=>{
            this.cleanup();
            callback();
        };
        if (needsRevertAnimation && this.mirrorEl && this.isVisible && this.revertDuration && // if 0, transition won't work
        (this.deltaX || this.deltaY // if same coords, transition won't work
        )) this.doRevertAnimation(done, this.revertDuration);
        else setTimeout(done, 0);
    }
    doRevertAnimation(callback, revertDuration) {
        let mirrorEl = this.mirrorEl;
        let finalSourceElRect = this.sourceEl.getBoundingClientRect(); // because autoscrolling might have happened
        mirrorEl.style.transition = "top " + revertDuration + "ms," + "left " + revertDuration + "ms";
        (0, $200f5cce291452b2$export$2ed0fc6709e59212)(mirrorEl, {
            left: finalSourceElRect.left,
            top: finalSourceElRect.top
        });
        (0, $200f5cce291452b2$export$2ec5befb9e6c97d4)(mirrorEl, ()=>{
            mirrorEl.style.transition = "";
            callback();
        });
    }
    cleanup() {
        if (this.mirrorEl) {
            (0, $200f5cce291452b2$export$c03999cb2f36933f)(this.mirrorEl);
            this.mirrorEl = null;
        }
        this.sourceEl = null;
    }
    updateElPosition() {
        if (this.sourceEl && this.isVisible) (0, $200f5cce291452b2$export$2ed0fc6709e59212)(this.getMirrorEl(), {
            left: this.sourceElRect.left + this.deltaX,
            top: this.sourceElRect.top + this.deltaY
        });
    }
    getMirrorEl() {
        let sourceElRect = this.sourceElRect;
        let mirrorEl = this.mirrorEl;
        if (!mirrorEl) {
            mirrorEl = this.mirrorEl = this.sourceEl.cloneNode(true); // cloneChildren=true
            // we don't want long taps or any mouse interaction causing selection/menus.
            // would use preventSelection(), but that prevents selectstart, causing problems.
            mirrorEl.style.userSelect = "none";
            mirrorEl.classList.add("fc-event-dragging");
            (0, $200f5cce291452b2$export$2ed0fc6709e59212)(mirrorEl, {
                position: "fixed",
                zIndex: this.zIndex,
                visibility: "",
                boxSizing: "border-box",
                width: sourceElRect.right - sourceElRect.left,
                height: sourceElRect.bottom - sourceElRect.top,
                right: "auto",
                bottom: "auto",
                margin: 0
            });
            this.parentNode.appendChild(mirrorEl);
        }
        return mirrorEl;
    }
    constructor(){
        this.isVisible = false; // must be explicitly enabled
        this.sourceEl = null;
        this.mirrorEl = null;
        this.sourceElRect = null; // screen coords relative to viewport
        // options that can be set directly by caller
        this.parentNode = document.body; // HIGHLY SUGGESTED to set this to sidestep ShadowDOM issues
        this.zIndex = 9999;
        this.revertDuration = 0;
    }
}
/*
Is a cache for a given element's scroll information (all the info that ScrollController stores)
in addition the "client rectangle" of the element.. the area within the scrollbars.

The cache can be in one of two modes:
- doesListening:false - ignores when the container is scrolled by someone else
- doesListening:true - watch for scrolling and update the cache
*/ class $a4d9a0c10526343d$var$ScrollGeomCache extends (0, $200f5cce291452b2$export$c5d1328b37d47994) {
    destroy() {
        if (this.doesListening) this.getEventTarget().removeEventListener("scroll", this.handleScroll);
    }
    getScrollTop() {
        return this.scrollTop;
    }
    getScrollLeft() {
        return this.scrollLeft;
    }
    setScrollTop(top) {
        this.scrollController.setScrollTop(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollTop = Math.max(Math.min(top, this.getMaxScrollTop()), 0);
            this.handleScrollChange();
        }
    }
    setScrollLeft(top) {
        this.scrollController.setScrollLeft(top);
        if (!this.doesListening) {
            // we are not relying on the element to normalize out-of-bounds scroll values
            // so we need to sanitize ourselves
            this.scrollLeft = Math.max(Math.min(top, this.getMaxScrollLeft()), 0);
            this.handleScrollChange();
        }
    }
    getClientWidth() {
        return this.clientWidth;
    }
    getClientHeight() {
        return this.clientHeight;
    }
    getScrollWidth() {
        return this.scrollWidth;
    }
    getScrollHeight() {
        return this.scrollHeight;
    }
    handleScrollChange() {}
    constructor(scrollController, doesListening){
        super();
        this.handleScroll = ()=>{
            this.scrollTop = this.scrollController.getScrollTop();
            this.scrollLeft = this.scrollController.getScrollLeft();
            this.handleScrollChange();
        };
        this.scrollController = scrollController;
        this.doesListening = doesListening;
        this.scrollTop = this.origScrollTop = scrollController.getScrollTop();
        this.scrollLeft = this.origScrollLeft = scrollController.getScrollLeft();
        this.scrollWidth = scrollController.getScrollWidth();
        this.scrollHeight = scrollController.getScrollHeight();
        this.clientWidth = scrollController.getClientWidth();
        this.clientHeight = scrollController.getClientHeight();
        this.clientRect = this.computeClientRect(); // do last in case it needs cached values
        if (this.doesListening) this.getEventTarget().addEventListener("scroll", this.handleScroll);
    }
}
class $a4d9a0c10526343d$var$ElementScrollGeomCache extends $a4d9a0c10526343d$var$ScrollGeomCache {
    getEventTarget() {
        return this.scrollController.el;
    }
    computeClientRect() {
        return (0, $200f5cce291452b2$export$53c86fa97d611818)(this.scrollController.el);
    }
    constructor(el, doesListening){
        super(new (0, $200f5cce291452b2$export$d22783b3c2400a3a)(el), doesListening);
    }
}
class $a4d9a0c10526343d$var$WindowScrollGeomCache extends $a4d9a0c10526343d$var$ScrollGeomCache {
    getEventTarget() {
        return window;
    }
    computeClientRect() {
        return {
            left: this.scrollLeft,
            right: this.scrollLeft + this.clientWidth,
            top: this.scrollTop,
            bottom: this.scrollTop + this.clientHeight
        };
    }
    // the window is the only scroll object that changes it's rectangle relative
    // to the document's topleft as it scrolls
    handleScrollChange() {
        this.clientRect = this.computeClientRect();
    }
    constructor(doesListening){
        super(new (0, $200f5cce291452b2$export$7f557e5eb95176c2)(), doesListening);
    }
}
// If available we are using native "performance" API instead of "Date"
// Read more about it on MDN:
// https://developer.mozilla.org/en-US/docs/Web/API/Performance
const $a4d9a0c10526343d$var$getTime = typeof performance === "function" ? performance.now : Date.now;
/*
For a pointer interaction, automatically scrolls certain scroll containers when the pointer
approaches the edge.

The caller must call start + handleMove + stop.
*/ class $a4d9a0c10526343d$var$AutoScroller {
    start(pageX, pageY, scrollStartEl) {
        if (this.isEnabled) {
            this.scrollCaches = this.buildCaches(scrollStartEl);
            this.pointerScreenX = null;
            this.pointerScreenY = null;
            this.everMovedUp = false;
            this.everMovedDown = false;
            this.everMovedLeft = false;
            this.everMovedRight = false;
            this.handleMove(pageX, pageY);
        }
    }
    handleMove(pageX, pageY) {
        if (this.isEnabled) {
            let pointerScreenX = pageX - window.pageXOffset;
            let pointerScreenY = pageY - window.pageYOffset;
            let yDelta = this.pointerScreenY === null ? 0 : pointerScreenY - this.pointerScreenY;
            let xDelta = this.pointerScreenX === null ? 0 : pointerScreenX - this.pointerScreenX;
            if (yDelta < 0) this.everMovedUp = true;
            else if (yDelta > 0) this.everMovedDown = true;
            if (xDelta < 0) this.everMovedLeft = true;
            else if (xDelta > 0) this.everMovedRight = true;
            this.pointerScreenX = pointerScreenX;
            this.pointerScreenY = pointerScreenY;
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.requestAnimation($a4d9a0c10526343d$var$getTime());
            }
        }
    }
    stop() {
        if (this.isEnabled) {
            this.isAnimating = false; // will stop animation
            for (let scrollCache of this.scrollCaches)scrollCache.destroy();
            this.scrollCaches = null;
        }
    }
    requestAnimation(now) {
        this.msSinceRequest = now;
        requestAnimationFrame(this.animate);
    }
    handleSide(edge, seconds) {
        let { scrollCache: scrollCache } = edge;
        let { edgeThreshold: edgeThreshold } = this;
        let invDistance = edgeThreshold - edge.distance;
        let velocity = invDistance * invDistance / (edgeThreshold * edgeThreshold) * // quadratic
        this.maxVelocity * seconds;
        let sign = 1;
        switch(edge.name){
            case "left":
                sign = -1;
            // falls through
            case "right":
                scrollCache.setScrollLeft(scrollCache.getScrollLeft() + velocity * sign);
                break;
            case "top":
                sign = -1;
            // falls through
            case "bottom":
                scrollCache.setScrollTop(scrollCache.getScrollTop() + velocity * sign);
                break;
        }
    }
    // left/top are relative to document topleft
    computeBestEdge(left, top) {
        let { edgeThreshold: edgeThreshold } = this;
        let bestSide = null;
        let scrollCaches = this.scrollCaches || [];
        for (let scrollCache of scrollCaches){
            let rect = scrollCache.clientRect;
            let leftDist = left - rect.left;
            let rightDist = rect.right - left;
            let topDist = top - rect.top;
            let bottomDist = rect.bottom - top;
            // completely within the rect?
            if (leftDist >= 0 && rightDist >= 0 && topDist >= 0 && bottomDist >= 0) {
                if (topDist <= edgeThreshold && this.everMovedUp && scrollCache.canScrollUp() && (!bestSide || bestSide.distance > topDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "top",
                    distance: topDist
                };
                if (bottomDist <= edgeThreshold && this.everMovedDown && scrollCache.canScrollDown() && (!bestSide || bestSide.distance > bottomDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "bottom",
                    distance: bottomDist
                };
                if (leftDist <= edgeThreshold && this.everMovedLeft && scrollCache.canScrollLeft() && (!bestSide || bestSide.distance > leftDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "left",
                    distance: leftDist
                };
                if (rightDist <= edgeThreshold && this.everMovedRight && scrollCache.canScrollRight() && (!bestSide || bestSide.distance > rightDist)) bestSide = {
                    scrollCache: scrollCache,
                    name: "right",
                    distance: rightDist
                };
            }
        }
        return bestSide;
    }
    buildCaches(scrollStartEl) {
        return this.queryScrollEls(scrollStartEl).map((el)=>{
            if (el === window) return new $a4d9a0c10526343d$var$WindowScrollGeomCache(false); // false = don't listen to user-generated scrolls
            return new $a4d9a0c10526343d$var$ElementScrollGeomCache(el, false); // false = don't listen to user-generated scrolls
        });
    }
    queryScrollEls(scrollStartEl) {
        let els = [];
        for (let query of this.scrollQuery)if (typeof query === "object") els.push(query);
        else els.push(...Array.prototype.slice.call(scrollStartEl.getRootNode().querySelectorAll(query)));
        return els;
    }
    constructor(){
        // options that can be set by caller
        this.isEnabled = true;
        this.scrollQuery = [
            window,
            ".fc-scroller"
        ];
        this.edgeThreshold = 50; // pixels
        this.maxVelocity = 300; // pixels per second
        // internal state
        this.pointerScreenX = null;
        this.pointerScreenY = null;
        this.isAnimating = false;
        this.scrollCaches = null;
        // protect against the initial pointerdown being too close to an edge and starting the scroll
        this.everMovedUp = false;
        this.everMovedDown = false;
        this.everMovedLeft = false;
        this.everMovedRight = false;
        this.animate = ()=>{
            if (this.isAnimating) {
                let edge = this.computeBestEdge(this.pointerScreenX + window.pageXOffset, this.pointerScreenY + window.pageYOffset);
                if (edge) {
                    let now = $a4d9a0c10526343d$var$getTime();
                    this.handleSide(edge, (now - this.msSinceRequest) / 1000);
                    this.requestAnimation(now);
                } else this.isAnimating = false; // will stop animation
            }
        };
    }
}
/*
Monitors dragging on an element. Has a number of high-level features:
- minimum distance required before dragging
- minimum wait time ("delay") before dragging
- a mirror element that follows the pointer
*/ class $a4d9a0c10526343d$var$FeaturefulElementDragging extends (0, $200f5cce291452b2$export$60bb826a6acf3081) {
    destroy() {
        this.pointer.destroy();
        // HACK: simulate a pointer-up to end the current drag
        // TODO: fire 'dragend' directly and stop interaction. discourage use of pointerup event (b/c might not fire)
        this.onPointerUp({});
    }
    startDelay(ev) {
        if (typeof this.delay === "number") this.delayTimeoutId = setTimeout(()=>{
            this.delayTimeoutId = null;
            this.handleDelayEnd(ev);
        }, this.delay); // not assignable to number!
        else this.handleDelayEnd(ev);
    }
    handleDelayEnd(ev) {
        this.isDelayEnded = true;
        this.tryStartDrag(ev);
    }
    handleDistanceSurpassed(ev) {
        this.isDistanceSurpassed = true;
        this.tryStartDrag(ev);
    }
    tryStartDrag(ev) {
        if (this.isDelayEnded && this.isDistanceSurpassed) {
            if (!this.pointer.wasTouchScroll || this.touchScrollAllowed) {
                this.isDragging = true;
                this.mirrorNeedsRevert = false;
                this.autoScroller.start(ev.pageX, ev.pageY, this.containerEl);
                this.emitter.trigger("dragstart", ev);
                if (this.touchScrollAllowed === false) this.pointer.cancelTouchScroll();
            }
        }
    }
    tryStopDrag(ev) {
        // .stop() is ALWAYS asynchronous, which we NEED because we want all pointerup events
        // that come from the document to fire beforehand. much more convenient this way.
        this.mirror.stop(this.mirrorNeedsRevert, this.stopDrag.bind(this, ev));
    }
    stopDrag(ev) {
        this.isDragging = false;
        this.emitter.trigger("dragend", ev);
    }
    // fill in the implementations...
    setIgnoreMove(bool) {
        this.pointer.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        this.mirror.setIsVisible(bool);
    }
    setMirrorNeedsRevert(bool) {
        this.mirrorNeedsRevert = bool;
    }
    setAutoScrollEnabled(bool) {
        this.autoScroller.isEnabled = bool;
    }
    constructor(containerEl, selector){
        super(containerEl);
        this.containerEl = containerEl;
        // options that can be directly set by caller
        // the caller can also set the PointerDragging's options as well
        this.delay = null;
        this.minDistance = 0;
        this.touchScrollAllowed = true; // prevents drag from starting and blocks scrolling during drag
        this.mirrorNeedsRevert = false;
        this.isInteracting = false; // is the user validly moving the pointer? lasts until pointerup
        this.isDragging = false; // is it INTENTFULLY dragging? lasts until after revert animation
        this.isDelayEnded = false;
        this.isDistanceSurpassed = false;
        this.delayTimeoutId = null;
        this.onPointerDown = (ev)=>{
            if (!this.isDragging) {
                this.isInteracting = true;
                this.isDelayEnded = false;
                this.isDistanceSurpassed = false;
                (0, $200f5cce291452b2$export$d24c54395ce0c509)(document.body);
                (0, $200f5cce291452b2$export$493d36ec626b6698)(document.body);
                // prevent links from being visited if there's an eventual drag.
                // also prevents selection in older browsers (maybe?).
                // not necessary for touch, besides, browser would complain about passiveness.
                if (!ev.isTouch) ev.origEvent.preventDefault();
                this.emitter.trigger("pointerdown", ev);
                if (this.isInteracting && // not destroyed via pointerdown handler
                !this.pointer.shouldIgnoreMove) {
                    // actions related to initiating dragstart+dragmove+dragend...
                    this.mirror.setIsVisible(false); // reset. caller must set-visible
                    this.mirror.start(ev.subjectEl, ev.pageX, ev.pageY); // must happen on first pointer down
                    this.startDelay(ev);
                    if (!this.minDistance) this.handleDistanceSurpassed(ev);
                }
            }
        };
        this.onPointerMove = (ev)=>{
            if (this.isInteracting) {
                this.emitter.trigger("pointermove", ev);
                if (!this.isDistanceSurpassed) {
                    let minDistance = this.minDistance;
                    let distanceSq; // current distance from the origin, squared
                    let { deltaX: deltaX, deltaY: deltaY } = ev;
                    distanceSq = deltaX * deltaX + deltaY * deltaY;
                    if (distanceSq >= minDistance * minDistance) this.handleDistanceSurpassed(ev);
                }
                if (this.isDragging) {
                    // a real pointer move? (not one simulated by scrolling)
                    if (ev.origEvent.type !== "scroll") {
                        this.mirror.handleMove(ev.pageX, ev.pageY);
                        this.autoScroller.handleMove(ev.pageX, ev.pageY);
                    }
                    this.emitter.trigger("dragmove", ev);
                }
            }
        };
        this.onPointerUp = (ev)=>{
            if (this.isInteracting) {
                this.isInteracting = false;
                (0, $200f5cce291452b2$export$6554612db691658e)(document.body);
                (0, $200f5cce291452b2$export$1fbe638ecf81657e)(document.body);
                this.emitter.trigger("pointerup", ev); // can potentially set mirrorNeedsRevert
                if (this.isDragging) {
                    this.autoScroller.stop();
                    this.tryStopDrag(ev); // which will stop the mirror
                }
                if (this.delayTimeoutId) {
                    clearTimeout(this.delayTimeoutId);
                    this.delayTimeoutId = null;
                }
            }
        };
        let pointer = this.pointer = new $a4d9a0c10526343d$var$PointerDragging(containerEl);
        pointer.emitter.on("pointerdown", this.onPointerDown);
        pointer.emitter.on("pointermove", this.onPointerMove);
        pointer.emitter.on("pointerup", this.onPointerUp);
        if (selector) pointer.selector = selector;
        this.mirror = new $a4d9a0c10526343d$var$ElementMirror();
        this.autoScroller = new $a4d9a0c10526343d$var$AutoScroller();
    }
}
/*
When this class is instantiated, it records the offset of an element (relative to the document topleft),
and continues to monitor scrolling, updating the cached coordinates if it needs to.
Does not access the DOM after instantiation, so highly performant.

Also keeps track of all scrolling/overflow:hidden containers that are parents of the given element
and an determine if a given point is inside the combined clipping rectangle.
*/ class $a4d9a0c10526343d$var$OffsetTracker {
    destroy() {
        for (let scrollCache of this.scrollCaches)scrollCache.destroy();
    }
    computeLeft() {
        let left = this.origRect.left;
        for (let scrollCache of this.scrollCaches)left += scrollCache.origScrollLeft - scrollCache.getScrollLeft();
        return left;
    }
    computeTop() {
        let top = this.origRect.top;
        for (let scrollCache of this.scrollCaches)top += scrollCache.origScrollTop - scrollCache.getScrollTop();
        return top;
    }
    isWithinClipping(pageX, pageY) {
        let point = {
            left: pageX,
            top: pageY
        };
        for (let scrollCache of this.scrollCaches){
            if (!$a4d9a0c10526343d$var$isIgnoredClipping(scrollCache.getEventTarget()) && !(0, $200f5cce291452b2$export$cf2f7c5792f80b46)(point, scrollCache.clientRect)) return false;
        }
        return true;
    }
    constructor(el){
        this.origRect = (0, $200f5cce291452b2$export$c18d01048907ea92)(el);
        // will work fine for divs that have overflow:hidden
        this.scrollCaches = (0, $200f5cce291452b2$export$7a0bdf7d4a91ea88)(el).map((scrollEl)=>new $a4d9a0c10526343d$var$ElementScrollGeomCache(scrollEl, true));
    }
}
// certain clipping containers should never constrain interactions, like <html> and <body>
// https://github.com/fullcalendar/fullcalendar/issues/3615
function $a4d9a0c10526343d$var$isIgnoredClipping(node) {
    let tagName = node.tagName;
    return tagName === "HTML" || tagName === "BODY";
}
/*
Tracks movement over multiple droppable areas (aka "hits")
that exist in one or more DateComponents.
Relies on an existing draggable.

emits:
- pointerdown
- dragstart
- hitchange - fires initially, even if not over a hit
- pointerup
- (hitchange - again, to null, if ended over a hit)
- dragend
*/ class $a4d9a0c10526343d$var$HitDragging {
    // sets initialHit
    // sets coordAdjust
    processFirstCoord(ev) {
        let origPoint = {
            left: ev.pageX,
            top: ev.pageY
        };
        let adjustedPoint = origPoint;
        let subjectEl = ev.subjectEl;
        let subjectRect;
        if (subjectEl instanceof HTMLElement) {
            subjectRect = (0, $200f5cce291452b2$export$c18d01048907ea92)(subjectEl);
            adjustedPoint = (0, $200f5cce291452b2$export$53a70dd1ebbae346)(adjustedPoint, subjectRect);
        }
        let initialHit = this.initialHit = this.queryHitForOffset(adjustedPoint.left, adjustedPoint.top);
        if (initialHit) {
            if (this.useSubjectCenter && subjectRect) {
                let slicedSubjectRect = (0, $200f5cce291452b2$export$158acd800e1ef08b)(subjectRect, initialHit.rect);
                if (slicedSubjectRect) adjustedPoint = (0, $200f5cce291452b2$export$a33b77bbdbb8366c)(slicedSubjectRect);
            }
            this.coordAdjust = (0, $200f5cce291452b2$export$b9a6b53f9be3734)(adjustedPoint, origPoint);
        } else this.coordAdjust = {
            left: 0,
            top: 0
        };
    }
    handleMove(ev, forceHandle) {
        let hit = this.queryHitForOffset(ev.pageX + this.coordAdjust.left, ev.pageY + this.coordAdjust.top);
        if (forceHandle || !$a4d9a0c10526343d$var$isHitsEqual(this.movingHit, hit)) {
            this.movingHit = hit;
            this.emitter.trigger("hitupdate", hit, false, ev);
        }
    }
    prepareHits() {
        this.offsetTrackers = (0, $200f5cce291452b2$export$407448d2b89b1813)(this.droppableStore, (interactionSettings)=>{
            interactionSettings.component.prepareHits();
            return new $a4d9a0c10526343d$var$OffsetTracker(interactionSettings.el);
        });
    }
    releaseHits() {
        let { offsetTrackers: offsetTrackers } = this;
        for(let id in offsetTrackers)offsetTrackers[id].destroy();
        this.offsetTrackers = {};
    }
    queryHitForOffset(offsetLeft, offsetTop) {
        let { droppableStore: droppableStore, offsetTrackers: offsetTrackers } = this;
        let bestHit = null;
        for(let id in droppableStore){
            let component = droppableStore[id].component;
            let offsetTracker = offsetTrackers[id];
            if (offsetTracker && // wasn't destroyed mid-drag
            offsetTracker.isWithinClipping(offsetLeft, offsetTop)) {
                let originLeft = offsetTracker.computeLeft();
                let originTop = offsetTracker.computeTop();
                let positionLeft = offsetLeft - originLeft;
                let positionTop = offsetTop - originTop;
                let { origRect: origRect } = offsetTracker;
                let width = origRect.right - origRect.left;
                let height = origRect.bottom - origRect.top;
                if (// must be within the element's bounds
                positionLeft >= 0 && positionLeft < width && positionTop >= 0 && positionTop < height) {
                    let hit = component.queryHit(positionLeft, positionTop, width, height);
                    if (hit && // make sure the hit is within activeRange, meaning it's not a dead cell
                    (0, $200f5cce291452b2$export$4ae495d48253603d)(hit.dateProfile.activeRange, hit.dateSpan.range) && (!bestHit || hit.layer > bestHit.layer)) {
                        hit.componentId = id;
                        hit.context = component.context;
                        // TODO: better way to re-orient rectangle
                        hit.rect.left += originLeft;
                        hit.rect.right += originLeft;
                        hit.rect.top += originTop;
                        hit.rect.bottom += originTop;
                        bestHit = hit;
                    }
                }
            }
        }
        return bestHit;
    }
    constructor(dragging, droppableStore){
        // options that can be set by caller
        this.useSubjectCenter = false;
        this.requireInitial = true; // if doesn't start out on a hit, won't emit any events
        this.initialHit = null;
        this.movingHit = null;
        this.finalHit = null; // won't ever be populated if shouldIgnoreMove
        this.handlePointerDown = (ev)=>{
            let { dragging: dragging } = this;
            this.initialHit = null;
            this.movingHit = null;
            this.finalHit = null;
            this.prepareHits();
            this.processFirstCoord(ev);
            if (this.initialHit || !this.requireInitial) {
                dragging.setIgnoreMove(false);
                // TODO: fire this before computing processFirstCoord, so listeners can cancel. this gets fired by almost every handler :(
                this.emitter.trigger("pointerdown", ev);
            } else dragging.setIgnoreMove(true);
        };
        this.handleDragStart = (ev)=>{
            this.emitter.trigger("dragstart", ev);
            this.handleMove(ev, true); // force = fire even if initially null
        };
        this.handleDragMove = (ev)=>{
            this.emitter.trigger("dragmove", ev);
            this.handleMove(ev);
        };
        this.handlePointerUp = (ev)=>{
            this.releaseHits();
            this.emitter.trigger("pointerup", ev);
        };
        this.handleDragEnd = (ev)=>{
            if (this.movingHit) this.emitter.trigger("hitupdate", null, true, ev);
            this.finalHit = this.movingHit;
            this.movingHit = null;
            this.emitter.trigger("dragend", ev);
        };
        this.droppableStore = droppableStore;
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        dragging.emitter.on("dragmove", this.handleDragMove);
        dragging.emitter.on("pointerup", this.handlePointerUp);
        dragging.emitter.on("dragend", this.handleDragEnd);
        this.dragging = dragging;
        this.emitter = new (0, $200f5cce291452b2$export$d66501df72047452)();
    }
}
function $a4d9a0c10526343d$var$isHitsEqual(hit0, hit1) {
    if (!hit0 && !hit1) return true;
    if (Boolean(hit0) !== Boolean(hit1)) return false;
    return (0, $200f5cce291452b2$export$151db275011178c4)(hit0.dateSpan, hit1.dateSpan);
}
function $a4d9a0c10526343d$var$buildDatePointApiWithContext(dateSpan, context) {
    let props = {};
    for (let transform of context.pluginHooks.datePointTransforms)Object.assign(props, transform(dateSpan, context));
    Object.assign(props, $a4d9a0c10526343d$var$buildDatePointApi(dateSpan, context.dateEnv));
    return props;
}
function $a4d9a0c10526343d$var$buildDatePointApi(span, dateEnv) {
    return {
        date: dateEnv.toDate(span.range.start),
        dateStr: dateEnv.formatIso(span.range.start, {
            omitTime: span.allDay
        }),
        allDay: span.allDay
    };
}
/*
Monitors when the user clicks on a specific date/time of a component.
A pointerdown+pointerup on the same "hit" constitutes a click.
*/ class $a4d9a0c10526343d$var$DateClicking extends (0, $200f5cce291452b2$export$dc98b0b04f4c7758) {
    destroy() {
        this.dragging.destroy();
    }
    constructor(settings){
        super(settings);
        this.handlePointerDown = (pev)=>{
            let { dragging: dragging } = this;
            let downEl = pev.origEvent.target;
            // do this in pointerdown (not dragend) because DOM might be mutated by the time dragend is fired
            dragging.setIgnoreMove(!this.component.isValidDateDownEl(downEl));
        };
        // won't even fire if moving was ignored
        this.handleDragEnd = (ev)=>{
            let { component: component } = this;
            let { pointer: pointer } = this.dragging;
            if (!pointer.wasTouchScroll) {
                let { initialHit: initialHit, finalHit: finalHit } = this.hitDragging;
                if (initialHit && finalHit && $a4d9a0c10526343d$var$isHitsEqual(initialHit, finalHit)) {
                    let { context: context } = component;
                    let arg = Object.assign(Object.assign({}, $a4d9a0c10526343d$var$buildDatePointApiWithContext(initialHit.dateSpan, context)), {
                        dayEl: initialHit.dayEl,
                        jsEvent: ev.origEvent,
                        view: context.viewApi || context.calendarApi.view
                    });
                    context.emitter.trigger("dateClick", arg);
                }
            }
        };
        // we DO want to watch pointer moves because otherwise finalHit won't get populated
        this.dragging = new $a4d9a0c10526343d$var$FeaturefulElementDragging(settings.el);
        this.dragging.autoScroller.isEnabled = false;
        let hitDragging = this.hitDragging = new $a4d9a0c10526343d$var$HitDragging(this.dragging, (0, $200f5cce291452b2$export$aff10ba49ece4b91)(settings));
        hitDragging.emitter.on("pointerdown", this.handlePointerDown);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
    }
}
/*
Tracks when the user selects a portion of time of a component,
constituted by a drag over date cells, with a possible delay at the beginning of the drag.
*/ class $a4d9a0c10526343d$var$DateSelecting extends (0, $200f5cce291452b2$export$dc98b0b04f4c7758) {
    destroy() {
        this.dragging.destroy();
    }
    constructor(settings){
        super(settings);
        this.dragSelection = null;
        this.handlePointerDown = (ev)=>{
            let { component: component, dragging: dragging } = this;
            let { options: options } = component.context;
            let canSelect = options.selectable && component.isValidDateDownEl(ev.origEvent.target);
            // don't bother to watch expensive moves if component won't do selection
            dragging.setIgnoreMove(!canSelect);
            // if touch, require user to hold down
            dragging.delay = ev.isTouch ? $a4d9a0c10526343d$var$getComponentTouchDelay$1(component) : null;
        };
        this.handleDragStart = (ev)=>{
            this.component.context.calendarApi.unselect(ev); // unselect previous selections
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            let { context: context } = this.component;
            let dragSelection = null;
            let isInvalid = false;
            if (hit) {
                let initialHit = this.hitDragging.initialHit;
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) dragSelection = $a4d9a0c10526343d$var$joinHitsIntoSelection(initialHit, hit, context.pluginHooks.dateSelectionTransformers);
                if (!dragSelection || !(0, $200f5cce291452b2$export$c69d65aa55814164)(dragSelection, hit.dateProfile, context)) {
                    isInvalid = true;
                    dragSelection = null;
                }
            }
            if (dragSelection) context.dispatch({
                type: "SELECT_DATES",
                selection: dragSelection
            });
            else if (!isFinal) context.dispatch({
                type: "UNSELECT_DATES"
            });
            if (!isInvalid) (0, $200f5cce291452b2$export$92108d983e8ee699)();
            else (0, $200f5cce291452b2$export$9fa96a7d116ea3ce)();
            if (!isFinal) this.dragSelection = dragSelection; // only clear if moved away from all hits while dragging
        };
        this.handlePointerUp = (pev)=>{
            if (this.dragSelection) {
                // selection is already rendered, so just need to report selection
                (0, $200f5cce291452b2$export$9ddbdd0bfc5623a)(this.dragSelection, pev, this.component.context);
                this.dragSelection = null;
            }
        };
        let { component: component } = settings;
        let { options: options } = component.context;
        let dragging = this.dragging = new $a4d9a0c10526343d$var$FeaturefulElementDragging(settings.el);
        dragging.touchScrollAllowed = false;
        dragging.minDistance = options.selectMinDistance || 0;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new $a4d9a0c10526343d$var$HitDragging(this.dragging, (0, $200f5cce291452b2$export$aff10ba49ece4b91)(settings));
        hitDragging.emitter.on("pointerdown", this.handlePointerDown);
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", this.handlePointerUp);
    }
}
function $a4d9a0c10526343d$var$getComponentTouchDelay$1(component) {
    let { options: options } = component.context;
    let delay = options.selectLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
function $a4d9a0c10526343d$var$joinHitsIntoSelection(hit0, hit1, dateSelectionTransformers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let ms = [
        dateSpan0.range.start,
        dateSpan0.range.end,
        dateSpan1.range.start,
        dateSpan1.range.end
    ];
    ms.sort((0, $200f5cce291452b2$export$d66dc83d8cfc8dd));
    let props = {};
    for (let transformer of dateSelectionTransformers){
        let res = transformer(hit0, hit1);
        if (res === false) return null;
        if (res) Object.assign(props, res);
    }
    props.range = {
        start: ms[0],
        end: ms[3]
    };
    props.allDay = dateSpan0.allDay;
    return props;
}
class $a4d9a0c10526343d$var$EventDragging extends (0, $200f5cce291452b2$export$dc98b0b04f4c7758) {
    destroy() {
        this.dragging.destroy();
    }
    // render a drag state on the next receivingCalendar
    displayDrag(nextContext, state) {
        let initialContext = this.component.context;
        let prevContext = this.receivingContext;
        // does the previous calendar need to be cleared?
        if (prevContext && prevContext !== nextContext) {
            // does the initial calendar need to be cleared?
            // if so, don't clear all the way. we still need to to hide the affectedEvents
            if (prevContext === initialContext) prevContext.dispatch({
                type: "SET_EVENT_DRAG",
                state: {
                    affectedEvents: state.affectedEvents,
                    mutatedEvents: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
                    isEvent: true
                }
            });
            else prevContext.dispatch({
                type: "UNSET_EVENT_DRAG"
            });
        }
        if (nextContext) nextContext.dispatch({
            type: "SET_EVENT_DRAG",
            state: state
        });
    }
    clearDrag() {
        let initialCalendar = this.component.context;
        let { receivingContext: receivingContext } = this;
        if (receivingContext) receivingContext.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
        // the initial calendar might have an dummy drag state from displayDrag
        if (initialCalendar !== receivingContext) initialCalendar.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
    }
    cleanup() {
        this.subjectSeg = null;
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null;
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
    }
    constructor(settings){
        super(settings);
        // internal state
        this.subjectEl = null;
        this.subjectSeg = null; // the seg being selected/dragged
        this.isDragging = false;
        this.eventRange = null;
        this.relevantEvents = null; // the events being dragged
        this.receivingContext = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let origTarget = ev.origEvent.target;
            let { component: component, dragging: dragging } = this;
            let { mirror: mirror } = dragging;
            let { options: options } = component.context;
            let initialContext = component.context;
            this.subjectEl = ev.subjectEl;
            let subjectSeg = this.subjectSeg = (0, $200f5cce291452b2$export$71511d61b312f219)(ev.subjectEl);
            let eventRange = this.eventRange = subjectSeg.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            this.relevantEvents = (0, $200f5cce291452b2$export$1ee57be6f6687d2c)(initialContext.getCurrentData().eventStore, eventInstanceId);
            dragging.minDistance = ev.isTouch ? 0 : options.eventDragMinDistance;
            dragging.delay = // only do a touch delay if touch and this event hasn't been selected yet
            ev.isTouch && eventInstanceId !== component.props.eventSelection ? $a4d9a0c10526343d$var$getComponentTouchDelay(component) : null;
            if (options.fixedMirrorParent) mirror.parentNode = options.fixedMirrorParent;
            else mirror.parentNode = (0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(origTarget, ".fc");
            mirror.revertDuration = options.dragRevertDuration;
            let isValid = component.isValidSegDownEl(origTarget) && !(0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(origTarget, ".fc-event-resizer"); // NOT on a resizer
            dragging.setIgnoreMove(!isValid);
            // disable dragging for elements that are resizable (ie, selectable)
            // but are not draggable
            this.isDragging = isValid && ev.subjectEl.classList.contains("fc-event-draggable");
        };
        this.handleDragStart = (ev)=>{
            let initialContext = this.component.context;
            let eventRange = this.eventRange;
            let eventInstanceId = eventRange.instance.instanceId;
            if (ev.isTouch) // need to select a different event?
            {
                if (eventInstanceId !== this.component.props.eventSelection) initialContext.dispatch({
                    type: "SELECT_EVENT",
                    eventInstanceId: eventInstanceId
                });
            } else // if now using mouse, but was previous touch interaction, clear selected event
            initialContext.dispatch({
                type: "UNSELECT_EVENT"
            });
            if (this.isDragging) {
                initialContext.calendarApi.unselect(ev); // unselect *date* selection
                initialContext.emitter.trigger("eventDragStart", {
                    el: this.subjectEl,
                    event: new (0, $200f5cce291452b2$export$34aec0b863436764)(initialContext, eventRange.def, eventRange.instance),
                    jsEvent: ev.origEvent,
                    view: initialContext.viewApi
                });
            }
        };
        this.handleHitUpdate = (hit, isFinal)=>{
            if (!this.isDragging) return;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let initialContext = this.component.context;
            // states based on new hit
            let receivingContext = null;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
                isEvent: true
            };
            if (hit) {
                receivingContext = hit.context;
                let receivingOptions = receivingContext.options;
                if (initialContext === receivingContext || receivingOptions.editable && receivingOptions.droppable) {
                    mutation = $a4d9a0c10526343d$var$computeEventMutation(initialHit, hit, receivingContext.getCurrentData().pluginHooks.eventDragMutationMassagers);
                    if (mutation) {
                        mutatedRelevantEvents = (0, $200f5cce291452b2$export$6d1e945284085e64)(relevantEvents, receivingContext.getCurrentData().eventUiBases, mutation, receivingContext);
                        interaction.mutatedEvents = mutatedRelevantEvents;
                        if (!(0, $200f5cce291452b2$export$c667925124dac624)(interaction, hit.dateProfile, receivingContext)) {
                            isInvalid = true;
                            mutation = null;
                            mutatedRelevantEvents = null;
                            interaction.mutatedEvents = (0, $200f5cce291452b2$export$9bb611d729802a56)();
                        }
                    }
                } else receivingContext = null;
            }
            this.displayDrag(receivingContext, interaction);
            if (!isInvalid) (0, $200f5cce291452b2$export$92108d983e8ee699)();
            else (0, $200f5cce291452b2$export$9fa96a7d116ea3ce)();
            if (!isFinal) {
                if (initialContext === receivingContext && // TODO: write test for this
                $a4d9a0c10526343d$var$isHitsEqual(initialHit, hit)) mutation = null;
                this.dragging.setMirrorNeedsRevert(!mutation);
                // render the mirror if no already-rendered mirror
                // TODO: wish we could somehow wait for dispatch to guarantee render
                this.dragging.setMirrorIsVisible(!hit || !this.subjectEl.getRootNode().querySelector(".fc-event-mirror"));
                // assign states based on new hit
                this.receivingContext = receivingContext;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handlePointerUp = ()=>{
            if (!this.isDragging) this.cleanup(); // because handleDragEnd won't fire
        };
        this.handleDragEnd = (ev)=>{
            if (this.isDragging) {
                let initialContext = this.component.context;
                let initialView = initialContext.viewApi;
                let { receivingContext: receivingContext, validMutation: validMutation } = this;
                let eventDef = this.eventRange.def;
                let eventInstance = this.eventRange.instance;
                let eventApi = new (0, $200f5cce291452b2$export$34aec0b863436764)(initialContext, eventDef, eventInstance);
                let relevantEvents = this.relevantEvents;
                let mutatedRelevantEvents = this.mutatedRelevantEvents;
                let { finalHit: finalHit } = this.hitDragging;
                this.clearDrag(); // must happen after revert animation
                initialContext.emitter.trigger("eventDragStop", {
                    el: this.subjectEl,
                    event: eventApi,
                    jsEvent: ev.origEvent,
                    view: initialView
                });
                if (validMutation) {
                    // dropped within same calendar
                    if (receivingContext === initialContext) {
                        let updatedEventApi = new (0, $200f5cce291452b2$export$34aec0b863436764)(initialContext, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                        initialContext.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents
                        });
                        let eventChangeArg = {
                            oldEvent: eventApi,
                            event: updatedEventApi,
                            relatedEvents: (0, $200f5cce291452b2$export$efccba1c4a2ef57b)(mutatedRelevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        let transformed = {};
                        for (let transformer of initialContext.getCurrentData().pluginHooks.eventDropTransformers)Object.assign(transformed, transformer(validMutation, initialContext));
                        initialContext.emitter.trigger("eventDrop", Object.assign(Object.assign(Object.assign({}, eventChangeArg), transformed), {
                            el: ev.subjectEl,
                            delta: validMutation.datesDelta,
                            jsEvent: ev.origEvent,
                            view: initialView
                        }));
                        initialContext.emitter.trigger("eventChange", eventChangeArg);
                    // dropped in different calendar
                    } else if (receivingContext) {
                        let eventRemoveArg = {
                            event: eventApi,
                            relatedEvents: (0, $200f5cce291452b2$export$efccba1c4a2ef57b)(relevantEvents, initialContext, eventInstance),
                            revert () {
                                initialContext.dispatch({
                                    type: "MERGE_EVENTS",
                                    eventStore: relevantEvents
                                });
                            }
                        };
                        initialContext.emitter.trigger("eventLeave", Object.assign(Object.assign({}, eventRemoveArg), {
                            draggedEl: ev.subjectEl,
                            view: initialView
                        }));
                        initialContext.dispatch({
                            type: "REMOVE_EVENTS",
                            eventStore: relevantEvents
                        });
                        initialContext.emitter.trigger("eventRemove", eventRemoveArg);
                        let addedEventDef = mutatedRelevantEvents.defs[eventDef.defId];
                        let addedEventInstance = mutatedRelevantEvents.instances[eventInstance.instanceId];
                        let addedEventApi = new (0, $200f5cce291452b2$export$34aec0b863436764)(receivingContext, addedEventDef, addedEventInstance);
                        receivingContext.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: mutatedRelevantEvents
                        });
                        let eventAddArg = {
                            event: addedEventApi,
                            relatedEvents: (0, $200f5cce291452b2$export$efccba1c4a2ef57b)(mutatedRelevantEvents, receivingContext, addedEventInstance),
                            revert () {
                                receivingContext.dispatch({
                                    type: "REMOVE_EVENTS",
                                    eventStore: mutatedRelevantEvents
                                });
                            }
                        };
                        receivingContext.emitter.trigger("eventAdd", eventAddArg);
                        if (ev.isTouch) receivingContext.dispatch({
                            type: "SELECT_EVENT",
                            eventInstanceId: eventInstance.instanceId
                        });
                        receivingContext.emitter.trigger("drop", Object.assign(Object.assign({}, $a4d9a0c10526343d$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                            draggedEl: ev.subjectEl,
                            jsEvent: ev.origEvent,
                            view: finalHit.context.viewApi
                        }));
                        receivingContext.emitter.trigger("eventReceive", Object.assign(Object.assign({}, eventAddArg), {
                            draggedEl: ev.subjectEl,
                            view: finalHit.context.viewApi
                        }));
                    }
                } else initialContext.emitter.trigger("_noEventDrop");
            }
            this.cleanup();
        };
        let { component: component } = this;
        let { options: options } = component.context;
        let dragging = this.dragging = new $a4d9a0c10526343d$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = $a4d9a0c10526343d$var$EventDragging.SELECTOR;
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = options.dragScroll;
        let hitDragging = this.hitDragging = new $a4d9a0c10526343d$var$HitDragging(this.dragging, (0, $200f5cce291452b2$export$a93c5207d687da10));
        hitDragging.useSubjectCenter = settings.useEventCenter;
        hitDragging.emitter.on("pointerdown", this.handlePointerDown);
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("pointerup", this.handlePointerUp);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
    }
}
// TODO: test this in IE11
// QUESTION: why do we need it on the resizable???
$a4d9a0c10526343d$var$EventDragging.SELECTOR = ".fc-event-draggable, .fc-event-resizable";
function $a4d9a0c10526343d$var$computeEventMutation(hit0, hit1, massagers) {
    let dateSpan0 = hit0.dateSpan;
    let dateSpan1 = hit1.dateSpan;
    let date0 = dateSpan0.range.start;
    let date1 = dateSpan1.range.start;
    let standardProps = {};
    if (dateSpan0.allDay !== dateSpan1.allDay) {
        standardProps.allDay = dateSpan1.allDay;
        standardProps.hasEnd = hit1.context.options.allDayMaintainDuration;
        if (dateSpan1.allDay) // means date1 is already start-of-day,
        // but date0 needs to be converted
        date0 = (0, $200f5cce291452b2$export$9e5f44173e64f162)(date0);
    }
    let delta = (0, $200f5cce291452b2$export$91c6e00c14e7e6fd)(date0, date1, hit0.context.dateEnv, hit0.componentId === hit1.componentId ? hit0.largeUnit : null);
    if (delta.milliseconds) standardProps.allDay = false;
    let mutation = {
        datesDelta: delta,
        standardProps: standardProps
    };
    for (let massager of massagers)massager(mutation, hit0, hit1);
    return mutation;
}
function $a4d9a0c10526343d$var$getComponentTouchDelay(component) {
    let { options: options } = component.context;
    let delay = options.eventLongPressDelay;
    if (delay == null) delay = options.longPressDelay;
    return delay;
}
class $a4d9a0c10526343d$var$EventResizing extends (0, $200f5cce291452b2$export$dc98b0b04f4c7758) {
    destroy() {
        this.dragging.destroy();
    }
    querySegEl(ev) {
        return (0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(ev.subjectEl, ".fc-event");
    }
    constructor(settings){
        super(settings);
        // internal state
        this.draggingSegEl = null;
        this.draggingSeg = null; // TODO: rename to resizingSeg? subjectSeg?
        this.eventRange = null;
        this.relevantEvents = null;
        this.validMutation = null;
        this.mutatedRelevantEvents = null;
        this.handlePointerDown = (ev)=>{
            let { component: component } = this;
            let segEl = this.querySegEl(ev);
            let seg = (0, $200f5cce291452b2$export$71511d61b312f219)(segEl);
            let eventRange = this.eventRange = seg.eventRange;
            this.dragging.minDistance = component.context.options.eventDragMinDistance;
            // if touch, need to be working with a selected event
            this.dragging.setIgnoreMove(!this.component.isValidSegDownEl(ev.origEvent.target) || ev.isTouch && this.component.props.eventSelection !== eventRange.instance.instanceId);
        };
        this.handleDragStart = (ev)=>{
            let { context: context } = this.component;
            let eventRange = this.eventRange;
            this.relevantEvents = (0, $200f5cce291452b2$export$1ee57be6f6687d2c)(context.getCurrentData().eventStore, this.eventRange.instance.instanceId);
            let segEl = this.querySegEl(ev);
            this.draggingSegEl = segEl;
            this.draggingSeg = (0, $200f5cce291452b2$export$71511d61b312f219)(segEl);
            context.calendarApi.unselect();
            context.emitter.trigger("eventResizeStart", {
                el: segEl,
                event: new (0, $200f5cce291452b2$export$34aec0b863436764)(context, eventRange.def, eventRange.instance),
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { context: context } = this.component;
            let relevantEvents = this.relevantEvents;
            let initialHit = this.hitDragging.initialHit;
            let eventInstance = this.eventRange.instance;
            let mutation = null;
            let mutatedRelevantEvents = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: relevantEvents,
                mutatedEvents: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
                isEvent: true
            };
            if (hit) {
                let disallowed = hit.componentId === initialHit.componentId && this.isHitComboAllowed && !this.isHitComboAllowed(initialHit, hit);
                if (!disallowed) mutation = $a4d9a0c10526343d$var$computeMutation(initialHit, hit, ev.subjectEl.classList.contains("fc-event-resizer-start"), eventInstance.range);
            }
            if (mutation) {
                mutatedRelevantEvents = (0, $200f5cce291452b2$export$6d1e945284085e64)(relevantEvents, context.getCurrentData().eventUiBases, mutation, context);
                interaction.mutatedEvents = mutatedRelevantEvents;
                if (!(0, $200f5cce291452b2$export$c667925124dac624)(interaction, hit.dateProfile, context)) {
                    isInvalid = true;
                    mutation = null;
                    mutatedRelevantEvents = null;
                    interaction.mutatedEvents = null;
                }
            }
            if (mutatedRelevantEvents) context.dispatch({
                type: "SET_EVENT_RESIZE",
                state: interaction
            });
            else context.dispatch({
                type: "UNSET_EVENT_RESIZE"
            });
            if (!isInvalid) (0, $200f5cce291452b2$export$92108d983e8ee699)();
            else (0, $200f5cce291452b2$export$9fa96a7d116ea3ce)();
            if (!isFinal) {
                if (mutation && $a4d9a0c10526343d$var$isHitsEqual(initialHit, hit)) mutation = null;
                this.validMutation = mutation;
                this.mutatedRelevantEvents = mutatedRelevantEvents;
            }
        };
        this.handleDragEnd = (ev)=>{
            let { context: context } = this.component;
            let eventDef = this.eventRange.def;
            let eventInstance = this.eventRange.instance;
            let eventApi = new (0, $200f5cce291452b2$export$34aec0b863436764)(context, eventDef, eventInstance);
            let relevantEvents = this.relevantEvents;
            let mutatedRelevantEvents = this.mutatedRelevantEvents;
            context.emitter.trigger("eventResizeStop", {
                el: this.draggingSegEl,
                event: eventApi,
                jsEvent: ev.origEvent,
                view: context.viewApi
            });
            if (this.validMutation) {
                let updatedEventApi = new (0, $200f5cce291452b2$export$34aec0b863436764)(context, mutatedRelevantEvents.defs[eventDef.defId], eventInstance ? mutatedRelevantEvents.instances[eventInstance.instanceId] : null);
                context.dispatch({
                    type: "MERGE_EVENTS",
                    eventStore: mutatedRelevantEvents
                });
                let eventChangeArg = {
                    oldEvent: eventApi,
                    event: updatedEventApi,
                    relatedEvents: (0, $200f5cce291452b2$export$efccba1c4a2ef57b)(mutatedRelevantEvents, context, eventInstance),
                    revert () {
                        context.dispatch({
                            type: "MERGE_EVENTS",
                            eventStore: relevantEvents
                        });
                    }
                };
                context.emitter.trigger("eventResize", Object.assign(Object.assign({}, eventChangeArg), {
                    el: this.draggingSegEl,
                    startDelta: this.validMutation.startDelta || (0, $200f5cce291452b2$export$4368d992c4eafac0)(0),
                    endDelta: this.validMutation.endDelta || (0, $200f5cce291452b2$export$4368d992c4eafac0)(0),
                    jsEvent: ev.origEvent,
                    view: context.viewApi
                }));
                context.emitter.trigger("eventChange", eventChangeArg);
            } else context.emitter.trigger("_noEventResize");
            // reset all internal state
            this.draggingSeg = null;
            this.relevantEvents = null;
            this.validMutation = null;
        // okay to keep eventInstance around. useful to set it in handlePointerDown
        };
        let { component: component } = settings;
        let dragging = this.dragging = new $a4d9a0c10526343d$var$FeaturefulElementDragging(settings.el);
        dragging.pointer.selector = ".fc-event-resizer";
        dragging.touchScrollAllowed = false;
        dragging.autoScroller.isEnabled = component.context.options.dragScroll;
        let hitDragging = this.hitDragging = new $a4d9a0c10526343d$var$HitDragging(this.dragging, (0, $200f5cce291452b2$export$aff10ba49ece4b91)(settings));
        hitDragging.emitter.on("pointerdown", this.handlePointerDown);
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
    }
}
function $a4d9a0c10526343d$var$computeMutation(hit0, hit1, isFromStart, instanceRange) {
    let dateEnv = hit0.context.dateEnv;
    let date0 = hit0.dateSpan.range.start;
    let date1 = hit1.dateSpan.range.start;
    let delta = (0, $200f5cce291452b2$export$91c6e00c14e7e6fd)(date0, date1, dateEnv, hit0.largeUnit);
    if (isFromStart) {
        if (dateEnv.add(instanceRange.start, delta) < instanceRange.end) return {
            startDelta: delta
        };
    } else if (dateEnv.add(instanceRange.end, delta) > instanceRange.start) return {
        endDelta: delta
    };
    return null;
}
class $a4d9a0c10526343d$var$UnselectAuto {
    destroy() {
        this.context.emitter.off("select", this.onSelect);
        this.documentPointer.destroy();
    }
    constructor(context){
        this.context = context;
        this.isRecentPointerDateSelect = false; // wish we could use a selector to detect date selection, but uses hit system
        this.matchesCancel = false;
        this.matchesEvent = false;
        this.onSelect = (selectInfo)=>{
            if (selectInfo.jsEvent) this.isRecentPointerDateSelect = true;
        };
        this.onDocumentPointerDown = (pev)=>{
            let unselectCancel = this.context.options.unselectCancel;
            let downEl = (0, $200f5cce291452b2$export$738ab4df8bf92ae9)(pev.origEvent);
            this.matchesCancel = !!(0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(downEl, unselectCancel);
            this.matchesEvent = !!(0, $200f5cce291452b2$export$3d8c2f653ac9d0b9)(downEl, $a4d9a0c10526343d$var$EventDragging.SELECTOR); // interaction started on an event?
        };
        this.onDocumentPointerUp = (pev)=>{
            let { context: context } = this;
            let { documentPointer: documentPointer } = this;
            let calendarState = context.getCurrentData();
            // touch-scrolling should never unfocus any type of selection
            if (!documentPointer.wasTouchScroll) {
                if (calendarState.dateSelection && // an existing date selection?
                !this.isRecentPointerDateSelect // a new pointer-initiated date selection since last onDocumentPointerUp?
                ) {
                    let unselectAuto = context.options.unselectAuto;
                    if (unselectAuto && (!unselectAuto || !this.matchesCancel)) context.calendarApi.unselect(pev);
                }
                if (calendarState.eventSelection && // an existing event selected?
                !this.matchesEvent // interaction DIDN'T start on an event
                ) context.dispatch({
                    type: "UNSELECT_EVENT"
                });
            }
            this.isRecentPointerDateSelect = false;
        };
        let documentPointer = this.documentPointer = new $a4d9a0c10526343d$var$PointerDragging(document);
        documentPointer.shouldIgnoreMove = true;
        documentPointer.shouldWatchScroll = false;
        documentPointer.emitter.on("pointerdown", this.onDocumentPointerDown);
        documentPointer.emitter.on("pointerup", this.onDocumentPointerUp);
        /*
        TODO: better way to know about whether there was a selection with the pointer
        */ context.emitter.on("select", this.onSelect);
    }
}
const $a4d9a0c10526343d$var$OPTION_REFINERS = {
    fixedMirrorParent: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5)
};
const $a4d9a0c10526343d$var$LISTENER_REFINERS = {
    dateClick: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventDragStart: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventDragStop: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventDrop: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventResizeStart: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventResizeStop: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventResize: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    drop: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventReceive: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5),
    eventLeave: (0, $200f5cce291452b2$export$7ccc53e8f1e7dfc5)
};
/*
Given an already instantiated draggable object for one-or-more elements,
Interprets any dragging as an attempt to drag an events that lives outside
of a calendar onto a calendar.
*/ class $a4d9a0c10526343d$var$ExternalElementDragging {
    buildDragMeta(subjectEl) {
        if (typeof this.suppliedDragMeta === "object") return (0, $200f5cce291452b2$export$1abb261478089fe6)(this.suppliedDragMeta);
        if (typeof this.suppliedDragMeta === "function") return (0, $200f5cce291452b2$export$1abb261478089fe6)(this.suppliedDragMeta(subjectEl));
        return $a4d9a0c10526343d$var$getDragMetaFromEl(subjectEl);
    }
    displayDrag(nextContext, state) {
        let prevContext = this.receivingContext;
        if (prevContext && prevContext !== nextContext) prevContext.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
        if (nextContext) nextContext.dispatch({
            type: "SET_EVENT_DRAG",
            state: state
        });
    }
    clearDrag() {
        if (this.receivingContext) this.receivingContext.dispatch({
            type: "UNSET_EVENT_DRAG"
        });
    }
    canDropElOnCalendar(el, receivingContext) {
        let dropAccept = receivingContext.options.dropAccept;
        if (typeof dropAccept === "function") return dropAccept.call(receivingContext.calendarApi, el);
        if (typeof dropAccept === "string" && dropAccept) return Boolean((0, $200f5cce291452b2$export$f96d196f7728bb5)(el, dropAccept));
        return true;
    }
    constructor(dragging, suppliedDragMeta){
        this.receivingContext = null;
        this.droppableEvent = null; // will exist for all drags, even if create:false
        this.suppliedDragMeta = null;
        this.dragMeta = null;
        this.handleDragStart = (ev)=>{
            this.dragMeta = this.buildDragMeta(ev.subjectEl);
        };
        this.handleHitUpdate = (hit, isFinal, ev)=>{
            let { dragging: dragging } = this.hitDragging;
            let receivingContext = null;
            let droppableEvent = null;
            let isInvalid = false;
            let interaction = {
                affectedEvents: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
                mutatedEvents: (0, $200f5cce291452b2$export$9bb611d729802a56)(),
                isEvent: this.dragMeta.create
            };
            if (hit) {
                receivingContext = hit.context;
                if (this.canDropElOnCalendar(ev.subjectEl, receivingContext)) {
                    droppableEvent = $a4d9a0c10526343d$var$computeEventForDateSpan(hit.dateSpan, this.dragMeta, receivingContext);
                    interaction.mutatedEvents = (0, $200f5cce291452b2$export$9d0e2d13d04f7070)(droppableEvent);
                    isInvalid = !(0, $200f5cce291452b2$export$c667925124dac624)(interaction, hit.dateProfile, receivingContext);
                    if (isInvalid) {
                        interaction.mutatedEvents = (0, $200f5cce291452b2$export$9bb611d729802a56)();
                        droppableEvent = null;
                    }
                }
            }
            this.displayDrag(receivingContext, interaction);
            // show mirror if no already-rendered mirror element OR if we are shutting down the mirror (?)
            // TODO: wish we could somehow wait for dispatch to guarantee render
            dragging.setMirrorIsVisible(isFinal || !droppableEvent || !document.querySelector(".fc-event-mirror"));
            if (!isInvalid) (0, $200f5cce291452b2$export$92108d983e8ee699)();
            else (0, $200f5cce291452b2$export$9fa96a7d116ea3ce)();
            if (!isFinal) {
                dragging.setMirrorNeedsRevert(!droppableEvent);
                this.receivingContext = receivingContext;
                this.droppableEvent = droppableEvent;
            }
        };
        this.handleDragEnd = (pev)=>{
            let { receivingContext: receivingContext, droppableEvent: droppableEvent } = this;
            this.clearDrag();
            if (receivingContext && droppableEvent) {
                let finalHit = this.hitDragging.finalHit;
                let finalView = finalHit.context.viewApi;
                let dragMeta = this.dragMeta;
                receivingContext.emitter.trigger("drop", Object.assign(Object.assign({}, $a4d9a0c10526343d$var$buildDatePointApiWithContext(finalHit.dateSpan, receivingContext)), {
                    draggedEl: pev.subjectEl,
                    jsEvent: pev.origEvent,
                    view: finalView
                }));
                if (dragMeta.create) {
                    let addingEvents = (0, $200f5cce291452b2$export$9d0e2d13d04f7070)(droppableEvent);
                    receivingContext.dispatch({
                        type: "MERGE_EVENTS",
                        eventStore: addingEvents
                    });
                    if (pev.isTouch) receivingContext.dispatch({
                        type: "SELECT_EVENT",
                        eventInstanceId: droppableEvent.instance.instanceId
                    });
                    // signal that an external event landed
                    receivingContext.emitter.trigger("eventReceive", {
                        event: new (0, $200f5cce291452b2$export$34aec0b863436764)(receivingContext, droppableEvent.def, droppableEvent.instance),
                        relatedEvents: [],
                        revert () {
                            receivingContext.dispatch({
                                type: "REMOVE_EVENTS",
                                eventStore: addingEvents
                            });
                        },
                        draggedEl: pev.subjectEl,
                        view: finalView
                    });
                }
            }
            this.receivingContext = null;
            this.droppableEvent = null;
        };
        let hitDragging = this.hitDragging = new $a4d9a0c10526343d$var$HitDragging(dragging, (0, $200f5cce291452b2$export$a93c5207d687da10));
        hitDragging.requireInitial = false; // will start outside of a component
        hitDragging.emitter.on("dragstart", this.handleDragStart);
        hitDragging.emitter.on("hitupdate", this.handleHitUpdate);
        hitDragging.emitter.on("dragend", this.handleDragEnd);
        this.suppliedDragMeta = suppliedDragMeta;
    }
}
// Utils for computing event store from the DragMeta
// ----------------------------------------------------------------------------------------------------
function $a4d9a0c10526343d$var$computeEventForDateSpan(dateSpan, dragMeta, context) {
    let defProps = Object.assign({}, dragMeta.leftoverProps);
    for (let transform of context.pluginHooks.externalDefTransforms)Object.assign(defProps, transform(dateSpan, dragMeta));
    let { refined: refined, extra: extra } = (0, $200f5cce291452b2$export$ab83b03e4111b1d0)(defProps, context);
    let def = (0, $200f5cce291452b2$export$21579262ef46735b)(refined, extra, dragMeta.sourceId, dateSpan.allDay, context.options.forceEventDuration || Boolean(dragMeta.duration), context);
    let start = dateSpan.range.start;
    // only rely on time info if drop zone is all-day,
    // otherwise, we already know the time
    if (dateSpan.allDay && dragMeta.startTime) start = context.dateEnv.add(start, dragMeta.startTime);
    let end = dragMeta.duration ? context.dateEnv.add(start, dragMeta.duration) : (0, $200f5cce291452b2$export$1776704b6532a19a)(dateSpan.allDay, start, context);
    let instance = (0, $200f5cce291452b2$export$3b513254972cfc9c)(def.defId, {
        start: start,
        end: end
    });
    return {
        def: def,
        instance: instance
    };
}
// Utils for extracting data from element
// ----------------------------------------------------------------------------------------------------
function $a4d9a0c10526343d$var$getDragMetaFromEl(el) {
    let str = $a4d9a0c10526343d$var$getEmbeddedElData(el, "event");
    let obj = str ? JSON.parse(str) : {
        create: false
    }; // if no embedded data, assume no event creation
    return (0, $200f5cce291452b2$export$1abb261478089fe6)(obj);
}
(0, $200f5cce291452b2$export$27d1aff6bea49709).dataAttrPrefix = "";
function $a4d9a0c10526343d$var$getEmbeddedElData(el, name) {
    let prefix = (0, $200f5cce291452b2$export$27d1aff6bea49709).dataAttrPrefix;
    let prefixedName = (prefix ? prefix + "-" : "") + name;
    return el.getAttribute("data-" + prefixedName) || "";
}
/*
Makes an element (that is *external* to any calendar) draggable.
Can pass in data that determines how an event will be created when dropped onto a calendar.
Leverages FullCalendar's internal drag-n-drop functionality WITHOUT a third-party drag system.
*/ class $a4d9a0c10526343d$export$f2a139e5d18b9882 {
    destroy() {
        this.dragging.destroy();
    }
    constructor(el, settings = {}){
        this.handlePointerDown = (ev)=>{
            let { dragging: dragging } = this;
            let { minDistance: minDistance, longPressDelay: longPressDelay } = this.settings;
            dragging.minDistance = minDistance != null ? minDistance : ev.isTouch ? 0 : (0, $200f5cce291452b2$export$f1e1789686576879).eventDragMinDistance;
            dragging.delay = ev.isTouch ? longPressDelay != null ? longPressDelay : (0, $200f5cce291452b2$export$f1e1789686576879).longPressDelay : 0;
        };
        this.handleDragStart = (ev)=>{
            if (ev.isTouch && this.dragging.delay && ev.subjectEl.classList.contains("fc-event")) this.dragging.mirror.getMirrorEl().classList.add("fc-event-selected");
        };
        this.settings = settings;
        let dragging = this.dragging = new $a4d9a0c10526343d$var$FeaturefulElementDragging(el);
        dragging.touchScrollAllowed = false;
        if (settings.itemSelector != null) dragging.pointer.selector = settings.itemSelector;
        if (settings.appendTo != null) dragging.mirror.parentNode = settings.appendTo; // TODO: write tests
        dragging.emitter.on("pointerdown", this.handlePointerDown);
        dragging.emitter.on("dragstart", this.handleDragStart);
        new $a4d9a0c10526343d$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
}
/*
Detects when a *THIRD-PARTY* drag-n-drop system interacts with elements.
The third-party system is responsible for drawing the visuals effects of the drag.
This class simply monitors for pointer movements and fires events.
It also has the ability to hide the moving element (the "mirror") during the drag.
*/ class $a4d9a0c10526343d$var$InferredElementDragging extends (0, $200f5cce291452b2$export$60bb826a6acf3081) {
    destroy() {
        this.pointer.destroy();
    }
    setIgnoreMove(bool) {
        this.shouldIgnoreMove = bool;
    }
    setMirrorIsVisible(bool) {
        if (bool) // restore a previously hidden element.
        // use the reference in case the selector class has already been removed.
        {
            if (this.currentMirrorEl) {
                this.currentMirrorEl.style.visibility = "";
                this.currentMirrorEl = null;
            }
        } else {
            let mirrorEl = this.mirrorSelector ? document.querySelector(this.mirrorSelector) : null;
            if (mirrorEl) {
                this.currentMirrorEl = mirrorEl;
                mirrorEl.style.visibility = "hidden";
            }
        }
    }
    constructor(containerEl){
        super(containerEl);
        this.shouldIgnoreMove = false;
        this.mirrorSelector = "";
        this.currentMirrorEl = null;
        this.handlePointerDown = (ev)=>{
            this.emitter.trigger("pointerdown", ev);
            if (!this.shouldIgnoreMove) // fire dragstart right away. does not support delay or min-distance
            this.emitter.trigger("dragstart", ev);
        };
        this.handlePointerMove = (ev)=>{
            if (!this.shouldIgnoreMove) this.emitter.trigger("dragmove", ev);
        };
        this.handlePointerUp = (ev)=>{
            this.emitter.trigger("pointerup", ev);
            if (!this.shouldIgnoreMove) // fire dragend right away. does not support a revert animation
            this.emitter.trigger("dragend", ev);
        };
        let pointer = this.pointer = new $a4d9a0c10526343d$var$PointerDragging(containerEl);
        pointer.emitter.on("pointerdown", this.handlePointerDown);
        pointer.emitter.on("pointermove", this.handlePointerMove);
        pointer.emitter.on("pointerup", this.handlePointerUp);
    }
}
/*
Bridges third-party drag-n-drop systems with FullCalendar.
Must be instantiated and destroyed by caller.
*/ class $a4d9a0c10526343d$export$51e5e9a9728fcd8f {
    destroy() {
        this.dragging.destroy();
    }
    constructor(containerOrSettings, settings){
        let containerEl = document;
        if (// wish we could just test instanceof EventTarget, but doesn't work in IE11
        containerOrSettings === document || containerOrSettings instanceof Element) {
            containerEl = containerOrSettings;
            settings = settings || {};
        } else settings = containerOrSettings || {};
        let dragging = this.dragging = new $a4d9a0c10526343d$var$InferredElementDragging(containerEl);
        if (typeof settings.itemSelector === "string") dragging.pointer.selector = settings.itemSelector;
        else if (containerEl === document) dragging.pointer.selector = "[data-event]";
        if (typeof settings.mirrorSelector === "string") dragging.mirrorSelector = settings.mirrorSelector;
        new $a4d9a0c10526343d$var$ExternalElementDragging(dragging, settings.eventData); // eslint-disable-line no-new
    }
}
var $a4d9a0c10526343d$export$2e2bcd8739ae039 = (0, $76a516e930faac74$export$ae829ec7b2625219)({
    name: "@fullcalendar/interaction",
    componentInteractions: [
        $a4d9a0c10526343d$var$DateClicking,
        $a4d9a0c10526343d$var$DateSelecting,
        $a4d9a0c10526343d$var$EventDragging,
        $a4d9a0c10526343d$var$EventResizing
    ],
    calendarInteractions: [
        $a4d9a0c10526343d$var$UnselectAuto
    ],
    elementDraggingImpl: $a4d9a0c10526343d$var$FeaturefulElementDragging,
    optionRefiners: $a4d9a0c10526343d$var$OPTION_REFINERS,
    listenerRefiners: $a4d9a0c10526343d$var$LISTENER_REFINERS
});


var $74d3a9284317db0a$export$2e2bcd8739ae039 = {
    code: "pt",
    week: {
        dow: 1,
        doy: 4
    },
    buttonText: {
        prev: "Anterior",
        next: "Seguinte",
        today: "Hoje",
        year: "Ano",
        month: "M\xeas",
        week: "Semana",
        day: "Dia",
        list: "Agenda"
    },
    weekText: "Sem",
    allDayText: "Todo o dia",
    moreLinkText: "mais",
    noEventsText: "N\xe3o h\xe1 eventos para mostrar"
};


var $537063cc3b82d520$export$2e2bcd8739ae039 = {
    code: "en-gb",
    week: {
        dow: 1,
        doy: 4
    },
    buttonHints: {
        prev: "Previous $0",
        next: "Next $0",
        today: "This $0"
    },
    viewHint: "$0 view",
    navLinkHint: "Go to $0",
    moreLinkHint (eventCnt) {
        return `Show ${eventCnt} more event${eventCnt === 1 ? "" : "s"}`;
    }
};


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $afCHG = parcelRequire("afCHG");

var $aili3 = parcelRequire("aili3");
var $6F4ic = parcelRequire("6F4ic");
var $2hGJ2 = parcelRequire("2hGJ2");
var $aUdfW = parcelRequire("aUdfW");
var $8smOS = parcelRequire("8smOS");
var $8wwTv = parcelRequire("8wwTv");
var $eNZsp = parcelRequire("eNZsp");
var $pF6j5 = parcelRequire("pF6j5");
var $2MkI1 = parcelRequire("2MkI1");
var $8TDId = parcelRequire("8TDId");
var $lHSFU = parcelRequire("lHSFU");
var $58CWL = parcelRequire("58CWL");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $aUdfW = parcelRequire("aUdfW");
var $8smOS = parcelRequire("8smOS");
var $8wwTv = parcelRequire("8wwTv");
var $eNZsp = parcelRequire("eNZsp");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dNDci = parcelRequire("dNDci");

var $fnVR5 = parcelRequire("fnVR5");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $8pNrC = parcelRequire("8pNrC");

var $a2ay0 = parcelRequire("a2ay0");

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5a1af90f4ba984a4$var$AccordionContext = /*#__PURE__*/ $7fPBF.createContext({});
var $5a1af90f4ba984a4$export$2e2bcd8739ae039 = $5a1af90f4ba984a4$var$AccordionContext;



var $568MF = parcelRequire("568MF");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $163963791cd5489f$export$80fb6a2cb3f13b8b(slot) {
    return (0, $k6RDS.default)("MuiAccordion", slot);
}
const $163963791cd5489f$var$accordionClasses = (0, $4jzsB.default)("MuiAccordion", [
    "root",
    "rounded",
    "expanded",
    "disabled",
    "gutters",
    "region"
]);
var $163963791cd5489f$export$2e2bcd8739ae039 = $163963791cd5489f$var$accordionClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e9f205f7f0ba8e26$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "TransitionComponent",
    "TransitionProps"
];
const $e9f205f7f0ba8e26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            !square && "rounded",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        region: [
            "region"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $163963791cd5489f$export$80fb6a2cb3f13b8b), classes);
};
const $e9f205f7f0ba8e26$var$AccordionRoot = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiAccordion",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $163963791cd5489f$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: "relative",
        transition: theme.transitions.create([
            "margin"
        ], transition),
        overflowAnchor: "none",
        // Keep the same scrolling position
        "&:before": {
            position: "absolute",
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                "opacity",
                "background-color"
            ], transition)
        },
        "&:first-of-type": {
            "&:before": {
                display: "none"
            }
        },
        [`&.${(0, $163963791cd5489f$export$2e2bcd8739ae039).expanded}`]: {
            "&:before": {
                opacity: 0
            },
            "&:first-of-type": {
                marginTop: 0
            },
            "&:last-of-type": {
                marginBottom: 0
            },
            "& + &": {
                "&:before": {
                    display: "none"
                }
            }
        },
        [`&.${(0, $163963791cd5489f$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, !ownerState.square && {
        borderRadius: 0,
        "&:first-of-type": {
            borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderTopRightRadius: (theme.vars || theme).shape.borderRadius
        },
        "&:last-of-type": {
            borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
            // Fix a rendering issue on Edge
            "@supports (-ms-ime-align: auto)": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $163963791cd5489f$export$2e2bcd8739ae039).expanded}`]: {
            margin: "16px 0"
        }
    }));
const $e9f205f7f0ba8e26$var$Accordion = /*#__PURE__*/ $7fPBF.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAccordion"
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, TransitionComponent: TransitionComponent = (0, $8pNrC.default), TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $e9f205f7f0ba8e26$var$_excluded);
    const [expanded, setExpandedState] = (0, $568MF.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: "Accordion",
        state: "expanded"
    });
    const handleChange = $7fPBF.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $7fPBF.Children.toArray(childrenProp);
    const contextValue = $7fPBF.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $e9f205f7f0ba8e26$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($e9f205f7f0ba8e26$var$AccordionRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5a1af90f4ba984a4$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                in: expanded,
                timeout: "auto"
            }, TransitionProps, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props["aria-controls"],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $e9f205f7f0ba8e26$export$2e2bcd8739ae039 = $e9f205f7f0ba8e26$var$Accordion;


var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $d8975e70417897b8$var$_ = (t)=>t, $d8975e70417897b8$var$t, $d8975e70417897b8$var$t1, $d8975e70417897b8$var$t2, $d8975e70417897b8$var$t3;
const $d8975e70417897b8$export$9f206abb5ed94520 = (0, $6hfZk.default)((0, $e9f205f7f0ba8e26$export$2e2bcd8739ae039))($d8975e70417897b8$var$t || ($d8975e70417897b8$var$t = $d8975e70417897b8$var$_`
    background-color: #fafafa !important;
    box-shadow: none !important;

    &::before {
        background-color: #fff !important;
    }
`));
const $d8975e70417897b8$export$35583f225b728fea = (0, $6hfZk.default)((0, $aili3.default))($d8975e70417897b8$var$t1 || ($d8975e70417897b8$var$t1 = $d8975e70417897b8$var$_`
    display: flex;
    flex-direction: column;
    gap: 16px;
`));
const $d8975e70417897b8$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($d8975e70417897b8$var$t2 || ($d8975e70417897b8$var$t2 = $d8975e70417897b8$var$_`
    width: 100%;
`));
const $d8975e70417897b8$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($d8975e70417897b8$var$t3 || ($d8975e70417897b8$var$t3 = $d8975e70417897b8$var$_`
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: end;
`));


const $e76a34dc688aa94a$export$97a0a8c219eb7de3 = ({ booking: booking, open: open, onClose: onClose, onDelete: onDelete })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const [sendingRequest, setSendingRequest] = (0, $7fPBF.useState)(false);
    const handleDelete = ()=>{
        setSendingRequest(true);
        new (0, $dNDci.AppService)().api_deleteBooking("public", booking.id).then((res)=>{
            if (res.status !== 200) throw new Error(res);
            onClose();
            onDelete();
        }).catch((error)=>{
            console.log(error);
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("cancelBookingAlertMessage.500")
            });
        }).finally(()=>setSendingRequest(false));
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aUdfW.default), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eNZsp.default), {
                children: t("cancelBookingReservation", {
                    booking: booking === null || booking === void 0 ? void 0 : booking.shareId
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8wwTv.default), {
                dividers: true,
                children: t("cancelBookingMessage", {
                    email: booking === null || booking === void 0 ? void 0 : booking.email
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8smOS.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8975e70417897b8$export$e3da0e99c81a4b99), {
                        variant: "outlined",
                        onClick: onClose,
                        disabled: sendingRequest,
                        children: t("return")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8975e70417897b8$export$e3da0e99c81a4b99), {
                        color: "error",
                        variant: "contained",
                        disabled: sendingRequest,
                        onClick: handleDelete,
                        children: t("cancelBooking")
                    })
                ]
            })
        ]
    });
};



var $fnVR5 = parcelRequire("fnVR5");


var $7qlUi = parcelRequire("7qlUi");

var $3Ou5w = parcelRequire("3Ou5w");

var $i1fqN = parcelRequire("i1fqN");

var $hKUqD = parcelRequire("hKUqD");

var $ga3mZ = parcelRequire("ga3mZ");
parcelRequire("fI21S");
var $1HW2x = parcelRequire("1HW2x");

var $dNDci = parcelRequire("dNDci");
function $557a9dbb4cc5ad14$export$888e286a72668218() {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, data: data = [] } = (0, $1HW2x.useQuery)({
        queryKey: [
            "reservationTypes"
        ],
        queryFn: async ()=>{
            const res = await appService.api_getReservationTypes("private");
            return res.data;
        },
        retry: false
    });
    return {
        data: data,
        isLoading: isLoading
    };
}



var $930Hd = parcelRequire("930Hd");
parcelRequire("fI21S");
var $3irMb = parcelRequire("3irMb");

var $dNDci = parcelRequire("dNDci");
function $8bc6109dbb2423dd$export$196847cb578533dd(role) {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, data: data, mutate: mutate, isError: isError, error: error } = (0, $3irMb.useMutation)({
        mutationKey: [
            "updateReservation"
        ],
        mutationFn: async (data)=>{
            const res = await appService.api_updateBooking(role, data);
            return res;
        }
    });
    return {
        data: data,
        isLoading: isLoading,
        mutate: mutate,
        isError: isError,
        error: error
    };
}


var $ec220ad88bcb791b$exports = {};
/*global window, global*/ 
var $5LV4O = parcelRequire("5LV4O");

var $h1RhN = parcelRequire("h1RhN");
function $ec220ad88bcb791b$var$now() {
    return new Date().getTime();
}
var $ec220ad88bcb791b$var$slice = Array.prototype.slice;
var $ec220ad88bcb791b$var$console;
var $ec220ad88bcb791b$var$times = {};
if (typeof $parcel$global !== "undefined" && $parcel$global.console) $ec220ad88bcb791b$var$console = $parcel$global.console;
else if (typeof window !== "undefined" && window.console) $ec220ad88bcb791b$var$console = window.console;
else $ec220ad88bcb791b$var$console = {};
var $ec220ad88bcb791b$var$functions = [
    [
        $ec220ad88bcb791b$var$log,
        "log"
    ],
    [
        $ec220ad88bcb791b$var$info,
        "info"
    ],
    [
        $ec220ad88bcb791b$var$warn,
        "warn"
    ],
    [
        $ec220ad88bcb791b$var$error,
        "error"
    ],
    [
        $ec220ad88bcb791b$var$time,
        "time"
    ],
    [
        $ec220ad88bcb791b$var$timeEnd,
        "timeEnd"
    ],
    [
        $ec220ad88bcb791b$var$trace,
        "trace"
    ],
    [
        $ec220ad88bcb791b$var$dir,
        "dir"
    ],
    [
        $ec220ad88bcb791b$var$consoleAssert,
        "assert"
    ]
];
for(var $ec220ad88bcb791b$var$i = 0; $ec220ad88bcb791b$var$i < $ec220ad88bcb791b$var$functions.length; $ec220ad88bcb791b$var$i++){
    var $ec220ad88bcb791b$var$tuple = $ec220ad88bcb791b$var$functions[$ec220ad88bcb791b$var$i];
    var $ec220ad88bcb791b$var$f = $ec220ad88bcb791b$var$tuple[0];
    var $ec220ad88bcb791b$var$name = $ec220ad88bcb791b$var$tuple[1];
    if (!$ec220ad88bcb791b$var$console[$ec220ad88bcb791b$var$name]) $ec220ad88bcb791b$var$console[$ec220ad88bcb791b$var$name] = $ec220ad88bcb791b$var$f;
}
$ec220ad88bcb791b$exports = $ec220ad88bcb791b$var$console;
function $ec220ad88bcb791b$var$log() {}
function $ec220ad88bcb791b$var$info() {
    $ec220ad88bcb791b$var$console.log.apply($ec220ad88bcb791b$var$console, arguments);
}
function $ec220ad88bcb791b$var$warn() {
    $ec220ad88bcb791b$var$console.log.apply($ec220ad88bcb791b$var$console, arguments);
}
function $ec220ad88bcb791b$var$error() {
    $ec220ad88bcb791b$var$console.warn.apply($ec220ad88bcb791b$var$console, arguments);
}
function $ec220ad88bcb791b$var$time(label) {
    $ec220ad88bcb791b$var$times[label] = $ec220ad88bcb791b$var$now();
}
function $ec220ad88bcb791b$var$timeEnd(label) {
    var time = $ec220ad88bcb791b$var$times[label];
    if (!time) throw new Error("No such label: " + label);
    delete $ec220ad88bcb791b$var$times[label];
    var duration = $ec220ad88bcb791b$var$now() - time;
    $ec220ad88bcb791b$var$console.log(label + ": " + duration + "ms");
}
function $ec220ad88bcb791b$var$trace() {
    var err = new Error();
    err.name = "Trace";
    err.message = $5LV4O.format.apply(null, arguments);
    $ec220ad88bcb791b$var$console.error(err.stack);
}
function $ec220ad88bcb791b$var$dir(object) {
    $ec220ad88bcb791b$var$console.log($5LV4O.inspect(object) + "\n");
}
function $ec220ad88bcb791b$var$consoleAssert(expression) {
    if (!expression) {
        var arr = $ec220ad88bcb791b$var$slice.call(arguments, 1);
        $h1RhN.ok(false, $5LV4O.format.apply(null, arr));
    }
}



var $bbzbN = parcelRequire("bbzbN");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $23907523cf37a860$export$a6afb527becfac26(slot) {
    return (0, $k6RDS.default)("MuiAccordionDetails", slot);
}
const $23907523cf37a860$var$accordionDetailsClasses = (0, $4jzsB.default)("MuiAccordionDetails", [
    "root"
]);
var $23907523cf37a860$export$2e2bcd8739ae039 = $23907523cf37a860$var$accordionDetailsClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a33ac73601ffa184$var$_excluded = [
    "className"
];
const $a33ac73601ffa184$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $23907523cf37a860$export$a6afb527becfac26), classes);
};
const $a33ac73601ffa184$var$AccordionDetailsRoot = (0, $kDBhE.default)("div", {
    name: "MuiAccordionDetails",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $a33ac73601ffa184$var$AccordionDetails = /*#__PURE__*/ $7fPBF.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAccordionDetails"
    });
    const { className: className } = props, other = (0, $cFLic.default)(props, $a33ac73601ffa184$var$_excluded);
    const ownerState = props;
    const classes = $a33ac73601ffa184$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a33ac73601ffa184$var$AccordionDetailsRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $a33ac73601ffa184$export$2e2bcd8739ae039 = $a33ac73601ffa184$var$AccordionDetails;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $3RNaF = parcelRequire("3RNaF");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $e30a7f2c0637be93$export$282216ad123d6580(slot) {
    return (0, $k6RDS.default)("MuiAccordionSummary", slot);
}
const $e30a7f2c0637be93$var$accordionSummaryClasses = (0, $4jzsB.default)("MuiAccordionSummary", [
    "root",
    "expanded",
    "focusVisible",
    "disabled",
    "gutters",
    "contentGutters",
    "content",
    "expandIconWrapper"
]);
var $e30a7f2c0637be93$export$2e2bcd8739ae039 = $e30a7f2c0637be93$var$accordionSummaryClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $4dadc25f7bb7b60a$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $4dadc25f7bb7b60a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        focusVisible: [
            "focusVisible"
        ],
        content: [
            "content",
            expanded && "expanded",
            !disableGutters && "contentGutters"
        ],
        expandIconWrapper: [
            "expandIconWrapper",
            expanded && "expanded"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $e30a7f2c0637be93$export$282216ad123d6580), classes);
};
const $4dadc25f7bb7b60a$var$AccordionSummaryRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: "MuiAccordionSummary",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return (0, $kY3Ke.default)({
        display: "flex",
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            "min-height",
            "background-color"
        ], transition),
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).disabled})`]: {
            cursor: "pointer"
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).expanded}`]: {
            minHeight: 64
        }
    });
});
const $4dadc25f7bb7b60a$var$AccordionSummaryContent = (0, $kDBhE.default)("div", {
    name: "MuiAccordionSummary",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex",
        flexGrow: 1,
        margin: "12px 0"
    }, !ownerState.disableGutters && {
        transition: theme.transitions.create([
            "margin"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).expanded}`]: {
            margin: "20px 0"
        }
    }));
const $4dadc25f7bb7b60a$var$AccordionSummaryExpandIconWrapper = (0, $kDBhE.default)("div", {
    name: "MuiAccordionSummary",
    slot: "ExpandIconWrapper",
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: "flex",
        color: (theme.vars || theme).palette.action.active,
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $e30a7f2c0637be93$export$2e2bcd8739ae039).expanded}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $4dadc25f7bb7b60a$var$AccordionSummary = /*#__PURE__*/ $7fPBF.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAccordionSummary"
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $cFLic.default)(props, $4dadc25f7bb7b60a$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $7fPBF.useContext((0, $5a1af90f4ba984a4$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $kY3Ke.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $4dadc25f7bb7b60a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($4dadc25f7bb7b60a$var$AccordionSummaryRoot, (0, $kY3Ke.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $hngXp.default)(classes.root, className),
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($4dadc25f7bb7b60a$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $bbzbN.jsx)($4dadc25f7bb7b60a$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $4dadc25f7bb7b60a$export$2e2bcd8739ae039 = $4dadc25f7bb7b60a$var$AccordionSummary;


var $3loMv = parcelRequire("3loMv");
parcelRequire("7fPBF");

var $bzrhL = parcelRequire("bzrhL");


var $6hfZk = parcelRequire("6hfZk");
let $614734e5d831cfb4$var$_ = (t)=>t, $614734e5d831cfb4$var$t;
const $614734e5d831cfb4$export$9f206abb5ed94520 = (0, $6hfZk.default)((0, $e9f205f7f0ba8e26$export$2e2bcd8739ae039))($614734e5d831cfb4$var$t || ($614734e5d831cfb4$var$t = $614734e5d831cfb4$var$_`
    background-color: #fafafa !important;
    box-shadow: none !important;

    &::before {
        background-color: #fff !important;
    }
`));


const $bbdf7a0d01a379ab$export$c6de04e2faaf9651 = ({ title: title, expanded: expanded, children: children })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $614734e5d831cfb4$export$9f206abb5ed94520), {
        expanded: expanded,
        onChange: (expanded)=>!expanded,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4dadc25f7bb7b60a$export$2e2bcd8739ae039), {
                expandIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzrhL))), {}),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a33ac73601ffa184$export$2e2bcd8739ae039), {
                children: children
            })
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $ed83f782f736c1e7$var$extendStatics = function(d, b) {
    $ed83f782f736c1e7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ed83f782f736c1e7$var$extendStatics(d, b);
};
function $ed83f782f736c1e7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ed83f782f736c1e7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ed83f782f736c1e7$export$18ce0697a983be9b = function() {
    $ed83f782f736c1e7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed83f782f736c1e7$export$18ce0697a983be9b.apply(this, arguments);
};
function $ed83f782f736c1e7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ed83f782f736c1e7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ed83f782f736c1e7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ed83f782f736c1e7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ed83f782f736c1e7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ed83f782f736c1e7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ed83f782f736c1e7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ed83f782f736c1e7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ed83f782f736c1e7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ed83f782f736c1e7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ed83f782f736c1e7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ed83f782f736c1e7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ed83f782f736c1e7$export$45d3717a4c69092e(o, m, p);
}
function $ed83f782f736c1e7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ed83f782f736c1e7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ed83f782f736c1e7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ed83f782f736c1e7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ed83f782f736c1e7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ed83f782f736c1e7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ed83f782f736c1e7$export$10c90e4f7922046c(v) {
    return this instanceof $ed83f782f736c1e7$export$10c90e4f7922046c ? (this.v = v, this) : new $ed83f782f736c1e7$export$10c90e4f7922046c(v);
}
function $ed83f782f736c1e7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ed83f782f736c1e7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ed83f782f736c1e7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ed83f782f736c1e7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ed83f782f736c1e7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ed83f782f736c1e7$export$19a8beecd37a4c45 === "function" ? $ed83f782f736c1e7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ed83f782f736c1e7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ed83f782f736c1e7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $ed83f782f736c1e7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ed83f782f736c1e7$export$45d3717a4c69092e(result, mod, k);
    }
    $ed83f782f736c1e7$var$__setModuleDefault(result, mod);
    return result;
}
function $ed83f782f736c1e7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ed83f782f736c1e7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ed83f782f736c1e7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ed83f782f736c1e7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ed83f782f736c1e7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ed83f782f736c1e7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ed83f782f736c1e7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ed83f782f736c1e7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $ed83f782f736c1e7$export$2e2bcd8739ae039 = {
    __extends: $ed83f782f736c1e7$export$a8ba968b8961cb8a,
    __assign: $ed83f782f736c1e7$export$18ce0697a983be9b,
    __rest: $ed83f782f736c1e7$export$3c9a16f847548506,
    __decorate: $ed83f782f736c1e7$export$29e00dfd3077644b,
    __param: $ed83f782f736c1e7$export$d5ad3fd78186038f,
    __metadata: $ed83f782f736c1e7$export$f1db080c865becb9,
    __awaiter: $ed83f782f736c1e7$export$1050f835b63b671e,
    __generator: $ed83f782f736c1e7$export$67ebef60e6f28a6,
    __createBinding: $ed83f782f736c1e7$export$45d3717a4c69092e,
    __exportStar: $ed83f782f736c1e7$export$f33643c0debef087,
    __values: $ed83f782f736c1e7$export$19a8beecd37a4c45,
    __read: $ed83f782f736c1e7$export$8d051b38c9118094,
    __spread: $ed83f782f736c1e7$export$afc72e2116322959,
    __spreadArrays: $ed83f782f736c1e7$export$6388937ca91ccae8,
    __spreadArray: $ed83f782f736c1e7$export$1216008129fb82ed,
    __await: $ed83f782f736c1e7$export$10c90e4f7922046c,
    __asyncGenerator: $ed83f782f736c1e7$export$e427f37a30a4de9b,
    __asyncDelegator: $ed83f782f736c1e7$export$bbd80228419bb833,
    __asyncValues: $ed83f782f736c1e7$export$e3b29a3d6162315f,
    __makeTemplateObject: $ed83f782f736c1e7$export$4fb47efe1390b86f,
    __importStar: $ed83f782f736c1e7$export$c21735bcef00d192,
    __importDefault: $ed83f782f736c1e7$export$da59b14a69baef04,
    __classPrivateFieldGet: $ed83f782f736c1e7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ed83f782f736c1e7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ed83f782f736c1e7$export$81fdc39f203e4e04,
    __addDisposableResource: $ed83f782f736c1e7$export$88ac25d8e944e405,
    __disposeResources: $ed83f782f736c1e7$export$8f076105dc360e92
};


var $aa42031db57b9246$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $aa42031db57b9246$export$8cc09085015f0dc7(file, path) {
    var f = $aa42031db57b9246$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $aa42031db57b9246$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $aa42031db57b9246$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $febb6c601004d864$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $febb6c601004d864$export$a36e16046ae8f1bb(evt) {
    return (0, $ed83f782f736c1e7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $ed83f782f736c1e7$export$67ebef60e6f28a6)(this, function(_a) {
            if ($febb6c601004d864$var$isObject(evt) && $febb6c601004d864$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $febb6c601004d864$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($febb6c601004d864$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $febb6c601004d864$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $febb6c601004d864$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $febb6c601004d864$var$isDataTransfer(value) {
    return $febb6c601004d864$var$isObject(value);
}
function $febb6c601004d864$var$isChangeEvt(value) {
    return $febb6c601004d864$var$isObject(value) && $febb6c601004d864$var$isObject(value.target);
}
function $febb6c601004d864$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $febb6c601004d864$var$getInputFiles(evt) {
    return $febb6c601004d864$var$fromList(evt.target.files).map(function(file) {
        return (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $febb6c601004d864$var$getFsHandleFiles(handles) {
    return (0, $ed83f782f736c1e7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $ed83f782f736c1e7$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $febb6c601004d864$var$getDataTransferFiles(dt, type) {
    return (0, $ed83f782f736c1e7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $ed83f782f736c1e7$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $febb6c601004d864$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($febb6c601004d864$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $febb6c601004d864$var$noIgnoredFiles($febb6c601004d864$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $febb6c601004d864$var$noIgnoredFiles($febb6c601004d864$var$fromList(dt.files).map(function(file) {
                            return (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $febb6c601004d864$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $febb6c601004d864$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $febb6c601004d864$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $febb6c601004d864$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $febb6c601004d864$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $febb6c601004d864$var$fromDirEntry(entry);
    return $febb6c601004d864$var$fromDataTransferItem(item);
}
function $febb6c601004d864$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $ed83f782f736c1e7$export$1216008129fb82ed)((0, $ed83f782f736c1e7$export$1216008129fb82ed)([], (0, $ed83f782f736c1e7$export$8d051b38c9118094)(acc), false), (0, $ed83f782f736c1e7$export$8d051b38c9118094)(Array.isArray(files) ? $febb6c601004d864$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $febb6c601004d864$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $febb6c601004d864$var$fromEntry(entry) {
    return (0, $ed83f782f736c1e7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $ed83f782f736c1e7$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $febb6c601004d864$var$fromDirEntry(entry) : $febb6c601004d864$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $febb6c601004d864$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $ed83f782f736c1e7$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $ed83f782f736c1e7$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($febb6c601004d864$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $febb6c601004d864$var$fromFileEntry(entry) {
    return (0, $ed83f782f736c1e7$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $ed83f782f736c1e7$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $aa42031db57b9246$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $d4bef793831b886e$export$1e511d4a378977f5;
var $d4bef793831b886e$export$2e2bcd8739ae039;
"use strict";
$d4bef793831b886e$export$1e511d4a378977f5 = true;
$d4bef793831b886e$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $64f375de9ad0fe46$var$_toConsumableArray(arr) {
    return $64f375de9ad0fe46$var$_arrayWithoutHoles(arr) || $64f375de9ad0fe46$var$_iterableToArray(arr) || $64f375de9ad0fe46$var$_unsupportedIterableToArray(arr) || $64f375de9ad0fe46$var$_nonIterableSpread();
}
function $64f375de9ad0fe46$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64f375de9ad0fe46$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $64f375de9ad0fe46$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $64f375de9ad0fe46$var$_arrayLikeToArray(arr);
}
function $64f375de9ad0fe46$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64f375de9ad0fe46$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $64f375de9ad0fe46$var$ownKeys(Object(source), !0).forEach(function(key) {
            $64f375de9ad0fe46$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $64f375de9ad0fe46$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $64f375de9ad0fe46$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64f375de9ad0fe46$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $64f375de9ad0fe46$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $64f375de9ad0fe46$var$_typeof(obj);
}
function $64f375de9ad0fe46$var$_slicedToArray(arr, i) {
    return $64f375de9ad0fe46$var$_arrayWithHoles(arr) || $64f375de9ad0fe46$var$_iterableToArrayLimit(arr, i) || $64f375de9ad0fe46$var$_unsupportedIterableToArray(arr, i) || $64f375de9ad0fe46$var$_nonIterableRest();
}
function $64f375de9ad0fe46$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64f375de9ad0fe46$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $64f375de9ad0fe46$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $64f375de9ad0fe46$var$_arrayLikeToArray(o, minLen);
}
function $64f375de9ad0fe46$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $64f375de9ad0fe46$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $64f375de9ad0fe46$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $64f375de9ad0fe46$export$d2c35cc369247232 = "file-invalid-type";
var $64f375de9ad0fe46$export$d7bd1185abe1e87c = "file-too-large";
var $64f375de9ad0fe46$export$8bd5ec6ed990dc9 = "file-too-small";
var $64f375de9ad0fe46$export$3271ef1d2dd155f9 = "too-many-files";
var $64f375de9ad0fe46$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $64f375de9ad0fe46$export$d2c35cc369247232,
    FileTooLarge: $64f375de9ad0fe46$export$d7bd1185abe1e87c,
    FileTooSmall: $64f375de9ad0fe46$export$8bd5ec6ed990dc9,
    TooManyFiles: $64f375de9ad0fe46$export$3271ef1d2dd155f9
}; // File Errors
var $64f375de9ad0fe46$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $64f375de9ad0fe46$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $64f375de9ad0fe46$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $64f375de9ad0fe46$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $64f375de9ad0fe46$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $64f375de9ad0fe46$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $64f375de9ad0fe46$export$1e1e1b6120329fe = {
    code: $64f375de9ad0fe46$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $64f375de9ad0fe46$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $d4bef793831b886e$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $64f375de9ad0fe46$export$bc0bbda045f09b5a(accept)
    ];
}
function $64f375de9ad0fe46$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($64f375de9ad0fe46$var$isDefined(file.size)) {
        if ($64f375de9ad0fe46$var$isDefined(minSize) && $64f375de9ad0fe46$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $64f375de9ad0fe46$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $64f375de9ad0fe46$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($64f375de9ad0fe46$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $64f375de9ad0fe46$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($64f375de9ad0fe46$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $64f375de9ad0fe46$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $64f375de9ad0fe46$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $64f375de9ad0fe46$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $64f375de9ad0fe46$export$b511db3632effe58(file, accept), _fileAccepted2 = $64f375de9ad0fe46$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $64f375de9ad0fe46$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $64f375de9ad0fe46$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $64f375de9ad0fe46$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $64f375de9ad0fe46$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $64f375de9ad0fe46$export$f9006bf02b243736(item) {
    return $64f375de9ad0fe46$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $64f375de9ad0fe46$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $64f375de9ad0fe46$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $64f375de9ad0fe46$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $64f375de9ad0fe46$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $64f375de9ad0fe46$var$isIe(userAgent) || $64f375de9ad0fe46$var$isEdge(userAgent);
}
function $64f375de9ad0fe46$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$64f375de9ad0fe46$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $64f375de9ad0fe46$export$8d6d6472146de265(event);
        });
    };
}
function $64f375de9ad0fe46$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $64f375de9ad0fe46$export$8ce4bd13c494743e(accept) {
    if ($64f375de9ad0fe46$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $64f375de9ad0fe46$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$64f375de9ad0fe46$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($64f375de9ad0fe46$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $64f375de9ad0fe46$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $64f375de9ad0fe46$var$_objectSpread($64f375de9ad0fe46$var$_objectSpread({}, agg), {}, $64f375de9ad0fe46$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $64f375de9ad0fe46$export$1278288bcefb97b9(accept) {
    if ($64f375de9ad0fe46$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $64f375de9ad0fe46$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($64f375de9ad0fe46$var$_toConsumableArray(a), [
            mimeType
        ], $64f375de9ad0fe46$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $64f375de9ad0fe46$export$69c8ec3250e1cfbf(v) || $64f375de9ad0fe46$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $64f375de9ad0fe46$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $64f375de9ad0fe46$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $64f375de9ad0fe46$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $64f375de9ad0fe46$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $c08bbb67d1713114$var$_excluded = [
    "children"
], $c08bbb67d1713114$var$_excluded2 = [
    "open"
], $c08bbb67d1713114$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $c08bbb67d1713114$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $c08bbb67d1713114$var$_toConsumableArray(arr) {
    return $c08bbb67d1713114$var$_arrayWithoutHoles(arr) || $c08bbb67d1713114$var$_iterableToArray(arr) || $c08bbb67d1713114$var$_unsupportedIterableToArray(arr) || $c08bbb67d1713114$var$_nonIterableSpread();
}
function $c08bbb67d1713114$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c08bbb67d1713114$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c08bbb67d1713114$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c08bbb67d1713114$var$_arrayLikeToArray(arr);
}
function $c08bbb67d1713114$var$_slicedToArray(arr, i) {
    return $c08bbb67d1713114$var$_arrayWithHoles(arr) || $c08bbb67d1713114$var$_iterableToArrayLimit(arr, i) || $c08bbb67d1713114$var$_unsupportedIterableToArray(arr, i) || $c08bbb67d1713114$var$_nonIterableRest();
}
function $c08bbb67d1713114$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c08bbb67d1713114$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c08bbb67d1713114$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c08bbb67d1713114$var$_arrayLikeToArray(o, minLen);
}
function $c08bbb67d1713114$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c08bbb67d1713114$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c08bbb67d1713114$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c08bbb67d1713114$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c08bbb67d1713114$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c08bbb67d1713114$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c08bbb67d1713114$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c08bbb67d1713114$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c08bbb67d1713114$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c08bbb67d1713114$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c08bbb67d1713114$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c08bbb67d1713114$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $c08bbb67d1713114$var$Dropzone = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $c08bbb67d1713114$var$_objectWithoutProperties(_ref, $c08bbb67d1713114$var$_excluded);
    var _useDropzone = $c08bbb67d1713114$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $c08bbb67d1713114$var$_objectWithoutProperties(_useDropzone, $c08bbb67d1713114$var$_excluded2);
    (0, $7fPBF.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7fPBF.Fragment), null, children($c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$c08bbb67d1713114$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $c08bbb67d1713114$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $febb6c601004d864$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$c08bbb67d1713114$var$Dropzone.defaultProps = $c08bbb67d1713114$var$defaultProps;
$c08bbb67d1713114$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
};
var $c08bbb67d1713114$export$2e2bcd8739ae039 = $c08bbb67d1713114$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $c08bbb67d1713114$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $c08bbb67d1713114$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, $c08bbb67d1713114$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $7fPBF.useMemo)(function() {
        return (0, $64f375de9ad0fe46$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $7fPBF.useMemo)(function() {
        return (0, $64f375de9ad0fe46$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $7fPBF.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $c08bbb67d1713114$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $7fPBF.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $c08bbb67d1713114$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $7fPBF.useRef)(null);
    var inputRef = (0, $7fPBF.useRef)(null);
    var _useReducer = (0, $7fPBF.useReducer)($c08bbb67d1713114$var$reducer, $c08bbb67d1713114$var$initialState), _useReducer2 = $c08bbb67d1713114$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $7fPBF.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $64f375de9ad0fe46$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $7fPBF.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $7fPBF.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $7fPBF.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $64f375de9ad0fe46$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $64f375de9ad0fe46$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $7fPBF.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $7fPBF.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($c08bbb67d1713114$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $64f375de9ad0fe46$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $64f375de9ad0fe46$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $7fPBF.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $64f375de9ad0fe46$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $c08bbb67d1713114$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $64f375de9ad0fe46$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $c08bbb67d1713114$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $64f375de9ad0fe46$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $7fPBF.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $64f375de9ad0fe46$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $64f375de9ad0fe46$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $7fPBF.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $64f375de9ad0fe46$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $64f375de9ad0fe46$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $7fPBF.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $7fPBF.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $64f375de9ad0fe46$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $7fPBF.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $c08bbb67d1713114$var$_objectWithoutProperties(_ref2, $c08bbb67d1713114$var$_excluded3);
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $7fPBF.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $7fPBF.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $c08bbb67d1713114$var$_objectWithoutProperties(_ref3, $c08bbb67d1713114$var$_excluded4);
            var inputProps = $c08bbb67d1713114$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $64f375de9ad0fe46$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $c08bbb67d1713114$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, $c08bbb67d1713114$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $c08bbb67d1713114$var$_objectSpread($c08bbb67d1713114$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $c08bbb67d1713114$var$_objectSpread({}, $c08bbb67d1713114$var$initialState);
        default:
            return state;
    }
}
function $c08bbb67d1713114$var$noop() {}



var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $6ff9bb83ec42d820$var$_ = (t)=>t, $6ff9bb83ec42d820$var$t, $6ff9bb83ec42d820$var$t1, $6ff9bb83ec42d820$var$t2, $6ff9bb83ec42d820$var$t3, $6ff9bb83ec42d820$var$t4;
const $6ff9bb83ec42d820$export$f292c632b3c6d150 = (0, $6hfZk.default)((0, $aili3.default))($6ff9bb83ec42d820$var$t || ($6ff9bb83ec42d820$var$t = $6ff9bb83ec42d820$var$_`
    display: flex;
    flex-direction: column;
    gap: 6px;
    text-align: center;
`));
const $6ff9bb83ec42d820$export$5ac7b85d728a3568 = (0, $6hfZk.default)((0, $aili3.default))($6ff9bb83ec42d820$var$t1 || ($6ff9bb83ec42d820$var$t1 = $6ff9bb83ec42d820$var$_`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
`));
const $6ff9bb83ec42d820$export$246ee17ce8755a38 = (0, $6hfZk.default)((0, $aili3.default))($6ff9bb83ec42d820$var$t2 || ($6ff9bb83ec42d820$var$t2 = $6ff9bb83ec42d820$var$_`
    text-align: center;
`));
const $6ff9bb83ec42d820$export$4a96334d5925dbf2 = (0, $6hfZk.default).img($6ff9bb83ec42d820$var$t3 || ($6ff9bb83ec42d820$var$t3 = $6ff9bb83ec42d820$var$_`
    max-width: 100%;
`));
const $6ff9bb83ec42d820$export$64afaefac45dc33b = (0, $6hfZk.default).p($6ff9bb83ec42d820$var$t4 || ($6ff9bb83ec42d820$var$t4 = $6ff9bb83ec42d820$var$_`
    font-size: 12px;
    font-weight: bold;
    color: var(--color-primary);
    margin: 0;
`));



var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
var $dV5yl = parcelRequire("dV5yl");
var $3loMv = parcelRequire("3loMv");
var $4c078c7a959fc44d$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($4c078c7a959fc44d$exports, "__esModule", {
    value: true
});
$4c078c7a959fc44d$exports.default = void 0;

var $4c078c7a959fc44d$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $4c078c7a959fc44d$var$_default = (0, $4c078c7a959fc44d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
}), "CloudUpload");
$4c078c7a959fc44d$exports.default = $4c078c7a959fc44d$var$_default;



var $dkKmP = parcelRequire("dkKmP");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("fI21S");
var $3irMb = parcelRequire("3irMb");

var $dNDci = parcelRequire("dNDci");
function $4b38317ef706a534$export$bc8f64956f4e2943(reservationId) {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, data: data, mutate: mutate } = (0, $3irMb.useMutation)({
        mutationKey: [
            "reservationPaymentProof"
        ],
        mutationFn: async (paymentProof)=>{
            const res = await appService.api_registerPaymentProof(reservationId, paymentProof);
            return res.data;
        }
    });
    return {
        data: data,
        isLoading: isLoading,
        mutate: mutate
    };
}



var $fnVR5 = parcelRequire("fnVR5");
const $014d1b09082dded3$export$d92f83d2e295fa99 = ({ reservationId: reservationId, maxFileNumber: maxFileNumber, onClose: onClose })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const { acceptedFiles: acceptedFiles, getRootProps: getRootProps, getInputProps: getInputProps, fileRejections: fileRejections } = (0, $c08bbb67d1713114$export$cd49c0ecc5be9f36)({
        accept: {
            "image/jpeg": [],
            "image/png": []
        },
        maxFiles: maxFileNumber,
        maxSize: 2097152
    });
    const [imagePreviews, setImagePreviews] = (0, $7fPBF.useState)([]);
    const { mutate: mutate } = (0, $4b38317ef706a534$export$bc8f64956f4e2943)(reservationId);
    (0, $7fPBF.useEffect)(()=>{
        // Update image previews when acceptedFiles change
        const previews = [];
        acceptedFiles.forEach((file)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>{
                previews.push(reader.result);
                setImagePreviews([
                    ...previews
                ]);
            };
            reader.readAsDataURL(file);
        });
        // Cleanup object URLs when component unmounts
        return ()=>{
            previews.forEach((preview)=>URL.revokeObjectURL(preview));
        };
    }, [
        acceptedFiles
    ]);
    const files = acceptedFiles.map((file, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ff9bb83ec42d820$export$246ee17ce8755a38), {
            children: imagePreviews[index] && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ff9bb83ec42d820$export$4a96334d5925dbf2), {
                src: imagePreviews[index],
                alt: file.name
            })
        }, file.name));
    const fileRejectionItems = fileRejections.map(({ errors: errors })=>errors.map((e, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                severity: "error",
                children: e.code === "file-too-large" ? t("fileUploadErrorMaxSize") : t("fileUploadErrorMaxFiles")
            }, index)));
    const handleSubmit = async ({ alt: alt, src: src })=>{
        const fileName = alt.replace(/[^a-zA-Z0-9.]/g, "");
        const [fileBaseName, fileExt] = fileName.split(".");
        const paymentProof = [
            {
                fileName: fileBaseName,
                extension: fileExt,
                base64Data: src
            }
        ];
        mutate(paymentProof, {
            onError: ()=>{
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "error",
                    children: t("paymentProof.message.failedUpload")
                });
                onClose();
            },
            onSuccess: (data)=>{
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: t("paymentProof.message.successUpload")
                });
                onClose();
            }
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6ff9bb83ec42d820$export$f292c632b3c6d150), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dV5yl.default), {
                ...getRootProps({
                    className: "dropzone"
                }),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        ...getInputProps()
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6ff9bb83ec42d820$export$5ac7b85d728a3568), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c078c7a959fc44d$exports))), {
                                fontSize: "large"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "body1",
                                children: t("fileUploadInput")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "body1",
                                children: t("fileUploadInputRules")
                            })
                        ]
                    })
                ]
            }),
            files && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ff9bb83ec42d820$export$246ee17ce8755a38), {
                children: files
            }),
            fileRejectionItems && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                children: fileRejectionItems[0]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                variant: "contained",
                onClick: ()=>handleSubmit(files[0].props.children.props),
                disabled: acceptedFiles.length === 0,
                children: t("save")
            })
        ]
    });
};


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $4fb093c442302189$export$e794b6ad1b0843e5 = ({ open: open, booking: booking, onClose: onClose, onDelete: onDelete, onIsPaidUpdate: onIsPaidUpdate })=>{
    var _booking_CreatedBy, _booking_PayedBy, _booking_CanceledBy;
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const submitting = (0, $7fPBF.useRef)(false);
    const [cancelBookingModalOpen, setCancelBookingModalOpen] = (0, $7fPBF.useState)(false);
    const { data: reservationTypes } = (0, $557a9dbb4cc5ad14$export$888e286a72668218)();
    const { mutate: updateReservation } = (0, $8bc6109dbb2423dd$export$196847cb578533dd)("private");
    const [isPaid, setIsPaid] = (0, $7fPBF.useState)(booking.isPayed);
    const [reservationType, setReservationType] = (0, $7fPBF.useState)(booking.reservationType);
    const handleCancelBooking = ()=>{
        setCancelBookingModalOpen(true);
    };
    const handleDeleteBooking = ()=>{
        onClose();
        onDelete();
    };
    (0, $7fPBF.useEffect)(()=>{
        setReservationType(booking.reservationType);
    }, [
        booking.reservationType
    ]);
    const handleIsPaidChange = (e)=>{
        const { checked: checked } = e.target;
        if (submitting.current) return;
        submitting.current = true;
        updateReservation({
            id: booking.id,
            isPayed: checked
        }, {
            onSuccess: (data)=>{
                if (data.status !== 200) throw data;
                if (typeof onIsPaidUpdate === "function") onIsPaidUpdate(checked);
                setIsPaid(checked);
                appContext.setBookingUpdate(true);
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "success",
                    children: checked ? t("bookingIsPaid", {
                        id: booking.shareId
                    }) : t("bookingIsNotPaid", {
                        id: booking.shareId
                    })
                });
            },
            onError: ()=>{
                console.log((0, $ec220ad88bcb791b$exports.error));
                setSnackbar({
                    open: true,
                    setOpen: ()=>{
                        setSnackbar({
                            open: false,
                            children: null,
                            setOpen: ()=>{}
                        });
                    },
                    severity: "error",
                    children: t("generalError")
                });
            },
            onSettled: ()=>{
                submitting.current = false;
            }
        });
    };
    const handleReservationTypeChange = (e)=>{
        if (submitting.current) return;
        submitting.current = true;
        setReservationType(e.target.value);
        if (e.target.value !== reservationType) {
            const formData = {
                id: booking.id,
                reservationType: e.target.value
            };
            updateReservation(formData, {
                onSuccess: (data)=>{
                    if (data.status !== 200) throw data;
                    appContext.setBookingUpdate(true);
                    setSnackbar({
                        open: true,
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "success",
                        children: t("clubAdmin.bookings.modal.reservationTypeUpdateSuccess")
                    });
                },
                onError: ()=>{
                    setSnackbar({
                        open: true,
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "error",
                        children: t("clubAdmin.bookings.modal.reservationTypeUpdateError")
                    });
                },
                onSettled: ()=>{
                    submitting.current = false;
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aUdfW.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $eNZsp.default), {
                children: [
                    `${t("clubAdmin.bookings.modal.title")} ${booking.shareId}`,
                    " ",
                    booking.canceled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                        label: t("canceled"),
                        color: "error"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                "aria-label": "close",
                onClick: onClose,
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hKUqD))), {})
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8wwTv.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8975e70417897b8$export$35583f225b728fea), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "area",
                            type: "text",
                            disabled: true,
                            hasLabelTop: true,
                            value: booking.area.name,
                            labelTop: t("area")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "category",
                            type: "text",
                            disabled: true,
                            value: booking === null || booking === void 0 ? void 0 : booking.category,
                            hasLabelTop: true,
                            labelTop: t("clubAdmin.bookings.inputLabel.selectedSport")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                    children: t("clubAdmin.bookings.inputLabel.reservationType")
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledSelectControl), {
                                    sx: {
                                        width: "100%"
                                    },
                                    variant: "outlined",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $930Hd.Select), {
                                        name: "reservationType",
                                        labelId: "reservationType",
                                        value: reservationType,
                                        onChange: (e)=>handleReservationTypeChange(e),
                                        children: reservationTypes === null || reservationTypes === void 0 ? void 0 : reservationTypes.map((category)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                value: category,
                                                children: t(`clubAdmin.bookings.reservationTypes.${category.toLowerCase()}`)
                                            }, category))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "name",
                            type: "text",
                            disabled: true,
                            hasLabelTop: true,
                            value: booking.name,
                            labelTop: t("clubAdmin.bookings.modal.clientName")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "email",
                            type: "text",
                            disabled: true,
                            value: booking.email,
                            hasLabelTop: true,
                            labelTop: t("clubAdmin.bookings.modal.clientEmail")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "mobilePhone",
                            type: "text",
                            disabled: true,
                            value: booking.mobilePhone ? booking.mobilePhone : "",
                            placeholder: t("clubAdmin.bookings.modal.mobilePhone"),
                            hasLabelTop: true,
                            labelTop: t("clubAdmin.bookings.modal.mobilePhone")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "day",
                            type: "text",
                            disabled: true,
                            hasLabelTop: true,
                            labelTop: t("clubAdmin.bookings.modal.day"),
                            value: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).format("DD-MM-YYYY")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                            name: "day",
                            type: "text",
                            disabled: true,
                            hasLabelTop: true,
                            labelTop: t("clubAdmin.bookings.modal.time"),
                            value: `${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.from).utc().format("HH:mm")} - ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.to).utc().format("HH:mm")}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2MkI1.default), {
                            control: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6F4ic.default), {
                                checked: isPaid,
                                onChange: handleIsPaidChange,
                                disabled: submitting.current || booking.canceled ? true : false
                            }),
                            label: t("paymentConfirmed")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbdf7a0d01a379ab$export$c6de04e2faaf9651), {
                            title: t("clubAdmin.bookings.payment"),
                            children: booking.paymentProofUrl ? /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                src: booking.paymentProofUrl,
                                alt: "",
                                style: {
                                    width: "100%"
                                }
                            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $014d1b09082dded3$export$d92f83d2e295fa99), {
                                reservationId: booking.id,
                                maxFileNumber: 1,
                                onClose: onClose
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7qlUi.FeatureToggleBaseComponent), {
                            featureToggle: (0, $3Ou5w.FeatureToggles).RESERVATION_HISTORY,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {
                                    light: true
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbdf7a0d01a379ab$export$c6de04e2faaf9651), {
                                    title: t("clubAdmin.historyData.accordionTitle"),
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                                variant: "caption",
                                                children: [
                                                    t("clubAdmin.historyData.createdBy"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                        children: booking === null || booking === void 0 ? void 0 : (_booking_CreatedBy = booking.CreatedBy) === null || _booking_CreatedBy === void 0 ? void 0 : _booking_CreatedBy.name
                                                    }),
                                                    " ",
                                                    t("clubAdmin.historyData.at"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking === null || booking === void 0 ? void 0 : booking.createdAt).utc().format("DD/MM/YYYY HH:mm")
                                                    })
                                                ]
                                            }),
                                            (booking === null || booking === void 0 ? void 0 : booking.isPayed) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                                    variant: "caption",
                                                    children: [
                                                        t("clubAdmin.historyData.paidBy"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                            children: booking === null || booking === void 0 ? void 0 : (_booking_PayedBy = booking.PayedBy) === null || _booking_PayedBy === void 0 ? void 0 : _booking_PayedBy.name
                                                        }),
                                                        " por",
                                                        t("clubAdmin.historyData.at"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.payedAt).utc().format("DD/MM/YYYY HH:mm")
                                                        })
                                                    ]
                                                })
                                            }),
                                            (booking === null || booking === void 0 ? void 0 : booking.canceled) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                                    variant: "caption",
                                                    children: [
                                                        t("clubAdmin.historyData.canceledBy"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                            children: booking === null || booking === void 0 ? void 0 : (_booking_CanceledBy = booking.CanceledBy) === null || _booking_CanceledBy === void 0 ? void 0 : _booking_CanceledBy.name
                                                        }),
                                                        " ",
                                                        t("clubAdmin.historyData.at"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.canceledAt).utc().format("DD/MM/YYYY HH:mm")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8smOS.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8975e70417897b8$export$e3da0e99c81a4b99), {
                        variant: "outlined",
                        disabled: submitting.current,
                        onClick: onClose,
                        children: t("back")
                    }),
                    !booking.canceled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8975e70417897b8$export$e3da0e99c81a4b99), {
                        color: "error",
                        variant: "contained",
                        disabled: submitting.current,
                        onClick: handleCancelBooking,
                        children: t("cancel")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8975e70417897b8$export$e3da0e99c81a4b99), {
                        variant: "contained",
                        disabled: submitting.current,
                        onClick: handleCancelBooking,
                        children: t("contact")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e76a34dc688aa94a$export$97a0a8c219eb7de3), {
                booking: booking,
                open: cancelBookingModalOpen,
                onClose: ()=>setCancelBookingModalOpen(false),
                onDelete: handleDeleteBooking
            })
        ]
    });
};


var $a4e7e9dec2f48754$exports = {};

$parcel$export($a4e7e9dec2f48754$exports, "eventContainer", function () { return $a4e7e9dec2f48754$export$dca30930aad3a5c9; }, function (v) { return $a4e7e9dec2f48754$export$dca30930aad3a5c9 = v; });
$parcel$export($a4e7e9dec2f48754$exports, "fullWidth", function () { return $a4e7e9dec2f48754$export$f59aa6be2711b90; }, function (v) { return $a4e7e9dec2f48754$export$f59aa6be2711b90 = v; });
var $a4e7e9dec2f48754$export$dca30930aad3a5c9;
var $a4e7e9dec2f48754$export$f59aa6be2711b90;
$a4e7e9dec2f48754$export$dca30930aad3a5c9 = `wq46wa_eventContainer`;
$a4e7e9dec2f48754$export$f59aa6be2711b90 = `wq46wa_fullWidth`;



var $682k2 = parcelRequire("682k2");

var $1aJMc = parcelRequire("1aJMc");

var $fnVR5 = parcelRequire("fnVR5");

var $i1fqN = parcelRequire("i1fqN");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $eQAbb = parcelRequire("eQAbb");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $03ffebe7ebc4d2b8$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"
}), "EmojiEvents");


var $8a4fbd8ea892c79c$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($8a4fbd8ea892c79c$exports, "__esModule", {
    value: true
});
$8a4fbd8ea892c79c$exports.default = void 0;

var $8a4fbd8ea892c79c$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $8a4fbd8ea892c79c$var$_default = (0, $8a4fbd8ea892c79c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"
}), "Groups");
$8a4fbd8ea892c79c$exports.default = $8a4fbd8ea892c79c$var$_default;


var $f7697038e13bca27$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($f7697038e13bca27$exports, "__esModule", {
    value: true
});
$f7697038e13bca27$exports.default = void 0;

var $f7697038e13bca27$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $f7697038e13bca27$var$_default = (0, $f7697038e13bca27$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"
}), "Filter5");
$f7697038e13bca27$exports.default = $f7697038e13bca27$var$_default;


var $31c652127016ce80$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($31c652127016ce80$exports, "__esModule", {
    value: true
});
$31c652127016ce80$exports.default = void 0;

var $31c652127016ce80$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $31c652127016ce80$var$_default = (0, $31c652127016ce80$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3 1 9l11 6 9-4.91V17h2V9L12 3z"
}), "School");
$31c652127016ce80$exports.default = $31c652127016ce80$var$_default;


const $548605d19f9602bc$var$ReservationTypeIcon = ({ reservationType: reservationType })=>{
    switch(reservationType){
        case "PRIVATE":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQAbb))), {
                fontSize: "small"
            });
        case "CLASSES":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($31c652127016ce80$exports))), {
                fontSize: "small"
            });
        case "CLASSES_PACK":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f7697038e13bca27$exports))), {
                fontSize: "small"
            });
        case "TEAM_BUILDING":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8a4fbd8ea892c79c$exports))), {
                fontSize: "small"
            });
        case "TOURNAMENT":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $03ffebe7ebc4d2b8$export$2e2bcd8739ae039), {
                fontSize: "small"
            });
        default:
            return null;
    }
};
var $548605d19f9602bc$export$2e2bcd8739ae039 = $548605d19f9602bc$var$ReservationTypeIcon;


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5x2Vb))));
const $993ca05831a04f77$export$ee2e924d6e1cf69d = ({ bookings: bookings, currDate: currDate, options: options = {
    slotInterval: "00:30"
}, selectedAreaInfo: selectedAreaInfo, onNewBooking: onNewBooking, onBookingDelete: onBookingDelete, onDateChange: onDateChange })=>{
    const { i18n: i18n, t: t } = (0, $doyfp.useTranslation)();
    const calendarRef = (0, $7fPBF.useRef)(null);
    //AppContext
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const appClub = appContext.club;
    const [selectedEvent, setSelectedEvent] = (0, $7fPBF.useState)(null);
    const [bookingModalOpen, setBookingModalOpen] = (0, $7fPBF.useState)(false);
    const [newDate, setNewDate] = (0, $7fPBF.useState)("");
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const getCalendarApi = ()=>{
        if (!calendarRef.current) return null;
        const current = calendarRef.current;
        return current.getApi();
    };
    const calendarDate = (0, $7fPBF.useMemo)(()=>{
        const calendarAPI = getCalendarApi();
        if (calendarAPI) calendarAPI.gotoDate(currDate);
        return currDate;
    }, [
        currDate
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const calendarAPI = getCalendarApi();
        if (!calendarAPI) return;
        calendarAPI.getEvents().forEach((elem)=>{
            elem.remove();
        });
        const colors = [
            "#2196F3",
            "#4CAF50",
            "#673AB7",
            "#FF9800",
            "#2196F3"
        ];
        const areas = [];
        bookings === null || bookings === void 0 ? void 0 : bookings.forEach((booking)=>{
            var _booking_area, _booking_area1, _booking_area2, _booking_area3;
            if (!areas.includes((_booking_area = booking.area) === null || _booking_area === void 0 ? void 0 : _booking_area.id)) areas.push((_booking_area1 = booking.area) === null || _booking_area1 === void 0 ? void 0 : _booking_area1.id);
            const bookingFrom = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.from).utc();
            const bookingTo = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.to).utc();
            const start = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).set("hour", bookingFrom.hour()).set("minute", bookingFrom.minute()).toISOString();
            const end = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).set("hour", bookingTo.hour()).set("minute", bookingTo.minute()).toISOString();
            const isCanceled = booking.canceled;
            calendarAPI.addEvent({
                id: booking.id,
                groupId: (_booking_area2 = booking.area) === null || _booking_area2 === void 0 ? void 0 : _booking_area2.id,
                title: isCanceled ? `${booking.name} (${t("canceled")})` : booking.name,
                start: start,
                end: end,
                display: "block",
                overlap: isCanceled,
                color: isCanceled ? "#757575" : colors[areas.indexOf((_booking_area3 = booking.area) === null || _booking_area3 === void 0 ? void 0 : _booking_area3.id) % colors.length],
                extendedProps: booking
            });
        });
    }, [
        bookings
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const calendarAPI = getCalendarApi();
        if (!calendarAPI) return;
        const newDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(calendarAPI.getDate());
        onDateChange(newDate.utc().format("YYYY-MM-DD"));
    }, [
        newDate
    ]);
    const handleEventClick = (clickInfo)=>{
        setSelectedEvent(clickInfo.event);
        setBookingModalOpen(true);
    };
    const handleIsSelectAllowed = (selectionInfo)=>{
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.start);
        const end = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.end);
        const correctMinutes = (0, $682k2.timeStringToMinutes)(options.slotInterval);
        const selectMinutes = end.diff(start, "minutes");
        return selectMinutes % correctMinutes === 0;
    };
    const isSelectionOverlapping = (selectionInfo)=>{
        const calendarAPI = getCalendarApi();
        if (!calendarAPI) return;
        let isOverlapping = false;
        calendarAPI.getEvents().forEach((elem)=>{
            if (!elem.overlap && (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.start).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(elem.extendedProps.from)) && (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.end).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(elem.extendedProps.to))) isOverlapping = true;
        });
        return isOverlapping;
    };
    const handleDateSelect = (selectionInfo)=>{
        const calendarAPI = getCalendarApi();
        if (!calendarAPI) return;
        const start = calendarAPI.currentData.currentViewType !== "timeGridDay" ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.start).format("YYYY-MM-DD") : (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.start).format("YYYY-MM-DDTHH:mm");
        const current = calendarAPI.currentData.currentViewType !== "timeGridDay" ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().format("YYYY-MM-DD") : (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().format("YYYY-MM-DDTHH:mm");
        const areaSchedules = (0, $1aJMc.generateOpeningHours)(selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.AreaSchedule, (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo === null || selectionInfo === void 0 ? void 0 : selectionInfo.start).locale("en").format("dddd").toUpperCase());
        const areaScheduleStart = calendarAPI.currentData.currentViewType === "timeGridDay" ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.start).format("HH") < areaSchedules.from : false;
        const areaScheduleEnd = calendarAPI.currentData.currentViewType === "timeGridDay" ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(selectionInfo.end).format("HH") > areaSchedules.to : false;
        if (areaScheduleStart || areaScheduleEnd) {
            calendarAPI.unselect();
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubAdmin.bookings.error.scheduleError")
            });
            return;
        }
        if (start < current) {
            calendarAPI.unselect();
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubAdmin.bookings.error.pastDate")
            });
            return;
        }
        if (appClub === null) {
            calendarAPI.unselect();
            setSnackbar({
                open: true,
                title: t("clubAdmin.bookings.error.noSelectedClubTitle"),
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubAdmin.bookings.error.noSelectedClub")
            });
            return;
        }
        if (isSelectionOverlapping(selectionInfo)) {
            calendarAPI.unselect();
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubAdmin.bookings.error.overlappingEvents")
            });
            return;
        }
        if (!handleIsSelectAllowed(selectionInfo)) {
            calendarAPI.unselect();
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: t("clubAdmin.bookings.error.invalidInterval").replace("{{time}}", `${options.slotInterval}h`)
            });
            return;
        }
        onNewBooking(selectionInfo.start, selectionInfo.end);
    };
    const handleDeleteEvent = ()=>{
        onBookingDelete(selectedEvent.id);
        setSelectedEvent(null);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a4e7e9dec2f48754$exports))).fullWidth,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ebe887ed207f0a89$export$2e2bcd8739ae039), {
                ref: calendarRef,
                plugins: [
                    (0, $a4a6497eb8588cfa$export$2e2bcd8739ae039),
                    (0, $481fb9d4622654d7$export$2e2bcd8739ae039),
                    (0, $a4d9a0c10526343d$export$2e2bcd8739ae039)
                ],
                headerToolbar: {
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,dayGridWeek,timeGridDay"
                },
                timeZone: "UTC",
                locales: [
                    (0, $74d3a9284317db0a$export$2e2bcd8739ae039),
                    (0, $537063cc3b82d520$export$2e2bcd8739ae039)
                ],
                locale: i18n.language,
                slotLabelFormat: {
                    hour: "2-digit",
                    minute: "2-digit"
                },
                slotLabelInterval: "01:00",
                slotDuration: "00:30",
                height: "90vh",
                scrollTime: "09:00",
                allDaySlot: false,
                selectable: true,
                selectMirror: true,
                // selectOverlap={false}
                initialView: "dayGridMonth",
                initialDate: calendarDate,
                dayMaxEvents: true,
                eventContent: $993ca05831a04f77$var$renderEventContent,
                eventClick: handleEventClick,
                select: handleDateSelect,
                datesSet: (info)=>setNewDate(info.start.toISOString()),
                now: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().format("YYYY-MM-DD"),
                businessHours: [
                    {
                        daysOfWeek: [
                            1,
                            2,
                            3,
                            4,
                            5
                        ],
                        startTime: "00:00",
                        endTime: "23:00"
                    }
                ]
            }),
            selectedEvent && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4fb093c442302189$export$e794b6ad1b0843e5), {
                booking: selectedEvent.extendedProps,
                open: bookingModalOpen,
                onClose: ()=>setBookingModalOpen(false),
                onDelete: handleDeleteEvent
            })
        ]
    });
};
function $993ca05831a04f77$var$renderEventContent(eventInfo) {
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a4e7e9dec2f48754$exports))).eventContainer,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                        children: eventInfo.timeText
                    }),
                    "\xa0",
                    eventInfo.event.title
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $548605d19f9602bc$export$2e2bcd8739ae039), {
                reservationType: eventInfo.event.extendedProps.reservationType
            })
        ]
    });
}



var $930Hd = parcelRequire("930Hd");

var $afCHG = parcelRequire("afCHG");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gC25j = parcelRequire("gC25j");
var $gXHSV = parcelRequire("gXHSV");
var $hG0Cb = parcelRequire("hG0Cb");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $2hGJ2 = parcelRequire("2hGJ2");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $9bb9ff31cd43576c$var$_ = (t)=>t, $9bb9ff31cd43576c$var$t, $9bb9ff31cd43576c$var$t1, $9bb9ff31cd43576c$var$t2;
const $9bb9ff31cd43576c$export$277414304e872396 = (0, $6hfZk.default).div($9bb9ff31cd43576c$var$t || ($9bb9ff31cd43576c$var$t = $9bb9ff31cd43576c$var$_`
    background-color: #fff;
    cursor: pointer;
    border-radius: 8px;
    padding: 16px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 2;
`));
const $9bb9ff31cd43576c$export$3a30621a8b0c1490 = (0, $6hfZk.default).button($9bb9ff31cd43576c$var$t1 || ($9bb9ff31cd43576c$var$t1 = $9bb9ff31cd43576c$var$_`
    display: block;
    cursor: pointer;
    text-align: left;
    justify-content: left;
    padding: 0;
    position: relative;
    z-index: 2;
    margin-top: 10px;
    text-transform: none;
    background-color: transparent;
    border: none;
    font-size: 14px;
    color: var(--color-primary);

    &:hover {
        text-decoration: underline;
        background: none;
    }
`));
const $9bb9ff31cd43576c$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($9bb9ff31cd43576c$var$t2 || ($9bb9ff31cd43576c$var$t2 = $9bb9ff31cd43576c$var$_`
    padding: 0 16px !important;
`));




var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
var $5b492b5e04078fcf$exports = {};

$5b492b5e04078fcf$exports = new URL((parcelRequire("4SSe9")).resolve("aS17W"), import.meta.url).toString();


var $c74d49d89d9d70a9$exports = {};

$c74d49d89d9d70a9$exports = new URL((parcelRequire("4SSe9")).resolve("5mvir"), import.meta.url).toString();


var $edc3da435dbee4c0$exports = {};

$edc3da435dbee4c0$exports = new URL((parcelRequire("4SSe9")).resolve("6Lzxf"), import.meta.url).toString();


var $f646a632c70d166b$exports = {};

$f646a632c70d166b$exports = new URL((parcelRequire("4SSe9")).resolve("8wVkv"), import.meta.url).toString();


var $6f74eed80e0c4a73$exports = {};

$6f74eed80e0c4a73$exports = new URL((parcelRequire("4SSe9")).resolve("kAlgT"), import.meta.url).toString();


var $0caa9bac4f1879f2$exports = {};

$0caa9bac4f1879f2$exports = new URL((parcelRequire("4SSe9")).resolve("it1iL"), import.meta.url).toString();


var $c5989d5e88a86877$exports = {};

$c5989d5e88a86877$exports = new URL((parcelRequire("4SSe9")).resolve("9dM0C"), import.meta.url).toString();


var $22d8bce80346deac$exports = {};

$22d8bce80346deac$exports = new URL((parcelRequire("4SSe9")).resolve("ivVlQ"), import.meta.url).toString();


var $e8390278303a4af3$exports = {};

$e8390278303a4af3$exports = new URL((parcelRequire("4SSe9")).resolve("dae82"), import.meta.url).toString();


var $74545e1e4b5369db$exports = {};

$74545e1e4b5369db$exports = new URL((parcelRequire("4SSe9")).resolve("kRcwS"), import.meta.url).toString();


var $578109ea02bcb156$exports = {};

$578109ea02bcb156$exports = new URL((parcelRequire("4SSe9")).resolve("aZE5b"), import.meta.url).toString();


const $40310fb81b979c81$export$1a117bf49afe5601 = {
    andebol: (0, (/*@__PURE__*/$parcel$interopDefault($5b492b5e04078fcf$exports))),
    basquetebol: (0, (/*@__PURE__*/$parcel$interopDefault($c74d49d89d9d70a9$exports))),
    fut5: (0, (/*@__PURE__*/$parcel$interopDefault($edc3da435dbee4c0$exports))),
    fut7: (0, (/*@__PURE__*/$parcel$interopDefault($f646a632c70d166b$exports))),
    futebol: (0, (/*@__PURE__*/$parcel$interopDefault($6f74eed80e0c4a73$exports))),
    futsal: (0, (/*@__PURE__*/$parcel$interopDefault($0caa9bac4f1879f2$exports))),
    hoquei_patins: (0, (/*@__PURE__*/$parcel$interopDefault($c5989d5e88a86877$exports))),
    padel: (0, (/*@__PURE__*/$parcel$interopDefault($22d8bce80346deac$exports))),
    squash: (0, (/*@__PURE__*/$parcel$interopDefault($e8390278303a4af3$exports))),
    tenis: (0, (/*@__PURE__*/$parcel$interopDefault($74545e1e4b5369db$exports))),
    voleibol: (0, (/*@__PURE__*/$parcel$interopDefault($578109ea02bcb156$exports)))
};



var $6hfZk = parcelRequire("6hfZk");

var $aili3 = parcelRequire("aili3");
let $0a693059d5f9283e$var$_ = (t)=>t, $0a693059d5f9283e$var$t, $0a693059d5f9283e$var$t1;
const $0a693059d5f9283e$export$635fecf246b00f28 = (0, $6hfZk.default)((0, $aili3.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "selected"
})($0a693059d5f9283e$var$t1 || ($0a693059d5f9283e$var$t1 = $0a693059d5f9283e$var$_`
    position: relative;
    display: inline-block;
    padding-right: 5px;

    img {
        width: 16px;
        height: 16px;

        ${0}
    }
`), ({ selected: selected })=>selected && (0, $6hfZk.css)($0a693059d5f9283e$var$t || ($0a693059d5f9283e$var$t = $0a693059d5f9283e$var$_`
                filter: invert(1);
            `)));


const $2a1a4fc57da56c62$export$76b259acec9cae97 = ({ category: category, selected: selected, ...remainingProps })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0a693059d5f9283e$export$635fecf246b00f28), {
        selected: selected,
        ...remainingProps,
        children: typeof category === "string" && /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
            src: (0, $40310fb81b979c81$export$1a117bf49afe5601)[category.toLowerCase()],
            alt: ""
        })
    });
};


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $1ea280f194c772d5$var$BookingCard = ({ booking: booking, onClick: onClick, onCancel: onCancel, onContact: onContact })=>{
    const { t: t, i18n: i18n } = (0, $doyfp.useTranslation)();
    const [shareModalOpen, setShareModalOpen] = (0, $7fPBF.useState)(false);
    const readableDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).locale(i18n.language).utc().format("ddd, DD MMMM YYYY");
    const isDeleted = booking.canceled;
    const handleCancelClick = (e)=>{
        e.stopPropagation();
        onCancel();
    };
    const handleCardClick = (e)=>{
        e.stopPropagation();
        onClick();
    };
    const handleShareClick = (e)=>{
        e.stopPropagation();
        setShareModalOpen(true);
    };
    const handleContactClick = (e)=>{
        e.stopPropagation();
        onContact();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9bb9ff31cd43576c$export$277414304e872396), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                sx: {
                    opacity: isDeleted ? "0.7" : undefined
                },
                onClick: handleCardClick,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                variant: "h6",
                                children: [
                                    "#",
                                    booking.shareId
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a1a4fc57da56c62$export$76b259acec9cae97), {
                                category: booking.category
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                        variant: "overline",
                        children: [
                            booking.club.name,
                            " - ",
                            booking.name,
                            " - ",
                            t(`search.sports.${booking.category.toLocaleLowerCase()}`)
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        direction: "row",
                        alignItems: "center",
                        flexWrap: "wrap",
                        useFlexGap: true,
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                variant: "caption",
                                children: readableDate
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                color: "tealLighten5",
                                size: "small",
                                label: `${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.from).utc().format("HH:mm")} - ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.to).utc().format("HH:mm")}`
                            }),
                            booking.isPayed ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                color: "success",
                                size: "small",
                                label: t("paymentConfirmed")
                            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                size: "small",
                                label: t("paymentNotConfirmed")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                children: !isDeleted && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9bb9ff31cd43576c$export$3a30621a8b0c1490), {
                            onClick: handleShareClick,
                            children: [
                                t("shareBooking.shareLink"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f626810b4000bbbe$export$eb64062c68bca198), {
                            booking: booking,
                            open: shareModalOpen,
                            onClose: ()=>setShareModalOpen(false)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                direction: "row",
                spacing: 2,
                mt: 2,
                children: [
                    isDeleted ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9bb9ff31cd43576c$export$e3da0e99c81a4b99), {
                        fullWidth: true,
                        variant: "contained",
                        disabled: true,
                        children: t("canceled")
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9bb9ff31cd43576c$export$e3da0e99c81a4b99), {
                        fullWidth: true,
                        variant: "outlined",
                        size: "small",
                        onClick: handleCancelClick,
                        children: t("cancel")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9bb9ff31cd43576c$export$e3da0e99c81a4b99), {
                        fullWidth: true,
                        variant: "contained",
                        size: "small",
                        color: "darkGrey",
                        onClick: handleContactClick,
                        children: t("contact")
                    })
                ]
            })
        ]
    });
};
var $1ea280f194c772d5$export$2e2bcd8739ae039 = $1ea280f194c772d5$var$BookingCard;


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $26a8ea32b99bba56$export$93d3c4cfea9ed490 = ({ bookings: bookings, clubId: clubId, onBookingDelete: onBookingDelete, onIsPaidUpdate: onIsPaidUpdate, history: history })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const [bookingModalOpen, setBookingModalOpen] = (0, $7fPBF.useState)(false);
    const [selectedBooking, setSelectedBooking] = (0, $7fPBF.useState)(null);
    const handleBookingClick = (booking)=>{
        setSelectedBooking(booking);
        setBookingModalOpen(true);
    };
    if (bookings.length === 0) return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gC25j.default), {
        variant: "filled",
        severity: "info",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gXHSV.default), {
                children: t("clubAdmin.bookings.noBookings")
            }),
            t("clubAdmin.bookings.noBookingsResult")
        ]
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
                width: "100%",
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    md: "1fr 1fr"
                },
                spacing: 2,
                useFlexGap: true,
                children: bookings.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(a.from).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(b.from)) ? 1 : -1).map((booking)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ea280f194c772d5$export$2e2bcd8739ae039), {
                        booking: booking,
                        onClick: ()=>handleBookingClick(booking),
                        onCancel: ()=>navigate(`/club-admin/club/${clubId}/booking/${booking.id}/cancel`),
                        onContact: ()=>window.location.href = `mailto:${booking.email}`
                    }, booking.id))
            }),
            selectedBooking && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4fb093c442302189$export$e794b6ad1b0843e5), {
                booking: selectedBooking,
                open: bookingModalOpen,
                onClose: ()=>setBookingModalOpen(false),
                onDelete: ()=>onBookingDelete(selectedBooking.id),
                onIsPaidUpdate: (isPaid)=>onIsPaidUpdate(selectedBooking.id, isPaid),
                historyFeatureToggle: history
            })
        ]
    });
};



var $hyW56 = parcelRequire("hyW56");

var $i1fqN = parcelRequire("i1fqN");

var $dNYY5 = parcelRequire("dNYY5");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aUdfW = parcelRequire("aUdfW");
var $8smOS = parcelRequire("8smOS");
var $8wwTv = parcelRequire("8wwTv");
var $eNZsp = parcelRequire("eNZsp");
var $8TDId = parcelRequire("8TDId");

var $hKUqD = parcelRequire("hKUqD");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $3jMGu = parcelRequire("3jMGu");
var $lHSFU = parcelRequire("lHSFU");
var $58CWL = parcelRequire("58CWL");
var $hG0Cb = parcelRequire("hG0Cb");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $1ZNeQ = parcelRequire("1ZNeQ");

var $7xRAC = parcelRequire("7xRAC");
var $ea56c01c193ff21f$export$67e02fa760e0413a;
(function(ReservationTypeEnum) {
    ReservationTypeEnum["PRIVATE"] = "PRIVATE";
    ReservationTypeEnum["CLASSES"] = "CLASSES";
    ReservationTypeEnum["CLASSES_PACK"] = "CLASSES_PACK";
    ReservationTypeEnum["TEAM_BUILDING"] = "TEAM_BUILDING";
    ReservationTypeEnum["TOURNAMENT"] = "TOURNAMENT";
})($ea56c01c193ff21f$export$67e02fa760e0413a || ($ea56c01c193ff21f$export$67e02fa760e0413a = {}));


const $0106a890f958b1bb$export$4845e299a8476eb0 = (t)=>{
    return $7xRAC.object({
        name: $7xRAC.string().min(3, t("validation.toShort")).max(50, t("validation.toLong")).required(t("validation.requiredName")),
        email: $7xRAC.string().email(t("validation.requiredValidEmail")).required(t("validation.requiredEmail")),
        mobilePhone: $7xRAC.string().matches(/^[0-9]+$/, t("validation.phoneOnlyNumber")).phone("PT", t("validation.requiredValidPhone")).required(t("validation.requiredPhone")),
        sport: $7xRAC.string().oneOf([
            "PADEL",
            "TENIS",
            "BASQUETEBOL",
            "ANDEBOL",
            "FUTEBOL",
            "FUT5",
            "FUT7",
            "FUTSAL",
            "SQUASH",
            "HOQUEI_PATINS",
            "VOLEIBOL"
        ], t("validation.requiredField")),
        reservationType: $7xRAC.string().default((0, $ea56c01c193ff21f$export$67e02fa760e0413a).PRIVATE),
        from: $7xRAC.date().required(t("validation.requiredField")),
        to: $7xRAC.date().min($7xRAC.ref("from"), t("validation.dateTo")).required(t("validation.requiredField"))
    });
};



var $afCHG = parcelRequire("afCHG");

var $8m7Fi = parcelRequire("8m7Fi");

var $5x2Vb = parcelRequire("5x2Vb");

var $5Bnf5 = parcelRequire("5Bnf5");

var $fnVR5 = parcelRequire("fnVR5");


var $930Hd = parcelRequire("930Hd");

var $YuiwO = parcelRequire("YuiwO");

var $1aJMc = parcelRequire("1aJMc");

var $i1fqN = parcelRequire("i1fqN");


parcelRequire("fI21S");
var $3irMb = parcelRequire("3irMb");

var $dNDci = parcelRequire("dNDci");
function $718a3211b59b8220$export$c33ee34973305fa8(role) {
    const appService = new (0, $dNDci.AppService)();
    const { isLoading: isLoading, data: data, mutate: mutate, isError: isError, error: error } = (0, $3irMb.useMutation)({
        mutationKey: [
            "createReservation"
        ],
        mutationFn: async (reservation)=>{
            const res = await appService.api_createBooking(role, reservation);
            return res;
        }
    });
    return {
        data: data,
        isLoading: isLoading,
        mutate: mutate,
        isError: isError,
        error: error
    };
}



var $7qlUi = parcelRequire("7qlUi");

var $3Ou5w = parcelRequire("3Ou5w");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5x2Vb))));
const $3d01f9bcfb088315$var$CreateBooking = ({ club: club, selectedArea: selectedArea, selectedSport: selectedSport, areaSports: areaSports, day: day, areaInfo: areaInfo, onSuccessSubmit: onSuccessSubmit })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const errorRef = (0, $7fPBF.useRef)(null);
    const { data: reservationCategories } = (0, $557a9dbb4cc5ad14$export$888e286a72668218)();
    const { mutate: createReservation, isError: isError } = (0, $718a3211b59b8220$export$c33ee34973305fa8)("public");
    const [clubArea, setClubArea] = (0, $7fPBF.useState)(selectedArea ? selectedArea : "all");
    const [selectedAreaInfo, setSelectedAreaInfo] = (0, $7fPBF.useState)(areaInfo);
    const [areaCategories, setAreaCategories] = (0, $7fPBF.useState)(areaSports);
    const [areaError, setAreaError] = (0, $7fPBF.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $7fPBF.useState)("");
    const selectedAreaSchedule = selectedAreaInfo ? (0, $1aJMc.generateOpeningHours)(selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.AreaSchedule, (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(day === null || day === void 0 ? void 0 : day.start).locale("en").format("dddd").toUpperCase()) : [];
    const minTime = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().set("hour", Number(selectedAreaSchedule.from)).startOf("hour");
    const maxTime = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().set("hour", Number(selectedAreaSchedule.to)).startOf("hour");
    const initialValues = {
        name: "",
        email: "",
        sport: selectedSport && selectedSport.length > 0 ? selectedSport[0] : "all",
        reservationType: "any",
        day: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(day === null || day === void 0 ? void 0 : day.start).format("YYYY-MM-DD"),
        from: day && (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(day === null || day === void 0 ? void 0 : day.start).format("HH:mm") !== "00:00" ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(day.start) : null,
        to: day && (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(day === null || day === void 0 ? void 0 : day.end).format("HH:mm") !== "00:00" ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(day.end) : null,
        mobilePhone: ""
    };
    const handleAreaChange = (e)=>{
        setClubArea(e.target.value);
        setAreaCategories((0, $1aJMc.getAreaCategories)(club === null || club === void 0 ? void 0 : club.areas, e.target.value));
        setSelectedAreaInfo((0, $1aJMc.getSelectedAreaInfo)(club === null || club === void 0 ? void 0 : club.areas, e.target.value));
        setAreaError(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        // Scroll to the error message when it appears
        if (errorRef.current) errorRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }, [
        isError
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $0106a890f958b1bb$export$4845e299a8476eb0)(t),
        enableReinitialize: true,
        validate: (values)=>{
            const isAreaError = clubArea === "all";
            setAreaError(isAreaError);
            try {
                (0, $0106a890f958b1bb$export$4845e299a8476eb0)(t).validateSync(values, {
                    abortEarly: false
                });
                return {};
            } catch (errors) {
                return errors.inner.reduce((acc, error)=>({
                        ...acc,
                        [error.path]: error.message
                    }), {});
            }
        },
        onSubmit: async (values)=>{
            var _values_sport;
            let responseStatus;
            const formData = {
                day: values.day,
                from: values.from,
                category: (_values_sport = values.sport) === null || _values_sport === void 0 ? void 0 : _values_sport.toUpperCase(),
                reservationType: values.reservationType !== "any" ? values.reservationType : (0, $ea56c01c193ff21f$export$67e02fa760e0413a).PRIVATE,
                to: values.to,
                name: values.name,
                email: values.email,
                mobilePhone: values.mobilePhone,
                timeUnit: selectedAreaInfo ? selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.timeUnit : areaInfo === null || areaInfo === void 0 ? void 0 : areaInfo.timeUnit,
                price: selectedAreaInfo ? Number(selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.price) : Number(areaInfo === null || areaInfo === void 0 ? void 0 : areaInfo.price),
                areaId: selectedAreaInfo ? selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.id : selectedArea
            };
            createReservation(formData, {
                onSuccess: (reservationData)=>{
                    responseStatus = reservationData.status;
                    if (reservationData.status !== 201) throw new Error();
                    setSnackbar({
                        open: true,
                        title: t(`clubAdmin.bookings.success.title`, {
                            area: selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.name
                        }),
                        setOpen: ()=>{
                            setSnackbar({
                                open: false,
                                children: null,
                                setOpen: ()=>{}
                            });
                        },
                        severity: "success",
                        children: t(`clubAdmin.bookings.success.${reservationData.status}`, {
                            area: selectedAreaInfo === null || selectedAreaInfo === void 0 ? void 0 : selectedAreaInfo.name,
                            clientName: values.name,
                            day: values.day,
                            from: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(values.from).format("HH:mm"),
                            to: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(values.to).format("HH:mm"),
                            email: values.email
                        })
                    });
                    appContext.setNewBookings(true);
                    onSuccessSubmit();
                },
                onError: ()=>{
                    setErrorMessage(t(`clubAdmin.bookings.error.${responseStatus}`));
                }
            });
        },
        children: (props)=>{
            var _club_areas;
            /*#__PURE__*/ return (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Form), {
                    id: "form-createBooking",
                    onSubmit: props.handleSubmit,
                    className: "w-100",
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                className: "w-100",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                        required: true,
                                        children: t("area")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                                        variant: "outlined",
                                        error: areaError,
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $930Hd.Select), {
                                            id: "areaName",
                                            name: "areaId",
                                            labelId: "areaId",
                                            value: clubArea,
                                            onChange: (e)=>handleAreaChange(e),
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "all",
                                                    children: t("clubAdmin.bookings.allAreas")
                                                }),
                                                (_club_areas = club.areas) === null || _club_areas === void 0 ? void 0 : _club_areas.map((area)=>{
                                                    /*#__PURE__*/ return (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                        value: area.id,
                                                        children: area === null || area === void 0 ? void 0 : area.name
                                                    }, area.id);
                                                })
                                            ]
                                        })
                                    }),
                                    areaError && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                        children: t("validation.requiredField")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                className: "w-100",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                        required: true,
                                        children: t("clubAdmin.bookings.inputLabel.selectedSport")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                                        className: "w-100",
                                        variant: "outlined",
                                        error: props.touched.sport && Boolean(props.errors.sport),
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $930Hd.Select), {
                                            name: "sport",
                                            labelId: "sport",
                                            value: props.values.sport,
                                            onChange: props.handleChange,
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                    value: "all",
                                                    selected: true,
                                                    children: t("clubAdmin.bookings.selectCategory")
                                                }),
                                                props.values.selectedArea === "all" ? areaSports === null || areaSports === void 0 ? void 0 : areaSports.map((category)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                        value: category.category,
                                                        children: category.category
                                                    }, category.category)) : areaCategories === null || areaCategories === void 0 ? void 0 : areaCategories.map((category)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                        value: category.category,
                                                        children: category.category
                                                    }, category.category))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                        name: "sport",
                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                children: msg
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7qlUi.FeatureToggleBaseComponent), {
                                featureToggle: (0, $3Ou5w.FeatureToggles).RESERVATION_TYPES,
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                    className: "w-100",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                            children: t("clubAdmin.bookings.inputLabel.reservationType")
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                                            className: "w-100",
                                            variant: "outlined",
                                            error: props.touched.reservationType && Boolean(props.errors.reservationType),
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $930Hd.Select), {
                                                name: "reservationType",
                                                labelId: "reservationType",
                                                value: props.values.reservationType,
                                                onChange: props.handleChange,
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                        value: "any",
                                                        selected: true,
                                                        children: t("clubAdmin.bookings.reservationTypes.selectReservationType")
                                                    }),
                                                    reservationCategories === null || reservationCategories === void 0 ? void 0 : reservationCategories.map((category)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                            value: category,
                                                            children: t(`clubAdmin.bookings.reservationTypes.${category.toLowerCase()}`)
                                                        }, category))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                            name: "reservationType",
                                            children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                    children: msg
                                                })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                className: "w-100",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                    id: "clientName",
                                    name: "name",
                                    placeholder: t("clubAdmin.bookings.inputPlaceholder.clientName"),
                                    type: "text",
                                    value: props.values.name,
                                    hasLabelTop: true,
                                    labelTop: t("clubAdmin.bookings.inputLabel.clientName"),
                                    labelTopRequired: true,
                                    onChange: props.handleChange,
                                    error: props.touched.name && Boolean(props.errors.name),
                                    helperText: props.touched.name && props.errors.name
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                className: "w-100",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                    id: "clientEmail",
                                    name: "email",
                                    placeholder: t("clubAdmin.bookings.inputPlaceholder.clientEmail"),
                                    type: "email",
                                    value: props.values.email,
                                    hasLabelTop: true,
                                    labelTop: t("clubAdmin.bookings.inputLabel.clientEmail"),
                                    labelTopRequired: true,
                                    onChange: props.handleChange,
                                    error: props.touched.email && Boolean(props.errors.email),
                                    helperText: props.touched.email && props.errors.email
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                className: "w-100",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                    id: "clientMobilePhone",
                                    name: "mobilePhone",
                                    placeholder: t("clubDetails.step.inputPlaceholder.clubPhone"),
                                    type: "tel",
                                    value: props.values.mobilePhone,
                                    hasLabelTop: true,
                                    labelTop: t("clubDetails.step.inputLabel.clubMobile"),
                                    labelTopRequired: true,
                                    onChange: props.handleChange,
                                    error: props.touched.mobilePhone && Boolean(props.errors.mobilePhone),
                                    helperText: props.touched.mobilePhone && props.errors.mobilePhone
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                className: "w-100",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                    id: "selectedDay",
                                    name: "day",
                                    type: "text",
                                    value: props.values.day,
                                    hasLabelTop: true,
                                    labelTop: t("clubAdmin.bookings.inputLabel.selectedDay"),
                                    disabled: true
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                className: "w-100",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                        required: true,
                                        children: t("schedule")
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b095e62db41017b4$export$acdc83b53a3e85ba), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                                    className: "w-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $YuiwO.default), {
                                                            name: "from",
                                                            label: t("search.fields.time"),
                                                            error: props.touched.from && Boolean(props.errors.from),
                                                            value: props.values.from,
                                                            disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().utc().format("YYYY-MM-DD") === props.values.day ? true : false,
                                                            minTime: minTime,
                                                            maxTime: maxTime,
                                                            onChange: (newValue)=>props.setFieldValue("from", newValue, true)
                                                        }),
                                                        props.touched.from && props.errors.from && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                            children: props.errors.from
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                                    className: "w-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $YuiwO.default), {
                                                            name: "to",
                                                            error: props.touched.to && Boolean(props.errors.to),
                                                            label: t("search.fields.endTime"),
                                                            value: props.values.to,
                                                            minTime: minTime,
                                                            maxTime: maxTime,
                                                            onChange: (newValue)=>props.setFieldValue("to", newValue, true)
                                                        }),
                                                        props.touched.to && props.errors.to && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                            children: props.errors.to
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isError && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$38fb881472c4cc64), {
                                severity: "error",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    ref: errorRef,
                                    children: errorMessage
                                })
                            })
                        ]
                    })
                })
            });
        }
    });
};
var $3d01f9bcfb088315$export$2e2bcd8739ae039 = $3d01f9bcfb088315$var$CreateBooking;



(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $9c59c6ae1d82ac72$export$65dfe8a0c60e163c = ({ open: open, onClose: onClose, club: club, selectedDay: selectedDay, selectedArea: selectedArea, selectedSport: selectedSport, areaSports: areaSports, selectedAreaInfo: selectedAreaInfo })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aUdfW.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $eNZsp.default), {
                sx: {
                    m: 0,
                    p: 2
                },
                children: [
                    t("clubAdmin.newCalendarBookingModal.title"),
                    " [",
                    club === null || club === void 0 ? void 0 : club.name,
                    "]"
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                "aria-label": "close",
                onClick: onClose,
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hKUqD))), {})
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8wwTv.default), {
                dividers: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3d01f9bcfb088315$export$2e2bcd8739ae039), {
                    club: club,
                    day: selectedDay,
                    selectedArea: selectedArea,
                    selectedSport: selectedSport,
                    areaSports: areaSports,
                    areaInfo: selectedAreaInfo,
                    onSuccessSubmit: onClose
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8smOS.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $710ebbe44120c3f0$export$e3da0e99c81a4b99), {
                        variant: "outlined",
                        onClick: onClose,
                        children: t("back")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $710ebbe44120c3f0$export$e3da0e99c81a4b99), {
                        variant: "contained",
                        form: `form-createBooking`,
                        type: "submit",
                        children: t("bookArea")
                    })
                ]
            })
        ]
    });
};



var $dkKmP = parcelRequire("dkKmP");

var $fnVR5 = parcelRequire("fnVR5");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $aili3 = parcelRequire("aili3");
var $2hGJ2 = parcelRequire("2hGJ2");
var $a2ay0 = parcelRequire("a2ay0");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $20da120e82cd7a77$var$_ = (t)=>t, $20da120e82cd7a77$var$t, $20da120e82cd7a77$var$t1, $20da120e82cd7a77$var$t2, $20da120e82cd7a77$var$t3, $20da120e82cd7a77$var$t4, $20da120e82cd7a77$var$t5, $20da120e82cd7a77$var$t6, $20da120e82cd7a77$var$t7, $20da120e82cd7a77$var$t8, $20da120e82cd7a77$var$t9;
const $20da120e82cd7a77$export$2220ad8536fc32db = (0, $6hfZk.default).p($20da120e82cd7a77$var$t || ($20da120e82cd7a77$var$t = $20da120e82cd7a77$var$_`
    color: var(--custom-secondary);
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    padding: 0 16px;
`));
const $20da120e82cd7a77$export$db786b39d2e28efc = (0, $6hfZk.default).p($20da120e82cd7a77$var$t1 || ($20da120e82cd7a77$var$t1 = $20da120e82cd7a77$var$_`
    color: var(--color-primary);
    background: rgba(25, 118, 210, 0.12);
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
    padding: 6px;
}`));
const $20da120e82cd7a77$export$d4790538dd500f21 = (0, $6hfZk.default).p($20da120e82cd7a77$var$t2 || ($20da120e82cd7a77$var$t2 = $20da120e82cd7a77$var$_`
    color: var(--custom-secondary);
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    padding: 6px;
`));
const $20da120e82cd7a77$export$49c5249628b2dbe4 = (0, $6hfZk.default)((0, $2hGJ2.default))($20da120e82cd7a77$var$t3 || ($20da120e82cd7a77$var$t3 = $20da120e82cd7a77$var$_`
    font-size: 12px !important;
`));
const $20da120e82cd7a77$export$85223b1dda938d1a = (0, $6hfZk.default)((0, $a2ay0.default))($20da120e82cd7a77$var$t4 || ($20da120e82cd7a77$var$t4 = $20da120e82cd7a77$var$_`
    margin: 16px;
    margin-bottom: 0;
    border-radius: 0;
`));
const $20da120e82cd7a77$export$e3826e1733c980d = (0, $6hfZk.default)((0, $aili3.default))($20da120e82cd7a77$var$t5 || ($20da120e82cd7a77$var$t5 = $20da120e82cd7a77$var$_`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    padding: 6px;
`));
const $20da120e82cd7a77$export$e9972592ca31d05c = (0, $6hfZk.default)((0, $aili3.default))($20da120e82cd7a77$var$t6 || ($20da120e82cd7a77$var$t6 = $20da120e82cd7a77$var$_`
    display: grid;
    grid-template-columns: 30% auto;
    align-items: center;
`));
const $20da120e82cd7a77$export$1d41361302b577a1 = (0, $6hfZk.default)((0, $aili3.default))($20da120e82cd7a77$var$t7 || ($20da120e82cd7a77$var$t7 = $20da120e82cd7a77$var$_`
    display: flex;
    flex-direction: column;
    gap: 8px;
`));
const $20da120e82cd7a77$export$fa0c6b1d24ae1c7e = (0, $6hfZk.default).p($20da120e82cd7a77$var$t8 || ($20da120e82cd7a77$var$t8 = $20da120e82cd7a77$var$_`
    padding: 0;
    margin: 0;
    font-size: 12px;
`));
const $20da120e82cd7a77$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($20da120e82cd7a77$var$t9 || ($20da120e82cd7a77$var$t9 = $20da120e82cd7a77$var$_`
    margin: 16px !important;
`));


parcelRequire("fI21S");
var $1HW2x = parcelRequire("1HW2x");

var $dNDci = parcelRequire("dNDci");

var $fnVR5 = parcelRequire("fnVR5");
function $1a1b491706c3747d$export$c8027b040cdd25c7(clubId, startDate, endDate) {
    const appService = new (0, $dNDci.AppService)();
    const { setIsShareButtonsVisible: setIsShareButtonsVisible } = (0, $fnVR5.useCommon)();
    const { isLoading: isLoading, data: data = [], isError: isError } = (0, $1HW2x.useQuery)({
        queryKey: [
            "availableSlots"
        ],
        queryFn: async ()=>{
            const res = await appService.api_getAvailableSlots(clubId, startDate, endDate);
            return res.data;
        },
        retry: false,
        onSuccess: ()=>{
            setIsShareButtonsVisible(true);
        },
        onError: ()=>{
            setIsShareButtonsVisible(false);
        }
    });
    return {
        data: data,
        isLoading: isLoading,
        isError: isError
    };
}



var $i1fqN = parcelRequire("i1fqN");

var $8m7Fi = parcelRequire("8m7Fi");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $iIluI = parcelRequire("iIluI");


const $9ecc8f4b2515346b$export$be8a2cb338d13d28 = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    //AppContext
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const club = appContext.club;
    const { clubId: clubId } = (0, $iIluI.useParams)();
    const currDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))();
    const nextDay = currDate.add(1, "day");
    const startDate = `${nextDay.format("YYYY-MM-DD")}T00:00.000Z`;
    const endDate = `${nextDay.format("YYYY-MM-DD")}T23:59.999Z`;
    const { data: data } = (0, $1a1b491706c3747d$export$c8027b040cdd25c7)(club ? club === null || club === void 0 ? void 0 : club.id : clubId, startDate, endDate);
    const currUrl = `${window.location.origin}/club/${club === null || club === void 0 ? void 0 : club.id}/available-slots`;
    const homeLink = `${window.location.origin}`;
    const message = (0, $7fPBF.useMemo)(()=>{
        var _data_areas;
        return t("shareAvailableSlotsMessage", {
            date: nextDay.format("DD-MM-YYYY"),
            clubName: data.club,
            area: (_data_areas = data.areas) === null || _data_areas === void 0 ? void 0 : _data_areas.map((area)=>`${area.name}: ${area.slots}\n`)
        }).replace("{{link}}", homeLink);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $20da120e82cd7a77$export$1d41361302b577a1), {
        children: [
            clubId !== undefined && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$2220ad8536fc32db), {
                        children: t("availableSlotsMessage")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$2220ad8536fc32db), {
                        children: t("availableSlotsDate", {
                            date: nextDay.format("DD-MM-YYYY")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $20da120e82cd7a77$export$85223b1dda938d1a), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$db786b39d2e28efc), {
                        children: data.club
                    }),
                    data && data.areas && data.areas.map((area, areaIndex)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $20da120e82cd7a77$export$e9972592ca31d05c), {
                            style: {
                                background: areaIndex % 2 !== 0 ? "#f2f2f2" : ""
                            },
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$d4790538dd500f21), {
                                    children: area.name
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$e3826e1733c980d), {
                                    children: area.slots && area.slots.length > 0 ? area.slots.map((slot, slotIndex)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$49c5249628b2dbe4), {
                                            label: slot
                                        }, slotIndex)) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$fa0c6b1d24ae1c7e), {
                                        children: t("shareAvailableSlotsNoSchedulesError")
                                    })
                                })
                            ]
                        }, area.id))
                ]
            }),
            clubId === undefined ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$b54ac9d7963ef6f6), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40aa70e50709aa5f$export$6065a61077043bd0), {
                    currUrl: currUrl,
                    message: message
                })
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20da120e82cd7a77$export$e3da0e99c81a4b99), {
                variant: "contained",
                sx: {
                    margin: "16px"
                },
                onClick: ()=>navigate("/search"),
                children: t("book")
            })
        ]
    });
};




var $icsrd = parcelRequire("icsrd");

var $7qlUi = parcelRequire("7qlUi");

var $3Ou5w = parcelRequire("3Ou5w");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $f0733c2c2aa9ef36$var$BookingsSearch = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const appService = new (0, $dNDci.AppService)();
    const theme = (0, $g9bTP.default)();
    const isSmallScreen = (0, $kspUS.default)(theme.breakpoints.down("sm"));
    const { data: clubs } = (0, $hyW56.useClubs)("private");
    //AppContext
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const club = appContext.club;
    const featureToggles = (0, $7fPBF.useContext)((0, $icsrd.FeatureTogglesContext));
    const clubFeatureToggle = featureToggles.featureToggles;
    const clubNewBookings = appContext.newBookings;
    const bookingUpdate = appContext.bookingUpdate;
    const initialValues = {
        selectedArea: "all",
        selectedSports: [],
        startDate: null,
        endDate: null,
        search: "",
        areaOptions: {
            slotInterval: "00:30"
        },
        newBookingDate: {
            start: new Date(),
            end: new Date()
        }
    };
    const [searchParams, setSearchParams] = (0, $dNYY5.useSearchParams)();
    const currDate = (0, $7fPBF.useMemo)(()=>{
        return searchParams.get("date") ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(searchParams.get("date")).format("YYYY-MM-DD") : (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().startOf("month").format("YYYY-MM-DD");
    }, [
        searchParams
    ]);
    const [bookings, setBookings] = (0, $7fPBF.useState)([]);
    const [isListView, setIsListView] = (0, $7fPBF.useState)(false);
    const [isFilterOpen, setIsFilterOpen] = (0, $7fPBF.useState)(false);
    const [newBookingModalOpen, setNewBookingModalOpen] = (0, $7fPBF.useState)(false);
    const [newBookingDate, setNewBookingDate] = (0, $7fPBF.useState)(initialValues.newBookingDate);
    const [selectedClubId, setSelectedClubId] = (0, $7fPBF.useState)("all");
    const [areas, setAreas] = (0, $7fPBF.useState)((club === null || club === void 0 ? void 0 : club.areas) ? club.areas : []);
    const [sports, setSports] = (0, $7fPBF.useState)((club === null || club === void 0 ? void 0 : club.categories) ? club.categories : []);
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const fetchData = async (apiEndpoint)=>{
        const firstDayOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(currDate).startOf("month").toISOString();
        const lastDayOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(currDate).endOf("month").toISOString();
        if (selectedClubId === "all") {
            localStorage.setItem("clubAdmin.selectedClub", JSON.stringify(null));
            appContext.setClub(null);
            setBookings([]);
            setAreas([]);
            setSports([]);
            return;
        }
        try {
            const [clubRes, bookingsRes] = await Promise.all([
                appService.api_getClub("private", {
                    clubId: selectedClubId
                }),
                appService[apiEndpoint]("private", selectedClubId, {
                    startDate: firstDayOfMonth,
                    endDate: lastDayOfMonth,
                    areaId: "",
                    sports: [],
                    search: ""
                })
            ]);
            if (clubRes.status !== 200) throw new Error();
            var _clubRes_data_categories;
            // Set club details
            setSports((_clubRes_data_categories = clubRes.data.categories) !== null && _clubRes_data_categories !== void 0 ? _clubRes_data_categories : []);
            setAreas(clubRes.data.areas);
            localStorage.setItem("clubAdmin.selectedClub", JSON.stringify(clubRes.data));
            appContext.setClub(clubRes.data);
            // Set bookings
            setBookings(bookingsRes.data);
        } catch (error) {
            console.error(error);
        }
    };
    const fetchReservation = async ()=>{
        await fetchData("api_getClubBookings");
    };
    const fetchHistory = async ()=>{
        await fetchData("api_getReservationHistory");
    };
    (0, $7fPBF.useEffect)(()=>{
        if (club) setSelectedClubId(club.id);
    }, [
        club
    ]);
    (0, $7fPBF.useEffect)(()=>{
        var _clubFeatureToggle_selectedClubId;
        if (selectedClubId !== "all" && ((_clubFeatureToggle_selectedClubId = clubFeatureToggle[selectedClubId]) === null || _clubFeatureToggle_selectedClubId === void 0 ? void 0 : _clubFeatureToggle_selectedClubId.length) >= 1) fetchHistory();
        else fetchReservation();
    }, [
        selectedClubId,
        currDate,
        clubFeatureToggle
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (clubNewBookings || bookingUpdate) {
            var _clubFeatureToggle_selectedClubId;
            if (((_clubFeatureToggle_selectedClubId = clubFeatureToggle[selectedClubId]) === null || _clubFeatureToggle_selectedClubId === void 0 ? void 0 : _clubFeatureToggle_selectedClubId.length) >= 1) fetchHistory();
            else fetchReservation();
        }
        return ()=>{
            appContext.setNewBookings(false);
            appContext.setBookingUpdate(false);
        };
    }, [
        clubNewBookings,
        bookingUpdate,
        clubFeatureToggle
    ]);
    const handleChangeCloseDate = (date)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    };
    const handleBookingListDelete = (id)=>{
        setBookings((prev)=>prev.map((a)=>{
                return a.id === id ? {
                    ...a,
                    canceled: true
                } : a;
            }));
    };
    const handleIsPaidChange = (id, isPaid)=>{
        setBookings((prev)=>prev.map((a)=>{
                return a.id === id ? {
                    ...a,
                    isPayed: isPaid
                } : a;
            }));
    };
    const handleCalendarChangeDate = (newDate)=>{
        if (!newDate) return;
        setSearchParams({
            date: newDate
        });
    };
    const handleNewBooking = (start, end)=>{
        setNewBookingDate({
            start: start,
            end: end
        });
        setNewBookingModalOpen(true);
    };
    const handleClubChange = (event)=>{
        setSelectedClubId(event.target.value);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9uOZr.Layout), {
        headerType: "menu",
        hideClubIcon: true,
        maxWidth: false,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG0Cb.default), {
                alignItems: "center",
                pb: 1,
                spacing: 2,
                mb: 3,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
                    initialValues: initialValues,
                    enableReinitialize: true,
                    validationSchema: "",
                    onSubmit: async (values)=>{
                        try {
                            if (clubFeatureToggle[selectedClubId].length === 0) {
                                const res = await appService.api_getClubBookings("private", selectedClubId, {
                                    startDate: values.startDate,
                                    endDate: values.endDate,
                                    areaId: values.selectedArea !== "all" ? values.selectedArea : "",
                                    sports: values.selectedSports,
                                    search: values.search
                                });
                                if (res.status !== 200) throw new Error();
                                setBookings(res.data);
                            } else {
                                const res = await appService.api_getReservationHistory("private", selectedClubId, {
                                    startDate: values.startDate,
                                    endDate: values.endDate,
                                    areaId: values.selectedArea !== "all" ? values.selectedArea : "",
                                    sports: values.selectedSports,
                                    search: values.search
                                });
                                if (res.status !== 200) throw new Error();
                                setBookings(res.data);
                            }
                        } catch (error) {
                            console.log(error);
                            setBookings([]);
                        }
                    },
                    children: (props)=>{
                        var _props_values_selectedSports, _clubFeatureToggle_selectedClubId;
                        /*#__PURE__*/ return (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$579a1e9bab103f15), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b095e62db41017b4$export$ab66e4aae63018c1), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b095e62db41017b4$export$eb3377d33cf857d6), {
                                                name: "selectedClub",
                                                labelId: "selectedClub",
                                                value: selectedClubId,
                                                onChange: handleClubChange,
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                        value: "all",
                                                        children: t("clubAdmin.bookings.allClubs")
                                                    }),
                                                    clubs === null || clubs === void 0 ? void 0 : clubs.map((club)=>{
                                                        /*#__PURE__*/ return (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                            value: club.id,
                                                            children: club === null || club === void 0 ? void 0 : club.name
                                                        }, club.id);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7qlUi.FeatureToggleBaseComponent), {
                                                featureToggle: (0, $3Ou5w.FeatureToggles).SHARE_AVAILABLE_SLOTS,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                                    variant: !isSmallScreen ? "contained" : "text",
                                                    startIcon: !isSmallScreen ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f159ab129bd778b8$exports))), {}) : null,
                                                    disabled: selectedClubId === "all" ? true : false,
                                                    onClick: ()=>{
                                                        setModal({
                                                            open: true,
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$5a0bc68f6657e9db), {
                                                                dividers: true,
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9ecc8f4b2515346b$export$be8a2cb338d13d28), {})
                                                            }),
                                                            title: t("booking.shareAvailableSlots")
                                                        });
                                                    },
                                                    children: !isSmallScreen ? t("booking.button.share") : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f159ab129bd778b8$exports))), {})
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $1ZNeQ.Form), {
                                    onSubmit: props.handleSubmit,
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b095e62db41017b4$export$18fbd793efee61f), {
                                            children: [
                                                props.values.selectedArea !== "" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                                    label: props.values.selectedArea === "all" ? t("clubAdmin.bookings.allAreas") : (0, $1aJMc.findAreaNameById)(props.values.selectedArea, areas)
                                                }),
                                                ((_props_values_selectedSports = props.values.selectedSports) === null || _props_values_selectedSports === void 0 ? void 0 : _props_values_selectedSports.length) > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                                    label: `${t("club.headers.sports")}: ${props.values.selectedSports.join(", ")}`
                                                }),
                                                props.values.startDate !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                                    label: `${t("from")}: ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(props.values.startDate).format("DD-MM-YYYY")}`
                                                }),
                                                props.values.endDate !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                                    label: `${t("to")}: ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(props.values.endDate).format("DD-MM-YYYY")}`
                                                }),
                                                props.values.search !== "" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                                    label: `${t("query")}: ${props.values.search}`
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                                                    "aria-label": "filter toggle",
                                                    onClick: ()=>setIsFilterOpen((prev)=>!prev),
                                                    sx: {
                                                        marginLeft: "auto"
                                                    },
                                                    children: isFilterOpen ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $433fb023fc001063$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e92d05408ee3d3db$export$2e2bcd8739ae039), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$a00c712da48b4cb5), {
                                            isFilterOpen: isFilterOpen,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b095e62db41017b4$export$3bb2bce6bb6f0906), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                                                variant: "outlined",
                                                                error: props.touched.selectedArea && Boolean(props.errors.selectedArea),
                                                                sx: {
                                                                    minWidth: "278px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                                                        children: t("clubAdmin.bookings.selectArea")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $930Hd.Select), {
                                                                        name: "selectedArea",
                                                                        labelId: "selectedArea",
                                                                        value: props.values.selectedArea,
                                                                        onChange: props.handleChange,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                                                value: "all",
                                                                                children: t("clubAdmin.bookings.allAreas")
                                                                            }),
                                                                            areas === null || areas === void 0 ? void 0 : areas.map((area)=>{
                                                                                /*#__PURE__*/ return (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                                                    value: area.id,
                                                                                    children: area === null || area === void 0 ? void 0 : area.name
                                                                                }, area.id);
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                                name: "selectedArea",
                                                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                                        children: msg
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                                                variant: "outlined",
                                                                error: props.touched.selectedSports && Boolean(props.errors.selectedSports),
                                                                sx: {
                                                                    minWidth: "278px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                                                        id: "sports",
                                                                        children: t("clubAdmin.bookings.selectCategory")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $930Hd.Select), {
                                                                        name: "selectedSports",
                                                                        labelId: "selectedSports",
                                                                        value: props.values.selectedSports,
                                                                        multiple: true,
                                                                        onChange: props.handleChange,
                                                                        renderValue: (selected)=>selected.join(", "),
                                                                        children: sports.map((sport)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                                                                value: sport,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6F4ic.default), {
                                                                                        checked: props.values.selectedSports.indexOf(sport) > -1
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                                                                        primary: sport
                                                                                    })
                                                                                ]
                                                                            }, sport))
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                                name: "selectedSports",
                                                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                                        children: msg
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    isListView && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Ju9q.default), {
                                                                        name: "startDate",
                                                                        error: Boolean(props.errors.startDate),
                                                                        label: t("clubAdmin.historyData.selectStartDate"),
                                                                        disablePast: false,
                                                                        disableFuture: false,
                                                                        onChange: (newValue)=>props.setFieldValue("startDate", handleChangeCloseDate(newValue), true)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                                        name: "startDate",
                                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                                                children: msg
                                                                            })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Ju9q.default), {
                                                                        name: "endDate",
                                                                        error: Boolean(props.touched.endDate && props.errors.endDate),
                                                                        label: props.errors.endDate ? "" : t("clubAdmin.historyData.selectEndDate"),
                                                                        disablePast: false,
                                                                        disableFuture: false,
                                                                        onChange: (newValue)=>props.setFieldValue("endDate", handleChangeCloseDate(newValue), true)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                                        name: "endDate",
                                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                                                children: msg
                                                                            })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                                name: "search",
                                                                placeholder: t("clubAdmin.bookings.inputLabel.search"),
                                                                label: t("clubAdmin.bookings.inputLabel.search"),
                                                                type: "text",
                                                                value: props.values.search,
                                                                onChange: props.handleChange,
                                                                error: props.touched.search && Boolean(props.errors.search),
                                                                sx: {
                                                                    width: "100%",
                                                                    minWidth: "343px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                                name: "search",
                                                                children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ea0ff3663964b59), {
                                                                        children: msg
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                                        children: isListView ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ca10aae50aa7bfa), {
                                                            variant: "outlined",
                                                            startIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c486dcd59b0b2597$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>setIsListView(false),
                                                            sx: {
                                                                minWidth: "278px"
                                                            },
                                                            children: t("clubAdmin.bookings.calendarButton")
                                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$4ca10aae50aa7bfa), {
                                                            variant: "outlined",
                                                            startIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $11220c52e16775ba$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>setIsListView(true),
                                                            sx: {
                                                                minWidth: "278px"
                                                            },
                                                            children: t("clubAdmin.bookings.listButton")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b095e62db41017b4$export$fb46dd9777cc6db0), {
                                                        variant: "contained",
                                                        type: "submit",
                                                        disabled: club === null ? true : false,
                                                        sx: {
                                                            minWidth: isListView ? "278px" : "243px"
                                                        },
                                                        children: t("filter")
                                                    })
                                                ]
                                            })
                                        }),
                                        isListView ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26a8ea32b99bba56$export$93d3c4cfea9ed490), {
                                            bookings: bookings,
                                            clubId: props.values.selectedClub,
                                            onBookingDelete: handleBookingListDelete,
                                            onIsPaidUpdate: handleIsPaidChange,
                                            history: ((_clubFeatureToggle_selectedClubId = clubFeatureToggle[selectedClubId]) === null || _clubFeatureToggle_selectedClubId === void 0 ? void 0 : _clubFeatureToggle_selectedClubId.length) >= 1
                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $993ca05831a04f77$export$ee2e924d6e1cf69d), {
                                            bookings: bookings,
                                            currDate: currDate,
                                            options: initialValues.areaOptions,
                                            onNewBooking: handleNewBooking,
                                            onBookingDelete: handleBookingListDelete,
                                            onDateChange: handleCalendarChangeDate,
                                            selectedAreaInfo: (0, $1aJMc.getSelectedAreaInfo)(club === null || club === void 0 ? void 0 : club.areas, props.values.selectedArea)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9c59c6ae1d82ac72$export$65dfe8a0c60e163c), {
                                    open: newBookingModalOpen,
                                    onClose: ()=>setNewBookingModalOpen(false),
                                    club: club,
                                    selectedDay: newBookingDate,
                                    selectedArea: props.values.selectedArea,
                                    selectedSport: props.values.selectedSports,
                                    areaSports: (0, $1aJMc.getAreaCategories)(club === null || club === void 0 ? void 0 : club.areas, props.values.selectedArea),
                                    selectedAreaInfo: (0, $1aJMc.getSelectedAreaInfo)(club === null || club === void 0 ? void 0 : club.areas, props.values.selectedArea)
                                })
                            ]
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $efd6aa927c8a73df$export$2e2bcd8739ae039), {
                variant: "extended",
                color: "primary",
                "aria-label": "add",
                sx: {
                    display: isListView ? "flex" : "none",
                    position: "fixed",
                    bottom: 16,
                    right: 16
                },
                onClick: ()=>setIsListView(false),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bfcdfa3f5a216ca0$export$2e2bcd8739ae039), {
                        sx: {
                            mr: 1
                        }
                    }),
                    t("clubAdmin.bookings.newBooking")
                ]
            })
        ]
    });
};
var $f0733c2c2aa9ef36$export$2e2bcd8739ae039 = $f0733c2c2aa9ef36$var$BookingsSearch;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $gC25j = parcelRequire("gC25j");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $8m7Fi = parcelRequire("8m7Fi");

var $lNdSG = parcelRequire("lNdSG");


var $dNDci = parcelRequire("dNDci");


var $huHez = parcelRequire("huHez");
var $499f7a534a463607$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
var $499f7a534a463607$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $499f7a534a463607$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $499f7a534a463607$export$2e2bcd8739ae039 = $499f7a534a463607$var$formatDistance;


function $55e1f9cf760fc530$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $89240e113ec3fa4e$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
var $89240e113ec3fa4e$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $89240e113ec3fa4e$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $89240e113ec3fa4e$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $89240e113ec3fa4e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $89240e113ec3fa4e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $89240e113ec3fa4e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $89240e113ec3fa4e$export$2e2bcd8739ae039 = $89240e113ec3fa4e$var$formatLong;


var $52f8c1721e042c21$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
var $52f8c1721e042c21$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $52f8c1721e042c21$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $52f8c1721e042c21$export$2e2bcd8739ae039 = $52f8c1721e042c21$var$formatRelative;


function $457628062959e556$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $7030be3ef212807a$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
var $7030be3ef212807a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $7030be3ef212807a$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
var $7030be3ef212807a$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
var $7030be3ef212807a$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
var $7030be3ef212807a$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
var $7030be3ef212807a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $7030be3ef212807a$var$localize = {
    ordinalNumber: $7030be3ef212807a$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $7030be3ef212807a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $7030be3ef212807a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $7030be3ef212807a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $7030be3ef212807a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $7030be3ef212807a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7030be3ef212807a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7030be3ef212807a$export$2e2bcd8739ae039 = $7030be3ef212807a$var$localize;


function $f58f09468deb70ae$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f58f09468deb70ae$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f58f09468deb70ae$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f58f09468deb70ae$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f58f09468deb70ae$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $ed51bd2201b1ffe0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $cbc3e52d214abf1c$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $cbc3e52d214abf1c$var$parseOrdinalNumberPattern = /\d+/i;
var $cbc3e52d214abf1c$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $cbc3e52d214abf1c$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $cbc3e52d214abf1c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $cbc3e52d214abf1c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cbc3e52d214abf1c$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $cbc3e52d214abf1c$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $cbc3e52d214abf1c$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $cbc3e52d214abf1c$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $cbc3e52d214abf1c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $cbc3e52d214abf1c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $cbc3e52d214abf1c$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $cbc3e52d214abf1c$var$matchOrdinalNumberPattern,
        parsePattern: $cbc3e52d214abf1c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $cbc3e52d214abf1c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbc3e52d214abf1c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $cbc3e52d214abf1c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbc3e52d214abf1c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $cbc3e52d214abf1c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbc3e52d214abf1c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $cbc3e52d214abf1c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cbc3e52d214abf1c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $cbc3e52d214abf1c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cbc3e52d214abf1c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $cbc3e52d214abf1c$export$2e2bcd8739ae039 = $cbc3e52d214abf1c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $9c88885a3f67903f$var$locale = {
    code: "pt",
    formatDistance: (0, $499f7a534a463607$export$2e2bcd8739ae039),
    formatLong: (0, $89240e113ec3fa4e$export$2e2bcd8739ae039),
    formatRelative: (0, $52f8c1721e042c21$export$2e2bcd8739ae039),
    localize: (0, $7030be3ef212807a$export$2e2bcd8739ae039),
    match: (0, $cbc3e52d214abf1c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9c88885a3f67903f$export$2e2bcd8739ae039 = $9c88885a3f67903f$var$locale;


var $2a93defe0440ad2b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $2a93defe0440ad2b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2a93defe0440ad2b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $2a93defe0440ad2b$export$2e2bcd8739ae039 = $2a93defe0440ad2b$var$formatDistance;



var $a6fa3c1fbba4fd67$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $a6fa3c1fbba4fd67$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $a6fa3c1fbba4fd67$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $a6fa3c1fbba4fd67$var$formatLong = {
    date: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $55e1f9cf760fc530$export$2e2bcd8739ae039)({
        formats: $a6fa3c1fbba4fd67$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a6fa3c1fbba4fd67$export$2e2bcd8739ae039 = $a6fa3c1fbba4fd67$var$formatLong;


var $5f9228dede0d6aa7$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $5f9228dede0d6aa7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5f9228dede0d6aa7$var$formatRelativeLocale[token];
};
var $5f9228dede0d6aa7$export$2e2bcd8739ae039 = $5f9228dede0d6aa7$var$formatRelative;



var $0ff1d0e06551a5c1$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $0ff1d0e06551a5c1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0ff1d0e06551a5c1$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $0ff1d0e06551a5c1$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $0ff1d0e06551a5c1$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $0ff1d0e06551a5c1$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $0ff1d0e06551a5c1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $0ff1d0e06551a5c1$var$localize = {
    ordinalNumber: $0ff1d0e06551a5c1$var$ordinalNumber,
    era: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $457628062959e556$export$2e2bcd8739ae039)({
        values: $0ff1d0e06551a5c1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0ff1d0e06551a5c1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0ff1d0e06551a5c1$export$2e2bcd8739ae039 = $0ff1d0e06551a5c1$var$localize;




var $7cafbb556cfb2776$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7cafbb556cfb2776$var$parseOrdinalNumberPattern = /\d+/i;
var $7cafbb556cfb2776$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $7cafbb556cfb2776$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $7cafbb556cfb2776$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $7cafbb556cfb2776$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7cafbb556cfb2776$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $7cafbb556cfb2776$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $7cafbb556cfb2776$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $7cafbb556cfb2776$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $7cafbb556cfb2776$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $7cafbb556cfb2776$var$match = {
    ordinalNumber: (0, $ed51bd2201b1ffe0$export$2e2bcd8739ae039)({
        matchPattern: $7cafbb556cfb2776$var$matchOrdinalNumberPattern,
        parsePattern: $7cafbb556cfb2776$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7cafbb556cfb2776$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7cafbb556cfb2776$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7cafbb556cfb2776$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7cafbb556cfb2776$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $f58f09468deb70ae$export$2e2bcd8739ae039)({
        matchPatterns: $7cafbb556cfb2776$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7cafbb556cfb2776$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7cafbb556cfb2776$export$2e2bcd8739ae039 = $7cafbb556cfb2776$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $fbb6af908147d006$var$locale = {
    code: "en-US",
    formatDistance: (0, $2a93defe0440ad2b$export$2e2bcd8739ae039),
    formatLong: (0, $a6fa3c1fbba4fd67$export$2e2bcd8739ae039),
    formatRelative: (0, $5f9228dede0d6aa7$export$2e2bcd8739ae039),
    localize: (0, $0ff1d0e06551a5c1$export$2e2bcd8739ae039),
    match: (0, $7cafbb556cfb2776$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fbb6af908147d006$export$2e2bcd8739ae039 = $fbb6af908147d006$var$locale;



var $kY3Ke = parcelRequire("kY3Ke");
function $c41ae7eb91efecef$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}



function $f4ec6dc17078088c$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $05b104d2fa74b1c7$export$2e2bcd8739ae039(argument) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $505ebcb184373782$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $bad15b7880e6f97c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}






function $bd716e10292c6930$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



function $5956604521ea0197$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}





var $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE = 60000;
function $6d59b3906efd21bf$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, amount * $6d59b3906efd21bf$var$MILLISECONDS_IN_MINUTE);
}





var $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR = 3600000;
function $d58247d27eb0dbf7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, amount * $d58247d27eb0dbf7$var$MILLISECONDS_IN_HOUR);
}





function $ef64b5b7aae137f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(dirtyDate, days);
}





function $b6e79fa3dbe621a2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $3b831424db570743$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}





function $3c454d4799b2e5e2$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $36c4fb25c3bcff41$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}



function $3a4e06016f5a1c64$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c454d4799b2e5e2$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $5df572e1c801b5e3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $5cd7293820fa2400$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $caa0de56b1948e3d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $583602322c3e1847$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(date).getTime() === (0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(date).getTime();
}


function $f6da14512b9613dc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $5df572e1c801b5e3$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $583602322c3e1847$export$2e2bcd8739ae039)((0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $36c4fb25c3bcff41$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



var $5815698037663c71$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $5815698037663c71$var$defaultRoundingMethod = "trunc";
function $5815698037663c71$export$b6474a47258c1211(method) {
    return method ? $5815698037663c71$var$roundingMap[method] : $5815698037663c71$var$roundingMap[$5815698037663c71$var$defaultRoundingMethod];
}


function $94905b8ecb1c8a63$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $f6da14512b9613dc$export$2e2bcd8739ae039)(dateLeft, dateRight) / 3;
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}




/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a197590075b6aa6e$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $e114ae87b2fb4d54$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY = 86400000;
function $0ff83ae00b0d75a6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $0ff83ae00b0d75a6$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $fcb7abc0fe52d209$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $0ff83ae00b0d75a6$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($fcb7abc0fe52d209$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $a282d77fbef9d903$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $fcb7abc0fe52d209$export$2e2bcd8739ae039)(dateLeft, dateRight) / 7;
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}



/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $b22734c988ed96b7$export$dfd9b671c89acc8e = 7;
var $b22734c988ed96b7$export$3913210603d8e9ae = 365.2425;
var $b22734c988ed96b7$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $b22734c988ed96b7$export$91246f0b9bd9beff = 60000;
var $b22734c988ed96b7$export$7f72910d6dfd237a = 3600000;
var $b22734c988ed96b7$export$397c2d5776aa9055 = 1000;
var $b22734c988ed96b7$export$4dec998e48f9c246 = -$b22734c988ed96b7$export$81caae6e1cc7a622;
var $b22734c988ed96b7$export$f2f5ae5a8e2d8f9f = 60;
var $b22734c988ed96b7$export$3c58128db900d44e = 3;
var $b22734c988ed96b7$export$80d7e435f744f319 = 12;
var $b22734c988ed96b7$export$4db7641526e3241f = 4;
var $b22734c988ed96b7$export$698aec755e92c695 = 3600;
var $b22734c988ed96b7$export$a77c1a7ebebe2a5a = 60;
var $b22734c988ed96b7$export$815a9362476d2fe3 = $b22734c988ed96b7$export$698aec755e92c695 * 24;
var $b22734c988ed96b7$export$34804a017b31e2fe = $b22734c988ed96b7$export$815a9362476d2fe3 * 7;
var $b22734c988ed96b7$export$7271e9e3478110d1 = $b22734c988ed96b7$export$815a9362476d2fe3 * $b22734c988ed96b7$export$3913210603d8e9ae;
var $b22734c988ed96b7$export$8e6600bbdee7dabb = $b22734c988ed96b7$export$7271e9e3478110d1 / 12;
var $b22734c988ed96b7$export$be1dccf2de902d31 = $b22734c988ed96b7$export$8e6600bbdee7dabb * 3;




function $656b09e1b179d990$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dateRight).getTime();
}




function $8fffbc588a798f57$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $656b09e1b179d990$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $b22734c988ed96b7$export$7f72910d6dfd237a);
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}






function $9a7a827aa3d7f832$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $656b09e1b179d990$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $b22734c988ed96b7$export$91246f0b9bd9beff);
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $3976f91395cc9929$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $656b09e1b179d990$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $5815698037663c71$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $ce8f943b2f1f7b6a$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError("Invalid interval");
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
    while(currentDate.getTime() <= endTime){
        dates.push((0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}



var $677412d78fecbb8b$var$defaultOptions = {};
function $677412d78fecbb8b$export$430a3269e24b912e() {
    return $677412d78fecbb8b$var$defaultOptions;
}
function $677412d78fecbb8b$export$95365be1b0704abc(newOptions) {
    $677412d78fecbb8b$var$defaultOptions = newOptions;
}





function $3a7443c6796c86d0$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $c6b92cd202ceada3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $759553f6ee74cd0d$export$2e2bcd8739ae039(value) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $505ebcb184373782$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $374216e389d08fec$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $759553f6ee74cd0d$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}





function $34348cf8fa5b62a4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $bd716e10292c6930$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $afb60d42de991571$var$MILLISECONDS_IN_DAY = 86400000;
function $afb60d42de991571$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $afb60d42de991571$var$MILLISECONDS_IN_DAY) + 1;
}





function $365301764998b714$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $518eb844f291f762$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $41042352236130d1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $518eb844f291f762$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $365301764998b714$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK = 604800000;
function $b0bdf1d2df59ff38$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $365301764998b714$export$2e2bcd8739ae039)(date).getTime() - (0, $41042352236130d1$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b0bdf1d2df59ff38$var$MILLISECONDS_IN_WEEK) + 1;
}








function $66392cbb34f04ad9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $bf632f7e6fcf0087$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $37d853466602e505$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK = 604800000;
function $57d2e8e06c23527b$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options).getTime() - (0, $37d853466602e505$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $57d2e8e06c23527b$var$MILLISECONDS_IN_WEEK) + 1;
}



function $598d25c1f2e4f194$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8845d2e14e26c506$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8845d2e14e26c506$export$2e2bcd8739ae039 = $8845d2e14e26c506$var$formatters;


var $71a1c96437171265$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $71a1c96437171265$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $518eb844f291f762$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $57d2e8e06c23527b$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $b0bdf1d2df59ff38$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $afb60d42de991571$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $71a1c96437171265$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8845d2e14e26c506$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $71a1c96437171265$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $71a1c96437171265$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $71a1c96437171265$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $71a1c96437171265$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $71a1c96437171265$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $71a1c96437171265$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(minutes, 2);
}
function $71a1c96437171265$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter);
}
function $71a1c96437171265$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $71a1c96437171265$export$2e2bcd8739ae039 = $71a1c96437171265$var$formatters;


var $eeef144218f64d7d$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $eeef144218f64d7d$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $eeef144218f64d7d$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $eeef144218f64d7d$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $eeef144218f64d7d$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $eeef144218f64d7d$var$timeLongFormatter(timePattern, formatLong));
};
var $eeef144218f64d7d$var$longFormatters = {
    p: $eeef144218f64d7d$var$timeLongFormatter,
    P: $eeef144218f64d7d$var$dateTimeLongFormatter
};
var $eeef144218f64d7d$export$2e2bcd8739ae039 = $eeef144218f64d7d$var$longFormatters;



var $12a3ea762b495ad3$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $12a3ea762b495ad3$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $12a3ea762b495ad3$export$c6cc36aa33304772(token) {
    return $12a3ea762b495ad3$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$c6b49d6dceb604a1(token) {
    return $12a3ea762b495ad3$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $12a3ea762b495ad3$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}






var $e94e6c2283c04dc4$export$2e2bcd8739ae039 = (0, $fbb6af908147d006$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0918c9925a326e99$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0918c9925a326e99$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0918c9925a326e99$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0918c9925a326e99$var$doubleQuoteRegExp = /''/g;
var $0918c9925a326e99$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0918c9925a326e99$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $e94e6c2283c04dc4$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $374216e389d08fec$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $34348cf8fa5b62a4$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($0918c9925a326e99$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $eeef144218f64d7d$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($0918c9925a326e99$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $0918c9925a326e99$var$cleanEscapedString(substring);
        var formatter = (0, $71a1c96437171265$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $12a3ea762b495ad3$export$c6b49d6dceb604a1)(substring)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $12a3ea762b495ad3$export$c6cc36aa33304772)(substring)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($0918c9925a326e99$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $0918c9925a326e99$var$cleanEscapedString(input) {
    var matched = input.match($0918c9925a326e99$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($0918c9925a326e99$var$doubleQuoteRegExp, "'");
}




function $4b40f36c6c4e8120$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}




function $1ba80981c4aaa361$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}




function $d0f608c42e15b075$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $6c0ddf6f2e376b6f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}




function $3e6008e0d859cbde$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}




function $128ac71efb3a2f51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $93c944119040e143$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
}






function $580c0aebe042d20a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}







function $27a236e22d5cc772$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $0c7cd58575015cf1$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $27a236e22d5cc772$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $e77bd7a0f5da8fd6$var$MILLISECONDS_IN_WEEK = 604800000;
function $e77bd7a0f5da8fd6$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(date, options).getTime() - (0, $0c7cd58575015cf1$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e77bd7a0f5da8fd6$var$MILLISECONDS_IN_WEEK) + 1;
}




function $88155eb6456a8ca8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $3467188658b165bd$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $8f5ca214877b2a80$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $0659d9ec4d7dbbf0$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $849043f97da8598e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $f3df37b4dec5127a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $61980f1dae65c9e0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $36601e4381c8841a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $8b16156dc6f0bfd4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $36601e4381c8841a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $36601e4381c8841a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}




function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $6f9e7a38a1550ef5$export$2e2bcd8739ae039)(o, minLen);
}


function $e24194a208e52c1b$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $4ca7aef5b7b26ccf$export$2e2bcd8739ae039)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}





function $6f0e75fc27c44afd$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}








var $3zeAJ = parcelRequire("3zeAJ");

var $iJeDO = parcelRequire("iJeDO");
function $5236ac5195402c05$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $iJeDO.default)(subClass, superClass);
}


function $b48febf76cf3d138$export$2e2bcd8739ae039(o) {
    $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b48febf76cf3d138$export$2e2bcd8739ae039(o);
}


function $cb0780e1471bbfb2$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($cb0780e1471bbfb2$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




var $3zeAJ = parcelRequire("3zeAJ");
function $690e545d5a200a90$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $505ebcb184373782$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3zeAJ.default)(self);
}


function $c2ec9395872a8e53$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $cb0780e1471bbfb2$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b48febf76cf3d138$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $690e545d5a200a90$export$2e2bcd8739ae039)(this, result);
    };
}





function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $7fddabb4b045308c$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY = 10;
var $f8f535a8fee12b58$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Setter);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $f8f535a8fee12b58$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);
var $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this2), "priority", $f8f535a8fee12b58$var$TIMEZONE_UNIT_PRIORITY);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($f8f535a8fee12b58$export$81d53e3678089a6);





var $3zeAJ = parcelRequire("3zeAJ");







var $d59a769c05ef4f32$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Parser);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $f8f535a8fee12b58$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $453e127a2cb59433$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 140);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $2f2b89d1b907546d$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $2f2b89d1b907546d$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $cac12873b21a7f06$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $cac12873b21a7f06$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff) + seconds * (0, $b22734c988ed96b7$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $cac12873b21a7f06$export$d931c43c4608a164(dateString) {
    return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $cac12873b21a7f06$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $cac12873b21a7f06$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388((0, $2f2b89d1b907546d$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $cac12873b21a7f06$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $cac12873b21a7f06$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $cac12873b21a7f06$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $cac12873b21a7f06$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $c1b2aad30ed081d9$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cac12873b21a7f06$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");







var $fd8a5a4d27b95514$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $bf632f7e6fcf0087$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $cac12873b21a7f06$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $b79f45105f4fc5bf$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $365301764998b714$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $d288b29c63f12ba7$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 130);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(4, dateString);
                return (0, $cac12873b21a7f06$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $f189536e19579fc7$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 120);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $235c501771f8f2c8$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 120);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $8cf9037af5c80a6b$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 110);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $e2c6ed9eece38c05$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 110);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");










function $9f415d9aa929cb5f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $57d2e8e06c23527b$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $1390979b933b1e35$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 100);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $66392cbb34f04ad9$export$2e2bcd8739ae039)((0, $9f415d9aa929cb5f$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");










function $c23fbe21a3e9d7ec$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $b0bdf1d2df59ff38$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $51ad9c3a7ea45056$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 100);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $365301764998b714$export$2e2bcd8739ae039)((0, $c23fbe21a3e9d7ec$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $e79adff529ff7d87$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $e79adff529ff7d87$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "subPriority", 1);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cac12873b21a7f06$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $e79adff529ff7d87$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $df3cfb3868b5f2d9$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "subpriority", 1);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $cac12873b21a7f06$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");








function $dad70b9d49228da0$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $59f2ba411bffa594$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $9fa34d129085f38e$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $10ea24d6b77d76b5$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $dad70b9d49228da0$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");








function $782a867d325da60d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $9fafc31a4201a6f4$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 90);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $782a867d325da60d$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $f000735938cd3f06$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $a786258bf503f7be$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $08b08c6d5753cdfd$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 80);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $cac12873b21a7f06$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $4b936300b1515974$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $fd3b98057917a9cb$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $50f15d1a322aa483$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $1f44a4cabb386e21$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 70);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $90a17725cd6a5e78$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 60);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $5849ee64b8145759$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 50);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $cac12873b21a7f06$export$cc7cc9e2a3ff9388)((0, $2f2b89d1b907546d$export$c123ee06d9da8480).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $ad67721c76585871$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 30);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $cac12873b21a7f06$export$4f84e3a82c7b538)((0, $cac12873b21a7f06$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $f1ec95a2e92c6a8e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 10);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basic, dateString);
                    case "XXXX":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");






var $9f4e851982e313bd$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 10);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basic, dateString);
                    case "xxxx":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $cac12873b21a7f06$export$6497f4c0ecdfba8e)((0, $2f2b89d1b907546d$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $d1d76f4ee5cb7969$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 40);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cac12873b21a7f06$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));





var $3zeAJ = parcelRequire("3zeAJ");





var $e4fe9dee5db1b18a$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $5236ac5195402c05$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $c2ec9395872a8e53$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $009b183922525d46$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "priority", 20);
        (0, $a155b5e75cfe9a4d$export$2e2bcd8739ae039)((0, $3zeAJ.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $381be8fad7784fe9$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $cac12873b21a7f06$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $d59a769c05ef4f32$export$7acfa6ed01010e37));


var $a9a09c5462def3d7$export$19131010e7fd8373 = {
    G: new (0, $453e127a2cb59433$export$8e5a1d3f85a9688)(),
    y: new (0, $c1b2aad30ed081d9$export$48d352de7cd4a988)(),
    Y: new (0, $fd8a5a4d27b95514$export$b8ef38dfcf05d5db)(),
    R: new (0, $b79f45105f4fc5bf$export$951d1df011fde06f)(),
    u: new (0, $d288b29c63f12ba7$export$bad9d2ea38e8f1a)(),
    Q: new (0, $f189536e19579fc7$export$5cb0f701186dde1d)(),
    q: new (0, $235c501771f8f2c8$export$300c0c2990e20e6d)(),
    M: new (0, $8cf9037af5c80a6b$export$400dd8b40ef138a3)(),
    L: new (0, $e2c6ed9eece38c05$export$1d7eaa53eaa5deba)(),
    w: new (0, $1390979b933b1e35$export$c4005ffc174e07c0)(),
    I: new (0, $51ad9c3a7ea45056$export$6fc8dbedd560a6af)(),
    d: new (0, $e79adff529ff7d87$export$e8d4b28a20981dd2)(),
    D: new (0, $df3cfb3868b5f2d9$export$6cfe0d613455f615)(),
    E: new (0, $59f2ba411bffa594$export$1b03c8b76262f7bd)(),
    e: new (0, $9fa34d129085f38e$export$44d1c127ab42c480)(),
    c: new (0, $10ea24d6b77d76b5$export$e447a647caaaec1d)(),
    i: new (0, $9fafc31a4201a6f4$export$693fb1e525095b2a)(),
    a: new (0, $f000735938cd3f06$export$8d1e08492351df91)(),
    b: new (0, $a786258bf503f7be$export$73ca2bd0a17d273)(),
    B: new (0, $08b08c6d5753cdfd$export$bb9212adf05373db)(),
    h: new (0, $4b936300b1515974$export$8a04050a727a1756)(),
    H: new (0, $fd3b98057917a9cb$export$e56f4dea2c3e56dd)(),
    K: new (0, $50f15d1a322aa483$export$cbbe855312f87d77)(),
    k: new (0, $1f44a4cabb386e21$export$6008046d2b34b6a5)(),
    m: new (0, $90a17725cd6a5e78$export$2b52670d9e2be53)(),
    s: new (0, $5849ee64b8145759$export$94d46d540cf1366a)(),
    S: new (0, $ad67721c76585871$export$b8e6f8b2d70893b1)(),
    X: new (0, $f1ec95a2e92c6a8e$export$104d901d49fea29b)(),
    x: new (0, $9f4e851982e313bd$export$12910e5204b52b9)(),
    t: new (0, $d1d76f4ee5cb7969$export$2cd8bf877a05e96)(),
    T: new (0, $e4fe9dee5db1b18a$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e23ab16419322690$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e23ab16419322690$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e23ab16419322690$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e23ab16419322690$var$doubleQuoteRegExp = /''/g;
var $e23ab16419322690$var$notWhitespaceRegExp = /\S/;
var $e23ab16419322690$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e23ab16419322690$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $677412d78fecbb8b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $e94e6c2283c04dc4$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $f8f535a8fee12b58$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($e23ab16419322690$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $eeef144218f64d7d$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $eeef144218f64d7d$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e23ab16419322690$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $e24194a208e52c1b$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $12a3ea762b495ad3$export$c6b49d6dceb604a1)(token)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $12a3ea762b495ad3$export$c6cc36aa33304772)(token)) (0, $12a3ea762b495ad3$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $a9a09c5462def3d7$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($e23ab16419322690$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $e23ab16419322690$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $505ebcb184373782$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $e23ab16419322690$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $34348cf8fa5b62a4$export$2e2bcd8739ae039)(date, (0, $a197590075b6aa6e$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $e24194a208e52c1b$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6f0e75fc27c44afd$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $e23ab16419322690$var$cleanEscapedString(input) {
    return input.match($e23ab16419322690$var$escapedStringRegExp)[1].replace($e23ab16419322690$var$doubleQuoteRegExp, "'");
}





function $4918c57fb0877934$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}





function $ee39c98c5378a0a6$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $bdc3656b920d564d$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $5d7226012cddb1a9$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $1ba80981c4aaa361$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $88db1f07d3462e3c$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $817a8c16f80f6cf9$export$2e2bcd8739ae039(dirtyDate, dirtyMilliseconds) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
}





function $ae8d0a047d9558ed$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $e8b720dd7751e2f7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}






function $eb08625b8e4078ad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}





function $15a89f5e74b8913f$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $c41ae7eb91efecef$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $15a89f5e74b8913f$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $15a89f5e74b8913f$var$parseYear(dateStrings.date, additionalDigits);
        date = $15a89f5e74b8913f$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $15a89f5e74b8913f$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $15a89f5e74b8913f$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $15a89f5e74b8913f$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $15a89f5e74b8913f$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $15a89f5e74b8913f$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $15a89f5e74b8913f$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $15a89f5e74b8913f$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($15a89f5e74b8913f$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($15a89f5e74b8913f$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($15a89f5e74b8913f$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $15a89f5e74b8913f$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $15a89f5e74b8913f$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $15a89f5e74b8913f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($15a89f5e74b8913f$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $15a89f5e74b8913f$var$parseDateUnit(captures[1]);
    var month = $15a89f5e74b8913f$var$parseDateUnit(captures[2]) - 1;
    var day = $15a89f5e74b8913f$var$parseDateUnit(captures[3]);
    var week = $15a89f5e74b8913f$var$parseDateUnit(captures[4]);
    var dayOfWeek = $15a89f5e74b8913f$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$15a89f5e74b8913f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $15a89f5e74b8913f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$15a89f5e74b8913f$var$validateDate(year, month, day) || !$15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $15a89f5e74b8913f$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $15a89f5e74b8913f$var$parseTime(timeString) {
    var captures = timeString.match($15a89f5e74b8913f$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $15a89f5e74b8913f$var$parseTimeUnit(captures[1]);
    var minutes = $15a89f5e74b8913f$var$parseTimeUnit(captures[2]);
    var seconds = $15a89f5e74b8913f$var$parseTimeUnit(captures[3]);
    if (!$15a89f5e74b8913f$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff) + seconds * 1000;
}
function $15a89f5e74b8913f$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $15a89f5e74b8913f$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($15a89f5e74b8913f$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$15a89f5e74b8913f$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $b22734c988ed96b7$export$7f72910d6dfd237a) + minutes * (0, $b22734c988ed96b7$export$91246f0b9bd9beff));
}
function $15a89f5e74b8913f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $15a89f5e74b8913f$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $15a89f5e74b8913f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $15a89f5e74b8913f$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($15a89f5e74b8913f$var$daysInMonths[month] || ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 29 : 28));
}
function $15a89f5e74b8913f$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($15a89f5e74b8913f$var$isLeapYearIndex(year) ? 366 : 365);
}
function $15a89f5e74b8913f$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $15a89f5e74b8913f$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $15a89f5e74b8913f$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}





function $36d38c5e1565f0a6$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $598d25c1f2e4f194$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}




function $bbcd414b3c303484$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $f4ec6dc17078088c$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $05b104d2fa74b1c7$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}



var $807e5074bec33cce$exports = {};
"use strict";
Object.defineProperty($807e5074bec33cce$exports, "__esModule", {
    value: true
});
$807e5074bec33cce$exports.default = void 0;
var $807e5074bec33cce$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $807e5074bec33cce$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $807e5074bec33cce$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $807e5074bec33cce$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $807e5074bec33cce$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $807e5074bec33cce$var$timeLongFormatter(timePattern, formatLong));
};
var $807e5074bec33cce$var$longFormatters = {
    p: $807e5074bec33cce$var$timeLongFormatter,
    P: $807e5074bec33cce$var$dateTimeLongFormatter
};
var $807e5074bec33cce$var$_default = $807e5074bec33cce$var$longFormatters;
$807e5074bec33cce$exports.default = $807e5074bec33cce$var$_default;
$807e5074bec33cce$exports = $807e5074bec33cce$exports.default;


const $082dc3e11d5a517d$var$formatTokenMap = {
    // Year
    y: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    yy: "year",
    yyy: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    yyyy: "year",
    // Month
    M: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    MM: "month",
    MMMM: {
        sectionType: "month",
        contentType: "letter"
    },
    MMM: {
        sectionType: "month",
        contentType: "letter"
    },
    L: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    LL: "month",
    LLL: {
        sectionType: "month",
        contentType: "letter"
    },
    LLLL: {
        sectionType: "month",
        contentType: "letter"
    },
    // Day of the month
    d: {
        sectionType: "day",
        contentType: "digit",
        maxLength: 2
    },
    dd: "day",
    do: {
        sectionType: "day",
        contentType: "digit-with-letter"
    },
    // Day of the week
    E: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEEEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    i: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    ii: "weekDay",
    iii: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    iiii: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    e: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    ee: "weekDay",
    eee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    eeee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    eeeee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    eeeeee: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    c: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    cc: "weekDay",
    ccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    cccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    ccccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    cccccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    // Meridiem
    a: "meridiem",
    aa: "meridiem",
    aaa: "meridiem",
    // Hours
    H: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    HH: "hours",
    h: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    hh: "hours",
    // Minutes
    m: {
        sectionType: "minutes",
        contentType: "digit",
        maxLength: 2
    },
    mm: "minutes",
    // Seconds
    s: {
        sectionType: "seconds",
        contentType: "digit",
        maxLength: 2
    },
    ss: "seconds"
};
const $082dc3e11d5a517d$var$defaultFormats = {
    year: "yyyy",
    month: "LLLL",
    monthShort: "MMM",
    dayOfMonth: "d",
    weekday: "EEEE",
    weekdayShort: "EEE",
    hours24h: "HH",
    hours12h: "hh",
    meridiem: "aa",
    minutes: "mm",
    seconds: "ss",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    keyboardDate: "P",
    shortDate: "MMM d",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    monthAndYear: "LLLL yyyy",
    monthAndDate: "MMMM d",
    fullTime: "p",
    fullTime12h: "hh:mm aa",
    fullTime24h: "HH:mm",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aa",
    fullDateTime24h: "PP HH:mm",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aa",
    keyboardDateTime24h: "P HH:mm"
};
class $082dc3e11d5a517d$export$81f56c0329a1921d {
    constructor({ locale: _locale, formats: formats } = {}){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = false;
        this.lib = "date-fns";
        this.locale = void 0;
        this.formats = void 0;
        this.formatTokenMap = $082dc3e11d5a517d$var$formatTokenMap;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.date = (value)=>{
            if (typeof value === "undefined") return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.dateWithTimezone = (value)=>{
            return this.date(value);
        };
        this.getTimezone = ()=>{
            return "default";
        };
        this.setTimezone = (value)=>{
            return value;
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.parseISO = (isoString)=>{
            return (0, $15a89f5e74b8913f$export$2e2bcd8739ae039)(isoString);
        };
        this.toISO = (value)=>{
            return (0, $36d38c5e1565f0a6$export$2e2bcd8739ae039)(value, {
                format: "extended"
            });
        };
        this.parse = (value, format)=>{
            if (value === "") return null;
            return (0, $e23ab16419322690$export$2e2bcd8739ae039)(value, format, new Date(), {
                locale: this.locale
            });
        };
        this.getCurrentLocaleCode = ()=>{
            var _this$locale;
            return ((_this$locale = this.locale) == null ? void 0 : _this$locale.code) || "en-US";
        };
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            if (this.locale) return /a/.test(this.locale.formatLong.time());
            // By default, date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($807e5074bec33cce$exports)))[firstCharacter];
                    const locale = this.locale || (0, $fbb6af908147d006$export$2e2bcd8739ae039);
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("");
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.isValid = (value)=>{
            return (0, $374216e389d08fec$export$2e2bcd8739ae039)(this.date(value));
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return (0, $0918c9925a326e99$export$2e2bcd8739ae039)(value, formatString, {
                locale: this.locale
            });
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (value, comparing, unit)=>{
            switch(unit){
                case "years":
                    return (0, $3a4e06016f5a1c64$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "quarters":
                    return (0, $94905b8ecb1c8a63$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "months":
                    return (0, $f6da14512b9613dc$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "weeks":
                    return (0, $a282d77fbef9d903$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "days":
                    return (0, $fcb7abc0fe52d209$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "hours":
                    return (0, $8fffbc588a798f57$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "minutes":
                    return (0, $9a7a827aa3d7f832$export$2e2bcd8739ae039)(value, this.date(comparing));
                case "seconds":
                    return (0, $3976f91395cc9929$export$2e2bcd8739ae039)(value, this.date(comparing));
                default:
                    return (0, $656b09e1b179d990$export$2e2bcd8739ae039)(value, this.date(comparing));
            }
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return (0, $0659d9ec4d7dbbf0$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $f3df37b4dec5127a$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $61980f1dae65c9e0$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $849043f97da8598e$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $8b16156dc6f0bfd4$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfter = (value, comparing)=>{
            return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfterYear = (value, comparing)=>{
            return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(comparing));
        };
        this.isAfterDay = (value, comparing)=>{
            return (0, $3467188658b165bd$export$2e2bcd8739ae039)(value, (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(comparing));
        };
        this.isBefore = (value, comparing)=>{
            return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isBeforeYear = (value, comparing)=>{
            return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(comparing));
        };
        this.isBeforeDay = (value, comparing)=>{
            return (0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(value, (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(comparing));
        };
        this.isWithinRange = (value, [start, end])=>{
            return (0, $bbcd414b3c303484$export$2e2bcd8739ae039)(value, {
                start: start,
                end: end
            });
        };
        this.startOfYear = (value)=>{
            return (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $e8b720dd7751e2f7$export$2e2bcd8739ae039)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.startOfDay = (value)=>{
            return (0, $e114ae87b2fb4d54$export$2e2bcd8739ae039)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(value);
        };
        this.endOfWeek = (value)=>{
            return (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.endOfDay = (value)=>{
            return (0, $5cd7293820fa2400$export$2e2bcd8739ae039)(value);
        };
        this.addYears = (value, amount)=>{
            return (0, $3b831424db570743$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMonths = (value, amount)=>{
            return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(value, amount);
        };
        this.addWeeks = (value, amount)=>{
            return (0, $ef64b5b7aae137f5$export$2e2bcd8739ae039)(value, amount);
        };
        this.addDays = (value, amount)=>{
            return (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(value, amount);
        };
        this.addHours = (value, amount)=>{
            return (0, $d58247d27eb0dbf7$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMinutes = (value, amount)=>{
            return (0, $6d59b3906efd21bf$export$2e2bcd8739ae039)(value, amount);
        };
        this.addSeconds = (value, amount)=>{
            return (0, $5956604521ea0197$export$2e2bcd8739ae039)(value, amount);
        };
        this.getYear = (value)=>{
            return (0, $88155eb6456a8ca8$export$2e2bcd8739ae039)(value);
        };
        this.getMonth = (value)=>{
            return (0, $3e6008e0d859cbde$export$2e2bcd8739ae039)(value);
        };
        this.getDate = (value)=>{
            return (0, $4b40f36c6c4e8120$export$2e2bcd8739ae039)(value);
        };
        this.getHours = (value)=>{
            return (0, $d0f608c42e15b075$export$2e2bcd8739ae039)(value);
        };
        this.getMinutes = (value)=>{
            return (0, $6c0ddf6f2e376b6f$export$2e2bcd8739ae039)(value);
        };
        this.getSeconds = (value)=>{
            return (0, $128ac71efb3a2f51$export$2e2bcd8739ae039)(value);
        };
        this.getMilliseconds = (value)=>{
            return (0, $93c944119040e143$export$2e2bcd8739ae039)(value);
        };
        this.setYear = (value, year)=>{
            return (0, $ae8d0a047d9558ed$export$2e2bcd8739ae039)(value, year);
        };
        this.setMonth = (value, month)=>{
            return (0, $5d7226012cddb1a9$export$2e2bcd8739ae039)(value, month);
        };
        this.setDate = (value, date)=>{
            return (0, $4918c57fb0877934$export$2e2bcd8739ae039)(value, date);
        };
        this.setHours = (value, hours)=>{
            return (0, $ee39c98c5378a0a6$export$2e2bcd8739ae039)(value, hours);
        };
        this.setMinutes = (value, minutes)=>{
            return (0, $bdc3656b920d564d$export$2e2bcd8739ae039)(value, minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return (0, $88db1f07d3462e3c$export$2e2bcd8739ae039)(value, seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return (0, $817a8c16f80f6cf9$export$2e2bcd8739ae039)(value, milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return (0, $1ba80981c4aaa361$export$2e2bcd8739ae039)(value);
        };
        this.getNextMonth = (value)=>{
            return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(value, 1);
        };
        this.getPreviousMonth = (value)=>{
            return (0, $b6e79fa3dbe621a2$export$2e2bcd8739ae039)(value, -1);
        };
        this.getMonthArray = (value)=>{
            const firstMonth = (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(value);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return this.setSeconds(this.setMinutes(this.setHours(dateParam, this.getHours(timeParam)), this.getMinutes(timeParam)), this.getSeconds(timeParam));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, $ce8f943b2f1f7b6a$export$2e2bcd8739ae039)({
                start: (0, $580c0aebe042d20a$export$2e2bcd8739ae039)(now, {
                    locale: this.locale
                }),
                end: (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, "EEEEEE"));
        };
        this.getWeekArray = (value)=>{
            const start = (0, $580c0aebe042d20a$export$2e2bcd8739ae039)((0, $e8b720dd7751e2f7$export$2e2bcd8739ae039)(value), {
                locale: this.locale
            });
            const end = (0, $3a7443c6796c86d0$export$2e2bcd8739ae039)((0, $caa0de56b1948e3d$export$2e2bcd8739ae039)(value), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while((0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = (0, $bad15b7880e6f97c$export$2e2bcd8739ae039)(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return (0, $e77bd7a0f5da8fd6$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, $eb08625b8e4078ad$export$2e2bcd8739ae039)(start);
            const endDate = (0, $c6b92cd202ceada3$export$2e2bcd8739ae039)(end);
            const years = [];
            let current = startDate;
            while((0, $8f5ca214877b2a80$export$2e2bcd8739ae039)(current, endDate)){
                years.push(current);
                current = (0, $3b831424db570743$export$2e2bcd8739ae039)(current, 1);
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.locale = _locale;
        this.formats = (0, $kY3Ke.default)({}, $082dc3e11d5a517d$var$defaultFormats, formats);
    }
}



var $9uOZr = parcelRequire("9uOZr");
(0, $9c88885a3f67903f$export$2e2bcd8739ae039).options = {
    weekStartsOn: 0
};
(0, $fbb6af908147d006$export$2e2bcd8739ae039).options = {
    weekStartsOn: 0
};
const $b56b774fe22f8323$var$Bookings = ()=>{
    const { t: t, i18n: i18n } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const [searchParams, setSearchParams] = (0, $dNYY5.useSearchParams)();
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [cancelModalOpen, setCancelModalOpen] = (0, $7fPBF.useState)(false);
    const [selectedBooking, setSelectedBooking] = (0, $7fPBF.useState)(null);
    const [bookings, setBookings] = (0, $7fPBF.useState)([]);
    const startDate = (0, $7fPBF.useMemo)(()=>{
        return searchParams.get("startDate") ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(searchParams.get("startDate")).format("YYYY-MM-DD") : (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))().format("YYYY-MM-DD");
    }, [
        searchParams
    ]);
    const endDate = (0, $7fPBF.useMemo)(()=>{
        const date = searchParams.get("endDate");
        if (date) return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(date).isAfter(startDate) || (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(date).isSame(startDate) ? (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(date).format("YYYY-MM-DD") : null;
        return null;
    }, [
        searchParams
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setLoading(true);
        new (0, $dNDci.AppService)().api_getBookingsByUser({
            startDate: `${startDate}T00:00:00.000Z`,
            endDate: endDate ? `${endDate}T23:59:00.000Z` : undefined
        }).then((res)=>{
            if (res.status !== 200) throw res;
            setBookings(res.data);
        }).catch((error)=>{
            console.log(error);
        }).finally(()=>setLoading(false));
    }, [
        startDate,
        endDate,
        setBookings
    ]);
    const handleChangeDate = (key, value)=>{
        if (!value || loading) return;
        setSearchParams((searchParams)=>{
            searchParams.set(key, value);
            return searchParams;
        });
    };
    const handleCardCancel = (booking)=>{
        setSelectedBooking(booking);
        setCancelModalOpen(true);
    };
    const handleCardDelete = ()=>{
        setBookings((prev)=>prev.map((a)=>{
                return a.id === selectedBooking.id ? {
                    ...a,
                    canceled: true
                } : a;
            }));
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
                headerType: "menu",
                maxWidth: "sm",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    spacing: 2,
                    p: 1,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "h5",
                            textAlign: "center",
                            children: t("bookings").toLocaleUpperCase()
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $huHez.LocalizationProvider), {
                            dateAdapter: (0, $082dc3e11d5a517d$export$81f56c0329a1921d),
                            adapterLocale: i18n.language === "pt" ? (0, $9c88885a3f67903f$export$2e2bcd8739ae039) : (0, $fbb6af908147d006$export$2e2bcd8739ae039),
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lNdSG.DatePicker), {
                                    sx: {
                                        width: "100%",
                                        backgroundColor: "#fff"
                                    },
                                    label: t("search.labels.startDate"),
                                    value: new Date(startDate),
                                    onChange: (dateSelected)=>{
                                        var _dayjs;
                                        return handleChangeDate("startDate", (_dayjs = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(dateSelected)) === null || _dayjs === void 0 ? void 0 : _dayjs.format("YYYY-MM-DD"));
                                    },
                                    disabled: loading
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lNdSG.DatePicker), {
                                    sx: {
                                        width: "100%",
                                        backgroundColor: "#fff"
                                    },
                                    label: t("search.labels.endDate"),
                                    value: endDate == null ? null : new Date(endDate),
                                    onChange: (dateSelected)=>{
                                        var _dayjs;
                                        return handleChangeDate("endDate", (_dayjs = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(dateSelected)) === null || _dayjs === void 0 ? void 0 : _dayjs.format("YYYY-MM-DD"));
                                    },
                                    disabled: loading
                                })
                            ]
                        }),
                        bookings.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                            variant: "filled",
                            severity: "info",
                            children: t("noBookings")
                        }) : bookings.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(a.day).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(b.day)) ? 1 : -1).map((booking)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ea280f194c772d5$export$2e2bcd8739ae039), {
                                booking: {
                                    ...booking,
                                    name: booking.area.name
                                },
                                onClick: ()=>navigate(`/booking-details/${booking.id}`),
                                onCancel: ()=>handleCardCancel(booking),
                                onContact: ()=>navigate(`/club/${booking.club.id}#contacts`)
                            }, booking.id))
                    ]
                })
            }),
            selectedBooking && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e76a34dc688aa94a$export$97a0a8c219eb7de3), {
                booking: selectedBooking,
                open: cancelModalOpen,
                onClose: ()=>setCancelModalOpen(false),
                onDelete: handleCardDelete
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $efd6aa927c8a73df$export$2e2bcd8739ae039), {
                variant: "extended",
                color: "primary",
                "aria-label": "add",
                sx: {
                    position: "fixed",
                    bottom: 16,
                    right: 16
                },
                onClick: ()=>navigate("/search"),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bfcdfa3f5a216ca0$export$2e2bcd8739ae039), {
                        sx: {
                            mr: 1
                        }
                    }),
                    t("newBooking")
                ]
            })
        ]
    });
};
var $b56b774fe22f8323$export$2e2bcd8739ae039 = $b56b774fe22f8323$var$Bookings;



var $fV1Xm = parcelRequire("fV1Xm");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $df3cf7471de1bed9$export$16a133332fff0737;
(function(BookingsContextKeys) {
    BookingsContextKeys["Booking"] = "booking";
})($df3cf7471de1bed9$export$16a133332fff0737 || ($df3cf7471de1bed9$export$16a133332fff0737 = {}));
const $df3cf7471de1bed9$export$830ea4ed067dacb = /*#__PURE__*/ (0, $7fPBF.createContext)({
    booking: null,
    setBooking: ()=>{},
    isLoading: true,
    setIsLoading: ()=>{}
});
const $df3cf7471de1bed9$export$2c59d9e667214a64 = (props)=>{
    const [booking, setBooking] = (0, $7fPBF.useState)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const values = {
        booking: booking,
        setBooking: setBooking,
        isLoading: isLoading,
        setIsLoading: setIsLoading
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($df3cf7471de1bed9$export$830ea4ed067dacb.Provider, {
        value: values,
        children: props.children
    });
};
const $df3cf7471de1bed9$export$b40d734c8db78b02 = ()=>(0, $7fPBF.useContext)($df3cf7471de1bed9$export$830ea4ed067dacb);



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $dNDci = parcelRequire("dNDci");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $7dba217b57b29882$export$163069ff6fe0ebb9 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isLoading: false,
    setIsLoading: ()=>undefined,
    club: undefined,
    setClub: ()=>undefined
});
const $7dba217b57b29882$export$80317e91e54b81a2 = (props)=>{
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [club, setClub] = (0, $7fPBF.useState)(undefined);
    const values = (0, $7fPBF.useMemo)(()=>({
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            club: club,
            setClub: setClub
        }), [
        isLoading,
        setIsLoading,
        club,
        setClub
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7dba217b57b29882$export$163069ff6fe0ebb9.Provider, {
        value: values,
        ...props
    });
};
const $7dba217b57b29882$var$useClubContext = ()=>(0, $7fPBF.useContext)($7dba217b57b29882$export$163069ff6fe0ebb9);
var $7dba217b57b29882$export$2e2bcd8739ae039 = $7dba217b57b29882$var$useClubContext;



var $1N52b = parcelRequire("1N52b");
const $78bc65f04043bddb$export$ca8754786c7d383a = ()=>{
    const appService = new (0, $dNDci.AppService)();
    const navigate = (0, $iIluI.useNavigate)();
    const { role: role } = (0, $1N52b.useAuth)();
    const { setIsLoading: setIsLoading, setClub: setClub } = (0, $7dba217b57b29882$export$2e2bcd8739ae039)();
    const fetch = (clubId)=>{
        setIsLoading(true);
        appService.api_getClub(role === "club-admin" ? "public" : "open", {
            clubId: clubId
        }).then((res)=>{
            if (res.status !== 200) {
                navigate("/search");
                throw new Error();
            }
            setClub(res.data);
        }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
    };
    return {
        actions: {
            fetch: fetch
        }
    };
};



var $iIluI = parcelRequire("iIluI");


var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


var $6hfZk = parcelRequire("6hfZk");
let $2f1687cd6fb68a89$var$_ = (t)=>t, $2f1687cd6fb68a89$var$t, $2f1687cd6fb68a89$var$t1, $2f1687cd6fb68a89$var$t2, $2f1687cd6fb68a89$var$t3;
const $2f1687cd6fb68a89$export$42a852a2b6b56249 = (0, $6hfZk.default)("div").withConfig({
    shouldForwardProp: (prop)=>prop !== "image"
})($2f1687cd6fb68a89$var$t || ($2f1687cd6fb68a89$var$t = $2f1687cd6fb68a89$var$_`
    display: flex;
    min-height: 10rem;
    flex-direction: column;
    background-size: cover;
    background-position: center;
    background-image: url(${0});
`), ({ image: image })=>image);
const $2f1687cd6fb68a89$export$48423cf6a25b5248 = (0, $6hfZk.default).div($2f1687cd6fb68a89$var$t1 || ($2f1687cd6fb68a89$var$t1 = $2f1687cd6fb68a89$var$_`
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
`));
const $2f1687cd6fb68a89$export$c4868e4a24d48fad = (0, $6hfZk.default).div($2f1687cd6fb68a89$var$t2 || ($2f1687cd6fb68a89$var$t2 = $2f1687cd6fb68a89$var$_`
    width: 100%;
    color: white;
    text-align: center;
`));
const $2f1687cd6fb68a89$export$7c8f159da0dc916 = (0, $6hfZk.default).img($2f1687cd6fb68a89$var$t3 || ($2f1687cd6fb68a89$var$t3 = $2f1687cd6fb68a89$var$_`
    filter: invert(1);
    margin-right: 0.2rem;
    transform: translateY(0.2rem);
`));


var $466aa0f23e42c6dd$exports = {};

$466aa0f23e42c6dd$exports = new URL((parcelRequire("4SSe9")).resolve("dEUqq"), import.meta.url).toString();



var $9uOZr = parcelRequire("9uOZr");
const $c5f59a514954c054$export$df63f2d6395ac139 = ()=>{
    const { club: club } = (0, $7dba217b57b29882$export$2e2bcd8739ae039)();
    const image = (0, $7fPBF.useMemo)(()=>{
        var _club_photos;
        if (club === null || club === void 0 ? void 0 : (_club_photos = club.photos) === null || _club_photos === void 0 ? void 0 : _club_photos.length) {
            const defaultPhoto = club.photos.find((photo)=>photo.isDefault);
            return defaultPhoto ? defaultPhoto.photoUrl : club.photos[0].photoUrl;
        } else return "https://placehold.co/400";
    }, [
        club
    ]);
    const address = (0, $7fPBF.useMemo)(()=>{
        return `${club === null || club === void 0 ? void 0 : club.address.address}, ${club === null || club === void 0 ? void 0 : club.address.county}, ${club === null || club === void 0 ? void 0 : club.address.district}`;
    }, [
        club
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2f1687cd6fb68a89$export$42a852a2b6b56249), {
        image: image,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2f1687cd6fb68a89$export$48423cf6a25b5248), {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $2f1687cd6fb68a89$export$c4868e4a24d48fad), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                            children: club === null || club === void 0 ? void 0 : club.name
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2f1687cd6fb68a89$export$7c8f159da0dc916), {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($466aa0f23e42c6dd$exports)))
                                }),
                                " ",
                                address
                            ]
                        })
                    ]
                })
            })
        })
    });
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



var $6hfZk = parcelRequire("6hfZk");

var $i3L0M = parcelRequire("i3L0M");

var $aili3 = parcelRequire("aili3");
let $330563ce3a2653c2$var$_ = (t)=>t, $330563ce3a2653c2$var$t, $330563ce3a2653c2$var$t1, $330563ce3a2653c2$var$t2, $330563ce3a2653c2$var$t3, $330563ce3a2653c2$var$t4, $330563ce3a2653c2$var$t5, $330563ce3a2653c2$var$t6, $330563ce3a2653c2$var$t7, $330563ce3a2653c2$var$t8;
const $330563ce3a2653c2$export$42a852a2b6b56249 = (0, $6hfZk.default)((0, $aili3.default))($330563ce3a2653c2$var$t || ($330563ce3a2653c2$var$t = $330563ce3a2653c2$var$_`
    max-width: 540px;
    margin: 2rem auto 2rem;
    width: calc(100% - 48px);

    @media (min-width: 1024px) {
        max-width: 1400px;
    }
`));
const $330563ce3a2653c2$export$8b251419efc915eb = (0, $6hfZk.default).h3($330563ce3a2653c2$var$t1 || ($330563ce3a2653c2$var$t1 = $330563ce3a2653c2$var$_`
    margin-top: 3rem;
    display: flex;
    align-items: center;

    > img {
        margin-right: 0.5rem;
        transform: translateY(0.2rem);
    }
`));
const $330563ce3a2653c2$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "variant"
})($330563ce3a2653c2$var$t3 || ($330563ce3a2653c2$var$t3 = $330563ce3a2653c2$var$_`
    ${0}
`), ({ variant: variant })=>variant === "small" && (0, $6hfZk.css)($330563ce3a2653c2$var$t2 || ($330563ce3a2653c2$var$t2 = $330563ce3a2653c2$var$_`
            font-size: 0.85rem;

            img {
                margin-right: 0.25rem;
                transform: translateY(0.2rem) scale(0.8);
            }
            ${0} {
                font-size: 0.85rem;
                margin-top: 1rem;
                margin-bottom: 0.5rem;
            }
        `), $330563ce3a2653c2$export$8b251419efc915eb));
const $330563ce3a2653c2$export$393edc798c47379d = (0, $6hfZk.default).p($330563ce3a2653c2$var$t4 || ($330563ce3a2653c2$var$t4 = $330563ce3a2653c2$var$_`
    line-height: 1.5;
`));
const $330563ce3a2653c2$export$124d4c7bf7db9715 = (0, $6hfZk.default).div($330563ce3a2653c2$var$t5 || ($330563ce3a2653c2$var$t5 = $330563ce3a2653c2$var$_`
    gap: 1rem;
    display: grid;
    grid-template-columns: auto 30%;
`));
const $330563ce3a2653c2$export$3ba510748aae365e = (0, $6hfZk.default)((0, $i3L0M.Map))($330563ce3a2653c2$var$t6 || ($330563ce3a2653c2$var$t6 = $330563ce3a2653c2$var$_`
    width: 100%;
    height: 40rem;
`));
const $330563ce3a2653c2$export$7f272e528db53fa5 = (0, $6hfZk.default).p($330563ce3a2653c2$var$t7 || ($330563ce3a2653c2$var$t7 = $330563ce3a2653c2$var$_`
    line-height: 1.5;
`));
const $330563ce3a2653c2$export$cbf3f354590ee1d7 = (0, $6hfZk.default)((0, $aili3.default))($330563ce3a2653c2$var$t8 || ($330563ce3a2653c2$var$t8 = $330563ce3a2653c2$var$_`
    @media (min-width: 1024px) {
        display: flex;
        flex-wrap: wrap;

        > div {
            width: 50%;

            &:last-of-type,
            &:first-of-type {
                width: 100%;
            }
        }
    }
`));


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
const $1335e35c06139c82$export$d372a871356834cd = (objects)=>{
    return objects.map((object)=>{
        var _object_address, _object_address1;
        const center = {
            lat: (_object_address = object.address) === null || _object_address === void 0 ? void 0 : _object_address.lat,
            lng: (_object_address1 = object.address) === null || _object_address1 === void 0 ? void 0 : _object_address1.lng
        };
        const address = `${object === null || object === void 0 ? void 0 : object.address.address}, ${object === null || object === void 0 ? void 0 : object.address.county}, ${object === null || object === void 0 ? void 0 : object.address.district}`;
        let clubPhoto = object.photoUrl;
        return {
            clubId: object.id,
            clubName: object.name,
            clubPhoto: clubPhoto,
            address: address,
            center: center,
            areas: object.areas
        };
    });
};



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");
var $94ctx = parcelRequire("94ctx");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $g9bTP = parcelRequire("g9bTP");

var $52luK = parcelRequire("52luK");
// Source from https://github.com/alitaheri/normalize-scroll-left
let $0e1ac0a299c7d29d$var$cachedType;
function $0e1ac0a299c7d29d$export$a10970ffb6510128() {
    if ($0e1ac0a299c7d29d$var$cachedType) return $0e1ac0a299c7d29d$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $0e1ac0a299c7d29d$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $0e1ac0a299c7d29d$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $0e1ac0a299c7d29d$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $0e1ac0a299c7d29d$var$cachedType;
}
function $0e1ac0a299c7d29d$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $0e1ac0a299c7d29d$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $83b553d4c6fa4e14$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $83b553d4c6fa4e14$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $83b553d4c6fa4e14$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $52luK = parcelRequire("52luK");

var $9kBlI = parcelRequire("9kBlI");
var $hQtyv = parcelRequire("hQtyv");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3a66d534e874acfc$var$_excluded = [
    "onChange"
];
const $3a66d534e874acfc$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $3a66d534e874acfc$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $cFLic.default)(props, $3a66d534e874acfc$var$_excluded);
    const scrollbarHeight = $7fPBF.useRef();
    const nodeRef = $7fPBF.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $hQtyv.default)(()=>{
        const handleResize = (0, $52luK.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $9kBlI.default)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $7fPBF.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", (0, $kY3Ke.default)({
        style: $3a66d534e874acfc$var$styles,
        ref: nodeRef
    }, other));
}



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");
var $94ctx = parcelRequire("94ctx");
parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $590c3983f7881c0e$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $0fb9b8a257411062$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");



var $3RNaF = parcelRequire("3RNaF");

var $g9bTP = parcelRequire("g9bTP");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $b12a210959784eb2$export$34861783d3c2eef8(slot) {
    return (0, $k6RDS.default)("MuiTabScrollButton", slot);
}
const $b12a210959784eb2$var$tabScrollButtonClasses = (0, $4jzsB.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $b12a210959784eb2$export$2e2bcd8739ae039 = $b12a210959784eb2$var$tabScrollButtonClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a882ddb0e71234be$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $a882ddb0e71234be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $b12a210959784eb2$export$34861783d3c2eef8), classes);
};
const $a882ddb0e71234be$var$TabScrollButtonRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $b12a210959784eb2$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $a882ddb0e71234be$var$TabScrollButton = /*#__PURE__*/ $7fPBF.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $cFLic.default)(props, $a882ddb0e71234be$var$_excluded);
    const theme = (0, $g9bTP.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $kY3Ke.default)({
        isRtl: isRtl
    }, props);
    const classes = $a882ddb0e71234be$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $590c3983f7881c0e$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $0fb9b8a257411062$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $94ctx.useSlotProps)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $94ctx.useSlotProps)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a882ddb0e71234be$var$TabScrollButtonRoot, (0, $kY3Ke.default)({
        component: "div",
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $bbzbN.jsx)(StartButtonIcon, (0, $kY3Ke.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $bbzbN.jsx)(EndButtonIcon, (0, $kY3Ke.default)({}, endButtonIconProps))
    }));
});
var $a882ddb0e71234be$export$2e2bcd8739ae039 = $a882ddb0e71234be$var$TabScrollButton;



var $1XFnq = parcelRequire("1XFnq");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $11c5a026a0fc305f$export$cdd93bd054dec359(slot) {
    return (0, $k6RDS.default)("MuiTabs", slot);
}
const $11c5a026a0fc305f$var$tabsClasses = (0, $4jzsB.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $11c5a026a0fc305f$export$2e2bcd8739ae039 = $11c5a026a0fc305f$var$tabsClasses;



var $cNbkS = parcelRequire("cNbkS");

var $9kBlI = parcelRequire("9kBlI");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c45f613599c3205d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $c45f613599c3205d$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $c45f613599c3205d$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $c45f613599c3205d$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $c45f613599c3205d$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $11c5a026a0fc305f$export$cdd93bd054dec359), classes);
};
const $c45f613599c3205d$var$TabsRoot = (0, $kDBhE.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $11c5a026a0fc305f$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $11c5a026a0fc305f$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $11c5a026a0fc305f$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $c45f613599c3205d$var$TabsScroller = (0, $kDBhE.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $c45f613599c3205d$var$FlexContainer = (0, $kDBhE.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $c45f613599c3205d$var$TabsIndicator = (0, $kDBhE.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $c45f613599c3205d$var$TabsScrollbarSize = (0, $kDBhE.default)((0, $3a66d534e874acfc$export$2e2bcd8739ae039), {
    name: "MuiTabs",
    slot: "ScrollbarSize"
})({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $c45f613599c3205d$var$defaultIndicatorStyle = {};
let $c45f613599c3205d$var$warnedOnceTabPresent = false;
const $c45f613599c3205d$var$Tabs = /*#__PURE__*/ $7fPBF.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $g9bTP.default)();
    const isRtl = theme.direction === "rtl";
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $a882ddb0e71234be$export$2e2bcd8739ae039), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $cFLic.default)(props, $c45f613599c3205d$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $c45f613599c3205d$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $94ctx.useSlotProps)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $94ctx.useSlotProps)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $7fPBF.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $7fPBF.useState($c45f613599c3205d$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $7fPBF.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $7fPBF.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $7fPBF.useState(false);
    const [scrollerStyle, setScrollerStyle] = $7fPBF.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $7fPBF.useRef(null);
    const tabListRef = $7fPBF.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $0e1ac0a299c7d29d$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $1XFnq.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $83b553d4c6fa4e14$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $0e1ac0a299c7d29d$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $7fPBF.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $bbzbN.jsx)($c45f613599c3205d$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $hngXp.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $bbzbN.jsx)(ScrollButtonComponent, (0, $kY3Ke.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $hngXp.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $bbzbN.jsx)(ScrollButtonComponent, (0, $kY3Ke.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $hngXp.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $1XFnq.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $1XFnq.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $7fPBF.useEffect(()=>{
        const handleResize = (0, $52luK.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        const win = (0, $9kBlI.default)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        updateIndicatorState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $7fPBF.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $7fPBF.useEffect(()=>{
        setMounted(true);
    }, []);
    $7fPBF.useEffect(()=>{
        updateIndicatorState();
    });
    $7fPBF.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($c45f613599c3205d$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $7fPBF.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $bbzbN.jsx)($c45f613599c3205d$var$TabsIndicator, (0, $kY3Ke.default)({}, TabIndicatorProps, {
        className: (0, $hngXp.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $kY3Ke.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $7fPBF.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, (0, $kY3Ke.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $cNbkS.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, currentFocus, $c45f613599c3205d$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, currentFocus, $c45f613599c3205d$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, null, $c45f613599c3205d$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, null, $c45f613599c3205d$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($c45f613599c3205d$var$TabsRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $bbzbN.jsxs)($c45f613599c3205d$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($c45f613599c3205d$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $c45f613599c3205d$export$2e2bcd8739ae039 = $c45f613599c3205d$var$Tabs;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $3RNaF = parcelRequire("3RNaF");

var $b6UUh = parcelRequire("b6UUh");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $ec63e1681c0cbdaa$export$72aef224d6115253(slot) {
    return (0, $k6RDS.default)("MuiTab", slot);
}
const $ec63e1681c0cbdaa$var$tabClasses = (0, $4jzsB.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $ec63e1681c0cbdaa$export$2e2bcd8739ae039 = $ec63e1681c0cbdaa$var$tabClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b2a8111cea006e88$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $b2a8111cea006e88$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $b6UUh.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $ec63e1681c0cbdaa$export$72aef224d6115253), classes);
};
const $b2a8111cea006e88$var$TabRoot = (0, $kDBhE.default)((0, $3RNaF.default), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $b6UUh.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $kY3Ke.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $b2a8111cea006e88$var$Tab = /*#__PURE__*/ $7fPBF.forwardRef(function Tab(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $cFLic.default)(props, $b2a8111cea006e88$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $b2a8111cea006e88$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $hngXp.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b2a8111cea006e88$var$TabRoot, (0, $kY3Ke.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $b2a8111cea006e88$export$2e2bcd8739ae039 = $b2a8111cea006e88$var$Tab;



var $aili3 = parcelRequire("aili3");

var $dNYY5 = parcelRequire("dNYY5");
const $65826a3097b94805$export$af1da6d923bf8e9d = [
    {
        title: "clubImageList",
        param: "photos"
    },
    {
        title: "paymentMethods",
        param: "paymentMethods"
    },
    {
        title: "parking",
        param: "carParkType"
    },
    {
        title: "lockerooms",
        param: "lockerRoomType"
    }
];
const $65826a3097b94805$export$96b01ac844a9b9c6 = [
    {
        title: "privacy-environment",
        param: [
            "privacy",
            "environment"
        ]
    },
    {
        title: "price-time",
        param: [
            "price",
            "timeUnit",
            "privacy"
        ]
    },
    {
        title: "sports",
        param: [
            "AreaCategory",
            "id"
        ]
    },
    {
        title: "schedules",
        param: "AreaSchedule"
    },
    {
        title: "closed",
        param: "AreaClosedSchedule"
    },
    {
        title: "reservations",
        param: "Reservation"
    }
];



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
var $50c94396c68cb344$exports = {};

$50c94396c68cb344$exports = new URL((parcelRequire("4SSe9")).resolve("4Bojj"), import.meta.url).toString();



const $4a5b2427b51d5f0e$export$fb98353eb72a772d = ({ carParkType: carParkType, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($50c94396c68cb344$exports)))
                    }),
                    t(`club.headers.parking`)
                ]
            }),
            !!carParkType ? t(`club.parking.${carParkType.toLowerCase()}`) : t("club.parking.noInformation")
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $gC25j = parcelRequire("gC25j");

var $6hfZk = parcelRequire("6hfZk");
let $5c147938f25106b8$var$_ = (t)=>t, $5c147938f25106b8$var$t, $5c147938f25106b8$var$t1;
const $5c147938f25106b8$export$22a81bdd3a723b46 = (0, $6hfZk.default).ul($5c147938f25106b8$var$t || ($5c147938f25106b8$var$t = $5c147938f25106b8$var$_`
    margin: 0;
    padding-inline-start: 2rem;
`));
const $5c147938f25106b8$export$38fb881472c4cc64 = (0, $6hfZk.default)((0, $gC25j.default))($5c147938f25106b8$var$t1 || ($5c147938f25106b8$var$t1 = $5c147938f25106b8$var$_`
    max-width: 420px !important;
`));


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $69839b6fee43a301$exports = {};

$69839b6fee43a301$exports = new URL((parcelRequire("4SSe9")).resolve("5MeqA"), import.meta.url).toString();


const $2d1dcd1fd83f2fed$export$ab218e41b1f3d913 = ({ paymentMethods: paymentMethods, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($69839b6fee43a301$exports))),
                        alt: ""
                    }),
                    t(`club.headers.paymentMethods`)
                ]
            }),
            !(paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c147938f25106b8$export$38fb881472c4cc64), {
                severity: "info",
                children: t("club.paymentMethods.emptyList")
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c147938f25106b8$export$22a81bdd3a723b46), {
                children: paymentMethods.map((paymentMethod)=>/*#__PURE__*/ (0, $bbzbN.jsx)("li", {
                        children: t(`club.paymentMethods.${paymentMethod.name.toLowerCase()}`)
                    }, paymentMethod.name))
            })
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $e8e78494152de3aa$exports = {};

$e8e78494152de3aa$exports = new URL((parcelRequire("4SSe9")).resolve("4hxWh"), import.meta.url).toString();


const $72858e3ed9332203$export$4615c62bf5701103 = ({ lockerRoomType: lockerRoomType, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e8e78494152de3aa$exports)))
                    }),
                    t(`club.headers.lockerooms`)
                ]
            }),
            !!lockerRoomType ? t(`club.lockerooms.${lockerRoomType.toLowerCase()}`) : t(`club.lockerooms.noInformation`)
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $4163bc59124ef87d$var$_ = (t)=>t, $4163bc59124ef87d$var$t, $4163bc59124ef87d$var$t1;
const $4163bc59124ef87d$export$32bdb1b219da874c = (0, $6hfZk.default)((0, $aili3.default))($4163bc59124ef87d$var$t || ($4163bc59124ef87d$var$t = $4163bc59124ef87d$var$_`
    display: flex;

    > div {
        flex: 1;
    }
`));
const $4163bc59124ef87d$export$3e431a229df88919 = (0, $6hfZk.default).img($4163bc59124ef87d$var$t1 || ($4163bc59124ef87d$var$t1 = $4163bc59124ef87d$var$_``));



var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $5x2Vb = parcelRequire("5x2Vb");

var $841b1fdf000f0b6e$exports = {};

$841b1fdf000f0b6e$exports = new URL((parcelRequire("4SSe9")).resolve("l9xZe"), import.meta.url).toString();


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5x2Vb))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz.setDefault("UTC");
const $4511ad029da9e7e2$export$4d8c8cd2c300d546 = ({ schedules: schedules, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4163bc59124ef87d$export$3e431a229df88919), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($841b1fdf000f0b6e$exports))),
                        alt: ""
                    }),
                    t(`club.headers.schedules`)
                ]
            }),
            !!(schedules === null || schedules === void 0 ? void 0 : schedules.length) ? schedules.map((schedule, index)=>{
                var _schedule_openDay;
                /*#__PURE__*/ return (0, $bbzbN.jsxs)((0, $4163bc59124ef87d$export$32bdb1b219da874c), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: t(`club.schedules.weekdays.${schedule === null || schedule === void 0 ? void 0 : (_schedule_openDay = schedule.openDay) === null || _schedule_openDay === void 0 ? void 0 : _schedule_openDay.toLowerCase()}`)
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(schedule.from).format("HH:mm"),
                                " - ",
                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(schedule.to).format("HH:mm")
                            ]
                        })
                    ]
                }, `schedule-${index}`);
            }) : t(`club.schedules.noInformation`)
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $5x2Vb = parcelRequire("5x2Vb");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $7ef4bcca92c23c96$var$_ = (t)=>t, $7ef4bcca92c23c96$var$t;
const $7ef4bcca92c23c96$export$80f129dcd8b9c5be = (0, $6hfZk.default)((0, $aili3.default))($7ef4bcca92c23c96$var$t || ($7ef4bcca92c23c96$var$t = $7ef4bcca92c23c96$var$_`
    color: red;
`));



var $6b48efc6b5dc9b3f$exports = {};

$6b48efc6b5dc9b3f$exports = new URL((parcelRequire("4SSe9")).resolve("26Fq2"), import.meta.url).toString();


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5x2Vb))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz.setDefault("UTC");
const $08c3101309c1b8b4$export$50057ebb4fe442d5 = ({ closed: closed, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6b48efc6b5dc9b3f$exports)))
                    }),
                    t(`club.headers.closed`)
                ]
            }),
            !(closed === null || closed === void 0 ? void 0 : closed.length) ? t("club.closed.noInformation") : closed.map((schedule, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7ef4bcca92c23c96$export$80f129dcd8b9c5be), {
                    children: [
                        (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(schedule.startDate).format("DD/MM/YYYY HH:mm"),
                        " -",
                        " ",
                        (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(schedule.endDate).format("DD/MM/YYYY HH:mm")
                    ]
                }, `schedule-${index}`))
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $230f84740d69d80a$exports = {};

$230f84740d69d80a$exports = new URL((parcelRequire("4SSe9")).resolve("MiVPk"), import.meta.url).toString();



const $780ea03aa9eb7b42$export$c1b63ffd678b702e = ({ AreaCategory: sports, variant: variant, id: areaId })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($230f84740d69d80a$exports))),
                        alt: ""
                    }),
                    t(`club.headers.sports`)
                ]
            }),
            (sports === null || sports === void 0 ? void 0 : sports.length) ? sports.map((sport)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a1a4fc57da56c62$export$76b259acec9cae97), {
                    category: sport.category
                }, `area-${areaId}-${sport.category}`)) : t("club.areas.noCategories")
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
var $85cd8fc070d8ad53$exports = {};

$85cd8fc070d8ad53$exports = new URL((parcelRequire("4SSe9")).resolve("emQEE"), import.meta.url).toString();



const $e2680caaa04acc71$export$7ed2599841ce6ad = (timeUnit)=>{
    switch(timeUnit){
        case "TRINTA_MINUTOS":
            return "00:30";
        case "UMA_HORA":
            return "01:00";
        case "UMA_HORA_TRINTA_MINUTOS":
            return "01:30";
        case "DUAS_HORA":
            return "02:00";
        default:
            return "";
    }
};


const $fb83ece5042f36dc$export$b90d960807546f30 = ({ price: price, timeUnit: timeUnit, variant: variant, privacy: privacy })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($85cd8fc070d8ad53$exports)))
                    }),
                    t("club.headers.priceByTimeUnit")
                ]
            }),
            privacy === "PUBLIC" ? "NA" : !!price ? `${parseFloat(`${price}`).toFixed(2)} €` : "-",
            " /",
            " ",
            !!timeUnit ? (0, $e2680caaa04acc71$export$7ed2599841ce6ad)(timeUnit) : "-"
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $5x2Vb = parcelRequire("5x2Vb");

var $98c47a9ce7515ebe$exports = {};

$98c47a9ce7515ebe$exports = new URL((parcelRequire("4SSe9")).resolve("eduNK"), import.meta.url).toString();



(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5x2Vb))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).tz.setDefault("UTC");
const $b6531603860f66ae$export$acf7dc6a5e4bb8ee = ({ reservations: reservations, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($98c47a9ce7515ebe$exports)))
                    }),
                    t(`club.headers.reservations`)
                ]
            }),
            !!(reservations === null || reservations === void 0 ? void 0 : reservations.length) ? reservations.map((reservation)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4163bc59124ef87d$export$32bdb1b219da874c), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(reservation.day).format("DD/MM/YYYY")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(reservation.from).format("HH:mm"),
                                " -",
                                " ",
                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(reservation.to).format("HH:mm")
                            ]
                        })
                    ]
                }, `reservation-${reservation.id}`)) : t("club.schedules.noInformation")
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");





var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $4be776149479a801$var$_ = (t)=>t, $4be776149479a801$var$t;
const $4be776149479a801$export$42a852a2b6b56249 = (0, $6hfZk.default)((0, $aili3.default))($4be776149479a801$var$t || ($4be776149479a801$var$t = $4be776149479a801$var$_`
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;

    div {
        gap: 0.25rem;
        display: flex;
        align-items: center;
        span {
            font-size: 0.9rem;
            text-transform: capitalize;
        }
    }
`));



var $aili3 = parcelRequire("aili3");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
const $7a6d7bc33d2bc30d$export$3176735d3ad67a5 = ({ privacy: privacy, environment: environment })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4be776149479a801$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                children: [
                    privacy === "PRIVATE" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($639cf2d093bbb4ad$exports))), {
                        fontSize: "small",
                        color: "disabled"
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3d319a6f13a7f1a$exports))), {
                        fontSize: "small",
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        children: t(`${privacy.toLowerCase()}`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                children: [
                    environment === "INDOOR" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ea0de4c2ab813d5e$exports))), {
                        fontSize: "small",
                        color: "disabled"
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($493aa4bc6d5b1843$exports))), {
                        fontSize: "small",
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        children: t(`${environment.toLowerCase()}`)
                    })
                ]
            })
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFCqu = parcelRequire("cFCqu");


var $hngXp = parcelRequire("hngXp");


var $7fPBF = parcelRequire("7fPBF");
parcelRequire("j2VHG");

var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $484ba40fa8d03c55$var$ImageListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $484ba40fa8d03c55$export$2e2bcd8739ae039 = $484ba40fa8d03c55$var$ImageListContext;



var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $91ID4 = parcelRequire("91ID4");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $21d90157efeecddb$export$85358568b821ddac(slot) {
    return (0, $k6RDS.default)("MuiImageListItem", slot);
}
const $21d90157efeecddb$var$imageListItemClasses = (0, $4jzsB.default)("MuiImageListItem", [
    "root",
    "img",
    "standard",
    "woven",
    "masonry",
    "quilted"
]);
var $21d90157efeecddb$export$2e2bcd8739ae039 = $21d90157efeecddb$var$imageListItemClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6ed8a3ce3c0210dd$var$_excluded = [
    "children",
    "className",
    "cols",
    "component",
    "rows",
    "style"
];
const $6ed8a3ce3c0210dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        img: [
            "img"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $21d90157efeecddb$export$85358568b821ddac), classes);
};
const $6ed8a3ce3c0210dd$var$ImageListItemRoot = (0, $kDBhE.default)("li", {
    name: "MuiImageListItem",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $21d90157efeecddb$export$2e2bcd8739ae039).img}`]: styles.img
            },
            styles.root,
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: "block",
        position: "relative"
    }, ownerState.variant === "standard" && {
        // For titlebar under list item
        display: "flex",
        flexDirection: "column"
    }, ownerState.variant === "woven" && {
        height: "100%",
        alignSelf: "center",
        "&:nth-of-type(even)": {
            height: "70%"
        }
    }, {
        [`& .${(0, $21d90157efeecddb$export$2e2bcd8739ae039).img}`]: (0, $kY3Ke.default)({
            objectFit: "cover",
            width: "100%",
            height: "100%",
            display: "block"
        }, ownerState.variant === "standard" && {
            height: "auto",
            flexGrow: 1
        })
    }));
const $6ed8a3ce3c0210dd$var$ImageListItem = /*#__PURE__*/ $7fPBF.forwardRef(function ImageListItem(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiImageListItem"
    });
    // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
    const { children: children, className: className, cols: cols = 1, component: component = "li", rows: rows = 1, style: style } = props, other = (0, $cFLic.default)(props, $6ed8a3ce3c0210dd$var$_excluded);
    const { rowHeight: rowHeight = "auto", gap: gap, variant: variant } = $7fPBF.useContext((0, $484ba40fa8d03c55$export$2e2bcd8739ae039));
    let height = "auto";
    if (variant === "woven") height = undefined;
    else if (rowHeight !== "auto") height = rowHeight * rows + gap * (rows - 1);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        cols: cols,
        component: component,
        gap: gap,
        rowHeight: rowHeight,
        rows: rows,
        variant: variant
    });
    const classes = $6ed8a3ce3c0210dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6ed8a3ce3c0210dd$var$ImageListItemRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, classes[variant], className),
        ref: ref,
        style: (0, $kY3Ke.default)({
            height: height,
            gridColumnEnd: variant !== "masonry" ? `span ${cols}` : undefined,
            gridRowEnd: variant !== "masonry" ? `span ${rows}` : undefined,
            marginBottom: variant === "masonry" ? gap : undefined
        }, style),
        ownerState: ownerState
    }, other, {
        children: $7fPBF.Children.map(children, (child)=>{
            if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
            if (child.type === "img" || (0, $91ID4.default)(child, [
                "Image"
            ])) return /*#__PURE__*/ $7fPBF.cloneElement(child, {
                className: (0, $hngXp.default)(classes.img, child.props.className)
            });
            return child;
        })
    }));
});
var $6ed8a3ce3c0210dd$export$2e2bcd8739ae039 = $6ed8a3ce3c0210dd$var$ImageListItem;


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
var $c50d9c535be77c99$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($c50d9c535be77c99$exports, "__esModule", {
    value: true
});
$c50d9c535be77c99$exports.default = void 0;

var $c50d9c535be77c99$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $c50d9c535be77c99$var$_default = (0, $c50d9c535be77c99$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
}), "Image");
$c50d9c535be77c99$exports.default = $c50d9c535be77c99$var$_default;



var $gC25j = parcelRequire("gC25j");

var $6hfZk = parcelRequire("6hfZk");
let $21dbae4cbc7c5fe9$var$_ = (t)=>t, $21dbae4cbc7c5fe9$var$t, $21dbae4cbc7c5fe9$var$t1;
const $21dbae4cbc7c5fe9$export$3e431a229df88919 = (0, $6hfZk.default).img($21dbae4cbc7c5fe9$var$t || ($21dbae4cbc7c5fe9$var$t = $21dbae4cbc7c5fe9$var$_`
    width: 268px;
    height: 268px;
    object-fit: cover;

    @media (max-width: 600px) {
        width: 100%;
    }
`));
const $21dbae4cbc7c5fe9$export$38fb881472c4cc64 = (0, $6hfZk.default)((0, $gC25j.default))($21dbae4cbc7c5fe9$var$t1 || ($21dbae4cbc7c5fe9$var$t1 = $21dbae4cbc7c5fe9$var$_`
    max-width: 420px !important;
`));



var $19315dd41209fb65$exports = {};
"use strict";
Object.defineProperty($19315dd41209fb65$exports, "__esModule", {
    value: true
});
$19315dd41209fb65$exports["default"] = void 0;

var $19315dd41209fb65$var$_slider = $19315dd41209fb65$var$_interopRequireDefault((parcelRequire("8FqGL")));
function $19315dd41209fb65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $19315dd41209fb65$var$_default = $19315dd41209fb65$var$_slider["default"];
$19315dd41209fb65$exports["default"] = $19315dd41209fb65$var$_default;


const $4e408bab6288c4a3$export$44dac671f43333ee = ({ photos: photos, variant: variant })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 380,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$d675f139b342d51a), {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c50d9c535be77c99$exports))), {
                        fontSize: "small",
                        className: "mr-1"
                    }),
                    t("club.headers.clubGallery")
                ]
            }),
            !(photos === null || photos === void 0 ? void 0 : photos.length) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $21dbae4cbc7c5fe9$export$38fb881472c4cc64), {
                severity: "info",
                className: "alert",
                children: t("club.gallery.emptyList")
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($19315dd41209fb65$exports))), {
                ...settings,
                children: photos.map((item)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ed8a3ce3c0210dd$export$2e2bcd8739ae039), {
                        sx: {
                            padding: "2px"
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $21dbae4cbc7c5fe9$export$3e431a229df88919), {
                            src: item.photoUrl,
                            alt: "",
                            loading: "lazy"
                        })
                    }, item.createdAt))
            })
        ]
    });
};


const $ece6984427a17b8a$export$4c0287abd2ec956e = ({ title: title, param: param }, object, variant = "big")=>{
    switch(title){
        case "paymentMethods":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2d1dcd1fd83f2fed$export$ab218e41b1f3d913), {
                variant: variant,
                paymentMethods: object[param]
            }, `${object.id}-${param}`);
        case "clubImageList":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4e408bab6288c4a3$export$44dac671f43333ee), {
                variant: variant,
                photos: object[param]
            }, `${object.id}-${param}`);
        case "parking":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4a5b2427b51d5f0e$export$fb98353eb72a772d), {
                variant: variant,
                carParkType: object[param]
            }, `${object.id}-${param}`);
        case "lockerooms":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $72858e3ed9332203$export$4615c62bf5701103), {
                variant: variant,
                lockerRoomType: object[param]
            }, `${object.id}-${param}`);
        case "schedules":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4511ad029da9e7e2$export$4d8c8cd2c300d546), {
                variant: variant,
                schedules: object[param]
            }, `${object.id}-${param}`);
        case "closed":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $08c3101309c1b8b4$export$50057ebb4fe442d5), {
                variant: variant,
                closed: object[param]
            }, `${object.id}-${param}`);
        case "sports":
            {
                const props = param.reduce((acc, prop)=>({
                        ...acc,
                        [prop]: object[prop]
                    }), {});
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $780ea03aa9eb7b42$export$c1b63ffd678b702e), {
                    ...props
                }, `${object.id}-${param}`);
            }
        case "price-time":
            {
                const props = param.reduce((acc, prop)=>({
                        ...acc,
                        [prop]: object[prop]
                    }), {});
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fb83ece5042f36dc$export$b90d960807546f30), {
                    variant: variant,
                    ...props
                }, `${object.id}-${param[0]}`);
            }
        case "reservations":
            return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6531603860f66ae$export$acf7dc6a5e4bb8ee), {
                variant: variant,
                reservations: object[param]
            }, `${object.id}-${param}`);
        case "privacy-environment":
            {
                const props = param.reduce((acc, prop)=>({
                        ...acc,
                        [prop]: object[prop]
                    }), {});
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7a6d7bc33d2bc30d$export$3176735d3ad67a5), {
                    ...props
                }, `${object.id}-${param[0]}`);
            }
        default:
            return null;
    }
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $c8e684b0305bca57$var$_ = (t)=>t, $c8e684b0305bca57$var$t, $c8e684b0305bca57$var$t1, $c8e684b0305bca57$var$t2;
const $c8e684b0305bca57$export$84af16ba1207cbe2 = (0, $6hfZk.default)((0, $aili3.default))($c8e684b0305bca57$var$t || ($c8e684b0305bca57$var$t = $c8e684b0305bca57$var$_`
    margin-top: 2.5rem;
`));
const $c8e684b0305bca57$export$3e7ac2a27534b0a2 = (0, $6hfZk.default)((0, $aili3.default))($c8e684b0305bca57$var$t1 || ($c8e684b0305bca57$var$t1 = $c8e684b0305bca57$var$_`
    gap: 1rem;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;

    > div {
        width: calc(50% - 0.5rem);
        &:last-of-type {
            width: 100%;
        }
    }

    @media (min-width: 1024px) {
        > div {
            flex: 1;
            width: unset;
        }
    }
`));
const $c8e684b0305bca57$export$be037cb0eb4aad7a = (0, $6hfZk.default)((0, $aili3.default))($c8e684b0305bca57$var$t2 || ($c8e684b0305bca57$var$t2 = $c8e684b0305bca57$var$_`
    @media (min-width: 1024px) {
        gap: 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
    }
`));



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gC25j = parcelRequire("gC25j");
var $gXHSV = parcelRequire("gXHSV");

var $goR7t = parcelRequire("goR7t");



var $aili3 = parcelRequire("aili3");
var $3loMv = parcelRequire("3loMv");

var $6hfZk = parcelRequire("6hfZk");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $1N52b = parcelRequire("1N52b");

var $goR7t = parcelRequire("goR7t");

var $84nYO = parcelRequire("84nYO");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $6hfZk = parcelRequire("6hfZk");
let $160160002fd2e06d$var$_ = (t)=>t, $160160002fd2e06d$var$t;
const $160160002fd2e06d$export$b04be29aa201d4f5 = (0, $6hfZk.default).p($160160002fd2e06d$var$t || ($160160002fd2e06d$var$t = $160160002fd2e06d$var$_`
    color: red;
    z-index: 1;
    text-align: end;
    font-size: 0.9rem;
    position: relative;
`));


const $e64763870b2dcbbb$export$863d91069b245c1d = ({ schedules: schedules, closedSchedule: closedSchedule, baseTranslationKey: baseTranslationKey })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $160160002fd2e06d$export$b04be29aa201d4f5), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                children: t(`${baseTranslationKey}.club_unavailable`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: !schedules.length ? t(`${baseTranslationKey}.schedule_error`) : t(`${baseTranslationKey}.closed_schedule_error`, {
                    from: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(closedSchedule === null || closedSchedule === void 0 ? void 0 : closedSchedule.startDate).format("DD-MM-YYYY"),
                    to: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(closedSchedule === null || closedSchedule === void 0 ? void 0 : closedSchedule.endDate).format("DD-MM-YYYY")
                })
            })
        ]
    });
};



var $6hfZk = parcelRequire("6hfZk");

var $aili3 = parcelRequire("aili3");
var $5ZeKC = parcelRequire("5ZeKC");
var $2hGJ2 = parcelRequire("2hGJ2");
let $6a0d74d9d8c84bda$var$_ = (t)=>t, $6a0d74d9d8c84bda$var$t, $6a0d74d9d8c84bda$var$t1, $6a0d74d9d8c84bda$var$t2, $6a0d74d9d8c84bda$var$t3, $6a0d74d9d8c84bda$var$t4, $6a0d74d9d8c84bda$var$t5;
const $6a0d74d9d8c84bda$export$6c9e9c9ca4347ce8 = (0, $6hfZk.default)((0, $aili3.default))($6a0d74d9d8c84bda$var$t || ($6a0d74d9d8c84bda$var$t = $6a0d74d9d8c84bda$var$_`
    display: flex;
    flex-wrap: wrap;
    gap: 0.2rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
`));
const $6a0d74d9d8c84bda$export$ef50152da13f3005 = (0, $6hfZk.default)((0, $2hGJ2.default))($6a0d74d9d8c84bda$var$t1 || ($6a0d74d9d8c84bda$var$t1 = $6a0d74d9d8c84bda$var$_`
    .MuiChip-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .MuiChip-avatarColorPrimary {
        background: transparent !important;
    }

    &.Mui-disabled {
        opacity: 0.75 !important;
    }
`));
const $6a0d74d9d8c84bda$export$1070e5b79dbe801f = (0, $6hfZk.default).div($6a0d74d9d8c84bda$var$t2 || ($6a0d74d9d8c84bda$var$t2 = $6a0d74d9d8c84bda$var$_`
    color: red;
    font-size: 0.9rem;
    margin-bottom: 1rem;
`));
const $6a0d74d9d8c84bda$export$40dbffe112efbdd7 = (0, $6hfZk.default).p($6a0d74d9d8c84bda$var$t3 || ($6a0d74d9d8c84bda$var$t3 = $6a0d74d9d8c84bda$var$_`
    flex: 1;
    margin: 0;
    display: flex;
    flex-shrink: 0;
    text-align: end;
    font-size: 0.9rem;
    font-weight: bold;
    margin-left: 1rem;
    margin-bottom: 0.5rem;
    align-items: flex-end;
    justify-content: flex-end;
`));
const $6a0d74d9d8c84bda$export$2d5d2ba3c7c8c40b = (0, $6hfZk.default)((0, $5ZeKC.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "disabledAspect"
})($6a0d74d9d8c84bda$var$t5 || ($6a0d74d9d8c84bda$var$t5 = $6a0d74d9d8c84bda$var$_`
    width: 100%;
    box-shadow: none !important;
    max-height: 2.3rem;

    .MuiTouchRipple-root {
        display: none !important;
    }

    ${0}
`), ({ disabledAspect: disabledAspect })=>disabledAspect && (0, $6hfZk.css)($6a0d74d9d8c84bda$var$t4 || ($6a0d74d9d8c84bda$var$t4 = $6a0d74d9d8c84bda$var$_`
            background-color: lightgrey !important;
            color: #424242 !important;
        `)));




var $aili3 = parcelRequire("aili3");
const $a7cb30f46f215d07$export$83e59e016ed543bf = ({ clubId: clubId, categories: areaCategories, areaId: areaId, areaName: areaName, price: price, privacy: privacy, reservations: reservations, areaSchedules: areaSchedules, areaClosedSchedules: areaClosedSchedules, displayOptions: displayOptions, ...remainingProps })=>{
    const { role: role } = (0, $1N52b.useAuth)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { searchObj: searchObj, categories: allCategories } = (0, $goR7t.default)();
    const { showPrice: showPrice } = displayOptions;
    const [sport, selectSport] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(!!searchObj.sport && searchObj.sport.length > 0 ? allCategories === null || allCategories === void 0 ? void 0 : allCategories.find((cat)=>searchObj.sport.includes(cat.toUpperCase())) : (areaCategories === null || areaCategories === void 0 ? void 0 : areaCategories.length) === 1 ? areaCategories[0] : undefined);
    (0, $7fPBF.useEffect)(()=>{
        if (!!searchObj.sport && searchObj.sport.length > 0) selectSport(allCategories === null || allCategories === void 0 ? void 0 : allCategories.find((cat)=>searchObj.sport.includes(cat.toUpperCase())));
        else if ((areaCategories === null || areaCategories === void 0 ? void 0 : areaCategories.length) === 1) selectSport(areaCategories[0]);
    }, [
        searchObj.sport
    ]);
    const isAreaClosed = !areaSchedules.length || areaClosedSchedules.length > 0;
    const areaClosedSchedule = (areaClosedSchedules === null || areaClosedSchedules === void 0 ? void 0 : areaClosedSchedules.length) ? areaClosedSchedules[0] : undefined;
    const isButtonDisabled = isAreaClosed || (reservations === null || reservations === void 0 ? void 0 : reservations.length) > 0 || !sport;
    const handleBookingNavigation = (sport)=>{
        const { url: url, state: state } = (0, $84nYO.getBookingUrlAndState)(role, searchObj, allCategories, clubId, {
            id: areaId,
            name: areaName
        }, price, sport);
        navigate(url, {
            state: {
                ...state
            }
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        ...remainingProps,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6a0d74d9d8c84bda$export$6c9e9c9ca4347ce8), {
                children: areaCategories.map((category)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $6a0d74d9d8c84bda$export$ef50152da13f3005), {
                        avatar: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a1a4fc57da56c62$export$76b259acec9cae97), {
                            selected: sport === category,
                            category: category
                        }, `area-${areaId}-${category}`),
                        label: t(`search.sports.${category.toLowerCase()}`),
                        color: "primary",
                        onClick: ()=>selectSport(category),
                        variant: sport === category ? "filled" : "outlined",
                        disabled: !!searchObj.sport && searchObj.sport.length < 0
                    }, `chip-${areaId}-cat-${category}`))
            }),
            isAreaClosed && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e64763870b2dcbbb$export$863d91069b245c1d), {
                schedules: areaSchedules,
                closedSchedule: areaClosedSchedule,
                baseTranslationKey: "clubList.area"
            }),
            (reservations === null || reservations === void 0 ? void 0 : reservations.length) > 0 && reservations.map((reservation, index)=>{
                return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6a0d74d9d8c84bda$export$1070e5b79dbe801f), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                            children: [
                                t("alreadyBooked"),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("b", {
                            children: [
                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(reservation.from).format("HH:mm"),
                                " -",
                                " ",
                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(reservation.to).format("HH:mm")
                            ]
                        })
                    ]
                }, `area-${areaId}-reservation-${index}`);
            }),
            showPrice ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6a0d74d9d8c84bda$export$40dbffe112efbdd7), {
                children: privacy !== "PUBLIC" ? `${Number(price).toFixed(2)} €` : "N/A"
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                title: !sport ? "Selecione um desporto" : "",
                arrow: true,
                placement: "top",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6a0d74d9d8c84bda$export$2d5d2ba3c7c8c40b), {
                    id: "book-now",
                    variant: "contained",
                    disabledAspect: isButtonDisabled,
                    onClick: ()=>!isButtonDisabled && handleBookingNavigation(sport),
                    children: t("clubList.book")
                })
            })
        ]
    });
};


let $8847901b98254615$var$_ = (t)=>t, $8847901b98254615$var$t, $8847901b98254615$var$t1, $8847901b98254615$var$t2, $8847901b98254615$var$t3, $8847901b98254615$var$t4, $8847901b98254615$var$t5, $8847901b98254615$var$t6, $8847901b98254615$var$t7, $8847901b98254615$var$t8, $8847901b98254615$var$t9, $8847901b98254615$var$t10, $8847901b98254615$var$t11, $8847901b98254615$var$t12, $8847901b98254615$var$t13;
const $8847901b98254615$export$ea1a111407f37557 = (0, $6hfZk.default)((0, $aili3.default))($8847901b98254615$var$t || ($8847901b98254615$var$t = $8847901b98254615$var$_`
    margin-bottom: 1rem;
    background: white;
    border-radius: 0.5rem;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -3px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px,
        rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;

    @media (min-width: 1024px) {
        width: calc(33% - 11px);
    }
`));
const $8847901b98254615$export$73f41f283d4de22 = (0, $6hfZk.default)((0, $aili3.default))($8847901b98254615$var$t1 || ($8847901b98254615$var$t1 = $8847901b98254615$var$_`
    gap: 1rem;
    display: flex;
    flex-direction: column;
`));
const $8847901b98254615$export$2eec7c08090e9eb9 = (0, $6hfZk.default)((0, $aili3.default))($8847901b98254615$var$t2 || ($8847901b98254615$var$t2 = $8847901b98254615$var$_`
    width: 100%;
`));
const $8847901b98254615$export$71219af9848f38ea = (0, $6hfZk.default).img($8847901b98254615$var$t3 || ($8847901b98254615$var$t3 = $8847901b98254615$var$_`
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    max-height: 200px;
`));
const $8847901b98254615$export$3abaa6c4e0fb33ef = (0, $6hfZk.default)((0, $aili3.default))($8847901b98254615$var$t4 || ($8847901b98254615$var$t4 = $8847901b98254615$var$_`
    flex: 1;
    & > div:first-of-type {
        padding-inline: 1rem;
    }
`));
const $8847901b98254615$export$f975a78ec18d4f97 = (0, $6hfZk.default).h4($8847901b98254615$var$t5 || ($8847901b98254615$var$t5 = $8847901b98254615$var$_`
    margin: 0;
`));
const $8847901b98254615$export$40dbffe112efbdd7 = (0, $6hfZk.default)((0, $aili3.default))($8847901b98254615$var$t6 || ($8847901b98254615$var$t6 = $8847901b98254615$var$_`
    h3 {
        margin: 0;
        text-align: end;
    }
`));
const $8847901b98254615$export$f76e95e9e8da061f = (0, $6hfZk.default).p($8847901b98254615$var$t7 || ($8847901b98254615$var$t7 = $8847901b98254615$var$_`
    width: 100%;
    max-height: 4.5em;
    line-height: 1.5em;
    padding: 0 1rem;
    overflow: auto;
`));
const $8847901b98254615$export$9f206abb5ed94520 = (0, $6hfZk.default)((0, $e9f205f7f0ba8e26$export$2e2bcd8739ae039))($8847901b98254615$var$t8 || ($8847901b98254615$var$t8 = $8847901b98254615$var$_`
    margin-top: 1rem;
`));
const $8847901b98254615$export$55a634df6fa02b47 = (0, $6hfZk.default)((0, $3loMv.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "expanded"
})($8847901b98254615$var$t11 || ($8847901b98254615$var$t11 = $8847901b98254615$var$_`
    position: relative;
    padding-left: 2rem;

    &:after {
        width: 8px;
        height: 8px;
        content: '';
        display: block;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        transition: top .3s ease, transform: .3s ease;

        ${0}
    }
`), ({ expanded: expanded })=>!expanded ? (0, $6hfZk.css)($8847901b98254615$var$t9 || ($8847901b98254615$var$t9 = $8847901b98254615$var$_`
                      top: 5px;
                      left: 2px;
                      transform: rotate(-135deg);
                  `)) : (0, $6hfZk.css)($8847901b98254615$var$t10 || ($8847901b98254615$var$t10 = $8847901b98254615$var$_`
                      top: 9px;
                      left: 2px;
                      transform: rotate(45deg);
                  `)));
const $8847901b98254615$export$8aac60c6d5e488c5 = (0, $6hfZk.default)((0, $aili3.default))($8847901b98254615$var$t12 || ($8847901b98254615$var$t12 = $8847901b98254615$var$_`
    padding: 1rem;
`));
const $8847901b98254615$export$244a0feea1197f7c = (0, $6hfZk.default)((0, $a7cb30f46f215d07$export$83e59e016ed543bf))($8847901b98254615$var$t13 || ($8847901b98254615$var$t13 = $8847901b98254615$var$_`
    margin-top: 1rem;
`));



parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

const $68a8f04e27a2a3ca$export$4ff3678dc42e6cf7 = ({ area: area, images: images, isSearchEnabled: isSearchEnabled })=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const { results: results } = (0, $goR7t.default)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const clubResult = results === null || results === void 0 ? void 0 : results[0];
    const areaResult = clubResult === null || clubResult === void 0 ? void 0 : clubResult.areas.find((clubArea)=>clubArea.id === area.id);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$ea1a111407f37557), {
        id: `area-${area.id}`,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8847901b98254615$export$73f41f283d4de22), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$2eec7c08090e9eb9), {
                    children: (images === null || images === void 0 ? void 0 : images.length) > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2b2f9356127c80f0$exports))), {
                        className: "carousel",
                        autoPlay: false,
                        navButtonsAlwaysVisible: (images === null || images === void 0 ? void 0 : images.length) > 1 ? true : false,
                        indicators: false,
                        navButtonsProps: {
                            className: "carousel-nav-buttons"
                        },
                        children: images === null || images === void 0 ? void 0 : images.map((image, idx)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$71219af9848f38ea), {
                                src: image.photoUrl
                            }, idx))
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$71219af9848f38ea), {
                        src: "https://placehold.co/400"
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8847901b98254615$export$3abaa6c4e0fb33ef), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$124d4c7bf7db9715), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$f975a78ec18d4f97), {
                                    children: area.name
                                }),
                                areaResult ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$40dbffe112efbdd7), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("h3", {
                                        children: [
                                            areaResult.price,
                                            " €"
                                        ]
                                    })
                                }) : null
                            ]
                        }),
                        !!area.description && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$f76e95e9e8da061f), {
                            children: area.description
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8847901b98254615$export$9f206abb5ed94520), {
                            expanded: expanded,
                            onChange: ()=>setExpanded((previous)=>!previous),
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4dadc25f7bb7b60a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8847901b98254615$export$55a634df6fa02b47), {
                                        expanded: expanded,
                                        children: [
                                            expanded ? t("less") : t("more"),
                                            " info"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a33ac73601ffa184$export$2e2bcd8739ae039), {
                                    children: (0, $65826a3097b94805$export$96b01ac844a9b9c6).map((section)=>(0, $ece6984427a17b8a$export$4c0287abd2ec956e)(section, area, "small"))
                                })
                            ]
                        }),
                        clubResult && areaResult && isSearchEnabled ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$8aac60c6d5e488c5), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$244a0feea1197f7c), {
                                categories: areaResult.categories,
                                clubId: clubResult.id,
                                areaId: areaResult.id,
                                price: areaResult.price,
                                privacy: areaResult.privacy,
                                areaName: areaResult.name,
                                areaSchedules: areaResult.schedules,
                                areaClosedSchedules: areaResult.closedSchedules,
                                reservations: areaResult.reservations,
                                displayOptions: {
                                    showPrice: false,
                                    showClosedClubLabel: true
                                }
                            })
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8847901b98254615$export$8aac60c6d5e488c5), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gC25j.default), {
                                severity: "info",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gXHSV.default), {
                                        children: t("clubAreas.message.noSportInfoTitle")
                                    }),
                                    t("clubAreas.message.noSportInfoDescription")
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $goR7t = parcelRequire("goR7t");

var $a13Ew = parcelRequire("a13Ew");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $6hfZk = parcelRequire("6hfZk");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");
var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $fx0uj = parcelRequire("fx0uj");
var $gaYwN = parcelRequire("gaYwN");
var $giDhD = parcelRequire("giDhD");
var $65Itt = parcelRequire("65Itt");
var $7fPBF = parcelRequire("7fPBF");
"use client";
const $8058a65d531805f3$var$usePreviousProps = (value)=>{
    const ref = $7fPBF.useRef({});
    $7fPBF.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $8058a65d531805f3$export$2e2bcd8739ae039 = $8058a65d531805f3$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $6bd1c39efcabe1c3$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $6bd1c39efcabe1c3$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $6bd1c39efcabe1c3$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $6bd1c39efcabe1c3$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $6bd1c39efcabe1c3$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $6bd1c39efcabe1c3$var$defaultFilterOptions = $6bd1c39efcabe1c3$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $6bd1c39efcabe1c3$var$pageSize = 5;
const $6bd1c39efcabe1c3$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $6bd1c39efcabe1c3$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $6bd1c39efcabe1c3$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $6bd1c39efcabe1c3$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $65Itt.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $7fPBF.useRef(false);
    const firstFocus = $7fPBF.useRef(true);
    const inputRef = $7fPBF.useRef(null);
    const listboxRef = $7fPBF.useRef(null);
    const [anchorEl, setAnchorEl] = $7fPBF.useState(null);
    const [focusedTag, setFocusedTag] = $7fPBF.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $7fPBF.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $gaYwN.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $gaYwN.default)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $7fPBF.useState(false);
    const resetInputValue = $7fPBF.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $gaYwN.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $7fPBF.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $8058a65d531805f3$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $7fPBF.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $giDhD.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $7fPBF.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) return -1;
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const setHighlightedIndex = (0, $giDhD.default)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $giDhD.default)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $7fPBF.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $6bd1c39efcabe1c3$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $6bd1c39efcabe1c3$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $giDhD.default)((node)=>{
        (0, $fx0uj.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $7fPBF.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $7fPBF.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $6bd1c39efcabe1c3$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$6bd1c39efcabe1c3$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $6bd1c39efcabe1c3$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (inputValue === "" || !open) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $kY3Ke.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $kY3Ke.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $cxeT8 = parcelRequire("cxeT8");

var $41bfV = parcelRequire("41bfV");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $5j2OD = parcelRequire("5j2OD");

var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0842d99f651a305f$export$6816d4fc0981ec7(slot) {
    return (0, $k6RDS.default)("MuiListSubheader", slot);
}
const $0842d99f651a305f$var$listSubheaderClasses = (0, $4jzsB.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $0842d99f651a305f$export$2e2bcd8739ae039 = $0842d99f651a305f$var$listSubheaderClasses;



var $bbzbN = parcelRequire("bbzbN");
"use client";
const $f6a8c189b782c624$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $f6a8c189b782c624$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $b6UUh.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $0842d99f651a305f$export$6816d4fc0981ec7), classes);
};
const $f6a8c189b782c624$var$ListSubheaderRoot = (0, $kDBhE.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $f6a8c189b782c624$var$ListSubheader = /*#__PURE__*/ $7fPBF.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $cFLic.default)(props, $f6a8c189b782c624$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $f6a8c189b782c624$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($f6a8c189b782c624$var$ListSubheaderRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$f6a8c189b782c624$var$ListSubheader.muiSkipListHighlight = true;
var $f6a8c189b782c624$export$2e2bcd8739ae039 = $f6a8c189b782c624$var$ListSubheader;



var $a2ay0 = parcelRequire("a2ay0");

var $8TDId = parcelRequire("8TDId");

var $2hGJ2 = parcelRequire("2hGJ2");

var $eFvie = parcelRequire("eFvie");

var $3HkEr = parcelRequire("3HkEr");

var $lCN2y = parcelRequire("lCN2y");

var $gImJ8 = parcelRequire("gImJ8");

var $bVWI3 = parcelRequire("bVWI3");

var $aI4oF = parcelRequire("aI4oF");

var $5j2OD = parcelRequire("5j2OD");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $b00bc803f1d3305d$export$8ee01529667e66d9(slot) {
    return (0, $k6RDS.default)("MuiAutocomplete", slot);
}
const $b00bc803f1d3305d$var$autocompleteClasses = (0, $4jzsB.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $b00bc803f1d3305d$export$2e2bcd8739ae039 = $b00bc803f1d3305d$var$autocompleteClasses;



var $b6UUh = parcelRequire("b6UUh");

var $6NwTb = parcelRequire("6NwTb");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $b63de180c8636c16$var$_ClearIcon, $b63de180c8636c16$var$_ArrowDropDownIcon;
const $b63de180c8636c16$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $b63de180c8636c16$var$_excluded2 = [
    "ref"
];
const $b63de180c8636c16$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $b6UUh.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $b00bc803f1d3305d$export$8ee01529667e66d9), classes);
};
const $b63de180c8636c16$var$AutocompleteRoot = (0, $kDBhE.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $b6UUh.default)(size)}`]
            },
            {
                [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        [`&.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).focused} .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).tag}`]: (0, $kY3Ke.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $eFvie.default).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $eFvie.default).root}.${(0, $3HkEr.default).sizeSmall}`]: {
            [`& .${(0, $eFvie.default).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $lCN2y.default).root}`]: {
            padding: 9,
            [`.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $lCN2y.default).root}.${(0, $3HkEr.default).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, $gImJ8.default).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $gImJ8.default).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $gImJ8.default).root}.${(0, $3HkEr.default).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $gImJ8.default).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $3HkEr.default).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $gImJ8.default).root}.${(0, $3HkEr.default).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $gImJ8.default).root}.${(0, $3HkEr.default).hiddenLabel}.${(0, $3HkEr.default).sizeSmall}`]: {
            [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).input}`]: (0, $kY3Ke.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $b63de180c8636c16$var$AutocompleteEndAdornment = (0, $kDBhE.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $b63de180c8636c16$var$AutocompleteClearIndicator = (0, $kDBhE.default)((0, $8TDId.default), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $b63de180c8636c16$var$AutocompletePopupIndicator = (0, $kDBhE.default)((0, $8TDId.default), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $kY3Ke.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $b63de180c8636c16$var$AutocompletePopper = (0, $kDBhE.default)((0, $41bfV.default), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $b63de180c8636c16$var$AutocompletePaper = (0, $kDBhE.default)((0, $a2ay0.default), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $b63de180c8636c16$var$AutocompleteLoading = (0, $kDBhE.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $b63de180c8636c16$var$AutocompleteNoOptions = (0, $kDBhE.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $b63de180c8636c16$var$AutocompleteListbox = (0, $kDBhE.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $cxeT8.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $b63de180c8636c16$var$AutocompleteGroupLabel = (0, $kDBhE.default)((0, $f6a8c189b782c624$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $b63de180c8636c16$var$AutocompleteGroupUl = (0, $kDBhE.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $b00bc803f1d3305d$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $b63de180c8636c16$var$Autocomplete = /*#__PURE__*/ $7fPBF.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $5j2OD.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $b63de180c8636c16$var$_ClearIcon || ($b63de180c8636c16$var$_ClearIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bVWI3.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading…", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $a2ay0.default), PopperComponent: PopperComponent = (0, $41bfV.default), popupIcon: popupIcon = $b63de180c8636c16$var$_ArrowDropDownIcon || ($b63de180c8636c16$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aI4oF.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $cFLic.default)(props, $b63de180c8636c16$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $6bd1c39efcabe1c3$export$1e40b3ca02d92d21)((0, $kY3Ke.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $cFLic.default)(_getListboxProps, $b63de180c8636c16$var$_excluded2);
    const combinedListboxRef = (0, $6NwTb.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $b63de180c8636c16$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $kY3Ke.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), (0, $kY3Ke.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>/*#__PURE__*/ (0, $bbzbN.jsx)("li", (0, $kY3Ke.default)({}, props2, {
            children: getOptionLabel(option)
        }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $kY3Ke.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteRoot, (0, $kY3Ke.default)({
                ref: ref,
                className: (0, $hngXp.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $kY3Ke.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $bbzbN.jsxs)($b63de180c8636c16$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteClearIndicator, (0, $kY3Ke.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $hngXp.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompletePopupIndicator, (0, $kY3Ke.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $hngXp.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $kY3Ke.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompletePopper, (0, $kY3Ke.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $hngXp.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)($b63de180c8636c16$var$AutocompletePaper, (0, $kY3Ke.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $hngXp.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)($b63de180c8636c16$var$AutocompleteListbox, (0, $kY3Ke.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $b63de180c8636c16$export$2e2bcd8739ae039 = $b63de180c8636c16$var$Autocomplete;


var $aili3 = parcelRequire("aili3");
var $jh0sD = parcelRequire("jh0sD");

var $lNdSG = parcelRequire("lNdSG");

var $dkKmP = parcelRequire("dkKmP");
let $599cbc729f56127c$var$_ = (t)=>t, $599cbc729f56127c$var$t, $599cbc729f56127c$var$t1, $599cbc729f56127c$var$t2, $599cbc729f56127c$var$t3, $599cbc729f56127c$var$t4, $599cbc729f56127c$var$t5, $599cbc729f56127c$var$t6, $599cbc729f56127c$var$t7, $599cbc729f56127c$var$t8, $599cbc729f56127c$var$t9;
const $599cbc729f56127c$export$f8697111af41b441 = (0, $6hfZk.css)($599cbc729f56127c$var$t || ($599cbc729f56127c$var$t = $599cbc729f56127c$var$_`
    position: relative;
    pointer-events: none;
    background-color: white;

    .MuiInputAdornment-outlined {
        pointer-events: all;

        > button {
            position: unset;

            .MuiTouchRipple-root {
                display: none;
            }

            &::before {
                top: 0;
                left: 0;
                content: '';
                width: 100%;
                height: 100%;
                display: block;
                position: absolute;
            }
        }
    }
`));
const $599cbc729f56127c$export$e7e6b99c949fd18a = (0, $6hfZk.default)((0, $jh0sD.default))($599cbc729f56127c$var$t1 || ($599cbc729f56127c$var$t1 = $599cbc729f56127c$var$_`
    background-color: white;
`));
const $599cbc729f56127c$export$124d4c7bf7db9715 = (0, $6hfZk.default).div($599cbc729f56127c$var$t2 || ($599cbc729f56127c$var$t2 = $599cbc729f56127c$var$_`
    gap: 0.7rem;
    display: flex;
    flex-wrap: wrap;

    > div {
        width: calc(50% - 0.35rem);
    }

    @media (min-width: 1024px) {
        gap: 1rem;

        > div {
            width: calc(50% - 0.5rem);
        }
    }
`));
const $599cbc729f56127c$export$fe6e7db83e51bd64 = (0, $6hfZk.default)((0, $lNdSG.DatePicker))($599cbc729f56127c$var$t3 || ($599cbc729f56127c$var$t3 = $599cbc729f56127c$var$_`
    background-color: white;
    @media (pointer: fine) {
        ${0};
    }
`), $599cbc729f56127c$export$f8697111af41b441);
const $599cbc729f56127c$export$96952269499d1070 = (0, $6hfZk.default)((0, $b63de180c8636c16$export$2e2bcd8739ae039))($599cbc729f56127c$var$t4 || ($599cbc729f56127c$var$t4 = $599cbc729f56127c$var$_`
    background-color: white;
`));
const $599cbc729f56127c$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($599cbc729f56127c$var$t5 || ($599cbc729f56127c$var$t5 = $599cbc729f56127c$var$_`
    gap: 1rem;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    @media (min-width: 1024px) {
        flex-direction: row;
        padding-right: 1rem;
    }
`));
const $599cbc729f56127c$export$71655785c758526a = (0, $6hfZk.default)((0, $aili3.default))($599cbc729f56127c$var$t6 || ($599cbc729f56127c$var$t6 = $599cbc729f56127c$var$_`
    gap: 1rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > div {
        &:not(:last-of-type) {
            width: calc(50% - 0.5rem);
        }
    }

    @media (min-width: 1024px) {
        flex: 1;
        flex-wrap: wrap;
        flex-direction: row;
        padding-inline-start: 1rem;

        > div {
            flex: 1;
            width: calc(20% - 0.858rem);
            min-width: calc(20% - 0.858rem);
            &:not(:last-of-type) {
                min-width: unset;
                width: calc(calc(80% / 6) - 0.858rem);
            }

            &:first-of-type,
            &:nth-of-type(3),
            &:nth-of-type(5),
            &:nth-of-type(6) {
                max-width: 175px;
            }

            &:nth-of-type(2),
            &:nth-of-type(4) {
                max-width: 150px;
            }
        }
    }
`));
const $599cbc729f56127c$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($599cbc729f56127c$var$t7 || ($599cbc729f56127c$var$t7 = $599cbc729f56127c$var$_`
    @media (min-width: 1024px) {
        width: 64px !important;
        height: 56px !important;
    }
`));
const $599cbc729f56127c$export$deafc66e4bed6a0c = (0, $6hfZk.default).span($599cbc729f56127c$var$t8 || ($599cbc729f56127c$var$t8 = $599cbc729f56127c$var$_`
    @media (min-width: 1024px) {
        display: none;
    }
`));
const $599cbc729f56127c$export$1cf99fbf89ef919e = (0, $6hfZk.default).img($599cbc729f56127c$var$t9 || ($599cbc729f56127c$var$t9 = $599cbc729f56127c$var$_`
    display: none;

    @media (min-width: 1024px) {
        display: block;
    }
`));



var $3jMGu = parcelRequire("3jMGu");
var $gFr0F = parcelRequire("gFr0F");
var $lHSFU = parcelRequire("lHSFU");
var $58CWL = parcelRequire("58CWL");

var $3XFgI = parcelRequire("3XFgI");

var $a13Ew = parcelRequire("a13Ew");

var $goR7t = parcelRequire("goR7t");
const $cf0a543cffa96588$export$56e6458301f6214c = ({ error: error, additionalSearchObj: additionalSearchObj, ...remainingProps })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { availableHours: availableHours, actions: { handleInputChange: handleInputChange } } = (0, $a13Ew.useSearch)();
    const { searchObj: searchObj } = (0, $goR7t.default)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                id: "date-select",
                error: (error === null || error === void 0 ? void 0 : error.field) === "date",
                required: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$fe6e7db83e51bd64), {
                    disablePast: true,
                    format: "DD-MM-YYYY",
                    label: t("search.labels.date"),
                    value: searchObj.date,
                    slotProps: {
                        textField: {
                            required: true,
                            error: (error === null || error === void 0 ? void 0 : error.field) === "date",
                            helperText: (error === null || error === void 0 ? void 0 : error.field) === "date" ? error.message : undefined
                        }
                    },
                    onChange: (date)=>handleInputChange("date", date, additionalSearchObj !== null && additionalSearchObj !== void 0 ? additionalSearchObj : {})
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                id: "time-select",
                error: (error === null || error === void 0 ? void 0 : error.field) === "time",
                required: true,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                        id: "search-time",
                        children: t("search.labels.time")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$e7e6b99c949fd18a), {
                        required: true,
                        name: "time",
                        variant: "outlined",
                        labelId: "search-time",
                        label: t("search.labels.time"),
                        value: searchObj.time,
                        onChange: (e)=>handleInputChange("time", e.target.value, additionalSearchObj !== null && additionalSearchObj !== void 0 ? additionalSearchObj : {}),
                        children: availableHours.map((hour)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                value: hour.value,
                                children: hour.label
                            }, `time-${hour.value}`))
                    }),
                    (error === null || error === void 0 ? void 0 : error.field) === "time" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFr0F.default), {
                        children: error.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                id: "time-unit-select",
                error: (error === null || error === void 0 ? void 0 : error.field) === "timeUnit",
                required: true,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                        id: "search-timeUnit",
                        children: t("search.labels.timeUnit")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$e7e6b99c949fd18a), {
                        required: true,
                        variant: "outlined",
                        value: searchObj.timeUnit,
                        labelId: "search-timeUnit",
                        name: "timeUnit",
                        label: t("search.labels.timeUnit"),
                        onChange: ({ target: { name: name, value: value } })=>handleInputChange(name, value, additionalSearchObj !== null && additionalSearchObj !== void 0 ? additionalSearchObj : {}),
                        children: (0, $3XFgI.timeUnits) === null || (0, $3XFgI.timeUnits) === void 0 ? void 0 : (0, $3XFgI.timeUnits).map((timeUnit)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                value: timeUnit.value,
                                children: timeUnit.label
                            }, `timeUnit-${timeUnit.value}`))
                    }),
                    (error === null || error === void 0 ? void 0 : error.field) === "timeUnit" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFr0F.default), {
                        children: error.message
                    })
                ]
            })
        ]
    });
};



var $gC25j = parcelRequire("gC25j");
const $af0136fc233ca553$export$6d30910ea0d7d65e = ({ isSearchEnabled: isSearchEnabled, clubId: clubId, areas: areas, clubPhoto: clubPhoto })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const checkQueryStringRef = (0, $7fPBF.useRef)(false);
    const [error] = (0, $7fPBF.useState)(undefined);
    const { isLoadingFilters: isLoadingFilters } = (0, $goR7t.default)();
    const { actions: { checkQueryString: checkQueryString } } = (0, $a13Ew.useSearch)();
    (0, $7fPBF.useEffect)(()=>{
        if (isLoadingFilters || checkQueryStringRef.current) return;
        checkQueryStringRef.current = true;
        checkQueryString({
            clubId: clubId
        });
    }, [
        isLoadingFilters
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c8e684b0305bca57$export$84af16ba1207cbe2), {
        children: [
            isSearchEnabled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c8e684b0305bca57$export$3e7ac2a27534b0a2), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0a543cffa96588$export$56e6458301f6214c), {
                    error: error,
                    additionalSearchObj: {
                        clubId: clubId
                    }
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c8e684b0305bca57$export$be037cb0eb4aad7a), {
                children: !areas.length ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                    severity: "info",
                    children: t("club.areas.noAreas")
                }) : areas.map((area)=>{
                    var _area_AreaPhoto;
                    /*#__PURE__*/ return (0, $bbzbN.jsx)((0, $68a8f04e27a2a3ca$export$4ff3678dc42e6cf7), {
                        isSearchEnabled: isSearchEnabled,
                        area: area,
                        images: ((_area_AreaPhoto = area.AreaPhoto) === null || _area_AreaPhoto === void 0 ? void 0 : _area_AreaPhoto.length) ? area.AreaPhoto : clubPhoto
                    }, area.id);
                })
            })
        ]
    });
};



var $1N52b = parcelRequire("1N52b");
const $d598a55fa9f9d889$export$75591de432b8adb2 = ()=>{
    var _club_photos, _club_address, _club_address1;
    const { club: club } = (0, $7dba217b57b29882$export$2e2bcd8739ae039)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const { role: role } = (0, $1N52b.useAuth)();
    const [tab, setTab] = (0, $7fPBF.useState)(0);
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const mappedClub = (0, $7fPBF.useMemo)(()=>(0, $1335e35c06139c82$export$d372a871356834cd)(club ? [
            club
        ] : []), [
        club
    ]);
    const handleChange = (event, tabIndex)=>{
        setTab(tabIndex);
    };
    (0, $7fPBF.useEffect)(()=>{
        const areaId = searchParams.get("area");
        if (!club || !areaId) return;
        if (areaId) {
            setTab(0);
            const element = document.getElementById(`area-${areaId}`);
            if (element) element.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        club,
        searchParams
    ]);
    if (!club) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                children: t("club.headers.description")
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $330563ce3a2653c2$export$393edc798c47379d), {
                children: club.description
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c45f613599c3205d$export$2e2bcd8739ae039), {
                value: tab,
                onChange: handleChange,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                        id: "club-areas-tab",
                        label: t("club.tabs.areas"),
                        "aria-controls": "club-areas-tabpanel"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                        id: "club-description-tab",
                        label: t("club.tabs.description"),
                        "aria-controls": "club-description-tabpanel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                role: "tabpanel",
                hidden: tab !== 0,
                id: "club-areas-tabpanel",
                "aria-labelledby": "club-areas-tab",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $af0136fc233ca553$export$6d30910ea0d7d65e), {
                    isSearchEnabled: role === "club-admin" ? club.mine : true,
                    clubId: club.id,
                    areas: club.areas,
                    clubPhoto: ((_club_photos = club.photos) === null || _club_photos === void 0 ? void 0 : _club_photos.length) ? club.photos : []
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                role: "tabpanel",
                hidden: tab !== 1,
                id: "club-description-tabpanel",
                "aria-labelledby": "club-description-tab",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$cbf3f354590ee1d7), {
                    children: [
                        (0, $65826a3097b94805$export$af1da6d923bf8e9d).map((section)=>(0, $ece6984427a17b8a$export$4c0287abd2ec956e)(section, club)),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $330563ce3a2653c2$export$8b251419efc915eb), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($466aa0f23e42c6dd$exports)))
                                        }),
                                        " ",
                                        t("club.headers.location")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $330563ce3a2653c2$export$7f272e528db53fa5), {
                                    children: `${club.address.address}, ${club.address.county}, ${club.address.district}`
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $330563ce3a2653c2$export$3ba510748aae365e), {
                                    isActive: tab == 1,
                                    center: {
                                        lat: (_club_address = club.address) === null || _club_address === void 0 ? void 0 : _club_address.lat,
                                        lng: (_club_address1 = club.address) === null || _club_address1 === void 0 ? void 0 : _club_address1.lng
                                    },
                                    mapInfos: mappedClub !== null && mappedClub !== void 0 ? mappedClub : [],
                                    withPrice: false,
                                    showPopUp: false
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $6hfZk = parcelRequire("6hfZk");

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $223ba2a309a8ffb0$var$_ = (t)=>t, $223ba2a309a8ffb0$var$t, $223ba2a309a8ffb0$var$t1, $223ba2a309a8ffb0$var$t2, $223ba2a309a8ffb0$var$t3, $223ba2a309a8ffb0$var$t4, $223ba2a309a8ffb0$var$t5, $223ba2a309a8ffb0$var$t6, $223ba2a309a8ffb0$var$t7, $223ba2a309a8ffb0$var$t8, $223ba2a309a8ffb0$var$t9;
const $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t || ($223ba2a309a8ffb0$var$t = $223ba2a309a8ffb0$var$_`
    margin: 0 auto;
    max-width: 1100px;
    padding-inline: 24px;

    @media (min-width: 600px) {
        padding-inline: 40px;
    }
`));
const $223ba2a309a8ffb0$var$headerFontStyles = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t1 || ($223ba2a309a8ffb0$var$t1 = $223ba2a309a8ffb0$var$_`
    margin-block: 0;
    font-weight: normal;
    font-family: 'Bowlby One', sans-serif;
`));
const $223ba2a309a8ffb0$var$bodyFontStyles = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t2 || ($223ba2a309a8ffb0$var$t2 = $223ba2a309a8ffb0$var$_`
    margin-block: 0;
    font-family: 'Golos Text', sans-serif;
`));
const $223ba2a309a8ffb0$export$a9ea127f4b5018b0 = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t3 || ($223ba2a309a8ffb0$var$t3 = $223ba2a309a8ffb0$var$_`
    font-size: 44px;

    @media (min-width: 600px) {
        font-size: 55px;
    }

    @media (min-width: 891px) {
        font-size: 60px;
    }

    ${0};
`), $223ba2a309a8ffb0$var$headerFontStyles);
const $223ba2a309a8ffb0$export$fb02c795f1eb23eb = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t4 || ($223ba2a309a8ffb0$var$t4 = $223ba2a309a8ffb0$var$_`
    font-size: 48px;
    ${0};
`), $223ba2a309a8ffb0$var$headerFontStyles);
const $223ba2a309a8ffb0$export$255b806436d2199 = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t5 || ($223ba2a309a8ffb0$var$t5 = $223ba2a309a8ffb0$var$_`
    font-size: 32px;
    ${0};
`), $223ba2a309a8ffb0$var$headerFontStyles);
const $223ba2a309a8ffb0$export$e5d6432f30b950b2 = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t6 || ($223ba2a309a8ffb0$var$t6 = $223ba2a309a8ffb0$var$_`
    font-size: 22px;
    ${0};
`), $223ba2a309a8ffb0$var$headerFontStyles);
const $223ba2a309a8ffb0$export$68e2d6fb3c07c0b4 = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t7 || ($223ba2a309a8ffb0$var$t7 = $223ba2a309a8ffb0$var$_`
    font-size: 20px;
    line-height: 1.5em;
    ${0};
`), $223ba2a309a8ffb0$var$bodyFontStyles);
const $223ba2a309a8ffb0$export$3b92b0afb61b3761 = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t8 || ($223ba2a309a8ffb0$var$t8 = $223ba2a309a8ffb0$var$_`
    font-size: 16px;
    ${0};
`), $223ba2a309a8ffb0$var$bodyFontStyles);
const $223ba2a309a8ffb0$export$dfb2a4e17199f269 = (0, $6hfZk.css)($223ba2a309a8ffb0$var$t9 || ($223ba2a309a8ffb0$var$t9 = $223ba2a309a8ffb0$var$_`
    font-size: 13px;
    ${0};
`), $223ba2a309a8ffb0$var$bodyFontStyles);



var $9uOZr = parcelRequire("9uOZr");
let $f39b3abf0ccb3e1f$var$_ = (t)=>t, $f39b3abf0ccb3e1f$var$t, $f39b3abf0ccb3e1f$var$t1, $f39b3abf0ccb3e1f$var$t2, $f39b3abf0ccb3e1f$var$t3, $f39b3abf0ccb3e1f$var$t4, $f39b3abf0ccb3e1f$var$t5, $f39b3abf0ccb3e1f$var$t6;
const $f39b3abf0ccb3e1f$export$1dd6b49c38c99076 = (0, $6hfZk.default)((0, $9uOZr.Layout))($f39b3abf0ccb3e1f$var$t || ($f39b3abf0ccb3e1f$var$t = $f39b3abf0ccb3e1f$var$_`
    padding-left: 0 !important;
    padding-right: 0 !important;
`));
const $f39b3abf0ccb3e1f$export$cd640987c37b8c23 = (0, $6hfZk.default)((0, $aili3.default))($f39b3abf0ccb3e1f$var$t1 || ($f39b3abf0ccb3e1f$var$t1 = $f39b3abf0ccb3e1f$var$_`
    color: white;
    padding-block: 80px;
    background-color: #1976d2;

    > div {
        gap: 40px;
        display: flex;
        flex-direction: column;
        ${0};
    }
`), (0, $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f));
const $f39b3abf0ccb3e1f$export$bafbed5541cae1c7 = (0, $6hfZk.default).h3($f39b3abf0ccb3e1f$var$t2 || ($f39b3abf0ccb3e1f$var$t2 = $f39b3abf0ccb3e1f$var$_`
    ${0};
`), (0, $223ba2a309a8ffb0$export$255b806436d2199));
const $f39b3abf0ccb3e1f$export$e720ec32d577006a = (0, $6hfZk.default)((0, $aili3.default))($f39b3abf0ccb3e1f$var$t3 || ($f39b3abf0ccb3e1f$var$t3 = $f39b3abf0ccb3e1f$var$_`
    gap: 15px;
    display: flex;

    ${0};

    button {
        border: unset;
        cursor: pointer;
        padding: 10px 15px;

        ${0};

        color: white;
        background-color: #21295c;
    }
`), (0, $223ba2a309a8ffb0$export$3b92b0afb61b3761), (0, $223ba2a309a8ffb0$export$3b92b0afb61b3761));
const $f39b3abf0ccb3e1f$export$a06f1c675e846f6f = (0, $6hfZk.default).footer($f39b3abf0ccb3e1f$var$t4 || ($f39b3abf0ccb3e1f$var$t4 = $f39b3abf0ccb3e1f$var$_`
    padding-block: 60px;
    background-color: #1976d2;
`));
const $f39b3abf0ccb3e1f$export$7fff059ad723fa92 = (0, $6hfZk.default)((0, $aili3.default))($f39b3abf0ccb3e1f$var$t5 || ($f39b3abf0ccb3e1f$var$t5 = $f39b3abf0ccb3e1f$var$_`
    display: flex;
    ${0};
`), (0, $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f));
const $f39b3abf0ccb3e1f$export$8d8e9363690df25b = (0, $6hfZk.default)((0, $aili3.default))($f39b3abf0ccb3e1f$var$t6 || ($f39b3abf0ccb3e1f$var$t6 = $f39b3abf0ccb3e1f$var$_`
    flex: 1;
    gap: 20px;
    width: 100%;
    color: white;
    display: flex;
    flex-direction: column;

    ${0};

    a {
        color: white;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
`), (0, $223ba2a309a8ffb0$export$3b92b0afb61b3761));


const $307fe44614891063$export$4fa4ceee2bc5b93 = ()=>{
    const { actions: { fetch: fetch } } = (0, $78bc65f04043bddb$export$ca8754786c7d383a)();
    const { clubId: clubId } = (0, $iIluI.useParams)();
    const { isLoading: isLoading, club: club } = (0, $7dba217b57b29882$export$2e2bcd8739ae039)();
    (0, $7fPBF.useEffect)(()=>{
        if (!!clubId) fetch(clubId);
    }, []);
    if (isLoading || !!!club) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$1dd6b49c38c99076), {
        headerType: "menu",
        maxWidth: false,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c5f59a514954c054$export$df63f2d6395ac139), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d598a55fa9f9d889$export$75591de432b8adb2), {})
        ]
    });
};




var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $7fPBF = parcelRequire("7fPBF");

var $dNDci = parcelRequire("dNDci");
const $b9165c9d2a4ceafb$export$10927d0a6d433056 = ()=>{
    const appService = new (0, $dNDci.AppService)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [area, setArea] = (0, $7fPBF.useState)(undefined);
    const fetchArea = (id)=>{
        setIsLoading(true);
        appService.api_getAreaById(id).then((res)=>{
            if (res.status !== 200) throw new Error();
            if (res.data) setArea(res.data);
        }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
    };
    return {
        isLoading: isLoading,
        area: area,
        actions: {
            fetchArea: fetchArea
        }
    };
};



var $jQ4lF = parcelRequire("jQ4lF");
//React imports

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $1ZNeQ = parcelRequire("1ZNeQ");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $8m7Fi = parcelRequire("8m7Fi");

var $gC25j = parcelRequire("gC25j");
var $gXHSV = parcelRequire("gXHSV");
var $6F4ic = parcelRequire("6F4ic");
var $3jMGu = parcelRequire("3jMGu");
var $2MkI1 = parcelRequire("2MkI1");
var $hC78m = parcelRequire("hC78m");
var $j4xM6 = parcelRequire("j4xM6");
var $joOxH = parcelRequire("joOxH");

var $dkKmP = parcelRequire("dkKmP");

var $7xRAC = parcelRequire("7xRAC");

const $7dd092cc948d3a7c$export$102bbec517896a4d = (t, isVisible)=>{
    const baseSchema = {
        payment: $7xRAC.string().nullable(),
        reservationType: $7xRAC.string().default((0, $ea56c01c193ff21f$export$67e02fa760e0413a).PRIVATE),
        terms: $7xRAC.boolean().test({
            name: "required-terms",
            test: function(value) {
                if (!value) return this.createError({
                    path: "terms",
                    message: t("validation.requiredTermsAndConditions")
                });
                return true;
            }
        })
    };
    // Add payment validation conditionally
    if (isVisible) baseSchema.payment = $7xRAC.string().nullable().required(t("validation.requiredPaymentMethod"));
    else baseSchema.payment = $7xRAC.string().nullable();
    return $7xRAC.object().shape(baseSchema);
};



var $6hfZk = parcelRequire("6hfZk");

var $afCHG = parcelRequire("afCHG");

var $aili3 = parcelRequire("aili3");
var $cnEvg = parcelRequire("cnEvg");
let $b1ff74ee15cbdc1e$var$_ = (t)=>t, $b1ff74ee15cbdc1e$var$t, $b1ff74ee15cbdc1e$var$t1, $b1ff74ee15cbdc1e$var$t2, $b1ff74ee15cbdc1e$var$t3, $b1ff74ee15cbdc1e$var$t4;
const $b1ff74ee15cbdc1e$export$a195049fd73b3fe2 = (0, $6hfZk.default)((0, $afCHG.Input))($b1ff74ee15cbdc1e$var$t || ($b1ff74ee15cbdc1e$var$t = $b1ff74ee15cbdc1e$var$_`
    margin-bottom: 2rem !important;
`));
const $b1ff74ee15cbdc1e$export$d4857d41ad5ff79f = (0, $6hfZk.default)((0, $cnEvg.default))($b1ff74ee15cbdc1e$var$t1 || ($b1ff74ee15cbdc1e$var$t1 = $b1ff74ee15cbdc1e$var$_`
    color: #d32f2f !important;
    font-size: small !important;
    margin-left: 32px;
`));
const $b1ff74ee15cbdc1e$export$86c2c71c265465c4 = (0, $6hfZk.default).span($b1ff74ee15cbdc1e$var$t2 || ($b1ff74ee15cbdc1e$var$t2 = $b1ff74ee15cbdc1e$var$_`
    color: #d32f2f;
`));
const $b1ff74ee15cbdc1e$export$a7fed597f4b8afd8 = (0, $6hfZk.default).form($b1ff74ee15cbdc1e$var$t3 || ($b1ff74ee15cbdc1e$var$t3 = $b1ff74ee15cbdc1e$var$_`
    display: flex;
    flex-direction: column;
    gap: 24px;
`));
const $b1ff74ee15cbdc1e$export$d3d1f040e32e00d3 = (0, $6hfZk.default)((0, $aili3.default))($b1ff74ee15cbdc1e$var$t4 || ($b1ff74ee15cbdc1e$var$t4 = $b1ff74ee15cbdc1e$var$_`
    display: grid;
    grid-template-columns: 50% auto;
    gap: 8px;
`));



var $jQ4lF = parcelRequire("jQ4lF");

var $682k2 = parcelRequire("682k2");

var $cRz8b = parcelRequire("cRz8b");

var $3mPwx = parcelRequire("3mPwx");


var $7fPBF = parcelRequire("7fPBF");

var $dNDci = parcelRequire("dNDci");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $fnVR5 = parcelRequire("fnVR5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
const $f6654670d4663eb2$export$f5f0031c7bcd7450 = ()=>{
    const api_service = new (0, $dNDci.AppService)();
    const navigate = (0, $iIluI.useNavigate)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const createBooking = (role, booking, return_url)=>{
        setIsLoading(true);
        api_service.api_createBooking(role, booking).then((res)=>{
            if ([
                401,
                403
            ].includes(res.status)) {
                navigate(`/login?return_url=${encodeURIComponent(return_url)}`);
                return;
            }
            if (res.status !== 201) throw new Error();
            navigate(`/booking-details/${res.data.id}`);
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "success",
                children: t("booking.label.bookingSuccess")
            });
        }).catch((error)=>console.log(error)).finally(()=>setIsLoading(false));
    };
    return {
        isLoading: isLoading,
        actions: {
            createBooking: createBooking
        }
    };
};



var $1N52b = parcelRequire("1N52b");

var $0569b5db04aa6a7a$exports = {};

$0569b5db04aa6a7a$exports = new URL((parcelRequire("4SSe9")).resolve("9WQdJ"), import.meta.url).toString();


var $8d65695c1a546d79$exports = {};

$8d65695c1a546d79$exports = new URL((parcelRequire("4SSe9")).resolve("dmyGp"), import.meta.url).toString();


var $e6205bc9b72a6e8d$exports = {};

$e6205bc9b72a6e8d$exports = new URL((parcelRequire("4SSe9")).resolve("f5XOE"), import.meta.url).toString();



var $2rOQj = parcelRequire("2rOQj");

const $eb4350c353601cfa$export$876e12fd1628a497 = ({ areaId: areaId, price: price, privacy: privacy, category: category, date: date, time: time, timeUnit: timeUnit, clubId: clubId })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { isAuthenticated: isAuthenticated, role: role } = (0, $1N52b.useAuth)();
    const navigate = (0, $iIluI.useNavigate)();
    const location = (0, $iIluI.useLocation)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const isReady = (0, $7fPBF.useRef)(false);
    const { user: user } = (0, $3mPwx.useUserContext)();
    const { club: club } = (0, $7dba217b57b29882$export$2e2bcd8739ae039)();
    const isPaymentVisible = privacy !== "PUBLIC";
    const { actions: { fetch: fetch } } = (0, $78bc65f04043bddb$export$ca8754786c7d383a)();
    const { actions: { fetchDomainFeatureToggles: fetchDomainFeatureToggles, hasDomainFeatureToggle: hasDomainFeatureToggle } } = (0, $2rOQj.useFeatureToggles)();
    (0, $7fPBF.useEffect)(()=>{
        if (isReady.current) return;
        isReady.current = true;
        if (!!clubId) {
            fetch(clubId);
            fetchDomainFeatureToggles();
        }
    }, []);
    const { isLoading: isLoading, actions: { createBooking: createBooking } } = (0, $f6654670d4663eb2$export$f5f0031c7bcd7450)();
    const initialValues = {
        payment: searchParams.get("payment"),
        terms: searchParams.get("terms") ? true : false,
        name: ""
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
        initialValues: initialValues,
        validationSchema: (0, $7dd092cc948d3a7c$export$102bbec517896a4d)(t, isPaymentVisible),
        onSubmit: async (values)=>{
            const from = (0, $682k2.formatDate)((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(time)).utc());
            const [hoursToAdd, minutesToAdd] = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(timeUnit)).utc().format("HH:mm").split(":");
            const to = (0, $682k2.formatDate)((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(time)).utc().add(Number(hoursToAdd), "hour").add(Number(minutesToAdd), "minute"));
            const day = (0, $682k2.formatDate)((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(searchParams.get("date"))));
            const booking = {
                ...values,
                name: user === null || user === void 0 ? void 0 : user.name,
                email: user === null || user === void 0 ? void 0 : user.email,
                category: category.toUpperCase(),
                day: day,
                from: from,
                to: to,
                price: Number(price),
                timeUnit: (0, $cRz8b.getTimeUnit)((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(timeUnit)).utc().format("HH:mm")),
                areaId: areaId,
                reservationType: (0, $ea56c01c193ff21f$export$67e02fa760e0413a).PRIVATE,
                paymentMethodId: values.payment === "null" ? null : values.payment
            };
            const return_url = `${location.pathname}${location.search}&terms=${values.terms}&payment=${values.payment}`;
            if (isAuthenticated) createBooking(role, booking, return_url);
            else navigate(`/checkout/booking?return_url=${encodeURIComponent(return_url)}`, {
                state: {
                    ...booking
                }
            });
        },
        children: (props)=>{
            /*#__PURE__*/ return (0, $bbzbN.jsxs)((0, $b1ff74ee15cbdc1e$export$a7fed597f4b8afd8), {
                onSubmit: props.handleSubmit,
                children: [
                    privacy !== "PUBLIC" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCard), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardContent), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardLabel), {
                                    children: [
                                        t("booking.label.paymentMethods"),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b1ff74ee15cbdc1e$export$86c2c71c265465c4), {
                                            children: "*"
                                        })
                                    ]
                                }),
                                (club === null || club === void 0 ? void 0 : club.paymentMethods) && club.paymentMethods.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $joOxH.default), {
                                            "aria-labelledby": "payment-group-label",
                                            name: "payment-group",
                                            children: club.paymentMethods.map((pm)=>{
                                                var _props_values_payment;
                                                return hasDomainFeatureToggle(pm.name) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2MkI1.default), {
                                                    name: "payment",
                                                    value: pm.id,
                                                    control: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j4xM6.default), {
                                                        name: "payment",
                                                        checked: (_props_values_payment = props.values.payment) === null || _props_values_payment === void 0 ? void 0 : _props_values_payment.includes(pm.id),
                                                        onChange: props.handleChange
                                                    }),
                                                    label: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.PaymentMethodLabel), {
                                                        children: [
                                                            t(`club.paymentMethods.${pm.name.toLowerCase()}`),
                                                            pm.name === "MBWAY" && /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($0569b5db04aa6a7a$exports))),
                                                                alt: "MBWay logo"
                                                            }),
                                                            pm.name === "CREDIT_CARD" && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.CreditCardBox), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8d65695c1a546d79$exports))),
                                                                        alt: "Visa logo"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e6205bc9b72a6e8d$exports))),
                                                                        alt: "Mastercard logo"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, pm.name);
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                            name: "payment",
                                            children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                                                    severity: "error",
                                                    children: msg
                                                })
                                        }),
                                        props.values.payment === "BANK_TRANSFER" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                                            variant: "filled",
                                            severity: "info",
                                            children: t("booking.label.importantNote")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gC25j.default), {
                                    severity: "info",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gXHSV.default), {
                                            children: t("booking.noPaymentMethodsTitle")
                                        }),
                                        t("booking.noPaymentMethodsInfo")
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledCard), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardContent), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledCardLabel), {
                                    children: [
                                        t("termsAndConditions"),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b1ff74ee15cbdc1e$export$86c2c71c265465c4), {
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hC78m.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.StyledFormControlLabel), {
                                            control: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6F4ic.default), {
                                                name: "terms",
                                                checked: props.values.terms,
                                                onChange: props.handleChange
                                            }),
                                            label: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.TermsAndConditionsLabel), {
                                                children: [
                                                    t("booking.label.acceptance"),
                                                    " ",
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.Link), {
                                                        to: "/terms-and-conditions",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jQ4lF.TermsAndConditionsLink), {
                                                            children: t("booking.label.termsAndConditions")
                                                        })
                                                    }),
                                                    " ",
                                                    t("booking.label.sportsFacility")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                            name: "terms",
                                            children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                                                    severity: "error",
                                                    children: msg
                                                })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                        variant: "contained",
                        type: "submit",
                        disabled: isLoading || privacy !== "PUBLIC" && props.values.payment === null || props.values.terms === false,
                        children: privacy !== "PUBLIC" ? t("booking.button.next") : t("booking.button.book")
                    })
                ]
            });
        }
    });
};




var $8m7Fi = parcelRequire("8m7Fi");

var $9uOZr = parcelRequire("9uOZr");
const $6acadd74b09771bb$export$4f9b4f8cb84c809f = ()=>{
    var _area_club_address, _area_club_address1, _area_club_address2, _area_club_address3, _area_club_address4;
    const navigate = (0, $iIluI.useNavigate)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const areaId = searchParams.get("area");
    const category = searchParams.get("sport");
    const categoryId = searchParams.get("sportId");
    const date = searchParams.get("date");
    const time = searchParams.get("time");
    const timeUnit = searchParams.get("timeUnit");
    const price = searchParams.get("price");
    const { isLoading: isLoading, area: area, actions: { fetchArea: fetchArea } } = (0, $b9165c9d2a4ceafb$export$10927d0a6d433056)();
    (0, $7fPBF.useEffect)(()=>{
        const hasMissingField = [
            areaId,
            category,
            categoryId,
            date,
            time,
            timeUnit
        ].some((val)=>!!!val);
        if (hasMissingField) {
            navigate("/search");
            return;
        }
        fetchArea(areaId);
    }, []);
    if (isLoading || !area) return null;
    const formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(date)).format("ddd, MMM D, YYYY");
    const from = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(time)).utc().format("HH:mm");
    const [hoursToAdd, minutesToAdd] = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(timeUnit)).utc().format("HH:mm").split(":");
    const to = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(time)).utc().add(Number(hoursToAdd), "hour").add(Number(minutesToAdd), "minute").format("HH:mm");
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledBox), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45ae9643aaece5b5$export$4162f0f332955ca9), {
                    club: {
                        name: area.club.name,
                        mobilePhone: area.club.mobilePhone,
                        email: area.club.email,
                        carParkType: area.club.carParkType,
                        lockerRoomType: area.club.lockerRoomType,
                        address: {
                            address: (_area_club_address = area.club.address) === null || _area_club_address === void 0 ? void 0 : _area_club_address.address,
                            postalCode: (_area_club_address1 = area.club.address) === null || _area_club_address1 === void 0 ? void 0 : _area_club_address1.postalCode,
                            district: (_area_club_address2 = area.club.address) === null || _area_club_address2 === void 0 ? void 0 : _area_club_address2.district,
                            lat: (_area_club_address3 = area.club.address) === null || _area_club_address3 === void 0 ? void 0 : _area_club_address3.lat,
                            lng: (_area_club_address4 = area.club.address) === null || _area_club_address4 === void 0 ? void 0 : _area_club_address4.lng
                        },
                        photos: area.club.photos.map((photo)=>({
                                photoUrl: photo.photoUrl
                            }))
                    },
                    area: {
                        name: area.name,
                        description: area.description,
                        price: price !== null && price !== void 0 ? price : "0",
                        privacy: area.privacy,
                        environment: area.environment,
                        photos: area.photos.map((photo)=>({
                                photoUrl: photo.photoUrl
                            }))
                    },
                    category: category,
                    date: formattedDate,
                    from: from,
                    to: to
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eb4350c353601cfa$export$876e12fd1628a497), {
                    areaId: areaId,
                    category: category,
                    date: date,
                    time: time,
                    timeUnit: timeUnit,
                    privacy: area.privacy,
                    price: price,
                    clubId: area.clubId
                })
            ]
        })
    });
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $6CVVo = parcelRequire("6CVVo");

var $gC25j = parcelRequire("gC25j");
var $hG0Cb = parcelRequire("hG0Cb");


var $jQ4lF = parcelRequire("jQ4lF");

var $8m7Fi = parcelRequire("8m7Fi");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");



var $9uOZr = parcelRequire("9uOZr");

var $aili3 = parcelRequire("aili3");
var $gsokU = parcelRequire("gsokU");

var $6hfZk = parcelRequire("6hfZk");

var $dkKmP = parcelRequire("dkKmP");
let $cf0c028fb30d59f8$var$_ = (t)=>t, $cf0c028fb30d59f8$var$t, $cf0c028fb30d59f8$var$t1, $cf0c028fb30d59f8$var$t2, $cf0c028fb30d59f8$var$t3, $cf0c028fb30d59f8$var$t4, $cf0c028fb30d59f8$var$t5, $cf0c028fb30d59f8$var$t6, $cf0c028fb30d59f8$var$t7, $cf0c028fb30d59f8$var$t8, $cf0c028fb30d59f8$var$t9;
const $cf0c028fb30d59f8$export$f99233281efd08a0 = (0, $6hfZk.default).h1($cf0c028fb30d59f8$var$t || ($cf0c028fb30d59f8$var$t = $cf0c028fb30d59f8$var$_`
    font-size: 16px;
    text-align: center;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: var(--custom-secondary);
    text-transform: uppercase;
`));
const $cf0c028fb30d59f8$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($cf0c028fb30d59f8$var$t1 || ($cf0c028fb30d59f8$var$t1 = $cf0c028fb30d59f8$var$_`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 1rem;
    margin-bottom: 20px;

     @media (max-width: 600px) {
        padding: 0;
    },
`));
const $cf0c028fb30d59f8$export$b1bd3336d32d1d33 = (0, $6hfZk.default).p($cf0c028fb30d59f8$var$t2 || ($cf0c028fb30d59f8$var$t2 = $cf0c028fb30d59f8$var$_`
    font-size: 14px;
    margin: 0;
`));
const $cf0c028fb30d59f8$export$cef3e53872019e23 = (0, $6hfZk.default).p($cf0c028fb30d59f8$var$t3 || ($cf0c028fb30d59f8$var$t3 = $cf0c028fb30d59f8$var$_`
    font-size: 14px;
    margin: 0;
    color: #e65100;
`));
const $cf0c028fb30d59f8$export$94fdbc1f5368d5e4 = (0, $6hfZk.default)((0, $gsokU.default))($cf0c028fb30d59f8$var$t4 || ($cf0c028fb30d59f8$var$t4 = $cf0c028fb30d59f8$var$_`
    box-shadow: none !important;
    border-radius: 0 !important;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`));
const $cf0c028fb30d59f8$export$d69e8e89ba492243 = (0, $6hfZk.default).h2($cf0c028fb30d59f8$var$t5 || ($cf0c028fb30d59f8$var$t5 = $cf0c028fb30d59f8$var$_`
    color: var(--black-087);
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
`));
const $cf0c028fb30d59f8$export$1b777da6462b204f = (0, $6hfZk.default).h3($cf0c028fb30d59f8$var$t6 || ($cf0c028fb30d59f8$var$t6 = $cf0c028fb30d59f8$var$_`
    color: var(--black-087);
    font-size: 16px;
    font-style: medium;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.5px;
    margin: 0;
`));
const $cf0c028fb30d59f8$export$4c37618c69ec9a48 = (0, $6hfZk.default).p($cf0c028fb30d59f8$var$t7 || ($cf0c028fb30d59f8$var$t7 = $cf0c028fb30d59f8$var$_`
    color: var(--black-058);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0;
`));
const $cf0c028fb30d59f8$export$37ab3bdebc286ca = (0, $6hfZk.default).div($cf0c028fb30d59f8$var$t8 || ($cf0c028fb30d59f8$var$t8 = $cf0c028fb30d59f8$var$_`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    margin-top: 32px;
`));
const $cf0c028fb30d59f8$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($cf0c028fb30d59f8$var$t9 || ($cf0c028fb30d59f8$var$t9 = $cf0c028fb30d59f8$var$_`
    width: 100%;
`));



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $e0fb7d1a17cf6117$var$__defProp = Object.defineProperty;
var $e0fb7d1a17cf6117$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e0fb7d1a17cf6117$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e0fb7d1a17cf6117$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e0fb7d1a17cf6117$var$__defNormalProp = (obj, key, value)=>key in obj ? $e0fb7d1a17cf6117$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e0fb7d1a17cf6117$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e0fb7d1a17cf6117$var$__hasOwnProp.call(b, prop)) $e0fb7d1a17cf6117$var$__defNormalProp(a, prop, b[prop]);
    if ($e0fb7d1a17cf6117$var$__getOwnPropSymbols) {
        for (var prop of $e0fb7d1a17cf6117$var$__getOwnPropSymbols(b))if ($e0fb7d1a17cf6117$var$__propIsEnum.call(b, prop)) $e0fb7d1a17cf6117$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e0fb7d1a17cf6117$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e0fb7d1a17cf6117$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e0fb7d1a17cf6117$var$__getOwnPropSymbols) {
        for (var prop of $e0fb7d1a17cf6117$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e0fb7d1a17cf6117$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $e0fb7d1a17cf6117$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class {
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        getModules() {
            return this.modules;
        }
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.modules = [];
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
    };
    let QrCode = _QrCode;
    QrCode.MIN_VERSION = 1;
    QrCode.MAX_VERSION = 40;
    QrCode.PENALTY_N1 = 3;
    QrCode.PENALTY_N2 = 3;
    QrCode.PENALTY_N3 = 40;
    QrCode.PENALTY_N4 = 10;
    QrCode.ECC_CODEWORDS_PER_BLOCK = [
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    qrcodegen2.QrCode = QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class {
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        getData() {
            return this.bitData.slice();
        }
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substr(i + 1, 2), 16));
                i += 2;
            }
            return result;
        }
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
    };
    let QrSegment = _QrSegment;
    QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    qrcodegen2.QrSegment = QrSegment;
})($e0fb7d1a17cf6117$var$qrcodegen || ($e0fb7d1a17cf6117$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class {
            constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        let Ecc = _Ecc;
        Ecc.LOW = new _Ecc(0, 1);
        Ecc.MEDIUM = new _Ecc(1, 0);
        Ecc.QUARTILE = new _Ecc(2, 3);
        Ecc.HIGH = new _Ecc(3, 2);
        QrCode2.Ecc = Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($e0fb7d1a17cf6117$var$qrcodegen || ($e0fb7d1a17cf6117$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class {
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
            constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
        };
        let Mode = _Mode;
        Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        QrSegment2.Mode = Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($e0fb7d1a17cf6117$var$qrcodegen || ($e0fb7d1a17cf6117$var$qrcodegen = {}));
var $e0fb7d1a17cf6117$var$qrcodegen_default = $e0fb7d1a17cf6117$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $e0fb7d1a17cf6117$var$ERROR_LEVEL_MAP = {
    L: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $e0fb7d1a17cf6117$var$DEFAULT_SIZE = 128;
var $e0fb7d1a17cf6117$var$DEFAULT_LEVEL = "L";
var $e0fb7d1a17cf6117$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $e0fb7d1a17cf6117$var$DEFAULT_FGCOLOR = "#000000";
var $e0fb7d1a17cf6117$var$DEFAULT_INCLUDEMARGIN = false;
var $e0fb7d1a17cf6117$var$MARGIN_SIZE = 4;
var $e0fb7d1a17cf6117$var$DEFAULT_IMG_SCALE = 0.1;
function $e0fb7d1a17cf6117$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $e0fb7d1a17cf6117$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $e0fb7d1a17cf6117$var$getImageSettings(cells, size, includeMargin, imageSettings) {
    if (imageSettings == null) return null;
    const margin = includeMargin ? $e0fb7d1a17cf6117$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $e0fb7d1a17cf6117$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation
    };
}
var $e0fb7d1a17cf6117$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
function $e0fb7d1a17cf6117$export$7e3713cf0c0fe9d0(props) {
    const _a = props, { value: value, size: size = $e0fb7d1a17cf6117$var$DEFAULT_SIZE, level: level = $e0fb7d1a17cf6117$var$DEFAULT_LEVEL, bgColor: bgColor = $e0fb7d1a17cf6117$var$DEFAULT_BGCOLOR, fgColor: fgColor = $e0fb7d1a17cf6117$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $e0fb7d1a17cf6117$var$DEFAULT_INCLUDEMARGIN, style: style, imageSettings: imageSettings } = _a, otherProps = $e0fb7d1a17cf6117$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "style",
        "imageSettings"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, $7fPBF.useRef)(null);
    const _image = (0, $7fPBF.useRef)(null);
    const [isImgLoaded, setIsImageLoaded] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cells = $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.encodeText(value, $e0fb7d1a17cf6117$var$ERROR_LEVEL_MAP[level]).getModules();
            const margin = includeMargin ? $e0fb7d1a17cf6117$var$MARGIN_SIZE : 0;
            const numCells = cells.length + margin * 2;
            const calculatedImageSettings = $e0fb7d1a17cf6117$var$getImageSettings(cells, size, includeMargin, imageSettings);
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cells = $e0fb7d1a17cf6117$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($e0fb7d1a17cf6117$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($e0fb7d1a17cf6117$var$generatePath(cells, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $e0fb7d1a17cf6117$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("canvas", $e0fb7d1a17cf6117$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: _canvas
    }, otherProps)), img);
}
function $e0fb7d1a17cf6117$export$10307208e61210e9(props) {
    const _a = props, { value: value, size: size = $e0fb7d1a17cf6117$var$DEFAULT_SIZE, level: level = $e0fb7d1a17cf6117$var$DEFAULT_LEVEL, bgColor: bgColor = $e0fb7d1a17cf6117$var$DEFAULT_BGCOLOR, fgColor: fgColor = $e0fb7d1a17cf6117$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $e0fb7d1a17cf6117$var$DEFAULT_INCLUDEMARGIN, imageSettings: imageSettings } = _a, otherProps = $e0fb7d1a17cf6117$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "imageSettings"
    ]);
    let cells = $e0fb7d1a17cf6117$var$qrcodegen_default.QrCode.encodeText(value, $e0fb7d1a17cf6117$var$ERROR_LEVEL_MAP[level]).getModules();
    const margin = includeMargin ? $e0fb7d1a17cf6117$var$MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const calculatedImageSettings = $e0fb7d1a17cf6117$var$getImageSettings(cells, size, includeMargin, imageSettings);
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cells = $e0fb7d1a17cf6117$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("image", {
            xlinkHref: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none"
        });
    }
    const fgPath = $e0fb7d1a17cf6117$var$generatePath(cells, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $e0fb7d1a17cf6117$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`
    }, otherProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
}
var $e0fb7d1a17cf6117$export$2e2bcd8739ae039 = (props)=>{
    const _a = props, { renderAs: renderAs } = _a, otherProps = $e0fb7d1a17cf6117$var$__objRest(_a, [
        "renderAs"
    ]);
    if (renderAs === "svg") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e0fb7d1a17cf6117$export$10307208e61210e9, $e0fb7d1a17cf6117$var$__spreadValues({}, otherProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($e0fb7d1a17cf6117$export$7e3713cf0c0fe9d0, $e0fb7d1a17cf6117$var$__spreadValues({}, otherProps));
};


const $f567012663b97d59$export$a77d98f00e648d58 = ({ value: value, options: options = {} })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e0fb7d1a17cf6117$export$10307208e61210e9), {
        value: value,
        ...options
    });
};


const $1bc7d261d80607fe$export$167407e059d5158d = ()=>{
    var _booking_paymentMethod, _booking_paymentMethod1, _booking_club_address, _booking_club_address1, _booking_club_address2, _booking_club_address3, _booking_club_address4, _booking_paymentMethod2;
    const { id: id } = (0, $iIluI.useParams)();
    const { t: t, i18n: i18n } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { isLoading: isLoading, booking: booking, actions: { fetch_booking: fetch_booking, setAsDeleted: setAsDeleted } } = (0, $6CVVo.useReservation)();
    const [cancelModalOpen, setCancelModalOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (!id) {
            navigate("/");
            return;
        }
        fetch_booking(id);
    }, []);
    if (isLoading || !booking) return null;
    const formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.day).locale(i18n.language).utc().format("ddd, MMM D, YYYY");
    const from = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.from).utc().format("HH:mm");
    const to = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking.to).utc().format("HH:mm");
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$d675f139b342d51a), {
            sx: {
                marginBottom: "2rem"
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$f99233281efd08a0), {
                    children: booking.area.privacy === "PUBLIC" || booking.isPayed || ((_booking_paymentMethod = booking.paymentMethod) === null || _booking_paymentMethod === void 0 ? void 0 : _booking_paymentMethod.name) !== "BANK_TRANSFER" ? t("booking.details", {
                        bookingId: booking.shareId
                    }) : t("booking.payment")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    children: [
                        booking.isPayed && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                            severity: "success",
                            children: t("booking.label.paymentConfirmed")
                        }),
                        ((_booking_paymentMethod1 = booking.paymentMethod) === null || _booking_paymentMethod1 === void 0 ? void 0 : _booking_paymentMethod1.name) === "BANK_TRANSFER" && !booking.isPayed && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $jQ4lF.StyledAlert), {
                            severity: "warning",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$b1bd3336d32d1d33), {
                                    children: [
                                        t("booking.label.transferObservation"),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("strong", {
                                            children: [
                                                "#",
                                                booking.shareId
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$b1bd3336d32d1d33), {
                                    children: [
                                        t("iban"),
                                        " ",
                                        booking.club.iban ? booking.club.iban : t("missingInfo"),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                                        t("bic"),
                                        " ",
                                        booking.club.swift ? booking.club.swift : t("missingInfo"),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                                        t("email"),
                                        " ",
                                        booking.club.email ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $dNYY5.Link), {
                                            to: `mailto:${booking.club.email}?subject=Comprovativo de pagamento da reserva #${booking.shareId}`,
                                            children: [
                                                booking.club.email,
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0e979bbad9fc1510$exports))), {
                                                    fontSize: "small",
                                                    className: "p-2"
                                                })
                                            ]
                                        }) : t("missingInfo")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$cef3e53872019e23), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                        children: t("booking.label.paymentNote")
                                    })
                                }),
                                " ",
                                /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$cef3e53872019e23), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                        children: t("booking.label.reservationNote")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45ae9643aaece5b5$export$4162f0f332955ca9), {
                    club: {
                        name: booking.club.name,
                        mobilePhone: booking.club.mobilePhone,
                        email: booking.club.email,
                        carParkType: booking.club.carParkType,
                        lockerRoomType: booking.club.lockerRoomType,
                        address: {
                            address: (_booking_club_address = booking.club.address) === null || _booking_club_address === void 0 ? void 0 : _booking_club_address.address,
                            postalCode: (_booking_club_address1 = booking.club.address) === null || _booking_club_address1 === void 0 ? void 0 : _booking_club_address1.postalCode,
                            district: (_booking_club_address2 = booking.club.address) === null || _booking_club_address2 === void 0 ? void 0 : _booking_club_address2.district,
                            lat: (_booking_club_address3 = booking.club.address) === null || _booking_club_address3 === void 0 ? void 0 : _booking_club_address3.lat,
                            lng: (_booking_club_address4 = booking.club.address) === null || _booking_club_address4 === void 0 ? void 0 : _booking_club_address4.lng
                        },
                        photos: booking.club.photos.map((photo)=>({
                                photoUrl: photo.photoUrl
                            }))
                    },
                    area: {
                        name: booking.area.name,
                        description: booking.area.description,
                        price: booking.totalPrice || booking.price,
                        privacy: booking.area.privacy,
                        environment: booking.area.environment,
                        photos: booking.area.photos.map((photo)=>({
                                photoUrl: photo.photoUrl
                            }))
                    },
                    category: booking.category,
                    date: formattedDate,
                    from: from,
                    to: to
                }),
                booking.paymentMethod && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$94fdbc1f5368d5e4), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$d69e8e89ba492243), {
                            children: t("booking.label.paymentMethods")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$4c37618c69ec9a48), {
                            children: t(`club.paymentMethods.${(_booking_paymentMethod2 = booking.paymentMethod) === null || _booking_paymentMethod2 === void 0 ? void 0 : _booking_paymentMethod2.name.toLowerCase()}`)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$94fdbc1f5368d5e4), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$d69e8e89ba492243), {
                            children: t("booking.userInfo")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$1b777da6462b204f), {
                            children: t("booking.label.name")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$4c37618c69ec9a48), {
                            children: booking.name
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$1b777da6462b204f), {
                            children: t("email")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$4c37618c69ec9a48), {
                            children: booking.email
                        })
                    ]
                }),
                !(booking === null || booking === void 0 ? void 0 : booking.canceled) ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$37ab3bdebc286ca), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f567012663b97d59$export$a77d98f00e648d58), {
                            value: `https://${window.location.host}/booking/share/${booking.shareId}`,
                            options: {
                                height: 135,
                                width: 138
                            }
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$e3da0e99c81a4b99), {
                            variant: "contained",
                            onClick: ()=>navigate(`/booking/share/${booking.shareId}?action=share`),
                            children: t("booking.button.shareBooking")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cf0c028fb30d59f8$export$e3da0e99c81a4b99), {
                            variant: "outlined",
                            onClick: ()=>navigate("/player/bookings"),
                            children: [
                                t("booking.bookings"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$e3da0e99c81a4b99), {
                            variant: "contained",
                            color: "error",
                            onClick: ()=>setCancelModalOpen(true),
                            children: t("cancelBooking")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e76a34dc688aa94a$export$97a0a8c219eb7de3), {
                            booking: booking,
                            open: cancelModalOpen,
                            onClose: ()=>setCancelModalOpen(false),
                            onDelete: setAsDeleted
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0c028fb30d59f8$export$e3da0e99c81a4b99), {
                    variant: "contained",
                    disabled: true,
                    children: t("canceled")
                })
            ]
        })
    });
};



var $3mPwx = parcelRequire("3mPwx");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $9uOZr = parcelRequire("9uOZr");
const $f60519f88630e7ec$var$TermsAndConditions = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            spacing: 4,
            mt: 4,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    variant: "h4",
                    textAlign: "center",
                    children: t("termsAndConditions").toUpperCase()
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                    variant: "body1",
                    sx: {
                        textAlign: "justify"
                    },
                    children: [
                        '1. ACKNOWLEDGMENT AND ACCEPTANCE OF TERMS OF SERVICE THIS IS A LEGAL AGREEMENT BETWEEN YOU ("USER" OR "YOU") AND WONDERSOFT INC ("Wondersoft"). BY COMPLETING THE REGISTRATION PROCESS, YOU ARE INDICATING YOUR AGREEMENT TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT. The Online Service ("Service") is provided to you ("User") under the following Wondersoft terms ("Terms"). The Terms comprise the entire agreement between User and Wondersoft and supersede all prior agreements between the parties regarding the subject matter contained herein.',
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        '2. DESCRIPTION OF SERVICE Wondersoft is providing User with a capability to create and convert PDF files. User must: (1) provide all equipment and communications services, including a computer and modem, necessary to establish a connection to the World Wide Web and (2) provide for own access to the World Wide Web and pay any connection and service fees associated with such access. In consideration for this Service, User agrees to: (1) provide certain current, complete, and accurate information about User as prompted to do so by the Service and (2) maintain and update this information as required to keep it current, complete and accurate. All information requested on original sign up shall be referred to as registration Information ("Registration Information"). Wondersoft will maintain Registration Information in accordance with these Terms and then current PDF Copy Paste privacy policy, available at http://www.pdfcopypaste.com/privacy.html. Should there be any conflict between these Terms and Wondersoft\'s privacy policy, these Terms shall supersede the privacy policy. You authorize a recurring monthly or annual charge to your credit card in exchange for use of the Wondersoft service as indicated by published standard plans or a customized quote provided for your specific use. You also agree that the enrollment for the next service period is automatic. Please note that refunds on a pro-rated basis are issued only for yearly plans. When yearly subscriptions are cancelled before the subscriptions end, refunds are issued based on a pro-rated calculation of the subscription charges at the monthly rate for the plan, for the actual number of months the account was subscribed (the number of months between the most recent yearly charges and the cancellation date). If the calculated refund amount exceeds the yearly subscription rate, then no refund is issued. Wondersoft will not issue any pro-rated refunds for the remaining period during the month when an account with a monthly subscription plan ("current plan") is downgraded to a smaller plan ("new plan") (a plan that costs less per month than the current plan) during the middle of a month. However the rate applicable to the new plan will automatically be charged starting the first of the subsequent month, and you must contact sales@pdfcopypaste.com in order to downgrade. If you attempt to sign up for a downgraded account via the online system, it will be considers as a new account and therefore you will be charged for both accounts until you cancel your old subscription.',
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        '3. CONDITIONS OF USE You are solely responsible for the content of all data You store or retrieve from, or attempt to store or retrieve from, Your Account. Your use of the Service is subject to all applicable local, state, national and international laws and regulations. You will: (a) not use the Service for any illegal purposes; (b) not use the Service to store, retrieve, transmit or view any file, data, image or program that contains: (i) any illegal pictures, materials or information; (ii) any harassing, libelous, abusive, threatening, harmful, vulgar, pornographic, obscene or otherwise objectionable material of any kind or nature; (iii) any material that encourages conduct that could constitute a criminal offense, give rise to civil liability or otherwise violate any applicable local, state, national or international law or regulation; (iv) any code or material that violates the intellectual property rights of others; (v) any Windows temporary files of any kind (including, without limitation, any *.p or ~*.* files); or (vi) any viruses, worms, "Trojan horses" or any other similar contaminating or destructive features; (c) comply with United States and other applicable law regarding the exportation and re-exportation of any data or other materials from the United States or other jurisdictions through the Service; (d) not use the Service for any spamming, chain letters or other use that may otherwise disrupt the Service or the networks through which You access and use the Service; (e) comply with all regulations, policies and procedures of networks through which You access and use the Service; and (f) not access or attempt to access any Service account for which You have no access authorization or duplicate, modify, distribute or display any of the data or files from any such account. (h) Wondersoft PDF creation service should not be used to sell digital content to others. It is not a media for dissemination of digital content for commercial purposes. WE WILL NOT APPROACH YOUR DATA BUT IF WE SUSPECT ILLEGAL ACTIVITY WE WILL NOTIFY YOU FOR ACCOUNT TERMINATION',
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "4. MODIFICATIONS TO SERVICE Wondersoft reserves the right to modify or discontinue the Service with or without notice to User. Wondersoft shall not be liable to User or any third party should Wondersoft exercise its right to modify or discontinue the Service.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "5. AUTOMATIC CONVERSION OF TRIAL TO PAID ACCOUNTS Wondersoft may offer trial accounts that require users to provide credit card information which may be used to convert the trial to a paid account at the end of free trial period. If the card transaction fails at the end of free trial period, an email would be sent to the user requesting the user to upgrade the account manually online. In such a case, if the user fails to upgrade to a paid account within three business days, account will be suspended.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "6. USER ACCOUNT, PASSWORD, AND SECURITY Once you become a User of the Service, you shall receive a password and an account. You are entirely responsible if you do not maintain the confidentiality of your password and account. Furthermore, you are entirely responsible for any and all activities which occur under your account. You may change your password at any time by following instructions which we provide to you through our on line support. You agree to immediately notify Wondersoft of any unauthorized use of your account or any other breach of security of which you become aware.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        '7. DISCLAIMER OF WARRANTIES USER EXPRESSLY AGREES THAT USE OF THE SERVICE IS AT USER\'S SOLE RISK. ALTHOUGH Wondersoft WILL ATTEMPT TO PROVIDE UNINTERRUPTED, TIMELY, AND SECURE SERVICES, Wondersoft MAKES NO REPRESENTATION THAT IT WILL BE ABLE TO DO SO. THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. Wondersoft EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. Wondersoft MAKES NO WARRANTY THAT THE SERVICE WILL MEET YOUR REQUIREMENTS, OR THAT THE SERVICE WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE. USER UNDERSTANDS AND AGREES THAT ANY MATERIAL AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SERVICE IS DONE AT USER\'S OWN DISCRETION AND RISK AND THAT USER WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO USER\'S COMPUTER \\ SYSTEM OR LOSS OF DATA OR UNAUTHORIZED DISCLOSURE OF DATA THAT RESULTS FROM THE UPLOAD, DOWNLOAD OR STORAGE OF SUCH MATERIAL AND/OR DATA. Wondersoft MAKES NO WARRANTY REGARDING ANY GOODS OR SERVICES PURCHASED OR OBTAINED THROUGH THE SERVICE OR ANY TRANSACTIONS ENTERED INTO THROUGH THE SERVICE. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY USER FROM Wondersoft OR THROUGH THE SERVICE SHALL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES, SO SOME OF THE ABOVE EXCLUSIONS MAY NOT APPLY TO YOU.',
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "8. LIMITATIONS OF LIABILITY IN NO EVENT SHALL Wondersoft OR ITS ADVERTISERS OR SUPPLIERS HAVE ANY OBLIGATION OR LIABILITY TO YOU FOR THE COST OF PROCUREMENT OF SUBSTITUTE SERVICES OR DATA OR FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES (INCLUDING, WITHOUT LIMITATION, ANY LOSS OF DATA, REVENUE OR PROFITS OR BUSINESS INTERRUPTION) OR OTHER PECUNIARY LOSS ARISING OUT OF YOUR USE OR INABILITY TO USE YOUR ACCOUNT OR THE SERVICE OR YOUR LOSS OF DATA OR FILES STORED THEREIN.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "9. NO RESALE OR COMMERCIAL USE OF THE SERVICE User's right to use the Service is personal to User. User agrees not to resell or make any commercial use of the Service, without the prior express written consent of Wondersoft.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "10. SECURITY OF STORED DATA AND FILES Wondersoft will endeavor to restrict access to the data and files You store or retrieve from Your Account to persons accessing such data and files through use of Your Account or Password. It may also be necessary to access users accounts to verify that the accounts are not being misused, especially with respect to digital copy-right laws and resource misuse checks including bandwidth.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "11. INDEMNIFICATION User agrees to indemnify and hold Wondersoft, contractors, suppliers and its and their employees, harmless from and against any claim or demand, including reasonable attorneys' fees, made by any third party due to or arising out of User's use of the Service, the violation of these Terms by User, or the infringement by User, or other user of the Service using User's computer, of any intellectual property or other right of any person or entity.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "12. ACCOUNT SUSPENSION: Account suspension will occur if the user fails to provide a valid credit card for transactions. If the user fails to provide valid credit card information within a month of suspension, the account and the entire data stored in the quota for the user will be terminated. However, if the succeeds to provide the information the account will be completely recovered.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "13. TERMINATION The User may terminate the Service with or without cause at any time and effective immediately. Should User object to any terms and conditions of the Terms or any subsequent modifications thereto or become dissatisfied with the Service in any way, User's only recourse is to immediately: (1) discontinue use of the Service; (2) terminate Service Membership; and (3) notify Wondersoft of termination. Upon termination of the Service, User's right to use the Service and Software immediately ceases. User shall have no right and Wondersoft will have no obligation thereafter to continue to store User’s data or information or to forward any unread or unsent messages to User or any third party. Wondersoft will terminate accounts in two cases (1) after a month of account suspension. (2) Misuse suspicion. In either case, the user is notified of the action via an email from Wondersoft.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "14. NOTICE All notices to a party shall be in writing and shall be made either via email or conventional mail. Wondersoft may broadcast notices or messages through the Service to inform User of changes to the Terms, the Service, or other matters of importance; such broadcasts shall constitute notice to User.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        '15. PROPRIETARY RIGHTS TO CONTENT User acknowledges that content, including but not limited to text, software, music, sound, photographs, video, graphics or other material contained in either sponsor advertisements or email-distributed, commercially produced information presented to User by the Service ("Content") by Wondersoft or Wondersoft\'s Advertisers (“Advertiser”), is protected by copyrights, trademarks, service marks, patents or other proprietary rights and laws; therefore, User is only permitted to use this Content as expressly authorized by the Service or the Advertiser. User may not copy, reproduce, distribute, or create derivative works from this Content without expressly being authorized to do so by the Service or the Advertiser.'
                    ]
                })
            ]
        })
    });
};
var $f60519f88630e7ec$export$2e2bcd8739ae039 = $f60519f88630e7ec$var$TermsAndConditions;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $1N52b = parcelRequire("1N52b");

var $dNDci = parcelRequire("dNDci");

var $fnVR5 = parcelRequire("fnVR5");

var $2Bwgd = parcelRequire("2Bwgd");
const $ab33f93f6e31bea3$var$ExternalProvider = ()=>{
    const navigate = (0, $iIluI.useNavigate)();
    const { login: login } = (0, $1N52b.useAuth)();
    const fetched = (0, $7fPBF.useRef)(false);
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const { setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const return_url = sessionStorage.getItem("google.returnURL");
    (0, $7fPBF.useEffect)(()=>{
        if (fetched.current) return;
        fetched.current = true;
        const code = searchParams.get("code");
        const error = searchParams.get("error_description");
        if (error) {
            navigate(return_url ? `/login?return_url=${encodeURIComponent(return_url)}` : "/login");
            setSnackbar({
                open: true,
                setOpen: ()=>{
                    setSnackbar({
                        open: false,
                        children: null,
                        setOpen: ()=>{}
                    });
                },
                severity: "error",
                children: (0, $2Bwgd.t)("validation.invalidSSO")
            });
        }
        if (code) new (0, $dNDci.AppService)().api_loginWithGoogle({
            code: code
        }).then((res)=>{
            if (res.status !== 200) throw res;
            login(res.data, "player");
            navigate(return_url !== null && return_url !== void 0 ? return_url : "/");
        }).catch((error)=>{
            console.log(error);
            navigate(return_url ? `/login?return_url=${encodeURIComponent(return_url)}` : "/login");
        }).finally(()=>sessionStorage.removeItem("google.returnURL"));
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
        children: "A entrar..."
    });
};
var $ab33f93f6e31bea3$export$2e2bcd8739ae039 = $ab33f93f6e31bea3$var$ExternalProvider;



var $fnVR5 = parcelRequire("fnVR5");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $dNDci = parcelRequire("dNDci");
const $58cd3b6d67d42cc4$export$383143fb714363e6 = ()=>{
    const appService = new (0, $dNDci.AppService)();
    const fetch = ()=>appService.api_getHighlightedClubs().then((res)=>{
            if (res.status !== 200) throw new Error();
            return res.data;
        }).catch((error)=>console.log(error));
    return {
        actions: {
            fetch: fetch
        }
    };
};


const $93ad482b1d83f84c$export$a2606588460d0e0f = /*#__PURE__*/ (0, $7fPBF.createContext)({
    isLoading: true,
    setIsLoading: ()=>undefined,
    clubs: undefined,
    setClubs: ()=>undefined
});
const $93ad482b1d83f84c$export$2f00b6de1a889f12 = (props)=>{
    const dataFetchedRef = (0, $7fPBF.useRef)(false);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const [clubs, setClubs] = (0, $7fPBF.useState)(undefined);
    const { actions: { fetch: fetch } } = (0, $58cd3b6d67d42cc4$export$383143fb714363e6)();
    const values = (0, $7fPBF.useMemo)(()=>({
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            clubs: clubs,
            setClubs: setClubs
        }), [
        isLoading,
        setIsLoading,
        clubs,
        setClubs
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!dataFetchedRef.current) {
            dataFetchedRef.current = true;
            fetch().then((clubs)=>{
                setClubs(clubs);
                setIsLoading(false);
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($93ad482b1d83f84c$export$a2606588460d0e0f.Provider, {
        value: values,
        ...props
    });
};
const $93ad482b1d83f84c$var$useHomePageContext = ()=>(0, $7fPBF.useContext)($93ad482b1d83f84c$export$a2606588460d0e0f);
var $93ad482b1d83f84c$export$2e2bcd8739ae039 = $93ad482b1d83f84c$var$useHomePageContext;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");


var $goR7t = parcelRequire("goR7t");

var $jpsxw = parcelRequire("jpsxw");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $8m7Fi = parcelRequire("8m7Fi");

var $3jMGu = parcelRequire("3jMGu");

var $jpsxw = parcelRequire("jpsxw");
var $8714e6639ca6acc6$exports = {};

$8714e6639ca6acc6$exports = new URL((parcelRequire("4SSe9")).resolve("cp3oH"), import.meta.url).toString();



var $aili3 = parcelRequire("aili3");

var $lNdSG = parcelRequire("lNdSG");


var $6hfZk = parcelRequire("6hfZk");


let $cb1543788e1ba181$var$_ = (t)=>t, $cb1543788e1ba181$var$t, $cb1543788e1ba181$var$t1, $cb1543788e1ba181$var$t2, $cb1543788e1ba181$var$t3, $cb1543788e1ba181$var$t4, $cb1543788e1ba181$var$t5, $cb1543788e1ba181$var$t6, $cb1543788e1ba181$var$t7;
const $cb1543788e1ba181$export$45c0d0d85148c88c = (0, $6hfZk.default)((0, $aili3.default))($cb1543788e1ba181$var$t || ($cb1543788e1ba181$var$t = $cb1543788e1ba181$var$_`
    display: flex;
    position: relative;
    padding-bottom: 40px;
    align-items: flex-end;
    min-height: calc(100vh - 84px);

    @media (min-width: 600px) {
        min-height: unset;
        height: calc(100vh - 84px);
    }
`));
const $cb1543788e1ba181$export$730f8d97fa8d7a6a = (0, $6hfZk.default)((0, (/*@__PURE__*/$parcel$interopDefault($19315dd41209fb65$exports))))($cb1543788e1ba181$var$t1 || ($cb1543788e1ba181$var$t1 = $cb1543788e1ba181$var$_`
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    position: absolute;

    .slick-list,
    .slick-track,
    .slick-slide div {
        height: 100%;
    }
`));
const $cb1543788e1ba181$export$7722b1870d9eec03 = (0, $6hfZk.default).img($cb1543788e1ba181$var$t2 || ($cb1543788e1ba181$var$t2 = $cb1543788e1ba181$var$_`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: inline-block;
    filter: brightness(0.4);
`));
const $cb1543788e1ba181$export$ee7794de3a87322d = (0, $6hfZk.default)((0, $aili3.default))($cb1543788e1ba181$var$t3 || ($cb1543788e1ba181$var$t3 = $cb1543788e1ba181$var$_`
    width: 100%;
    display: flex;
    justify-content: center;

    ${0};
`), (0, $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f));
const $cb1543788e1ba181$export$873b7756313e36bb = (0, $6hfZk.default).h1($cb1543788e1ba181$var$t4 || ($cb1543788e1ba181$var$t4 = $cb1543788e1ba181$var$_`
    color: white;
    max-width: 850px;
    position: relative;

    ${0};
`), (0, $223ba2a309a8ffb0$export$a9ea127f4b5018b0));
const $cb1543788e1ba181$export$a7fed597f4b8afd8 = (0, $6hfZk.default)((0, $aili3.default))($cb1543788e1ba181$var$t5 || ($cb1543788e1ba181$var$t5 = $cb1543788e1ba181$var$_`
    top: 50%;
    left: 50%;
    display: flex;
    max-width: 325px;
    position: absolute;
    width: calc(100% - 48px);
    transform: translate(-50%, -100%);
`));
const $cb1543788e1ba181$export$6f7f87712f2166d0 = (0, $6hfZk.default)((0, $lNdSG.DatePicker))($cb1543788e1ba181$var$t6 || ($cb1543788e1ba181$var$t6 = $cb1543788e1ba181$var$_`
    overflow: hidden;
    border-radius: 5px;
    background-color: white;

    @media (pointer: fine) {
        ${0};
    }
`), (0, $599cbc729f56127c$export$f8697111af41b441));
const $cb1543788e1ba181$export$2d5d2ba3c7c8c40b = (0, $6hfZk.default).button($cb1543788e1ba181$var$t7 || ($cb1543788e1ba181$var$t7 = $cb1543788e1ba181$var$_`
    width: 70px;
    color: white;
    border: unset;
    margin-left: 15px;
    border-radius: 5px;
    background-color: black;
`));


const $30ec3f61b7b3fab9$var$settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1
};
const $30ec3f61b7b3fab9$export$861edd1ccea2f746 = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [value, setValue] = (0, $7fPBF.useState)((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))());
    const search = ()=>{
        setError(null);
        if (!!!value) {
            setError("Preenche o dia");
            return;
        }
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(value, "DD-MM-YYYY HH:mm").hour(0).minute(0).second(0);
        const queryString = (0, $jpsxw.mountQueryString)({
            date: `${date.unix()}`
        });
        navigate(`/search${queryString}`);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cb1543788e1ba181$export$45c0d0d85148c88c), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cb1543788e1ba181$export$730f8d97fa8d7a6a), {
                ...$30ec3f61b7b3fab9$var$settings,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$7722b1870d9eec03), {
                        src: "/images/basket-1.jpg"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$7722b1870d9eec03), {
                        src: "/images/padel-2.avif"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$7722b1870d9eec03), {
                        src: "/images/football-3.avif"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$7722b1870d9eec03), {
                        src: "/images/tennis-4.avif"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cb1543788e1ba181$export$ee7794de3a87322d), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$873b7756313e36bb), {
                        children: t("homepage.title")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $cb1543788e1ba181$export$a7fed597f4b8afd8), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                                error: !!error,
                                required: true,
                                fullWidth: true,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$6f7f87712f2166d0), {
                                    disablePast: true,
                                    format: "DD-MM-YYYY",
                                    value: value,
                                    slotProps: {
                                        textField: {
                                            required: true,
                                            error: !!error,
                                            helperText: !!error ? error : undefined
                                        }
                                    },
                                    onChange: (date)=>setValue(date)
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cb1543788e1ba181$export$2d5d2ba3c7c8c40b), {
                                onClick: ()=>search(),
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8714e6639ca6acc6$exports)))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
var $81851bd2fd51d774$exports = {};

$81851bd2fd51d774$exports = new URL((parcelRequire("4SSe9")).resolve("6Daup"), import.meta.url).toString();


var $4e3d016df5857b54$exports = {};

$4e3d016df5857b54$exports = new URL((parcelRequire("4SSe9")).resolve("hCA3c"), import.meta.url).toString();


var $2b0bf5b981eadc8c$exports = {};

$2b0bf5b981eadc8c$exports = new URL((parcelRequire("4SSe9")).resolve("ltN45"), import.meta.url).toString();


var $22e533d74bcd7254$exports = {};

$22e533d74bcd7254$exports = new URL((parcelRequire("4SSe9")).resolve("hSBPR"), import.meta.url).toString();


var $d17b7f976f803209$exports = {};

$d17b7f976f803209$exports = new URL((parcelRequire("4SSe9")).resolve("klpFL"), import.meta.url).toString();


var $0abc4e1441a69395$exports = {};

$0abc4e1441a69395$exports = new URL((parcelRequire("4SSe9")).resolve("jcTjH"), import.meta.url).toString();


const $a86c843422031477$export$9e7d6defa524938d = [
    {
        img: (0, (/*@__PURE__*/$parcel$interopDefault($81851bd2fd51d774$exports))),
        translationKey: "search"
    },
    {
        img: (0, (/*@__PURE__*/$parcel$interopDefault($4e3d016df5857b54$exports))),
        translationKey: "book"
    },
    {
        img: (0, (/*@__PURE__*/$parcel$interopDefault($2b0bf5b981eadc8c$exports))),
        translationKey: "share"
    }
];
const $a86c843422031477$export$4d7fe5cd1f80c3f7 = [
    {
        value: "∞",
        translationKey: "fun"
    }
];
const $a86c843422031477$export$6116430962d2e86c = [
    {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($22e533d74bcd7254$exports))),
        text: "first_text",
        subtext: "first_subtext"
    },
    {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d17b7f976f803209$exports))),
        text: "second_text",
        subtext: "second_subtext"
    },
    {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($0abc4e1441a69395$exports))),
        text: "third_text",
        subtext: "third_subtext"
    }
];



var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");

let $b6afde0cf10da040$var$_ = (t)=>t, $b6afde0cf10da040$var$t, $b6afde0cf10da040$var$t1, $b6afde0cf10da040$var$t2, $b6afde0cf10da040$var$t3;
const $b6afde0cf10da040$export$1fe335f09c382cba = (0, $6hfZk.default)((0, $aili3.default))($b6afde0cf10da040$var$t || ($b6afde0cf10da040$var$t = $b6afde0cf10da040$var$_`
    gap: 40px;
    display: flex;
    padding: 80px 24px;
    flex-direction: column;
    background-color: #1976d2;
`));
const $b6afde0cf10da040$export$c4c482fa9749b862 = (0, $6hfZk.default).h2($b6afde0cf10da040$var$t1 || ($b6afde0cf10da040$var$t1 = $b6afde0cf10da040$var$_`
    color: white;
    text-align: center;

    ${0};
`), (0, $223ba2a309a8ffb0$export$fb02c795f1eb23eb));
const $b6afde0cf10da040$export$3985d38e981269df = (0, $6hfZk.default)((0, $aili3.default))($b6afde0cf10da040$var$t2 || ($b6afde0cf10da040$var$t2 = $b6afde0cf10da040$var$_`
    gap: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    padding-inline: unset !important;
    flex-direction: column;

    @media (min-width: 720px) {
        gap: 20px;
        flex-direction: row;
        align-items: unset;
    }

    ${0};
`), (0, $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f));
const $b6afde0cf10da040$export$25f0557f767cf1c9 = (0, $6hfZk.default)((0, $aili3.default))($b6afde0cf10da040$var$t3 || ($b6afde0cf10da040$var$t3 = $b6afde0cf10da040$var$_`
    flex: 1;
    gap: 20px;
    width: 100%;
    color: white;
    display: flex;
    padding: 50px;
    max-width: 350px;
    text-align: center;
    border-radius: 40px;
    flex-direction: column;
    background-color: #0363c2;

    h3 {
        ${0};
    }

    p {
        ${0};
    }
`), (0, $223ba2a309a8ffb0$export$fb02c795f1eb23eb), (0, $223ba2a309a8ffb0$export$3b92b0afb61b3761));


const $a06c2467a2615432$export$fb587a27d5a722e7 = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b6afde0cf10da040$export$1fe335f09c382cba), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6afde0cf10da040$export$c4c482fa9749b862), {
                children: t(`homepage.steps.title`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6afde0cf10da040$export$3985d38e981269df), {
                children: (0, $a86c843422031477$export$9e7d6defa524938d).map((step, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b6afde0cf10da040$export$25f0557f767cf1c9), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                src: step.img
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h3", {
                                children: index + 1
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: t(`homepage.steps.${step.translationKey}`)
                            })
                        ]
                    }, `step-card-${index}`))
            })
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

const $cd8dad90fae20160$export$2f17821776a07b7b = (value)=>{
    const roundedValue = Math.floor((value - 1) / 5) * 5;
    if (roundedValue < 5) return value - 1;
    return roundedValue;
};





var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");

let $83213ce85a36b4a6$var$_ = (t)=>t, $83213ce85a36b4a6$var$t, $83213ce85a36b4a6$var$t1, $83213ce85a36b4a6$var$t2, $83213ce85a36b4a6$var$t3, $83213ce85a36b4a6$var$t4, $83213ce85a36b4a6$var$t5, $83213ce85a36b4a6$var$t6, $83213ce85a36b4a6$var$t7, $83213ce85a36b4a6$var$t8, $83213ce85a36b4a6$var$t9, $83213ce85a36b4a6$var$t10, $83213ce85a36b4a6$var$t11, $83213ce85a36b4a6$var$t12, $83213ce85a36b4a6$var$t13;
const $83213ce85a36b4a6$export$7e62e9488dbb2420 = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t || ($83213ce85a36b4a6$var$t = $83213ce85a36b4a6$var$_`
    gap: 40px;
    display: flex;
    color: #212a5c;
    padding-block: 80px;
    flex-direction: column;

    ${0};
`), (0, $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f));
const $83213ce85a36b4a6$export$6c2ebd88fb7771eb = (0, $6hfZk.default).h2($83213ce85a36b4a6$var$t1 || ($83213ce85a36b4a6$var$t1 = $83213ce85a36b4a6$var$_`
    ${0};
`), (0, $223ba2a309a8ffb0$export$fb02c795f1eb23eb));
const $83213ce85a36b4a6$export$9f6f841775169212 = (0, $6hfZk.default).p($83213ce85a36b4a6$var$t2 || ($83213ce85a36b4a6$var$t2 = $83213ce85a36b4a6$var$_`
    max-width: 615px;

    ${0};
`), (0, $223ba2a309a8ffb0$export$68e2d6fb3c07c0b4));
const $83213ce85a36b4a6$export$56e6e3b6654ca2d9 = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t3 || ($83213ce85a36b4a6$var$t3 = $83213ce85a36b4a6$var$_`
    gap: 40px;
    display: flex;
    max-width: 615px;
    flex-direction: column;

    @media (min-width: 600px) {
        gap: 20px;
        flex-direction: row;
    }
`));
const $83213ce85a36b4a6$export$50660b89867aee9f = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t4 || ($83213ce85a36b4a6$var$t4 = $83213ce85a36b4a6$var$_`
    flex: 1;

    h5 {
        ${0};

        @media (min-width: 600px) {
            ${0};
        }
    }

    p {
        ${0};

        @media (min-width: 600px) {
            ${0};
        }
    }
`), (0, $223ba2a309a8ffb0$export$fb02c795f1eb23eb), (0, $223ba2a309a8ffb0$export$255b806436d2199), (0, $223ba2a309a8ffb0$export$68e2d6fb3c07c0b4), (0, $223ba2a309a8ffb0$export$3b92b0afb61b3761));
const $83213ce85a36b4a6$export$d3adeef97d7acaed = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t5 || ($83213ce85a36b4a6$var$t5 = $83213ce85a36b4a6$var$_`
    margin-top: 50px;
`));
const $83213ce85a36b4a6$export$4fa4ceee2bc5b93 = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t6 || ($83213ce85a36b4a6$var$t6 = $83213ce85a36b4a6$var$_`
    gap: 40px;
    display: flex;
    max-width: 400px;
    margin-inline: auto;
    align-items: flex-start;
    flex-direction: column;

    @media (min-width: 600px) {
        max-width: unset;
        flex-direction: row;
        margin-inline: unset;

        &:nth-of-type(2n) {
            flex-direction: row-reverse;
        }
    }

    &:not(:last-of-type) {
        margin-bottom: 100px;
    }
`));
const $83213ce85a36b4a6$export$b3c4bd02c0f20564 = (0, $6hfZk.default).div($83213ce85a36b4a6$var$t7 || ($83213ce85a36b4a6$var$t7 = $83213ce85a36b4a6$var$_`
    flex: 1;

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`));
const $83213ce85a36b4a6$export$26e16093cf7c29df = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t8 || ($83213ce85a36b4a6$var$t8 = $83213ce85a36b4a6$var$_`
    flex: 1;
`));
const $83213ce85a36b4a6$export$a6fd403a1a35df92 = (0, $6hfZk.default).a($83213ce85a36b4a6$var$t9 || ($83213ce85a36b4a6$var$t9 = $83213ce85a36b4a6$var$_`
    ${0};

    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`), (0, $223ba2a309a8ffb0$export$e5d6432f30b950b2));
const $83213ce85a36b4a6$export$86ed7347802957c3 = (0, $6hfZk.default)((0, $aili3.default))($83213ce85a36b4a6$var$t10 || ($83213ce85a36b4a6$var$t10 = $83213ce85a36b4a6$var$_`
    gap: 10px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
`));
const $83213ce85a36b4a6$export$75591de432b8adb2 = (0, $6hfZk.default).p($83213ce85a36b4a6$var$t11 || ($83213ce85a36b4a6$var$t11 = $83213ce85a36b4a6$var$_`
    ${0};
`), (0, $223ba2a309a8ffb0$export$68e2d6fb3c07c0b4));
const $83213ce85a36b4a6$export$8ee7b452befc74f4 = (0, $6hfZk.default).p($83213ce85a36b4a6$var$t12 || ($83213ce85a36b4a6$var$t12 = $83213ce85a36b4a6$var$_`
    ${0};

    margin-block: 20px;
`), (0, $223ba2a309a8ffb0$export$68e2d6fb3c07c0b4));
const $83213ce85a36b4a6$export$7c8f159da0dc916 = (0, $6hfZk.default).img($83213ce85a36b4a6$var$t13 || ($83213ce85a36b4a6$var$t13 = $83213ce85a36b4a6$var$_`
    margin-right: 0.2rem;
`));



const $36936ca2bbf56f25$export$2dceb80d0af9bf60 = ({ numberofClubs: numberofClubs, numberOfSports: numberOfSports, highlightedClubs: highlightedClubs })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$7e62e9488dbb2420), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$6c2ebd88fb7771eb), {
                children: t(`homepage.statistics.title`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$9f6f841775169212), {
                children: t(`homepage.statistics.text`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$56e6e3b6654ca2d9), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$50660b89867aee9f), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h5", {
                                children: [
                                    (0, $cd8dad90fae20160$export$2f17821776a07b7b)(numberofClubs),
                                    "+"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: t(`homepage.statistics.locations`)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$50660b89867aee9f), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h5", {
                                children: [
                                    (0, $cd8dad90fae20160$export$2f17821776a07b7b)(numberOfSports),
                                    "+"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: t(`homepage.statistics.sports`)
                            })
                        ]
                    }),
                    (0, $a86c843422031477$export$4d7fe5cd1f80c3f7).map((statistic, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$50660b89867aee9f), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("h5", {
                                    children: [
                                        statistic.value,
                                        "+"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    children: t(`homepage.statistics.${statistic.translationKey}`)
                                })
                            ]
                        }, `statistics-card-${index}`))
                ]
            }),
            (highlightedClubs === null || highlightedClubs === void 0 ? void 0 : highlightedClubs.length) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$d3adeef97d7acaed), {
                children: highlightedClubs.map((club)=>{
                    var _club_photos, _club_photos_, _club_categories, _club_address, _club_address1, _club_address2;
                    /*#__PURE__*/ return (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$4fa4ceee2bc5b93), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$b3c4bd02c0f20564), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                    src: ((_club_photos = club.photos) === null || _club_photos === void 0 ? void 0 : (_club_photos_ = _club_photos[0]) === null || _club_photos_ === void 0 ? void 0 : _club_photos_.photoUrl) || "https://placehold.co/400"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$26e16093cf7c29df), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$a6fd403a1a35df92), {
                                        href: `/club/${club.id}`,
                                        children: club === null || club === void 0 ? void 0 : club.name
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$86ed7347802957c3), {
                                        children: (_club_categories = club.categories) === null || _club_categories === void 0 ? void 0 : _club_categories.map((category)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $6a0d74d9d8c84bda$export$ef50152da13f3005), {
                                                avatar: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a1a4fc57da56c62$export$76b259acec9cae97), {
                                                    category: category
                                                }),
                                                label: t(`search.sports.${category.toLowerCase()}`),
                                                color: "primary",
                                                variant: "outlined"
                                            }, `club-${club.id}-${category}`))
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $83213ce85a36b4a6$export$8ee7b452befc74f4), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$7c8f159da0dc916), {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($466aa0f23e42c6dd$exports)))
                                            }),
                                            " ",
                                            club === null || club === void 0 ? void 0 : (_club_address = club.address) === null || _club_address === void 0 ? void 0 : _club_address.address,
                                            ", ",
                                            club === null || club === void 0 ? void 0 : (_club_address1 = club.address) === null || _club_address1 === void 0 ? void 0 : _club_address1.county,
                                            ",",
                                            " ",
                                            club === null || club === void 0 ? void 0 : (_club_address2 = club.address) === null || _club_address2 === void 0 ? void 0 : _club_address2.district
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $83213ce85a36b4a6$export$75591de432b8adb2), {
                                        children: club.description
                                    })
                                ]
                            })
                        ]
                    }, `club-${club.id}`);
                })
            })
        ]
    });
};




var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");


var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");

let $b8d7e2e5cd87505d$var$_ = (t)=>t, $b8d7e2e5cd87505d$var$t, $b8d7e2e5cd87505d$var$t1, $b8d7e2e5cd87505d$var$t2, $b8d7e2e5cd87505d$var$t3, $b8d7e2e5cd87505d$var$t4;
const $b8d7e2e5cd87505d$export$3411bef2eae0018c = (0, $6hfZk.default)((0, $aili3.default))($b8d7e2e5cd87505d$var$t || ($b8d7e2e5cd87505d$var$t = $b8d7e2e5cd87505d$var$_`
    gap: 40px;
    display: flex;
    padding: 80px 24px;
    flex-direction: column;

    ${0};
`), (0, $223ba2a309a8ffb0$export$b4ac0ea54a7abd9f));
const $b8d7e2e5cd87505d$export$d23e4cac5a5ff9b2 = (0, $6hfZk.default).h2($b8d7e2e5cd87505d$var$t1 || ($b8d7e2e5cd87505d$var$t1 = $b8d7e2e5cd87505d$var$_`
    color: #212a5c;

    ${0};
`), (0, $223ba2a309a8ffb0$export$fb02c795f1eb23eb));
const $b8d7e2e5cd87505d$export$d4ee0eac67572e29 = (0, $6hfZk.default)((0, $aili3.default))($b8d7e2e5cd87505d$var$t2 || ($b8d7e2e5cd87505d$var$t2 = $b8d7e2e5cd87505d$var$_`
    gap: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    padding-inline: unset !important;
    flex-direction: column;

    @media (min-width: 720px) {
        gap: 20px;
        flex-direction: row;
        align-items: unset;
    }
`));
const $b8d7e2e5cd87505d$export$3eed96e2f5578c27 = (0, $6hfZk.default)((0, $aili3.default))($b8d7e2e5cd87505d$var$t3 || ($b8d7e2e5cd87505d$var$t3 = $b8d7e2e5cd87505d$var$_`
    flex: 1;
    gap: 20px;
    width: 100%;
    display: flex;
    padding: 20px;
    color: #21295c;
    max-width: 350px;
    border-radius: 20px;
    flex-direction: column;
    background-color: #f2f2f2;

    p {
        flex: 1;
        ${0};
    }

    span {
        ${0};
    }
`), (0, $223ba2a309a8ffb0$export$68e2d6fb3c07c0b4), (0, $223ba2a309a8ffb0$export$dfb2a4e17199f269));
const $b8d7e2e5cd87505d$export$27a3b73b514c5dff = (0, $6hfZk.default)((0, $aili3.default))($b8d7e2e5cd87505d$var$t4 || ($b8d7e2e5cd87505d$var$t4 = $b8d7e2e5cd87505d$var$_`
    border-radius: 20px;
    background-color: white;

    img {
        width: 90%;
        display: block;
        max-width: 150px;
        max-height: 150px;
        margin: 25px auto;
    }
`));


const $37201c0dc30f453c$export$20e455c6fca4f25f = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b8d7e2e5cd87505d$export$3411bef2eae0018c), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b8d7e2e5cd87505d$export$d23e4cac5a5ff9b2), {
                children: t(`homepage.advantages.title`)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b8d7e2e5cd87505d$export$d4ee0eac67572e29), {
                children: (0, $a86c843422031477$export$6116430962d2e86c).map((advantages_card, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b8d7e2e5cd87505d$export$3eed96e2f5578c27), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b8d7e2e5cd87505d$export$27a3b73b514c5dff), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                    src: advantages_card.image
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: t(`homepage.advantages.${advantages_card.text}`)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                children: t(`homepage.advantages.${advantages_card.subtext}`)
                            })
                        ]
                    }, `advantages-card-${index}`))
            })
        ]
    });
};


const $cc47c1f3012a44fa$var$HomePage = ()=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const navigate = (0, $iIluI.useNavigate)();
    const { clubs: clubs } = (0, $93ad482b1d83f84c$export$2e2bcd8739ae039)();
    const { categories: categories, clubNames: clubNames } = (0, $goR7t.default)();
    const navigateWithQueryString = (inputParams = {})=>{
        const queryString = (0, $jpsxw.mountQueryString)(inputParams);
        navigate(`/search${queryString}`);
    };
    var _categories_length;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$1dd6b49c38c99076), {
        headerType: "menu",
        maxWidth: false,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $30ec3f61b7b3fab9$export$861edd1ccea2f746), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a06c2467a2615432$export$fb587a27d5a722e7), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $36936ca2bbf56f25$export$2dceb80d0af9bf60), {
                numberofClubs: clubNames === null || clubNames === void 0 ? void 0 : clubNames.length,
                numberOfSports: (_categories_length = categories === null || categories === void 0 ? void 0 : categories.length) !== null && _categories_length !== void 0 ? _categories_length : 0,
                highlightedClubs: clubs
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f39b3abf0ccb3e1f$export$cd640987c37b8c23), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f39b3abf0ccb3e1f$export$bafbed5541cae1c7), {
                            children: t(`homepage.book.title`)
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f39b3abf0ccb3e1f$export$e720ec32d577006a), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                onClick: ()=>navigateWithQueryString({}),
                                children: t(`homepage.book.bookNow`)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $37201c0dc30f453c$export$20e455c6fca4f25f), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f39b3abf0ccb3e1f$export$a06f1c675e846f6f), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$7fff059ad723fa92), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$8d8e9363690df25b), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    children: t(`homepage.footer.courts`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>navigateWithQueryString({
                                            sport: "tenis"
                                        }),
                                    children: t(`homepage.footer.tennis`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>navigateWithQueryString({
                                            sport: "basquetebol"
                                        }),
                                    children: t(`homepage.footer.basketball`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>navigateWithQueryString({
                                            sport: "futebol"
                                        }),
                                    children: t(`homepage.footer.soccer`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$8d8e9363690df25b), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    children: t(`homepage.footer.sports`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>navigateWithQueryString({
                                            sport: "voleibol"
                                        }),
                                    children: t(`homepage.footer.volleyball`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>navigateWithQueryString({
                                            sport: "padel"
                                        }),
                                    children: t(`homepage.footer.padel`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>navigateWithQueryString({
                                            sport: "futsal"
                                        }),
                                    children: t(`homepage.footer.futsal`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$8d8e9363690df25b), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    children: t(`homepage.footer.help`)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    onClick: ()=>window.location.href = `mailto:desporto@cm-aveiro.pt?subject=Contacto`,
                                    children: t(`contact`)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $cc47c1f3012a44fa$export$2e2bcd8739ae039 = $cc47c1f3012a44fa$var$HomePage;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


var $6hfZk = parcelRequire("6hfZk");

var $aili3 = parcelRequire("aili3");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $goR7t = parcelRequire("goR7t");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $864bff06b6c5bed8$var$_ = (t)=>t, $864bff06b6c5bed8$var$t, $864bff06b6c5bed8$var$t1;
const $864bff06b6c5bed8$var$loading = (0, $6hfZk.keyframes)($864bff06b6c5bed8$var$t || ($864bff06b6c5bed8$var$t = $864bff06b6c5bed8$var$_`
    from { 
        transform: rotate(0deg);
    }
    to { 
        transform: rotate(360deg);
    }
`));
const $864bff06b6c5bed8$export$bed6cc91e533babe = (0, $6hfZk.default)((0, $aili3.default))($864bff06b6c5bed8$var$t1 || ($864bff06b6c5bed8$var$t1 = $864bff06b6c5bed8$var$_`
    width: 5rem;
    height: 5rem;
    border: 0.3rem solid;
    border-radius: 50%;
    animation: ${0} 1s linear infinite;
    border-color: black black black transparent;
`), $864bff06b6c5bed8$var$loading);


const $6d4a29dbc701c5bc$export$669f6ea7d267feaf = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $864bff06b6c5bed8$export$bed6cc91e533babe), {
        ...props
    });
};



var $aili3 = parcelRequire("aili3");

var $6hfZk = parcelRequire("6hfZk");
let $f55d8dd0943d37d3$var$_ = (t)=>t, $f55d8dd0943d37d3$var$t, $f55d8dd0943d37d3$var$t1, $f55d8dd0943d37d3$var$t2, $f55d8dd0943d37d3$var$t3, $f55d8dd0943d37d3$var$t4, $f55d8dd0943d37d3$var$t5, $f55d8dd0943d37d3$var$t6, $f55d8dd0943d37d3$var$t7, $f55d8dd0943d37d3$var$t8, $f55d8dd0943d37d3$var$t9, $f55d8dd0943d37d3$var$t10, $f55d8dd0943d37d3$var$t11;
const $f55d8dd0943d37d3$export$e9f5ea1b4dfabd67 = (0, $6hfZk.default)((0, $aili3.default))($f55d8dd0943d37d3$var$t || ($f55d8dd0943d37d3$var$t = $f55d8dd0943d37d3$var$_`
    padding: 0 1rem 0rem 1rem;
    margin-top: 1.5rem;
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
        0px 1px 8px 0px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
    overflow: hidden;

    &:first-of-type {
        margin-top: 0.5rem;
    }

    @media (min-width: 1024px) {
        &:first-of-type {
            margin-top: unset;
        }
        margin-top: unset;
        box-shadow: unset;
        border-radius: unset;
        &:not(:last-of-type) {
            border-bottom: 1px solid;
        }
    }
`));
const $f55d8dd0943d37d3$export$26e16093cf7c29df = (0, $6hfZk.default)((0, $aili3.default))($f55d8dd0943d37d3$var$t1 || ($f55d8dd0943d37d3$var$t1 = $f55d8dd0943d37d3$var$_`
    padding: 0.5rem 0.5rem 0;
`));
const $f55d8dd0943d37d3$export$f7f6cd525d0f9a80 = (0, $6hfZk.default).div($f55d8dd0943d37d3$var$t2 || ($f55d8dd0943d37d3$var$t2 = $f55d8dd0943d37d3$var$_`
    margin: -0.5rem -1.5rem 1rem -1.5rem;
`));
const $f55d8dd0943d37d3$export$b3c4bd02c0f20564 = (0, $6hfZk.default).img($f55d8dd0943d37d3$var$t3 || ($f55d8dd0943d37d3$var$t3 = $f55d8dd0943d37d3$var$_`
    height: 8rem;
    width: 100%;
    object-fit: cover;
    object-position: center;
`));
const $f55d8dd0943d37d3$export$c7bd411105e2dec3 = (0, $6hfZk.default).h5($f55d8dd0943d37d3$var$t4 || ($f55d8dd0943d37d3$var$t4 = $f55d8dd0943d37d3$var$_`
    margin: 0;
    cursor: pointer;
    font-size: 0.9rem;

    &:hover {
        text-decoration: underline;
    }
`));
const $f55d8dd0943d37d3$export$393edc798c47379d = (0, $6hfZk.default).p($f55d8dd0943d37d3$var$t5 || ($f55d8dd0943d37d3$var$t5 = $f55d8dd0943d37d3$var$_`
    color: grey;
    margin: 0.5rem 0 1rem;
    font-size: 0.8em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    img {
        transform: translateY(0.2rem);
        margin-right: 0.5rem;
        filter: contrast(0.1);
    }
`));
const $f55d8dd0943d37d3$export$ea1a111407f37557 = (0, $6hfZk.default)((0, $aili3.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "disabled"
})($f55d8dd0943d37d3$var$t7 || ($f55d8dd0943d37d3$var$t7 = $f55d8dd0943d37d3$var$_`
    display: flex;
    padding: 1rem 0;
    border-bottom: solid 1px #ccc;

    &:last-of-type {
        border-bottom: unset;
    }

    ${0}
`), ({ disabled: disabled })=>disabled && (0, $6hfZk.css)($f55d8dd0943d37d3$var$t6 || ($f55d8dd0943d37d3$var$t6 = $f55d8dd0943d37d3$var$_`
            position: relative;

            ${0} {
                z-index: 1;
                opacity: 0.7;
                position: relative;
            }

            &:after {
                top: 0;
                left: 0;
                content: '';
                width: 100%;
                height: 100%;
                opacity: 0.5;
                display: block;
                position: absolute;
                background-color: white;
            }
        `), $f55d8dd0943d37d3$export$c7bd411105e2dec3));
const $f55d8dd0943d37d3$export$2eec7c08090e9eb9 = (0, $6hfZk.default)((0, $aili3.default))($f55d8dd0943d37d3$var$t8 || ($f55d8dd0943d37d3$var$t8 = $f55d8dd0943d37d3$var$_`
    width: 30%;
    height: inherit;

    @media (max-width: 425px) {
        display: none;
    }
`));
const $f55d8dd0943d37d3$export$71219af9848f38ea = (0, $6hfZk.default).img($f55d8dd0943d37d3$var$t9 || ($f55d8dd0943d37d3$var$t9 = $f55d8dd0943d37d3$var$_`
    height: 100%;
    display: block;
    object-fit: cover;
    width: 100%;
`));
const $f55d8dd0943d37d3$export$6aafbbb3df4a0dd = (0, $6hfZk.default)((0, $aili3.default))($f55d8dd0943d37d3$var$t10 || ($f55d8dd0943d37d3$var$t10 = $f55d8dd0943d37d3$var$_`
    flex: 1;
    display: flex;
    margin-left: 0.5rem;
    padding-left: 0.5rem;
    flex-direction: column;

    @media (max-width: 425px) {
        padding-left: 0;
    }
`));
const $f55d8dd0943d37d3$export$3a46b95641c69038 = (0, $6hfZk.default).span($f55d8dd0943d37d3$var$t11 || ($f55d8dd0943d37d3$var$t11 = $f55d8dd0943d37d3$var$_`
    display: block;
    margin: 0 1rem;
    font-weight: 600;
`));


parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");




var $7vf1K = parcelRequire("7vf1K");

var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
const $2434f90fabaaf39c$export$aa855a00633ee0da = (props)=>{
    const { isLoading: isLoading, isFirstSearchPerformed: isFirstSearchPerformed, searchObj: searchObj, results: results, setPin: setPin } = (0, $goR7t.default)();
    const navigate = (0, $iIluI.useNavigate)();
    const { t: t } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ...props,
        children: isLoading ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6d4a29dbc701c5bc$export$669f6ea7d267feaf), {}) : !(results === null || results === void 0 ? void 0 : results.length) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$3a46b95641c69038), {
            children: isFirstSearchPerformed && !isLoading && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                severity: "info",
                children: t("clubList.emptyList")
            })
        }) : results === null || results === void 0 ? void 0 : results.map(({ id: id, name: name, photoUrl: photoUrl, description: description, address: address, areas: areas })=>{
            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f55d8dd0943d37d3$export$e9f5ea1b4dfabd67), {
                onMouseEnter: ()=>{
                    setPin(id);
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f55d8dd0943d37d3$export$26e16093cf7c29df), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$f7f6cd525d0f9a80), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$b3c4bd02c0f20564), {
                                    src: photoUrl ? photoUrl : "https://placehold.co/400"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$c7bd411105e2dec3), {
                                onClick: ()=>{
                                    navigate(`/club/${id}?a=1${(0, $7vf1K.fromObjectToQueryString)(searchObj)}`);
                                },
                                children: name
                            }),
                            !!address && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f55d8dd0943d37d3$export$393edc798c47379d), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($466aa0f23e42c6dd$exports))),
                                        alt: ""
                                    }),
                                    `${address.address}, ${address.postalCode} - ${address.county}, ${address.district}`
                                ]
                            }),
                            !!description && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$393edc798c47379d), {
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                        children: areas.map((area)=>{
                            const { id: areaId, name: name, price: price, description: description, photoUrl: photoUrl, schedules: schedules, closedSchedules: closedSchedules, reservations: reservations, privacy: privacy, environment: environment, categories: categories } = area;
                            const isAreaClosed = !schedules.length || closedSchedules.length > 0;
                            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f55d8dd0943d37d3$export$ea1a111407f37557), {
                                disabled: isAreaClosed || (reservations === null || reservations === void 0 ? void 0 : reservations.length) > 0,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$2eec7c08090e9eb9), {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$71219af9848f38ea), {
                                            src: photoUrl ? photoUrl : "https://placehold.co/400"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f55d8dd0943d37d3$export$6aafbbb3df4a0dd), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$c7bd411105e2dec3), {
                                                onClick: ()=>{
                                                    navigate(`/club/${id}?area=${areaId}${(0, $7vf1K.fromObjectToQueryString)(searchObj)}`);
                                                },
                                                children: name
                                            }),
                                            !!description && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55d8dd0943d37d3$export$393edc798c47379d), {
                                                children: description
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7a6d7bc33d2bc30d$export$3176735d3ad67a5), {
                                                privacy: privacy,
                                                environment: environment
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a7cb30f46f215d07$export$83e59e016ed543bf), {
                                                categories: categories,
                                                clubId: id,
                                                areaId: areaId,
                                                areaName: name,
                                                price: price,
                                                privacy: privacy,
                                                reservations: reservations,
                                                areaSchedules: schedules,
                                                areaClosedSchedules: closedSchedules,
                                                displayOptions: {
                                                    showPrice: true,
                                                    showClosedClubLabel: false
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, areaId);
                        })
                    })
                ]
            }, id);
        })
    });
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $6hfZk = parcelRequire("6hfZk");

var $i3L0M = parcelRequire("i3L0M");


var $aili3 = parcelRequire("aili3");
let $b2d537959abde10c$var$_ = (t)=>t, $b2d537959abde10c$var$t, $b2d537959abde10c$var$t1, $b2d537959abde10c$var$t2, $b2d537959abde10c$var$t3;
const $b2d537959abde10c$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($b2d537959abde10c$var$t || ($b2d537959abde10c$var$t = $b2d537959abde10c$var$_`
    position: relative;
`));
const $b2d537959abde10c$export$3ba510748aae365e = (0, $6hfZk.default)((0, $i3L0M.Map))($b2d537959abde10c$var$t1 || ($b2d537959abde10c$var$t1 = $b2d537959abde10c$var$_`
    width: 100%;
    height: 40rem;
    margin-top: 4rem;

    @media (min-width: 1024px) {
        height: 100%;
        margin-top: unset;
    }
`));
const $b2d537959abde10c$export$5e3f251c730829 = (0, $6hfZk.default)((0, $aili3.default))($b2d537959abde10c$var$t2 || ($b2d537959abde10c$var$t2 = $b2d537959abde10c$var$_`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
`));
const $b2d537959abde10c$export$bed6cc91e533babe = (0, $6hfZk.default)((0, $6d4a29dbc701c5bc$export$669f6ea7d267feaf))($b2d537959abde10c$var$t3 || ($b2d537959abde10c$var$t3 = $b2d537959abde10c$var$_`
    position: absolute;
    top: calc(50% - 2.5rem);
    left: calc(50% - 2.5rem);
`));



var $goR7t = parcelRequire("goR7t");

const $26afe7af649a5f3e$export$aa23630cf786ed99 = (props)=>{
    const { isLoading: isLoading, results: results } = (0, $goR7t.default)();
    const center = (0, $7fPBF.useMemo)(()=>{
        if (!(results === null || results === void 0 ? void 0 : results.length)) return {
            lat: 40.64217439827243,
            lng: -8.65346967664854
        };
        const aggregate = results === null || results === void 0 ? void 0 : results.reduce((acc, club)=>{
            var _club_address, _club_address1;
            return {
                lat: acc.lat + Number((_club_address = club.address) === null || _club_address === void 0 ? void 0 : _club_address.lat),
                lng: acc.lng + Number((_club_address1 = club.address) === null || _club_address1 === void 0 ? void 0 : _club_address1.lng)
            };
        }, {
            lat: 0,
            lng: 0
        });
        return {
            lat: (aggregate === null || aggregate === void 0 ? void 0 : aggregate.lat) / (results === null || results === void 0 ? void 0 : results.length),
            lng: (aggregate === null || aggregate === void 0 ? void 0 : aggregate.lng) / (results === null || results === void 0 ? void 0 : results.length)
        };
    }, [
        results
    ]);
    const mappedClubs = (0, $7fPBF.useMemo)(()=>{
        return (results === null || results === void 0 ? void 0 : results.length) ? (0, $1335e35c06139c82$export$d372a871356834cd)(results) : [];
    }, [
        results
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b2d537959abde10c$export$d675f139b342d51a), {
        ...props,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2d537959abde10c$export$3ba510748aae365e), {
                center: center,
                mapInfos: mappedClubs,
                showPopUp: true
            }),
            isLoading && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2d537959abde10c$export$5e3f251c730829), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2d537959abde10c$export$bed6cc91e533babe), {})
            })
        ]
    });
};



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $7fPBF = parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $3jMGu = parcelRequire("3jMGu");
var $gFr0F = parcelRequire("gFr0F");
var $lHSFU = parcelRequire("lHSFU");
var $58CWL = parcelRequire("58CWL");
var $f6ezL = parcelRequire("f6ezL");
var $3loMv = parcelRequire("3loMv");

var $a13Ew = parcelRequire("a13Ew");

var $goR7t = parcelRequire("goR7t");

var $3XFgI = parcelRequire("3XFgI");

var $c7SNK = parcelRequire("c7SNK");




const $28f3f8635466462c$export$9d8971762169e65a = ({ onSearch: onSearch, ...remainingProps })=>{
    const checkQueryStringRef = (0, $7fPBF.useRef)(false);
    const { searchObj: searchObj, categories: categories, clubNames: clubNames, isLoadingFilters: isLoadingFilters } = (0, $goR7t.default)();
    const [error, setError] = (0, $7fPBF.useState)(undefined);
    const { t: t } = (0, $doyfp.useTranslation)();
    const { actions: { search: search, checkQueryString: checkQueryString, handleInputChange: handleInputChange } } = (0, $a13Ew.useSearch)();
    (0, $7fPBF.useEffect)(()=>{
        if (isLoadingFilters || checkQueryStringRef.current) return;
        checkQueryStringRef.current = true;
        checkQueryString();
    }, [
        isLoadingFilters
    ]);
    const handleSubmit = (0, $7fPBF.useCallback)(()=>{
        setError(undefined);
        const error = (0, $c7SNK.checkIfFieldsAreValidAndReturnError)(searchObj);
        if (error) {
            error.message = t("search.errors.isRequired", {
                field: t(`search.fields.${error.field}`)
            });
            setError(error);
            return;
        }
        onSearch === null || onSearch === void 0 ? void 0 : onSearch();
        search(searchObj);
    }, [
        searchObj
    ]);
    if (isLoadingFilters) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $599cbc729f56127c$export$d675f139b342d51a), {
        ...remainingProps,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $599cbc729f56127c$export$71655785c758526a), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                        error: (error === null || error === void 0 ? void 0 : error.field) === "sport",
                        required: true,
                        fullWidth: true,
                        style: {
                            minWidth: 300
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$96952269499d1070), {
                                multiple: true,
                                id: "search-sport",
                                noOptionsText: t("search.labels.noSport"),
                                options: categories === null || categories === void 0 ? void 0 : categories.map((category)=>category),
                                filterSelectedOptions: true,
                                value: searchObj.sport,
                                getOptionLabel: (option)=>t(`search.sports.${option.toLowerCase()}`),
                                renderOption: (props, option)=>{
                                    const category = categories && categories.find((category)=>category.toLocaleLowerCase() === option.toLowerCase());
                                    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                        component: "li",
                                        flexDirection: "row",
                                        flex: 1,
                                        display: "flex",
                                        ...props,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a1a4fc57da56c62$export$76b259acec9cae97), {
                                                category: category
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                                style: {
                                                    marginLeft: 16
                                                },
                                                children: t(`search.sports.${option.toLowerCase()}`)
                                            })
                                        ]
                                    }, option);
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), {
                                        ...params,
                                        label: t("search.labels.sport"),
                                        placeholder: t("search.labels.sport")
                                    }),
                                onChange: (e, values)=>{
                                    handleInputChange("sport", values);
                                }
                            }),
                            (error === null || error === void 0 ? void 0 : error.field) === "sport" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gFr0F.default), {
                                children: error.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cf0a543cffa96588$export$56e6458301f6214c), {
                        error: error
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                id: "search-privacy",
                                children: t("privacy")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$e7e6b99c949fd18a), {
                                variant: "outlined",
                                value: searchObj.privacy,
                                labelId: "search-privacy",
                                name: "privacy",
                                label: t("privacy"),
                                onChange: ({ target: { name: name, value: value } })=>handleInputChange(name, value),
                                children: (0, $3XFgI.privacies).map((privacy)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                        value: privacy,
                                        children: t(`${privacy.toLowerCase()}`)
                                    }, `privacy-${privacy}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                id: "search-environment",
                                children: t("environment")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$e7e6b99c949fd18a), {
                                variant: "outlined",
                                value: searchObj.environment,
                                labelId: "search-environment",
                                name: "environment",
                                label: t("environment"),
                                onChange: ({ target: { name: name, value: value } })=>handleInputChange(name, value),
                                children: (0, $3XFgI.environments).map((environment)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                        value: environment,
                                        children: t(`${environment.toLowerCase()}`)
                                    }, `environment-${environment}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3jMGu.default), {
                        fullWidth: true,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$96952269499d1070), {
                            multiple: true,
                            id: "tags-outlined",
                            noOptionsText: t("search.labels.noInfrastructures"),
                            options: clubNames,
                            filterSelectedOptions: true,
                            value: searchObj.clubName,
                            getOptionLabel: (clubName)=>clubName,
                            renderInput: (params)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $f6ezL.default), {
                                    ...params,
                                    label: t("search.labels.selectInfrastructure"),
                                    placeholder: t("search.labels.selectInfrastructure")
                                }),
                            onChange: (e, values)=>{
                                handleInputChange("clubName", values);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $599cbc729f56127c$export$e3da0e99c81a4b99), {
                id: "edit-account",
                variant: "contained",
                onClick: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$deafc66e4bed6a0c), {
                        children: t("search.cta")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $599cbc729f56127c$export$1cf99fbf89ef919e), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8714e6639ca6acc6$exports)))
                    })
                ]
            })
        ]
    });
};


let $54604da660e5d94f$var$_ = (t)=>t, $54604da660e5d94f$var$t, $54604da660e5d94f$var$t1, $54604da660e5d94f$var$t2, $54604da660e5d94f$var$t3, $54604da660e5d94f$var$t4, $54604da660e5d94f$var$t5, $54604da660e5d94f$var$t6;
const $54604da660e5d94f$var$sharedPaddingProp = (0, $6hfZk.css)($54604da660e5d94f$var$t || ($54604da660e5d94f$var$t = $54604da660e5d94f$var$_`
    padding: 1rem 0;
`));
const $54604da660e5d94f$export$26164c1136e1deed = (0, $6hfZk.default)((0, $aili3.default))($54604da660e5d94f$var$t1 || ($54604da660e5d94f$var$t1 = $54604da660e5d94f$var$_`
    top: 0px;
    z-index: 401;
    overflow: auto;
    position: sticky;
    padding: 1rem;
    background: #fafafa;
    max-height: calc(100vh - 84px);
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -3px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px;

    @media (min-width: 1024px) {
        display: none;
    }
`));
const $54604da660e5d94f$export$d675f139b342d51a = (0, $6hfZk.default)((0, $aili3.default))($54604da660e5d94f$var$t2 || ($54604da660e5d94f$var$t2 = $54604da660e5d94f$var$_`
    gap: 2rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    ${0};
    padding-inline: 1rem;
    max-width: 600px;
    margin-inline: auto;

    @media (min-width: 1024px) {
        gap: 1rem;
        padding: 0;
        margin: unset;
        max-width: unset;
        height: calc(100vh - 84px);
    }
`), $54604da660e5d94f$var$sharedPaddingProp);
const $54604da660e5d94f$export$ba80066cb05476ac = (0, $6hfZk.default)((0, $28f3f8635466462c$export$9d8971762169e65a))($54604da660e5d94f$var$t3 || ($54604da660e5d94f$var$t3 = $54604da660e5d94f$var$_`
    display: none;

    @media (min-width: 1024px) {
        display: flex;
    }
`));
const $54604da660e5d94f$export$aee53da69e9839be = (0, $6hfZk.default)((0, $aili3.default))($54604da660e5d94f$var$t4 || ($54604da660e5d94f$var$t4 = $54604da660e5d94f$var$_`
    @media (min-width: 1024px) {
        flex: 1;
        display: flex;
        overflow: auto;
    }
`));
const $54604da660e5d94f$export$a5bd4b736b526129 = (0, $6hfZk.default)((0, $2434f90fabaaf39c$export$aa855a00633ee0da))($54604da660e5d94f$var$t5 || ($54604da660e5d94f$var$t5 = $54604da660e5d94f$var$_`
    @media (min-width: 1024px) {
        flex: 2;
        max-width: 500px;
        overflow-y: auto;
    }
`));
const $54604da660e5d94f$export$af0bc215d74560c6 = (0, $6hfZk.default)((0, $26afe7af649a5f3e$export$aa23630cf786ed99))($54604da660e5d94f$var$t6 || ($54604da660e5d94f$var$t6 = $54604da660e5d94f$var$_`
    flex: 3;
`));



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $goR7t = parcelRequire("goR7t");

var $k6mBf = parcelRequire("k6mBf");

var $aili3 = parcelRequire("aili3");
var $5ZeKC = parcelRequire("5ZeKC");
var $2hGJ2 = parcelRequire("2hGJ2");

var $6hfZk = parcelRequire("6hfZk");

let $ed3429d89bfd30af$var$_ = (t)=>t, $ed3429d89bfd30af$var$t, $ed3429d89bfd30af$var$t1, $ed3429d89bfd30af$var$t2, $ed3429d89bfd30af$var$t3, $ed3429d89bfd30af$var$t4, $ed3429d89bfd30af$var$t5;
const $ed3429d89bfd30af$export$2604b9d957848d1 = (0, $6hfZk.default)((0, $aili3.default))($ed3429d89bfd30af$var$t || ($ed3429d89bfd30af$var$t = $ed3429d89bfd30af$var$_`
    display: flex;
    align-items: center;
`));
const $ed3429d89bfd30af$export$4e5fef3bf0d55c67 = (0, $6hfZk.default)((0, $aili3.default))($ed3429d89bfd30af$var$t1 || ($ed3429d89bfd30af$var$t1 = $ed3429d89bfd30af$var$_`
    flex: 1;
    gap: 10px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
`));
const $ed3429d89bfd30af$export$ef50152da13f3005 = (0, $6hfZk.default)((0, $2hGJ2.default))($ed3429d89bfd30af$var$t2 || ($ed3429d89bfd30af$var$t2 = $ed3429d89bfd30af$var$_`
    color: #1976d2;
    text-transform: capitalize;

    .MuiChip-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .MuiChip-avatarColorPrimary {
        background: transparent !important;
    }

    &.Mui-disabled {
        opacity: 0.75 !important;
    }
`));
const $ed3429d89bfd30af$export$2d5d2ba3c7c8c40b = (0, $6hfZk.default)((0, $5ZeKC.default)).withConfig({
    shouldForwardProp: (prop)=>prop !== "selected"
})($ed3429d89bfd30af$var$t4 || ($ed3429d89bfd30af$var$t4 = $ed3429d89bfd30af$var$_`
    width: 40px;
    height: 40px;
    border: 1px solid #1976d2 !important;
    border-radius: 50% !important;
    padding: unset !important;
    min-width: unset !important;

    ${0}
`), ({ selected: selected })=>selected && (0, $6hfZk.css)($ed3429d89bfd30af$var$t3 || ($ed3429d89bfd30af$var$t3 = $ed3429d89bfd30af$var$_`
            background: #1976d2 !important;

            img {
                filter: brightness(5);
            }
        `)));
const $ed3429d89bfd30af$export$bdce958b5c11c505 = (0, $6hfZk.default)((0, $28f3f8635466462c$export$9d8971762169e65a))($ed3429d89bfd30af$var$t5 || ($ed3429d89bfd30af$var$t5 = $ed3429d89bfd30af$var$_`
    padding-top: 1rem;
`));



var $8m7Fi = parcelRequire("8m7Fi");
const $5e011eea801955a8$export$849185e0dcb47a7f = (key, value)=>{
    switch(key){
        case "sport":
            return value;
        case "district":
            return value;
        case "date":
            return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(value).format("DD-MM-YYYY");
        case "time":
        case "timeUnit":
            return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).unix(Number(value)).utc().format("HH:mm");
        case "privacy":
        case "environment":
            return value.toLowerCase();
        case "clubName":
            return value.join("; ");
        case "domain":
            return value;
        default:
            break;
    }
};


var $78abb34d306afc93$exports = {};

$78abb34d306afc93$exports = new URL((parcelRequire("4SSe9")).resolve("5ixwU"), import.meta.url).toString();



var $aili3 = parcelRequire("aili3");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");
const $d1325733d61d994f$export$92a576f896a9bf72 = ({ ...remainingProps })=>{
    const { searchObj: searchObj } = (0, $goR7t.default)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const finalObj = (0, $k6mBf.removeEmptyeKeys)({
        ...searchObj
    }, [
        "NOT_SPECIFIED"
    ]);
    const renderFilterChip = (key, index, label)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $ed3429d89bfd30af$export$ef50152da13f3005), {
            color: "default",
            label: label
        }, `filter-${label}`);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ed3429d89bfd30af$export$2604b9d957848d1), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ed3429d89bfd30af$export$4e5fef3bf0d55c67), {
                        ...remainingProps,
                        children: Object.keys(finalObj).map((key, index)=>{
                            if (key === "privacy") return renderFilterChip(key, index, t(`search.privacy.${finalObj.privacy.toLowerCase()}`));
                            if (key === "environment") return renderFilterChip(key, index, t(`search.environment.${finalObj.environment.toLowerCase()}`));
                            if (key === "sport") return finalObj.sport.map((s)=>renderFilterChip(key, index, t(`search.sports.${s.toLocaleLowerCase()}`)));
                            if (key === "domain") return null;
                            if (key !== "clubName") return renderFilterChip(key, index, (0, $5e011eea801955a8$export$849185e0dcb47a7f)(key, finalObj[key]));
                            if (finalObj.clubName.length) return finalObj.clubName.map((club)=>renderFilterChip(`filter-name-${index}`, index, club));
                            return null;
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ed3429d89bfd30af$export$2d5d2ba3c7c8c40b), {
                        selected: open,
                        onClick: ()=>setOpen((previous)=>!previous),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($78abb34d306afc93$exports))),
                            alt: ""
                        })
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ed3429d89bfd30af$export$bdce958b5c11c505), {
                onSearch: ()=>setOpen(false)
            }) : null
        ]
    });
};


const $c9325638d2c8ec10$var$Search = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $f39b3abf0ccb3e1f$export$1dd6b49c38c99076), {
        headerType: "menu",
        maxWidth: false,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $54604da660e5d94f$export$26164c1136e1deed), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d1325733d61d994f$export$92a576f896a9bf72), {})
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $54604da660e5d94f$export$d675f139b342d51a), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $54604da660e5d94f$export$ba80066cb05476ac), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $54604da660e5d94f$export$aee53da69e9839be), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $54604da660e5d94f$export$a5bd4b736b526129), {}),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $54604da660e5d94f$export$af0bc215d74560c6), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $c9325638d2c8ec10$export$2e2bcd8739ae039 = $c9325638d2c8ec10$var$Search;



var $goR7t = parcelRequire("goR7t");

var $86kTa = parcelRequire("86kTa");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");
var $dNYY5 = parcelRequire("dNYY5");

var $pF6j5 = parcelRequire("pF6j5");
var $aXrmT = parcelRequire("aXrmT");
var $3loMv = parcelRequire("3loMv");

parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dkKmP = parcelRequire("dkKmP");



var $dNDci = parcelRequire("dNDci");

var $6hfZk = parcelRequire("6hfZk");

var $aili3 = parcelRequire("aili3");
var $aXrmT = parcelRequire("aXrmT");

var $dkKmP = parcelRequire("dkKmP");
let $8612c42ab9b10e96$var$_ = (t)=>t, $8612c42ab9b10e96$var$t, $8612c42ab9b10e96$var$t1, $8612c42ab9b10e96$var$t2, $8612c42ab9b10e96$var$t3, $8612c42ab9b10e96$var$t4, $8612c42ab9b10e96$var$t5, $8612c42ab9b10e96$var$t6, $8612c42ab9b10e96$var$t7, $8612c42ab9b10e96$var$t8;
const $8612c42ab9b10e96$export$fc5cde352ee7854 = (0, $6hfZk.default)((0, $aXrmT.default))($8612c42ab9b10e96$var$t || ($8612c42ab9b10e96$var$t = $8612c42ab9b10e96$var$_`
    display: flex;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`));
const $8612c42ab9b10e96$export$c0724d7adbcbed78 = (0, $6hfZk.default)((0, $aXrmT.default))($8612c42ab9b10e96$var$t1 || ($8612c42ab9b10e96$var$t1 = $8612c42ab9b10e96$var$_`
    display: flex;
`));
const $8612c42ab9b10e96$export$e686db73613e62f7 = (0, $6hfZk.default)((0, $aXrmT.default))($8612c42ab9b10e96$var$t2 || ($8612c42ab9b10e96$var$t2 = $8612c42ab9b10e96$var$_`
    display: grid;
    gap: 1rem;
    background-color: #fff;
    padding: 1rem;
    border-radius: 4px 0 0 4px;
`));
const $8612c42ab9b10e96$export$c594d11ca3b095b9 = (0, $6hfZk.default)((0, $aXrmT.default))($8612c42ab9b10e96$var$t3 || ($8612c42ab9b10e96$var$t3 = $8612c42ab9b10e96$var$_`
    background-color: #f2f2f2;
    padding: 1rem;
    border-radius: 0 4px 4px 0;
    text-align: left;
`));
const $8612c42ab9b10e96$export$47eb42ff093406d4 = (0, $6hfZk.default)((0, $aili3.default))($8612c42ab9b10e96$var$t4 || ($8612c42ab9b10e96$var$t4 = $8612c42ab9b10e96$var$_`
    display: flex;
    gap: 1rem;
    border-bottom: 1px solid rgba(47, 51, 51, 0.4);
    justify-content: space-between;
    padding: 0.75rem 0;
`));
const $8612c42ab9b10e96$export$1f906d15c2a36e9d = (0, $6hfZk.default).p($8612c42ab9b10e96$var$t5 || ($8612c42ab9b10e96$var$t5 = $8612c42ab9b10e96$var$_`
    color: var(--black-06);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0;
`));
const $8612c42ab9b10e96$export$3e431a229df88919 = (0, $6hfZk.default).img($8612c42ab9b10e96$var$t6 || ($8612c42ab9b10e96$var$t6 = $8612c42ab9b10e96$var$_`
    margin: 8% auto;
    height: auto;
    max-width: 246px;
`));
const $8612c42ab9b10e96$export$e3da0e99c81a4b99 = (0, $6hfZk.default)((0, $dkKmP.AppButton))($8612c42ab9b10e96$var$t7 || ($8612c42ab9b10e96$var$t7 = $8612c42ab9b10e96$var$_`
    width: 100%;
`));
const $8612c42ab9b10e96$export$f99233281efd08a0 = (0, $6hfZk.default).h1($8612c42ab9b10e96$var$t8 || ($8612c42ab9b10e96$var$t8 = $8612c42ab9b10e96$var$_`
    color: var(--black-087);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
`));



var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $7qlUi = parcelRequire("7qlUi");

var $3Ou5w = parcelRequire("3Ou5w");

var $9uOZr = parcelRequire("9uOZr");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $8b58a96ac4f8c0a9$var$CheckoutBooking = ()=>{
    var _areaInfo_club;
    const clientId = "3e8e4fv584qslg0on1k69i2d5r";
    const redirectUrL = "https://freecourts.pt/external-provider";
    const cognitoDomain = "https://conexa-player-pool-production.auth.eu-west-1.amazoncognito.com";
    const googleProvider = `${cognitoDomain}/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrL}&state=STATE&scope=aws.cognito.signin.user.admin&identity_provider=Google`;
    const navigate = (0, $iIluI.useNavigate)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const [searchParams] = (0, $dNYY5.useSearchParams)();
    const location = (0, $iIluI.useLocation)();
    const return_url = searchParams.get("return_url");
    const appService = new (0, $dNDci.AppService)();
    const booking = location.state;
    const [areaInfo, setAreaInfo] = (0, $7fPBF.useState)();
    const handleGoogleLogin = ()=>{
        if (return_url) sessionStorage.setItem("google.returnURL", return_url);
    };
    (0, $7fPBF.useEffect)(()=>{
        appService.api_getAreaById(booking.areaId).then((res)=>{
            setAreaInfo(res.data);
        });
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        maxWidth: "md",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aXrmT.default), {
            container: true,
            marginBottom: 4,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8612c42ab9b10e96$export$c0724d7adbcbed78), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8612c42ab9b10e96$export$3e431a229df88919), {
                        src: "/logo_aveiro_tech_city.png",
                        alt: "FreeCourts: Courts for everyone"
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$fc5cde352ee7854), {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$e686db73613e62f7), {
                            item: true,
                            xs: 12,
                            md: 7,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8612c42ab9b10e96$export$f99233281efd08a0), {
                                    children: t("checkout.message")
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {}),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7qlUi.FeatureToggleBaseComponent), {
                                    featureToggle: (0, $3Ou5w.FeatureToggles).GOOGLE_SSO,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.Link), {
                                            to: googleProvider,
                                            onClick: handleGoogleLogin,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                                variant: "outlined",
                                                color: "primary",
                                                startIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6a40c1aa52d185d$exports))), {}),
                                                children: t("login.loginWithGoogle")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {
                                            children: t("or")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d968782d7a2b7181$export$1f58f750f20f344b), {
                                    userType: "player",
                                    redirect: return_url ? return_url : "/"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                                    variant: "outlined",
                                    color: "primary",
                                    onClick: ()=>navigate((0, $711f8784a526fd26$export$6a5c05795461ca18)("/signup", return_url)),
                                    children: t("login.register")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$c594d11ca3b095b9), {
                            item: true,
                            xs: 12,
                            md: 5,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$f99233281efd08a0), {
                                    children: [
                                        t("bookingDetails"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$47eb42ff093406d4), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                            variant: "body2",
                                            children: [
                                                t("area"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$1f906d15c2a36e9d), {
                                            children: [
                                                areaInfo === null || areaInfo === void 0 ? void 0 : areaInfo.name,
                                                " - ",
                                                areaInfo === null || areaInfo === void 0 ? void 0 : (_areaInfo_club = areaInfo.club) === null || _areaInfo_club === void 0 ? void 0 : _areaInfo_club.address.address
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$47eb42ff093406d4), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                            variant: "body2",
                                            children: [
                                                t("sport"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8612c42ab9b10e96$export$1f906d15c2a36e9d), {
                                            children: booking === null || booking === void 0 ? void 0 : booking.category
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$47eb42ff093406d4), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                            variant: "body2",
                                            children: [
                                                t("day"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8612c42ab9b10e96$export$1f906d15c2a36e9d), {
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(booking === null || booking === void 0 ? void 0 : booking.day).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$47eb42ff093406d4), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                            variant: "body2",
                                            children: [
                                                t("schedule"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$1f906d15c2a36e9d), {
                                            children: [
                                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(booking === null || booking === void 0 ? void 0 : booking.from).format("HH:mm"),
                                                " - ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).utc(booking === null || booking === void 0 ? void 0 : booking.to).format("HH:mm")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$47eb42ff093406d4), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                            variant: "body2",
                                            children: t("price")
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8612c42ab9b10e96$export$1f906d15c2a36e9d), {
                                            children: [
                                                booking === null || booking === void 0 ? void 0 : booking.price,
                                                "€"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $8b58a96ac4f8c0a9$export$2e2bcd8739ae039 = $8b58a96ac4f8c0a9$var$CheckoutBooking;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $iIluI = parcelRequire("iIluI");

var $gC25j = parcelRequire("gC25j");
var $aili3 = parcelRequire("aili3");
var $6F4ic = parcelRequire("6F4ic");
var $2hGJ2 = parcelRequire("2hGJ2");
var $8TDId = parcelRequire("8TDId");
var $lHSFU = parcelRequire("lHSFU");
var $dxMGW = parcelRequire("dxMGW");
var $58CWL = parcelRequire("58CWL");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");


var $dNDci = parcelRequire("dNDci");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $2hGJ2 = parcelRequire("2hGJ2");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $aili3 = parcelRequire("aili3");
var $5ZeKC = parcelRequire("5ZeKC");

var $kDBhE = parcelRequire("kDBhE");
let $1bd415aa4a99509d$var$_ = (t)=>t, $1bd415aa4a99509d$var$t, $1bd415aa4a99509d$var$t1;
const $1bd415aa4a99509d$export$67f7b5e0f9df4245 = (0, $kDBhE.default)((0, $aili3.default))($1bd415aa4a99509d$var$t || ($1bd415aa4a99509d$var$t = $1bd415aa4a99509d$var$_`
    cursor: pointer;
    border-radius: 8px;
    padding: 16px;
`));
const $1bd415aa4a99509d$export$3a30621a8b0c1490 = (0, $kDBhE.default)((0, $5ZeKC.default))($1bd415aa4a99509d$var$t1 || ($1bd415aa4a99509d$var$t1 = $1bd415aa4a99509d$var$_`
    text-align: left;
    justify-content: left;
    padding: 0;
    margin-top: 10px;
    text-transform: none;

    &:hover {
        text-decoration: underline;
        background: none;
    }
`));



(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $38eff236d850dc82$var$HistoryDataCard = ({ history: history, onClick: onClick })=>{
    var _history_CreatedBy, _history_PayedBy, _history_paymentMethod, _history_CanceledBy;
    const { t: t } = (0, $doyfp.useTranslation)();
    const handleCardClick = (e)=>{
        e.stopPropagation();
        if (onClick) onClick();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1bd415aa4a99509d$export$67f7b5e0f9df4245), {
        width: "100%",
        bgcolor: "#ffffff",
        p: 1,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
            onClick: handleCardClick,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                            variant: "h6",
                            children: [
                                "#",
                                history.shareId
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a1a4fc57da56c62$export$76b259acec9cae97), {
                            category: history.category
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    variant: "overline",
                    children: history === null || history === void 0 ? void 0 : history.name
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                    direction: "row",
                    alignItems: "center",
                    flexWrap: "wrap",
                    useFlexGap: true,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                            variant: "caption",
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(history.day).format("DD-MM-YYYY")
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                            color: "tealLighten5",
                            size: "small",
                            label: `${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(history === null || history === void 0 ? void 0 : history.from).utc().format("HH:mm")} - ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(history === null || history === void 0 ? void 0 : history.to).utc().format("HH:mm")}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                    variant: "caption",
                    children: [
                        t("clubAdmin.historyData.createdBy"),
                        " ",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                            children: (_history_CreatedBy = history.CreatedBy) === null || _history_CreatedBy === void 0 ? void 0 : _history_CreatedBy.name
                        }),
                        " ",
                        t("clubAdmin.historyData.at"),
                        " ",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(history.createdAt).utc().format("DD/MM/YYYY HH:mm")
                        })
                    ]
                }),
                history.isPayed && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                        variant: "caption",
                        children: [
                            t("clubAdmin.historyData.paidBy"),
                            " ",
                            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                children: (_history_PayedBy = history.PayedBy) === null || _history_PayedBy === void 0 ? void 0 : _history_PayedBy.name
                            }),
                            " por",
                            " ",
                            (_history_paymentMethod = history.paymentMethod) === null || _history_paymentMethod === void 0 ? void 0 : _history_paymentMethod.name,
                            " ",
                            t("clubAdmin.historyData.at"),
                            " ",
                            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(history.payedAt).utc().format("DD/MM/YYYY HH:mm")
                            })
                        ]
                    })
                }),
                history.canceled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                        variant: "caption",
                        children: [
                            t("clubAdmin.historyData.canceledBy"),
                            " ",
                            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                children: (_history_CanceledBy = history.CanceledBy) === null || _history_CanceledBy === void 0 ? void 0 : _history_CanceledBy.name
                            }),
                            " ",
                            t("clubAdmin.historyData.at"),
                            " ",
                            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(history.canceledAt).utc().format("DD/MM/YYYY HH:mm")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $38eff236d850dc82$export$2e2bcd8739ae039 = $38eff236d850dc82$var$HistoryDataCard;


parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $aili3 = parcelRequire("aili3");
var $aUdfW = parcelRequire("aUdfW");
var $pF6j5 = parcelRequire("pF6j5");
var $3loMv = parcelRequire("3loMv");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $afCHG = parcelRequire("afCHG");

var $dkKmP = parcelRequire("dkKmP");

var $bzrhL = parcelRequire("bzrhL");

var $aili3 = parcelRequire("aili3");
var $3loMv = parcelRequire("3loMv");

var $6hfZk = parcelRequire("6hfZk");
let $5ec549326cf21959$var$_ = (t)=>t, $5ec549326cf21959$var$t, $5ec549326cf21959$var$t1, $5ec549326cf21959$var$t2;
const $5ec549326cf21959$export$16f7638e4a34b909 = (0, $6hfZk.default)((0, $3loMv.default))($5ec549326cf21959$var$t || ($5ec549326cf21959$var$t = $5ec549326cf21959$var$_`
    font-size: 20px !important;
    font-weight: 500 !important;
    letter-spacing: 0.25px !important;
    line-height: 32px !important;
`));
const $5ec549326cf21959$export$9f206abb5ed94520 = (0, $6hfZk.default)((0, $e9f205f7f0ba8e26$export$2e2bcd8739ae039))($5ec549326cf21959$var$t1 || ($5ec549326cf21959$var$t1 = $5ec549326cf21959$var$_`
    background-color: #fafafa !important;
    box-shadow: none !important;

    &::before {
        background-color: #fff !important;
    }
`));
const $5ec549326cf21959$export$35583f225b728fea = (0, $6hfZk.default)((0, $aili3.default))($5ec549326cf21959$var$t2 || ($5ec549326cf21959$var$t2 = $5ec549326cf21959$var$_`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`));


(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $9dd1f02d159fedfd$export$3cd359713473b2db = ({ open: open, historyData: historyData, onClose: onClose })=>{
    var _historyData_area, _historyData_CreatedBy;
    const { t: t } = (0, $doyfp.useTranslation)();
    const submitting = (0, $7fPBF.useRef)(false);
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const handleChange = (panel)=>(event, isExpanded)=>{
            setExpanded(isExpanded ? panel : false);
        };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aUdfW.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5ec549326cf21959$export$35583f225b728fea), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ec549326cf21959$export$16f7638e4a34b909), {
                    children: `${t("clubAdmin.bookings.modal.title")} ${historyData.shareId}`
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "area",
                    type: "text",
                    disabled: true,
                    label: (_historyData_area = historyData.area) === null || _historyData_area === void 0 ? void 0 : _historyData_area.name
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "category",
                    type: "text",
                    disabled: true,
                    label: historyData === null || historyData === void 0 ? void 0 : historyData.category
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "name",
                    type: "text",
                    disabled: true,
                    hasLabelTop: true,
                    value: historyData.name,
                    labelTop: t("clubAdmin.bookings.modal.clientName")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "email",
                    type: "text",
                    disabled: true,
                    value: historyData.email,
                    hasLabelTop: true,
                    labelTop: t("clubAdmin.bookings.modal.clientEmail")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "mobilePhone",
                    type: "text",
                    disabled: true,
                    value: historyData.mobilePhone,
                    hasLabelTop: true,
                    labelTop: t("clubAdmin.bookings.modal.mobilePhone")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "day",
                    type: "text",
                    disabled: true,
                    hasLabelTop: true,
                    labelTop: t("clubAdmin.bookings.modal.day"),
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(historyData.day).format("DD-MM-YYYY")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                    name: "day",
                    type: "text",
                    disabled: true,
                    hasLabelTop: true,
                    labelTop: t("clubAdmin.bookings.modal.time"),
                    value: `${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(historyData.from).utc().format("HH:mm")} - ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(historyData.to).utc().format("HH:mm")}`
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $pF6j5.default), {
                    light: true
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5ec549326cf21959$export$9f206abb5ed94520), {
                    expanded: expanded === "panel1",
                    onChange: handleChange("panel1"),
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4dadc25f7bb7b60a$export$2e2bcd8739ae039), {
                            expandIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzrhL))), {}),
                            "aria-controls": "panel1bh-content",
                            id: "panel1bh-header",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                children: t("clubAdmin.historyData.accordionTitle")
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a33ac73601ffa184$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                        variant: "caption",
                                        children: [
                                            t("clubAdmin.historyData.createdBy"),
                                            " ",
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                children: (_historyData_CreatedBy = historyData.CreatedBy) === null || _historyData_CreatedBy === void 0 ? void 0 : _historyData_CreatedBy.name
                                            }),
                                            " ",
                                            t("clubAdmin.historyData.at"),
                                            " ",
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(historyData.createdAt).utc().format("DD/MM/YYYY HH:mm")
                                            })
                                        ]
                                    }),
                                    historyData.isPayed && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                            variant: "caption",
                                            children: [
                                                t("clubAdmin.historyData.paidBy"),
                                                " ",
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                    children: historyData === null || historyData === void 0 ? void 0 : historyData.name
                                                }),
                                                " por MBWay",
                                                " ",
                                                t("clubAdmin.historyData.at"),
                                                " ",
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(historyData.payedAt).utc().format("DD/MM/YYYY HH:mm")
                                                })
                                            ]
                                        })
                                    }),
                                    historyData.canceled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3loMv.default), {
                                            variant: "caption",
                                            children: [
                                                t("clubAdmin.historyData.canceledBy"),
                                                " ",
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                    children: historyData === null || historyData === void 0 ? void 0 : historyData.CanceledBy.name
                                                }),
                                                " ",
                                                t("clubAdmin.historyData.at"),
                                                " ",
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(historyData.canceledAt).utc().format("DD/MM/YYYY HH:mm")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                        variant: "outlined",
                        disabled: submitting.current,
                        onClick: onClose,
                        children: t("back")
                    })
                })
            ]
        })
    });
};



var $ga3mZ = parcelRequire("ga3mZ");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
const $0ace06152e53c77c$export$2b674232367c8d0e = ({ historyData: historyData, clubId: clubId })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const [bookingModalOpen, setHistoryDataModalOpen] = (0, $7fPBF.useState)(false);
    const [selectedHistoryData, setSelectedHistoryData] = (0, $7fPBF.useState)(null);
    const handleHistoryDataClick = (booking)=>{
        setSelectedHistoryData(booking);
        setHistoryDataModalOpen(true);
    };
    if (historyData.length === 0) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledAlert), {
        variant: "filled",
        severity: "info",
        children: t("clubAdmin.historyData.noHistory")
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledContainer), {
                children: historyData.sort((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(a.from).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(b.from)) ? 1 : -1).map((history)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $38eff236d850dc82$export$2e2bcd8739ae039), {
                        history: history,
                        onClick: ()=>handleHistoryDataClick(history)
                    }, history.id))
            }),
            selectedHistoryData && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9dd1f02d159fedfd$export$3cd359713473b2db), {
                historyData: selectedHistoryData,
                open: bookingModalOpen,
                onClose: ()=>setHistoryDataModalOpen(false)
            })
        ]
    });
};



var $ga3mZ = parcelRequire("ga3mZ");

var $1ZNeQ = parcelRequire("1ZNeQ");

var $930Hd = parcelRequire("930Hd");

var $5Ju9q = parcelRequire("5Ju9q");

var $afCHG = parcelRequire("afCHG");

var $1aJMc = parcelRequire("1aJMc");

var $7xRAC = parcelRequire("7xRAC");
const $da9b3871e09f0dd3$export$d6a7258616d43076 = (t)=>{
    return $7xRAC.object({
        selectedArea: $7xRAC.string(),
        selectedSports: $7xRAC.array().of($7xRAC.string()),
        startDate: $7xRAC.date().nullable(),
        endDate: $7xRAC.date().nullable().min($7xRAC.ref("startDate"), t("validation.minEndDate")),
        search: $7xRAC.string()
    });
};



var $9uOZr = parcelRequire("9uOZr");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
var $c4dbc16c51af293d$var$_localStorage_getItem;
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).locale(($c4dbc16c51af293d$var$_localStorage_getItem = localStorage.getItem("i18netLng")) !== null && $c4dbc16c51af293d$var$_localStorage_getItem !== void 0 ? $c4dbc16c51af293d$var$_localStorage_getItem : "pt");
const $c4dbc16c51af293d$var$HistoryData = ()=>{
    const { clubId: clubId } = (0, $iIluI.useParams)();
    const { t: t } = (0, $doyfp.useTranslation)();
    const appService = new (0, $dNDci.AppService)();
    const [areas, setAreas] = (0, $7fPBF.useState)([]);
    const [sports, setSports] = (0, $7fPBF.useState)([]);
    const [bookings, setBookings] = (0, $7fPBF.useState)([]);
    //const [users, setUsers] = useState<string[]>([]);
    const [isListView, setIsListView] = (0, $7fPBF.useState)(false);
    const [isFilterOpen, setIsFilterOpen] = (0, $7fPBF.useState)(false);
    const initialValues = {
        selectedArea: "",
        selectedSports: [],
        startDate: null,
        endDate: null,
        users: [],
        search: ""
    };
    const handleChangeCloseDate = (date)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    };
    (0, $7fPBF.useEffect)(()=>{
        appService.api_getClub("private", {
            clubId: clubId
        }).then((res)=>{
            if (res.status !== 200) throw new Error();
            var _res_data_categories;
            setSports((_res_data_categories = res.data.categories) !== null && _res_data_categories !== void 0 ? _res_data_categories : []);
            setAreas(res.data.areas);
        }).catch((error)=>console.log(error));
    }, [
        clubId
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        maxWidth: false,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
            alignItems: "center",
            p: 2,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                    variant: "h5",
                    children: t("clubAdmin.menu.historyData")
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.Formik), {
                    initialValues: initialValues,
                    validationSchema: (0, $da9b3871e09f0dd3$export$d6a7258616d43076)(t),
                    enableReinitialize: true,
                    onSubmit: async (values)=>{
                        await appService.api_getReservationHistory("private", clubId, {
                            startDate: values.startDate,
                            endDate: values.endDate,
                            areaId: values.selectedArea !== "all" ? values.selectedArea : "",
                            sports: values.selectedSports,
                            search: values.search
                        }).then((res)=>{
                            if (res.status !== 200) throw new Error();
                            setIsListView(true);
                            setBookings(res.data);
                        }).catch((error)=>{
                            console.log(error);
                            setBookings([]);
                        });
                    },
                    children: (props)=>{
                        var _props_values_selectedSports;
                        /*#__PURE__*/ return (0, $bbzbN.jsxs)((0, $1ZNeQ.Form), {
                            onSubmit: props.handleSubmit,
                            style: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ga3mZ.MobileFilter), {
                                    children: [
                                        props.values.selectedArea !== "" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                            label: props.values.selectedArea === "all" ? t("clubAdmin.bookings.allAreas") : (0, $1aJMc.findAreaNameById)(props.values.selectedArea, areas)
                                        }),
                                        ((_props_values_selectedSports = props.values.selectedSports) === null || _props_values_selectedSports === void 0 ? void 0 : _props_values_selectedSports.length) > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                            label: `${t("club.headers.sports")}: ${props.values.selectedSports.join(", ")}`
                                        }),
                                        props.values.startDate !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                            label: `${t("from")}: ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(props.values.startDate).format("DD-MM-YYYY")}`
                                        }),
                                        props.values.endDate !== null && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                            label: `${t("to")}: ${(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(props.values.endDate).format("DD-MM-YYYY")}`
                                        }),
                                        props.values.search !== "" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                                            label: `${t("query")}: ${props.values.search}`
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                                            "aria-label": "filter toggle",
                                            onClick: ()=>setIsFilterOpen((prev)=>!prev),
                                            sx: {
                                                marginLeft: "auto"
                                            },
                                            children: isFilterOpen ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $433fb023fc001063$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e92d05408ee3d3db$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.DesktopFilter), {
                                    isFilterOpen: isFilterOpen,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ga3mZ.SelectGrid), {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ga3mZ.StyledSelectControl), {
                                                        variant: "outlined",
                                                        error: props.touched.selectedArea && Boolean(props.errors.selectedArea),
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                                                id: "sports",
                                                                children: t("clubAdmin.bookings.selectArea")
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $930Hd.Select), {
                                                                name: "selectedArea",
                                                                labelId: "selectedArea",
                                                                value: props.values.selectedArea,
                                                                onChange: props.handleChange,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                                        value: "all",
                                                                        children: t("clubAdmin.bookings.allAreas")
                                                                    }),
                                                                    areas.map((area)=>{
                                                                        /*#__PURE__*/ return (0, $bbzbN.jsx)((0, $58CWL.default), {
                                                                            value: area.id,
                                                                            children: area === null || area === void 0 ? void 0 : area.name
                                                                        }, area.id);
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                        name: "selectedArea",
                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledError), {
                                                                children: msg
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ga3mZ.StyledSelectControl), {
                                                        variant: "outlined",
                                                        error: props.touched.selectedSports && Boolean(props.errors.selectedSports),
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                                                id: "sports",
                                                                children: t("clubAdmin.bookings.selectCategory")
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $930Hd.Select), {
                                                                name: "selectedSports",
                                                                labelId: "selectedSports",
                                                                value: props.values.selectedSports,
                                                                multiple: true,
                                                                onChange: props.handleChange,
                                                                renderValue: (selected)=>selected.join(", "),
                                                                children: sports.map((sport)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                                                        value: sport,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6F4ic.default), {
                                                                                checked: props.values.selectedSports.indexOf(sport) > -1
                                                                            }),
                                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                                                                primary: sport
                                                                            })
                                                                        ]
                                                                    }, sport))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                        name: "sports",
                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledError), {
                                                                children: msg
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ga3mZ.StyledSelectControl), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Ju9q.default), {
                                                        name: "startDate",
                                                        error: Boolean(props.errors.startDate),
                                                        label: t("clubAdmin.historyData.selectStartDate"),
                                                        disablePast: false,
                                                        disableFuture: true,
                                                        onChange: (newValue)=>props.setFieldValue("startDate", handleChangeCloseDate(newValue), true)
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                        name: "startDate",
                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledError), {
                                                                children: msg
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $ga3mZ.StyledSelectControl), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Ju9q.default), {
                                                        name: "endDate",
                                                        error: Boolean(props.touched.endDate && props.errors.endDate),
                                                        label: props.errors.endDate ? "" : t("clubAdmin.historyData.selectEndDate"),
                                                        disablePast: false,
                                                        disableFuture: true,
                                                        onChange: (newValue)=>props.setFieldValue("endDate", handleChangeCloseDate(newValue), true)
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                        name: "endDate",
                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledError), {
                                                                children: msg
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aili3.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afCHG.Input), {
                                                        name: "search",
                                                        placeholder: t("clubAdmin.bookings.inputLabel.search"),
                                                        label: t("clubAdmin.bookings.inputLabel.search"),
                                                        type: "text",
                                                        value: props.values.search,
                                                        onChange: props.handleChange,
                                                        error: props.touched.search && Boolean(props.errors.search)
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1ZNeQ.ErrorMessage), {
                                                        name: "search",
                                                        children: (msg)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.StyledError), {
                                                                children: msg
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ga3mZ.FilterButton), {
                                                isFilterOpen: isFilterOpen,
                                                variant: "contained",
                                                type: "submit",
                                                children: t("filter")
                                            })
                                        ]
                                    })
                                })
                            ]
                        });
                    }
                }),
                isListView ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0ace06152e53c77c$export$2b674232367c8d0e), {
                    historyData: bookings,
                    clubId: clubId
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                    variant: "filled",
                    severity: "info",
                    sx: {
                        width: "100%"
                    },
                    children: t("clubAdmin.historyData.selectFilterToShowResults")
                })
            ]
        })
    });
};
var $c4dbc16c51af293d$export$2e2bcd8739ae039 = $c4dbc16c51af293d$var$HistoryData;



var $bbzbN = parcelRequire("bbzbN");

var $iIluI = parcelRequire("iIluI");parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $1N52b = parcelRequire("1N52b");

var $7fPBF = parcelRequire("7fPBF");
const $9c92c843c4c5b035$export$f01b3d7c7bbe3997 = ({ allowedRoles: allowedRoles, redirect: redirect })=>{
    const { isAuthenticated: isAuthenticated, role: role } = (0, $1N52b.useAuth)();
    const navigate = (0, $iIluI.useNavigate)();
    const isAuthorized = allowedRoles.includes(role);
    (0, $7fPBF.useEffect)(()=>{
        if (!isAuthenticated || !isAuthorized) navigate(redirect);
    });
    return isAuthenticated && isAuthorized ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Outlet), {}) : null;
};
var $9c92c843c4c5b035$export$2e2bcd8739ae039 = $9c92c843c4c5b035$export$f01b3d7c7bbe3997;



var $gSx8R = parcelRequire("gSx8R");

var $7qlUi = parcelRequire("7qlUi");

var $3Ou5w = parcelRequire("3Ou5w");

var $i1fqN = parcelRequire("i1fqN");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gC25j = parcelRequire("gC25j");
var $6F4ic = parcelRequire("6F4ic");
var $3jMGu = parcelRequire("3jMGu");
var $lHSFU = parcelRequire("lHSFU");
var $dxMGW = parcelRequire("dxMGW");
var $58CWL = parcelRequire("58CWL");
var $hG0Cb = parcelRequire("hG0Cb");

var $dkKmP = parcelRequire("dkKmP");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $aili3 = parcelRequire("aili3");
var $5ZeKC = parcelRequire("5ZeKC");
var $2hGJ2 = parcelRequire("2hGJ2");
var $8TDId = parcelRequire("8TDId");
var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $bGIah = parcelRequire("bGIah");
var $iopmn = parcelRequire("iopmn");
var $e8c7892484a4b6ad$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($e8c7892484a4b6ad$exports, "__esModule", {
    value: true
});
$e8c7892484a4b6ad$exports.default = void 0;

var $e8c7892484a4b6ad$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $e8c7892484a4b6ad$var$_default = (0, $e8c7892484a4b6ad$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
        d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
    }, "0"),
    /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
        d: "M11 7h2v6h-2zm0 8h2v2h-2z"
    }, "1")
], "ReportGmailerrorred");
$e8c7892484a4b6ad$exports.default = $e8c7892484a4b6ad$var$_default;



var $6hfZk = parcelRequire("6hfZk");
let $4c1cca53b2cb55af$var$_ = (t)=>t, $4c1cca53b2cb55af$var$t;
const $4c1cca53b2cb55af$export$f92c1e90941113c = (0, $6hfZk.default).div($4c1cca53b2cb55af$var$t || ($4c1cca53b2cb55af$var$t = $4c1cca53b2cb55af$var$_`
    position: relative;
    padding: 16px;
    background-color: #fff;
`));



var $l5i9v = parcelRequire("l5i9v");

var $8m7Fi = parcelRequire("8m7Fi");

var $5Bnf5 = parcelRequire("5Bnf5");

var $97Jiy = parcelRequire("97Jiy");
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5Bnf5))));
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).extend((0, (/*@__PURE__*/$parcel$interopDefault($97Jiy))));
const $3f8998d21b785118$var$AreaCard = ({ area: area, onStop: onStop, onDetails: onDetails, onEdit: onEdit, onDelete: onDelete })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const closedMessage = (0, $7fPBF.useMemo)(()=>{
        var _area_AreaClosedSchedule;
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))();
        let msg = null;
        if (!Array.isArray(area.AreaClosedSchedule)) return msg;
        (_area_AreaClosedSchedule = area.AreaClosedSchedule) === null || _area_AreaClosedSchedule === void 0 ? void 0 : _area_AreaClosedSchedule.forEach((schedule)=>{
            const from = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(schedule.from);
            const to = (0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi)))(schedule.to);
            if (now.isBetween(from, to, "minute", "()")) {
                msg = `${from.utc().format("DD/MM/YYYY HH:mm")} - ${to.utc().format("DD/MM/YYYY HH:mm")}`;
                return;
            }
        });
        return msg;
    }, [
        area
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4c1cca53b2cb55af$export$f92c1e90941113c), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aili3.default), {
                                flex: 2,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                    src: area.AreaPhoto && area.AreaPhoto.length > 0 ? area.AreaPhoto[0].photoUrl : (0, (/*@__PURE__*/$parcel$interopDefault($l5i9v))),
                                    style: {
                                        width: "100%",
                                        height: "160px",
                                        objectFit: "cover",
                                        objectPosition: "center"
                                    },
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                flex: 3,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                                        direction: "row",
                                        spacing: 1,
                                        justifyContent: "end",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                                                "aria-label": "delete",
                                                size: "small",
                                                color: "primary",
                                                onClick: onDelete,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bGIah.default), {})
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8TDId.default), {
                                                "aria-label": "edit",
                                                size: "small",
                                                color: "primary",
                                                onClick: onEdit,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iopmn.default), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                        variant: "body1",
                                        children: area.name
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                                        variant: "caption",
                                        children: area.description
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                fullWidth: true,
                                variant: "outlined",
                                size: "small",
                                onClick: onStop,
                                children: t("stop")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5ZeKC.default), {
                                fullWidth: true,
                                variant: "contained",
                                size: "small",
                                onClick: onDetails,
                                children: t("details")
                            })
                        ]
                    })
                ]
            }),
            closedMessage && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ea99f2520fe8509d$export$2e2bcd8739ae039), {
                title: t("areaIsClosed").replace("{{schedule}}", closedMessage),
                arrow: true,
                sx: {
                    position: "absolute",
                    top: "8px",
                    left: "8px"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2hGJ2.default), {
                    color: "primary",
                    size: "small",
                    icon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8c7892484a4b6ad$exports))), {}),
                    label: t("stopped")
                })
            })
        ]
    });
};
var $3f8998d21b785118$export$2e2bcd8739ae039 = $3f8998d21b785118$var$AreaCard;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $hG0Cb = parcelRequire("hG0Cb");
var $3loMv = parcelRequire("3loMv");

var $dkKmP = parcelRequire("dkKmP");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $dNDci = parcelRequire("dNDci");

var $fnVR5 = parcelRequire("fnVR5");
const $3cbf372fca50d095$export$a319b1cf85624fba = ({ area: area, onDelete: onDelete })=>{
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setModal: setModal, setSnackbar: setSnackbar } = (0, $fnVR5.useCommon)();
    const handleCloseModal = ()=>{
        setModal({
            open: false,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
        });
    };
    const handleDeleteClub = ()=>{
        new (0, $dNDci.AppService)().api_deleteArea(area.id).then((res)=>{
            if (res.status !== 200) throw new Error(res);
            if (typeof onDelete === "function") onDelete();
            setModal({
                open: false,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
            });
        }).catch((error)=>{
            console.log(error);
            const alert = {
                severity: "error",
                children: t("generalError")
            };
            setSnackbar({
                open: true,
                ...alert,
                setOpen: ()=>setSnackbar({
                        open: false,
                        ...alert,
                        setOpen: ()=>{}
                    })
            });
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
        spacing: 1,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3loMv.default), {
                variant: "body1",
                px: 1,
                children: t("areaDeleteDescription")
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                id: "delete-club",
                variant: "contained",
                color: "error",
                onClick: handleDeleteClub,
                children: t("delete")
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                id: "cancel",
                variant: "outlined",
                type: "reset",
                onClick: handleCloseModal,
                children: t("cancel")
            })
        ]
    });
};



var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $4bcdadd511a46d79$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
}), "Tune");


parcelRequire("dNYY5");
var $iIluI = parcelRequire("iIluI");

var $dNDci = parcelRequire("dNDci");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $fnVR5 = parcelRequire("fnVR5");

var $3rqz0 = parcelRequire("3rqz0");

var $9uOZr = parcelRequire("9uOZr");

var $i1fqN = parcelRequire("i1fqN");

var $930Hd = parcelRequire("930Hd");
const $f535653de3528570$var$AreaManagement = ()=>{
    var _appContext_club;
    //AppContext
    const appContext = (0, $7fPBF.useContext)((0, $i1fqN.AppContext));
    const clubId = (_appContext_club = appContext.club) === null || _appContext_club === void 0 ? void 0 : _appContext_club.id;
    const { t: t } = (0, $doyfp.useTranslation)();
    const { setModal: setModal } = (0, $fnVR5.useCommon)();
    const navigate = (0, $iIluI.useNavigate)();
    const [filtersOpen, setFiltersOpen] = (0, $7fPBF.useState)(false);
    const [areas, setAreas] = (0, $7fPBF.useState)([]);
    const [sports, setSports] = (0, $7fPBF.useState)([]);
    const [selectedSports, setSelectedSports] = (0, $7fPBF.useState)([]);
    (0, $7fPBF.useEffect)(()=>{
        const appService = new (0, $dNDci.AppService)();
        appService.api_getClub("private", {
            clubId: clubId
        }).then((res)=>{
            if (res.status !== 200) throw new Error();
            setAreas(res.data.areas);
            setSports(res.data.categories);
            setSelectedSports([]);
        }).catch((error)=>console.log(error));
    }, [
        clubId
    ]);
    const handleSportChange = (event)=>{
        const { value: value } = event.target;
        setSelectedSports(typeof value === "string" ? value.split(",") : value);
    };
    const handleDelete = (deletedId)=>{
        setAreas((prev)=>prev.filter((a)=>a.id !== deletedId));
    };
    const filteredAreas = (0, $7fPBF.useMemo)(()=>{
        if (selectedSports.length === 0) return areas;
        const arr = [];
        areas.forEach((area)=>{
            const isInSelected = area.AreaCategory.map((a)=>a.category).some((value)=>selectedSports.includes(value));
            if (isInSelected) arr.push(area);
        });
        return arr;
    }, [
        areas,
        selectedSports
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9uOZr.Layout), {
        headerType: "menu",
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $hG0Cb.default), {
                spacing: 3,
                mb: 10,
                px: 1,
                mt: 2,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3rqz0.Title), {
                        children: t("areasOfClub")
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dkKmP.AppButton), {
                        variant: "contained",
                        startIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4bcdadd511a46d79$export$2e2bcd8739ae039), {}),
                        onClick: ()=>setFiltersOpen((prev)=>!prev),
                        children: t("filter")
                    }),
                    filtersOpen && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3jMGu.default), {
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lHSFU.default), {
                                id: "select-sports-label",
                                children: t("clubAdmin.bookings.selectCategory")
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $930Hd.Select), {
                                variant: "outlined",
                                multiple: true,
                                labelId: "select-sports-label",
                                label: t("clubAdmin.bookings.selectCategory"),
                                value: selectedSports,
                                onChange: handleSportChange,
                                renderValue: (selected)=>selected.join(", "),
                                children: sports === null || sports === void 0 ? void 0 : sports.map((sport)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $58CWL.default), {
                                        value: sport,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6F4ic.default), {
                                                checked: selectedSports.indexOf(sport) > -1
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dxMGW.default), {
                                                primary: sport
                                            })
                                        ]
                                    }, sport))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3rqz0.StyledStack), {
                        children: [
                            filteredAreas.map((a)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3f8998d21b785118$export$2e2bcd8739ae039), {
                                    area: a,
                                    onStop: ()=>{},
                                    onDetails: ()=>{},
                                    onEdit: ()=>navigate(`/club-admin/club-areas/${a.id}`),
                                    onDelete: ()=>setModal({
                                            open: true,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3cbf372fca50d095$export$a319b1cf85624fba), {
                                                area: a,
                                                onDelete: ()=>handleDelete(a.id)
                                            }),
                                            title: `${t("areaDelete")} \"${a.name}\"`
                                        })
                                }, a.id)),
                            filteredAreas.length < 1 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gC25j.default), {
                                variant: "filled",
                                severity: "info",
                                children: t("noAreas")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $efd6aa927c8a73df$export$2e2bcd8739ae039), {
                variant: "extended",
                color: "primary",
                "aria-label": "add",
                sx: {
                    position: "fixed",
                    bottom: 16,
                    right: 16
                },
                onClick: ()=>navigate("/club-admin/club-areas/"),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bfcdfa3f5a216ca0$export$2e2bcd8739ae039), {
                        sx: {
                            mr: 1
                        }
                    }),
                    t("newArea")
                ]
            })
        ]
    });
};
var $f535653de3528570$export$2e2bcd8739ae039 = $f535653de3528570$var$AreaManagement;



var $icsrd = parcelRequire("icsrd");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $9uOZr = parcelRequire("9uOZr");

const $858c1456b9fcb484$export$39d2eddc798924e7 = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9uOZr.Layout), {
        headerType: "menu",
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9ecc8f4b2515346b$export$be8a2cb338d13d28), {})
    });
};



const $6921d10a59af4a10$var$CancelBooking = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("EOZxw")));

const $6921d10a59af4a10$var$ClubDetails = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("97h5N")));

const $6921d10a59af4a10$var$ClubAreas = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("frhhm")));

const $6921d10a59af4a10$var$EditAccount = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("14MaG")));

const $6921d10a59af4a10$var$Success = /*#__PURE__*/ (0, $7fPBF.lazy)(()=>(parcelRequire("b72qa")));
// Create a client
const $6921d10a59af4a10$var$queryClient = new (0, $3lDoJ.QueryClient)();
function $6921d10a59af4a10$var$AppRoutes() {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNYY5.BrowserRouter), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6V5bv.QueryClientProvider), {
            client: $6921d10a59af4a10$var$queryClient,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i1fqN.AppContextProvider), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $icsrd.FeatureTogglesContextProvider), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fnVR5.CommonContextProvider), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $goR7t.SearchContextProvider), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3mPwx.UserContextProvider), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $iIluI.Routes), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/",
                                            index: true,
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $93ad482b1d83f84c$export$2f00b6de1a889f12), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cc47c1f3012a44fa$export$2e2bcd8739ae039), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/search",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c9325638d2c8ec10$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/booking",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7dba217b57b29882$export$80317e91e54b81a2), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6acadd74b09771bb$export$4f9b4f8cb84c809f), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/checkout/booking",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8b58a96ac4f8c0a9$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/booking-details/:id",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1bc7d261d80607fe$export$167407e059d5158d), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "club/:clubId",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7dba217b57b29882$export$80317e91e54b81a2), {
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $307fe44614891063$export$4fa4ceee2bc5b93), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "club/:clubId/available-slots",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $858c1456b9fcb484$export$39d2eddc798924e7), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/login",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $60f73f8cc1267854$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/admin/login",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $14054902dd55656f$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/signup",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $36d500beb4456b8b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/logout",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $911b334883a2df86$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/verify",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0565e9788296f70a$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/terms-and-conditions",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f60519f88630e7ec$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/external-provider",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ab33f93f6e31bea3$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/booking/share/:id",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $81f70df8dc2d1c1b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/404",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9607625e138e8af6$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "/admin",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9c92c843c4c5b035$export$2e2bcd8739ae039), {
                                                allowedRoles: [
                                                    "admin"
                                                ],
                                                redirect: "/"
                                            }),
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6b332e946dc6bafc$export$2e2bcd8739ae039), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $iIluI.Route), {
                                            path: "/club-admin",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9c92c843c4c5b035$export$2e2bcd8739ae039), {
                                                allowedRoles: [
                                                    "club-admin"
                                                ],
                                                redirect: "/"
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    index: true,
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f0733c2c2aa9ef36$export$2e2bcd8739ae039), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "club-details/:id?",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fV1Xm.ClubsContextProvider), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)($6921d10a59af4a10$var$ClubDetails, {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "club-areas/:id?",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $86kTa.AreasContextProvider), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7dba217b57b29882$export$80317e91e54b81a2), {
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)($6921d10a59af4a10$var$ClubAreas, {})
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "edit-account",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3mPwx.UserContextProvider), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)($6921d10a59af4a10$var$EditAccount, {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "club/:clubId/bookings",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f0733c2c2aa9ef36$export$2e2bcd8739ae039), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "club/:clubId/booking/:bookingId/cancel",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $df3cf7471de1bed9$export$2c59d9e667214a64), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)($6921d10a59af4a10$var$CancelBooking, {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "club/:clubId/areas",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f535653de3528570$export$2e2bcd8739ae039), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "club/:clubId/history",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fV1Xm.ClubsContextProvider), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7qlUi.FeatureToggleBaseComponent), {
                                                                featureToggle: (0, $3Ou5w.FeatureToggles).RESERVATION_HISTORY,
                                                                redirect: "/club-admin",
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c4dbc16c51af293d$export$2e2bcd8739ae039), {})
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "success",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($6921d10a59af4a10$var$Success, {})
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $iIluI.Route), {
                                            path: "/player",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9c92c843c4c5b035$export$2e2bcd8739ae039), {
                                                allowedRoles: [
                                                    "player"
                                                ],
                                                redirect: "/login"
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "bookings",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b56b774fe22f8323$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                                    path: "edit-account",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gSx8R.Spinner), {}),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($6921d10a59af4a10$var$EditAccount, {})
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIluI.Route), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9607625e138e8af6$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
var $6921d10a59af4a10$export$2e2bcd8739ae039 = $6921d10a59af4a10$var$AppRoutes;



var $DCRi1 = parcelRequire("DCRi1");

var $hmhHQ = parcelRequire("hmhHQ");
var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;



var $7fPBF = parcelRequire("7fPBF");

function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039));
    return theme;
}


const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $24ebfb3bf89f6ffe$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;



parcelRequire("bpHMA");
var $6H441 = parcelRequire("6H441");

var $84PRT = parcelRequire("84PRT");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kY3Ke.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kY3Ke.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kY3Ke.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $84PRT.default)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6H441.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;



var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cFLic.default)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $jwhZE.default];
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        themeId: scopedTheme ? (0, $jwhZE.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $huHez = parcelRequire("huHez");

var $4kQoR = parcelRequire("4kQoR");
parcelRequire("3GBGj");
var $doyfp = parcelRequire("doyfp");

var $eYKx4 = parcelRequire("eYKx4");
var $iXs1l = parcelRequire("iXs1l");
var $b9e905abff178497$exports = {};
"use strict";
function $b9e905abff178497$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b9e905abff178497$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b9e905abff178497$var$_typeof(obj);
}
Object.defineProperty($b9e905abff178497$exports, "__esModule", {
    value: true
});
$b9e905abff178497$exports["default"] = $b9e905abff178497$exports.ReactGAImplementation = void 0;

var $b9e905abff178497$var$_ga = $b9e905abff178497$var$_interopRequireWildcard((parcelRequire("7I5on")));
function $b9e905abff178497$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b9e905abff178497$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b9e905abff178497$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b9e905abff178497$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $b9e905abff178497$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $b9e905abff178497$var$ReactGAImplementation = $b9e905abff178497$var$_ga.GA4;
$b9e905abff178497$exports.ReactGAImplementation = $b9e905abff178497$var$ReactGAImplementation;
var $b9e905abff178497$var$_default = $b9e905abff178497$var$_ga["default"];
$b9e905abff178497$exports["default"] = $b9e905abff178497$var$_default;







// Portuguese [pt]

var $8m7Fi = parcelRequire("8m7Fi");
const $3ac283795679c237$var$locale = {
    name: "pt",
    weekdays: "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),
    weekdaysShort: "dom_seg_ter_qua_qui_sex_sab".split("_"),
    months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
    monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
    ordinal: (n)=>`${n}º`,
    weekStart: 0,
    yearStart: 4,
    formats: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"
    },
    relativeTime: {
        future: "em %s",
        past: "h\xe1 %s",
        s: "alguns segundos",
        m: "um minuto",
        mm: "%d minutos",
        h: "uma hora",
        hh: "%d horas",
        d: "um dia",
        dd: "%d dias",
        M: "um m\xeas",
        MM: "%d meses",
        y: "um ano",
        yy: "%d anos"
    }
};
(0, (/*@__PURE__*/$parcel$interopDefault($8m7Fi))).locale($3ac283795679c237$var$locale, null, true);
var $3ac283795679c237$export$2e2bcd8739ae039 = $3ac283795679c237$var$locale;


// English [en]
// We don't need weekdaysShort, weekdaysMin, monthsShort in en.js locale
// eslint-disable-next-line
var $a981f7821f8cfa82$export$2e2bcd8739ae039 = {
    name: "en",
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    ordinal: (n)=>{
        const s = [
            "th",
            "st",
            "nd",
            "rd"
        ];
        const v = n % 100;
        return `[${n}${s[(v - 20) % 10] || s[v] || s[0]}]`;
    }
};


(0, (/*@__PURE__*/$parcel$interopDefault($b9e905abff178497$exports))).initialize("G-EES7KCRRCL");
const { palette: $5c121a02b943fe91$var$palette } = (0, $hmhHQ.default)();
const { augmentColor: $5c121a02b943fe91$var$augmentColor } = $5c121a02b943fe91$var$palette;
const $5c121a02b943fe91$var$createColor = (mainColor)=>$5c121a02b943fe91$var$augmentColor({
        color: {
            main: mainColor
        }
    });
const $5c121a02b943fe91$var$theme = (0, $hmhHQ.default)({
    palette: {
        white: $5c121a02b943fe91$var$createColor("#ffffff"),
        black: $5c121a02b943fe91$var$createColor("#000000"),
        tealLighten5: $5c121a02b943fe91$var$createColor("#E0F2F1"),
        darkGrey: $5c121a02b943fe91$var$createColor("#424242"),
        error: $5c121a02b943fe91$var$createColor("#ff5252")
    }
});
const $5c121a02b943fe91$var$App = ()=>{
    const { i18n: i18n } = (0, $doyfp.useTranslation)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $DCRi1.AuthProvider), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $huHez.LocalizationProvider), {
            dateAdapter: (0, $4kQoR.AdapterDayjs),
            adapterLocale: i18n.language,
            localeText: i18n.language === "pt" ? (0, $iXs1l.ptBR).components.MuiLocalizationProvider.defaultProps.localeText : (0, $eYKx4.enUS).components.MuiLocalizationProvider.defaultProps.localeText,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
                theme: $5c121a02b943fe91$var$theme,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6921d10a59af4a10$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;


const $4a5191623062d5ff$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById("root"));
$4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.12bab758.js.map
